// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0iaXNvbGF0aW9uOmlzb2xhdGUiIHZpZXdCb3g9IjAgMCAxNiAxNiIgd2lkdGg9IjE2cHQiIGhlaWdodD0iMTZwdCI+PHBhdGggZD0iIE0gNS41NzYgMy41NzYgQyA1LjgxIDMuMzQxIDYuMTkgMy4zNDEgNi40MjQgMy41NzYgTCAxMC40MjQgNy41NzYgQyAxMC42NTkgNy44MSAxMC42NTkgOC4xOSAxMC40MjQgOC40MjQgTCA2LjQyNCAxMi40MjQgQyA2LjE5IDEyLjY1OSA1LjgxIDEyLjY1OSA1LjU3NiAxMi40MjQgQyA1LjM0MSAxMi4xOSA1LjM0MSAxMS44MSA1LjU3NiAxMS41NzYgTCA5LjE1MSA4IEwgNS41NzYgNC40MjQgQyA1LjM0MSA0LjE5IDUuMzQxIDMuODEgNS41NzYgMy41NzYgWiAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZmlsbD0icmdiKDIwNiwyMTUsMjI2KSIvPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/lightstone-dark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../images/flow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../images/reos.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../images/pd-logo-white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../images/lightstone.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../images/pd-logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../images/bg.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../images/bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../images/dots.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADFJREFUeNpilJGRYcACIoB4ORMuCSCOZMIlga4TRQJZJ4YETCdWCSBmZMIlATIOIMAAEyAPt4RnNx0AAAAASUVORK5CYII=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/png;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 32 32%27%3E%3Cpath d=%27M27 4L12 19l-7-7-5 5 12 12L32 9z%27 fill=%27%23FFF%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;1,400;1,500;1,600&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
*,
*::before,
*::after {
  box-sizing: border-box;
}
html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: transparent;
}
article,
aside,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section {
  display: block;
}
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
  background-color: #ffffff;
}
[tabindex="-1"]:focus {
  outline: 0 !important;
}
hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}
p {
  margin-top: 0;
  margin-bottom: 1rem;
}
abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
}
address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}
ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}
ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}
dt {
  font-weight: 700;
}
dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}
blockquote {
  margin: 0 0 1rem;
}
dfn {
  font-style: italic;
}
b,
strong {
  font-weight: bolder;
}
small {
  font-size: 80%;
}
sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
}
a:hover {
  color: #0056b3;
  text-decoration: underline;
}
a:not([href]):not([tabindex]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([tabindex]):hover,
a:not([href]):not([tabindex]):focus {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([tabindex]):focus {
  outline: 0;
}
pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}
pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}
figure {
  margin: 0 0 1rem;
}
img {
  vertical-align: middle;
  border-style: none;
}
svg:not(:root) {
  overflow: hidden;
}
table {
  border-collapse: collapse;
}
caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}
th {
  text-align: inherit;
}
label {
  display: inline-block;
  margin-bottom: 0.5rem;
}
button {
  border-radius: 0;
}
button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}
input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
button,
input {
  overflow: visible;
}
button,
select {
  text-transform: none;
}
button,
html [type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}
button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}
input[type="radio"],
input[type="checkbox"] {
  box-sizing: border-box;
  padding: 0;
}
input[type="date"],
input[type="time"],
input[type="datetime-local"],
input[type="month"] {
  -webkit-appearance: listbox;
}
textarea {
  overflow: auto;
  resize: vertical;
}
fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}
legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}
progress {
  vertical-align: baseline;
}
[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}
[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: none;
}
[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}
output {
  display: inline-block;
}
summary {
  display: list-item;
  cursor: pointer;
}
template {
  display: none;
}
[hidden] {
  display: none !important;
}
.align-baseline {
  vertical-align: baseline !important;
}
.align-top {
  vertical-align: top !important;
}
.align-middle {
  vertical-align: middle !important;
}
.align-bottom {
  vertical-align: bottom !important;
}
.align-text-bottom {
  vertical-align: text-bottom !important;
}
.align-text-top {
  vertical-align: text-top !important;
}
.bg-primary {
  background-color: #007bff !important;
}
a.bg-primary:hover,
button.bg-primary:hover,
a.bg-primary:focus,
button.bg-primary:focus {
  background-color: #0062cc !important;
}
.bg-secondary {
  background-color: #6c757d !important;
}
a.bg-secondary:hover,
button.bg-secondary:hover,
a.bg-secondary:focus,
button.bg-secondary:focus {
  background-color: #545b62 !important;
}
.bg-success {
  background-color: #73C677 !important;
}
a.bg-success:hover,
button.bg-success:hover,
a.bg-success:focus,
button.bg-success:focus {
  background-color: #4fb754 !important;
}
.bg-info {
  background-color: #60D3EC !important;
}
a.bg-info:hover,
button.bg-info:hover,
a.bg-info:focus,
button.bg-info:focus {
  background-color: #32c6e7 !important;
}
.bg-warning {
  background-color: #FFA564 !important;
}
a.bg-warning:hover,
button.bg-warning:hover,
a.bg-warning:focus,
button.bg-warning:focus {
  background-color: #ff8731 !important;
}
.bg-danger {
  background-color: #dc3545 !important;
}
a.bg-danger:hover,
button.bg-danger:hover,
a.bg-danger:focus,
button.bg-danger:focus {
  background-color: #bd2130 !important;
}
.bg-light {
  background-color: #f8f9fa !important;
}
a.bg-light:hover,
button.bg-light:hover,
a.bg-light:focus,
button.bg-light:focus {
  background-color: #dae0e5 !important;
}
.bg-dark {
  background-color: #343a40 !important;
}
a.bg-dark:hover,
button.bg-dark:hover,
a.bg-dark:focus,
button.bg-dark:focus {
  background-color: #1d2124 !important;
}
.bg-white {
  background-color: #ffffff !important;
}
.bg-transparent {
  background-color: transparent !important;
}
.border {
  border: 1px solid #dee2e6 !important;
}
.border-top {
  border-top: 1px solid #dee2e6 !important;
}
.border-right {
  border-right: 1px solid #dee2e6 !important;
}
.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}
.border-left {
  border-left: 1px solid #dee2e6 !important;
}
.border-0 {
  border: 0 !important;
}
.border-top-0 {
  border-top: 0 !important;
}
.border-right-0 {
  border-right: 0 !important;
}
.border-bottom-0 {
  border-bottom: 0 !important;
}
.border-left-0 {
  border-left: 0 !important;
}
.border-primary {
  border-color: #007bff !important;
}
.border-secondary {
  border-color: #6c757d !important;
}
.border-success {
  border-color: #73C677 !important;
}
.border-info {
  border-color: #60D3EC !important;
}
.border-warning {
  border-color: #FFA564 !important;
}
.border-danger {
  border-color: #dc3545 !important;
}
.border-light {
  border-color: #f8f9fa !important;
}
.border-dark {
  border-color: #343a40 !important;
}
.border-white {
  border-color: #ffffff !important;
}
.rounded {
  border-radius: 3px !important;
}
.rounded-top {
  border-top-left-radius: 3px !important;
  border-top-right-radius: 3px !important;
}
.rounded-right {
  border-top-right-radius: 3px !important;
  border-bottom-right-radius: 3px !important;
}
.rounded-bottom {
  border-bottom-right-radius: 3px !important;
  border-bottom-left-radius: 3px !important;
}
.rounded-left {
  border-top-left-radius: 3px !important;
  border-bottom-left-radius: 3px !important;
}
.rounded-circle {
  border-radius: 50% !important;
}
.rounded-0 {
  border-radius: 0 !important;
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}
.d-none {
  display: none !important;
}
.d-inline {
  display: inline !important;
}
.d-inline-block {
  display: inline-block !important;
}
.d-block {
  display: block !important;
}
.d-table {
  display: table !important;
}
.d-table-row {
  display: table-row !important;
}
.d-table-cell {
  display: table-cell !important;
}
.d-flex {
  display: flex !important;
}
.d-inline-flex {
  display: inline-flex !important;
}
@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}
.embed-responsive-16by9::before {
  padding-top: 56.25%;
}
.embed-responsive-4by3::before {
  padding-top: 75%;
}
.embed-responsive-1by1::before {
  padding-top: 100%;
}
.flex-row {
  flex-direction: row !important;
}
.flex-column {
  flex-direction: column !important;
}
.flex-row-reverse {
  flex-direction: row-reverse !important;
}
.flex-column-reverse {
  flex-direction: column-reverse !important;
}
.flex-wrap {
  flex-wrap: wrap !important;
}
.flex-nowrap {
  flex-wrap: nowrap !important;
}
.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}
.flex-fill {
  flex: 1 1 auto !important;
}
.flex-grow-0 {
  flex-grow: 0 !important;
}
.flex-grow-1 {
  flex-grow: 1 !important;
}
.flex-shrink-0 {
  flex-shrink: 0 !important;
}
.flex-shrink-1 {
  flex-shrink: 1 !important;
}
.justify-content-start {
  justify-content: flex-start !important;
}
.justify-content-end {
  justify-content: flex-end !important;
}
.justify-content-center {
  justify-content: center !important;
}
.justify-content-between {
  justify-content: space-between !important;
}
.justify-content-around {
  justify-content: space-around !important;
}
.align-items-start {
  align-items: flex-start !important;
}
.align-items-end {
  align-items: flex-end !important;
}
.align-items-center {
  align-items: center !important;
}
.align-items-baseline {
  align-items: baseline !important;
}
.align-items-stretch {
  align-items: stretch !important;
}
.align-content-start {
  align-content: flex-start !important;
}
.align-content-end {
  align-content: flex-end !important;
}
.align-content-center {
  align-content: center !important;
}
.align-content-between {
  align-content: space-between !important;
}
.align-content-around {
  align-content: space-around !important;
}
.align-content-stretch {
  align-content: stretch !important;
}
.align-self-auto {
  align-self: auto !important;
}
.align-self-start {
  align-self: flex-start !important;
}
.align-self-end {
  align-self: flex-end !important;
}
.align-self-center {
  align-self: center !important;
}
.align-self-baseline {
  align-self: baseline !important;
}
.align-self-stretch {
  align-self: stretch !important;
}
@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}
.float-right {
  float: right !important;
}
.float-none {
  float: none !important;
}
@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.position-static {
  position: static !important;
}
.position-relative {
  position: relative !important;
}
.position-absolute {
  position: absolute !important;
}
.position-fixed {
  position: fixed !important;
}
.position-sticky {
  position: sticky !important;
}
.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}
.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}
@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}
.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}
.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}
.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}
.shadow-none {
  box-shadow: none !important;
}
.w-25 {
  width: 25% !important;
}
.w-50 {
  width: 50% !important;
}
.w-75 {
  width: 75% !important;
}
.w-100 {
  width: 100% !important;
}
.w-auto {
  width: auto !important;
}
.h-25 {
  height: 25% !important;
}
.h-50 {
  height: 50% !important;
}
.h-75 {
  height: 75% !important;
}
.h-100 {
  height: 100% !important;
}
.h-auto {
  height: auto !important;
}
.mw-100 {
  max-width: 100% !important;
}
.mh-100 {
  max-height: 100% !important;
}
.m-0 {
  margin: 0 !important;
}
.mt-0,
.my-0 {
  margin-top: 0 !important;
}
.mr-0,
.mx-0 {
  margin-right: 0 !important;
}
.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}
.ml-0,
.mx-0 {
  margin-left: 0 !important;
}
.m-1 {
  margin: 0.25rem !important;
}
.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}
.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}
.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}
.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}
.m-2 {
  margin: 0.5rem !important;
}
.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}
.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}
.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}
.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}
.m-3 {
  margin: 1rem !important;
}
.mt-3,
.my-3 {
  margin-top: 1rem !important;
}
.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}
.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}
.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}
.m-4 {
  margin: 1.5rem !important;
}
.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}
.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}
.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}
.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}
.m-5 {
  margin: 3rem !important;
}
.mt-5,
.my-5 {
  margin-top: 3rem !important;
}
.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}
.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}
.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}
.p-0 {
  padding: 0 !important;
}
.pt-0,
.py-0 {
  padding-top: 0 !important;
}
.pr-0,
.px-0 {
  padding-right: 0 !important;
}
.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}
.pl-0,
.px-0 {
  padding-left: 0 !important;
}
.p-1 {
  padding: 0.25rem !important;
}
.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}
.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}
.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}
.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}
.p-2 {
  padding: 0.5rem !important;
}
.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}
.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}
.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}
.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}
.p-3 {
  padding: 1rem !important;
}
.pt-3,
.py-3 {
  padding-top: 1rem !important;
}
.pr-3,
.px-3 {
  padding-right: 1rem !important;
}
.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}
.pl-3,
.px-3 {
  padding-left: 1rem !important;
}
.p-4 {
  padding: 1.5rem !important;
}
.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}
.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}
.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}
.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}
.p-5 {
  padding: 3rem !important;
}
.pt-5,
.py-5 {
  padding-top: 3rem !important;
}
.pr-5,
.px-5 {
  padding-right: 3rem !important;
}
.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}
.pl-5,
.px-5 {
  padding-left: 3rem !important;
}
.m-auto {
  margin: auto !important;
}
.mt-auto,
.my-auto {
  margin-top: auto !important;
}
.mr-auto,
.mx-auto {
  margin-right: auto !important;
}
.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}
.ml-auto,
.mx-auto {
  margin-left: auto !important;
}
@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-justify {
  text-align: justify !important;
}
.text-nowrap {
  white-space: nowrap !important;
}
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-left {
  text-align: left !important;
}
.text-right {
  text-align: right !important;
}
.text-center {
  text-align: center !important;
}
@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}
.text-uppercase {
  text-transform: uppercase !important;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.font-weight-light {
  font-weight: 300 !important;
}
.font-weight-normal {
  font-weight: 400 !important;
}
.font-weight-bold {
  font-weight: 700 !important;
}
.font-italic {
  font-style: italic !important;
}
.text-white {
  color: #ffffff !important;
}
.text-primary {
  color: #007bff !important;
}
a.text-primary:hover,
a.text-primary:focus {
  color: #0062cc !important;
}
.text-secondary {
  color: #6c757d !important;
}
a.text-secondary:hover,
a.text-secondary:focus {
  color: #545b62 !important;
}
.text-success {
  color: #73C677 !important;
}
a.text-success:hover,
a.text-success:focus {
  color: #4fb754 !important;
}
.text-info {
  color: #60D3EC !important;
}
a.text-info:hover,
a.text-info:focus {
  color: #32c6e7 !important;
}
.text-warning {
  color: #FFA564 !important;
}
a.text-warning:hover,
a.text-warning:focus {
  color: #ff8731 !important;
}
.text-danger {
  color: #dc3545 !important;
}
a.text-danger:hover,
a.text-danger:focus {
  color: #bd2130 !important;
}
.text-light {
  color: #f8f9fa !important;
}
a.text-light:hover,
a.text-light:focus {
  color: #dae0e5 !important;
}
.text-dark {
  color: #343a40 !important;
}
a.text-dark:hover,
a.text-dark:focus {
  color: #1d2124 !important;
}
.text-body {
  color: #212529 !important;
}
.text-muted {
  color: #6c757d !important;
}
.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}
.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}
.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}
.visible {
  visibility: visible !important;
}
.invisible {
  visibility: hidden !important;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #cfcdcd;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media screen and (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #495057;
  background-color: #ffffff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}
select.form-control:not([size]):not([multiple]) {
  height: calc(2.25rem + 2px);
}
select.form-control:focus::-ms-value {
  color: #495057;
  background-color: #ffffff;
}
.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}
.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}
.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.25rem;
  line-height: 1.5;
}
.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.875rem;
  line-height: 1.5;
}
.form-control-plaintext {
  display: block;
  width: 100%;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  margin-bottom: 0;
  line-height: 1.5;
  color: #212529;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm,
.form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}
.form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 3px;
}
select.form-control-sm:not([size]):not([multiple]) {
  height: calc(1.8125rem + 2px);
}
.form-control-lg {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 3px;
}
select.form-control-lg:not([size]):not([multiple]) {
  height: calc(2.875rem + 2px);
}
.form-group {
  margin-bottom: 1rem;
}
.form-text {
  display: block;
  margin-top: 0.25rem;
}
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*="col-"] {
  padding-right: 5px;
  padding-left: 5px;
}
.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}
.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input:disabled ~ .form-check-label {
  color: #6c757d;
}
.form-check-label {
  margin-bottom: 0;
}
.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}
.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #73C677;
}
.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1;
  color: #ffffff;
  background-color: rgba(115, 198, 119, 0.8);
  border-radius: 0.2rem;
}
.was-validated .form-control:valid,
.was-validated .custom-select:valid,
.form-control.is-valid,
.custom-select.is-valid {
  border-color: #73C677;
}
.was-validated .form-control:valid:focus,
.was-validated .custom-select:valid:focus,
.form-control.is-valid:focus,
.custom-select.is-valid:focus {
  border-color: #73C677;
  box-shadow: 0 0 0 0.2rem rgba(115, 198, 119, 0.25);
}
.was-validated .form-control:valid ~ .valid-feedback,
.was-validated .custom-select:valid ~ .valid-feedback,
.form-control.is-valid ~ .valid-feedback,
.custom-select.is-valid ~ .valid-feedback,
.was-validated .form-control:valid ~ .valid-tooltip,
.was-validated .custom-select:valid ~ .valid-tooltip,
.form-control.is-valid ~ .valid-tooltip,
.custom-select.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .form-control-file:valid ~ .valid-feedback,
.form-control-file.is-valid ~ .valid-feedback,
.was-validated .form-control-file:valid ~ .valid-tooltip,
.form-control-file.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .form-check-input:valid ~ .form-check-label,
.form-check-input.is-valid ~ .form-check-label {
  color: #73C677;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-control-input:valid ~ .custom-control-label,
.custom-control-input.is-valid ~ .custom-control-label {
  color: #73C677;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before,
.custom-control-input.is-valid ~ .custom-control-label::before {
  background-color: #ceebcf;
}
.was-validated .custom-control-input:valid ~ .valid-feedback,
.custom-control-input.is-valid ~ .valid-feedback,
.was-validated .custom-control-input:valid ~ .valid-tooltip,
.custom-control-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before,
.custom-control-input.is-valid:checked ~ .custom-control-label::before {
  background-color: #97d59a;
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before,
.custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.2rem rgba(115, 198, 119, 0.25);
}
.was-validated .custom-file-input:valid ~ .custom-file-label,
.custom-file-input.is-valid ~ .custom-file-label {
  border-color: #73C677;
}
.was-validated .custom-file-input:valid ~ .custom-file-label::before,
.custom-file-input.is-valid ~ .custom-file-label::before {
  border-color: inherit;
}
.was-validated .custom-file-input:valid ~ .valid-feedback,
.custom-file-input.is-valid ~ .valid-feedback,
.was-validated .custom-file-input:valid ~ .valid-tooltip,
.custom-file-input.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label,
.custom-file-input.is-valid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0.2rem rgba(115, 198, 119, 0.25);
}
.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  line-height: 1;
  color: #ffffff;
  background-color: rgba(220, 53, 69, 0.8);
  border-radius: 0.2rem;
}
.was-validated .form-control:invalid,
.was-validated .custom-select:invalid,
.form-control.is-invalid,
.custom-select.is-invalid {
  border-color: #dc3545;
}
.was-validated .form-control:invalid:focus,
.was-validated .custom-select:invalid:focus,
.form-control.is-invalid:focus,
.custom-select.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.was-validated .form-control:invalid ~ .invalid-feedback,
.was-validated .custom-select:invalid ~ .invalid-feedback,
.form-control.is-invalid ~ .invalid-feedback,
.custom-select.is-invalid ~ .invalid-feedback,
.was-validated .form-control:invalid ~ .invalid-tooltip,
.was-validated .custom-select:invalid ~ .invalid-tooltip,
.form-control.is-invalid ~ .invalid-tooltip,
.custom-select.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .form-control-file:invalid ~ .invalid-feedback,
.form-control-file.is-invalid ~ .invalid-feedback,
.was-validated .form-control-file:invalid ~ .invalid-tooltip,
.form-control-file.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .form-check-input:invalid ~ .form-check-label,
.form-check-input.is-invalid ~ .form-check-label {
  color: #dc3545;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label,
.custom-control-input.is-invalid ~ .custom-control-label {
  color: #dc3545;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before,
.custom-control-input.is-invalid ~ .custom-control-label::before {
  background-color: #efa2a9;
}
.was-validated .custom-control-input:invalid ~ .invalid-feedback,
.custom-control-input.is-invalid ~ .invalid-feedback,
.was-validated .custom-control-input:invalid ~ .invalid-tooltip,
.custom-control-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before,
.custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  background-color: #e4606d;
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before,
.custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.was-validated .custom-file-input:invalid ~ .custom-file-label,
.custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #dc3545;
}
.was-validated .custom-file-input:invalid ~ .custom-file-label::before,
.custom-file-input.is-invalid ~ .custom-file-label::before {
  border-color: inherit;
}
.was-validated .custom-file-input:invalid ~ .invalid-feedback,
.custom-file-input.is-invalid ~ .invalid-feedback,
.was-validated .custom-file-input:invalid ~ .invalid-tooltip,
.custom-file-input.is-invalid ~ .invalid-tooltip {
  display: block;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label,
.custom-file-input.is-invalid:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}
.container-fluid {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}
.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}
.grid-column,
.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12,
.col,
.col-auto,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm,
.col-sm-auto,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md,
.col-md-auto,
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg,
.col-lg-auto,
.col-xl-1,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl,
.col-xl-auto {
  position: relative;
  width: 100%;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}
.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}
.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
}
.col-1 {
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}
.col-2 {
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}
.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}
.col-4 {
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}
.col-5 {
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}
.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}
.col-7 {
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}
.col-8 {
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}
.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}
.col-10 {
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}
.col-11 {
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}
.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}
.order-first {
  order: -1;
}
.order-last {
  order: 13;
}
.order-0 {
  order: 0;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.order-4 {
  order: 4;
}
.order-5 {
  order: 5;
}
.order-6 {
  order: 6;
}
.order-7 {
  order: 7;
}
.order-8 {
  order: 8;
}
.order-9 {
  order: 9;
}
.order-10 {
  order: 10;
}
.order-11 {
  order: 11;
}
.order-12 {
  order: 12;
}
.offset-1 {
  margin-left: 8.33333333%;
}
.offset-2 {
  margin-left: 16.66666667%;
}
.offset-3 {
  margin-left: 25%;
}
.offset-4 {
  margin-left: 33.33333333%;
}
.offset-5 {
  margin-left: 41.66666667%;
}
.offset-6 {
  margin-left: 50%;
}
.offset-7 {
  margin-left: 58.33333333%;
}
.offset-8 {
  margin-left: 66.66666667%;
}
.offset-9 {
  margin-left: 75%;
}
.offset-10 {
  margin-left: 83.33333333%;
}
.offset-11 {
  margin-left: 91.66666667%;
}
@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-sm-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-md-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-lg-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .col-xl-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
}
/* Basics */
/* Primary */
/* Secondary */
/* Tertiary */
/* States */
/* Text */
/* Shadows */
/* Greys */
/* Global styles */
html {
  position: relative;
  min-height: 100vh;
  font-size: 12px;
  line-height: 26px;
}
body {
  font-size: 12px;
  min-height: 100%;
  color: #78789A;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  margin: 0;
  padding: 0;
  font-family: 'Poppins', sans-serif;
}
ul {
  padding: 15px 0 0 15px;
}
li {
  line-height: 1.5em;
  margin-top: 5px;
}
a,
a:link {
  text-decoration: none;
  color: #78789A;
}
a:active,
a:focus,
a:hover {
  color: #000;
}
a:focus,
a:active,
button::-moz-focus-inner,
button:focus,
input[type="reset"]::-moz-focus-inner,
input[type="button"]::-moz-focus-inner,
input[type="submit"]::-moz-focus-inner,
select::-moz-focus-inner,
input[type="file"] > input[type="button"]::-moz-focus-inner {
  border: 0;
  outline: 0;
}
form {
  display: inline;
}
input[type="submit"],
button {
  box-sizing: border-box;
}
/* Reset IOS input box styling */
input {
  -webkit-appearance: none;
  border-radius: 0;
}
input[type="checkbox"] {
  -webkit-appearance: checkbox;
}
input[type="radio"] {
  -webkit-appearance: radio;
}
/* Reset webkit yellow background on autofill */
input:-webkit-autofill::first-line,
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:autofill,
input:autofill:hover,
input:autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
textarea:autofill,
textarea:autofill:hover,
textarea:autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus,
select:autofill,
select:autofill:hover,
select:autofill:focus {
  -webkit-background-clip: text !important;
  appearance: none;
  box-shadow: 0 0 0px 1000px #fff inset !important;
  -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
  -webkit-text-fill-color: #676a6c !important;
  color: #222;
  background-color: #fff !important;
  background-image: none !important;
  filter: none !important;
  font-size: 14px !important;
  font-family: 'Poppins', sans-serif !important;
}
input:-internal-autofill-selected {
  -webkit-background-clip: text !important;
  appearance: none;
  box-shadow: 0 0 0px 1000px #fff inset !important;
  -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
  -webkit-text-fill-color: #676a6c !important;
  color: #222;
  background-color: #fff !important;
  background-image: none !important;
  filter: none !important;
  font-size: 14px !important;
  font-family: 'Poppins', sans-serif !important;
}
input:-internal-autofill-previewed {
  -webkit-background-clip: text !important;
  appearance: none;
  box-shadow: 0 0 0px 1000px #fff inset !important;
  -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
  -webkit-text-fill-color: #676a6c !important;
  color: #222;
  background-color: #fff !important;
  background-image: none !important;
  filter: none !important;
  font-size: 14px !important;
  font-family: 'Poppins', sans-serif !important;
}
input:-internal-autofill-selected {
  font-family: 'Poppins', sans-serif;
  -webkit-background-clip: text !important;
  appearance: none;
  box-shadow: 0 0 0px 1000px #fff inset !important;
  -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;
  -webkit-text-fill-color: #676a6c !important;
  color: #222 !important;
  background-color: #fff !important;
  background-image: none !important;
  filter: none !important;
  font-size: 14px !important;
}
input[type='number'] {
  -moz-appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/* Remove Webkit glow */
textarea,
input {
  outline: 0 !important;
}
/* Remove webkit focus glow */
:focus {
  outline-color: transparent;
  outline-style: none;
  outline: 0;
}
textarea {
  width: 100%;
  min-height: 250px;
  border: 1px solid #edf3f7;
  padding: 5px;
  color: #444;
}
input[type="text"].error,
input[type="password"].error {
  border-bottom: 1px solid #FC495D;
}
select {
  margin: 0 0 10px;
  appearance: none;
  border-radius: 0;
  box-sizing: border-box;
  display: inline-block;
  width: auto;
  background: none;
}
/* Explicitly specify font-weight for all headings */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 600;
  color: #10294D;
}
h1 {
  font-size: 20px;
  line-height: 1.2em;
  font-weight: 300;
}
h2 {
  font-size: 18px;
  margin: 0;
  font-weight: 600;
}
h3 {
  font-size: 16px;
  line-height: 30px;
  margin: 10px 0;
  font-weight: 600;
}
h4 {
  font-size: 14px;
  font-weight: 600;
}
h5 {
  font-size: 12px;
  line-height: 1em;
  font-weight: 700;
}
h6 {
  font-size: 10px;
  line-height: 1em;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
input:focus:-moz-placeholder {
  color: transparent;
}
/* FF 4-18 */
input:focus::-moz-placeholder {
  color: transparent;
}
/* FF 19+ */
input:focus:-ms-input-placeholder {
  color: transparent;
}
/* IE 10+ */
::-webkit-input-placeholder {
  color: #efefef;
}
:-moz-placeholder {
  color: #efefef;
}
::-moz-placeholder {
  color: #efefef;
}
:-ms-input-placeholder {
  color: #efefef;
}
strong {
  color: #333;
  font-weight: 700;
}
.heavy {
  font-weight: 700;
}
.capitalize {
  text-transform: capitalize;
}
svg {
  fill: #222;
}
.hidden-sm {
  display: none;
}
@media screen and (min-width: 576px) {
  .hidden-sm {
    display: block;
  }
}
/* Silo Header */
.silo-header {
  top: 0px;
  grid-area: silo-header;
  height: 60px;
  z-index: 900;
  background: #000000;
  left: 0;
  right: 0;
  transition: transform 0.2s ease-in-out;
}
@media print {
  .silo-header {
    display: none;
  }
}
.silo-header .awaiting {
  position: fixed;
  top: 0px;
  height: 2px;
  width: 100%;
  background: #000000;
}
.silo-header .awaiting > div.awaitcount {
  width: 0;
  height: 2px;
  background-color: #ffffff;
}
.silo-header .logo-lg {
  display: flex;
  font-family: "Century Gothic", CenturyGothic, AppleGothic, sans-serif;
  white-space: nowrap;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  line-height: 60px;
  max-height: 60px;
  max-width: 200px;
  margin-left: 10px;
  position: absolute;
}
.silo-header .logo-lg:before {
  content: " ";
  font-family: "italici";
}
.silo-header .logo-lg a {
  color: #ffffff;
}
.silo-header .logo-lg img {
  display: inline-block;
}
.silo-header .logo-lg svg {
  margin: 0 6px 0 2px;
  height: 32px;
  vertical-align: middle;
}
.silo-header > .navbar {
  display: none;
  margin-bottom: 0;
  margin-right: 20px;
  border: none;
  min-height: 60px;
  border-radius: 0;
  max-height: 60px;
  line-height: 58px;
  float: right;
}
@media (min-width: 576px) {
  .silo-header > .navbar {
    display: block;
  }
}
.layout-top-nav .silo-header > .navbar {
  margin-left: 0;
}
.silo-header > .navbar .navbar-collapse {
  display: inline-block !important;
  vertical-align: middle;
}
.silo-header > .navbar .navbar-collapse ul {
  margin: 0;
  padding: 0;
}
.silo-header > .navbar .navbar-collapse ul li {
  margin-left: 3px;
  display: inline-block;
  list-style: none;
}
.silo-header > .navbar .navbar-collapse ul li a {
  display: inline-block;
  color: rgba(255, 255, 255, 0.57);
  padding: 0 15px;
  text-transform: uppercase;
  line-height: 34px;
  border: 1px solid rgba(255, 255, 255, 0);
}
.silo-header > .navbar .navbar-collapse ul li a:hover {
  background: none;
  color: #ffffff;
  border: 1px solid #ffffff;
}
.silo-header > .navbar .navbar-collapse ul li.active a {
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.57);
}
.silo-header > .navbar .navbar-collapse ul li.active a:hover {
  background: none;
  border: 1px solid #ffffff;
}
a.btn,
button.btn,
.btn {
  display: flex;
  align-items: center;
  padding: 6px 15px;
  min-height: 36px;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid transparent;
  transition: all 0.2s ease-in-out;
  border-radius: 4px;
  cursor: pointer;
  appearance: none;
  font-weight: 500;
}
a.btn-small,
button.btn-small,
.btn-small {
  padding: 0 8px;
  min-height: 26px;
}
a.btn svg,
button.btn svg,
.btn svg {
  fill: none;
  transition: all 0.2s ease-in-out;
}
a.btn.input-group-addon,
button.btn.input-group-addon,
.btn.input-group-addon {
  min-height: 34px;
  max-height: none;
}
a.btn-primary,
button.btn-primary,
.btn-primary {
  background: #10294D;
  border-color: transparent;
  color: #ffffff;
}
a.btn-primary svg,
button.btn-primary svg,
.btn-primary svg {
  stroke: #ffffff;
  fill: none;
}
a.btn-primary:not(.disabled).focus,
button.btn-primary:not(.disabled).focus,
.btn-primary:not(.disabled).focus,
a.btn-primary:not(.disabled):focus,
button.btn-primary:not(.disabled):focus,
.btn-primary:not(.disabled):focus,
a.btn-primary:not(.disabled):focus-visible,
button.btn-primary:not(.disabled):focus-visible,
.btn-primary:not(.disabled):focus-visible {
  color: #ffffff;
  border: 1px solid transparent;
  background: #071B38;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
a.btn-primary:not(.disabled).active,
button.btn-primary:not(.disabled).active,
.btn-primary:not(.disabled).active,
a.btn-primary:not(.disabled):active,
button.btn-primary:not(.disabled):active,
.btn-primary:not(.disabled):active {
  color: #ffffff;
  border: 1px solid transparent;
  background: #071B38;
}
a.btn-primary:not(.disabled).active.focus,
button.btn-primary:not(.disabled).active.focus,
.btn-primary:not(.disabled).active.focus,
a.btn-primary:not(.disabled):active.focus,
button.btn-primary:not(.disabled):active.focus,
.btn-primary:not(.disabled):active.focus,
a.btn-primary:not(.disabled).active:focus,
button.btn-primary:not(.disabled).active:focus,
.btn-primary:not(.disabled).active:focus,
a.btn-primary:not(.disabled):active:focus,
button.btn-primary:not(.disabled):active:focus,
.btn-primary:not(.disabled):active:focus,
a.btn-primary:not(.disabled).active:focus-visible,
button.btn-primary:not(.disabled).active:focus-visible,
.btn-primary:not(.disabled).active:focus-visible,
a.btn-primary:not(.disabled):active:focus-visible,
button.btn-primary:not(.disabled):active:focus-visible,
.btn-primary:not(.disabled):active:focus-visible {
  background: #071B38;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
a.btn-primary:not(.disabled).hover,
button.btn-primary:not(.disabled).hover,
.btn-primary:not(.disabled).hover,
a.btn-primary:not(.disabled):hover,
button.btn-primary:not(.disabled):hover,
.btn-primary:not(.disabled):hover {
  color: #ffffff;
  border: 1px solid transparent;
  background: #071B38;
}
a.btn-primary:not(.disabled).hover.active,
button.btn-primary:not(.disabled).hover.active,
.btn-primary:not(.disabled).hover.active,
a.btn-primary:not(.disabled):hover.active,
button.btn-primary:not(.disabled):hover.active,
.btn-primary:not(.disabled):hover.active,
a.btn-primary:not(.disabled).hover:active,
button.btn-primary:not(.disabled).hover:active,
.btn-primary:not(.disabled).hover:active,
a.btn-primary:not(.disabled):hover:active,
button.btn-primary:not(.disabled):hover:active,
.btn-primary:not(.disabled):hover:active {
  border-color: transparent;
  background: #071B38;
}
a.btn-primary:not(.disabled).hover.active.focus,
button.btn-primary:not(.disabled).hover.active.focus,
.btn-primary:not(.disabled).hover.active.focus,
a.btn-primary:not(.disabled):hover.active.focus,
button.btn-primary:not(.disabled):hover.active.focus,
.btn-primary:not(.disabled):hover.active.focus,
a.btn-primary:not(.disabled).hover:active.focus,
button.btn-primary:not(.disabled).hover:active.focus,
.btn-primary:not(.disabled).hover:active.focus,
a.btn-primary:not(.disabled):hover:active.focus,
button.btn-primary:not(.disabled):hover:active.focus,
.btn-primary:not(.disabled):hover:active.focus,
a.btn-primary:not(.disabled).hover.active:focus,
button.btn-primary:not(.disabled).hover.active:focus,
.btn-primary:not(.disabled).hover.active:focus,
a.btn-primary:not(.disabled):hover.active:focus,
button.btn-primary:not(.disabled):hover.active:focus,
.btn-primary:not(.disabled):hover.active:focus,
a.btn-primary:not(.disabled).hover:active:focus,
button.btn-primary:not(.disabled).hover:active:focus,
.btn-primary:not(.disabled).hover:active:focus,
a.btn-primary:not(.disabled):hover:active:focus,
button.btn-primary:not(.disabled):hover:active:focus,
.btn-primary:not(.disabled):hover:active:focus,
a.btn-primary:not(.disabled).hover.active:focus-visible,
button.btn-primary:not(.disabled).hover.active:focus-visible,
.btn-primary:not(.disabled).hover.active:focus-visible,
a.btn-primary:not(.disabled):hover.active:focus-visible,
button.btn-primary:not(.disabled):hover.active:focus-visible,
.btn-primary:not(.disabled):hover.active:focus-visible,
a.btn-primary:not(.disabled).hover:active:focus-visible,
button.btn-primary:not(.disabled).hover:active:focus-visible,
.btn-primary:not(.disabled).hover:active:focus-visible,
a.btn-primary:not(.disabled):hover:active:focus-visible,
button.btn-primary:not(.disabled):hover:active:focus-visible,
.btn-primary:not(.disabled):hover:active:focus-visible {
  background: #071B38;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
a.btn-secondary,
button.btn-secondary,
.btn-secondary {
  background: #FC495D;
  border-color: transparent;
  color: #ffffff;
}
a.btn-secondary svg,
button.btn-secondary svg,
.btn-secondary svg {
  display: block;
  stroke: #ffffff;
  fill: none;
}
a.btn-secondary.focus,
button.btn-secondary.focus,
.btn-secondary.focus,
a.btn-secondary:focus,
button.btn-secondary:focus,
.btn-secondary:focus,
a.btn-secondary:focus-visible,
button.btn-secondary:focus-visible,
.btn-secondary:focus-visible {
  color: #ffffff;
  border: 1px solid transparent;
  background: #E62D42;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FED1D6;
}
a.btn-secondary.active,
button.btn-secondary.active,
.btn-secondary.active,
a.btn-secondary:active,
button.btn-secondary:active,
.btn-secondary:active {
  color: #ffffff;
  border: 1px solid transparent;
  background: #E62D42;
}
a.btn-secondary.active.focus,
button.btn-secondary.active.focus,
.btn-secondary.active.focus,
a.btn-secondary:active.focus,
button.btn-secondary:active.focus,
.btn-secondary:active.focus,
a.btn-secondary.active:focus,
button.btn-secondary.active:focus,
.btn-secondary.active:focus,
a.btn-secondary:active:focus,
button.btn-secondary:active:focus,
.btn-secondary:active:focus,
a.btn-secondary.active:focus-visible,
button.btn-secondary.active:focus-visible,
.btn-secondary.active:focus-visible,
a.btn-secondary:active:focus-visible,
button.btn-secondary:active:focus-visible,
.btn-secondary:active:focus-visible {
  background: #E62D42;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FED1D6;
}
a.btn-secondary.hover,
button.btn-secondary.hover,
.btn-secondary.hover,
a.btn-secondary:hover,
button.btn-secondary:hover,
.btn-secondary:hover {
  color: #ffffff;
  border: 1px solid transparent;
  background: #E62D42;
}
a.btn-secondary.hover.active,
button.btn-secondary.hover.active,
.btn-secondary.hover.active,
a.btn-secondary:hover.active,
button.btn-secondary:hover.active,
.btn-secondary:hover.active,
a.btn-secondary.hover:active,
button.btn-secondary.hover:active,
.btn-secondary.hover:active,
a.btn-secondary:hover:active,
button.btn-secondary:hover:active,
.btn-secondary:hover:active {
  border-color: transparent;
  background: #E62D42;
}
a.btn-secondary.hover.active.focus,
button.btn-secondary.hover.active.focus,
.btn-secondary.hover.active.focus,
a.btn-secondary:hover.active.focus,
button.btn-secondary:hover.active.focus,
.btn-secondary:hover.active.focus,
a.btn-secondary.hover:active.focus,
button.btn-secondary.hover:active.focus,
.btn-secondary.hover:active.focus,
a.btn-secondary:hover:active.focus,
button.btn-secondary:hover:active.focus,
.btn-secondary:hover:active.focus,
a.btn-secondary.hover.active:focus,
button.btn-secondary.hover.active:focus,
.btn-secondary.hover.active:focus,
a.btn-secondary:hover.active:focus,
button.btn-secondary:hover.active:focus,
.btn-secondary:hover.active:focus,
a.btn-secondary.hover:active:focus,
button.btn-secondary.hover:active:focus,
.btn-secondary.hover:active:focus,
a.btn-secondary:hover:active:focus,
button.btn-secondary:hover:active:focus,
.btn-secondary:hover:active:focus,
a.btn-secondary.hover.active:focus-visible,
button.btn-secondary.hover.active:focus-visible,
.btn-secondary.hover.active:focus-visible,
a.btn-secondary:hover.active:focus-visible,
button.btn-secondary:hover.active:focus-visible,
.btn-secondary:hover.active:focus-visible,
a.btn-secondary.hover:active:focus-visible,
button.btn-secondary.hover:active:focus-visible,
.btn-secondary.hover:active:focus-visible,
a.btn-secondary:hover:active:focus-visible,
button.btn-secondary:hover:active:focus-visible,
.btn-secondary:hover:active:focus-visible {
  background: #E62D42;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FED1D6;
}
a.btn-round,
button.btn-round,
.btn-round {
  border-radius: 30px;
}
a.btn-red,
button.btn-red,
.btn-red {
  background: #FFEDEF;
  color: #FC495D;
}
a.btn-red svg,
button.btn-red svg,
.btn-red svg {
  stroke: #FC495D;
}
a.btn-red.focus,
button.btn-red.focus,
.btn-red.focus,
a.btn-red:focus,
button.btn-red:focus,
.btn-red:focus,
a.btn-red:focus-visible,
button.btn-red:focus-visible,
.btn-red:focus-visible {
  color: #FC495D;
  border: 1px solid transparent;
  background: #FED1D6;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FFEDEF;
}
a.btn-red.active,
button.btn-red.active,
.btn-red.active,
a.btn-red:active,
button.btn-red:active,
.btn-red:active {
  color: #FC495D;
  border: 1px solid transparent;
  background: #FED1D6;
}
a.btn-red.active.focus,
button.btn-red.active.focus,
.btn-red.active.focus,
a.btn-red:active.focus,
button.btn-red:active.focus,
.btn-red:active.focus,
a.btn-red.active:focus,
button.btn-red.active:focus,
.btn-red.active:focus,
a.btn-red:active:focus,
button.btn-red:active:focus,
.btn-red:active:focus,
a.btn-red.active:focus-visible,
button.btn-red.active:focus-visible,
.btn-red.active:focus-visible,
a.btn-red:active:focus-visible,
button.btn-red:active:focus-visible,
.btn-red:active:focus-visible {
  background: #FED1D6;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FFEDEF;
}
a.btn-red.hover,
button.btn-red.hover,
.btn-red.hover,
a.btn-red:hover,
button.btn-red:hover,
.btn-red:hover {
  color: #FC495D;
  border: 1px solid transparent;
  background: #FED1D6;
}
a.btn-red.hover.active,
button.btn-red.hover.active,
.btn-red.hover.active,
a.btn-red:hover.active,
button.btn-red:hover.active,
.btn-red:hover.active,
a.btn-red.hover:active,
button.btn-red.hover:active,
.btn-red.hover:active,
a.btn-red:hover:active,
button.btn-red:hover:active,
.btn-red:hover:active {
  border-color: transparent;
  background: #FED1D6;
}
a.btn-red.hover.active.focus,
button.btn-red.hover.active.focus,
.btn-red.hover.active.focus,
a.btn-red:hover.active.focus,
button.btn-red:hover.active.focus,
.btn-red:hover.active.focus,
a.btn-red.hover:active.focus,
button.btn-red.hover:active.focus,
.btn-red.hover:active.focus,
a.btn-red:hover:active.focus,
button.btn-red:hover:active.focus,
.btn-red:hover:active.focus,
a.btn-red.hover.active:focus,
button.btn-red.hover.active:focus,
.btn-red.hover.active:focus,
a.btn-red:hover.active:focus,
button.btn-red:hover.active:focus,
.btn-red:hover.active:focus,
a.btn-red.hover:active:focus,
button.btn-red.hover:active:focus,
.btn-red.hover:active:focus,
a.btn-red:hover:active:focus,
button.btn-red:hover:active:focus,
.btn-red:hover:active:focus,
a.btn-red.hover.active:focus-visible,
button.btn-red.hover.active:focus-visible,
.btn-red.hover.active:focus-visible,
a.btn-red:hover.active:focus-visible,
button.btn-red:hover.active:focus-visible,
.btn-red:hover.active:focus-visible,
a.btn-red.hover:active:focus-visible,
button.btn-red.hover:active:focus-visible,
.btn-red.hover:active:focus-visible,
a.btn-red:hover:active:focus-visible,
button.btn-red:hover:active:focus-visible,
.btn-red:hover:active:focus-visible {
  background: #FED1D6;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FFEDEF;
}
a.btn-green,
button.btn-green,
.btn-green {
  background: #F0F9F1;
  color: #73C677;
}
a.btn-green svg,
button.btn-green svg,
.btn-green svg {
  stroke: #73C677;
}
a.btn-green.focus,
button.btn-green.focus,
.btn-green.focus,
a.btn-green:focus,
button.btn-green:focus,
.btn-green:focus,
a.btn-green:focus-visible,
button.btn-green:focus-visible,
.btn-green:focus-visible {
  color: #73C677;
  border: 1px solid transparent;
  background: #DCF1DE;
  outline: none;
  box-shadow: 0px 0px 0px 3px #F0F9F1;
}
a.btn-green.active,
button.btn-green.active,
.btn-green.active,
a.btn-green:active,
button.btn-green:active,
.btn-green:active {
  color: #73C677;
  border: 1px solid transparent;
  background: #DCF1DE;
}
a.btn-green.active.focus,
button.btn-green.active.focus,
.btn-green.active.focus,
a.btn-green:active.focus,
button.btn-green:active.focus,
.btn-green:active.focus,
a.btn-green.active:focus,
button.btn-green.active:focus,
.btn-green.active:focus,
a.btn-green:active:focus,
button.btn-green:active:focus,
.btn-green:active:focus,
a.btn-green.active:focus-visible,
button.btn-green.active:focus-visible,
.btn-green.active:focus-visible,
a.btn-green:active:focus-visible,
button.btn-green:active:focus-visible,
.btn-green:active:focus-visible {
  background: #DCF1DE;
  outline: none;
  box-shadow: 0px 0px 0px 3px #F0F9F1;
}
a.btn-green.hover,
button.btn-green.hover,
.btn-green.hover,
a.btn-green:hover,
button.btn-green:hover,
.btn-green:hover {
  color: #73C677;
  border: 1px solid transparent;
  background: #DCF1DE;
}
a.btn-green.hover.active,
button.btn-green.hover.active,
.btn-green.hover.active,
a.btn-green:hover.active,
button.btn-green:hover.active,
.btn-green:hover.active,
a.btn-green.hover:active,
button.btn-green.hover:active,
.btn-green.hover:active,
a.btn-green:hover:active,
button.btn-green:hover:active,
.btn-green:hover:active {
  border-color: transparent;
  background: #DCF1DE;
}
a.btn-green.hover.active.focus,
button.btn-green.hover.active.focus,
.btn-green.hover.active.focus,
a.btn-green:hover.active.focus,
button.btn-green:hover.active.focus,
.btn-green:hover.active.focus,
a.btn-green.hover:active.focus,
button.btn-green.hover:active.focus,
.btn-green.hover:active.focus,
a.btn-green:hover:active.focus,
button.btn-green:hover:active.focus,
.btn-green:hover:active.focus,
a.btn-green.hover.active:focus,
button.btn-green.hover.active:focus,
.btn-green.hover.active:focus,
a.btn-green:hover.active:focus,
button.btn-green:hover.active:focus,
.btn-green:hover.active:focus,
a.btn-green.hover:active:focus,
button.btn-green.hover:active:focus,
.btn-green.hover:active:focus,
a.btn-green:hover:active:focus,
button.btn-green:hover:active:focus,
.btn-green:hover:active:focus,
a.btn-green.hover.active:focus-visible,
button.btn-green.hover.active:focus-visible,
.btn-green.hover.active:focus-visible,
a.btn-green:hover.active:focus-visible,
button.btn-green:hover.active:focus-visible,
.btn-green:hover.active:focus-visible,
a.btn-green.hover:active:focus-visible,
button.btn-green.hover:active:focus-visible,
.btn-green.hover:active:focus-visible,
a.btn-green:hover:active:focus-visible,
button.btn-green:hover:active:focus-visible,
.btn-green:hover:active:focus-visible {
  background: #DCF1DE;
  outline: none;
  box-shadow: 0px 0px 0px 3px #F0F9F1;
}
a.btn-blue,
button.btn-blue,
.btn-blue {
  background: #EFFBFD;
  color: #34BFDE;
}
a.btn-blue svg,
button.btn-blue svg,
.btn-blue svg {
  stroke: #73C677;
}
a.btn-blue.focus,
button.btn-blue.focus,
.btn-blue.focus,
a.btn-blue:focus,
button.btn-blue:focus,
.btn-blue:focus,
a.btn-blue:focus-visible,
button.btn-blue:focus-visible,
.btn-blue:focus-visible {
  color: #73C677;
  border: 1px solid transparent;
  background: #D7F4FA;
  outline: none;
  box-shadow: 0px 0px 0px 3px #EFFBFD;
}
a.btn-blue.active,
button.btn-blue.active,
.btn-blue.active,
a.btn-blue:active,
button.btn-blue:active,
.btn-blue:active {
  color: #73C677;
  border: 1px solid transparent;
  background: #D7F4FA;
}
a.btn-blue.active.focus,
button.btn-blue.active.focus,
.btn-blue.active.focus,
a.btn-blue:active.focus,
button.btn-blue:active.focus,
.btn-blue:active.focus,
a.btn-blue.active:focus,
button.btn-blue.active:focus,
.btn-blue.active:focus,
a.btn-blue:active:focus,
button.btn-blue:active:focus,
.btn-blue:active:focus,
a.btn-blue.active:focus-visible,
button.btn-blue.active:focus-visible,
.btn-blue.active:focus-visible,
a.btn-blue:active:focus-visible,
button.btn-blue:active:focus-visible,
.btn-blue:active:focus-visible {
  background: #D7F4FA;
  outline: none;
  box-shadow: 0px 0px 0px 3px #EFFBFD;
}
a.btn-blue.hover,
button.btn-blue.hover,
.btn-blue.hover,
a.btn-blue:hover,
button.btn-blue:hover,
.btn-blue:hover {
  color: #73C677;
  border: 1px solid transparent;
  background: #D7F4FA;
}
a.btn-blue.hover.active,
button.btn-blue.hover.active,
.btn-blue.hover.active,
a.btn-blue:hover.active,
button.btn-blue:hover.active,
.btn-blue:hover.active,
a.btn-blue.hover:active,
button.btn-blue.hover:active,
.btn-blue.hover:active,
a.btn-blue:hover:active,
button.btn-blue:hover:active,
.btn-blue:hover:active {
  border-color: transparent;
  background: #D7F4FA;
}
a.btn-blue.hover.active.focus,
button.btn-blue.hover.active.focus,
.btn-blue.hover.active.focus,
a.btn-blue:hover.active.focus,
button.btn-blue:hover.active.focus,
.btn-blue:hover.active.focus,
a.btn-blue.hover:active.focus,
button.btn-blue.hover:active.focus,
.btn-blue.hover:active.focus,
a.btn-blue:hover:active.focus,
button.btn-blue:hover:active.focus,
.btn-blue:hover:active.focus,
a.btn-blue.hover.active:focus,
button.btn-blue.hover.active:focus,
.btn-blue.hover.active:focus,
a.btn-blue:hover.active:focus,
button.btn-blue:hover.active:focus,
.btn-blue:hover.active:focus,
a.btn-blue.hover:active:focus,
button.btn-blue.hover:active:focus,
.btn-blue.hover:active:focus,
a.btn-blue:hover:active:focus,
button.btn-blue:hover:active:focus,
.btn-blue:hover:active:focus,
a.btn-blue.hover.active:focus-visible,
button.btn-blue.hover.active:focus-visible,
.btn-blue.hover.active:focus-visible,
a.btn-blue:hover.active:focus-visible,
button.btn-blue:hover.active:focus-visible,
.btn-blue:hover.active:focus-visible,
a.btn-blue.hover:active:focus-visible,
button.btn-blue.hover:active:focus-visible,
.btn-blue.hover:active:focus-visible,
a.btn-blue:hover:active:focus-visible,
button.btn-blue:hover:active:focus-visible,
.btn-blue:hover:active:focus-visible {
  background: #D7F4FA;
  outline: none;
  box-shadow: 0px 0px 0px 3px #EFFBFD;
}
a.btn-none,
button.btn-none,
.btn-none {
  background: transparent;
  color: #70859E;
}
a.btn-none svg,
button.btn-none svg,
.btn-none svg {
  stroke: #10294D;
}
a.btn-none.focus,
button.btn-none.focus,
.btn-none.focus,
a.btn-none:focus,
button.btn-none:focus,
.btn-none:focus,
a.btn-none:focus-visible,
button.btn-none:focus-visible,
.btn-none:focus-visible {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
a.btn-none.active,
button.btn-none.active,
.btn-none.active,
a.btn-none:active,
button.btn-none:active,
.btn-none:active {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
a.btn-none.active.focus,
button.btn-none.active.focus,
.btn-none.active.focus,
a.btn-none:active.focus,
button.btn-none:active.focus,
.btn-none:active.focus,
a.btn-none.active:focus,
button.btn-none.active:focus,
.btn-none.active:focus,
a.btn-none:active:focus,
button.btn-none:active:focus,
.btn-none:active:focus,
a.btn-none.active:focus-visible,
button.btn-none.active:focus-visible,
.btn-none.active:focus-visible,
a.btn-none:active:focus-visible,
button.btn-none:active:focus-visible,
.btn-none:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
a.btn-none.hover,
button.btn-none.hover,
.btn-none.hover,
a.btn-none:hover,
button.btn-none:hover,
.btn-none:hover {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
a.btn-none.hover.active,
button.btn-none.hover.active,
.btn-none.hover.active,
a.btn-none:hover.active,
button.btn-none:hover.active,
.btn-none:hover.active,
a.btn-none.hover:active,
button.btn-none.hover:active,
.btn-none.hover:active,
a.btn-none:hover:active,
button.btn-none:hover:active,
.btn-none:hover:active {
  border-color: transparent;
  background: transparent;
}
a.btn-none.hover.active.focus,
button.btn-none.hover.active.focus,
.btn-none.hover.active.focus,
a.btn-none:hover.active.focus,
button.btn-none:hover.active.focus,
.btn-none:hover.active.focus,
a.btn-none.hover:active.focus,
button.btn-none.hover:active.focus,
.btn-none.hover:active.focus,
a.btn-none:hover:active.focus,
button.btn-none:hover:active.focus,
.btn-none:hover:active.focus,
a.btn-none.hover.active:focus,
button.btn-none.hover.active:focus,
.btn-none.hover.active:focus,
a.btn-none:hover.active:focus,
button.btn-none:hover.active:focus,
.btn-none:hover.active:focus,
a.btn-none.hover:active:focus,
button.btn-none.hover:active:focus,
.btn-none.hover:active:focus,
a.btn-none:hover:active:focus,
button.btn-none:hover:active:focus,
.btn-none:hover:active:focus,
a.btn-none.hover.active:focus-visible,
button.btn-none.hover.active:focus-visible,
.btn-none.hover.active:focus-visible,
a.btn-none:hover.active:focus-visible,
button.btn-none:hover.active:focus-visible,
.btn-none:hover.active:focus-visible,
a.btn-none.hover:active:focus-visible,
button.btn-none.hover:active:focus-visible,
.btn-none.hover:active:focus-visible,
a.btn-none:hover:active:focus-visible,
button.btn-none:hover:active:focus-visible,
.btn-none:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
a.btn-none-red,
button.btn-none-red,
.btn-none-red {
  background: transparent;
  color: #70859E;
}
a.btn-none-red svg,
button.btn-none-red svg,
.btn-none-red svg {
  stroke: #FC495D;
}
a.btn-none-red.focus,
button.btn-none-red.focus,
.btn-none-red.focus,
a.btn-none-red:focus,
button.btn-none-red:focus,
.btn-none-red:focus,
a.btn-none-red:focus-visible,
button.btn-none-red:focus-visible,
.btn-none-red:focus-visible {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
a.btn-none-red.active,
button.btn-none-red.active,
.btn-none-red.active,
a.btn-none-red:active,
button.btn-none-red:active,
.btn-none-red:active {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
a.btn-none-red.active.focus,
button.btn-none-red.active.focus,
.btn-none-red.active.focus,
a.btn-none-red:active.focus,
button.btn-none-red:active.focus,
.btn-none-red:active.focus,
a.btn-none-red.active:focus,
button.btn-none-red.active:focus,
.btn-none-red.active:focus,
a.btn-none-red:active:focus,
button.btn-none-red:active:focus,
.btn-none-red:active:focus,
a.btn-none-red.active:focus-visible,
button.btn-none-red.active:focus-visible,
.btn-none-red.active:focus-visible,
a.btn-none-red:active:focus-visible,
button.btn-none-red:active:focus-visible,
.btn-none-red:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
a.btn-none-red.hover,
button.btn-none-red.hover,
.btn-none-red.hover,
a.btn-none-red:hover,
button.btn-none-red:hover,
.btn-none-red:hover {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
a.btn-none-red.hover.active,
button.btn-none-red.hover.active,
.btn-none-red.hover.active,
a.btn-none-red:hover.active,
button.btn-none-red:hover.active,
.btn-none-red:hover.active,
a.btn-none-red.hover:active,
button.btn-none-red.hover:active,
.btn-none-red.hover:active,
a.btn-none-red:hover:active,
button.btn-none-red:hover:active,
.btn-none-red:hover:active {
  border-color: transparent;
  background: transparent;
}
a.btn-none-red.hover.active.focus,
button.btn-none-red.hover.active.focus,
.btn-none-red.hover.active.focus,
a.btn-none-red:hover.active.focus,
button.btn-none-red:hover.active.focus,
.btn-none-red:hover.active.focus,
a.btn-none-red.hover:active.focus,
button.btn-none-red.hover:active.focus,
.btn-none-red.hover:active.focus,
a.btn-none-red:hover:active.focus,
button.btn-none-red:hover:active.focus,
.btn-none-red:hover:active.focus,
a.btn-none-red.hover.active:focus,
button.btn-none-red.hover.active:focus,
.btn-none-red.hover.active:focus,
a.btn-none-red:hover.active:focus,
button.btn-none-red:hover.active:focus,
.btn-none-red:hover.active:focus,
a.btn-none-red.hover:active:focus,
button.btn-none-red.hover:active:focus,
.btn-none-red.hover:active:focus,
a.btn-none-red:hover:active:focus,
button.btn-none-red:hover:active:focus,
.btn-none-red:hover:active:focus,
a.btn-none-red.hover.active:focus-visible,
button.btn-none-red.hover.active:focus-visible,
.btn-none-red.hover.active:focus-visible,
a.btn-none-red:hover.active:focus-visible,
button.btn-none-red:hover.active:focus-visible,
.btn-none-red:hover.active:focus-visible,
a.btn-none-red.hover:active:focus-visible,
button.btn-none-red.hover:active:focus-visible,
.btn-none-red.hover:active:focus-visible,
a.btn-none-red:hover:active:focus-visible,
button.btn-none-red:hover:active:focus-visible,
.btn-none-red:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
a.btn-subtle,
button.btn-subtle,
.btn-subtle {
  background: transparent;
  border: 1px solid #E5EBF1;
  color: #10294D;
}
a.btn-subtle svg,
button.btn-subtle svg,
.btn-subtle svg {
  stroke: #10294D;
}
a.btn-subtle.focus,
button.btn-subtle.focus,
.btn-subtle.focus,
a.btn-subtle:focus,
button.btn-subtle:focus,
.btn-subtle:focus,
a.btn-subtle:focus-visible,
button.btn-subtle:focus-visible,
.btn-subtle:focus-visible {
  color: #071B38;
  border: 1px solid #CED7E2;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
a.btn-subtle.active,
button.btn-subtle.active,
.btn-subtle.active,
a.btn-subtle:active,
button.btn-subtle:active,
.btn-subtle:active {
  color: #071B38;
  border: 1px solid #CED7E2;
  background: transparent;
}
a.btn-subtle.active.focus,
button.btn-subtle.active.focus,
.btn-subtle.active.focus,
a.btn-subtle:active.focus,
button.btn-subtle:active.focus,
.btn-subtle:active.focus,
a.btn-subtle.active:focus,
button.btn-subtle.active:focus,
.btn-subtle.active:focus,
a.btn-subtle:active:focus,
button.btn-subtle:active:focus,
.btn-subtle:active:focus,
a.btn-subtle.active:focus-visible,
button.btn-subtle.active:focus-visible,
.btn-subtle.active:focus-visible,
a.btn-subtle:active:focus-visible,
button.btn-subtle:active:focus-visible,
.btn-subtle:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
a.btn-subtle.hover,
button.btn-subtle.hover,
.btn-subtle.hover,
a.btn-subtle:hover,
button.btn-subtle:hover,
.btn-subtle:hover {
  color: #071B38;
  border: 1px solid #CED7E2;
  background: transparent;
}
a.btn-subtle.hover.active,
button.btn-subtle.hover.active,
.btn-subtle.hover.active,
a.btn-subtle:hover.active,
button.btn-subtle:hover.active,
.btn-subtle:hover.active,
a.btn-subtle.hover:active,
button.btn-subtle.hover:active,
.btn-subtle.hover:active,
a.btn-subtle:hover:active,
button.btn-subtle:hover:active,
.btn-subtle:hover:active {
  border-color: #CED7E2;
  background: transparent;
}
a.btn-subtle.hover.active.focus,
button.btn-subtle.hover.active.focus,
.btn-subtle.hover.active.focus,
a.btn-subtle:hover.active.focus,
button.btn-subtle:hover.active.focus,
.btn-subtle:hover.active.focus,
a.btn-subtle.hover:active.focus,
button.btn-subtle.hover:active.focus,
.btn-subtle.hover:active.focus,
a.btn-subtle:hover:active.focus,
button.btn-subtle:hover:active.focus,
.btn-subtle:hover:active.focus,
a.btn-subtle.hover.active:focus,
button.btn-subtle.hover.active:focus,
.btn-subtle.hover.active:focus,
a.btn-subtle:hover.active:focus,
button.btn-subtle:hover.active:focus,
.btn-subtle:hover.active:focus,
a.btn-subtle.hover:active:focus,
button.btn-subtle.hover:active:focus,
.btn-subtle.hover:active:focus,
a.btn-subtle:hover:active:focus,
button.btn-subtle:hover:active:focus,
.btn-subtle:hover:active:focus,
a.btn-subtle.hover.active:focus-visible,
button.btn-subtle.hover.active:focus-visible,
.btn-subtle.hover.active:focus-visible,
a.btn-subtle:hover.active:focus-visible,
button.btn-subtle:hover.active:focus-visible,
.btn-subtle:hover.active:focus-visible,
a.btn-subtle.hover:active:focus-visible,
button.btn-subtle.hover:active:focus-visible,
.btn-subtle.hover:active:focus-visible,
a.btn-subtle:hover:active:focus-visible,
button.btn-subtle:hover:active:focus-visible,
.btn-subtle:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
a.btn-text,
button.btn-text,
.btn-text {
  background: transparent;
  color: #10294D;
}
a.btn-text svg,
button.btn-text svg,
.btn-text svg {
  stroke: #CED7E2;
}
a.btn-text.focus,
button.btn-text.focus,
.btn-text.focus,
a.btn-text:focus,
button.btn-text:focus,
.btn-text:focus,
a.btn-text:focus-visible,
button.btn-text:focus-visible,
.btn-text:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
a.btn-text.active,
button.btn-text.active,
.btn-text.active,
a.btn-text:active,
button.btn-text:active,
.btn-text:active {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
a.btn-text.active.focus,
button.btn-text.active.focus,
.btn-text.active.focus,
a.btn-text:active.focus,
button.btn-text:active.focus,
.btn-text:active.focus,
a.btn-text.active:focus,
button.btn-text.active:focus,
.btn-text.active:focus,
a.btn-text:active:focus,
button.btn-text:active:focus,
.btn-text:active:focus,
a.btn-text.active:focus-visible,
button.btn-text.active:focus-visible,
.btn-text.active:focus-visible,
a.btn-text:active:focus-visible,
button.btn-text:active:focus-visible,
.btn-text:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
a.btn-text.hover,
button.btn-text.hover,
.btn-text.hover,
a.btn-text:hover,
button.btn-text:hover,
.btn-text:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
a.btn-text.hover.active,
button.btn-text.hover.active,
.btn-text.hover.active,
a.btn-text:hover.active,
button.btn-text:hover.active,
.btn-text:hover.active,
a.btn-text.hover:active,
button.btn-text.hover:active,
.btn-text.hover:active,
a.btn-text:hover:active,
button.btn-text:hover:active,
.btn-text:hover:active {
  border-color: transparent;
  background: transparent;
}
a.btn-text.hover.active.focus,
button.btn-text.hover.active.focus,
.btn-text.hover.active.focus,
a.btn-text:hover.active.focus,
button.btn-text:hover.active.focus,
.btn-text:hover.active.focus,
a.btn-text.hover:active.focus,
button.btn-text.hover:active.focus,
.btn-text.hover:active.focus,
a.btn-text:hover:active.focus,
button.btn-text:hover:active.focus,
.btn-text:hover:active.focus,
a.btn-text.hover.active:focus,
button.btn-text.hover.active:focus,
.btn-text.hover.active:focus,
a.btn-text:hover.active:focus,
button.btn-text:hover.active:focus,
.btn-text:hover.active:focus,
a.btn-text.hover:active:focus,
button.btn-text.hover:active:focus,
.btn-text.hover:active:focus,
a.btn-text:hover:active:focus,
button.btn-text:hover:active:focus,
.btn-text:hover:active:focus,
a.btn-text.hover.active:focus-visible,
button.btn-text.hover.active:focus-visible,
.btn-text.hover.active:focus-visible,
a.btn-text:hover.active:focus-visible,
button.btn-text:hover.active:focus-visible,
.btn-text:hover.active:focus-visible,
a.btn-text.hover:active:focus-visible,
button.btn-text.hover:active:focus-visible,
.btn-text.hover:active:focus-visible,
a.btn-text:hover:active:focus-visible,
button.btn-text:hover:active:focus-visible,
.btn-text:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
a.btn-text-only,
button.btn-text-only,
.btn-text-only {
  padding: 0;
  background: transparent;
  color: #10294D;
}
a.btn-text-only svg,
button.btn-text-only svg,
.btn-text-only svg {
  stroke: #CED7E2;
}
a.btn-text-only.focus,
button.btn-text-only.focus,
.btn-text-only.focus,
a.btn-text-only:focus,
button.btn-text-only:focus,
.btn-text-only:focus,
a.btn-text-only:focus-visible,
button.btn-text-only:focus-visible,
.btn-text-only:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
a.btn-text-only.active,
button.btn-text-only.active,
.btn-text-only.active,
a.btn-text-only:active,
button.btn-text-only:active,
.btn-text-only:active {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
a.btn-text-only.active.focus,
button.btn-text-only.active.focus,
.btn-text-only.active.focus,
a.btn-text-only:active.focus,
button.btn-text-only:active.focus,
.btn-text-only:active.focus,
a.btn-text-only.active:focus,
button.btn-text-only.active:focus,
.btn-text-only.active:focus,
a.btn-text-only:active:focus,
button.btn-text-only:active:focus,
.btn-text-only:active:focus,
a.btn-text-only.active:focus-visible,
button.btn-text-only.active:focus-visible,
.btn-text-only.active:focus-visible,
a.btn-text-only:active:focus-visible,
button.btn-text-only:active:focus-visible,
.btn-text-only:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
a.btn-text-only.hover,
button.btn-text-only.hover,
.btn-text-only.hover,
a.btn-text-only:hover,
button.btn-text-only:hover,
.btn-text-only:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
a.btn-text-only.hover.active,
button.btn-text-only.hover.active,
.btn-text-only.hover.active,
a.btn-text-only:hover.active,
button.btn-text-only:hover.active,
.btn-text-only:hover.active,
a.btn-text-only.hover:active,
button.btn-text-only.hover:active,
.btn-text-only.hover:active,
a.btn-text-only:hover:active,
button.btn-text-only:hover:active,
.btn-text-only:hover:active {
  border-color: transparent;
  background: transparent;
}
a.btn-text-only.hover.active.focus,
button.btn-text-only.hover.active.focus,
.btn-text-only.hover.active.focus,
a.btn-text-only:hover.active.focus,
button.btn-text-only:hover.active.focus,
.btn-text-only:hover.active.focus,
a.btn-text-only.hover:active.focus,
button.btn-text-only.hover:active.focus,
.btn-text-only.hover:active.focus,
a.btn-text-only:hover:active.focus,
button.btn-text-only:hover:active.focus,
.btn-text-only:hover:active.focus,
a.btn-text-only.hover.active:focus,
button.btn-text-only.hover.active:focus,
.btn-text-only.hover.active:focus,
a.btn-text-only:hover.active:focus,
button.btn-text-only:hover.active:focus,
.btn-text-only:hover.active:focus,
a.btn-text-only.hover:active:focus,
button.btn-text-only.hover:active:focus,
.btn-text-only.hover:active:focus,
a.btn-text-only:hover:active:focus,
button.btn-text-only:hover:active:focus,
.btn-text-only:hover:active:focus,
a.btn-text-only.hover.active:focus-visible,
button.btn-text-only.hover.active:focus-visible,
.btn-text-only.hover.active:focus-visible,
a.btn-text-only:hover.active:focus-visible,
button.btn-text-only:hover.active:focus-visible,
.btn-text-only:hover.active:focus-visible,
a.btn-text-only.hover:active:focus-visible,
button.btn-text-only.hover:active:focus-visible,
.btn-text-only.hover:active:focus-visible,
a.btn-text-only:hover:active:focus-visible,
button.btn-text-only:hover:active:focus-visible,
.btn-text-only:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
a.btn-grey,
button.btn-grey,
.btn-grey {
  background: #E5EBF1;
  color: #10294D;
}
a.btn-grey svg,
button.btn-grey svg,
.btn-grey svg {
  stroke: #10294D;
}
a.btn-grey.input-group-addon,
button.btn-grey.input-group-addon,
.btn-grey.input-group-addon {
  min-height: 34px;
  max-height: none;
  background: #E5EBF1;
  color: #10294D;
}
a.btn-grey.input-group-addon svg,
button.btn-grey.input-group-addon svg,
.btn-grey.input-group-addon svg {
  stroke: #10294D;
}
a.btn-grey.focus,
button.btn-grey.focus,
.btn-grey.focus,
a.btn-grey:focus,
button.btn-grey:focus,
.btn-grey:focus,
a.btn-grey:focus-visible,
button.btn-grey:focus-visible,
.btn-grey:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
a.btn-grey.active,
button.btn-grey.active,
.btn-grey.active,
a.btn-grey:active,
button.btn-grey:active,
.btn-grey:active {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
a.btn-grey.active.focus,
button.btn-grey.active.focus,
.btn-grey.active.focus,
a.btn-grey:active.focus,
button.btn-grey:active.focus,
.btn-grey:active.focus,
a.btn-grey.active:focus,
button.btn-grey.active:focus,
.btn-grey.active:focus,
a.btn-grey:active:focus,
button.btn-grey:active:focus,
.btn-grey:active:focus,
a.btn-grey.active:focus-visible,
button.btn-grey.active:focus-visible,
.btn-grey.active:focus-visible,
a.btn-grey:active:focus-visible,
button.btn-grey:active:focus-visible,
.btn-grey:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
a.btn-grey.hover,
button.btn-grey.hover,
.btn-grey.hover,
a.btn-grey:hover,
button.btn-grey:hover,
.btn-grey:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
a.btn-grey.hover.active,
button.btn-grey.hover.active,
.btn-grey.hover.active,
a.btn-grey:hover.active,
button.btn-grey:hover.active,
.btn-grey:hover.active,
a.btn-grey.hover:active,
button.btn-grey.hover:active,
.btn-grey.hover:active,
a.btn-grey:hover:active,
button.btn-grey:hover:active,
.btn-grey:hover:active {
  border-color: transparent;
  background: #CED7E2;
}
a.btn-grey.hover.active.focus,
button.btn-grey.hover.active.focus,
.btn-grey.hover.active.focus,
a.btn-grey:hover.active.focus,
button.btn-grey:hover.active.focus,
.btn-grey:hover.active.focus,
a.btn-grey.hover:active.focus,
button.btn-grey.hover:active.focus,
.btn-grey.hover:active.focus,
a.btn-grey:hover:active.focus,
button.btn-grey:hover:active.focus,
.btn-grey:hover:active.focus,
a.btn-grey.hover.active:focus,
button.btn-grey.hover.active:focus,
.btn-grey.hover.active:focus,
a.btn-grey:hover.active:focus,
button.btn-grey:hover.active:focus,
.btn-grey:hover.active:focus,
a.btn-grey.hover:active:focus,
button.btn-grey.hover:active:focus,
.btn-grey.hover:active:focus,
a.btn-grey:hover:active:focus,
button.btn-grey:hover:active:focus,
.btn-grey:hover:active:focus,
a.btn-grey.hover.active:focus-visible,
button.btn-grey.hover.active:focus-visible,
.btn-grey.hover.active:focus-visible,
a.btn-grey:hover.active:focus-visible,
button.btn-grey:hover.active:focus-visible,
.btn-grey:hover.active:focus-visible,
a.btn-grey.hover:active:focus-visible,
button.btn-grey.hover:active:focus-visible,
.btn-grey.hover:active:focus-visible,
a.btn-grey:hover:active:focus-visible,
button.btn-grey:hover:active:focus-visible,
.btn-grey:hover:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
a.btn-grey-50,
button.btn-grey-50,
.btn-grey-50 {
  background: #F3F5F8;
  color: #10294D;
}
a.btn-grey-50 svg,
button.btn-grey-50 svg,
.btn-grey-50 svg {
  stroke: #10294D;
}
a.btn-grey-50.input-group-addon,
button.btn-grey-50.input-group-addon,
.btn-grey-50.input-group-addon {
  min-height: 34px;
  max-height: none;
  background: #F3F5F8;
  color: #10294D;
}
a.btn-grey-50.input-group-addon svg,
button.btn-grey-50.input-group-addon svg,
.btn-grey-50.input-group-addon svg {
  stroke: #10294D;
}
a.btn-grey-50.focus,
button.btn-grey-50.focus,
.btn-grey-50.focus,
a.btn-grey-50:focus,
button.btn-grey-50:focus,
.btn-grey-50:focus,
a.btn-grey-50:focus-visible,
button.btn-grey-50:focus-visible,
.btn-grey-50:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
a.btn-grey-50.active,
button.btn-grey-50.active,
.btn-grey-50.active,
a.btn-grey-50:active,
button.btn-grey-50:active,
.btn-grey-50:active {
  color: #10294D;
  border: 1px solid transparent;
  background: #E5EBF1;
}
a.btn-grey-50.active.focus,
button.btn-grey-50.active.focus,
.btn-grey-50.active.focus,
a.btn-grey-50:active.focus,
button.btn-grey-50:active.focus,
.btn-grey-50:active.focus,
a.btn-grey-50.active:focus,
button.btn-grey-50.active:focus,
.btn-grey-50.active:focus,
a.btn-grey-50:active:focus,
button.btn-grey-50:active:focus,
.btn-grey-50:active:focus,
a.btn-grey-50.active:focus-visible,
button.btn-grey-50.active:focus-visible,
.btn-grey-50.active:focus-visible,
a.btn-grey-50:active:focus-visible,
button.btn-grey-50:active:focus-visible,
.btn-grey-50:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
a.btn-grey-50.hover,
button.btn-grey-50.hover,
.btn-grey-50.hover,
a.btn-grey-50:hover,
button.btn-grey-50:hover,
.btn-grey-50:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: #E5EBF1;
}
a.btn-grey-50.hover.active,
button.btn-grey-50.hover.active,
.btn-grey-50.hover.active,
a.btn-grey-50:hover.active,
button.btn-grey-50:hover.active,
.btn-grey-50:hover.active,
a.btn-grey-50.hover:active,
button.btn-grey-50.hover:active,
.btn-grey-50.hover:active,
a.btn-grey-50:hover:active,
button.btn-grey-50:hover:active,
.btn-grey-50:hover:active {
  border-color: transparent;
  background: #E5EBF1;
}
a.btn-grey-50.hover.active.focus,
button.btn-grey-50.hover.active.focus,
.btn-grey-50.hover.active.focus,
a.btn-grey-50:hover.active.focus,
button.btn-grey-50:hover.active.focus,
.btn-grey-50:hover.active.focus,
a.btn-grey-50.hover:active.focus,
button.btn-grey-50.hover:active.focus,
.btn-grey-50.hover:active.focus,
a.btn-grey-50:hover:active.focus,
button.btn-grey-50:hover:active.focus,
.btn-grey-50:hover:active.focus,
a.btn-grey-50.hover.active:focus,
button.btn-grey-50.hover.active:focus,
.btn-grey-50.hover.active:focus,
a.btn-grey-50:hover.active:focus,
button.btn-grey-50:hover.active:focus,
.btn-grey-50:hover.active:focus,
a.btn-grey-50.hover:active:focus,
button.btn-grey-50.hover:active:focus,
.btn-grey-50.hover:active:focus,
a.btn-grey-50:hover:active:focus,
button.btn-grey-50:hover:active:focus,
.btn-grey-50:hover:active:focus,
a.btn-grey-50.hover.active:focus-visible,
button.btn-grey-50.hover.active:focus-visible,
.btn-grey-50.hover.active:focus-visible,
a.btn-grey-50:hover.active:focus-visible,
button.btn-grey-50:hover.active:focus-visible,
.btn-grey-50:hover.active:focus-visible,
a.btn-grey-50.hover:active:focus-visible,
button.btn-grey-50.hover:active:focus-visible,
.btn-grey-50.hover:active:focus-visible,
a.btn-grey-50:hover:active:focus-visible,
button.btn-grey-50:hover:active:focus-visible,
.btn-grey-50:hover:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
a.btn-white,
button.btn-white,
.btn-white {
  background: #ffffff;
  color: #10294D;
}
a.btn-white svg,
button.btn-white svg,
.btn-white svg {
  stroke: #CED7E2;
}
a.btn-white.input-group-addon,
button.btn-white.input-group-addon,
.btn-white.input-group-addon {
  min-height: 34px;
  max-height: none;
  background: #E5EBF1;
  color: #10294D;
}
a.btn-white.input-group-addon svg,
button.btn-white.input-group-addon svg,
.btn-white.input-group-addon svg {
  stroke: #CED7E2;
}
a.btn-white.focus,
button.btn-white.focus,
.btn-white.focus,
a.btn-white:focus,
button.btn-white:focus,
.btn-white:focus,
a.btn-white:focus-visible,
button.btn-white:focus-visible,
.btn-white:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
a.btn-white.active,
button.btn-white.active,
.btn-white.active,
a.btn-white:active,
button.btn-white:active,
.btn-white:active {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
a.btn-white.active.focus,
button.btn-white.active.focus,
.btn-white.active.focus,
a.btn-white:active.focus,
button.btn-white:active.focus,
.btn-white:active.focus,
a.btn-white.active:focus,
button.btn-white.active:focus,
.btn-white.active:focus,
a.btn-white:active:focus,
button.btn-white:active:focus,
.btn-white:active:focus,
a.btn-white.active:focus-visible,
button.btn-white.active:focus-visible,
.btn-white.active:focus-visible,
a.btn-white:active:focus-visible,
button.btn-white:active:focus-visible,
.btn-white:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
a.btn-white.hover,
button.btn-white.hover,
.btn-white.hover,
a.btn-white:hover,
button.btn-white:hover,
.btn-white:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
a.btn-white.hover.active,
button.btn-white.hover.active,
.btn-white.hover.active,
a.btn-white:hover.active,
button.btn-white:hover.active,
.btn-white:hover.active,
a.btn-white.hover:active,
button.btn-white.hover:active,
.btn-white.hover:active,
a.btn-white:hover:active,
button.btn-white:hover:active,
.btn-white:hover:active {
  border-color: transparent;
  background: #CED7E2;
}
a.btn-white.hover.active.focus,
button.btn-white.hover.active.focus,
.btn-white.hover.active.focus,
a.btn-white:hover.active.focus,
button.btn-white:hover.active.focus,
.btn-white:hover.active.focus,
a.btn-white.hover:active.focus,
button.btn-white.hover:active.focus,
.btn-white.hover:active.focus,
a.btn-white:hover:active.focus,
button.btn-white:hover:active.focus,
.btn-white:hover:active.focus,
a.btn-white.hover.active:focus,
button.btn-white.hover.active:focus,
.btn-white.hover.active:focus,
a.btn-white:hover.active:focus,
button.btn-white:hover.active:focus,
.btn-white:hover.active:focus,
a.btn-white.hover:active:focus,
button.btn-white.hover:active:focus,
.btn-white.hover:active:focus,
a.btn-white:hover:active:focus,
button.btn-white:hover:active:focus,
.btn-white:hover:active:focus,
a.btn-white.hover.active:focus-visible,
button.btn-white.hover.active:focus-visible,
.btn-white.hover.active:focus-visible,
a.btn-white:hover.active:focus-visible,
button.btn-white:hover.active:focus-visible,
.btn-white:hover.active:focus-visible,
a.btn-white.hover:active:focus-visible,
button.btn-white.hover:active:focus-visible,
.btn-white.hover:active:focus-visible,
a.btn-white:hover:active:focus-visible,
button.btn-white:hover:active:focus-visible,
.btn-white:hover:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
a.btn-white:hover svg,
button.btn-white:hover svg,
.btn-white:hover svg,
a.btn-white.active svg,
button.btn-white.active svg,
.btn-white.active svg,
a.btn-white:active svg,
button.btn-white:active svg,
.btn-white:active svg {
  stroke: #10294D;
}
a.btn.disabled,
button.btn.disabled,
.btn.disabled,
a.btn[disabled],
button.btn[disabled],
.btn[disabled] {
  background: #E5EBF1;
  border: 1px solid transparent;
  cursor: not-allowed;
  color: #CED7E2;
}
a.btn.disabled svg,
button.btn.disabled svg,
.btn.disabled svg,
a.btn[disabled] svg,
button.btn[disabled] svg,
.btn[disabled] svg {
  display: block;
  stroke: #CED7E2;
}
a.btn.disabled.focus,
button.btn.disabled.focus,
.btn.disabled.focus,
a.btn[disabled].focus,
button.btn[disabled].focus,
.btn[disabled].focus,
a.btn.disabled:focus,
button.btn.disabled:focus,
.btn.disabled:focus,
a.btn[disabled]:focus,
button.btn[disabled]:focus,
.btn[disabled]:focus,
a.btn.disabled:focus-visible,
button.btn.disabled:focus-visible,
.btn.disabled:focus-visible,
a.btn[disabled]:focus-visible,
button.btn[disabled]:focus-visible,
.btn[disabled]:focus-visible {
  color: #CED7E2;
  border: 1px solid transparent;
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
a.btn.disabled.active,
button.btn.disabled.active,
.btn.disabled.active,
a.btn[disabled].active,
button.btn[disabled].active,
.btn[disabled].active,
a.btn.disabled:active,
button.btn.disabled:active,
.btn.disabled:active,
a.btn[disabled]:active,
button.btn[disabled]:active,
.btn[disabled]:active {
  color: #CED7E2;
  border: 1px solid transparent;
  background: #E5EBF1;
}
a.btn.disabled.active.focus,
button.btn.disabled.active.focus,
.btn.disabled.active.focus,
a.btn[disabled].active.focus,
button.btn[disabled].active.focus,
.btn[disabled].active.focus,
a.btn.disabled:active.focus,
button.btn.disabled:active.focus,
.btn.disabled:active.focus,
a.btn[disabled]:active.focus,
button.btn[disabled]:active.focus,
.btn[disabled]:active.focus,
a.btn.disabled.active:focus,
button.btn.disabled.active:focus,
.btn.disabled.active:focus,
a.btn[disabled].active:focus,
button.btn[disabled].active:focus,
.btn[disabled].active:focus,
a.btn.disabled:active:focus,
button.btn.disabled:active:focus,
.btn.disabled:active:focus,
a.btn[disabled]:active:focus,
button.btn[disabled]:active:focus,
.btn[disabled]:active:focus,
a.btn.disabled.active:focus-visible,
button.btn.disabled.active:focus-visible,
.btn.disabled.active:focus-visible,
a.btn[disabled].active:focus-visible,
button.btn[disabled].active:focus-visible,
.btn[disabled].active:focus-visible,
a.btn.disabled:active:focus-visible,
button.btn.disabled:active:focus-visible,
.btn.disabled:active:focus-visible,
a.btn[disabled]:active:focus-visible,
button.btn[disabled]:active:focus-visible,
.btn[disabled]:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
a.btn.disabled.hover,
button.btn.disabled.hover,
.btn.disabled.hover,
a.btn[disabled].hover,
button.btn[disabled].hover,
.btn[disabled].hover,
a.btn.disabled:hover,
button.btn.disabled:hover,
.btn.disabled:hover,
a.btn[disabled]:hover,
button.btn[disabled]:hover,
.btn[disabled]:hover {
  color: #CED7E2;
  border: 1px solid transparent;
  background: #E5EBF1;
}
a.btn.disabled.hover.active,
button.btn.disabled.hover.active,
.btn.disabled.hover.active,
a.btn[disabled].hover.active,
button.btn[disabled].hover.active,
.btn[disabled].hover.active,
a.btn.disabled:hover.active,
button.btn.disabled:hover.active,
.btn.disabled:hover.active,
a.btn[disabled]:hover.active,
button.btn[disabled]:hover.active,
.btn[disabled]:hover.active,
a.btn.disabled.hover:active,
button.btn.disabled.hover:active,
.btn.disabled.hover:active,
a.btn[disabled].hover:active,
button.btn[disabled].hover:active,
.btn[disabled].hover:active,
a.btn.disabled:hover:active,
button.btn.disabled:hover:active,
.btn.disabled:hover:active,
a.btn[disabled]:hover:active,
button.btn[disabled]:hover:active,
.btn[disabled]:hover:active {
  border-color: transparent;
  background: #E5EBF1;
}
a.btn.disabled.hover.active.focus,
button.btn.disabled.hover.active.focus,
.btn.disabled.hover.active.focus,
a.btn[disabled].hover.active.focus,
button.btn[disabled].hover.active.focus,
.btn[disabled].hover.active.focus,
a.btn.disabled:hover.active.focus,
button.btn.disabled:hover.active.focus,
.btn.disabled:hover.active.focus,
a.btn[disabled]:hover.active.focus,
button.btn[disabled]:hover.active.focus,
.btn[disabled]:hover.active.focus,
a.btn.disabled.hover:active.focus,
button.btn.disabled.hover:active.focus,
.btn.disabled.hover:active.focus,
a.btn[disabled].hover:active.focus,
button.btn[disabled].hover:active.focus,
.btn[disabled].hover:active.focus,
a.btn.disabled:hover:active.focus,
button.btn.disabled:hover:active.focus,
.btn.disabled:hover:active.focus,
a.btn[disabled]:hover:active.focus,
button.btn[disabled]:hover:active.focus,
.btn[disabled]:hover:active.focus,
a.btn.disabled.hover.active:focus,
button.btn.disabled.hover.active:focus,
.btn.disabled.hover.active:focus,
a.btn[disabled].hover.active:focus,
button.btn[disabled].hover.active:focus,
.btn[disabled].hover.active:focus,
a.btn.disabled:hover.active:focus,
button.btn.disabled:hover.active:focus,
.btn.disabled:hover.active:focus,
a.btn[disabled]:hover.active:focus,
button.btn[disabled]:hover.active:focus,
.btn[disabled]:hover.active:focus,
a.btn.disabled.hover:active:focus,
button.btn.disabled.hover:active:focus,
.btn.disabled.hover:active:focus,
a.btn[disabled].hover:active:focus,
button.btn[disabled].hover:active:focus,
.btn[disabled].hover:active:focus,
a.btn.disabled:hover:active:focus,
button.btn.disabled:hover:active:focus,
.btn.disabled:hover:active:focus,
a.btn[disabled]:hover:active:focus,
button.btn[disabled]:hover:active:focus,
.btn[disabled]:hover:active:focus,
a.btn.disabled.hover.active:focus-visible,
button.btn.disabled.hover.active:focus-visible,
.btn.disabled.hover.active:focus-visible,
a.btn[disabled].hover.active:focus-visible,
button.btn[disabled].hover.active:focus-visible,
.btn[disabled].hover.active:focus-visible,
a.btn.disabled:hover.active:focus-visible,
button.btn.disabled:hover.active:focus-visible,
.btn.disabled:hover.active:focus-visible,
a.btn[disabled]:hover.active:focus-visible,
button.btn[disabled]:hover.active:focus-visible,
.btn[disabled]:hover.active:focus-visible,
a.btn.disabled.hover:active:focus-visible,
button.btn.disabled.hover:active:focus-visible,
.btn.disabled.hover:active:focus-visible,
a.btn[disabled].hover:active:focus-visible,
button.btn[disabled].hover:active:focus-visible,
.btn[disabled].hover:active:focus-visible,
a.btn.disabled:hover:active:focus-visible,
button.btn.disabled:hover:active:focus-visible,
.btn.disabled:hover:active:focus-visible,
a.btn[disabled]:hover:active:focus-visible,
button.btn[disabled]:hover:active:focus-visible,
.btn[disabled]:hover:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
a.btn-icon-16 .icon,
button.btn-icon-16 .icon,
.btn-icon-16 .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
}
a.btn-icon-16 .icon svg,
button.btn-icon-16 .icon svg,
.btn-icon-16 .icon svg {
  width: 16px;
  height: 16px;
  stroke-width: 2.4;
}
a.btn-icon-24 .icon,
button.btn-icon-24 .icon,
.btn-icon-24 .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
}
a.btn-icon-24 .icon svg,
button.btn-icon-24 .icon svg,
.btn-icon-24 .icon svg {
  width: 24px;
  height: 24px;
  stroke-width: 1.4;
}
a.btn-icon-right,
button.btn-icon-right,
.btn-icon-right {
  padding-right: 10px;
}
a.btn-icon-right .icon,
button.btn-icon-right .icon,
.btn-icon-right .icon {
  order: 1;
  margin-left: 5px;
}
a.btn-icon-right .icon svg,
button.btn-icon-right .icon svg,
.btn-icon-right .icon svg {
  fill: none;
}
a.btn-icon-left,
button.btn-icon-left,
.btn-icon-left {
  padding-left: 10px;
}
a.btn-icon-left .icon,
button.btn-icon-left .icon,
.btn-icon-left .icon {
  order: 0;
  margin-right: 5px;
}
a.btn-icon-left .icon svg,
button.btn-icon-left .icon svg,
.btn-icon-left .icon svg {
  fill: none;
}
a.btn-icon-righta.btn-icon-left .icon,
a.btn-icon-rightbutton.btn-icon-left .icon,
a.btn-icon-right.btn-icon-left .icon,
button.btn-icon-righta.btn-icon-left .icon,
button.btn-icon-rightbutton.btn-icon-left .icon,
button.btn-icon-right.btn-icon-left .icon,
.btn-icon-righta.btn-icon-left .icon,
.btn-icon-rightbutton.btn-icon-left .icon,
.btn-icon-right.btn-icon-left .icon {
  margin: 0;
}
a.btn-icon-only,
button.btn-icon-only,
.btn-icon-only {
  padding: 0;
}
a.btn-icon-only.btn-icon-24,
button.btn-icon-only.btn-icon-24,
.btn-icon-only.btn-icon-24 {
  min-height: 26px;
  max-height: 26px;
  max-width: 26px;
}
a.btn-icon-only.btn-icon-24 .icon,
button.btn-icon-only.btn-icon-24 .icon,
.btn-icon-only.btn-icon-24 .icon {
  max-height: 24px;
  max-width: 24px;
}
a.btn-icon-only.btn-icon-16,
button.btn-icon-only.btn-icon-16,
.btn-icon-only.btn-icon-16 {
  min-height: 18px;
  max-height: 18px;
  max-width: 18px;
}
a.btn-icon-only.btn-icon-16 .icon,
button.btn-icon-only.btn-icon-16 .icon,
.btn-icon-only.btn-icon-16 .icon {
  max-height: 16px;
  max-width: 16px;
}
a.btn-icon-only.input-group-addon,
button.btn-icon-only.input-group-addon,
.btn-icon-only.input-group-addon {
  min-height: 34px;
  max-height: none;
}
a.btn-icon-success .icon svg,
button.btn-icon-success .icon svg,
.btn-icon-success .icon svg {
  fill: none;
  stroke: #73C677;
}
a.btn-glyph .icon svg,
button.btn-glyph .icon svg,
.btn-glyph .icon svg {
  stroke: none;
}
a.btn.highlight,
button.btn.highlight,
.btn.highlight {
  --color4: #60D3EC;
}
a.btn.has-submenu,
button.btn.has-submenu,
.btn.has-submenu {
  padding: 0;
}
a.btn-red-text,
button.btn-red-text,
.btn-red-text {
  color: #FC495D;
  padding-left: 1px;
}
.track-vertical {
  width: 6px;
  top: 2px;
  right: 2px;
  bottom: 2px;
}
.track-horizontal {
  height: 6px;
  right: 8px;
  left: 2px;
  bottom: 2px;
}
.thumb-vertical {
  background: #92A7C0;
  border-radius: 3px;
}
.thumb-horizontal {
  background: #92A7C0;
  border-radius: 3px;
}
.user-photo {
  position: relative;
}
.avatar-sm {
  flex: 0 0 auto;
}
.avatar-sm > .thumbimg {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.avatar-md {
  flex: 0 0 auto;
}
.avatar-md > .thumbimg {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}
.avatar-lg {
  flex: 0 0 auto;
}
.avatar-lg > .thumbimg {
  width: 64px;
  height: 64px;
  border-radius: 50%;
}
.avatar > .thumbimg {
  overflow: hidden;
}
.avatar > .thumbimg img {
  aspect-ratio: 1 / 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.avatar > .initials {
  stroke: none;
}
.avatar > .initials svg {
  stroke: none;
}
.avatar > .initials svg circle {
  fill: #FFF6F7;
}
.avatar > .initials svg text {
  stroke: none;
  fill: #FC495D;
}
.avatar svg {
  width: 100%;
  height: 100%;
  stroke: #CED7E2;
}
iframe {
  border: 0 none;
}
.wrapper {
  max-width: 100vw;
  position: relative;
  display: grid;
  grid-gap: 0;
  grid-template-rows: auto 1fr;
  height: 100vh;
  grid-template-areas: "header" "content";
}
@media (min-width: 800px) {
  .wrapper {
    grid-template-areas: "header header" "nav content";
  }
}
.wrapper.login {
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  grid-template-areas: "content";
}
.wrapper.login .content:not(.form-group) {
  width: 100%;
  height: 100vh;
  background: none;
}
.wrapper.modaled {
  opacity: 0.5;
}
.main .showmenu .context-sidebar {
  border-left: 1px solid #efefef;
  width: 280px;
  z-index: 900;
}
.main .showmenu .menubtn {
  background-color: #fff;
}
.main .showmenu .menubtn > div,
.main .showmenu .menubtn > div:before,
.main .showmenu .menubtn > div:after {
  background-color: #FC495D;
}
/* Loader */
.loader {
  margin: 0 auto;
  position: relative;
  z-index: 9999;
}
.loader svg {
  width: 40px;
  height: 40px;
}
.loader svg image {
  width: 100%;
  height: 100%;
}
.loader.inline {
  z-index: auto;
  display: inline-flex;
  justify-content: center;
  align-content: center;
}
.loader.inline svg {
  width: 14px;
  height: 14px;
}
.loader.inline.large svg {
  width: 40px;
  height: 40px;
  margin: 20px;
}
/* Errors */
.viewerror {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: calc(100vh - 68px);
}
.viewerror.view.container-fluid {
  grid-area: view;
  height: 100vh;
}
.viewerror svg {
  height: 100px;
  fill: #CED7E2;
}
.viewerror .err {
  max-width: 280px;
}
@keyframes load8 {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
.isloading {
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.login .isloading {
  top: 0 !important;
  left: 0 !important;
}
.isloading.inline {
  display: inline-block;
  width: auto;
  position: relative;
  top: 10px;
  left: 10px;
  height: 30px;
}
.isloading.block {
  margin: 0 auto;
  width: auto;
  height: 100%;
  width: 100%;
  z-index: 950;
  background: rgba(255, 255, 255, 0.5);
}
@media (min-width: 799px) {
  .isloading.block {
    top: 68px;
    left: 64px;
  }
  .isloading.block .loader {
    margin-top: -68px;
    margin-left: calc(50% - 54px);
  }
}
.isloading.solid {
  background: #ffffff;
}
button.disabled,
.btn.disabled,
.navitem.disabled {
  cursor: not-allowed;
}
.flex-container {
  display: flex;
  flex-wrap: wrap;
}
.card .cardbody .flex-container.ccontent {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 100%;
}
.flex-container.gap-20 {
  gap: 20px 20px;
}
.flex-container.gap-40 {
  gap: 40px;
}
.text-left .checkcontainer {
  align-items: flex-start;
}
.text-right .checkcontainer {
  align-items: flex-end;
}
.text-center .checkcontainer {
  align-items: middle;
}
.grid-container {
  display: grid;
  gap: 16px 16px;
}
@media screen and (min-width: 799px) {
  .grid-container {
    grid-template-columns: repeat(4, 1fr [col-start]);
  }
}
.card .cardbody .grid-container.ccontent {
  padding: 0;
}
.grid-container .card .cardbody {
  margin-bottom: auto;
}
@media screen and (min-width: 799px) {
  .grid-container.grid-3 {
    grid-template-columns: repeat(3, 1fr [col-start]);
  }
}
@media screen and (min-width: 799px) {
  .grid-container.grid-2 {
    grid-template-columns: repeat(2, 1fr [col-start]);
  }
}
@media screen and (min-width: 799px) {
  .grid-container.grid-1 {
    grid-template-columns: repeat(1, 1fr [col-start]);
  }
}
.grid-container .grid-row-2 {
  grid-row: span 2;
}
.grid-container .grid-row-3 {
  grid-row: span 3;
}
.grid-container .card {
  margin: 0;
}
.grid-container .no-grow {
  margin-bottom: auto;
}
.grid-container .grid-col-5 {
  grid-column: span 5;
}
.grid-container .grid-col-4 {
  grid-column: span 4;
}
.grid-container .grid-col-3 {
  grid-column: span 4;
  align-content: flex-start;
}
.grid-5 .grid-container .grid-col-3 {
  grid-column: span 5;
}
@media screen and (min-width: 799px) {
  .grid-container .grid-col-3 {
    grid-column: span 3;
  }
}
.grid-container .grid-col-2 {
  grid-column: span 4;
  align-content: flex-start;
}
.grid-5 .grid-container .grid-col-2 {
  grid-column: span 5;
}
@media screen and (min-width: 799px) {
  .grid-container .grid-col-2 {
    grid-column: span 2;
  }
}
.grid-container .grid-col-1 {
  grid-column: span 4;
  align-content: flex-start;
}
.grid-5 .grid-container .grid-col-1 {
  grid-column: span 5;
}
@media screen and (min-width: 799px) {
  .grid-container .grid-col-1 {
    grid-column: span 1;
  }
}
@media screen and (min-width: 799px) {
  .grid-container.grid-5 {
    grid-template-columns: repeat(5, 1fr [col-start]);
  }
}
.grid-container.grid-5 .grid-col-3 {
  grid-column: span 5;
  align-content: flex-start;
}
@media screen and (min-width: 799px) {
  .grid-container.grid-5 .grid-col-3 {
    grid-column: span 3;
  }
}
.grid-container.grid-5 .grid-col-2 {
  grid-column: span 5;
  align-content: flex-start;
}
@media screen and (min-width: 799px) {
  .grid-container.grid-5 .grid-col-2 {
    grid-column: span 2;
  }
}
.grid-container.grid-5 .grid-col-1 {
  grid-column: span 5;
  align-content: flex-start;
}
@media screen and (min-width: 799px) {
  .grid-container.grid-5 .grid-col-1 {
    grid-column: span 1;
  }
}
.grid-container .grid-listing-details {
  order: -1;
}
@media screen and (min-width: 799px) {
  .grid-container .grid-listing-details {
    order: unset;
  }
}
.grid-container > [class^="grid-col-"],
.grid-container > [class*="grid-col-"] {
  display: grid;
  min-width: 0;
}
@media screen and (max-width: 799px) {
  .grid-container > [class^="grid-col-"],
  .grid-container > [class*="grid-col-"] {
    grid-column: span 5;
  }
}
.grid-container > [class^="grid-col-"] > *,
.grid-container > [class*="grid-col-"] > * {
  min-width: 0;
}
.monaco-editor {
  min-height: 100px;
  resize: vertical;
  overflow: auto;
}
.monaco-editor .monaco-editor-tabs {
  margin-top: -6px;
  margin-left: -15px;
  display: flex;
  height: 35px;
}
.monaco-editor .monaco-editor-tabs .monaco-editor-tab {
  background: rgba(227, 228, 226, 0.16);
  color: #fff;
  border-right: 1px solid #1e1f1c;
  background-color: #34352f;
  padding-left: 12px;
  width: 120px;
  min-width: fit-content;
  min-width: -moz-fit-content;
  flex-shrink: 0;
  font-family: Menlo, Monaco, "Courier New", monospace;
  font-weight: normal;
  font-size: 12px;
  font-feature-settings: "liga" 0, "calt" 0;
  line-height: 18px;
  letter-spacing: 0px;
  line-height: 35px;
}
.monaco-editor .monaco-editor-tabs .monaco-editor-tab.active {
  background: rgba(227, 228, 226, 0.16);
  color: var(--vscode-textPreformat-foreground);
}
.version-list {
  display: grid;
  gap: 20px;
  padding: 0;
  margin: 0 0 0 -20px;
  grid-template-areas: "jump-menu" "details";
}
@media screen and (min-width: 799px) {
  .version-list {
    grid-template-areas: "jump-menu details";
    grid-template-columns: 370px auto;
    grid-template-rows: auto;
  }
}
.version-list .stepper {
  grid-area: details;
}
.version-list .versions {
  grid-area: details;
}
.version-list .versions .tablemeta {
  padding-top: 0;
  flex: 0 0 100%;
}
.version-list .versions .version-buttons {
  display: flex;
  gap: 15px 6px;
}
.reviewComment {
  margin: 8px;
  margin-top: 0;
  padding: 8px;
  border-top: 1px solid var(--vscode-textSeparator-foreground);
  border-bottom: 1px solid var(--vscode-textSeparator-foreground);
}
.reviewComment > div {
  border-radius: 6px !important;
  border: 1px solid var(--vscode-textSeparator-foreground);
}
.reviewComment > div .reviewComment-meta {
  border-radius: 6px !important;
  padding-right: 8px !important;
  padding-left: 8px !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.reviewComment > div .reviewComment-text {
  padding-right: 8px !important;
  padding-left: 8px !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.headerwrap {
  grid-area: header;
  position: sticky;
  top: 0px;
  z-index: 950;
}
@media (max-width: 799px) {
  .headerwrap.down {
    top: -60px;
  }
}
/* Main Header */
.main-header {
  left: 0;
  right: 0;
  top: 68px;
  background: #10294D;
  color: #ffffff;
  display: flex;
  flex-wrap: wrap;
  font-weight: 400;
  /* User */
  /* User */
  /* Menu */
}
.main-header svg {
  vertical-align: middle;
  transition: all 0.3s ease 0s;
}
@media print {
  .main-header {
    display: none;
  }
}
@media (min-width: 799px) {
  .main-header {
    background: #ffffff;
    color: #10294D;
    flex-wrap: nowrap;
  }
}
.main-header .navbtn {
  left: 0;
  top: 0;
  max-width: 64px;
  flex: 0 0 64px;
  height: 68px;
  background-color: inherit;
  background-image: none;
  line-height: 1;
  display: inline-block;
  text-align: center;
  cursor: pointer;
  background: #10294D;
  position: relative;
  color: #ffffff;
  z-index: 1;
}
.main-header .navbtn:before {
  content: "";
  width: 64px;
  position: absolute;
  height: 68px;
  top: 0;
  left: 0;
  background: #10294D;
  z-index: -1;
}
.main-header .navbtn > div {
  display: inline-block;
  line-height: 68px;
  height: 100%;
}
.main-header .navbtn > div svg {
  width: 24px;
  height: 24px;
  fill: none;
  stroke: #ffffff;
  stroke-width: 1.4;
  position: absolute;
  top: 50%;
  margin-top: -12px;
  left: 50%;
  margin-left: -12px;
  transition: all 0.2s ease-in-out;
}
.main-header .navbtn > div svg.close {
  opacity: 0;
  transform: scale(0);
}
.main-header .navbtn > div svg.open {
  opacity: 1;
  transform: scale(1);
}
.main-header .navbtn + div:nth-child(2) {
  margin-left: auto;
}
.main-header .navbtn .icon-bar {
  width: 22px;
  height: 3px;
  display: block;
  border-radius: 6px;
  background: #ffffff;
  margin-bottom: 4px;
}
.main-header .navbtn .icon-bar:last-of-type {
  margin-bottom: 0;
}
.main-header .breadcrumbs {
  order: 4;
  background: #ffffff;
  color: #92A7C0;
  flex: 0 0 100%;
  padding: 11.5px 20px;
  display: flex;
  align-items: center;
  font-size: 14px;
  justify-content: flex-start;
}
@media (min-width: 799px) {
  .main-header .breadcrumbs {
    order: 0;
    flex: 1 1 auto;
  }
}
.main-header .breadcrumbs .crumb {
  text-transform: capitalize;
  color: #92A7C0;
}
.main-header .breadcrumbs .crumb span.title {
  text-transform: none;
}
.main-header .breadcrumbs .crumb a.lower {
  text-transform: lowercase;
}
.main-header .breadcrumbs .crumb span:last-of-type {
  color: #10294D;
  font-weight: 600;
}
.main-header .breadcrumbs .crumb span,
.main-header .breadcrumbs .crumb a {
  color: #92A7C0;
}
.main-header .breadcrumbs .crumb span:before,
.main-header .breadcrumbs .crumb a:before {
  display: inline-block;
  width: 20px;
  height: 16px;
  vertical-align: top;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.main-header ~ .wrapper {
  margin-top: 68px;
}
.main-header .userhead {
  display: flex;
  cursor: pointer;
  margin-right: 10px;
  order: 2;
}
.main-header .userhead .user-toggle {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
}
.main-header .userhead .user-toggle .user-details {
  margin-right: 10px;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  text-align: right;
}
.main-header .userhead .user-toggle .user-name {
  flex: 0 0 auto;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.main-header .userhead .user-toggle .site-name {
  flex: 0 0 auto;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
}
.main-header .globaladd {
  display: flex;
  cursor: pointer;
  margin-right: 10px;
  align-items: center;
  order: 3;
}
.main-header .globaladd .thumbimg {
  background: #FC495D;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-header .globaladd svg {
  width: 24px;
  stroke: #ffffff;
  stroke-width: 2.4;
}
.main-header .menubtn {
  margin-left: auto;
  width: 50px;
  height: 68px;
  line-height: 68px;
  cursor: pointer;
  text-align: center;
  position: relative;
  transition: all 0.2s ease 0s;
}
.main-header .menubtn > div {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #ffffff;
  transform: translate(0, 0);
  display: inline-block;
  vertical-align: middle;
  line-height: 0;
}
.main-header .menubtn > div:before {
  content: "";
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #ffffff;
  transform: translate(0, -9px);
}
.main-header .menubtn > div:after {
  content: "";
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #ffffff;
  transform: translate(0, 4px);
}
/* Notifications */
.alertshead,
.chatshead {
  cursor: pointer;
  max-width: 50px;
  display: none;
  flex: 0 0 50px;
  height: 68px;
  line-height: 68px;
  margin-left: auto;
  order: 1;
  justify-content: center;
  align-items: center;
}
@media screen and (min-width: 799px) {
  .alertshead,
  .chatshead {
    display: flex;
  }
}
.alertshead .btn,
.chatshead .btn {
  padding: 0;
  position: relative;
}
.alertshead .btn .icon svg,
.chatshead .btn .icon svg {
  fill: none;
  stroke: #10294D;
}
.alertshead .badge,
.chatshead .badge {
  position: absolute;
  font-size: 10px;
  min-width: 14px;
  display: block;
  line-height: 1;
  bottom: 50%;
  left: 50%;
  text-align: center;
  border-radius: 50%;
}
.alertshead + .userhead,
.chatshead + .userhead {
  margin-left: 20px;
}
.user-menu {
  background: #FFFFFF;
  border: 1px solid #CFCDCD;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
  z-index: 100;
  flex-direction: column;
  padding: 0 0 20px 0;
  overflow: auto;
}
@media screen and (min-width: 799px) {
  .user-menu {
    padding-top: 20px;
  }
}
.user-menu .selectinput.default_home_page {
  margin: 0 20px;
}
.user-menu .action {
  display: flex;
  position: relative;
  cursor: pointer;
  padding: 0.75rem 20px;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
}
.user-menu .action svg {
  fill: none;
  stroke: #10294D;
  stroke-width: 1.4;
}
.user-menu .action .icon {
  margin-right: 10px;
}
.user-menu .action:hover {
  background: #F3F5F8;
}
.user-menu .action.menu-close {
  width: 36px;
  height: 36px;
  max-width: 36px;
  padding: 0;
  justify-content: center;
  align-items: center;
  background: #E5EBF1;
  border-radius: 18px;
  margin-left: auto;
}
.user-menu .action.menu-close svg {
  fill: none;
  stroke: #10294D;
  stroke-width: 1.4;
}
.user-menu .action.alerts-head svg {
  fill: none;
  stroke: #10294D;
  stroke-width: 1.4;
}
.user-menu .menu-icons {
  display: flex;
  padding: 20px;
  gap: 0 10px;
}
.user-menu .menu-icons .btn {
  flex: 0 0 auto;
  width: 45px;
  height: 45px;
  max-width: 45px;
  padding: 0;
}
.user-menu .menu-icons .btn:hover {
  background: none;
}
.user-menu .menu-icons .btn .icon {
  margin-right: 0;
}
@media screen and (min-width: 799px) {
  .user-menu .menu-icons {
    display: none;
  }
}
.user-menu .label {
  display: flex;
  flex: 0 0 auto;
  display: inline-block;
  white-space: nowrap;
}
.user-menu .navicon {
  flex: 0 0 auto;
  margin-right: 5px;
}
.user-menu-cover {
  margin: 20px;
}
@media screen and (min-width: 799px) {
  .user-menu-cover {
    position: absolute;
    left: auto;
    min-width: 280px;
    right: 0;
  }
}
.user-menu-cover-wrapper {
  position: fixed;
  top: 68px;
  left: 0;
  right: 0;
}
.user-menu-cover-backdrop {
  position: fixed;
  top: 68px;
  left: 0;
  height: calc(100vh - 68px);
  right: 0;
  z-index: -1;
  background: #F3F5F8;
}
@media screen and (min-width: 799px) {
  .user-menu-cover-backdrop {
    background: none;
  }
}
/* Notifications */
.alerts-head .badge {
  position: absolute;
  font-size: 10px;
  min-width: 14px;
  display: block;
  line-height: 1;
  bottom: 50%;
  left: 50%;
  text-align: center;
  border-radius: 50%;
}
.badge {
  font-size: 10px;
  padding: 5px 8px;
  position: absolute;
  background: #FC495D;
  color: #ffffff;
}
.ws-status {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #F3F5F8;
  position: absolute;
  bottom: 0;
  right: 0;
}
.ws-status.connected {
  background: #73C677;
}
.ws-status.disconnected {
  background: #FF6464;
}
.menu-group {
  margin: 10px 0;
}
.menu-group > .label {
  padding: 0 20px;
  text-transform: uppercase;
  color: #92A7C0;
}
@media screen and (min-width: 799px) {
  .menu-group:first-of-type {
    margin: 0 0;
  }
}
.pddash {
  height: calc(100vh -  60px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}
.pddash svg {
  height: 200px;
  fill: #efefef;
}
.pddash h4 {
  font-size: 1.4rem;
  color: #ccc;
}
.dashcontent .dashmessagecontainer .msgactions {
  text-align: right;
}
.dashcontent .dashmessagecontainer .dashmessage {
  display: flex;
  margin: 15px 0;
  align-items: top;
  max-height: 200px;
}
.dashcontent .dashmessagecontainer .dashmessage .msgall {
  overflow-y: scroll;
  max-height: 200px;
}
.dashcontent .dashmessagecontainer .dashmessage .msgall .msghead {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.dashcontent .dashmessagecontainer .dashmessage .msgall .msghead .msgauthor {
  font-weight: 600;
  color: #333;
}
.dashcontent .dashmessagecontainer .dashmessage .msgall .msg {
  padding: 15px;
  border: 1px solid #efefef;
  border-radius: 3px;
}
.dashcontent .dashmessagecontainer .dashmessage .msgreply {
  margin-top: 10px;
}
.dashcontent .dashmessagecontainer .dashmessage .msgreply > div {
  text-align: right;
}
.dashcontent .dashmessagecontainer .dashmessage .msgcomments {
  display: flex;
  flex-direction: row-reverse;
}
.dashcontent .dashmessagecontainer .dashmessage .msgcomments .msgcomment {
  display: inline-block;
  background-color: #efefef;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 10px 5px;
  margin: 15px 0;
  align-items: top;
  max-height: 200px;
  text-align: right;
}
.dashcontent .dashmessagecontainer .dashmessage .msgcomments .msgcomment .commentagent {
  display: block;
  font-weight: 600;
  color: #333;
  margin: 0 0 5px;
}
.dashcontent .dashmessagecontainer .dashmessage .msgcomments .msgcomment .comment {
  overflow-y: scroll;
  max-height: 200px;
}
.dashcontent .listingquality > div {
  margin-bottom: 10px;
  padding: 10px;
}
.dashcontent .listingtype {
  font-size: 1.1rem;
  font-weight: 600;
  text-align: right;
  margin: 20px 0;
}
.dashcontent .listingtype .radiocontainer {
  display: inline-block;
  min-width: 120px;
  text-align: left;
}
.dashcontent .dashstats {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.dashcontent .dashstats .bigstat {
  border-radius: 4px;
  display: inline-block;
  padding: 15px 0;
  font-size: 24px;
  background-color: #FC495D;
  color: #fff;
  margin: 0 0 20px 0;
  min-width: 100%;
}
.dashcontent .dashstats .bigstat span {
  font-size: 1rem;
  display: block;
}
.dashcontent .dashstats .bigstat h1 {
  color: #fff;
}
.dashcontent .dashstats .bigstat.nobg {
  background-color: transparent;
  color: #979797;
}
.dashcontent .nodata {
  text-align: center;
}
.dashcontent .nodata svg {
  height: 120px;
  fill: #eeeeee;
}
.dashcontent .nodata h5 {
  color: #aaa;
  font-weight: 600;
}
.dashcontent .simpletablecontainer,
.dashcontent .timeonmarket,
.dashcontent .listingquality {
  display: flex;
  flex-direction: column;
}
.dashcontent .simpletablecontainer .selectinput,
.dashcontent .timeonmarket .selectinput,
.dashcontent .listingquality .selectinput {
  max-width: 200px;
  min-width: 200px;
  align-self: flex-end;
}
.dashcontent table.simpletable {
  width: 100%;
}
.dashcontent table.simpletable tr {
  border-bottom: 1px solid #efefef;
}
.dashcontent table.simpletable td,
.dashcontent table.simpletable th {
  padding: 5px 2px;
  text-align: right;
}
.dashcontent table.simpletable th:first-of-type,
.dashcontent table.simpletable td:first-of-type {
  text-align: left;
}
.dashcontent .leads-analysis .pie {
  text-align: center;
}
.tourmask {
  height: 100%;
  width: 100%;
}
.tour {
  background-color: #ffffff;
}
.tour svg {
  height: 10px;
}
.tour .touritem h3 {
  font-weight: 500;
}
.tour .touritem h3 span {
  font-weight: 600;
}
.percentage-change {
  display: flex;
  align-items: center;
  margin-left: auto;
  font-size: 14px;
}
.percentage-change.success {
  --color4: #73C677;
  color: #73C677;
}
.percentage-change.failed {
  --color4: #FF6464;
  color: #FF6464;
}
.percentage-change svg {
  width: 16px;
}
.flex-quality {
  gap: 20px;
}
.quality-block {
  background: #F3F5F8;
  padding: 20px;
  border-radius: 4px;
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(25% - 20px);
  min-width: 280px;
  gap: 0 20px;
}
.flex-3 .quality-block {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33% - 20px);
}
.quality-block .quality-graph {
  flex: 0 0 100px;
  height: 100px;
}
.quality-block .quality-content {
  display: flex;
  flex-direction: column;
}
.quality-block .quality-content h3 {
  margin: 0;
}
.quality-block .quality-content strong {
  color: #92A7C0;
  font-weight: 600;
}
.quality-block .quality-content h2 {
  font-size: 30px;
  font-weight: 400;
}
.quality-block .quality-content .btn {
  margin-right: auto;
}
.customized-legend {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;
  padding-bottom: 20px;
}
@media screen and (min-width: 799px) {
  .customized-legend {
    width: 240px;
  }
}
.customized-legend .legend-total {
  flex: 1 1 100%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: auto;
}
.customized-legend .legend-total .legend-count {
  font-size: 36px;
  flex: 1 1 100%;
  padding: 0;
}
.customized-legend .legend-item {
  flex: 1 1 50%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 10px;
  height: 44px;
}
.customized-legend .legend-label {
  text-transform: uppercase;
  font-size: 11px;
  color: #70859E;
}
.customized-legend .legend-count {
  flex: 1 1 100%;
  padding-left: 20px;
  font-size: 18px;
  color: #10294D;
}
.customized-legend-vertical {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  min-width: 240px;
  height: 100%;
  padding-top: 20px;
  padding-left: 20px;
  align-items: center;
  justify-content: center;
}
@media screen and (min-width: 799px) {
  .customized-legend-vertical {
    padding-top: 0;
  }
}
.customized-legend-vertical .legend-item {
  display: flex;
  flex-wrap: wrap;
  min-width: 100%;
  align-items: center;
  height: 36px;
  box-shadow: 0px 1px 0px #E5EBF1;
}
.customized-legend-vertical .legend-label {
  font-size: 14px;
  padding-left: 10px;
  color: #70859E;
}
.customized-legend-vertical .legend-count {
  margin-left: auto;
  font-size: 16px;
  color: #10294D;
}
.expiring-listings-widget .datatablewrap-inner {
  max-height: 515px;
}
.latest-leads-widget tbody .tablecell {
  min-height: 40px;
}
.latest-leads-widget .datatablewrap-inner {
  max-height: 515px;
}
#listing-value-widget {
  min-height: 330px;
}
.syndication-widget .scrollview {
  max-height: 244px;
}
.syndication-widget .flex-2 {
  gap: 20px 20px;
  flex-wrap: wrap;
  align-items: flex-start !important;
}
.syndication-widget .flex-2 > div {
  flex: 1 1 100%;
}
@media screen and (min-width: 799px) {
  .syndication-widget .flex-2 > div {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    max-width: calc(50% - 10px);
  }
}
.syndication-summary {
  flex: 1 1 auto;
  min-width: 240px;
}
.syndication-summary .listbody {
  max-height: 515px;
}
.syndication-summary .syndication-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px 20px;
  margin-bottom: 20px;
  justify-content: center;
}
.syndication-summary .syndication-meta .syndication-logo {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  min-width: 100px;
  overflow: hidden;
  border: 1px solid #E5EBF1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.syndication-summary .syndication-meta .syndication-logo img {
  width: 100px;
}
.syndication-summary .syndication-meta .syndication-counts {
  display: flex;
  flex: 1 1;
  gap: 0 10px;
  justify-content: flex-end;
}
@media screen and (min-width: 799px) {
  .syndication-summary .syndication-meta .syndication-counts {
    flex: 0 0;
    margin-left: auto;
  }
}
.syndication-summary .syndication-meta .syndication-counts .syndication-count {
  flex: 1 1 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0;
}
.syndication-summary .syndication-meta .syndication-counts .syndication-count button {
  min-width: 90px;
  height: 63px;
  background: #F3F5F8;
  border-radius: 8px;
  border: none;
  outline: none;
  color: inherit;
  cursor: pointer;
}
.syndication-summary .syndication-meta .syndication-counts .syndication-count button.active {
  outline: 2px solid #B2C2D4;
  cursor: default;
}
.syndication-summary .syndication-meta .syndication-counts .syndication-count strong {
  color: #5A6F89;
  display: flex;
  justify-content: center;
  align-items: center;
}
.syndication-summary .syndication-meta .syndication-counts .syndication-count button > div {
  font-size: 20px;
  flex: 1 1 100%;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  color: inherit;
}
.syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-success {
  color: #73C677;
}
.syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-failures {
  color: #FF6464;
}
.syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-pending {
  color: #FFA564;
}
.syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-withdrawn {
  color: #455870;
}
.syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-res {
  color: #455870;
}
.syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-com {
  color: #455870;
}
.uae-list-actions {
  display: flex;
  padding: 20px 0;
  gap: 16px;
}
.uae-syndication-summary {
  min-width: 240px;
}
.uae-syndication-summary .syndication-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px 20px;
  margin-bottom: 20px;
  justify-content: center;
}
.uae-syndication-summary .syndication-meta .syndication-logo {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  min-width: 100px;
  overflow: hidden;
  border: 1px solid #E5EBF1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 40px;
}
.uae-syndication-summary .syndication-meta .syndication-logo img {
  width: 100px;
}
.uae-syndication-summary .syndication-meta .syndication-counts {
  display: flex;
  flex: 1 1;
  gap: 0 10px;
  justify-content: flex-end;
}
@media screen and (min-width: 799px) {
  .uae-syndication-summary .syndication-meta .syndication-counts {
    flex: 0 0;
    margin-left: auto;
  }
}
.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count {
  flex: 1 1 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 0;
}
.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count button {
  min-width: 90px;
  height: 63px;
  background: #F3F5F8;
  border-radius: 8px;
  border: none;
  outline: none;
  color: inherit;
  cursor: pointer;
}
.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count button.active {
  outline: 2px solid #B2C2D4;
  cursor: default;
}
.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count strong {
  color: #5A6F89;
  display: flex;
  justify-content: center;
  align-items: center;
}
.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count button > div {
  font-size: 20px;
  flex: 1 1 100%;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  color: inherit;
}
.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-success {
  color: #73C677;
}
.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-failures {
  color: #FF6464;
}
.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-pending {
  color: #FFA564;
}
.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-withdrawn {
  color: #455870;
}
.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-res {
  color: #455870;
}
.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-com {
  color: #455870;
}
.notification {
  padding: 20px 0;
  box-shadow: 0px 1px 0px #E5EBF1;
}
.notification .notification-body {
  font-size: 12px;
}
.notification .notification-body * {
  font-size: 12px;
}
.notification .notification-actions {
  padding: 20px 0 0;
}
.notes-widget .notes-summary {
  box-shadow: 0px 1px 0px #E5EBF1;
}
.notes-widget .notes-summary .agents {
  display: flex;
  align-items: center;
}
.notes-widget .notes-summary .agents > div {
  margin-right: 10px;
}
.empty.flex-container {
  justify-content: center;
}
.flex-lifetime-sales {
  flex-direction: column;
}
.flex-lifetime-sales > div:nth-child(1) {
  min-width: 0;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.flex-lifetime-sales > div:nth-child(1) > div {
  flex: 1 1 25%;
}
.flex-lifetime-sales > div:nth-child(2) {
  margin-top: 30px;
  min-width: 0;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  flex-wrap: wrap;
  gap: 20px;
}
.flex-lifetime-sales .strong {
  color: #70859E;
}
.flex-lifetime-sales h1,
.flex-lifetime-sales h3 {
  color: #10294D;
  font-weight: 500;
  margin: 0;
}
.main-sidebar {
  background: #10294D;
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  left: 0;
  top: 68px;
  min-height: calc(100vh -  68px);
  z-index: 951;
  width: 100%;
  transform: translate3d(-100%, 0, 0);
}
.main-sidebar svg {
  transition: all 0.3s ease 0s;
}
.main-sidebar ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  flex: 1 1 100%;
  max-width: 100%;
}
.main-sidebar .scrollview {
  display: flex;
  flex-wrap: wrap;
}
.main-sidebar .pd-logo {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: auto;
  padding: 20px 0;
  gap: 10px 0;
  transition: none;
  flex: 1 1 100%;
  max-width: 100%;
  min-width: 300px;
}
.main-sidebar .pd-logo svg {
  --color1: #ffffff;
  --color2: #ffffff;
  width: 215px;
  height: 32px;
  flex: 1 1 100%;
}
.main-sidebar .pd-logo div {
  flex: 1 1 100%;
  display: flex;
  justify-content: center;
  color: #92A7C0;
}
.main-sidebar .menu-item > .inner-item {
  min-height: 50px;
  font-size: 16px;
}
.main-sidebar .menu-item {
  margin: 0;
  line-height: 1.2;
  cursor: pointer;
}
.main-sidebar .menu-item .inner-item {
  max-width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  color: #8894A6;
}
.main-sidebar .menu-item .inner-item .menu-icon-wrapper {
  display: flex;
  padding: 0 10px;
  width: 64px;
  height: 44px;
  align-items: center;
  justify-content: center;
}
.main-sidebar .menu-item .inner-item .menu-icon-wrapper .menu-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease-in-out;
  width: 44px;
  height: 44px;
  border-radius: 50%;
}
.main-sidebar .menu-item .inner-item .menu-icon-wrapper svg {
  flex: 0 0 24px;
  fill: none;
  stroke: #ffffff;
  stroke-width: 1.4;
  min-width: 24px;
  height: 24px;
}
.main-sidebar .menu-item .inner-item .menu-item-content {
  white-space: nowrap;
  display: flex;
  overflow: hidden;
  align-items: center;
  line-height: inherit;
  align-content: center;
  transition: color 0.2s ease-in-out;
}
.main-sidebar .menu-item .inner-item .menu-arrow-wrapper {
  display: flex;
  width: 44px;
  height: 44px;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  transition: transform 0.2s ease-in-out;
}
.main-sidebar .menu-item .inner-item .menu-arrow-wrapper svg {
  display: block;
  flex: 0 0 24px;
  fill: none;
  stroke: #ffffff;
  stroke-width: 1.4;
  min-width: 24px;
  height: 24px;
}
.main-sidebar .menu-item:hover > .inner-item .menu-item-content {
  color: #ffffff;
}
.main-sidebar .menu-item:hover .menu-icon {
  background: #4B5E79;
}
.main-sidebar .menu-item.active > .inner-item .menu-item-content {
  color: #ffffff;
}
.main-sidebar .menu-item.active .menu-icon {
  background: #FC495D;
}
.main-sidebar .menu-item.sub-menu.open .menu-arrow-wrapper {
  transform: rotate(90deg);
}
.main-sidebar .list-item {
  overflow: hidden;
  padding-left: 64px;
}
.main-sidebar .list-item > ul > .menu-item > .inner-item {
  min-height: 34px;
  font-size: 14px;
}
.main-sidebar .popper-element {
  max-height: none;
  padding-left: 0;
  height: auto !important;
  position: fixed;
  visibility: hidden;
  min-width: 220px;
  max-width: 270px;
  background-color: transparent;
  max-height: 100%;
  padding-left: 3px;
}
.main-sidebar .popper-element .popper-inner {
  background: #10294D;
  border-radius: 4px;
  padding: 7px 0;
}
.main-sidebar .popper-element .popper-inner .menu-item {
  padding: 0 15px;
}
.main-sidebar .popper-element .popper-inner .menu-item > .inner-item {
  font-size: 14px;
  min-height: 36px;
}
.main .full .main-sidebar {
  transform: translate3d(0, 0, 0);
}
.main .full .main-header .navbtn:before {
  width: 100vw;
}
.main .full .main-header .navbtn svg.close {
  opacity: 1;
  transform: scale(1);
}
.main .full .main-header .navbtn svg.open {
  opacity: 0;
  transform: scale(0);
}
@media (min-width: 799px) {
  .main-sidebar {
    width: 300px;
    top: auto;
    height: calc(100vh -  68px);
    grid-area: nav;
    transform: translate3d(0, 0, 0);
  }
  .main-sidebar .menu-item:hover .popper-element {
    transition: visibility, transform 0.3s;
    visibility: visible;
  }
  .open .list-item:not(.popper-element) {
    max-height: 0;
  }
  .main .mini {
    grid-template-columns: 64px 1fr;
  }
  .main .mini .main-sidebar {
    width: 64px;
  }
  .main .mini .main-sidebar .nav .navitem span {
    opacity: 0;
    line-height: 1px;
    height: 0px;
    font-size: 1px;
  }
  .main .mini .main-sidebar .pd-logo {
    display: none;
  }
  .main .full {
    grid-template-columns: 64px 1fr;
  }
  .main .full .open .list-item {
    max-height: none;
  }
  .main .full .main-header .navbtn:before {
    width: 300px;
  }
}
.sidebar-right {
  background: #ffffff;
  width: 0;
  position: absolute;
  top: 112px;
  bottom: 0;
  z-index: 900;
  right: 0;
  grid-area: actions;
  border-left: 1px solid #CFCDCD;
  overflow: hidden;
}
@media screen and (min-width: 799px) {
  .sidebar-right {
    top: 134px;
  }
}
.sidebar-right:after {
  content: "";
  position: absolute;
  pointer-events: none;
  right: 100%;
  width: 0;
  top: 0;
  bottom: 0;
}
.sidebar-right .sidebar-view {
  width: 280px;
}
.sidebar-right-enter {
  width: 0;
}
.sidebar-right-enter-done {
  width: 281px;
}
.sidebar-right-enter-done:after {
  width: 60px;
}
.sidebar-right-enter-active {
  width: 280px;
}
.sidebar-right-enter-active:after {
  width: 60px;
}
/* Modal */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1100;
  background-color: rgba(51, 51, 51, 0.65);
  display: block;
}
.modal-backdrop.nobackground {
  opacity: 1;
}
.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 948;
  height: 100%;
  width: 100%;
}
.modal-wrapper .modal {
  position: relative;
  z-index: 1200;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
  min-width: 300px;
  max-width: 40%;
  max-height: 60vh;
  overflow-y: auto;
  text-align: center;
  border-radius: 2px;
  font-size: 1.2rem;
  font-weight: 300;
}
@media (max-width: 991px) {
  .modal-wrapper .modal {
    max-width: 70%;
  }
}
@media (max-width: 799px) {
  .modal-wrapper .modal {
    max-width: 90%;
  }
}
.modal-wrapper .modal .card {
  border: 1px solid #efefef;
  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.1);
  margin-bottom: 0;
}
.modal-wrapper .modal .card .cardfoot {
  border: 0;
}
.modal-wrapper .modal .card .cardfoot > .ccontent {
  display: flex;
  justify-content: center;
}
.modal-wrapper .modal .card .cardfoot .modal-buttons {
  display: flex;
  justify-content: center;
  gap: 10px 5px;
}
.modal-wrapper .modal button.close {
  position: absolute;
  top: 5px;
  right: 5px;
}
.modal-wrapper .modal button.actionbtn {
  margin: 20px 0;
}
.modal-wrapper h2 {
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: normal;
}
.modal-wrapper code {
  background: #eeeeee;
  font-weight: normal;
  padding: 3px 6px;
  font-size: 1rem;
}
.snippet-modal {
  position: absolute;
  left: 30%;
  top: 10%;
  max-height: 270px;
  width: 280px;
  overflow: auto;
  display: none;
  z-index: 10;
  border-radius: 8px;
  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);
  border: 1px solid #E5EBF1;
}
.snippet-modal.showing {
  display: block;
}
.snippet-modal .snippet-container {
  margin: auto;
}
.snippet-modal .snippet-container .card {
  font-weight: 500;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 0;
  margin-bottom: 0;
}
.snippet-modal .snippet-container .card .cardhead {
  padding: 5px;
  border-bottom: 1px solid #B2C2D4;
}
.snippet-modal .snippet-container .card .cardhead input {
  padding-left: 5px;
}
.snippet-modal .snippet-container .card .cardhead input::-webkit-input-placeholder {
  /* WebKit browsers */
  font-size: 12px;
  font-weight: 600;
}
.snippet-modal .snippet-container .card .cardhead input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  font-size: 12px;
  font-weight: 600;
}
.snippet-modal .snippet-container .card .cardhead input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-size: 12px;
  font-weight: 600;
}
.snippet-modal .snippet-container .card .cardhead input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  font-size: 12px;
  font-weight: 600;
}
.snippet-modal .snippet-container .card .cardhead .ccontent > div {
  display: flex;
}
.snippet-modal .snippet-container .card .cardhead .ccontent > div input {
  width: 230px;
}
.snippet-modal .snippet-container .card .cardbody {
  overflow: auto;
}
.snippet-modal .snippet-container .card .cardbody .ccontent {
  padding: 0;
}
.snippet-modal .snippet-container .card .cardbody .ccontent .snippet-option {
  padding: 10px 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 5px 10px 5px;
  line-height: 30px;
  color: #233142;
}
.snippet-modal .snippet-container .card .cardbody .ccontent .snippet-option:hover {
  cursor: pointer;
  background-color: #F3F5F8;
}
.snippet-modal .snippet-container .card .cardbody .ccontent .snippet-option.selected {
  background-color: #E5EBF1;
}
.context-sidebar {
  background: #ffffff;
  position: absolute;
  top: 136px;
  right: 0;
  bottom: 0;
  z-index: 3;
  transition: all 0.2s ease-in-out;
  width: 0;
  min-height: calc(100vh -  68px*2 + 50px);
}
.context-sidebar svg {
  height: 18px;
}
.context-menu-cover .nav {
  min-width: 145px;
  background: #ffffff;
  position: absolute;
  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);
  border-radius: 4px;
  z-index: 100;
  overflow: visible;
}
.context-menu-cover .nav > .action {
  display: flex;
  align-content: center;
  align-items: center;
  position: relative;
  overflow: visible;
  height: auto;
  border-radius: 0;
}
.context-menu-cover .nav > .action:first-child {
  border-radius: 4px 4px 0 0;
}
.context-menu-cover .nav > .action:last-child {
  border-radius: 0 0 4px 4px;
}
.context-menu-cover .nav > .action:last-child > .btn,
.context-menu-cover .nav > .action:last-child.has-submenu > .btn {
  border-radius: 0 0 4px 4px;
}
.context-menu-cover .nav > .action .label {
  height: auto;
  line-height: 1.5;
}
.context-menu-cover .nav > .action .navicon {
  margin-right: 10px;
}
.context-menu-cover .nav > .action.has-submenu {
  display: flex;
  align-content: center;
  align-items: center;
}
.context-menu-cover .nav > .action.has-submenu .navitem {
  display: flex;
  border-radius: 0;
  flex: 1 1 100%;
  align-content: center;
  align-items: center;
  padding-right: 6px;
}
.context-menu-cover .nav > .action.has-submenu .navicon.submenu-icon {
  margin-left: auto;
  flex: 0 0 auto;
  margin-right: 0;
  transform: rotate(-90deg);
}
.context-menu-cover .nav > .action.has-submenu .navicon.submenu-icon svg {
  stroke: #10294D;
  stroke-width: 1.4;
  min-width: 24px;
  height: 24px;
}
.context-menu-cover .nav > .action.has-submenu .action-submenu {
  display: none;
  position: absolute;
  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);
  top: 0;
  left: 100%;
  overflow: hidden;
  padding-left: 5px;
}
.context-menu-cover .nav > .action.has-submenu .action-submenu .action-submenu-inner {
  min-width: 145px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);
  border-radius: 4px;
  overflow: hidden;
}
.context-menu-cover .nav > .action.has-submenu .action-submenu .action-sub-item {
  text-align: left;
  cursor: pointer;
  white-space: nowrap;
  padding: 0.75rem 0.8em;
  background: #fff;
  border: 0 none;
  transition: background-color 0.2s ease-in-out;
}
.context-menu-cover .nav > .action.has-submenu .action-submenu .action-sub-item:hover {
  background: #CED7E2;
}
.context-menu-cover-wrapper {
  overflow: visible;
  position: absolute;
}
.context-menu-cover-backdrop {
  overflow: visible;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  transform: translateZ(0);
  background-color: rgba(0, 0, 0, 0);
}
.content:not(.form-group) {
  grid-area: content;
  display: grid;
  grid-template-areas: "actions" "view";
  grid-template-rows: 67px 1fr;
  position: relative;
  background: #F3F5F8;
  transition: left 0.2s ease-in-out, margin-right 0.2s ease-in-out;
  left: 0;
  right: 0;
  will-change: left margin-right;
  min-height: 0;
}
@media screen and (min-width: 799px) {
  .content:not(.form-group) {
    grid-template-columns: 1fr;
  }
}
.content:not(.form-group).canvassing {
  grid-template-rows: 127px auto;
}
.view:not(.action) {
  grid-area: view;
  min-height: 0;
  min-width: 0;
  padding: 0;
}
.view:not(.action) .viewcontent {
  display: grid;
  grid-template-rows: 1fr auto;
  grid-template-columns: 1fr;
  grid-template-areas: "content";
  padding: 10px;
  grid-area: content;
  height: 100%;
  width: 100%;
  overflow: auto;
}
@media screen and (min-width: 281px) {
  .view:not(.action) .viewcontent {
    padding: 20px;
  }
}
.view:not(.action) .viewcontent > div {
  grid-area: content;
  min-width: 0;
}
.view:not(.action) .viewcontent > div.horizontal-tabs-container,
.view:not(.action) .viewcontent > div:not(.brochure-generator) .horizontal-tabs-container {
  margin: -20px -20px -20px -20px;
}
.integrations .viewcontent {
  padding: 15px 0;
}
.integrations .viewcontent .integrations-group .ccontent {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.integrations .viewcontent .integrations-group .ccontent > div {
  flex: 1 1 auto;
}
.integrations .viewcontent .integrations-group .ccontent .editgroup {
  align-items: center;
  justify-content: flex-end;
}
.integrations .viewcontent .integrations-group .ccontent .editgroup .input-group {
  flex: 0 1 auto;
  padding-left: 10px;
}
.integrations .viewcontent .integrations-group .ccontent .editgroup .input-group .forminput {
  justify-content: flex-end;
}
.integrations .viewcontent .integrations-group .lightstone-logo {
  width: 146px;
  height: 49px;
  flex: 0 0 146px;
  color: #071B38;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  margin: 0 0 20px 0;
}
.integrations .viewcontent .integrations-group .flow-logo {
  width: 146px;
  height: 49px;
  flex: 0 0 146px;
  color: #071B38;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  margin: 0 0 20px 0;
}
.integrations .viewcontent .integrations-group .reos-logo {
  width: 146px;
  height: 49px;
  flex: 0 0 146px;
  color: #071B38;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
  margin: 0 0 20px 0;
}
.content.main-dashboard .actionswrap .action-list {
  justify-content: flex-start;
}
.rbc-btn {
  color: inherit;
  font: inherit;
  margin: 0;
}
button.rbc-btn {
  overflow: visible;
  text-transform: none;
  appearance: button;
  cursor: pointer;
}
button[disabled].rbc-btn {
  cursor: not-allowed;
}
button.rbc-input::-moz-focus-inner {
  border: 0;
  padding: 0;
}
.rbc-calendar {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.rbc-calendar * {
  box-sizing: inherit;
}
.rbc-calendar *:before {
  box-sizing: inherit;
}
.rbc-calendar *:after {
  box-sizing: inherit;
}
.rbc-m-b-negative-3 {
  margin-bottom: -3px;
}
.rbc-h-full {
  height: 100%;
}
.rbc-abs-full {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.rbc-row-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: row;
  flex: 1 0;
  overflow: hidden;
  right: 1px;
}
.rbc-ellipsis {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rbc-show-more {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 4;
  font-weight: bold;
  height: auto;
  line-height: normal;
  color: #3174ad;
}
.rbc-show-more:hover {
  color: #265985;
}
.rbc-show-more:focus {
  color: #265985;
}
.rbc-row-segment {
  padding: 0 1px 1px 1px;
}
.rbc-row-segment .rbc-event-content {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rbc-event-label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rbc-rtl {
  direction: rtl;
}
.rbc-rtl .rbc-header + .rbc-header {
  border-left-width: 0;
  border-right: 1px solid #E5EBF1;
}
.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {
  border-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-rtl .rbc-btn-group button + button {
  margin-left: 0;
  margin-right: -1px;
}
.rbc-rtl .rbc-day-bg + .rbc-day-bg {
  border-left-width: 0;
  border-right: 1px solid #E5EBF1;
}
.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left-width: 0;
  border-right: 1px solid #E5EBF1;
}
.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  text-align: right;
}
.rbc-rtl .rbc-time-header.rbc-overflowing {
  border-right-width: 0;
}
.rbc-rtl .rbc-time-header-content {
  border-left-width: 0;
}
.rbc-rtl .rbc-time-content > * + * > * {
  border-left-width: 0;
  border-right: 1px solid #E5EBF1;
}
.rbc-off-range {
  color: #999999;
}
.rbc-off-range-bg {
  background: #e6e6e6;
}
.rbc-header {
  overflow: hidden;
  flex: 1 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 3px;
  text-align: center;
  min-height: 45px;
  display: inline-flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.rbc-header > a {
  color: inherit;
  text-decoration: none;
}
.rbc-header > a:active {
  color: inherit;
  text-decoration: none;
}
.rbc-header > a:visited {
  color: inherit;
  text-decoration: none;
}
.rbc-button-link {
  color: #10294D;
  font-weight: 600;
  background: none;
  margin: 0;
  padding: 0;
  border: none;
  cursor: pointer;
  -webkit-user-select: text;
  user-select: text;
}
.rbc-row-content {
  position: relative;
  user-select: none;
  -webkit-user-select: none;
  z-index: 4;
}
.rbc-row-content-scrollable {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.rbc-row-content-scrollable .rbc-row-content-scroll-container {
  height: 100%;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.rbc-row-content-scrollable .rbc-row-content-scroll-container::-webkit-scrollbar {
  display: none;
}
.rbc-today {
  background-color: #FAFBFD;
}
.rbc-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}
.rbc-toolbar .rbc-toolbar-label {
  flex-grow: 1;
  padding: 0 10px;
  text-align: center;
  font-weight: 600;
  color: #10294D;
}
.rbc-btn-group {
  display: inline-block;
  white-space: nowrap;
}
.rbc-btn-group > button:first-child:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-btn-group > button:last-child:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-btn-group > button:not(:first-child):not(:last-child) {
  border-radius: 0;
}
.rbc-btn-group button + button {
  margin-left: -1px;
}
.rbc-btn-group + .rbc-btn-group {
  margin-left: 10px;
}
.rbc-btn-group + button {
  margin-left: 10px;
}
.rbc-event {
  border: none;
  box-sizing: border-box;
  box-shadow: none;
  margin: 0;
  padding: 2px 5px;
  background-color: #EBF5FF;
  border-radius: 5px;
  color: #3699FE;
  cursor: pointer;
  width: 100%;
  text-align: left;
  font-size: 11px;
}
.rbc-day-slot {
  position: relative;
}
.rbc-day-slot .rbc-background-event {
  border: none;
  box-sizing: border-box;
  box-shadow: none;
  margin: 0;
  padding: 2px 5px;
  background-color: #3174ad;
  border-radius: 5px;
  color: #fff;
  cursor: pointer;
  width: 100%;
  text-align: left;
  border: 1px solid #265985;
  display: flex;
  max-height: 100%;
  min-height: 20px;
  flex-flow: column wrap;
  align-items: flex-start;
  overflow: hidden;
  position: absolute;
  opacity: 0.75;
}
.rbc-day-slot .rbc-background-event:focus {
  outline: 5px auto #3b99fc;
}
.rbc-day-slot .rbc-slot-selecting .rbc-background-event {
  cursor: inherit;
  pointer-events: none;
}
.rbc-day-slot .rbc-selected.rbc-background-event {
  background-color: #265985;
}
.rbc-day-slot .rbc-events-container {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  margin-right: 10px;
  top: 0;
}
.rbc-day-slot .rbc-events-container .tc-tooltip {
  margin-left: 10px;
  margin-top: 5px;
  min-width: 100%;
  max-width: none;
  width: 130%;
  border: 0 none;
  background: #ffffff;
  box-shadow: 0px 16px 32px #DCDEDF;
  padding: 12px 15px;
}
.rbc-day-slot .rbc-events-container .tc-tooltip .tc-tooltip-title {
  background: none;
  border: 0 none;
}
.rbc-day-slot .rbc-events-container .tc-tooltip .tc-tooltip-title .btn {
  position: absolute;
  top: 0;
  right: 0;
}
.rbc-day-slot .rbc-events-container .tc-tooltip .tc-tooltip-content {
  background: none;
  border: 0 none;
}
.rbc-day-slot .rbc-events-container .tc-tooltip .tc-tooltip-content .btn {
  display: inline-flex;
  margin-top: 8px;
}
.rbc-day-slot .rbc-events-container.rbc-rtl {
  left: 10px;
  right: 0;
}
.rbc-day-slot .rbc-event {
  display: flex;
  max-height: 100%;
  min-height: 20px;
  flex-flow: column wrap;
  align-items: flex-start;
  overflow: hidden;
  position: absolute;
}
.rbc-day-slot .rbc-event-label {
  flex: none;
  padding-right: 5px;
  width: auto;
}
.rbc-day-slot .rbc-event-content {
  width: 100%;
  flex: 1 1;
  word-wrap: break-word;
  line-height: 1;
  height: 100%;
  min-height: 1em;
}
.rbc-day-slot .rbc-time-slot {
  border-top: 1px solid #f7f7f7;
}
.rbc-slot-selecting {
  cursor: move;
}
.rbc-slot-selecting .rbc-event {
  cursor: inherit;
  pointer-events: none;
}
.rbc-slot-selecting .rbc-day-slot .rbc-background-event {
  cursor: inherit;
  pointer-events: none;
}
.rbc-event.rbc-selected {
  background-color: #CDE4FE;
}
.rbc-event-overlaps {
  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
}
.rbc-event-continues-prior {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.rbc-event-continues-after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-event-continues-earlier {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.rbc-event-continues-later {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.rbc-row {
  display: flex;
  flex-direction: row;
}
.rbc-selected-cell {
  background-color: rgba(0, 0, 0, 0.1);
}
.rbc-month-view {
  position: relative;
  border: 1px solid #E5EBF1;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
  height: 100%;
}
.rbc-month-header {
  display: flex;
  flex-direction: row;
}
.rbc-month-row {
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1 0;
  flex-basis: 0px;
  overflow: hidden;
  height: 100%;
}
.rbc-month-row + .rbc-month-row {
  border-top: 1px solid #E5EBF1;
}
.rbc-date-cell {
  flex: 1 1;
  min-width: 0;
  padding-right: 5px;
  text-align: right;
}
.rbc-date-cell > a {
  color: inherit;
  text-decoration: none;
}
.rbc-date-cell > a:active {
  color: inherit;
  text-decoration: none;
}
.rbc-date-cell > a:visited {
  color: inherit;
  text-decoration: none;
}
.rbc-date-cell.rbc-now {
  font-weight: bold;
}
.rbc-day-bg {
  flex: 1 0;
}
.rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid #E5EBF1;
}
.rbc-overlay {
  position: absolute;
  z-index: 5;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  padding: 10px;
}
.rbc-overlay > * + * {
  margin-top: 1px;
}
.rbc-overlay-header {
  border-bottom: 1px solid #e5e5e5;
  margin: -10px -10px 5px -10px;
  padding: 2px 10px;
}
.rbc-agenda-view {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  overflow: auto;
}
.rbc-agenda-view table.rbc-agenda-table {
  width: 100%;
  border: 1px solid #E5EBF1;
  border-spacing: 0;
  border-collapse: collapse;
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
  padding: 5px 10px;
  vertical-align: top;
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left: 1px solid #E5EBF1;
}
.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {
  border-top: 1px solid #E5EBF1;
}
.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {
  padding-left: 15px;
  padding-right: 15px;
  text-transform: lowercase;
}
.rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  padding: 3px 5px;
  text-align: left;
  border-bottom: 1px solid #E5EBF1;
}
.rbc-agenda-time-cell {
  text-transform: lowercase;
  white-space: nowrap;
}
.rbc-agenda-time-cell .rbc-continues-after:after {
  content: " »";
}
.rbc-agenda-time-cell .rbc-continues-prior:before {
  content: "« ";
}
.rbc-agenda-date-cell {
  white-space: nowrap;
}
.rbc-agenda-event-cell {
  width: 100%;
}
.rbc-time-column {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
.rbc-time-column .rbc-timeslot-group {
  flex: 1 1;
}
.rbc-timeslot-group {
  border-bottom: 1px solid #E5EBF1;
  min-height: 40px;
  display: flex;
  flex-flow: column nowrap;
}
.rbc-time-gutter {
  flex: none;
}
.rbc-header-gutter {
  flex: none;
}
.rbc-label {
  padding: 0 5px;
}
.rbc-time-view-resources .rbc-time-gutter {
  position: sticky;
  left: 0;
  background-color: white;
  border-right: 1px solid #E5EBF1;
  z-index: 10;
  margin-right: -1px;
}
.rbc-time-view-resources .rbc-time-header-gutter {
  position: sticky;
  left: 0;
  background-color: white;
  border-right: 1px solid #E5EBF1;
  z-index: 10;
  margin-right: -1px;
}
.rbc-time-view-resources .rbc-time-header {
  overflow: hidden;
}
.rbc-time-view-resources .rbc-time-header-content {
  min-width: auto;
  flex: 1 0;
  flex-basis: 0px;
}
.rbc-time-view-resources .rbc-time-header-cell-single-day {
  display: none;
}
.rbc-time-view-resources .rbc-day-slot {
  min-width: 140px;
}
.rbc-time-view-resources .rbc-header {
  width: 140px;
  flex: 1 1;
  flex-basis: 0 px;
}
.rbc-time-view-resources .rbc-day-bg {
  width: 140px;
  flex: 1 1;
  flex-basis: 0 px;
}
.rbc-time-header-content {
  flex: 1 1;
  display: flex;
  min-width: 0;
  flex-direction: column;
}
.rbc-time-header-content + .rbc-time-header-content {
  margin-left: -1px;
}
.rbc-time-header-content > .rbc-row.rbc-row-resource {
  border-bottom: 1px solid #E5EBF1;
  flex-shrink: 0;
}
.rbc-time-slot {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 11px;
  color: #10294D;
  font-weight: 600;
  flex: 1 0;
}
.rbc-time-slot.rbc-now {
  font-weight: bold;
}
.rbc-day-header {
  text-align: center;
}
.rbc-slot-selection {
  z-index: 10;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  width: 100%;
  padding: 3px;
}
.rbc-time-view {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  width: 100%;
  min-height: 0;
}
.rbc-time-view .rbc-time-gutter {
  white-space: nowrap;
  text-align: right;
}
.rbc-time-view .rbc-allday-cell {
  box-sizing: content-box;
  width: 100%;
  height: 100%;
  position: relative;
  display: none;
}
.rbc-time-view .rbc-allday-cell + .rbc-allday-cell {
  border-left: 1px solid #E5EBF1;
}
.rbc-time-view .rbc-allday-events {
  position: relative;
  z-index: 4;
}
.rbc-time-view .rbc-row {
  box-sizing: border-box;
  min-height: 20px;
}
.rbc-time-header {
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
}
.rbc-time-header > .rbc-row:first-child {
  border-bottom: 1px solid #E5EBF1;
}
.rbc-time-header > .rbc-row.rbc-row-resource {
  border-bottom: 1px solid #E5EBF1;
}
.rbc-time-header-cell-single-day {
  display: none;
}
.rbc-time-content {
  display: flex;
  flex: 1 0;
  align-items: flex-start;
  width: 100%;
  overflow-y: auto;
  position: relative;
  border: 1px solid #E5EBF1;
}
.rbc-time-content > .rbc-time-gutter {
  flex: none;
}
.rbc-time-content > * + * > * {
  border-left: 1px solid #E5EBF1;
}
.rbc-time-content > .rbc-day-slot {
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
}
.rbc-current-time-indicator {
  position: absolute;
  z-index: 3;
  left: 0;
  right: 0;
  height: 3px;
  background-color: #FC495D;
  pointer-events: none;
}
.rbc-resource-grouping.rbc-time-header-content {
  display: flex;
  flex-direction: column;
}
.rbc-resource-grouping .rbc-row .rbc-header {
  width: 141px;
}
@media (max-width: 767px) {
  .rbc-toolbar {
    flex-direction: column;
  }
}
.rbc-week-toolbar {
  display: inline-flex;
  align-items: center;
  font-size: 16px;
}
.wide-sidebar {
  width: 0;
  right: 0;
  bottom: 0;
  z-index: 949;
  background: #ffffff;
  position: absolute;
  top: 114px;
  max-height: calc(100vh - 114px);
  display: flex;
}
@media (min-width: 799px) {
  .wide-sidebar {
    top: 67px;
    max-height: calc(100vh - 67px);
  }
}
.wide-sidebar:after {
  content: "";
  position: absolute;
  pointer-events: none;
  right: 100%;
  width: 0;
  top: 0;
  bottom: 0;
  background: linear-gradient(270deg, rgba(31, 41, 51, 0.15) 0%, rgba(31, 41, 51, 0) 100%);
}
.wide-sidebar .sidebar-view {
  width: 100vw;
}
.wide-sidebar-enter {
  width: 0;
}
.wide-sidebar-enter-done {
  width: 100vw;
}
.wide-sidebar-enter-done:after {
  width: 60px;
}
.wide-sidebar-enter-active {
  width: 100vw;
}
.wide-sidebar-enter-active:after {
  width: 60px;
}
@media (min-width: 799px) {
  .wide-sidebar .sidebar-view {
    width: 844px;
  }
  .wide-sidebar-enter {
    width: 0;
  }
  .wide-sidebar-enter-done {
    width: 844px;
  }
  .wide-sidebar-enter-done:after {
    width: 60px;
  }
  .wide-sidebar-enter-active {
    width: 844px;
  }
  .wide-sidebar-enter-active:after {
    width: 60px;
  }
}
.wide-sidebar .wide-sidebar-container {
  list-style: none;
  margin: 0;
  padding: 0 0;
  position: sticky;
  top: 0;
  width: 100%;
  grid-template-rows: 50px auto;
  justify-content: space-between;
  overflow: hidden;
}
@media (min-width: 799px) {
  .wide-sidebar .wide-sidebar-container {
    width: 844px;
  }
}
.wide-sidebar .wide-sidebar-content {
  position: relative;
  background: #ffffff;
  padding: 20px 20px 120px;
  min-width: 280px;
}
@media (min-width: 799px) {
  .wide-sidebar .wide-sidebar-content {
    width: 844px;
    padding: 20px 40px 120px;
  }
}
.wide-sidebar .wide-sidebar-content .editgroup {
  margin-top: 27px;
}
.wide-sidebar .wide-sidebar-content .editgroup .btmatches {
  width: 100%;
}
.wide-sidebar .wide-sidebar-heading {
  position: sticky;
  background: #F3F5F8;
  top: 0;
  z-index: 10;
  min-height: 84px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
@media (min-width: 799px) {
  .wide-sidebar .wide-sidebar-heading {
    padding: 0 40px;
  }
}
.wide-sidebar .wide-sidebar-heading .btn-wide-sidebar-close {
  margin-left: auto;
  margin-right: -20px;
}
.wide-sidebar .wide-sidebar-heading h4 {
  margin: 0;
}
.wide-sidebar .wide-sidebar-footer {
  padding: 15px 0;
  display: flex;
  justify-content: flex-end;
  gap: 20px 20px;
}
.wide-sidebar .wide-sidebar-footer button {
  min-height: 36px;
}
.model-selector-sidebar.wide-sidebar .datatablewrap {
  min-width: 100%;
}
.model-selector-sidebar.wide-sidebar .search-buttons {
  display: flex;
  justify-content: end;
  gap: 10px;
  width: 100%;
}
.model-selector-sidebar.wide-sidebar .editgroup + .search-buttons {
  margin-top: 20px;
}
.model-selector-sidebar.wide-sidebar .editgroup:has(.listbody) {
  gap: 0;
}
.model-selector-sidebar.wide-sidebar .term {
  margin-bottom: 15px;
}
.model-selector-sidebar.wide-sidebar .recipients-search .term {
  margin-bottom: 0px;
}
.deeds-lookup-sidebar tbody td:last-of-type svg:hover {
  cursor: pointer;
}
.deeds-lookup-sidebar .keyword-search {
  box-shadow: 0px 1px 0 #F3F5F8;
  padding-bottom: 20px;
}
.datatable.locationselector {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}
.datatable.locationselector .datatable-headers {
  display: grid;
  padding: 0 10px;
  margin-bottom: 10px;
}
.datatable.locationselector .datatable-headers[data-columns="3"] {
  grid-template-columns: 160px 0.7fr 0.3fr;
}
.datatable.locationselector .datatable-headers[data-columns="4"] {
  grid-template-columns: 160px 112px 234px 0.3fr;
}
.datatable.locationselector .datatable-headers[data-columns="5"] {
  grid-template-columns: 170px 170px 170px 210px auto 0.3fr;
}
.datatable.locationselector .datatable-headers[data-columns="7"] {
  grid-template-columns: 140px 140px 120px 120px 120px 80px auto 0.3fr;
}
.datatable.locationselector .datatable-headers[data-columns="8"] {
  grid-template-columns: 140px 140px 80px 80px 80px 80px 100px auto 0.3fr;
}
.datatable.locationselector .datatable-headers > div {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 700;
  color: #455870;
}
.datatable.locationselector .datatable-headers > div.centered {
  justify-content: center;
}
.datatable.locationselector .datatable-body {
  gap: 10px 0;
  display: flex;
  flex-direction: column;
}
.datatable.locationselector .datatable-body .datatable-row {
  display: grid;
  font-size: 12px;
  color: #5A6F89;
  border: 1px solid #E5EBF1;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(195, 201, 210, 0.31);
  padding: 0 10px;
}
.datatable.locationselector .datatable-body .datatable-row:hover {
  background: #F3F5F8;
}
.datatable.locationselector .datatable-body .datatable-row > div {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  font-size: 12px;
  color: #5A6F89;
}
.datatable.locationselector .datatable-body .datatable-row > div .btn {
  padding-left: 0;
  padding-right: 0;
}
.datatable.locationselector .datatable-body .datatable-row > div.centered {
  justify-content: center;
}
.datatable.locationselector .datatable-body .datatable-row > div.right {
  justify-content: right;
}
.datatable.locationselector .datatable-body .datatable-row svg {
  fill: none;
  stroke: #5A6F89;
  stroke-width: 2.4;
}
.datatable.locationselector .datatable-body[data-columns="3"] .datatable-row {
  grid-template-columns: 160px auto 24px;
}
.datatable.locationselector .datatable-body[data-columns="3"] .datatable-row.datatable-row-empty {
  grid-template-columns: auto;
}
.datatable.locationselector .datatable-body[data-columns="4"] .datatable-row {
  grid-template-columns: 160px 112px auto 24px;
}
.datatable.locationselector .datatable-body[data-columns="4"] .datatable-row.datatable-row-empty {
  grid-template-columns: auto;
}
.datatable.locationselector .datatable-body[data-columns="5"] .datatable-row {
  grid-template-columns: 170px 170px 170px 210px auto 0.3fr;
}
.datatable.locationselector .datatable-body[data-columns="5"] .datatable-row.datatable-row-empty {
  grid-template-columns: auto;
}
.datatable.locationselector .datatable-body[data-columns="7"] .datatable-row {
  grid-template-columns: 140px 140px 120px 120px 120px 80px auto 0.3fr;
}
.datatable.locationselector .datatable-body[data-columns="7"] .datatable-row.datatable-row-empty {
  grid-template-columns: auto;
}
.datatable.locationselector .datatable-body[data-columns="8"] .datatable-row {
  grid-template-columns: 140px 140px 80px 80px 80px 80px 100px auto 0.3fr;
}
.datatable.locationselector .datatable-body[data-columns="8"] .datatable-row.datatable-row-empty {
  grid-template-columns: auto;
}
.datatable.locationselector .tablecell {
  display: block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 10px;
}
.datatable.locationselector .tablecell img {
  max-width: 90px;
}
.datatable.locationselector .tablecell svg {
  height: 13px;
}
.datatable.locationselector .tablecell svg.success {
  fill: #DFB0F4;
}
.datatable.locationselector .tablecell svg.pending {
  fill: #ff7400;
}
.datatable.locationselector .tablecell svg.unknown,
.datatable.locationselector .tablecell svg.failed {
  fill: #EB4A36;
}
.datatable.locationselector .tablecell.ellipses {
  min-width: 167px;
}
.datatable.contactselector {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}
.datatable.contactselector .datatable-headers {
  display: grid;
  padding: 0 10px;
  margin-bottom: 10px;
}
.datatable.contactselector .datatable-headers[data-columns="3"] {
  grid-template-columns: 100px 0.7fr 0.3fr;
}
.datatable.contactselector .datatable-headers[data-columns="5"] {
  grid-template-columns: 140px 112px 234px 234px 0.3fr;
}
.datatable.contactselector .datatable-headers[data-columns="6"] {
  grid-template-columns: 100px 140px 140px 112px 230px 0.3fr;
}
.datatable.contactselector .datatable-headers > div {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  text-transform: uppercase;
  font-size: 10px;
  font-weight: 700;
  color: #455870;
}
.datatable.contactselector .datatable-body {
  gap: 10px 0;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.datatable.contactselector .datatable-body .datatable-row {
  display: grid;
  font-size: 12px;
  color: #5A6F89;
  border: 1px solid #E5EBF1;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(195, 201, 210, 0.31);
  padding: 0 10px;
}
.datatable.contactselector .datatable-body .datatable-row:hover {
  background: #F3F5F8;
}
.datatable.contactselector .datatable-body .datatable-row > div {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  font-size: 12px;
  color: #5A6F89;
}
.datatable.contactselector .datatable-body .datatable-row > div .btn {
  padding-left: 0;
  padding-right: 0;
}
.datatable.contactselector .datatable-body .datatable-row svg {
  fill: none;
  stroke: #5A6F89;
  stroke-width: 2.4;
}
.datatable.contactselector .datatable-body[data-columns="3"] .datatable-row {
  grid-template-columns: 100px auto 24px;
}
.datatable.contactselector .datatable-body[data-columns="3"] .datatable-row.datatable-row-empty {
  grid-template-columns: auto;
}
.datatable.contactselector .datatable-body[data-columns="5"] .datatable-row {
  grid-template-columns: 140px 112px 234px 234px 0.3fr;
}
.datatable.contactselector .datatable-body[data-columns="5"] .datatable-row.datatable-row-empty {
  grid-template-columns: auto;
}
.datatable.contactselector .datatable-body[data-columns="6"] .datatable-row {
  grid-template-columns: 100px 140px 140px 112px 230px 0.3fr;
}
.datatable.contactselector .datatable-body[data-columns="6"] .datatable-row.datatable-row-empty {
  grid-template-columns: auto;
}
.datatable.contactselector .tablecell {
  display: block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 10px;
}
.datatable.contactselector .tablecell img {
  max-width: 90px;
}
.datatable.contactselector .tablecell svg {
  height: 13px;
}
.datatable.contactselector .tablecell svg.success {
  fill: #DFB0F4;
}
.datatable.contactselector .tablecell svg.pending {
  fill: #ff7400;
}
.datatable.contactselector .tablecell svg.unknown,
.datatable.contactselector .tablecell svg.failed {
  fill: #EB4A36;
}
.datatable.contactselector .tablecell.ellipses {
  min-width: 167px;
}
.credit-report {
  display: flex;
  flex-direction: column;
  gap: 20px 20px;
}
.credit-report .report-tags {
  display: flex;
}
.credit-report .report-tags .tag-label {
  padding: 5px 8px;
  background: #FC495D;
  color: #ffffff;
  font-size: 11px;
  flex: 0 0;
  border-radius: 50px;
}
.credit-report .report-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px 20px;
}
.credit-report .report-information {
  display: flex;
  flex-direction: column;
  gap: 10px 20px;
}
.credit-report .report-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
  background: #FAFBFD;
  padding: 20px;
}
.credit-report .report-summary > div {
  flex: 0 1 48%;
}
/* Tables */
.datatablewrap-inner {
  max-width: 100%;
  overflow: auto;
}
.datatable {
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
  font-size: 12px;
  margin-bottom: 1px;
}
.datatable .checkcontainer {
  min-height: 0;
  height: auto;
}
.datatable thead tr:first-child td:first-child,
.datatable thead tr:first-child th:first-child {
  overflow: hidden;
}
.datatable thead tr:first-child td:last-child,
.datatable thead tr:first-child th:last-child {
  overflow: hidden;
}
.datatable thead th {
  vertical-align: bottom;
  padding: 0;
}
.datatable tfoot tr:first-child td:first-child,
.datatable tfoot tr:first-child th:first-child {
  border-bottom-left-radius: 4px;
  overflow: hidden;
}
.datatable tfoot tr:first-child td:last-child,
.datatable tfoot tr:first-child th:last-child {
  border-bottom-right-radius: 4px;
  overflow: hidden;
}
.datatable tfoot th {
  vertical-align: top;
  padding: 0;
}
.datatable label.tooltip {
  display: none;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  padding: 10px 15px;
  background-color: #fff;
  font-weight: 400;
  border-radius: 3px;
  text-align: center;
  border: 1px solid #efefef;
  box-shadow: 4px 4px 3px -2px rgba(0, 0, 0, 0.3);
}
.datatable svg {
  vertical-align: middle;
}
.datatable thead:not(:has(th[rowspan="2"])),
.datatable tfoot:not(:has(th[rowspan="2"])) {
  background: #F3F5F8;
}
.datatable thead td,
.datatable tfoot td,
.datatable thead th,
.datatable tfoot th {
  position: relative;
  overflow: visible;
  white-space: nowrap;
  font-size: 10px;
  font-weight: 600;
  color: #5A6F89;
  padding: 0;
}
.datatable thead td .heading-wrapper,
.datatable tfoot td .heading-wrapper,
.datatable thead th .heading-wrapper,
.datatable tfoot th .heading-wrapper {
  display: flex;
  align-items: center;
  padding: 5px 8px;
  background: #F3F5F8;
  min-height: 40px;
}
.datatable thead td .heading-wrapper .heading,
.datatable tfoot td .heading-wrapper .heading,
.datatable thead th .heading-wrapper .heading,
.datatable tfoot th .heading-wrapper .heading {
  flex: 0 0 auto;
}
.datatable thead td .heading-wrapper .heading + svg,
.datatable tfoot td .heading-wrapper .heading + svg,
.datatable thead th .heading-wrapper .heading + svg,
.datatable tfoot th .heading-wrapper .heading + svg {
  flex: 0 0 16px;
  min-width: 16px;
  fill: #CED7E2;
  --color1: #CED7E2;
}
.datatable thead td.text-right .heading-wrapper,
.datatable tfoot td.text-right .heading-wrapper,
.datatable thead th.text-right .heading-wrapper,
.datatable tfoot th.text-right .heading-wrapper {
  justify-content: flex-end;
}
.datatable thead td.text-center .heading-wrapper,
.datatable tfoot td.text-center .heading-wrapper,
.datatable thead th.text-center .heading-wrapper,
.datatable tfoot th.text-center .heading-wrapper {
  justify-content: center;
}
.datatable thead td.column-check,
.datatable tfoot td.column-check,
.datatable thead th.column-check,
.datatable tfoot th.column-check {
  width: 25px;
}
.datatable thead td.orderable .heading,
.datatable tfoot td.orderable .heading,
.datatable thead th.orderable .heading,
.datatable tfoot th.orderable .heading {
  cursor: pointer;
  text-transform: uppercase;
}
.datatable thead td.orderable .heading + svg,
.datatable tfoot td.orderable .heading + svg,
.datatable thead th.orderable .heading + svg,
.datatable tfoot th.orderable .heading + svg {
  width: 16px;
  height: 16px;
  margin: 0;
  fill: #CED7E2;
  --color1: #CED7E2;
  --color4: #CED7E2;
}
.datatable thead td:hover label.tooltip,
.datatable tfoot td:hover label.tooltip,
.datatable thead th:hover label.tooltip,
.datatable tfoot th:hover label.tooltip {
  display: block;
}
.datatable thead td .checkmark,
.datatable tfoot td .checkmark,
.datatable thead th .checkmark,
.datatable tfoot th .checkmark {
  background-color: #fff;
}
.datatable thead .grouper {
  z-index: 0;
  min-height: 20px;
  text-transform: uppercase;
  padding: 0 8px;
}
.datatable thead .grouper:before {
  content: "";
  background: #E5EBF1;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 1px;
  right: 1px;
  bottom: 0;
}
.datatable tfoot .grouper {
  z-index: 0;
  min-height: 20px;
  text-transform: uppercase;
  padding: 0 8px;
}
.datatable tfoot .grouper:before {
  content: "";
  background: #E5EBF1;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 1px;
  right: 1px;
  bottom: 0;
}
.datatable tbody tr td {
  box-shadow: 0px 1px 0px #E5EBF1;
}
.datatable tbody tr td .cell-wrapper {
  max-width: 100%;
  display: block;
}
.datatable tbody tr td .icon.viewicon svg {
  fill: none;
  stroke: #10294D;
}
.datatable tbody tr .checkmark {
  background-color: #fff;
}
.datatable tbody tr .checkcontainer {
  min-height: auto;
  height: auto;
  margin: 0 auto;
}
.datatable tbody tr .column-cell_number,
.datatable tbody tr .column-metacontactcell_number {
  max-width: 200px;
}
.datatable tbody tr .column-cell_number svg,
.datatable tbody tr .column-metacontactcell_number svg {
  stroke: #10294D;
  stroke-width: 1.4;
}
.datatable tbody tr:hover:not(.selected) td {
  background-color: rgba(229, 235, 241, 0.5);
}
.datatable tbody tr.selected td {
  background-color: rgba(54, 153, 254, 0.11);
}
.datatable tbody tr .thumbimg {
  display: inline-block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #F3F5F8;
  background-position: center center;
  background-size: cover;
  transition: all 0.3s ease 0s;
  vertical-align: middle;
}
.datatable tbody tr .thumbimg svg {
  width: 40px;
  height: 40px;
  fill: none;
}
.datatable tbody tr .thumbimg svg text {
  fill: #10294D;
}
.datatable tr.expanded td {
  vertical-align: top;
}
.datatable tr.expanded td .tablecell {
  white-space: normal;
}
.datatable td,
.datatable th {
  display: table-cell;
  line-height: 1.8rem;
  overflow: hidden;
  vertical-align: middle;
  max-width: 170px;
  font-size: 1rem;
}
.datatable td.column-check,
.datatable th.column-check {
  width: 25px;
  text-align: center;
}
.datatable td.column-score,
.datatable th.column-score {
  text-align: center;
}
.datatable td.column-score svg,
.datatable th.column-score svg {
  display: inline-block;
}
.datatable td.column-feed_status svg,
.datatable th.column-feed_status svg,
.datatable td[class^="feed_status"] svg,
.datatable th[class^="feed_status"] svg,
.datatable td[class*="feed_status"] svg,
.datatable th[class*="feed_status"] svg {
  fill: none;
}
.datatable td.column-actions,
.datatable th.column-actions {
  vertical-align: middle;
  text-align: right;
  max-width: none;
}
.datatable td.column-actions > div,
.datatable th.column-actions > div {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0 4px;
  gap: 5px 5px;
}
.datatable td.column-actions > div > *:first-child,
.datatable th.column-actions > div > *:first-child {
  margin-left: auto;
}
.datatable td .tablecell,
.datatable th .tablecell {
  display: block;
  max-width: 100%;
  padding: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.datatable td .tablecell img,
.datatable th .tablecell img {
  max-width: 90px;
}
.datatable td .tablecell svg,
.datatable th .tablecell svg {
  height: 20px;
  padding-left: 0px;
}
.datatable td .tablecell svg.success,
.datatable th .tablecell svg.success {
  stroke: #73C677;
  fill: none;
}
.datatable td .tablecell svg.pending,
.datatable th .tablecell svg.pending {
  stroke: #FFA564;
  fill: none;
}
.datatable td .tablecell svg.withdrawn,
.datatable th .tablecell svg.withdrawn {
  stroke: #455870;
  fill: none;
}
.datatable td .tablecell svg.unknown,
.datatable th .tablecell svg.unknown,
.datatable td .tablecell svg.failed,
.datatable th .tablecell svg.failed {
  stroke: #FF6464;
  fill: none;
}
.datatable td .tablecell.ellipses,
.datatable th .tablecell.ellipses {
  min-width: 167px;
}
.datatable.imagestbl td:nth-of-type(2) {
  width: 100px;
}
.datatable.imagestbl td:nth-of-type(8) {
  text-align: center;
}
.datatable.imagestbl td .tablecell svg {
  height: 40px;
  fill: #ccc;
}
.datatable.portal-log-table .column-view-on-portal {
  width: 5%;
}
.datatable.portal-log-table td .tablecell {
  padding-left: 0;
  padding-right: 0;
}
.datatable.portal-log-table tbody tr:hover:not(.selected) td {
  background: none;
}
.datatable.commission-slip-table tbody tr:hover:not(.selected) td {
  background: none;
}
.datatable.commission-slip-table tr[class*="-branch"] .forminput:has(input:disabled) {
  border: 0 none;
}
.datatable.commission-slip-table td,
.datatable.commission-slip-table th {
  position: relative;
  overflow: visible;
  white-space: nowrap;
  padding: 0;
}
.datatable.commission-slip-table td .heading-wrapper,
.datatable.commission-slip-table th .heading-wrapper {
  display: flex;
  align-items: center;
  padding: 5px;
  background: #F3F5F8;
  min-height: 40px;
}
.datatable.commission-slip-table td .heading-wrapper .heading,
.datatable.commission-slip-table th .heading-wrapper .heading {
  flex: 0 0 auto;
}
.datatable.commission-slip-table td .heading-wrapper .heading + svg,
.datatable.commission-slip-table th .heading-wrapper .heading + svg {
  flex: 0 0 16px;
  min-width: 16px;
  fill: #CED7E2;
  --color1: #CED7E2;
}
.datatable.commission-slip-table td.text-right .tablecell,
.datatable.commission-slip-table th.text-right .tablecell,
.datatable.commission-slip-table td.text-right .heading-wrapper,
.datatable.commission-slip-table th.text-right .heading-wrapper {
  justify-content: flex-end;
}
.datatable.commission-slip-table td.field .tablecell,
.datatable.commission-slip-table th.field .tablecell {
  overflow: visible;
}
.datatable.commission-slip-table td.field .form-group,
.datatable.commission-slip-table th.field .form-group {
  min-width: 100px;
}
.datatable.commission-slip-table td.field .form-group.selectinput,
.datatable.commission-slip-table th.field .form-group.selectinput {
  min-width: 150px;
}
.datatable.commission-slip-table td.field .form-group.asyncselectinput,
.datatable.commission-slip-table th.field .form-group.asyncselectinput {
  min-width: 150px;
}
.datatable.commission-slip-table td.field .form-group[class*=".nett_amount"],
.datatable.commission-slip-table th.field .form-group[class*=".nett_amount"],
.datatable.commission-slip-table td.field .form-group[class*=".gross_amount"],
.datatable.commission-slip-table th.field .form-group[class*=".gross_amount"] {
  min-width: 150px;
  max-width: 150px;
}
.datatable.commission-slip-table td.field .form-group[class*=".percentage"],
.datatable.commission-slip-table th.field .form-group[class*=".percentage"],
.datatable.commission-slip-table td.field .form-group[class*=".share_percentage"],
.datatable.commission-slip-table th.field .form-group[class*=".share_percentage"] {
  min-width: 70px;
  max-width: 70px;
}
.datatable.commission-slip-table td.field .form-group[class*=".deduct_franchise_fee"],
.datatable.commission-slip-table th.field .form-group[class*=".deduct_franchise_fee"] {
  min-width: 180px;
}
.datatable.commission-slip-table td.field .form-group[class*=".deduct_franchise_fee"] .forminput .checkcontainer + label,
.datatable.commission-slip-table th.field .form-group[class*=".deduct_franchise_fee"] .forminput .checkcontainer + label {
  min-width: 0;
  margin-left: 0;
}
.datatable.commission-slip-table td .indicator,
.datatable.commission-slip-table th .indicator {
  width: 16px;
  height: 16px;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-content: center;
}
.datatable.commission-slip-table td .indicator svg,
.datatable.commission-slip-table th .indicator svg {
  width: 16px;
  height: 16px;
  stroke: #ffffff;
  fill: none;
}
.datatable.commission-slip-table td.text-center .heading-wrapper,
.datatable.commission-slip-table th.text-center .heading-wrapper {
  justify-content: center;
}
.datatable.commission-slip-table td {
  color: #10294D;
  font-size: 12px;
}
.datatable.commission-slip-table th {
  color: #5A6F89;
  font-size: 10px;
  text-transform: uppercase;
}
.datatable.commission-slip-table .primary-bg td,
.datatable.commission-slip-table .primary-bg th {
  background: #10294D;
  color: #ffffff;
}
.datatable.commission-slip-table .primary-bg td .heading-wrapper,
.datatable.commission-slip-table .primary-bg th .heading-wrapper {
  background: none;
}
.datatable.commission-slip-table .primary-bg.success td:not([colspan]),
.datatable.commission-slip-table .primary-bg.success th:not([colspan]) {
  color: #73C677;
}
.datatable.commission-slip-table .primary-bg.success td:not([colspan]) .indicator,
.datatable.commission-slip-table .primary-bg.success th:not([colspan]) .indicator {
  background: #73C677;
}
.datatable.commission-slip-table .primary-bg.fail td:not([colspan]),
.datatable.commission-slip-table .primary-bg.fail th:not([colspan]) {
  color: #FF6464;
}
.datatable.commission-slip-table .primary-bg.fail td:not([colspan]) .indicator,
.datatable.commission-slip-table .primary-bg.fail th:not([colspan]) .indicator {
  background: #FF6464;
}
.datatable.commission-slip-table .react-select__control {
  min-height: 30px;
}
.datatable.commission-slip-table .react-select__control .react-select__single-value {
  font-size: 12px;
  font-weight: normal;
}
.datatable.commission-slip-table .checkmark {
  background-color: reset;
}
.datatable.commission-slip-table td .tablecell {
  padding: 5px;
}
.datatable .tablemeta select {
  width: 45px;
  padding: 10px 0 0;
  text-indent: 10px;
}
.profile-form-footer {
  margin-top: 10px;
  margin-bottom: 25px;
}
.profile-form-footer .btn {
  margin-top: 10px;
  margin-right: 10px;
  flex: 0 0 auto !important;
}
.profile-form-footer .btn:last-of-type {
  margin-right: 0;
}
.details-section .details-section-buttons {
  padding-right: 15px;
}
.details-section .details-section-buttons .btn {
  margin-top: 5px;
  margin-right: 5px;
}
.details-section .details-section-buttons .btn:last-of-type {
  margin-right: 0;
}
.details-section .details-section-buttons + form {
  margin-top: 20px;
  display: block;
}
.list-actions {
  display: flex;
  padding: 20px 0;
}
.listbody {
  overflow-y: visible;
  overflow-x: auto;
}
.listbody thead th,
.listbody tfoot th,
.listbody thead td,
.listbody tfoot td {
  vertical-align: center;
  text-transform: uppercase;
  color: #5A6F89;
}
.listbody thead th.column-rating,
.listbody tfoot th.column-rating,
.listbody thead td.column-rating,
.listbody tfoot td.column-rating {
  width: 0;
}
.listbody thead th.column-rating svg,
.listbody tfoot th.column-rating svg,
.listbody thead td.column-rating svg,
.listbody tfoot td.column-rating svg {
  height: 23px;
  fill: #ffffff;
}
.btmatches .listbody thead th,
.btmatches .listbody tfoot th,
.btmatches .listbody thead td,
.btmatches .listbody tfoot td {
  background: #F3F5F8;
  padding: 0 5px;
}
.listbody thead th.column-check,
.listbody tfoot th.column-check,
.listbody thead td.column-check,
.listbody tfoot td.column-check {
  width: 46px;
  min-width: 46px;
  max-width: 46px;
}
.listbody thead th.column-view-on-portal,
.listbody tfoot th.column-view-on-portal,
.listbody thead td.column-view-on-portal,
.listbody tfoot td.column-view-on-portal {
  width: 120px;
}
.listbody thead th.column-feedstatus,
.listbody tfoot th.column-feedstatus,
.listbody thead td.column-feedstatus,
.listbody tfoot td.column-feedstatus {
  width: 0;
}
.listbody thead th.column-reason,
.listbody tfoot th.column-reason,
.listbody thead td.column-reason,
.listbody tfoot td.column-reason {
  width: 50%;
}
.listbody thead th.column-stage.stage-expanded,
.listbody tfoot th.column-stage.stage-expanded,
.listbody thead td.column-stage.stage-expanded,
.listbody tfoot td.column-stage.stage-expanded {
  min-width: 510px;
  width: 30%;
  max-width: none;
}
.listbody tbody tr {
  box-shadow: 0px 1px 0px #E5EBF1;
}
.listbody tbody td .table-cell {
  padding: 0 5px;
}
.listbody tbody td svg {
  height: 13px;
}
.listbody tbody td.column-rating svg {
  height: 23px;
}
.listbody tbody td .check-match {
  height: 9px;
  stroke: #22cf6d;
  margin-right: 8px;
}
.listbody tbody td.column-view-on-portal {
  text-align: right;
}
.listbody tbody td.column-feedstatus {
  width: 0;
}
.listbody tbody td.column-feedstatus svg {
  height: 24px;
  fill: none;
  stroke: #FFA564;
  stroke-width: 1.4;
}
.listbody tbody td.column-feedstatus svg.success {
  stroke: #73C677;
}
.listbody tbody td.column-feedstatus svg.failes {
  stroke: #FF6464;
}
.listbody tbody tr:last-child td:first-child,
.listbody tbody tr:last-child th:first-child {
  overflow: hidden;
}
.listbody tbody tr:last-child td:last-child,
.listbody tbody tr:last-child th:last-child {
  overflow: hidden;
}
.listbody + form {
  display: block;
  margin-top: 20px;
}
.datatable.tfoot {
  table-layout: fixed;
}
.datatable a:hover {
  text-decoration: underline;
}
/* Table Metas */
.tablemeta {
  justify-content: space-between;
  align-items: center;
  font-size: 1.1rem;
  margin: 0;
  padding: 10px 0 0;
  display: flex;
  flex-wrap: wrap;
  color: #333333;
  gap: 10px 10px;
  /* Search */
}
.tablemeta p {
  font-size: inherit;
  vertical-align: middle;
  margin: 0;
}
.tablemeta select {
  margin: 0;
}
.tablemeta .inlineselectinput {
  flex: 1 1 100%;
  margin-bottom: 0;
}
@media screen and (min-width: 799px) {
  .tablemeta .inlineselectinput {
    flex: 0 0 auto;
  }
}
.tablemeta .inlineselectinput .forminput .input-group-addon {
  padding-right: 0;
  color: #10294D;
  font-weight: 600;
}
.tablemeta .inlineselectinput .react-select .react-select__single-value {
  color: #10294D;
  font-weight: 500;
}
.tablemeta input[type="text"] {
  width: auto;
  display: inline-block;
  min-width: 300px;
}
.tablemeta form .btn {
  display: inline-block;
  margin: 0 0 0 20px;
}
@media (max-width: 799px) {
  .tablemeta > div {
    text-align: left;
    margin-bottom: 10px;
  }
}
@media (max-width: 799px) {
  .tablemeta > div:last-of-type {
    text-align: center;
  }
}
.tablemeta .selected-records {
  font-weight: 600;
}
.page-tools {
  display: flex;
  flex-wrap: nowrap;
  flex: 1 1;
  gap: 10px 10px;
  justify-content: flex-end;
  color: #333333;
  font-size: 12px;
}
.page-tools .pagejump .form-group .page-jump {
  width: auto;
  max-width: 60px;
}
.page-buttons {
  display: flex;
  flex: 0 0 auto;
  gap: 10px 5px;
  justify-content: flex-end;
  color: #92A7C0;
  font-size: 12px;
  margin-left: auto;
}
@media screen and (min-width: 799px) {
  .page-buttons {
    margin-left: 0;
  }
}
.record-count {
  display: flex;
  align-items: center;
  white-space: nowrap;
  flex-wrap: nowrap;
}
.pagejump {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
}
.pagejump form,
.pagejump > div {
  flex: 0 0 auto;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0 10px;
}
@media screen and (min-width: 799px) {
  .pagejump form,
  .pagejump > div {
    flex: 1 1 auto;
  }
}
.pagejump form > *,
.pagejump > div > * {
  vertical-align: middle;
}
.pagejump .form-group {
  flex: 1 1 auto;
}
.pagejump .form-group .page-jump {
  display: inline-block;
  height: 36px;
  width: 36px;
  text-align: center;
  padding: 6px;
  color: #333333;
  font-weight: 500;
}
.pagejump .btn-primary {
  height: 36px;
  line-height: 1.6;
  vertical-align: middle;
  margin: 0 0 0 5px;
}
a.btn.btn-none.btn-gray,
button.btn.btn-none.btn-gray,
html [type="button"].btn.btn-none.btn-gray {
  color: #333333;
}
a.btn.btn-none.btn-gray svg,
button.btn.btn-none.btn-gray svg,
html [type="button"].btn.btn-none.btn-gray svg {
  fill: #333333;
}
/* Steppers / paginations */
.pagestep {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  border-radius: 4px;
  justify-content: flex-end;
  gap: 0 5px;
}
.pagestep .stepposition {
  padding-right: 10px;
}
.pagestep .btn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 36px;
  padding: 0;
  min-width: 36px;
}
.inline-select input[type="text"] {
  width: auto;
  min-width: auto;
}
.inline__control.inline__control {
  min-height: 32px;
}
.description input[type="text"] {
  min-width: 25px;
}
.status input[type="text"] {
  min-width: 50px;
}
.tablesearch {
  position: relative;
  transition: all 0.2s ease-in-out;
  z-index: 1;
  box-shadow: 0px 1px 0px #E5EBF1;
  padding-bottom: 1px;
}
.tablesearch-simple {
  display: none;
}
.tablesearch-advanced {
  display: none;
}
.tablesearch .open {
  display: block;
}
.tablesearch .search-buttons {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px 20px;
  flex: 1 1 auto;
}
.tablesearch .search-buttons .btn {
  width: 100%;
  justify-content: center;
}
@media screen and (min-width: 799px) {
  .tablesearch .search-buttons .btn {
    justify-content: initial;
    width: auto;
  }
}
.tablesearch .adv-count {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #10294D;
  text-align: right;
  width: 100%;
  min-width: 280px;
  justify-content: flex-start;
}
@media screen and (min-width: 799px) {
  .tablesearch .adv-count {
    width: auto;
    justify-content: flex-end;
    min-width: 0;
  }
}
.search-fields {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px 15px;
  margin-bottom: 10px;
}
.input-group .tags-form,
.input-group .snippets-form {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px 15px;
  padding-bottom: 10px;
  margin-bottom: 10px;
}
.input-group .tags-form .field,
.input-group .snippets-form .field {
  flex: 0 0 100%;
}
.tbltags .column-label {
  min-width: 280px;
}
.reset-group {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0 10px;
  flex: 0 0 auto;
}
.activity-search {
  align-items: flex-start;
  flex-wrap: wrap;
}
.activity-search .flex-container {
  gap: 15px 20px;
  justify-content: flex-start;
  margin-bottom: 15px;
}
.activity-search .reset-group {
  white-space: nowrap;
}
.activity-search .input-group {
  flex: 1 1;
  margin: 0;
}
.activity-search .form-group.dateinput .forminput {
  border: 0 none;
  flex-wrap: wrap;
}
.activity-search .form-group.dateinput .forminput:hover {
  border: 0 none;
}
.activity-search .form-group.dateinput .forminput:focus {
  box-shadow: none;
}
.activity-search .form-group.dateinput .forminput .input-group-addon {
  width: auto;
  flex: 1 1 100%;
  max-width: none;
}
.activity-search .field {
  padding: 0;
}
@media screen and (min-width: 799px) {
  .activity-search .field {
    flex: 0 0 200px;
  }
  .activity-search .field:first-child {
    flex: 0 0 280px;
  }
}
.activity-search .field .form-group {
  margin-bottom: auto;
}
@media screen and (min-width: 799px) {
  .activity-search .field .form-group.dateinput {
    max-width: 200px;
  }
  .activity-search .field .form-group.search {
    max-width: 280px;
  }
}
.activity-search .field .form-group .flatpickr-inputwrap input {
  min-height: 34px;
}
/* Table Manager */
.table-manager {
  display: flex;
  flex: 0 0 36px;
}
.table-manager > .btn {
  display: flex;
  flex: 0 0 36px;
  padding: 6px;
  justify-content: center;
}
.drag-handle {
  display: inline-block;
  width: 24px;
  min-width: 24px;
  max-width: 24px;
  height: 18px;
  vertical-align: middle;
  line-height: 14px;
  margin-right: 10px;
  padding: 0;
  cursor: row-resize;
  -webkit-user-select: none;
          user-select: none;
}
.meta-status {
  padding-left: 10px;
}
.meta-status .input-group-addon {
  padding-right: 0;
  color: #10294D;
  font-weight: 600;
  font-size: 1.1rem;
}
.table-manager-sidebar .track-horizontal {
  right: 2px;
  left: 8px;
}
.table-manager-sidebar .track-vertical {
  left: 2px;
  right: auto;
}
.table-manager-sidebar .table-manager-container {
  list-style: none;
  margin: 0;
  padding: 0;
  position: sticky;
  grid-template-rows: 50px auto;
  justify-content: space-between;
  overflow: hidden;
}
.table-manager-sidebar .table-manager-content {
  position: relative;
  height: calc(100vh -  68px);
  width: 280px;
}
.table-manager-sidebar .table-manager-pane {
  position: relative;
  width: 280px;
}
.table-manager-sidebar .table-manager-heading {
  display: flex;
  position: sticky;
  background: #F3F5F8;
  height: 64px;
  align-items: center;
  justify-content: space-between;
  top: 0;
  z-index: 10;
}
.table-manager-sidebar h3 {
  padding-left: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.table-manager-sidebar .btn-table-manager-update {
  outline: 0 !important;
  box-shadow: none !important;
  border: 1px solid #ccc;
  height: 36px;
  top: 0;
  margin: 10px 0;
}
.table-manager-sidebar .btn-table-manager-update svg {
  margin: 0;
  height: 14px;
}
.table-manager-sidebar .table-column-list {
  width: 280px;
  padding: 20px 10px;
}
.table-manager-sidebar .table-column-list *::selection {
  background: transparent;
}
.table-manager-sidebar .table-column-dropper {
  overflow: hidden;
  transition: all 0.2s ease-in-out;
  font-weight: 500;
  font-size: 12px;
  touch-action: none;
}
.table-manager-sidebar .table-column-dropper > * {
  touch-action: none;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable {
  padding: 0 0 0 13px;
  display: flex;
  align-items: center;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable > .btn svg {
  stroke: #10294D;
  transition: all 0.2s ease-in-out;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable:hover {
  background: #E5EBF1;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable:hover > span {
  color: #10294D;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable[style^="left"],
.table-manager-sidebar .table-column-dropper .table-column-draggable[style*="left"] {
  background: #E5EBF1;
  transition: none;
  box-shadow: 0px 2px 4px #C5CFDC;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable .column-remover {
  margin-left: auto;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable .column-remover svg {
  stroke: #B2C2D4;
  transition: all 0.2s ease-in-out;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable .column-remover:hover svg {
  stroke: #10294D;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable.protected {
  color: #ccc;
  pointer-events: none;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable {
  flex-wrap: wrap;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable > .column-remover svg {
  transform: rotate(90deg);
  stroke: #10294D;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable.open > .column-remover svg {
  transform: rotate(0deg);
}
.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable:hover .table-column-draggable {
  background: #F3F5F8;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable:hover .table-column-draggable:hover {
  background: #E5EBF1;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable .table-column-draggable {
  padding-left: 33px;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable .table-column-draggable[style^="left"],
.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable .table-column-draggable[style*="left"] {
  background: #E5EBF1;
  box-shadow: 0px 2px 4px #C5CFDC;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable .table-column-dropper {
  margin-left: -13px;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% + 13px);
}
.table-manager-sidebar .table-column-dropper .table-column-draggable span {
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  color: #70859E;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable strong {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1 200px;
}
.table-manager-sidebar .table-column-dropper .table-column-draggable button {
  flex: 0 0 30px;
}
.table-manager-sidebar .column-remover {
  padding: 0;
  cursor: pointer;
}
.table-manager-sidebar .table-manager-actions {
  padding: 0 10px 10px;
}
.table-manager-sidebar .table-manager-actions .form-group {
  margin: 0;
  width: 100%;
}
.table-manager-sidebar .table-manager-actions .btn-reset {
  margin-bottom: 1rem;
}
.table-manager-sidebar .table-manager-field-form {
  display: block;
  margin-bottom: 10px;
}
.table-manager-sidebar .table-manager-field-form .selectinput .react-select {
  width: 212px;
}
.table-manager-sidebar .btn-primary.btn-primary svg {
  margin-right: 0 !important;
}
.table-manager-sidebar .msg.error {
  flex: 1 1 100%;
  color: #FFB1B1;
  font-size: 1rem;
  font-weight: 600;
  text-align: left;
}
.preference-list {
  width: 280px;
  margin-top: -10px;
  padding: 0 10px 30px 20px;
}
.preference-list .preference-item {
  width: 100%;
  display: flex;
  align-items: center;
  align-content: center;
  min-height: 36px;
}
.preference-list .preference-item .column-remover {
  margin-left: auto;
}
.preference-list .preference-item .column-remover svg {
  stroke: #B2C2D4;
  transition: all 0.2s ease-in-out;
}
.preference-list .preference-item .column-remover:hover svg {
  stroke: #10294D;
}
.preference-list .preference-item .form-group {
  margin: 0;
  flex: 1 1 100%;
  display: flex;
  align-items: center;
  align-content: center;
}
.filtered_notice {
  width: 100%;
  border-bottom: 1px solid #cccccc;
  line-height: 2em;
  background-color: #efefef;
  text-align: center;
  padding: 10px 5px;
}
a.has-link,
.has-link {
  color: inherit;
  text-decoration: underline;
}
a.has-link .listing-popup,
.has-link .listing-popup,
a.has-link .contact-popup,
.has-link .contact-popup {
  text-decoration: inherit;
  display: inline;
}
a.has-link:hover,
.has-link:hover {
  color: #10294D;
}
a.has-link.secondary,
.has-link.secondary {
  color: #FC495D;
  text-decoration: none;
}
a.has-link.secondary:hover,
.has-link.secondary:hover {
  text-decoration: underline;
}
.column-stage a {
  text-decoration: none;
}
.lead-stage {
  display: flex;
  align-items: center;
  padding: 6px 15px;
  min-height: 36px;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid transparent;
  transition: all 0.2s ease-in-out;
  border-radius: 4px;
  cursor: pointer;
  appearance: none;
  font-weight: 500;
  border-radius: 30px;
  min-height: 0;
  padding: 3px 15px;
  text-decoration: none;
  display: inline-block;
}
.lead-stage-small {
  padding: 0 8px;
  min-height: 26px;
}
.lead-stage svg {
  fill: none;
  transition: all 0.2s ease-in-out;
}
.lead-stage.input-group-addon {
  min-height: 34px;
  max-height: none;
}
.lead-stage-primary {
  background: #10294D;
  border-color: transparent;
  color: #ffffff;
}
.lead-stage-primary svg {
  stroke: #ffffff;
  fill: none;
}
.lead-stage-primary:not(.disabled).focus,
.lead-stage-primary:not(.disabled):focus,
.lead-stage-primary:not(.disabled):focus-visible {
  color: #ffffff;
  border: 1px solid transparent;
  background: #071B38;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.lead-stage-primary:not(.disabled).active,
.lead-stage-primary:not(.disabled):active {
  color: #ffffff;
  border: 1px solid transparent;
  background: #071B38;
}
.lead-stage-primary:not(.disabled).active.focus,
.lead-stage-primary:not(.disabled):active.focus,
.lead-stage-primary:not(.disabled).active:focus,
.lead-stage-primary:not(.disabled):active:focus,
.lead-stage-primary:not(.disabled).active:focus-visible,
.lead-stage-primary:not(.disabled):active:focus-visible {
  background: #071B38;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.lead-stage-primary:not(.disabled).hover,
.lead-stage-primary:not(.disabled):hover {
  color: #ffffff;
  border: 1px solid transparent;
  background: #071B38;
}
.lead-stage-primary:not(.disabled).hover.active,
.lead-stage-primary:not(.disabled):hover.active,
.lead-stage-primary:not(.disabled).hover:active,
.lead-stage-primary:not(.disabled):hover:active {
  border-color: transparent;
  background: #071B38;
}
.lead-stage-primary:not(.disabled).hover.active.focus,
.lead-stage-primary:not(.disabled):hover.active.focus,
.lead-stage-primary:not(.disabled).hover:active.focus,
.lead-stage-primary:not(.disabled):hover:active.focus,
.lead-stage-primary:not(.disabled).hover.active:focus,
.lead-stage-primary:not(.disabled):hover.active:focus,
.lead-stage-primary:not(.disabled).hover:active:focus,
.lead-stage-primary:not(.disabled):hover:active:focus,
.lead-stage-primary:not(.disabled).hover.active:focus-visible,
.lead-stage-primary:not(.disabled):hover.active:focus-visible,
.lead-stage-primary:not(.disabled).hover:active:focus-visible,
.lead-stage-primary:not(.disabled):hover:active:focus-visible {
  background: #071B38;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.lead-stage-secondary {
  background: #FC495D;
  border-color: transparent;
  color: #ffffff;
}
.lead-stage-secondary svg {
  display: block;
  stroke: #ffffff;
  fill: none;
}
.lead-stage-secondary.focus,
.lead-stage-secondary:focus,
.lead-stage-secondary:focus-visible {
  color: #ffffff;
  border: 1px solid transparent;
  background: #E62D42;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FED1D6;
}
.lead-stage-secondary.active,
.lead-stage-secondary:active {
  color: #ffffff;
  border: 1px solid transparent;
  background: #E62D42;
}
.lead-stage-secondary.active.focus,
.lead-stage-secondary:active.focus,
.lead-stage-secondary.active:focus,
.lead-stage-secondary:active:focus,
.lead-stage-secondary.active:focus-visible,
.lead-stage-secondary:active:focus-visible {
  background: #E62D42;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FED1D6;
}
.lead-stage-secondary.hover,
.lead-stage-secondary:hover {
  color: #ffffff;
  border: 1px solid transparent;
  background: #E62D42;
}
.lead-stage-secondary.hover.active,
.lead-stage-secondary:hover.active,
.lead-stage-secondary.hover:active,
.lead-stage-secondary:hover:active {
  border-color: transparent;
  background: #E62D42;
}
.lead-stage-secondary.hover.active.focus,
.lead-stage-secondary:hover.active.focus,
.lead-stage-secondary.hover:active.focus,
.lead-stage-secondary:hover:active.focus,
.lead-stage-secondary.hover.active:focus,
.lead-stage-secondary:hover.active:focus,
.lead-stage-secondary.hover:active:focus,
.lead-stage-secondary:hover:active:focus,
.lead-stage-secondary.hover.active:focus-visible,
.lead-stage-secondary:hover.active:focus-visible,
.lead-stage-secondary.hover:active:focus-visible,
.lead-stage-secondary:hover:active:focus-visible {
  background: #E62D42;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FED1D6;
}
.lead-stage-round {
  border-radius: 30px;
}
.lead-stage-red {
  background: #FFEDEF;
  color: #FC495D;
}
.lead-stage-red svg {
  stroke: #FC495D;
}
.lead-stage-red.focus,
.lead-stage-red:focus,
.lead-stage-red:focus-visible {
  color: #FC495D;
  border: 1px solid transparent;
  background: #FED1D6;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FFEDEF;
}
.lead-stage-red.active,
.lead-stage-red:active {
  color: #FC495D;
  border: 1px solid transparent;
  background: #FED1D6;
}
.lead-stage-red.active.focus,
.lead-stage-red:active.focus,
.lead-stage-red.active:focus,
.lead-stage-red:active:focus,
.lead-stage-red.active:focus-visible,
.lead-stage-red:active:focus-visible {
  background: #FED1D6;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FFEDEF;
}
.lead-stage-red.hover,
.lead-stage-red:hover {
  color: #FC495D;
  border: 1px solid transparent;
  background: #FED1D6;
}
.lead-stage-red.hover.active,
.lead-stage-red:hover.active,
.lead-stage-red.hover:active,
.lead-stage-red:hover:active {
  border-color: transparent;
  background: #FED1D6;
}
.lead-stage-red.hover.active.focus,
.lead-stage-red:hover.active.focus,
.lead-stage-red.hover:active.focus,
.lead-stage-red:hover:active.focus,
.lead-stage-red.hover.active:focus,
.lead-stage-red:hover.active:focus,
.lead-stage-red.hover:active:focus,
.lead-stage-red:hover:active:focus,
.lead-stage-red.hover.active:focus-visible,
.lead-stage-red:hover.active:focus-visible,
.lead-stage-red.hover:active:focus-visible,
.lead-stage-red:hover:active:focus-visible {
  background: #FED1D6;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FFEDEF;
}
.lead-stage-green {
  background: #F0F9F1;
  color: #73C677;
}
.lead-stage-green svg {
  stroke: #73C677;
}
.lead-stage-green.focus,
.lead-stage-green:focus,
.lead-stage-green:focus-visible {
  color: #73C677;
  border: 1px solid transparent;
  background: #DCF1DE;
  outline: none;
  box-shadow: 0px 0px 0px 3px #F0F9F1;
}
.lead-stage-green.active,
.lead-stage-green:active {
  color: #73C677;
  border: 1px solid transparent;
  background: #DCF1DE;
}
.lead-stage-green.active.focus,
.lead-stage-green:active.focus,
.lead-stage-green.active:focus,
.lead-stage-green:active:focus,
.lead-stage-green.active:focus-visible,
.lead-stage-green:active:focus-visible {
  background: #DCF1DE;
  outline: none;
  box-shadow: 0px 0px 0px 3px #F0F9F1;
}
.lead-stage-green.hover,
.lead-stage-green:hover {
  color: #73C677;
  border: 1px solid transparent;
  background: #DCF1DE;
}
.lead-stage-green.hover.active,
.lead-stage-green:hover.active,
.lead-stage-green.hover:active,
.lead-stage-green:hover:active {
  border-color: transparent;
  background: #DCF1DE;
}
.lead-stage-green.hover.active.focus,
.lead-stage-green:hover.active.focus,
.lead-stage-green.hover:active.focus,
.lead-stage-green:hover:active.focus,
.lead-stage-green.hover.active:focus,
.lead-stage-green:hover.active:focus,
.lead-stage-green.hover:active:focus,
.lead-stage-green:hover:active:focus,
.lead-stage-green.hover.active:focus-visible,
.lead-stage-green:hover.active:focus-visible,
.lead-stage-green.hover:active:focus-visible,
.lead-stage-green:hover:active:focus-visible {
  background: #DCF1DE;
  outline: none;
  box-shadow: 0px 0px 0px 3px #F0F9F1;
}
.lead-stage-blue {
  background: #EFFBFD;
  color: #34BFDE;
}
.lead-stage-blue svg {
  stroke: #73C677;
}
.lead-stage-blue.focus,
.lead-stage-blue:focus,
.lead-stage-blue:focus-visible {
  color: #73C677;
  border: 1px solid transparent;
  background: #D7F4FA;
  outline: none;
  box-shadow: 0px 0px 0px 3px #EFFBFD;
}
.lead-stage-blue.active,
.lead-stage-blue:active {
  color: #73C677;
  border: 1px solid transparent;
  background: #D7F4FA;
}
.lead-stage-blue.active.focus,
.lead-stage-blue:active.focus,
.lead-stage-blue.active:focus,
.lead-stage-blue:active:focus,
.lead-stage-blue.active:focus-visible,
.lead-stage-blue:active:focus-visible {
  background: #D7F4FA;
  outline: none;
  box-shadow: 0px 0px 0px 3px #EFFBFD;
}
.lead-stage-blue.hover,
.lead-stage-blue:hover {
  color: #73C677;
  border: 1px solid transparent;
  background: #D7F4FA;
}
.lead-stage-blue.hover.active,
.lead-stage-blue:hover.active,
.lead-stage-blue.hover:active,
.lead-stage-blue:hover:active {
  border-color: transparent;
  background: #D7F4FA;
}
.lead-stage-blue.hover.active.focus,
.lead-stage-blue:hover.active.focus,
.lead-stage-blue.hover:active.focus,
.lead-stage-blue:hover:active.focus,
.lead-stage-blue.hover.active:focus,
.lead-stage-blue:hover.active:focus,
.lead-stage-blue.hover:active:focus,
.lead-stage-blue:hover:active:focus,
.lead-stage-blue.hover.active:focus-visible,
.lead-stage-blue:hover.active:focus-visible,
.lead-stage-blue.hover:active:focus-visible,
.lead-stage-blue:hover:active:focus-visible {
  background: #D7F4FA;
  outline: none;
  box-shadow: 0px 0px 0px 3px #EFFBFD;
}
.lead-stage-none {
  background: transparent;
  color: #70859E;
}
.lead-stage-none svg {
  stroke: #10294D;
}
.lead-stage-none.focus,
.lead-stage-none:focus,
.lead-stage-none:focus-visible {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.lead-stage-none.active,
.lead-stage-none:active {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
.lead-stage-none.active.focus,
.lead-stage-none:active.focus,
.lead-stage-none.active:focus,
.lead-stage-none:active:focus,
.lead-stage-none.active:focus-visible,
.lead-stage-none:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.lead-stage-none.hover,
.lead-stage-none:hover {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
.lead-stage-none.hover.active,
.lead-stage-none:hover.active,
.lead-stage-none.hover:active,
.lead-stage-none:hover:active {
  border-color: transparent;
  background: transparent;
}
.lead-stage-none.hover.active.focus,
.lead-stage-none:hover.active.focus,
.lead-stage-none.hover:active.focus,
.lead-stage-none:hover:active.focus,
.lead-stage-none.hover.active:focus,
.lead-stage-none:hover.active:focus,
.lead-stage-none.hover:active:focus,
.lead-stage-none:hover:active:focus,
.lead-stage-none.hover.active:focus-visible,
.lead-stage-none:hover.active:focus-visible,
.lead-stage-none.hover:active:focus-visible,
.lead-stage-none:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.lead-stage-none-red {
  background: transparent;
  color: #70859E;
}
.lead-stage-none-red svg {
  stroke: #FC495D;
}
.lead-stage-none-red.focus,
.lead-stage-none-red:focus,
.lead-stage-none-red:focus-visible {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.lead-stage-none-red.active,
.lead-stage-none-red:active {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
.lead-stage-none-red.active.focus,
.lead-stage-none-red:active.focus,
.lead-stage-none-red.active:focus,
.lead-stage-none-red:active:focus,
.lead-stage-none-red.active:focus-visible,
.lead-stage-none-red:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.lead-stage-none-red.hover,
.lead-stage-none-red:hover {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
.lead-stage-none-red.hover.active,
.lead-stage-none-red:hover.active,
.lead-stage-none-red.hover:active,
.lead-stage-none-red:hover:active {
  border-color: transparent;
  background: transparent;
}
.lead-stage-none-red.hover.active.focus,
.lead-stage-none-red:hover.active.focus,
.lead-stage-none-red.hover:active.focus,
.lead-stage-none-red:hover:active.focus,
.lead-stage-none-red.hover.active:focus,
.lead-stage-none-red:hover.active:focus,
.lead-stage-none-red.hover:active:focus,
.lead-stage-none-red:hover:active:focus,
.lead-stage-none-red.hover.active:focus-visible,
.lead-stage-none-red:hover.active:focus-visible,
.lead-stage-none-red.hover:active:focus-visible,
.lead-stage-none-red:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.lead-stage-subtle {
  background: transparent;
  border: 1px solid #E5EBF1;
  color: #10294D;
}
.lead-stage-subtle svg {
  stroke: #10294D;
}
.lead-stage-subtle.focus,
.lead-stage-subtle:focus,
.lead-stage-subtle:focus-visible {
  color: #071B38;
  border: 1px solid #CED7E2;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.lead-stage-subtle.active,
.lead-stage-subtle:active {
  color: #071B38;
  border: 1px solid #CED7E2;
  background: transparent;
}
.lead-stage-subtle.active.focus,
.lead-stage-subtle:active.focus,
.lead-stage-subtle.active:focus,
.lead-stage-subtle:active:focus,
.lead-stage-subtle.active:focus-visible,
.lead-stage-subtle:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.lead-stage-subtle.hover,
.lead-stage-subtle:hover {
  color: #071B38;
  border: 1px solid #CED7E2;
  background: transparent;
}
.lead-stage-subtle.hover.active,
.lead-stage-subtle:hover.active,
.lead-stage-subtle.hover:active,
.lead-stage-subtle:hover:active {
  border-color: #CED7E2;
  background: transparent;
}
.lead-stage-subtle.hover.active.focus,
.lead-stage-subtle:hover.active.focus,
.lead-stage-subtle.hover:active.focus,
.lead-stage-subtle:hover:active.focus,
.lead-stage-subtle.hover.active:focus,
.lead-stage-subtle:hover.active:focus,
.lead-stage-subtle.hover:active:focus,
.lead-stage-subtle:hover:active:focus,
.lead-stage-subtle.hover.active:focus-visible,
.lead-stage-subtle:hover.active:focus-visible,
.lead-stage-subtle.hover:active:focus-visible,
.lead-stage-subtle:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.lead-stage-text {
  background: transparent;
  color: #10294D;
}
.lead-stage-text svg {
  stroke: #CED7E2;
}
.lead-stage-text.focus,
.lead-stage-text:focus,
.lead-stage-text:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.lead-stage-text.active,
.lead-stage-text:active {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
.lead-stage-text.active.focus,
.lead-stage-text:active.focus,
.lead-stage-text.active:focus,
.lead-stage-text:active:focus,
.lead-stage-text.active:focus-visible,
.lead-stage-text:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.lead-stage-text.hover,
.lead-stage-text:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
.lead-stage-text.hover.active,
.lead-stage-text:hover.active,
.lead-stage-text.hover:active,
.lead-stage-text:hover:active {
  border-color: transparent;
  background: transparent;
}
.lead-stage-text.hover.active.focus,
.lead-stage-text:hover.active.focus,
.lead-stage-text.hover:active.focus,
.lead-stage-text:hover:active.focus,
.lead-stage-text.hover.active:focus,
.lead-stage-text:hover.active:focus,
.lead-stage-text.hover:active:focus,
.lead-stage-text:hover:active:focus,
.lead-stage-text.hover.active:focus-visible,
.lead-stage-text:hover.active:focus-visible,
.lead-stage-text.hover:active:focus-visible,
.lead-stage-text:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.lead-stage-text-only {
  padding: 0;
  background: transparent;
  color: #10294D;
}
.lead-stage-text-only svg {
  stroke: #CED7E2;
}
.lead-stage-text-only.focus,
.lead-stage-text-only:focus,
.lead-stage-text-only:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.lead-stage-text-only.active,
.lead-stage-text-only:active {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
.lead-stage-text-only.active.focus,
.lead-stage-text-only:active.focus,
.lead-stage-text-only.active:focus,
.lead-stage-text-only:active:focus,
.lead-stage-text-only.active:focus-visible,
.lead-stage-text-only:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.lead-stage-text-only.hover,
.lead-stage-text-only:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
.lead-stage-text-only.hover.active,
.lead-stage-text-only:hover.active,
.lead-stage-text-only.hover:active,
.lead-stage-text-only:hover:active {
  border-color: transparent;
  background: transparent;
}
.lead-stage-text-only.hover.active.focus,
.lead-stage-text-only:hover.active.focus,
.lead-stage-text-only.hover:active.focus,
.lead-stage-text-only:hover:active.focus,
.lead-stage-text-only.hover.active:focus,
.lead-stage-text-only:hover.active:focus,
.lead-stage-text-only.hover:active:focus,
.lead-stage-text-only:hover:active:focus,
.lead-stage-text-only.hover.active:focus-visible,
.lead-stage-text-only:hover.active:focus-visible,
.lead-stage-text-only.hover:active:focus-visible,
.lead-stage-text-only:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.lead-stage-grey {
  background: #E5EBF1;
  color: #10294D;
}
.lead-stage-grey svg {
  stroke: #10294D;
}
.lead-stage-grey.input-group-addon {
  min-height: 34px;
  max-height: none;
  background: #E5EBF1;
  color: #10294D;
}
.lead-stage-grey.input-group-addon svg {
  stroke: #10294D;
}
.lead-stage-grey.focus,
.lead-stage-grey:focus,
.lead-stage-grey:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.lead-stage-grey.active,
.lead-stage-grey:active {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
.lead-stage-grey.active.focus,
.lead-stage-grey:active.focus,
.lead-stage-grey.active:focus,
.lead-stage-grey:active:focus,
.lead-stage-grey.active:focus-visible,
.lead-stage-grey:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.lead-stage-grey.hover,
.lead-stage-grey:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
.lead-stage-grey.hover.active,
.lead-stage-grey:hover.active,
.lead-stage-grey.hover:active,
.lead-stage-grey:hover:active {
  border-color: transparent;
  background: #CED7E2;
}
.lead-stage-grey.hover.active.focus,
.lead-stage-grey:hover.active.focus,
.lead-stage-grey.hover:active.focus,
.lead-stage-grey:hover:active.focus,
.lead-stage-grey.hover.active:focus,
.lead-stage-grey:hover.active:focus,
.lead-stage-grey.hover:active:focus,
.lead-stage-grey:hover:active:focus,
.lead-stage-grey.hover.active:focus-visible,
.lead-stage-grey:hover.active:focus-visible,
.lead-stage-grey.hover:active:focus-visible,
.lead-stage-grey:hover:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.lead-stage-grey-50 {
  background: #F3F5F8;
  color: #10294D;
}
.lead-stage-grey-50 svg {
  stroke: #10294D;
}
.lead-stage-grey-50.input-group-addon {
  min-height: 34px;
  max-height: none;
  background: #F3F5F8;
  color: #10294D;
}
.lead-stage-grey-50.input-group-addon svg {
  stroke: #10294D;
}
.lead-stage-grey-50.focus,
.lead-stage-grey-50:focus,
.lead-stage-grey-50:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.lead-stage-grey-50.active,
.lead-stage-grey-50:active {
  color: #10294D;
  border: 1px solid transparent;
  background: #E5EBF1;
}
.lead-stage-grey-50.active.focus,
.lead-stage-grey-50:active.focus,
.lead-stage-grey-50.active:focus,
.lead-stage-grey-50:active:focus,
.lead-stage-grey-50.active:focus-visible,
.lead-stage-grey-50:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.lead-stage-grey-50.hover,
.lead-stage-grey-50:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: #E5EBF1;
}
.lead-stage-grey-50.hover.active,
.lead-stage-grey-50:hover.active,
.lead-stage-grey-50.hover:active,
.lead-stage-grey-50:hover:active {
  border-color: transparent;
  background: #E5EBF1;
}
.lead-stage-grey-50.hover.active.focus,
.lead-stage-grey-50:hover.active.focus,
.lead-stage-grey-50.hover:active.focus,
.lead-stage-grey-50:hover:active.focus,
.lead-stage-grey-50.hover.active:focus,
.lead-stage-grey-50:hover.active:focus,
.lead-stage-grey-50.hover:active:focus,
.lead-stage-grey-50:hover:active:focus,
.lead-stage-grey-50.hover.active:focus-visible,
.lead-stage-grey-50:hover.active:focus-visible,
.lead-stage-grey-50.hover:active:focus-visible,
.lead-stage-grey-50:hover:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.lead-stage-white {
  background: #ffffff;
  color: #10294D;
}
.lead-stage-white svg {
  stroke: #CED7E2;
}
.lead-stage-white.input-group-addon {
  min-height: 34px;
  max-height: none;
  background: #E5EBF1;
  color: #10294D;
}
.lead-stage-white.input-group-addon svg {
  stroke: #CED7E2;
}
.lead-stage-white.focus,
.lead-stage-white:focus,
.lead-stage-white:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.lead-stage-white.active,
.lead-stage-white:active {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
.lead-stage-white.active.focus,
.lead-stage-white:active.focus,
.lead-stage-white.active:focus,
.lead-stage-white:active:focus,
.lead-stage-white.active:focus-visible,
.lead-stage-white:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.lead-stage-white.hover,
.lead-stage-white:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
.lead-stage-white.hover.active,
.lead-stage-white:hover.active,
.lead-stage-white.hover:active,
.lead-stage-white:hover:active {
  border-color: transparent;
  background: #CED7E2;
}
.lead-stage-white.hover.active.focus,
.lead-stage-white:hover.active.focus,
.lead-stage-white.hover:active.focus,
.lead-stage-white:hover:active.focus,
.lead-stage-white.hover.active:focus,
.lead-stage-white:hover.active:focus,
.lead-stage-white.hover:active:focus,
.lead-stage-white:hover:active:focus,
.lead-stage-white.hover.active:focus-visible,
.lead-stage-white:hover.active:focus-visible,
.lead-stage-white.hover:active:focus-visible,
.lead-stage-white:hover:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.lead-stage-white:hover svg,
.lead-stage-white.active svg,
.lead-stage-white:active svg {
  stroke: #10294D;
}
.lead-stage.disabled,
.lead-stage[disabled] {
  background: #E5EBF1;
  border: 1px solid transparent;
  cursor: not-allowed;
  color: #CED7E2;
}
.lead-stage.disabled svg,
.lead-stage[disabled] svg {
  display: block;
  stroke: #CED7E2;
}
.lead-stage.disabled.focus,
.lead-stage[disabled].focus,
.lead-stage.disabled:focus,
.lead-stage[disabled]:focus,
.lead-stage.disabled:focus-visible,
.lead-stage[disabled]:focus-visible {
  color: #CED7E2;
  border: 1px solid transparent;
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.lead-stage.disabled.active,
.lead-stage[disabled].active,
.lead-stage.disabled:active,
.lead-stage[disabled]:active {
  color: #CED7E2;
  border: 1px solid transparent;
  background: #E5EBF1;
}
.lead-stage.disabled.active.focus,
.lead-stage[disabled].active.focus,
.lead-stage.disabled:active.focus,
.lead-stage[disabled]:active.focus,
.lead-stage.disabled.active:focus,
.lead-stage[disabled].active:focus,
.lead-stage.disabled:active:focus,
.lead-stage[disabled]:active:focus,
.lead-stage.disabled.active:focus-visible,
.lead-stage[disabled].active:focus-visible,
.lead-stage.disabled:active:focus-visible,
.lead-stage[disabled]:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.lead-stage.disabled.hover,
.lead-stage[disabled].hover,
.lead-stage.disabled:hover,
.lead-stage[disabled]:hover {
  color: #CED7E2;
  border: 1px solid transparent;
  background: #E5EBF1;
}
.lead-stage.disabled.hover.active,
.lead-stage[disabled].hover.active,
.lead-stage.disabled:hover.active,
.lead-stage[disabled]:hover.active,
.lead-stage.disabled.hover:active,
.lead-stage[disabled].hover:active,
.lead-stage.disabled:hover:active,
.lead-stage[disabled]:hover:active {
  border-color: transparent;
  background: #E5EBF1;
}
.lead-stage.disabled.hover.active.focus,
.lead-stage[disabled].hover.active.focus,
.lead-stage.disabled:hover.active.focus,
.lead-stage[disabled]:hover.active.focus,
.lead-stage.disabled.hover:active.focus,
.lead-stage[disabled].hover:active.focus,
.lead-stage.disabled:hover:active.focus,
.lead-stage[disabled]:hover:active.focus,
.lead-stage.disabled.hover.active:focus,
.lead-stage[disabled].hover.active:focus,
.lead-stage.disabled:hover.active:focus,
.lead-stage[disabled]:hover.active:focus,
.lead-stage.disabled.hover:active:focus,
.lead-stage[disabled].hover:active:focus,
.lead-stage.disabled:hover:active:focus,
.lead-stage[disabled]:hover:active:focus,
.lead-stage.disabled.hover.active:focus-visible,
.lead-stage[disabled].hover.active:focus-visible,
.lead-stage.disabled:hover.active:focus-visible,
.lead-stage[disabled]:hover.active:focus-visible,
.lead-stage.disabled.hover:active:focus-visible,
.lead-stage[disabled].hover:active:focus-visible,
.lead-stage.disabled:hover:active:focus-visible,
.lead-stage[disabled]:hover:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.lead-stage-icon-16 .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
}
.lead-stage-icon-16 .icon svg {
  width: 16px;
  height: 16px;
  stroke-width: 2.4;
}
.lead-stage-icon-24 .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
}
.lead-stage-icon-24 .icon svg {
  width: 24px;
  height: 24px;
  stroke-width: 1.4;
}
.lead-stage-icon-right {
  padding-right: 10px;
}
.lead-stage-icon-right .icon {
  order: 1;
  margin-left: 5px;
}
.lead-stage-icon-right .icon svg {
  fill: none;
}
.lead-stage-icon-left {
  padding-left: 10px;
}
.lead-stage-icon-left .icon {
  order: 0;
  margin-right: 5px;
}
.lead-stage-icon-left .icon svg {
  fill: none;
}
.lead-stage-icon-right.lead-stage-icon-left .icon {
  margin: 0;
}
.lead-stage-icon-only {
  padding: 0;
}
.lead-stage-icon-only.btn-icon-24 {
  min-height: 26px;
  max-height: 26px;
  max-width: 26px;
}
.lead-stage-icon-only.btn-icon-24 .icon {
  max-height: 24px;
  max-width: 24px;
}
.lead-stage-icon-only.btn-icon-16 {
  min-height: 18px;
  max-height: 18px;
  max-width: 18px;
}
.lead-stage-icon-only.btn-icon-16 .icon {
  max-height: 16px;
  max-width: 16px;
}
.lead-stage-icon-only.input-group-addon {
  min-height: 34px;
  max-height: none;
}
.lead-stage-icon-success .icon svg {
  fill: none;
  stroke: #73C677;
}
.lead-stage-glyph .icon svg {
  stroke: none;
}
.lead-stage.highlight {
  --color4: #60D3EC;
}
.lead-stage.has-submenu {
  padding: 0;
}
.lead-stage-red-text {
  color: #FC495D;
  padding-left: 1px;
}
.lead-stage.New {
  background: #FC495D;
  color: #ffffff;
}
.lead-stage.Contacted {
  background: #73C677;
  color: #ffffff;
}
.lead-stage.Viewing {
  background: #3699FE;
  color: #ffffff;
}
.lead-stage.Offer {
  background: #BF60EC;
  color: #ffffff;
}
.lead-stage.Sold {
  background: #FFA564;
  color: #ffffff;
}
.lead-stage.Rented {
  background: #FFA564;
  color: #ffffff;
}
.lead-stage.Rental-Application {
  background: #BF60EC;
  color: #ffffff;
}
.lead-stage.Archived {
  background: #10294D;
  color: #ffffff;
}
.email-stage {
  color: #ffffff;
  border-radius: 30px;
  min-height: 0;
  padding: 3px 15px;
  text-decoration: none;
  display: inline-block;
}
.email-stage.delivered {
  background: #73C677;
}
.email-stage.open {
  background: #0CA6C8;
}
.email-stage.click {
  background: #10294D;
}
.email-stage.bounce {
  background: #FC495D;
}
.email-stage.unsubscribe {
  background: #70859E;
}
.email-stage.spamreport {
  background: #459948;
}
.email-stage.dropped {
  background: #006DDC;
}
.deal-stage {
  color: #ffffff;
  border-radius: 30px;
  min-height: 0;
  padding: 3px 15px;
  text-decoration: none;
  display: inline-block;
}
.deal-stage.offer-made {
  background: #60D3EC;
}
.deal-stage.sale-agreement {
  background: #0CA6C8;
}
.deal-stage.buyer-signed {
  background: #3699FE;
}
.deal-stage.seller-signed {
  background: #006DDC;
}
.deal-stage.instruction-sent {
  background: #BF60EC;
}
.deal-stage.deposit-received {
  background: #B339EC;
}
.deal-stage.conditions-met {
  background: #B339EC;
}
.deal-stage.lodged {
  background: #73C677;
}
.deal-stage.closed {
  background: #E62D42;
}
.deal-stage.cancelled {
  background: #10294D;
}
.application-stage {
  display: flex;
  align-items: center;
  padding: 6px 15px;
  min-height: 36px;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid transparent;
  transition: all 0.2s ease-in-out;
  border-radius: 4px;
  cursor: pointer;
  appearance: none;
  font-weight: 500;
  border-radius: 30px;
  min-height: 0;
  padding: 3px 15px;
  text-decoration: none;
  display: inline-block;
}
.application-stage-small {
  padding: 0 8px;
  min-height: 26px;
}
.application-stage svg {
  fill: none;
  transition: all 0.2s ease-in-out;
}
.application-stage.input-group-addon {
  min-height: 34px;
  max-height: none;
}
.application-stage-primary {
  background: #10294D;
  border-color: transparent;
  color: #ffffff;
}
.application-stage-primary svg {
  stroke: #ffffff;
  fill: none;
}
.application-stage-primary:not(.disabled).focus,
.application-stage-primary:not(.disabled):focus,
.application-stage-primary:not(.disabled):focus-visible {
  color: #ffffff;
  border: 1px solid transparent;
  background: #071B38;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.application-stage-primary:not(.disabled).active,
.application-stage-primary:not(.disabled):active {
  color: #ffffff;
  border: 1px solid transparent;
  background: #071B38;
}
.application-stage-primary:not(.disabled).active.focus,
.application-stage-primary:not(.disabled):active.focus,
.application-stage-primary:not(.disabled).active:focus,
.application-stage-primary:not(.disabled):active:focus,
.application-stage-primary:not(.disabled).active:focus-visible,
.application-stage-primary:not(.disabled):active:focus-visible {
  background: #071B38;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.application-stage-primary:not(.disabled).hover,
.application-stage-primary:not(.disabled):hover {
  color: #ffffff;
  border: 1px solid transparent;
  background: #071B38;
}
.application-stage-primary:not(.disabled).hover.active,
.application-stage-primary:not(.disabled):hover.active,
.application-stage-primary:not(.disabled).hover:active,
.application-stage-primary:not(.disabled):hover:active {
  border-color: transparent;
  background: #071B38;
}
.application-stage-primary:not(.disabled).hover.active.focus,
.application-stage-primary:not(.disabled):hover.active.focus,
.application-stage-primary:not(.disabled).hover:active.focus,
.application-stage-primary:not(.disabled):hover:active.focus,
.application-stage-primary:not(.disabled).hover.active:focus,
.application-stage-primary:not(.disabled):hover.active:focus,
.application-stage-primary:not(.disabled).hover:active:focus,
.application-stage-primary:not(.disabled):hover:active:focus,
.application-stage-primary:not(.disabled).hover.active:focus-visible,
.application-stage-primary:not(.disabled):hover.active:focus-visible,
.application-stage-primary:not(.disabled).hover:active:focus-visible,
.application-stage-primary:not(.disabled):hover:active:focus-visible {
  background: #071B38;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.application-stage-secondary {
  background: #FC495D;
  border-color: transparent;
  color: #ffffff;
}
.application-stage-secondary svg {
  display: block;
  stroke: #ffffff;
  fill: none;
}
.application-stage-secondary.focus,
.application-stage-secondary:focus,
.application-stage-secondary:focus-visible {
  color: #ffffff;
  border: 1px solid transparent;
  background: #E62D42;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FED1D6;
}
.application-stage-secondary.active,
.application-stage-secondary:active {
  color: #ffffff;
  border: 1px solid transparent;
  background: #E62D42;
}
.application-stage-secondary.active.focus,
.application-stage-secondary:active.focus,
.application-stage-secondary.active:focus,
.application-stage-secondary:active:focus,
.application-stage-secondary.active:focus-visible,
.application-stage-secondary:active:focus-visible {
  background: #E62D42;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FED1D6;
}
.application-stage-secondary.hover,
.application-stage-secondary:hover {
  color: #ffffff;
  border: 1px solid transparent;
  background: #E62D42;
}
.application-stage-secondary.hover.active,
.application-stage-secondary:hover.active,
.application-stage-secondary.hover:active,
.application-stage-secondary:hover:active {
  border-color: transparent;
  background: #E62D42;
}
.application-stage-secondary.hover.active.focus,
.application-stage-secondary:hover.active.focus,
.application-stage-secondary.hover:active.focus,
.application-stage-secondary:hover:active.focus,
.application-stage-secondary.hover.active:focus,
.application-stage-secondary:hover.active:focus,
.application-stage-secondary.hover:active:focus,
.application-stage-secondary:hover:active:focus,
.application-stage-secondary.hover.active:focus-visible,
.application-stage-secondary:hover.active:focus-visible,
.application-stage-secondary.hover:active:focus-visible,
.application-stage-secondary:hover:active:focus-visible {
  background: #E62D42;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FED1D6;
}
.application-stage-round {
  border-radius: 30px;
}
.application-stage-red {
  background: #FFEDEF;
  color: #FC495D;
}
.application-stage-red svg {
  stroke: #FC495D;
}
.application-stage-red.focus,
.application-stage-red:focus,
.application-stage-red:focus-visible {
  color: #FC495D;
  border: 1px solid transparent;
  background: #FED1D6;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FFEDEF;
}
.application-stage-red.active,
.application-stage-red:active {
  color: #FC495D;
  border: 1px solid transparent;
  background: #FED1D6;
}
.application-stage-red.active.focus,
.application-stage-red:active.focus,
.application-stage-red.active:focus,
.application-stage-red:active:focus,
.application-stage-red.active:focus-visible,
.application-stage-red:active:focus-visible {
  background: #FED1D6;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FFEDEF;
}
.application-stage-red.hover,
.application-stage-red:hover {
  color: #FC495D;
  border: 1px solid transparent;
  background: #FED1D6;
}
.application-stage-red.hover.active,
.application-stage-red:hover.active,
.application-stage-red.hover:active,
.application-stage-red:hover:active {
  border-color: transparent;
  background: #FED1D6;
}
.application-stage-red.hover.active.focus,
.application-stage-red:hover.active.focus,
.application-stage-red.hover:active.focus,
.application-stage-red:hover:active.focus,
.application-stage-red.hover.active:focus,
.application-stage-red:hover.active:focus,
.application-stage-red.hover:active:focus,
.application-stage-red:hover:active:focus,
.application-stage-red.hover.active:focus-visible,
.application-stage-red:hover.active:focus-visible,
.application-stage-red.hover:active:focus-visible,
.application-stage-red:hover:active:focus-visible {
  background: #FED1D6;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FFEDEF;
}
.application-stage-green {
  background: #F0F9F1;
  color: #73C677;
}
.application-stage-green svg {
  stroke: #73C677;
}
.application-stage-green.focus,
.application-stage-green:focus,
.application-stage-green:focus-visible {
  color: #73C677;
  border: 1px solid transparent;
  background: #DCF1DE;
  outline: none;
  box-shadow: 0px 0px 0px 3px #F0F9F1;
}
.application-stage-green.active,
.application-stage-green:active {
  color: #73C677;
  border: 1px solid transparent;
  background: #DCF1DE;
}
.application-stage-green.active.focus,
.application-stage-green:active.focus,
.application-stage-green.active:focus,
.application-stage-green:active:focus,
.application-stage-green.active:focus-visible,
.application-stage-green:active:focus-visible {
  background: #DCF1DE;
  outline: none;
  box-shadow: 0px 0px 0px 3px #F0F9F1;
}
.application-stage-green.hover,
.application-stage-green:hover {
  color: #73C677;
  border: 1px solid transparent;
  background: #DCF1DE;
}
.application-stage-green.hover.active,
.application-stage-green:hover.active,
.application-stage-green.hover:active,
.application-stage-green:hover:active {
  border-color: transparent;
  background: #DCF1DE;
}
.application-stage-green.hover.active.focus,
.application-stage-green:hover.active.focus,
.application-stage-green.hover:active.focus,
.application-stage-green:hover:active.focus,
.application-stage-green.hover.active:focus,
.application-stage-green:hover.active:focus,
.application-stage-green.hover:active:focus,
.application-stage-green:hover:active:focus,
.application-stage-green.hover.active:focus-visible,
.application-stage-green:hover.active:focus-visible,
.application-stage-green.hover:active:focus-visible,
.application-stage-green:hover:active:focus-visible {
  background: #DCF1DE;
  outline: none;
  box-shadow: 0px 0px 0px 3px #F0F9F1;
}
.application-stage-blue {
  background: #EFFBFD;
  color: #34BFDE;
}
.application-stage-blue svg {
  stroke: #73C677;
}
.application-stage-blue.focus,
.application-stage-blue:focus,
.application-stage-blue:focus-visible {
  color: #73C677;
  border: 1px solid transparent;
  background: #D7F4FA;
  outline: none;
  box-shadow: 0px 0px 0px 3px #EFFBFD;
}
.application-stage-blue.active,
.application-stage-blue:active {
  color: #73C677;
  border: 1px solid transparent;
  background: #D7F4FA;
}
.application-stage-blue.active.focus,
.application-stage-blue:active.focus,
.application-stage-blue.active:focus,
.application-stage-blue:active:focus,
.application-stage-blue.active:focus-visible,
.application-stage-blue:active:focus-visible {
  background: #D7F4FA;
  outline: none;
  box-shadow: 0px 0px 0px 3px #EFFBFD;
}
.application-stage-blue.hover,
.application-stage-blue:hover {
  color: #73C677;
  border: 1px solid transparent;
  background: #D7F4FA;
}
.application-stage-blue.hover.active,
.application-stage-blue:hover.active,
.application-stage-blue.hover:active,
.application-stage-blue:hover:active {
  border-color: transparent;
  background: #D7F4FA;
}
.application-stage-blue.hover.active.focus,
.application-stage-blue:hover.active.focus,
.application-stage-blue.hover:active.focus,
.application-stage-blue:hover:active.focus,
.application-stage-blue.hover.active:focus,
.application-stage-blue:hover.active:focus,
.application-stage-blue.hover:active:focus,
.application-stage-blue:hover:active:focus,
.application-stage-blue.hover.active:focus-visible,
.application-stage-blue:hover.active:focus-visible,
.application-stage-blue.hover:active:focus-visible,
.application-stage-blue:hover:active:focus-visible {
  background: #D7F4FA;
  outline: none;
  box-shadow: 0px 0px 0px 3px #EFFBFD;
}
.application-stage-none {
  background: transparent;
  color: #70859E;
}
.application-stage-none svg {
  stroke: #10294D;
}
.application-stage-none.focus,
.application-stage-none:focus,
.application-stage-none:focus-visible {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.application-stage-none.active,
.application-stage-none:active {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
.application-stage-none.active.focus,
.application-stage-none:active.focus,
.application-stage-none.active:focus,
.application-stage-none:active:focus,
.application-stage-none.active:focus-visible,
.application-stage-none:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.application-stage-none.hover,
.application-stage-none:hover {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
.application-stage-none.hover.active,
.application-stage-none:hover.active,
.application-stage-none.hover:active,
.application-stage-none:hover:active {
  border-color: transparent;
  background: transparent;
}
.application-stage-none.hover.active.focus,
.application-stage-none:hover.active.focus,
.application-stage-none.hover:active.focus,
.application-stage-none:hover:active.focus,
.application-stage-none.hover.active:focus,
.application-stage-none:hover.active:focus,
.application-stage-none.hover:active:focus,
.application-stage-none:hover:active:focus,
.application-stage-none.hover.active:focus-visible,
.application-stage-none:hover.active:focus-visible,
.application-stage-none.hover:active:focus-visible,
.application-stage-none:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.application-stage-none-red {
  background: transparent;
  color: #70859E;
}
.application-stage-none-red svg {
  stroke: #FC495D;
}
.application-stage-none-red.focus,
.application-stage-none-red:focus,
.application-stage-none-red:focus-visible {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.application-stage-none-red.active,
.application-stage-none-red:active {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
.application-stage-none-red.active.focus,
.application-stage-none-red:active.focus,
.application-stage-none-red.active:focus,
.application-stage-none-red:active:focus,
.application-stage-none-red.active:focus-visible,
.application-stage-none-red:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.application-stage-none-red.hover,
.application-stage-none-red:hover {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
.application-stage-none-red.hover.active,
.application-stage-none-red:hover.active,
.application-stage-none-red.hover:active,
.application-stage-none-red:hover:active {
  border-color: transparent;
  background: transparent;
}
.application-stage-none-red.hover.active.focus,
.application-stage-none-red:hover.active.focus,
.application-stage-none-red.hover:active.focus,
.application-stage-none-red:hover:active.focus,
.application-stage-none-red.hover.active:focus,
.application-stage-none-red:hover.active:focus,
.application-stage-none-red.hover:active:focus,
.application-stage-none-red:hover:active:focus,
.application-stage-none-red.hover.active:focus-visible,
.application-stage-none-red:hover.active:focus-visible,
.application-stage-none-red.hover:active:focus-visible,
.application-stage-none-red:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.application-stage-subtle {
  background: transparent;
  border: 1px solid #E5EBF1;
  color: #10294D;
}
.application-stage-subtle svg {
  stroke: #10294D;
}
.application-stage-subtle.focus,
.application-stage-subtle:focus,
.application-stage-subtle:focus-visible {
  color: #071B38;
  border: 1px solid #CED7E2;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.application-stage-subtle.active,
.application-stage-subtle:active {
  color: #071B38;
  border: 1px solid #CED7E2;
  background: transparent;
}
.application-stage-subtle.active.focus,
.application-stage-subtle:active.focus,
.application-stage-subtle.active:focus,
.application-stage-subtle:active:focus,
.application-stage-subtle.active:focus-visible,
.application-stage-subtle:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.application-stage-subtle.hover,
.application-stage-subtle:hover {
  color: #071B38;
  border: 1px solid #CED7E2;
  background: transparent;
}
.application-stage-subtle.hover.active,
.application-stage-subtle:hover.active,
.application-stage-subtle.hover:active,
.application-stage-subtle:hover:active {
  border-color: #CED7E2;
  background: transparent;
}
.application-stage-subtle.hover.active.focus,
.application-stage-subtle:hover.active.focus,
.application-stage-subtle.hover:active.focus,
.application-stage-subtle:hover:active.focus,
.application-stage-subtle.hover.active:focus,
.application-stage-subtle:hover.active:focus,
.application-stage-subtle.hover:active:focus,
.application-stage-subtle:hover:active:focus,
.application-stage-subtle.hover.active:focus-visible,
.application-stage-subtle:hover.active:focus-visible,
.application-stage-subtle.hover:active:focus-visible,
.application-stage-subtle:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.application-stage-text {
  background: transparent;
  color: #10294D;
}
.application-stage-text svg {
  stroke: #CED7E2;
}
.application-stage-text.focus,
.application-stage-text:focus,
.application-stage-text:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.application-stage-text.active,
.application-stage-text:active {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
.application-stage-text.active.focus,
.application-stage-text:active.focus,
.application-stage-text.active:focus,
.application-stage-text:active:focus,
.application-stage-text.active:focus-visible,
.application-stage-text:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.application-stage-text.hover,
.application-stage-text:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
.application-stage-text.hover.active,
.application-stage-text:hover.active,
.application-stage-text.hover:active,
.application-stage-text:hover:active {
  border-color: transparent;
  background: transparent;
}
.application-stage-text.hover.active.focus,
.application-stage-text:hover.active.focus,
.application-stage-text.hover:active.focus,
.application-stage-text:hover:active.focus,
.application-stage-text.hover.active:focus,
.application-stage-text:hover.active:focus,
.application-stage-text.hover:active:focus,
.application-stage-text:hover:active:focus,
.application-stage-text.hover.active:focus-visible,
.application-stage-text:hover.active:focus-visible,
.application-stage-text.hover:active:focus-visible,
.application-stage-text:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.application-stage-text-only {
  padding: 0;
  background: transparent;
  color: #10294D;
}
.application-stage-text-only svg {
  stroke: #CED7E2;
}
.application-stage-text-only.focus,
.application-stage-text-only:focus,
.application-stage-text-only:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.application-stage-text-only.active,
.application-stage-text-only:active {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
.application-stage-text-only.active.focus,
.application-stage-text-only:active.focus,
.application-stage-text-only.active:focus,
.application-stage-text-only:active:focus,
.application-stage-text-only.active:focus-visible,
.application-stage-text-only:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.application-stage-text-only.hover,
.application-stage-text-only:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
.application-stage-text-only.hover.active,
.application-stage-text-only:hover.active,
.application-stage-text-only.hover:active,
.application-stage-text-only:hover:active {
  border-color: transparent;
  background: transparent;
}
.application-stage-text-only.hover.active.focus,
.application-stage-text-only:hover.active.focus,
.application-stage-text-only.hover:active.focus,
.application-stage-text-only:hover:active.focus,
.application-stage-text-only.hover.active:focus,
.application-stage-text-only:hover.active:focus,
.application-stage-text-only.hover:active:focus,
.application-stage-text-only:hover:active:focus,
.application-stage-text-only.hover.active:focus-visible,
.application-stage-text-only:hover.active:focus-visible,
.application-stage-text-only.hover:active:focus-visible,
.application-stage-text-only:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.application-stage-grey {
  background: #E5EBF1;
  color: #10294D;
}
.application-stage-grey svg {
  stroke: #10294D;
}
.application-stage-grey.input-group-addon {
  min-height: 34px;
  max-height: none;
  background: #E5EBF1;
  color: #10294D;
}
.application-stage-grey.input-group-addon svg {
  stroke: #10294D;
}
.application-stage-grey.focus,
.application-stage-grey:focus,
.application-stage-grey:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.application-stage-grey.active,
.application-stage-grey:active {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
.application-stage-grey.active.focus,
.application-stage-grey:active.focus,
.application-stage-grey.active:focus,
.application-stage-grey:active:focus,
.application-stage-grey.active:focus-visible,
.application-stage-grey:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.application-stage-grey.hover,
.application-stage-grey:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
.application-stage-grey.hover.active,
.application-stage-grey:hover.active,
.application-stage-grey.hover:active,
.application-stage-grey:hover:active {
  border-color: transparent;
  background: #CED7E2;
}
.application-stage-grey.hover.active.focus,
.application-stage-grey:hover.active.focus,
.application-stage-grey.hover:active.focus,
.application-stage-grey:hover:active.focus,
.application-stage-grey.hover.active:focus,
.application-stage-grey:hover.active:focus,
.application-stage-grey.hover:active:focus,
.application-stage-grey:hover:active:focus,
.application-stage-grey.hover.active:focus-visible,
.application-stage-grey:hover.active:focus-visible,
.application-stage-grey.hover:active:focus-visible,
.application-stage-grey:hover:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.application-stage-grey-50 {
  background: #F3F5F8;
  color: #10294D;
}
.application-stage-grey-50 svg {
  stroke: #10294D;
}
.application-stage-grey-50.input-group-addon {
  min-height: 34px;
  max-height: none;
  background: #F3F5F8;
  color: #10294D;
}
.application-stage-grey-50.input-group-addon svg {
  stroke: #10294D;
}
.application-stage-grey-50.focus,
.application-stage-grey-50:focus,
.application-stage-grey-50:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.application-stage-grey-50.active,
.application-stage-grey-50:active {
  color: #10294D;
  border: 1px solid transparent;
  background: #E5EBF1;
}
.application-stage-grey-50.active.focus,
.application-stage-grey-50:active.focus,
.application-stage-grey-50.active:focus,
.application-stage-grey-50:active:focus,
.application-stage-grey-50.active:focus-visible,
.application-stage-grey-50:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.application-stage-grey-50.hover,
.application-stage-grey-50:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: #E5EBF1;
}
.application-stage-grey-50.hover.active,
.application-stage-grey-50:hover.active,
.application-stage-grey-50.hover:active,
.application-stage-grey-50:hover:active {
  border-color: transparent;
  background: #E5EBF1;
}
.application-stage-grey-50.hover.active.focus,
.application-stage-grey-50:hover.active.focus,
.application-stage-grey-50.hover:active.focus,
.application-stage-grey-50:hover:active.focus,
.application-stage-grey-50.hover.active:focus,
.application-stage-grey-50:hover.active:focus,
.application-stage-grey-50.hover:active:focus,
.application-stage-grey-50:hover:active:focus,
.application-stage-grey-50.hover.active:focus-visible,
.application-stage-grey-50:hover.active:focus-visible,
.application-stage-grey-50.hover:active:focus-visible,
.application-stage-grey-50:hover:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.application-stage-white {
  background: #ffffff;
  color: #10294D;
}
.application-stage-white svg {
  stroke: #CED7E2;
}
.application-stage-white.input-group-addon {
  min-height: 34px;
  max-height: none;
  background: #E5EBF1;
  color: #10294D;
}
.application-stage-white.input-group-addon svg {
  stroke: #CED7E2;
}
.application-stage-white.focus,
.application-stage-white:focus,
.application-stage-white:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.application-stage-white.active,
.application-stage-white:active {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
.application-stage-white.active.focus,
.application-stage-white:active.focus,
.application-stage-white.active:focus,
.application-stage-white:active:focus,
.application-stage-white.active:focus-visible,
.application-stage-white:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.application-stage-white.hover,
.application-stage-white:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
.application-stage-white.hover.active,
.application-stage-white:hover.active,
.application-stage-white.hover:active,
.application-stage-white:hover:active {
  border-color: transparent;
  background: #CED7E2;
}
.application-stage-white.hover.active.focus,
.application-stage-white:hover.active.focus,
.application-stage-white.hover:active.focus,
.application-stage-white:hover:active.focus,
.application-stage-white.hover.active:focus,
.application-stage-white:hover.active:focus,
.application-stage-white.hover:active:focus,
.application-stage-white:hover:active:focus,
.application-stage-white.hover.active:focus-visible,
.application-stage-white:hover.active:focus-visible,
.application-stage-white.hover:active:focus-visible,
.application-stage-white:hover:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.application-stage-white:hover svg,
.application-stage-white.active svg,
.application-stage-white:active svg {
  stroke: #10294D;
}
.application-stage.disabled,
.application-stage[disabled] {
  background: #E5EBF1;
  border: 1px solid transparent;
  cursor: not-allowed;
  color: #CED7E2;
}
.application-stage.disabled svg,
.application-stage[disabled] svg {
  display: block;
  stroke: #CED7E2;
}
.application-stage.disabled.focus,
.application-stage[disabled].focus,
.application-stage.disabled:focus,
.application-stage[disabled]:focus,
.application-stage.disabled:focus-visible,
.application-stage[disabled]:focus-visible {
  color: #CED7E2;
  border: 1px solid transparent;
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.application-stage.disabled.active,
.application-stage[disabled].active,
.application-stage.disabled:active,
.application-stage[disabled]:active {
  color: #CED7E2;
  border: 1px solid transparent;
  background: #E5EBF1;
}
.application-stage.disabled.active.focus,
.application-stage[disabled].active.focus,
.application-stage.disabled:active.focus,
.application-stage[disabled]:active.focus,
.application-stage.disabled.active:focus,
.application-stage[disabled].active:focus,
.application-stage.disabled:active:focus,
.application-stage[disabled]:active:focus,
.application-stage.disabled.active:focus-visible,
.application-stage[disabled].active:focus-visible,
.application-stage.disabled:active:focus-visible,
.application-stage[disabled]:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.application-stage.disabled.hover,
.application-stage[disabled].hover,
.application-stage.disabled:hover,
.application-stage[disabled]:hover {
  color: #CED7E2;
  border: 1px solid transparent;
  background: #E5EBF1;
}
.application-stage.disabled.hover.active,
.application-stage[disabled].hover.active,
.application-stage.disabled:hover.active,
.application-stage[disabled]:hover.active,
.application-stage.disabled.hover:active,
.application-stage[disabled].hover:active,
.application-stage.disabled:hover:active,
.application-stage[disabled]:hover:active {
  border-color: transparent;
  background: #E5EBF1;
}
.application-stage.disabled.hover.active.focus,
.application-stage[disabled].hover.active.focus,
.application-stage.disabled:hover.active.focus,
.application-stage[disabled]:hover.active.focus,
.application-stage.disabled.hover:active.focus,
.application-stage[disabled].hover:active.focus,
.application-stage.disabled:hover:active.focus,
.application-stage[disabled]:hover:active.focus,
.application-stage.disabled.hover.active:focus,
.application-stage[disabled].hover.active:focus,
.application-stage.disabled:hover.active:focus,
.application-stage[disabled]:hover.active:focus,
.application-stage.disabled.hover:active:focus,
.application-stage[disabled].hover:active:focus,
.application-stage.disabled:hover:active:focus,
.application-stage[disabled]:hover:active:focus,
.application-stage.disabled.hover.active:focus-visible,
.application-stage[disabled].hover.active:focus-visible,
.application-stage.disabled:hover.active:focus-visible,
.application-stage[disabled]:hover.active:focus-visible,
.application-stage.disabled.hover:active:focus-visible,
.application-stage[disabled].hover:active:focus-visible,
.application-stage.disabled:hover:active:focus-visible,
.application-stage[disabled]:hover:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.application-stage-icon-16 .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
}
.application-stage-icon-16 .icon svg {
  width: 16px;
  height: 16px;
  stroke-width: 2.4;
}
.application-stage-icon-24 .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
}
.application-stage-icon-24 .icon svg {
  width: 24px;
  height: 24px;
  stroke-width: 1.4;
}
.application-stage-icon-right {
  padding-right: 10px;
}
.application-stage-icon-right .icon {
  order: 1;
  margin-left: 5px;
}
.application-stage-icon-right .icon svg {
  fill: none;
}
.application-stage-icon-left {
  padding-left: 10px;
}
.application-stage-icon-left .icon {
  order: 0;
  margin-right: 5px;
}
.application-stage-icon-left .icon svg {
  fill: none;
}
.application-stage-icon-right.application-stage-icon-left .icon {
  margin: 0;
}
.application-stage-icon-only {
  padding: 0;
}
.application-stage-icon-only.btn-icon-24 {
  min-height: 26px;
  max-height: 26px;
  max-width: 26px;
}
.application-stage-icon-only.btn-icon-24 .icon {
  max-height: 24px;
  max-width: 24px;
}
.application-stage-icon-only.btn-icon-16 {
  min-height: 18px;
  max-height: 18px;
  max-width: 18px;
}
.application-stage-icon-only.btn-icon-16 .icon {
  max-height: 16px;
  max-width: 16px;
}
.application-stage-icon-only.input-group-addon {
  min-height: 34px;
  max-height: none;
}
.application-stage-icon-success .icon svg {
  fill: none;
  stroke: #73C677;
}
.application-stage-glyph .icon svg {
  stroke: none;
}
.application-stage.highlight {
  --color4: #60D3EC;
}
.application-stage.has-submenu {
  padding: 0;
}
.application-stage-red-text {
  color: #FC495D;
  padding-left: 1px;
}
.application-stage.Sent {
  background: #3699FE;
  color: #ffffff;
}
.application-stage.Submitted {
  background: #BF60EC;
  color: #ffffff;
}
.application-stage.Expired {
  background: #FFA564;
  color: #ffffff;
}
.application-stage.Accepted {
  background: #73C677;
  color: #ffffff;
}
.application-stage.Declined {
  background: #FC495D;
  color: #ffffff;
}
@media print {
  body {
    height: auto;
    width: auto;
    overflow: visible;
    flex-wrap: nowrap !important;
  }
  .viewhead {
    display: none;
  }
  .print-page .viewhead {
    display: none;
  }
  .print-page .print-card-no-display {
    visibility: hidden !important;
  }
  .print-page .mini {
    grid-template-columns: 20px 1fr;
  }
  .print-page .view .heavy {
    flex: 0 0 1%;
  }
  .print-page .meta-detail {
    display: flex !important;
    flex-wrap: wrap;
    line-height: 1.5rem;
    grid-gap: 0 16px;
    gap: 0 16px;
  }
  .print-page .col-lg-6 {
    flex: 1 1;
  }
  .print-page .meta-detail .col {
    padding: 5px 6px !important;
  }
  .print-page .view .heavy + div {
    display: flex;
    flex: 1 1;
    padding: 5px 6px;
    min-width: auto;
    overflow-wrap: break-word;
  }
  .print-page .model-details {
    background-color: #ffffff;
    padding: 0px 0 0 0 !important;
  }
  .print-page .card {
    page-break-inside: avoid;
    break-inside: avoid;
    position: relative;
    border-radius: 0 !important;
    box-shadow: none;
    margin-bottom: 0px !important;
    width: 100%;
    border: none;
    border-bottom: 1px solid #CED7E2;
  }
  .print-page .card:last-of-type {
    border-bottom: 1px solid transparent;
  }
  .print-page .wrapper {
    display: block !important;
    height: auto !important;
    grid-template-rows: 20px auto;
    background-color: #ffffff !important;
  }
  .print-page .wrapper .content:not(.form-group) {
    display: block !important;
    background-color: #ffffff;
    grid-template-rows: 20px auto !important;
  }
  .print-page .wrapper .content:not(.form-group) .scrollview {
    position: relative !important;
    display: block !important;
    overflow: visible !important;
  }
  .image-gallery .image-gallery-thumb {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% / 4 - 20px);
    min-width: 0;
  }
  .productfruits--container {
    display: none;
  }
  .model-details .card .cardbody > .ccontent {
    page-break-before: avoid;
  }
}
.print-page .viewcontent {
  padding: 0;
}
.print-page .viewhead {
  display: none;
}
.print-page .mini {
  grid-template-columns: 20px 1fr;
}
.print-page .print-card-no-display {
  color: #ffffff !important;
  border: none !important;
}
.print-page .checkmark {
  border: none !important;
  background: transparent !important;
}
.print-page .model-details {
  background-color: #ffffff;
  padding: 0px 0 0 0 !important;
}
.print-page .meta-detail .col {
  padding: 5px 6px !important;
}
.print-page .meta-detail .col iframe {
  border: 0;
}
.print-page .viewhead {
  display: none;
}
.print-page .mini {
  grid-template-columns: 20px 1fr;
}
.print-page .view .heavy {
  flex: 0 0 1%;
}
.print-page .meta-detail {
  display: flex !important;
  flex-wrap: wrap;
  line-height: 1.5rem;
  grid-gap: 0 16px;
  gap: 0 16px;
}
.print-page .col-lg-6 {
  flex: 1 1;
}
.print-page .meta-detail .col a {
  flex: 1 1;
}
.print-page .view .heavy + div {
  display: flex;
  flex: 1 1;
  padding: 5px 6px;
  min-width: auto;
  overflow-wrap: anywhere;
}
.print-page .view .heavy + div {
  display: flex;
  flex: 1 1;
  padding: 5px 6px;
  min-width: auto;
  overflow-wrap: break-word;
}
.print-page .card {
  page-break-inside: avoid;
  break-inside: avoid;
  position: relative;
  border-radius: 0 !important;
  box-shadow: none;
  margin-bottom: 0px !important;
  width: 100%;
  border: none;
  border-bottom: 1px solid #CED7E2;
}
.print-page .card .section-underline {
  width: 100%;
}
.print-page .card:last-of-type {
  border-bottom: 1px solid transparent;
}
.print-page .wrapper {
  grid-template-columns: auto;
  grid-template-rows: auto;
  background-color: #ffffff !important;
  grid-template-areas: "header" "content";
}
.print-page .wrapper .content:not(.form-group) {
  grid-template-columns: auto;
  grid-template-rows: auto;
  grid-template-areas: "view";
  background-color: #ffffff !important;
  height: 100vh;
}
.print-page .image-gallery {
  justify-content: space-between;
  grid-template-columns: repeat(3, 1fr);
}
.print-page .image-gallery img {
  page-break-before: auto;
  page-break-after: auto;
  page-break-inside: avoid;
}
.print-page .image-gallery .image-gallery-thumb-img-size {
  display: none;
}
.print-page .image-gallery .image-gallery-thumb-meta {
  display: none;
}
.print-page .address-date {
  flex: 0 0 100%;
  text-align: center;
}
@media screen and (min-width: 799px) {
  .print-page .header-section {
    height: 90px;
    justify-content: space-between;
  }
  .print-page .address-date {
    flex: 1 1 auto;
    text-align: right;
  }
}
.print-page .header-section {
  flex-wrap: wrap;
  height: auto;
  justify-content: center;
  gap: 20px 20px;
}
.header-section {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  height: 90px;
  box-sizing: border-box;
}
.header-section .logo img {
  object-fit: contain;
  height: 50px;
}
.header-section .address-date .address {
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
}
.header-section .address-date .datetime {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
}
.tags-search .input-group.keyword-search {
  flex: 0 0 100%;
}
@media screen and (min-width: 799px) {
  .tags-search .input-group.keyword-search {
    flex: 0 0 200px;
  }
}
.tags-search .input-group.keyword-search + .btn {
  flex: 0 0 100%;
  justify-content: center;
}
@media screen and (min-width: 799px) {
  .tags-search .input-group.keyword-search + .btn {
    flex: 0 0;
  }
}
.tags-search .search-buttons {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 10px 10px;
}
.tags-search .search-buttons .btn {
  flex: 0 0 100%;
  justify-content: center;
}
@media screen and (min-width: 799px) {
  .tags-search .search-buttons .btn {
    flex: 0 0;
  }
}
.tagsbody {
  max-width: calc(100vw - 82px);
}
.modelchoice {
  grid-template-rows: min-content;
}
.modelchoice .choice {
  display: flex;
  justify-content: center;
  max-height: 350px;
}
.modelchoice .choice .ccontent {
  height: 100%;
}
.modelchoice .choice .ccontent .preview {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.modelchoice .choice .ccontent .preview:hover {
  cursor: pointer;
}
.modelchoice .choice .ccontent .preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.modelchoice h2 {
  margin-top: 20px;
}
.modelchoice .img-placeholder {
  height: 250px;
}
.group-detail .details {
  padding: 15px;
}
.view.details,
.view.model {
  grid-area: view;
}
.view.details .viewcontent,
.view.model .viewcontent {
  width: 100%;
  height: 100%;
}
.view.details.brochures .flex-container,
.view.model.brochures .flex-container {
  padding-top: 20px;
  padding-bottom: 20px;
}
.view.details.brochures .form-group.checkinput .checkcontainer,
.view.model.brochures .form-group.checkinput .checkcontainer {
  min-height: 24px;
  margin-top: -5px;
  margin-bottom: -5px;
}
.html-preview .viewcontent .horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav {
  max-width: calc(100vw - 40px);
}
.html-preview .viewcontent .horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-content {
  padding-left: 0;
  padding-right: 0;
}
.html-preview .viewcontent .html-preview-form {
  background: none;
  grid-area: form;
}
.html-preview .viewcontent .html-preview-form form {
  display: block;
}
.html-preview .viewcontent .tab-content {
  padding: 0;
}
.html-preview .viewcontent .preview-pane {
  padding-top: 20px;
  grid-area: pane;
}
.html-preview .viewcontent .recipients-count {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px;
}
.html-preview .viewcontent .recipients-count > div {
  line-height: 36px;
  margin-right: 10px;
}
.col-md-4 .horizontal-tabs-container {
  margin-top: -20px;
}
.permission-list {
  padding: 0;
  margin: 0;
}
.permission-list li {
  list-style: none;
  border-bottom: 1px solid #cccccc;
  line-height: 3em;
  margin: 0;
  padding-left: 15px;
}
.permission-list li svg {
  margin-right: 10px;
  height: 18px;
}
.permission-list li span {
  display: inline-block;
  line-height: 18px;
  vertical-align: middle;
}
.permission-list li:last-of-type {
  border-bottom: none;
}
.model-details {
  padding: 20px;
  min-width: 0;
  min-height: 0;
  overflow: auto;
  position: relative;
}
@media screen and (min-width: 799px) {
  .model-details {
    padding-left: 0;
    padding-top: 0;
  }
}
.model-details .card .cardbody > .ccontent {
  display: flex;
  flex-wrap: wrap;
  padding-top: 5px;
  gap: 7px 0;
}
.model-details #portal-feeds .ccontent > .meta-group > .meta-group {
  border-bottom: 4px solid #E5EBF1;
}
.model-details #portal-feeds .ccontent > .meta-group > .meta-group:last-of-type {
  border-bottom: none;
}
.model-details .array-group {
  margin-bottom: 20px;
  padding-bottom: 8px;
}
.financial-structure.ccontent {
  display: flex;
  flex-wrap: wrap;
  padding-top: 5px;
  gap: 7px 0;
}
.meta-group {
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 100%;
  gap: 7px 20px;
}
.meta-group .col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}
.meta-group .col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
}
.meta-group .col-1 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(8.33333333%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(8.33333333% - 18.33333333px);
  max-width: 8.33333333%;
}
.meta-group .col-2 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(16.66666667%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(16.66666667% - 16.66666667px);
  max-width: 16.66666667%;
}
.meta-group .col-3 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(25%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(25% - 15px);
  max-width: 25%;
}
.meta-group .col-4 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(33.33333333%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(33.33333333% - 13.33333333px);
  max-width: 33.33333333%;
}
.meta-group .col-5 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(41.66666667%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(41.66666667% - 16.66666667px);
  max-width: 41.66666667%;
}
.meta-group .col-6 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(50%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(50% - 10px);
  max-width: 50%;
}
.meta-group .col-7 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(58.33333333%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(58.33333333% - 11.66666667px);
  max-width: 58.33333333%;
}
.meta-group .col-8 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(66.66666667%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(66.66666667% - 13.33333333px);
  max-width: 66.66666667%;
}
.meta-group .col-9 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(75%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(75% - 15px);
  max-width: 75%;
}
.meta-group .col-10 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(83.33333333%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(83.33333333% - 16.66666667px);
  max-width: 83.33333333%;
}
.meta-group .col-11 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(91.66666667%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(91.66666667% - 18.33333333px);
  max-width: 91.66666667%;
}
.meta-group .col-12 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(100%);
  max-width: 100%;
}
.meta-group .order-first {
  order: -1;
}
.meta-group .order-last {
  order: 13;
}
.meta-group .order-0 {
  order: 0;
}
.meta-group .order-1 {
  order: 1;
}
.meta-group .order-2 {
  order: 2;
}
.meta-group .order-3 {
  order: 3;
}
.meta-group .order-4 {
  order: 4;
}
.meta-group .order-5 {
  order: 5;
}
.meta-group .order-6 {
  order: 6;
}
.meta-group .order-7 {
  order: 7;
}
.meta-group .order-8 {
  order: 8;
}
.meta-group .order-9 {
  order: 9;
}
.meta-group .order-10 {
  order: 10;
}
.meta-group .order-11 {
  order: 11;
}
.meta-group .order-12 {
  order: 12;
}
.meta-group .offset-1 {
  margin-left: 8.33333333%;
}
.meta-group .offset-2 {
  margin-left: 16.66666667%;
}
.meta-group .offset-3 {
  margin-left: 25%;
}
.meta-group .offset-4 {
  margin-left: 33.33333333%;
}
.meta-group .offset-5 {
  margin-left: 41.66666667%;
}
.meta-group .offset-6 {
  margin-left: 50%;
}
.meta-group .offset-7 {
  margin-left: 58.33333333%;
}
.meta-group .offset-8 {
  margin-left: 66.66666667%;
}
.meta-group .offset-9 {
  margin-left: 75%;
}
.meta-group .offset-10 {
  margin-left: 83.33333333%;
}
.meta-group .offset-11 {
  margin-left: 91.66666667%;
}
@media (min-width: 576px) {
  .meta-group .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .meta-group .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .meta-group .col-sm-1 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333% - 18.33333333px);
    max-width: 8.33333333%;
  }
  .meta-group .col-sm-2 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667% - 16.66666667px);
    max-width: 16.66666667%;
  }
  .meta-group .col-sm-3 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25% - 15px);
    max-width: 25%;
  }
  .meta-group .col-sm-4 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333% - 13.33333333px);
    max-width: 33.33333333%;
  }
  .meta-group .col-sm-5 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667% - 16.66666667px);
    max-width: 41.66666667%;
  }
  .meta-group .col-sm-6 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    max-width: 50%;
  }
  .meta-group .col-sm-7 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333% - 11.66666667px);
    max-width: 58.33333333%;
  }
  .meta-group .col-sm-8 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667% - 13.33333333px);
    max-width: 66.66666667%;
  }
  .meta-group .col-sm-9 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75% - 15px);
    max-width: 75%;
  }
  .meta-group .col-sm-10 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333% - 16.66666667px);
    max-width: 83.33333333%;
  }
  .meta-group .col-sm-11 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667% - 18.33333333px);
    max-width: 91.66666667%;
  }
  .meta-group .col-sm-12 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(100%);
    max-width: 100%;
  }
  .meta-group .order-sm-first {
    order: -1;
  }
  .meta-group .order-sm-last {
    order: 13;
  }
  .meta-group .order-sm-0 {
    order: 0;
  }
  .meta-group .order-sm-1 {
    order: 1;
  }
  .meta-group .order-sm-2 {
    order: 2;
  }
  .meta-group .order-sm-3 {
    order: 3;
  }
  .meta-group .order-sm-4 {
    order: 4;
  }
  .meta-group .order-sm-5 {
    order: 5;
  }
  .meta-group .order-sm-6 {
    order: 6;
  }
  .meta-group .order-sm-7 {
    order: 7;
  }
  .meta-group .order-sm-8 {
    order: 8;
  }
  .meta-group .order-sm-9 {
    order: 9;
  }
  .meta-group .order-sm-10 {
    order: 10;
  }
  .meta-group .order-sm-11 {
    order: 11;
  }
  .meta-group .order-sm-12 {
    order: 12;
  }
  .meta-group .offset-sm-0 {
    margin-left: 0;
  }
  .meta-group .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .meta-group .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .meta-group .offset-sm-3 {
    margin-left: 25%;
  }
  .meta-group .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .meta-group .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .meta-group .offset-sm-6 {
    margin-left: 50%;
  }
  .meta-group .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .meta-group .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .meta-group .offset-sm-9 {
    margin-left: 75%;
  }
  .meta-group .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .meta-group .offset-sm-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 768px) {
  .meta-group .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .meta-group .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .meta-group .col-md-1 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333% - 18.33333333px);
    max-width: 8.33333333%;
  }
  .meta-group .col-md-2 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667% - 16.66666667px);
    max-width: 16.66666667%;
  }
  .meta-group .col-md-3 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25% - 15px);
    max-width: 25%;
  }
  .meta-group .col-md-4 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333% - 13.33333333px);
    max-width: 33.33333333%;
  }
  .meta-group .col-md-5 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667% - 16.66666667px);
    max-width: 41.66666667%;
  }
  .meta-group .col-md-6 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    max-width: 50%;
  }
  .meta-group .col-md-7 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333% - 11.66666667px);
    max-width: 58.33333333%;
  }
  .meta-group .col-md-8 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667% - 13.33333333px);
    max-width: 66.66666667%;
  }
  .meta-group .col-md-9 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75% - 15px);
    max-width: 75%;
  }
  .meta-group .col-md-10 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333% - 16.66666667px);
    max-width: 83.33333333%;
  }
  .meta-group .col-md-11 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667% - 18.33333333px);
    max-width: 91.66666667%;
  }
  .meta-group .col-md-12 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(100%);
    max-width: 100%;
  }
  .meta-group .order-md-first {
    order: -1;
  }
  .meta-group .order-md-last {
    order: 13;
  }
  .meta-group .order-md-0 {
    order: 0;
  }
  .meta-group .order-md-1 {
    order: 1;
  }
  .meta-group .order-md-2 {
    order: 2;
  }
  .meta-group .order-md-3 {
    order: 3;
  }
  .meta-group .order-md-4 {
    order: 4;
  }
  .meta-group .order-md-5 {
    order: 5;
  }
  .meta-group .order-md-6 {
    order: 6;
  }
  .meta-group .order-md-7 {
    order: 7;
  }
  .meta-group .order-md-8 {
    order: 8;
  }
  .meta-group .order-md-9 {
    order: 9;
  }
  .meta-group .order-md-10 {
    order: 10;
  }
  .meta-group .order-md-11 {
    order: 11;
  }
  .meta-group .order-md-12 {
    order: 12;
  }
  .meta-group .offset-md-0 {
    margin-left: 0;
  }
  .meta-group .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .meta-group .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .meta-group .offset-md-3 {
    margin-left: 25%;
  }
  .meta-group .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .meta-group .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .meta-group .offset-md-6 {
    margin-left: 50%;
  }
  .meta-group .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .meta-group .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .meta-group .offset-md-9 {
    margin-left: 75%;
  }
  .meta-group .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .meta-group .offset-md-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 992px) {
  .meta-group .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .meta-group .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .meta-group .col-lg-1 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333% - 18.33333333px);
    max-width: 8.33333333%;
  }
  .meta-group .col-lg-2 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667% - 16.66666667px);
    max-width: 16.66666667%;
  }
  .meta-group .col-lg-3 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25% - 15px);
    max-width: 25%;
  }
  .meta-group .col-lg-4 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333% - 13.33333333px);
    max-width: 33.33333333%;
  }
  .meta-group .col-lg-5 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667% - 16.66666667px);
    max-width: 41.66666667%;
  }
  .meta-group .col-lg-6 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    max-width: 50%;
  }
  .meta-group .col-lg-7 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333% - 11.66666667px);
    max-width: 58.33333333%;
  }
  .meta-group .col-lg-8 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667% - 13.33333333px);
    max-width: 66.66666667%;
  }
  .meta-group .col-lg-9 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75% - 15px);
    max-width: 75%;
  }
  .meta-group .col-lg-10 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333% - 16.66666667px);
    max-width: 83.33333333%;
  }
  .meta-group .col-lg-11 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667% - 18.33333333px);
    max-width: 91.66666667%;
  }
  .meta-group .col-lg-12 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(100%);
    max-width: 100%;
  }
  .meta-group .order-lg-first {
    order: -1;
  }
  .meta-group .order-lg-last {
    order: 13;
  }
  .meta-group .order-lg-0 {
    order: 0;
  }
  .meta-group .order-lg-1 {
    order: 1;
  }
  .meta-group .order-lg-2 {
    order: 2;
  }
  .meta-group .order-lg-3 {
    order: 3;
  }
  .meta-group .order-lg-4 {
    order: 4;
  }
  .meta-group .order-lg-5 {
    order: 5;
  }
  .meta-group .order-lg-6 {
    order: 6;
  }
  .meta-group .order-lg-7 {
    order: 7;
  }
  .meta-group .order-lg-8 {
    order: 8;
  }
  .meta-group .order-lg-9 {
    order: 9;
  }
  .meta-group .order-lg-10 {
    order: 10;
  }
  .meta-group .order-lg-11 {
    order: 11;
  }
  .meta-group .order-lg-12 {
    order: 12;
  }
  .meta-group .offset-lg-0 {
    margin-left: 0;
  }
  .meta-group .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .meta-group .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .meta-group .offset-lg-3 {
    margin-left: 25%;
  }
  .meta-group .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .meta-group .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .meta-group .offset-lg-6 {
    margin-left: 50%;
  }
  .meta-group .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .meta-group .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .meta-group .offset-lg-9 {
    margin-left: 75%;
  }
  .meta-group .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .meta-group .offset-lg-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 1200px) {
  .meta-group .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .meta-group .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .meta-group .col-xl-1 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333% - 18.33333333px);
    max-width: 8.33333333%;
  }
  .meta-group .col-xl-2 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667% - 16.66666667px);
    max-width: 16.66666667%;
  }
  .meta-group .col-xl-3 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25% - 15px);
    max-width: 25%;
  }
  .meta-group .col-xl-4 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333% - 13.33333333px);
    max-width: 33.33333333%;
  }
  .meta-group .col-xl-5 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667% - 16.66666667px);
    max-width: 41.66666667%;
  }
  .meta-group .col-xl-6 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    max-width: 50%;
  }
  .meta-group .col-xl-7 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333% - 11.66666667px);
    max-width: 58.33333333%;
  }
  .meta-group .col-xl-8 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667% - 13.33333333px);
    max-width: 66.66666667%;
  }
  .meta-group .col-xl-9 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75% - 15px);
    max-width: 75%;
  }
  .meta-group .col-xl-10 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333% - 16.66666667px);
    max-width: 83.33333333%;
  }
  .meta-group .col-xl-11 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667% - 18.33333333px);
    max-width: 91.66666667%;
  }
  .meta-group .col-xl-12 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(100%);
    max-width: 100%;
  }
  .meta-group .order-xl-first {
    order: -1;
  }
  .meta-group .order-xl-last {
    order: 13;
  }
  .meta-group .order-xl-0 {
    order: 0;
  }
  .meta-group .order-xl-1 {
    order: 1;
  }
  .meta-group .order-xl-2 {
    order: 2;
  }
  .meta-group .order-xl-3 {
    order: 3;
  }
  .meta-group .order-xl-4 {
    order: 4;
  }
  .meta-group .order-xl-5 {
    order: 5;
  }
  .meta-group .order-xl-6 {
    order: 6;
  }
  .meta-group .order-xl-7 {
    order: 7;
  }
  .meta-group .order-xl-8 {
    order: 8;
  }
  .meta-group .order-xl-9 {
    order: 9;
  }
  .meta-group .order-xl-10 {
    order: 10;
  }
  .meta-group .order-xl-11 {
    order: 11;
  }
  .meta-group .order-xl-12 {
    order: 12;
  }
  .meta-group .offset-xl-0 {
    margin-left: 0;
  }
  .meta-group .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .meta-group .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .meta-group .offset-xl-3 {
    margin-left: 25%;
  }
  .meta-group .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .meta-group .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .meta-group .offset-xl-6 {
    margin-left: 50%;
  }
  .meta-group .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .meta-group .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .meta-group .offset-xl-9 {
    margin-left: 75%;
  }
  .meta-group .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .meta-group .offset-xl-11 {
    margin-left: 91.66666667%;
  }
}
.meta-group [class^="col-"],
.meta-group [class*="col-"] {
  padding: 0;
}
.meta-group .meta-detail:not([class^="col-"]):not([class*="col-"]) {
  display: inherit;
  flex-wrap: wrap;
  gap: 16px 20px;
}
.meta-group .meta-detail:not([class^="col-"]):not([class*="col-"]) .tip {
  flex: 0 0 100%;
}
.meta-group .bordered {
  margin-top: 23px;
  border-top: 4px solid #E5EBF1;
  padding-top: 27px;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% + 30px);
}
.meta-detail {
  display: flex;
  flex-wrap: wrap;
  line-height: 1.5rem;
  gap: 0 16px;
}
.meta-detail div.domstring {
  /* Ensure that the formatting is not lost on the Description text. */
  white-space: pre-wrap;
}
.meta-detail div.domstring.position-left {
  float: left;
}
.meta-detail div.domstring.position-right {
  float: right;
}
.meta-detail div.domstring.position-full {
  width: 100%;
}
.meta-detail div.domstring .inline-image {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.meta-detail div.domstring .inline-image figcaption {
  padding: 10px;
  width: 100%;
  text-align: center;
}
.meta-detail ul {
  padding-top: 0;
}
.meta-detail svg {
  margin: 0;
  height: 18px;
  vertical-align: middle;
  transition: all 0.3s ease 0s;
}
.meta-detail label {
  margin-bottom: 0;
}
.meta-detail .btn {
  line-height: 1.5rem;
  vertical-align: top;
  margin-right: 20px;
}
.meta-detail .col.cell_number {
  display: flex;
  flex-wrap: wrap;
}
.meta-detail .col.cell_number > div {
  flex: 0 0 100%;
  display: flex;
}
.meta-detail .col {
  flex-wrap: wrap;
  align-self: flex-start;
}
.meta-detail .col a {
  flex: 0 0 auto;
}
.meta-detail .col:has(.tags-selected) {
  gap: 6px 6px;
}
.meta-detail.extras .col {
  align-items: center;
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  min-width: 240px;
  padding: 0;
  gap: 6px 6px;
  -webkit-overflow-scrolling: touch;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  border: none;
}
@media screen and (max-width: 799px) {
  .meta-detail.extras .col {
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
  }
}
.meta-detail.extras .extras-legend {
  margin-left: 3px;
}
.meta-detail.extras .extras-selected {
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #E5EBF1;
  padding: 3px;
}
.meta-detail.extras .extras-selected .extras-label {
  padding-left: 3px;
}
@media screen and (max-width: 799px) {
  .meta-detail.extras .extras-selected {
    flex: 0 0 100%;
  }
}
.meta-detail .tags-selected {
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #E5EBF1;
  padding: 3px;
  line-height: 1;
  font-size: 11px;
}
.meta-detail .tags-selected .tag-tags {
  margin-left: 3px;
  padding: 2px 5px;
  border-radius: 2px;
  background: #FC495D;
  color: #ffffff;
  font-size: 11px;
}
@media screen and (max-width: 799px) {
  .meta-detail .tags-selected {
    flex: 0 0 100%;
  }
}
.meta-detail .col.tags {
  padding-top: 2.5px;
  padding-bottom: 0;
  padding-right: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px 6px;
}
.view .heavy {
  text-transform: uppercase;
  display: flex;
  word-wrap: anywhere;
  background: #F3F5F8;
  padding: 5px 6px;
  flex: 0 0 100%;
  min-width: 190px;
  font-size: 10px;
  margin-bottom: auto;
}
@media screen and (min-width: 799px) {
  .view .heavy {
    flex: 0 0 1%;
  }
}
.view .heavy + div {
  display: flex;
  padding: 5px 6px;
  min-width: 200px;
  overflow-wrap: anywhere;
}
.view .heavy + div.agent {
  margin-right: 0;
}
.view .dashboard-meta {
  flex: 1 1 100%;
}
.view .dashboard-meta .heavy {
  background: none;
  padding: 0;
  font-size: 14px;
  color: #10294D;
  font-weight: 600;
  text-transform: none;
  min-width: 120px;
}
.view .dashboard-meta .heavy + div {
  display: inline;
  padding: 0;
  flex: 1 1;
  font-size: 14px;
  min-width: 0;
}
.view .dashboard-meta.subtle-meta .heavy {
  font-weight: 400;
  color: #70859E;
}
.view .dashboard-meta.subtle-meta .heavy + div {
  display: none;
}
.input-group .contact-details {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 10px;
  flex: 1 1;
}
.input-group .contact-details.col-auto {
  display: flex;
  flex-wrap: wrap;
  gap: 3px 0;
  flex: 1 1;
}
.input-group .contact-details .input-group {
  gap: 6px 0;
}
.input-group .contact-details:not(.no-wrap) .meta-detail .heavy {
  flex: 1 1 100%;
  margin-bottom: 0;
}
.input-group .address-details {
  display: flex;
  justify-content: flex-end;
  gap: 6px 20px;
  flex: 1 1;
}
.listing-contacts-list {
  display: flex;
  flex-direction: column;
  gap: 10px 10px;
}
.social-icons {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 10px;
  flex: 0 1;
  min-width: 108px;
}
@media screen and (min-width: 799px) {
  .social-icons {
    justify-content: flex-end;
  }
}
.card .cardbody > .ccontent.dashboard-sharing {
  padding-top: 0;
}
.dashboard-sharing .social-icons {
  justify-content: space-between;
}
.dashboard-sharing .social-icons .social-icon svg {
  width: 40px;
}
.dashboard-sharing .portals {
  margin-top: 20px;
}
.dashboard-listing-buttons {
  margin-top: 20px;
  display: flex;
  gap: 10px 10px;
  flex-wrap: wrap;
}
.flagged-matches .datatable tbody tr:hover:not(.selected) td {
  background: none;
}
.flagged-matches .datatable td:first-of-type .tablecell {
  padding-left: 0;
}
.flagged-matches .datatable td.column-actions > div {
  padding-right: 0;
}
.flagged-matches a.btn-icon-16,
.flagged-matches button.btn-icon-16,
.flagged-matches .btn-icon-16 {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  min-width: 32px;
  min-height: 32px;
  max-width: 32px;
  justify-content: center;
}
.flagged-matches .has-link {
  text-decoration: none;
}
.latest-notes-list-inner {
  display: flex;
  gap: 10px 10px;
  flex-direction: column;
}
.latest-notes-note {
  display: flex;
  gap: 10px 10px;
}
.latest-notes-note .agent {
  padding-top: 16px;
  margin: 0;
}
.latest-notes-note .avatar-md > .thumbimg {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.latest-notes-note .latest-notes-summary {
  flex: 1 1 auto;
  background: #F3F5F8;
  padding: 20px;
  border-radius: 4px;
}
.latest-notes-note .noteauthor {
  color: #10294D;
  font-weight: 600;
}
.latest-notes-note .notes-summary-date {
  font-size: 11px;
  font-weight: 400;
  color: #B2C2D4;
  text-align: right;
}
.latest-notes-note .notes-summary-body {
  margin-top: 10px;
  margin-bottom: 0;
  color: #5A6F89;
}
.branch-tel-number {
  margin-top: 16px;
  font-size: 30px;
  font-weight: 400;
  line-height: 30px;
  color: #10294D;
  flex: 1 1 100%;
}
.single-stat svg {
  width: 70px;
  height: auto;
  margin: 0 0 0.5rem;
  fill: #979797;
}
.single-stat h1 {
  color: #FC495D;
}
.big-number {
  font-size: 30px;
  line-height: 1;
  margin-top: 15px;
  margin-bottom: 15px;
  flex: 1 1 100%;
  max-height: 50px;
  color: #10294D;
}
.big-number a {
  text-decoration: none;
}
@media (max-width: 799px) {
  .big-number {
    font-size: 24px;
  }
}
.agent-details .branchstats .details-section-heading {
  padding: 0;
}
.listing-details .singlemeta img {
  margin: 10px 20px 20px 0;
  border: 4px solid #efefef;
  border-radius: 3px;
  width: 30%;
}
.listing-details .singlemeta img.headline {
  margin: 0;
  display: block;
}
.listing-details .singlemeta img:first-of-type {
  width: 100%;
}
.listing-details .singlemeta img:nth-of-type(4) {
  margin-right: 0;
}
.listing-details .singlemeta h2 {
  margin: 30px 0 ;
}
.listing-details .singlemeta .description {
  white-space: pre-line;
  font-weight: 400;
}
.listing-details .singlemeta .agency-details .branch {
  margin-bottom: 20px;
}
.listing-details .singlemeta .meta-detail span {
  font-weight: 400;
}
.listing-details .singlemeta .meta-detail span:first-of-type {
  text-align: right;
  font-weight: 600;
  display: block;
}
span.tag {
  background-color: #efefef;
  color: #333333;
  padding: 1px 8px;
  border-radius: 3px;
  font-size: 11px;
  line-height: 1.5rem;
  display: inline-block;
}
span.tag + span.tag {
  margin: 0 3px;
}
span.tag.rounded {
  border-radius: 60px !important;
}
.tagged .col {
  gap: 3px 3px;
}
.tagged span.tag + span.tag {
  margin: 0;
}
@keyframes AnimatedLoadingGradient {
  0% {
    background-position: 50% 0%;
  }
  50% {
    background-position: 50% 100%;
  }
  100% {
    background-position: 50% 0%;
  }
}
.mixed-gallery {
  margin-bottom: 0;
  margin-left: -15px;
  margin-right: -15px;
  display: flex;
  flex-wrap: wrap;
}
.mixed-gallery h2 {
  text-transform: capitalize;
}
.mixed-gallery > div {
  display: flex;
  flex: 1 1 280px;
  height: 210px;
  max-width: 280px;
  min-width: 280px;
  align-items: center;
  align-content: center;
  overflow: hidden;
  margin: 15px;
  position: relative;
  justify-content: center;
}
.mixed-gallery > div a {
  position: relative;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  max-width: 280px;
  width: 100%;
  overflow: hidden;
  height: 100%;
  background: linear-gradient(140deg, #ffffff, #dddddd);
  background-size: 400% 400%;
  animation: AnimatedLoadingGradient 2s ease infinite;
}
.mixed-gallery > div .img {
  width: 100%;
}
.mixed-gallery > div svg {
  height: 64px;
}
@media screen and (max-width: 798px) {
  .mixed-gallery > div {
    height: auto;
    max-width: 100%;
  }
  .mixed-gallery > div a {
    max-width: 100%;
    height: auto;
  }
  .mixed-gallery > div a img {
    width: 100%;
    height: auto;
  }
}
.mixed-gallery-caption {
  position: absolute;
  justify-content: center;
  align-content: center;
  background: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  padding: 8px 12px;
  display: flex;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 280px;
}
.mixed-gallery img {
  height: 210px;
}
.details-section {
  margin-bottom: 20px;
  padding: 20px;
}
.details-section .modelname {
  display: inline-block;
  margin-right: 20px;
  line-height: 3rem;
  vertical-align: middle;
}
.details-section .mediatype {
  margin-bottom: 40px;
}
.details-section-heading {
  font-weight: normal;
  padding-top: 20px;
  padding-bottom: 20px;
  margin: 0;
}
.no-border .details-section-heading,
.details-section-heading.no-border {
  border-top: 0;
  padding-top: 0;
}
.details-section-heading-inline {
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 100%;
}
.details-section-buttons {
  display: flex;
  flex: 0 1 450px;
  flex-wrap: wrap;
  gap: 6px 6px;
  margin-left: 10px;
  margin-left: auto;
}
.details-section-buttons.min-flex {
  flex: 0 1 100%;
  margin-left: 0;
  margin-right: 0;
}
.details-section-buttons.min-flex > div {
  flex: 1 1 100%;
  margin: 0;
}
@media (min-width: 799px) {
  .details-section-buttons {
    flex: 1 1 auto;
    justify-content: flex-end;
    min-width: -moz-fit-content;
    min-width: fit-content;
  }
  .details-section-buttons.min-flex {
    padding-top: 0;
    flex: 1 1 auto;
  }
  .details-section-buttons.min-flex > div {
    flex: 0 1 auto;
  }
}
.details-section-buttons .btn {
  line-height: 1.5rem;
  vertical-align: top;
  display: flex;
  flex: 0 0 auto;
  cursor: pointer;
  justify-content: center;
  align-self: center;
}
.details-section-buttons .btn:last-of-type {
  margin-right: 0;
}
.details-section-buttons .btn > svg {
  height: 13px;
  margin: 0 0.5em 0 0;
}
.details-section-buttons + form {
  margin-top: 20px;
  display: block;
}
.details-section:first-of-type .details-section-heading {
  padding-top: 0;
  border-top: none;
}
.details-section .para {
  padding-bottom: 15px;
  font-size: 1.1rem;
  font-weight: 400;
}
.details-section.contact,
.details-section .social {
  margin: 30px 0;
}
.details-section .textformat,
.details-section .summary-branch_profile,
.details-section .summary-description {
  white-space: pre-line;
  font-weight: 400;
}
.space-evenly {
  justify-content: space-between;
}
.social-icon {
  display: flex;
  max-width: 48px;
  max-height: 48px;
}
.social-icon svg {
  width: 48px;
  height: 48px;
}
.image-gallery {
  margin-bottom: 40px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(275px, max-content));
  justify-content: space-around;
  gap: 15px;
  flex-wrap: wrap;
}
.image-gallery-thumb {
  position: relative;
  background: #F3F5F8;
  padding: 15px;
  gap: 8px;
}
.image-gallery-thumb .checkcontainer {
  min-height: 24px;
}
.image-gallery h2 {
  text-transform: capitalize;
}
.image-gallery > div {
  display: flex;
  flex: 1 1 280px;
  max-width: 280px;
  min-width: 280px;
  align-items: center;
  align-content: center;
  overflow: hidden;
  position: relative;
  justify-content: center;
  flex-wrap: wrap;
}
.image-gallery > div a {
  position: relative;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  max-width: 280px;
  overflow: hidden;
  max-height: 210px;
  background: linear-gradient(140deg, #ffffff, #dddddd);
  background-size: 400% 400%;
  animation: AnimatedLoadingGradient 2s ease infinite;
}
.image-gallery > div img {
  max-height: 100%;
  max-width: 100%;
  background: linear-gradient(140deg, #ffffff, #dddddd);
  background-size: 400% 400%;
  animation: AnimatedLoadingGradient 2s ease infinite;
}
.image-gallery .image-gallery-thumb-meta {
  flex: 0 0 100%;
  gap: 10px;
  align-items: flex-start;
  align-content: flex-start;
  display: flex;
}
.image-gallery-caption {
  color: #92A7C0;
}
.documents-gallery {
  width: 100%;
  margin-bottom: 15px;
}
.documents-gallery thead th {
  color: #333333;
  white-space: nowrap;
  padding: 10px;
}
.documents-gallery thead th:first-of-type {
  padding-left: 0;
}
.documents-gallery .file-item {
  flex: 0 1 100%;
  min-height: 44px;
  align-items: center;
}
.documents-gallery .file-item td {
  border-top: 1px solid #d6d6d6;
}
.documents-gallery .file-name {
  padding: 10px 12px 10px 0;
  width: 100%;
  vertical-align: middle;
}
.documents-gallery .file-name .btn {
  border: 0;
  padding: 0;
}
.documents-gallery .file-name > div {
  display: flex;
  align-items: center;
}
.documents-gallery .file-name > div span {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 44px);
}
.documents-gallery .file-size {
  padding: 0 10px;
  white-space: nowrap;
  display: none;
}
@media (min-width: 799px) {
  .documents-gallery .file-size {
    display: table-cell;
  }
}
.documents-gallery .file-type {
  flex: 0 0 30px;
  padding: 0 10px;
  text-align: center;
  display: none;
}
@media (min-width: 799px) {
  .documents-gallery .file-type {
    display: table-cell;
  }
}
.documents-gallery .file-type svg {
  height: 24px;
}
.toolbox div.toolgroup {
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
}
.toolbox h4 {
  flex: 1 0 100%;
}
.toolbox div.toolcontainer {
  margin-right: 20px;
  margin-bottom: 10px;
  vertical-align: top;
  width: 100px;
  text-align: left;
  color: #979797;
}
.toolbox div.toolcontainer .tool {
  border-radius: 4px;
  border: 1px solid #cfcdcd;
  background: none;
  display: block;
  width: 100px;
  height: 100px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.toolbox div.toolcontainer .tool svg {
  height: 48px;
  fill: #10294D;
  fill-rule: evenodd;
}
.toolbox div.toolcontainer a {
  text-decoration: none;
}
.toolbox div.toolcontainer a.tool:hover svg,
.toolbox div.toolcontainer .has-link:hover svg {
  fill: #444444;
}
.toolbox div.toolcontainer .has-link {
  color: #FC495D;
  cursor: pointer;
}
.toolbox div.toolcontainer span.toolcount {
  font-size: 1.5rem;
  color: #444444;
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}
.toolbox div.toolcontainer span.toolcount + svg {
  height: 34px;
}
.toolbox div.toolcontainer span.toollabel {
  display: inline-block;
  max-width: 100%;
  margin: 10px 0;
  font-size: 1.1rem;
}
.card .publish-portals.cardbody > .ccontent {
  padding-top: 0;
}
.publish-portals > .row {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% + 30px);
}
.publish-portals .column-feed_status {
  width: 60px;
}
.publish-portals .column-modified {
  width: 130px;
}
.publish-portals h2 {
  padding-bottom: 10px;
}
.publish .portals table.datatable tbody tr:hover td,
.syndication .portals table.datatable tbody tr:hover td {
  background-color: #fff;
}
.publish .portals .portal,
.syndication .portals .portal {
  text-align: center;
  border: 1px solid #E5EBF1;
  border-radius: 3px;
  display: inline-block;
  width: 200px;
  height: 100px;
  align-items: center;
  flex: 0 0 200px;
}
.publish .portals .portal img,
.syndication .portals .portal img {
  height: 100%;
}
.publish .portals .portal.portaloff img,
.syndication .portals .portal.portaloff img {
  filter: grayscale(100%);
}
.publish .portals .portal label,
.syndication .portals .portal label {
  display: block;
  min-width: auto;
}
.publish .portals .portal-log-meta,
.syndication .portals .portal-log-meta {
  display: block;
  padding: 15px 0;
}
.publish .portals .portal-log-meta > div,
.syndication .portals .portal-log-meta > div {
  display: inline-block;
  vertical-align: bottom;
}
.publish .portals .portal-log-meta .btn-primary.btn-primary,
.syndication .portals .portal-log-meta .btn-primary.btn-primary {
  display: inline-block !important;
}
.publish .portals .portal-log-meta button svg,
.syndication .portals .portal-log-meta button svg {
  height: 11px;
  margin-top: -2px;
  margin-right: 8px !important;
}
.publish .portal-col,
.syndication .portal-col {
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 1%;
  gap: 15px;
}
.publish .portal-col.spacer,
.syndication .portal-col.spacer {
  margin-bottom: 0;
}
.publish .portal-col .row,
.syndication .portal-col .row {
  flex-wrap: auto;
}
.publish .portal-col .portal-fields,
.syndication .portal-col .portal-fields {
  flex: 1 1 100%;
  min-height: 48px;
}
.publish .portal-col .meta-detail,
.syndication .portal-col .meta-detail {
  flex: 1 1 100%;
  display: flex;
  align-items: center;
  margin-bottom: auto;
  gap: 0;
}
.publish .portal-col .meta-detail svg,
.syndication .portal-col .meta-detail svg {
  height: 24px;
  stroke: #10294D;
  stroke-width: 1.4;
}
.publish .portal-col .meta-detail .portal-field-value,
.syndication .portal-col .meta-detail .portal-field-value {
  flex: 0 0 20px;
}
.publish .portal-col .meta-detail .portal-field-label,
.syndication .portal-col .meta-detail .portal-field-label {
  flex: 1 1 auto;
}
.flex-full {
  flex-basis: 100% !important;
}
.syndication .portals > div {
  justify-content: center;
  align-items: top;
}
.portal-settings .cardbody .form-group {
  display: flex;
  align-items: center;
}
.portal-settings .cardbody .form-group .portallogo .portal {
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 10px 5px;
  display: inline-block;
  min-width: 250px;
  max-width: 250px;
  min-height: 250px;
  margin: 15px 15px 15px 15px;
  max-height: 250px;
  align-items: center;
}
.portal-settings .cardbody .form-group .portallogo .portal.portaloff img {
  filter: grayscale(100%);
}
.portal-settings .cardbody .form-group .portallogo .portal img {
  width: 220px;
}
.portal-settings .cardbody .form-group .portallogo button.btn {
  display: block;
  margin: 0 auto;
}
.portal-settings .cardbody table.datatable tr:hover td {
  background-color: #fff;
}
.portal-settings .cardbody table.datatable td {
  width: 25%;
  border: none;
  overflow: visible;
}
.portal-settings .cardbody table.datatable td .tablecell {
  overflow: visible;
}
.portal-settings .cardbody table.datatable td:last-of-type {
  text-align: center;
}
.card .cardbody .bar-graph.ccontent {
  padding: 40px 20px 0;
}
@media screen and (min-width: 799px) {
  .card .cardbody .bar-graph.ccontent {
    padding: 0 20px;
  }
}
.bar-graph .recharts-default-legend .recharts-legend-item {
  margin: 0;
  padding-bottom: 14px;
}
.stacked-legend-percentage {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #70859E;
}
.recharts-default-tooltip {
  margin: 0px;
  padding: 10px;
  background-color: #ffffff;
  border: 0 none !important;
  border-radius: 8px;
  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);
  white-space: nowrap;
}
.piechart-columns {
  margin-top: -30px;
}
.piechart-columns .piechart-column {
  margin-top: 30px;
}
.piechart-columns .piechart-column .pie-chart {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.piechart-columns .piechart-column .pie-chart .stacked-legend {
  max-width: calc(100% - 250px);
  min-width: 250px;
  flex-direction: column;
}
.piechart-columns .piechart-column .pie-chart .stacked-legend li {
  min-width: 100%;
}
@media screen and (min-width: 799px) {
  .piechart-columns .piechart-column .pie-chart .stacked-legend li {
    min-width: 0;
  }
}
.stacked-legend ul {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 20px;
}
.stacked-legend ul .recharts-legend-item {
  list-style: none;
  margin: 0;
}
.matches-listing {
  overflow: hidden;
}
.tablecell .indicator {
  height: 16px;
  width: 16px;
  stroke-width: 2.4;
  stroke: #73C677;
  fill: none;
  margin-right: 5px;
}
.tablecell .whatsapp-tel-link .whatsapp-link {
  color: inherit;
  text-decoration: underline;
}
.tablecell .whatsapp-tel-link .whatsapp-link svg {
  stroke: #78789A;
  stroke-width: 2.4;
}
.tablecell .whatsapp-tel-link .whatsapp-link .listing-popup,
.tablecell .whatsapp-tel-link .whatsapp-link .contact-popup {
  text-decoration: inherit;
  display: inline;
}
.tablecell .whatsapp-tel-link .whatsapp-link:hover {
  color: #10294D;
}
.tablecell .whatsapp-tel-link .whatsapp-link.secondary {
  color: #FC495D;
  text-decoration: none;
}
.tablecell .whatsapp-tel-link .whatsapp-link.secondary:hover {
  text-decoration: underline;
}
.matches-listing-details {
  display: flex;
  gap: 16px 16px;
}
.matches-listing-details .matches-listing-image {
  flex: 1 1 100;
  height: 144px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
}
@media screen and (min-width: 799px) {
  .matches-listing-details .matches-listing-image {
    flex: 0 0 208px;
  }
}
.matches-listing-details .matches-listing-meta {
  flex: 1 1 100;
  height: 144px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  background: #F3F5F8;
  padding: 15px;
}
@media screen and (min-width: 799px) {
  .matches-listing-details .matches-listing-meta {
    flex: 0 0 334px;
  }
}
.matches-listing-details .matches-listing-meta .matches-listing-type {
  margin-left: auto;
  flex: 0 0 auto;
  color: #CED7E2;
}
.matches-listing-details .matches-listing-meta .matches-listing-price {
  margin-left: auto;
  flex: 0 0 100%;
  font-size: 24px;
  font-weight: 500;
  color: #10294D;
}
.matches-listing-details .matches-listing-meta .matches-listing-address {
  margin-left: auto;
  flex: 0 0 100%;
  font-size: 16px;
  color: #10294D;
}
.matches-listing-details .matches-listing-map {
  flex: 1 1 100;
  height: 144px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
}
@media screen and (min-width: 799px) {
  .matches-listing-details .matches-listing-map {
    flex: 1 1 auto;
  }
}
.matches-listing-details .matches-listing-map img {
  object-fit: cover;
  min-width: 100%;
}
.dashboard-listing-details {
  display: flex;
  flex: 1 1 100%;
  width: 100%;
  height: 100%;
  min-height: 350px;
  background-size: cover;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  overflow: hidden;
}
.dashboard-listing-details > img {
  width: 100%;
  height: 350px;
  object-fit: cover;
}
@media screen and (min-width: 799px) {
  .dashboard-listing-details > img {
    height: 469px;
  }
}
.dashboard-listing-details:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 64.06%, #000000 100%);
  border-radius: 8px;
}
.dashboard-listing-details .dashboard-listing-buttons {
  position: absolute;
  display: flex;
  top: 20px;
  right: 20px;
  gap: 10px 10px;
}
.dashboard-listing-details .dashboard-listing-buttons .btn {
  color: #10294D;
  font-weight: 600;
}
.dashboard-listing-details .dashboard-listing-meta {
  flex: 1 1 100;
  border-radius: 8px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  flex-wrap: wrap;
  padding: 15px;
  gap: 10px 0;
  color: #ffffff;
}
@media screen and (min-width: 799px) {
  .dashboard-listing-details .dashboard-listing-meta {
    flex: 0 0 334px;
  }
}
.dashboard-listing-details .dashboard-listing-meta .dashboard-listing-type {
  margin-left: auto;
  flex: 0 0 auto;
  color: #ffffff;
}
.dashboard-listing-details .dashboard-listing-meta .dashboard-listing-price {
  margin-left: auto;
  flex: 0 0 100%;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}
.dashboard-listing-details .dashboard-listing-meta .dashboard-listing-address {
  margin-left: auto;
  flex: 0 0 100%;
  font-size: 14px;
  line-height: 21px;
  color: #ffffff;
}
.listing-contacts-item {
  display: flex;
  min-height: 48px;
  height: auto;
  gap: 15px 15px;
}
.listing-contacts-item .listing-contacts-details {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.listing-contacts-item .listing-contacts-name {
  font-size: 14px;
  line-height: 1.5;
  flex: 1 1 100%;
  margin: 0;
}
.listing-contacts-item .listing-contacts-name a {
  text-decoration: none;
}
.listing-contacts-item .listing-contacts-meta {
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 0 10px;
}
.listing-contacts-item .listing-contacts-meta svg {
  width: 24px;
  stroke: #CED7E2;
  stroke-width: 1.4;
}
.listing-contacts-item .listing-contacts-meta a {
  text-decoration: none;
}
.listing-brochure-mini {
  width: calc(100% - 40px);
  max-width: 203px;
  max-height: 260px;
  box-shadow: 4px 4px 0 0 #E5EBF1;
  position: relative;
}
.listing-brochure-mini .listing-brochure-mini-container {
  width: 100%;
  padding-bottom: 141.42%;
}
.listing-brochure-mini .listing-brochure-mini-image {
  height: 60%;
  width: 100%;
  max-width: 203px;
  position: absolute;
  object-fit: cover;
}
.listing-brochure-mini .listing-brochure-mini-image img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.listing-brochure-mini .listing-brochure-mini-logo {
  position: absolute;
  bottom: 15px;
  left: 15px;
  max-width: 50%;
  object-fit: cover;
}
.listing-brochure-mini .listing-brochure-mini-logo img {
  width: 100%;
}
.listing-brochure-mini + h3 {
  display: flex;
  flex: 0 0 100%;
  justify-content: center;
}
.marker-dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: rgba(252, 73, 93, 0.7);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 0 25px rgba(252, 73, 93, 0.2);
}
.btmatches .table-header {
  padding: 10px 0 20px;
}
.btmatches .btm-summary {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.btmatches .btm-summary .btm-legend {
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: left;
  text-align: center;
  color: #333;
  max-width: 100%;
  flex-wrap: wrap;
}
.btmatches .btm-summary .btm-legend .heavy {
  text-align: right;
  min-width: 0;
}
.btmatches .btm-summary .btm-legend div {
  padding: 0 10px;
  white-space: nowrap;
}
.btmatches .btm-summary .btm-legend div div {
  display: inline-block;
}
.btmatches .btm-summary .btm-legend svg {
  height: 35px;
  display: block;
}
@media screen and (max-width: 798px) {
  .btmatches .btm-summary {
    justify-content: start;
  }
  .btmatches .btm-summary .btm-legend > div:first-of-type {
    padding: 0;
  }
  .btmatches .btm-summary .btm-legend > div:nth-child(2) > div:first-of-type {
    padding-left: 0;
  }
  .btmatches .btm-summary .btm-legend > div:first-of-type,
  .btmatches .btm-summary .btm-legend > div:nth-child(2) {
    padding-left: 0;
  }
  .btmatches .btm-summary .btm-legend .heavy {
    min-width: 190px;
    text-align: left;
  }
}
.btmatches .listbody {
  position: relative;
}
.btmatches .datatable thead td,
.btmatches .datatable thead th {
  padding: 12px 8px;
}
.btmatches .datatable thead td.column-rating,
.btmatches .datatable thead th.column-rating {
  padding: 8px;
}
.btmatches .datatable .loader.inline {
  position: relative;
  visibility: hidden;
}
.btmatches .loader.inline {
  position: absolute;
  bottom: 5px;
  margin: 10px auto;
  border-width: 4px;
  width: 40px;
  height: 40px;
  left: 50%;
  margin-left: -20px;
  z-index: auto;
}
.listing-leads .datatable td:last-of-type {
  text-align: center;
}
.listing-leads .datatable td button {
  background-color: transparent;
}
.listing-leads .datatable td button:hover {
  cursor: pointer;
}
svg.btmstar {
  width: 24px;
}
tbody svg.btmstar {
  width: 16px;
}
svg.btmstar.smaller {
  width: 12px;
}
svg.btmstar.hot {
  --color4: #CF0000;
}
svg.btmstar.warm {
  --color4: #F7CA34;
}
svg.btmstar.cold {
  --color4: #0073B7;
}
.contact-compliance .datatable td:first-of-type,
.contact-compliance .datatable th:first-of-type {
  width: auto;
}
.contact-compliance .btn-primary {
  margin-bottom: 2rem;
}
.model-details .stepper .card .cardbody > .ccontent {
  padding-top: 20px;
}
.stepper .pagestep {
  flex: 1 1;
}
.stepper .card {
  margin-bottom: 0;
}
.model-details .stepper .card {
  margin-bottom: 20px;
}
.google-map {
  margin-top: 15px;
  margin-bottom: 30px;
  width: 100%;
  height: calc(75vw - 110px);
  max-height: 400px;
  position: relative;
}
.google-map svg path {
  fill: #FC495D;
}
.notes-form {
  padding-bottom: 20px;
}
.notes-form textarea.form-control {
  min-height: 150px;
}
.notes-form .loader + .btn {
  margin-left: 10px;
}
.notes-form svg {
  height: 16px;
}
.notes-form .btn-primary.btn-primary {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}
.notes-form .btn-primary.btn-primary svg {
  height: 18px;
}
.notes-form .note-original {
  padding: 0 15px;
  font-size: 1.1rem;
}
.notes-form .note-original p {
  font-size: inherit;
}
.profile-listing-model .inline-select {
  margin: 0;
}
.profile-listing-model .form-group .forminput .input-group-addon {
  padding-left: 15px;
}
.referrals .meta-detail .referral-contact {
  display: flex;
}
.referrals .meta-detail .referral-contact .referral-contact-icon {
  display: flex;
  align-items: center;
  margin-right: 5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #FF6464;
}
.referrals .meta-detail .referral-contact .referral-contact-icon.match {
  background: #73C677;
}
.referrals .meta-detail .referral-contact .referral-contact-icon svg {
  fill: none;
  stroke: #ffffff;
  stroke-width: 2.4;
  width: 16px;
  height: 16px !important;
}
.contacts {
  flex: 1 1 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}
.contacts .col {
  flex: 0 0 1%;
}
.contacts .col.associated_agents {
  flex: 1 1 1%;
}
.contacts .col .meta-detail {
  flex-wrap: nowrap;
}
.contacts .col .meta-detail .heavy {
  flex: 1 1 160px;
  min-width: 160px;
  white-space: nowrap;
}
@media (max-width: 799px) {
  .agents {
    display: flex;
  }
  .contacts .col .meta-detail {
    flex-wrap: wrap;
  }
}
.meta-detail .microsite.has-link {
  display: inline-block;
  padding-left: 10px;
}
.meta-label {
  font-weight: bold;
  color: #333333;
  max-width: 85px;
}
a.meta-label {
  color: #333333;
}
.listing-contacts {
  display: flex;
  flex-wrap: wrap;
}
.listing-contacts .row {
  min-width: calc(100% + 30px);
}
.listing-contacts .listing-contacts-details {
  flex: 1 1 auto;
}
.listing-contacts .listing-contacts-details .listing-contacts-meta .row {
  margin-top: 15px;
}
.listing-contacts .avatar {
  margin-right: 20px;
  width: 100px;
  height: 100px;
}
.listing-contacts .avatar .thumbimg {
  width: 100px;
  height: 100px;
  background-size: cover;
}
.listing-contacts .avatar .thumbimg svg {
  width: 100px;
  height: 100px;
}
.section-underline {
  margin: 15px 0 0;
  line-height: 1;
}
.row + .section-underline {
  margin-top: 0;
}
.section-underline:after {
  content: "";
  display: inline-block;
  position: relative;
  width: 100%;
  vertical-align: bottom;
  height: 1px;
  background: #cccccc;
}
.contact-cards {
  display: grid;
  gap: 16px 16px;
}
@media screen and (min-width: 799px) {
  .contact-cards {
    grid-template-columns: repeat(auto-fit, 320px);
  }
}
.tc-tooltip-content .contact-cards {
  padding: 12px;
  font-size: 12px;
}
.contact-cards .card {
  margin-bottom: 0;
  max-width: 400px;
}
.contact-cards .listing-contacts-card {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 0;
}
.contact-cards .listing-contacts-card a,
.contact-cards .listing-contacts-card button {
  text-decoration: none;
}
.contact-cards .listing-contacts-card .avatar {
  width: 96px;
  height: 96px;
  order: -1;
}
.contact-cards .listing-contacts-card .avatar .thumbimg {
  width: 96px;
  height: 96px;
  border-radius: 50%;
}
.contact-cards .listing-contacts-card .listing-contacts-details {
  display: flex;
  flex: 0 0 100%;
  flex-wrap: wrap;
}
.contact-cards .listing-contacts-card .listing-contacts-label {
  color: #CED7E2;
  text-transform: uppercase;
  flex: 0 0 100%;
}
.contact-cards .listing-contacts-card .listing-contacts-name {
  margin-top: 0;
  flex: 0 0 100%;
}
.contact-cards .listing-contacts-card .listing-contacts-status {
  display: flex;
  align-items: center;
  gap: 0 5px;
  padding: 0 8px;
  height: 21px;
  border-radius: 12px;
  background: #FFEEEF;
  color: #FF6464;
  font-size: 14px;
  flex: 0 0 auto;
}
.contact-cards .listing-contacts-card .listing-contacts-status:before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #FF6464;
  display: block;
}
.contact-cards .listing-contacts-card .listing-contacts-status.active {
  background: #F0F9F1;
  color: #73C677;
}
.contact-cards .listing-contacts-card .listing-contacts-status.active:before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #73C677;
  display: block;
}
.contact-cards .listing-contacts-card .listing-contacts-meta {
  margin-top: 15px;
  flex: 0 0 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 7px 0;
}
.contact-cards .listing-contacts-card .listing-contacts-meta div {
  flex: 0 0 100%;
  display: flex;
  gap: 0 15px;
  align-items: center;
}
.contact-cards .listing-contacts-card .listing-contacts-meta svg {
  width: 24px;
  stroke: #10294D;
  stroke-width: 1.4;
}
@media screen and (min-width: 799px) {
  .contact-cards .listing-contacts-card {
    flex-wrap: nowrap;
  }
  .contact-cards .listing-contacts-card .listing-contacts-details {
    flex: 1 1 100%;
  }
  .contact-cards .listing-contacts-card .avatar {
    position: absolute;
    top: 20px;
    right: 20px;
    margin-left: auto;
    order: 1;
  }
}
.input-group.publish-group {
  gap: 7px 20px;
}
.input-group.publish-group .heavy {
  min-width: 220px;
}
.player-container {
  width: 100%;
  max-width: 480px;
  padding: 15px 0;
}
.player-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  padding-top: 56.25%;
}
.react-player {
  position: absolute;
  top: 0;
  left: 0;
}
.notes-search {
  display: flex;
  padding: 0 20px;
}
.notes-stream {
  padding: 20px;
}
.notes-stream .notes-stream-content {
  margin-left: -15px;
  margin-right: -15px;
}
.notes-stream .notes-stream-event {
  border-top: 5px solid #cccccc;
  padding: 30px 15px;
}
.notes-stream .notes-stream-event-card-header {
  font-size: 1rem;
  display: flex;
  align-items: center;
}
.notes-stream .notes-stream-event-card-header strong {
  color: #000000;
  margin-right: 5px;
}
.notes-stream .notes-stream-event-card-header .btn {
  margin-left: auto;
}
.notes-stream .notes-stream-event-card-body {
  font-size: 1.1rem;
}
.notes-stream .notes-stream-event-card-body p {
  font-size: inherit;
}
.notes-stream .notes-stream-event-card .note-actions {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}
.notes-stream .notes-stream-event-card .note-actions .agents {
  margin-right: auto;
  display: flex;
}
.notes-stream .notes-stream-event-card .note-actions .thumb.small {
  width: 40px;
  height: 40px;
}
.notes-stream .notes-stream-event-card .note-actions .thumb.small .thumbimg {
  width: 40px;
  height: 40px;
}
.notes-stream .notes-stream-event-card .note-comments .notes-stream-event {
  margin-top: 15px;
  border: 1px solid #cccccc;
  border-radius: 4px;
  padding: 15px;
}
.user-resume {
  margin-top: 20px;
}
.activity {
  display: grid;
  grid-template-areas: "search" "timeline";
  grid-template-columns: 1fr;
  grid-template-rows: min-content min-content;
  min-height: 0;
  min-width: 0;
}
@media screen and (min-width: 799px) {
  .activity {
    grid-template-areas: "timeline search";
    grid-template-columns: 1fr 355px;
    grid-template-rows: 1fr;
  }
}
.activity > .form {
  min-height: 0;
  min-width: 0;
  flex-wrap: wrap;
  grid-area: search;
  display: grid;
  padding: 20px;
}
@media screen and (min-width: 799px) {
  .activity > .form {
    padding: 0;
    padding-right: 20px;
  }
}
.activity > .form > div {
  min-width: 0;
}
.activity > .form .editgroup > .input-group {
  flex: 1 1 100%;
  background: #ffffff;
  padding: 10px;
  border-radius: 8px;
}
.activity > .form .activity-search .field:first-child {
  flex: 1 1;
}
.activity > .form .activity-search .field:first-child .form-group.search {
  max-width: none;
}
.activity > .form .activity-search .field:first-child .form-group.dateinput {
  max-width: none;
}
.activity > .form .activity-search .field:first-child .form-group.dateinput .forminput {
  padding-bottom: 2px;
}
.activity > .form .activity-search .field:first-child .form-group.dateinput .flatpickr-calendar {
  box-shadow: none;
  border: 0 none;
}
.activity > .form .activity-search .field:first-child .form-group.dateinput .flatpickr-innerContainer {
  border: 0 none;
}
.activity > .form .activity-search .field:first-child .form-group.dateinput .flatpickr-months {
  padding-bottom: 5px;
}
.activity > .form .activity-search #keyword-search-btn {
  margin-left: 10px;
  padding: 0 9px;
}
.activity > .form .activity-search #field-search {
  flex-wrap: nowrap;
}
.activity > .form .activity-search #field-search .forminput {
  flex: 1 1 100%;
}
.activity > .form .activity-search .flatpickr-wrapper > .flatpickr-calendar.inline {
  margin: 0 auto;
}
.activity > div {
  grid-area: timeline;
  min-height: 0;
  min-width: 0;
  overflow: auto;
}
.activity .list-actions {
  padding-left: 50px;
}
.activity .thumb.small,
.activity .thumb.small .thumbimg {
  border-radius: 50%;
  width: 32px;
  height: 32px;
}
.viewing-feedback-graph .customized-legend {
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: auto;
  min-width: 150px;
  gap: 8px;
}
.viewing-feedback-graph .customized-legend .legend-count {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 46px;
  line-height: 1;
}
.viewing-feedback-graph .customized-legend .legend-total {
  flex: 0 0;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
}
.marketing-email-pie-graph .legend-label {
  font-weight: 500;
}
.marketing-email-pie-graph .legend-count {
  font-weight: 600;
  color: #222222;
}
.viewing-feedback-card div {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px 10px;
}
.viewing-feedback-card span {
  font-size: 34px;
  color: #10294D;
}
.viewing-feedback-card svg {
  width: 56px;
  stroke: #10294D;
  fill: none;
}
.column-metaviewingfeedback {
  width: 50%;
}
.column-metaviewingviewing_date {
  width: 100px;
}
.col.stage .lead-stage {
  background: none;
  padding: 0;
  color: inherit;
  text-decoration: inherit;
}
.grid-container.grid-5 .grid-col-1.flex-stats {
  align-content: center;
}
.grid-container.grid-5 .grid-col-1.flex-stats .flex-container {
  gap: 20px 20px;
  justify-content: center;
  align-items: center;
}
.grid-container.grid-5 .grid-col-1.flex-stats .stat-count {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  font-size: 42px;
  color: #10294D;
}
.grid-container.grid-5 .grid-col-1.flex-stats .stat-heading {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  align-items: center;
  text-align: center;
  font-size: 16px;
  color: #70859E;
}
.image-gallery-thumb-img-size {
  position: absolute;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.7);
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  padding: 8px 12px;
  display: flex;
  border-radius: 18px;
  right: 0;
  top: 0px;
  margin: 19px;
  z-index: 1;
}
#social-Whatsapp path {
  fill: rgba(0, 0, 0, 0.7);
}
.whatsapp-tel-link {
  display: flex;
  align-items: center;
  gap: 0px 5px;
}
a.whatsapp-link,
button.whatsapp-link {
  display: flex;
  align-items: center;
  background: none;
  border: 0 none;
  padding: 0;
  margin: 0;
  cursor: pointer;
}
.whatsapp-link .has-link {
  display: flex;
  align-items: center;
  background: none;
  border: 0 none;
  padding: 0;
  margin: 0;
  cursor: pointer;
}
.whatsapp-link svg {
  width: 16px;
  fill: none;
  stroke: #78789A;
  stroke-width: 2.4;
}
.referral-response-outcome {
  width: 100%;
}
.referral-response-outcome .radiogroup .radioinput {
  margin-top: 10px;
}
.flow-placeholder {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 10px;
}
.flow-placeholder-text {
  flex: 0 0 100%;
  text-align: center;
  font-size: 14px;
  line-height: 21px;
}
.flow-placeholder-text span {
  color: #10294D;
}
.flow-placeholder .btn {
  font-size: 14px;
}
.social-performance-filters .filter-overlay-ga .form-group.checkinput .forminput .checkcontainer + label {
  min-width: auto;
  margin-right: 12px;
}
.social-performance-widget .flex-container {
  gap: 10px;
}
.social-performance-widget .customized-legend {
  width: 100%;
  gap: 10px 30px;
  font-size: 11px;
  padding-bottom: 0;
}
.social-performance-widget .customized-legend .legend-item {
  flex: 0 0 auto;
  height: auto;
  cursor: pointer;
}
.social-performance-widget .customized-legend .powered-by {
  white-space: nowrap;
  display: flex;
  align-items: center;
  align-content: center;
  margin-left: auto;
}
.social-performance-widget .customized-legend .powered-by svg {
  display: inline;
  width: 46px;
  flex: 0 0 46px;
  margin-left: 10px;
}
.deal-columns .grid-container {
  border-bottom: 1px solid #E5EBF1;
}
.deal-columns .deal-columns--label {
  color: #92A7C0;
  align-self: center;
  padding: 3px 0;
}
.deal-columns .deal-columns--label strong {
  color: #10294D;
}
.deal-columns .deal-columns--value {
  align-self: center;
  padding: 3px 0;
  justify-self: flex-end;
  text-align: right;
}
.deal-columns .deal-columns--value.large {
  color: #10294D;
  font-size: 18px;
  font-weight: 600;
}
.commission-block {
  padding: 20px;
  background: #F3F5F8;
}
.commission-block > div {
  display: flex;
  justify-content: space-between;
}
.commission-save {
  display: flex;
  justify-content: flex-end;
}
.report-group {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
}
.report-group .report-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  color: #10294D;
  background: #F3F5F8;
  padding: 10px 16px;
  font-size: 16px;
  line-height: 24px;
}
.report-group .report-heading span {
  color: #92A7C0;
  font-size: 12px;
}
.report-group .report-list {
  margin: 0;
}
.report-group .report-list dd,
.report-group .report-list dt {
  margin: 0;
  padding: 6px 15px;
  color: #455870;
  font-size: 12px;
  font-weight: 500;
}
.report-group .report-list dt {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.report-group .report-list dd {
  background: #FAFBFD;
}
.tab-availability .card {
  margin-bottom: 0;
}
.alerts-sidebar {
  background: #ffffff;
  display: flex;
}
.alerts-sidebar .alerts-heading {
  display: flex;
  position: sticky;
  background: #F3F5F8;
  height: 64px;
  align-items: center;
  justify-content: space-between;
  top: 0;
  z-index: 10;
  padding-left: 20px;
}
.alerts-sidebar .alerts-container {
  list-style: none;
  margin: 0;
  padding: 0;
  position: sticky;
  top: 68px;
  transition: width 0.2s ease-in-out;
  width: 280px;
  grid-template-rows: 50px auto;
  max-height: calc(100vh -  68px);
  justify-content: space-between;
  overflow: hidden;
}
.alerts-sidebar .alerts-container .alert-action {
  display: flex;
  margin-top: 20px;
  justify-content: space-between;
  align-items: baseline;
}
.alerts-sidebar .alerts-container .alert-content {
  overflow: visible;
  overflow-x: visible;
  overflow-y: auto;
  position: relative;
  right: -17px;
  left: 0;
  height: calc(100vh - 200px);
  width: 297px;
}
.alerts-sidebar .alerts-container .alert-item {
  text-align: left;
  border-bottom: 1px solid #ccc;
  padding: 10px 20px;
  margin-right: 17px;
}
.alerts-sidebar .alerts-container .alert-item .alert-detail {
  color: #979797;
  font-size: 1rem;
}
.alerts-sidebar .alerts-container .alert-item .alert-detail.domain {
  text-transform: capitalize;
}
.alerts-sidebar .alerts-container .alert-item.noalerts {
  text-align: center;
}
.alerts-sidebar .alerts-container.noalerts h3 {
  border-bottom: 2px solid #efefef;
}
.alerts-sidebar .alerts-container p {
  font-size: 1rem;
}
.alerts-sidebar .alerts-container svg {
  height: 100px;
  fill: none;
  stroke: #E5EBF1;
}
.alerts-sidebar .alerts-container .close-window {
  text-align: right;
  margin-right: 10px;
}
.alerts-sidebar .alerts-container .close-window button.btn.btn-alert-close-x {
  background-color: transparent;
  display: inline-block;
}
.alerts-sidebar .alerts-container .close-window svg {
  height: 20px;
  stroke: #CED7E2;
}
.notifier {
  position: fixed;
  z-index: 1000;
  top: 85px;
  right: 15px;
  width: 300px;
  display: flex;
  flex-direction: column-reverse;
}
.notifier .notice-content {
  position: relative;
  transition: left 0.5s, opacity 0.6s, opacity 0.5s, opacity 0.6s;
  left: 300px;
  opacity: 0;
  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);
  background-color: #fff;
  padding: 20px;
  margin-bottom: 10px;
  min-height: 40px;
  color: #B2C2D4;
}
.notifier .notice-content.active {
  left: 0;
  opacity: 1;
}
.notifier .notice-content.success {
  border-left: 4px solid #73C677;
}
.notifier .notice-content.error {
  border-left: 4px solid #FF6464;
}
.notifier .notice-content.info {
  border-left: 4px solid #60D3EC;
}
.notifier .notice-buttons {
  display: flex;
  gap: 10px 10px;
}
/* Cards */
.card {
  position: relative;
  border-radius: 8px;
  margin-bottom: 20px;
  width: 100%;
  border: 1px solid rgba(195, 201, 210, 0.31);
}
.card.active {
  border: 1px solid #92A7C0;
}
.card.maxcard {
  overflow-y: hidden;
}
.card.no-shadow {
  box-shadow: none;
}
.card.stats-card-grey {
  background: #F3F5F8;
  height: 100%;
}
.card.stats-card-grey h3 {
  font-size: 24px;
  margin-top: 0;
}
.card.stats-card-grey .ccontent svg {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  stroke: #10294D;
  stroke-width: 1.4;
}
.card.stats-card-grey .ccontent div {
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.card.stats-card-grey .ccontent div span {
  color: #70859E;
}
.card.stats-card-grey .ccontent div .view-text {
  color: #B2C2D4;
}
.card-legend {
  display: flex;
  align-items: center;
  gap: 0 5px;
}
.card-legend legend {
  font-size: 1rem;
  vertical-align: middle;
  width: auto;
  display: flex;
  align-items: center;
  margin: 0;
}
.card-legend legend:before {
  content: "";
  width: 6px;
  height: 6px;
  display: block;
  border-radius: 3px;
  margin-right: 10px;
}
.card-legend legend.required:before {
  background: #FFB1B1;
}
.card-legend legend.quality:before {
  background: #DFB0F4;
}
.card-meta {
  display: flex;
  justify-content: space-between;
  margin: -20px;
  margin-bottom: 20px;
  background: #ffffff;
  padding: 20px;
}
.card-meta .card-toggles {
  margin-left: auto;
  display: flex;
  align-items: center;
}
.card-meta .cardtoggle-required {
  text-align: right;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 5px 0;
  padding-bottom: 20px;
}
.card-meta .cardtoggle-required .btn {
  flex: 1 1 100%;
  justify-content: center;
  background: #ffffff;
  border: 1px solid #E5EBF1;
  color: #10294D;
}
.card-meta .cardtoggle-required .btn svg {
  stroke: #10294D;
}
.card-meta .cardtoggle-required .btn.focus,
.card-meta .cardtoggle-required .btn:focus,
.card-meta .cardtoggle-required .btn:focus-visible {
  color: #071B38;
  border: 1px solid #CED7E2;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.card-meta .cardtoggle-required .btn.active,
.card-meta .cardtoggle-required .btn:active {
  color: #071B38;
  border: 1px solid #CED7E2;
  background: transparent;
}
.card-meta .cardtoggle-required .btn.active.focus,
.card-meta .cardtoggle-required .btn:active.focus,
.card-meta .cardtoggle-required .btn.active:focus,
.card-meta .cardtoggle-required .btn:active:focus,
.card-meta .cardtoggle-required .btn.active:focus-visible,
.card-meta .cardtoggle-required .btn:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.card-meta .cardtoggle-required .btn.hover,
.card-meta .cardtoggle-required .btn:hover {
  color: #071B38;
  border: 1px solid #CED7E2;
  background: transparent;
}
.card-meta .cardtoggle-required .btn.hover.active,
.card-meta .cardtoggle-required .btn:hover.active,
.card-meta .cardtoggle-required .btn.hover:active,
.card-meta .cardtoggle-required .btn:hover:active {
  border-color: #CED7E2;
  background: transparent;
}
.card-meta .cardtoggle-required .btn.hover.active.focus,
.card-meta .cardtoggle-required .btn:hover.active.focus,
.card-meta .cardtoggle-required .btn.hover:active.focus,
.card-meta .cardtoggle-required .btn:hover:active.focus,
.card-meta .cardtoggle-required .btn.hover.active:focus,
.card-meta .cardtoggle-required .btn:hover.active:focus,
.card-meta .cardtoggle-required .btn.hover:active:focus,
.card-meta .cardtoggle-required .btn:hover:active:focus,
.card-meta .cardtoggle-required .btn.hover.active:focus-visible,
.card-meta .cardtoggle-required .btn:hover.active:focus-visible,
.card-meta .cardtoggle-required .btn.hover:active:focus-visible,
.card-meta .cardtoggle-required .btn:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
@media screen and (max-width: 799px) {
  .card-meta {
    flex-wrap: wrap;
  }
  .card-meta .card-toggles {
    flex: 1 1 100%;
    flex-wrap: wrap;
  }
  .card-meta .card-toggles .pagestep {
    margin-top: 1.25rem;
    margin-left: 8px;
    margin-right: 0;
    flex: 1 1 100%;
  }
  .card-meta .card-toggles .pagestep .firstpage {
    margin-left: auto;
  }
  .card-meta .cardtoggle-required {
    margin-top: 1.25rem;
    text-align: left;
  }
}
.card.hidden {
  display: none;
}
.card .requiredonly .notrequired {
  display: none;
}
.card .cardhead {
  padding: 10px 20px;
  display: flex;
  align-items: center;
}
.card .cardhead h3 {
  margin: 0;
  line-height: 36px;
}
.card .cardhead .ccontent {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.card .cardhead .cardtoggle {
  background: none;
  border: none;
  outline: none;
  flex: 0 0 18px;
  text-align: center;
  cursor: pointer;
}
.card .cardhead .cardtoggle svg {
  width: 12px;
  fill: #ccc;
  display: inline-block;
  vertical-align: middle;
}
.card .cardhead .profile-matches {
  display: flex;
  gap: 8px 12px;
  position: absolute;
  right: 0px;
  margin-right: 28px;
}
@media screen and (max-width: 799px) {
  .card .cardhead .profile-matches {
    display: flex;
    gap: 8px 12px;
    position: absolute;
    top: 44px;
  }
}
.card .cardhead .profile-matches > div {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
.card .cardhead .profile-matches > div span {
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
}
.card .cardhead .profile-matches > div svg {
  height: 16px;
  width: 24px;
}
.card .cardhead .matches-header {
  margin: 0px;
}
@media screen and (max-width: 799px) {
  .card .cardhead .matches-header {
    margin: 0px 0 16px 0;
  }
}
.card .cardbody {
  overflow: hidden;
  max-height: none;
  transition: max-height 0.2s ease-in-out;
}
.card .cardbody .horizontal-tabs-container {
  margin-top: -15px;
}
.card .cardbody > .ccontent {
  padding: 20px;
}
.card .cardbody > .ccontent.stats-card h1 a {
  color: #ffffff;
}
.card .cardbody > .ccontent.stats-card .flex-container {
  align-items: center;
}
.card .cardbody > .ccontent.stats-card-mini {
  padding: 13px 20px;
}
.card .cardbody > .ccontent.no-top-padding {
  padding-top: 0 !important;
}
.card .cardbody > .ccontent.no-padding {
  padding: 0 !important;
}
.dash .card .cardbody > div {
  text-align: center;
  max-width: 145px;
}
.card#communication-preferences .listbody {
  flex: 0 0 100%;
}
.card.open .cardbody {
  overflow: visible;
  height: auto;
  margin: 0;
}
.card.closed .cardbody {
  height: 0;
  margin: 0;
}
.card .ccontent.nopadding {
  padding: 0;
}
.card .cardfoot {
  padding: 20px 15px;
}
.card .details {
  font-size: 1.1rem;
}
.card .details span {
  display: inline-block;
  margin-right: 10px;
}
.card .stats > div {
  margin: 20px 0;
}
.card .contacts td:first-of-type {
  font-weight: 700;
  text-align: right;
  padding-right: 10px;
}
.card.tab-container {
  border: 1px solid #cccccc;
  border-radius: 3px;
}
.card.tab-container .ccontent {
  padding-left: 0;
  padding-right: 0;
}
.withbg {
  background: #ffffff;
}
.grey_25 {
  background: #FAFBFD;
}
.primary-bg {
  background: #10294D;
  color: #ffffff;
}
.primary-bg * {
  color: inherit;
}
.primary-bg h1 {
  font-size: 40px;
  margin: 0;
}
.primary-bg h3 {
  margin: 0;
}
.primary-bg span {
  color: #70859E;
}
.primary-bg strong {
  font-size: 14px;
  color: #B2C2D4;
  font-weight: 600;
}
.primary-bg .whatsapp-link svg {
  stroke: #ffffff;
  stroke-width: 2.4 !important;
}
.primary-bg .has-link:hover {
  color: #ffffff;
  text-decoration: none;
}
.primary-bg .heavy.heavy {
  color: #ffffff;
  font-weight: 600;
}
.primary-bg .flex-container {
  align-items: center;
  justify-content: flex-start;
}
.primary-bg .flex-container.justify-center {
  justify-content: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between !important;
}
.agent-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 1 100%;
  gap: 30px 0;
  padding: 40px 16px;
}
@media screen and (min-width: 799px) {
  .agent-card {
    flex: 1 1 240px;
    max-width: 240px;
  }
}
.agent-card h3 {
  font-weight: 600;
  text-align: center;
  margin: 0 0 10px;
}
.agent-card h4 {
  font-weight: 500;
}
.agent-card .avatar-lg > .thumbimg {
  width: 120px;
  height: 120px;
  border-radius: 50%;
}
.agent-card .single-user {
  margin: 0;
  justify-content: center;
}
.agent-card .agent-details {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.agent-card .agent-details > * {
  flex: 1 1 100%;
  text-align: center;
}
.agent-card .agent-details h1 {
  font-size: 30px;
  margin-top: 20px;
}
.agent-card .agent-links {
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
  gap: 10px;
}
.cardtoggle-jump {
  height: 37px;
  flex: 0 0 100%;
}
.cardtoggle-jump .btn {
  left: 0;
  right: 0;
  padding: 6px 20px;
  background: #CED7E2;
  border-radius: 0;
  transition: none;
  font-weight: 500;
  width: 100%;
  z-index: 99;
}
.cardtoggle-jump.sticky .btn {
  position: fixed;
  margin: 0;
  left: 0;
  right: 0;
  top: 178px;
}
.stats-filters {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
}
.stats-filters .form-group:not(.checkinput) {
  flex: 0 0 auto;
}
.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) {
  flex: 1 1;
  border-color: transparent;
}
.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only):hover,
.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only):focus,
.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only):active,
.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only):focus-within {
  border-color: transparent;
  box-shadow: none;
}
.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) .react-select__control--is-focused {
  border-color: transparent;
}
.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) .react-select__value-container {
  padding: 0;
}
.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) .react-select__control {
  min-height: 21px;
}
.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) .react-select__control:hover {
  cursor: pointer;
}
.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) .react-select__input-container {
  color: transparent;
}
.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) .react-select__dropdown-indicator {
  padding: 0;
}
.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) .react-select__indicators {
  flex: 0 0;
}
@media screen and (max-width: 799px) {
  .stats-filters {
    display: block;
  }
}
.primary-bg .react-select .react-select__dropdown-indicator svg {
  stroke: #92A7C0;
}
.whatsapp-gray-div {
  width: 14px;
  height: 15px;
}
.force-update + .card {
  margin-top: 20px;
}
.hotcoldcard {
  font-size: 16px;
  padding-right: 41px;
  display: flex;
  font-weight: 900;
  height: 22px;
  margin-bottom: 0px;
}
.hotcoldvalue {
  padding-right: 41px;
  padding-left: 6px;
}
.hotcoldvalueend {
  padding-left: 6px;
}
.banner {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  padding: 20px;
  gap: 16px;
  background: #ffffff;
}
.banner .banner-heading {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  flex: none;
  align-self: stretch;
  flex-grow: 0;
}
.banner .banner-heading .btn-banner-close {
  padding: 0;
  min-height: unset;
}
.banner .banner-heading h3 {
  margin: 0;
  display: flex;
  align-items: center;
  flex: none;
  flex-grow: 1;
}
.banner.quality {
  background: #EFD7F9;
}
.banner.success {
  background: #DCF1DE;
}
.banner.info {
  background: #D7F4FA;
}
.banner.error {
  background: #FFB1B1;
}
.tab-content {
  display: grid;
  grid-area: tab-content;
  padding: 20px;
  padding-top: 0;
  gap: 20px;
  min-width: 0;
  min-height: 0;
  grid-template-rows: auto minmax(min-content, max-content);
  align-content: flex-start;
}
.tab-content > .portals {
  max-width: calc(100vw - 40px);
}
.tab-content.tab-details,
.tab-content.tab-notes {
  padding: 0;
  gap: 0;
  grid-template-areas: "jump-menu" "details";
  grid-template-rows: auto 1fr;
  min-height: 0;
}
@media screen and (min-width: 799px) {
  .tab-content.tab-details,
  .tab-content.tab-notes {
    grid-template-areas: "jump-menu details";
    grid-template-columns: 260px 1fr;
    grid-template-rows: 1fr;
    gap: 20px 20px;
  }
}
@media screen and (min-width: 799px) {
  .tab-content.tab-notes {
    grid-template-areas: "jump-menu details";
    grid-template-columns: 370px 1fr;
    grid-template-rows: 1fr;
  }
}
.tab-content.tab-activity {
  padding: 0;
}
.tab-content.tab-design {
  gap: 0;
}
.tab-content.tab-stage {
  gap: 0;
}
.tab-content .stepper:empty {
  height: 0;
}
.tab-content .stepper + div {
  min-width: 0;
}
.horizontal-tabs-container {
  display: grid;
  grid-template-areas: "tabs" "tab-content";
  grid-template-rows: auto 1fr;
  padding-left: 0;
  min-height: 0;
  flex: 1 0 100%;
}
.horizontal-tabs-container .horizontal-tabs-wrapper {
  grid-area: tabs;
  min-width: 0;
  display: flex;
}
@media screen and (min-width: 799px) {
  .horizontal-tabs-container .horizontal-tabs-wrapper {
    max-width: calc(100vw - 64px);
  }
}
.horizontal-tabs-container .horizontal-tabs-wrapper .for-scroll {
  display: none;
}
.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-content {
  display: flex;
  gap: 0 5px;
  flex: 1 1 auto;
  padding: 14px 40px 15px 10px;
}
@media screen and (min-width: 799px) {
  .horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-content {
    padding: 14px 20px;
  }
}
.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav {
  display: flex;
  flex: 1 1 100%;
  max-width: 100vw;
}
@media screen and (min-width: 799px) {
  .horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav {
    max-width: calc(100vw - 64px);
  }
}
.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .horizontal-tabs-content:after {
  content: "";
  flex: 0 0 10px;
  width: 20px;
  order: 9999999;
}
.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #F3F5F8;
  left: 0;
  height: 66px;
}
.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-left button {
  margin: 0 10px 0 20px;
}
.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-left svg {
  height: 100%;
  width: 24px;
  fill: none;
  stroke: #10294D;
  stroke-width: 1.4;
}
.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-left:before {
  content: "";
  z-index: 1;
  background: linear-gradient(to right, #f3f5f8, rgba(243, 245, 248, 0) 100%);
  position: absolute;
  left: 100%;
  width: 10px;
  bottom: 0;
  top: 0;
  pointer-events: none;
}
.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #F3F5F8;
  right: 0;
  height: 66px;
}
.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-right button {
  margin: 0 20px 0 10px;
}
.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-right svg {
  height: 100%;
  width: 24px;
  fill: none;
  stroke: #10294D;
  stroke-width: 1.4;
}
.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-right:after {
  content: "";
  z-index: 1;
  background: linear-gradient(to right, rgba(243, 245, 248, 0), #f3f5f8 100%);
  position: absolute;
  right: 100%;
  width: 10px;
  bottom: 0;
  top: 0;
  pointer-events: none;
}
.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .nav:before {
  content: "";
  flex: 0 0 15px;
  background: none;
  order: 0;
}
.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .nav:after {
  content: "";
  flex: 0 0 15px;
  background: none;
  order: 9999999;
}
.horizontal-tabs-container .horizontal-tabs-wrapper .btn.btn-none.active {
  background: #10294D;
  color: #ffffff;
}
/* Action Buttons */
.viewhead {
  position: sticky;
  top: 0;
  max-width: 100vw;
  background: #ffffff;
  border-top: 1px solid rgba(195, 201, 210, 0.31);
  border-bottom: 1px solid rgba(195, 201, 210, 0.31);
  grid-area: actions;
  z-index: 100;
}
@media screen and (min-width: 799px) {
  .viewhead {
    max-width: calc(100vw - 64px);
  }
}
.viewhead + div {
  grid-area: view;
}
.viewhead .track-vertical {
  display: none;
}
.viewhead .track-horizontal {
  right: 2px;
}
.viewhead .scrollview {
  display: flex;
}
.canvashead {
  position: sticky;
  top: 0;
  max-width: 100vw;
  background: #10294D;
  grid-area: actions;
  z-index: 100;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  padding: 0 32px;
}
@media screen and (min-width: 799px) {
  .canvashead {
    max-width: calc(100vw);
  }
}
.canvashead .track-vertical {
  display: none;
}
.canvashead .track-horizontal {
  right: 2px;
}
.canvashead .scrollview {
  display: flex;
}
.canvashead .pd-logo {
  width: 208px;
  height: 54px;
  flex: 0 0 208px;
  margin-left: 10px;
  color: #071B38;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
}
.canvashead .lightstone-logo {
  width: 146px;
  height: 49px;
  flex: 0 0 146px;
  color: #071B38;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: contain;
  background-position: center center;
  background-repeat: no-repeat;
}
.canvashead .pd-callnow {
  display: flex;
  align-items: center;
  align-content: center;
  text-align: right;
  color: #ffffff;
}
.canvashead .pd-callnow a {
  color: #ffffff;
  text-decoration: underline;
}
.canvashead .pd-callnow a:hover {
  color: #ffffff;
  text-decoration: underline;
}
.canvas-footer {
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: space-between;
  padding: 0 20px 20px;
}
.canvas-footer .pd-logo {
  width: 208px;
  height: 54px;
  flex: 0 0 208px;
  color: #071B38;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-size: cover;
}
.canvas-footer .pd-callnow {
  display: flex;
  align-items: center;
  align-content: center;
  text-align: right;
}
.action-bar {
  display: flex;
}
.action-bar > div {
  flex: 1 1 auto;
  max-width: 100%;
}
.action-bar > .pagestep {
  flex: 0 0 auto;
  margin-right: 0;
}
.sticky-outer-wrapper.active .sticky-inner-wrapper {
  z-index: 100;
  right: 0;
  left: 64px;
  width: auto !important;
}
.sticky-outer-wrapper.active .sticky-inner-wrapper .actionswrap {
  background: #ffffff;
  margin: 0;
}
.actionswrap {
  z-index: 100;
  display: grid;
  grid-template-columns: 0 1fr 0;
  gap: 20px;
  grid-template-areas: "left scroll right";
  flex: 1 1 auto;
}
.actionswrap > div:not(.scroll-left):not(.scroll-right) {
  grid-area: scroll;
}
.actionswrap.has-scroll {
  gap: 0;
  touch-action: pan-x;
  grid-template-columns: 60px 1fr 60px;
}
.actionswrap.has-scroll * {
  touch-action: pan-x;
}
.actionswrap.has-scroll .action-list {
  padding-right: 0;
}
.actionswrap.has-scroll .scroll-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #ffffff;
  position: relative;
  height: 66px;
  grid-area: left;
}
.actionswrap.has-scroll .scroll-left button {
  margin: 0 10px 0 20px;
}
.actionswrap.has-scroll .scroll-left svg {
  height: 100%;
  width: 24px;
  fill: none;
  stroke: #10294D;
  stroke-width: 1.4;
}
.actionswrap.has-scroll .scroll-left:before {
  content: "";
  z-index: 1;
  background: linear-gradient(to right, #ffffff 20%, rgba(255, 255, 255, 0) 100%);
  position: absolute;
  left: 100%;
  width: 10px;
  bottom: 0;
  top: 0;
  pointer-events: none;
}
.actionswrap.has-scroll .scroll-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: #ffffff;
  position: relative;
  height: 66px;
  grid-area: right;
}
.actionswrap.has-scroll .scroll-right button {
  margin: 0 20px 0 10px;
}
.actionswrap.has-scroll .scroll-right svg {
  height: 100%;
  width: 24px;
  fill: none;
  stroke: #10294D;
  stroke-width: 1.4;
}
.actionswrap.has-scroll .scroll-right:after {
  content: "";
  z-index: 1;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff 100%);
  position: absolute;
  right: 100%;
  width: 10px;
  bottom: 0;
  top: 0;
  pointer-events: none;
}
.actionswrap.has-scroll .nav:before {
  content: "";
  flex: 0 0 15px;
  background: none;
  order: 0;
}
.actionswrap.has-scroll .nav:after {
  content: "";
  flex: 0 0 15px;
  background: none;
  order: 9999999;
}
.actionswrap.sticky {
  background: #ffffff;
  margin: 0;
  position: fixed;
  right: 0;
  top: 60px;
}
.actionswrap .action-list {
  grid-template: scroll;
  display: flex;
  justify-content: flex-start;
  white-space: nowrap;
  padding: 0 40px 0 10px;
  top: 0;
  gap: 0 5px;
  flex: 1 1 auto;
}
.actionswrap .action-list:after {
  content: "";
  flex: 0 0 5px;
  width: 10px;
  order: 9999999;
}
@media screen and (min-width: 799px) {
  .actionswrap .action-list {
    justify-content: flex-end;
    padding: 0 0;
  }
  .actionswrap .action-list:after {
    flex: 0 0;
  }
}
.actionswrap .action-list .navitem {
  margin-top: 14px;
  margin-bottom: 15px;
}
.actionswrap .action-list .add {
  margin-right: auto;
}
.actionswrap .action-list .list {
  order: 0;
  margin-right: auto;
}
@media screen and (min-width: 799px) {
  .viewhead:not(.details) .actionswrap .action-list .list {
    margin-right: 0;
  }
}
.actionswrap .action-list .save {
  order: 999;
}
.actionswrap .action-list .cancel {
  order: 1000;
}
.actionswrap .action-list .card-legend {
  order: 1;
  margin-right: auto;
}
.actionswrap .action-list .cardtoggle-required {
  display: flex;
  align-items: center;
  gap: 0 5px;
  order: 2;
}
.actionswrap .action-list .submenu-icon {
  margin-left: 5px;
  margin-right: 0;
}
.actionswrap .action-list .submenu-icon svg {
  stroke: #10294D;
  stroke-width: 1.4;
  min-width: 24px;
  height: 24px;
}
.actionswrap .action-list > .has-submenu {
  display: flex;
  flex: 0 0 auto;
  padding: 0;
}
.actionswrap .action-list > .has-submenu .btn {
  padding-right: 10px;
}
@media (min-width: 799px) {
  .actionswrap .action-list > .has-submenu {
    flex-wrap: nowrap;
  }
}
@media (min-width: 799px) {
  .full .actionswrap {
    left: 300px;
  }
}
@media (max-width: 799px) {
  .full .actionswrap {
    left: 0;
  }
  .mini .actionswrap {
    left: 0;
  }
  .actionswrap.down {
    transform: translate3d(0, 0, 0);
    transition: all 0.2s ease-in-out;
    top: 0;
  }
  .actionswrap.up {
    transform: translate3d(0, 0, 0);
    transition: all 0.2s ease-in-out;
    top: 60px;
  }
}
.context-sidebar .action-submenu {
  border-top: 0;
  width: 100%;
  display: flex;
}
.context-sidebar .action-submenu strong {
  display: block;
  padding: 0 0 0 0.8em;
  line-height: 2em;
}
.context-sidebar .action-submenu .action-sub-item {
  display: block;
  padding: 0 0.8em;
  cursor: pointer;
  background: none;
  border: 0 none;
}
.context-sidebar .nav > .navitem.disabled {
  color: #ccc;
}
.context-sidebar .nav > .navitem.disabled svg {
  fill: #ccc;
}
.action-submenu-cover-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
}
.action-submenu-cover-wrapper .action-submenu-cover {
  margin-top: 10px;
  z-index: 101;
  transition: top 0.2s ease-in-out;
}
.action-submenu-cover-wrapper .action-submenu-cover-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  transform: translateZ(0);
  background-color: rgba(0, 0, 0, 0);
}
.action-submenu-cover-wrapper .action-submenu {
  background: #ffffff;
  margin-top: 3px;
  border: 1px solid #CED7E2;
  border-radius: 4px;
}
.action-submenu-cover-wrapper .action-submenu strong {
  display: block;
  padding: 0.75rem 0.8em;
}
.action-submenu-cover-wrapper .action-submenu .action-sub-item {
  display: block;
  padding: 0.75rem 0.8em;
  cursor: pointer;
  background: #fff;
  border: 0 none;
  width: 100%;
  text-align: left;
  text-decoration: none;
  color: #78789A;
}
.action-submenu-cover-wrapper .action-submenu .action-sub-item:hover {
  background-color: #F3F5F8;
}
input:invalid {
  border: none;
  box-shadow: none !important;
}
.editgroup {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  gap: 27px 0;
}
.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #cfcdcd;
  border-radius: 4px;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  flex: 1 1 auto;
  font-size: 14px;
  line-height: 21px;
  min-height: 34px;
  padding: 6px 15px;
  border: none;
  outline: none;
  color: #70859E;
  background: transparent;
}
@media screen and (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #495057;
  background-color: #ffffff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.form-control::placeholder {
  color: #6c757d;
  opacity: 1;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}
.was-validated .form-control:valid,
.form-control.is-valid {
  border-color: #73C677;
}
.was-validated .form-control:valid:focus,
.form-control.is-valid:focus {
  border-color: #73C677;
  box-shadow: 0 0 0 0.2rem rgba(115, 198, 119, 0.25);
}
.was-validated .form-control:valid ~ .valid-feedback,
.form-control.is-valid ~ .valid-feedback,
.was-validated .form-control:valid ~ .valid-tooltip,
.form-control.is-valid ~ .valid-tooltip {
  display: block;
}
.was-validated .form-control:invalid,
.form-control.is-invalid {
  border-color: #dc3545;
}
.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
.was-validated .form-control:invalid ~ .invalid-feedback,
.form-control.is-invalid ~ .invalid-feedback,
.was-validated .form-control:invalid ~ .invalid-tooltip,
.form-control.is-invalid ~ .invalid-tooltip {
  display: block;
}
.form-control::placeholder {
  color: #B2C2D4;
  font-size: 14px;
  line-height: 21px;
  opacity: 1;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: transparent;
  color: #92A7C0;
  opacity: 1;
}
.form-control:hover {
  border: none;
}
.form-control:focus,
.form-control:focus-within {
  color: #70859E;
  border: none;
  box-shadow: none;
}
textarea.form-control {
  line-height: 18px;
  min-height: 112px;
  color: #444;
  background: none;
}
textarea.form-control:focus {
  background: none;
}
.form-control.domstring {
  white-space: pre-wrap;
}
.form-control + .tip:not(:first-of-type) {
  margin-top: 10px;
}
.form-control + .tip:not(:first-of-type) + .tip {
  margin-bottom: 0;
}
.form-control.google-map {
  padding: 0;
  margin: 0;
  min-height: 420px;
  margin-bottom: 104px;
}
.form-control.google-map .map-search,
.form-control.google-map .map-buttons {
  font-family: 'Poppins', sans-serif;
  font-size: 12px;
}
.form-control.google-map .map-search {
  box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
  margin: 10px;
  background: #ffffff;
  max-width: 300px;
  width: calc(100vw - 100px);
  border-radius: 2px;
}
.form-control.google-map .map-search .react-select__menu {
  font-size: 10px;
}
.form-control.google-map .map-buttons {
  margin: 10px 0;
  display: flex;
  gap: 10px 10px;
}
.form-control.sortable-text {
  margin-bottom: 5px;
}
.form-control.sortable-text input {
  border: 0;
  height: 100%;
}
.fieldarray-label {
  margin-bottom: 10px;
}
.fieldarray,
.sortabletextinput,
.fieldlist {
  display: flex;
  flex-wrap: wrap;
  gap: 27px 20px;
}
.fieldarray:not(.fieldlist) fieldset,
.sortabletextinput:not(.fieldlist) fieldset,
.fieldlist:not(.fieldlist) fieldset {
  flex: 0 0 100%;
}
.fieldarray:not(.fieldlist) fieldset + fieldset,
.sortabletextinput:not(.fieldlist) fieldset + fieldset,
.fieldlist:not(.fieldlist) fieldset + fieldset {
  padding-top: 27px;
}
.fieldarray:not(.fieldlist) fieldset > .input-group,
.sortabletextinput:not(.fieldlist) fieldset > .input-group,
.fieldlist:not(.fieldlist) fieldset > .input-group {
  flex: 1 1 100%;
}
.fieldarray .arrayaction,
.sortabletextinput .arrayaction,
.fieldlist .arrayaction {
  display: flex;
  gap: 27px 20px;
}
.fieldarray#field-portals fieldset + fieldset,
.sortabletextinput#field-portals fieldset + fieldset,
.fieldlist#field-portals fieldset + fieldset {
  box-shadow: 0px -5px 0px #E5EBF1;
}
.fieldarray.fieldarray > .input-group > .input-group > .input-group,
.sortabletextinput.fieldarray > .input-group > .input-group > .input-group,
.fieldlist.fieldarray > .input-group > .input-group > .input-group {
  flex: 1 1 100%;
}
.fieldarray.fieldarray .btn-drag,
.sortabletextinput.fieldarray .btn-drag,
.fieldlist.fieldarray .btn-drag {
  flex: 0 0;
  max-height: 34px;
  border: 0 !important;
  outline: 0 !important;
  box-shadow: none !important;
  cursor: row-resize;
}
.fieldarray.fieldarray .btn-drag ~ .input-group,
.sortabletextinput.fieldarray .btn-drag ~ .input-group,
.fieldlist.fieldarray .btn-drag ~ .input-group {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(100% - 40px);
}
.fieldarray.fieldarray .dz-handle,
.sortabletextinput.fieldarray .dz-handle,
.fieldlist.fieldarray .dz-handle {
  max-width: 12px;
  margin: 0;
}
.listings-lookup .listings-items {
  margin-bottom: 20px;
}
.listings-lookup .listing-lookup-listing-item {
  width: 100%;
  display: flex;
  line-height: 20px;
  padding-bottom: 10px;
}
.listings-lookup .listing-lookup-listing-item .listing-item-price {
  font-weight: 800;
  color: #000;
  min-width: 80px;
}
.listings-lookup .listing-lookup-listing-item .listing-item-price p {
  color: #92A7C0;
  text-transform: uppercase;
  margin: 0px;
}
.listings-lookup .listing-lookup-listing-item .listing-item-remove {
  padding-left: 5px;
}
.form-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 0;
  position: relative;
  flex: 0 0 100%;
}
@media screen and (min-width: 799px) {
  .form-group {
    flex: 1 1 auto;
  }
  .form-group.country-code-phone .input-group {
    flex-wrap: nowrap;
  }
}
.form-group.urltemplate .selectinput {
  margin-top: 10px;
}
.form-group.notesinput {
  margin-top: 10px;
}
.form-group.rtl textarea {
  text-align: right;
}
.form-group.translatabletextareainput .input-group + .input-group {
  margin-top: 20px;
}
.form-group.translatabletextareainput .input-group + .arrayaction {
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 100%;
}
.form-group.translatabletextareainput .input-group + .arrayaction .input-group {
  display: flex;
  flex-wrap: wrap;
}
.form-group.translatabletextareainput .input-group + .arrayaction .input-group .arrayaction-button {
  display: flex;
  flex-wrap: wrap;
  gap: 20px 20px;
}
.disabled .form-group {
  cursor: not-allowed;
}
.disabled .form-group .form-control {
  color: #92A7C0;
}
.disabled .form-group .input-label {
  color: #B2C2D4;
}
.form-group:not(.checkinput) .forminput {
  display: flex;
}
.form-group:not(.checkinput) .forminput:not(.input-only) {
  flex: 0 0 100%;
  border-radius: 4px;
  border: 1px solid #E5EBF1;
}
.form-group:not(.checkinput) .forminput:not(.input-only):hover {
  border: 1px solid #CED7E2;
}
.form-group:not(.checkinput) .forminput:not(.input-only):focus,
.form-group:not(.checkinput) .forminput:not(.input-only):focus-within {
  box-shadow: 0px 0px 0px 3px #E4E7EB;
}
.form-group:not(.checkinput) .forminput::placeholder {
  color: #B2C2D4;
  opacity: 1;
}
.required:not(:has(.required)) .form-group:not(.not-required):not(.checkinput) .forminput:before {
  content: "";
  min-width: 6px;
  margin: 3px 0 3px 3px;
  border-radius: 2px 0 0 2px;
  background: #FFB1B1;
}
.required:not(:has(.required)) .form-group:not(.not-required):not(.checkinput) .forminput .form-control,
.required:not(:has(.required)) .form-group:not(.not-required):not(.checkinput) .forminput .react-select .react-select__control {
  padding-left: 6px;
}
.quality .form-group:not(.not-required):not(.checkinput) .forminput:before {
  content: "";
  min-width: 6px;
  margin: 3px 0 3px 3px;
  border-radius: 2px 0 0 2px;
  background: #DFB0F4;
}
.quality .form-group:not(.not-required):not(.checkinput) .forminput .form-control,
.quality .form-group:not(.not-required):not(.checkinput) .forminput .react-select .react-select__control {
  padding-left: 6px;
}
.form-group.code-input .formlabel {
  position: relative;
  top: unset;
  left: unset;
  margin-left: 10px;
}
.form-group.checkinput {
  flex-wrap: nowrap;
}
.form-group.checkinput .formlabel {
  font-size: unset;
  line-height: unset;
  font-weight: unset;
  position: unset;
  padding: unset;
  display: unset;
  height: unset;
  min-height: unset;
  background: unset;
  color: unset;
  top: unset;
  left: unset;
  margin: 0;
  margin-left: 10px;
  color: #10294D;
}
.search-fields .form-group.checkinput {
  min-width: 0;
}
.form-group.checkinput .forminput {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}
.form-group.checkinput .forminput .checkcontainer {
  flex: 0 0 auto;
}
.form-group.checkinput .forminput .checkcontainer + label {
  max-width: calc(100vw - 182px);
  white-space: normal;
  flex: 1 1;
  text-align: left;
}
@media screen and (min-width: 799px) {
  .form-group.checkinput .forminput .checkcontainer + label {
    min-width: 220px;
  }
  .search-fields .form-group.checkinput .forminput .checkcontainer + label {
    min-width: 0;
  }
}
.form-group.checkinput .forminput .input-group-addon.btn {
  padding: 6px 15px;
  border-radius: 4px;
}
.form-group.previewinput {
  flex-wrap: wrap;
  flex: 0 0 150px;
  max-width: 150px;
}
@media screen and (min-width: 799px) {
  .form-group.previewinput {
    justify-content: center;
  }
}
.form-group.previewinput .single-user {
  max-width: 150px;
  max-height: 150px;
}
.form-group.previewinput .thumb {
  background: none;
}
.form-group.previewinput .thumb .thumbimg {
  display: flex;
  align-items: center;
  border: 1px dashed #CED7E2;
  justify-content: center;
  background: none;
}
.form-group.previewinput .thumb .thumbimg svg {
  vertical-align: middle;
  width: 68px;
  height: 68px;
  fill: none;
  stroke: #CED7E2;
  stroke-width: 0.6;
}
.form-group.previewinput .thumb .thumbimg[style] {
  border: none;
}
.form-group.previewinput .thumb .thumbimg[style] svg {
  display: none;
}
.form-group.previewinput .thumb:hover {
  box-shadow: none;
}
.form-group.previewinput .thumb:hover .thumbimg {
  transform: scale(1) translateZ(1000px);
}
.form-group.previewinput label {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  stroke: #92A7C0;
  flex: 0 0 100%;
}
.form-group.uom .forminput:after {
  justify-content: center;
  min-width: 36px;
  display: flex;
  align-items: center;
  width: auto;
  padding: 0;
  flex: 0 0 auto;
  padding-right: 13px;
  font-weight: 600;
  color: #10294D;
}
.form-group.uom .forminput:after.btn {
  justify-content: center;
}
.form-group.uom .forminput:after .btn-none:focus {
  outline: none;
}
.form-group.uom .forminput:after:not(.btn-icon-16) svg {
  width: 24px;
  height: 24px;
  stroke-width: 1.4;
}
.form-group.uom.seconds .forminput:after {
  content: "sec";
}
.form-group.uom.metres .forminput:after {
  content: "m";
}
.form-group.uom.squaremetres .forminput:after {
  content: "m\\00B2";
}
.form-group.uom.squarefeet .forminput:after {
  content: "ft\\00B2";
}
.form-group.uom.acres .forminput:after {
  content: "ac";
}
.form-group.uom.hectares .forminput:after {
  content: "ha";
}
.form-group.uom.percentage .forminput:after {
  content: "%";
}
.form-group.uom.per.squaremetres .forminput:after {
  content: "per m\\00B2";
}
.form-group.uom.per.squarefeet .forminput:after {
  content: "per ft\\00B2";
}
.form-group.uom.loadingcapacity .forminput:after {
  content: "tn/m\\00B2";
}
.form-group.uom input.form-control {
  padding-right: 40px;
}
.form-group.recipient-lookup {
  display: flex;
  justify-content: space-between;
}
.form-group.contact-lookup.bulk {
  display: flex;
  justify-content: space-between;
}
.form-group.contact-lookup .recipients {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  line-height: 16px;
  padding: 20px 0px 0px;
}
.form-group.contact-lookup .recipients > div {
  display: flex;
  align-items: center;
}
.form-group.contact-lookup .recipients > div svg {
  fill: none;
  stroke: #233142;
  width: 16px;
  height: 16px !important;
}
.form-group.contact-lookup .form-contact-card {
  border: 1px solid #E5EBF1;
  border-radius: 4px;
  padding: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 2px 0;
}
.form-group.contact-lookup .form-contact-card .contact-card-details {
  flex: 0 0 100%;
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 0 10px;
}
.form-group.contact-lookup .form-contact-card .meta-detail .heavy {
  min-width: 45%;
}
.form-group.contact-lookup .form-contact-card .meta-detail .heavy + div {
  min-width: 45%;
  max-width: calc(100vw - 110px);
  flex: 1 1 45%;
  white-space: nowrap;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
}
.form-group.contact-lookup .form-contact-card .arrayaction {
  display: flex;
  margin-top: 15px;
}
.form-group.contact-lookup .form-contact-card-empty .arrayaction {
  display: flex;
  margin-top: auto;
}
.form-group.contact-lookup .arrayaction {
  flex: 1 1 100%;
  gap: 10px 20px;
  display: flex;
  flex-wrap: wrap;
}
.form-group.on_show .forminput {
  flex-wrap: wrap;
}
.form-group.on_show .onshowhistory {
  flex: 1 1 100%;
}
.form-group.on_show_events {
  gap: 27px 20px;
}
.form-group.on_show_events .arrayaction {
  display: flex;
  flex: 1 1 100%;
  gap: 10px 20px;
  flex-wrap: wrap;
}
.form-group.on_show_events fieldset {
  display: flex;
  flex-direction: column;
  box-shadow: 0px 5px 0px #E5EBF1;
  padding-bottom: 20px;
}
.form-group.size_breakdowns {
  gap: 27px 20px;
}
.form-group.size_breakdowns .arrayaction {
  display: flex;
  flex: 1 1 100%;
  gap: 10px 20px;
  flex-wrap: wrap;
}
.form-group.size_breakdowns fieldset {
  display: flex;
  flex-wrap: wrap;
}
.form-group.size_breakdowns fieldset > .btn {
  flex: 0 0;
  max-height: none;
  min-width: 24px;
  justify-content: center;
}
.form-group.size_breakdowns fieldset > .input-group {
  flex: 1 1;
}
.form-group.size_breakdowns fieldset .section-heading {
  display: flex;
  align-items: center;
}
.form-group.size_breakdowns fieldset .section-heading h4 {
  margin: 0;
}
.form-group.size_breakdowns .breakdown-totals {
  display: flex;
}
.form-group.size_breakdowns .breakdown-totals > .btn {
  flex: 0 0;
  max-height: none;
  min-width: 24px;
  justify-content: center;
}
.form-group.size_breakdowns .breakdown-totals > .input-group {
  flex: 1 1;
  gap: 0px 20px;
}
.form-group.size_breakdowns .breakdown-totals .breakdown-total {
  color: #B2C2D4;
  padding: 6px 15px;
}
.form-group.size_breakdowns .arrayaction > .btn {
  max-height: none;
  min-width: 24px;
  justify-content: center;
}
.form-group.size_breakdowns .arrayaction > .input-group {
  flex: 1 1;
}
@media screen and (min-width: 799px) {
  .form-group.size_breakdowns .arrayaction .arrayaction-button {
    margin-left: -44px;
    margin-right: 44px;
  }
}
.form-group .input-label {
  font-size: 11px;
  line-height: 16.5px;
  font-weight: 600;
  position: absolute;
  padding: 0 5px;
  display: block;
  height: auto;
  min-height: auto;
  background: #ffffff;
  color: #455870;
  top: -8px;
  left: 10px;
  margin: auto;
  white-space: nowrap;
  max-width: calc(100% - 10px);
  overflow: hidden;
  text-overflow: ellipsis;
}
.form-group .error {
  font-size: 11px;
  line-height: 16.5px;
  font-weight: 600;
  position: absolute;
  padding: 0 5px;
  display: block;
  height: auto;
  min-height: auto;
  background: #ffffff;
  top: -8px;
  right: 10px;
  margin: auto;
  color: #FF6464;
}
.form-group.textnotes .error,
.form-group.selectnotes .error {
  right: 80px;
}
.form-group .form-control-info {
  flex: 1 1 100%;
  display: block;
  padding: 4px 15px;
  color: #B2C2D4;
  font-size: 9px;
}
.form-group .forminput {
  flex: 1 1 auto;
}
.form-group .forminput .input-group-addon {
  min-width: 36px;
  display: flex;
  align-items: center;
  width: auto;
  padding: 0;
  flex: 0 0 auto;
}
.form-group .forminput .input-group-addon.btn {
  justify-content: center;
}
.form-group .forminput .input-group-addon .btn-none:focus {
  outline: none;
}
.form-group .forminput .input-group-addon:not(.btn-icon-16) svg {
  width: 24px;
  height: 24px;
  stroke-width: 1.4;
}
.form-group .forminput .input-group-suffix {
  border-right: 0;
  padding-right: 0;
  border-radius: 4px 0 0 4px;
}
.form-group .forminput .input-group-suffix ~ .input-group-addon {
  min-width: 36px;
  border-left: 1px solid transparent;
  border-radius: 0;
  font-weight: 600;
}
.form-group .forminput .input-group-suffix ~ .input-group-addon.btn {
  justify-content: center;
}
.form-group .forminput .input-group-suffix ~ .input-group-addon.btn.btn-grey {
  padding-left: 15px;
  padding-right: 15px;
}
.form-group .forminput .input-group-suffix ~ .input-group-addon svg {
  stroke: #10294D;
}
.form-group .forminput .input-group-prefix {
  border-left: 0;
  padding-left: 0;
  border-radius: 0 4px 4px 0;
}
.form-group .forminput .input-group-prefix:not(.input-group-suffix) {
  order: 1;
}
.form-group .forminput .input-group-prefix + .input-group-addon {
  border-left: 0;
  order: 0;
  font-weight: 600;
  border-radius: 0;
  padding: 0;
}
.form-group .forminput .input-group-prefix + .input-group-addon svg {
  stroke: #10294D;
}
.form-group #country_code {
  min-width: 145px;
}
.form-group.has-copy-link {
  margin-top: 30px;
}
.form-group.has-copy-link .btn {
  order: 0;
  flex: 0 0;
  width: 0;
  overflow: visible;
  position: relative;
  margin-bottom: auto;
  margin-top: -50px;
  left: 0;
  padding: 0;
  text-decoration: underline;
}
.form-group.has-copy-link .btn:hover,
.form-group.has-copy-link .btn:focus,
.form-group.has-copy-link .btn:active {
  box-shadow: none;
}
.form-group.has-copy-link label {
  order: 1;
}
.required .form-group.has-copy-link .btn {
  left: -10px;
}
.form-group.bordered {
  border-top: 4px solid #E5EBF1;
  padding-top: 27px;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% + 30px);
}
.ratio-group .col-lg-2 {
  display: flex;
  align-items: center;
  justify-content: center;
}
.section-heading.bordered {
  border-top: 4px solid #E5EBF1;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(100% + 30px);
}
.section-heading.bordered .section-heading-content {
  padding-top: 27px;
}
.sortabletextinput:not(.checkinput) .arrayaction {
  margin-top: -10px;
  align-self: flex-end;
  margin-left: auto;
}
.sortabletextinput:not(.checkinput) .arrayaction .btn {
  border-top-left-radius: 0;
  border-bottom-right-radius: 0;
}
.sortabletextinput:not(.checkinput) .sortable-text-list {
  flex: 0 0 100%;
}
.sortabletextinput:not(.checkinput) .sortable-text-list .forminput {
  flex-wrap: wrap;
  flex: 0 0 100%;
  gap: 5px 0;
  padding-top: 10px;
}
.sortabletextinput:not(.checkinput) .sortable-text-list .sortable-text {
  width: 100%;
  flex: 1 1 100%;
  margin: 0 5px;
  border: 1px solid #E5EBF1;
  display: flex;
  align-items: center;
}
.sortabletextinput:not(.checkinput) .sortable-text-list .sortable-text[style^="left"],
.sortabletextinput:not(.checkinput) .sortable-text-list .sortable-text[style*="left"] {
  background: #E5EBF1;
  transition: none;
  box-shadow: 0px 2px 4px #C5CFDC;
}
.sortabletextinput:not(.checkinput) .sortable-text-list .sortable-text input {
  width: 100%;
  background: none;
}
.sortabletextinput:not(.checkinput) .sortable-text-list .sortable-text .btn {
  padding: 0;
  min-height: 0;
}
.sortabletextinput:not(.checkinput) .sortable-text-list .sortable-text:last-of-type {
  margin-bottom: 5px;
}
.input-group-addon {
  min-width: 36px;
  display: flex;
  align-items: center;
  width: auto;
  padding: 0;
  flex: 0 0 auto;
}
.input-group-addon.btn {
  justify-content: center;
}
.input-group-addon .btn-none:focus {
  outline: none;
}
.input-group-addon:not(.btn-icon-16) svg {
  width: 24px;
  height: 24px;
  stroke-width: 1.4;
}
.input-group-suffix {
  border-right: 0;
  padding-right: 0;
  border-radius: 4px 0 0 4px;
}
.input-group-suffix ~ .input-group-addon {
  min-width: 36px;
  border-left: 1px solid transparent;
  border-radius: 0;
  font-weight: 600;
}
.input-group-suffix ~ .input-group-addon.btn {
  justify-content: center;
}
.input-group-suffix ~ .input-group-addon.btn.btn-grey {
  padding-left: 15px;
  padding-right: 15px;
}
.input-group-suffix ~ .input-group-addon svg {
  stroke: #10294D;
}
.input-group-prefix {
  border-left: 0;
  padding-left: 0;
  border-radius: 0 4px 4px 0;
}
.input-group-prefix:not(.input-group-suffix) {
  order: 1;
}
.input-group-prefix + .input-group-addon {
  border-left: 0;
  order: 0;
  font-weight: 600;
  border-radius: 0;
  padding: 0;
}
.input-group-prefix + .input-group-addon svg {
  stroke: #10294D;
}
#profile-picture .editgroup,
#signature-picture .editgroup {
  justify-content: center;
}
@media screen and (min-width: 799px) {
  #profile-picture .editgroup .input-group,
  #signature-picture .editgroup .input-group {
    flex: 0 0 auto;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  #profile-picture .editgroup .input-group .field,
  #signature-picture .editgroup .input-group .field {
    max-width: none;
    flex: 1 1 auto;
  }
}
.input-group {
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 100%;
  gap: 27px 20px;
}
.input-group > * {
  flex: 1 1 100%;
}
@media screen and (min-width: 799px) {
  .input-group > * {
    flex: auto;
  }
}
.input-group .col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}
.input-group .col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
}
.input-group .col-1 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(8.33333333%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(8.33333333% - 18.33333333px);
  max-width: 8.33333333%;
}
.input-group .col-2 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(16.66666667%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(16.66666667% - 16.66666667px);
  max-width: 16.66666667%;
}
.input-group .col-3 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(25%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(25% - 15px);
  max-width: 25%;
}
.input-group .col-4 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(33.33333333%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(33.33333333% - 13.33333333px);
  max-width: 33.33333333%;
}
.input-group .col-5 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(41.66666667%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(41.66666667% - 16.66666667px);
  max-width: 41.66666667%;
}
.input-group .col-6 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(50%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(50% - 10px);
  max-width: 50%;
}
.input-group .col-7 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(58.33333333%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(58.33333333% - 11.66666667px);
  max-width: 58.33333333%;
}
.input-group .col-8 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(66.66666667%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(66.66666667% - 13.33333333px);
  max-width: 66.66666667%;
}
.input-group .col-9 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(75%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(75% - 15px);
  max-width: 75%;
}
.input-group .col-10 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(83.33333333%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(83.33333333% - 16.66666667px);
  max-width: 83.33333333%;
}
.input-group .col-11 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(91.66666667%);
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(91.66666667% - 18.33333333px);
  max-width: 91.66666667%;
}
.input-group .col-12 {
  flex-grow: 0;
  flex-shrink: 1;
  flex-basis: calc(100%);
  max-width: 100%;
}
.input-group .order-first {
  order: -1;
}
.input-group .order-last {
  order: 13;
}
.input-group .order-0 {
  order: 0;
}
.input-group .order-1 {
  order: 1;
}
.input-group .order-2 {
  order: 2;
}
.input-group .order-3 {
  order: 3;
}
.input-group .order-4 {
  order: 4;
}
.input-group .order-5 {
  order: 5;
}
.input-group .order-6 {
  order: 6;
}
.input-group .order-7 {
  order: 7;
}
.input-group .order-8 {
  order: 8;
}
.input-group .order-9 {
  order: 9;
}
.input-group .order-10 {
  order: 10;
}
.input-group .order-11 {
  order: 11;
}
.input-group .order-12 {
  order: 12;
}
.input-group .offset-1 {
  margin-left: 8.33333333%;
}
.input-group .offset-2 {
  margin-left: 16.66666667%;
}
.input-group .offset-3 {
  margin-left: 25%;
}
.input-group .offset-4 {
  margin-left: 33.33333333%;
}
.input-group .offset-5 {
  margin-left: 41.66666667%;
}
.input-group .offset-6 {
  margin-left: 50%;
}
.input-group .offset-7 {
  margin-left: 58.33333333%;
}
.input-group .offset-8 {
  margin-left: 66.66666667%;
}
.input-group .offset-9 {
  margin-left: 75%;
}
.input-group .offset-10 {
  margin-left: 83.33333333%;
}
.input-group .offset-11 {
  margin-left: 91.66666667%;
}
@media (min-width: 576px) {
  .input-group .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .input-group .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .input-group .col-sm-1 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333% - 18.33333333px);
    max-width: 8.33333333%;
  }
  .input-group .col-sm-2 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667% - 16.66666667px);
    max-width: 16.66666667%;
  }
  .input-group .col-sm-3 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25% - 15px);
    max-width: 25%;
  }
  .input-group .col-sm-4 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333% - 13.33333333px);
    max-width: 33.33333333%;
  }
  .input-group .col-sm-5 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667% - 16.66666667px);
    max-width: 41.66666667%;
  }
  .input-group .col-sm-6 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    max-width: 50%;
  }
  .input-group .col-sm-7 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333% - 11.66666667px);
    max-width: 58.33333333%;
  }
  .input-group .col-sm-8 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667% - 13.33333333px);
    max-width: 66.66666667%;
  }
  .input-group .col-sm-9 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75% - 15px);
    max-width: 75%;
  }
  .input-group .col-sm-10 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333% - 16.66666667px);
    max-width: 83.33333333%;
  }
  .input-group .col-sm-11 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667% - 18.33333333px);
    max-width: 91.66666667%;
  }
  .input-group .col-sm-12 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(100%);
    max-width: 100%;
  }
  .input-group .order-sm-first {
    order: -1;
  }
  .input-group .order-sm-last {
    order: 13;
  }
  .input-group .order-sm-0 {
    order: 0;
  }
  .input-group .order-sm-1 {
    order: 1;
  }
  .input-group .order-sm-2 {
    order: 2;
  }
  .input-group .order-sm-3 {
    order: 3;
  }
  .input-group .order-sm-4 {
    order: 4;
  }
  .input-group .order-sm-5 {
    order: 5;
  }
  .input-group .order-sm-6 {
    order: 6;
  }
  .input-group .order-sm-7 {
    order: 7;
  }
  .input-group .order-sm-8 {
    order: 8;
  }
  .input-group .order-sm-9 {
    order: 9;
  }
  .input-group .order-sm-10 {
    order: 10;
  }
  .input-group .order-sm-11 {
    order: 11;
  }
  .input-group .order-sm-12 {
    order: 12;
  }
  .input-group .offset-sm-0 {
    margin-left: 0;
  }
  .input-group .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .input-group .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .input-group .offset-sm-3 {
    margin-left: 25%;
  }
  .input-group .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .input-group .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .input-group .offset-sm-6 {
    margin-left: 50%;
  }
  .input-group .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .input-group .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .input-group .offset-sm-9 {
    margin-left: 75%;
  }
  .input-group .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .input-group .offset-sm-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 768px) {
  .input-group .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .input-group .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .input-group .col-md-1 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333% - 18.33333333px);
    max-width: 8.33333333%;
  }
  .input-group .col-md-2 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667% - 16.66666667px);
    max-width: 16.66666667%;
  }
  .input-group .col-md-3 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25% - 15px);
    max-width: 25%;
  }
  .input-group .col-md-4 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333% - 13.33333333px);
    max-width: 33.33333333%;
  }
  .input-group .col-md-5 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667% - 16.66666667px);
    max-width: 41.66666667%;
  }
  .input-group .col-md-6 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    max-width: 50%;
  }
  .input-group .col-md-7 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333% - 11.66666667px);
    max-width: 58.33333333%;
  }
  .input-group .col-md-8 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667% - 13.33333333px);
    max-width: 66.66666667%;
  }
  .input-group .col-md-9 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75% - 15px);
    max-width: 75%;
  }
  .input-group .col-md-10 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333% - 16.66666667px);
    max-width: 83.33333333%;
  }
  .input-group .col-md-11 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667% - 18.33333333px);
    max-width: 91.66666667%;
  }
  .input-group .col-md-12 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(100%);
    max-width: 100%;
  }
  .input-group .order-md-first {
    order: -1;
  }
  .input-group .order-md-last {
    order: 13;
  }
  .input-group .order-md-0 {
    order: 0;
  }
  .input-group .order-md-1 {
    order: 1;
  }
  .input-group .order-md-2 {
    order: 2;
  }
  .input-group .order-md-3 {
    order: 3;
  }
  .input-group .order-md-4 {
    order: 4;
  }
  .input-group .order-md-5 {
    order: 5;
  }
  .input-group .order-md-6 {
    order: 6;
  }
  .input-group .order-md-7 {
    order: 7;
  }
  .input-group .order-md-8 {
    order: 8;
  }
  .input-group .order-md-9 {
    order: 9;
  }
  .input-group .order-md-10 {
    order: 10;
  }
  .input-group .order-md-11 {
    order: 11;
  }
  .input-group .order-md-12 {
    order: 12;
  }
  .input-group .offset-md-0 {
    margin-left: 0;
  }
  .input-group .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .input-group .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .input-group .offset-md-3 {
    margin-left: 25%;
  }
  .input-group .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .input-group .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .input-group .offset-md-6 {
    margin-left: 50%;
  }
  .input-group .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .input-group .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .input-group .offset-md-9 {
    margin-left: 75%;
  }
  .input-group .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .input-group .offset-md-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 992px) {
  .input-group .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .input-group .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .input-group .col-lg-1 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333% - 18.33333333px);
    max-width: 8.33333333%;
  }
  .input-group .col-lg-2 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667% - 16.66666667px);
    max-width: 16.66666667%;
  }
  .input-group .col-lg-3 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25% - 15px);
    max-width: 25%;
  }
  .input-group .col-lg-4 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333% - 13.33333333px);
    max-width: 33.33333333%;
  }
  .input-group .col-lg-5 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667% - 16.66666667px);
    max-width: 41.66666667%;
  }
  .input-group .col-lg-6 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    max-width: 50%;
  }
  .input-group .col-lg-7 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333% - 11.66666667px);
    max-width: 58.33333333%;
  }
  .input-group .col-lg-8 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667% - 13.33333333px);
    max-width: 66.66666667%;
  }
  .input-group .col-lg-9 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75% - 15px);
    max-width: 75%;
  }
  .input-group .col-lg-10 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333% - 16.66666667px);
    max-width: 83.33333333%;
  }
  .input-group .col-lg-11 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667% - 18.33333333px);
    max-width: 91.66666667%;
  }
  .input-group .col-lg-12 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(100%);
    max-width: 100%;
  }
  .input-group .order-lg-first {
    order: -1;
  }
  .input-group .order-lg-last {
    order: 13;
  }
  .input-group .order-lg-0 {
    order: 0;
  }
  .input-group .order-lg-1 {
    order: 1;
  }
  .input-group .order-lg-2 {
    order: 2;
  }
  .input-group .order-lg-3 {
    order: 3;
  }
  .input-group .order-lg-4 {
    order: 4;
  }
  .input-group .order-lg-5 {
    order: 5;
  }
  .input-group .order-lg-6 {
    order: 6;
  }
  .input-group .order-lg-7 {
    order: 7;
  }
  .input-group .order-lg-8 {
    order: 8;
  }
  .input-group .order-lg-9 {
    order: 9;
  }
  .input-group .order-lg-10 {
    order: 10;
  }
  .input-group .order-lg-11 {
    order: 11;
  }
  .input-group .order-lg-12 {
    order: 12;
  }
  .input-group .offset-lg-0 {
    margin-left: 0;
  }
  .input-group .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .input-group .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .input-group .offset-lg-3 {
    margin-left: 25%;
  }
  .input-group .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .input-group .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .input-group .offset-lg-6 {
    margin-left: 50%;
  }
  .input-group .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .input-group .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .input-group .offset-lg-9 {
    margin-left: 75%;
  }
  .input-group .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .input-group .offset-lg-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 1200px) {
  .input-group .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .input-group .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: none;
  }
  .input-group .col-xl-1 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(8.33333333% - 18.33333333px);
    max-width: 8.33333333%;
  }
  .input-group .col-xl-2 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(16.66666667% - 16.66666667px);
    max-width: 16.66666667%;
  }
  .input-group .col-xl-3 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(25% - 15px);
    max-width: 25%;
  }
  .input-group .col-xl-4 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(33.33333333% - 13.33333333px);
    max-width: 33.33333333%;
  }
  .input-group .col-xl-5 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(41.66666667% - 16.66666667px);
    max-width: 41.66666667%;
  }
  .input-group .col-xl-6 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(50% - 10px);
    max-width: 50%;
  }
  .input-group .col-xl-7 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(58.33333333% - 11.66666667px);
    max-width: 58.33333333%;
  }
  .input-group .col-xl-8 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(66.66666667% - 13.33333333px);
    max-width: 66.66666667%;
  }
  .input-group .col-xl-9 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(75% - 15px);
    max-width: 75%;
  }
  .input-group .col-xl-10 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(83.33333333% - 16.66666667px);
    max-width: 83.33333333%;
  }
  .input-group .col-xl-11 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667%);
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(91.66666667% - 18.33333333px);
    max-width: 91.66666667%;
  }
  .input-group .col-xl-12 {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: calc(100%);
    max-width: 100%;
  }
  .input-group .order-xl-first {
    order: -1;
  }
  .input-group .order-xl-last {
    order: 13;
  }
  .input-group .order-xl-0 {
    order: 0;
  }
  .input-group .order-xl-1 {
    order: 1;
  }
  .input-group .order-xl-2 {
    order: 2;
  }
  .input-group .order-xl-3 {
    order: 3;
  }
  .input-group .order-xl-4 {
    order: 4;
  }
  .input-group .order-xl-5 {
    order: 5;
  }
  .input-group .order-xl-6 {
    order: 6;
  }
  .input-group .order-xl-7 {
    order: 7;
  }
  .input-group .order-xl-8 {
    order: 8;
  }
  .input-group .order-xl-9 {
    order: 9;
  }
  .input-group .order-xl-10 {
    order: 10;
  }
  .input-group .order-xl-11 {
    order: 11;
  }
  .input-group .order-xl-12 {
    order: 12;
  }
  .input-group .offset-xl-0 {
    margin-left: 0;
  }
  .input-group .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .input-group .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .input-group .offset-xl-3 {
    margin-left: 25%;
  }
  .input-group .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .input-group .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .input-group .offset-xl-6 {
    margin-left: 50%;
  }
  .input-group .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .input-group .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .input-group .offset-xl-9 {
    margin-left: 75%;
  }
  .input-group .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .input-group .offset-xl-11 {
    margin-left: 91.66666667%;
  }
}
.input-group [class^="col-"],
.input-group [class*="col-"] {
  padding: 0;
}
.input-group .field:not([class^="col-"]):not([class*="col-"]):not(td) {
  display: inherit;
  flex-wrap: wrap;
  flex: 1 1 auto;
  gap: 16px 20px;
}
.input-group .field:not([class^="col-"]):not([class*="col-"]):not(td) .tip:not(:first-of-type) {
  flex: 0 0 100%;
  margin-top: 10px;
  margin-bottom: 0;
}
.input-group td.field {
  padding: 0;
}
.input-group td.field .form-control {
  min-height: 30px;
  padding: 6px 8px;
  font-size: 12px;
  line-height: 1.125;
}
.input-group td.field .form-group .forminput .input-group-addon {
  min-width: 30px;
  min-height: 30px;
}
.input-group .field .tip:not(:first-of-type) {
  margin-top: 10px;
}
.input-group .field .tip:not(:first-of-type) + .tip {
  margin-bottom: 0;
}
.input-group .field .tip:first-of-type {
  margin-bottom: 10px;
}
.input-group .field.disabled .forminput {
  color: #5A6F89;
  opacity: 1;
}
.input-group .field .clevercompose-field {
  margin-top: 10px;
}
.input-group .submit-button {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 10px;
}
.input-group.keyword-search {
  gap: 0 10px;
}
@media screen and (min-width: 799px) {
  .input-group.keyword-search {
    flex: 1 1 auto;
  }
  .input-group.keyword-search > div {
    flex: 0 0 auto;
  }
  .input-group.keyword-search .form-group.term {
    flex: 0 0 300px;
    width: 205px;
    max-width: 205px;
  }
}
@media screen and (min-width: 799px) {
  .input-group.advanced-search {
    flex: 0 1 auto;
  }
}
/* Create a custom radio */
.radiocontainer {
  display: flex;
  position: relative;
  margin: 0;
  gap: 8px 8px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  min-height: 25px;
  line-height: 25px;
  font-size: 14px;
}
.radiocontainer input {
  position: absolute;
  z-index: 10;
  opacity: 0;
  cursor: pointer;
  left: 0;
  height: 24px;
  width: 24px;
}
.radiocontainer .radio {
  flex: 0 0 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  background-color: #fff;
  box-shadow: inset 0 0 0 1px #E5EBF1;
  border-radius: 50%;
  order: -1;
}
.radiocontainer .radio:after {
  content: "";
  display: none;
}
.radiocontainer:hover input ~ .radio {
  box-shadow: inset 0 0 0 1px #CED7E2;
}
.radiocontainer input:checked ~ .radio:after {
  display: block;
  background-color: #10294D;
}
.radiocontainer .radio:after {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: white;
}
.onshowhistory {
  flex-basis: 100%;
}
.onshowhistory table.on_show_history {
  margin-top: 10px;
  min-width: 280px;
}
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: flex;
  min-width: 60px;
}
.switch input {
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
}
/* The slider */
.slider {
  cursor: pointer;
  display: flex;
  width: 60px;
  height: 34px;
  background-color: #CED7E2;
  padding: 4px;
  align-items: center;
}
.slider .onoff {
  height: 26px;
  width: 26px;
  background-color: white;
  border-radius: 50%;
}
.slider.round {
  border-radius: 34px;
}
input:checked + .slider {
  background-color: #10294D;
}
input:checked + .slider span.onoff {
  left: 14px;
}
input:focus + .slider {
  box-shadow: 0px 0px 0px 3px #E4E7EB;
}
input:checked + .slider .onoff {
  transform: translateX(26px);
}
input:disabled + .slider {
  background-color: #E5EBF1;
  cursor: not-allowed;
}
input:disabled + .slider .onoff {
  transform: translateX(14px);
}
.checkgroup {
  font-size: 1.1rem;
  display: flex;
  align-items: center;
}
.checkgroup label:nth-of-type(2) {
  margin-left: 10px;
}
.checkcontainer {
  display: flex;
  flex-direction: column;
  position: relative;
  max-width: 100%;
  min-height: 36px;
  width: 36px;
  height: 36px;
  align-items: center;
  cursor: pointer;
  margin: 0;
  -webkit-user-select: none;
  user-select: none;
  justify-content: center;
  /* Hide the browser's default checkbox */
  /* On mouse-over, add a grey background color */
  /* Show the checkmark when checked */
  /* Style the checkmark/indicator */
}
.checkcontainer.input-group-suffix {
  flex: 1 1 auto;
}
.checkcontainer input {
  position: absolute;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.checkcontainer.readonly span {
  pointer-events: none;
  cursor: not-allowed;
  background-color: #E5EBF1;
}
.checkcontainer:focus .checkmark,
.checkcontainer:focus-within .checkmark {
  box-shadow: 0px 0px 0px 3px #E4E7EB;
}
.checkcontainer input:disabled ~ .checkmark,
.checkcontainer input:checked:disabled ~ .checkmark {
  background-color: #E5EBF1;
}
.checkcontainer:hover input:disabled ~ .checkmark {
  cursor: not-allowed;
}
.checkcontainer input:checked ~ .checkmark {
  background: #10294D;
  border-color: transparent;
}
.checkcontainer .checkmark svg {
  stroke: #ffffff;
  fill: none;
  width: 22px;
  height: 22px;
  stroke-width: 2.4;
}
.checkmark {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  height: 24px;
  width: 24px;
  border-radius: 4px;
  border: 1px solid #E5EBF1;
  background: #ffffff;
}
.checkmark:hover {
  border: 1px solid #CED7E2;
}
/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.selected .checkcontainer .checkmark {
  border: 1px solid #fff;
}
.selected .checkcontainer .checkmark:after {
  content: "";
  border: solid #fff;
  border-width: 0 2px 2px 0;
  margin-top: -7px;
  height: 11px;
}
.asynccheckgroup-filter-buttons {
  margin-bottom: 15px;
}
.dz-thumb-caption.linked_plan .react-select__single-value {
  color: #cccccc;
}
.react-select {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  font-size: 14px;
}
.react-select__control {
  align-items: center;
  background-color: transparent;
  border-radius: 3px;
  border-style: solid;
  box-shadow: none;
  cursor: default;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  min-height: 34px;
  outline: 0 !important;
  position: relative;
  box-sizing: border-box;
  border: none;
  padding-left: 14px;
}
.react-select__control--is-focused {
  border-color: #E5EBF1;
}
.react-select__control--is-focused + .react-select__menu {
  border-color: #E5EBF1;
}
.react-select .react-select__dropdown-indicator {
  border: 0 !important;
}
.react-select .react-select__dropdown-indicator svg {
  fill: none;
  stroke: #10294D;
  stroke-width: 1.4;
  width: 24px;
  height: 24px;
}
.react-select.top .react-select__control--menu-is-open {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  border-top: 0 none;
}
.react-select.top .react-select__control--menu-is-open .react-select__dropdown-indicator {
  border-right: 1px solid #58ACE4;
}
.react-select__value-container {
  align-items: center;
  display: inline-grid;
  flex: 1 1;
  padding: 0;
  gap: 2px 4px;
  font-size: inherit;
  line-height: 1;
  -webkit-overflow-scrolling: touch;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  border: none;
}
.react-select__value-container [class^="-Input"],
.react-select__value-container [class*="-Input"] {
  margin: 0;
  padding: 0;
}
.react-select__value-container--has-value {
  display: flex;
}
.react-select__value-container--is-multi {
  padding: 6px 0 2px 0;
  flex-wrap: wrap;
  padding: 6px 0;
}
.inline-select .react-select .react-select__value-container {
  gap: 0 0;
}
.react-select [class^="-A11yText"],
.react-select [class*="-A11yText"] {
  z-index: 9999;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  width: 1px;
  position: absolute;
  overflow: hidden;
  padding: 0;
  white-space: nowrap;
}
.react-select__menu {
  top: 100%;
  left: 50%;
  transform: translateX(-50%) translateZ(10px);
  min-width: 200px;
  background-color: hsl(0, 0%, 100%);
  border-radius: 4px;
  box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);
  margin-bottom: 8px;
  margin-top: 8px;
  position: absolute;
  width: 100%;
  z-index: 1;
  box-sizing: border-box;
}
.asynccheckgroup .react-select__menu {
  top: 0;
  position: relative;
  border: 0;
  box-shadow: none;
  margin: 0;
  margin-top: 10px;
  padding-top: 0;
  background: none;
  z-index: 0;
}
.react-select__single-value {
  color: #5A6F89;
  font-size: 14px;
  line-height: 21px;
  top: unset;
  margin: 0 1px;
  transform: none;
  align-self: center;
  position: relative;
  grid-area: 1 / 1 / 2 / 3;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.react-select__single-value--is-disabled {
  color: #B2C2D4;
}
.react-select__multi-value {
  background: #E5EBF1;
  border: 1px solid #E5EBF1;
  display: flex;
  margin: 0;
  border-radius: 2px;
  padding: 2px 3px 2px 6px;
}
.react-select__multi-value__label {
  color: #455870;
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: 500;
}
.dependentselectinput .react-select__multi-value__label {
  padding: 2px 6px;
}
.react-select__multi-value__remove {
  cursor: pointer;
  padding: 0;
  display: flex;
  flex: 0 0 1%;
  align-items: center;
  background: none;
}
.react-select__multi-value__remove svg {
  width: 16px;
  fill: none;
  stroke: #92A7C0;
  stroke-width: 2.4;
}
.react-select__multi-value__remove:hover {
  background: none;
}
.react-select__multi-value__remove:hover svg {
  fill: none;
  stroke: #455870;
}
.react-select__placeholder {
  color: #B2C2D4;
  opacity: 1;
  margin-left: 2px;
  margin-right: 2px;
  box-sizing: border-box;
  grid-area: 1 / 1 / 2 / 2;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.react-select__placeholder + div {
  margin: 0;
  padding-bottom: 0;
  padding-top: 0;
  visibility: visible;
  box-sizing: border-box;
}
.react-select__indicators {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 0;
  transition: color 150ms ease 0s;
}
.react-select__indicator {
  display: flex;
  cursor: pointer;
  padding: 0 7px;
  transition: color 150ms;
  box-sizing: border-box;
}
.react-select__indicator.react-select__clear-indicator {
  padding: 0;
}
.react-select__indicator.react-select__clear-indicator svg {
  width: 16px;
  fill: none;
  stroke: #10294D;
  stroke-width: 2.4;
}
.react-select__input-container {
  visibility: visible;
  flex: 1 1 auto;
  display: inline-grid;
  grid-area: 1 / 1 / 2 / 3;
  grid-template-columns: 0px min-content;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.react-select__input-container:after {
  content: attr(data-value) " ";
  visibility: hidden;
  white-space: pre;
  grid-area: 1/2;
  font: inherit;
  min-width: 2px;
  border: 0;
  margin: 0;
  outline: 0;
  padding: 0;
}
.react-select__input {
  color: inherit;
  background: 0px center;
  opacity: 1;
  width: 100%;
  grid-area: 1 / 2;
  font: inherit;
  min-width: 2px;
  border: 0px none;
  margin: 0px;
  outline: 0px;
  padding: 0px;
}
.react-select__menu {
  border-radius: 4px;
  box-shadow: 1px 1px 4px -2px rgba(0, 0, 0, 0.2);
  border: 1px solid #E5EBF1;
  overflow: hidden;
}
.react-select.top .react-select__menu {
  border-top: 1px solid #58ACE4;
  top: auto;
  bottom: 100%;
  box-shadow: 0px -3px 5px -1px rgba(0, 0, 0, 0.2);
  margin-top: 0;
  border-top: 0 none;
  z-index: 950;
}
.react-select__menu-list {
  max-height: 300px;
  overflow-y: auto;
  padding-bottom: 4px;
  padding-top: 4px;
  position: relative;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
}
.react-select__option {
  background-color: none;
  color: #455870;
  cursor: default;
  display: block;
  font-size: inherit;
  padding: 7.5px 15px;
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
}
.react-select__option--is-focused,
.react-select__option:hover {
  background-color: #F3F5F8;
}
.asynccheckgroup .react-select__option--is-focused,
.asynccheckgroup .react-select__option:hover {
  background-color: inherit;
}
.react-select__option--is-selected {
  background-color: #E5EBF1;
  color: #455870;
}
.asynccheckgroup .react-select__option--is-selected {
  background: none;
  color: #455870;
}
.react-select__option--is-disabled {
  background-color: #F3F5F8;
  color: #B2C2D4;
}
.asynccheckgroup .react-select__option--is-disabled {
  background: none;
  color: #455870;
}
.react-select__option .customopt {
  display: flex;
  flex-wrap: wrap;
}
.react-select__option .customopt img {
  flex: 0 0 50px;
  height: 50px;
  width: 50px;
  display: inline-block;
  border-radius: 100px;
  margin-right: 10px;
  border: none;
  background-color: #efefef;
}
.react-select__option .customopt > div {
  flex: 1 1 auto;
  vertical-align: middle;
  line-height: 21px;
}
.react-select__option .customopt > div.select-tags {
  flex: 0 0 auto;
}
.react-select__option .customopt > div.select-tags .select-tag {
  background: #FC495D;
  color: #ffffff;
  font-size: 11px;
  padding: 4px 6px;
  border-radius: 2px;
  text-transform: uppercase;
}
.react-select__option .customopt > div.select-tags .select-tag.Active {
  background: #73C677;
}
.react-select__option .customopt > div.select-tags .select-tag.Inactive {
  background: #FF6464;
}
.react-select__option .customopt span.sub {
  display: block;
  font-size: 11px;
  line-height: 16.5px;
  color: #92A7C0;
}
.asynccheckgroup .react-select__option .customopt {
  box-shadow: 0px 1px 0px #E5EBF1;
  padding-top: 8px;
  padding-bottom: 8px;
}
.asynccheckgroup .react-select__option .customopt:last-of-type {
  box-shadow: none;
}
.asynccheckgroup .react-select__option .customopt .checkcontainer {
  min-height: 24px;
}
.asynccheckgroup .react-select__option .customopt .domstring {
  margin-left: 15px;
}
.react-select__menu-notice--no-options {
  background-color: none;
  color: #455870;
  cursor: default;
  display: block;
  font-size: inherit;
  padding: 7.5px 15px;
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
}
.react-select__menu-notice--loading {
  background-color: none;
  color: #455870;
  cursor: default;
  display: block;
  font-size: inherit;
  padding: 7.5px 15px;
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
}
.react-select__group-heading {
  background-color: #F3F5F8;
  color: #92A7C0;
  text-align: center;
  margin: 1px 15px;
  cursor: default;
  display: block;
  font-size: 11px;
  padding: 3px 6px;
  font-weight: 600;
  -webkit-user-select: none;
          user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
  text-transform: none;
}
.react-select__group-heading .customopt {
  padding-left: 12px;
}
.react-select__group-heading .customopt img {
  height: 50px;
  width: 50px;
  display: inline-block;
  border-radius: 100px;
  margin-right: 10px;
  border: none;
  background-color: #efefef;
}
.react-select__group-heading .customopt > div {
  display: inline-block;
  vertical-align: middle;
}
.react-select__group-heading .customopt span.sub {
  display: block;
  font-size: 1rem;
  color: #aaa;
}
.react-select__indicator-separator {
  display: none;
}
.dz-handle {
  display: inline-block;
  width: 10px;
  height: 5px;
  vertical-align: middle;
  margin-right: 10px;
  border-top: 1px solid #979797;
  cursor: row-resize;
  border-bottom: 1px solid #979797;
}
.mg-collative-img-size {
  flex: 1 1 100%;
  width: 100%;
  font-weight: 400;
  font-style: normal;
  display: flex;
  align-items: center;
}
.dz-buttons-above {
  display: flex;
  padding: 0;
  left: 600px;
  gap: 10px 0px;
}
.dz-container-above {
  margin-top: 15px;
  display: flex;
  flex: 1 1 100%;
  align-items: center;
  align-content: center;
  justify-content: space-between;
}
.dz-container-above button {
  margin-right: 3px;
}
.dz-actions label.checkcontainer span.checkmark {
  width: 34px;
  height: 35px;
}
.dz-actions label.checkcontainer span.checkmark svg {
  width: 31px;
  height: 31px;
}
.dropzoneinput {
  display: flex;
  margin-bottom: 5px;
}
.dropzoneinput .filehead {
  width: 0;
  height: 1.1rem;
  background-color: #FC495D;
  border-radius: 4px;
  font-size: 1.1rem;
  padding: 0;
  margin-top: 10px;
  margin-bottom: 10px;
  z-index: 3;
  white-space: nowrap;
  transition: background-color 2.5s ease, width 0.5s ease;
}
.dropzoneinput .dropzone {
  display: flex;
  flex: 1 1 100%;
}
.dropzoneinput .dropzone.mini-dropzone {
  order: 2;
  position: relative;
}
.dropzoneinput .dropzone.mini-dropzone .btn {
  padding: 6px 15px;
}
.dropzoneinput .dropzone.mini-dropzone .btn input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.dropzoneinput .dropzone.mini-dropzone .btn svg {
  height: 24px;
}
.dropzoneinput .dropzone.mini-dropzone .dz-dropper {
  min-height: 0;
  height: auto;
  width: auto;
  border: none;
  justify-content: flex-start;
}
.dropzoneinput .dropzone.mini-dropzone .dz-dropper.dz-dropper--isActive {
  flex: 1 1 100%;
}
.dropzoneinput .dropzone .dz-dropper {
  width: 100%;
  border: 1px dashed #E5EBF1;
  min-height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dropzoneinput .dropzone .dz-message {
  text-align: center;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px 0;
}
.dropzoneinput .dropzone .dz-message > p {
  flex: 0 0 100%;
}
.dropzoneinput .dropzone .dz-message svg {
  height: 36px;
}
.dropzoneinput .dropzone .dz-message .dz-icons {
  flex: 0 0 100%;
}
.dropzoneinput .dropzone .btn {
  padding: 8px 12px;
}
.dropzoneinput .dropzone p {
  color: #92A7C0;
  font-size: 1.1rem;
  font-weight: normal;
  text-align: center;
  margin: 0;
  display: none;
}
@media screen and (min-width: 799px) {
  .dropzoneinput .dropzone p {
    display: block;
  }
}
.dropzoneinput .dz-list {
  display: flex;
  flex-wrap: wrap;
  min-width: calc(100% + 30px);
  justify-content: flex-start;
  align-items: flex-start;
  justify-content: space-around;
  margin-left: -15px;
  margin-right: -15px;
}
.dropzoneinput .dz-list * {
  touch-action: none;
}
.dropzoneinput .dz-list.mini-items {
  display: flex;
  gap: 10px;
  order: 1;
  margin-left: 0;
  margin-right: 0;
  min-width: 0;
}
.dropzoneinput .dz-list.mini-items .formlabel {
  flex: 0 0 100%;
}
.dropzoneinput .dz-list.mini-items .dz-item {
  height: 72px;
  min-width: 72px;
  flex: 0 0 auto;
  margin: 0 0 45px;
}
.dropzoneinput .dz-list.mini-items .dz-item .dz-actions {
  display: flex;
  flex: 0 0 72px;
  max-height: 30px;
  justify-content: center;
}
.dropzoneinput .dz-list.mini-items .dz-item button.btn.btn-none {
  margin: 0 3px;
}
.dropzoneinput .dz-list.mini-items .dz-item button.btn.btn-none svg {
  fill: #333333;
}
.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb {
  height: 72px;
  max-height: 72px;
}
.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb:hover {
  cursor: default;
}
.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb:hover[style] {
  cursor: move;
}
.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb .dz-thumb-img {
  height: 72px;
}
.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb .dz-thumb-img img {
  height: auto;
  max-height: 100%;
  max-width: 100%;
}
.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb .dz-thumb-img.icon {
  width: 100%;
  border: 1px solid #cfcdcd;
  border-radius: 3px;
  background: #ffffff;
}
.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb .dz-thumb-img.icon svg {
  width: 54px;
  height: 54px;
}
.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb-caption {
  position: relative;
  align-self: flex-end;
  padding: 4px 6px;
  font-size: 0.8rem;
  white-space: nowrap;
}
.dropzoneinput.dropzone-single .dz-list {
  justify-content: center;
}
.dropzoneinput .table-wrapper {
  width: 100%;
  max-width: calc(100vw - 80px);
  overflow: auto;
}
.dropzoneinput .dz-file-list {
  width: 100%;
  margin-top: 15px;
  margin-bottom: 15px;
}
.dropzoneinput .dz-file-list thead th {
  color: #333333;
  white-space: nowrap;
  padding: 10px;
}
.dropzoneinput .dz-file-item {
  flex: 0 1 100%;
  min-height: 44px;
  align-items: center;
  border-top: 1px solid #d6d6d6;
}
.dropzoneinput tr.dz-file-item {
  box-shadow: 0px 1px 0px #E5EBF1;
}
.dropzoneinput .dz-file-handle {
  padding: 10px 0;
  vertical-align: middle;
  table-layout: fixed;
}
.dropzoneinput .dz-file-handle .dz-handle {
  margin-top: -5px;
}
.dropzoneinput .dz-edit-file-name {
  display: none;
  min-height: 0;
  padding: 0;
}
.dropzoneinput:hover .dz-edit-file-name {
  display: inline-block;
}
.dropzoneinput:hover .dz-edit-file-name svg {
  stroke-width: 2.4;
  stroke: #92A7C0;
}
.dropzoneinput .dz-file-name {
  padding: 10px 12px;
  width: 100%;
  vertical-align: middle;
}
.dropzoneinput .dz-file-name > div {
  display: flex;
  align-items: center;
}
.dropzoneinput .dz-file-name > div .btn {
  margin-left: 10px;
}
.dropzoneinput .dz-file-size {
  padding: 0 10px;
  white-space: nowrap;
}
.dropzoneinput .dz-file-type {
  flex: 0 0 30px;
  padding: 0 10px;
  text-align: center;
}
.dropzoneinput .dz-file-type svg {
  height: 24px;
}
.dropzoneinput td.dz-file-actions,
.dropzoneinput th.dz-file-actions {
  white-space: nowrap;
}
.dropzoneinput td.dz-file-actions .btn-none,
.dropzoneinput th.dz-file-actions .btn-none {
  border: 0;
  display: inline-flex;
  padding: 7.5px;
}
.dropzoneinput .dz-item {
  display: flex;
  flex-direction: column;
  flex: 0 0 100%;
  max-width: calc(100vw - 82px);
  margin: 15px;
}
@media screen and (min-width: 799px) {
  .dropzoneinput .dz-item {
    flex: 0 0 320px;
    max-width: 320px;
  }
}
.dropzoneinput .dz-item .loader.inline {
  justify-self: center;
  align-self: center;
  z-index: auto;
  border-width: 3px;
  width: 30px;
  height: 30px;
}
.dropzoneinput .dz-item .dz-thumb-caption {
  position: absolute;
  justify-content: center;
  align-content: center;
  background: rgba(0, 0, 0, 0.7);
  color: #ffffff;
  padding: 8px 12px;
  display: flex;
  bottom: 0;
  left: 0;
  right: 0;
}
.dropzoneinput .dz-item .dz-thumb-img-size {
  position: absolute;
  justify-content: center;
  align-content: center;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.7);
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  padding: 8px 12px;
  display: flex;
  border-radius: 18px;
  right: 0;
  margin: 7px;
}
.dropzoneinput .dz-item .dz-thumb {
  flex: 1 1 100%;
  height: 240px;
  max-height: 240px;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  box-shadow: inset 0 0 480px -240px #92A7C0;
}
.dropzoneinput .dz-item .dz-thumb *::selection {
  background: transparent;
}
.dropzoneinput .dz-item .dz-thumb:hover {
  cursor: move;
}
.dropzoneinput .dz-item .dz-thumb.updating .dz-thumb-img img {
  display: none;
}
.dropzoneinput .dz-item .dz-thumb .dz-thumb-img {
  height: 240px;
  flex: 1 1 100%;
  padding: 0;
  position: relative;
  border-radius: 0;
  margin: 0;
  overflow: hidden;
  border: 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.dropzoneinput .dz-item .dz-thumb .dz-thumb-img img {
  height: 240px;
  width: 320px;
  object-fit: cover;
  flex: 1 1 100%;
}
.dropzoneinput .dz-item .dz-thumb .dz-thumb-img:after {
  position: absolute;
  content: "";
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.dropzoneinput .dz-item .dz-actions {
  padding-top: 5px;
  flex: 0 0 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 5px 5px;
}
@media screen and (min-width: 799px) {
  .dropzoneinput .dz-item .dz-actions {
    flex-wrap: nowrap;
  }
}
.dropzoneinput .dz-item .dz-actions .rotate,
.dropzoneinput .dz-item .dz-actions .delete {
  padding-left: 0;
  padding-right: 0;
  min-width: 36px;
  width: 36px;
  height: 36px;
  justify-content: center;
}
.dropzoneinput .dz-item .dz-actions .rotate svg,
.dropzoneinput .dz-item .dz-actions .delete svg {
  width: 16px;
  height: 16px;
  stroke: #10294D;
  stroke-width: 2.4;
}
.dropzoneinput .dz-item .dz-actions .btn:not(.rotate):not(.delete) {
  padding: 7.5px 15px;
}
.dropzoneinput .dz-item .dz-actions .dz-thumb-caption {
  position: relative;
  flex-wrap: wrap;
  flex: 0 0 100%;
  background: none;
  padding: 0;
  margin-top: -41px;
  gap: 5px 5px;
}
.dropzoneinput .dz-item .dz-actions .dz-thumb-caption > div {
  flex: 0 0 100%;
  background: rgba(0, 0, 0, 0.7);
  box-shadow: none !important;
  border: 0 none !important;
}
.dropzoneinput .dz-item .dz-actions .dz-thumb-caption > div .flatpickr-wrapper {
  display: flex;
}
.dropzoneinput .dz-item .dz-actions .dz-thumb-caption > div .flatpickr-wrapper svg {
  stroke: #ffffff;
}
.dropzoneinput .dz-item .dz-actions .dz-thumb-caption > div input {
  background: none;
  text-align: center;
  border: none;
  color: #ffffff;
  min-height: 36px;
  width: 100%;
  padding: 0;
}
.dropzoneinput .dz-item .dz-actions .dz-thumb-caption > div .btn:not(.rotate):not(.delete) {
  padding-top: 0;
  padding-bottom: 0;
}
.dropzoneinput .dz-thumb-img-dims {
  margin: 10px 0;
  display: block;
  text-align: center;
}
.cardbody .form-group.uploadinput {
  align-items: start;
}
.serviced-location-lookup .forminput {
  padding: 10px;
}
.serviced-location-lookup .forminput .btn {
  padding: 10px;
}
.uploadinput .img-container {
  width: 200px;
}
.uploadinput .img-container img {
  width: 100%;
  border: none;
  display: block;
  border-radius: 4px;
}
.uploadinput .img-container .img-placeholder {
  height: 300px;
  width: 200px;
  border-radius: 4px;
  background-color: #F3F5F8;
  display: flex;
  align-items: center;
}
.uploadinput .img-container .img-placeholder .inline {
  margin: 0 auto;
}
.uploadwrap {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
}
.uploadwrap .imagecropbtn {
  margin-top: 10px;
}
.uploadwrap .imagecropbtn input:hover {
  cursor: pointer;
}
.uploadwrap .inlineload {
  position: relative;
  min-height: 3.4rem;
  line-height: 3.4rem;
  vertical-align: middle;
}
.uploadwrap .inlineload a {
  display: inline-block;
  padding-left: 10px;
  position: absolute;
  z-index: 4;
}
.uploadwrap .inlineloaded {
  width: 0%;
}
.ReactCrop__image {
  max-height: none;
}
.recordselector-heading {
  margin-top: 27px;
}
input[type="file"] {
  position: absolute;
  left: 0;
  top: 9px;
  opacity: 0;
  height: 3rem;
  width: 100px;
}
input[type="file"]:hover {
  cursor: pointer;
}
@keyframes fpFadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
.flatpickr-calendar {
  background: transparent;
  opacity: 0;
  display: none;
  text-align: center;
  visibility: hidden;
  padding: 0;
  animation: none;
  direction: ltr;
  border: 0;
  font-size: 14px;
  line-height: 24px;
  border-radius: 5px;
  position: absolute;
  width: 307.875px;
  box-sizing: border-box;
  touch-action: manipulation;
  background: #fff;
  box-shadow: 1px 0 0 #e6e6e6, -1px 0 0 #e6e6e6, 0 1px 0 #e6e6e6, 0 -1px 0 #e6e6e6, 0 3px 13px rgba(0, 0, 0, 0.08);
}
.flatpickr-calendar .hasWeeks .dayContainer {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
}
.flatpickr-calendar .hasTime .dayContainer {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.flatpickr-calendar:before {
  position: absolute;
  display: block;
  pointer-events: none;
  border: solid transparent;
  content: "";
  height: 0;
  width: 0;
  left: 22px;
  border-width: 5px;
  margin: 0 -5px;
}
.flatpickr-calendar:after {
  position: absolute;
  display: block;
  pointer-events: none;
  border: solid transparent;
  content: "";
  height: 0;
  width: 0;
  left: 22px;
  border-width: 4px;
  margin: 0 -4px;
}
.flatpickr-calendar:focus {
  outline: 0;
}
.flatpickr-calendar.open {
  opacity: 1;
  max-height: 640px;
  visibility: visible;
  display: inline-block;
  z-index: 99999;
}
.flatpickr-calendar.inline {
  opacity: 1;
  max-height: 640px;
  visibility: visible;
  display: block;
  position: relative;
  top: 2px;
}
.flatpickr-calendar.animate.open {
  animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);
}
.flatpickr-calendar.static {
  position: absolute;
  top: calc(100% + 2px);
}
.flatpickr-calendar.static.open {
  z-index: 999;
  display: block;
}
.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n + 1) .flatpickr-day.inRange:nth-child(7n + 7) {
  box-shadow: none !important;
}
.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n + 2) .flatpickr-day.inRange:nth-child(7n + 1) {
  box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
}
.flatpickr-calendar.showTimeInput.hasTime .flatpickr-time {
  height: 40px;
  border-top: 1px solid #e6e6e6;
}
.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
  height: auto;
}
.flatpickr-calendar.rightMost:before {
  left: auto;
  right: 22px;
}
.flatpickr-calendar.rightMost:after {
  left: auto;
  right: 22px;
}
.flatpickr-calendar.arrowTop:before {
  bottom: 100%;
  border: 0 none;
}
.flatpickr-calendar.arrowTop:after {
  bottom: 100%;
  border: 0 none;
}
.flatpickr-calendar.arrowBottom:before {
  top: 100%;
  border: 0 none;
}
.flatpickr-calendar.arrowBottom:after {
  top: 100%;
  border: 0 none;
}
.flatpickr-wrapper {
  position: unset;
  display: inline-block;
  flex: 1 1;
}
.dateinput {
  text-decoration: none;
}
.dateinput .form-control.hidden {
  width: 1px;
  height: 1px;
  margin: 0;
  padding: 0;
  position: absolute;
  pointer-events: none;
  opacity: 0;
}
.dateinput .input-group-addon.btn {
  margin-left: 0;
}
.dateinput .flatpickr-inputwrap {
  display: flex;
  flex: 1 1 100%;
  flex-wrap: nowrap;
  border: 1px solid #cfcdcd;
  border-radius: 3px;
}
.dateinput .flatpickr-inputwrap input {
  flex: 1 1 100%;
  border: 0;
}
.dateinput .flatpickr-inputwrap button svg {
  height: 20px;
  fill: #cccccc;
}
.dateinput .flatpickr-inputwrap button:hover svg {
  fill: hsl(0, 0%, 60%);
}
.flatpickr-months {
  display: flex;
}
.flatpickr-months .flatpickr-month {
  background: #ffffff;
  color: #70859E;
  fill: #70859E;
  height: 28px;
  line-height: 1;
  text-align: center;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  flex: 1 1;
}
.flatpickr-months .flatpickr-month .flatpickr-current-month select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-overflow: '';
}
.flatpickr-months .flatpickr-month .flatpickr-current-month select::-ms-expand {
  display: none;
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  text-decoration: none;
  cursor: pointer;
  position: absolute;
  top: 0;
  line-height: 16px;
  height: 28px;
  padding: 10px;
  z-index: 3;
  color: #70859E;
  fill: #70859E;
}
.flatpickr-months .flatpickr-prev-month i,
.flatpickr-months .flatpickr-next-month i {
  position: relative;
}
.flatpickr-months .flatpickr-prev-month:hover,
.flatpickr-months .flatpickr-next-month:hover {
  color: #ffffff;
}
.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
  fill: #ffffff;
}
.flatpickr-months .flatpickr-prev-month svg,
.flatpickr-months .flatpickr-next-month svg {
  width: 14px;
  height: 14px;
}
.flatpickr-months .flatpickr-prev-month svg path,
.flatpickr-months .flatpickr-next-month svg path {
  transition: fill 0.1s;
  fill: #70859E;
}
.flatpickr-months .flatpickr-prev-month.disabled {
  display: none;
}
.flatpickr-months .flatpickr-next-month.disabled {
  display: none;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month {
  left: 0;
}
.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
  left: 0;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-next-month {
  right: 0;
}
.flatpickr-months .flatpickr-next-month.flatpickr-next-month {
  right: 0;
}
.numInputWrapper {
  position: relative;
  height: auto;
}
.numInputWrapper input {
  display: inline-block;
  width: 100%;
}
.numInputWrapper input::-ms-clear {
  display: none;
}
.numInputWrapper span {
  display: inline-block;
  position: absolute;
  right: 0;
  width: 14px;
  padding: 0 4px 0 2px;
  height: 50%;
  line-height: 50%;
  opacity: 0;
  cursor: pointer;
  border: 1px solid rgba(57, 57, 57, 0.15);
  box-sizing: border-box;
}
.numInputWrapper span:hover {
  background: rgba(0, 0, 0, 0.1);
}
.numInputWrapper span:active {
  background: rgba(0, 0, 0, 0.2);
}
.numInputWrapper span:after {
  display: block;
  content: "";
  position: absolute;
}
.numInputWrapper span svg {
  width: inherit;
  height: auto;
}
.numInputWrapper span svg path {
  fill: rgba(0, 0, 0, 0.5);
}
.numInputWrapper span.arrowUp {
  top: 0;
  border-bottom: 0;
}
.numInputWrapper span.arrowUp:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid rgba(57, 57, 57, 0.6);
  top: 26%;
}
.numInputWrapper span.arrowDown {
  top: 50%;
}
.numInputWrapper span.arrowDown:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid rgba(57, 57, 57, 0.6);
  top: 40%;
}
.numInputWrapper:hover {
  background: rgba(0, 0, 0, 0.05);
}
.numInputWrapper:hover span {
  opacity: 1;
}
.flatpickr-current-month {
  font-size: 135%;
  line-height: inherit;
  color: inherit;
  position: absolute;
  width: 75%;
  left: 12.5%;
  padding: 6.16px 0 0 0;
  line-height: 1;
  height: 28px;
  display: inline-block;
  text-align: center;
  transform: translate3d(0, 0, 0);
}
.flatpickr-current-month span.cur-month {
  font-family: inherit;
  font-weight: bold;
  color: inherit;
  display: inline-block;
  margin-left: 0.5ch;
  padding: 0;
}
.flatpickr-current-month span.cur-month:hover {
  background: rgba(0, 0, 0, 0.05);
}
.flatpickr-current-month .numInputWrapper {
  width: 6ch;
  width: 7ch\\0;
  display: inline-block;
}
.flatpickr-current-month .numInputWrapper span.arrowUp:after {
  border-bottom-color: rgba(0, 0, 0, 0.9);
}
.flatpickr-current-month .numInputWrapper span.arrowDown:after {
  border-top-color: rgba(0, 0, 0, 0.9);
}
.flatpickr-current-month input.cur-year {
  background: transparent;
  box-sizing: border-box;
  color: inherit;
  cursor: text;
  padding: 0 0 0 0.5ch;
  margin: 0;
  display: inline-block;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
  height: auto;
  border: 0;
  border-radius: 0;
  vertical-align: initial;
}
.flatpickr-current-month input.cur-year:focus {
  outline: 0;
}
.flatpickr-current-month input.cur-year[disabled] {
  font-size: 100%;
  color: rgba(0, 0, 0, 0.5);
  background: transparent;
  pointer-events: none;
}
.flatpickr-current-month input.cur-year[disabled]:hover {
  font-size: 100%;
  color: rgba(0, 0, 0, 0.5);
  background: transparent;
  pointer-events: none;
}
.flatpickr-weekdays {
  background: #ffffff;
  text-align: center;
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  height: 28px;
}
.flatpickr-weekdays .flatpickr-weekdaycontainer {
  display: flex;
  flex: 1 1;
}
span.flatpickr-weekday {
  cursor: default;
  font-size: 11px;
  background: transparent;
  color: #B2C2D4;
  line-height: 1;
  margin: 0;
  text-align: center;
  display: block;
  flex: 1 1;
  font-weight: bolder;
}
.dayContainer {
  padding: 1px 0 0 0;
  padding: 0;
  outline: 0;
  text-align: left;
  width: 307.875px;
  min-width: 307.875px;
  max-width: 307.875px;
  box-sizing: border-box;
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  transform: translate3d(0, 0, 0);
  opacity: 1;
}
.dayContainer .dayContainer {
  box-shadow: -1px 0 0 #e6e6e6;
}
.flatpickr-weeks {
  padding: 1px 0 0 0;
}
.flatpickr-days {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  width: 307.875px;
  border: 0;
}
.flatpickr-days:focus {
  outline: 0;
}
.flatpickr-day {
  background: none;
  border-radius: 0;
  border: 0 none;
  font-size: 12px;
  box-sizing: border-box;
  color: #5A6F89;
  cursor: pointer;
  width: 14.2857143%;
  flex-basis: 14.2857143%;
  max-width: 39px;
  height: 39px;
  line-height: 39px;
  margin: 0;
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.flatpickr-day:hover {
  cursor: pointer;
  outline: 0;
  font-weight: bold;
  background: #ffffff;
}
.flatpickr-day:focus {
  cursor: pointer;
  outline: 0;
  background: #ffffff;
}
.flatpickr-day.inRange {
  cursor: pointer;
  outline: 0;
  background: #e6e6e6;
  border-color: #e6e6e6;
  border-radius: 0;
  box-shadow: -5px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
}
.flatpickr-day.prevMonthDay.inRange {
  cursor: pointer;
  outline: 0;
  background: #e6e6e6;
  border-color: #e6e6e6;
}
.flatpickr-day.nextMonthDay.inRange {
  cursor: pointer;
  outline: 0;
  background: #e6e6e6;
  border-color: #e6e6e6;
}
.flatpickr-day.today.inRange {
  cursor: pointer;
  outline: 0;
  background: #e6e6e6;
  border-color: #e6e6e6;
}
.flatpickr-day.prevMonthDay.today.inRange {
  cursor: pointer;
  outline: 0;
  background: #e6e6e6;
  border-color: #e6e6e6;
}
.flatpickr-day.nextMonthDay.today.inRange {
  cursor: pointer;
  outline: 0;
  background: #e6e6e6;
  border-color: #e6e6e6;
}
.flatpickr-day.prevMonthDay {
  color: rgba(57, 57, 57, 0.3);
  background: transparent;
  border-color: transparent;
  cursor: default;
}
.flatpickr-day.prevMonthDay:hover {
  cursor: pointer;
  outline: 0;
  background: #e6e6e6;
  border-color: #e6e6e6;
}
.flatpickr-day.prevMonthDay:focus {
  cursor: pointer;
  outline: 0;
  background: #e6e6e6;
  border-color: #e6e6e6;
}
.flatpickr-day.nextMonthDay {
  color: rgba(57, 57, 57, 0.3);
  background: transparent;
  border-color: transparent;
  cursor: default;
}
.flatpickr-day.nextMonthDay:hover {
  cursor: pointer;
  outline: 0;
  background: #e6e6e6;
  border-color: #e6e6e6;
}
.flatpickr-day.nextMonthDay:focus {
  cursor: pointer;
  outline: 0;
  background: #e6e6e6;
  border-color: #e6e6e6;
}
.flatpickr-day.today {
  color: #3699FE;
}
.flatpickr-day.today:hover {
  background: #ffffff;
  color: #3699FE;
}
.flatpickr-day.today:focus {
  background: #ffffff;
  color: #3699FE;
}
.flatpickr-day.selected {
  background: #F3F5F8;
  box-shadow: none;
  color: #10294D;
  font-weight: bold;
  border-radius: 50%;
}
.flatpickr-day.selected:focus {
  color: #10294D;
  background: #ffffff;
  box-shadow: none;
}
.flatpickr-day.selected:hover {
  color: #10294D;
  background: #ffffff;
  box-shadow: none;
}
.flatpickr-day.startRange {
  background: #FC495D;
  box-shadow: none;
  color: #fff;
  border-color: #FC495D;
}
.flatpickr-day.startRange:focus {
  background: #FC495D;
  box-shadow: none;
  color: #fff;
  border-color: #FC495D;
}
.flatpickr-day.startRange:hover {
  background: #FC495D;
  box-shadow: none;
  color: #fff;
  border-color: #FC495D;
}
.flatpickr-day.endRange {
  background: #FC495D;
  box-shadow: none;
  color: #fff;
  border-color: #FC495D;
}
.flatpickr-day.endRange:focus {
  background: #FC495D;
  box-shadow: none;
  color: #fff;
  border-color: #FC495D;
}
.flatpickr-day.endRange:hover {
  background: #FC495D;
  box-shadow: none;
  color: #fff;
  border-color: #FC495D;
}
.flatpickr-day.selected.inRange {
  background: #FC495D;
  box-shadow: none;
  color: #fff;
  border-color: #FC495D;
}
.flatpickr-day.startRange.inRange {
  background: #FC495D;
  box-shadow: none;
  color: #fff;
  border-color: #FC495D;
}
.flatpickr-day.endRange.inRange {
  background: #FC495D;
  box-shadow: none;
  color: #fff;
  border-color: #FC495D;
}
.flatpickr-day.selected.prevMonthDay,
.flatpickr-day.selected.nextMonthDay {
  background: #ffffff;
  box-shadow: none;
  color: #10294D;
  border: 0 none;
}
.flatpickr-day.selected.prevMonthDay:hover,
.flatpickr-day.selected.nextMonthDay:hover {
  color: #10294D;
}
.flatpickr-day.startRange.prevMonthDay {
  background: #FC495D;
  box-shadow: none;
  color: #fff;
  border-color: #FC495D;
}
.flatpickr-day.endRange.prevMonthDay {
  background: #FC495D;
  box-shadow: none;
  color: #fff;
  border-color: #FC495D;
}
.flatpickr-day.startRange.nextMonthDay {
  background: #FC495D;
  box-shadow: none;
  color: #fff;
  border-color: #FC495D;
}
.flatpickr-day.endRange.nextMonthDay {
  background: #FC495D;
  box-shadow: none;
  color: #fff;
  border-color: #FC495D;
}
.flatpickr-day.selected.startRange {
  border-radius: 50px 0 0 50px;
}
.flatpickr-day.selected.startRange .endRange:not(:nth-child(7n + 1)) {
  box-shadow: -10px 0 0 #FC495D;
}
.flatpickr-day.startRange.startRange {
  border-radius: 50px 0 0 50px;
}
.flatpickr-day.startRange.startRange .endRange:not(:nth-child(7n + 1)) {
  box-shadow: -10px 0 0 #FC495D;
}
.flatpickr-day.endRange.startRange {
  border-radius: 50px 0 0 50px;
}
.flatpickr-day.endRange.startRange .endRange:not(:nth-child(7n + 1)) {
  box-shadow: -10px 0 0 #FC495D;
}
.flatpickr-day.selected.endRange {
  border-radius: 0 50px 50px 0;
}
.flatpickr-day.startRange.endRange {
  border-radius: 0 50px 50px 0;
}
.flatpickr-day.endRange.endRange {
  border-radius: 0 50px 50px 0;
}
.flatpickr-day.selected.startRange.endRange {
  border-radius: 50px;
}
.flatpickr-day.startRange.startRange.endRange {
  border-radius: 50px;
}
.flatpickr-day.endRange.startRange.endRange {
  border-radius: 50px;
}
.flatpickr-day.disabled,
.flatpickr-day.flatpickr-disabled,
.flatpickr-day.notAllowed,
.flatpickr-day.prevMonthDay,
.flatpickr-day.nextMonthDay {
  color: #B2C2D4;
  background: transparent;
  border-color: transparent;
}
.flatpickr-day.disabled:hover,
.flatpickr-day.flatpickr-disabled:hover,
.flatpickr-day.notAllowed:hover,
.flatpickr-day.prevMonthDay:hover,
.flatpickr-day.nextMonthDay:hover {
  background: transparent;
  border-color: transparent;
  color: #B2C2D4;
}
.flatpickr-day.disabled,
.flatpickr-day.flatpickr-disabled,
.flatpickr-day.notAllowed,
.flatpickr-day.prevMonthDay.flatpickr-disabled,
.flatpickr-day.nextMonthDay.flatpickr-disabled {
  color: #CED7E2;
  cursor: not-allowed;
}
.flatpickr-day.disabled:hover,
.flatpickr-day.flatpickr-disabled:hover,
.flatpickr-day.notAllowed:hover,
.flatpickr-day.prevMonthDay.flatpickr-disabled:hover,
.flatpickr-day.nextMonthDay.flatpickr-disabled:hover {
  cursor: not-allowed;
  font-weight: 400;
  color: #CED7E2;
}
.flatpickr-day.week.selected {
  border-radius: 0;
  box-shadow: -5px 0 0 #FC495D, 5px 0 0 #FC495D;
}
.flatpickr-day.hidden {
  visibility: hidden;
}
.rangeMode .flatpickr-day {
  margin-top: 1px;
}
.flatpickr-weekwrapper {
  display: inline-block;
}
.flatpickr-weekwrapper .flatpickr-weeks {
  padding: 0 12px;
  box-shadow: 1px 0 0 #e6e6e6;
}
.flatpickr-weekwrapper .flatpickr-weekday {
  float: none;
  width: 100%;
  line-height: 28px;
}
.flatpickr-weekwrapper span.flatpickr-day {
  display: block;
  width: 100%;
  max-width: none;
  color: rgba(57, 57, 57, 0.3);
  background: transparent;
  cursor: default;
  border: none;
}
.flatpickr-weekwrapper span.flatpickr-day:hover {
  display: block;
  width: 100%;
  max-width: none;
  color: rgba(57, 57, 57, 0.3);
  background: transparent;
  cursor: default;
  border: none;
}
.flatpickr-innerContainer {
  display: block;
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
}
.flatpickr-rContainer {
  display: inline-block;
  padding: 0;
  box-sizing: border-box;
}
.flatpickr-time {
  text-align: center;
  outline: 0;
  display: block;
  height: 0;
  line-height: 40px;
  max-height: 40px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
}
.flatpickr-time:after {
  content: "";
  display: table;
  clear: both;
}
.flatpickr-time .numInputWrapper {
  flex: 1 1;
  width: 40%;
  height: 40px;
  float: left;
}
.flatpickr-time .numInputWrapper span.arrowUp:after {
  border-bottom-color: #393939;
}
.flatpickr-time .numInputWrapper span.arrowDown:after {
  border-top-color: #393939;
}
.flatpickr-time input {
  background: transparent;
  box-shadow: none;
  border: 0;
  border-radius: 0;
  text-align: center;
  margin: 0;
  padding: 0;
  height: inherit;
  line-height: inherit;
  color: #393939;
  font-size: 14px;
  position: relative;
  box-sizing: border-box;
}
.flatpickr-time input:focus {
  outline: 0;
  border: 0;
  background: #f3f3f3;
}
.flatpickr-time input:hover {
  background: #f3f3f3;
}
.flatpickr-time input.flatpickr-hour {
  font-weight: bold;
}
.flatpickr-time input.flatpickr-minute {
  font-weight: 400;
}
.flatpickr-time input.flatpickr-second {
  font-weight: 400;
}
.flatpickr-time .flatpickr-time-separator {
  height: inherit;
  display: inline-block;
  line-height: inherit;
  color: #393939;
  font-weight: bold;
  width: 2%;
  -webkit-user-select: none;
          user-select: none;
  align-self: center;
}
.flatpickr-time .flatpickr-am-pm {
  height: inherit;
  display: inline-block;
  line-height: inherit;
  color: #393939;
  font-weight: bold;
  width: 2%;
  -webkit-user-select: none;
          user-select: none;
  align-self: center;
  outline: 0;
  width: 18%;
  cursor: pointer;
  text-align: center;
  font-weight: 400;
}
.flatpickr-time .flatpickr-am-pm:hover {
  background: #f3f3f3;
}
.flatpickr-time .flatpickr-am-pm:focus {
  background: #f3f3f3;
}
.flatpickr-time.hasSeconds .numInputWrapper {
  width: 26%;
}
.flatpickr-time.time24hr .numInputWrapper {
  width: 49%;
}
.flatpickr-input[readonly] {
  cursor: pointer;
  background-color: #ffffff;
}
.flatpickr-calendar .flatpickr-monthDropdown-months,
.flatpickr-calendar .flatpickr-current-month input.cur-year {
  background: none;
  font-size: 1.2rem;
  font-weight: 600;
  -webkit-appearance: textfield;
}
.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
  background: #ffffff;
  padding: 0;
}
.flatpickr-calendar span.flatpickr-weekday {
  font-weight: 600;
}
.flatpickr-calendar .flatpickr-day {
  line-height: 36px;
  height: 40px;
  max-width: 40px;
}
.tip {
  min-height: 36px;
  flex: 1 1 100%;
  display: flex;
  align-items: center;
  color: #70859E;
  vertical-align: center;
  border-radius: 4px;
  background: #EFFBFD;
}
.tip .tip-content {
  padding: 6px 10px;
}
.tip.hot {
  background: #FFEEEF;
  color: #FF6464;
}
.tip.alert {
  background: #FEF6EF;
  color: #70859E;
}
.tip.fix-width {
  min-width: 100%;
}
.tip.tip-input {
  margin: 0 !important;
}
.tip .tipheading {
  font-weight: 600;
  padding-right: 10px;
  white-space: nowrap;
}
.tip.multi,
.input-group .field .tip.multi {
  margin-top: -10px;
}
.tip.multi .tipheading.multi,
.input-group .field .tip.multi .tipheading.multi {
  flex: 0 0 100%;
}
.tip.multi .tiptext.multi,
.input-group .field .tip.multi .tiptext.multi {
  flex: 0 0 100%;
}
.colorpicker .color-swatch {
  width: 36px;
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}
.colorpicker .formlabel {
  left: 37px;
}
.colorpicker .input-group-addon {
  border-radius: 4px 0 0 4px;
}
.colorpicker .input-group-addon ~ input.input-group-prefix {
  padding-left: 8px;
}
.colorpicker .forminput {
  position: relative;
  flex: 1 1 auto !important;
}
.colorpicker .forminput input {
  padding-left: 8px !important;
}
.colorpicker .picker_wrapper {
  background: #ffffff;
}
.colorpicker .picker_editor {
  flex: 1 1 auto;
  border-radius: 4px 0 0 4px;
  border: 1px solid #cfcdcd;
  overflow: hidden;
  margin-right: 0;
  border-right: 0;
}
.colorpicker .picker_editor input {
  border: none;
  box-shadow: none;
}
.colorpicker .picker_alpha {
  width: 100%;
}
.colorpicker .picker_sample {
  flex: 0 0 36px;
  margin-left: 0;
  margin-right: 0;
  box-shadow: none;
  border: 1px solid #cfcdcd;
}
.colorpicker .picker_done {
  margin-left: 0;
}
.colorpicker .picker_done button {
  display: flex;
  align-items: center;
  padding: 6px 15px;
  min-height: 36px;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  border: 1px solid transparent;
  transition: all 0.2s ease-in-out;
  border-radius: 4px;
  cursor: pointer;
  appearance: none;
  font-weight: 500;
  box-shadow: none;
  background: #F3F5F8;
  color: #10294D;
  border-radius: 0 4px 4px 0;
}
.colorpicker .picker_done button-small {
  padding: 0 8px;
  min-height: 26px;
}
.colorpicker .picker_done button svg {
  fill: none;
  transition: all 0.2s ease-in-out;
}
.colorpicker .picker_done button.input-group-addon {
  min-height: 34px;
  max-height: none;
}
.colorpicker .picker_done button-primary {
  background: #10294D;
  border-color: transparent;
  color: #ffffff;
}
.colorpicker .picker_done button-primary svg {
  stroke: #ffffff;
  fill: none;
}
.colorpicker .picker_done button-primary:not(.disabled).focus,
.colorpicker .picker_done button-primary:not(.disabled):focus,
.colorpicker .picker_done button-primary:not(.disabled):focus-visible {
  color: #ffffff;
  border: 1px solid transparent;
  background: #071B38;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.colorpicker .picker_done button-primary:not(.disabled).active,
.colorpicker .picker_done button-primary:not(.disabled):active {
  color: #ffffff;
  border: 1px solid transparent;
  background: #071B38;
}
.colorpicker .picker_done button-primary:not(.disabled).active.focus,
.colorpicker .picker_done button-primary:not(.disabled):active.focus,
.colorpicker .picker_done button-primary:not(.disabled).active:focus,
.colorpicker .picker_done button-primary:not(.disabled):active:focus,
.colorpicker .picker_done button-primary:not(.disabled).active:focus-visible,
.colorpicker .picker_done button-primary:not(.disabled):active:focus-visible {
  background: #071B38;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.colorpicker .picker_done button-primary:not(.disabled).hover,
.colorpicker .picker_done button-primary:not(.disabled):hover {
  color: #ffffff;
  border: 1px solid transparent;
  background: #071B38;
}
.colorpicker .picker_done button-primary:not(.disabled).hover.active,
.colorpicker .picker_done button-primary:not(.disabled):hover.active,
.colorpicker .picker_done button-primary:not(.disabled).hover:active,
.colorpicker .picker_done button-primary:not(.disabled):hover:active {
  border-color: transparent;
  background: #071B38;
}
.colorpicker .picker_done button-primary:not(.disabled).hover.active.focus,
.colorpicker .picker_done button-primary:not(.disabled):hover.active.focus,
.colorpicker .picker_done button-primary:not(.disabled).hover:active.focus,
.colorpicker .picker_done button-primary:not(.disabled):hover:active.focus,
.colorpicker .picker_done button-primary:not(.disabled).hover.active:focus,
.colorpicker .picker_done button-primary:not(.disabled):hover.active:focus,
.colorpicker .picker_done button-primary:not(.disabled).hover:active:focus,
.colorpicker .picker_done button-primary:not(.disabled):hover:active:focus,
.colorpicker .picker_done button-primary:not(.disabled).hover.active:focus-visible,
.colorpicker .picker_done button-primary:not(.disabled):hover.active:focus-visible,
.colorpicker .picker_done button-primary:not(.disabled).hover:active:focus-visible,
.colorpicker .picker_done button-primary:not(.disabled):hover:active:focus-visible {
  background: #071B38;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.colorpicker .picker_done button-secondary {
  background: #FC495D;
  border-color: transparent;
  color: #ffffff;
}
.colorpicker .picker_done button-secondary svg {
  display: block;
  stroke: #ffffff;
  fill: none;
}
.colorpicker .picker_done button-secondary.focus,
.colorpicker .picker_done button-secondary:focus,
.colorpicker .picker_done button-secondary:focus-visible {
  color: #ffffff;
  border: 1px solid transparent;
  background: #E62D42;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FED1D6;
}
.colorpicker .picker_done button-secondary.active,
.colorpicker .picker_done button-secondary:active {
  color: #ffffff;
  border: 1px solid transparent;
  background: #E62D42;
}
.colorpicker .picker_done button-secondary.active.focus,
.colorpicker .picker_done button-secondary:active.focus,
.colorpicker .picker_done button-secondary.active:focus,
.colorpicker .picker_done button-secondary:active:focus,
.colorpicker .picker_done button-secondary.active:focus-visible,
.colorpicker .picker_done button-secondary:active:focus-visible {
  background: #E62D42;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FED1D6;
}
.colorpicker .picker_done button-secondary.hover,
.colorpicker .picker_done button-secondary:hover {
  color: #ffffff;
  border: 1px solid transparent;
  background: #E62D42;
}
.colorpicker .picker_done button-secondary.hover.active,
.colorpicker .picker_done button-secondary:hover.active,
.colorpicker .picker_done button-secondary.hover:active,
.colorpicker .picker_done button-secondary:hover:active {
  border-color: transparent;
  background: #E62D42;
}
.colorpicker .picker_done button-secondary.hover.active.focus,
.colorpicker .picker_done button-secondary:hover.active.focus,
.colorpicker .picker_done button-secondary.hover:active.focus,
.colorpicker .picker_done button-secondary:hover:active.focus,
.colorpicker .picker_done button-secondary.hover.active:focus,
.colorpicker .picker_done button-secondary:hover.active:focus,
.colorpicker .picker_done button-secondary.hover:active:focus,
.colorpicker .picker_done button-secondary:hover:active:focus,
.colorpicker .picker_done button-secondary.hover.active:focus-visible,
.colorpicker .picker_done button-secondary:hover.active:focus-visible,
.colorpicker .picker_done button-secondary.hover:active:focus-visible,
.colorpicker .picker_done button-secondary:hover:active:focus-visible {
  background: #E62D42;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FED1D6;
}
.colorpicker .picker_done button-round {
  border-radius: 30px;
}
.colorpicker .picker_done button-red {
  background: #FFEDEF;
  color: #FC495D;
}
.colorpicker .picker_done button-red svg {
  stroke: #FC495D;
}
.colorpicker .picker_done button-red.focus,
.colorpicker .picker_done button-red:focus,
.colorpicker .picker_done button-red:focus-visible {
  color: #FC495D;
  border: 1px solid transparent;
  background: #FED1D6;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FFEDEF;
}
.colorpicker .picker_done button-red.active,
.colorpicker .picker_done button-red:active {
  color: #FC495D;
  border: 1px solid transparent;
  background: #FED1D6;
}
.colorpicker .picker_done button-red.active.focus,
.colorpicker .picker_done button-red:active.focus,
.colorpicker .picker_done button-red.active:focus,
.colorpicker .picker_done button-red:active:focus,
.colorpicker .picker_done button-red.active:focus-visible,
.colorpicker .picker_done button-red:active:focus-visible {
  background: #FED1D6;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FFEDEF;
}
.colorpicker .picker_done button-red.hover,
.colorpicker .picker_done button-red:hover {
  color: #FC495D;
  border: 1px solid transparent;
  background: #FED1D6;
}
.colorpicker .picker_done button-red.hover.active,
.colorpicker .picker_done button-red:hover.active,
.colorpicker .picker_done button-red.hover:active,
.colorpicker .picker_done button-red:hover:active {
  border-color: transparent;
  background: #FED1D6;
}
.colorpicker .picker_done button-red.hover.active.focus,
.colorpicker .picker_done button-red:hover.active.focus,
.colorpicker .picker_done button-red.hover:active.focus,
.colorpicker .picker_done button-red:hover:active.focus,
.colorpicker .picker_done button-red.hover.active:focus,
.colorpicker .picker_done button-red:hover.active:focus,
.colorpicker .picker_done button-red.hover:active:focus,
.colorpicker .picker_done button-red:hover:active:focus,
.colorpicker .picker_done button-red.hover.active:focus-visible,
.colorpicker .picker_done button-red:hover.active:focus-visible,
.colorpicker .picker_done button-red.hover:active:focus-visible,
.colorpicker .picker_done button-red:hover:active:focus-visible {
  background: #FED1D6;
  outline: none;
  box-shadow: 0px 0px 0px 3px #FFEDEF;
}
.colorpicker .picker_done button-green {
  background: #F0F9F1;
  color: #73C677;
}
.colorpicker .picker_done button-green svg {
  stroke: #73C677;
}
.colorpicker .picker_done button-green.focus,
.colorpicker .picker_done button-green:focus,
.colorpicker .picker_done button-green:focus-visible {
  color: #73C677;
  border: 1px solid transparent;
  background: #DCF1DE;
  outline: none;
  box-shadow: 0px 0px 0px 3px #F0F9F1;
}
.colorpicker .picker_done button-green.active,
.colorpicker .picker_done button-green:active {
  color: #73C677;
  border: 1px solid transparent;
  background: #DCF1DE;
}
.colorpicker .picker_done button-green.active.focus,
.colorpicker .picker_done button-green:active.focus,
.colorpicker .picker_done button-green.active:focus,
.colorpicker .picker_done button-green:active:focus,
.colorpicker .picker_done button-green.active:focus-visible,
.colorpicker .picker_done button-green:active:focus-visible {
  background: #DCF1DE;
  outline: none;
  box-shadow: 0px 0px 0px 3px #F0F9F1;
}
.colorpicker .picker_done button-green.hover,
.colorpicker .picker_done button-green:hover {
  color: #73C677;
  border: 1px solid transparent;
  background: #DCF1DE;
}
.colorpicker .picker_done button-green.hover.active,
.colorpicker .picker_done button-green:hover.active,
.colorpicker .picker_done button-green.hover:active,
.colorpicker .picker_done button-green:hover:active {
  border-color: transparent;
  background: #DCF1DE;
}
.colorpicker .picker_done button-green.hover.active.focus,
.colorpicker .picker_done button-green:hover.active.focus,
.colorpicker .picker_done button-green.hover:active.focus,
.colorpicker .picker_done button-green:hover:active.focus,
.colorpicker .picker_done button-green.hover.active:focus,
.colorpicker .picker_done button-green:hover.active:focus,
.colorpicker .picker_done button-green.hover:active:focus,
.colorpicker .picker_done button-green:hover:active:focus,
.colorpicker .picker_done button-green.hover.active:focus-visible,
.colorpicker .picker_done button-green:hover.active:focus-visible,
.colorpicker .picker_done button-green.hover:active:focus-visible,
.colorpicker .picker_done button-green:hover:active:focus-visible {
  background: #DCF1DE;
  outline: none;
  box-shadow: 0px 0px 0px 3px #F0F9F1;
}
.colorpicker .picker_done button-blue {
  background: #EFFBFD;
  color: #34BFDE;
}
.colorpicker .picker_done button-blue svg {
  stroke: #73C677;
}
.colorpicker .picker_done button-blue.focus,
.colorpicker .picker_done button-blue:focus,
.colorpicker .picker_done button-blue:focus-visible {
  color: #73C677;
  border: 1px solid transparent;
  background: #D7F4FA;
  outline: none;
  box-shadow: 0px 0px 0px 3px #EFFBFD;
}
.colorpicker .picker_done button-blue.active,
.colorpicker .picker_done button-blue:active {
  color: #73C677;
  border: 1px solid transparent;
  background: #D7F4FA;
}
.colorpicker .picker_done button-blue.active.focus,
.colorpicker .picker_done button-blue:active.focus,
.colorpicker .picker_done button-blue.active:focus,
.colorpicker .picker_done button-blue:active:focus,
.colorpicker .picker_done button-blue.active:focus-visible,
.colorpicker .picker_done button-blue:active:focus-visible {
  background: #D7F4FA;
  outline: none;
  box-shadow: 0px 0px 0px 3px #EFFBFD;
}
.colorpicker .picker_done button-blue.hover,
.colorpicker .picker_done button-blue:hover {
  color: #73C677;
  border: 1px solid transparent;
  background: #D7F4FA;
}
.colorpicker .picker_done button-blue.hover.active,
.colorpicker .picker_done button-blue:hover.active,
.colorpicker .picker_done button-blue.hover:active,
.colorpicker .picker_done button-blue:hover:active {
  border-color: transparent;
  background: #D7F4FA;
}
.colorpicker .picker_done button-blue.hover.active.focus,
.colorpicker .picker_done button-blue:hover.active.focus,
.colorpicker .picker_done button-blue.hover:active.focus,
.colorpicker .picker_done button-blue:hover:active.focus,
.colorpicker .picker_done button-blue.hover.active:focus,
.colorpicker .picker_done button-blue:hover.active:focus,
.colorpicker .picker_done button-blue.hover:active:focus,
.colorpicker .picker_done button-blue:hover:active:focus,
.colorpicker .picker_done button-blue.hover.active:focus-visible,
.colorpicker .picker_done button-blue:hover.active:focus-visible,
.colorpicker .picker_done button-blue.hover:active:focus-visible,
.colorpicker .picker_done button-blue:hover:active:focus-visible {
  background: #D7F4FA;
  outline: none;
  box-shadow: 0px 0px 0px 3px #EFFBFD;
}
.colorpicker .picker_done button-none {
  background: transparent;
  color: #70859E;
}
.colorpicker .picker_done button-none svg {
  stroke: #10294D;
}
.colorpicker .picker_done button-none.focus,
.colorpicker .picker_done button-none:focus,
.colorpicker .picker_done button-none:focus-visible {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.colorpicker .picker_done button-none.active,
.colorpicker .picker_done button-none:active {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
.colorpicker .picker_done button-none.active.focus,
.colorpicker .picker_done button-none:active.focus,
.colorpicker .picker_done button-none.active:focus,
.colorpicker .picker_done button-none:active:focus,
.colorpicker .picker_done button-none.active:focus-visible,
.colorpicker .picker_done button-none:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.colorpicker .picker_done button-none.hover,
.colorpicker .picker_done button-none:hover {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
.colorpicker .picker_done button-none.hover.active,
.colorpicker .picker_done button-none:hover.active,
.colorpicker .picker_done button-none.hover:active,
.colorpicker .picker_done button-none:hover:active {
  border-color: transparent;
  background: transparent;
}
.colorpicker .picker_done button-none.hover.active.focus,
.colorpicker .picker_done button-none:hover.active.focus,
.colorpicker .picker_done button-none.hover:active.focus,
.colorpicker .picker_done button-none:hover:active.focus,
.colorpicker .picker_done button-none.hover.active:focus,
.colorpicker .picker_done button-none:hover.active:focus,
.colorpicker .picker_done button-none.hover:active:focus,
.colorpicker .picker_done button-none:hover:active:focus,
.colorpicker .picker_done button-none.hover.active:focus-visible,
.colorpicker .picker_done button-none:hover.active:focus-visible,
.colorpicker .picker_done button-none.hover:active:focus-visible,
.colorpicker .picker_done button-none:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.colorpicker .picker_done button-none-red {
  background: transparent;
  color: #70859E;
}
.colorpicker .picker_done button-none-red svg {
  stroke: #FC495D;
}
.colorpicker .picker_done button-none-red.focus,
.colorpicker .picker_done button-none-red:focus,
.colorpicker .picker_done button-none-red:focus-visible {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.colorpicker .picker_done button-none-red.active,
.colorpicker .picker_done button-none-red:active {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
.colorpicker .picker_done button-none-red.active.focus,
.colorpicker .picker_done button-none-red:active.focus,
.colorpicker .picker_done button-none-red.active:focus,
.colorpicker .picker_done button-none-red:active:focus,
.colorpicker .picker_done button-none-red.active:focus-visible,
.colorpicker .picker_done button-none-red:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.colorpicker .picker_done button-none-red.hover,
.colorpicker .picker_done button-none-red:hover {
  color: #071B38;
  border: 1px solid transparent;
  background: transparent;
}
.colorpicker .picker_done button-none-red.hover.active,
.colorpicker .picker_done button-none-red:hover.active,
.colorpicker .picker_done button-none-red.hover:active,
.colorpicker .picker_done button-none-red:hover:active {
  border-color: transparent;
  background: transparent;
}
.colorpicker .picker_done button-none-red.hover.active.focus,
.colorpicker .picker_done button-none-red:hover.active.focus,
.colorpicker .picker_done button-none-red.hover:active.focus,
.colorpicker .picker_done button-none-red:hover:active.focus,
.colorpicker .picker_done button-none-red.hover.active:focus,
.colorpicker .picker_done button-none-red:hover.active:focus,
.colorpicker .picker_done button-none-red.hover:active:focus,
.colorpicker .picker_done button-none-red:hover:active:focus,
.colorpicker .picker_done button-none-red.hover.active:focus-visible,
.colorpicker .picker_done button-none-red:hover.active:focus-visible,
.colorpicker .picker_done button-none-red.hover:active:focus-visible,
.colorpicker .picker_done button-none-red:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.colorpicker .picker_done button-subtle {
  background: transparent;
  border: 1px solid #E5EBF1;
  color: #10294D;
}
.colorpicker .picker_done button-subtle svg {
  stroke: #10294D;
}
.colorpicker .picker_done button-subtle.focus,
.colorpicker .picker_done button-subtle:focus,
.colorpicker .picker_done button-subtle:focus-visible {
  color: #071B38;
  border: 1px solid #CED7E2;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.colorpicker .picker_done button-subtle.active,
.colorpicker .picker_done button-subtle:active {
  color: #071B38;
  border: 1px solid #CED7E2;
  background: transparent;
}
.colorpicker .picker_done button-subtle.active.focus,
.colorpicker .picker_done button-subtle:active.focus,
.colorpicker .picker_done button-subtle.active:focus,
.colorpicker .picker_done button-subtle:active:focus,
.colorpicker .picker_done button-subtle.active:focus-visible,
.colorpicker .picker_done button-subtle:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.colorpicker .picker_done button-subtle.hover,
.colorpicker .picker_done button-subtle:hover {
  color: #071B38;
  border: 1px solid #CED7E2;
  background: transparent;
}
.colorpicker .picker_done button-subtle.hover.active,
.colorpicker .picker_done button-subtle:hover.active,
.colorpicker .picker_done button-subtle.hover:active,
.colorpicker .picker_done button-subtle:hover:active {
  border-color: #CED7E2;
  background: transparent;
}
.colorpicker .picker_done button-subtle.hover.active.focus,
.colorpicker .picker_done button-subtle:hover.active.focus,
.colorpicker .picker_done button-subtle.hover:active.focus,
.colorpicker .picker_done button-subtle:hover:active.focus,
.colorpicker .picker_done button-subtle.hover.active:focus,
.colorpicker .picker_done button-subtle:hover.active:focus,
.colorpicker .picker_done button-subtle.hover:active:focus,
.colorpicker .picker_done button-subtle:hover:active:focus,
.colorpicker .picker_done button-subtle.hover.active:focus-visible,
.colorpicker .picker_done button-subtle:hover.active:focus-visible,
.colorpicker .picker_done button-subtle.hover:active:focus-visible,
.colorpicker .picker_done button-subtle:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px #E6EAED;
}
.colorpicker .picker_done button-text {
  background: transparent;
  color: #10294D;
}
.colorpicker .picker_done button-text svg {
  stroke: #CED7E2;
}
.colorpicker .picker_done button-text.focus,
.colorpicker .picker_done button-text:focus,
.colorpicker .picker_done button-text:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.colorpicker .picker_done button-text.active,
.colorpicker .picker_done button-text:active {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
.colorpicker .picker_done button-text.active.focus,
.colorpicker .picker_done button-text:active.focus,
.colorpicker .picker_done button-text.active:focus,
.colorpicker .picker_done button-text:active:focus,
.colorpicker .picker_done button-text.active:focus-visible,
.colorpicker .picker_done button-text:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.colorpicker .picker_done button-text.hover,
.colorpicker .picker_done button-text:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
.colorpicker .picker_done button-text.hover.active,
.colorpicker .picker_done button-text:hover.active,
.colorpicker .picker_done button-text.hover:active,
.colorpicker .picker_done button-text:hover:active {
  border-color: transparent;
  background: transparent;
}
.colorpicker .picker_done button-text.hover.active.focus,
.colorpicker .picker_done button-text:hover.active.focus,
.colorpicker .picker_done button-text.hover:active.focus,
.colorpicker .picker_done button-text:hover:active.focus,
.colorpicker .picker_done button-text.hover.active:focus,
.colorpicker .picker_done button-text:hover.active:focus,
.colorpicker .picker_done button-text.hover:active:focus,
.colorpicker .picker_done button-text:hover:active:focus,
.colorpicker .picker_done button-text.hover.active:focus-visible,
.colorpicker .picker_done button-text:hover.active:focus-visible,
.colorpicker .picker_done button-text.hover:active:focus-visible,
.colorpicker .picker_done button-text:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.colorpicker .picker_done button-text-only {
  padding: 0;
  background: transparent;
  color: #10294D;
}
.colorpicker .picker_done button-text-only svg {
  stroke: #CED7E2;
}
.colorpicker .picker_done button-text-only.focus,
.colorpicker .picker_done button-text-only:focus,
.colorpicker .picker_done button-text-only:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.colorpicker .picker_done button-text-only.active,
.colorpicker .picker_done button-text-only:active {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
.colorpicker .picker_done button-text-only.active.focus,
.colorpicker .picker_done button-text-only:active.focus,
.colorpicker .picker_done button-text-only.active:focus,
.colorpicker .picker_done button-text-only:active:focus,
.colorpicker .picker_done button-text-only.active:focus-visible,
.colorpicker .picker_done button-text-only:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.colorpicker .picker_done button-text-only.hover,
.colorpicker .picker_done button-text-only:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: transparent;
}
.colorpicker .picker_done button-text-only.hover.active,
.colorpicker .picker_done button-text-only:hover.active,
.colorpicker .picker_done button-text-only.hover:active,
.colorpicker .picker_done button-text-only:hover:active {
  border-color: transparent;
  background: transparent;
}
.colorpicker .picker_done button-text-only.hover.active.focus,
.colorpicker .picker_done button-text-only:hover.active.focus,
.colorpicker .picker_done button-text-only.hover:active.focus,
.colorpicker .picker_done button-text-only:hover:active.focus,
.colorpicker .picker_done button-text-only.hover.active:focus,
.colorpicker .picker_done button-text-only:hover.active:focus,
.colorpicker .picker_done button-text-only.hover:active:focus,
.colorpicker .picker_done button-text-only:hover:active:focus,
.colorpicker .picker_done button-text-only.hover.active:focus-visible,
.colorpicker .picker_done button-text-only:hover.active:focus-visible,
.colorpicker .picker_done button-text-only.hover:active:focus-visible,
.colorpicker .picker_done button-text-only:hover:active:focus-visible {
  background: transparent;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.colorpicker .picker_done button-grey {
  background: #E5EBF1;
  color: #10294D;
}
.colorpicker .picker_done button-grey svg {
  stroke: #10294D;
}
.colorpicker .picker_done button-grey.input-group-addon {
  min-height: 34px;
  max-height: none;
  background: #E5EBF1;
  color: #10294D;
}
.colorpicker .picker_done button-grey.input-group-addon svg {
  stroke: #10294D;
}
.colorpicker .picker_done button-grey.focus,
.colorpicker .picker_done button-grey:focus,
.colorpicker .picker_done button-grey:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.colorpicker .picker_done button-grey.active,
.colorpicker .picker_done button-grey:active {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
.colorpicker .picker_done button-grey.active.focus,
.colorpicker .picker_done button-grey:active.focus,
.colorpicker .picker_done button-grey.active:focus,
.colorpicker .picker_done button-grey:active:focus,
.colorpicker .picker_done button-grey.active:focus-visible,
.colorpicker .picker_done button-grey:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.colorpicker .picker_done button-grey.hover,
.colorpicker .picker_done button-grey:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
.colorpicker .picker_done button-grey.hover.active,
.colorpicker .picker_done button-grey:hover.active,
.colorpicker .picker_done button-grey.hover:active,
.colorpicker .picker_done button-grey:hover:active {
  border-color: transparent;
  background: #CED7E2;
}
.colorpicker .picker_done button-grey.hover.active.focus,
.colorpicker .picker_done button-grey:hover.active.focus,
.colorpicker .picker_done button-grey.hover:active.focus,
.colorpicker .picker_done button-grey:hover:active.focus,
.colorpicker .picker_done button-grey.hover.active:focus,
.colorpicker .picker_done button-grey:hover.active:focus,
.colorpicker .picker_done button-grey.hover:active:focus,
.colorpicker .picker_done button-grey:hover:active:focus,
.colorpicker .picker_done button-grey.hover.active:focus-visible,
.colorpicker .picker_done button-grey:hover.active:focus-visible,
.colorpicker .picker_done button-grey.hover:active:focus-visible,
.colorpicker .picker_done button-grey:hover:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.colorpicker .picker_done button-grey-50 {
  background: #F3F5F8;
  color: #10294D;
}
.colorpicker .picker_done button-grey-50 svg {
  stroke: #10294D;
}
.colorpicker .picker_done button-grey-50.input-group-addon {
  min-height: 34px;
  max-height: none;
  background: #F3F5F8;
  color: #10294D;
}
.colorpicker .picker_done button-grey-50.input-group-addon svg {
  stroke: #10294D;
}
.colorpicker .picker_done button-grey-50.focus,
.colorpicker .picker_done button-grey-50:focus,
.colorpicker .picker_done button-grey-50:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.colorpicker .picker_done button-grey-50.active,
.colorpicker .picker_done button-grey-50:active {
  color: #10294D;
  border: 1px solid transparent;
  background: #E5EBF1;
}
.colorpicker .picker_done button-grey-50.active.focus,
.colorpicker .picker_done button-grey-50:active.focus,
.colorpicker .picker_done button-grey-50.active:focus,
.colorpicker .picker_done button-grey-50:active:focus,
.colorpicker .picker_done button-grey-50.active:focus-visible,
.colorpicker .picker_done button-grey-50:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.colorpicker .picker_done button-grey-50.hover,
.colorpicker .picker_done button-grey-50:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: #E5EBF1;
}
.colorpicker .picker_done button-grey-50.hover.active,
.colorpicker .picker_done button-grey-50:hover.active,
.colorpicker .picker_done button-grey-50.hover:active,
.colorpicker .picker_done button-grey-50:hover:active {
  border-color: transparent;
  background: #E5EBF1;
}
.colorpicker .picker_done button-grey-50.hover.active.focus,
.colorpicker .picker_done button-grey-50:hover.active.focus,
.colorpicker .picker_done button-grey-50.hover:active.focus,
.colorpicker .picker_done button-grey-50:hover:active.focus,
.colorpicker .picker_done button-grey-50.hover.active:focus,
.colorpicker .picker_done button-grey-50:hover.active:focus,
.colorpicker .picker_done button-grey-50.hover:active:focus,
.colorpicker .picker_done button-grey-50:hover:active:focus,
.colorpicker .picker_done button-grey-50.hover.active:focus-visible,
.colorpicker .picker_done button-grey-50:hover.active:focus-visible,
.colorpicker .picker_done button-grey-50.hover:active:focus-visible,
.colorpicker .picker_done button-grey-50:hover:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.colorpicker .picker_done button-white {
  background: #ffffff;
  color: #10294D;
}
.colorpicker .picker_done button-white svg {
  stroke: #CED7E2;
}
.colorpicker .picker_done button-white.input-group-addon {
  min-height: 34px;
  max-height: none;
  background: #E5EBF1;
  color: #10294D;
}
.colorpicker .picker_done button-white.input-group-addon svg {
  stroke: #CED7E2;
}
.colorpicker .picker_done button-white.focus,
.colorpicker .picker_done button-white:focus,
.colorpicker .picker_done button-white:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.colorpicker .picker_done button-white.active,
.colorpicker .picker_done button-white:active {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
.colorpicker .picker_done button-white.active.focus,
.colorpicker .picker_done button-white:active.focus,
.colorpicker .picker_done button-white.active:focus,
.colorpicker .picker_done button-white:active:focus,
.colorpicker .picker_done button-white.active:focus-visible,
.colorpicker .picker_done button-white:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.colorpicker .picker_done button-white.hover,
.colorpicker .picker_done button-white:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: #CED7E2;
}
.colorpicker .picker_done button-white.hover.active,
.colorpicker .picker_done button-white:hover.active,
.colorpicker .picker_done button-white.hover:active,
.colorpicker .picker_done button-white:hover:active {
  border-color: transparent;
  background: #CED7E2;
}
.colorpicker .picker_done button-white.hover.active.focus,
.colorpicker .picker_done button-white:hover.active.focus,
.colorpicker .picker_done button-white.hover:active.focus,
.colorpicker .picker_done button-white:hover:active.focus,
.colorpicker .picker_done button-white.hover.active:focus,
.colorpicker .picker_done button-white:hover.active:focus,
.colorpicker .picker_done button-white.hover:active:focus,
.colorpicker .picker_done button-white:hover:active:focus,
.colorpicker .picker_done button-white.hover.active:focus-visible,
.colorpicker .picker_done button-white:hover.active:focus-visible,
.colorpicker .picker_done button-white.hover:active:focus-visible,
.colorpicker .picker_done button-white:hover:active:focus-visible {
  background: #CED7E2;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.colorpicker .picker_done button-white:hover svg,
.colorpicker .picker_done button-white.active svg,
.colorpicker .picker_done button-white:active svg {
  stroke: #10294D;
}
.colorpicker .picker_done button.disabled,
.colorpicker .picker_done button[disabled] {
  background: #E5EBF1;
  border: 1px solid transparent;
  cursor: not-allowed;
  color: #CED7E2;
}
.colorpicker .picker_done button.disabled svg,
.colorpicker .picker_done button[disabled] svg {
  display: block;
  stroke: #CED7E2;
}
.colorpicker .picker_done button.disabled.focus,
.colorpicker .picker_done button[disabled].focus,
.colorpicker .picker_done button.disabled:focus,
.colorpicker .picker_done button[disabled]:focus,
.colorpicker .picker_done button.disabled:focus-visible,
.colorpicker .picker_done button[disabled]:focus-visible {
  color: #CED7E2;
  border: 1px solid transparent;
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.colorpicker .picker_done button.disabled.active,
.colorpicker .picker_done button[disabled].active,
.colorpicker .picker_done button.disabled:active,
.colorpicker .picker_done button[disabled]:active {
  color: #CED7E2;
  border: 1px solid transparent;
  background: #E5EBF1;
}
.colorpicker .picker_done button.disabled.active.focus,
.colorpicker .picker_done button[disabled].active.focus,
.colorpicker .picker_done button.disabled:active.focus,
.colorpicker .picker_done button[disabled]:active.focus,
.colorpicker .picker_done button.disabled.active:focus,
.colorpicker .picker_done button[disabled].active:focus,
.colorpicker .picker_done button.disabled:active:focus,
.colorpicker .picker_done button[disabled]:active:focus,
.colorpicker .picker_done button.disabled.active:focus-visible,
.colorpicker .picker_done button[disabled].active:focus-visible,
.colorpicker .picker_done button.disabled:active:focus-visible,
.colorpicker .picker_done button[disabled]:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.colorpicker .picker_done button.disabled.hover,
.colorpicker .picker_done button[disabled].hover,
.colorpicker .picker_done button.disabled:hover,
.colorpicker .picker_done button[disabled]:hover {
  color: #CED7E2;
  border: 1px solid transparent;
  background: #E5EBF1;
}
.colorpicker .picker_done button.disabled.hover.active,
.colorpicker .picker_done button[disabled].hover.active,
.colorpicker .picker_done button.disabled:hover.active,
.colorpicker .picker_done button[disabled]:hover.active,
.colorpicker .picker_done button.disabled.hover:active,
.colorpicker .picker_done button[disabled].hover:active,
.colorpicker .picker_done button.disabled:hover:active,
.colorpicker .picker_done button[disabled]:hover:active {
  border-color: transparent;
  background: #E5EBF1;
}
.colorpicker .picker_done button.disabled.hover.active.focus,
.colorpicker .picker_done button[disabled].hover.active.focus,
.colorpicker .picker_done button.disabled:hover.active.focus,
.colorpicker .picker_done button[disabled]:hover.active.focus,
.colorpicker .picker_done button.disabled.hover:active.focus,
.colorpicker .picker_done button[disabled].hover:active.focus,
.colorpicker .picker_done button.disabled:hover:active.focus,
.colorpicker .picker_done button[disabled]:hover:active.focus,
.colorpicker .picker_done button.disabled.hover.active:focus,
.colorpicker .picker_done button[disabled].hover.active:focus,
.colorpicker .picker_done button.disabled:hover.active:focus,
.colorpicker .picker_done button[disabled]:hover.active:focus,
.colorpicker .picker_done button.disabled.hover:active:focus,
.colorpicker .picker_done button[disabled].hover:active:focus,
.colorpicker .picker_done button.disabled:hover:active:focus,
.colorpicker .picker_done button[disabled]:hover:active:focus,
.colorpicker .picker_done button.disabled.hover.active:focus-visible,
.colorpicker .picker_done button[disabled].hover.active:focus-visible,
.colorpicker .picker_done button.disabled:hover.active:focus-visible,
.colorpicker .picker_done button[disabled]:hover.active:focus-visible,
.colorpicker .picker_done button.disabled.hover:active:focus-visible,
.colorpicker .picker_done button[disabled].hover:active:focus-visible,
.colorpicker .picker_done button.disabled:hover:active:focus-visible,
.colorpicker .picker_done button[disabled]:hover:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px transparent;
}
.colorpicker .picker_done button-icon-16 .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
}
.colorpicker .picker_done button-icon-16 .icon svg {
  width: 16px;
  height: 16px;
  stroke-width: 2.4;
}
.colorpicker .picker_done button-icon-24 .icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
}
.colorpicker .picker_done button-icon-24 .icon svg {
  width: 24px;
  height: 24px;
  stroke-width: 1.4;
}
.colorpicker .picker_done button-icon-right {
  padding-right: 10px;
}
.colorpicker .picker_done button-icon-right .icon {
  order: 1;
  margin-left: 5px;
}
.colorpicker .picker_done button-icon-right .icon svg {
  fill: none;
}
.colorpicker .picker_done button-icon-left {
  padding-left: 10px;
}
.colorpicker .picker_done button-icon-left .icon {
  order: 0;
  margin-right: 5px;
}
.colorpicker .picker_done button-icon-left .icon svg {
  fill: none;
}
.colorpicker .picker_done button-icon-right.colorpicker .picker_done button-icon-left .icon {
  margin: 0;
}
.colorpicker .picker_done button-icon-only {
  padding: 0;
}
.colorpicker .picker_done button-icon-only.btn-icon-24 {
  min-height: 26px;
  max-height: 26px;
  max-width: 26px;
}
.colorpicker .picker_done button-icon-only.btn-icon-24 .icon {
  max-height: 24px;
  max-width: 24px;
}
.colorpicker .picker_done button-icon-only.btn-icon-16 {
  min-height: 18px;
  max-height: 18px;
  max-width: 18px;
}
.colorpicker .picker_done button-icon-only.btn-icon-16 .icon {
  max-height: 16px;
  max-width: 16px;
}
.colorpicker .picker_done button-icon-only.input-group-addon {
  min-height: 34px;
  max-height: none;
}
.colorpicker .picker_done button-icon-success .icon svg {
  fill: none;
  stroke: #73C677;
}
.colorpicker .picker_done button-glyph .icon svg {
  stroke: none;
}
.colorpicker .picker_done button.highlight {
  --color4: #60D3EC;
}
.colorpicker .picker_done button.has-submenu {
  padding: 0;
}
.colorpicker .picker_done button-red-text {
  color: #FC495D;
  padding-left: 1px;
}
.colorpicker .picker_done button svg {
  stroke: #10294D;
}
.colorpicker .picker_done button.input-group-addon {
  min-height: 34px;
  max-height: none;
  background: #F3F5F8;
  color: #10294D;
}
.colorpicker .picker_done button.input-group-addon svg {
  stroke: #10294D;
}
.colorpicker .picker_done button.focus,
.colorpicker .picker_done button:focus,
.colorpicker .picker_done button:focus-visible {
  color: #10294D;
  border: 1px solid transparent;
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.colorpicker .picker_done button.active,
.colorpicker .picker_done button:active {
  color: #10294D;
  border: 1px solid transparent;
  background: #E5EBF1;
}
.colorpicker .picker_done button.active.focus,
.colorpicker .picker_done button:active.focus,
.colorpicker .picker_done button.active:focus,
.colorpicker .picker_done button:active:focus,
.colorpicker .picker_done button.active:focus-visible,
.colorpicker .picker_done button:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.colorpicker .picker_done button.hover,
.colorpicker .picker_done button:hover {
  color: #10294D;
  border: 1px solid transparent;
  background: #E5EBF1;
}
.colorpicker .picker_done button.hover.active,
.colorpicker .picker_done button:hover.active,
.colorpicker .picker_done button.hover:active,
.colorpicker .picker_done button:hover:active {
  border-color: transparent;
  background: #E5EBF1;
}
.colorpicker .picker_done button.hover.active.focus,
.colorpicker .picker_done button:hover.active.focus,
.colorpicker .picker_done button.hover:active.focus,
.colorpicker .picker_done button:hover:active.focus,
.colorpicker .picker_done button.hover.active:focus,
.colorpicker .picker_done button:hover.active:focus,
.colorpicker .picker_done button.hover:active:focus,
.colorpicker .picker_done button:hover:active:focus,
.colorpicker .picker_done button.hover.active:focus-visible,
.colorpicker .picker_done button:hover.active:focus-visible,
.colorpicker .picker_done button.hover:active:focus-visible,
.colorpicker .picker_done button:hover:active:focus-visible {
  background: #E5EBF1;
  outline: none;
  box-shadow: 0px 0px 0px 3px #C3C9D2;
}
.extras-opt,
.extras-selected,
.extras-legend {
  display: flex;
  justify-content: space-between;
}
.extras-opt .extras-tags,
.extras-selected .extras-tags,
.extras-legend .extras-tags {
  display: flex;
  gap: 0 5px;
}
.extras-opt .extras-tag,
.extras-selected .extras-tag,
.extras-legend .extras-tag {
  font-size: 11px;
  display: block;
  border-radius: 2px;
  padding: 2px 5px;
  color: #5A6F89;
}
.extras-opt .extras-tag.group-tag,
.extras-selected .extras-tag.group-tag,
.extras-legend .extras-tag.group-tag {
  background: #E5EBF1;
}
.extras-opt .extras-tag.P24,
.extras-selected .extras-tag.P24,
.extras-legend .extras-tag.P24 {
  background: rgba(88, 172, 228, 0.3);
}
.extras-opt .extras-tag.PP,
.extras-selected .extras-tag.PP,
.extras-legend .extras-tag.PP {
  background: rgba(83, 216, 106, 0.3);
}
.extras-opt .extras-tag.DBZ,
.extras-selected .extras-tag.DBZ,
.extras-legend .extras-tag.DBZ {
  background: #ffe98a;
}
.extras-opt .extras-tag.BYT,
.extras-selected .extras-tag.BYT,
.extras-legend .extras-tag.BYT {
  background: rgba(40, 177, 109, 0.5);
}
.extras-opt .extras-tag.PF,
.extras-selected .extras-tag.PF,
.extras-legend .extras-tag.PF {
  background: #fda79d;
}
.extras-selected {
  align-content: center;
  line-height: 1;
  font-size: 11px;
}
.extras-selected .extras-label {
  display: flex;
  align-items: center;
}
.extras-selected .extras-tags {
  margin-left: 3px;
}
.extras-legend {
  color: #000;
  flex-wrap: wrap;
  justify-content: flex-end;
  min-width: 240px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.col .extras-legend {
  flex: 1 1 100%;
  justify-content: flex-start;
}
.extras-legend > div {
  display: flex;
  align-content: center;
  align-items: center;
  margin-right: 5px;
  margin-bottom: 10px;
}
.extras-legend > div .extras-tag {
  margin-left: 0;
  margin-right: 5px;
}
.model-form.view:not(.action) {
  display: grid;
  grid-area: view;
  grid-template-areas: "jump-menu" "form";
  grid-template-rows: 37px auto;
  padding: 0;
}
@media screen and (min-width: 799px) {
  .model-form.view:not(.action) {
    grid-template-areas: "jump-menu form";
    grid-template-columns: 260px auto;
    grid-template-rows: auto;
  }
}
.model-form.view:not(.action) .viewcontent {
  grid-area: form;
  position: relative;
  overflow: auto;
}
.jumplist {
  grid-area: jump-menu;
  background: #E5EBF1;
  top: 0;
  width: 100vw;
  height: 37px;
  max-height: 37px;
  overflow: hidden;
  z-index: 101;
  margin-bottom: 60px;
}
@media screen and (min-width: 799px) {
  .jumplist {
    top: 0;
    position: sticky;
    overflow: auto;
    height: auto;
    width: 260px;
    max-height: none;
    margin-bottom: 0;
  }
}
.jumplist + div {
  grid-area: details;
}
.jumplist.show {
  position: absolute;
  top: 66px;
  height: auto;
  max-height: none;
}
@media screen and (min-width: 799px) {
  .jumplist.show {
    position: relative;
    top: 0;
  }
}
.jumplist-inner {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.jumplist-inner a {
  background: #E5EBF1;
  height: 37px;
  flex: 0 0 100%;
  display: flex;
  align-items: center;
  padding: 8px 20px;
  color: #92A7C0;
  font-weight: 500;
}
.jumplist-inner a.active {
  background: #CED7E2;
  color: #10294D;
}
.jumplist-inner a:hover {
  background: #CED7E2;
  color: #10294D;
}
.vehicle-manager .search-fields {
  justify-content: unset;
}
.vehicle-manager .search-buttons {
  flex-wrap: nowrap;
  display: flex;
  gap: inherit;
  align-self: start;
}
.template-manager .search-buttons {
  flex: 0 0 100%;
}
.previewcontainer {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-bottom: 20px;
}
@media (min-width: 799px) {
  .previewcontainer {
    padding-left: 20px;
    padding-right: 20px;
  }
}
.previewcontainer .isloading {
  position: absolute;
  z-index: 999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.previewcontainer-nav {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 20px;
}
@media (min-width: 799px) {
  .previewcontainer-nav {
    padding-left: 0;
    padding-right: 0;
  }
}
.previewcontainer-nav .btn-highlight {
  text-align: center;
}
.previewcontainer-nav .nav-group {
  display: flex;
  gap: 10px 5px;
}
@media (max-width: 799px) {
  .previewcontainer-nav .nav-group:nth-of-type(2) {
    display: none;
  }
}
.previewcontainer-nav .nav-group .btn-icon-only {
  min-width: 38px;
  max-width: 38px;
  min-height: 38px;
  max-height: 38px;
  justify-content: center;
}
.previewcontainer-nav .seperator {
  margin: 0 10px;
  width: 0;
  border-right: 1px solid #cfcdcd;
}
.previewcontainer-nav .form-group {
  margin: 0;
}
.previewcontainer-nav .page {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  white-space: nowrap;
  justify-content: center;
  margin-right: 15px;
}
.previewcontainer-nav .page .forminput {
  flex: 1 1;
  margin-left: 3px;
  margin-right: 3px;
}
.previewcontainer-nav .page .page-jump {
  width: 36px;
  min-width: 36px;
  max-width: 36px;
  text-align: center;
}
.previewcontainer-nav .zoom {
  min-width: 150px;
}
.previewcontainer-content {
  margin-top: 20px;
  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);
  overflow: auto;
}
.previewcontainer-content iframe {
  width: 100%;
  border: none;
  overflow: visible;
}
.check-header {
  display: flex;
  flex: 1 1;
  color: #455870;
  font-weight: 500;
  justify-content: space-between;
}
.check-body {
  font-size: 12px;
  color: #455870;
}
.asset-selector {
  width: 100%;
  max-width: 100%;
  position: relative;
  overflow: hidden;
  height: 56px;
  max-height: 56px;
}
.asset-selector.selected {
  height: 230px;
  max-height: 230px;
  display: flex;
  justify-content: center;
}
.asset-selector .asset-selector-btn-container {
  position: absolute;
  width: 100%;
  margin: 10px -5px;
  display: flex;
  flex-direction: row-reverse;
}
.asset-selector .asset-selector-btn-container .asset-selector-btn:first-of-type {
  margin-left: 5px;
}
.asset-selector .asset-selector-btn-container .asset-selector-btn .btn-icon-only {
  min-height: 36px;
  max-height: 36px;
  max-width: 36px;
  padding: 6px 15px;
  justify-content: center;
}
.asset-selector .asset-item {
  margin-top: 5px;
}
.gallery-selector {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: min-content;
  width: 100%;
  max-width: 100%;
  position: relative;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  gap: 10px 10px;
  height: 300px;
  max-height: 300px;
}
.gallery-selector * {
  touch-action: none;
}
.gallery-selector .gallery-item {
  height: min-content;
  border-radius: 4px;
  position: relative;
  padding: 10px;
}
.gallery-selector .gallery-item.active {
  background: #CED7E2;
}
.gallery-selector .gallery-item .checkcontainer {
  justify-content: flex-start;
  align-items: flex-start;
  position: absolute;
  bottom: 0;
  right: 0;
  min-height: 24px;
}
.gallery-selector .gallery-item img {
  width: 100%;
  aspect-ratio: 4 / 3;
  max-height: 100%;
  max-width: 100%;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}
.gallery-selector .gallery-item.disabled .checkcontainer {
  display: none;
}
.gallery-selector .gallery-item.required .checkcontainer span {
  background: #FFB1B1;
}
.customopt .domstring {
  display: flex;
  gap: 14px 14px;
  align-items: center;
}
.customopt .check-image {
  min-width: 150px;
  max-width: 150px;
  height: 150px;
}
.customopt .check-image img {
  background: #ffffff;
  border-radius: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.customopt .check-listing .listing-property-type {
  color: #B2C2D4;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}
.customopt .check-listing .listing-address {
  color: #5A6F89;
  font-size: 13px;
  line-height: 21px;
}
.customopt .check-listing .listing-meta {
  display: flex;
  gap: 14px 14px;
  padding: 14px 0;
}
.customopt .check-listing .listing-meta svg {
  fill: none;
  stroke: #10294D;
  stroke-width: 2.4;
  width: 16px;
}
.customopt .check-listing .icon-value {
  display: flex;
  align-items: center;
  color: #5A6F89;
  gap: 2px 2px;
}
.customopt .check-listing .listing-price {
  font-size: 15px;
  font-weight: 600;
  color: #10294D;
}
.brochures .forminput,
.brochures .input-group {
  max-width: 100%;
}
.brochures .forminput [class^="col-"],
.brochures .input-group [class^="col-"],
.brochures .forminput [class*="col-"],
.brochures .input-group [class*="col-"] {
  min-width: 180px;
}
#field-to {
  margin-top: 1rem;
}
.versions-summary {
  padding: 20px;
  display: block;
}
.versions-summary:hover {
  background: #EBF5FF;
}
.versions-summary-top {
  display: flex;
  align-items: center;
  gap: 0 6px;
}
.versions-summary-top .avatar-md {
  max-width: 24px;
}
.versions-summary-top .avatar-md > .thumbimg {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.versions-summary-top .agents {
  display: flex;
  align-items: center;
  gap: 0 6px;
}
.versions-summary-date {
  margin-left: auto;
}
.versions-summary-pin .btn svg {
  stroke: #CED7E2;
}
.versions-summary-pin .btn.pinned svg {
  stroke: #10294D;
}
.versions-summary-tag-name .tag {
  background-color: #ffffff;
  border: 1px solid #CED7E2;
}
.versions-summary-body {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 20px 0 0;
  display: flex;
  justify-content: space-between;
  gap: 6px 6px;
}
.versions-summary-body .versions-summary-content {
  overflow: hidden;
}
.versions-summary-bottom {
  display: flex;
  gap: 6px 6px;
}
.versions-summary-bottom .versions-summary-comments {
  display: flex;
  align-items: center;
  gap: 0 6px;
  color: #10294D;
  font-weight: 600;
}
.versions-summary-bottom .versions-summary-comments .icon {
  width: 16px;
  height: 16px;
}
.versions-summary-bottom .versions-summary-comments svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: #CED7E2;
  stroke-width: 2.4;
}
.versions-summary .versions-summary-attachments {
  display: flex;
  align-items: center;
  gap: 0 6px;
  color: #10294D;
  font-weight: 600;
}
.versions-summary .versions-summary-attachments svg {
  width: 16px;
  fill: none;
  stroke: #CED7E2;
  stroke-width: 2.4;
}
.versions-summary .versions-summary-tag {
  border-radius: 30px;
  padding: 5px 8px;
  font-size: 10px;
  background: #B2C2D4;
  color: #ffffff;
}
.versions-summary .versions-summary-tag-related {
  border-radius: 30px;
  padding: 5px 8px;
  font-size: 10px;
  background: #CED7E2;
  color: #ffffff;
}
.check-input-group {
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 100%;
  border: 1px solid #E5EBF1;
  padding: 9px 15px 8px;
  border-radius: 4px;
}
.check-input-group fieldset {
  display: flex;
  flex: 0 0 100%;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: 0 15px;
}
.check-input-group fieldset .checkcontainer {
  display: flex;
  flex: 1 1 auto;
  align-items: flex-start;
  flex-wrap: nowrap;
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.check-input-group fieldset .checkcontainer .formlabel {
  font-weight: normal;
}
.match-filters-header .cardhead {
  padding-top: 20px;
  padding-bottom: 20px;
}
.match-filters-header .cardbody {
  display: none;
}
@media screen and (min-width: 799px) {
  .match-filters-header .match-filters {
    min-width: 910px;
  }
}
.match-filters {
  display: flex;
  gap: 20px 20px;
  align-items: flex-end;
  justify-content: space-between;
  min-height: 60px;
  margin: 10px;
}
@media screen and (max-width: 1200px) {
  .match-filters {
    align-items: flex-start;
    flex-direction: column;
  }
}
.match-filters h3 {
  line-height: auto;
  margin: 0;
}
.match-filters .filters-container {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
}
@media screen and (min-width: 799px) {
  .match-filters .filters-container {
    flex-direction: row;
    flex-wrap: wrap;
  }
}
.match-filters .filters-container > div {
  padding-right: 15px;
}
.match-filters .form-group {
  flex: 0 0 auto;
}
.match-filters .form-group .checkinput .forminput,
.match-filters .form-group .checkgroup {
  border: 0 !important;
  padding: 10px 0;
  font-size: 1.1rem;
}
.match-filters .form-group .checkinput .forminput:focus,
.match-filters .form-group .checkgroup:focus,
.match-filters .form-group .checkinput .forminput:focus-within,
.match-filters .form-group .checkgroup:focus-within {
  box-shadow: none;
}
.match-filters .form-group .checkinput .forminput .checkcontainer + label,
.match-filters .form-group .checkgroup .checkcontainer + label {
  min-width: 0;
}
.match-filters .check-input-group {
  border: 0;
  padding: 0;
}
.match-filters .check-input-group .checkcontainer {
  display: contents;
}
.match-filters .check-input-group > .input-label {
  display: none;
}
.match-filters .score {
  width: 100%;
  max-width: 360px;
  /* Adjust the maximum width as needed */
  min-width: 0;
}
.vacancy-list {
  flex: 0 0 100%;
}
.vacancy-list .vacancy-wrapper {
  display: flex;
  align-items: center;
  gap: 20px 20px;
}
.vacancy-list .vacancy-wrapper + .vacancy-wrapper {
  margin-top: 20px;
}
.vacancy-list .vacancy-wrapper .vacancy-image {
  flex: 0 0 186px;
  width: 186px;
  height: 150px;
}
.vacancy-list .vacancy-wrapper .vacancy-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.vacancy-list .vacancy-wrapper .vacancy-data {
  display: flex;
  flex: 1 1 auto;
  min-width: 280px;
}
.vacancy-list .vacancy-wrapper .vacancy-data h5 {
  margin-bottom: 0;
}
.vacancy-list .vacancy-wrapper .vacancy-data svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: #10294D;
  margin-right: 5px;
}
.vacancy-list .vacancy-wrapper .vacancy-data span {
  display: inline-flex;
  align-items: center;
  align-content: center;
  white-space: nowrap;
  text-align: right;
}
.vacancy-list .vacancy-wrapper .vacancy-meta {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
}
.vacancy-list .vacancy-wrapper .vacancy-meta > * {
  flex: 0 0 100%;
}
.vacancy-list .vacancy-wrapper .vacancy-meta > * + * {
  margin: 10px 0 0 0;
}
.vacancy-list .vacancy-wrapper .vacancy-price {
  flex: 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  white-space: nowrap;
  text-align: right;
}
.vacancy-list .vacancy-wrapper .vacancy-price .btn {
  margin-top: auto;
}
.bulkedit .container-fluid {
  padding-top: 20px;
}
.vacancy-agent-detail {
  flex: 0 0;
  display: inline-block;
  flex-wrap: wrap;
}
.company-user-detail {
  display: flex;
  flex-wrap: nowrap;
}
.company-user-detail > div {
  display: flex;
  flex-wrap: wrap;
}
.vacancy-agent-email {
  padding-left: 19px;
}
.vacancy-show-contact-detail {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  cursor: pointer;
}
.vacancy-show-contact-detail .btn:hover {
  background-color: #ffffff;
}
.vacancy-hide-contact-detail {
  display: none;
}
.vacancy-hide-agent-contact-detail {
  display: none;
}
.vacancy-show-agent-contact-detail {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  color: #fc495d;
  background: #ffffff;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  padding-left: 1px;
  border: none;
  font-family: 'Poppins', sans-serif;
}
.brochure-generator {
  grid-template-areas: "form" "pane";
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  min-width: 0;
  min-height: 0;
  gap: 20px;
  margin: -20px;
  position: relative;
}
@media screen and (min-width: 799px) {
  .brochure-generator {
    display: grid;
    grid-template-areas: "form pane";
    grid-template-columns: 400px 1fr;
  }
}
.brochure-generator .brochure-form {
  min-height: 0;
  overflow: auto;
  padding: 20px;
  grid-area: form;
}
.brochure-generator .brochure-preview {
  grid-area: pane;
  min-height: 0;
  overflow: auto;
  padding: 20px;
}
@media screen and (min-width: 799px) {
  .brochure-generator .brochure-preview {
    padding: 20px 20px 0 0;
  }
}
.area-groups-search .field {
  padding: 0;
}
#field-modules {
  padding-left: 0;
  padding-right: 0;
}
#field-modules .checkgroup {
  flex: 1 1 100%;
}
#field-modules .checkinput {
  padding: 9px 20px 8px;
}
#field-modules .checkinput .input-label {
  top: unset;
  left: unset;
  position: unset;
  background: none;
  flex: 1 1;
}
#field-modules .checkinput.checked {
  background: #EBF5FF;
}
#field-modules .checkcontainer {
  flex: 0 0 24px;
}
#field-modules .credit-check-option {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 9px 20px 8px;
}
#field-modules .credit-check-option > div {
  display: flex;
  flex-direction: column;
}
#field-modules .credit-check-option strong {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  /* Primary/100 */
  color: #10294D;
}
#field-modules .credit-check-option span {
  white-space: normal;
  /* Frame 1601 */
  font-size: 12px;
  line-height: 18px;
  font-weight: normal;
  color: #455870;
}
.templates-search {
  display: flex;
}
.templates-search > div {
  display: flex;
  flex: 1 1 100%;
}
.templates-search > div .search-fields {
  margin-bottom: 10px;
  flex: 1 1 100%;
}
.templates-search > div .search-fields > .field {
  margin-right: auto;
}
.report-table-criteria {
  display: grid;
  grid-template-columns: auto fit-content(100px);
  align-items: center;
}
.report-table-criteria .report-table-criteria-list {
  display: inline-flex;
}
.report-table-criteria .report-table-criteria-buttons {
  min-width: 0;
}
.thumb {
  display: inline-block;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #efefef;
  transition: all 0.3s ease 0s;
}
.thumb.small,
.thumb.small .thumbimg {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}
.thumb .thumbimg {
  display: inline-block;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background-color: #f5f5f5;
  background-position: center center;
  background-size: cover;
  transition: all 0.3s ease 0s;
  transform: scale(1) translateZ(1000px);
}
.thumb .thumbimg svg {
  width: 100%;
  height: 100%;
}
.thumb:hover {
  box-shadow: -1px 1px 3px 0px rgba(0, 0, 0, 0.2), 1px -1px 3px 0px rgba(0, 0, 0, 0.2);
}
.thumb:hover .thumbimg {
  transform: scale(1.15) translateZ(1000px);
}
.agent {
  display: flex;
  text-align: left;
  margin-right: 20px;
}
.single-user.agent .thumb {
  display: block;
}
.branchagents,
.teammembers {
  display: flex;
}
.branchagents > .row,
.teammembers > .row {
  flex-grow: 1;
}
.branchagents > .row > .col,
.teammembers > .row > .col {
  flex-grow: 0;
}
.branchagents h3,
.teammembers h3 {
  box-sizing: border-box;
  padding: 0 15px;
  margin-top: 30px;
  line-height: 22px;
  min-height: 2em;
}
.branchagents .agents,
.teammembers .agents {
  display: flex;
}
.branchagents .agent,
.teammembers .agent {
  padding: 0 15px;
  margin-top: 15px;
  justify-content: center;
}
@media (max-width: 799px) {
  .branchagents > .row .col,
  .teammembers > .row .col {
    flex-grow: 1;
  }
}
@media (min-width: 799px) {
  .branchagents h3,
  .teammembers h3 {
    margin-top: 0;
  }
  .branchagents .agent,
  .teammembers .agent {
    margin: 0;
  }
}
.branchstats {
  margin: 30px 0;
}
.branchstats .row {
  justify-content: flex-start;
}
.branchstats .singlestat {
  text-align: left;
  flex: 0 1 200px;
  max-width: none;
}
@media (max-width: 799px) {
  .branchstats .singlestat {
    flex: 0 1 300px;
    text-align: center;
  }
}
.branchstats .singlestat:last-of-type {
  margin-right: auto;
}
.branchstats .singlestat h1 {
  color: #FC495D;
  margin: 15px 0 0;
  line-height: 1;
}
.branchstats .singlestat h4 {
  font-size: 1.5rem;
  margin: 0;
}
.branchstats .singlestat p {
  font-size: 1.1rem;
  margin: 0;
}
.branchstats .singlestat svg {
  width: 80px;
  height: auto;
  fill: #979797;
}
.branchmap {
  max-height: 280px;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  position: relative;
}
.branchmap img {
  width: 100%;
}
.pie-graph {
  margin-top: 60px;
  padding: 0 15px;
  font-size: 1rem;
  flex: 1 1 360px;
  display: flex;
  flex-wrap: wrap;
}
@media screen and (min-width: 799px) {
  .pie-graph {
    margin-top: 30px;
    max-width: 360px;
  }
}
.pie-graph svg {
  margin: 0;
}
@media screen and (min-width: 799px) {
  .pie-graph svg {
    padding: 0 15px 0 0;
  }
}
.pie-graph h4 {
  flex: 0 0 100%;
}
.pie-graph-wrapper {
  flex: 1 1 100%;
  display: flex;
  flex-wrap: wrap;
}
@media screen and (min-width: 799px) {
  .pie-graph-wrapper {
    margin-top: 0;
    flex-wrap: nowrap;
  }
}
.pie-graph-legend {
  margin-top: 16px;
  padding: 0;
}
.pie-graph-legend li {
  list-style: none;
  white-space: nowrap;
}
.pie-graph-legend li .pie-graph-legend-color {
  display: inline-block;
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 3px;
}
.pie-graph-legend li span {
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
}
.login .content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow: auto;
}
.login .overlay {
  display: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  width: 100%;
  min-height: 100%;
}
.webp .login .overlay {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.no-webp .login .overlay {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.login .overlay:after {
  content: "";
  position: absolute;
  top: 30%;
  right: 5%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  width: 180px;
  height: 180px;
}
@media (min-width: 799px) {
  .login .overlay {
    display: block;
    width: 100%;
    min-height: 100%;
    z-index: -1;
  }
}
.login .pd-logo {
  width: 208px;
  height: 54px;
  flex: 0 0 208px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.login .content-wrapper {
  flex: 1 1 40%;
  position: relative;
  min-width: 320px;
  min-height: 100%;
  display: grid;
  grid-template-rows: auto 92px;
  align-items: center;
  flex-wrap: wrap;
  background: #ffffff;
}
.login .login-box,
.login .welcome,
.login .agentselector {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  flex: 1 1 100%;
}
.login .login-box,
.login .agentselector {
  overflow: hidden;
  margin: 0 0;
  padding-top: 30px;
  padding-bottom: 30px;
}
.login .login-box .scrollview:after,
.login .agentselector .scrollview:after {
  content: "";
  height: 30px;
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff 95%);
  position: sticky;
  display: block;
  bottom: 0;
  left: 0;
  right: 0;
}
.login .welcome h2,
.login .welcome h1 {
  color: #ffffff;
  background-color: #FC495D;
  font-weight: 500;
  padding: 10px 15px;
  display: inline-block;
  margin-top: 10px;
}
.login .form-group {
  position: relative;
  margin-bottom: 24px;
}
.login .forgot {
  margin-top: 1px;
  margin-left: auto;
  font-size: 12px;
  color: #78789A;
}
.login .forgot.float-right {
  margin-left: 0;
}
.login .login-box {
  text-align: center;
  background: #ffffff;
  height: 650px;
}
.login .login-box h3 {
  color: #10294D;
  flex: 1 1 100%;
  font-weight: 500;
  padding: 20px 0 0;
}
.login .login-box h3 span {
  font-weight: 600;
}
.login .login-box-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.login .login-box-buttons a {
  margin-right: auto;
}
.login .login-box form {
  width: 100%;
}
.login .login-box-body {
  background: #ffffff;
  padding: 20px 10%;
  border-top: 0;
  max-width: 100%;
  width: 100%;
  min-height: 95px;
}
.login .login-box-body p:first-of-type {
  margin-bottom: 30px;
}
.login .login-box-body .form-control-feedback {
  color: #777;
}
.login .login-box-body .box-header,
.login .login-box-body .box-header span {
  text-align: center;
}
.login .login-box-body .box-header h3,
.login .login-box-body .box-header span h3 {
  display: inline-block;
}
.login .login-box .message {
  background-color: #fff;
  font-size: 1.1rem;
  width: 100%;
  color: #fff;
  margin-top: 30px;
  padding: 10px;
}
.login .login-box .message.error {
  background-color: #FF6464;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login .login-box .message.success {
  background-color: #73C677;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login .login-box .social-logins {
  text-align: center;
  padding-top: 0;
  padding-bottom: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}
.login .login-box .social-logins span {
  color: #70859E;
  font-size: 14px;
  flex: 0 0 100%;
}
.login .login-box .social-logins > div {
  flex: 0 0 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px;
}
.login .login-box .social-logins a {
  flex: 1 1 auto;
  height: 44px;
  border: 1px solid #E5EBF1;
  border-radius: 4px;
  color: #10294D;
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.login .login-box .social-logins a svg {
  flex: 0 0 20px;
  height: 20px;
  margin-right: 8px;
}
.login .login-box .social-logins a:hover {
  background-color: #eeeeee;
}
.login .footer {
  min-height: 50px;
  background: none;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  padding: 0.75rem 15px;
  margin: 0;
  color: #92A7C0;
}
.login .footer a {
  color: #92A7C0;
}
.login .login-box-footer {
  background: #fff;
  margin: auto 0 0;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0 20px 20px 20px;
  display: flex;
  bottom: 50px;
  left: 0;
  right: 0;
}
.login .login-box-footer > a {
  text-align: center;
  color: #FC495D;
}
.login .help-text {
  margin-bottom: 0;
}
.login .help-text .fa-question-circle {
  font-size: 38px;
  margin-right: 5px;
}
.login .agentselector {
  background-color: #fff;
  text-align: center;
  justify-content: center;
}
.login .agentselector h3 {
  margin: 0 ;
  padding: 10px 0;
}
.login .agentselector .agent-option {
  align-items: center;
  display: flex;
  box-shadow: 0px 1px 0px #E5EBF1;
  max-width: 100%;
  overflow: hidden;
}
.login .agentselector .agent-option:first-of-type {
  border-top: none;
}
.login .agentselector .agent-option:hover {
  cursor: pointer;
}
.login .agentselector .agent-option > div {
  padding: 10px 20px;
  color: #B2C2D4;
  font-size: 11px;
}
.login .agentselector .agent-option > div .site-name {
  text-transform: uppercase;
  font-weight: 600;
}
.login .agentselector .agent-option > div .site-domain {
  font-weight: 500;
}
.login .agentselector .agent-option > div .site-email {
  font-weight: 500;
}
.login .agentselector .agent-option > div svg {
  fill: #FC495D;
  stroke: none;
}
.login .agentselector .agent-option > div:first-of-type {
  padding: 0px;
  padding-left: 20px;
}
.login .agentselector .agent-option > div:last-of-type {
  text-align: left;
}
.login .agentselector .notfound {
  align-items: center;
  flex-direction: column;
  font-size: 1.2rem;
  padding: 20px 0;
}
.login .agentselector .notfound h4 {
  font-size: 1.3rem;
  padding: 10px 0;
  display: block;
}
.timeline {
  padding-bottom: 60px;
  position: relative;
}
.timeline-bar {
  text-align: center;
  position: absolute;
  width: 50px;
  top: 0;
  bottom: 5px;
}
.timeline-bar:before {
  content: "";
  height: 100%;
  display: inline-block;
  width: 3px;
  background: #E5EBF1;
}
.timeline-bar:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-image: linear-gradient(to bottom, transparent, #F3F5F8);
}
.timeline-heading {
  padding-left: 50px;
  padding-right: 15px;
  padding-top: 20px;
  margin-top: 0;
  margin-bottom: 30px;
  margin-left: 0;
  min-width: 0;
}
.timeline-event {
  display: flex;
  flex-wrap: nowrap;
  padding-right: 20px;
}
.timeline-event-day {
  text-align: center;
  position: relative;
  padding: 0;
  z-index: 1;
  margin-top: 14px;
  min-width: 50px;
  flex: 0 0 50px;
  color: #FC495D;
}
.timeline-event-day:before {
  content: "";
  background: #fff;
  width: 14px;
  height: 14px;
  position: absolute;
  left: 50%;
  top: 0;
  margin-left: -7px;
  margin-top: -12px;
  border-radius: 50%;
  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);
}
.timeline-event-day:after {
  content: "";
  background: #FC495D;
  width: 8px;
  height: 8px;
  position: absolute;
  left: 50%;
  top: 0;
  margin-left: -4px;
  margin-top: -9px;
  border-radius: 50%;
  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);
}
.timeline-event-card {
  flex: 1 1 auto;
  padding: 0;
  min-width: 0;
}
.timeline-event-card .cardhead {
  margin-left: -15px;
  margin-right: -15px;
}
.timeline-event-card .card {
  overflow: hidden;
}
.timeline-event-card-right {
  min-width: 0;
}
.timeline-event-card-header {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #B2C2D4;
  padding: 0 0 10px 0;
}
.timeline-event-card-changes {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 0;
}
.timeline-event-card-changes > div {
  flex: 0 0 100%;
}
.timeline-event-card-body {
  display: flex;
  color: #92A7C0;
}
.timeline-event-card-body h4 {
  padding: 5px 0 5px 0;
}
.timeline-event-card-body h5 {
  color: #979797;
  padding: 0px 0 20px 0;
}
.timeline-event-card-body code,
.timeline-event-card-body pre {
  background: #F3F5F8;
  padding: 2px 5px;
  line-height: 1.2em;
}
.timeline-event-card-body code ul,
.timeline-event-card-body pre ul {
  padding-top: 0;
  margin: 0;
  margin-bottom: 5px;
  background: #F3F5F8;
}
.timeline-event-card-body strong {
  color: #10294D;
}
.timeline-event-card-body .agent .thumbimg {
  display: flex;
  justify-content: center;
  align-items: center;
}
.timeline-event-card-footer {
  display: flex;
  align-items: center;
  font-size: 11px;
  color: #979797;
  padding: 0;
  font-weight: 600;
  padding-top: 20px;
}
.timeline-event-card .notebody {
  padding-bottom: 15px;
  font-size: 1.2rem;
}
.timeline-event-card .notebody > p {
  font-size: inherit;
}
.noteauthor,
.noteauthor a {
  color: #B2C2D4;
  font-size: 11px;
  font-weight: 600;
}
.wide-sidebar-pane .activity {
  padding-left: 15px;
}
.wide-sidebar-pane .activity .timeline-bar:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
}
.pdfcontainer-nav {
  flex-wrap: wrap;
  display: flex;
  justify-content: space-between;
  margin-left: -15px;
  margin-right: -15px;
  padding: 0 15px;
}
.pdfcontainer-nav .btn-highlight {
  text-align: center;
}
.pdfcontainer-nav .nav-group {
  display: flex;
  gap: 10px 5px;
}
@media (max-width: 799px) {
  .pdfcontainer-nav .nav-group:nth-of-type(2) {
    display: none;
  }
}
.pdfcontainer-nav .nav-group .btn-icon-only {
  min-width: 38px;
  max-width: 38px;
  min-height: 38px;
  max-height: 38px;
  justify-content: center;
}
.pdfcontainer-nav .seperator {
  margin: 0 10px;
  width: 0;
  border-right: 1px solid #cfcdcd;
}
.pdfcontainer-nav .form-group {
  margin: 0;
}
.pdfcontainer-nav .page {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  white-space: nowrap;
  justify-content: center;
  margin-right: 15px;
}
.pdfcontainer-nav .page.form-group .forminput {
  flex: 1 1 auto;
  margin-left: 3px;
  margin-right: 3px;
}
.pdfcontainer-nav .page .page-jump {
  width: 36px;
  min-width: 36px;
  max-width: 36px;
  text-align: center;
}
.pdfcontainer-nav .zoom {
  min-width: 150px;
}
.react-pdf {
  overflow: auto;
  cursor: grab;
}
.react-pdf .text-center {
  display: flex;
  min-height: 68px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.react-pdf .text-center .message {
  flex: 0 0 100%;
}
.react-pdf__Highlighting {
  cursor: auto;
}
.react-pdf__Scrolling {
  cursor: grabbing;
}
.react-pdf__Document {
  text-align: center;
  padding: 20px 0;
}
.react-pdf__Page {
  margin: 20px;
  display: inline-block;
  text-align: initial;
  border: 1px solid rgba(0, 0, 0, 0.14);
  box-shadow: 8px 8px 16px -2px rgba(0, 0, 0, 0.14);
}
.react-pdf__Page__annotations {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  opacity: 0.2;
  line-height: 1;
}
.react-pdf__Page__annotations > section {
  color: transparent;
  position: absolute;
  white-space: pre;
  cursor: text;
  transform-origin: 0% 0%;
}
.react-pdf__Page__annotations > .linkAnnotation > a {
  position: absolute;
  font-size: 1em;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.no-pdf {
  background: #F3F5F8;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
}
/*!
 jodit - Jodit is awesome and usefully wysiwyg editor with filebrowser
 Author: Chupurnov <chupurnov@gmail.com> (https://xdsoft.net/)
 Version: v3.2.44
 Url: https://xdsoft.net/jodit/
 License(s): GPL-2.0-or-later
*/
.jodit,
.jodit *,
.jodit_container,
.jodit_container * {
  box-sizing: border-box;
}
.jodit .jodit_workplace,
.jodit_container .jodit_workplace {
  position: relative;
  overflow: auto;
}
.jodit .jodit_workplace .jodit_wysiwyg,
.jodit .jodit_workplace .jodit_wysiwyg_iframe,
.jodit_container .jodit_workplace .jodit_wysiwyg,
.jodit_container .jodit_workplace .jodit_wysiwyg_iframe {
  height: 100%;
  width: 100%;
}
.jodit_container:not(.jodit_inline) {
  background: #fff;
  font-size: 14px;
  font-family: Helvetica, sans-serif;
}
.jodit_container:not(.jodit_inline).jodit_disabled {
  background: hsla(0, 0%, 88%, 0.99);
}
.jodit_container:not(.jodit_inline).jodit_disabled .jodit_workplace {
  opacity: 0.4;
}
.jodit_container:not(.jodit_inline) .jodit_workplace {
  border: 1px solid #ccc;
}
.jodit_disabled {
  -webkit-user-select: none!important;
  user-select: none !important;
}
.jodit_hidden {
  display: none !important;
}
.jodit_wysiwyg {
  outline: 0;
}
.jodit_wysiwyg::selection,
.jodit_wysiwyg ::selection {
  background: #b5d6fd;
  color: #000;
}
.jodit_container:not(.jodit_inline) .jodit_wysiwyg {
  margin: 0;
  padding: 10px;
  outline: 0;
  overflow-x: auto;
  position: relative;
}
.jodit_container:not(.jodit_inline) .jodit_wysiwyg img {
  position: relative;
  max-width: 100%;
}
.jodit_container:not(.jodit_inline) .jodit_wysiwyg p,
.jodit_container:not(.jodit_inline) .jodit_wysiwyg pre {
  margin: 0 0 10px;
}
.jodit_container:not(.jodit_inline) .jodit_wysiwyg h1,
.jodit_container:not(.jodit_inline) .jodit_wysiwyg h2,
.jodit_container:not(.jodit_inline) .jodit_wysiwyg h3,
.jodit_container:not(.jodit_inline) .jodit_wysiwyg h4,
.jodit_container:not(.jodit_inline) .jodit_wysiwyg h5 {
  margin-top: 0;
}
.jodit_container:not(.jodit_inline) .jodit_wysiwyg blockquote {
  border-left: 2px solid #222;
  margin-left: 0;
  padding-left: 5px;
  color: #222;
}
.jodit_container:not(.jodit_inline) .jodit_wysiwyg jodit-media {
  position: relative;
}
.jodit_container:not(.jodit_inline) .jodit_wysiwyg jodit-media * {
  position: relative;
  z-index: 0;
}
.jodit_container:not(.jodit_inline) .jodit_wysiwyg jodit-media:before {
  z-index: 1;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.jodit_clearfix:after,
.jodit_clearfix:before {
  content: " ";
  display: table;
}
.jodit_clearfix:after {
  clear: both;
}
.jodit_dark_theme.jodit_container,
.jodit_dark_theme.jodit_container.jodit_disabled {
  background-color: #575757;
}
.jodit_dark_theme .jodit_workplace {
  border-color: rgba(87, 87, 87, 0.8);
}
.jodit_dark_theme .jodit_statusbar {
  background-color: rgba(95, 92, 92, 0.8);
  border-color: rgba(87, 87, 87, 0.8);
}
.jodit_dark_theme .jodit_statusbar,
.jodit_dark_theme .jodit_statusbar .jodit_statusbar_item span {
  color: #d1cccc;
}
.jodit_dark_theme .jodit_toolbar_popup,
.jodit_dark_theme .jodit_toolbar_popup-inline,
.jodit_dark_theme .jodit_toolbar_popup-inline:before,
.jodit_dark_theme .jodit_toolbar_popup:before {
  background: #575757;
}
.jodit_dark_theme .jodit_toolbar {
  background: #5f5c5c;
  border-color: rgba(87, 87, 87, 0.8);
}
.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn > a {
  color: #d1cccc;
}
.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn > a:hover {
  background-color: #575757;
}
.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn.jodit_toolbar_btn-break {
  border-top-color: #686767;
}
.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn.jodit_toolbar_btn-separator {
  border-right-color: #686767;
}
.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn.active,
.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn.jodit_active,
.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn:active,
.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn:hover {
  background-color: #575757;
}
.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn.jodit_with_dropdownlist .jodit_with_dropdownlist-trigger {
  border-top-color: silver;
}
.jodit_dark_theme .jodit_icon {
  fill: silver;
}
.jodit_dark_theme .jodit_wysiwyg,
.jodit_dark_theme .jodit_wysiwyg_iframe {
  background-color: #575757;
  color: #d1cccc;
}
.jodit_dark_theme .jodit_wysiwyg [data-jodit-selected-cell],
.jodit_dark_theme .jodit_wysiwyg_iframe [data-jodit-selected-cell] {
  border-color: #152f5f;
}
.jodit_dark_theme .jodit_dropdownlist {
  background: #5f5c5c;
}
.jodit_dark_theme .jodit_tabs .jodit_tabs_buttons > a {
  background-color: #686767;
  color: #d1cccc;
}
.jodit_dark_theme .jodit_tabs .jodit_tabs_buttons > a:hover {
  background-color: hsla(0, 0%, 41%, 0.8);
  color: #d1cccc;
  border-color: hsla(0, 0%, 41%, 0.9);
}
.jodit_dark_theme .jodit_tabs .jodit_tabs_buttons > a.active {
  background: rgba(81, 81, 81, 0.41);
  border-color: #686767;
}
.jodit_dark_theme .jodit_tabs .jodit_tabs_buttons > a svg {
  fill: silver;
}
.jodit_dark_theme .jodit_form input[type=text],
.jodit_dark_theme .jodit_form input[type=url],
.jodit_dark_theme .jodit_form textarea {
  background-color: rgba(81, 81, 81, 0.41);
  border-color: #686767;
  color: #d1cccc;
}
.jodit_dark_theme .jodit_form button {
  background-color: hsla(0, 0%, 41%, 0.75);
  color: #d1cccc;
}
.jodit_dark_theme .jodit_placeholder {
  color: hsla(0, 5%, 81%, 0.8);
}
.jodit_dark_theme .jodit_draganddrop_file_box,
.jodit_dark_theme .jodit_uploadfile_button {
  color: #d1cccc;
}
.jodit_dark_theme .jodit_draganddrop_file_box:hover,
.jodit_dark_theme .jodit_uploadfile_button:hover {
  background-color: hsla(0, 0%, 41%, 0.75);
}
.jodit_dark_theme .jodit-add-new-line:before {
  border-top-color: #686767;
}
.jodit_dark_theme .jodit-add-new-line span {
  background: hsla(0, 0%, 41%, 0.75);
  border-color: #686767;
}
.jodit_dark_theme .jodit-add-new-line span svg {
  fill: #d1cccc;
}
.jodit_dark_theme .jodit_resizer > i {
  background: hsla(0, 0%, 41%, 0.75);
  border-color: silver;
}
.jodit_btn {
  border: 1px solid;
  border-radius: 0;
  background-color: #f5f5f5;
  background-image: linear-gradient(180deg, #fff, #e6e6e6);
  border-color: #ccc;
  text-shadow: 0 1px 1px hsla(0, 0%, 100%, 0.75);
  color: #333;
  background-repeat: repeat-x;
  outline: 0;
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.jodit_btn:hover {
  background-color: #e6e6e6;
  background-position: 0 -15px;
  text-decoration: none;
}
.jodit_btn.jodit_btn_success {
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
  background-color: #5bb75b;
  background-image: linear-gradient(180deg, #62c462, #51a351);
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  color: #fff;
}
.jodit_btn.jodit_btn_success svg {
  fill: #fff;
}
.jodit_btn.jodit_btn_success:hover {
  background-color: #51a351;
}
.jodit_btn.jodit_btn_danger {
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
  background-color: #da4f49;
  background-image: linear-gradient(180deg, #ee5f5b, #bd362f);
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  color: #fff;
}
.jodit_btn.jodit_btn_danger svg {
  fill: #fff;
}
.jodit_btn.jodit_btn_danger:hover {
  background-color: #bd362f;
}
.jodit_btn.jodit_btn_inverse {
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
  background-color: #363636;
  background-image: linear-gradient(180deg, #444, #222);
  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
  color: #fff;
}
.jodit_btn.jodit_btn_inverse svg {
  fill: #fff;
}
.jodit_btn.jodit_btn_inverse:hover {
  background-color: #222;
}
.jodit_btn.active,
.jodit_btn:active {
  background-image: none;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05);
}
.jodit_btn_group {
  font-size: 0;
  vertical-align: middle;
}
.jodit_btn_group input {
  display: none;
}
.jodit_btn_group button {
  float: left;
}
.jodit_btn_group button + button {
  margin-left: -1px;
}
.jodit_btn_group button:first-child,
.jodit_btn_group input:first-child + button {
  border-right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.jodit_btn_group button:last-child,
.jodit_btn_group input:last-child + button {
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.jodit_btn_group:after {
  content: "";
  clear: both;
  float: none;
  display: table;
}
.jodit_context_menu {
  font-family: Helvetica, sans-serif;
  display: none;
  background: #fff;
  position: absolute;
  min-width: 150px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.24);
  z-index: 15;
}
.jodit_context_menu a {
  display: block;
  border-bottom: 1px solid hsla(0, 0%, 80%, 0.24);
  text-decoration: none!important;
  color: #727272;
}
.jodit_context_menu a svg {
  float: left;
  display: block;
  width: 18px;
  height: 28px;
  margin: 0 4.5px;
  fill: #727272;
}
.jodit_context_menu a span {
  margin-left: 27px;
  display: block;
  padding: 5px;
  border-left: 1px solid hsla(0, 0%, 80%, 0.24);
  line-height: 18px;
}
.jodit_context_menu a:hover {
  background-color: #e3e3e3;
  color: #000;
}
.jodit_context_menu a:hover .jodit_icon {
  fill: #000;
}
.jodit_context_menu a:last-child {
  border: 0;
}
.jodit_context_menu-show {
  display: block;
}
.jodit_dialog_box {
  box-sizing: border-box;
  display: none;
  width: 0;
  height: 0;
  border: 0;
  position: absolute;
  will-change: left, top, width, height;
}
.jodit_dialog_box.jodit_dialog_box-moved {
  -webkit-user-select: none;
  user-select: none;
}
.jodit_dialog_box * {
  box-sizing: border-box;
}
.jodit_dialog_box .jodit_elfinder,
.jodit_dialog_box .jodit_elfinder * {
  box-sizing: content-box;
  box-sizing: initial;
}
.jodit_dialog_box .jodit_dialog_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 13;
  text-align: center;
  white-space: nowrap;
  overflow: auto;
  display: none;
  background-color: rgba(0, 0, 0, 0.5);
}
.jodit_dialog_box.active,
.jodit_dialog_box.jodit_modal .jodit_dialog_overlay {
  display: block;
}
.jodit_dialog_box .jodit_dialog {
  z-index: 14;
  display: inline-block;
  vertical-align: middle;
  white-space: normal;
  text-align: left;
  position: fixed;
  left: 0;
  top: 0;
  background-color: #fff;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  min-width: 200px;
  min-height: 100px;
}
@media (max-width: 480px) {
  .jodit_dialog_box .jodit_dialog {
    max-width: 100%;
    width: 100%!important;
    height: 100%!important;
    top: 0!important;
    left: 0 !important;
  }
}
.jodit_dialog_box .jodit_dialog .jodit_promt {
  max-width: 300px;
  min-width: 200px;
  padding: 10px;
  word-break: break-all;
}
.jodit_dialog_box .jodit_dialog .jodit_promt label {
  margin-bottom: 5px;
  display: block;
}
.jodit_dialog_box .jodit_dialog .jodit_promt input[type=text] {
  display: block;
  border: 1px solid #ccc;
  background: #fff;
  width: 100%;
  height: 28px;
  line-height: 16px;
  padding: 3px 6px;
  outline: none;
}
.jodit_dialog_box .jodit_dialog .jodit_alert {
  max-width: 300px;
  min-width: 200px;
  padding: 10px;
  word-break: break-all;
}
.jodit_dialog_box .jodit_dialog .jodit_button {
  padding: 0;
  margin: 0;
  border: 0;
  display: inline-block;
  vertical-align: top;
  width: 32px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
}
.jodit_dialog_box .jodit_dialog .jodit_button:not(.disabled):hover {
  background-color: #ecebe9;
}
.jodit_dialog_box .jodit_dialog .jodit_button.disabled {
  opacity: 0.7;
}
.jodit_dialog_box .jodit_dialog .jodit_input {
  border: 1px solid #ccc;
  padding: 5px;
  background-color: #fff;
  outline: 0;
  width: 120px;
  margin-left: 10px;
  font: 13px Arial;
  height: 28px;
  vertical-align: middle;
}
.jodit_dialog_box .jodit_dialog select.jodit_input {
  width: 75px;
}
.jodit_dialog_box .jodit_dialog .jodit_button .jodit_icon,
.jodit_dialog_box .jodit_dialog .jodit_button svg,
.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_icon,
.jodit_dialog_box .jodit_dialog .jodit_dialog_header svg {
  width: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: middle;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_header {
  display: flex;
  justify-content: space-between;
  text-align: left;
  color: #222;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16), 0 1px 2px rgba(0, 0, 0, 0.23);
  cursor: move;
  height: 48px;
  overflow: hidden;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-title,
.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-toolbar {
  flex-shrink: 3;
  font-size: 18px;
  margin: 0;
  font-weight: 400;
  line-height: 48px;
  vertical-align: top;
  padding: 0 10px;
}
@media (max-width: 480px) {
  .jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-title,
  .jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-toolbar {
    padding-left: 0;
  }
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_header button {
  margin-right: 10px;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-button {
  color: #222;
  font-size: 28px;
  transition: background-color 0.2s ease 0s;
  flex-basis: 48px;
  height: 48px;
  line-height: 48px;
  text-decoration: none;
  text-align: center;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-button:hover {
  background-color: #ecebe9;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar {
  background: transparent;
  display: block;
  height: 100%;
  border: 0;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar > li.jodit_toolbar_btn {
  vertical-align: middle;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar > li.jodit_toolbar_btn input[type=number],
.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar > li.jodit_toolbar_btn input[type=text],
.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar > li.jodit_toolbar_btn input[type=url],
.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar > li.jodit_toolbar_btn select {
  margin: 0 5px;
  padding-left: 10px;
  width: auto;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_content {
  height: calc(100% - 48px);
  overflow: auto;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group {
  margin-bottom: 10px;
  padding: 0 10px;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group:first-child {
  margin-top: 10px;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: 700;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input.select,
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=number],
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=text],
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=url],
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select.select,
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=number],
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=text],
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=url] {
  display: block;
  height: 34px;
  padding: 6px 4px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 0;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input.select:focus,
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=number]:focus,
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=text]:focus,
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=url]:focus,
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select.select:focus,
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=number]:focus,
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=text]:focus,
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=url]:focus {
  border-color: #66afe9;
  outline: 0;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input.select[disabled],
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=number][disabled],
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=text][disabled],
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=url][disabled],
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select.select[disabled],
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=number][disabled],
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=text][disabled],
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=url][disabled] {
  background-color: #f0f0f0;
  color: #ccc;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input.select:not([class*=col-]),
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=number]:not([class*=col-]),
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=text]:not([class*=col-]),
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=url]:not([class*=col-]),
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select.select:not([class*=col-]),
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=number]:not([class*=col-]),
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=text]:not([class*=col-]),
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=url]:not([class*=col-]) {
  width: 100%;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group {
  display: table;
  border-collapse: separate;
  width: 100%;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group > * {
  vertical-align: middle;
  display: table-cell;
  height: 34px;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group > input {
  float: left;
  margin: 0 !important;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group > input:not([class*=col-]) {
  width: 100%;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group-buttons {
  width: 1%;
  font-size: 0;
  white-space: nowrap;
  vertical-align: middle;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group-buttons > a {
  text-align: center;
  display: inline-block;
  border: 1px solid #ccc;
  margin-left: -1px;
  position: relative;
  height: 34px;
  line-height: 34px;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_footer {
  padding: 0 10px;
  padding-top: 10px;
  text-align: center;
  height: 48px;
  display: none;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button {
  width: auto;
  margin-bottom: 10px;
  height: 32px;
  line-height: 100%;
  padding: 0 15px;
  background-color: #ccc;
  border: 1px solid #ccc;
  color: #000;
  font-size: 0;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button:before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  height: 100%;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button svg {
  display: inline-block;
  width: 24px;
  height: 24px;
  vertical-align: middle;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button span {
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  margin-left: 5px;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button:focus {
  border: 1px solid #8bade4;
  outline: 1px solid #82b2e8;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button:nth-child(n+2) {
  margin-left: 10px;
}
.jodit_dialog_box .jodit_dialog.with_footer .jodit_dialog_content {
  height: calc(100% - 96px);
}
.jodit_dialog_box .jodit_dialog.with_footer .jodit_dialog_footer {
  display: block;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_resizer {
  position: absolute;
  bottom: 0;
  right: 0;
  cursor: se-resize;
  width: 7px;
  height: 7px;
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_resizer:hover {
  border-color: rgba(0, 0, 0, 0.6);
}
@media (max-width: 480px) {
  .jodit_dialog_box .jodit_dialog .jodit_dialog_resizer {
    display: none;
  }
}
.jodit_dialog_box.jodit_fullsize .jodit_dialog {
  top: 0!important;
  bottom: 0!important;
  left: 0!important;
  right: 0!important;
  width: 100%!important;
  height: 100% !important;
}
.jodit_dialog_box.jodit_fullsize .jodit_dialog .jodit_dialog_resizer {
  display: none;
}
@media (max-width: 768px) {
  .jodit_dialog_header .jodit_input,
  .jodit_dialog_header .jodit_toolbar_btn-filter,
  .jodit_dialog_header .jodit_toolbar_btn-separator,
  .jodit_dialog_header .jodit_toolbar_btn-sort,
  .jodit_dialog_header_fullsize,
  .jodit_dialog_header_title {
    display: none !important;
  }
}
.jodit_toolbar_list > .jodit_toolbar {
  max-height: 400px;
  overflow: auto;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  padding: 0;
  margin: auto;
  text-align: left;
  box-sizing: border-box;
  transition: max-height 0.2s ease 0s;
  margin-top: 0!important;
  list-style-type: none;
  font-size: 16px;
  z-index: 8;
  position: absolute;
  left: 0;
  top: 100%;
}
.jodit_toolbar_list > .jodit_toolbar,
.jodit_toolbar_list > .jodit_toolbar .jodit_toolbar {
  background: #f9f9f9;
}
.jodit_toolbar_list > .jodit_toolbar blockquote,
.jodit_toolbar_list > .jodit_toolbar h1,
.jodit_toolbar_list > .jodit_toolbar h2,
.jodit_toolbar_list > .jodit_toolbar h3,
.jodit_toolbar_list > .jodit_toolbar h4,
.jodit_toolbar_list > .jodit_toolbar h5,
.jodit_toolbar_list > .jodit_toolbar p,
.jodit_toolbar_list > .jodit_toolbar pre {
  font-family: Helvetica, sans-serif;
  margin: 0;
  padding: 0;
  font-weight: 400;
}
.jodit_toolbar_list > .jodit_toolbar h5 {
  font-size: 0.8em;
  line-height: 1.4;
}
.jodit_toolbar_list > .jodit_toolbar h3 {
  font-size: 1.31em;
  line-height: 1.4;
}
.jodit_toolbar_list > .jodit_toolbar h4,
.jodit_toolbar_list > .jodit_toolbar p {
  font-size: 1em;
  line-height: 1.5em;
}
.jodit_toolbar_list > .jodit_toolbar h2 {
  font-size: 1.74em;
  line-height: 1.4;
}
.jodit_toolbar_list > .jodit_toolbar h1 {
  font-size: 2.17em;
  line-height: 1.4;
}
.jodit_toolbar_list > .jodit_toolbar blockquote,
.jodit_toolbar_list > .jodit_toolbar pre {
  font-family: monospace;
}
.jodit_toolbar_list > .jodit_toolbar li.jodit_toolbar_btn {
  display: block;
  cursor: pointer;
  white-space: nowrap;
  color: inherit;
  text-decoration: none;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  text-align: left;
}
.jodit_toolbar_list > .jodit_toolbar li.jodit_toolbar_btn > a {
  background-image: none;
  padding: 7px 24px;
  cursor: pointer;
  line-height: 100%;
  width: auto;
  height: auto;
  display: block;
}
.jodit_toolbar_list > .jodit_toolbar li.jodit_toolbar_btn > a > span {
  display: inline-block;
}
.jodit_toolbar_list > .jodit_toolbar li.jodit_toolbar_btn > a:hover {
  background-color: #f3f0f0;
}
.jodit_toolbar_list > .jodit_toolbar li.jodit_toolbar_btn > a:after {
  display: none;
}
.jodit_toolbar[dir=rtl] .jodit_toolbar_list > .jodit_toolbar,
.jodit_toolbar[dir=rtl] .jodit_toolbar_list > .jodit_toolbar li.jodit_toolbar_btn {
  text-align: right;
}
.jodit_filebrowser {
  font-family: Helvetica, sans-serif;
  font-size: 0;
  height: 100%;
}
.jodit_filebrowser .jodit_filebrowser_loader {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.jodit_filebrowser .jodit_filebrowser_loader i {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -64px;
  margin-left: -64px;
}
.jodit_filebrowser .jodit_filebrowser_status {
  position: absolute;
  font-size: 10px;
  padding: 2px 3px;
  border-top: 1px solid hsla(0, 0%, 50%, 0.4);
  left: 31%;
  right: 0;
  bottom: 0;
  background-color: #4a4a4a;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s linear;
  color: #b38888;
  word-break: break-all;
}
.jodit_filebrowser .jodit_filebrowser_status.success {
  color: #c5c5c5;
}
.jodit_filebrowser .jodit_filebrowser_status.active {
  visibility: visible;
  opacity: 1;
}
.jodit_filebrowser .jodit_filebrowser_files,
.jodit_filebrowser .jodit_filebrowser_tree {
  display: none;
  vertical-align: top;
  height: 100%;
  position: relative;
}
.jodit_filebrowser .jodit_filebrowser_files.active,
.jodit_filebrowser .jodit_filebrowser_tree.active {
  display: inline-block;
}
.jodit_filebrowser .jodit_filebrowser_files::-webkit-scrollbar,
.jodit_filebrowser .jodit_filebrowser_tree::-webkit-scrollbar {
  width: 5px;
}
.jodit_filebrowser .jodit_filebrowser_files::-webkit-scrollbar-track,
.jodit_filebrowser .jodit_filebrowser_tree::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.jodit_filebrowser .jodit_filebrowser_files::-webkit-scrollbar-thumb,
.jodit_filebrowser .jodit_filebrowser_tree::-webkit-scrollbar-thumb {
  background-color: #a9a9a9;
  outline: 1px solid #708090;
}
.jodit_filebrowser .jodit_filebrowser_tree.active {
  width: 31%;
  background-color: #3f3f3f;
  overflow-y: auto;
}
@media (max-width: 480px) {
  .jodit_filebrowser .jodit_filebrowser_tree.active {
    display: none;
  }
}
.jodit_filebrowser .jodit_filebrowser_tree.active::-webkit-scrollbar {
  width: 5px;
}
.jodit_filebrowser .jodit_filebrowser_tree.active::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.jodit_filebrowser .jodit_filebrowser_tree.active::-webkit-scrollbar-thumb {
  background-color: hsla(0, 0%, 50%, 0.5);
  outline: 1px solid #708090;
}
.jodit_filebrowser .jodit_filebrowser_tree.active .jodit_filebrowser_source_title {
  -webkit-user-select: none;
  user-select: none;
  display: block;
  padding: 10px;
  color: #969696;
  border-bottom: 1px solid #484848;
  line-height: 17px;
  min-height: 38px;
  position: relative;
  word-break: break-all;
  background: #5a5a5a;
  font-size: 16px;
}
.jodit_filebrowser .jodit_filebrowser_tree.active a {
  display: block;
  padding: 10px 20px;
  text-decoration: none;
  color: #b1b1b1;
  font-weight: 600;
  transition: background-color 0.2s ease 0s;
  border-bottom: 1px solid #474747;
  line-height: 17px;
  min-height: 38px;
  position: relative;
  word-break: break-all;
  font-size: 16px;
}
.jodit_filebrowser .jodit_filebrowser_tree.active a i.remove {
  height: 16px;
  width: 16px;
  line-height: 17px;
  font-size: 16px;
  position: absolute;
  right: 5px;
  top: 11px;
  opacity: 0;
  padding-left: 3px;
  display: inline-block;
}
.jodit_filebrowser .jodit_filebrowser_tree.active a i.remove:hover {
  background: #696969;
}
.jodit_filebrowser .jodit_filebrowser_tree.active a:hover {
  color: #222;
  background-color: #ecebe9;
}
.jodit_filebrowser .jodit_filebrowser_tree.active a:hover i.remove {
  opacity: 0.6;
}
.jodit_filebrowser .jodit_filebrowser_tree.active a.jodit_button {
  cursor: pointer;
  background: #696969;
  text-align: center;
  width: auto;
  height: 38px;
  color: #333;
}
.jodit_filebrowser .jodit_filebrowser_tree.active a.jodit_button svg {
  vertical-align: top;
}
.jodit_filebrowser .jodit_filebrowser_tree.active a.jodit_button:not(.disabled):hover {
  background-color: #ecebe9;
}
.jodit_filebrowser .jodit_filebrowser_tree.active a.jodit_button.disabled,
.jodit_filebrowser .jodit_filebrowser_tree.active a.jodit_button:hover i {
  opacity: 0.7;
}
.jodit_filebrowser .jodit_filebrowser_files.active {
  width: 100%;
  overflow-y: auto;
  padding: 10px;
}
.jodit_filebrowser .jodit_filebrowser_files.active .jodit_filebrowser_source_title {
  -webkit-user-select: none;
  user-select: none;
  margin: -10px -10px 0;
  display: block;
  padding: 10px;
  line-height: 17px;
  min-height: 38px;
  position: relative;
  word-break: break-all;
  background: #5a5a5a;
  font-size: 16px;
  color: #969696;
}
.jodit_filebrowser .jodit_filebrowser_files.active a + .jodit_filebrowser_source_title {
  margin-top: 10px;
}
.jodit_filebrowser .jodit_filebrowser_files.active a {
  vertical-align: top;
  display: inline-block;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
  border: 1px solid #ccc;
  margin: 5px 5px 10px;
  font-size: 0;
  overflow: hidden;
  transition: border 0.1s linear, bottom 0.1s linear;
  box-sizing: content-box;
  position: relative;
}
.jodit_filebrowser .jodit_filebrowser_files.active a img {
  max-width: 100%;
  vertical-align: middle;
}
.jodit_filebrowser .jodit_filebrowser_files.active a:hover {
  border-color: #433b5c;
}
.jodit_filebrowser .jodit_filebrowser_files.active a.active {
  border-color: #1e88e5;
  background-color: #b5b5b5;
}
.jodit_filebrowser .jodit_filebrowser_files.active a .jodit_filebrowser_files_item-info {
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  white-space: normal;
  opacity: 0.85;
  overflow: visible;
  padding: 0.3em 0.6em;
  transition: opacity 0.4s ease;
  background-color: #e9e9e9;
  color: #333;
  text-shadow: #eee 0 1px 0;
  font-size: 14px;
  line-height: 16px;
  text-align: left;
}
.jodit_filebrowser .jodit_filebrowser_files.active a .jodit_filebrowser_files_item-info > span {
  display: block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 0.75em;
}
.jodit_filebrowser .jodit_filebrowser_files.active a .jodit_filebrowser_files_item-info > span.jodit_filebrowser_files_item-info-filename {
  font-weight: 700;
  font-size: 0.9em;
}
.jodit_filebrowser .jodit_filebrowser_files.active a.active .jodit_filebrowser_files_item-info {
  background-color: #b5b5b5;
  color: #fff;
  text-shadow: none;
}
.jodit_filebrowser .jodit_filebrowser_files.active a:hover .jodit_filebrowser_files_item-info {
  bottom: -100px;
}
.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list {
  scroll-behavior: smooth;
}
.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a {
  display: block;
  width: 100%;
  height: 26px;
  line-height: 26px;
  margin: 0;
  border-width: 0 0 1px;
  text-align: left;
  white-space: nowrap;
}
.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a img {
  min-width: 16px;
  max-width: 16px;
  vertical-align: middle;
  display: inline-block;
  margin-left: 4px;
}
.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a .jodit_filebrowser_files_item-info {
  padding: 0;
  position: static;
  display: inline-block;
  width: calc(100% - 20px);
  margin-left: 4px;
  background-color: transparent;
  height: 100%;
  line-height: inherit;
  vertical-align: middle;
  font-size: 0;
}
.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a .jodit_filebrowser_files_item-info > span {
  display: inline-block;
  height: 100%;
  font-size: 12px;
}
.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a .jodit_filebrowser_files_item-info > span.jodit_filebrowser_files_item-info-filename {
  width: 50%;
}
.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a .jodit_filebrowser_files_item-info > span.jodit_filebrowser_files_item-info-filechanged,
.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a .jodit_filebrowser_files_item-info > span.jodit_filebrowser_files_item-info-filesize {
  width: 25%;
}
.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a:hover {
  background-color: #433b5c;
}
.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a:hover .jodit_filebrowser_files_item-info {
  color: #fff;
  text-shadow: none;
}
.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a:before {
  height: 100%;
  content: "";
  vertical-align: middle;
  display: inline-block;
}
.jodit_filebrowser .jodit_filebrowser_tree.active + .jodit_filebrowser_files.active {
  width: 69%;
}
@media (max-width: 480px) {
  .jodit_filebrowser .jodit_filebrowser_tree.active + .jodit_filebrowser_files.active {
    width: auto;
    display: block;
  }
}
.jodit_filebrowser_preview {
  text-align: center;
  min-width: 300px;
  max-width: 900px;
  max-height: 700px;
  min-height: 700px;
  position: relative;
}
.jodit_filebrowser_preview .jodit_filebrowser_preview_navigation {
  position: absolute;
  top: 0;
  height: 100%;
  left: 0;
}
.jodit_filebrowser_preview .jodit_filebrowser_preview_navigation-next {
  left: auto;
  right: 0;
}
.jodit_filebrowser_preview .jodit_filebrowser_preview_navigation svg {
  width: 45px;
  height: 45px;
  position: relative;
  top: 50%;
  margin-top: -22px;
  transition: fill 0.3s linear;
  fill: #9e9ba7;
}
.jodit_filebrowser_preview .jodit_filebrowser_preview_navigation:hover svg {
  fill: #000;
}
.jodit_filebrowser_preview img {
  max-width: 100%;
  max-height: 100%;
}
.jodit_draghover {
  background-color: #ecebe9;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-title .jodit_upload_button {
  position: relative;
  width: 220px;
  border: 0;
  padding: 25px 0;
  margin: 10px 0;
  overflow: hidden;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-title .jodit_upload_button input {
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  margin: 0 -10px 0 0;
  padding: 0;
  opacity: 0;
  font-size: 400px;
}
.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-title.jodit_filebrowser_title_box {
  padding-left: 10px;
}
.jodit_grid {
  width: 100%;
}
.jodit_grid [class*=jodit_col-] {
  display: block;
  float: left;
}
.jodit_grid .jodit_col-lg-5-5 {
  width: 100%;
}
.jodit_grid .jodit_col-lg-4-5 {
  width: 80%;
}
.jodit_grid .jodit_col-lg-3-5 {
  width: 60%;
}
.jodit_grid .jodit_col-lg-2-5 {
  width: 40%;
}
.jodit_grid .jodit_col-lg-1-5 {
  width: 20%;
}
.jodit_grid .jodit_col-lg-4-4 {
  width: 100%;
}
.jodit_grid .jodit_col-lg-3-4 {
  width: 75%;
}
.jodit_grid .jodit_col-lg-2-4 {
  width: 50%;
}
.jodit_grid .jodit_col-lg-1-4 {
  width: 25%;
}
.jodit_grid:after,
.jodit_grid:before {
  content: " ";
  display: table;
}
.jodit_grid:after {
  clear: both;
}
@keyframes a {
  to {
    transform: rotate(1turn);
  }
}
.jodit_icon-loader {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat 50%;
  background-size: 100% 100%;
  width: 128px;
  height: 128px;
  will-change: transform;
  animation: a 2s ease-out 0s infinite;
}
.jodit_icon,
.jodit_icon-loader {
  display: inline-block;
  vertical-align: middle;
}
.jodit_icon {
  font-style: normal;
  width: 14px;
  height: 14px;
  font-size: 8px;
  fill: #222;
  transform-origin: 0 0!important;
  overflow: visible;
  background: 50% no-repeat;
  background-size: contain;
}
svg.jodit_icon {
  height: auto;
}
.jodit_text_icon {
  font-size: 14px;
}
.jodit_toolbar_size-small .jodit_icon {
  min-width: 12px;
  height: 12px;
  line-height: 12px;
}
.jodit_toolbar_size-large .jodit_icon {
  min-width: 16px;
  height: 16px;
  line-height: 16px;
}
.jodit_image_editor {
  width: 100%;
  height: 100%;
  padding: 10px;
  overflow: hidden;
}
@media (max-width: 768px) {
  .jodit_image_editor {
    height: auto;
  }
}
.jodit_image_editor > div,
.jodit_image_editor > div > div {
  height: 100%;
}
@media (max-width: 768px) {
  .jodit_image_editor > div,
  .jodit_image_editor > div > div {
    height: auto;
    min-height: 200px;
  }
}
.jodit_image_editor * {
  box-sizing: border-box;
}
.jodit_image_editor .jodit_image_editor_slider-title {
  text-shadow: #f3f3f3 0 1px 0;
  color: #333;
  border-bottom: 1px solid hsla(0, 0%, 62%, 0.31);
  background-color: #f9f9f9;
  padding: 0.8em 1em;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  font-weight: 700;
  line-height: 1em;
}
.jodit_image_editor .jodit_image_editor_slider-title svg {
  margin-right: 10px;
  width: 16px;
  display: inline-block;
  vertical-align: middle;
}
.jodit_image_editor .jodit_image_editor_slider-content {
  display: none;
}
.jodit_image_editor .jodit_image_editor_slider.active .jodit_image_editor_slider-title {
  background-color: #5d5d5d;
  color: #fff;
  text-shadow: #000 0 1px 0;
}
.jodit_image_editor .jodit_image_editor_slider.active .jodit_image_editor_slider-title svg {
  fill: #fff;
}
.jodit_image_editor .jodit_image_editor_slider.active .jodit_image_editor_slider-content {
  display: block;
}
.jodit_image_editor_area {
  background-color: #eee;
  background-image: linear-gradient(45deg, #ccc 25%, transparent 0, transparent 75%, #ccc 0, #ccc), linear-gradient(45deg, #ccc 25%, transparent 0, transparent 75%, #ccc 0, #ccc);
  background-size: 30px 30px;
  background-position: 0 0,15px 15px;
  height: 100%;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  position: relative;
  display: none;
}
.jodit_image_editor_area.active {
  display: block;
}
.jodit_image_editor_area .jodit_image_editor_box {
  overflow: hidden;
  position: relative;
  z-index: 1;
  pointer-events: none;
  height: 100%;
}
.jodit_image_editor_area .jodit_image_editor_box img {
  -webkit-user-select: none;
  user-select: none;
  max-width: 100%;
  max-height: 100%;
}
.jodit_image_editor_area .jodit_image_editor_croper,
.jodit_image_editor_area .jodit_image_editor_resizer {
  z-index: 2;
  width: 100px;
  height: 100px;
  position: absolute;
  box-shadow: 0 0 11px #000;
  border: 1px solid #fff;
  background-repeat: no-repeat;
  top: 10px;
  left: 20px;
  pointer-events: none;
}
.jodit_image_editor_area .jodit_image_editor_croper i.jodit_bottomright,
.jodit_image_editor_area .jodit_image_editor_resizer i.jodit_bottomright {
  position: absolute;
  display: inline-block;
  border: 1px solid #383838;
  z-index: 4;
  background-color: #8c7878;
  cursor: se-resize;
  border-radius: 10px;
  height: 20px;
  width: 20px;
  right: -10px;
  bottom: -10px;
  box-shadow: 0 0 11px #000;
  pointer-events: all;
}
.jodit_image_editor_area .jodit_image_editor_croper i.jodit_bottomright:active,
.jodit_image_editor_area .jodit_image_editor_resizer i.jodit_bottomright:active {
  border: 1px solid #ff0;
}
.jodit_image_editor_area.jodit_image_editor_area_crop {
  height: 100%;
  background: #eee;
  text-align: center;
  line-height: 100%;
  position: relative;
}
.jodit_image_editor_area.jodit_image_editor_area_crop:before {
  content: "";
  line-height: 100%;
  vertical-align: middle;
  height: 100%;
  display: inline-block;
}
.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box {
  height: 100%;
  overflow: visible;
  display: inline-block;
  vertical-align: middle;
  pointer-events: all;
  font-size: 0;
  text-align: left;
  line-height: 100%;
}
.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box img {
  max-width: 100%;
  max-height: 100%;
}
.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box:before {
  content: "";
  line-height: 100%;
  vertical-align: middle;
  height: 100%;
  display: inline-block;
}
.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  background: hsla(0, 0%, 100%, 0.3);
  z-index: 1;
}
.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box .jodit_image_editor_croper {
  pointer-events: all;
  cursor: move;
}
.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box .jodit_image_editor_croper i.jodit_sizes {
  font-size: 12px;
  white-space: pre;
  position: absolute;
  bottom: -30px;
  left: 100%;
  text-align: center;
  color: #fff;
  text-shadow: none;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 0.4em;
  padding: 9px 6px;
  display: block;
}
.jodit_properties svg {
  font-style: normal;
  display: inline-block;
  width: 14px;
  height: 14px;
  line-height: 14px;
  font-size: 8px;
  overflow: hidden;
  vertical-align: middle;
  fill: #222;
  transform-origin: 0 0 !important;
}
.jodit_properties #tabsbox {
  padding: 10px;
}
.jodit_properties #tabsbox .jodit_form_group {
  padding: 0;
}
.jodit_properties .jodit_properties_view_box {
  padding: 10px;
}
.jodit_properties .jodit_properties_view_box .jodit_properties_image_view {
  height: 150px;
  text-align: center;
  line-height: 1;
  vertical-align: middle;
  padding: 0;
  background-color: #f6f6f6;
  margin: 0;
  vertical-align: baseline;
  font-size: 100%;
  margin-bottom: 10px;
}
.jodit_properties .jodit_properties_view_box .jodit_properties_image_view:before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  height: 100%;
}
.jodit_properties .jodit_properties_view_box .jodit_properties_image_view img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: middle;
}
.jodit_properties .jodit_properties_view_box .jodit_properties_image_sizes.jodit_form_group {
  padding: 0!important;
  margin: 0 !important;
}
.jodit_properties .jodit_properties_view_box .jodit_properties_image_sizes.jodit_form_group a {
  display: inline-block;
  cursor: pointer;
}
.jodit_properties .jodit_properties_view_box .jodit_properties_image_sizes.jodit_form_group input[type=number] {
  display: inline-block !important;
  width: calc(50% - 8px) !important;
}
.jodit_toolbar,
.jodit_toolbar * {
  box-sizing: border-box;
}
.jodit_toolbar {
  position: relative;
  left: 0;
  top: 0;
  margin: 0!important;
  padding: 0!important;
  list-style: none!important;
  font-size: 0;
  background: #f9f9f9;
  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.14);
  border: 1px solid #ccc;
  border-bottom: 0;
  min-height: 16px !important;
}
.jodit_toolbar + .jodit_toolbar_dummy {
  display: none;
}
.jodit_toolbar.jodit_fly {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 10;
  background: #fff;
}
.jodit_toolbar.jodit_sticky {
  position: fixed;
  position: sticky;
  z-index: 3;
  top: 0;
  left: auto;
}
.jodit_toolbar.jodit_sticky + .jodit_toolbar_dummy {
  display: block;
}
.jodit_toolbar .jodit_toolbar_btn > a {
  color: #000;
  text-decoration: none;
  display: block;
  background: no-repeat 50%;
}
.jodit_toolbar > li.jodit_toolbar_btn {
  display: inline-block;
  vertical-align: top;
  margin: 0!important;
  padding: 0;
  list-style: none!important;
  outline: none;
  position: relative;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.2s linear, opacity 0.1s linear;
}
.jodit_toolbar > li.jodit_toolbar_btn.jodit_disabled {
  background-color: transparent!important;
  opacity: 0.3;
  cursor: default;
}
.jodit_toolbar > li.jodit_toolbar_btn.jodit_disabled a {
  cursor: default;
}
.jodit_toolbar > li.jodit_toolbar_btn.jodit_toolbar_btn-separator {
  border-left: 0;
  border-right: 1px solid #e6e6e6;
  padding: 0;
  margin: 2px 3px 0!important;
  cursor: default;
}
.jodit_toolbar > li.jodit_toolbar_btn.jodit_toolbar_btn-break {
  display: block!important;
  width: auto;
  border-top: 1px solid #e6e6e6;
  height: 0;
  margin: 0 3px !important;
}
.jodit_toolbar > li.jodit_toolbar_btn .jodit_toolbar_btn > a,
.jodit_toolbar > li.jodit_toolbar_btn > a {
  width: 100%;
  height: 100%;
  display: inline-block;
  outline: none;
  text-decoration: none;
}
.jodit_toolbar > li.jodit_toolbar_btn .jodit_toolbar_btn > a:after,
.jodit_toolbar > li.jodit_toolbar_btn > a:after {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}
.jodit_toolbar > li.jodit_toolbar_btn .jodit_toolbar_btn > a:active + .jodit_tooltip,
.jodit_toolbar > li.jodit_toolbar_btn > a:active + .jodit_tooltip {
  visibility: hidden !important;
}
.jodit_toolbar > li.jodit_toolbar_btn.jodit_disabled .jodit_tooltip {
  display: none !important;
}
.jodit_toolbar > li.jodit_toolbar_btn > a {
  line-height: 100%;
}
.jodit_toolbar > li.jodit_toolbar_btn.jodit_dropdown_open .jodit_tooltip,
.jodit_toolbar > li.jodit_toolbar_btn .jodit_popap_open,
.jodit_toolbar > li.jodit_toolbar_btn.jodit_popup_open .jodit_tooltip {
  visibility: hidden !important;
}
.jodit_toolbar > li.jodit_toolbar_btn:not(.jodit_toolbar-input):hover {
  background-color: #dde4ef;
  outline: none;
}
.jodit_toolbar > li.jodit_toolbar_btn.jodit_active,
.jodit_toolbar > li.jodit_toolbar_btn:not(.jodit_toolbar-input):active {
  background-color: hsla(0, 0%, 87%, 0.4);
  outline: none;
}
.jodit_toolbar > li.jodit_toolbar_btn.jodit-btn-hidden {
  display: none !important;
}
.jodit_toolbar > li.jodit_toolbar_btn.jodit_with_dropdownlist .jodit_with_dropdownlist-trigger {
  width: 0;
  height: 0;
  border-right: 3px solid transparent;
  border-left: 3px solid transparent;
  border-top: 3px solid #4c4c4c;
  display: inline-block;
  vertical-align: middle;
  margin-left: 3px;
}
.jodit_toolbar > li.jodit_toolbar_btn.jodit_toolbar-input input,
.jodit_toolbar > li.jodit_toolbar_btn.jodit_toolbar-input select {
  appearance: none;
  height: 100%;
  border-radius: 0;
  outline: none;
  line-height: 100%;
}
.jodit_toolbar > li.jodit_toolbar_btn.jodit_toolbar-input select {
  padding-right: 20px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat 98% 50% !important;
}
.jodit_toolbar > li {
  min-width: 32px;
  height: 32px;
  line-height: 32px;
}
.jodit_toolbar > li.jodit_toolbar_btn-separator {
  height: 28px;
  width: 0;
  min-width: 0;
}
.jodit_tooltip {
  position: absolute;
  background: #727171;
  color: #fff;
  font-size: 12px;
  line-height: 15px;
  padding: 4px 5px;
  font-family: Arial, sans-serif;
  z-index: 9;
  width: 90px;
  transition: opacity 0.3s linear;
}
@media (max-width: 768px) {
  .jodit_tooltip {
    display: none;
  }
}
.jodit_toolbar_size-small .jodit_toolbar {
  min-height: 12px !important;
}
.jodit_toolbar_size-small .jodit_toolbar > li {
  min-width: 24px;
  height: 24px;
  line-height: 24px;
}
.jodit_toolbar_size-small .jodit_toolbar > li.jodit_toolbar_btn-separator {
  height: 20px;
  width: 0;
  min-width: 0;
}
.jodit_toolbar_size-large .jodit_toolbar {
  min-height: 18px !important;
}
.jodit_toolbar_size-large .jodit_toolbar > li {
  min-width: 36px;
  height: 36px;
  line-height: 36px;
}
.jodit_toolbar_size-large .jodit_toolbar > li.jodit_toolbar_btn-separator {
  height: 32px;
  width: 0;
  min-width: 0;
}
.jodit_toolbar_popup {
  position: absolute;
  z-index: 7;
  top: 100%;
  margin-top: 10px;
  padding-top: 0;
  left: 0;
  font-size: 14px;
  line-height: 14px!important;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.jodit_toolbar_popup .jodit_toolbar {
  box-shadow: none;
  border-width: 0;
  background-color: transparent;
}
.jodit_toolbar_popup .jodit_toolbar .jodit_toolbar {
  background-color: #f9f9f9;
  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.14);
  border: 1px solid #ccc;
}
.jodit_toolbar_popup > * {
  margin: 10px;
}
.jodit_toolbar_popup .jodit_popup_triangle {
  padding: 0;
  margin: 0;
  width: 8px;
  height: 8px;
  position: absolute;
  top: -5px;
  left: 9px;
  display: inline-block;
  transform: rotate(45deg);
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-width: 1px 0 0 1px;
  z-index: 5;
}
.jodit_toolbar_popup.jodit_right {
  left: auto;
  right: 0;
}
.jodit_toolbar_popup.jodit_right:before {
  left: auto;
  right: 14px;
}
.jodit_toolbar .jodit_toolbar_btn > svg {
  max-width: 50%;
  vertical-align: middle;
  font-smoothing: antialiased;
}
.jodit_container > .jodit_toolbar > li:first-child {
  margin-left: 2px !important;
}
.jodit_container[dir=rtl] > .jodit_toolbar > li:first-child {
  margin-left: 0!important;
  margin-right: 2px !important;
}
.jodit_draganddrop_file_box,
.jodit_uploadfile_button {
  position: relative;
  width: 220px;
  border: 1px dashed #ccc;
  padding: 25px 0;
  margin: 10px 0;
  text-align: center;
  overflow: hidden;
}
.jodit_draganddrop_file_box:hover,
.jodit_uploadfile_button:hover {
  background-color: #ecebe9;
}
.jodit_draganddrop_file_box input,
.jodit_uploadfile_button input {
  cursor: pointer;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  margin: 0;
  padding: 0;
  opacity: 0;
  font-size: 400px;
}
@media (max-width: 768px) {
  .jodit_draganddrop_file_box {
    width: auto;
    max-width: 100%;
    min-width: 120px;
  }
}
.jodit_statusbar {
  border: 1px solid #ccc;
  border-top: 0;
  font-size: 0;
  background-color: #f9f9f9;
  padding: 0 5px;
}
.jodit_statusbar .jodit_statusbar_item {
  font-size: 11px;
  float: left;
  line-height: 1.57142857em;
  margin: 0 10px 0 0;
  padding: 0;
  vertical-align: middle;
}
.jodit_statusbar .jodit_statusbar_item.jodit_statusbar_item-right {
  float: right;
  margin: 0 0 0 10px;
}
.jodit_statusbar .jodit_statusbar_item li,
.jodit_statusbar .jodit_statusbar_item ul {
  margin: 0;
  padding: 0;
  list-style: none;
  display: inline-block;
  vertical-align: top;
  position: relative;
}
.jodit_statusbar .jodit_statusbar_item li li,
.jodit_statusbar .jodit_statusbar_item ul li {
  margin-right: 5px;
}
.jodit_statusbar .jodit_statusbar_item a,
.jodit_statusbar .jodit_statusbar_item span {
  -webkit-user-select: none;
  user-select: none;
  display: inline-block;
  vertical-align: baseline;
  text-align: left;
  white-space: nowrap;
  padding: 2px 3px;
  line-height: 10px;
  outline: 0;
  border: 0;
  color: #222;
}
.jodit_statusbar .jodit_statusbar_item a span,
.jodit_statusbar .jodit_statusbar_item span span {
  padding: 0;
}
.jodit_statusbar .jodit_statusbar_item svg {
  width: 11px;
  height: 11px;
  display: inline-block;
  vertical-align: top;
}
.jodit_statusbar .jodit_statusbar_item a {
  text-decoration: none;
  cursor: default;
  border-radius: 3px;
}
.jodit_statusbar .jodit_statusbar_item a:hover {
  background-color: hsla(0, 0%, 88%, 0.99);
  text-decoration: none;
  color: #222;
}
.jodit_statusbar:after {
  content: " ";
  display: block;
  visibility: hidden;
  font-size: 0;
  height: 0;
  float: none;
  clear: both;
}
.jodit_disabled .jodit_statusbar {
  opacity: 0.4;
}
.jodit_form {
  color: #000;
}
.jodit_form input[type=text],
.jodit_form input[type=url],
.jodit_form textarea {
  -webkit-appearance: none;
  -moz-appearance: none;
  display: block;
  outline: none;
  border: 1px solid #b5b5b5;
  height: 28px;
  line-height: 28px;
  padding: 0 5px;
  min-width: 220px;
  margin-top: 10px;
}
.jodit_form input[type=text].jodit_error,
.jodit_form input[type=url].jodit_error,
.jodit_form textarea.jodit_error {
  border-color: #f7d1d1;
  box-shadow: inset 0 0 3px 0 hsla(0, 0%, 74%, 0.3);
}
@media (max-width: 768px) {
  .jodit_form input[type=text],
  .jodit_form input[type=url],
  .jodit_form textarea {
    min-width: 150px;
  }
}
.jodit_form textarea {
  height: 128px;
}
.jodit_form button {
  height: 36px;
  line-height: 1;
  color: #000;
  padding: 10px;
  cursor: pointer;
  text-decoration: none;
  border: none;
  background: #d6d6d6;
  font-size: 16px;
  outline: none;
  transition: background 0.2s ease 0s;
  margin-top: 10px;
  margin-bottom: 10px;
}
.jodit_form button:hover {
  background-color: #ecebe9;
  color: #000;
}
.jodit_form button:active {
  background: #ecebe9;
  color: #000;
}
.jodit_form input[type=checkbox] {
  display: inline-block;
  z-index: 2;
  border: 0 none;
  cursor: pointer;
  height: 16px;
  margin: 0;
  padding: 0;
  width: 16px;
  position: relative;
  outline: none;
  top: 3px;
}
.jodit_form input[type=checkbox]:after {
  content: "";
  background: #fff;
  border: 1px solid hsla(0, 0%, 88%, 0.99);
  border-radius: 2px;
  background-clip: padding-box;
  width: 16px;
  height: 16px;
  display: inline-block;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  transition: background 0.2s ease 0s, border-color 0.2s ease 0s;
}
.jodit_form input[type=checkbox]:checked:after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat 50%;
  background-color: #b5b5b5;
  border-color: #b5b5b5;
}
.jodit_form label {
  margin-top: 10px;
  display: block;
  text-align: left;
}
.jodit_form form:after {
  content: "";
  display: table;
  clear: both;
}
.jodit_about {
  padding: 20px;
}
.jodit_about a {
  color: #459ce7;
  text-decoration: none;
}
.jodit_about a:focus,
.jodit_about a:hover {
  color: #23527c;
  text-decoration: underline;
  outline: 0;
}
.jodit_about div {
  margin-bottom: 5px;
}
.jodit_colorpicker {
  min-width: 180px;
  text-align: left;
  margin: 0;
  -webkit-user-select: none;
  user-select: none;
}
.jodit_colorpicker .jodit_colorpicker_group {
  margin-bottom: 5px;
  white-space: normal;
}
.jodit_colorpicker a {
  width: 18px;
  height: 18px;
  line-height: 16px;
  display: inline-block;
  text-decoration: none;
  vertical-align: middle;
  text-align: center;
}
.jodit_colorpicker a:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  width: 0;
}
.jodit_colorpicker a svg {
  display: inline-block;
  vertical-align: middle;
  font-smoothing: antialiased;
  max-width: 14px;
}
.jodit_colorpicker a:hover {
  border-color: #000;
}
.jodit_colorpicker a:active {
  background: #d6d6d6;
  color: #b5b5b5;
}
.jodit_colorpicker .jodit_text_icon {
  width: auto;
  text-decoration: none;
  color: #000;
}
.jodit_colorpicker span {
  float: right;
}
.jodit_colorpicker span em {
  width: 16px;
  height: 16px;
  display: inline-block;
  margin-right: 4px;
}
.jodit_colorpicker span input {
  width: 18px;
  height: 18px;
  padding: 0;
  border: none;
  -webkit-appearance: none;
}
.jodit_colorpicker span input[type=color]::-webkit-color-swatch-wrapper {
  padding: 0;
}
.jodit_colorpicker span input input[type=color]::-webkit-color-swatch {
  border: none;
}
@keyframes b {
  30% {
    opacity: 0.6;
  }
  60% {
    opacity: 0;
  }
  to {
    opacity: 0.6;
  }
}
.jodit_progress_bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 2px;
  z-index: 16;
  border-radius: 1px;
  display: none;
}
.jodit_progress_bar div {
  position: relative;
  background: #b91f1f;
  height: 2px;
  transition: width 0.5s ease-out, opacity 0.5s linear;
  will-change: width, opacity;
}
.jodit_progress_bar div:after,
.jodit_progress_bar div:before {
  animation: b 2s ease-out 0s infinite;
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  height: 2px;
  box-shadow: 1px 0 6px 1px #b91f1f;
  border-radius: 100%;
  opacity: 0.6;
}
.jodit_progress_bar div:before {
  width: 180px;
  right: -80px;
  clip: rect(-6px, 90px, 14px, -6px);
}
.jodit_progress_bar div:after {
  width: 20px;
  right: 0;
  clip: rect(-6px, 22px, 14px, 10px);
}
.jodit_tabs .jodit_tabs_buttons {
  line-height: 18px;
  margin-bottom: 5px;
  margin-top: 4px;
}
.jodit_tabs .jodit_tabs_buttons > a {
  display: inline-block;
  text-decoration: none;
  font-size: 11px;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  height: 29px;
  line-height: 27px;
  position: relative;
  vertical-align: middle;
  transition: background 0.1s linear;
  text-overflow: ellipsis;
  overflow: hidden;
  box-shadow: none;
  background-color: #f5f5f5;
  color: #737373;
  border: 1px solid rgba(0, 0, 0, 0.1);
  outline: none;
}
@media (max-width: 768px) {
  .jodit_tabs .jodit_tabs_buttons > a {
    width: 100%!important;
    border-radius: 0 !important;
  }
}
.jodit_tabs .jodit_tabs_buttons > a + a {
  margin-left: -1px;
}
.jodit_tabs .jodit_tabs_buttons > a i,
.jodit_tabs .jodit_tabs_buttons > a svg {
  width: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: sub;
  margin-right: 5px;
  fill: #737373;
}
.jodit_tabs .jodit_tabs_buttons > a:hover {
  border: 1px solid #c6c6c6;
  color: #111;
  box-shadow: none;
  background-color: #f8f8f8;
  outline: none;
}
.jodit_tabs .jodit_tabs_buttons > a:hover i,
.jodit_tabs .jodit_tabs_buttons > a:hover svg {
  fill: #111;
}
.jodit_tabs .jodit_tabs_buttons > a.active,
.jodit_tabs .jodit_tabs_buttons > a:active {
  outline: none;
  background: #fff;
  border: 1px solid #ccc;
  color: #333;
}
.jodit_tabs .jodit_tabs_buttons > a.active i,
.jodit_tabs .jodit_tabs_buttons > a.active svg,
.jodit_tabs .jodit_tabs_buttons > a:active i,
.jodit_tabs .jodit_tabs_buttons > a:active svg {
  fill: #333;
}
.jodit_tabs .jodit_tabs_wrapper .jodit_tab {
  display: none;
}
.jodit_tabs .jodit_tabs_wrapper .jodit_tab.active {
  display: block;
}
.jodit_tabs .jodit_tabs_wrapper .jodit_tab .jodit_tab_empty {
  min-width: 220px;
  min-height: 100px;
}
.jodit-add-new-line {
  z-index: 1;
  position: absolute;
  height: 20px;
  line-height: 100%;
  vertical-align: middle;
  font-size: 0;
  top: 0;
  outline: none;
  margin-top: -10px;
  display: none;
}
.jodit-add-new-line,
.jodit-add-new-line * {
  box-sizing: border-box;
}
.jodit-add-new-line:before {
  height: 100%;
}
.jodit-add-new-line:after,
.jodit-add-new-line:before {
  display: inline-block;
  vertical-align: middle;
  content: "";
}
.jodit-add-new-line:after {
  box-sizing: border-box;
  border-top: 1px solid #ccc;
  height: 1px;
  width: calc(100% - 30px);
}
.jodit-add-new-line span {
  right: 0;
  position: absolute;
  display: inline-block;
  width: 30px;
  height: 20px;
  background: hsla(40, 7%, 92%, 0.3);
  vertical-align: top;
  border: 1px solid #ccc;
  padding: 0 5px;
  cursor: pointer;
}
.jodit-add-new-line span:hover {
  background: #ecebe9;
}
.jodit-add-new-line svg {
  width: 16px;
  fill: #ccc;
  vertical-align: top;
}
.jodit_source_mode .jodit-add-new-line {
  display: none !important;
}
.jodit_error_box_for_messages {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 0;
  height: 0;
  overflow: visible;
  z-index: 3;
}
.jodit_error_box_for_messages > * {
  position: absolute;
  right: 5px;
  bottom: 0;
  display: block;
  transition: opacity 0.1s linear, bottom 0.3s linear;
  opacity: 0;
  background: rgba(255, 0, 0, 0.29);
  color: #e02b2b;
  padding: 2px 7px;
  border: 1px solid hsla(0, 65%, 67%, 0.44);
  font-size: 14px;
  white-space: pre;
}
.jodit_error_box_for_messages > .active {
  opacity: 1;
}
.jodit_error_box_for_messages > .info {
  background: rgba(204, 229, 247, 0.71);
  color: #776565;
  border: 1px solid hsla(0, 0%, 60%, 0.44);
}
.jodit_error_box_for_messages > .success {
  background: rgba(77, 236, 112, 0.29);
  color: #5d5a5a;
  border: 1px solid hsla(0, 0%, 58%, 0.44);
}
.card.jodit_fullsize_box {
  position: static;
}
.viewcontent.jodit_fullsize_box {
  position: sticky;
  min-height: calc(100vh + 30px);
}
.viewcontent.jodit_fullsize_box > *:not(.jodit_fullsize_box) {
  display: none;
}
.jodit_fullsize {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 11;
  max-width: 100% !important;
}
.jodit_fullsize .toolbar {
  width: 100% !important;
}
.jodit_fullsize .jodit_area,
.jodit_fullsize .jodit_editor {
  height: 100%;
}
.jodit_fullsize .jodit_workflow {
  height: calc(100% - 16px * 1.5);
  overflow: auto;
}
.jodit_fullsize.jodit_toolbar_size-small .jodit_workflow {
  height: calc(100% - 12px * 1.5);
}
.jodit_fullsize.jodit_toolbar_size-large .jodit_workflow {
  height: calc(100% - 18px * 1.5);
}
.jodit_placeholder {
  -webkit-user-select: none!important;
  user-select: none!important;
  top: 0;
  left: 0;
  display: block;
  position: absolute;
  padding: 10px;
  color: rgba(0, 0, 0, 0.35);
  pointer-events: none;
}
.jodit_toolbar_popup-inline-target {
  position: absolute;
  width: 0;
  height: 0;
}
.jodit_toolbar_popup-inline-target.jodit_toolbar_popup-inline-target-hidden {
  display: none;
}
.jodit_toolbar_popup-inline {
  display: inline-block !important;
  position: relative !important;
}
.jodit_toolbar_popup-inline > div {
  color: hsla(0, 0%, 88%, 0.99);
  background: #fff;
  box-shadow: none;
  background-clip: padding-box;
  font-family: Helvetica, sans-serif;
  box-sizing: border-box;
  -webkit-user-select: none;
  user-select: none;
  z-index: 12!important;
  text-align: left;
  border: 1px solid hsla(0, 0%, 88%, 0.99);
  display: inline-block;
  vertical-align: top;
}
.jodit_toolbar_popup-inline .jodit_toolbar {
  z-index: 6;
  border: 0;
  white-space: normal;
}
.jodit_toolbar_popup-inline > div > .jodit_toolbar {
  white-space: nowrap;
  box-shadow: none;
  vertical-align: top;
}
.jodit_toolbar_popup-inline > .jodit_popup_triangle {
  padding: 0;
  margin: 0;
  width: 8px;
  height: 8px;
  position: absolute;
  top: -4px;
  margin-left: -4px;
  display: inline-block;
  transform: rotate(45deg);
  background: #fff;
  border: 1px solid hsla(0, 0%, 88%, 0.99);
  border-width: 1px 0 0 1px;
  z-index: 5;
}
.jodit_toolbar_popup-inline.jodit_toolbar_popup-inline-top > .jodit_popup_triangle {
  top: auto;
  bottom: -4px;
  border-width: 0 1px 1px 0;
}
.jodit_toolbar_popup-inline .buttons {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  padding: 0 2px;
  white-space: nowrap;
  line-height: 0;
  border-bottom: 0;
}
[data-jodit_iframe_wrapper] {
  display: block;
  clear: both;
  -webkit-user-select: none;
  user-select: none;
  position: relative;
}
[data-jodit_iframe_wrapper]:after {
  position: absolute;
  content: "";
  z-index: 1;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  display: block;
  background: transparent;
}
.jodit_resizer {
  width: 100px;
  height: 100px;
  position: absolute;
  border: 1px solid rgba(3, 14, 82, 0.92);
  top: 0;
  left: 0;
  display: none;
  pointer-events: none;
  font-size: 0;
}
.jodit_resizer * {
  box-sizing: border-box;
}
.jodit_resizer > span {
  opacity: 0;
  transition: opacity 0.2s linear;
  left: 50%;
  top: 50%;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  width: 70px;
  margin-left: -35px;
  margin-top: -12px;
  text-align: center;
  overflow: visible;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.35);
  max-width: 100%;
}
.jodit_resizer > i,
.jodit_resizer > span {
  position: absolute;
  display: inline-block;
}
.jodit_resizer > i {
  z-index: 4;
  pointer-events: all;
  border: 1px solid rgba(3, 14, 82, 0.92);
  background-color: hsla(0, 0%, 88%, 0.99);
  width: 10px;
  height: 10px;
}
.jodit_resizer > i:hover {
  background-color: #f8f8f8;
}
.jodit_resizer > i:first-child {
  left: -5px;
  top: -5px;
  cursor: nw-resize;
}
.jodit_resizer > i:nth-child(2) {
  right: -5px;
  top: -5px;
  cursor: ne-resize;
}
.jodit_resizer > i:nth-child(3) {
  right: -5px;
  bottom: -5px;
  cursor: se-resize;
}
.jodit_resizer > i:nth-child(4) {
  left: -5px;
  bottom: -5px;
  cursor: sw-resize;
}
@media (max-width: 768px) {
  .jodit_resizer > i {
    width: 20px;
    height: 20px;
  }
  .jodit_resizer > i:first-child {
    left: -10px;
    top: -10px;
    cursor: nw-resize;
  }
  .jodit_resizer > i:nth-child(2) {
    right: -10px;
    top: -10px;
    cursor: ne-resize;
  }
  .jodit_resizer > i:nth-child(3) {
    right: -10px;
    bottom: -10px;
    cursor: se-resize;
  }
  .jodit_resizer > i:nth-child(4) {
    left: -10px;
    bottom: -10px;
    cursor: sw-resize;
  }
}
.jodit_container {
  min-height: 100px;
}
.jodit_container .jodit_workplace {
  display: flex;
  height: auto;
  min-height: 50px;
  overflow: hidden;
}
.jodit_editor_resize {
  position: relative;
}
.jodit_editor_resize a {
  position: absolute;
  bottom: 0;
  right: 0;
  -webkit-user-select: none;
  user-select: none;
  width: 0;
  height: 0;
  overflow: hidden;
  border-width: 7px 7px 0 0;
  border-color: transparent #ccc transparent transparent;
  border-style: dashed solid dashed dashed;
  cursor: se-resize;
}
.jodit_source {
  display: none;
  position: relative;
  background-color: #f8f8f8;
  font-size: 0;
  flex: 1 1;
  overflow: auto;
}
.jodit_source,
.jodit_source .jodit_source_mirror-fake {
  min-height: 100%;
}
.jodit_container.jodit_source_mode .jodit_wysiwyg,
.jodit_container.jodit_source_mode .jodit_wysiwyg_iframe {
  display: none !important;
}
.jodit_container.jodit_source_mode .jodit_source {
  display: block !important;
}
.jodit_container.jodit_split_mode .jodit_source,
.jodit_container.jodit_split_mode .jodit_wysiwyg,
.jodit_container.jodit_split_mode .jodit_wysiwyg_iframe {
  display: block!important;
  width: 50%;
  flex: 1 1;
}
.jodit_source_mirror {
  border: 0;
  width: 100%;
  background: #3f3f3f;
  margin: 0;
  height: 100%;
  box-shadow: none;
  resize: none;
  box-sizing: border-box;
  color: #f0f0f0;
  outline: none;
  font-family: Menlo, Monaco, monospace, sans-serif;
  font-size: 13px;
  line-height: 1.3em;
  z-index: 2;
  padding: 10px;
  overflow: auto;
  white-space: pre-wrap;
  tab-size: 2em;
  min-height: 100%;
}
.jodit_source_mirror::selection {
  background: #bdbdbd;
}
.jodit_table_resizer {
  cursor: col-resize;
  position: absolute;
  z-index: 3;
  padding-left: 5px;
  padding-right: 5px;
  margin-left: -5px;
}
.jodit_table_resizer:after {
  content: "";
  display: block;
  height: 100%;
  width: 0;
  border: 1px solid transparent;
  border-width: 0 1px 0 0;
}
.jodit_table_resizer-moved {
  z-index: 2;
}
.jodit_table_resizer-moved:after {
  border-color: #1e88e5;
}
.jodit_wysiwyg table {
  width: 100%;
  border: none;
  border-collapse: collapse;
  table-layout: fixed;
  empty-cells: show;
  max-width: 100%;
}
.jodit_wysiwyg table tr {
  -webkit-user-select: none;
  user-select: none;
}
.jodit_wysiwyg table tr td,
.jodit_wysiwyg table tr th {
  border: 1px solid #ddd;
  text-align: left;
  vertical-align: middle;
  -webkit-user-select: text;
  user-select: text;
}
.jodit_wysiwyg table tr td[data-jodit-selected-cell],
.jodit_wysiwyg table tr th[data-jodit-selected-cell] {
  border: 1px double #1e88e5;
}
.jodit_form_inserter .jodit_form-table-creator-box {
  font-size: 0;
}
.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-container {
  display: inline-block;
  vertical-align: top;
  padding: 0;
  margin: 0;
  min-width: 180px;
  font-size: 0;
}
.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-container > div {
  width: 18px;
  height: 18px;
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  vertical-align: top;
}
.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-container > div:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1px solid #ccc;
}
.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-container > div.hovered:after {
  background: #7a450f;
  border: 1px solid #b5b5b5;
}
.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-options {
  font-size: 14px;
  display: inline-block;
  vertical-align: top;
}
.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-options label {
  text-align: left;
  padding-top: 0;
}
.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-options label input {
  margin-right: 10px;
}
.jodit_form_inserter label {
  text-align: center;
  font-size: 14px;
  padding: 8px;
  display: block;
  margin: 0;
}
.jodit_text_icons .jodit_icon {
  width: auto;
  font-size: 14px;
}
.jodit_text_icons .jodit_icon:first-letter {
  text-transform: uppercase;
}
.jodit_text_icons .jodit_tabs .jodit_tabs_buttons > a {
  font-family: Helvetica, sans-serif;
  width: auto;
}
.jodit_text_icons .jodit_tabs .jodit_tabs_buttons > a i,
.jodit_text_icons .jodit_toolbar > li {
  width: auto;
}
.jodit_text_icons .jodit_toolbar > li > a {
  text-decoration: none;
}
.jodit_text_icons.jodit_dialog_box .jodit_dialog .jodit_button,
.jodit_text_icons.jodit_dialog_box .jodit_dialog .jodit_dialog_header a,
.jodit_text_icons .jodit_toolbar > li > a {
  padding: 0 12px;
  font-family: Helvetica, sans-serif;
  width: auto;
  color: rgba(0, 0, 0, 0.75);
}
.jodit_text_icons.jodit_dialog_box .jodit_dialog .jodit_button .jodit_icon,
.jodit_text_icons.jodit_dialog_box .jodit_dialog .jodit_dialog_header a .jodit_icon {
  width: auto;
}
.jodit_widget,
.jodit_widget * {
  box-sizing: border-box;
}
.jodit_search {
  visibility: hidden;
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
}
.jodit_search.jodit_search-active {
  visibility: visible;
}
.jodit_search .jodit_search_box {
  width: 320px;
  position: absolute;
  right: 0;
  background-color: #f9f9f9;
  border: 1px solid #ccc;
  border-width: 0 0 1px 1px;
  padding: 5px;
}
.jodit_search .jodit_search_box input {
  margin: 0;
  width: 100%;
  height: 100%;
  border: 0;
  background-color: transparent;
  outline: none;
  padding: 0 10px;
}
.jodit_search .jodit_search_box input.jodit_search-replace {
  display: none;
}
.jodit_search .jodit_search_box .jodit_search_buttons,
.jodit_search .jodit_search_box .jodit_search_counts,
.jodit_search .jodit_search_box .jodit_search_inputs {
  height: 30px;
  display: inline-block;
  vertical-align: top;
}
.jodit_search .jodit_search_box .jodit_search_inputs {
  width: 60%;
  padding-right: 5px;
}
.jodit_search .jodit_search_box .jodit_search_counts {
  width: 15%;
  line-height: 100%;
  text-align: center;
  color: #ccc;
  border-left: 1px solid #ccc;
}
.jodit_search .jodit_search_box .jodit_search_counts:before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  height: 100%;
}
.jodit_search .jodit_search_box .jodit_search_counts span {
  display: inline-block;
  vertical-align: middle;
}
.jodit_search .jodit_search_box .jodit_search_buttons {
  padding-left: 0;
  width: 25%;
}
.jodit_search .jodit_search_box .jodit_search_buttons button {
  outline: 0;
  width: 32%;
  padding: 1px 5px;
  margin-right: 1%;
  transition: transform 0.1s linear;
  height: 100%;
  border: 1px solid transparent;
  background-color: transparent;
}
.jodit_search .jodit_search_box .jodit_search_buttons button.jodit_search_buttons-replace {
  width: 100%;
  border: 1px solid #ccc;
  margin-top: 2px;
  display: none;
}
.jodit_search .jodit_search_box .jodit_search_buttons button:hover {
  background-color: #ecebe9;
}
.jodit_search .jodit_search_box .jodit_search_buttons button:focus {
  border: 1px solid rgba(181, 214, 253, 0.5);
}
.jodit_search .jodit_search_box .jodit_search_buttons button:active {
  border: 1px solid #b5d6fd;
  transform: scale(0.95);
}
.jodit_search.jodit_search-and-replace .jodit_search_counts,
.jodit_search.jodit_search-and-replace .jodit_search_inputs {
  height: 60px;
}
.jodit_search.jodit_search-and-replace .jodit_search_counts input,
.jodit_search.jodit_search-and-replace .jodit_search_inputs input {
  height: 50%;
  transition: background-color 0.1s linear;
}
.jodit_search.jodit_search-and-replace .jodit_search_counts input:focus,
.jodit_search.jodit_search-and-replace .jodit_search_inputs input:focus {
  box-shadow: inset 0 0 3px 0 hsla(0, 0%, 80%, 0.58);
}
.jodit_search.jodit_search-and-replace .jodit_search_buttons button.jodit_search_buttons-replace,
.jodit_search.jodit_search-and-replace .jodit_search_inputs input.jodit_search-replace {
  display: block;
}
@media (max-width: 320px) {
  .jodit_search,
  .jodit_search .jodit_search_box {
    width: 100%;
  }
}
.jodit_symbols {
  width: 460px;
  padding: 10px;
}
.jodit_symbols .jodit_symbols-container_preview,
.jodit_symbols .jodit_symbols-container_table {
  display: inline-block;
  vertical-align: top;
}
.jodit_symbols .jodit_symbols-container_table {
  width: 88%;
}
.jodit_symbols .jodit_symbols-container_preview {
  width: 12%;
}
.jodit_symbols .jodit_symbols-container_preview .jodit_symbols-preview {
  font-size: 34px;
  text-align: center;
  padding: 20px 0;
  border: 1px solid #ccc;
}
.jodit_symbols table {
  border: 0;
  border-spacing: 0;
  table-layout: fixed;
}
.jodit_symbols table td {
  padding: 0;
}
.jodit_symbols table td a {
  font-size: 16px;
  text-decoration: none;
  color: #000;
  display: inline-block;
  box-sizing: border-box;
  width: 21.6px;
  height: 21.6px;
  border: 1px solid transparent;
  text-align: center;
  line-height: 21.6px;
  vertical-align: top;
}
.jodit_symbols table td a:focus,
.jodit_symbols table td a:hover {
  border: 1px solid #1e88e5;
}
.jodit_sticky-dummy_toolbar {
  display: none;
}
.jodit_sticky > .jodit_toolbar {
  position: fixed;
  z-index: 3;
  top: 0;
  left: auto;
}
.jodit_sticky .jodit_sticky-dummy_toolbar {
  display: block;
}
.jodit_paste_storage {
  padding: 10px;
  max-width: 600px;
}
@media (max-width: 768px) {
  .jodit_paste_storage {
    max-width: 100%;
  }
}
.jodit_paste_storage > div {
  max-width: 100%;
  max-height: 300px;
  border: 1px solid #ccc;
}
.jodit_paste_storage > div:first-child {
  margin-bottom: 10px;
}
.jodit_paste_storage > div:first-child a {
  outline: none;
  box-sizing: border-box;
  display: block;
  max-width: 100%;
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 5px;
  margin: 0;
  border: 1px solid transparent;
  text-decoration: none;
  color: #000;
}
.jodit_paste_storage > div:first-child a.jodit_active {
  color: #fff;
  background-color: #575757;
}
.jodit_paste_storage > div:first-child a:focus {
  outline: none;
}
.jodit_paste_storage > div:last-child {
  padding: 10px;
  overflow: auto;
}
.jodit_paste_storage > div:last-child li,
.jodit_paste_storage > div:last-child ul {
  margin: 0;
}
.form-group .form-control.rdw-editor-wrapper {
  padding: 0;
}
.form-control.forminput.slate-wrapper {
  flex-wrap: wrap;
}
.form-control.forminput.slate-wrapper .slate-editor {
  flex: 0 0 100%;
  min-height: 112px;
  padding: 15px;
}
.required .form-control.forminput.slate-wrapper:before {
  position: absolute;
}
.form-control.forminput.slate-wrapper .DraftEditor-editorContainer {
  z-index: auto;
}
.slate-toolbar {
  position: relative;
  border: 0;
  border-bottom: 2px solid #eeeeee;
  display: flex;
  flex: 1 1 100%;
  flex-wrap: wrap;
  gap: 0 7.5px;
  padding: 15px 0;
  margin: 0 15px;
  border-radius: 0;
  align-items: center;
}
.slate-toolbar > div {
  margin: 0;
  display: flex;
  gap: 0 7.5px;
}
.slate-toolbar .btn {
  padding: 0;
  width: 24px;
  min-height: 24px;
  justify-content: center;
}
.slate-toolbar .btn:hover {
  box-shadow: none;
}
.slate-toolbar .btn.rdw-option-active {
  box-shadow: none;
}
.slate-toolbar .btn.rdw-option-active svg {
  stroke-width: 2.4;
}
.slate-toolbar .slate-button {
  flex: 0 0 auto;
  width: 24px;
  height: 24px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  display: flex;
  margin: 0 5px;
}
.slate-toolbar .slate-button.code {
  display: none;
}
.slate-toolbar .slate-button.blockquote {
  display: none;
}
.slate-toolbar .slate-button.u {
  display: none;
}
.slate-toolbar .slate-button span {
  display: flex;
}
.slate-toolbar .slate-button svg {
  display: block;
  width: 20px;
  height: 20px;
}
@media (min-width: 799px) {
  .slate-toolbar .slate-button.code {
    display: flex;
  }
  .slate-toolbar .slate-button.blockquote {
    display: flex;
  }
  .slate-toolbar .slate-button.u {
    display: flex;
  }
}
.slate-toolbar .slate-source {
  box-sizing: border-box;
  padding: 2px;
  height: 28px;
  align-self: middle;
  margin-left: auto;
}
[data-slate-editor] {
  flex: 0 0 100%;
}
[data-slate-editor] > p {
  font-size: 1.1rem;
}
[data-slate-editor] blockquote {
  border-left: 5px solid #ccc;
  font-style: italic;
  margin: 1.5em 10px;
  padding: 0.5em 10px;
  quotes: "\\201C" "\\201D" "\\2018" "\\2019";
}
[data-slate-editor] blockquote:before {
  color: #ccc;
  font-style: normal;
  content: open-quote;
  font-size: 4em;
  line-height: 0.1em;
  margin-right: 0.25em;
  vertical-align: -0.4em;
}
[data-slate-editor] blockquote p {
  display: inline;
}
[data-slate-editor] code {
  background: #f9f9f9;
  padding: 5px 8px;
}
[data-slate-editor] {
  padding: 0 10px;
}
[data-slate-editor] * + * {
  margin-top: 1em;
}
.slate-editor-frame {
  width: 100%;
  height: 480px;
  border: 1px solid #f9f9f9;
}
.form-group.editor {
  flex: 0 0 100%;
  max-width: 100%;
}
.other h2 {
  font-size: 18px;
  color: #444;
  margin-bottom: 7px;
}
.other a {
  color: #777;
  text-decoration: underline;
  font-size: 14px;
}
.other ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.App {
  font-family: sans-serif;
  text-align: center;
}
h1 {
  font-size: 24px;
  color: #333;
}
.ltr {
  text-align: left;
}
.rtl {
  text-align: right;
}
.editor-container {
  background: none;
  font-weight: 400;
  text-align: left;
  flex-wrap: wrap;
}
.editor-inner {
  position: relative;
  width: 100%;
  max-width: 100%;
}
.editor-input {
  flex: 0 0 100%;
  min-height: 150px;
  max-width: 100%;
  resize: none;
  position: relative;
  tab-size: 1;
  outline: 0;
  padding: 15px 10px;
}
@media screen and (max-width: 799px) {
  .editor-input * {
    -webkit-touch-callout: none;
    /* Safari Touch */
    -webkit-user-select: none;
    /* Webkit */
    /* Firefox */
    /* Edge*/
    user-select: none;
    /* Future-proof*/
  }
}
.editor-input a {
  color: inherit;
  text-decoration: underline;
}
.editor-input a:hover {
  color: #10294D;
}
.editor-input .underline {
  text-decoration: underline;
}
.editor-input .line-through {
  text-decoration: line-through;
}
.editor-placeholder {
  color: #B2C2D4;
  overflow: hidden;
  position: absolute;
  text-overflow: ellipsis;
  top: 15px;
  left: 10px;
  font-size: 15px;
  -webkit-user-select: none;
          user-select: none;
  display: inline-block;
  pointer-events: none;
}
.editor-text-bold {
  font-weight: bold;
}
.editor-text-italic {
  font-style: italic;
}
.editor-text-underline {
  text-decoration: underline;
}
.editor-text-strikethrough {
  text-decoration: line-through;
}
.editor-text-underlineStrikethrough {
  text-decoration: underline line-through;
}
.editor-text-code {
  background-color: #f0f2f5;
  padding: 1px 0.25rem;
  font-family: Menlo, Consolas, Monaco, monospace;
  font-size: 94%;
}
.editor-link {
  color: #216fdb;
  text-decoration: none;
}
.tree-view-output {
  display: block;
  background: #222;
  color: #fff;
  padding: 5px;
  font-size: 12px;
  white-space: pre-wrap;
  margin: 1px auto 10px auto;
  max-height: 250px;
  position: relative;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  overflow: auto;
  line-height: 14px;
}
.editor-code {
  background-color: #f0f2f5;
  font-family: Menlo, Consolas, Monaco, monospace;
  display: block;
  padding: 8px 8px 8px 52px;
  line-height: 1.53;
  font-size: 13px;
  margin: 0;
  margin-top: 8px;
  margin-bottom: 8px;
  tab-size: 2;
  /* white-space: pre; */
  overflow-x: auto;
  position: relative;
}
.editor-code:before {
  content: attr(data-gutter);
  position: absolute;
  background-color: #eee;
  left: 0;
  top: 0;
  border-right: 1px solid #ccc;
  padding: 8px;
  color: #777;
  white-space: pre-wrap;
  text-align: right;
  min-width: 25px;
}
.editor-code:after {
  content: attr(data-highlight-language);
  top: 0;
  right: 3px;
  padding: 3px;
  font-size: 10px;
  text-transform: uppercase;
  position: absolute;
  color: rgba(0, 0, 0, 0.5);
}
.editor-tokenComment {
  color: slategray;
}
.editor-tokenPunctuation {
  color: #999;
}
.editor-tokenProperty {
  color: #905;
}
.editor-tokenSelector {
  color: #690;
}
.editor-tokenOperator {
  color: #9a6e3a;
}
.editor-tokenAttr {
  color: #07a;
}
.editor-tokenVariable {
  color: #e90;
}
.editor-tokenFunction {
  color: #dd4a68;
}
.editor-paragraph {
  margin: 0;
  margin-bottom: 8px;
  position: relative;
}
.editor-paragraph:last-child {
  margin-bottom: 0;
}
.editor-heading-h1 {
  font-size: 24px;
  color: #050505;
  font-weight: 400;
  margin: 0;
  margin-bottom: 12px;
  padding: 0;
}
.editor-heading-h2 {
  font-size: 15px;
  color: #65676b;
  font-weight: 700;
  margin: 0;
  margin-top: 10px;
  padding: 0;
  text-transform: uppercase;
}
blockquote {
  background: #f2f2f2;
  border-left-color: #ced0d4;
  border-left-width: 4px;
  border-left-style: solid;
  padding: 16px;
  margin: 1em 0;
}
.editor-list-ol {
  padding: 0;
  margin: 0;
  margin-left: 16px;
}
.editor-list-ul {
  padding: 0;
  margin: 0;
  margin-left: 16px;
}
.editor-listitem {
  margin: 8px 32px 8px 32px;
}
.editor-nested-listitem {
  list-style-type: none;
}
pre::-webkit-scrollbar {
  background: transparent;
  width: 10px;
}
pre::-webkit-scrollbar-thumb {
  background: #999;
}
.debug-timetravel-panel {
  overflow: hidden;
  padding: 0 0 10px 0;
  margin: auto;
  display: flex;
}
.debug-timetravel-panel-slider {
  padding: 0;
  flex: 8 1;
}
.debug-timetravel-panel-button {
  padding: 0;
  border: 0;
  background: none;
  flex: 1 1;
  color: #fff;
  font-size: 12px;
}
.debug-timetravel-panel-button:hover {
  text-decoration: underline;
}
.debug-timetravel-button {
  border: 0;
  padding: 0;
  font-size: 12px;
  top: 10px;
  right: 15px;
  position: absolute;
  background: none;
  color: #fff;
}
.debug-timetravel-button:hover {
  text-decoration: underline;
}
.emoji {
  color: transparent;
  background-size: 16px 16px;
  background-position: center;
  background-repeat: no-repeat;
  vertical-align: middle;
  margin: 0 -1px;
}
.emoji-inner {
  padding: 0 0.15em;
}
.emoji-inner::selection {
  color: transparent;
  background-color: rgba(150, 150, 150, 0.4);
}
.emoji-inner::moz-selection {
  color: transparent;
  background-color: rgba(150, 150, 150, 0.4);
}
.toolbar {
  display: flex;
  flex: 0 0 100%;
  margin-bottom: 1px;
  flex-wrap: wrap;
  padding-bottom: 4px;
  vertical-align: middle;
  border-bottom: 2px solid #eeeeee;
}
.toolbar button.toolbar-item {
  border: 1px solid transparent;
  display: flex;
  background: none;
  padding: 8px;
  cursor: pointer;
  vertical-align: middle;
}
.toolbar button.toolbar-item:disabled {
  cursor: not-allowed;
}
.toolbar button.toolbar-item.spaced {
  margin-right: 2px;
}
.toolbar button.toolbar-item i.format {
  background-size: contain;
  display: inline-block;
  height: 18px;
  width: 18px;
  margin-top: 2px;
  vertical-align: -0.25em;
  display: flex;
  opacity: 0.6;
}
.toolbar button.toolbar-item:disabled i.format {
  opacity: 0.2;
}
.toolbar button.toolbar-item.active {
  background-color: rgba(223, 232, 250, 0.3);
}
.toolbar button.toolbar-item.active i {
  opacity: 1;
}
.toolbar .toolbar-item:hover:not([disabled]) {
  background-color: #eee;
}
.toolbar .divider {
  width: 1px;
  background-color: #eee;
  margin: 0 4px;
}
.toolbar select.toolbar-item {
  border: 1px solid transparent;
  display: flex;
  background: none;
  border-radius: 10px;
  padding: 8px;
  vertical-align: middle;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 70px;
  font-size: 14px;
  color: #777;
  text-overflow: ellipsis;
}
.toolbar select.code-language {
  text-transform: capitalize;
  width: 130px;
}
.toolbar .toolbar-item .text {
  display: flex;
  line-height: 20px;
  width: 200px;
  vertical-align: middle;
  font-size: 14px;
  color: #777;
  text-overflow: ellipsis;
  width: 70px;
  overflow: hidden;
  height: 20px;
  text-align: left;
}
.toolbar i.chevron-down {
  margin-top: 3px;
  width: 16px;
  height: 16px;
  display: flex;
  -webkit-user-select: none;
          user-select: none;
}
.toolbar i.chevron-down.inside {
  width: 16px;
  height: 16px;
  display: flex;
  margin-left: -25px;
  margin-top: 11px;
  margin-right: 10px;
  pointer-events: none;
}
i.chevron-down {
  background-color: transparent;
  background-size: contain;
  display: inline-block;
  height: 8px;
  width: 8px;
}
#block-controls button:hover {
  background-color: #efefef;
}
#block-controls button:focus-visible {
  border-color: blue;
}
#block-controls span.block-type {
  background-size: contain;
  display: block;
  width: 18px;
  height: 18px;
  margin: 2px;
}
.dropdown {
  z-index: 5;
  display: block;
  position: absolute;
  box-shadow: 0 12px 28px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(255, 255, 255, 0.5);
  border-radius: 8px;
  min-width: 100px;
  min-height: 40px;
  background-color: #fff;
}
.dropdown .item {
  margin: 0 8px 0 8px;
  padding: 8px;
  color: #050505;
  cursor: pointer;
  line-height: 16px;
  font-size: 15px;
  display: flex;
  align-content: center;
  flex-direction: row;
  flex-shrink: 0;
  justify-content: space-between;
  background-color: #fff;
  border-radius: 8px;
  border: 0;
  min-width: 268px;
}
.dropdown .item .active {
  display: flex;
  width: 20px;
  height: 20px;
  background-size: contain;
}
.dropdown .item:first-child {
  margin-top: 8px;
}
.dropdown .item:last-child {
  margin-bottom: 8px;
}
.dropdown .item:hover {
  background-color: #eee;
}
.dropdown .item .text {
  display: flex;
  line-height: 20px;
  flex-grow: 1;
  width: 200px;
}
.dropdown .item .icon {
  display: flex;
  width: 20px;
  height: 20px;
  -webkit-user-select: none;
          user-select: none;
  margin-right: 12px;
  line-height: 16px;
  background-size: contain;
}
.link-editor {
  position: absolute;
  z-index: 1000;
  top: -10000px;
  left: -10000px;
  margin-top: -6px;
  max-width: 300px;
  width: 100%;
  opacity: 0;
  background-color: #fff;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  transition: opacity 0.5s;
}
.link-editor .link-input {
  display: flex;
  width: calc(100% - 24px);
  box-sizing: border-box;
  margin: 8px 12px;
  padding: 8px 0 8px 12px;
  border-radius: 15px;
  background-color: #eee;
  font-size: 15px;
  color: #050505;
  border: 0;
  outline: 0;
  position: relative;
  font-family: inherit;
}
.link-editor .link-target {
  display: flex;
  gap: 5px 5px;
  width: 100%;
  margin: 8px 12px;
  padding: 8px 0 8px 0;
}
.link-editor div.link-edit {
  background-size: 16px;
  background-position: center;
  background-repeat: no-repeat;
  width: 35px;
  vertical-align: -0.25em;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  cursor: pointer;
}
.link-editor .link-input a {
  color: #216fdb;
  text-decoration: none;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1 100%;
}
.link-editor .link-input a:hover {
  text-decoration: underline;
}
.link-editor .button {
  width: 20px;
  height: 20px;
  display: inline-block;
  padding: 6px;
  border-radius: 8px;
  cursor: pointer;
  margin: 0 2px;
}
.link-editor .button.hovered {
  width: 20px;
  height: 20px;
  display: inline-block;
  background-color: #eee;
}
.link-editor .button i,
.actions i {
  background-size: contain;
  display: inline-block;
  height: 20px;
  width: 20px;
  vertical-align: -0.25em;
}
.nestedListItem {
  list-style-type: none;
}
.nestedListItem:before,
.nestedListItem:after {
  display: none;
}
.nestedListItem > ul {
  padding-top: 0;
}
.lexical-inline-image {
  position: relative;
}
.lexical-inline-image button {
  position: absolute;
  top: 5px;
  left: 5px;
}
.lexical-inline-image img.focused.draggable {
  cursor: grab;
}
.lexical-inline-image img.focused.draggable:active {
  cursor: grabbing;
}
figure.inline-image {
  display: inline-flex;
  flex-direction: column;
}
figure.inline-image.position-left {
  float: left;
}
figure.inline-image.position-right {
  float: right;
}
figure.inline-image.position-full {
  width: 100%;
}
.notes-summary {
  display: block;
}
.notes-summary:hover {
  background: #EBF5FF;
}
.notes-summary-top {
  border-top: 1px solid #F3F5F8;
  padding: 20px 20px 0 20px;
  display: flex;
  align-items: center;
  gap: 0 6px;
}
.notes-summary-top .avatar-md > .thumbimg {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.notes-summary-top .agents {
  display: flex;
  align-items: center;
  overflow: hidden;
}
.notes-summary-date {
  margin-left: auto;
  font-size: 11px;
  font-weight: 400;
  color: #B2C2D4;
  text-align: right;
}
.notes-summary-pin .btn svg {
  stroke: #CED7E2;
}
.notes-summary-pin .btn.pinned svg {
  stroke: #10294D;
}
.notes-summary-private .btn svg {
  stroke: #CED7E2;
}
.notes-summary-private .btn.private svg {
  stroke: #10294D;
}
.notes-summary-tag-name {
  display: flex;
}
.notes-summary-body {
  padding: 20px 20px;
  display: block;
}
.notes-summary-body div {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-summary:last-of-type .notes-summary-bottom {
  border-bottom: 1px solid #F3F5F8;
}
.notes-summary-bottom {
  display: flex;
  gap: 6px 6px;
  padding: 0 20px 20px 20px;
  justify-content: space-between;
}
.notes-summary-bottom .notes-summary-comments {
  display: flex;
  align-items: center;
  gap: 0 6px;
  color: #10294D;
  font-weight: 600;
}
.notes-summary-bottom .notes-summary-comments .icon {
  width: 16px;
  height: 16px;
}
.notes-summary-bottom .notes-summary-comments svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: #CED7E2;
  stroke-width: 2.4;
}
.notes-summary .notes-summary-creator .agent {
  margin-right: 5px;
}
.notes-summary .notes-summary-attachments {
  display: flex;
  align-items: center;
  gap: 0 6px;
  color: #10294D;
  font-weight: 600;
}
.notes-summary .notes-summary-attachments svg {
  width: 16px;
  fill: none;
  stroke: #CED7E2;
  stroke-width: 2.4;
}
.notes-summary .notes-summary-tag {
  border-radius: 30px;
  padding: 5px 8px;
  font-size: 10px;
  background: #B2C2D4;
  color: #ffffff;
}
.notes-summary .notes-summary-tag-related {
  border-radius: 30px;
  padding: 5px 8px;
  font-size: 10px;
  background: #CED7E2;
  color: #ffffff;
}
.notes-summary .notes-summary-tag-name {
  margin-left: auto;
}
.notes-summary.active {
  border: 2px solid #E5EBF1;
}
.notes-index {
  top: 0;
  position: relative;
  grid-area: jump-menu;
  width: 100%;
  background: #ffffff;
}
@media screen and (min-width: 799px) {
  .notes-index {
    position: sticky;
    width: 370px;
  }
}
.notes-index form,
.notes-index > div:nth-child(1) {
  padding: 10px 20px;
  display: flex;
}
.notes-index .keyword-search {
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 100%;
  gap: 10px 10px;
}
.notes-index .keyword-search .btn-red {
  margin-left: auto;
}
.notes-index .keyword-search > .form-group {
  flex: 0 0 100%;
  gap: 10px 10px;
}
.notes-index .keyword-search > .form-group .form-group {
  flex: 1 1 auto;
}
.notes-index .keyword-search > .form-group .form-group.dateinput {
  flex: 0 0 auto;
}
.notes-index .keyword-search .advanced-toggle {
  flex: 1 1 auto;
  justify-content: center;
}
.notes-index .keyword-search .button-only {
  flex: 0 0 auto !important;
}
.notes-index .keyword-search .input-only .flatpickr-wrapper {
  flex: 0 0;
  max-width: 0;
}
.notes-index .keyword-search .input-only .input-group-addon {
  min-height: 36px;
}
.notes-index .keyword-search .inline-select .input-group-addon {
  font-size: 14px;
  padding-left: 15px;
}
.notes-index .no-notes {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 100%;
  padding-bottom: 56px;
}
.notes-index .no-notes .no-notes-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 100%;
}
.notes-view-notes {
  display: flex;
  flex-wrap: wrap;
  gap: 20px 0;
}
.tab-notes .stepper {
  grid-area: details;
}
.notes-view {
  position: fixed;
  top: 112px;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-x: auto;
  z-index: 1000;
  padding-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
  grid-area: details;
  grid-template-areas: "interactions";
  grid-template-columns: auto;
  background-color: #F3F5F8;
}
@media screen and (min-width: 799px) {
  .notes-view {
    z-index: initial;
    position: relative;
    top: 0;
    padding-top: 0;
    padding-left: 0;
    display: grid;
  }
}
.notes-view.no-notes {
  display: flex;
  align-items: center;
  justify-content: center;
}
.notes-view-note,
.notes-view-comment {
  display: flex;
  flex-wrap: nowrap;
  gap: 0 20px;
  flex: 0 0 100%;
}
.notes-view .agent {
  margin: 0;
}
.notes-view-author {
  font-size: 11px;
  color: #5A6F89;
  font-weight: 600;
}
.notes-view-comment .notes-view-body {
  background: #EBF5FF;
}
.notes-view-body {
  flex: 1 1 100%;
  display: flex;
  flex-wrap: wrap;
  background: #FAFBFD;
  padding: 20px;
  gap: 10px 0;
  border-radius: 8px;
  position: relative;
}
.notes-view-body .notes-summary-tag-name {
  margin-right: 5px;
}
.notes-view-content {
  flex: 0 0 100%;
}
.notes-view-top {
  flex: 0 0 100%;
  display: flex;
  flex-wrap: nowrap;
}
.notes-view-date {
  margin-left: auto;
  font-size: 11px;
  font-weight: 400;
  color: #92A7C0;
  text-align: right;
}
.notes-view-bottom {
  flex: 0 0 100%;
  display: flex;
  gap: 6px 6px;
}
.notes-view-bottom .btn {
  min-height: 1.5em;
}
.notes-view-attachments {
  flex: 0 0 100%;
  display: flex;
  gap: 6px 6px;
}
.notes-view-attachments svg {
  width: 16px;
  fill: none;
  stroke: #10294D;
  stroke-width: 2.4;
}
.notes-view-relations-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 10px;
}
.notes-view-relation {
  border: 1px solid #CED7E2;
  border-radius: 2px;
  font-weight: 500;
  font-size: 12px;
  padding: 2px 5px;
  color: #455870;
}
.notes-view .tag,
.notes-summary .tag {
  background-color: #ffffff;
  border: 1px solid #CED7E2;
}
.notes-view .tag.Scheduled,
.notes-summary .tag.Scheduled {
  background-color: #FFF6EF;
  color: #FFA564;
  border: none;
  display: list-item;
  list-style-position: inside;
  white-space: nowrap;
}
.notes-view .tag.Complete,
.notes-summary .tag.Complete {
  background-color: #F0F9F1;
  color: #73C677;
  border: none;
  display: list-item;
  list-style-position: inside;
  white-space: nowrap;
}
.notes-view .tag.Proceed,
.notes-summary .tag.Proceed {
  background-color: #EFFBFD;
  color: #60D3EC;
  border: none;
  display: list-item;
  list-style-position: inside;
  white-space: nowrap;
}
.notes-view .tag.Cancelled,
.notes-summary .tag.Cancelled {
  background-color: #FFEEEF;
  color: #FF6464;
  border: none;
  display: list-item;
  list-style-position: inside;
  white-space: nowrap;
}
.notes-view-form {
  flex: 0 0 100%;
}
.notes-view-form-footer {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
}
.notes-view-private-footer {
  background-color: #10294D;
  position: absolute;
  right: 0px;
  bottom: 0px;
  color: #ffffff;
  border-radius: 0px 0px 5px 0px;
  display: flex;
  align-items: center;
}
.notes-view-private-footer .icon {
  height: 16px;
  width: 16px;
}
.notes-view-private-footer .icon svg {
  stroke: #ffffff;
  stroke-width: 2.4;
}
.notes-view-private-footer .list {
  padding: 0px 3px 0px 3px;
}
.leads-summary {
  padding: 20px;
  background: #FAFBFD;
  border-radius: 8px;
}
.leads-summary.new-lead {
  background: #EBF5FF;
}
.leads-summary:hover {
  background: #EBF5FF;
}
.leads-summary.active {
  box-shadow: 0 0 0 2px #E5EBF1;
}
.leads-summary-top {
  display: flex;
  align-items: center;
  gap: 0 6px;
}
.leads-summary-top .tag.New {
  background: #FC495D;
  color: #ffffff;
}
.leads-summary-top .tag.Contacted {
  background: #73C677;
  color: #ffffff;
}
.leads-summary-top .tag.Viewing {
  background: #3699FE;
  color: #ffffff;
}
.leads-summary-top .tag.Rental-Application {
  background: #BF60EC;
  color: #ffffff;
}
.leads-summary-top .tag.Offer {
  background: #BF60EC;
  color: #ffffff;
}
.leads-summary-top .tag.Sold {
  background: #FFA564;
  color: #ffffff;
}
.leads-summary-top .tag.Rented {
  background: #FFA564;
  color: #ffffff;
}
.leads-summary-top .tag.Archived {
  background: #10294D;
  color: #ffffff;
}
.leads-summary-date {
  margin-left: auto;
  font-size: 11px;
}
.leads-summary-pin .btn svg {
  stroke: #CED7E2;
}
.leads-summary-pin .btn.pinned svg {
  stroke: #10294D;
}
.leads-summary-body {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 20px 0 0;
}
.leads-summary-bottom {
  display: flex;
  gap: 6px 6px;
}
.leads-summary-bottom .leads-summary-comments {
  display: flex;
  align-items: center;
  gap: 0 6px;
  color: #10294D;
  font-weight: 600;
}
.leads-summary-bottom .leads-summary-comments .icon {
  width: 16px;
  height: 16px;
}
.leads-summary-bottom .leads-summary-comments svg {
  width: 16px;
  height: 16px;
  fill: none;
  stroke: #CED7E2;
  stroke-width: 2.4;
}
.leads-summary .leads-summary-attachments {
  display: flex;
  align-items: center;
  gap: 0 6px;
  color: #10294D;
  font-weight: 600;
}
.leads-summary .leads-summary-attachments svg {
  width: 16px;
  fill: none;
  stroke: #CED7E2;
  stroke-width: 2.4;
}
.leads-summary .leads-summary-tag {
  border-radius: 30px;
  padding: 5px 8px;
  font-size: 10px;
  background: #B2C2D4;
  color: #ffffff;
}
.leads-summary .leads-summary-tag-related {
  border-radius: 30px;
  padding: 5px 8px;
  font-size: 10px;
  background: #CED7E2;
  color: #ffffff;
}
.leads-view-leads {
  display: flex;
  flex-wrap: wrap;
  gap: 20px 0;
}
.residential .tab-leads,
.commercial .tab-leads,
.projects .tab-leads,
.holiday .tab-leads {
  padding: 0;
  grid-template-areas: "jump-menu" "details";
}
@media screen and (min-width: 799px) {
  .residential .tab-leads,
  .commercial .tab-leads,
  .projects .tab-leads,
  .holiday .tab-leads {
    grid-template-areas: "jump-menu details";
    grid-template-columns: 370px 1fr;
    grid-template-rows: 1fr;
  }
}
.residential .tab-leads .stepper,
.commercial .tab-leads .stepper,
.projects .tab-leads .stepper,
.holiday .tab-leads .stepper {
  grid-area: details;
}
.latest-leads-widget.leads-index {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px 8px;
}
.leads-view {
  position: fixed;
  top: 112px;
  bottom: 0;
  overflow-x: auto;
  z-index: 1000;
  padding-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
  grid-area: details;
  grid-template-areas: "lead-details" "interactions";
  grid-template-columns: 1fr;
  background-color: #F3F5F8;
  gap: 20px 20px;
}
@media screen and (min-width: 799px) {
  .leads-view {
    z-index: initial;
    position: relative;
    top: 0;
    padding-top: 0;
    padding-left: 0;
    display: grid;
    grid-template-areas: "interactions lead-details";
    grid-template-columns: 1fr 260px;
  }
}
.leads-view .lead-details {
  grid-area: lead-details;
}
.leads-view .lead-details .primary-bg h3 {
  color: #ffffff;
}
.leads-view .lead-details .btn-grey {
  margin-right: auto;
}
.leads-view .lead-interactions {
  grid-area: interactions;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  gap: 20px;
}
.leads-view .lead-interactions .card {
  margin-bottom: 0;
}
.leads-view.no-leads {
  display: flex;
  align-items: center;
  justify-content: center;
}
.leads-view-note,
.leads-view-comment {
  display: flex;
  flex-wrap: nowrap;
  gap: 0 20px;
  flex: 0 0 100%;
}
.leads-view .agent {
  margin: 0;
}
.leads-view-author {
  font-size: 11px;
  color: #5A6F89;
  font-weight: 600;
}
.leads-view-comment .leads-view-body {
  background: #EBF5FF;
}
.leads-view-body {
  flex: 1 1 100%;
  display: flex;
  flex-wrap: wrap;
  background: #FAFBFD;
  padding: 20px;
  gap: 10px 0;
  border-radius: 8px;
}
.leads-view-content {
  flex: 0 0 100%;
}
.leads-view-top {
  flex: 0 0 100%;
  display: flex;
  flex-wrap: nowrap;
}
.leads-view-date {
  margin-left: auto;
  font-size: 11px;
}
.leads-view-bottom {
  flex: 0 0 100%;
  display: flex;
  gap: 6px 6px;
}
.leads-view-bottom .btn {
  min-height: 1.5em;
}
.leads-view-attachments {
  flex: 0 0 100%;
  display: flex;
  gap: 6px 6px;
}
.leads-view-attachments svg {
  width: 16px;
  fill: none;
  stroke: #10294D;
  stroke-width: 2.4;
}
.leads-view-relation {
  border-radius: 2px;
  border: 1px solid #CED7E2;
  font-weight: 500;
  font-size: 12px;
  padding: 2px 5px;
}
.leads-view-form {
  flex: 0 0 100%;
}
.leads-view-form-footer {
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
}
.leads-index {
  top: 0;
  position: relative;
  grid-area: jump-menu;
  min-width: 0;
  min-height: 0;
  background: #ffffff;
}
@media screen and (min-width: 799px) {
  .leads-index {
    position: sticky;
    width: 370px;
  }
}
.leads-index form,
.leads-index > div:nth-child(1) {
  padding: 10px 15px;
  display: flex;
}
.leads-index .keyword-search {
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 100%;
  gap: 10px 10px;
}
.leads-index .keyword-search .btn-red {
  margin-left: auto;
}
.leads-index .keyword-search > .form-group {
  flex: 0 0 100%;
  gap: 10px 10px;
}
.leads-index .keyword-search > .form-group .form-group {
  flex: 1 1 auto;
}
.leads-index .keyword-search > .form-group .form-group.dateinput {
  flex: 0 0 auto;
}
.leads-index .keyword-search .advanced-toggle {
  flex: 1 1 auto;
  justify-content: center;
}
.leads-index .keyword-search .button-only {
  flex: 0 0 auto !important;
}
.leads-index .keyword-search .input-only .flatpickr-wrapper {
  flex: 0 0;
  max-width: 0;
}
.leads-index .keyword-search .input-only .input-group-addon {
  min-height: 36px;
}
.leads-index .keyword-search .inline-select .input-group-addon {
  font-size: 14px;
  padding-left: 15px;
}
.leads-index .leads-index-list-inner {
  padding: 2px 15px 0;
  display: flex;
  gap: 15px 0;
  flex-direction: column;
}
.leads-index .no-leads {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 100%;
  padding-bottom: 56px;
}
.leads-index .no-leads .no-leads-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 100%;
}
.lead-progress {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0 10px;
  padding: 15px 20px;
}
.tablecell .lead-progress {
  padding: 0;
}
.lead-progress .lead-progress-label {
  text-align: center;
  white-space: nowrap;
}
.flex-heading + .lead-progress {
  margin-left: auto;
  padding: 0;
}
.flex-heading + .lead-progress .lead-progress-item {
  flex-direction: row;
  gap: 10px 10px;
}
.flex-heading + .lead-progress .lead-progress-label {
  font-weight: bold;
  color: #10294D;
}
.lead-progress .lead-progress-label {
  margin-top: 5px;
  text-align: center;
  white-space: nowrap;
}
.lead-progress .lead-progress-meta {
  font-size: 9px;
  color: #5A6F89;
  text-align: center;
  white-space: nowrap;
}
.lead-progress .lead-progress-divider {
  height: 1px;
  margin: 32px 0 0;
  background: #E5EBF1;
  align-self: flex-start;
  flex: 1 1 auto;
}
.lead-progress .lead-progress-icon {
  display: flex;
  align-items: center;
  background: #E5EBF1;
  width: 16px;
  height: 16px;
  border-radius: 50%;
}
.lead-progress .lead-progress-icon svg {
  fill: none;
  stroke: #ffffff;
  stroke-width: 2.4;
  width: 16px;
  height: 16px !important;
}
.lead-progress .lead-progress-icon.New {
  background: #FC495D;
}
.lead-progress .lead-progress-icon.New + .lead-progress-label {
  color: #10294D;
}
.lead-progress .lead-progress-icon.Contacted {
  background: #73C677;
}
.lead-progress .lead-progress-icon.Contacted + .lead-progress-label {
  color: #10294D;
}
.lead-progress .lead-progress-icon.Lease-Application {
  background: #BF60EC;
}
.lead-progress .lead-progress-icon.Lease-Application + .lead-progress-label {
  color: #10294D;
}
.lead-progress .lead-progress-icon.Viewing {
  background: #3699FE;
}
.lead-progress .lead-progress-icon.Viewing + .lead-progress-label {
  color: #10294D;
}
.lead-progress .lead-progress-icon.Offer {
  background: #BF60EC;
}
.lead-progress .lead-progress-icon.Offer + .lead-progress-label {
  color: #10294D;
}
.lead-progress .lead-progress-icon.Sold {
  background: #FFA564;
}
.lead-progress .lead-progress-icon.Sold + .lead-progress-label {
  color: #10294D;
}
.lead-progress .lead-progress-icon.Rented {
  background: #FFA564;
}
.lead-progress .lead-progress-icon.Rented + .lead-progress-label {
  color: #10294D;
}
.lead-progress .lead-progress-icon.Archived {
  background: #10294D;
}
.lead-progress .lead-progress-icon.Archived + .lead-progress-label {
  color: #10294D;
}
.lead-progress .lead-progress-icon.offer-made {
  background: #60D3EC;
}
.lead-progress .lead-progress-icon.offer-made + .lead-progress-label {
  color: #10294D;
  font-weight: 500;
}
.lead-progress .lead-progress-icon.sale-agreement {
  background: #0CA6C8;
}
.lead-progress .lead-progress-icon.sale-agreement + .lead-progress-label {
  color: #10294D;
  font-weight: 500;
}
.lead-progress .lead-progress-icon.buyer-signed {
  background: #3699FE;
}
.lead-progress .lead-progress-icon.buyer-signed + .lead-progress-label {
  color: #10294D;
  font-weight: 500;
}
.lead-progress .lead-progress-icon.seller-signed {
  background: #006DDC;
}
.lead-progress .lead-progress-icon.seller-signed + .lead-progress-label {
  color: #10294D;
  font-weight: 500;
}
.lead-progress .lead-progress-icon.instruction-sent {
  background: #BF60EC;
}
.lead-progress .lead-progress-icon.instruction-sent + .lead-progress-label {
  color: #10294D;
  font-weight: 500;
}
.lead-progress .lead-progress-icon.deposit-received {
  background: #B339EC;
}
.lead-progress .lead-progress-icon.deposit-received + .lead-progress-label {
  color: #10294D;
  font-weight: 500;
}
.lead-progress .lead-progress-icon.conditions-met {
  background: #B339EC;
}
.lead-progress .lead-progress-icon.conditions-met + .lead-progress-label {
  color: #10294D;
  font-weight: 500;
}
.lead-progress .lead-progress-icon.lodged {
  background: #73C677;
}
.lead-progress .lead-progress-icon.lodged + .lead-progress-label {
  color: #10294D;
  font-weight: 500;
}
.lead-progress .lead-progress-icon.closed {
  background: #E62D42;
}
.lead-progress .lead-progress-icon.closed + .lead-progress-label {
  color: #10294D;
  font-weight: 500;
}
.lead-progress .lead-progress-icon.cancelled {
  background: #10294D;
}
.lead-progress .lead-progress-icon.cancelled + .lead-progress-label {
  color: #10294D;
}
.lead-progress .lead-progress-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 0 0;
  line-height: 21px;
}
.interaction-selection {
  display: flex;
  gap: 15px 6px;
  flex-wrap: wrap;
  margin-bottom: 25px;
}
.interaction-selection .btn {
  flex: 0 0 100%;
}
@media screen and (min-width: 799px) {
  .interaction-selection .btn {
    flex: 0 0 auto;
  }
}
.back-to-leads {
  position: fixed;
  padding: 4px 0 !important;
  background: #ffffff;
  top: 68px;
  left: 0;
  right: 0;
  z-index: 1000;
}
.interaction-buttons {
  margin-top: 25px;
}
.lead-interaction-details strong {
  font-size: 12px;
}
.lead-interaction-details .cardbody .ccontent {
  display: flex;
  flex-direction: column;
  gap: 10px 10px;
}
.lead-interaction-item-icon {
  display: flex;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
}
.lead-interaction-item-icon.Contacted {
  background: #DCF1DE;
}
.lead-interaction-item-icon.Contacted svg {
  stroke: #73C677;
}
.lead-interaction-item-icon.Viewing {
  background: #D7F4FA;
}
.lead-interaction-item-icon.Viewing svg {
  stroke: #60D3EC;
}
.lead-interaction-item-icon.Rental-Application {
  background: #EFD7F9;
}
.lead-interaction-item-icon.Rental-Application svg {
  stroke: #BF60EC;
}
.lead-interaction-item-icon.Offer {
  background: #EFD7F9;
}
.lead-interaction-item-icon.Offer svg {
  stroke: #BF60EC;
}
.lead-interaction-item-icon.Archived {
  background: #C3C9D2;
}
.lead-interaction-item-icon.Archived svg {
  stroke: #10294D;
}
.lead-interaction-item-icon svg {
  width: 24px;
  height: 24px;
  stroke-width: 1.4;
}
.lead-interaction-item-header {
  font-size: 11px;
  flex: 1 1 auto;
  gap: 12px 12px;
  display: flex;
  align-items: center;
}
.lead-interaction-item-top {
  flex: 1 1 auto;
}
.lead-interaction-item-top > * {
  flex: 1 1 100%;
}
.lead-interaction-item-top strong {
  color: #10294D;
  margin-right: auto;
}
.lead-interaction-item-date {
  font-size: 11px;
}
.interaction-buttons {
  display: flex;
  gap: 20px 20px;
}
.interaction-form .form-group .input-label {
  background: #FAFBFD;
}
.lead-interaction-tags {
  margin-top: 12px;
}
.lead-interaction-tags .lead-interaction-tag {
  background: #ffffff;
  border: 1px solid #CED7E2;
}
.lead-interaction-item-body label {
  display: block;
  color: #92A7C0;
  text-transform: uppercase;
  font-size: 11px;
  margin-top: 12px;
}
.lead-interaction-item-body label:nth-child(1) {
  margin-top: 0;
}
.lead-log-timeline {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  gap: 13px 13px;
  padding-bottom: 0;
}
.lead-log-timeline .lead-log-timeline-bar {
  width: 7px;
}
.lead-log-timeline .lead-log-timeline-bar:before {
  width: 1px;
}
.lead-log-timeline .lead-log-timeline-bar:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 20px;
  background-image: linear-gradient(to bottom, transparent, #FFF);
}
.lead-log-timeline .lead-log-item {
  position: relative;
  display: flex;
  gap: 2px 12px;
  z-index: 1;
}
.lead-log-timeline .lead-log-item h5 {
  margin: 0;
  font-weight: 600;
}
.lead-log-timeline .lead-log-item-icon {
  display: flex;
  align-items: center;
  margin: 2px 0;
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
.lead-log-timeline .lead-log-item-icon.New {
  background: #FC495D;
  color: #ffffff;
}
.lead-log-timeline .lead-log-item-icon.Contacted {
  background: #73C677;
  color: #ffffff;
}
.lead-log-timeline .lead-log-item-icon.Viewing {
  background: #3699FE;
  color: #ffffff;
}
.lead-log-timeline .lead-log-item-icon.Rental-Application {
  background: #BF60EC;
  color: #ffffff;
}
.lead-log-timeline .lead-log-item-icon.Offer {
  background: #BF60EC;
  color: #ffffff;
}
.lead-log-timeline .lead-log-item-icon.Sold {
  background: #FFA564;
  color: #ffffff;
}
.lead-log-timeline .lead-log-item-icon.Rented {
  background: #FFA564;
  color: #ffffff;
}
.lead-log-timeline .lead-log-item-icon.Archived {
  background: #10294D;
  color: #ffffff;
}
.tc-tooltip {
  pointer-events: none;
  font-size: 0.9rem;
  background: #FAFBFD;
  border-radius: 3px;
  border: 1px solid #CED7E2;
  max-width: 50%;
  z-index: 1000;
}
.tc-tooltip.tc-tooltip-clickable {
  pointer-events: all;
}
.tc-tooltip-wrapper {
  position: relative;
  display: inline-block;
}
.tc-tooltip-title {
  margin: 0;
  padding: 6px 8px;
  font-size: 1rem;
  line-height: 1;
  border-bottom: 1px solid #CED7E2;
  background: #f4f4f4;
}
.tc-tooltip-content {
  text-align: left;
  padding: 8px;
}
.tc-tooltip-arrow-bottom {
  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);
}
.tc-tooltip-arrow-bottom:after {
  content: "";
  border-color: #FAFBFD transparent transparent transparent;
  border-width: 10px;
  border-style: solid;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
}
.tc-tooltip-arrow-bottom:before {
  content: "";
  border-color: #CED7E2 transparent transparent transparent;
  border-width: 11px;
  border-style: solid;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
}
.tc-tooltip-arrow-bottom-left {
  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);
}
.tc-tooltip-arrow-bottom-left:after {
  content: "";
  border-color: #FAFBFD transparent transparent transparent;
  border-width: 10px;
  border-style: solid;
  position: absolute;
  top: 100%;
  left: 80px;
  transform: translateX(-50%);
}
.tc-tooltip-arrow-bottom-left:before {
  content: "";
  border-color: #CED7E2 transparent transparent transparent;
  border-width: 11px;
  border-style: solid;
  position: absolute;
  top: 100%;
  left: 80px;
  transform: translateX(-50%);
}
.tc-tooltip-arrow-top {
  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);
}
.tc-tooltip-arrow-top:after {
  content: "";
  border-color: transparent transparent #FAFBFD transparent;
  border-width: 10px;
  border-style: solid;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
}
.tc-tooltip-arrow-top:before {
  content: "";
  border-color: transparent transparent #CED7E2 transparent;
  border-width: 11px;
  border-style: solid;
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
}
.popup-wrapper {
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;
}
.popup-wrapper .popup-image {
  width: 160px;
  position: relative;
  flex: 0 0 100%;
  min-height: 160px;
  display: flex;
  align-content: center;
  justify-content: center;
  overflow: hidden;
  background-size: cover;
  background-position: center;
}
@media screen and (min-width: 799px) {
  .popup-wrapper .popup-image {
    flex: 0 0 160px;
  }
}
.popup-wrapper .popup-image img {
  width: 100%;
  object-fit: cover;
}
.popup-wrapper .popup-data {
  flex: 1 1 auto;
  display: flex;
  flex-wrap: wrap;
  max-width: 380px;
}
.popup-wrapper h5 {
  flex: 1 1 100%;
  text-transform: uppercase;
  color: #10294D;
}
.popup-wrapper .popup-price {
  flex: 1 1 100%;
  font-size: 1.25rem;
  font-weight: bold;
  color: #5A6F89;
}
.popup-wrapper .popup-address {
  flex: 1 1 100%;
  margin-top: 2px;
  color: #5A6F89;
}
.popup-wrapper .popup-divider {
  flex: 1 1 100%;
  height: 1px;
  background: #CED7E2;
  margin-top: 8px;
  margin-bottom: 8px;
}
.popup-wrapper .popup-featured {
  display: grid;
  grid-template-columns: auto auto;
  flex: 0 0 100%;
  gap: 4px 10px;
  flex-wrap: wrap;
}
.popup-wrapper .popup-featured > .meta-detail {
  display: flex;
  margin: 0;
  flex-wrap: nowrap;
  align-items: center;
  align-content: center;
  gap: 4px 10px;
}
.popup-wrapper .popup-featured > .meta-detail .heavy {
  display: flex;
  min-width: 90px;
  margin: auto;
  font-size: 10px;
  text-transform: uppercase;
  white-space: nowrap;
  background: #F3F5F8;
  flex: 0 0 1%;
  padding: 3px 6px;
}
.popup-wrapper .popup-featured > .meta-detail .col {
  display: flex;
  padding: 0;
  max-width: 90px;
  margin: auto;
  flex: 0 1 auto;
  align-items: center;
}
.tree-wrapper {
  padding: 0 10px;
}
.tree-wrapper ul {
  padding: 0;
  margin: 0;
  min-height: 36px;
}
.tree-item--wrapper {
  list-style: none;
  box-sizing: border-box;
  padding-left: var(--spacing);
  margin-bottom: -1px;
}
.tree-item--clone {
  display: inline-block;
  pointer-events: none;
  padding: 0;
  padding-left: 10px;
  padding-top: 5px;
}
.tree-item--clone .tree-item--item {
  --vertical-padding: 5px;
  padding-right: 24px;
  border-radius: 4px;
  box-shadow: 0px 15px 15px 0 rgba(34, 33, 81, 0.1);
}
.tree-item--ghost.tree-item--indicator {
  opacity: 1;
  position: relative;
  z-index: 1;
  margin-bottom: -1px;
}
.tree-item--ghost.tree-item--indicator .tree-item--item {
  position: relative;
  padding: 0;
  height: 8px;
  border-color: #2389ff;
  background-color: #56a1f8;
}
.tree-item--ghost.tree-item--indicator .tree-item--item:before {
  position: absolute;
  left: -8px;
  top: -4px;
  display: block;
  content: '';
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid #2389ff;
  background-color: #ffffff;
}
.tree-item--ghost.tree-item--indicator .tree-item--item > * {
  /* Items are hidden using height and opacity to retain focus */
  opacity: 0;
  height: 0;
}
.tree-item--ghost:not(.tree-item--indicator) {
  opacity: 0.5;
}
.tree-item--ghost .tree-item--item > * {
  box-shadow: none;
  background-color: transparent;
}
.tree-item--item {
  --vertical-padding: 8px;
  position: relative;
  display: flex;
  align-items: center;
  padding: var(--vertical-padding) 13px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #cfcdcd;
  border-color: #E5EBF1;
  color: #222;
  box-sizing: border-box;
}
.tree-item--item svg {
  fill: none;
  stroke: #92A7C0;
  stroke-width: 2.4;
  width: 16px;
  transition: transform 250ms ease;
}
.tree-item--item:hover .tree-item--item--remove {
  cursor: pointer;
  opacity: 1;
  pointer-events: all;
}
.tree-item--item--text {
  flex-grow: 1;
  padding-left: 0.5rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.tree-item--item--count {
  position: absolute;
  top: -10px;
  right: -10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #2389ff;
  font-size: 0.8rem;
  font-weight: 600;
  color: #fff;
}
.tree-item--item--disable-interaction {
  pointer-events: none;
}
.tree-item--item--disable-selection .tree-item--item--text,
.tree-item--clone .tree-item--item--text,
.tree-item--item--disable-selection .tree-item--item--count,
.tree-item--clone .tree-item--item--count {
  user-select: none;
  -webkit-user-select: none;
}
.tree-item--item--collapse {
  margin-right: 10px;
  display: flex;
  align-items: center;
}
.tree-item--item--collapse.tree-item--item--collapsed svg {
  transform: rotate(-90deg);
}
.tree-item--item--remove {
  margin-left: auto;
  display: flex;
  opacity: 0;
  pointer-events: none;
  align-items: center;
}
#fc_frame.fc-widget-small {
  bottom: 50px;
  right: 10px;
  z-index: 10;
}
#fc_frame.freshchat_frame.fc-open {
  z-index: 1000;
  right: 0;
}
#hubspot-conversations-inline-iframe {
  width: 100vw;
  height: calc(100vh - 68px);
  border: none;
}
@media screen and (min-width: 799px) {
  #hubspot-conversations-inline-iframe {
    width: 300px;
    height: 500px;
  }
}
#hubspot-chat-holder {
  position: fixed;
  right: 50%;
  transform: translate(50%, 0);
  top: 68px;
  background-color: white;
  box-shadow: 0px 0px 59px 0px rgba(0, 0, 0, 0.25);
  z-index: 1000;
  visibility: hidden;
}
@media screen and (min-width: 799px) {
  #hubspot-chat-holder {
    right: 15px;
    transform: none;
  }
}
#hubspot-chat-holder > .btn {
  position: absolute;
  top: calc(68px / 2);
  right: 0;
  transform: translate(0, -50%);
}
#hubspot-chat-holder > .btn svg {
  stroke: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/less/ui/common/global.less","webpack://./src/less/ui/bootstrap/less/_reboot.less","webpack://./src/css/ui/framework.css","webpack://./src/less/ui/bootstrap/less/mixins/_hover.less","webpack://./src/less/ui/bootstrap/less/utilities/_align.less","webpack://./src/less/ui/bootstrap/less/mixins/_background-variant.less","webpack://./src/less/ui/bootstrap/less/utilities/_background.less","webpack://./src/less/ui/bootstrap/less/utilities/_borders.less","webpack://./src/less/ui/bootstrap/less/mixins/_clearfix.less","webpack://./src/less/ui/bootstrap/less/utilities/_display.less","webpack://./src/less/ui/bootstrap/less/mixins/_breakpoints.less","webpack://./src/less/ui/bootstrap/less/utilities/_embed.less","webpack://./src/less/ui/bootstrap/less/utilities/_flex.less","webpack://./src/less/ui/bootstrap/less/utilities/_float.less","webpack://./src/less/ui/bootstrap/less/mixins/_float.less","webpack://./src/less/ui/bootstrap/less/utilities/_position.less","webpack://./src/less/ui/bootstrap/less/utilities/_screenreaders.less","webpack://./src/less/ui/bootstrap/less/mixins/_screen-reader.less","webpack://./src/less/ui/bootstrap/less/utilities/_shadows.less","webpack://./src/less/ui/bootstrap/less/utilities/_sizing.less","webpack://./src/less/ui/bootstrap/less/utilities/_spacing.less","webpack://./src/less/ui/bootstrap/less/utilities/_text.less","webpack://./src/less/ui/bootstrap/less/mixins/_text-truncate.less","webpack://./src/less/ui/bootstrap/less/mixins/_text-emphasis.less","webpack://./src/less/ui/bootstrap/less/mixins/_text-hide.less","webpack://./src/less/ui/bootstrap/less/utilities/_visibility.less","webpack://./src/less/ui/bootstrap/less/mixins/_visibility.less","webpack://./src/less/ui/bootstrap/less/_forms.less","webpack://./src/less/ui/bootstrap/less/mixins/_transition.less","webpack://./src/less/ui/bootstrap/less/mixins/_forms.less","webpack://./src/less/ui/bootstrap/less/mixins/_border-radius.less","webpack://./src/less/ui/bootstrap/less/mixins/_gradients.less","webpack://./src/less/ui/bootstrap/less/_grid.less","webpack://./src/less/ui/bootstrap/less/mixins/_grid.less","webpack://./src/less/ui/bootstrap/less/mixins/_grid-framework.less","webpack://./src/less/ui/common/silo-header.less","webpack://./src/less/ui/common/buttons.less","webpack://./src/less/ui/common/scrollbars.less","webpack://./src/less/ui/common/avatar.less","webpack://./src/less/ui/framework.less","webpack://./src/less/ui/common/grid.less","webpack://./src/less/ui/common/header.less","webpack://./src/less/ui/common/dash.less","webpack://./src/less/ui/common/nav.less","webpack://./src/less/ui/common/sidebar.less","webpack://./src/less/ui/common/modal.less","webpack://./src/less/ui/common/contextmenu.less","webpack://./src/less/ui/common/content.less","webpack://./src/less/ui/common/calendar.less","webpack://./src/less/ui/common/widesidebar.less","webpack://./src/less/ui/common/modellist.less","webpack://./src/less/ui/common/modeldetails.less","webpack://./src/less/ui/common/forms.less","webpack://./src/less/ui/common/notifications.less","webpack://./src/less/ui/common/card.less","webpack://./src/less/ui/common/banners.less","webpack://./src/less/ui/common/tabs.less","webpack://./src/less/ui/common/actions.less","webpack://./src/less/ui/common/users.less","webpack://./src/less/ui/common/branch.less","webpack://./src/less/ui/common/login.less","webpack://./src/less/ui/common/timeline.less","webpack://./src/less/ui/common/pdf.less","webpack://./src/less/ui/common/editor.less","webpack://./src/less/ui/common/notes.less","webpack://./src/less/ui/common/leads.less","webpack://./src/less/ui/common/tooltips.less","webpack://./src/less/ui/common/tree.less","webpack://./src/less/ui/common/freshchat.less"],"names":[],"mappings":"AAEA,gBAAS;ACgBT;;;EAGC,sBAAA;ACfD;ADkBA;EACC,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6BAAA;EAEA,wCAAA;ACjBD;AD2BA;;;;;;;;;;EACC,cAAA;ACbD;ADuBA;EACC,SAAA;EACA,iKAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;ACrBD;AD6BA;EACC,qBAAA;AC3BD;ADoCA;EACC,uBAAA;EACA,SAAA;EACA,iBAAA;AClCD;AD8CA;;;;;;EACC,aAAA;EACA,qBAAA;ACvCD;AD8CA;EACC,aAAA;EACA,mBAAA;AC5CD;ADsDA;;EAEC,0BAAA;EACA,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,gBAAA;ACpDD;ADuDA;EACC,mBAAA;EACA,kBAAA;EACA,oBAAA;ACrDD;ADwDA;;;EAGC,aAAA;EACA,mBAAA;ACtDD;ADyDA;;;;EAIC,gBAAA;ACvDD;AD0DA;EACC,gBAAA;ACxDD;AD2DA;EACC,qBAAA;EACA,cAAA;ACzDD;AD4DA;EACC,gBAAA;AC1DD;AD6DA;EACC,kBAAA;AC3DD;AD8DA;;EAEC,mBAAA;AC5DD;AD+DA;EACC,cAAA;AC7DD;ADqEA;;EAEC,kBAAA;EACA,cAAA;EACA,cAAA;EACA,wBAAA;ACnED;ADsEA;EAAM,eAAA;ACnEN;ADoEA;EAAM,WAAA;ACjEN;ADwEA;EACC,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,qCAAA;ACtED;AC/GC;EFwLC,cAAA;EACA,0BAAA;ACtEF;ADgFA;EACC,cAAA;EACA,qBAAA;AC9ED;ACnHC;;EFoMC,cAAA;EACA,qBAAA;AC7EF;ADgFC;EACC,UAAA;AC9EF;ADuFA;;;;EAIC,iGAAA;EACA,cAAA;ACrFD;ADwFA;EAEC,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AC3FD;ADmGA;EAEC,gBAAA;AClGD;AD0GA;EACC,sBAAA;EACA,kBAAA;ACxGD;AD2GA;EACC,gBAAA;ACzGD;ADiHA;EACC,yBAAA;AC/GD;ADkHA;EACC,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;AChHD;ADmHA;EAGC,mBAAA;ACnHD;AD2HA;EAEC,qBAAA;EACA,qBAAA;AC1HD;ADgIA;EACC,gBAAA;AC9HD;ADqIA;EACC,mBAAA;EACA,0CAAA;ACnID;ADsIA;;;;;EAKC,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;ACpID;ADuIA;;EAEC,iBAAA;ACrID;ADwIA;;EAEC,oBAAA;ACtID;AD4IA;;;;EAIC,0BAAA;AC1ID;AD8IA;;;;EAIC,UAAA;EACA,kBAAA;AC5ID;AD+IA;;EAEC,sBAAA;EACA,UAAA;AC7ID;ADiJA;;;;EASC,2BAAA;ACpJD;ADuJA;EACC,cAAA;EAEA,gBAAA;ACtJD;ADyJA;EAMC,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AC7JD;ADkKA;EACC,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;AChKD;ADmKA;EACC,wBAAA;ACjKD;ADqKA;;EAEC,YAAA;ACnKD;ADsKA;EAKC,oBAAA;EACA,wBAAA;ACxKD;AD+KA;;EAEC,wBAAA;AC7KD;ADqLA;EACC,aAAA;EACA,0BAAA;ACnLD;AD0LA;EACC,qBAAA;ACxLD;AD2LA;EACC,kBAAA;EACA,eAAA;ACzLD;AD4LA;EACC,aAAA;AC1LD;AD+LA;EACC,wBAAA;AC7LD;AEzRA;EAAqB,mCAAA;AF4RrB;AE3RA;EAAqB,8BAAA;AF8RrB;AE7RA;EAAqB,iCAAA;AFgSrB;AE/RA;EAAqB,iCAAA;AFkSrB;AEjSA;EAAqB,sCAAA;AFoSrB;AEnSA;EAAqB,mCAAA;AFsSrB;AGxSE;EACA,oCAAA;AH0SF;AC9RC;;;;EEPE,oCAAA;AH2SH;AGjTE;EACA,oCAAA;AHmTF;ACvSC;;;;EEPE,oCAAA;AHoTH;AG1TE;EACA,oCAAA;AH4TF;AChTC;;;;EEPE,oCAAA;AH6TH;AGnUE;EACA,oCAAA;AHqUF;ACzTC;;;;EEPE,oCAAA;AHsUH;AG5UE;EACA,oCAAA;AH8UF;AClUC;;;;EEPE,oCAAA;AH+UH;AGrVE;EACA,oCAAA;AHuVF;AC3UC;;;;EEPE,oCAAA;AHwVH;AG9VE;EACA,oCAAA;AHgWF;ACpVC;;;;EEPE,oCAAA;AHiWH;AGvWE;EACA,oCAAA;AHyWF;AC7VC;;;;EEPE,oCAAA;AH0WH;AItVA;EACC,oCAAA;AJwVD;AIrVA;EACC,wCAAA;AJuVD;AKrXA;EAAkB,oCAAA;ALwXlB;AKvXA;EAAkB,wCAAA;AL0XlB;AKzXA;EAAkB,0CAAA;AL4XlB;AK3XA;EAAkB,2CAAA;AL8XlB;AK7XA;EAAkB,yCAAA;ALgYlB;AK9XA;EAAmB,oBAAA;ALiYnB;AKhYA;EAAmB,wBAAA;ALmYnB;AKlYA;EAAmB,0BAAA;ALqYnB;AKpYA;EAAmB,2BAAA;ALuYnB;AKtYA;EAAmB,yBAAA;ALyYnB;AK7XE;EACA,gCAAA;AL+XF;AKhYE;EACA,gCAAA;ALkYF;AKnYE;EACA,gCAAA;ALqYF;AKtYE;EACA,gCAAA;ALwYF;AKzYE;EACA,gCAAA;AL2YF;AK5YE;EACA,gCAAA;AL8YF;AK/YE;EACA,gCAAA;ALiZF;AKlZE;EACA,gCAAA;ALoZF;AK9YA;EACC,gCAAA;ALgZD;AKzYA;EACC,6BAAA;AL2YD;AKzYA;EACC,sCAAA;EACA,uCAAA;AL2YD;AKzYA;EACC,uCAAA;EACA,0CAAA;AL2YD;AKzYA;EACC,0CAAA;EACA,yCAAA;AL2YD;AKzYA;EACC,sCAAA;EACA,yCAAA;AL2YD;AKxYA;EACC,6BAAA;AL0YD;AKvYA;EACC,2BAAA;ALyYD;AM1cC;EACC,cAAA;EACA,WAAA;EACA,WAAA;AN4cF;AOxbG;EAAyB,wBAAA;AP2b5B;AO1bG;EAAyB,0BAAA;AP6b5B;AO5bG;EAAyB,gCAAA;AP+b5B;AO9bG;EAAyB,yBAAA;APic5B;AOhcG;EAAyB,yBAAA;APmc5B;AOlcG;EAAyB,6BAAA;APqc5B;AOpcG;EAAyB,8BAAA;APuc5B;AOtcG;EAAyB,wBAAA;APyc5B;AOxcG;EAAyB,+BAAA;AP2c5B;AQlaE;EDjDC;IAAyB,wBAAA;EPud1B;EOtdC;IAAyB,0BAAA;EPyd1B;EOxdC;IAAyB,gCAAA;EP2d1B;EO1dC;IAAyB,yBAAA;EP6d1B;EO5dC;IAAyB,yBAAA;EP+d1B;EO9dC;IAAyB,6BAAA;EPie1B;EOheC;IAAyB,8BAAA;EPme1B;EOleC;IAAyB,wBAAA;EPqe1B;EOpeC;IAAyB,+BAAA;EPue1B;AACF;AQ/bE;EDjDC;IAAyB,wBAAA;EPof1B;EOnfC;IAAyB,0BAAA;EPsf1B;EOrfC;IAAyB,gCAAA;EPwf1B;EOvfC;IAAyB,yBAAA;EP0f1B;EOzfC;IAAyB,yBAAA;EP4f1B;EO3fC;IAAyB,6BAAA;EP8f1B;EO7fC;IAAyB,8BAAA;EPggB1B;EO/fC;IAAyB,wBAAA;EPkgB1B;EOjgBC;IAAyB,+BAAA;EPogB1B;AACF;AQ5dE;EDjDC;IAAyB,wBAAA;EPihB1B;EOhhBC;IAAyB,0BAAA;EPmhB1B;EOlhBC;IAAyB,gCAAA;EPqhB1B;EOphBC;IAAyB,yBAAA;EPuhB1B;EOthBC;IAAyB,yBAAA;EPyhB1B;EOxhBC;IAAyB,6BAAA;EP2hB1B;EO1hBC;IAAyB,8BAAA;EP6hB1B;EO5hBC;IAAyB,wBAAA;EP+hB1B;EO9hBC;IAAyB,+BAAA;EPiiB1B;AACF;AQzfE;EDjDC;IAAyB,wBAAA;EP8iB1B;EO7iBC;IAAyB,0BAAA;EPgjB1B;EO/iBC;IAAyB,gCAAA;EPkjB1B;EOjjBC;IAAyB,yBAAA;EPojB1B;EOnjBC;IAAyB,yBAAA;EPsjB1B;EOrjBC;IAAyB,6BAAA;EPwjB1B;EOvjBC;IAAyB,8BAAA;EP0jB1B;EOzjBC;IAAyB,wBAAA;EP4jB1B;EO3jBC;IAAyB,+BAAA;EP8jB1B;AACF;AOpjBA;EACC;IAAwB,wBAAA;EPujBvB;EOtjBD;IAAwB,0BAAA;EPyjBvB;EOxjBD;IAAwB,gCAAA;EP2jBvB;EO1jBD;IAAwB,yBAAA;EP6jBvB;EO5jBD;IAAwB,yBAAA;EP+jBvB;EO9jBD;IAAwB,6BAAA;EPikBvB;EOhkBD;IAAwB,8BAAA;EPmkBvB;EOlkBD;IAAwB,wBAAA;EPqkBvB;EOpkBD;IAAwB,+BAAA;EPukBvB;AACF;AS1nBA;EACC,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;AT4nBD;AS1nBC;EACC,cAAA;EACA,WAAA;AT4nBF;ASroBA;;;;;EAiBE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AT2nBF;AStnBC;EACC,yBAAA;ATwnBF;ASnnBC;EACC,mBAAA;ATqnBF;AShnBC;EACC,gBAAA;ATknBF;AS7mBC;EACC,iBAAA;AT+mBF;AUzmBG;EAA8B,8BAAA;AV4mBjC;AU3mBG;EAA8B,iCAAA;AV8mBjC;AU7mBG;EAA8B,sCAAA;AVgnBjC;AU/mBG;EAA8B,yCAAA;AVknBjC;AUhnBG;EAA4B,0BAAA;AVmnB/B;AUlnBG;EAA4B,4BAAA;AVqnB/B;AUpnBG;EAA4B,kCAAA;AVunB/B;AUtnBG;EAA4B,yBAAA;AVynB/B;AUxnBG;EAA4B,uBAAA;AV2nB/B;AU1nBG;EAA4B,uBAAA;AV6nB/B;AU5nBG;EAA4B,yBAAA;AV+nB/B;AU9nBG;EAA4B,yBAAA;AVioB/B;AU/nBG;EAAkC,sCAAA;AVkoBrC;AUjoBG;EAAkC,oCAAA;AVooBrC;AUnoBG;EAAkC,kCAAA;AVsoBrC;AUroBG;EAAkC,yCAAA;AVwoBrC;AUvoBG;EAAkC,wCAAA;AV0oBrC;AUxoBG;EAA+B,kCAAA;AV2oBlC;AU1oBG;EAA+B,gCAAA;AV6oBlC;AU5oBG;EAA+B,8BAAA;AV+oBlC;AU9oBG;EAA+B,gCAAA;AVipBlC;AUhpBG;EAA+B,+BAAA;AVmpBlC;AUjpBG;EAAgC,oCAAA;AVopBnC;AUnpBG;EAAgC,kCAAA;AVspBnC;AUrpBG;EAAgC,gCAAA;AVwpBnC;AUvpBG;EAAgC,uCAAA;AV0pBnC;AUzpBG;EAAgC,sCAAA;AV4pBnC;AU3pBG;EAAgC,iCAAA;AV8pBnC;AU5pBG;EAA8B,2BAAA;AV+pBjC;AU9pBG;EAA8B,iCAAA;AViqBjC;AUhqBG;EAA8B,+BAAA;AVmqBjC;AUlqBG;EAA8B,6BAAA;AVqqBjC;AUpqBG;EAA8B,+BAAA;AVuqBjC;AUtqBG;EAA8B,8BAAA;AVyqBjC;AQ7rBE;EElBC;IAA8B,8BAAA;EVmtB/B;EUltBC;IAA8B,iCAAA;EVqtB/B;EUptBC;IAA8B,sCAAA;EVutB/B;EUttBC;IAA8B,yCAAA;EVytB/B;EUvtBC;IAA4B,0BAAA;EV0tB7B;EUztBC;IAA4B,4BAAA;EV4tB7B;EU3tBC;IAA4B,kCAAA;EV8tB7B;EU7tBC;IAA4B,yBAAA;EVguB7B;EU/tBC;IAA4B,uBAAA;EVkuB7B;EUjuBC;IAA4B,uBAAA;EVouB7B;EUnuBC;IAA4B,yBAAA;EVsuB7B;EUruBC;IAA4B,yBAAA;EVwuB7B;EUtuBC;IAAkC,sCAAA;EVyuBnC;EUxuBC;IAAkC,oCAAA;EV2uBnC;EU1uBC;IAAkC,kCAAA;EV6uBnC;EU5uBC;IAAkC,yCAAA;EV+uBnC;EU9uBC;IAAkC,wCAAA;EVivBnC;EU/uBC;IAA+B,kCAAA;EVkvBhC;EUjvBC;IAA+B,gCAAA;EVovBhC;EUnvBC;IAA+B,8BAAA;EVsvBhC;EUrvBC;IAA+B,gCAAA;EVwvBhC;EUvvBC;IAA+B,+BAAA;EV0vBhC;EUxvBC;IAAgC,oCAAA;EV2vBjC;EU1vBC;IAAgC,kCAAA;EV6vBjC;EU5vBC;IAAgC,gCAAA;EV+vBjC;EU9vBC;IAAgC,uCAAA;EViwBjC;EUhwBC;IAAgC,sCAAA;EVmwBjC;EUlwBC;IAAgC,iCAAA;EVqwBjC;EUnwBC;IAA8B,2BAAA;EVswB/B;EUrwBC;IAA8B,iCAAA;EVwwB/B;EUvwBC;IAA8B,+BAAA;EV0wB/B;EUzwBC;IAA8B,6BAAA;EV4wB/B;EU3wBC;IAA8B,+BAAA;EV8wB/B;EU7wBC;IAA8B,8BAAA;EVgxB/B;AACF;AQryBE;EElBC;IAA8B,8BAAA;EV2zB/B;EU1zBC;IAA8B,iCAAA;EV6zB/B;EU5zBC;IAA8B,sCAAA;EV+zB/B;EU9zBC;IAA8B,yCAAA;EVi0B/B;EU/zBC;IAA4B,0BAAA;EVk0B7B;EUj0BC;IAA4B,4BAAA;EVo0B7B;EUn0BC;IAA4B,kCAAA;EVs0B7B;EUr0BC;IAA4B,yBAAA;EVw0B7B;EUv0BC;IAA4B,uBAAA;EV00B7B;EUz0BC;IAA4B,uBAAA;EV40B7B;EU30BC;IAA4B,yBAAA;EV80B7B;EU70BC;IAA4B,yBAAA;EVg1B7B;EU90BC;IAAkC,sCAAA;EVi1BnC;EUh1BC;IAAkC,oCAAA;EVm1BnC;EUl1BC;IAAkC,kCAAA;EVq1BnC;EUp1BC;IAAkC,yCAAA;EVu1BnC;EUt1BC;IAAkC,wCAAA;EVy1BnC;EUv1BC;IAA+B,kCAAA;EV01BhC;EUz1BC;IAA+B,gCAAA;EV41BhC;EU31BC;IAA+B,8BAAA;EV81BhC;EU71BC;IAA+B,gCAAA;EVg2BhC;EU/1BC;IAA+B,+BAAA;EVk2BhC;EUh2BC;IAAgC,oCAAA;EVm2BjC;EUl2BC;IAAgC,kCAAA;EVq2BjC;EUp2BC;IAAgC,gCAAA;EVu2BjC;EUt2BC;IAAgC,uCAAA;EVy2BjC;EUx2BC;IAAgC,sCAAA;EV22BjC;EU12BC;IAAgC,iCAAA;EV62BjC;EU32BC;IAA8B,2BAAA;EV82B/B;EU72BC;IAA8B,iCAAA;EVg3B/B;EU/2BC;IAA8B,+BAAA;EVk3B/B;EUj3BC;IAA8B,6BAAA;EVo3B/B;EUn3BC;IAA8B,+BAAA;EVs3B/B;EUr3BC;IAA8B,8BAAA;EVw3B/B;AACF;AQ74BE;EElBC;IAA8B,8BAAA;EVm6B/B;EUl6BC;IAA8B,iCAAA;EVq6B/B;EUp6BC;IAA8B,sCAAA;EVu6B/B;EUt6BC;IAA8B,yCAAA;EVy6B/B;EUv6BC;IAA4B,0BAAA;EV06B7B;EUz6BC;IAA4B,4BAAA;EV46B7B;EU36BC;IAA4B,kCAAA;EV86B7B;EU76BC;IAA4B,yBAAA;EVg7B7B;EU/6BC;IAA4B,uBAAA;EVk7B7B;EUj7BC;IAA4B,uBAAA;EVo7B7B;EUn7BC;IAA4B,yBAAA;EVs7B7B;EUr7BC;IAA4B,yBAAA;EVw7B7B;EUt7BC;IAAkC,sCAAA;EVy7BnC;EUx7BC;IAAkC,oCAAA;EV27BnC;EU17BC;IAAkC,kCAAA;EV67BnC;EU57BC;IAAkC,yCAAA;EV+7BnC;EU97BC;IAAkC,wCAAA;EVi8BnC;EU/7BC;IAA+B,kCAAA;EVk8BhC;EUj8BC;IAA+B,gCAAA;EVo8BhC;EUn8BC;IAA+B,8BAAA;EVs8BhC;EUr8BC;IAA+B,gCAAA;EVw8BhC;EUv8BC;IAA+B,+BAAA;EV08BhC;EUx8BC;IAAgC,oCAAA;EV28BjC;EU18BC;IAAgC,kCAAA;EV68BjC;EU58BC;IAAgC,gCAAA;EV+8BjC;EU98BC;IAAgC,uCAAA;EVi9BjC;EUh9BC;IAAgC,sCAAA;EVm9BjC;EUl9BC;IAAgC,iCAAA;EVq9BjC;EUn9BC;IAA8B,2BAAA;EVs9B/B;EUr9BC;IAA8B,iCAAA;EVw9B/B;EUv9BC;IAA8B,+BAAA;EV09B/B;EUz9BC;IAA8B,6BAAA;EV49B/B;EU39BC;IAA8B,+BAAA;EV89B/B;EU79BC;IAA8B,8BAAA;EVg+B/B;AACF;AQr/BE;EElBC;IAA8B,8BAAA;EV2gC/B;EU1gCC;IAA8B,iCAAA;EV6gC/B;EU5gCC;IAA8B,sCAAA;EV+gC/B;EU9gCC;IAA8B,yCAAA;EVihC/B;EU/gCC;IAA4B,0BAAA;EVkhC7B;EUjhCC;IAA4B,4BAAA;EVohC7B;EUnhCC;IAA4B,kCAAA;EVshC7B;EUrhCC;IAA4B,yBAAA;EVwhC7B;EUvhCC;IAA4B,uBAAA;EV0hC7B;EUzhCC;IAA4B,uBAAA;EV4hC7B;EU3hCC;IAA4B,yBAAA;EV8hC7B;EU7hCC;IAA4B,yBAAA;EVgiC7B;EU9hCC;IAAkC,sCAAA;EViiCnC;EUhiCC;IAAkC,oCAAA;EVmiCnC;EUliCC;IAAkC,kCAAA;EVqiCnC;EUpiCC;IAAkC,yCAAA;EVuiCnC;EUtiCC;IAAkC,wCAAA;EVyiCnC;EUviCC;IAA+B,kCAAA;EV0iChC;EUziCC;IAA+B,gCAAA;EV4iChC;EU3iCC;IAA+B,8BAAA;EV8iChC;EU7iCC;IAA+B,gCAAA;EVgjChC;EU/iCC;IAA+B,+BAAA;EVkjChC;EUhjCC;IAAgC,oCAAA;EVmjCjC;EUljCC;IAAgC,kCAAA;EVqjCjC;EUpjCC;IAAgC,gCAAA;EVujCjC;EUtjCC;IAAgC,uCAAA;EVyjCjC;EUxjCC;IAAgC,sCAAA;EV2jCjC;EU1jCC;IAAgC,iCAAA;EV6jCjC;EU3jCC;IAA8B,2BAAA;EV8jC/B;EU7jCC;IAA8B,iCAAA;EVgkC/B;EU/jCC;IAA8B,+BAAA;EVkkC/B;EUjkCC;IAA8B,6BAAA;EVokC/B;EUnkCC;IAA8B,+BAAA;EVskC/B;EUrkCC;IAA8B,8BAAA;EVwkC/B;AACF;AWvpCG;ECdF,sBAAA;AZwqCD;AWzpCG;ECZF,uBAAA;AZwqCD;AW3pCG;ECVF,sBAAA;AZwqCD;AQtmCE;EG1DC;ICdF,sBAAA;EZkrCC;EWnqCC;ICZF,uBAAA;EZkrCC;EWrqCC;ICVF,sBAAA;EZkrCC;AACF;AQjnCE;EG1DC;ICdF,sBAAA;EZ6rCC;EW9qCC;ICZF,uBAAA;EZ6rCC;EWhrCC;ICVF,sBAAA;EZ6rCC;AACF;AQ5nCE;EG1DC;ICdF,sBAAA;EZwsCC;EWzrCC;ICZF,uBAAA;EZwsCC;EW3rCC;ICVF,sBAAA;EZwsCC;AACF;AQvoCE;EG1DC;ICdF,sBAAA;EZmtCC;EWpsCC;ICZF,uBAAA;EZmtCC;EWtsCC;ICVF,sBAAA;EZmtCC;AACF;AahtCE;EAAuB,2BAAA;AbmtCzB;AantCE;EAAuB,6BAAA;AbstCzB;AattCE;EAAuB,6BAAA;AbytCzB;AaztCE;EAAuB,0BAAA;Ab4tCzB;Aa5tCE;EAAuB,2BAAA;Ab+tCzB;AaxtCA;EACC,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;Ab0tCD;AavtCA;EACC,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;AbytCD;AartCC;EAAA;IACC,gBAAA;IACA,MAAA;IACA,aAAA;EbwtCA;AACF;Ac3vCA;ECEC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;Af4vCD;AelvCC;;EAEC,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AfovCF;AgBlxCA;EAAa,8DAAA;AhBqxCb;AgBpxCA;EAAU,wDAAA;AhBuxCV;AgBtxCA;EAAa,uDAAA;AhByxCb;AgBxxCA;EAAe,2BAAA;AhB2xCf;AiB3wCG;EAAoB,qBAAA;AjB8wCvB;AiB9wCG;EAAoB,qBAAA;AjBixCvB;AiBjxCG;EAAoB,qBAAA;AjBoxCvB;AiBpxCG;EAAoB,sBAAA;AjBuxCvB;AiBvxCG;EAAoB,sBAAA;AjB0xCvB;AiB1xCG;EAAoB,sBAAA;AjB6xCvB;AiB7xCG;EAAoB,sBAAA;AjBgyCvB;AiBhyCG;EAAoB,sBAAA;AjBmyCvB;AiBnyCG;EAAoB,uBAAA;AjBsyCvB;AiBtyCG;EAAoB,uBAAA;AjByyCvB;AiBjyCA;EAAU,0BAAA;AjBoyCV;AiBnyCA;EAAU,2BAAA;AjBsyCV;AkB/vCK;EAA4B,oBAAA;AlBkwCjC;AkBjwCK;;EAEA,wBAAA;AlBmwCL;AkBjwCK;;EAEA,0BAAA;AlBmwCL;AkBjwCK;;EAEA,2BAAA;AlBmwCL;AkBjwCK;;EAEA,yBAAA;AlBmwCL;AkBlxCK;EAA4B,0BAAA;AlBqxCjC;AkBpxCK;;EAEA,8BAAA;AlBsxCL;AkBpxCK;;EAEA,gCAAA;AlBsxCL;AkBpxCK;;EAEA,iCAAA;AlBsxCL;AkBpxCK;;EAEA,+BAAA;AlBsxCL;AkBryCK;EAA4B,yBAAA;AlBwyCjC;AkBvyCK;;EAEA,6BAAA;AlByyCL;AkBvyCK;;EAEA,+BAAA;AlByyCL;AkBvyCK;;EAEA,gCAAA;AlByyCL;AkBvyCK;;EAEA,8BAAA;AlByyCL;AkBxzCK;EAA4B,uBAAA;AlB2zCjC;AkB1zCK;;EAEA,2BAAA;AlB4zCL;AkB1zCK;;EAEA,6BAAA;AlB4zCL;AkB1zCK;;EAEA,8BAAA;AlB4zCL;AkB1zCK;;EAEA,4BAAA;AlB4zCL;AkB30CK;EAA4B,yBAAA;AlB80CjC;AkB70CK;;EAEA,6BAAA;AlB+0CL;AkB70CK;;EAEA,+BAAA;AlB+0CL;AkB70CK;;EAEA,gCAAA;AlB+0CL;AkB70CK;;EAEA,8BAAA;AlB+0CL;AkB91CK;EAA4B,uBAAA;AlBi2CjC;AkBh2CK;;EAEA,2BAAA;AlBk2CL;AkBh2CK;;EAEA,6BAAA;AlBk2CL;AkBh2CK;;EAEA,8BAAA;AlBk2CL;AkBh2CK;;EAEA,4BAAA;AlBk2CL;AkBj3CK;EAA4B,qBAAA;AlBo3CjC;AkBn3CK;;EAEA,yBAAA;AlBq3CL;AkBn3CK;;EAEA,2BAAA;AlBq3CL;AkBn3CK;;EAEA,4BAAA;AlBq3CL;AkBn3CK;;EAEA,0BAAA;AlBq3CL;AkBp4CK;EAA4B,2BAAA;AlBu4CjC;AkBt4CK;;EAEA,+BAAA;AlBw4CL;AkBt4CK;;EAEA,iCAAA;AlBw4CL;AkBt4CK;;EAEA,kCAAA;AlBw4CL;AkBt4CK;;EAEA,gCAAA;AlBw4CL;AkBv5CK;EAA4B,0BAAA;AlB05CjC;AkBz5CK;;EAEA,8BAAA;AlB25CL;AkBz5CK;;EAEA,gCAAA;AlB25CL;AkBz5CK;;EAEA,iCAAA;AlB25CL;AkBz5CK;;EAEA,+BAAA;AlB25CL;AkB16CK;EAA4B,wBAAA;AlB66CjC;AkB56CK;;EAEA,4BAAA;AlB86CL;AkB56CK;;EAEA,8BAAA;AlB86CL;AkB56CK;;EAEA,+BAAA;AlB86CL;AkB56CK;;EAEA,6BAAA;AlB86CL;AkB77CK;EAA4B,0BAAA;AlBg8CjC;AkB/7CK;;EAEA,8BAAA;AlBi8CL;AkB/7CK;;EAEA,gCAAA;AlBi8CL;AkB/7CK;;EAEA,iCAAA;AlBi8CL;AkB/7CK;;EAEA,+BAAA;AlBi8CL;AkBh9CK;EAA4B,wBAAA;AlBm9CjC;AkBl9CK;;EAEA,4BAAA;AlBo9CL;AkBl9CK;;EAEA,8BAAA;AlBo9CL;AkBl9CK;;EAEA,+BAAA;AlBo9CL;AkBl9CK;;EAEA,6BAAA;AlBo9CL;AkB18CG;EAAiB,uBAAA;AlB68CpB;AkB58CG;;EAEA,2BAAA;AlB88CH;AkB58CG;;EAEA,6BAAA;AlB88CH;AkB58CG;;EAEA,8BAAA;AlB88CH;AkB58CG;;EAEA,4BAAA;AlB88CH;AQh/CE;EUNG;IAA4B,oBAAA;ElB0/C/B;EkBz/CG;;IAEA,wBAAA;ElB2/CH;EkBz/CG;;IAEA,0BAAA;ElB2/CH;EkBz/CG;;IAEA,2BAAA;ElB2/CH;EkBz/CG;;IAEA,yBAAA;ElB2/CH;EkB1gDG;IAA4B,0BAAA;ElB6gD/B;EkB5gDG;;IAEA,8BAAA;ElB8gDH;EkB5gDG;;IAEA,gCAAA;ElB8gDH;EkB5gDG;;IAEA,iCAAA;ElB8gDH;EkB5gDG;;IAEA,+BAAA;ElB8gDH;EkB7hDG;IAA4B,yBAAA;ElBgiD/B;EkB/hDG;;IAEA,6BAAA;ElBiiDH;EkB/hDG;;IAEA,+BAAA;ElBiiDH;EkB/hDG;;IAEA,gCAAA;ElBiiDH;EkB/hDG;;IAEA,8BAAA;ElBiiDH;EkBhjDG;IAA4B,uBAAA;ElBmjD/B;EkBljDG;;IAEA,2BAAA;ElBojDH;EkBljDG;;IAEA,6BAAA;ElBojDH;EkBljDG;;IAEA,8BAAA;ElBojDH;EkBljDG;;IAEA,4BAAA;ElBojDH;EkBnkDG;IAA4B,yBAAA;ElBskD/B;EkBrkDG;;IAEA,6BAAA;ElBukDH;EkBrkDG;;IAEA,+BAAA;ElBukDH;EkBrkDG;;IAEA,gCAAA;ElBukDH;EkBrkDG;;IAEA,8BAAA;ElBukDH;EkBtlDG;IAA4B,uBAAA;ElBylD/B;EkBxlDG;;IAEA,2BAAA;ElB0lDH;EkBxlDG;;IAEA,6BAAA;ElB0lDH;EkBxlDG;;IAEA,8BAAA;ElB0lDH;EkBxlDG;;IAEA,4BAAA;ElB0lDH;EkBzmDG;IAA4B,qBAAA;ElB4mD/B;EkB3mDG;;IAEA,yBAAA;ElB6mDH;EkB3mDG;;IAEA,2BAAA;ElB6mDH;EkB3mDG;;IAEA,4BAAA;ElB6mDH;EkB3mDG;;IAEA,0BAAA;ElB6mDH;EkB5nDG;IAA4B,2BAAA;ElB+nD/B;EkB9nDG;;IAEA,+BAAA;ElBgoDH;EkB9nDG;;IAEA,iCAAA;ElBgoDH;EkB9nDG;;IAEA,kCAAA;ElBgoDH;EkB9nDG;;IAEA,gCAAA;ElBgoDH;EkB/oDG;IAA4B,0BAAA;ElBkpD/B;EkBjpDG;;IAEA,8BAAA;ElBmpDH;EkBjpDG;;IAEA,gCAAA;ElBmpDH;EkBjpDG;;IAEA,iCAAA;ElBmpDH;EkBjpDG;;IAEA,+BAAA;ElBmpDH;EkBlqDG;IAA4B,wBAAA;ElBqqD/B;EkBpqDG;;IAEA,4BAAA;ElBsqDH;EkBpqDG;;IAEA,8BAAA;ElBsqDH;EkBpqDG;;IAEA,+BAAA;ElBsqDH;EkBpqDG;;IAEA,6BAAA;ElBsqDH;EkBrrDG;IAA4B,0BAAA;ElBwrD/B;EkBvrDG;;IAEA,8BAAA;ElByrDH;EkBvrDG;;IAEA,gCAAA;ElByrDH;EkBvrDG;;IAEA,iCAAA;ElByrDH;EkBvrDG;;IAEA,+BAAA;ElByrDH;EkBxsDG;IAA4B,wBAAA;ElB2sD/B;EkB1sDG;;IAEA,4BAAA;ElB4sDH;EkB1sDG;;IAEA,8BAAA;ElB4sDH;EkB1sDG;;IAEA,+BAAA;ElB4sDH;EkB1sDG;;IAEA,6BAAA;ElB4sDH;EkBlsDC;IAAiB,uBAAA;ElBqsDlB;EkBpsDC;;IAEA,2BAAA;ElBssDD;EkBpsDC;;IAEA,6BAAA;ElBssDD;EkBpsDC;;IAEA,8BAAA;ElBssDD;EkBpsDC;;IAEA,4BAAA;ElBssDD;AACF;AQzuDE;EUNG;IAA4B,oBAAA;ElBmvD/B;EkBlvDG;;IAEA,wBAAA;ElBovDH;EkBlvDG;;IAEA,0BAAA;ElBovDH;EkBlvDG;;IAEA,2BAAA;ElBovDH;EkBlvDG;;IAEA,yBAAA;ElBovDH;EkBnwDG;IAA4B,0BAAA;ElBswD/B;EkBrwDG;;IAEA,8BAAA;ElBuwDH;EkBrwDG;;IAEA,gCAAA;ElBuwDH;EkBrwDG;;IAEA,iCAAA;ElBuwDH;EkBrwDG;;IAEA,+BAAA;ElBuwDH;EkBtxDG;IAA4B,yBAAA;ElByxD/B;EkBxxDG;;IAEA,6BAAA;ElB0xDH;EkBxxDG;;IAEA,+BAAA;ElB0xDH;EkBxxDG;;IAEA,gCAAA;ElB0xDH;EkBxxDG;;IAEA,8BAAA;ElB0xDH;EkBzyDG;IAA4B,uBAAA;ElB4yD/B;EkB3yDG;;IAEA,2BAAA;ElB6yDH;EkB3yDG;;IAEA,6BAAA;ElB6yDH;EkB3yDG;;IAEA,8BAAA;ElB6yDH;EkB3yDG;;IAEA,4BAAA;ElB6yDH;EkB5zDG;IAA4B,yBAAA;ElB+zD/B;EkB9zDG;;IAEA,6BAAA;ElBg0DH;EkB9zDG;;IAEA,+BAAA;ElBg0DH;EkB9zDG;;IAEA,gCAAA;ElBg0DH;EkB9zDG;;IAEA,8BAAA;ElBg0DH;EkB/0DG;IAA4B,uBAAA;ElBk1D/B;EkBj1DG;;IAEA,2BAAA;ElBm1DH;EkBj1DG;;IAEA,6BAAA;ElBm1DH;EkBj1DG;;IAEA,8BAAA;ElBm1DH;EkBj1DG;;IAEA,4BAAA;ElBm1DH;EkBl2DG;IAA4B,qBAAA;ElBq2D/B;EkBp2DG;;IAEA,yBAAA;ElBs2DH;EkBp2DG;;IAEA,2BAAA;ElBs2DH;EkBp2DG;;IAEA,4BAAA;ElBs2DH;EkBp2DG;;IAEA,0BAAA;ElBs2DH;EkBr3DG;IAA4B,2BAAA;ElBw3D/B;EkBv3DG;;IAEA,+BAAA;ElBy3DH;EkBv3DG;;IAEA,iCAAA;ElBy3DH;EkBv3DG;;IAEA,kCAAA;ElBy3DH;EkBv3DG;;IAEA,gCAAA;ElBy3DH;EkBx4DG;IAA4B,0BAAA;ElB24D/B;EkB14DG;;IAEA,8BAAA;ElB44DH;EkB14DG;;IAEA,gCAAA;ElB44DH;EkB14DG;;IAEA,iCAAA;ElB44DH;EkB14DG;;IAEA,+BAAA;ElB44DH;EkB35DG;IAA4B,wBAAA;ElB85D/B;EkB75DG;;IAEA,4BAAA;ElB+5DH;EkB75DG;;IAEA,8BAAA;ElB+5DH;EkB75DG;;IAEA,+BAAA;ElB+5DH;EkB75DG;;IAEA,6BAAA;ElB+5DH;EkB96DG;IAA4B,0BAAA;ElBi7D/B;EkBh7DG;;IAEA,8BAAA;ElBk7DH;EkBh7DG;;IAEA,gCAAA;ElBk7DH;EkBh7DG;;IAEA,iCAAA;ElBk7DH;EkBh7DG;;IAEA,+BAAA;ElBk7DH;EkBj8DG;IAA4B,wBAAA;ElBo8D/B;EkBn8DG;;IAEA,4BAAA;ElBq8DH;EkBn8DG;;IAEA,8BAAA;ElBq8DH;EkBn8DG;;IAEA,+BAAA;ElBq8DH;EkBn8DG;;IAEA,6BAAA;ElBq8DH;EkB37DC;IAAiB,uBAAA;ElB87DlB;EkB77DC;;IAEA,2BAAA;ElB+7DD;EkB77DC;;IAEA,6BAAA;ElB+7DD;EkB77DC;;IAEA,8BAAA;ElB+7DD;EkB77DC;;IAEA,4BAAA;ElB+7DD;AACF;AQl+DE;EUNG;IAA4B,oBAAA;ElB4+D/B;EkB3+DG;;IAEA,wBAAA;ElB6+DH;EkB3+DG;;IAEA,0BAAA;ElB6+DH;EkB3+DG;;IAEA,2BAAA;ElB6+DH;EkB3+DG;;IAEA,yBAAA;ElB6+DH;EkB5/DG;IAA4B,0BAAA;ElB+/D/B;EkB9/DG;;IAEA,8BAAA;ElBggEH;EkB9/DG;;IAEA,gCAAA;ElBggEH;EkB9/DG;;IAEA,iCAAA;ElBggEH;EkB9/DG;;IAEA,+BAAA;ElBggEH;EkB/gEG;IAA4B,yBAAA;ElBkhE/B;EkBjhEG;;IAEA,6BAAA;ElBmhEH;EkBjhEG;;IAEA,+BAAA;ElBmhEH;EkBjhEG;;IAEA,gCAAA;ElBmhEH;EkBjhEG;;IAEA,8BAAA;ElBmhEH;EkBliEG;IAA4B,uBAAA;ElBqiE/B;EkBpiEG;;IAEA,2BAAA;ElBsiEH;EkBpiEG;;IAEA,6BAAA;ElBsiEH;EkBpiEG;;IAEA,8BAAA;ElBsiEH;EkBpiEG;;IAEA,4BAAA;ElBsiEH;EkBrjEG;IAA4B,yBAAA;ElBwjE/B;EkBvjEG;;IAEA,6BAAA;ElByjEH;EkBvjEG;;IAEA,+BAAA;ElByjEH;EkBvjEG;;IAEA,gCAAA;ElByjEH;EkBvjEG;;IAEA,8BAAA;ElByjEH;EkBxkEG;IAA4B,uBAAA;ElB2kE/B;EkB1kEG;;IAEA,2BAAA;ElB4kEH;EkB1kEG;;IAEA,6BAAA;ElB4kEH;EkB1kEG;;IAEA,8BAAA;ElB4kEH;EkB1kEG;;IAEA,4BAAA;ElB4kEH;EkB3lEG;IAA4B,qBAAA;ElB8lE/B;EkB7lEG;;IAEA,yBAAA;ElB+lEH;EkB7lEG;;IAEA,2BAAA;ElB+lEH;EkB7lEG;;IAEA,4BAAA;ElB+lEH;EkB7lEG;;IAEA,0BAAA;ElB+lEH;EkB9mEG;IAA4B,2BAAA;ElBinE/B;EkBhnEG;;IAEA,+BAAA;ElBknEH;EkBhnEG;;IAEA,iCAAA;ElBknEH;EkBhnEG;;IAEA,kCAAA;ElBknEH;EkBhnEG;;IAEA,gCAAA;ElBknEH;EkBjoEG;IAA4B,0BAAA;ElBooE/B;EkBnoEG;;IAEA,8BAAA;ElBqoEH;EkBnoEG;;IAEA,gCAAA;ElBqoEH;EkBnoEG;;IAEA,iCAAA;ElBqoEH;EkBnoEG;;IAEA,+BAAA;ElBqoEH;EkBppEG;IAA4B,wBAAA;ElBupE/B;EkBtpEG;;IAEA,4BAAA;ElBwpEH;EkBtpEG;;IAEA,8BAAA;ElBwpEH;EkBtpEG;;IAEA,+BAAA;ElBwpEH;EkBtpEG;;IAEA,6BAAA;ElBwpEH;EkBvqEG;IAA4B,0BAAA;ElB0qE/B;EkBzqEG;;IAEA,8BAAA;ElB2qEH;EkBzqEG;;IAEA,gCAAA;ElB2qEH;EkBzqEG;;IAEA,iCAAA;ElB2qEH;EkBzqEG;;IAEA,+BAAA;ElB2qEH;EkB1rEG;IAA4B,wBAAA;ElB6rE/B;EkB5rEG;;IAEA,4BAAA;ElB8rEH;EkB5rEG;;IAEA,8BAAA;ElB8rEH;EkB5rEG;;IAEA,+BAAA;ElB8rEH;EkB5rEG;;IAEA,6BAAA;ElB8rEH;EkBprEC;IAAiB,uBAAA;ElBurElB;EkBtrEC;;IAEA,2BAAA;ElBwrED;EkBtrEC;;IAEA,6BAAA;ElBwrED;EkBtrEC;;IAEA,8BAAA;ElBwrED;EkBtrEC;;IAEA,4BAAA;ElBwrED;AACF;AQ3tEE;EUNG;IAA4B,oBAAA;ElBquE/B;EkBpuEG;;IAEA,wBAAA;ElBsuEH;EkBpuEG;;IAEA,0BAAA;ElBsuEH;EkBpuEG;;IAEA,2BAAA;ElBsuEH;EkBpuEG;;IAEA,yBAAA;ElBsuEH;EkBrvEG;IAA4B,0BAAA;ElBwvE/B;EkBvvEG;;IAEA,8BAAA;ElByvEH;EkBvvEG;;IAEA,gCAAA;ElByvEH;EkBvvEG;;IAEA,iCAAA;ElByvEH;EkBvvEG;;IAEA,+BAAA;ElByvEH;EkBxwEG;IAA4B,yBAAA;ElB2wE/B;EkB1wEG;;IAEA,6BAAA;ElB4wEH;EkB1wEG;;IAEA,+BAAA;ElB4wEH;EkB1wEG;;IAEA,gCAAA;ElB4wEH;EkB1wEG;;IAEA,8BAAA;ElB4wEH;EkB3xEG;IAA4B,uBAAA;ElB8xE/B;EkB7xEG;;IAEA,2BAAA;ElB+xEH;EkB7xEG;;IAEA,6BAAA;ElB+xEH;EkB7xEG;;IAEA,8BAAA;ElB+xEH;EkB7xEG;;IAEA,4BAAA;ElB+xEH;EkB9yEG;IAA4B,yBAAA;ElBizE/B;EkBhzEG;;IAEA,6BAAA;ElBkzEH;EkBhzEG;;IAEA,+BAAA;ElBkzEH;EkBhzEG;;IAEA,gCAAA;ElBkzEH;EkBhzEG;;IAEA,8BAAA;ElBkzEH;EkBj0EG;IAA4B,uBAAA;ElBo0E/B;EkBn0EG;;IAEA,2BAAA;ElBq0EH;EkBn0EG;;IAEA,6BAAA;ElBq0EH;EkBn0EG;;IAEA,8BAAA;ElBq0EH;EkBn0EG;;IAEA,4BAAA;ElBq0EH;EkBp1EG;IAA4B,qBAAA;ElBu1E/B;EkBt1EG;;IAEA,yBAAA;ElBw1EH;EkBt1EG;;IAEA,2BAAA;ElBw1EH;EkBt1EG;;IAEA,4BAAA;ElBw1EH;EkBt1EG;;IAEA,0BAAA;ElBw1EH;EkBv2EG;IAA4B,2BAAA;ElB02E/B;EkBz2EG;;IAEA,+BAAA;ElB22EH;EkBz2EG;;IAEA,iCAAA;ElB22EH;EkBz2EG;;IAEA,kCAAA;ElB22EH;EkBz2EG;;IAEA,gCAAA;ElB22EH;EkB13EG;IAA4B,0BAAA;ElB63E/B;EkB53EG;;IAEA,8BAAA;ElB83EH;EkB53EG;;IAEA,gCAAA;ElB83EH;EkB53EG;;IAEA,iCAAA;ElB83EH;EkB53EG;;IAEA,+BAAA;ElB83EH;EkB74EG;IAA4B,wBAAA;ElBg5E/B;EkB/4EG;;IAEA,4BAAA;ElBi5EH;EkB/4EG;;IAEA,8BAAA;ElBi5EH;EkB/4EG;;IAEA,+BAAA;ElBi5EH;EkB/4EG;;IAEA,6BAAA;ElBi5EH;EkBh6EG;IAA4B,0BAAA;ElBm6E/B;EkBl6EG;;IAEA,8BAAA;ElBo6EH;EkBl6EG;;IAEA,gCAAA;ElBo6EH;EkBl6EG;;IAEA,iCAAA;ElBo6EH;EkBl6EG;;IAEA,+BAAA;ElBo6EH;EkBn7EG;IAA4B,wBAAA;ElBs7E/B;EkBr7EG;;IAEA,4BAAA;ElBu7EH;EkBr7EG;;IAEA,8BAAA;ElBu7EH;EkBr7EG;;IAEA,+BAAA;ElBu7EH;EkBr7EG;;IAEA,6BAAA;ElBu7EH;EkB76EC;IAAiB,uBAAA;ElBg7ElB;EkB/6EC;;IAEA,2BAAA;ElBi7ED;EkB/6EC;;IAEA,6BAAA;ElBi7ED;EkB/6EC;;IAEA,8BAAA;ElBi7ED;EkB/6EC;;IAEA,4BAAA;ElBi7ED;AACF;AmBzhFA;EAAkB,iGAAA;AnB4hFlB;AmBxhFA;EAAiB,8BAAA;AnB2hFjB;AmB1hFA;EAAiB,8BAAA;AnB6hFjB;AmB5hFA;ECNC,gBAAA;EACA,uBAAA;EACA,mBAAA;ApBqiFD;AmB9gFG;EAAsB,2BAAA;AnBihFzB;AmBhhFG;EAAsB,4BAAA;AnBmhFzB;AmBlhFG;EAAsB,6BAAA;AnBqhFzB;AQ3+EE;EW5CC;IAAsB,2BAAA;EnB2hFvB;EmB1hFC;IAAsB,4BAAA;EnB6hFvB;EmB5hFC;IAAsB,6BAAA;EnB+hFvB;AACF;AQt/EE;EW5CC;IAAsB,2BAAA;EnBsiFvB;EmBriFC;IAAsB,4BAAA;EnBwiFvB;EmBviFC;IAAsB,6BAAA;EnB0iFvB;AACF;AQjgFE;EW5CC;IAAsB,2BAAA;EnBijFvB;EmBhjFC;IAAsB,4BAAA;EnBmjFvB;EmBljFC;IAAsB,6BAAA;EnBqjFvB;AACF;AQ5gFE;EW5CC;IAAsB,2BAAA;EnB4jFvB;EmB3jFC;IAAsB,4BAAA;EnB8jFvB;EmB7jFC;IAAsB,6BAAA;EnBgkFvB;AACF;AmBzjFA;EAAmB,oCAAA;AnB4jFnB;AmB3jFA;EAAmB,oCAAA;AnB8jFnB;AmB7jFA;EAAmB,qCAAA;AnBgkFnB;AmB5jFA;EAAsB,2BAAA;AnB+jFtB;AmB9jFA;EAAsB,2BAAA;AnBikFtB;AmBhkFA;EAAsB,2BAAA;AnBmkFtB;AmBlkFA;EAAsB,6BAAA;AnBqkFtB;AmBjkFA;EAAc,yBAAA;AnBokFd;AqBrnFE;EACA,yBAAA;ArBunFF;AC3mFC;;EoBRE,yBAAA;ArBunFH;AqB5nFE;EACA,yBAAA;ArB8nFF;AClnFC;;EoBRE,yBAAA;ArB8nFH;AqBnoFE;EACA,yBAAA;ArBqoFF;ACznFC;;EoBRE,yBAAA;ArBqoFH;AqB1oFE;EACA,yBAAA;ArB4oFF;AChoFC;;EoBRE,yBAAA;ArB4oFH;AqBjpFE;EACA,yBAAA;ArBmpFF;ACvoFC;;EoBRE,yBAAA;ArBmpFH;AqBxpFE;EACA,yBAAA;ArB0pFF;AC9oFC;;EoBRE,yBAAA;ArB0pFH;AqB/pFE;EACA,yBAAA;ArBiqFF;ACrpFC;;EoBRE,yBAAA;ArBiqFH;AqBtqFE;EACA,yBAAA;ArBwqFF;AC5pFC;;EoBRE,yBAAA;ArBwqFH;AmB7mFA;EAAa,yBAAA;AnBgnFb;AmB/mFA;EAAc,yBAAA;AnBknFd;AmBhnFA;EAAiB,oCAAA;AnBmnFjB;AmBlnFA;EAAiB,0CAAA;AnBqnFjB;AmBjnFA;EGzEC,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;AtB6rFD;AuB/rFA;ECDC,8BAAA;AxBmsFD;AuB9rFA;ECLC,6BAAA;AxBssFD;AyBrsFA;EACC,cAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,4BAAA;EACA,yBAAA;EAKC,kBAAA;ECOC,wEAAA;A1B6rFH;A0BvrFC;EAAA;IACC,gBAAA;E1B0rFA;AACF;AyB9rFC;EACC,6BAAA;EACA,SAAA;AzBgsFF;A2BltFC;EACC,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EAMC,gDAAA;A3B+sFH;AyBhsFC;EACC,cAAA;EAEA,UAAA;AzBisFF;AyBzrFC;;EAEC,yBAAA;EAEA,UAAA;AzB0rFF;AyBrrFC;EACC,2BAAA;AzBurFF;AyBprFC;EAMC,cAAA;EACA,yBAAA;AzBirFF;AyB5qFA;;EAEC,cAAA;EACA,WAAA;AzB8qFD;AyBpqFA;EACC,iCAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AzBsqFD;AyBnqFA;EACC,+BAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;AzBqqFD;AyBlqFA;EACC,gCAAA;EACA,mCAAA;EACA,mBAAA;EACA,gBAAA;AzBoqFD;AyB3pFA;EACC,cAAA;EACA,WAAA;EACA,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,6BAAA;EACA,yBAAA;EACA,mBAAA;AzB6pFD;AyB3pFC;;EAEC,gBAAA;EACA,eAAA;AzB6pFF;AyBhpFA;EACC,uBAAA;EACA,mBAAA;EACA,gBAAA;EG/IA,kBAAA;A5BkyFD;AyB9oFC;EACC,6BAAA;AzBgpFF;AyB5oFA;EACC,oBAAA;EACA,kBAAA;EACA,gBAAA;EG5JA,kBAAA;A5B2yFD;AyB1oFC;EACC,4BAAA;AzB4oFF;AyBloFA;EACC,mBAAA;AzBooFD;AyBjoFA;EACC,cAAA;EACA,mBAAA;AzBmoFD;AyB3nFA;EACC,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AzB6nFD;AyBjoFA;;EAQE,kBAAA;EACA,iBAAA;AzB6nFF;AyBpnFA;EACC,kBAAA;EACA,cAAA;EACA,qBAAA;AzBsnFD;AyBnnFA;EACC,kBAAA;EACA,kBAAA;EACA,qBAAA;AzBqnFD;AyBnnFC;EACC,cAAA;AzBqnFF;AyBjnFA;EACC,gBAAA;AzBmnFD;AyBhnFA;EACC,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;AzBknFD;AyBtnFA;EAQE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;AzBinFF;A2Bj0FE;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;A3Bm0FF;A2Bh0FE;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,0CAAA;EACA,qBAAA;A3Bk0FF;A2B7zFG;;;;EAEA,qBAAA;A3Bi0FH;A2B/zFG;;;;EACC,qBAAA;EACA,kDAAA;A3Bo0FJ;A2B10FG;;;;;;;;EAWC,cAAA;A3By0FJ;A2Bn0FG;;;;EAIC,cAAA;A3Bq0FJ;A2B/zFG;;EAGC,cAAA;A3Bg0FJ;A2Bn0FG;;;;EAQC,cAAA;A3Bi0FJ;A2B3zFG;;EAGC,cAAA;A3B4zFJ;A2B1zFI;;EACC,yBAAA;A3B6zFL;A2Bn0FG;;;;EAYC,cAAA;A3B6zFJ;A2B1zFG;;EExGD,yBAAA;A7Bs6FF;A2BxzFG;;EAEE,qEAAA;A3B0zFL;A2BlzFG;;EAGC,qBAAA;A3BmzFJ;A2BjzFI;;EAAY,qBAAA;A3BqzFhB;A2B1zFG;;;;EAUC,cAAA;A3BszFJ;A2BnzFG;;EAEE,kDAAA;A3BqzFL;A2Br6FE;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;A3Bu6FF;A2Bp6FE;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,wCAAA;EACA,qBAAA;A3Bs6FF;A2Bj6FG;;;;EAEA,qBAAA;A3Bq6FH;A2Bn6FG;;;;EACC,qBAAA;EACA,gDAAA;A3Bw6FJ;A2B96FG;;;;;;;;EAWC,cAAA;A3B66FJ;A2Bv6FG;;;;EAIC,cAAA;A3By6FJ;A2Bn6FG;;EAGC,cAAA;A3Bo6FJ;A2Bv6FG;;;;EAQC,cAAA;A3Bq6FJ;A2B/5FG;;EAGC,cAAA;A3Bg6FJ;A2B95FI;;EACC,yBAAA;A3Bi6FL;A2Bv6FG;;;;EAYC,cAAA;A3Bi6FJ;A2B95FG;;EExGD,yBAAA;A7B0gGF;A2B55FG;;EAEE,mEAAA;A3B85FL;A2Bt5FG;;EAGC,qBAAA;A3Bu5FJ;A2Br5FI;;EAAY,qBAAA;A3By5FhB;A2B95FG;;;;EAUC,cAAA;A3B05FJ;A2Bv5FG;;EAEE,gDAAA;A3By5FL;AyBjyFA;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;AzBmyFD;AyBtyFA;EASE,WAAA;AzBgyFF;AQt+FE;EAAA;IiB4MC,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EzB8xFD;EQ7+FA;IiBoNC,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;EzB4xFD;EQp/FA;IiB6NC,qBAAA;IACA,WAAA;IACA,sBAAA;EzB0xFD;EQz/FA;IiBoOC,qBAAA;EzBwxFD;EQ5/FA;;IiByOC,WAAA;EzBuxFD;EQhgGA;IiB+OC,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;EzBoxFD;EQvgGA;IiBsPC,kBAAA;IACA,aAAA;IACA,qBAAA;IACA,cAAA;EzBoxFD;EQ7gGA;IiB6PC,mBAAA;IACA,uBAAA;EzBmxFD;EQjhGA;IiBiQC,gBAAA;EzBmxFD;AACF;A8B1lGA;ECCC,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;A/B4lGD;AQ5hGE;EAAA;IuB7CC,gBAAA;E/B6kGD;AACF;AQjiGE;EAAA;IuB7CC,gBAAA;E/BklGD;AACF;AQtiGE;EAAA;IuB7CC,gBAAA;E/BulGD;AACF;AQ3iGE;EAAA;IuB7CC,iBAAA;E/B4lGD;AACF;A8B3mGA;ECTC,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;A/BunGD;A8B1mGA;ECcC,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;A/B+lGD;A8B1mGA;EACC,eAAA;EACA,cAAA;A9B4mGD;A8B9mGA;;EAME,gBAAA;EACA,eAAA;A9B4mGF;AgCvkGC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EACC,kBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AhC+oGF;AgCznGI;EACA,aAAA;EACA,YAAA;EACA,eAAA;AhC2nGJ;AgCznGI;EACA,cAAA;EACA,WAAA;EACA,eAAA;AhC2nGJ;AgCvnGK;EDzDJ,qBAAA;EAIA,sBAAA;A/BgrGD;AgC3nGK;EDzDJ,sBAAA;EAIA,uBAAA;A/BorGD;AgC/nGK;EDzDJ,aAAA;EAIA,cAAA;A/BwrGD;AgCnoGK;EDzDJ,sBAAA;EAIA,uBAAA;A/B4rGD;AgCvoGK;EDzDJ,sBAAA;EAIA,uBAAA;A/BgsGD;AgC3oGK;EDzDJ,aAAA;EAIA,cAAA;A/BosGD;AgC/oGK;EDzDJ,sBAAA;EAIA,uBAAA;A/BwsGD;AgCnpGK;EDzDJ,sBAAA;EAIA,uBAAA;A/B4sGD;AgCvpGK;EDzDJ,aAAA;EAIA,cAAA;A/BgtGD;AgC3pGK;EDzDJ,sBAAA;EAIA,uBAAA;A/BotGD;AgC/pGK;EDzDJ,sBAAA;EAIA,uBAAA;A/BwtGD;AgCnqGK;EDzDJ,cAAA;EAIA,eAAA;A/B4tGD;AgChqGI;EAAsB,SAAA;AhCmqG1B;AgCjqGI;EAAqB,SAAA;AhCoqGzB;AgCjqGK;EAAuB,QAAA;AhCoqG5B;AgCpqGK;EAAuB,QAAA;AhCuqG5B;AgCvqGK;EAAuB,QAAA;AhC0qG5B;AgC1qGK;EAAuB,QAAA;AhC6qG5B;AgC7qGK;EAAuB,QAAA;AhCgrG5B;AgChrGK;EAAuB,QAAA;AhCmrG5B;AgCnrGK;EAAuB,QAAA;AhCsrG5B;AgCtrGK;EAAuB,QAAA;AhCyrG5B;AgCzrGK;EAAuB,QAAA;AhC4rG5B;AgC5rGK;EAAuB,QAAA;AhC+rG5B;AgC/rGK;EAAuB,SAAA;AhCksG5B;AgClsGK;EAAuB,SAAA;AhCqsG5B;AgCrsGK;EAAuB,SAAA;AhCwsG5B;AgC/rGM;EDhEJ,wBAAA;A/BkwGF;AgClsGM;EDhEJ,yBAAA;A/BqwGF;AgCrsGM;EDhEJ,gBAAA;A/BwwGF;AgCxsGM;EDhEJ,yBAAA;A/B2wGF;AgC3sGM;EDhEJ,yBAAA;A/B8wGF;AgC9sGM;EDhEJ,gBAAA;A/BixGF;AgCjtGM;EDhEJ,yBAAA;A/BoxGF;AgCptGM;EDhEJ,yBAAA;A/BuxGF;AgCvtGM;EDhEJ,gBAAA;A/B0xGF;AgC1tGM;EDhEJ,yBAAA;A/B6xGF;AgC7tGM;EDhEJ,yBAAA;A/BgyGF;AQ3xGE;EwB0BE;IACA,aAAA;IACA,YAAA;IACA,eAAA;EhCowGF;EgClwGE;IACA,cAAA;IACA,WAAA;IACA,eAAA;EhCowGF;EgChwGG;IDzDJ,qBAAA;IAIA,sBAAA;E/ByzGC;EgCpwGG;IDzDJ,sBAAA;IAIA,uBAAA;E/B6zGC;EgCxwGG;IDzDJ,aAAA;IAIA,cAAA;E/Bi0GC;EgC5wGG;IDzDJ,sBAAA;IAIA,uBAAA;E/Bq0GC;EgChxGG;IDzDJ,sBAAA;IAIA,uBAAA;E/By0GC;EgCpxGG;IDzDJ,aAAA;IAIA,cAAA;E/B60GC;EgCxxGG;IDzDJ,sBAAA;IAIA,uBAAA;E/Bi1GC;EgC5xGG;IDzDJ,sBAAA;IAIA,uBAAA;E/Bq1GC;EgChyGG;IDzDJ,aAAA;IAIA,cAAA;E/By1GC;EgCpyGG;IDzDJ,sBAAA;IAIA,uBAAA;E/B61GC;EgCxyGG;IDzDJ,sBAAA;IAIA,uBAAA;E/Bi2GC;EgC5yGG;IDzDJ,cAAA;IAIA,eAAA;E/Bq2GC;EgCzyGE;IAAsB,SAAA;EhC4yGxB;EgC1yGE;IAAqB,SAAA;EhC6yGvB;EgC1yGG;IAAuB,QAAA;EhC6yG1B;EgC7yGG;IAAuB,QAAA;EhCgzG1B;EgChzGG;IAAuB,QAAA;EhCmzG1B;EgCnzGG;IAAuB,QAAA;EhCszG1B;EgCtzGG;IAAuB,QAAA;EhCyzG1B;EgCzzGG;IAAuB,QAAA;EhC4zG1B;EgC5zGG;IAAuB,QAAA;EhC+zG1B;EgC/zGG;IAAuB,QAAA;EhCk0G1B;EgCl0GG;IAAuB,QAAA;EhCq0G1B;EgCr0GG;IAAuB,QAAA;EhCw0G1B;EgCx0GG;IAAuB,SAAA;EhC20G1B;EgC30GG;IAAuB,SAAA;EhC80G1B;EgC90GG;IAAuB,SAAA;EhCi1G1B;EgCx0GI;IDnEJ,cAAA;E/B84GA;EgC30GI;IDhEJ,wBAAA;E/B84GA;EgC90GI;IDhEJ,yBAAA;E/Bi5GA;EgCj1GI;IDhEJ,gBAAA;E/Bo5GA;EgCp1GI;IDhEJ,yBAAA;E/Bu5GA;EgCv1GI;IDhEJ,yBAAA;E/B05GA;EgC11GI;IDhEJ,gBAAA;E/B65GA;EgC71GI;IDhEJ,yBAAA;E/Bg6GA;EgCh2GI;IDhEJ,yBAAA;E/Bm6GA;EgCn2GI;IDhEJ,gBAAA;E/Bs6GA;EgCt2GI;IDhEJ,yBAAA;E/By6GA;EgCz2GI;IDhEJ,yBAAA;E/B46GA;AACF;AQx6GE;EwB0BE;IACA,aAAA;IACA,YAAA;IACA,eAAA;EhCi5GF;EgC/4GE;IACA,cAAA;IACA,WAAA;IACA,eAAA;EhCi5GF;EgC74GG;IDzDJ,qBAAA;IAIA,sBAAA;E/Bs8GC;EgCj5GG;IDzDJ,sBAAA;IAIA,uBAAA;E/B08GC;EgCr5GG;IDzDJ,aAAA;IAIA,cAAA;E/B88GC;EgCz5GG;IDzDJ,sBAAA;IAIA,uBAAA;E/Bk9GC;EgC75GG;IDzDJ,sBAAA;IAIA,uBAAA;E/Bs9GC;EgCj6GG;IDzDJ,aAAA;IAIA,cAAA;E/B09GC;EgCr6GG;IDzDJ,sBAAA;IAIA,uBAAA;E/B89GC;EgCz6GG;IDzDJ,sBAAA;IAIA,uBAAA;E/Bk+GC;EgC76GG;IDzDJ,aAAA;IAIA,cAAA;E/Bs+GC;EgCj7GG;IDzDJ,sBAAA;IAIA,uBAAA;E/B0+GC;EgCr7GG;IDzDJ,sBAAA;IAIA,uBAAA;E/B8+GC;EgCz7GG;IDzDJ,cAAA;IAIA,eAAA;E/Bk/GC;EgCt7GE;IAAsB,SAAA;EhCy7GxB;EgCv7GE;IAAqB,SAAA;EhC07GvB;EgCv7GG;IAAuB,QAAA;EhC07G1B;EgC17GG;IAAuB,QAAA;EhC67G1B;EgC77GG;IAAuB,QAAA;EhCg8G1B;EgCh8GG;IAAuB,QAAA;EhCm8G1B;EgCn8GG;IAAuB,QAAA;EhCs8G1B;EgCt8GG;IAAuB,QAAA;EhCy8G1B;EgCz8GG;IAAuB,QAAA;EhC48G1B;EgC58GG;IAAuB,QAAA;EhC+8G1B;EgC/8GG;IAAuB,QAAA;EhCk9G1B;EgCl9GG;IAAuB,QAAA;EhCq9G1B;EgCr9GG;IAAuB,SAAA;EhCw9G1B;EgCx9GG;IAAuB,SAAA;EhC29G1B;EgC39GG;IAAuB,SAAA;EhC89G1B;EgCr9GI;IDnEJ,cAAA;E/B2hHA;EgCx9GI;IDhEJ,wBAAA;E/B2hHA;EgC39GI;IDhEJ,yBAAA;E/B8hHA;EgC99GI;IDhEJ,gBAAA;E/BiiHA;EgCj+GI;IDhEJ,yBAAA;E/BoiHA;EgCp+GI;IDhEJ,yBAAA;E/BuiHA;EgCv+GI;IDhEJ,gBAAA;E/B0iHA;EgC1+GI;IDhEJ,yBAAA;E/B6iHA;EgC7+GI;IDhEJ,yBAAA;E/BgjHA;EgCh/GI;IDhEJ,gBAAA;E/BmjHA;EgCn/GI;IDhEJ,yBAAA;E/BsjHA;EgCt/GI;IDhEJ,yBAAA;E/ByjHA;AACF;AQrjHE;EwB0BE;IACA,aAAA;IACA,YAAA;IACA,eAAA;EhC8hHF;EgC5hHE;IACA,cAAA;IACA,WAAA;IACA,eAAA;EhC8hHF;EgC1hHG;IDzDJ,qBAAA;IAIA,sBAAA;E/BmlHC;EgC9hHG;IDzDJ,sBAAA;IAIA,uBAAA;E/BulHC;EgCliHG;IDzDJ,aAAA;IAIA,cAAA;E/B2lHC;EgCtiHG;IDzDJ,sBAAA;IAIA,uBAAA;E/B+lHC;EgC1iHG;IDzDJ,sBAAA;IAIA,uBAAA;E/BmmHC;EgC9iHG;IDzDJ,aAAA;IAIA,cAAA;E/BumHC;EgCljHG;IDzDJ,sBAAA;IAIA,uBAAA;E/B2mHC;EgCtjHG;IDzDJ,sBAAA;IAIA,uBAAA;E/B+mHC;EgC1jHG;IDzDJ,aAAA;IAIA,cAAA;E/BmnHC;EgC9jHG;IDzDJ,sBAAA;IAIA,uBAAA;E/BunHC;EgClkHG;IDzDJ,sBAAA;IAIA,uBAAA;E/B2nHC;EgCtkHG;IDzDJ,cAAA;IAIA,eAAA;E/B+nHC;EgCnkHE;IAAsB,SAAA;EhCskHxB;EgCpkHE;IAAqB,SAAA;EhCukHvB;EgCpkHG;IAAuB,QAAA;EhCukH1B;EgCvkHG;IAAuB,QAAA;EhC0kH1B;EgC1kHG;IAAuB,QAAA;EhC6kH1B;EgC7kHG;IAAuB,QAAA;EhCglH1B;EgChlHG;IAAuB,QAAA;EhCmlH1B;EgCnlHG;IAAuB,QAAA;EhCslH1B;EgCtlHG;IAAuB,QAAA;EhCylH1B;EgCzlHG;IAAuB,QAAA;EhC4lH1B;EgC5lHG;IAAuB,QAAA;EhC+lH1B;EgC/lHG;IAAuB,QAAA;EhCkmH1B;EgClmHG;IAAuB,SAAA;EhCqmH1B;EgCrmHG;IAAuB,SAAA;EhCwmH1B;EgCxmHG;IAAuB,SAAA;EhC2mH1B;EgClmHI;IDnEJ,cAAA;E/BwqHA;EgCrmHI;IDhEJ,wBAAA;E/BwqHA;EgCxmHI;IDhEJ,yBAAA;E/B2qHA;EgC3mHI;IDhEJ,gBAAA;E/B8qHA;EgC9mHI;IDhEJ,yBAAA;E/BirHA;EgCjnHI;IDhEJ,yBAAA;E/BorHA;EgCpnHI;IDhEJ,gBAAA;E/BurHA;EgCvnHI;IDhEJ,yBAAA;E/B0rHA;EgC1nHI;IDhEJ,yBAAA;E/B6rHA;EgC7nHI;IDhEJ,gBAAA;E/BgsHA;EgChoHI;IDhEJ,yBAAA;E/BmsHA;EgCnoHI;IDhEJ,yBAAA;E/BssHA;AACF;AQlsHE;EwB0BE;IACA,aAAA;IACA,YAAA;IACA,eAAA;EhC2qHF;EgCzqHE;IACA,cAAA;IACA,WAAA;IACA,eAAA;EhC2qHF;EgCvqHG;IDzDJ,qBAAA;IAIA,sBAAA;E/BguHC;EgC3qHG;IDzDJ,sBAAA;IAIA,uBAAA;E/BouHC;EgC/qHG;IDzDJ,aAAA;IAIA,cAAA;E/BwuHC;EgCnrHG;IDzDJ,sBAAA;IAIA,uBAAA;E/B4uHC;EgCvrHG;IDzDJ,sBAAA;IAIA,uBAAA;E/BgvHC;EgC3rHG;IDzDJ,aAAA;IAIA,cAAA;E/BovHC;EgC/rHG;IDzDJ,sBAAA;IAIA,uBAAA;E/BwvHC;EgCnsHG;IDzDJ,sBAAA;IAIA,uBAAA;E/B4vHC;EgCvsHG;IDzDJ,aAAA;IAIA,cAAA;E/BgwHC;EgC3sHG;IDzDJ,sBAAA;IAIA,uBAAA;E/BowHC;EgC/sHG;IDzDJ,sBAAA;IAIA,uBAAA;E/BwwHC;EgCntHG;IDzDJ,cAAA;IAIA,eAAA;E/B4wHC;EgChtHE;IAAsB,SAAA;EhCmtHxB;EgCjtHE;IAAqB,SAAA;EhCotHvB;EgCjtHG;IAAuB,QAAA;EhCotH1B;EgCptHG;IAAuB,QAAA;EhCutH1B;EgCvtHG;IAAuB,QAAA;EhC0tH1B;EgC1tHG;IAAuB,QAAA;EhC6tH1B;EgC7tHG;IAAuB,QAAA;EhCguH1B;EgChuHG;IAAuB,QAAA;EhCmuH1B;EgCnuHG;IAAuB,QAAA;EhCsuH1B;EgCtuHG;IAAuB,QAAA;EhCyuH1B;EgCzuHG;IAAuB,QAAA;EhC4uH1B;EgC5uHG;IAAuB,QAAA;EhC+uH1B;EgC/uHG;IAAuB,SAAA;EhCkvH1B;EgClvHG;IAAuB,SAAA;EhCqvH1B;EgCrvHG;IAAuB,SAAA;EhCwvH1B;EgC/uHI;IDnEJ,cAAA;E/BqzHA;EgClvHI;IDhEJ,wBAAA;E/BqzHA;EgCrvHI;IDhEJ,yBAAA;E/BwzHA;EgCxvHI;IDhEJ,gBAAA;E/B2zHA;EgC3vHI;IDhEJ,yBAAA;E/B8zHA;EgC9vHI;IDhEJ,yBAAA;E/Bi0HA;EgCjwHI;IDhEJ,gBAAA;E/Bo0HA;EgCpwHI;IDhEJ,yBAAA;E/Bu0HA;EgCvwHI;IDhEJ,yBAAA;E/B00HA;EgC1wHI;IDhEJ,gBAAA;E/B60HA;EgC7wHI;IDhEJ,yBAAA;E/Bg1HA;EgChxHI;IDhEJ,yBAAA;E/Bm1HA;AACF;AACA,WAAW;AACX,YAAY;AACZ,cAAc;AACd,aAAa;AACb,WAAW;AACX,SAAS;AACT,YAAY;AACZ,UAAU;AACV,kBAAkB;AF55HlB;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;AE85HF;AF55HA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kCAAA;EACA,mCAAA;EACA,SAAA;EACA,UAAA;EACA,kCAAA;AE85HF;AF35HA;EACE,sBAAA;AE65HF;AF35HA;EACE,kBAAA;EACA,eAAA;AE65HF;AF35HA;;EACE,qBAAA;EACA,cAAA;AE85HF;AF55HA;;;EACE,WAAA;AEg6HF;AF95HA;;;;;;;;;EAQE,SAAA;EACA,UAAA;AEi6HF;AF/5HA;EACE,eAAA;AEi6HF;AF/5HA;;EACE,sBAAA;AEk6HF;AACA,gCAAgC;AFh6HhC;EACE,wBAAA;EACA,gBAAA;AEk6HF;AFh6HA;EACE,4BAAA;AEk6HF;AFh6HA;EACE,yBAAA;AEk6HF;AACA,+CAA+C;AFh6H/C;;;;;;;;;;;;;;;;;;;EAmBI,wCAAA;EACA,gBAAA;EACA,gDAAA;EACA,wDAAA;EACA,2CAAA;EACA,WAAA;EACA,iCAAA;EACA,iCAAA;EACA,uBAAA;EACA,0BAAA;EACA,6CAAA;AEk6HJ;AF/5HA;EACE,wCAAA;EACA,gBAAA;EACA,gDAAA;EACA,wDAAA;EACA,2CAAA;EACA,WAAA;EACA,iCAAA;EACA,iCAAA;EACA,uBAAA;EACA,0BAAA;EACA,6CAAA;AEi6HF;AF95HA;EACE,wCAAA;EACA,gBAAA;EACA,gDAAA;EACA,wDAAA;EACA,2CAAA;EACA,WAAA;EACA,iCAAA;EACA,iCAAA;EACA,uBAAA;EACA,0BAAA;EACA,6CAAA;AEg6HF;AF75HA;EACE,kCAAA;EACA,wCAAA;EACA,gBAAA;EACA,gDAAA;EACA,wDAAA;EACA,2CAAA;EACA,sBAAA;EACA,iCAAA;EACA,iCAAA;EACA,uBAAA;EACA,0BAAA;AE+5HF;AF55HA;EACI,0BAAA;AE85HJ;AF35HA;;EAEI,wBAAA;AE65HJ;AACA,uBAAuB;AF15HvB;;EAAkB,qBAAA;AE85HlB;AACA,6BAA6B;AF75H7B;EACE,0BAAA;EACA,mBAAA;EACA,UAAA;AE+5HF;AF75HA;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;AE+5HF;AF75HA;;EACE,gCAAA;AEg6HF;AF95HA;EACE,gBAAA;EAGA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;AEg6HF;AACA,oDAAoD;AF95HpD;;;;;;EACE,gBAAA;EACA,cAAA;AEq6HF;AFn6HA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;AEq6HF;AFn6HA;EACE,eAAA;EACA,SAAA;EACA,gBAAA;AEq6HF;AFn6HA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AEq6HF;AFn6HA;EACE,eAAA;EACA,gBAAA;AEq6HF;AFn6HA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AEq6HF;AFn6HA;EACE,eAAA;EACA,gBAAA;AEq6HF;AFn6HA;EAAyC,kBAAA;AEs6HzC;AFr6HA;EAA+B,kBAAA;AEw6H/B;AACA,YAAY;AFx6HZ;EAAgC,kBAAA;AE26HhC;AACA,WAAW;AF36HX;EAAoC,kBAAA;AE86HpC;AACA,WAAW;AF96HX;EACE,cAAA;AEg7HF;AF96HA;EACE,cAAA;AEg7HF;AF96HA;EACE,cAAA;AEg7HF;AF96HA;EACE,cAAA;AEg7HF;AF96HA;EACE,WAAA;EACA,gBAAA;AEg7HF;AF76HA;EACE,gBAAA;AE+6HF;AF56HA;EACE,0BAAA;AE86HF;AF36HA;EACE,UAAA;AE66HF;AFp6HA;EACE,aAAA;AEs6HF;AFr6HE;EAAA;IACE,cAAA;EEw6HF;AACF;AACA,gBAAgB;AiCpqIhB;EACE,QAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,sCAAA;AjCsqIF;AiCrqIE;EAAA;IACE,aAAA;EjCwqIF;AACF;AiCnrIA;EAaI,eAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;AjCyqIJ;AiC1rIA;EAmBM,QAAA;EACA,WAAA;EACA,yBAAA;AjC0qIN;AiC/rIA;EAyBI,aAAA;EACA,qEAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AjCyqIJ;AiCxqII;EACE,YAAA;EACA,sBAAA;AjC0qIN;AiCjtIA;EA0CM,cAAA;AjC0qIN;AiCptIA;EA6CM,qBAAA;AjC0qIN;AiCvtIA;EAgDM,mBAAA;EACA,YAAA;EACA,sBAAA;AjC0qIN;AiC5tIA;EAuDI,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AjCwqIJ;AiCvqII;EAAA;IACE,cAAA;EjC0qIJ;AACF;AiCzqII;EACE,cAAA;AjC2qIN;AiC/uIA;EAuEM,gCAAA;EACA,sBAAA;AjC2qIN;AiCnvIA;EA0EQ,SAAA;EACA,UAAA;AjC4qIR;AiCvvIA;EA6EU,gBAAA;EACA,qBAAA;EACA,gBAAA;AjC6qIV;AiC5vIA;EAiFY,qBAAA;EACA,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,wCAAA;AjC8qIZ;AiC7qIY;EACE,gBAAA;EACA,cAAA;EACA,yBAAA;AjC+qId;AiC5qIU;EAEI,cAAA;EACA,2CAAA;AjC6qId;AiC5qIc;EACE,gBAAA;EACA,yBAAA;AjC8qIhB;AkCjuIA;;;EAGE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;EAGA,gBAAA;EACA,gBAAA;AlCmuIF;AkCjuIE;;;EACE,cAAA;EACA,gBAAA;AlCquIJ;AkC3vIA;;;EA0BI,UAAA;EACA,gCAAA;AlCsuIJ;AkCnuIE;;;EACE,gBAAA;EACA,gBAAA;AlCuuIJ;AkCpuIE;;;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AlCwuIJ;AkC3uIE;;;EAMI,eAAA;EACA,UAAA;AlC0uIN;AkCn0IE;;;;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlC20IJ;AkCx0IE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC80IJ;AkC50II;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC61IN;AkCz1IE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC+1IJ;AkC71II;;;;;;;;;;;;EAEE,yBAAA;EACA,mBAAA;AlCy2IN;AkCv2IM;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC04IR;AkCl1IE;;;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AlCs1IJ;AkCz1IE;;;EAMI,cAAA;EACA,eAAA;EACA,UAAA;AlCw1IN;AkCj8IE;;;;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCy8IJ;AkCt8IE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC48IJ;AkC18II;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC29IN;AkCv9IE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC69IJ;AkC39II;;;;;;;;;;;;EAEE,yBAAA;EACA,mBAAA;AlCu+IN;AkCr+IM;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCwgJR;AkCl8IE;;;EACE,mBAAA;AlCs8IJ;AkCn8IE;;;EACE,mBAAA;EACA,cAAA;AlCu8IJ;AkCz8IE;;;EAKI,eAAA;AlCy8IN;AkCjkJE;;;;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCykJJ;AkCtkJE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC4kJJ;AkC1kJI;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC2lJN;AkCvlJE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC6lJJ;AkC3lJI;;;;;;;;;;;;EAEE,yBAAA;EACA,mBAAA;AlCumJN;AkCrmJM;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCwoJR;AkCnjJE;;;EACE,mBAAA;EACA,cAAA;AlCujJJ;AkCzjJE;;;EAKI,eAAA;AlCyjJN;AkC5rJE;;;;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCosJJ;AkCjsJE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCusJJ;AkCrsJI;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCstJN;AkCltJE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCwtJJ;AkCttJI;;;;;;;;;;;;EAEE,yBAAA;EACA,mBAAA;AlCkuJN;AkChuJM;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCmwJR;AkCnqJE;;;EACE,mBAAA;EACA,cAAA;AlCuqJJ;AkCzqJE;;;EAKI,eAAA;AlCyqJN;AkCvzJE;;;;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlC+zJJ;AkC5zJE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCk0JJ;AkCh0JI;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCi1JN;AkC70JE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCm1JJ;AkCj1JI;;;;;;;;;;;;EAEE,yBAAA;EACA,mBAAA;AlC61JN;AkC31JM;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC83JR;AkCnxJE;;;EACE,uBAAA;EACA,cAAA;AlCuxJJ;AkCzxJE;;;EAKI,eAAA;AlCyxJN;AkCl7JE;;;;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;AlC07JJ;AkCv7JE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlC67JJ;AkC37JI;;;;;;;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlC48JN;AkCx8JE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlC88JJ;AkC58JI;;;;;;;;;;;;EAEE,yBAAA;EACA,uBAAA;AlCw9JN;AkCt9JM;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCy/JR;AkCp4JI;;;EACE,uBAAA;EACA,cAAA;AlCw4JN;AkC14JI;;;EAKI,eAAA;AlC04JR;AkC7iKE;;;;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;AlCqjKJ;AkCljKE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCwjKJ;AkCtjKI;;;;;;;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCukKN;AkCnkKE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCykKJ;AkCvkKI;;;;;;;;;;;;EAEE,yBAAA;EACA,uBAAA;AlCmlKN;AkCjlKM;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlConKR;AkCn/JE;;;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;AlCu/JJ;AkC1/JE;;;EAMI,eAAA;AlCy/JN;AkCzqKE;;;;;;;;;EAGE,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;AlCirKJ;AkC9qKE;;;;;;EAEE,cAAA;EACA,yBAAA;EACA,uBAAA;AlCorKJ;AkClrKI;;;;;;;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCmsKN;AkC/rKE;;;;;;EAEE,cAAA;EACA,yBAAA;EACA,uBAAA;AlCqsKJ;AkCnsKI;;;;;;;;;;;;EAEE,qBAAA;EACA,uBAAA;AlC+sKN;AkC7sKM;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCgvKR;AkCnmKE;;;EACE,uBAAA;EACA,cAAA;AlCumKJ;AkCzmKE;;;EAKI,eAAA;AlCymKN;AkCpyKE;;;;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,uCAAA;AlC4yKJ;AkCzyKE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlC+yKJ;AkC7yKI;;;;;;;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlC8zKN;AkC1zKE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCg0KJ;AkC9zKI;;;;;;;;;;;;EAEE,yBAAA;EACA,uBAAA;AlC00KN;AkCx0KM;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlC22KR;AkCntKE;;;EACE,UAAA;EACA,uBAAA;EACA,cAAA;AlCutKJ;AkC1tKE;;;EAMI,eAAA;AlCytKN;AkCh6KE;;;;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,uCAAA;AlCw6KJ;AkCr6KE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlC26KJ;AkCz6KI;;;;;;;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlC07KN;AkCt7KE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlC47KJ;AkC17KI;;;;;;;;;;;;EAEE,yBAAA;EACA,uBAAA;AlCs8KN;AkCp8KM;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlCu+KR;AkCn0KE;;;EACE,mBAAA;EACA,cAAA;AlCu0KJ;AkCz0KE;;;EAKI,eAAA;AlCy0KN;AkCt0KI;;;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AlC00KN;AkC90KI;;;EAOI,eAAA;AlC40KR;AkCxiLE;;;;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCgjLJ;AkC7iLE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCmjLJ;AkCjjLI;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCkkLN;AkC9jLE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCokLJ;AkClkLI;;;;;;;;;;;;EAEE,yBAAA;EACA,mBAAA;AlC8kLN;AkC5kLM;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC+mLR;AkCr7KE;;;EACE,mBAAA;EACA,cAAA;AlCy7KJ;AkC37KE;;;EAKI,eAAA;AlC27KN;AkCx7KI;;;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AlC47KN;AkCh8KI;;;EAOI,eAAA;AlC87KR;AkChrLE;;;;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCwrLJ;AkCrrLE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC2rLJ;AkCzrLI;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC0sLN;AkCtsLE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC4sLJ;AkC1sLI;;;;;;;;;;;;EAEE,yBAAA;EACA,mBAAA;AlCstLN;AkCptLM;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCuvLR;AkCviLE;;;EACE,mBAAA;EACA,cAAA;AlC2iLJ;AkC7iLE;;;EAKI,eAAA;AlC6iLN;AkC1iLI;;;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AlC8iLN;AkCljLI;;;EAOI,eAAA;AlCgjLR;AkCxzLE;;;;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCg0LJ;AkC7zLE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCm0LJ;AkCj0LI;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCk1LN;AkC90LE;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCo1LJ;AkCl1LI;;;;;;;;;;;;EAEE,yBAAA;EACA,mBAAA;AlC81LN;AkC51LM;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC+3LR;AkC1pLI;;;;;;;;;EAII,eAAA;AlCiqLR;AkC5pLE;;;;;;EAEE,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;AlCkqLJ;AkCvqLE;;;;;;EAQI,cAAA;EACA,eAAA;AlCuqLN;AkCv8LE;;;;;;;;;;;;;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,uCAAA;AlCw9LJ;AkCr9LE;;;;;;;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCi+LJ;AkC/9LI;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,uCAAA;AlCkgMN;AkC9/LE;;;;;;;;;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC0gMJ;AkCxgMI;;;;;;;;;;;;;;;;;;;;;;;;EAEE,yBAAA;EACA,mBAAA;AlCgiMN;AkC9hMM;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,uCAAA;AlCqmMR;AkCx2LE;;;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AlC22LN;AkCh3LE;;;EAQM,WAAA;EACA,YAAA;EACA,iBAAA;AlC62LR;AkCx2LE;;;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AlC22LN;AkCh3LE;;;EAQM,WAAA;EACA,YAAA;EACA,iBAAA;AlC62LR;AkCx2LE;;;EACE,mBAAA;AlC42LJ;AkC72LE;;;EAQI,QAAA;EACA,gBAAA;AlC02LN;AkCn3LE;;;EAKM,UAAA;AlCm3LR;AkC32LE;;;EACE,kBAAA;AlC+2LJ;AkCh3LE;;;EAQI,QAAA;EACA,iBAAA;AlC62LN;AkCt3LE;;;EAKM,UAAA;AlCs3LR;AkC92LE;;;;;;;;;EAEI,SAAA;AlCu3LN;AkCn3LE;;;EACE,UAAA;AlCu3LJ;AkCr3LI;;;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;AlCy3LN;AkC53LI;;;EAMI,gBAAA;EACA,eAAA;AlC23LR;AkCv3LI;;;EAME,gBAAA;EACA,gBAAA;EACA,eAAA;AlCs3LN;AkC93LI;;;EAEI,gBAAA;EACA,eAAA;AlCi4LR;AkCz3LI;;;EACE,gBAAA;EACA,gBAAA;AlC63LN;AkCz3LE;;;EAGM,UAAA;EACA,eAAA;AlC23LR;AkCt3LE;;;EAGM,YAAA;AlCw3LR;AkCn3LE;;;EACE,iBAAA;AlCu3LJ;AkCp3LE;;;EACE,UAAA;AlCw3LJ;AkCr3LE;;;EACE,cAAA;EACA,iBAAA;AlCy3LJ;AmCzxMA;EACE,UAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AnC2xMF;AmCzxMA;EACE,WAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AnC2xMF;AmCzxMA;EACE,mBAAA;EACA,kBAAA;AnC2xMF;AmCzxMA;EACE,mBAAA;EACA,kBAAA;AnC2xMF;AoC7yMA;EACE,kBAAA;ApC+yMF;AoC3yME;EACE,cAAA;ApC6yMJ;AoC9yME;EtC4PA,WAAA;EACA,YAAA;EACA,kBAAA;AEqjMF;AoC7yME;EACE,cAAA;ApC+yMJ;AoChzME;EtCsPA,WAAA;EACA,YAAA;EACA,kBAAA;AE6jMF;AoC/yME;EACE,cAAA;ApCizMJ;AoClzME;EtCgPA,WAAA;EACA,YAAA;EACA,kBAAA;AEqkMF;AoCp0MA;EAoBI,gBAAA;ApCmzMJ;AoCv0MA;EAsBM,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;ApCozMN;AoC70MA;EA6BI,YAAA;ApCmzMJ;AoCh1MA;EA+BM,YAAA;ApCozMN;AoCn1MA;EAiCQ,aAAA;ApCqzMR;AoCt1MA;EAoCQ,YAAA;EACA,aAAA;ApCqzMR;AoC11MA;EA0CI,WAAA;EACA,YAAA;EACA,eAAA;ApCmzMJ;AqCl1MA;EACE,cAAA;ArCo1MF;AqCh1MA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,4BAAA;EACA,aAAA;EACA,uCAAA;ArCk1MF;AqC/0ME;EAAA;IACE,kDAAA;ErCk1MF;AACF;AqC/0ME;EACE,0BAAA;EACA,wBAAA;EACA,8BAAA;ArCi1MJ;AqCp1ME;EAMI,WAAA;EACA,aAAA;EACA,gBAAA;ArCi1MN;AqC90ME;EACE,YAAA;ArCg1MJ;AqCl0MA;EAEI,8BAAA;EACA,YAAA;EACA,YAAA;ArCm0MJ;AqCv0MA;EAOI,sBAAA;ArCm0MJ;AqC10MA;;;EAUI,yBAAA;ArCq0MJ;AACA,WAAW;AqCj0MX;EACE,cAAA;EACA,kBAAA;EACA,aAAA;ArCm0MF;AqCt0MA;EAKI,WAAA;EACA,YAAA;ArCo0MJ;AqC10MA;EAQM,WAAA;EACA,YAAA;ArCq0MN;AqCl0ME;EACE,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,qBAAA;ArCo0MJ;AqCx0ME;EAMI,WAAA;EACA,YAAA;ArCq0MN;AqCn0MI;EACE,WAAA;EACA,YAAA;EACA,YAAA;ArCq0MN;AACA,WAAW;AqC/zMX;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8BAAA;ArCi0MF;AqCh0ME;EACE,eAAA;EACA,aAAA;ArCk0MJ;AqC10MA;EAWI,aAAA;EACA,aAAA;ArCk0MJ;AqC90MA;EAeI,gBAAA;ArCk0MJ;AqCnzMA;EACE;IAEE,wBAAA;ErC+zMF;EqC7zMA;IAEE,0BAAA;ErC+zMF;AACF;AqC7zMA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;ArC+zMF;AqC7zMA;EACE,iBAAA;EACA,kBAAA;ArC+zMF;AqC7zMA;EACE,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;ArC+zMF;AqC7zMA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;ArC+zMF;AqC9zME;EAAA;IACE,SAAA;IACA,UAAA;ErCi0MF;EqCn0MA;IAII,iBAAA;IACA,6BAAA;ErCk0MJ;AACF;AqC9zMA;EACE,mBAAA;ArCg0MF;AqC7zMA;;;EACE,mBAAA;ArCi0MF;AqCvxMA;EACE,aAAA;EACA,eAAA;ArCyxMF;AqCxxME;EACE,UAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;ArC0xMJ;AqCxxME;EACE,cAAA;ArC0xMJ;AqCxxME;EACE,SAAA;ArC0xMJ;AqCrxMA;EAEI,uBAAA;ArCsxMJ;AqCnxMA;EAEI,qBAAA;ArCoxMJ;AqCjxMA;EAEI,mBAAA;ArCkxMJ;AsC3hNA;EACE,aAAA;EAUA,cAAA;AtCohNF;AsC7hNE;EAAA;IACE,iDAAA;EtCgiNF;AACF;AsC/hNE;EACE,UAAA;AtCiiNJ;AsCviNA;EASI,mBAAA;AtCiiNJ;AsC7hNI;EAAA;IACE,iDAAA;EtCgiNJ;AACF;AsC7hNI;EAAA;IACE,iDAAA;EtCgiNJ;AACF;AsC7hNI;EAAA;IACE,iDAAA;EtCgiNJ;AACF;AsCzjNA;EA4BI,gBAAA;AtCgiNJ;AsC5jNA;EA+BI,gBAAA;AtCgiNJ;AsC/jNA;EAkCI,SAAA;AtCgiNJ;AsClkNA;EAqCI,mBAAA;AtCgiNJ;AsCrkNA;EAwCI,mBAAA;AtCgiNJ;AsCxkNA;EA2CI,mBAAA;AtCgiNJ;AsC3kNA;EA8CI,mBAAA;EAIA,yBAAA;AtC6hNJ;AsChiNI;EACE,mBAAA;AtCkiNN;AsC/hNI;EAAA;IACE,mBAAA;EtCkiNJ;AACF;AsCvlNA;EAwDI,mBAAA;EAIA,yBAAA;AtC+hNJ;AsCliNI;EACE,mBAAA;AtCoiNN;AsCjiNI;EAAA;IACE,mBAAA;EtCoiNJ;AACF;AsCnmNA;EAkEI,mBAAA;EAIA,yBAAA;AtCiiNJ;AsCpiNI;EACE,mBAAA;AtCsiNN;AsCniNI;EAAA;IACE,mBAAA;EtCsiNJ;AACF;AsCniNI;EAAA;IACE,iDAAA;EtCsiNJ;AACF;AsCziNE;EAKI,mBAAA;EACA,yBAAA;AtCuiNN;AsCtiNM;EAAA;IACE,mBAAA;EtCyiNN;AACF;AsCljNE;EAYI,mBAAA;EACA,yBAAA;AtCyiNN;AsCxiNM;EAAA;IACE,mBAAA;EtC2iNN;AACF;AsC3jNE;EAmBI,mBAAA;EACA,yBAAA;AtC2iNN;AsC1iNM;EAAA;IACE,mBAAA;EtC6iNN;AACF;AsC/oNA;EAsGI,SAAA;AtC4iNJ;AsC3iNI;EAAA;IACE,YAAA;EtC8iNJ;AACF;AsCvpNA;;EA4GI,aAAA;EACA,YAAA;AtC+iNJ;AsC9iNI;EAAA;;IACE,mBAAA;EtCkjNJ;AACF;AsClqNA;;EAkHM,YAAA;AtCojNN;AsC/iNA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AtCijNF;AsCpjNA;EAKI,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;AtCkjNJ;AsC1jNA;EAUM,qCAAA;EACA,WAAA;EAKA,+BAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,cAAA;EACA,oDAAA;EACA,mBAAA;EACA,eAAA;EACA,yCAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;AtC+iNN;AsChkNM;EACE,qCAAA;EACA,6CAAA;AtCkkNR;AsC9iNA;EACE,aAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,0CAAA;AtCgjNF;AsC/iNE;EAAA;IACE,wCAAA;IACA,iCAAA;IACA,wBAAA;EtCkjNF;AACF;AsC5jNA;EAYI,kBAAA;AtCmjNJ;AsC/jNA;EAeI,kBAAA;AtCmjNJ;AsClkNA;EAiBM,cAAA;EACA,cAAA;AtCojNN;AsCtkNA;EAqBM,aAAA;EACA,aAAA;AtCojNN;AsC/iNA;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,4DAAA;EACA,+DAAA;AtCijNF;AsCtjNA;EAOI,6BAAA;EACA,wDAAA;AtCkjNJ;AsC1jNA;EAUM,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,8BAAA;AtCmjNN;AsCjkNA;EAiBM,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,8BAAA;AtCmjNN;AuC1vNA;EACE,iBAAA;EACA,gBAAA;EACA,QAAA;EACA,YAAA;AvC4vNF;AuC3vNE;EACE;IACE,UAAA;EvC6vNJ;AACF;AACA,gBAAgB;AuCxvNhB;EACE,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EvC0vNA,SAAS;EACT,SAAS;EACT,SAAS;AACX;AuCrwNA;EAUI,sBAAA;EACA,4BAAA;AvC8vNJ;AuC5vNE;EAAA;IACE,aAAA;EvC+vNF;AACF;AuC9vNE;EAAA;IACE,mBAAA;IACA,cAAA;IACA,iBAAA;EvCiwNF;AACF;AuCrxNA;EAuBI,OAAA;EACA,MAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AvCiwNJ;AuChwNI;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,mBAAA;EACA,WAAA;AvCkwNN;AuChzNA;EAiDM,qBAAA;EACA,iBAAA;EACA,YAAA;AvCkwNN;AuCrzNA;EAqDQ,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;AvCmwNR;AuClwNQ;EACE,UAAA;EACA,mBAAA;AvCowNV;AuClwNQ;EACE,UAAA;EACA,mBAAA;AvCowNV;AuC10NA;EA2EM,iBAAA;AvCkwNN;AuC70NA;EA8EM,WAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AvCkwNN;AuCjwNM;EACE,gBAAA;AvCmwNR;AuCx1NA;EA2FI,QAAA;EACA,mBAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;AvCgwNJ;AuC/vNI;EAAA;IACE,QAAA;IACA,cAAA;EvCkwNJ;AACF;AuCz2NA;EAyGM,0BAAA;EACA,cAAA;AvCmwNN;AuC72NA;EA4GQ,oBAAA;AvCowNR;AuCh3NA;EA+GQ,yBAAA;AvCowNR;AuCn3NA;EAkHQ,cAAA;EACA,gBAAA;AvCowNR;AuCv3NA;;EAsHQ,cAAA;AvCqwNR;AuCpwNQ;;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gDAAA;AvCuwNV;AuCn4NA;EAoII,gBAAA;AvCkwNJ;AuCt4NA;EA0II,aAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;AvC+vNJ;AuC54NA;EA+IM,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,2BAAA;AvCgwNN;AuCl5NA;EAoJQ,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;AvCiwNR;AuCz5NA;EA2JQ,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AvCiwNR;AuC/5NA;EAiKQ,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AvCiwNR;AuCr6NA;EA2KI,aAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;AvC6vNJ;AuC56NA;EAiLM,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AvC8vNN;AuCl7NA;EAuLM,WAAA;EACA,eAAA;EACA,iBAAA;AvC8vNN;AuCv7NA;EA+LI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;AvC2vNJ;AuCj8NA;EFwCE,UAAA;EACA,WAAA;EACA,kBAAA;EAEA,yBAAA;EACA,0BAAA;EE4JI,qBAAA;EACA,sBAAA;EACA,cAAA;AvCgwNN;AuC/vNM;EACE,WAAA;EFtKN,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EAEA,yBAAA;EACA,6BAAA;ArCu6NF;AuCpwNM;EACE,WAAA;EF1KN,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EAEA,yBAAA;EACA,4BAAA;ArCg7NF;AACA,kBAAkB;AuCrwNlB;;EACE,eAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;AvCwwNF;AuCvwNE;EAAA;;IACE,aAAA;EvC2wNF;AACF;AuCxxNA;;EAeI,UAAA;EACA,kBAAA;AvC6wNJ;AuC7xNA;;EAmBQ,UAAA;EACA,eAAA;AvC8wNR;AuClyNA;;EAyBI,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;AvC6wNJ;AuC9yNA;;EAoCI,iBAAA;AvC8wNJ;AuC3wNA;EACE,mBAAA;EACA,yBAAA;EACA,2CAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EAIA,cAAA;AvC0wNF;AuC7wNE;EAAA;IACE,iBAAA;EvCgxNF;AACF;AuCzxNA;EAYI,cAAA;AvCgxNJ;AuC5xNA;EAeI,aAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;AvCgxNJ;AuCryNA;EAuBM,UAAA;EACA,eAAA;EACA,iBAAA;AvCixNN;AuC1yNA;EA4BM,kBAAA;AvCixNN;AuC/wNI;EACE,mBAAA;AvCixNN;AuC/wNI;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AvCixNN;AuC1xNI;EAWI,UAAA;EACA,eAAA;EACA,iBAAA;AvCkxNR;AuC/wNI;EAEI,UAAA;EACA,eAAA;EACA,iBAAA;AvCgxNR;AuCr0NA;EA0DI,aAAA;EACA,aAAA;EACA,WAAA;AvC8wNJ;AuC10NA;EA8DM,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AvC+wNN;AuC9wNM;EACE,gBAAA;AvCgxNR;AuCp1NA;EAuEQ,eAAA;AvCgxNR;AuC7wNI;EAAA;IACE,aAAA;EvCgxNJ;AACF;AuC51NA;EA+EI,aAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;AvCgxNJ;AuCl2NA;EAqFI,cAAA;EACA,iBAAA;AvCgxNJ;AuC9wNE;EACE,YAAA;AvCgxNJ;AuC/wNI;EAAA;IACE,kBAAA;IACA,UAAA;IACA,gBAAA;IACA,QAAA;EvCkxNJ;AACF;AuChxNE;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AvCkxNJ;AuChxNE;EACE,eAAA;EACA,SAAA;EACA,OAAA;EACA,0BAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;AvCkxNJ;AuCjxNI;EAAA;IACE,gBAAA;EvCoxNJ;AACF;AACA,kBAAkB;AuChxNlB;EAEI,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;AvCixNJ;AuC9wNA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;AvCgxNF;AuC7wNA;EzCzJE,WAAA;EACA,YAAA;EACA,kBAAA;EyC2JA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AvC+wNF;AuC9wNE;EACE,mBAAA;AvCgxNJ;AuC9wNE;EACE,mBAAA;AvCgxNJ;AuC5wNA;EACE,cAAA;AvC8wNF;AuC/wNA;EAGI,eAAA;EACA,yBAAA;EACA,cAAA;AvC+wNJ;AuC7wNE;EACE;IACE,WAAA;EvC+wNJ;AACF;AwCnsOA;EACE,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AxCqsOF;AwC3sOA;EAQI,aAAA;EACA,aAAA;AxCssOJ;AwC/sOA;EAYI,iBAAA;EACA,WAAA;AxCssOJ;AwCnsOA;EAGM,iBAAA;AxCmsON;AwCtsOA;EAMM,aAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AxCmsON;AwC5sOA;EAWQ,kBAAA;EACA,iBAAA;AxCosOR;AwChtOA;EAcU,aAAA;EACA,8BAAA;EACA,mBAAA;AxCqsOV;AwCrtOA;EAkBY,gBAAA;EACA,WAAA;AxCssOZ;AwCztOA;EAuBU,aAAA;EACA,yBAAA;EACA,kBAAA;AxCqsOV;AwC9tOA;EA6BQ,gBAAA;AxCosOR;AwCjuOA;EA+BU,iBAAA;AxCqsOV;AwCpuOA;EAmCQ,aAAA;EACA,2BAAA;AxCosOR;AwCxuOA;EAsCU,qBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AxCqsOV;AwCnvOA;EAgDY,cAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AxCssOZ;AwCzvOA;EAsDY,kBAAA;EACA,iBAAA;AxCssOZ;AwC7vOA;EA8DI,mBAAA;EACA,aAAA;AxCksOJ;AwCjwOA;EAkEI,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AxCksOJ;AwCvwOA;EAuEM,qBAAA;EACA,gBAAA;EACA,gBAAA;AxCmsON;AwC5wOA;EA6EI,kBAAA;EACA,gBAAA;EACA,mBAAA;AxCksOJ;AwCjxOA;EAkFM,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AxCksON;AwC3xOA;EA2FQ,eAAA;EACA,cAAA;AxCmsOR;AwC/xOA;EA+FQ,WAAA;AxCmsOR;AwCjsOM;EACE,6BAAA;EACA,cAAA;AxCmsOR;AwCtyOA;EAwGI,kBAAA;AxCisOJ;AwCzyOA;EA0GM,aAAA;EACA,aAAA;AxCksON;AwC7yOA;EA8GM,WAAA;EACA,gBAAA;AxCksON;AwCjzOA;;;EAmHI,aAAA;EACA,sBAAA;AxCmsOJ;AwCvzOA;;;EAsHM,gBAAA;EACA,gBAAA;EACA,oBAAA;AxCssON;AwC9zOA;EA4HI,WAAA;AxCqsOJ;AwCj0OA;EA8HM,gCAAA;AxCssON;AwCp0OA;;EAiIM,gBAAA;EACA,iBAAA;AxCusON;AwCz0OA;;EAqIM,gBAAA;AxCwsON;AwC70OA;EAyII,kBAAA;AxCusOJ;AwCnsOA;EACE,YAAA;EACA,WAAA;AxCqsOF;AwCnsOA;EACE,yBAAA;AxCqsOF;AwCtsOA;EAGI,YAAA;AxCssOJ;AwCzsOA;EAOM,gBAAA;AxCqsON;AwC5sOA;EAUM,gBAAA;AxCqsON;AwChsOA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AxCksOF;AwCjsOE;EACE,iBAAA;EACA,cAAA;AxCmsOJ;AwCjsOE;EACE,iBAAA;EACA,cAAA;AxCmsOJ;AwC9sOA;EAcI,WAAA;AxCmsOJ;AwC/rOA;EACE,SAAA;AxCisOF;AwC9rOA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EAAA,cAAA;EAAA,4BAAA;EAIA,gBAAA;EACA,WAAA;AxC6rOF;AwCjsOE;EACE,YAAA;EAAA,cAAA;EAAA,4BAAA;AxCmsOJ;AwC1sOA;EAYI,eAAA;EACA,aAAA;AxCisOJ;AwC9sOA;EAgBI,aAAA;EACA,sBAAA;AxCisOJ;AwCltOA;EAmBM,SAAA;AxCksON;AwCrtOA;EAsBM,cAAA;EACA,gBAAA;AxCksON;AwCztOA;EA0BM,eAAA;EACA,gBAAA;AxCksON;AwC7tOA;EA8BM,kBAAA;AxCksON;AwCvrOA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EAIA,YAAA;EACA,oBAAA;AxCsrOF;AwC1rOE;EAAA;IACE,YAAA;ExC6rOF;AACF;AwCnsOA;EAUI,cAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AxC4rOJ;AwCzsOA;EAeM,eAAA;EACA,cAAA;EACA,UAAA;AxC6rON;AwC9sOA;EAqBI,aAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AxC4rOJ;AwCttOA;EA6BI,yBAAA;EACA,eAAA;EACA,cAAA;AxC4rOJ;AwC3tOA;EAkCI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AxC4rOJ;AwCxrOA;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EAIA,kBAAA;EACA,mBAAA;EACA,uBAAA;AxCurOF;AwC5rOE;EAAA;IACE,cAAA;ExC+rOF;AACF;AwCxsOA;EAcI,aAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,+BAAA;AxC6rOJ;AwChtOA;EAsBI,eAAA;EACA,kBAAA;EACA,cAAA;AxC6rOJ;AwCrtOA;EA2BI,iBAAA;EACA,eAAA;EACA,cAAA;AxC6rOJ;AwCzrOA;EAEI,iBAAA;AxC0rOJ;AwCtrOA;EAEI,gBAAA;AxCurOJ;AwCzrOA;EAKI,iBAAA;AxCurOJ;AwCnrOA;EACE,iBAAA;AxCqrOF;AwClrOA;EAEI,iBAAA;AxCmrOJ;AwCrrOA;EAKI,cAAA;EACA,eAAA;EACA,kCAAA;AxCmrOJ;AwC1rOA;EASM,cAAA;AxCorON;AwCnrOM;EAAA;IACE,YAAA;IAAA,cAAA;IAAA,4BAAA;IACA,2BAAA;ExCsrON;AACF;AwCjrOA;EACE,cAAA;EACA,gBAAA;AxCmrOF;AwCrrOA;EAII,iBAAA;AxCorOJ;AwCxrOA;EAOI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;AxCorOJ;AwChsOA;E1C7FE,YAAA;EACA,aAAA;EACA,kBAAA;E0C0GI,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AxCurON;AwC3sOA;EAsBQ,YAAA;AxCwrOR;AwC9sOA;EA0BM,aAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;AxCurON;AwCtrOM;EAAA;IACE,SAAA;IACA,iBAAA;ExCyrON;AACF;AwC1tOA;EAmCQ,cAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,MAAA;AxC0rOR;AwCluOA;EA0CU,eAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AxC2rOV;AwC1rOU;EACE,0BAAA;EACA,eAAA;AxC4rOZ;AwChvOA;EAwDU,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AxC2rOV;AwCtvOA;EA8DU,eAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AxC2rOV;AwCzrOQ;EACE,cAAA;AxC2rOV;AwCzrOQ;EACE,cAAA;AxC2rOV;AwCzrOQ;EACE,cAAA;AxC2rOV;AwCzrOQ;EACE,cAAA;AxC2rOV;AwCzrOQ;EACE,cAAA;AxC2rOV;AwCzrOQ;EACE,cAAA;AxC2rOV;AwCprOA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AxCsrOF;AwCnrOA;EACE,gBAAA;AxCqrOF;AwCtrOA;EAGI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;AxCsrOJ;AwC9rOA;E1CjME,YAAA;EACA,aAAA;EACA,kBAAA;E0C0MI,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AxCyrON;AwC1sOA;EAmBQ,YAAA;AxC0rOR;AwC7sOA;EAuBM,aAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;AxCyrON;AwCxrOM;EAAA;IACE,SAAA;IACA,iBAAA;ExC2rON;AACF;AwCztOA;EAgCQ,cAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,MAAA;AxC4rOR;AwCjuOA;EAuCU,eAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AxC6rOV;AwC5rOU;EACE,0BAAA;EACA,eAAA;AxC8rOZ;AwC/uOA;EAqDU,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AxC6rOV;AwCrvOA;EA2DU,eAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AxC6rOV;AwC3rOQ;EACE,cAAA;AxC6rOV;AwC3rOQ;EACE,cAAA;AxC6rOV;AwC3rOQ;EACE,cAAA;AxC6rOV;AwC3rOQ;EACE,cAAA;AxC6rOV;AwC3rOQ;EACE,cAAA;AxC6rOV;AwC3rOQ;EACE,cAAA;AxC6rOV;AwCtrOA;EACE,eAAA;EACA,+BAAA;AxCwrOF;AwC1rOA;EAII,eAAA;AxCyrOJ;AwC7rOA;EAMM,eAAA;AxC0rON;AwChsOA;EAUI,iBAAA;AxCyrOJ;AwCrrOA;EAEI,+BAAA;AxCsrOJ;AwCxrOA;EAIM,aAAA;EACA,mBAAA;AxCurON;AwC5rOA;EAOQ,kBAAA;AxCwrOR;AwClrOA;EACE,uBAAA;AxCorOF;AwCjrOA;EACE,sBAAA;AxCmrOF;AwCprOA;EAGI,YAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;AxCorOJ;AwC3rOA;EASM,aAAA;AxCqrON;AwC9rOA;EAaI,gBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;AxCorOJ;AwCvsOA;EAsBI,cAAA;AxCorOJ;AwC1sOA;;EAyBI,cAAA;EACA,gBAAA;EACA,SAAA;AxCqrOJ;AyC5wPA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,+BAAA;EACA,YAAA;EACA,WAAA;EACA,mCAAA;AzC8wPF;AyCxxPA;EAYI,4BAAA;AzC+wPJ;AyC3xPA;EAeI,qBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AzC+wPJ;AyClyPA;EAsBI,aAAA;EACA,eAAA;AzC+wPJ;AyCtyPA;EA0BI,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AzC+wPJ;AyClzPA;EAqCM,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;AzCgxPN;AyCzzPA;EA4CM,cAAA;EACA,aAAA;EACA,uBAAA;EACA,cAAA;AzCgxPN;AyC/zPA;EAmDI,gBAAA;EACA,eAAA;AzC+wPJ;AyCn0PA;EAuDI,SAAA;EACA,gBAAA;EACA,eAAA;AzC+wPJ;AyCx0PA;EA2DM,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AzCgxPN;AyC/0PA;EAiEQ,aAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AzCixPR;AyCv1PA;EAwEU,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,uCAAA;E3CoLR,WAAA;EACA,YAAA;EACA,kBAAA;AE6lPF;AyCh2PA;EAiFU,cAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AzCkxPV;AyCx2PA;EA0FQ,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kCAAA;AzCixPR;AyCj3PA;EAmGQ,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,sCAAA;AzCixPR;AyC13PA;EA2GU,cAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AzCkxPV;AyC9wPI;EAEI,cAAA;AzC+wPR;AyCjxPI;EAKI,mBAAA;AzC+wPR;AyC5wPI;EAEI,cAAA;AzC6wPR;AyC/wPI;EAKI,mBAAA;AzC6wPR;AyCzwPM;EAEI,wBAAA;AzC0wPV;AyCl5PA;EA8II,gBAAA;EACA,kBAAA;AzCuwPJ;AyCt5PA;EAiJM,gBAAA;EACA,eAAA;AzCwwPN;AyC15PA;EAkKI,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;AzC2vPJ;AyCt6PA;EAuJM,mBAAA;EACA,kBAAA;EACA,cAAA;AzCkxPN;AyC36PA;EA2JQ,eAAA;AzCmxPR;AyC96PA;EA6JU,eAAA;EACA,gBAAA;AzCoxPV;AyCnwPA;EAGM,+BAAA;AzCmwPN;AyC/vPQ;EACE,YAAA;AzCiwPV;AyCzwPA;EAWU,UAAA;EACA,mBAAA;AzCiwPV;AyC7wPA;EAeU,UAAA;EACA,mBAAA;AzCiwPV;AyC1vPA;EACE;IACE,YAAA;IACA,SAAA;IACA,2BAAA;IACA,cAAA;IACA,+BAAA;EzC4vPF;EyCjwPA;IAOI,sCAAA;IACA,mBAAA;EzC6vPJ;EyC1vPA;IACE,aAAA;EzC4vPF;EyC1vPA;IACE,+BAAA;EzC4vPF;EyC7vPA;IAGI,WAAA;EzC6vPJ;EyChwPA;IAKM,UAAA;IACA,gBAAA;IACA,WAAA;IACA,cAAA;EzC8vPN;EyCtwPA;IAWM,aAAA;EzC8vPN;EyC1vPA;IACE,+BAAA;EzC4vPF;EyC7vPA;IAGI,gBAAA;EzC6vPJ;EyC1vPI;IACE,YAAA;EzC4vPN;AACF;A0Cx+PA;EACE,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,UAAA;EAIA,SAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,8BAAA;EACA,gBAAA;A1Cu+PF;A0C/+PE;EAAA;IACE,UAAA;E1Ck/PF;AACF;A0C3+PE;EACE,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;A1C6+PJ;A0ClgQA;EAwBI,YAAA;A1C6+PJ;A0C1+PE;EACE,QAAA;A1C4+PJ;A0C1+PE;EACE,YAAA;A1C4+PJ;A0C3+PI;EACE,WAAA;A1C6+PN;A0C1+PE;EACE,YAAA;A1C4+PJ;A0C3+PI;EACE,WAAA;A1C6+PN;AACA,UAAU;A2CrhQV;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;EACA,cAAA;A3CuhQF;A2CphQA;EACE,UAAA;A3CshQF;A2CnhQA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;A3CqhQF;A2C3hQA;EASI,kBAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;A3CqhQJ;A2CnhQI;EAAA;IACE,cAAA;E3CshQJ;AACF;A2CphQI;EAAA;IACE,cAAA;E3CuhQJ;AACF;A2CpjQA;EAgCM,yBAAA;EACA,8CAAA;EACA,gBAAA;A3CuhQN;A2CzjQA;EAqCQ,SAAA;A3CuhQR;A2C5jQA;EAwCU,aAAA;EACA,uBAAA;A3CuhQV;A2ChkQA;EA6CU,aAAA;EACA,uBAAA;EACA,aAAA;A3CshQV;A2ChhQM;EACE,kBAAA;EACA,QAAA;EACA,UAAA;A3CkhQR;A2C/gQM;EACE,cAAA;A3CihQR;A2C7kQA;EAkEI,kBAAA;EACA,eAAA;EACA,mBAAA;A3C8gQJ;A2CllQA;EAwEI,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;A3C6gQJ;A2CzgQA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,kDAAA;EACA,yBAAA;A3C2gQF;A2CzgQE;EACE,cAAA;A3C2gQJ;A2CzhQA;EAkBI,YAAA;A3C0gQJ;A2C5hQA;EAsBM,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;A3CygQN;A2CniQA;EA6BQ,YAAA;EACA,gCAAA;A3CygQR;A2CviQA;EAiCU,iBAAA;A3CygQV;A2C1iQA;E3C4iQE,oBAAoB;E2CtgQZ,eAAA;EACA,gBAAA;A3CwgQV;A2C/iQA;E3CijQE,4BAA4B;E2CrgQpB,eAAA;EACA,gBAAA;A3CugQV;A2CpjQA;E3CsjQE,wBAAwB;E2CpgQhB,eAAA;EACA,gBAAA;A3CsgQV;A2CzjQA;E3C2jQE,0BAA0B;E2CngQlB,eAAA;EACA,gBAAA;A3CqgQV;A2C9jQA;EA6DU,aAAA;A3CogQV;A2CjkQA;EAgEY,YAAA;A3CogQZ;A2CpkQA;EAsEQ,cAAA;A3CigQR;A2CvkQA;EAyEU,UAAA;A3CigQV;A2C1kQA;EA4EY,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;A3CigQZ;A2C//PY;EACE,eAAA;EACA,yBAAA;A3CigQd;A2C9/PY;EACE,yBAAA;A3CggQd;A4CzrQA;EACE,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gCAAA;EACA,QAAA;EACA,wCAAA;A5C2rQF;A4CpsQA;EAWI,YAAA;A5C4rQJ;A4ChrQA;EAEI,gBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kDAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;A5CgrQJ;A4CzrQA;EAWM,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;A5CirQN;A4ChrQM;EACE,0BAAA;A5CkrQR;A4ChrQM;EACE,0BAAA;A5CkrQR;A4CjrQQ;;EACE,0BAAA;A5CorQV;A4C5sQA;EA4BQ,YAAA;EACA,gBAAA;A5CmrQR;A4ChtQA;EAgCQ,kBAAA;A5CmrQR;A4CjrQM;EACE,aAAA;EACA,qBAAA;EACA,mBAAA;A5CmrQR;A4CtrQM;EAKI,aAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;A5CorQV;A4C9rQM;EAaI,iBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;A5CorQV;A4CpsQM;EAkBM,eAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;A5CqrQZ;A4C1sQM;EAyBI,aAAA;EACA,kBAAA;EACA,kDAAA;EACA,MAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;A5CorQV;A4CntQM;EAiCM,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kDAAA;EACA,kBAAA;EACA,gBAAA;A5CqrQZ;A4C5tQM;EA0CM,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,6CAAA;A5CqrQZ;A4CprQY;EACE,mBAAA;A5CsrQd;A4C/qQE;EACE,iBAAA;EACA,kBAAA;A5CirQJ;A4C/qQE;EACE,iBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,kCAAA;A5CirQJ;A6C/yQA;EACE,kBAAA;EACA,aAAA;EACA,qCAAA;EAGA,4BAAA;EAIA,kBAAA;EACA,mBAAA;EACA,gEAAA;EACA,OAAA;EACA,QAAA;EACA,8BAAA;EACA,aAAA;A7C4yQF;A6CrzQE;EAAA;IACE,0BAAA;E7CwzQF;AACF;A6ChzQE;EACE,8BAAA;A7CkzQJ;A6C/yQA;EACE,eAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;A7CizQF;A6CrzQA;EAMI,aAAA;EACA,4BAAA;EACA,0BAAA;EACA,8BAAA;EACA,aAAA;EAIA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;A7C+yQJ;A6CrzQI;EAAA;IACE,aAAA;E7CwzQJ;AACF;A6Cr0QA;EAmBM,kBAAA;EACA,YAAA;A7CqzQN;A6CpzQM;;EACE,+BAAA;A7CuzQR;A6CjzQA;EAEI,eAAA;A7CkzQJ;A6CpzQA;EAKQ,aAAA;EACA,8BAAA;EACA,mBAAA;A7CkzQR;A6CzzQA;EASU,cAAA;A7CmzQV;A6C5zQA;EAYU,mBAAA;EACA,yBAAA;A7CmzQV;A6Ch0QA;EAeY,cAAA;EACA,kBAAA;A7CozQZ;A6Cp0QA;EAkBc,yBAAA;A7CqzQd;A6Cv0QA;EAwBQ,YAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,yDAAA;EACA,wBAAA;EACA,kCAAA;EACA,4BAAA;EACA,kBAAA;A7CkzQR;A6Cl1QA;EAmCQ,YAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,yDAAA;EACA,wBAAA;EACA,kCAAA;EACA,4BAAA;EACA,kBAAA;A7CkzQR;A6C71QA;EA8CQ,YAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,yDAAA;EACA,wBAAA;EACA,kCAAA;EACA,4BAAA;EACA,kBAAA;A7CkzQR;A6C5yQA;EAEI,2BAAA;A7C6yQJ;A8Cv4QA;EACC,cAAA;EACA,aAAA;EACA,SAAA;A9Cy4QD;A8Cv4QA;EACC,iBAAA;EACA,oBAAA;EAGA,kBAAA;EACA,eAAA;A9Cy4QD;A8Cv4QA;EACC,mBAAA;A9Cy4QD;A8Ct4QC;EACC,SAAA;EACA,UAAA;A9Cw4QF;A8Cr4QA;EAEC,sBAAA;EACA,YAAA;EAGA,aAAA;EAIA,sBAAA;EAGA,oBAAA;A9Cu4QD;A8Cp5QA;EAgBE,mBAAA;A9Cw4QF;A8Cv4QE;EAEC,mBAAA;A9Cy4QH;A8Cv4QE;EAEC,mBAAA;A9Cy4QH;A8Cr4QA;EACC,mBAAA;A9Cu4QD;A8Cr4QA;EACC,YAAA;A9Cu4QD;A8Cr4QA;EACC,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;A9Cu4QD;A8Cr4QA;EAEC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EAGA,aAAA;EAIA,mBAAA;EAGA,SAAA;EACA,gBAAA;EACA,UAAA;A9Cs4QD;A8Cp4QA;EACC,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A9Cs4QD;A8Cp4QA;EACC,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;A9Cs4QD;A8Cr4QC;EACC,cAAA;A9Cu4QF;A8Cr4QC;EACC,cAAA;A9Cu4QF;A8Cp4QA;EAOC,sBAAA;A9Cg4QD;A8Cv4QA;EAEE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A9Cw4QF;A8Cp4QA;EACC,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A9Cs4QD;A8Cp4QA;EACC,cAAA;A9Cs4QD;A8Cp4QE;EACC,oBAAA;EACA,+BAAA;A9Cs4QH;A8Ch4QI;EACC,kBAAA;EACA,yBAAA;EACA,4BAAA;A9Ck4QL;A8C93QI;EACC,kBAAA;EACA,0BAAA;EACA,6BAAA;A9Cg4QL;A8C33QG;EACC,cAAA;EACA,kBAAA;A9C63QJ;A8Cx3QE;EACC,oBAAA;EACA,+BAAA;A9C03QH;A8Cl3QM;EACC,oBAAA;EACA,+BAAA;A9Co3QP;A8Cj6QA;EAqDM,iBAAA;A9C+2QN;A8Cp6QA;EA4DE,qBAAA;A9C22QF;A8Cv6QA;EA+DE,oBAAA;A9C22QF;A8Cv2QG;EAEE,oBAAA;EACA,+BAAA;A9Cw2QL;A8Cl2QA;EACC,cAAA;A9Co2QD;A8Cl2QA;EACC,mBAAA;A9Co2QD;A8Cl2QA;EACC,gBAAA;EAGA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACG,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;A9Co2QJ;A8Cj3QA;EAeE,cAAA;EACA,qBAAA;A9Cq2QF;A8Cp2QE;EACC,cAAA;EACA,qBAAA;A9Cs2QH;A8Cp2QE;EACC,cAAA;EACA,qBAAA;A9Cs2QH;A8Cl2QA;EACI,cAAA;EACA,gBAAA;EACH,gBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;A9Co2QD;A8Cl2QA;EACC,kBAAA;EAGA,iBAAA;EACA,yBAAA;EACA,UAAA;A9Co2QD;A8Cl2QA;EAGC,aAAA;EAIA,sBAAA;EACA,YAAA;A9Co2QD;A8C52QA;EAUE,YAAA;EACA,kBAAA;EAGA,wBAAA;EACA,qBAAA;A9Cm2QF;A8Cl2QE;EACC,aAAA;A9Co2QH;A8Ch2QA;EACC,yBAAA;A9Ck2QD;A8Ch2QA;EAGC,aAAA;EAEA,eAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;A9Ck2QD;A8C92QA;EAgBE,YAAA;EACA,eAAA;EACA,kBAAA;EACM,gBAAA;EACA,cAAA;A9Cm2QR;A8Ch2QA;EACC,qBAAA;EACA,mBAAA;A9Ck2QD;A8C/1QG;EACC,0BAAA;EACA,6BAAA;A9Ci2QJ;A8C71QG;EACC,yBAAA;EACA,4BAAA;A9C+1QJ;A8C31QG;EACC,gBAAA;A9C61QJ;A8Cx1QE;EACC,iBAAA;A9C01QH;A8Cv1QC;EACC,iBAAA;A9Cy1QF;A8Cv1QC;EACC,iBAAA;A9Cy1QF;A8Ct1QA;EACC,YAAA;EAEA,sBAAA;EAEA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACG,eAAA;A9Cw1QJ;A8Ct1QA;EA4CC,kBAAA;A9C6yQD;A8Cz1QA;EAEE,YAAA;EAEA,sBAAA;EAEA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EAGA,aAAA;EACA,gBAAA;EACA,gBAAA;EAIA,sBAAA;EAGA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;A9C01QF;A8Cz1QE;EACC,yBAAA;A9C21QH;A8C33QA;EAqCG,eAAA;EACA,oBAAA;A9Cy1QH;A8C/3QA;EA0CE,yBAAA;A9Cw1QF;A8Cl4QA;EA8CE,SAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;A9Cu1QF;A8C14QA;EAqDG,iBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;A9Cw1QH;A8Cr5QA;EA+DI,gBAAA;EACA,cAAA;A9Cy1QJ;A8Cz5QA;EAkEK,kBAAA;EACK,MAAA;EACA,QAAA;A9C01QV;A8C95QA;EAwEI,gBAAA;EACA,cAAA;A9Cy1QJ;A8Cl6QA;EA2EK,oBAAA;EACA,eAAA;A9C01QL;A8Ct6QA;EAkFE,UAAA;EACA,QAAA;A9Cu1QF;A8C16QA;EAwFE,aAAA;EACA,gBAAA;EACA,gBAAA;EAIA,sBAAA;EAGA,uBAAA;EACA,gBAAA;EACA,kBAAA;A9Cu1QF;A8C17QA;EAwGE,UAAA;EACA,kBAAA;EACA,WAAA;A9Cu1QF;A8Cj8QA;EA6GE,WAAA;EAGA,SAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;A9Cu1QF;A8C38QA;EAuHE,6BAAA;A9Cu1QF;A8Cp1QA;EAWC,YAAA;A9C40QD;A8Cv1QA;EAEE,eAAA;EACA,oBAAA;A9Cw1QF;A8C31QA;EAOG,eAAA;EACA,oBAAA;A9Cu1QH;A8Cl1QA;EACC,yBAAA;A9Co1QD;A8Cl1QA;EAEC,kDAAA;A9Co1QD;A8Cl1QA;EACC,yBAAA;EACA,4BAAA;A9Co1QD;A8Cl1QA;EACC,0BAAA;EACA,6BAAA;A9Co1QD;A8Cl1QA;EACC,yBAAA;EACA,0BAAA;A9Co1QD;A8Cl1QA;EACC,4BAAA;EACA,6BAAA;A9Co1QD;A8Cl1QA;EAGC,aAAA;EAIA,mBAAA;A9Co1QD;A8Cl1QA;EACC,oCAAA;A9Co1QD;A8Cl1QA;EACC,kBAAA;EACA,yBAAA;EAGA,aAAA;EAIA,sBAAA;EAGA,SAAA;EACA,WAAA;EAGA,iBAAA;EACA,yBAAA;EACA,YAAA;A9Co1QD;A8Cl1QA;EAGC,aAAA;EAIA,mBAAA;A9Co1QD;A8Cl1QA;EAGC,aAAA;EACA,kBAAA;EAIA,sBAAA;EAGA,SAAA;EAEA,eAAA;EACA,gBAAA;EACA,YAAA;A9Co1QD;A8Cn1QC;EACC,6BAAA;A9Cq1QF;A8Cl1QA;EAGC,SAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;A9Co1QD;A8C11QA;EAQE,cAAA;EACA,qBAAA;A9Cq1QF;A8Cp1QE;EACC,cAAA;EACA,qBAAA;A9Cs1QH;A8Cp1QE;EACC,cAAA;EACA,qBAAA;A9Cs1QH;A8Cl1QA;EACC,iBAAA;A9Co1QD;A8Cl1QA;EAGC,SAAA;A9Co1QD;A8Cn1QC;EACC,8BAAA;A9Cq1QF;A8Cl1QA;EACC,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,sBAAA;EAEA,0CAAA;EACA,aAAA;A9Co1QD;A8Cl1QE;EACC,eAAA;A9Co1QH;A8Ch1QA;EACC,gCAAA;EACA,6BAAA;EACA,iBAAA;A9Ck1QD;A8Ch1QA;EAGC,aAAA;EAIA,sBAAA;EAGA,SAAA;EACA,cAAA;A9Ck1QD;A8C71QA;EAaE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,yBAAA;A9Cm1QF;A8Cn2QA;EAoBK,iBAAA;EACA,mBAAA;A9Ck1QL;A8Cj1QK;EACC,8BAAA;A9Cm1QN;A8Ch1QI;EACC,6BAAA;A9Ck1QL;A8C72QA;EAgCG,kBAAA;EACA,mBAAA;EACA,yBAAA;A9Cg1QH;A8Cl3QA;EAuCK,gBAAA;EACA,gBAAA;EACA,gCAAA;A9C80QL;A8Cx0QA;EACC,yBAAA;EACA,mBAAA;A9C00QD;A8Cx0QE;EACC,aAAA;A9C00QH;A8Ct0QE;EACC,aAAA;A9Cw0QH;A8Cp0QA;EACC,mBAAA;A9Cs0QD;A8Cp0QA;EACC,WAAA;A9Cs0QD;A8Cp0QA;EAGC,aAAA;EAIA,sBAAA;EACA,gBAAA;A9Cs0QD;A8C90QA;EAYE,SAAA;A9Cu0QF;A8Cp0QA;EACC,gCAAA;EACA,gBAAA;EAGA,aAAA;EAIA,wBAAA;A9Cs0QD;A8Cp0QA;EAGC,UAAA;A9Cs0QD;A8Cp0QA;EAGC,UAAA;A9Cs0QD;A8Cp0QA;EACC,cAAA;A9Cs0QD;A8Cp0QA;EAEE,gBAAA;EACA,OAAA;EACA,uBAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;A9Cq0QF;A8C50QA;EAUE,gBAAA;EACA,OAAA;EACA,uBAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;A9Cq0QF;A8Cp1QA;EAkBE,gBAAA;A9Cq0QF;A8Cv1QA;EAqBE,eAAA;EAGA,SAAA;EAEA,eAAA;A9Cq0QF;A8C/1QA;EA6BE,aAAA;A9Cq0QF;A8Cl2QA;EAgCE,gBAAA;A9Cq0QF;A8Cr2QA;EAmCE,YAAA;EAGA,SAAA;EAEA,gBAAA;A9Cq0QF;A8C72QA;EA2CE,YAAA;EAGA,SAAA;EAEA,gBAAA;A9Cq0QF;A8Cl0QA;EAMC,SAAA;EAGA,aAAA;EACA,YAAA;EAIA,sBAAA;A9Ci0QD;A8C90QC;EACC,iBAAA;A9Cg1QF;A8Cl1QA;EAgBE,gCAAA;EAEA,cAAA;A9Cq0QF;A8Cl0QA;EACI,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EAGH,SAAA;A9Co0QD;A8Cl0QA;EACC,iBAAA;A9Co0QD;A8Cl0QA;EACC,kBAAA;A9Co0QD;A8Cl0QA;EACC,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;A9Co0QD;A8Cl0QA;EAGC,aAAA;EAIA,sBAAA;EAGA,SAAA;EACA,WAAA;EACA,aAAA;A9Co0QD;A8Ch1QA;EAcE,mBAAA;EACA,iBAAA;A9Cq0QF;A8Cp1QA;EAmBE,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACM,aAAA;A9Cq0QR;A8Cp0QE;EACC,8BAAA;A9Cs0QH;A8C/1QA;EA6BE,kBAAA;EACA,UAAA;A9Cq0QF;A8Cn2QA;EAkCE,sBAAA;EACA,gBAAA;A9Cq0QF;A8Cl0QA;EAGC,aAAA;EAGA,cAAA;EAIA,mBAAA;A9Co0QD;A8Cl0QE;EACC,gCAAA;A9Co0QH;A8Cj1QA;EAiBE,gCAAA;A9Cm0QF;A8Ch0QA;EACC,aAAA;A9Ck0QD;A8Ch0QA;EAGC,aAAA;EAGA,SAAA;EAGA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACG,yBAAA;A9Ck0QJ;A8C/0QA;EAiBE,UAAA;A9Cm0QF;A8Ch0QE;EAEE,8BAAA;A9Ci0QJ;A8Cv1QA;EA2BE,WAAA;EAGA,iBAAA;EACA,yBAAA;A9C+zQF;A8C5zQA;EACC,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;A9C8zQD;A8C5zQA;EAGC,aAAA;EAIA,sBAAA;A9C8zQD;A8C5zQA;EAGG,YAAA;A9C4zQH;A8CxzQA;EACC;IAIC,sBAAA;E9C0zQA;AACF;A8CvzQA;EACI,oBAAA;EACA,mBAAA;EACA,eAAA;A9CyzQJ;A+CtwSA;EACE,QAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,+BAAA;EACA,aAAA;A/CwwSF;A+CtwSE;EAAA;IACE,SAAA;IACA,8BAAA;E/CywSF;AACF;A+CvwSE;EACE,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,wFAAA;A/CywSJ;A+CjySA;EA4BI,YAAA;A/CwwSJ;A+CrwSE;EACE,QAAA;A/CuwSJ;A+CpwSE;EACE,YAAA;A/CswSJ;A+CpwSI;EACE,WAAA;A/CswSN;A+ClwSE;EACE,YAAA;A/CowSJ;A+ClwSI;EACE,WAAA;A/CowSN;A+ChwSE;EAAA;IAEI,YAAA;E/CkwSJ;E+C/vSE;IACE,QAAA;E/CiwSJ;E+C9vSE;IACE,YAAA;E/CgwSJ;E+C9vSI;IACE,WAAA;E/CgwSN;E+C5vSE;IACE,YAAA;E/C8vSJ;E+C5vSI;IACE,WAAA;E/C8vSN;AACF;A+Cv0SA;EA8EI,gBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,6BAAA;EACA,8BAAA;EACA,gBAAA;A/C4vSJ;A+C1vSI;EAAA;IACE,YAAA;E/C6vSJ;AACF;A+Cv1SA;EA8FI,kBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;A/C4vSJ;A+C1vSI;EAAA;IACE,YAAA;IACA,wBAAA;E/C6vSJ;AACF;A+Cn2SA;EAyGM,gBAAA;A/C6vSN;A+Ct2SA;EA4GQ,WAAA;A/C6vSR;A+Cz2SA;EAkHI,gBAAA;EACA,mBAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;A/C0vSJ;A+CxvSI;EAAA;IACE,eAAA;E/C2vSJ;AACF;A+Cx3SA;EAgIM,iBAAA;EACA,mBAAA;A/C2vSN;A+C53SA;EAqIM,SAAA;A/C0vSN;A+C/3SA;EA0II,eAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;A/CwvSJ;A+Cr4SA;EAgJM,gBAAA;A/CwvSN;A+ClvSA;EAGI,eAAA;A/CkvSJ;A+CrvSA;EAOI,aAAA;EACA,oBAAA;EACA,SAAA;EACA,WAAA;A/CivSJ;A+C3vSA;EAcI,gBAAA;A/CgvSJ;A+C9vSA;EAkBI,MAAA;A/C+uSJ;A+CjwSA;EAsBI,mBAAA;A/C8uSJ;A+CpwSA;EA0BI,kBAAA;A/C6uSJ;A+CxuSA;EAEI,eAAA;A/CyuSJ;A+C3uSA;EAMI,6BAAA;EACA,oBAAA;A/CwuSJ;A+CpuSA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;A/CsuSF;A+CzuSA;EAMI,aAAA;EACA,eAAA;EACA,mBAAA;A/CsuSJ;A+CpuSI;EACE,wCAAA;A/CsuSN;A+CnuSI;EACE,8CAAA;A/CquSN;A+CluSI;EACE,yDAAA;A/CouSN;A+CjuSI;EACE,oEAAA;A/CmuSN;A+ChuSI;EACE,uEAAA;A/CkuSN;A+C7vSA;EA+BM,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;A/CiuSN;A+C/tSM;EACE,uBAAA;A/CiuSR;A+CzwSA;EA8CI,WAAA;EACA,aAAA;EACA,sBAAA;A/C8tSJ;A+C9wSA;EAmDM,aAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,iDAAA;EACA,eAAA;A/C8tSN;A+C5tSM;EACE,mBAAA;A/C8tSR;A+C1xSA;EAgEQ,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;A/C6tSR;A+CjySA;EAuEU,eAAA;EACA,gBAAA;A/C6tSV;A+C1tSQ;EACE,uBAAA;A/C4tSV;A+CztSQ;EACE,sBAAA;A/C2tSV;A+C3ySA;EAqFQ,UAAA;EACA,eAAA;EACA,iBAAA;A/CytSR;A+CrtSI;EACE,sCAAA;A/CutSN;A+CrtSM;EACE,2BAAA;A/CutSR;A+CntSI;EACE,4CAAA;A/CqtSN;A+CntSM;EACE,2BAAA;A/CqtSR;A+CjtSI;EACE,yDAAA;A/CmtSN;A+CjtSM;EACE,2BAAA;A/CmtSR;A+C/sSI;EACE,oEAAA;A/CitSN;A+C/sSM;EACE,2BAAA;A/CitSR;A+C7sSI;EACE,uEAAA;A/C+sSN;A+C7sSM;EACE,2BAAA;A/C+sSR;A+C90SA;EAqII,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;A/C4sSJ;A+Ct1SA;EA6IM,eAAA;A/C4sSN;A+Cz1SA;EAiJM,YAAA;A/C2sSN;A+CzsSM;EACE,aAAA;A/C2sSR;A+CxsSM;EACE,aAAA;A/C0sSR;A+CvsSM;;EAEE,aAAA;A/CysSR;A+CrsSI;EACE,gBAAA;A/CusSN;A+ClsSA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;A/CosSF;A+CvsSA;EAMI,aAAA;EACA,eAAA;EACA,mBAAA;A/CosSJ;A+ClsSI;EACE,wCAAA;A/CosSN;A+CjsSI;EACE,oDAAA;A/CmsSN;A+ChsSI;EACE,0DAAA;A/CksSN;A+CrtSA;EAuBM,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;A/CisSN;A+C9tSA;EAkCI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;A/C+rSJ;A+CpuSA;EAwCM,aAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,iDAAA;EACA,eAAA;A/C+rSN;A+C7rSM;EACE,mBAAA;A/C+rSR;A+ChvSA;EAqDQ,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;A/C8rSR;A+CvvSA;EA4DU,eAAA;EACA,gBAAA;A/C8rSV;A+C3vSA;EAkEQ,UAAA;EACA,eAAA;EACA,iBAAA;A/C4rSR;A+CxrSI;EACE,sCAAA;A/C0rSN;A+CxrSM;EACE,2BAAA;A/C0rSR;A+CtrSI;EACE,oDAAA;A/CwrSN;A+CtrSM;EACE,2BAAA;A/CwrSR;A+CprSI;EACE,0DAAA;A/CsrSN;A+CprSM;EACE,2BAAA;A/CsrSR;A+ClxSA;EAkGI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;A/CmrSJ;A+C1xSA;EA0GM,eAAA;A/CmrSN;A+C7xSA;EA8GM,YAAA;A/CkrSN;A+ChrSM;EACE,aAAA;A/CkrSR;A+C/qSM;EACE,aAAA;A/CirSR;A+C9qSM;;EAEE,aAAA;A/CgrSR;A+C5qSI;EACE,gBAAA;A/C8qSN;A+CzqSA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;A/C2qSF;A+C9qSA;EAMI,aAAA;A/C2qSJ;A+CjrSA;EASM,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;A/C2qSN;A+CzrSA;EAmBI,aAAA;EACA,yBAAA;EACA,cAAA;A/CyqSJ;A+C9rSA;EAyBI,aAAA;EACA,sBAAA;EACA,cAAA;A/CwqSJ;A+CnsSA;EA+BI,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,aAAA;A/CuqSJ;A+C1sSA;EAsCM,aAAA;A/CuqSN;AACA,WAAW;AgD3rTX;EACE,eAAA;EACA,cAAA;AhD6rTF;AgD1rTA;EACE,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;AhD4rTF;AgDjsTA;EAQI,aAAA;EACA,YAAA;AhD4rTJ;AgDrsTA;;EAiBQ,gBAAA;AhDwrTR;AgDzsTA;;EAyBQ,gBAAA;AhDorTR;AgD7sTA;EA8BM,sBAAA;EACA,UAAA;AhDkrTN;AgDjtTA;;EAwCQ,8BAAA;EACA,gBAAA;AhD6qTR;AgDttTA;;EAiDQ,+BAAA;EACA,gBAAA;AhDyqTR;AgD3tTA;EAuDM,mBAAA;EACA,UAAA;AhDuqTN;AgD/tTA;EA6DI,aAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,+CAAA;AhDqqTJ;AgD7uTA;EA4EI,sBAAA;AhDoqTJ;AgD/pTI;;EACE,mBAAA;AhDkqTN;AgDpvTA;;;;EAuFM,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;AhDmqTN;AgDhwTA;;;;EAgGQ,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AhDsqTR;AgD1wTA;;;;EAuGU,cAAA;AhDyqTV;AgDhxTA;;;;EA0GY,cAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AhD4qTZ;AgDvqTM;;;;EACE,yBAAA;AhD4qTR;AgDzqTM;;;;EACE,uBAAA;AhD8qTR;AgD3qTM;;;;EACE,WAAA;AhDgrTR;AgD7qTM;;;;EAEI,eAAA;EACA,yBAAA;AhDirTV;AgD/qTU;;;;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;AhDorTZ;AgD/qTM;;;;EAEI,cAAA;AhDmrTV;AgDn0TA;;;;EAqJQ,sBAAA;AhDorTR;AgDz0TA;EA2JI,UAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AhDirTJ;AgD/qTI;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AhDirTN;AgDz1TA;EA6KI,UAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AhD+qTJ;AgD7qTI;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;AhD+qTN;AgDz2TA;EAsMQ,+BAAA;AhDsqTR;AgD52TA;EAkMU,eAAA;EACA,cAAA;AhD6qTV;AgDh3TA;EA0MY,UAAA;EACA,eAAA;AhDyqTZ;AgDp3TA;EAiNQ,sBAAA;AhDsqTR;AgDv3TA;EAqNQ,gBAAA;EACA,YAAA;EACA,cAAA;AhDqqTR;AgD53TA;;EA4NQ,gBAAA;AhDoqTR;AgDh4TA;;EA+NU,eAAA;EACA,iBAAA;AhDqqTV;AgDjqTM;EAEI,0CAAA;AhDkqTV;AgD9pTM;EAEI,0CAAA;AhD+pTV;AgD34TA;EAiPQ,qBAAA;ElDWN,WAAA;EACA,YAAA;EACA,kBAAA;EkDXM,gBAAA;EACA,yBAAA;EACA,kCAAA;EACA,sBAAA;EACA,4BAAA;EACA,sBAAA;AhD+pTR;AgDv5TA;EA2PU,WAAA;EACA,YAAA;EACA,UAAA;AhD+pTV;AgD55TA;EAgQY,aAAA;AhD+pTZ;AgD/5TA;EAyQM,mBAAA;AhDypTN;AgDl6TA;EA4QQ,mBAAA;AhDypTR;AgDr6TA;;EAmRI,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AhDspTJ;AgDppTI;;EACE,WAAA;EACA,kBAAA;AhDupTN;AgDppTI;;EACE,kBAAA;AhDupTN;AgDxpTI;;EAII,qBAAA;AhDwpTR;AgDppTI;;;;;;EAII,UAAA;AhDwpTR;AgDppTI;;EACE,sBAAA;EACA,iBAAA;EACA,eAAA;AhDupTN;AgD1pTI;;EAMI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AhDwpTR;AgDlqTI;;EAaM,iBAAA;AhDypTV;AgDr9TA;;EAkUM,cAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AhDupTN;AgD99TA;;EA0UQ,eAAA;AhDwpTR;AgDl+TA;;EA8UQ,YAAA;EACA,iBAAA;AhDwpTR;AgDtpTQ;;EACE,eAAA;EACA,UAAA;AhDypTV;AgDtpTQ;;EACE,eAAA;EACA,UAAA;AhDypTV;AgDtpTQ;;EACE,eAAA;EACA,UAAA;AhDypTV;AgDtpTQ;;;;EAEE,eAAA;EACA,UAAA;AhD0pTV;AgDtpTM;;EACE,gBAAA;AhDypTR;AgDppTE;EAEI,YAAA;AhDqpTN;AgDvpTE;EAMI,kBAAA;AhDopTN;AgD1pTE;EAUI,YAAA;EACA,UAAA;AhDmpTN;AgD/oTE;EAEI,SAAA;AhDgpTN;AgDlpTE;EAOM,eAAA;EACA,gBAAA;AhD8oTR;AgDtpTE;EAaI,gBAAA;AhD4oTN;AgDxoTE;EAEI,gBAAA;AhDyoTN;AgD3oTE;EAOM,cAAA;AhDuoTR;AgD9oTE;;EAaI,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;AhDqoTN;AgDrpTE;;EAmBM,aAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AhDsoTR;AgD7pTE;;EA0BQ,cAAA;AhDuoTV;AgDjqTE;;EA6BU,cAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AhDwoTZ;AgDnoTM;;;;EAII,yBAAA;AhDqoTV;AgDjoTM;;EAEI,iBAAA;AhDmoTV;AgDroTM;;EAMI,gBAAA;AhDmoTV;AgDzoTM;;EAUI,gBAAA;AhDmoTV;AgD7oTM;;EAcI,gBAAA;AhDmoTV;AgDjpTM;;;;EAmBI,gBAAA;EACA,gBAAA;AhDooTV;AgDxpTM;;;;EAyBI,eAAA;EACA,eAAA;AhDqoTV;AgD/pTM;;EA8BI,gBAAA;AhDqoTV;AgDnqTM;;EAiCM,YAAA;EACA,cAAA;AhDsoTZ;AgDrtTE;;EAqFM,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;AhDooTR;AgD9tTE;;EA6FQ,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;AhDqoTV;AgDjoTM;;EACE,uBAAA;AhDooTR;AgDzuTE;EA0GI,cAAA;EACA,eAAA;AhDkoTN;AgD7uTE;EA+GI,cAAA;EACA,eAAA;EACA,yBAAA;AhDioTN;AgDlvTE;;EAwHM,mBAAA;EACA,cAAA;AhD8nTR;AgDvvTE;;EA4HQ,gBAAA;AhD+nTV;AgD3nTM;;EAII,cAAA;AhD2nTV;AgD/nTM;;EAOM,mBAAA;AhD4nTZ;AgDvnTM;;EAII,cAAA;AhDunTV;AgD3nTM;;EAOM,mBAAA;AhDwnTZ;AgD3wTE;EA0JI,gBAAA;AhDonTN;AgD9wTE;EA6JM,eAAA;EACA,mBAAA;AhDonTR;AgDlxTE;EAmKI,uBAAA;AhDknTN;AgDrxTE;EAwKM,YAAA;AhDgnTR;AgD1mTA;EACE,WAAA;EACA,iBAAA;EACA,iBAAA;AhD4mTF;AgDzmTA;EACE,gBAAA;EACA,mBAAA;AhD2mTF;AgD7mTA;EAKI,gBAAA;EACA,kBAAA;EACA,yBAAA;AhD2mTJ;AgDzmTI;EACE,eAAA;AhD2mTN;AgDtmTA;EAEI,mBAAA;AhDumTJ;AgDzmTA;EAKM,eAAA;EACA,iBAAA;AhDumTN;AgDrmTM;EACE,eAAA;AhDumTR;AgDhnTA;EAcM,gBAAA;EACA,cAAA;AhDqmTN;AgDhmTA;EACE,aAAA;EACA,eAAA;AhDkmTF;AgD/lTA;EACE,mBAAA;EACA,gBAAA;AhDimTF;AgDnmTA;;;;EASM,sBAAA;EACA,yBAAA;EACA,cAAA;AhDgmTN;AgD9lTM;;;;EACE,QAAA;AhDmmTR;AgDpmTM;;;;EAII,YAAA;EACA,aAAA;AhDsmTV;AgDlmTM;;;;EACE,mBAAA;EACA,cAAA;AhDumTR;AgDpmTM;;;;EACE,WAAA;EACA,eAAA;EACA,eAAA;AhDymTR;AgDtmTM;;;;EACE,YAAA;AhD2mTR;AgDxmTM;;;;EACE,QAAA;AhD6mTR;AgD1mTM;;;;EACE,UAAA;AhD+mTR;AgD5mTM;;;;EACE,gBAAA;EACA,UAAA;EACA,eAAA;AhDinTR;AgDjqTA;EAuDM,+BAAA;AhD6mTN;AgDpqTA;EA4DQ,cAAA;AhD2mTR;AgDvqTA;EAgEQ,YAAA;AhD0mTR;AgDvmTM;EAEI,YAAA;AhDwmTV;AgD7qTA;EA0EQ,WAAA;EACA,eAAA;EACA,iBAAA;AhDsmTR;AgDnmTM;EACE,iBAAA;AhDqmTR;AgDlmTM;EACE,QAAA;AhDomTR;AgDrmTM;EAII,YAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AhDomTV;AgDlmTU;EACE,eAAA;AhDomTZ;AgDjmTU;EACE,eAAA;AhDmmTZ;AgDpsTA;;EA2GQ,gBAAA;AhD6lTR;AgDxsTA;;EAmHQ,gBAAA;AhDylTR;AgDplTE;EACE,cAAA;EACA,gBAAA;AhDslTJ;AgDllTA;EACE,mBAAA;AhDolTF;AgDjlTA;EACE,0BAAA;AhDmlTF;AACA,gBAAgB;AgDhlThB;EACE,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EhDklTA,WAAW;AACb;AgD5lTA;EAYI,kBAAA;EACA,sBAAA;EACA,SAAA;AhDmlTJ;AgDjmTA;EAkBI,SAAA;AhDklTJ;AgDpmTA;EAsBI,cAAA;EACA,gBAAA;AhDilTJ;AgD/kTI;EAAA;IACE,cAAA;EhDklTJ;AACF;AgD7mTA;EA8BM,gBAAA;EACA,cAAA;EACA,gBAAA;AhDklTN;AgDlnTA;EAoCM,cAAA;EACA,gBAAA;AhDilTN;AgDtnTA;EAuFI,WAAA;EACA,qBAAA;EACA,gBAAA;AhDkiTJ;AgD3nTA;EA6FI,qBAAA;EACA,kBAAA;AhDiiTJ;AgD7hTI;EAAA;IACE,gBAAA;IACA,mBAAA;EhDgiTJ;AACF;AgD5hTI;EAAA;IACE,kBAAA;EhD+hTJ;AACF;AgD1oTA;EA+GI,gBAAA;AhD8hTJ;AgD1hTA;EACE,aAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AhD4hTF;AgDniTA;EAUI,WAAA;EACA,eAAA;AhD4hTJ;AgDxhTA;EACE,aAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AhD0hTF;AgDxhTE;EAAA;IACE,cAAA;EhD2hTF;AACF;AgDxhTA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AhD0hTF;AgDvhTA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AhDyhTF;AgD9hTA;;EASI,cAAA;EAMA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AhDohTJ;AgD5hTI;EAAA;;IACE,cAAA;EhDgiTJ;AACF;AgD7iTA;;EAsBM,sBAAA;AhD2hTN;AgDjjTA;EA2BI,cAAA;AhDyhTJ;AgDpjTA;EA8BM,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AhDyhTN;AgD7jTA;EAyCI,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,iBAAA;AhDuhTJ;AgDhhTE;;;EACE,cAAA;AhDohTJ;AgDrhTE;;;EAII,aAAA;AhDshTN;AACA,2BAA2B;AgDjhT3B;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;AhDmhTF;AgD1hTA;EAUI,mBAAA;AhDmhTJ;AgD7hTA;EAcI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;AhDkhTJ;AgD9gTA;EAEI,WAAA;EACA,eAAA;AhD+gTJ;AgD3gTA;EACE,gBAAA;AhD6gTF;AgD1gTA;EAEI,eAAA;AhD2gTJ;AgDvgTA;EAEI,eAAA;AhDwgTJ;AgDpgTA;EACE,kBAAA;EACA,gCAAA;EACA,UAAA;EACA,+BAAA;EACA,mBAAA;AhDsgTF;AgDpgTE;EACE,aAAA;AhDsgTJ;AgDngTE;EACE,aAAA;AhDqgTJ;AgDjhTA;EAgBI,cAAA;AhDogTJ;AgDphTA;EAoBI,aAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AhDmgTJ;AgD3hTA;EA2BM,WAAA;EACA,uBAAA;AhDmgTN;AgDjgTM;EAAA;IACE,wBAAA;IACA,WAAA;EhDogTN;AACF;AgDriTA;EAsCI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;AhDkgTJ;AgDhgTI;EAAA;IACE,WAAA;IACA,yBAAA;IACA,YAAA;EhDmgTJ;AACF;AgD//SA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,cAAA;EACA,mBAAA;AhDigTF;AgD9/SA;;EAII,aAAA;EACA,eAAA;EACA,8BAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;AhD8/SJ;AgDvgTA;;EAYM,cAAA;AhD+/SN;AgD1/SA;EAEI,gBAAA;AhD2/SJ;AgDv/SA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AhDy/SF;AgDt/SA;EACE,uBAAA;EACA,eAAA;AhDw/SF;AgD1/SA;EAKI,cAAA;EACA,2BAAA;EACA,mBAAA;AhDw/SJ;AgD//SA;EAWI,mBAAA;AhDu/SJ;AgDlgTA;EAeI,SAAA;EACA,SAAA;AhDs/SJ;AgDtgTA;EAoBI,cAAA;EACA,eAAA;AhDq/SJ;AgDn/SI;EACE,cAAA;AhDq/SN;AgDl/SI;EACE,gBAAA;AhDo/SN;AgDhhTA;EAgCM,WAAA;EACA,cAAA;EACA,eAAA;AhDm/SN;AgDrhTA;EAuCI,UAAA;AhDi/SJ;AgD/+SI;EAAA;IACE,eAAA;EhDk/SJ;EgDh/SI;IACE,eAAA;EhDk/SN;AACF;AgDhiTA;EAkDM,mBAAA;AhDi/SN;AgD/+SM;EACE;IACE,gBAAA;EhDi/SR;EgD9+SM;IACE,gBAAA;EhDg/SR;AACF;AgD3iTA;EAgEU,gBAAA;AhD8+SV;AACA,kBAAkB;AgDt+SlB;EACE,aAAA;EACA,cAAA;AhDw+SF;AgD1+SA;EAKI,aAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;AhDw+SJ;AgDp+SA;EACE,qBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AhDs+SF;AgDn+SA;EACE,kBAAA;AhDq+SF;AgDt+SA;EAII,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AhDq+SJ;AgDj+SA;EAEI,UAAA;EACA,SAAA;AhDk+SJ;AgDr+SA;EAOI,SAAA;EACA,WAAA;AhDi+SJ;AgDz+SA;EAYI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;EACA,8BAAA;EACA,gBAAA;AhDg+SJ;AgDl/SA;EAsBI,kBAAA;EACA,2BAAA;EACA,YAAA;AhD+9SJ;AgDv/SA;EA4BI,kBAAA;EACA,YAAA;AhD89SJ;AgD3/SA;EAiCI,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,MAAA;EACA,WAAA;AhD69SJ;AgDrgTA;EA4CI,kBAAA;EACA,gBAAA;EACA,mBAAA;AhD49SJ;AgD1gTA;EAkDI,qBAAA;EACA,2BAAA;EACA,sBAAA;EACA,YAAA;EACA,MAAA;EACA,cAAA;AhD29SJ;AgDlhTA;EA0DM,SAAA;EACA,YAAA;AhD29SN;AgDthTA;EAgEI,YAAA;EACA,kBAAA;AhDy9SJ;AgD1hTA;EAoEM,uBAAA;AhDy9SN;AgD7hTA;EAyEI,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AhDu9SJ;AgDpiTA;EAgFM,kBAAA;AhDu9SN;AgDviTA;EAoFM,mBAAA;EACA,aAAA;EACA,mBAAA;AhDs9SN;AgD5iTA;EAyFQ,eAAA;EACA,gCAAA;AhDs9SR;AgDn9SM;EACE,mBAAA;AhDq9SR;AgDt9SM;EAII,cAAA;AhDq9SV;AgDj9SM;;EAEE,mBAAA;EACA,gBAAA;EACA,+BAAA;AhDm9SR;AgD5jTA;EA6GQ,iBAAA;AhDk9SR;AgD/jTA;EAgHU,eAAA;EACA,gCAAA;AhDk9SV;AgD/8SQ;EAEI,eAAA;AhDg9SZ;AgD38SM;EACE,WAAA;EACA,oBAAA;AhD68SR;AgD18SM;EACE,eAAA;AhD48SR;AgD78SM;EAII,wBAAA;EACA,eAAA;AhD48SV;AgDz8SQ;EAEI,uBAAA;AhD08SZ;AgDt8SQ;EAEI,mBAAA;AhDu8SZ;AgDr8SY;EACE,mBAAA;AhDu8Sd;AgD19SM;EA0BI,kBAAA;AhDm8SV;AgDj8SU;;EAEE,mBAAA;EACA,+BAAA;AhDm8SZ;AgDl+SM;EAoCI,kBAAA;EACA,YAAA;EAAA,cAAA;EAAA,6BAAA;AhDi8SV;AgDtmTA;EA0KQ,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;AhD+7SR;AgD9mTA;EAmLQ,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AhD87SR;AgDrnTA;EA2LQ,cAAA;AhD67SR;AgDxnTA;EAiMI,UAAA;EACA,eAAA;AhD07SJ;AgD5nTA;EAsMI,oBAAA;AhDy7SJ;AgD/nTA;EAyMM,SAAA;EACA,WAAA;AhDy7SN;AgDnoTA;EA8MM,mBAAA;AhDw7SN;AgDtoTA;EAmNI,cAAA;EACA,mBAAA;AhDs7SJ;AgD1oTA;EAuNM,YAAA;AhDs7SN;AgD7oTA;EA6NM,0BAAA;AhDm7SN;AgDhpTA;EAkOI,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AhDi7SJ;AgD76SA;EACE,YAAA;EACA,iBAAA;EACA,yBAAA;AhD+6SF;AgDl7SA;EAMI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AhD+6SJ;AgDz7SA;EAaM,iBAAA;AhD+6SN;AgD57SA;EAgBQ,eAAA;EACA,gCAAA;AhD+6SR;AgD56SM;EAEI,eAAA;AhD66SV;AgDn8SA;EA4BM,SAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;AhD06SN;AgDr6SA;EACE,WAAA;EACA,gCAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AhDu6SF;AgD/4SA;;EAEE,cAAA;EACA,0BAAA;AhDi5SF;AgDp5SA;;;;EAOI,wBAAA;EACA,eAAA;AhDm5SJ;AgDh5SE;;EACE,cAAA;AhDm5SJ;AgDh5SE;;EACE,cAAA;EACA,qBAAA;AhDm5SJ;AgDj5SI;;EACE,0BAAA;AhDo5SN;AgD/4SA;EAEI,qBAAA;AhDg5SJ;AgD54SA;Ed39CE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;EAGA,gBAAA;EACA,gBAAA;Ec88CA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;AhD65SF;AkC72VE;EACE,cAAA;EACA,gBAAA;AlC+2VJ;AgDv6SA;Edp8CI,UAAA;EACA,gCAAA;AlC82VJ;AkC32VE;EACE,gBAAA;EACA,gBAAA;AlC62VJ;AkC12VE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AlC42VJ;AkC/2VE;EAMI,eAAA;EACA,UAAA;AlC42VN;AkCr8VE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCu8VJ;AkCp8VE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCs8VJ;AkCp8VI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCy8VN;AkCr8VE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCu8VJ;AkCr8VI;;;;EAEE,yBAAA;EACA,mBAAA;AlCy8VN;AkCv8VM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCk9VR;AkC15VE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AlC45VJ;AkC/5VE;EAMI,cAAA;EACA,eAAA;EACA,UAAA;AlC45VN;AkCrgWE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCugWJ;AkCpgWE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCsgWJ;AkCpgWI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCygWN;AkCrgWE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCugWJ;AkCrgWI;;;;EAEE,yBAAA;EACA,mBAAA;AlCygWN;AkCvgWM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCkhWR;AkC58VE;EACE,mBAAA;AlC88VJ;AkC38VE;EACE,mBAAA;EACA,cAAA;AlC68VJ;AkC/8VE;EAKI,eAAA;AlC68VN;AkCrkWE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCukWJ;AkCpkWE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCskWJ;AkCpkWI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCykWN;AkCrkWE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCukWJ;AkCrkWI;;;;EAEE,yBAAA;EACA,mBAAA;AlCykWN;AkCvkWM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCklWR;AkC7/VE;EACE,mBAAA;EACA,cAAA;AlC+/VJ;AkCjgWE;EAKI,eAAA;AlC+/VN;AkCloWE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCooWJ;AkCjoWE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCmoWJ;AkCjoWI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCsoWN;AkCloWE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCooWJ;AkCloWI;;;;EAEE,yBAAA;EACA,mBAAA;AlCsoWN;AkCpoWM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC+oWR;AkC/iWE;EACE,mBAAA;EACA,cAAA;AlCijWJ;AkCnjWE;EAKI,eAAA;AlCijWN;AkC/rWE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCisWJ;AkC9rWE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCgsWJ;AkC9rWI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCmsWN;AkC/rWE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCisWJ;AkC/rWI;;;;EAEE,yBAAA;EACA,mBAAA;AlCmsWN;AkCjsWM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC4sWR;AkCjmWE;EACE,uBAAA;EACA,cAAA;AlCmmWJ;AkCrmWE;EAKI,eAAA;AlCmmWN;AkC5vWE;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;AlC8vWJ;AkC3vWE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlC6vWJ;AkC3vWI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCgwWN;AkC5vWE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlC8vWJ;AkC5vWI;;;;EAEE,yBAAA;EACA,uBAAA;AlCgwWN;AkC9vWM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCywWR;AkCppWI;EACE,uBAAA;EACA,cAAA;AlCspWN;AkCxpWI;EAKI,eAAA;AlCspWR;AkCzzWE;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;AlC2zWJ;AkCxzWE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlC0zWJ;AkCxzWI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlC6zWN;AkCzzWE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlC2zWJ;AkCzzWI;;;;EAEE,yBAAA;EACA,uBAAA;AlC6zWN;AkC3zWM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCs0WR;AkCrsWE;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;AlCusWJ;AkC1sWE;EAMI,eAAA;AlCusWN;AkCv3WE;;;EAGE,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;AlCy3WJ;AkCt3WE;;EAEE,cAAA;EACA,yBAAA;EACA,uBAAA;AlCw3WJ;AkCt3WI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlC23WN;AkCv3WE;;EAEE,cAAA;EACA,yBAAA;EACA,uBAAA;AlCy3WJ;AkCv3WI;;;;EAEE,qBAAA;EACA,uBAAA;AlC23WN;AkCz3WM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCo4WR;AkCvvWE;EACE,uBAAA;EACA,cAAA;AlCyvWJ;AkC3vWE;EAKI,eAAA;AlCyvWN;AkCp7WE;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,uCAAA;AlCs7WJ;AkCn7WE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCq7WJ;AkCn7WI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlCw7WN;AkCp7WE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCs7WJ;AkCp7WI;;;;EAEE,yBAAA;EACA,uBAAA;AlCw7WN;AkCt7WM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlCi8WR;AkCzyWE;EACE,UAAA;EACA,uBAAA;EACA,cAAA;AlC2yWJ;AkC9yWE;EAMI,eAAA;AlC2yWN;AkCl/WE;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,uCAAA;AlCo/WJ;AkCj/WE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCm/WJ;AkCj/WI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlCs/WN;AkCl/WE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCo/WJ;AkCl/WI;;;;EAEE,yBAAA;EACA,uBAAA;AlCs/WN;AkCp/WM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlC+/WR;AkC31WE;EACE,mBAAA;EACA,cAAA;AlC61WJ;AkC/1WE;EAKI,eAAA;AlC61WN;AkC11WI;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AlC41WN;AkCh2WI;EAOI,eAAA;AlC41WR;AkCxjXE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlC0jXJ;AkCvjXE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCyjXJ;AkCvjXI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC4jXN;AkCxjXE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC0jXJ;AkCxjXI;;;;EAEE,yBAAA;EACA,mBAAA;AlC4jXN;AkC1jXM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCqkXR;AkC34WE;EACE,mBAAA;EACA,cAAA;AlC64WJ;AkC/4WE;EAKI,eAAA;AlC64WN;AkC14WI;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AlC44WN;AkCh5WI;EAOI,eAAA;AlC44WR;AkC9nXE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCgoXJ;AkC7nXE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC+nXJ;AkC7nXI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCkoXN;AkC9nXE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCgoXJ;AkC9nXI;;;;EAEE,yBAAA;EACA,mBAAA;AlCkoXN;AkChoXM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC2oXR;AkC37WE;EACE,mBAAA;EACA,cAAA;AlC67WJ;AkC/7WE;EAKI,eAAA;AlC67WN;AkC17WI;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AlC47WN;AkCh8WI;EAOI,eAAA;AlC47WR;AkCpsXE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCssXJ;AkCnsXE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCqsXJ;AkCnsXI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCwsXN;AkCpsXE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCssXJ;AkCpsXI;;;;EAEE,yBAAA;EACA,mBAAA;AlCwsXN;AkCtsXM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCitXR;AkC5+WI;;;EAII,eAAA;AlC6+WR;AkCx+WE;;EAEE,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;AlC0+WJ;AkC/+WE;;EAQI,cAAA;EACA,eAAA;AlC2+WN;AkC3wXE;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,uCAAA;AlCgxXJ;AkC7wXE;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCixXJ;AkC/wXI;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,uCAAA;AlC0xXN;AkCtxXE;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC0xXJ;AkCxxXI;;;;;;;;EAEE,yBAAA;EACA,mBAAA;AlCgyXN;AkC9xXM;;;;;;;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,uCAAA;AlCqzXR;AkCxjXE;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AlCyjXN;AkC9jXE;EAQM,WAAA;EACA,YAAA;EACA,iBAAA;AlCyjXR;AkCpjXE;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AlCqjXN;AkC1jXE;EAQM,WAAA;EACA,YAAA;EACA,iBAAA;AlCqjXR;AkChjXE;EACE,mBAAA;AlCkjXJ;AkCnjXE;EAQI,QAAA;EACA,gBAAA;AlC8iXN;AkCvjXE;EAKM,UAAA;AlCqjXR;AkC7iXE;EACE,kBAAA;AlC+iXJ;AkChjXE;EAQI,QAAA;EACA,iBAAA;AlC2iXN;AkCpjXE;EAKM,UAAA;AlCkjXR;AkC1iXE;EAEI,SAAA;AlC2iXN;AkCviXE;EACE,UAAA;AlCyiXJ;AkCviXI;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;AlCyiXN;AkC5iXI;EAMI,gBAAA;EACA,eAAA;AlCyiXR;AkCriXI;EAME,gBAAA;EACA,gBAAA;EACA,eAAA;AlCkiXN;AkC1iXI;EAEI,gBAAA;EACA,eAAA;AlC2iXR;AkCniXI;EACE,gBAAA;EACA,gBAAA;AlCqiXN;AkCjiXE;EAGM,UAAA;EACA,eAAA;AlCiiXR;AkC5hXE;EAGM,YAAA;AlC4hXR;AkCvhXE;EACE,iBAAA;AlCyhXJ;AkCthXE;EACE,UAAA;AlCwhXJ;AkCrhXE;EACE,cAAA;EACA,iBAAA;AlCuhXJ;AgDh6UE;EACE,mBAAA;EACA,cAAA;AhDk6UJ;AgD/5UE;EACE,mBAAA;EACA,cAAA;AhDi6UJ;AgD95UE;EACE,mBAAA;EACA,cAAA;AhDg6UJ;AgD75UE;EACE,mBAAA;EACA,cAAA;AhD+5UJ;AgD55UE;EACE,mBAAA;EACA,cAAA;AhD85UJ;AgD35UE;EACE,mBAAA;EACA,cAAA;AhD65UJ;AgD15UE;EACE,mBAAA;EACA,cAAA;AhD45UJ;AgDz5UE;EACE,mBAAA;EACA,cAAA;AhD25UJ;AgDv5UA;EACE,cAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;AhDy5UF;AgDv5UE;EACE,mBAAA;AhDy5UJ;AgDt5UE;EACE,mBAAA;AhDw5UJ;AgDr5UE;EACE,mBAAA;AhDu5UJ;AgDp5UE;EACE,mBAAA;AhDs5UJ;AgDn5UE;EACE,mBAAA;AhDq5UJ;AgDl5UE;EACE,mBAAA;AhDo5UJ;AgDj5UE;EACE,mBAAA;AhDm5UJ;AgD/4UA;EACE,cAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;AhDi5UF;AgD/4UE;EACE,mBAAA;AhDi5UJ;AgD94UE;EACE,mBAAA;AhDg5UJ;AgD74UE;EACE,mBAAA;AhD+4UJ;AgD54UE;EACE,mBAAA;AhD84UJ;AgD34UE;EACE,mBAAA;AhD64UJ;AgD14UE;EACE,mBAAA;AhD44UJ;AgDz4UE;EACE,mBAAA;AhD24UJ;AgDx4UE;EACE,mBAAA;AhD04UJ;AgDv4UE;EACE,mBAAA;AhDy4UJ;AgDt4UE;EACE,mBAAA;AhDw4UJ;AgDp4UA;EdlmDE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;EAGA,gBAAA;EACA,gBAAA;EcqlDA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;AhDq5UF;AkC5+XE;EACE,cAAA;EACA,gBAAA;AlC8+XJ;AgD/5UA;Ed3kDI,UAAA;EACA,gCAAA;AlC6+XJ;AkC1+XE;EACE,gBAAA;EACA,gBAAA;AlC4+XJ;AkCz+XE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AlC2+XJ;AkC9+XE;EAMI,eAAA;EACA,UAAA;AlC2+XN;AkCpkYE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCskYJ;AkCnkYE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCqkYJ;AkCnkYI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCwkYN;AkCpkYE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCskYJ;AkCpkYI;;;;EAEE,yBAAA;EACA,mBAAA;AlCwkYN;AkCtkYM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCilYR;AkCzhYE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AlC2hYJ;AkC9hYE;EAMI,cAAA;EACA,eAAA;EACA,UAAA;AlC2hYN;AkCpoYE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCsoYJ;AkCnoYE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCqoYJ;AkCnoYI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCwoYN;AkCpoYE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCsoYJ;AkCpoYI;;;;EAEE,yBAAA;EACA,mBAAA;AlCwoYN;AkCtoYM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCipYR;AkC3kYE;EACE,mBAAA;AlC6kYJ;AkC1kYE;EACE,mBAAA;EACA,cAAA;AlC4kYJ;AkC9kYE;EAKI,eAAA;AlC4kYN;AkCpsYE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCssYJ;AkCnsYE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCqsYJ;AkCnsYI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCwsYN;AkCpsYE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCssYJ;AkCpsYI;;;;EAEE,yBAAA;EACA,mBAAA;AlCwsYN;AkCtsYM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCitYR;AkC5nYE;EACE,mBAAA;EACA,cAAA;AlC8nYJ;AkChoYE;EAKI,eAAA;AlC8nYN;AkCjwYE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCmwYJ;AkChwYE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCkwYJ;AkChwYI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCqwYN;AkCjwYE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCmwYJ;AkCjwYI;;;;EAEE,yBAAA;EACA,mBAAA;AlCqwYN;AkCnwYM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC8wYR;AkC9qYE;EACE,mBAAA;EACA,cAAA;AlCgrYJ;AkClrYE;EAKI,eAAA;AlCgrYN;AkC9zYE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCg0YJ;AkC7zYE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC+zYJ;AkC7zYI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCk0YN;AkC9zYE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCg0YJ;AkC9zYI;;;;EAEE,yBAAA;EACA,mBAAA;AlCk0YN;AkCh0YM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC20YR;AkChuYE;EACE,uBAAA;EACA,cAAA;AlCkuYJ;AkCpuYE;EAKI,eAAA;AlCkuYN;AkC33YE;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;AlC63YJ;AkC13YE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlC43YJ;AkC13YI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlC+3YN;AkC33YE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlC63YJ;AkC33YI;;;;EAEE,yBAAA;EACA,uBAAA;AlC+3YN;AkC73YM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCw4YR;AkCnxYI;EACE,uBAAA;EACA,cAAA;AlCqxYN;AkCvxYI;EAKI,eAAA;AlCqxYR;AkCx7YE;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;AlC07YJ;AkCv7YE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCy7YJ;AkCv7YI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlC47YN;AkCx7YE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlC07YJ;AkCx7YI;;;;EAEE,yBAAA;EACA,uBAAA;AlC47YN;AkC17YM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCq8YR;AkCp0YE;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;AlCs0YJ;AkCz0YE;EAMI,eAAA;AlCs0YN;AkCt/YE;;;EAGE,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;AlCw/YJ;AkCr/YE;;EAEE,cAAA;EACA,yBAAA;EACA,uBAAA;AlCu/YJ;AkCr/YI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlC0/YN;AkCt/YE;;EAEE,cAAA;EACA,yBAAA;EACA,uBAAA;AlCw/YJ;AkCt/YI;;;;EAEE,qBAAA;EACA,uBAAA;AlC0/YN;AkCx/YM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCmgZR;AkCt3YE;EACE,uBAAA;EACA,cAAA;AlCw3YJ;AkC13YE;EAKI,eAAA;AlCw3YN;AkCnjZE;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,uCAAA;AlCqjZJ;AkCljZE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCojZJ;AkCljZI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlCujZN;AkCnjZE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCqjZJ;AkCnjZI;;;;EAEE,yBAAA;EACA,uBAAA;AlCujZN;AkCrjZM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlCgkZR;AkCx6YE;EACE,UAAA;EACA,uBAAA;EACA,cAAA;AlC06YJ;AkC76YE;EAMI,eAAA;AlC06YN;AkCjnZE;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,uCAAA;AlCmnZJ;AkChnZE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCknZJ;AkChnZI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlCqnZN;AkCjnZE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCmnZJ;AkCjnZI;;;;EAEE,yBAAA;EACA,uBAAA;AlCqnZN;AkCnnZM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlC8nZR;AkC19YE;EACE,mBAAA;EACA,cAAA;AlC49YJ;AkC99YE;EAKI,eAAA;AlC49YN;AkCz9YI;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AlC29YN;AkC/9YI;EAOI,eAAA;AlC29YR;AkCvrZE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCyrZJ;AkCtrZE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCwrZJ;AkCtrZI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC2rZN;AkCvrZE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCyrZJ;AkCvrZI;;;;EAEE,yBAAA;EACA,mBAAA;AlC2rZN;AkCzrZM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCosZR;AkC1gZE;EACE,mBAAA;EACA,cAAA;AlC4gZJ;AkC9gZE;EAKI,eAAA;AlC4gZN;AkCzgZI;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AlC2gZN;AkC/gZI;EAOI,eAAA;AlC2gZR;AkC7vZE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlC+vZJ;AkC5vZE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC8vZJ;AkC5vZI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCiwZN;AkC7vZE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC+vZJ;AkC7vZI;;;;EAEE,yBAAA;EACA,mBAAA;AlCiwZN;AkC/vZM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC0wZR;AkC1jZE;EACE,mBAAA;EACA,cAAA;AlC4jZJ;AkC9jZE;EAKI,eAAA;AlC4jZN;AkCzjZI;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AlC2jZN;AkC/jZI;EAOI,eAAA;AlC2jZR;AkCn0ZE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCq0ZJ;AkCl0ZE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCo0ZJ;AkCl0ZI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCu0ZN;AkCn0ZE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCq0ZJ;AkCn0ZI;;;;EAEE,yBAAA;EACA,mBAAA;AlCu0ZN;AkCr0ZM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCg1ZR;AkC3mZI;;;EAII,eAAA;AlC4mZR;AkCvmZE;;EAEE,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;AlCymZJ;AkC9mZE;;EAQI,cAAA;EACA,eAAA;AlC0mZN;AkC14ZE;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,uCAAA;AlC+4ZJ;AkC54ZE;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCg5ZJ;AkC94ZI;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,uCAAA;AlCy5ZN;AkCr5ZE;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCy5ZJ;AkCv5ZI;;;;;;;;EAEE,yBAAA;EACA,mBAAA;AlC+5ZN;AkC75ZM;;;;;;;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,uCAAA;AlCo7ZR;AkCvrZE;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AlCwrZN;AkC7rZE;EAQM,WAAA;EACA,YAAA;EACA,iBAAA;AlCwrZR;AkCnrZE;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AlCorZN;AkCzrZE;EAQM,WAAA;EACA,YAAA;EACA,iBAAA;AlCorZR;AkC/qZE;EACE,mBAAA;AlCirZJ;AkClrZE;EAQI,QAAA;EACA,gBAAA;AlC6qZN;AkCtrZE;EAKM,UAAA;AlCorZR;AkC5qZE;EACE,kBAAA;AlC8qZJ;AkC/qZE;EAQI,QAAA;EACA,iBAAA;AlC0qZN;AkCnrZE;EAKM,UAAA;AlCirZR;AkCzqZE;EAEI,SAAA;AlC0qZN;AkCtqZE;EACE,UAAA;AlCwqZJ;AkCtqZI;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;AlCwqZN;AkC3qZI;EAMI,gBAAA;EACA,eAAA;AlCwqZR;AkCpqZI;EAME,gBAAA;EACA,gBAAA;EACA,eAAA;AlCiqZN;AkCzqZI;EAEI,gBAAA;EACA,eAAA;AlC0qZR;AkClqZI;EACE,gBAAA;EACA,gBAAA;AlCoqZN;AkChqZE;EAGM,UAAA;EACA,eAAA;AlCgqZR;AkC3pZE;EAGM,YAAA;AlC2pZR;AkCtpZE;EACE,iBAAA;AlCwpZJ;AkCrpZE;EACE,UAAA;AlCupZJ;AkCppZE;EACE,cAAA;EACA,iBAAA;AlCspZJ;AgDx5WE;EACE,mBAAA;EACA,cAAA;AhD05WJ;AgDv5WE;EACE,mBAAA;EACA,cAAA;AhDy5WJ;AgDt5WE;EACE,mBAAA;EACA,cAAA;AhDw5WJ;AgDr5WE;EACE,mBAAA;EACA,cAAA;AhDu5WJ;AgDp5WE;EACE,mBAAA;EACA,cAAA;AhDs5WJ;AgDl5WA;EACE;IACE,YAAA;IACA,WAAA;IACA,iBAAA;IACA,4BAAA;EhDo5WF;EgDj5WA;IACE,aAAA;EhDm5WF;EgDh5WA;IAEI,aAAA;EhDi5WJ;EgDn5WA;IAMI,6BAAA;EhDg5WJ;EgDt5WA;IAUI,+BAAA;EhD+4WJ;EgDz5WA;IAcI,YAAA;EhD84WJ;EgD55WA;IAkBI,wBAAA;IACA,eAAA;IACA,mBAAA;IACA,gBAAA;IACA,WAAA;EhD64WJ;EgDn6WA;IA0BI,SAAA;EhD44WJ;EgDt6WA;IA8BI,2BAAA;EhD24WJ;EgDz6WA;IAkCI,aAAA;IACA,SAAA;IACA,gBAAA;IACA,eAAA;IACA,yBAAA;EhD04WJ;EgDh7WA;IA0CI,yBAAA;IACA,6BAAA;EhDy4WJ;EgDp7WA;IA+CI,wBAAA;IAAA,mBAAA;IACA,kBAAA;IACA,2BAAA;IACA,gBAAA;IACA,6BAAA;IACA,WAAA;IACA,YAAA;IACA,gCAAA;EhDw4WJ;EgDt4WI;IACE,oCAAA;EhDw4WN;EgDj8WA;IA8DI,yBAAA;IACA,uBAAA;IACA,6BAAA;IACA,oCAAA;EhDs4WJ;EgDv8WA;IAoEM,yBAAA;IACA,yBAAA;IACA,wCAAA;EhDs4WN;EgD58WA;IAyEQ,6BAAA;IACA,yBAAA;IACA,4BAAA;EhDs4WR;EgDh4WA;IAEI,YAAA;IAAA,cAAA;IAAA,iCAAA;IACA,YAAA;EhDi4WJ;EgD73WA;IACE,aAAA;EhD+3WF;EgD53WA;IACE,wBAAA;EhD83WF;AACF;AgD33WA;EAEI,UAAA;AhD43WJ;AgD93WA;EAMI,aAAA;AhD23WJ;AgDj4WA;EAUI,+BAAA;AhD03WJ;AgDp4WA;EAcI,yBAAA;EACA,uBAAA;AhDy3WJ;AgDx4WA;EAmBI,uBAAA;EACA,kCAAA;AhDw3WJ;AgD54WA;EAwBI,yBAAA;EACA,6BAAA;AhDu3WJ;AgDh5WA;EA6BI,2BAAA;AhDs3WJ;AgDn5WA;EAgCM,SAAA;AhDs3WN;AgDt5WA;EAqCI,aAAA;AhDo3WJ;AgDz5WA;EAyCI,+BAAA;AhDm3WJ;AgD55WA;EA6CI,YAAA;AhDk3WJ;AgD/5WA;EAiDI,wBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AhDi3WJ;AgDt6WA;EAyDI,SAAA;AhDg3WJ;AgDz6WA;EA6DI,SAAA;AhD+2WJ;AgD56WA;EAiEI,aAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AhD82WJ;AgDn7WA;EAyEI,aAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AhD62WJ;AgD17WA;EAiFI,wBAAA;EAAA,mBAAA;EACA,kBAAA;EACA,2BAAA;EACA,gBAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;AhD42WJ;AgDp8WA;EA2FM,WAAA;AhD42WN;AgDz2WI;EACE,oCAAA;AhD22WN;AgD18WA;EAoGI,2BAAA;EACA,wBAAA;EACA,oCAAA;EACA,uCAAA;AhDy2WJ;AgDh9WA;EA4GM,2BAAA;EACA,wBAAA;EACA,2BAAA;EAEA,oCAAA;EACA,aAAA;AhDs2WN;AgDv9WA;EAsHI,8BAAA;EACA,qCAAA;AhDo2WJ;AgD39WA;EA0HM,uBAAA;EACA,sBAAA;EACA,wBAAA;AhDo2WN;AgDh+WA;EAgIM,aAAA;AhDm2WN;AgDn+WA;EAoIM,aAAA;AhDk2WN;AgDt+WA;EAyII,cAAA;EACA,kBAAA;AhDg2WJ;AgD71WE;EAAA;IAEI,YAAA;IACA,8BAAA;EhD+1WJ;EgDl2WA;IAOI,cAAA;IACA,iBAAA;EhD81WJ;AACF;AgDp/WA;EA0JI,eAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;AhD61WJ;AgDx1WA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,sBAAA;AhD01WF;AgDj2WA;EAWM,mBAAA;EACA,YAAA;AhDy1WN;AgDr2WA;EAkBM,eAAA;EACA,gBAAA;EACA,iBAAA;AhDs1WN;AgD12WA;EAwBM,eAAA;EACA,gBAAA;EACA,iBAAA;AhDq1WN;AgDh1WA;EAEI,cAAA;AhDi1WJ;AgD/0WI;EAAA;IACE,eAAA;EhDk1WJ;AACF;AgDx1WA;EASM,cAAA;EACA,uBAAA;AhDk1WN;AgDh1WM;EAAA;IACE,SAAA;EhDm1WN;AACF;AgDj2WA;EAmBI,aAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;AhDi1WJ;AgDv2WA;EAyBM,cAAA;EACA,uBAAA;AhDi1WN;AgD/0WM;EAAA;IACE,SAAA;EhDk1WN;AACF;AgD70WA;EACE,6BAAA;AhD+0WF;AgD50WA;EACE,+BAAA;AhD80WF;AgD/0WA;EAII,aAAA;EACA,uBAAA;EACA,iBAAA;AhD80WJ;AgDp1WA;EASM,YAAA;AhD80WN;AgDv1WA;EAYQ,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AhD80WR;AgD50WQ;EACE,eAAA;AhD80WV;AgDj2WA;EAuBU,WAAA;EACA,YAAA;EACA,mBAAA;AhD60WV;AgDt2WA;EAgCI,gBAAA;AhDy0WJ;AgDz2WA;EAoCI,aAAA;AhDw0WJ;AiDz3aA;EAEI,aAAA;AjD03aJ;AiDt3aA;;EACE,eAAA;AjDy3aF;AiD13aA;;EAGI,WAAA;EACA,YAAA;AjD23aJ;AiDz3aE;;EAEI,iBAAA;EACA,oBAAA;AjD23aN;AiD93aE;;EAMI,gBAAA;EACA,gBAAA;EACA,mBAAA;AjD43aN;AiDv3aA;EAGM,6BAAA;AjDu3aN;AiD13aA;EAMM,eAAA;EACA,gBAAA;AjDu3aN;AiD93aA;EAUM,gBAAA;EACA,eAAA;AjDu3aN;AiDl4aA;EAaQ,cAAA;AjDw3aR;AiDr4aA;EAiBM,UAAA;AjDu3aN;AiDx4aA;EAoBM,iBAAA;EACA,eAAA;AjDu3aN;AiD54aA;EAwBM,WAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;AjDu3aN;AiDt3aM;EACE,iBAAA;EACA,kBAAA;AjDw3aR;AiDl3aA;EACE,iBAAA;AjDo3aF;AiDj3aA;EACE,UAAA;EACA,SAAA;AjDm3aF;AiDr3aA;EAII,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;AjDo3aJ;AiD53aA;EAUM,kBAAA;EACA,YAAA;AjDq3aN;AiDh4aA;EAcM,qBAAA;EACA,iBAAA;EACA,sBAAA;AjDq3aN;AiDr4aA;EAoBI,mBAAA;AjDo3aJ;AiDh3aA;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;AjDk3aF;AiDj3aE;EAAA;IACE,eAAA;IACA,cAAA;EjDo3aF;AACF;AiD73aA;EAWI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AjDq3aJ;AiDn4aA;EAkBM,gCAAA;AjDo3aN;AiDt4aA;EAqBM,mBAAA;AjDo3aN;AiDz4aA;EAyBI,mBAAA;EACA,mBAAA;AjDm3aJ;AiD/2aA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AjDi3aF;AiD92aA;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;AjDg3aF;AiDp3aA;EChGQ,aAAA;EACA,YAAA;EACA,eAAA;AlDu9aR;AiDz3aA;EC1FQ,cAAA;EACA,WAAA;EACA,eAAA;AlDs9aR;AiD93aA;EC9BE,YAAA;EAAA,cAAA;EAAA,6BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,6CAAA;EAMF,sBAAA;AlDw5aF;AiDn4aA;EC9BE,YAAA;EAAA,cAAA;EAAA,8BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,8CAAA;EAMF,uBAAA;AlD65aF;AiDx4aA;EC9BE,YAAA;EAAA,cAAA;EAAA,qBAAA;EAGE,YAAA;EAAA,cAAA;EAAA,4BAAA;EAMF,cAAA;AlDk6aF;AiD74aA;EC9BE,YAAA;EAAA,cAAA;EAAA,8BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,8CAAA;EAMF,uBAAA;AlDu6aF;AiDl5aA;EC9BE,YAAA;EAAA,cAAA;EAAA,8BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,8CAAA;EAMF,uBAAA;AlD46aF;AiDv5aA;EC9BE,YAAA;EAAA,cAAA;EAAA,qBAAA;EAGE,YAAA;EAAA,cAAA;EAAA,4BAAA;EAMF,cAAA;AlDi7aF;AiD55aA;EC9BE,YAAA;EAAA,cAAA;EAAA,8BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,8CAAA;EAMF,uBAAA;AlDs7aF;AiDj6aA;EC9BE,YAAA;EAAA,cAAA;EAAA,8BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,8CAAA;EAMF,uBAAA;AlD27aF;AiDt6aA;EC9BE,YAAA;EAAA,cAAA;EAAA,qBAAA;EAGE,YAAA;EAAA,cAAA;EAAA,4BAAA;EAMF,cAAA;AlDg8aF;AiD36aA;EC9BE,YAAA;EAAA,cAAA;EAAA,8BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,8CAAA;EAMF,uBAAA;AlDq8aF;AiDh7aA;EC9BE,YAAA;EAAA,cAAA;EAAA,8BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,8CAAA;EAMF,uBAAA;AlD08aF;AiDr7aA;EC9BE,YAAA;EAAA,cAAA;EAAA,sBAAA;EASA,eAAA;AlD88aF;AiDz7aA;EC1EQ,SAAA;AlDsgbR;AiD57aA;ECtEQ,SAAA;AlDqgbR;AiD/7aA;ECjEU,QAAA;AlDmgbV;AiDl8aA;ECjEU,QAAA;AlDsgbV;AiDr8aA;ECjEU,QAAA;AlDygbV;AiDx8aA;ECjEU,QAAA;AlD4gbV;AiD38aA;ECjEU,QAAA;AlD+gbV;AiD98aA;ECjEU,QAAA;AlDkhbV;AiDj9aA;ECjEU,QAAA;AlDqhbV;AiDp9aA;ECjEU,QAAA;AlDwhbV;AiDv9aA;ECjEU,QAAA;AlD2hbV;AiD19aA;ECjEU,QAAA;AlD8hbV;AiD79aA;ECjEU,SAAA;AlDiibV;AiDh+aA;ECjEU,SAAA;AlDoibV;AiDn+aA;ECjEU,SAAA;AlDuibV;AiDt+aA;ElB5DE,wBAAA;A/BqibF;AiDz+aA;ElB5DE,yBAAA;A/BwibF;AiD5+aA;ElB5DE,gBAAA;A/B2ibF;AiD/+aA;ElB5DE,yBAAA;A/B8ibF;AiDl/aA;ElB5DE,yBAAA;A/BijbF;AiDr/aA;ElB5DE,gBAAA;A/BojbF;AiDx/aA;ElB5DE,yBAAA;A/BujbF;AiD3/aA;ElB5DE,yBAAA;A/B0jbF;AiD9/aA;ElB5DE,gBAAA;A/B6jbF;AiDjgbA;ElB5DE,yBAAA;A/BgkbF;AiDpgbA;ElB5DE,yBAAA;A/BmkbF;AQ9jbE;EAAA;I0CzCM,aAAA;IACA,YAAA;IACA,eAAA;ElD2mbN;EQpkbA;I0CnCM,cAAA;IACA,WAAA;IACA,eAAA;ElD0mbN;EQzkbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,6BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,6CAAA;IAMF,sBAAA;ElD4ibA;EQ9kbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDijbA;EQnlbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElDsjbA;EQxlbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD2jbA;EQ7lbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDgkbA;EQlmbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElDqkbA;EQvmbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD0kbA;EQ5mbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD+kbA;EQjnbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElDolbA;EQtnbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDylbA;EQ3nbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD8lbA;EQhobA;I0CyBA,YAAA;IAAA,cAAA;IAAA,sBAAA;IASA,eAAA;ElDkmbA;EQpobA;I0CnBM,SAAA;ElD0pbN;EQvobA;I0CfM,SAAA;ElDypbN;EQ1obA;I0CVQ,QAAA;ElDupbR;EQ7obA;I0CVQ,QAAA;ElD0pbR;EQhpbA;I0CVQ,QAAA;ElD6pbR;EQnpbA;I0CVQ,QAAA;ElDgqbR;EQtpbA;I0CVQ,QAAA;ElDmqbR;EQzpbA;I0CVQ,QAAA;ElDsqbR;EQ5pbA;I0CVQ,QAAA;ElDyqbR;EQ/pbA;I0CVQ,QAAA;ElD4qbR;EQlqbA;I0CVQ,QAAA;ElD+qbR;EQrqbA;I0CVQ,QAAA;ElDkrbR;EQxqbA;I0CVQ,SAAA;ElDqrbR;EQ3qbA;I0CVQ,SAAA;ElDwrbR;EQ9qbA;I0CVQ,SAAA;ElD2rbR;EQjrbA;IuBRA,cAAA;E/B4rbA;EQprbA;IuBLA,wBAAA;E/B4rbA;EQvrbA;IuBLA,yBAAA;E/B+rbA;EQ1rbA;IuBLA,gBAAA;E/BksbA;EQ7rbA;IuBLA,yBAAA;E/BqsbA;EQhsbA;IuBLA,yBAAA;E/BwsbA;EQnsbA;IuBLA,gBAAA;E/B2sbA;EQtsbA;IuBLA,yBAAA;E/B8sbA;EQzsbA;IuBLA,yBAAA;E/BitbA;EQ5sbA;IuBLA,gBAAA;E/BotbA;EQ/sbA;IuBLA,yBAAA;E/ButbA;EQltbA;IuBLA,yBAAA;E/B0tbA;AACF;AQttbE;EAAA;I0CzCM,aAAA;IACA,YAAA;IACA,eAAA;ElDmwbN;EQ5tbA;I0CnCM,cAAA;IACA,WAAA;IACA,eAAA;ElDkwbN;EQjubA;I0CyBA,YAAA;IAAA,cAAA;IAAA,6BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,6CAAA;IAMF,sBAAA;ElDosbA;EQtubA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDysbA;EQ3ubA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElD8sbA;EQhvbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDmtbA;EQrvbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDwtbA;EQ1vbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElD6tbA;EQ/vbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDkubA;EQpwbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDuubA;EQzwbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElD4ubA;EQ9wbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDivbA;EQnxbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDsvbA;EQxxbA;I0CyBA,YAAA;IAAA,cAAA;IAAA,sBAAA;IASA,eAAA;ElD0vbA;EQ5xbA;I0CnBM,SAAA;ElDkzbN;EQ/xbA;I0CfM,SAAA;ElDizbN;EQlybA;I0CVQ,QAAA;ElD+ybR;EQrybA;I0CVQ,QAAA;ElDkzbR;EQxybA;I0CVQ,QAAA;ElDqzbR;EQ3ybA;I0CVQ,QAAA;ElDwzbR;EQ9ybA;I0CVQ,QAAA;ElD2zbR;EQjzbA;I0CVQ,QAAA;ElD8zbR;EQpzbA;I0CVQ,QAAA;ElDi0bR;EQvzbA;I0CVQ,QAAA;ElDo0bR;EQ1zbA;I0CVQ,QAAA;ElDu0bR;EQ7zbA;I0CVQ,QAAA;ElD00bR;EQh0bA;I0CVQ,SAAA;ElD60bR;EQn0bA;I0CVQ,SAAA;ElDg1bR;EQt0bA;I0CVQ,SAAA;ElDm1bR;EQz0bA;IuBRA,cAAA;E/Bo1bA;EQ50bA;IuBLA,wBAAA;E/Bo1bA;EQ/0bA;IuBLA,yBAAA;E/Bu1bA;EQl1bA;IuBLA,gBAAA;E/B01bA;EQr1bA;IuBLA,yBAAA;E/B61bA;EQx1bA;IuBLA,yBAAA;E/Bg2bA;EQ31bA;IuBLA,gBAAA;E/Bm2bA;EQ91bA;IuBLA,yBAAA;E/Bs2bA;EQj2bA;IuBLA,yBAAA;E/By2bA;EQp2bA;IuBLA,gBAAA;E/B42bA;EQv2bA;IuBLA,yBAAA;E/B+2bA;EQ12bA;IuBLA,yBAAA;E/Bk3bA;AACF;AQ92bE;EAAA;I0CzCM,aAAA;IACA,YAAA;IACA,eAAA;ElD25bN;EQp3bA;I0CnCM,cAAA;IACA,WAAA;IACA,eAAA;ElD05bN;EQz3bA;I0CyBA,YAAA;IAAA,cAAA;IAAA,6BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,6CAAA;IAMF,sBAAA;ElD41bA;EQ93bA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDi2bA;EQn4bA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElDs2bA;EQx4bA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD22bA;EQ74bA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDg3bA;EQl5bA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElDq3bA;EQv5bA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD03bA;EQ55bA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD+3bA;EQj6bA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElDo4bA;EQt6bA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDy4bA;EQ36bA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD84bA;EQh7bA;I0CyBA,YAAA;IAAA,cAAA;IAAA,sBAAA;IASA,eAAA;ElDk5bA;EQp7bA;I0CnBM,SAAA;ElD08bN;EQv7bA;I0CfM,SAAA;ElDy8bN;EQ17bA;I0CVQ,QAAA;ElDu8bR;EQ77bA;I0CVQ,QAAA;ElD08bR;EQh8bA;I0CVQ,QAAA;ElD68bR;EQn8bA;I0CVQ,QAAA;ElDg9bR;EQt8bA;I0CVQ,QAAA;ElDm9bR;EQz8bA;I0CVQ,QAAA;ElDs9bR;EQ58bA;I0CVQ,QAAA;ElDy9bR;EQ/8bA;I0CVQ,QAAA;ElD49bR;EQl9bA;I0CVQ,QAAA;ElD+9bR;EQr9bA;I0CVQ,QAAA;ElDk+bR;EQx9bA;I0CVQ,SAAA;ElDq+bR;EQ39bA;I0CVQ,SAAA;ElDw+bR;EQ99bA;I0CVQ,SAAA;ElD2+bR;EQj+bA;IuBRA,cAAA;E/B4+bA;EQp+bA;IuBLA,wBAAA;E/B4+bA;EQv+bA;IuBLA,yBAAA;E/B++bA;EQ1+bA;IuBLA,gBAAA;E/Bk/bA;EQ7+bA;IuBLA,yBAAA;E/Bq/bA;EQh/bA;IuBLA,yBAAA;E/Bw/bA;EQn/bA;IuBLA,gBAAA;E/B2/bA;EQt/bA;IuBLA,yBAAA;E/B8/bA;EQz/bA;IuBLA,yBAAA;E/BigcA;EQ5/bA;IuBLA,gBAAA;E/BogcA;EQ//bA;IuBLA,yBAAA;E/BugcA;EQlgcA;IuBLA,yBAAA;E/B0gcA;AACF;AQtgcE;EAAA;I0CzCM,aAAA;IACA,YAAA;IACA,eAAA;ElDmjcN;EQ5gcA;I0CnCM,cAAA;IACA,WAAA;IACA,eAAA;ElDkjcN;EQjhcA;I0CyBA,YAAA;IAAA,cAAA;IAAA,6BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,6CAAA;IAMF,sBAAA;ElDo/bA;EQthcA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDy/bA;EQ3hcA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElD8/bA;EQhicA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDmgcA;EQricA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDwgcA;EQ1icA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElD6gcA;EQ/icA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDkhcA;EQpjcA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDuhcA;EQzjcA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElD4hcA;EQ9jcA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDiicA;EQnkcA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDsicA;EQxkcA;I0CyBA,YAAA;IAAA,cAAA;IAAA,sBAAA;IASA,eAAA;ElD0icA;EQ5kcA;I0CnBM,SAAA;ElDkmcN;EQ/kcA;I0CfM,SAAA;ElDimcN;EQllcA;I0CVQ,QAAA;ElD+lcR;EQrlcA;I0CVQ,QAAA;ElDkmcR;EQxlcA;I0CVQ,QAAA;ElDqmcR;EQ3lcA;I0CVQ,QAAA;ElDwmcR;EQ9lcA;I0CVQ,QAAA;ElD2mcR;EQjmcA;I0CVQ,QAAA;ElD8mcR;EQpmcA;I0CVQ,QAAA;ElDincR;EQvmcA;I0CVQ,QAAA;ElDoncR;EQ1mcA;I0CVQ,QAAA;ElDuncR;EQ7mcA;I0CVQ,QAAA;ElD0ncR;EQhncA;I0CVQ,SAAA;ElD6ncR;EQnncA;I0CVQ,SAAA;ElDgocR;EQtncA;I0CVQ,SAAA;ElDmocR;EQzncA;IuBRA,cAAA;E/BoocA;EQ5ncA;IuBLA,wBAAA;E/BoocA;EQ/ncA;IuBLA,yBAAA;E/BuocA;EQlocA;IuBLA,gBAAA;E/B0ocA;EQrocA;IuBLA,yBAAA;E/B6ocA;EQxocA;IuBLA,yBAAA;E/BgpcA;EQ3ocA;IuBLA,gBAAA;E/BmpcA;EQ9ocA;IuBLA,yBAAA;E/BspcA;EQjpcA;IuBLA,yBAAA;E/BypcA;EQppcA;IuBLA,gBAAA;E/B4pcA;EQvpcA;IuBLA,yBAAA;E/B+pcA;EQ1pcA;IuBLA,yBAAA;E/BkqcA;AACF;AiDvmcA;;EAOI,UAAA;AjDomcJ;AiD3mcA;EAUI,gBAAA;EACA,eAAA;EACA,cAAA;AjDomcJ;AiDhncA;EAcM,cAAA;AjDqmcN;AiDnncA;EAkBI,gBAAA;EACA,6BAAA;EACA,iBAAA;EACA,YAAA;EAAA,cAAA;EAAA,6BAAA;AjDomcJ;AiDhmcA;EA0BE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AjDykcF;AiDtmcA;EjDwmcE,oEAAoE;EiDpmclE,qBAAA;AjDsmcJ;AiDrmcI;EACE,WAAA;AjDumcN;AiDrmcI;EACE,YAAA;AjDumcN;AiDrmcI;EACE,WAAA;AjDumcN;AiDnncA;EAeM,oBAAA;EACA,uBAAA;EACA,mBAAA;AjDumcN;AiDxncA;EAmBQ,aAAA;EACA,WAAA;EACA,kBAAA;AjDwmcR;AiD7ncA;EA+BI,cAAA;AjDimcJ;AiDhocA;EAkCI,SAAA;EACA,YAAA;EACA,sBAAA;EACA,4BAAA;AjDimcJ;AiDtocA;EAwCI,gBAAA;AjDimcJ;AiDzocA;EA2CI,mBAAA;EACA,mBAAA;EACA,kBAAA;AjDimcJ;AiD9ocA;EAgDI,aAAA;EACA,eAAA;AjDimcJ;AiDlpcA;EAmDM,cAAA;EACA,aAAA;AjDkmcN;AiDtpcA;EAwDI,eAAA;EACA,sBAAA;AjDimcJ;AiD1pcA;EA2DM,cAAA;AjDkmcN;AiDhmcI;EACE,YAAA;AjDkmcN;AiD/lcE;EAEI,mBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;AjDgmcN;AiD/lcM;EAAA;IACE,mBAAA;IACA,uBAAA;IACA,2BAAA;EjDkmcN;AACF;AiDpncE;EAqBI,gBAAA;AjDkmcN;AiDvncE;EAwBI,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AjDkmcN;AiD7ncE;EA6BM,iBAAA;AjDmmcR;AiDjmcM;EAAA;IACE,cAAA;EjDomcN;AACF;AiDtscA;EAsGI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AjDmmcJ;AiDhtcA;EA+GM,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AjDomcN;AiDlmcI;EAAA;IACE,cAAA;EjDqmcJ;AACF;AiD7tcA;EA2HI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;AjDqmcJ;AiDjmcA;EAEI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EAIA,gBAAA;EACA,eAAA;EACA,mBAAA;AjD+lcJ;AiDpmcI;EAAA;IACE,YAAA;EjDumcJ;AACF;AiDjncA;EAeM,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AjDqmcN;AiDpmcM;EACE,eAAA;AjDsmcR;AiD1ncA;EAyBI,cAAA;AjDomcJ;AiD7ncA;EA2BM,gBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AjDqmcN;AiDtocA;EAmCQ,eAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;AjDsmcR;AiDnmcI;EAEI,gBAAA;EACA,cAAA;AjDomcR;AiDvmcI;EAKM,aAAA;AjDqmcV;AiD9lcA;EAEI,aAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;AjD+lcJ;AiD9lcI;EACE,aAAA;EACA,eAAA;EACA,UAAA;EACA,SAAA;AjDgmcN;AiD1mcA;EAaM,UAAA;AjDgmcN;AiD9lcI;EAGM,cAAA;EACA,gBAAA;AjD8lcV;AiDjncA;EAyBI,aAAA;EACA,yBAAA;EACA,aAAA;EACA,SAAA;AjD2lcJ;AiDvlcA;EACE,aAAA;EACA,sBAAA;EACA,cAAA;AjDylcF;AiDtlcA;EACE,aAAA;EACA,eAAA;EACA,6BAAA;EAIA,SAAA;EACA,SAAA;EACA,gBAAA;AjDqlcF;AiD1lcE;EAAA;IACE,yBAAA;EjD6lcF;AACF;AiDtlcE;EACE,cAAA;AjDwlcJ;AiD1lcA;EAKI,8BAAA;AjDwlcJ;AiD7lcA;EAOM,WAAA;AjDylcN;AiDhmcA;EAWI,gBAAA;AjDwlcJ;AiDplcA;EACE,gBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AjDslcF;AiDnlcA;EAEI,gBAAA;AjDolcJ;AiDjlcI;EAEI,eAAA;AjDklcR;AiD/kcI;EACE,gBAAA;AjDilcN;AiD5lcA;;;EnDxJE,WAAA;EACA,YAAA;EACA,kBAAA;EmDsKE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AjDolcJ;AiDvmcA;EAsBI,qBAAA;AjDolcJ;AiDhlcA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;AjDklcF;AiD/kcA;EACE,aAAA;EACA,cAAA;AjDilcF;AiDnlcA;EAII,iBAAA;EACA,SAAA;AjDklcJ;AiDvlcA;EnDxLE,WAAA;EACA,YAAA;EACA,kBAAA;AEkxcF;AiD5lcA;EAWI,cAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AjDolcJ;AiDlmcA;EAiBI,cAAA;EACA,gBAAA;AjDolcJ;AiDtmcA;EAqBI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AjDolcJ;AiD5mcA;EA2BI,gBAAA;EACA,gBAAA;EACA,cAAA;AjDolcJ;AiDhlcA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AjDklcF;AiD/kcA;EAEI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AjDglcJ;AiDrlcA;EAQI,cAAA;AjDglcJ;AiD5kcA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AjD8kcF;AiDrlcA;EASI,qBAAA;AjD+kcJ;AiD3kcA;EACE;IACE,eAAA;EjD6kcF;AACF;AiD1kcA;EACE,UAAA;AjD4kcF;AiDzkcA;EAGM,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AjDykcN;AiDxkcM;EACE,SAAA;EACA,cAAA;AjD0kcR;AiDnlcA;EAaM,WAAA;AjDykcN;AiDtlcA;EAgBM,eAAA;AjDykcN;AiDzlcA;EAmBM,eAAA;AjDykcN;AiD5lcA;EAsBM,qBAAA;EACA,gBAAA;AjDykcN;AiDhmcA;EA2BQ,mBAAA;AjDwkcR;AiDnmcA;EA+BM,gBAAA;AjDukcN;AiDtmcA;EAkCM,iBAAA;EACA,gBAAA;EACA,cAAA;AjDukcN;AiDnkcA;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;AjDqkcF;AiDpkcE;EACE,aAAA;AjDskcJ;AiDpkcE;EACE,8BAAA;AjDskcJ;AiDlkcA;EAEI,YAAA;AjDmkcJ;AiDrkcA;EAKI,SAAA;AjDmkcJ;AiDnjcA;EACI;IAAG,2BAAA;EjD4kcL;EiD3kcE;IAAI,6BAAA;EjD8kcN;EiD7kcE;IAAK,2BAAA;EjDglcP;AACF;AiD9kcA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AjDglcF;AiDrlcA;EAOI,0BAAA;AjDilcJ;AiDxlcA;EAUI,aAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;AjDilcJ;AiDrmcA;EAsBM,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,qDAAA;EACA,0BAAA;EAGA,mDAAA;AjDklcN;AiDrncA;EAsCM,WAAA;AjDklcN;AiDxncA;EAyCM,YAAA;AjDklcN;AiDhlcI;EAAA;IACE,YAAA;IACA,eAAA;EjDmlcJ;EiDrlcE;IAII,eAAA;IACA,YAAA;EjDolcN;EiDzlcE;IAOM,WAAA;IACA,YAAA;EjDqlcR;AACF;AiDjlcE;EACE,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;AjDmlcJ;AiDtpcA;EAsEI,aAAA;AjDmlcJ;AiDhlcA;EACE,mBAAA;EACA,aAAA;AjDklcF;AiDplcA;EAII,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;AjDmlcJ;AiD1lcA;EAUI,mBAAA;AjDmlcJ;AiDjlcE;EACE,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,SAAA;AjDmlcJ;AiDllcI;;EACE,aAAA;EACA,cAAA;AjDqlcN;AiDnlcI;EACE,aAAA;EACA,eAAA;EACA,cAAA;AjDqlcN;AiDllcE;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EAsBA,iBAAA;AjD+jcJ;AiDplcI;EACE,cAAA;EACA,cAAA;EACA,eAAA;AjDslcN;AiDzlcI;EAKI,cAAA;EACA,SAAA;AjDulcR;AiDplcI;EAAA;IACE,cAAA;IACA,yBAAA;IACA,2BAAA;IAAA,sBAAA;EjDulcJ;EiDtlcI;IACE,cAAA;IACA,cAAA;EjDwlcN;EiD1lcI;IAII,cAAA;EjDylcR;AACF;AiDjncE;EA6BI,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;AjDulcN;AiDtlcM;EACE,eAAA;AjDwlcR;AiD7ncE;EAwCM,YAAA;EACA,mBAAA;AjDwlcR;AiDjocE;EA6CI,gBAAA;EACA,cAAA;AjDulcN;AiDplcE;EACE,cAAA;EACA,gBAAA;AjDslcJ;AiDpqcA;EAiFI,oBAAA;EACA,iBAAA;EACA,gBAAA;AjDslcJ;AiDplcE;;EACE,cAAA;AjDulcJ;AiD7qcA;;;EA0FI,qBAAA;EACA,gBAAA;AjDwlcJ;AiDplcA;EACE,8BAAA;AjDslcF;AiDllcA;EACE,aAAA;EACA,eAAA;EACA,gBAAA;AjDolcF;AiDvlcA;EAKI,WAAA;EACA,YAAA;AjDqlcJ;AiDjlcA;EACE,mBAAA;EACA,aAAA;EACA,mEAAA;EACA,6BAAA;EACA,SAAA;EACA,eAAA;AjDmlcF;AiDllcE;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,QAAA;AjDolcJ;AiDxlcE;EAMI,gBAAA;AjDqlcN;AiDlmcA;EAiBI,0BAAA;AjDolcJ;AiDrmcA;EAoBI,aAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AjDolcJ;AiDjncA;EA+BM,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qDAAA;EACA,0BAAA;EAGA,mDAAA;AjDqlcN;AiDhocA;EA8CM,gBAAA;EACA,eAAA;EACA,qDAAA;EACA,0BAAA;EAGA,mDAAA;AjDqlcN;AiDzocA;EAwDI,cAAA;EACA,SAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;AjDolcJ;AiDllcE;EACE,cAAA;AjDolcJ;AiDjlcA;EACE,WAAA;EACA,mBAAA;AjDmlcF;AiDrlcA;EAKM,cAAA;EACA,mBAAA;EACA,aAAA;AjDmlcN;AiDllcM;EACE,eAAA;AjDolcR;AiD7lcA;EAcI,cAAA;EACA,gBAAA;EACA,mBAAA;AjDklcJ;AiDlmcA;EAkBM,6BAAA;AjDmlcN;AiDrmcA;EAsBI,yBAAA;EACA,WAAA;EACA,sBAAA;AjDklcJ;AiD1mcA;EA0BM,SAAA;EACA,UAAA;AjDmlcN;AiD9mcA;EA8BM,aAAA;EACA,mBAAA;AjDmlcN;AiDlncA;EAiCQ,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,4BAAA;AjDolcR;AiDxncA;EAyCI,eAAA;EACA,mBAAA;EACA,aAAA;AjDklcJ;AiDjlcI;EAAA;IACE,mBAAA;EjDolcJ;AACF;AiDlocA;EAiDI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;AjDolcJ;AiDnlcI;EAAA;IACE,mBAAA;EjDslcJ;AACF;AiD7ocA;EAyDM,YAAA;AjDulcN;AiDnlcA;EAEI,aAAA;EACA,eAAA;EACA,aAAA;AjDolcJ;AiDxlcA;EAOI,cAAA;AjDolcJ;AiD3lcA;EAUI,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,cAAA;AjDolcJ;AiDnmcA;EAiBM,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AjDqlcN;AiDhncA;EA6BQ,YAAA;EACA,aAAA;EACA,kBAAA;AjDslcR;AiDrncA;EAmCM,qBAAA;AjDqlcN;AiDxncA;;EAsCM,aAAA;AjDslcN;AiD5ncA;EAyCM,cAAA;EACA,eAAA;AjDslcN;AiDhocA;EA6CM,iBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AjDslcN;AiDrlcM;EACE,YAAA;AjDulcR;AiD1ocA;EAuDM,qBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AjDslcN;AiDhlcE;EACE,cAAA;AjDklcJ;AiDhlcE;EACE,YAAA;EAAA,cAAA;EAAA,6BAAA;AjDklcJ;AiDvlcA;EAQI,WAAA;AjDklcJ;AiD1lcA;EAWI,YAAA;AjDklcJ;AiD7lcA;EAcI,oBAAA;AjDklcJ;AiD/kcA;;EAIQ,sBAAA;AjD+kcR;AiDnlcA;;EAQM,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AjD+kcN;AiD9lcA;;EAiBQ,YAAA;AjDilcR;AiD/kcM;;EAGI,uBAAA;AjDilcV;AiDvmcA;;EA0BQ,cAAA;EACA,eAAA;AjDilcR;AiD5mcA;;EA+BM,cAAA;EACA,eAAA;AjDilcN;AiDhlcM;;EACE,qBAAA;EACA,sBAAA;AjDmlcR;AiDtncA;;EAsCQ,gCAAA;AjDolcR;AiD1ncA;;EA0CU,YAAA;EACA,gBAAA;EACA,4BAAA;AjDolcV;AiDhocA;;EAkDI,aAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AjDklcJ;AiDjlcI;;EACE,gBAAA;AjDolcN;AiD3ocA;;EA0DM,eAAA;AjDqlcN;AiD/ocA;;EA6DM,cAAA;EACA,gBAAA;AjDslcN;AiDppcA;;EAiEM,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,MAAA;AjDulcN;AiD5pcA;;EAuEQ,YAAA;EACA,eAAA;EACA,iBAAA;AjDylcR;AiDlqcA;;EA4EQ,cAAA;AjD0lcR;AiDtqcA;;EA+EQ,cAAA;AjD2lcR;AiDrlcA;EACE,2BAAA;AjDulcF;AiDplcA;EACE,uBAAA;EACA,gBAAA;AjDslcF;AiDnlcA;EAGM,aAAA;EACA,mBAAA;AjDmlcN;AiDvlcA;EAOU,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,iBAAA;EACA,mBAAA;AjDmlcV;AiDllcU;EAGI,uBAAA;AjDmlcd;AiDxmcA;EAyBY,YAAA;AjDklcZ;AiD3mcA;EA6BU,cAAA;EACA,cAAA;AjDilcV;AiD/mcA;EAoCQ,sBAAA;AjD8kcR;AiDlncA;EAuCQ,UAAA;EACA,YAAA;EACA,iBAAA;AjD8kcR;AiDvncA;EA2CU,iBAAA;AjD+kcV;AiD1ncA;EA+CQ,kBAAA;AjD8kcR;AiD5jcE;EACE,oBAAA;AjD8jcJ;AiD7jcI;EAAA;IACE,eAAA;EjDgkcJ;AACF;AiDrkcA;EASM,SAAA;EACA,oBAAA;AjD+jcN;AiD3jcA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AjD6jcF;AiD1jcA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kDAAA;EACA,mBAAA;AjD4jcF;AiD1jcA;EACE,iBAAA;AjD4jcF;AiD7jcA;EAGI,gBAAA;AjD6jcJ;AiDhkcA;EAKM,aAAA;EACA,eAAA;EACA,mBAAA;AjD8jcN;AiDrkcA;EASQ,6BAAA;EACA,gBAAA;EACA,sBAAA;AjD+jcR;AiD1kcA;EAaU,eAAA;AjDgkcV;AiD/jcU;EAAA;IACE,YAAA;EjDkkcV;AACF;AiD5jcA;EAEI,aAAA;EACA,eAAA;EACA,cAAA;AjD6jcJ;AiDjkcA;EAMM,gBAAA;EACA,SAAA;AjD8jcN;AiD1jcA;EACE,gBAAA;AjD4jcF;AiD1jcA;EAEI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;AjD2jcJ;AiDlkcA;EDmTE,cAAA;EACA,0BAAA;AhDkxbF;AiDtkcA;EAYQ,eAAA;EACA,iBAAA;AjD6jcR;AiD1kcA;;EDwTI,wBAAA;EACA,eAAA;AhDsxbJ;AgDnxbE;EACE,cAAA;AhDqxbJ;AgDlxbE;EACE,cAAA;EACA,qBAAA;AhDoxbJ;AgDlxbI;EACE,0BAAA;AhDoxbN;AiDtkcA;EACE,aAAA;EACA,cAAA;AjDwkcF;AiD1kcA;EAII,aAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AjDykcJ;AiDxkcI;EAAA;IACE,eAAA;EjD2kcJ;AACF;AiDzlcA;EAiBI,aAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;AjD2kcJ;AiD1kcI;EAAA;IACE,eAAA;EjD6kcJ;AACF;AiDxmcA;EA6BM,iBAAA;EACA,cAAA;EACA,cAAA;AjD8kcN;AiD7mcA;EAkCM,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AjD8kcN;AiDpncA;EAyCM,iBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;AjD8kcN;AiD1ncA;EAgDI,aAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;AjD6kcJ;AiD5kcI;EAAA;IACE,cAAA;EjD+kcJ;AACF;AiDzocA;EA4DM,iBAAA;EACA,eAAA;AjDglcN;AiD1kcA;EACE,aAAA;EAEA,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EAEA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AjD0kcF;AiDtlcA;EAcI,WAAA;EACA,aAAA;EAIA,iBAAA;AjDwkcJ;AiD3kcI;EAAA;IACE,aAAA;EjD8kcJ;AACF;AiD3kcE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,0EAAA;EACA,kBAAA;AjD6kcJ;AiD1mcA;EAgCI,kBAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;AjD6kcJ;AiDjncA;EAsCM,cAAA;EACA,gBAAA;AjD8kcN;AiDrncA;EA2CI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;AjD6kcJ;AiD5kcI;EAAA;IACE,eAAA;EjD+kcJ;AACF;AiDvocA;EA0DM,iBAAA;EACA,cAAA;EACA,cAAA;AjDglcN;AiD5ocA;EA+DM,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AjDglcN;AiDnpcA;EAsEM,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AjDglcN;AiD3kcA;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AjD6kcF;AiDjlcA;EAMI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;AjD8kcJ;AiDvlcA;EAYI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AjD8kcJ;AiD7lcA;EAiBM,qBAAA;AjD+kcN;AiDhmcA;EAqBI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AjD8kcJ;AiDtmcA;EA0BM,WAAA;EACA,eAAA;EACA,iBAAA;AjD+kcN;AiD3mcA;EA+BM,qBAAA;AjD+kcN;AiD1kcA;EACE,wBAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,kBAAA;AjD4kcF;AiDjlcA;EAOI,WAAA;EACA,uBAAA;AjD6kcJ;AiDrlcA;EAWI,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AjD6kcJ;AiD5lcA;EAiBM,YAAA;EACA,WAAA;EACA,iBAAA;AjD8kcN;AiDjmcA;EAuBI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;AjD6kcJ;AiDxmcA;EA6BM,WAAA;AjD8kcN;AiD3kcE;EACE,aAAA;EACA,cAAA;EACA,uBAAA;AjD6kcJ;AiDzkcA;EnD9qCE,WAAA;EACA,YAAA;EACA,kBAAA;EmD8qCA,kCAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,6CAAA;AjD6kcF;AiD1kcA;EAEI,oBAAA;AjD2kcJ;AiD7kcA;EAKI,aAAA;EACA,eAAA;EACA,8BAAA;AjD2kcJ;AiDllcA;EASM,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AjD4kcN;AiD5lcA;EAkBQ,iBAAA;EACA,YAAA;AjD6kcR;AiDhmcA;EAsBQ,eAAA;EACA,mBAAA;AjD6kcR;AiDpmcA;EAyBU,qBAAA;AjD8kcV;AiDvmcA;EA6BQ,YAAA;EACA,cAAA;AjD6kcR;AiD1kcI;EAAA;IACE,sBAAA;EjD6kcJ;EiD9kcE;IAIM,UAAA;EjD6kcR;EiDjlcE;IAQQ,eAAA;EjD4kcV;EiDplcE;;IAYM,eAAA;EjD4kcR;EiDxlcE;IAeM,gBAAA;IACA,gBAAA;EjD4kcR;AACF;AiD9ncA;EAuDI,kBAAA;AjD0kcJ;AiDjocA;;EA4DQ,iBAAA;AjDykcR;AiDxkcQ;;EACE,YAAA;AjD2kcV;AiDzocA;EAmEM,kBAAA;EACA,kBAAA;AjDykcN;AiD7ocA;EAwEI,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;AjDwkcJ;AiDlkcI;EACE,kBAAA;AjDokcN;AiDvkcA;EAMM,6BAAA;AjDokcN;AiDnkcM;EACE,eAAA;AjDqkcR;AiD/jcA;EACE,WAAA;AjDikcF;AiDhkcE;EACE,WAAA;AjDkkcJ;AiDhkcE;EACE,WAAA;AjDkkcJ;AiDhkcE;EACE,iBAAA;AjDkkcJ;AiDhkcE;EACE,iBAAA;AjDkkcJ;AiDhkcE;EACE,iBAAA;AjDkkcJ;AiD3jcM;;EACE,WAAA;AjD8jcR;AiDlkcA;EASI,mBAAA;AjD4jcJ;AiDxjcA;EACE,iBAAA;AjD0jcF;AiDvjcA;EAEI,SAAA;AjDwjcJ;AiD1jcA;EAKI,gBAAA;AjDwjcJ;AiDtjcE;EACE,mBAAA;AjDwjcJ;AiDpjcA;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;AjDsjcF;AiD5jcA;EASM,aAAA;AjDsjcN;AiDjjcA;EACE,oBAAA;AjDmjcF;AiDpjcA;EAGI,iBAAA;AjDojcJ;AiDvjcA;EAMI,iBAAA;AjDojcJ;AiD1jcA;EASI,YAAA;AjDojcJ;AiD7jcA;EAYI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AjDojcJ;AiDnkcA;EAiBM,YAAA;AjDqjcN;AiDtkcA;EAqBI,eAAA;EACA,iBAAA;AjDojcJ;AiD1kcA;EAwBM,kBAAA;AjDqjcN;AiDhjcA;EAEI,SAAA;AjDijcJ;AiDnjcA;EAKI,kBAAA;AjDijcJ;AiD7icA;EACE,aAAA;AjD+icF;AiDhjcA;EAGI,aAAA;EACA,mBAAA;EACA,iBAAA;EnDn4CF,WAAA;EACA,YAAA;EACA,kBAAA;EmDq4CE,mBAAA;AjDgjcJ;AiD/icI;EACI,mBAAA;AjDijcR;AiD5jcA;EAcM,UAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,uBAAA;AjDijcN;AiD5icA;EACE,cAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;AjD8icF;AiDljcA;EAMI,YAAA;AjD+icJ;AiD9icI;EACE,YAAA;AjDgjcN;AiDxjcA;EAWM,iBAAA;AjDgjcN;AiD3jcA;EAaQ,eAAA;EACA,gBAAA;EACA,mBAAA;AjDijcR;AiD5icA;EACE;IACE,aAAA;EjD8icF;EiD5icA;IAGM,eAAA;EjD4icN;AACF;AiDvicA;EACE,qBAAA;EACA,kBAAA;AjDyicF;AiDticA;EACE,iBAAA;EACA,cAAA;EACA,eAAA;AjDwicF;AiDvicE;EACE,cAAA;AjDyicJ;AiDricA;EACE,aAAA;EACA,eAAA;AjDuicF;AiDzicA;EAII,4BAAA;AjDwicJ;AiD5icA;EAOI,cAAA;AjDwicJ;AiD/icA;EASM,gBAAA;AjDyicN;AiDljcA;EAaI,kBAAA;EACA,YAAA;EACA,aAAA;AjDwicJ;AiDvjcA;EAiBM,YAAA;EACA,aAAA;EACA,sBAAA;AjDyicN;AiD5jcA;EAqBQ,YAAA;EACA,aAAA;AjD0icR;AiDpicA;EACE,gBAAA;EACA,cAAA;AjDsicF;AiDricE;EACE,aAAA;AjDuicJ;AiDricE;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;AjDuicJ;AiDnicA;EACE,aAAA;EAIA,cAAA;AjDkicF;AiDricE;EAAA;IACE,8CAAA;EjDwicF;AACF;AiDticE;EACE,aAAA;EACA,eAAA;AjDwicJ;AiDhjcA;EAWI,gBAAA;EACA,gBAAA;AjDwicJ;AiDpjcA;EAeI,aAAA;EACA,eAAA;EACA,WAAA;AjDwicJ;AiDzjcA;;EAmBM,qBAAA;AjD0icN;AiD7jcA;EAsBM,WAAA;EACA,YAAA;EACA,SAAA;AjD0icN;AiDlkcA;EnDj/CE,WAAA;EACA,YAAA;EACA,kBAAA;AEsjfF;AiDvkcA;EA8BM,aAAA;EACA,cAAA;EACA,eAAA;AjD4icN;AiD5kcA;EAmCM,cAAA;EACA,yBAAA;EACA,cAAA;AjD4icN;AiDjlcA;EAwCM,aAAA;EACA,cAAA;AjD4icN;AiDrlcA;EA4CM,aAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EAiBA,cAAA;AjD4hcN;AiD5icM;EACE,WAAA;EnDviDN,UAAA;EACA,WAAA;EACA,kBAAA;EmDuiDM,mBAAA;EACA,cAAA;AjDgjcR;AiD9icM;EACE,mBAAA;EACA,cAAA;AjDgjcR;AiD/icQ;EACE,WAAA;EnDhjDR,UAAA;EACA,WAAA;EACA,kBAAA;EmDgjDQ,mBAAA;EACA,cAAA;AjDmjcV;AiDrncA;EAyEM,gBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;AjD+icN;AiD5ncA;EA+EQ,cAAA;EACA,aAAA;EAEA,WAAA;EACA,mBAAA;AjD+icR;AiDlocA;EAsFQ,WAAA;EACA,eAAA;EACA,iBAAA;AjD+icR;AiD5icI;EAAA;IACE,iBAAA;EjD+icJ;EiDhjcE;IAGI,cAAA;EjDgjcN;EiDnjcE;IAMI,kBAAA;IACA,SAAA;IACA,WAAA;IACA,iBAAA;IACA,QAAA;EjDgjcN;AACF;AiD3icA;EACE,aAAA;AjD6icF;AiD9icA;EAGI,gBAAA;AjD8icJ;AiD1icA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;AjD4icF;AiD1icA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AjD4icF;AiDzicA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AjD2icF;AiDxicA;EACE,aAAA;EACA,eAAA;AjD0icF;AiDxicA;EACE,aAAA;AjD0icF;AiD3icA;EAGI,kBAAA;EACA,mBAAA;AjD2icJ;AiD/icA;EAOI,6BAAA;EACA,kBAAA;AjD2icJ;AiDxicI;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AjD0icN;AiD7icI;EAKI,cAAA;EACA,iBAAA;AjD2icR;AiDjjcI;EASI,iBAAA;AjD2icR;AiDxicI;EACE,iBAAA;AjD0icN;AiD3icI;EAGI,kBAAA;AjD2icR;AiDrkcA;EA8BM,gBAAA;EACA,aAAA;EACA,yBAAA;AjD0icN;AiD1kcA;EAkCQ,kBAAA;EACA,aAAA;AjD2icR;AiD9kcA;EAsCQ,WAAA;EACA,YAAA;AjD2icR;AiDllcA;EAyCU,WAAA;EACA,YAAA;AjD4icV;AiDtlcA;EAgDQ,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AjDyicR;AiDpicA;EACE,gBAAA;AjDsicF;AiDnicA;EACE,aAAA;EACA,wCAAA;EACA,0BAAA;EACA,2CAAA;EACA,aAAA;EACA,YAAA;AjDqicF;AiDpicE;EAAA;IACE,sCAAA;IACA,gCAAA;IACA,uBAAA;EjDuicF;AACF;AiDljcA;EAaI,aAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,aAAA;AjDwicJ;AiDvicI;EAAA;IACE,UAAA;IACA,mBAAA;EjD0icJ;AACF;AiDhkcA;EAwBM,YAAA;AjD2icN;AiDnkcA;EA4BQ,cAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AjD0icR;AiDzkcA;EAoCQ,SAAA;AjDwicR;AiD5kcA;EAsCU,eAAA;AjDyicV;AiD/kcA;EAyCU,eAAA;AjDyicV;AiDllcA;EA2CY,mBAAA;AjD0icZ;AiDrlcA;EA8CY,gBAAA;EACA,cAAA;AjD0icZ;AiDzlcA;EAkDY,cAAA;AjD0icZ;AiD5lcA;EAqDY,mBAAA;AjD0icZ;AiD/lcA;EA0DQ,iBAAA;EACA,cAAA;AjDwicR;AiDnmcA;EA8DQ,iBAAA;AjDwicR;AiDtmcA;EAgEU,cAAA;AjDyicV;AiDzmcA;EAoEQ,cAAA;AjDwicR;AiD5mcA;EAyEI,mBAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;AjDsicJ;AiDlncA;EA+EI,kBAAA;AjDsicJ;AiDrncA;;EnDnrDE,kBAAA;EmDswDE,WAAA;EACA,YAAA;AjDuicJ;AiDnicA;EAEI,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,QAAA;AjDoicJ;AiD3icA;EASM,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AjDqicN;AiDljcA;EAgBM,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AjDqicN;AiDhicA;EAEI,gBAAA;AjDiicJ;AiDnicA;EAKI,gBAAA;EACA,cAAA;AjDiicJ;AiD7hcA;EAEI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AjD8hcJ;AiDnicA;EAQI,eAAA;EACA,cAAA;AjD8hcJ;AiDvicA;EAYI,WAAA;EACA,eAAA;EACA,UAAA;AjD8hcJ;AiD1hcA;EACE,UAAA;AjD4hcF;AiDzhcA;EACE,YAAA;AjD2hcF;AiDxhcA;EAEI,gBAAA;EACA,UAAA;EACA,cAAA;EACA,wBAAA;AjDyhcJ;AiDrhcA;EACE,qBAAA;AjDuhcF;AiDxhcA;EAGI,cAAA;EACA,uBAAA;EACA,mBAAA;AjDwhcJ;AiD7hcA;EAQI,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AjDwhcJ;AiDricA;EAgBI,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AjDwhcJ;AiDphcA;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AjDshcF;AiDphcA;EACE,wBAAA;AjDshcF;AiDnhcA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AjDqhcF;AiDjhcE;;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AjDohcJ;AiD5hcA;EAWI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AjDohcJ;AiDricA;EAoBI,WAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AjDohcJ;AiDhhcA;EACE,WAAA;AjDkhcF;AiDnhcA;EAGI,gBAAA;AjDmhcJ;AiD/gcA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AjDihcF;AiDhhcE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AjDkhcJ;AiDthcE;EAMI,cAAA;AjDmhcN;AiD/hcA;EAgBI,eAAA;AjDkhcJ;AiD9gcA;EAGM,eAAA;EACA,kBAAA;AjD8gcN;AiDzgcA;EAEI,SAAA;AjD0gcJ;AiD5gcA;EAKI,WAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AjD0gcJ;AiDlhcA;EAUM,cAAA;EACA,YAAA;EACA,eAAA;AjD2gcN;AiDvhcA;EAeM,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;AjD2gcN;AiD9hcA;EAqBQ,eAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AjD4gcR;AiDtgcA;EAEI,gCAAA;AjDugcJ;AiDzgcA;EAKI,cAAA;EACA,kBAAA;EACA,cAAA;AjDugcJ;AiD9gcA;EASM,cAAA;AjDwgcN;AiDjhcA;EAaI,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;AjDugcJ;AiDtgcI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AjDwgcN;AiDngcA;EACE,aAAA;EACA,mBAAA;AjDqgcF;AiDvgcA;EAII,aAAA;EACA,8BAAA;AjDsgcJ;AiDlgcA;EACE,aAAA;EACA,yBAAA;AjDogcF;AiDjgcA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AjDmgcF;AiDtgcA;EAKI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AjDogcJ;AiDjhcA;EAeM,cAAA;EACA,eAAA;AjDqgcN;AiDrhcA;EAoBI,SAAA;AjDogcJ;AiDxhcA;;EAsBM,SAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AjDsgcN;AiDhicA;EA6BM,aAAA;EACA,mBAAA;EACA,8BAAA;AjDsgcN;AiDricA;EAkCM,mBAAA;AjDsgcN;AiDjgcA;EAEI,gBAAA;AjDkgcJ;AmDvzgBA;EACE,mBAAA;EACA,aAAA;AnDyzgBF;AmD3zgBA;EAII,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,MAAA;EACA,WAAA;EACA,kBAAA;AnD0zgBJ;AmDt0gBA;EAeI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,kCAAA;EACA,YAAA;EACA,6BAAA;EACA,+BAAA;EACA,8BAAA;EACA,gBAAA;AnD0zgBJ;AmDn1gBA;EA2BM,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,qBAAA;AnD2zgBN;AmDz1gBA;EAiCM,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,2BAAA;EACA,YAAA;AnD2zgBN;AmDn2gBA;EA4CM,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kBAAA;AnD0zgBN;AmDz2gBA;EAkDQ,cAAA;EACA,eAAA;AnD0zgBR;AmDzzgBQ;EACE,0BAAA;AnD2zgBV;AmDxzgBM;EACE,kBAAA;AnD0zgBR;AmDvzgBI;EACE,gCAAA;AnDyzgBN;AmDt3gBA;EAgEM,eAAA;AnDyzgBN;AmDz3gBA;EAmEM,aAAA;EACA,UAAA;EACA,eAAA;AnDyzgBN;AmD93gBA;EAyEM,iBAAA;EACA,kBAAA;AnDwzgBN;AmDl4gBA;EA4EQ,6BAAA;EACA,qBAAA;AnDyzgBR;AmDt4gBA;EAgFQ,YAAA;EACA,eAAA;AnDyzgBR;AmDlzgBA;EACE,eAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;AnDozgBF;AmD3zgBA;EAUI,kBAAA;EACA,+DAAA;EACA,WAAA;EACA,UAAA;EACA,kDAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AnDozgBJ;AmDnzgBI;EACE,OAAA;EACA,UAAA;AnDqzgBN;AmDnzgBI;EACE,8BAAA;AnDqzgBN;AmDnzgBI;EACE,8BAAA;AnDqzgBN;AmDnzgBI;EACE,8BAAA;AnDqzgBN;AmDp1gBA;EAmCI,aAAA;EACA,cAAA;AnDozgBJ;AACA,UAAU;AoDh7gBV;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,2CAAA;ApDk7gBF;AoDh7gBE;EACE,yBAAA;ApDk7gBJ;AoDh7gBE;EACE,kBAAA;ApDk7gBJ;AoDh7gBE;EACE,gBAAA;ApDk7gBJ;AoDh7gBE;EACE,mBAAA;EACA,YAAA;ApDk7gBJ;AoDp7gBE;EAII,eAAA;EACA,aAAA;ApDm7gBN;AoDx7gBE;EASM,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;ApDk7gBR;AoDh8gBE;EAiBM,eAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;ApDk7gBR;AoDt8gBE;EAsBQ,cAAA;ApDm7gBV;AoDz8gBE;EAyBQ,cAAA;ApDm7gBV;AoD96gBE;EACE,aAAA;EACA,mBAAA;EACA,UAAA;ApDg7gBJ;AoDn7gBE;EAKI,eAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;ApDi7gBN;AoDh7gBM;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;ApDk7gBR;AoDh7gBM;EACE,mBAAA;ApDk7gBR;AoDh7gBM;EACE,mBAAA;ApDk7gBR;AoD96gBE;EACE,aAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;ApDg7gBJ;AoDt7gBE;EAQI,iBAAA;EACA,aAAA;EACA,mBAAA;ApDi7gBN;AoD37gBE;EAaI,iBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;EACA,oBAAA;ApDi7gBN;AoDn8gBE;EAoBM,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;ApDk7gBR;AoD18gBE;EA0BQ,eAAA;ApDm7gBV;AkCrhhBE;;;EAGE,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;AlCuhhBJ;AkCphhBE;;EAEE,cAAA;EACA,yBAAA;EACA,uBAAA;AlCshhBJ;AkCphhBI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCyhhBN;AkCrhhBE;;EAEE,cAAA;EACA,yBAAA;EACA,uBAAA;AlCuhhBJ;AkCrhhBI;;;;EAEE,qBAAA;EACA,uBAAA;AlCyhhBN;AkCvhhBM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCkihBR;AoDp+gBI;EAAA;IACE,eAAA;EpDu+gBJ;EoDx+gBE;IAGI,cAAA;IACA,eAAA;EpDw+gBN;EoD5+gBE;IAMM,mBAAA;IACA,gBAAA;IACA,eAAA;IACA,cAAA;EpDy+gBR;EoDl/gBE;IAWQ,iBAAA;EpD0+gBV;EoDr/gBE;IAgBI,mBAAA;IACA,gBAAA;EpDw+gBN;AACF;AoDr+gBE;EACE,aAAA;ApDu+gBJ;AoDrmhBA;EAiII,aAAA;ApDu+gBJ;AoDxmhBA;EAqII,kBAAA;EACA,aAAA;EACA,mBAAA;ApDs+gBJ;AoD7mhBA;EAyIM,SAAA;EACA,iBAAA;ApDu+gBN;AoDjnhBA;EA6IM,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;ApDu+gBN;AoDvnhBA;EAmJM,gBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;ApDu+gBN;AoD/nhBA;EA0JQ,WAAA;EACA,UAAA;EACA,qBAAA;EACA,sBAAA;ApDw+gBR;AoDrohBA;EAiKM,aAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;ApDu+gBN;AoDt+gBM;EAAA;IACE,aAAA;IACA,aAAA;IACA,kBAAA;IACA,SAAA;EpDy+gBN;AACF;AoDpphBA;EA6KQ,aAAA;EACA,mBAAA;EACA,6BAAA;ApD0+gBR;AoDzphBA;EAiLU,gBAAA;EACA,eAAA;EACA,iBAAA;ApD2+gBV;AoD9phBA;EAsLU,YAAA;EACA,WAAA;ApD2+gBV;AoDlqhBA;EA4LM,WAAA;ApDy+gBN;AoDx+gBM;EAAA;IACC,oBAAA;EpD2+gBL;AACF;AoD1qhBA;EAoMI,gBAAA;EACA,gBAAA;EACA,uCAAA;ApDy+gBJ;AoD/qhBA;EAwMM,iBAAA;ApD0+gBN;AoDlrhBA;EA2MM,aAAA;ApD0+gBN;AoDz+gBM;EAEI,cAAA;ApD0+gBV;AoD5+gBM;EAKI,mBAAA;ApD0+gBV;AoDv+gBM;EACE,kBAAA;ApDy+gBR;AoDv+gBM;EACE,yBAAA;ApDy+gBR;AoDv+gBM;EACE,qBAAA;ApDy+gBR;AoDt+gBI;EACE,kBAAA;EACA,gBAAA;ApDw+gBN;AoDr+gBE;EAEI,cAAA;ApDs+gBN;AoDn+gBE;EACE,iBAAA;EACA,YAAA;EACA,SAAA;ApDq+gBJ;AoDn+gBE;EACE,SAAA;EACA,SAAA;ApDq+gBJ;AoDn+gBE;EACE,UAAA;ApDq+gBJ;AoDvthBA;EAqPI,kBAAA;ApDq+gBJ;AoD1thBA;EAyPI,iBAAA;ApDo+gBJ;AoD7thBA;EA2PM,qBAAA;EACA,kBAAA;ApDq+gBN;AoDjuhBA;EAkQM,cAAA;ApDk+gBN;AoDpuhBA;EAwQM,gBAAA;EACA,iBAAA;EACA,mBAAA;ApD+9gBN;AoD59gBE;EACE,yBAAA;EACA,kBAAA;ApD89gBJ;AoDh+gBE;EAII,eAAA;EACA,gBAAA;ApD+9gBN;AoD39gBA;EACE,mBAAA;ApD69gBF;AoD39gBA;EACE,mBAAA;ApD69gBF;AoD39gBA;EACE,mBAAA;EACA,cAAA;ApD69gBF;AoD/9gBA;EAII,cAAA;ApD89gBJ;AoDl+gBA;EAOI,eAAA;EACA,SAAA;ApD89gBJ;AoDt+gBA;EAWI,SAAA;ApD89gBJ;AoDz+gBA;EAcI,cAAA;ApD89gBJ;AoD5+gBA;EAiBI,eAAA;EACA,cAAA;EACA,gBAAA;ApD89gBJ;AoDj/gBA;EAsBI,eAAA;EACA,4BAAA;ApD89gBJ;AoDr/gBA;EA0BI,cAAA;EACA,qBAAA;ApD89gBJ;AoDz/gBA;EA8BI,cAAA;EACA,gBAAA;ApD89gBJ;AoD7/gBA;EAkCI,mBAAA;EACA,2BAAA;ApD89gBJ;AoD79gBI;EACE,uBAAA;ApD+9gBN;AoD39gBA;EACE,uBAAA;ApD69gBF;AoD39gBA;EACE,yCAAA;ApD69gBF;AoD19gBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EAKA,kBAAA;ApDw9gBF;AoD59gBE;EAAA;IACE,eAAA;IACA,gBAAA;EpD+9gBF;AACF;AoDx+gBA;EAYI,gBAAA;EACA,kBAAA;EACA,gBAAA;ApD+9gBJ;AoD7+gBA;EAiBI,gBAAA;ApD+9gBJ;AoDh/gBA;EtD5EE,YAAA;EACA,aAAA;EACA,kBAAA;AE+jhBF;AoDr/gBA;EAuBI,SAAA;EACA,uBAAA;ApDi+gBJ;AoDz/gBA;EA2BI,aAAA;EACA,eAAA;EACA,uBAAA;ApDi+gBJ;AoD9/gBA;EA+BM,cAAA;EACA,kBAAA;ApDk+gBN;AoDlghBA;EAmCM,eAAA;EACA,gBAAA;ApDk+gBN;AoDtghBA;EAyCI,eAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;ApDg+gBJ;AoD59gBA;EACE,YAAA;EACA,cAAA;ApD89gBF;AoDh+gBA;EAII,OAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;ApD+9gBJ;AoD79gBE;EAEI,eAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;ApD89gBN;AoDz9gBA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;ApD29gBF;AoD99gBA;EAKI,cAAA;ApD49gBJ;AoDj+gBA;EAOM,SAAA;EACA,yBAAA;ApD69gBN;AoD59gBM;;;;EACE,yBAAA;EACA,gBAAA;ApDi+gBR;AoD5+gBA;EAcQ,yBAAA;ApDi+gBR;AoD/+gBA;EAiBQ,UAAA;ApDi+gBR;AoDl/gBA;EAoBQ,gBAAA;ApDi+gBR;AoDh+gBQ;EACE,eAAA;ApDk+gBV;AoDx/gBA;EA0BQ,kBAAA;ApDi+gBR;AoD3/gBA;EA6BQ,UAAA;ApDi+gBR;AoD9/gBA;EAgCQ,SAAA;ApDi+gBR;AoD59gBG;EAAA;IACE,cAAA;EpD+9gBH;AACF;AoD59gBA;EAEI,eAAA;ApD69gBJ;AoD19gBA;EACE,WAAA;EACA,YAAA;ApD49gBF;AoD19gBA;EACE,gBAAA;ApD49gBF;AoDz9gBA;EACE,eAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;ApD29gBF;AoDx9gBA;EACE,mBAAA;EACA,iBAAA;ApD09gBF;AoDv9gBA;EACE,iBAAA;ApDy9gBF;AqDr7hBA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;ArDu7hBF;AqD77hBA;EAQI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;ArDw7hBJ;AqDt8hBA;EAgBM,UAAA;EACA,iBAAA;ArDy7hBN;AqD18hBA;EAoBM,SAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;ArDy7hBN;AqDt7hBE;EACE,mBAAA;ArDw7hBJ;AqDt7hBE;EACE,mBAAA;ArDw7hBJ;AqDt7hBE;EACE,mBAAA;ArDw7hBJ;AqDt7hBE;EACE,mBAAA;ArDw7hBJ;AsD79hBA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,yDAAA;EACA,yBAAA;AtD+9hBF;AsDx+hBA;EAWI,6BAAA;AtDg+hBJ;AsD99hBE;;EACE,UAAA;EACA,MAAA;EACA,0CAAA;EACA,4BAAA;EACA,aAAA;AtDi+hBJ;AsDh+hBI;EAAA;;IACE,wCAAA;IACA,gCAAA;IACA,uBAAA;IACA,cAAA;EtDo+hBJ;AACF;AsDj+hBI;EAAA;IACE,wCAAA;IACA,gCAAA;IACA,uBAAA;EtDo+hBJ;AACF;AsDl+hBE;EACE,UAAA;AtDo+hBJ;AsDl+hBE;EACE,MAAA;AtDo+hBJ;AsDl+hBE;EACE,MAAA;AtDo+hBJ;AsDj+hBI;EACE,SAAA;AtDm+hBN;AsD/giBA;EA+CM,YAAA;AtDm+hBN;AsD99hBA;EACE,aAAA;EACA,yCAAA;EACA,4BAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AtDg+hBF;AsDt+hBA;EAQI,eAAA;EACA,YAAA;EACA,aAAA;AtDi+hBJ;AsDh+hBI;EAAA;IACE,6BAAA;EtDm+hBJ;AACF;AsDh/hBA;EAeM,aAAA;AtDo+hBN;AsDn/hBA;EAmBM,aAAA;EACA,UAAA;EACA,cAAA;EACA,4BAAA;AtDm+hBN;AsDl+hBM;EAAA;IACE,kBAAA;EtDq+hBN;AACF;AsD9/hBA;EA4BM,aAAA;EACA,cAAA;EACA,gBAAA;AtDq+hBN;AsDp+hBM;EAAA;IACE,6BAAA;EtDu+hBN;AACF;AsDp+hBU;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;AtDs+hBZ;AsD5+hBM;EAUI,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;EACA,OAAA;EACA,YAAA;AtDq+hBV;AsDp/hBM;EAiBM,qBAAA;AtDs+hBZ;AsDv/hBM;EAoBM,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AtDs+hBZ;AsDp+hBU;EACE,WAAA;EACA,UAAA;EACA,2EAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,MAAA;EACA,oBAAA;AtDs+hBZ;AsDzgiBM;EAuCI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AtDq+hBV;AsDjhiBM;EA8CM,qBAAA;AtDs+hBZ;AsDphiBM;EAiDM,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AtDs+hBZ;AsDp+hBU;EACE,WAAA;EACA,UAAA;EACA,2EAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,MAAA;EACA,oBAAA;AtDs+hBZ;AsDtiiBM;EAoEI,WAAA;EACA,cAAA;EACA,gBAAA;EACA,QAAA;AtDq+hBV;AsD5iiBM;EA0EI,WAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AtDq+hBV;AsDpliBA;EAoHM,mBAAA;EACA,cAAA;AtDm+hBN;AACA,mBAAmB;AuD7oiBnB;EACE,gBAAA;EACA,MAAA;EACA,gBAAA;EAIA,mBAAA;EACA,+CAAA;EACA,kDAAA;EACA,kBAAA;EACA,YAAA;AvD4oiBF;AuDnpiBE;EAAA;IACE,6BAAA;EvDspiBF;AACF;AuD5piBA;EAaI,eAAA;AvDkpiBJ;AuD/piBA;EAgBI,aAAA;AvDkpiBJ;AuDlqiBA;EAmBI,UAAA;AvDkpiBJ;AuDrqiBA;EAsBI,aAAA;AvDkpiBJ;AuD/oiBA;EACE,gBAAA;EACA,MAAA;EACA,gBAAA;EAIA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;EACA,eAAA;AvD8oiBF;AuDxpiBE;EAAA;IACE,sBAAA;EvD2piBF;AACF;AuDjqiBA;EAgBI,aAAA;AvDopiBJ;AuDpqiBA;EAmBI,UAAA;AvDopiBJ;AuDvqiBA;EAsBI,aAAA;AvDopiBJ;AuD1qiBA;EA0BI,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,yDAAA;EACA,sBAAA;AvDmpiBJ;AuDnriBA;EAmCI,YAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,yDAAA;EACA,wBAAA;EACA,kCAAA;EACA,4BAAA;AvDmpiBJ;AuD7riBA;EA6CI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;AvDmpiBJ;AuDpsiBA;EAmDM,cAAA;EACA,0BAAA;AvDopiBN;AuDnpiBM;EACE,cAAA;EACA,0BAAA;AvDqpiBR;AuDhpiBA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;EACA,oBAAA;AvDkpiBF;AuDvpiBA;EAOI,YAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,yDAAA;EACA,sBAAA;AvDmpiBJ;AuD/piBA;EAeI,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;AvDmpiBJ;AuDhpiBA;EACE,aAAA;AvDkpiBF;AuDnpiBA;EAGI,cAAA;EACA,eAAA;AvDmpiBJ;AuDvpiBA;EAOI,cAAA;EACA,eAAA;AvDmpiBJ;AuDnoiBE;EAEI,YAAA;EACA,QAAA;EACA,UAAA;EACA,sBAAA;AvDooiBN;AuDzoiBE;EAOM,mBAAA;EACA,SAAA;AvDqoiBR;AuDhoiBA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;EACA,wCAAA;EACA,cAAA;AvDkoiBF;AuDxoiBA;EAQI,iBAAA;AvDmoiBJ;AuDjoiBE;EACE,MAAA;EACA,mBAAA;EACA,oCAAA;AvDmoiBJ;AuDtoiBE;EAKI,mBAAA;AvDooiBN;AuDzoiBE;EAQI,gBAAA;AvDooiBN;AuD5oiBE;EAWI,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AvDooiBN;AuDrpiBE;EAmBM,qBAAA;AvDqoiBR;AuDxpiBE;EAsBM,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AvDqoiBR;AuDnoiBM;EACE,WAAA;EACA,UAAA;EACA,+EAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,MAAA;EACA,oBAAA;AvDqoiBR;AuD1qiBE;EAyCI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AvDooiBN;AuDnriBE;EAiDM,qBAAA;AvDqoiBR;AuDtriBE;EAoDM,YAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AvDqoiBR;AuDnoiBM;EACE,WAAA;EACA,UAAA;EACA,2EAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,MAAA;EACA,oBAAA;AvDqoiBR;AuDxsiBE;EAuEI,WAAA;EACA,cAAA;EACA,gBAAA;EACA,QAAA;AvDooiBN;AuD9siBE;EA6EI,WAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AvDooiBN;AuDjoiBE;EACE,mBAAA;EACA,SAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;AvDmoiBJ;AuDruiBA;EAqGI,qBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;EACA,MAAA;EACA,UAAA;EACA,cAAA;AvDmoiBJ;AuDloiBI;EACE,WAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;AvDooiBN;AuDloiBI;EAAA;IACE,yBAAA;IACA,YAAA;EvDqoiBJ;EuDpoiBI;IACE,SAAA;EvDsoiBN;AACF;AuD9viBA;EA2HM,gBAAA;EACA,mBAAA;AvDsoiBN;AuDlwiBA;EA+HM,kBAAA;AvDsoiBN;AuDrwiBA;EAkIM,QAAA;EACA,kBAAA;AvDsoiBN;AuDroiBM;EACE;IACE,eAAA;EvDuoiBR;AACF;AuD9wiBA;EA2IM,UAAA;AvDsoiBN;AuDjxiBA;EA8IM,WAAA;AvDsoiBN;AuDpxiBA;EAiJM,QAAA;EACA,kBAAA;AvDsoiBN;AuDxxiBA;EAqJM,aAAA;EACA,mBAAA;EACA,UAAA;EACA,QAAA;AvDsoiBN;AuD9xiBA;EA2JM,gBAAA;EACA,eAAA;AvDsoiBN;AuDlyiBA;EA8JQ,eAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;AvDuoiBR;AuDxyiBA;EAkLM,aAAA;EACA,cAAA;EACA,UAAA;AvDyniBN;AuD7yiBA;EAsLQ,mBAAA;AvD0niBR;AuDxniBM;EAAA;IACE,iBAAA;EvD2niBN;AACF;AuD5+hBE;EACE;IACE,WAAA;EvD8+hBJ;AACF;AuD5+hBE;EACE;IACE,OAAA;EvD8+hBJ;EuD5+hBE;IACE,OAAA;EvD8+hBJ;EuD5+hBE;IACE,+BAAA;IACA,gCAAA;IACA,MAAA;EvD8+hBJ;EuD5+hBE;IACE,+BAAA;IACA,gCAAA;IACA,SAAA;EvD8+hBJ;AACF;AuD1+hBA;EAEI,aAAA;EACA,WAAA;EACA,aAAA;AvD2+hBJ;AuD/+hBA;EAMM,cAAA;EACA,oBAAA;EACA,gBAAA;AvD4+hBN;AuDp/hBA;EAWM,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AvD4+hBN;AuD3/hBA;EAoBM,WAAA;AvD0+hBN;AuD9/hBA;EAuBM,UAAA;AvD0+hBN;AuDr+hBA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AvDu+hBF;AuD7+hBA;EAQI,gBAAA;EACA,YAAA;EACA,gCAAA;AvDw+hBJ;AuDl/hBA;EAaI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,wBAAA;EACA,kCAAA;AvDw+hBJ;AuD5/hBA;EAuBI,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AvDw+hBJ;AuDlgiBA;EA4BM,cAAA;EACA,sBAAA;AvDy+hBN;AuDtgiBA;EAgCM,cAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AvDy+hBN;AuDx+hBM;EACE,yBAAA;AvD0+hBR;AkDp7iBA;EACE,YAAA;EACA,2BAAA;AlDs7iBF;AkDn7iBA;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;AlDq7iBF;AkDj7iBA;EzBvHC,cAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,4BAAA;EACA,yBAAA;EAKC,kBAAA;ECOC,wEAAA;EwBqGD,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;AlD67iBF;A0BpijBC;EAAA;IACC,gBAAA;E1BuijBA;AACF;AyB3ijBC;EACC,6BAAA;EACA,SAAA;AzB6ijBF;A2B/jjBC;EACC,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,UAAA;EAMC,gDAAA;A3B4jjBH;AyB7ijBC;EACC,cAAA;EAEA,UAAA;AzB8ijBF;AyBtijBC;;EAEC,yBAAA;EAEA,UAAA;AzBuijBF;A2BrijBG;;EAEA,qBAAA;A3BuijBH;A2BrijBG;;EACC,qBAAA;EACA,kDAAA;A3BwijBJ;A2B9ijBG;;;;EAWC,cAAA;A3ByijBJ;A2BpjjBG;;EAEA,qBAAA;A3BsjjBH;A2BpjjBG;;EACC,qBAAA;EACA,gDAAA;A3BujjBJ;A2B7jjBG;;;;EAWC,cAAA;A3BwjjBJ;AkDl/iBE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AlDo/iBJ;AkDj/iBE;;EAEE,6BAAA;EACA,cAAA;EACA,UAAA;AlDm/iBJ;AkDh/iBE;EACE,YAAA;AlDk/iBJ;AkD/+iBE;;EAEE,cAAA;EACA,YAAA;EACA,gBAAA;AlDi/iBJ;AkD9+iBE;EACE,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AlDg/iBJ;AkD9+iBI;EACE,gBAAA;AlDg/iBN;AkD5+iBE;EACE,qBAAA;AlD8+iBJ;AkD3+iBE;EACE,gBAAA;AlD6+iBJ;AkD3+iBI;EACE,gBAAA;AlD6+iBN;AkDz+iBE;EACE,UAAA;EACA,SAAA;EACA,iBAAA;EACA,oBAAA;AlD2+iBJ;AkD/+iBE;;EAQI,kCAAA;EACA,eAAA;AlD2+iBN;AkDp/iBE;EAaI,+CAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AlD0+iBN;AkD5/iBE;EAqBM,eAAA;AlD0+iBR;AkD//iBE;EA0BI,cAAA;EACA,aAAA;EACA,cAAA;AlDw+iBN;AkDp+iBE;EACE,kBAAA;AlDs+iBJ;AkDv+iBE;EAII,SAAA;EACA,YAAA;AlDs+iBN;AkDj+iBA;EACE,mBAAA;AlDm+iBF;AkDh+iBA;;;EAGE,aAAA;EACA,eAAA;EACA,cAAA;AlDk+iBF;AkDh+iBE;;;EACE,cAAA;AlDo+iBJ;AkDr+iBE;;;EAII,iBAAA;AlDs+iBN;AkD1+iBE;;;EAQI,cAAA;AlDu+iBN;AkDt/iBA;;;EAoBI,aAAA;EACA,cAAA;AlDu+iBJ;AkDp+iBE;;;EAEI,gCAAA;AlDu+iBN;AkDn+iBE;;;EAEI,cAAA;AlDs+iBN;AkDx+iBE;;;EAMI,SAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,2BAAA;EACA,kBAAA;AlDu+iBN;AkDl/iBE;;;EAcM,YAAA;EAAA,cAAA;EAAA,6BAAA;AlDy+iBR;AkDv/iBE;;;EAmBI,eAAA;EACA,SAAA;AlDy+iBN;AkDp+iBA;EAEI,mBAAA;AlDq+iBJ;AkDv+iBA;EAMI,WAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;AlDo+iBJ;AkD7+iBA;EAYM,gBAAA;EACA,WAAA;EACA,eAAA;AlDo+iBN;AkDl/iBA;EAiBQ,cAAA;EACA,yBAAA;EACA,WAAA;AlDo+iBR;AkDv/iBA;EAwBM,iBAAA;AlDk+iBN;AkD79iBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AlD+9iBF;AkD79iBE;EAAA;IACE,cAAA;ElDg+iBF;EkD99iBE;IAEI,iBAAA;ElD+9iBN;AACF;AkD39iBE;EACE,gBAAA;AlD69iBJ;AkD19iBE;EACE,gBAAA;AlD49iBJ;AkDz9iBE;EACE,iBAAA;AlD29iBJ;AkDt9iBM;EACE,gBAAA;AlDw9iBR;AkD39iBE;EAOM,aAAA;EACA,eAAA;EACA,cAAA;AlDu9iBR;AkDh+iBE;EAYQ,aAAA;EACA,eAAA;AlDu9iBV;AkDp+iBE;EAgBU,aAAA;EACA,eAAA;EACA,cAAA;AlDu9iBZ;AkDh9iBE;EACE,mBAAA;AlDk9iBJ;AkDn9iBE;EAII,cAAA;AlDk9iBN;AkDt9iBE;EAQI,cAAA;AlDi9iBN;AkD78iBE;EACE,aAAA;AlD+8iBJ;AkD78iBI;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;AlD+8iBN;AkD78iBM;EACE,yBAAA;AlD+8iBR;AkD58iBM;;EAEE,mCAAA;AlD88iBR;AkD18iBI;EACE,cAAA;EACA,UAAA;AlD48iBN;AkDv8iBI;EACE,WAAA;EACA,cAAA;EACA,qBAAA;EACA,0BAAA;EACA,mBAAA;AlDy8iBN;AkD/8iBE;;EAWI,iBAAA;AlDw8iBN;AkDn8iBI;EACE,WAAA;EACA,cAAA;EACA,qBAAA;EACA,0BAAA;EACA,mBAAA;AlDq8iBN;AkD38iBE;;EAWI,iBAAA;AlDo8iBN;AkDh8iBE;EAEI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;AlDi8iBN;AkD77iBE;EACE,iBAAA;AlD+7iBJ;AkDh8iBE;EAII,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;AlD+7iBN;AkD57iBI;EACE,YAAA;AlD87iBN;AkDp9iBE;EA0BI,aAAA;EACA,iBAAA;EACA,mBAAA;AlD67iBN;AkDz9iBE;EA+BM,cAAA;AlD67iBR;AkD59iBE;EAkCQ,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AlD67iBV;AkD37iBU;EAAA;IACE,gBAAA;ElD87iBV;EkD57iBU;IACE,YAAA;ElD87iBZ;AACF;AkDx7iBQ;EACE,iBAAA;EACA,kBAAA;AlD07iBV;AkDp7iBE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;AlDs7iBJ;AkDp7iBI;EAAA;IACE,uBAAA;ElDu7iBJ;AACF;AkD97iBE;EAUI,gBAAA;EACA,iBAAA;AlDu7iBN;AkDl8iBE;EAeI,gBAAA;AlDs7iBN;AkDr8iBE;EAkBM,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,uBAAA;EACA,gBAAA;AlDs7iBR;AkD58iBE;EAyBQ,sBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AlDs7iBV;AkDn7iBQ;EACE,YAAA;AlDq7iBV;AkDt7iBQ;EAII,aAAA;AlDq7iBZ;AkDh7iBM;EACE,gBAAA;AlDk7iBR;AkDn7iBM;EAII,sCAAA;AlDk7iBV;AkDh+iBE;EAoDI,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AlD+6iBN;AkD16iBI;EACE,uBAAA;EAyaJ,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EA5aI,mBAAA;EACA,gBAAA;EACA,cAAA;AlDi7iBN;AkDrgiBE;EACE,uBAAA;AlDugiBJ;AkDngiBI;EACE,aAAA;AlDqgiBN;AkDjgiBE;EAEI,WAAA;EACA,YAAA;EACA,iBAAA;AlDkgiBN;AkDz7iBI;EACE,cAAA;AlD27iBN;AkDx7iBI;EACE,YAAA;AlD07iBN;AkDv7iBI;EACE,iBAAA;AlDy7iBN;AkDt7iBI;EACE,kBAAA;AlDw7iBN;AkDr7iBI;EACE,aAAA;AlDu7iBN;AkDp7iBI;EACE,aAAA;AlDs7iBN;AkDn7iBI;EACE,YAAA;AlDq7iBN;AkDj7iBM;EACE,qBAAA;AlDm7iBR;AkDh7iBM;EACE,sBAAA;AlDk7iBR;AkD96iBI;EACE,oBAAA;AlDg7iBN;AkDh+iBE;EAoDI,mBAAA;AlD+6iBN;AkD36iBE;EACE,aAAA;EACA,8BAAA;AlD66iBJ;AkDz6iBI;EACE,aAAA;EACA,8BAAA;AlD26iBN;AkD96iBE;EAOI,aAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EAcA,qBAAA;AlD65iBN;AkDr7iBE;EAaM,aAAA;EACA,mBAAA;AlD26iBR;AkDz7iBE;EAiBQ,UAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;AlD26iBV;AkD/7iBE;EA4BI,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,UAAA;AlDs6iBN;AkDv8iBE;EAoCM,cAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;AlDs6iBR;AkD78iBE;EA4CQ,cAAA;AlDo6iBV;AkDh9iBE;EA+CU,cAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AlDo6iBZ;AkDz9iBE;EA2DM,aAAA;EACA,gBAAA;AlDi6iBR;AkD95iBM;EAEI,aAAA;EACA,gBAAA;AlD+5iBV;AkDj+iBE;EAwEI,cAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AlD45iBN;AkDx5iBE;EAEI,eAAA;AlDy5iBN;AkD35iBE;EAMI,cAAA;AlDw5iBN;AkDp5iBE;EACE,cAAA;AlDs5iBJ;AkDv5iBE;EAII,aAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AlDs5iBN;AkD75iBE;EAWI,aAAA;EACA,sBAAA;EACA,+BAAA;EACA,oBAAA;AlDq5iBN;AkDj5iBE;EACE,cAAA;AlDm5iBJ;AkDp5iBE;EAII,aAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AlDm5iBN;AkD15iBE;EAWI,aAAA;EACA,eAAA;AlDk5iBN;AkD95iBE;EAeM,SAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AlDk5iBR;AkDp6iBE;EAsBM,SAAA;AlDi5iBR;AkDv6iBE;EA0BM,aAAA;EACA,mBAAA;AlDg5iBR;AkD36iBE;EA8BQ,SAAA;AlDg5iBV;AkD96iBE;EAoCI,aAAA;AlD64iBN;AkDj7iBE;EAuCM,SAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;AlD64iBR;AkDv7iBE;EA8CM,SAAA;EACA,aAAA;AlD44iBR;AkD37iBE;EAmDM,cAAA;EACA,iBAAA;AlD24iBR;AkD/7iBE;EA0DM,gBAAA;EACA,eAAA;EACA,uBAAA;AlDw4iBR;AkDp8iBE;EAgEM,SAAA;AlDu4iBR;AkDp4iBM;EAAA;IAEI,kBAAA;IACA,kBAAA;ElDs4iBR;AACF;AkD72jBA;EA6eI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AlDm4iBJ;AkDh4jBA;EAigBI,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AlDk4iBJ;AkD/3iBE;;EAEE,WAAA;AlDi4iBJ;AkDn5jBA;EAshBI,cAAA;EACA,cAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AlDg4iBJ;AkD15jBA;EA8hBI,cAAA;AlD+3iBJ;AkD75jBA;EAmqBE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;AlD6viBF;AkD3viBE;EACE,uBAAA;AlD6viBJ;AkDzviBI;EACE,aAAA;AlD2viBN;AkDvviBE;EAEI,WAAA;EACA,YAAA;EACA,iBAAA;AlDwviBN;AkDh7jBA;EA8rBE,eAAA;EACA,gBAAA;EACA,0BAAA;AlDqviBF;AkDnviBE;EACE,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;AlDqviBJ;AkDnviBI;EACE,uBAAA;AlDqviBN;AkDnviBM;EACE,kBAAA;EACA,mBAAA;AlDqviBR;AkDhwiBE;EAgBI,eAAA;AlDmviBN;AkDr8jBA;EAwtBE,cAAA;EACA,eAAA;EACA,0BAAA;AlDgviBF;AkD9uiBE;EACE,QAAA;AlDgviBJ;AkD7uiBE;EACE,cAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AlD+uiBJ;AkDpviBE;EAQI,eAAA;AlD+uiBN;AkDv9jBA;EA8iBI,gBAAA;AlD46iBJ;AkDz6iBE;EACE,gBAAA;AlD26iBJ;AkD56iBE;EAII,QAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,OAAA;EACA,UAAA;EACA,0BAAA;AlD26iBN;AkDz6iBM;;;EAGE,gBAAA;AlD26iBR;AkD77iBE;EAuBI,QAAA;AlDy6iBN;AkDt6iBI;EAEI,WAAA;AlDu6iBR;AkDl6iBE;EACE,6BAAA;EACA,iBAAA;EACA,YAAA;EAAA,cAAA;EAAA,6BAAA;AlDo6iBJ;AkDh6iBA;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;AlDi6iBJ;AkD55iBE;EACE,6BAAA;EACA,YAAA;EAAA,cAAA;EAAA,6BAAA;AlD85iBJ;AkDh6iBE;EAKI,iBAAA;AlD85iBN;AkDz5iBA;EAEI,iBAAA;EACA,oBAAA;EACA,iBAAA;AlD05iBJ;AkD95iBA;EAOM,yBAAA;EACA,6BAAA;AlD05iBN;AkDl6iBA;EAaI,cAAA;AlDw5iBJ;AkDr6iBA;EAgBM,eAAA;EACA,cAAA;EACA,UAAA;EACA,iBAAA;AlDw5iBN;AkD36iBA;EAuBM,WAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AlDu5iBN;AkDr5iBM;;EAEE,mBAAA;EACA,gBAAA;EACA,+BAAA;AlDu5iBR;AkDz7iBA;EAsCQ,WAAA;EACA,gBAAA;AlDs5iBR;AkD77iBA;EA2CQ,UAAA;EACA,aAAA;AlDq5iBR;AkDl5iBM;EACE,kBAAA;AlDo5iBR;AkD94iBA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;AlDg5iBF;AkD94iBE;EACE,uBAAA;AlDg5iBJ;AkD54iBI;EACE,aAAA;AlD84iBN;AkD14iBE;EAEI,WAAA;EACA,YAAA;EACA,iBAAA;AlD24iBN;AkDt4iBA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AlDw4iBF;AkDt4iBE;EACE,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;AlDw4iBJ;AkDt4iBI;EACE,uBAAA;AlDw4iBN;AkDt4iBM;EACE,kBAAA;EACA,mBAAA;AlDw4iBR;AkDn5iBE;EAgBI,eAAA;AlDs4iBN;AkDj4iBA;EACE,cAAA;EACA,eAAA;EACA,0BAAA;AlDm4iBF;AkDj4iBE;EACE,QAAA;AlDm4iBJ;AkDh4iBE;EACE,cAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AlDk4iBJ;AkDv4iBE;EAQI,eAAA;AlDk4iBN;AkD73iBA;;EAEI,uBAAA;AlD+3iBJ;AkD53iBM;EAAA;;IACE,cAAA;IACA,iBAAA;IACA,8BAAA;ElDg4iBN;EkDn4iBI;;IAMI,eAAA;IACA,cAAA;ElDi4iBR;AACF;AkD33iBA;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AlD63iBF;AkDj4iBA;EAOI,cAAA;AlD63iBJ;AkD33iBI;EAAA;IACE,UAAA;ElD83iBJ;AACF;AkDz4iBA;EA1hCQ,aAAA;EACA,YAAA;EACA,eAAA;AlDs6kBR;AkD94iBA;EAphCQ,cAAA;EACA,WAAA;EACA,eAAA;AlDq6kBR;AkDn5iBA;EAx9BE,YAAA;EAAA,cAAA;EAAA,6BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,6CAAA;EAMF,sBAAA;AlDu2kBF;AkDx5iBA;EAx9BE,YAAA;EAAA,cAAA;EAAA,8BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,8CAAA;EAMF,uBAAA;AlD42kBF;AkD75iBA;EAx9BE,YAAA;EAAA,cAAA;EAAA,qBAAA;EAGE,YAAA;EAAA,cAAA;EAAA,4BAAA;EAMF,cAAA;AlDi3kBF;AkDl6iBA;EAx9BE,YAAA;EAAA,cAAA;EAAA,8BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,8CAAA;EAMF,uBAAA;AlDs3kBF;AkDv6iBA;EAx9BE,YAAA;EAAA,cAAA;EAAA,8BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,8CAAA;EAMF,uBAAA;AlD23kBF;AkD56iBA;EAx9BE,YAAA;EAAA,cAAA;EAAA,qBAAA;EAGE,YAAA;EAAA,cAAA;EAAA,4BAAA;EAMF,cAAA;AlDg4kBF;AkDj7iBA;EAx9BE,YAAA;EAAA,cAAA;EAAA,8BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,8CAAA;EAMF,uBAAA;AlDq4kBF;AkDt7iBA;EAx9BE,YAAA;EAAA,cAAA;EAAA,8BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,8CAAA;EAMF,uBAAA;AlD04kBF;AkD37iBA;EAx9BE,YAAA;EAAA,cAAA;EAAA,qBAAA;EAGE,YAAA;EAAA,cAAA;EAAA,4BAAA;EAMF,cAAA;AlD+4kBF;AkDh8iBA;EAx9BE,YAAA;EAAA,cAAA;EAAA,8BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,8CAAA;EAMF,uBAAA;AlDo5kBF;AkDr8iBA;EAx9BE,YAAA;EAAA,cAAA;EAAA,8BAAA;EAGE,YAAA;EAAA,cAAA;EAAA,8CAAA;EAMF,uBAAA;AlDy5kBF;AkD18iBA;EAx9BE,YAAA;EAAA,cAAA;EAAA,sBAAA;EASA,eAAA;AlD65kBF;AkD98iBA;EApgCQ,SAAA;AlDq9kBR;AkDj9iBA;EAhgCQ,SAAA;AlDo9kBR;AkDp9iBA;EA3/BU,QAAA;AlDk9kBV;AkDv9iBA;EA3/BU,QAAA;AlDq9kBV;AkD19iBA;EA3/BU,QAAA;AlDw9kBV;AkD79iBA;EA3/BU,QAAA;AlD29kBV;AkDh+iBA;EA3/BU,QAAA;AlD89kBV;AkDn+iBA;EA3/BU,QAAA;AlDi+kBV;AkDt+iBA;EA3/BU,QAAA;AlDo+kBV;AkDz+iBA;EA3/BU,QAAA;AlDu+kBV;AkD5+iBA;EA3/BU,QAAA;AlD0+kBV;AkD/+iBA;EA3/BU,QAAA;AlD6+kBV;AkDl/iBA;EA3/BU,SAAA;AlDg/kBV;AkDr/iBA;EA3/BU,SAAA;AlDm/kBV;AkDx/iBA;EA3/BU,SAAA;AlDs/kBV;AkD3/iBA;EnBt/BE,wBAAA;A/Bo/kBF;AkD9/iBA;EnBt/BE,yBAAA;A/Bu/kBF;AkDjgjBA;EnBt/BE,gBAAA;A/B0/kBF;AkDpgjBA;EnBt/BE,yBAAA;A/B6/kBF;AkDvgjBA;EnBt/BE,yBAAA;A/BgglBF;AkD1gjBA;EnBt/BE,gBAAA;A/BmglBF;AkD7gjBA;EnBt/BE,yBAAA;A/BsglBF;AkDhhjBA;EnBt/BE,yBAAA;A/ByglBF;AkDnhjBA;EnBt/BE,gBAAA;A/B4glBF;AkDthjBA;EnBt/BE,yBAAA;A/B+glBF;AkDzhjBA;EnBt/BE,yBAAA;A/BkhlBF;AQ7glBE;EAAA;I0CzCM,aAAA;IACA,YAAA;IACA,eAAA;ElD0jlBN;EQnhlBA;I0CnCM,cAAA;IACA,WAAA;IACA,eAAA;ElDyjlBN;EQxhlBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,6BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,6CAAA;IAMF,sBAAA;ElD2/kBA;EQ7hlBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDgglBA;EQlilBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElDqglBA;EQvilBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD0glBA;EQ5ilBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD+glBA;EQjjlBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElDohlBA;EQtjlBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDyhlBA;EQ3jlBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD8hlBA;EQhklBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElDmilBA;EQrklBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDwilBA;EQ1klBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD6ilBA;EQ/klBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,sBAAA;IASA,eAAA;ElDijlBA;EQnllBA;I0CnBM,SAAA;ElDymlBN;EQtllBA;I0CfM,SAAA;ElDwmlBN;EQzllBA;I0CVQ,QAAA;ElDsmlBR;EQ5llBA;I0CVQ,QAAA;ElDymlBR;EQ/llBA;I0CVQ,QAAA;ElD4mlBR;EQlmlBA;I0CVQ,QAAA;ElD+mlBR;EQrmlBA;I0CVQ,QAAA;ElDknlBR;EQxmlBA;I0CVQ,QAAA;ElDqnlBR;EQ3mlBA;I0CVQ,QAAA;ElDwnlBR;EQ9mlBA;I0CVQ,QAAA;ElD2nlBR;EQjnlBA;I0CVQ,QAAA;ElD8nlBR;EQpnlBA;I0CVQ,QAAA;ElDiolBR;EQvnlBA;I0CVQ,SAAA;ElDoolBR;EQ1nlBA;I0CVQ,SAAA;ElDuolBR;EQ7nlBA;I0CVQ,SAAA;ElD0olBR;EQholBA;IuBRA,cAAA;E/B2olBA;EQnolBA;IuBLA,wBAAA;E/B2olBA;EQtolBA;IuBLA,yBAAA;E/B8olBA;EQzolBA;IuBLA,gBAAA;E/BiplBA;EQ5olBA;IuBLA,yBAAA;E/BoplBA;EQ/olBA;IuBLA,yBAAA;E/BuplBA;EQlplBA;IuBLA,gBAAA;E/B0plBA;EQrplBA;IuBLA,yBAAA;E/B6plBA;EQxplBA;IuBLA,yBAAA;E/BgqlBA;EQ3plBA;IuBLA,gBAAA;E/BmqlBA;EQ9plBA;IuBLA,yBAAA;E/BsqlBA;EQjqlBA;IuBLA,yBAAA;E/ByqlBA;AACF;AQrqlBE;EAAA;I0CzCM,aAAA;IACA,YAAA;IACA,eAAA;ElDktlBN;EQ3qlBA;I0CnCM,cAAA;IACA,WAAA;IACA,eAAA;ElDitlBN;EQhrlBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,6BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,6CAAA;IAMF,sBAAA;ElDmplBA;EQrrlBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDwplBA;EQ1rlBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElD6plBA;EQ/rlBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDkqlBA;EQpslBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDuqlBA;EQzslBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElD4qlBA;EQ9slBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDirlBA;EQntlBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDsrlBA;EQxtlBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElD2rlBA;EQ7tlBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDgslBA;EQlulBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDqslBA;EQvulBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,sBAAA;IASA,eAAA;ElDyslBA;EQ3ulBA;I0CnBM,SAAA;ElDiwlBN;EQ9ulBA;I0CfM,SAAA;ElDgwlBN;EQjvlBA;I0CVQ,QAAA;ElD8vlBR;EQpvlBA;I0CVQ,QAAA;ElDiwlBR;EQvvlBA;I0CVQ,QAAA;ElDowlBR;EQ1vlBA;I0CVQ,QAAA;ElDuwlBR;EQ7vlBA;I0CVQ,QAAA;ElD0wlBR;EQhwlBA;I0CVQ,QAAA;ElD6wlBR;EQnwlBA;I0CVQ,QAAA;ElDgxlBR;EQtwlBA;I0CVQ,QAAA;ElDmxlBR;EQzwlBA;I0CVQ,QAAA;ElDsxlBR;EQ5wlBA;I0CVQ,QAAA;ElDyxlBR;EQ/wlBA;I0CVQ,SAAA;ElD4xlBR;EQlxlBA;I0CVQ,SAAA;ElD+xlBR;EQrxlBA;I0CVQ,SAAA;ElDkylBR;EQxxlBA;IuBRA,cAAA;E/BmylBA;EQ3xlBA;IuBLA,wBAAA;E/BmylBA;EQ9xlBA;IuBLA,yBAAA;E/BsylBA;EQjylBA;IuBLA,gBAAA;E/ByylBA;EQpylBA;IuBLA,yBAAA;E/B4ylBA;EQvylBA;IuBLA,yBAAA;E/B+ylBA;EQ1ylBA;IuBLA,gBAAA;E/BkzlBA;EQ7ylBA;IuBLA,yBAAA;E/BqzlBA;EQhzlBA;IuBLA,yBAAA;E/BwzlBA;EQnzlBA;IuBLA,gBAAA;E/B2zlBA;EQtzlBA;IuBLA,yBAAA;E/B8zlBA;EQzzlBA;IuBLA,yBAAA;E/Bi0lBA;AACF;AQ7zlBE;EAAA;I0CzCM,aAAA;IACA,YAAA;IACA,eAAA;ElD02lBN;EQn0lBA;I0CnCM,cAAA;IACA,WAAA;IACA,eAAA;ElDy2lBN;EQx0lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,6BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,6CAAA;IAMF,sBAAA;ElD2ylBA;EQ70lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDgzlBA;EQl1lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElDqzlBA;EQv1lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD0zlBA;EQ51lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD+zlBA;EQj2lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElDo0lBA;EQt2lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDy0lBA;EQ32lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD80lBA;EQh3lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElDm1lBA;EQr3lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDw1lBA;EQ13lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElD61lBA;EQ/3lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,sBAAA;IASA,eAAA;ElDi2lBA;EQn4lBA;I0CnBM,SAAA;ElDy5lBN;EQt4lBA;I0CfM,SAAA;ElDw5lBN;EQz4lBA;I0CVQ,QAAA;ElDs5lBR;EQ54lBA;I0CVQ,QAAA;ElDy5lBR;EQ/4lBA;I0CVQ,QAAA;ElD45lBR;EQl5lBA;I0CVQ,QAAA;ElD+5lBR;EQr5lBA;I0CVQ,QAAA;ElDk6lBR;EQx5lBA;I0CVQ,QAAA;ElDq6lBR;EQ35lBA;I0CVQ,QAAA;ElDw6lBR;EQ95lBA;I0CVQ,QAAA;ElD26lBR;EQj6lBA;I0CVQ,QAAA;ElD86lBR;EQp6lBA;I0CVQ,QAAA;ElDi7lBR;EQv6lBA;I0CVQ,SAAA;ElDo7lBR;EQ16lBA;I0CVQ,SAAA;ElDu7lBR;EQ76lBA;I0CVQ,SAAA;ElD07lBR;EQh7lBA;IuBRA,cAAA;E/B27lBA;EQn7lBA;IuBLA,wBAAA;E/B27lBA;EQt7lBA;IuBLA,yBAAA;E/B87lBA;EQz7lBA;IuBLA,gBAAA;E/Bi8lBA;EQ57lBA;IuBLA,yBAAA;E/Bo8lBA;EQ/7lBA;IuBLA,yBAAA;E/Bu8lBA;EQl8lBA;IuBLA,gBAAA;E/B08lBA;EQr8lBA;IuBLA,yBAAA;E/B68lBA;EQx8lBA;IuBLA,yBAAA;E/Bg9lBA;EQ38lBA;IuBLA,gBAAA;E/Bm9lBA;EQ98lBA;IuBLA,yBAAA;E/Bs9lBA;EQj9lBA;IuBLA,yBAAA;E/By9lBA;AACF;AQr9lBE;EAAA;I0CzCM,aAAA;IACA,YAAA;IACA,eAAA;ElDkgmBN;EQ39lBA;I0CnCM,cAAA;IACA,WAAA;IACA,eAAA;ElDigmBN;EQh+lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,6BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,6CAAA;IAMF,sBAAA;ElDm8lBA;EQr+lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDw8lBA;EQ1+lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElD68lBA;EQ/+lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDk9lBA;EQp/lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDu9lBA;EQz/lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElD49lBA;EQ9/lBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDi+lBA;EQngmBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDs+lBA;EQxgmBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,qBAAA;IAGE,YAAA;IAAA,cAAA;IAAA,4BAAA;IAMF,cAAA;ElD2+lBA;EQ7gmBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDg/lBA;EQlhmBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,8BAAA;IAGE,YAAA;IAAA,cAAA;IAAA,8CAAA;IAMF,uBAAA;ElDq/lBA;EQvhmBA;I0CyBA,YAAA;IAAA,cAAA;IAAA,sBAAA;IASA,eAAA;ElDy/lBA;EQ3hmBA;I0CnBM,SAAA;ElDijmBN;EQ9hmBA;I0CfM,SAAA;ElDgjmBN;EQjimBA;I0CVQ,QAAA;ElD8imBR;EQpimBA;I0CVQ,QAAA;ElDijmBR;EQvimBA;I0CVQ,QAAA;ElDojmBR;EQ1imBA;I0CVQ,QAAA;ElDujmBR;EQ7imBA;I0CVQ,QAAA;ElD0jmBR;EQhjmBA;I0CVQ,QAAA;ElD6jmBR;EQnjmBA;I0CVQ,QAAA;ElDgkmBR;EQtjmBA;I0CVQ,QAAA;ElDmkmBR;EQzjmBA;I0CVQ,QAAA;ElDskmBR;EQ5jmBA;I0CVQ,QAAA;ElDykmBR;EQ/jmBA;I0CVQ,SAAA;ElD4kmBR;EQlkmBA;I0CVQ,SAAA;ElD+kmBR;EQrkmBA;I0CVQ,SAAA;ElDklmBR;EQxkmBA;IuBRA,cAAA;E/BmlmBA;EQ3kmBA;IuBLA,wBAAA;E/BmlmBA;EQ9kmBA;IuBLA,yBAAA;E/BslmBA;EQjlmBA;IuBLA,gBAAA;E/BylmBA;EQplmBA;IuBLA,yBAAA;E/B4lmBA;EQvlmBA;IuBLA,yBAAA;E/B+lmBA;EQ1lmBA;IuBLA,gBAAA;E/BkmmBA;EQ7lmBA;IuBLA,yBAAA;E/BqmmBA;EQhmmBA;IuBLA,yBAAA;E/BwmmBA;EQnmmBA;IuBLA,gBAAA;E/B2mmBA;EQtmmBA;IuBLA,yBAAA;E/B8mmBA;EQzmmBA;IuBLA,yBAAA;E/BinmBA;AACF;AkD5nkBA;;EAkBI,UAAA;AlD8mkBJ;AkDhokBA;EAsBI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;AlD6mkBJ;AkDtokBA;EA4BM,cAAA;EACA,gBAAA;EACA,gBAAA;AlD6mkBN;AkD3okBA;EAmCI,UAAA;AlD2mkBJ;AkD9okBA;EAsCM,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AlD2mkBN;AkDppkBA;EA6CM,eAAA;EACA,gBAAA;AlD0mkBN;AkDxpkBA;EAoDM,gBAAA;AlDumkBN;AkDrmkBM;EACE,gBAAA;AlDumkBR;AkD9pkBA;EA4DM,mBAAA;AlDqmkBN;AkDlmkBI;EACE,cAAA;EACA,UAAA;AlDomkBN;AkDrqkBA;EAqEM,gBAAA;AlDmmkBN;AkDxqkBA;EA0EI,aAAA;EACA,eAAA;EACA,cAAA;AlDimkBJ;AkD9lkBE;EACE,WAAA;AlDgmkBJ;AkD9lkBI;EAAA;IACE,cAAA;ElDimkBJ;EkDlmkBE;IAII,cAAA;ElDimkBN;EkDrmkBE;IAQI,eAAA;IACA,YAAA;IACA,gBAAA;ElDgmkBN;AACF;AkD3lkBI;EAAA;IACE,cAAA;ElD8lkBJ;AACF;AACA,0BAA0B;AkD1jkB1B;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AlD4jkBF;AkDxkkBA;EAeI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AlD4jkBJ;AkDjlkBA;EAyBI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,mCAAA;EACA,kBAAA;EACA,SAAA;AlD2jkBJ;AkDzjkBI;EACE,WAAA;EACA,aAAA;AlD2jkBN;AkDvjkBE;EACE,mCAAA;AlDyjkBJ;AkDpmkBA;EA+CI,cAAA;EACA,yBAAA;AlDwjkBJ;AkDxmkBA;EAoDI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AlDujkBJ;AkDphkBA;EACE,gBAAA;AlDshkBF;AkDvhkBA;EAII,gBAAA;EACA,gBAAA;AlDshkBJ;AACA,2CAA2C;AkDjhkB3C;EACE,kBAAA;EACA,aAAA;EACA,eAAA;AlDmhkBF;AkDthkBA;EAMI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;AlDmhkBJ;AACA,eAAe;AkD/gkBf;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;AlDihkBF;AkDxhkBA;EAUI,YAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;AlDihkBJ;AkD9gkBE;EACE,mBAAA;AlDghkBJ;AkD5gkBA;EACE,yBAAA;AlD8gkBF;AkD/gkBA;EAII,UAAA;AlD8gkBJ;AkD1gkBA;EACE,mCAAA;AlD4gkBF;AkDzgkBA;EACE,2BAAA;AlD2gkBF;AkDxgkBA;EACE,yBAAA;EACA,mBAAA;AlD0gkBF;AkD5gkBA;EAKI,2BAAA;AlD0gkBJ;AkDpgkBA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;AlDsgkBF;AkDzgkBA;EAMI,iBAAA;AlDsgkBJ;AkDlgkBA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,yBAAA;EAGA,iBAAA;EACA,uBAAA;ElDogkBA,wCAAwC;EACxC,+CAA+C;EAC/C,oCAAoC;EACpC,kCAAkC;AACpC;AkDtgkBE;EACE,cAAA;AlDwgkBJ;AkD1hkBA;EAuBI,kBAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;AlDsgkBJ;AkDngkBE;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;AlDqgkBJ;AkDlgkBE;;EAGI,mCAAA;AlDmgkBN;AkDzikBA;;EA6CI,yBAAA;AlDggkBJ;AkD7/jBE;EACE,mBAAA;AlD+/jBJ;AkDhjkBA;EAsDI,mBAAA;EACA,yBAAA;AlD6/jBJ;AkDpjkBA;EA4DI,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AlD2/jBJ;AkDv/jBA;EACE,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AlDy/jBF;AkDt/jBA;EACE,yBAAA;AlDw/jBF;AACA,6DAA6D;AkDr/jB7D;EACE,WAAA;EACA,kBAAA;EACA,aAAA;AlDu/jBF;AkDp/jBA;EACE,sBAAA;AlDs/jBF;AkDl/jBA;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;AlDo/jBF;AkDj/jBA;EACE,mBAAA;AlDm/jBF;AkD/+jBA;EACE,cAAA;AlDi/jBF;AkD7+jBA;EACE,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;AlD++jBF;AkD7+jBE;EACE,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AlD++jBJ;AkD7+jBI;EACE,qBAAA;AlD++jBN;AkD7+jBM;EACE,qBAAA;AlD++jBR;AkD1+jBE;EACE,oBAAA;AlD4+jBJ;AkD7+jBE;EAII,UAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AlD4+jBN;AkDt+jBE;EACE,2BAAA;EACA,4BAAA;EACA,kBAAA;AlDw+jBJ;AkDt+jBI;EACE,+BAAA;AlDw+jBN;AkDp+jBE;EACE,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;AlDs+jBJ;AkDl/jBE;;EAgBI,SAAA;EACA,UAAA;AlDs+jBN;AkDn+jBI;EACE,aAAA;AlDq+jBN;AkDl+jBI;EACE,oBAAA;EACA,eAAA;EACA,cAAA;AlDo+jBN;AkDh+jBE;EACE,QAAA;AlDk+jBJ;AkD1jkBA;;EA6FI,aAAA;EACA,SAAA;EACA,8BAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;AlDi+jBJ;AkD99jBE;EACE,SAAA;EACA,SAAA;EACA,4CAAA;EACA,gBAAA;EACA,kCAAA;EACA,kBAAA;EACA,2EAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,sBAAA;AlDg+jBJ;AkD99jBI;EACE,MAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;AlDg+jBN;AkD59jBE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AlD89jBJ;AkD59jBI;EACE,cAAA;AlD89jBN;AkD19jBE;EACE,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;EACA,wBAAA;AlD49jBJ;AkDz9jBE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AlD29jBJ;AkDz9jBI;EACE,gBAAA;AlD29jBN;AkDv9jBE;EACE,eAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AlDy9jBJ;AkD/9jBE;EASI,WAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AlDy9jBN;AkDr9jBE;EACE,gBAAA;AlDu9jBJ;AkDx9jBE;EAII,UAAA;EACA,eAAA;AlDu9jBN;AkDn9jBE;EACE,cAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AlDq9jBJ;AkDn9jBI;EACE,SAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;AlDq9jBN;AkDj9jBE;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,UAAA;EACA,+BAAA;AlDm9jBJ;AkDh9jBE;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,sBAAA;AlDk9jBJ;AkDh9jBI;EACE,UAAA;AlDk9jBN;AkDn9jBI;EAII,WAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AlDk9jBR;AkD78jBE;EACE,mBAAA;EACA,cAAA;EACA,oBAAA;EACA,wBAAA;EACA,sCAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;AlD+8jBJ;AkD78jBI;EACE,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AlD+8jBN;AkD38jBE;EACE,cAAA;EACA,sBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AlD68jBJ;AkD18jBE;EACE,kBAAA;EACA,+CAAA;EACA,yBAAA;EACA,gBAAA;AlD48jBJ;AkDz8jBE;EACE,6BAAA;EACA,SAAA;EACA,YAAA;EACA,gDAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AlD28jBJ;AkDr8jBE;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;EACA,sBAAA;AlDu8jBJ;AkDj8jBE;EACE,sBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;EACA,sBAAA;AlDm8jBJ;AkDj8jBI;;EAEE,yBAAA;AlDm8jBN;AkD97jBM;;EAEE,yBAAA;AlDg8jBR;AkD57jBI;EACE,yBAAA;EACA,cAAA;AlD87jBN;AkD57jBM;EACE,gBAAA;EACA,cAAA;AlD87jBR;AkD17jBI;EACE,yBAAA;EACA,cAAA;AlD47jBN;AkD17jBM;EACE,gBAAA;EACA,cAAA;AlD47jBR;AkDr+jBE;EA8CI,aAAA;EACA,eAAA;AlD07jBN;AkDz+jBE;EAkDM,cAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AlD07jBR;AkDn/jBE;EA6DM,cAAA;EACA,sBAAA;EACA,iBAAA;AlDy7jBR;AkDv7jBQ;EACE,cAAA;AlDy7jBV;AkD17jBQ;EAII,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AlDy7jBZ;AkDv7jBY;EACE,mBAAA;AlDy7jBd;AkDt7jBY;EACE,mBAAA;AlDw7jBd;AkDzgkBE;EAwFM,cAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AlDo7jBR;AkDj7jBM;EACE,+BAAA;EACA,gBAAA;EACA,mBAAA;AlDm7jBR;AkDj7jBQ;EACE,gBAAA;AlDm7jBV;AkDz7jBM;EAUI,gBAAA;AlDk7jBV;AkD57jBM;EAcI,iBAAA;AlDi7jBV;AkD36jBE;EACE,sBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;EACA,sBAAA;AlD66jBJ;AkD16jBE;EACE,sBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;EACA,sBAAA;AlD46jBJ;AkDz6jBE;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;EACA,sBAAA;EACA,oBAAA;AlD26jBJ;AkDx7jBE;EAgBI,kBAAA;AlD26jBN;AkD37jBE;EAmBM,YAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AlD26jBR;AkDp8jBE;EA6BM,qBAAA;EACA,sBAAA;AlD06jBR;AkDx8jBE;EAkCM,cAAA;EACA,eAAA;EACA,WAAA;AlDy6jBR;AkDp6jBE;EACE,aAAA;AlDs6jBJ;AkDj6jBA;EACE,qBAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;EACA,gCAAA;AlDm6jBF;AkDh6jBA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AlDk6jBF;AkD/5jBA;EACE,aAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;AlDi6jBF;AkD75jBA;EACE,gBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;AlD+5jBF;AkDr6jBA;EASI,iBAAA;AlD+5jBJ;AkD35jBA;EAGM,WAAA;EACA,YAAA;AlD25jBN;AkD/5jBA;EAOQ,WAAA;EACA,YAAA;AlD25jBR;AkDr5jBA;EACE,aAAA;EACA,kBAAA;AlDu5jBF;AkDz5jBA;EAKI,QAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,uDAAA;AlDu5jBJ;AkDt6jBA;EAmBI,aAAA;EACA,cAAA;AlDs5jBJ;AkDp5jBI;EACE,QAAA;EACA,kBAAA;AlDs5jBN;AkDx5jBI;EAKI,iBAAA;AlDs5jBR;AkD35jBI;EAQM,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;AlDs5jBV;AkDl6jBI;EAgBM,YAAA;AlDq5jBV;AkDr6jBI;EAqBI,aAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;AlDm5jBR;AkDj5jBQ;EACE,cAAA;AlDm5jBV;AkDr8jBA;EAwDM,WAAA;EACA,0BAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AlDg5jBN;AkD78jBA;EAiEM,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;AlD+4jBN;AkDt9jBA;EA0EQ,cAAA;AlD+4jBR;AkDz9jBA;EA8EQ,YAAA;AlD84jBR;AkD59jBA;EAkFQ,cAAA;AlD64jBR;AkD/9jBA;EAuFM,iBAAA;AlD24jBN;AkDl+jBA;EA2FM,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;AlD04jBN;AkDx4jBM;EAAA;IACE,cAAA;ElD24jBN;AACF;AkD/+jBA;EAyGI,aAAA;EACA,eAAA;EACA,4BAAA;EACA,2BAAA;EACA,uBAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;AlDy4jBJ;AkDz/jBA;EAmHM,kBAAA;AlDy4jBN;AkDt4jBI;EACE,aAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;AlDw4jBN;AkD94jBI;EASI,cAAA;AlDw4jBR;AkDj5jBI;EAaI,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AlDu4jBR;AkDv5jBI;EAmBM,aAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AlDu4jBV;AkD75jBI;EA0BM,aAAA;AlDs4jBV;AkDh6jBI;EA6BQ,aAAA;AlDs4jBZ;AkDn6jBI;EAkCM,YAAA;EACA,gBAAA;AlDo4jBV;AkDl4jBU;EACE,eAAA;AlDo4jBZ;AkDl4jBY;EACE,YAAA;AlDo4jBd;AkD76jBI;EA8CQ,YAAA;AlDk4jBZ;AkDh7jBI;EAiDU,YAAA;EACA,gBAAA;EACA,eAAA;AlDk4jBd;AkD/3jBY;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AlDi4jBd;AkDr4jBY;EAOI,WAAA;EACA,YAAA;AlDi4jBhB;AkD/7jBI;EAqEM,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AlD63jBV;AkDv3jBE;EACE,uBAAA;AlDy3jBJ;AkD/jkBA;EA0MI,WAAA;EACA,6BAAA;EACA,cAAA;AlDw3jBJ;AkDpkkBA;EAiNI,WAAA;EACA,gBAAA;EACA,mBAAA;AlDs3jBJ;AkDzkkBA;EAuNQ,cAAA;EACA,mBAAA;EACA,aAAA;AlDq3jBR;AkD9kkBA;EA+NI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AlDk3jBJ;AkDplkBA;EAsOI,+BAAA;AlDi3jBJ;AkDvlkBA;EA0OI,eAAA;EACA,sBAAA;EACA,mBAAA;AlDg3jBJ;AkD5lkBA;EA+OM,gBAAA;AlDg3jBN;AkD/lkBA;EAoPI,aAAA;EACA,aAAA;EACA,UAAA;AlD82jBJ;AkD32jBE;EAEI,qBAAA;AlD42jBN;AkD92jBE;EAKM,iBAAA;EACA,eAAA;AlD42jBR;AkD3mkBA;EAqQI,kBAAA;EACA,WAAA;EACA,sBAAA;AlDy2jBJ;AkDhnkBA;EA0QM,aAAA;EACA,mBAAA;AlDy2jBN;AkDpnkBA;EA8QQ,iBAAA;AlDy2jBR;AkDvnkBA;EAoRI,eAAA;EACA,mBAAA;AlDs2jBJ;AkD3nkBA;EAyRI,cAAA;EACA,eAAA;EACA,kBAAA;AlDq2jBJ;AkDhokBA;EA8RM,YAAA;AlDq2jBN;AkDnokBA;;EAoSI,mBAAA;AlDm2jBJ;AkDvokBA;;EAuSM,SAAA;EACA,oBAAA;EACA,cAAA;AlDo2jBN;AkD7okBA;EA8SI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,6BAAA;EACA,YAAA;AlDk2jBJ;AkDh2jBI;EAAA;IACE,eAAA;IACA,gBAAA;ElDm2jBJ;AACF;AkD1pkBA;EA2TM,oBAAA;EACA,kBAAA;EACA,aAAA;EAGA,iBAAA;EACA,WAAA;EACA,YAAA;AlDg2jBN;AkDlqkBA;EAwUM,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AlD61jBN;AkD9qkBA;EAqVM,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AlD41jBN;AkD9rkBA;EAsWM,cAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;AlD21jBN;AkDxskBA;EAgXQ,uBAAA;AlD21jBR;AkDx1jBM;EACE,YAAA;AlD01jBR;AkDv1jBM;EACE,aAAA;AlDy1jBR;AkDjtkBA;EA4XQ,aAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;AlDw1jBR;AkD9tkBA;EAyYU,aAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AlDw1jBV;AkDr1jBQ;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;AlDu1jBV;AkD5ukBA;EA2ZM,gBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EAMA,uBAAA;EACA,YAAA;AlD+0jBN;AkDp1jBM;EAAA;IACE,iBAAA;ElDu1jBN;AACF;AkDzvkBA;;EAyaQ,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;AlDo1jBR;AkDlwkBA;;EAibU,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AlDq1jBV;AkDzwkBA;EAybQ,mBAAA;AlDm1jBR;AkD5wkBA;EA6bQ,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;AlDk1jBR;AkDrxkBA;EAscU,cAAA;EACA,8BAAA;EACA,2BAAA;EACA,yBAAA;AlDk1jBV;AkD3xkBA;EA4cY,aAAA;AlDk1jBZ;AkD9xkBA;EA+cc,eAAA;AlDk1jBd;AkDjykBA;EAodY,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;AlDg1jBZ;AkD1ykBA;EA8dY,cAAA;EACA,iBAAA;AlD+0jBZ;AkD9ykBA;EAueI,cAAA;EACA,cAAA;EACA,kBAAA;AlD00jBJ;AkDt0jBA;EACE,kBAAA;AlDw0jBF;AkDr0jBA;EACE,aAAA;AlDu0jBF;AkDx0jBA;EAII,aAAA;AlDu0jBJ;AkDn0jBA;EAEI,YAAA;AlDo0jBJ;AkDt0jBA;EAKM,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;AlDo0jBN;AkD50jBA;EAYM,aAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AlDm0jBN;AkDp1jBA;EAoBQ,cAAA;AlDm0jBR;AkD7zjBA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AlD+zjBF;AkDn0jBA;EAOI,gBAAA;AlD+zjBJ;AkDt0jBA;EAUM,eAAA;AlD+zjBN;AkDz0jBA;EAeI,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AlD6zjBJ;AkD/0jBA;EAqBM,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AlD6zjBN;AkDr1jBA;EA6BI,SAAA;AlD2zjBJ;AkDvzjBA;EACE,gBAAA;AlDyzjBF;AkDtzjBA;EACE,gBAAA;AlDwzjBF;AkDzwjBA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;AlD2wjBF;AkDxwjBA;EACE,eAAA;AlD0wjBF;AkDrwjBA;EACE;IACE,UAAA;IAEA,mCAAA;ElDuwjBF;EkDpwjBA;IACE,UAAA;IACA,+BAAA;ElDswjBF;AACF;AkDnwjBA;EACE,uBAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EAEA,eAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EAEA,0BAAA;EACA,gBAAA;EAGA,gHAAA;AlDowjBF;AkD1xjBA;EA2BM,gBAAA;EACA,6BAAA;EACA,4BAAA;EACA,cAAA;AlDkwjBN;AkDhyjBA;EAoCM,gBAAA;EACA,6BAAA;EACA,4BAAA;AlD+vjBN;AkD3vjBE;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AlD6vjBJ;AkD1vjBE;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;AlD4vjBJ;AkDzvjBE;EACE,UAAA;AlD2vjBJ;AkDvvjBA;EACE,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;AlDyvjBF;AkDtvjBA;EACE,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;AlDwvjBF;AkDrvjBA;EAEE,4DAAA;AlDuvjBF;AkDpvjBA;EACE,kBAAA;EACA,qBAAA;AlDsvjBF;AkDnvjBA;EACE,YAAA;EACA,cAAA;AlDqvjBF;AkD7ujBU;EAEE,2BAAA;AlD+ujBZ;AkDxujBU;EAEE,6CAAA;AlD0ujBZ;AkDlujBA;EAEI,YAAA;EACA,6BAAA;AlDmujBJ;AkD/tjBA;EAEI,YAAA;AlDgujBJ;AkD3tjBE;EACE,UAAA;EACA,WAAA;AlD6tjBJ;AkD1tjBE;EACE,UAAA;EACA,WAAA;AlD4tjBJ;AkDvtjBE;EACE,YAAA;EACA,cAAA;AlDytjBJ;AkDttjBE;EACE,YAAA;EACA,cAAA;AlDwtjBJ;AkDntjBE;EACE,SAAA;EACA,cAAA;AlDqtjBJ;AkDltjBE;EACE,SAAA;EACA,cAAA;AlDotjBJ;AkDhtjBA;EACE,eAAA;EACA,qBAAA;EACA,SAAA;AlDktjBF;AkD/sjBA;EACE,qBAAA;AlDitjBF;AkDltjBA;EAII,UAAA;EACA,WAAA;EAEA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,UAAA;AlDgtjBJ;AkD3tjBA;EAeI,cAAA;AlD+sjBJ;AkD9tjBA;EAmBI,aAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AlD8sjBJ;AkDrujBA;EA0BM,cAAA;EACA,SAAA;AlD8sjBN;AkDzujBA;EAgCQ,YAAA;EACA,aAAA;AlD4sjBR;AkDzsjBM;EAEI,qBAAA;AlD0sjBV;AkDnsjBA;EACE,aAAA;AlDqsjBF;AkDtsjBA;EAII,mBAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,SAAA;AlDqsjBJ;AkDjtjBA;EAeM,wBAAA;EACA,qBAAA;EAEA,iBAAA;AlDosjBN;AkDttjBA;EAuBM,aAAA;AlDksjBN;AkDztjBA;;EA+BI,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;AlD8rjBJ;AkDtujBA;;EA2CM,kBAAA;AlD+rjBN;AkD5rjBI;;EACE,cAAA;AlD+rjBN;AkDhsjBI;;EAII,aAAA;AlDgsjBR;AkDlvjBA;;EAuDM,WAAA;EACA,YAAA;AlD+rjBN;AkDvvjBA;;EA4DQ,qBAAA;EACA,aAAA;AlDgsjBR;AkD7vjBA;EAmEI,aAAA;AlD6rjBJ;AkDhwjBA;EAuEI,aAAA;AlD4rjBJ;AkDnwjBA;EA2EI,OAAA;AlD2rjBJ;AkDtwjBA;EA+EI,OAAA;AlD0rjBJ;AkDzwjBA;EAmFI,QAAA;AlDyrjBJ;AkD5wjBA;EAuFI,QAAA;AlDwrjBJ;AkDprjBA;EACE,kBAAA;EACA,YAAA;AlDsrjBF;AkDxrjBA;EAKI,qBAAA;EACA,WAAA;AlDsrjBJ;AkDprjBI;EACE,aAAA;AlDsrjBN;AkD/rjBA;EAcI,qBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,wCAAA;EACA,sBAAA;AlDorjBJ;AkDlrjBI;EACE,8BAAA;AlDorjBN;AkDjrjBI;EACE,8BAAA;AlDmrjBN;AkDhrjBI;EACE,cAAA;EACA,WAAA;EACA,kBAAA;AlDkrjBN;AkDvtjBA;EAyCM,cAAA;EACA,YAAA;AlDirjBN;AkD3tjBA;EA6CQ,wBAAA;AlDirjBR;AkD9tjBA;EAmDI,MAAA;EACA,gBAAA;AlD8qjBJ;AkD5qjBI;EACE,kCAAA;EACA,mCAAA;EACA,8CAAA;EACA,QAAA;AlD8qjBN;AkDxujBA;EA+DI,QAAA;AlD4qjBJ;AkD1qjBI;EACE,kCAAA;EACA,mCAAA;EACA,2CAAA;EACA,QAAA;AlD4qjBN;AkDxqjBE;EACE,+BAAA;AlD0qjBJ;AkD3qjBE;EAII,UAAA;AlD0qjBN;AkDrqjBA;EACE,eAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,+BAAA;AlDuqjBF;AkDnrjBA;EAeI,oBAAA;EACA,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;AlDuqjBJ;AkDrqjBI;EACE,+BAAA;AlDuqjBN;AkD9rjBA;EA4BI,UAAA;EACA,YAAA;EACA,qBAAA;AlDqqjBJ;AkDlqjBM;EACE,uCAAA;AlDoqjBR;AkD/pjBM;EACE,oCAAA;AlDiqjBR;AkDzsjBA;EA8CI,uBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;AlD8pjBJ;AkD5pjBI;EACE,UAAA;AlD8pjBN;AkD5tjBA;EAmEI,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,oBAAA;AlD4pjBJ;AkD1pjBI;EACE,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,oBAAA;AlD4pjBN;AkDvpjBA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EAIA,mBAAA;EACA,YAAA;AlDypjBF;AkDnqjBA;EAaI,aAAA;EACA,SAAA;AlDypjBJ;AkDrpjBA;EACE,eAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,mBAAA;AlDupjBF;AkDppjBA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,+BAAA;EACA,UAAA;AlDspjBF;AkDpqjBA;EAmBM,4BAAA;AlDqpjBN;AkDhpjBA;EACE,kBAAA;AlDkpjBF;AkD/ojBA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;AlDipjBF;AkD/ojBE;EACE,UAAA;AlDipjBJ;AkD7ojBA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AlD+ojBF;AkD7ojBE;EACE,eAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;AlD+ojBJ;AkD5ojBE;EACE,eAAA;EACA,UAAA;EACA,mBAAA;AlD8ojBJ;AkD1ojBA;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EAEA,6CAAA;AlD4ojBF;AkDzojBA;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;AlD2ojBF;AkDxojBA;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;AlD0ojBF;AkDvojBA;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;AlDyojBF;AkDtojBA;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;AlDwojBF;AkDrojBA;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;AlDuojBF;AkDpojBA;EAeE,4BAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;AlDwnjBF;AkDzojBE;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;AlD2ojBJ;AkDxojBE;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;AlD0ojBJ;AkDjojBA;EAeE,4BAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;AlDqnjBF;AkDtojBE;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;AlDwojBJ;AkDrojBE;EACE,eAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;AlDuojBJ;AkD9njBA;EACE,cAAA;AlDgojBF;AkD9njBE;EACE,mBAAA;EACA,cAAA;AlDgojBJ;AkD7njBE;EACE,mBAAA;EACA,cAAA;AlD+njBJ;AkD3njBA;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AlD6njBF;AkD3njBE;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AlD6njBJ;AkD1njBE;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;AlD4njBJ;AkDxnjBA;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AlD0njBF;AkDxnjBE;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AlD0njBJ;AkDvnjBE;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AlDynjBJ;AkDrnjBA;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AlDunjBF;AkDrnjBE;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AlDunjBJ;AkDpnjBE;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AlDsnjBJ;AkDlnjBA;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AlDonjBF;AkDjnjBA;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AlDmnjBF;AkDhnjBA;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AlDknjBF;AkD/mjBA;;EAEE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AlDinjBF;AkD/mjBE;;EACE,cAAA;AlDknjBJ;AkD9mjBA;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AlDgnjBF;AkD7mjBA;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AlD+mjBF;AkD5mjBA;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AlD8mjBF;AkD3mjBA;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;AlD6mjBF;AkD1mjBA;EACE,4BAAA;AlD4mjBF;AkDxmjBM;EACE,6BAAA;AlD0mjBR;AkDpmjBA;EACE,4BAAA;AlDsmjBF;AkDlmjBM;EACE,6BAAA;AlDomjBR;AkD9ljBA;EACE,4BAAA;AlDgmjBF;AkD5ljBM;EACE,6BAAA;AlD8ljBR;AkDxljBA;EACE,4BAAA;AlD0ljBF;AkDvljBA;EACE,4BAAA;AlDyljBF;AkDtljBA;EACE,4BAAA;AlDwljBF;AkDrljBA;EACE,mBAAA;AlDuljBF;AkDpljBA;EACE,mBAAA;AlDsljBF;AkDnljBA;EACE,mBAAA;AlDqljBF;AkDlljBA;;;;;EAKE,cAAA;EACA,uBAAA;EACA,yBAAA;AlDoljBF;AkDlljBE;;;;;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;AlDwljBJ;AkDpljBA;;;;;EAKE,cAAA;EACA,mBAAA;AlDsljBF;AkDpljBE;;;;;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;AlD0ljBJ;AkDtljBA;EACE,gBAAA;EAEA,6CAAA;AlDwljBF;AkDrljBA;EACE,kBAAA;AlDuljBF;AkDpljBA;EAEI,eAAA;AlDqljBJ;AkDjljBA;EACE,qBAAA;AlDmljBF;AkDpljBA;EAII,eAAA;EAEA,2BAAA;AlDmljBJ;AkDzljBA;EAUI,WAAA;EACA,WAAA;EACA,iBAAA;AlDkljBJ;AkD9ljBA;EAgBI,cAAA;EACA,WAAA;EACA,eAAA;EACA,4BAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AlDiljBJ;AkD/kjBI;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,4BAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AlDiljBN;AkD5kjBA;EACE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AlD8kjBF;AkD3kjBA;EACE,qBAAA;EACA,UAAA;EACA,sBAAA;AlD6kjBF;AkD1kjBA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;AlD4kjBF;AkD1kjBE;EACE,WAAA;EACA,cAAA;EACA,WAAA;AlD4kjBJ;AkD1ljBA;EAqBI,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;AlD2kjBJ;AkDxkjBM;EACE,4BAAA;AlD0kjBR;AkDrkjBM;EACE,yBAAA;AlDukjBR;AkDzmjBA;EAwCI,uBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AlDokjBJ;AkDlkjBI;EACE,UAAA;EACA,SAAA;EACA,mBAAA;AlDokjBN;AkDjkjBI;EACE,mBAAA;AlDmkjBN;AkDhojBA;EAkEI,iBAAA;AlDikjBJ;AkDnojBA;EAsEI,gBAAA;AlDgkjBJ;AkDtojBA;EA0EI,gBAAA;AlD+jjBJ;AkDzojBA;EA8EI,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;AlD8jjBJ;AkDnpjBA;EAyFI,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AlD6jjBJ;AkD3jjBI;EACE,mBAAA;AlD6jjBN;AkD1jjBI;EACE,mBAAA;AlD4jjBN;AkDvjjBA;EAEI,UAAA;AlDwjjBJ;AkDpjjBA;EAEI,UAAA;AlDqjjBJ;AkDjjjBA;EACE,eAAA;EACA,yBAAA;AlDmjjBF;AkDhjjBA;;EAEE,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;AlDkjjBF;AkD/ijBA;EACE,mBAAA;EACA,UAAA;AlDijjBF;AkD9ijBA;EACE,gBAAA;AlDgjjBF;AkD7ijBA;EACE,iBAAA;EACA,YAAA;EACA,eAAA;AlD+ijBF;AkD/hjBA;EACE,gBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AlDiijBF;AkDzijBA;EAWI,iBAAA;AlDiijBJ;AkD9hjBE;EACE,mBAAA;EACA,cAAA;AlDgijBJ;AkD7hjBE;EACE,mBAAA;EACA,cAAA;AlD+hjBJ;AkD5hjBE;EACE,eAAA;AlD8hjBJ;AkD3hjBE;EACE,oBAAA;AlD6hjBJ;AkD1jjBA;EAiCI,gBAAA;EACA,mBAAA;EACA,mBAAA;AlD4hjBJ;AkDthjBE;;EAEE,iBAAA;AlDwhjBJ;AkD1hjBE;;EAKI,cAAA;AlDyhjBN;AkD9hjBE;;EASI,cAAA;AlDyhjBN;AkDphjBA;EAEI,WAAA;EACA,gDAAA;EACA,eAAA;AlDqhjBJ;AkDzhjBA;EAQI,UAAA;AlDohjBJ;AkD5hjBA;EAYI,0BAAA;AlDmhjBJ;AkD/hjBA;EAeM,iBAAA;AlDmhjBN;AkDlijBA;EAoBI,kBAAA;EACA,yBAAA;AlDihjBJ;AkDtijBA;EAwBM,4BAAA;AlDihjBN;AkDzijBA;EA6BI,mBAAA;AlD+gjBJ;AkD5ijBA;EAiCI,cAAA;EACA,0BAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AlD8gjBJ;AkDpjjBA;EAyCM,YAAA;EACA,gBAAA;AlD8gjBN;AkDxjjBA;EA+CI,WAAA;AlD4gjBJ;AkD3jjBA;EAmDI,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AlD2gjBJ;AkDlkjBA;EA2DI,cAAA;AlD0gjBJ;AkDrkjBA;EhBrwHE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6BAAA;EACA,gCAAA;EACA,kBAAA;EACA,eAAA;EAGA,gBAAA;EACA,gBAAA;EgBqzHI,gBAAA;EACA,mBAAA;EACA,cAAA;EAkBA,0BAAA;AlDwgjBN;AkC/0qBE;EACE,cAAA;EACA,gBAAA;AlCi1qBJ;AkD/ljBA;EhB9uHI,UAAA;EACA,gCAAA;AlCg1qBJ;AkC70qBE;EACE,gBAAA;EACA,gBAAA;AlC+0qBJ;AkC50qBE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AlC80qBJ;AkCj1qBE;EAMI,eAAA;EACA,UAAA;AlC80qBN;AkCv6qBE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCy6qBJ;AkCt6qBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCw6qBJ;AkCt6qBI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC26qBN;AkCv6qBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCy6qBJ;AkCv6qBI;;;;EAEE,yBAAA;EACA,mBAAA;AlC26qBN;AkCz6qBM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCo7qBR;AkC53qBE;EACE,mBAAA;EACA,yBAAA;EACA,cAAA;AlC83qBJ;AkCj4qBE;EAMI,cAAA;EACA,eAAA;EACA,UAAA;AlC83qBN;AkCv+qBE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCy+qBJ;AkCt+qBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCw+qBJ;AkCt+qBI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC2+qBN;AkCv+qBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCy+qBJ;AkCv+qBI;;;;EAEE,yBAAA;EACA,mBAAA;AlC2+qBN;AkCz+qBM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCo/qBR;AkC96qBE;EACE,mBAAA;AlCg7qBJ;AkC76qBE;EACE,mBAAA;EACA,cAAA;AlC+6qBJ;AkCj7qBE;EAKI,eAAA;AlC+6qBN;AkCvirBE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCyirBJ;AkCtirBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCwirBJ;AkCtirBI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC2irBN;AkCvirBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCyirBJ;AkCvirBI;;;;EAEE,yBAAA;EACA,mBAAA;AlC2irBN;AkCzirBM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCojrBR;AkC/9qBE;EACE,mBAAA;EACA,cAAA;AlCi+qBJ;AkCn+qBE;EAKI,eAAA;AlCi+qBN;AkCpmrBE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCsmrBJ;AkCnmrBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCqmrBJ;AkCnmrBI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCwmrBN;AkCpmrBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCsmrBJ;AkCpmrBI;;;;EAEE,yBAAA;EACA,mBAAA;AlCwmrBN;AkCtmrBM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCinrBR;AkCjhrBE;EACE,mBAAA;EACA,cAAA;AlCmhrBJ;AkCrhrBE;EAKI,eAAA;AlCmhrBN;AkCjqrBE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCmqrBJ;AkChqrBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCkqrBJ;AkChqrBI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCqqrBN;AkCjqrBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCmqrBJ;AkCjqrBI;;;;EAEE,yBAAA;EACA,mBAAA;AlCqqrBN;AkCnqrBM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC8qrBR;AkCnkrBE;EACE,uBAAA;EACA,cAAA;AlCqkrBJ;AkCvkrBE;EAKI,eAAA;AlCqkrBN;AkC9trBE;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;AlCgurBJ;AkC7trBE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlC+trBJ;AkC7trBI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCkurBN;AkC9trBE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCgurBJ;AkC9trBI;;;;EAEE,yBAAA;EACA,uBAAA;AlCkurBN;AkChurBM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlC2urBR;AkCtnrBI;EACE,uBAAA;EACA,cAAA;AlCwnrBN;AkC1nrBI;EAKI,eAAA;AlCwnrBR;AkC3xrBE;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;AlC6xrBJ;AkC1xrBE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlC4xrBJ;AkC1xrBI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlC+xrBN;AkC3xrBE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlC6xrBJ;AkC3xrBI;;;;EAEE,yBAAA;EACA,uBAAA;AlC+xrBN;AkC7xrBM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCwyrBR;AkCvqrBE;EACE,uBAAA;EACA,yBAAA;EACA,cAAA;AlCyqrBJ;AkC5qrBE;EAMI,eAAA;AlCyqrBN;AkCz1rBE;;;EAGE,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,mCAAA;AlC21rBJ;AkCx1rBE;;EAEE,cAAA;EACA,yBAAA;EACA,uBAAA;AlC01rBJ;AkCx1rBI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlC61rBN;AkCz1rBE;;EAEE,cAAA;EACA,yBAAA;EACA,uBAAA;AlC21rBJ;AkCz1rBI;;;;EAEE,qBAAA;EACA,uBAAA;AlC61rBN;AkC31rBM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,mCAAA;AlCs2rBR;AkCztrBE;EACE,uBAAA;EACA,cAAA;AlC2trBJ;AkC7trBE;EAKI,eAAA;AlC2trBN;AkCt5rBE;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,uCAAA;AlCw5rBJ;AkCr5rBE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCu5rBJ;AkCr5rBI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlC05rBN;AkCt5rBE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCw5rBJ;AkCt5rBI;;;;EAEE,yBAAA;EACA,uBAAA;AlC05rBN;AkCx5rBM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlCm6rBR;AkC3wrBE;EACE,UAAA;EACA,uBAAA;EACA,cAAA;AlC6wrBJ;AkChxrBE;EAMI,eAAA;AlC6wrBN;AkCp9rBE;;;EAGE,cAAA;EACA,6BAAA;EACA,uBAAA;EACA,aAAA;EACA,uCAAA;AlCs9rBJ;AkCn9rBE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCq9rBJ;AkCn9rBI;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlCw9rBN;AkCp9rBE;;EAEE,cAAA;EACA,6BAAA;EACA,uBAAA;AlCs9rBJ;AkCp9rBI;;;;EAEE,yBAAA;EACA,uBAAA;AlCw9rBN;AkCt9rBM;;;;;;;;;;;;EAGE,uBAAA;EACA,aAAA;EACA,uCAAA;AlCi+rBR;AkC7zrBE;EACE,mBAAA;EACA,cAAA;AlC+zrBJ;AkCj0rBE;EAKI,eAAA;AlC+zrBN;AkC5zrBI;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AlC8zrBN;AkCl0rBI;EAOI,eAAA;AlC8zrBR;AkC1hsBE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlC4hsBJ;AkCzhsBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC2hsBJ;AkCzhsBI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC8hsBN;AkC1hsBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC4hsBJ;AkC1hsBI;;;;EAEE,yBAAA;EACA,mBAAA;AlC8hsBN;AkC5hsBM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCuisBR;AkC72rBE;EACE,mBAAA;EACA,cAAA;AlC+2rBJ;AkCj3rBE;EAKI,eAAA;AlC+2rBN;AkC52rBI;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AlC82rBN;AkCl3rBI;EAOI,eAAA;AlC82rBR;AkChmsBE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCkmsBJ;AkC/lsBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCimsBJ;AkC/lsBI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlComsBN;AkChmsBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCkmsBJ;AkChmsBI;;;;EAEE,yBAAA;EACA,mBAAA;AlComsBN;AkClmsBM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC6msBR;AkC75rBE;EACE,mBAAA;EACA,cAAA;AlC+5rBJ;AkCj6rBE;EAKI,eAAA;AlC+5rBN;AkC55rBI;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AlC85rBN;AkCl6rBI;EAOI,eAAA;AlC85rBR;AkCtqsBE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCwqsBJ;AkCrqsBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCuqsBJ;AkCrqsBI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlC0qsBN;AkCtqsBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCwqsBJ;AkCtqsBI;;;;EAEE,yBAAA;EACA,mBAAA;AlC0qsBN;AkCxqsBM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCmrsBR;AkC98rBI;;;EAII,eAAA;AlC+8rBR;AkC18rBE;;EAEE,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,cAAA;AlC48rBJ;AkCj9rBE;;EAQI,cAAA;EACA,eAAA;AlC68rBN;AkC7usBE;;;;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,uCAAA;AlCkvsBJ;AkC/usBE;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCmvsBJ;AkCjvsBI;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,uCAAA;AlC4vsBN;AkCxvsBE;;;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlC4vsBJ;AkC1vsBI;;;;;;;;EAEE,yBAAA;EACA,mBAAA;AlCkwsBN;AkChwsBM;;;;;;;;;;;;;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,uCAAA;AlCuxsBR;AkC1hsBE;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AlC2hsBN;AkChisBE;EAQM,WAAA;EACA,YAAA;EACA,iBAAA;AlC2hsBR;AkCthsBE;EAEI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AlCuhsBN;AkC5hsBE;EAQM,WAAA;EACA,YAAA;EACA,iBAAA;AlCuhsBR;AkClhsBE;EACE,mBAAA;AlCohsBJ;AkCrhsBE;EAQI,QAAA;EACA,gBAAA;AlCghsBN;AkCzhsBE;EAKM,UAAA;AlCuhsBR;AkC/gsBE;EACE,kBAAA;AlCihsBJ;AkClhsBE;EAQI,QAAA;EACA,iBAAA;AlC6gsBN;AkCthsBE;EAKM,UAAA;AlCohsBR;AkC5gsBE;EAEI,SAAA;AlC6gsBN;AkCzgsBE;EACE,UAAA;AlC2gsBJ;AkCzgsBI;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;AlC2gsBN;AkC9gsBI;EAMI,gBAAA;EACA,eAAA;AlC2gsBR;AkCvgsBI;EAME,gBAAA;EACA,gBAAA;EACA,eAAA;AlCogsBN;AkC5gsBI;EAEI,gBAAA;EACA,eAAA;AlC6gsBR;AkCrgsBI;EACE,gBAAA;EACA,gBAAA;AlCugsBN;AkCngsBE;EAGM,UAAA;EACA,eAAA;AlCmgsBR;AkC9/rBE;EAGM,YAAA;AlC8/rBR;AkCz/rBE;EACE,iBAAA;AlC2/rBJ;AkCx/rBE;EACE,UAAA;AlC0/rBJ;AkCv/rBE;EACE,cAAA;EACA,iBAAA;AlCy/rBJ;AkDhmlBA;EAoEQ,eAAA;AlD+hlBR;AkD5hlBM;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AlD8hlBR;AkDlilBM;EAOI,eAAA;AlD8hlBV;AkCn6sBE;;;EAGE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;EACA,mCAAA;AlCq6sBJ;AkCl6sBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCo6sBJ;AkCl6sBI;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCu6sBN;AkCn6sBE;;EAEE,cAAA;EACA,6BAAA;EACA,mBAAA;AlCq6sBJ;AkCn6sBI;;;;EAEE,yBAAA;EACA,mBAAA;AlCu6sBN;AkCr6sBM;;;;;;;;;;;;EAGE,mBAAA;EACA,aAAA;EACA,mCAAA;AlCg7sBR;AkD1klBA;;;EAGE,aAAA;EACA,8BAAA;AlD4klBF;AkDhllBA;;;EAOI,aAAA;EACA,UAAA;AlD8klBJ;AkDtllBA;;;EAYI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AlD+klBJ;AkD7klBI;;;EACE,mBAAA;AlDillBN;AkD9klBI;;;EACE,mCAAA;AlDkllBN;AkD/klBI;;;EACE,mCAAA;AlDmllBN;AkDhllBI;;;EACE,mBAAA;AlDollBN;AkDjllBI;;;EACE,mCAAA;AlDqllBN;AkDlllBI;;;EACE,mBAAA;AlDsllBN;AkDjllBA;EACE,qBAAA;EACA,cAAA;EACA,eAAA;AlDmllBF;AkDtllBA;EAMI,aAAA;EACA,mBAAA;AlDmllBJ;AkD1llBA;EAWI,gBAAA;AlDkllBJ;AkD9klBA;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AlDgllBF;AkD9klBE;EACE,cAAA;EACA,2BAAA;AlDgllBJ;AkD1llBA;EAcI,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AlD+klBJ;AkDjmlBA;EAqBM,cAAA;EACA,iBAAA;AlD+klBN;AkD3jlBA;EACE,aAAA;EACA,eAAA;EACA,uCAAA;EACA,6BAAA;EACA,UAAA;AlD6jlBF;AkD3jlBE;EAAA;IACE,qCAAA;IACA,iCAAA;IACA,wBAAA;ElD8jlBF;AACF;AkDzklBA;EAcI,eAAA;EACA,kBAAA;EACA,cAAA;AlD8jlBJ;AkD1jlBA;EACE,oBAAA;EACA,mBAAA;EACA,MAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AlD4jlBF;AkD1jlBE;EAAA;IACE,MAAA;IACA,gBAAA;IACA,cAAA;IACA,YAAA;IACA,YAAA;IACA,gBAAA;IACA,gBAAA;ElD6jlBF;AACF;AkDhllBA;EAsBI,kBAAA;AlD6jlBJ;AkD1jlBE;EACE,kBAAA;EACA,SAAA;EACA,YAAA;EAOA,gBAAA;AlDsjlBJ;AkD3jlBI;EAAA;IACE,kBAAA;IACA,MAAA;ElD8jlBJ;AACF;AkDzjlBE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AlD2jlBJ;AkD9jlBE;EAMI,mBAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AlD2jlBN;AkDzjlBM;EACE,mBAAA;EACA,cAAA;AlD2jlBR;AkDxjlBM;EACE,mBAAA;EACA,cAAA;AlD0jlBR;AkDpjlBA;EAEI,sBAAA;AlDqjlBJ;AkDvjlBA;EAMI,iBAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;AlDojlBJ;AkDhjlBA;EAEI,cAAA;AlDijlBJ;AkD7ilBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,oBAAA;AlD+ilBF;AkD7ilBE;EAAA;IACE,kBAAA;IACA,mBAAA;ElDgjlBF;AACF;AkD1jlBA;EAaI,kBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AlDgjlBJ;AkD7ilBE;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,eAAA;AlD+ilBJ;AkD7ilBI;EAAA;IACE,eAAA;IACA,gBAAA;ElDgjlBJ;AACF;AkDzjlBE;EAYI,kBAAA;AlDgjlBN;AkD5jlBE;EAgBI,aAAA;EACA,aAAA;AlD+ilBN;AkD5ilBQ;EAAA;IACE,aAAA;ElD+ilBR;AACF;AkDrklBE;EA0BM,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AlD8ilBR;AkD5klBE;EAmCI,cAAA;EACA,QAAA;EACA,+BAAA;AlD4ilBN;AkDjllBE;EAyCI,SAAA;AlD2ilBN;AkDpllBE;EA6CI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AlD0ilBN;AkD5llBE;EAqDM,SAAA;EACA,gBAAA;EACA,iBAAA;AlD0ilBR;AkDjmlBE;EA2DM,WAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AlDyilBR;AkDvmlBE;EAmEI,gBAAA;AlDuilBN;AkDlilBA;EACE,gBAAA;EACA,kDAAA;EACA,cAAA;AlDoilBF;AkDvilBA;EAMI,WAAA;EACA,YAAA;EACA,iBAAA;AlDoilBJ;AkDhilBA;EACE,aAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;EACA,8BAAA;AlDkilBF;AkD/hlBA;EACE,eAAA;EACA,cAAA;AlDiilBF;AkD9hlBA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AlDgilBF;AkD9hlBE;EACE,aAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;AlDgilBJ;AkD5ilBA;EAgBI,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;EACA,2BAAA;AlD+hlBJ;AkDnjlBA;EAuBM,gBAAA;AlD+hlBN;AkDtjlBA;EA2BM,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AlD8hlBN;AkD7jlBA;EAoCI,eAAA;AlD4hlBJ;AkDxhlBA;EACE,aAAA;EACA,qCAAA;EACA,+BAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iCAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;AlD0hlBF;AkDrilBA;EAcI,kBAAA;AlD0hlBJ;AkDxilBA;EAkBI,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;AlDyhlBJ;AkDvhlBI;EACE,mBAAA;AlDyhlBN;AkDjjlBA;EA4BM,2BAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;AlDwhlBN;AkDzjlBA;EAqCM,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;AlDuhlBN;AkDphlBI;EAEI,aAAA;AlDqhlBR;AkDjhlBI;EAEI,mBAAA;AlDkhlBR;AkD5glBA;EAEI,aAAA;EACA,cAAA;EACA,mBAAA;AlD6glBJ;AkDjhlBA;EASI,gBAAA;EACA,gBAAA;EACA,aAAA;AlD2glBJ;AkDthlBA;EAcM,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AlD2glBN;AkD7hlBA;EAwBM,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AlDwglBN;AkDnilBA;EA+BM,cAAA;EACA,eAAA;EACA,iBAAA;AlDuglBN;AkDxilBA;EAqCM,aAAA;EACA,cAAA;EACA,eAAA;AlDsglBN;AkD7ilBA;EA0CQ,UAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;AlDsglBR;AkDnjlBA;EAkDM,aAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AlDoglBN;AkDzjlBA;EAyDM,eAAA;EACA,gBAAA;EACA,cAAA;AlDmglBN;AkD7/kBA;;EAII,eAAA;AlD6/kBJ;AkDjglBA;;;;EAQM,gBAAA;AlD+/kBN;AkD1/kBA;EACE,gBAAA;AlD4/kBF;AkDx/kBA;EACE,aAAA;EACA,cAAA;AlD0/kBF;AkDx/kBE;EACE,mBAAA;AlD0/kBJ;AkDv/kBE;EACE,aAAA;EACA,mBAAA;EACA,UAAA;AlDy/kBJ;AkD5/kBE;EAMI,eAAA;AlDy/kBN;AkD//kBE;EpDjpIA,WAAA;EACA,YAAA;EACA,kBAAA;AEmptBF;AkDpglBE;EAcI,aAAA;EACA,mBAAA;EACA,UAAA;AlDy/kBN;AkDr/kBE;EACE,iBAAA;AlDu/kBJ;AkDp/kBE;EAGM,eAAA;AlDo/kBR;AkDj/kBM;EAEI,eAAA;AlDk/kBV;AkD5+kBE;EAEI,yBAAA;EACA,yBAAA;AlD6+kBN;AkDz+kBE;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;AlD2+kBJ;AkDl/kBE;EAUI,gBAAA;AlD2+kBN;AkDv+kBE;EACE,aAAA;EACA,YAAA;AlDy+kBJ;AkD3+kBE;EAKI,aAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;AlDy+kBN;AkDl/kBE;EAYM,WAAA;EACA,YAAA;AlDy+kBR;AkDt/kBE;EAiBM,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AlDw+kBR;AkDhklBA;EA8FI,aAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;AlDq+kBJ;AkDvklBA;EAqGM,WAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AlDq+kBN;AkD7klBA;EA6GI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AlDm+kBJ;AkDj+kBI;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AlDm+kBN;AkD99kBA;EACE,aAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AlDg+kBF;AkDt+kBA;EASI,aAAA;EACA,cAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AlDg+kBJ;AkD9+kBA;EAiBM,aAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,2BAAA;EAAA,sBAAA;AlDg+kBN;AkDr/kBA;EAwBQ,mBAAA;AlDg+kBR;AkD19kBA;EAEI,iBAAA;EACA,oBAAA;AlD29kBJ;AkD99kBA;EAOI,aAAA;AlD09kBJ;AkDt9kBI;EAAA;IACE,gBAAA;ElDy9kBJ;AACF;AkDr9kBA;EACE,aAAA;EACA,cAAA;EACA,qBAAA;EACA,8BAAA;EACA,gBAAA;EACA,YAAA;AlDu9kBF;AkDr9kBE;EAAA;IACE,uBAAA;IACA,sBAAA;ElDw9kBF;AACF;AkDn+kBA;EAcI,iBAAA;EACA,SAAA;AlDw9kBJ;AkDv+kBA;EAmBI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,sBAAA;AlDu9kBJ;AkDr9kBI;EAAA;IACE,mBAAA;IACA,eAAA;ElDw9kBJ;AACF;AkDn/kBA;EA8BM,mBAAA;AlDw9kBN;AkDt/kBA;EAmCI,cAAA;AlDs9kBJ;AkDz/kBA;;EAuCM,oBAAA;EACA,eAAA;EACA,iBAAA;AlDs9kBN;AkDp9kBM;;;;EAEE,gBAAA;AlDw9kBR;AkDrglBA;;EAiDQ,YAAA;AlDw9kBR;AkDzglBA;EAuDI,SAAA;EACA,UAAA;AlDq9kBJ;AkD7glBA;EA2DM,iBAAA;AlDq9kBN;AkDhhlBA;EA+DM,aAAA;AlDo9kBN;AkDnhlBA;EAoEI,WAAA;EACA,gBAAA;ElDk9kBF,uCAAuC;EkDh9kBrC,YAAA;AlDk9kBJ;AkD98kBA;EACE,cAAA;AlDg9kBF;AkDj9kBA;EAQI,aAAA;EACA,mBAAA;EACA,cAAA;AlD48kBJ;AkDt9kBA;EAKM,gBAAA;AlDo9kBN;AkDz9kBA;EAaM,eAAA;EACA,YAAA;EACA,aAAA;AlD+8kBN;AkD99kBA;EAkBQ,WAAA;EACA,YAAA;EACA,iBAAA;AlD+8kBR;AkDn+kBA;EAyBM,aAAA;EACA,cAAA;EACA,gBAAA;AlD68kBN;AkDx+kBA;EA8BQ,gBAAA;AlD68kBR;AkD3+kBA;EAkCQ,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AlD48kBR;AkDl/kBA;EA0CQ,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;AlD28kBR;AkDz/kBA;EAmDM,aAAA;EACA,eAAA;EACA,cAAA;AlDy8kBN;AkD9/kBA;EAwDQ,cAAA;AlDy8kBR;AkDjglBA;EA4DQ,kBAAA;AlDw8kBR;AkDpglBA;EAiEM,SAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;AlDs8kBN;AkD5glBA;EAyEQ,gBAAA;AlDs8kBR;AkDh8kBA;EACE,iBAAA;AlDk8kBF;AkD/7kBA;EACE,SAAA;EACA,qBAAA;EACA,eAAA;AlDi8kBF;AkD97kBA;EAME,aAAA;EACA,iBAAA;AlD27kBF;AkDl8kBA;EAEI,aAAA;EACA,eAAA;AlDm8kBJ;AkD57kBA;EACE,kBAAA;AlD87kBF;AkD37kBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;AlD67kBF;AkD17kBA;EACE,yBAAA;AlD47kBF;AkDz7kBA;EACE,aAAA;AlD27kBF;AkDx7kBA;EACE,aAAA;AlD07kBF;AkDv7kBA;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,kCAAA;AlDy7kBF;AkDt7kBA;EACE,kCAAA;EAEA,uBAAA;EACA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;EACA,aAAA;EACA,kBAAA;AlDu7kBF;AkDr7kBE;EAAA;IACE,aAAA;IACA,gCAAA;IACA,gCAAA;ElDw7kBF;AACF;AkDv8kBA;EAkBI,aAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AlDw7kBJ;AkD78kBA;EAyBI,eAAA;EACA,aAAA;EACA,cAAA;EACA,aAAA;AlDu7kBJ;AkDr7kBI;EAAA;IACE,sBAAA;ElDw7kBJ;AACF;AkDp7kBA;EAEI,UAAA;AlDq7kBJ;AkDj7kBA;EACE,eAAA;EACA,gBAAA;AlDm7kBF;AkDr7kBA;EAKI,cAAA;AlDm7kBJ;AkDx7kBA;EAiBI,qBAAA;AlD06kBJ;AkD37kBA;EAUM,UAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AlDo7kBN;AkD/6kBI;EACE,mBAAA;AlDi7kBN;AkDr8kBA;EAyBI,cAAA;AlD+6kBJ;AkDx8kBA;EA6BI,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,qBAAA;AlD86kBJ;AkD98kBA;EAmCM,aAAA;EACA,sBAAA;AlD86kBN;AkDl9kBA;EAwCM,gBAAA;EACA,eAAA;EACA,iBAAA;ElD66kBJ,gBAAgB;EkD36kBZ,cAAA;AlD66kBN;AkDz9kBA;EAgDM,mBAAA;ElD46kBJ,eAAe;EkD16kBX,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AlD46kBN;AkDv6kBA;EACE,aAAA;AlDy6kBF;AkD16kBA;EAII,aAAA;EACA,cAAA;AlDy6kBJ;AkD96kBA;EAQM,mBAAA;EACA,cAAA;AlDy6kBN;AkDl7kBA;EAYQ,kBAAA;AlDy6kBR;AkDn6kBA;EACE,aAAA;EACA,8CAAA;EACA,mBAAA;AlDq6kBF;AkDx6kBA;EAMI,oBAAA;AlDq6kBJ;AkD36kBA;EAUI,YAAA;AlDo6kBJ;AwD9yuBA;EACE,qBAAA;E1DgQA,YAAA;EACA,aAAA;EACA,kBAAA;E0DhQA,gBAAA;EACA,yBAAA;EACA,4BAAA;AxDkzuBF;AwDjzuBE;;E1D2PA,WAAA;EACA,YAAA;EACA,kBAAA;AE0juBF;AwD7zuBA;EAUI,qBAAA;E1DuPF,YAAA;EACA,aAAA;EACA,kBAAA;E0DvPE,yBAAA;EACA,kCAAA;EACA,sBAAA;EACA,4BAAA;EACA,sCAAA;AxDwzuBJ;AwDx0uBA;EAkBM,WAAA;EACA,YAAA;AxDyzuBN;AwDtzuBE;EACE,oFAAA;AxDwzuBJ;AwDtzuBE;EACE,yCAAA;AxDwzuBJ;AwDrzuBA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;AxDuzuBF;AwDrzuBA;EACE,cAAA;AxDuzuBF;AyD31uBA;;EACE,aAAA;AzD81uBF;AyD/1uBA;;EAGI,YAAA;AzDg2uBJ;AyDn2uBA;;EAKM,YAAA;AzDk2uBN;AyDv2uBA;;EASI,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AzDk2uBJ;AyD/2uBA;;EAgBI,aAAA;AzDm2uBJ;AyDn3uBA;;EAmBI,eAAA;EACA,gBAAA;EACA,uBAAA;AzDo2uBJ;AyDl2uBE;EAAA;;IAEI,YAAA;EzDq2uBJ;AACF;AyDn2uBE;EAAA;;IAEI,aAAA;EzDs2uBJ;EyDx2uBA;;IAKI,SAAA;EzDu2uBJ;AACF;AyDn2uBA;EACE,cAAA;AzDq2uBF;AyDt2uBA;EAGI,2BAAA;AzDs2uBJ;AyDz2uBA;EAMI,gBAAA;EACA,eAAA;EACA,eAAA;AzDs2uBJ;AyDr2uBI;EAAA;IACE,eAAA;IACA,kBAAA;EzDw2uBJ;AACF;AyDv2uBI;EACE,kBAAA;AzDy2uBN;AyDv3uBA;EAiBM,cAAA;EACA,gBAAA;EACA,cAAA;AzDy2uBN;AyD53uBA;EAsBM,iBAAA;EACA,SAAA;AzDy2uBN;AyDh4uBA;EA0BM,iBAAA;EACA,SAAA;AzDy2uBN;AyDp4uBA;EA8BM,WAAA;EACA,YAAA;EACA,aAAA;AzDy2uBN;AyDp2uBA;EACE,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AzDs2uBF;AyD52uBA;EAQI,WAAA;AzDu2uBJ;AyDn2uBA;EACE,gBAAA;EACA,eAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;AzDq2uBF;AyDp2uBE;EAAA;IACE,gBAAA;IACA,gBAAA;EzDu2uBF;AACF;AyDj3uBA;EAYI,SAAA;AzDw2uBJ;AyDv2uBI;EAAA;IACE,mBAAA;EzD02uBJ;AACF;AyDz3uBA;EAkBI,cAAA;AzD02uBJ;AyDx2uBE;EACE,cAAA;EACA,aAAA;EACA,eAAA;AzD02uBJ;AyDz2uBI;EAAA;IACE,aAAA;IACA,iBAAA;EzD42uBJ;AACF;AyDz2uBE;EACE,gBAAA;EACA,UAAA;AzD22uBJ;AyD72uBE;EAII,gBAAA;EACA,mBAAA;AzD42uBN;AyDj3uBE;EAOM,qBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;AzD62uBR;AyDx3uBE;EAcM,qBAAA;EACA,sBAAA;EACA,kBAAA;AzD62uBR;A0Dl/uBA;EAEI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,cAAA;A1Dm/uBJ;A0Dz/uBA;EASI,aAAA;EACA,yDAAA;EAGA,4BAAA;EACA,sBAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;A1Di/uBJ;A0Dv/uBI;EAAU,yDAAA;A1D0/uBd;A0Dz/uBI;EAAa,yDAAA;A1D4/uBjB;A0Dt/uBI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yDAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;A1Dw/uBN;A0Dt/uBI;EAAA;IACE,cAAA;IACA,WAAA;IACA,gBAAA;IACA,WAAA;E1Dy/uBJ;AACF;A0D1hvBA;EAoCI,YAAA;EACA,YAAA;EACA,eAAA;EACA,yDAAA;A1Dy/uBJ;A0DhivBA;EA0CI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;A1Dy/uBJ;A0D3ivBA;;;EAqDI,WAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;EACA,cAAA;A1D2/uBJ;A0DrjvBA;;EA6DI,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;A1D4/uBJ;A0D1/uBM;;EACE,WAAA;EACA,YAAA;EACA,iFAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;A1D6/uBR;A0DvkvBA;;EAgFM,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;A1D2/uBN;A0DhlvBA;EAyFI,kBAAA;EACA,mBAAA;A1D0/uBJ;A0DplvBA;EA6FI,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;A1D0/uBJ;A0Dz/uBI;EACE,cAAA;A1D2/uBN;A0D7lvBA;EAsGI,kBAAA;EACA,mBAAA;EACA,aAAA;A1D0/uBJ;A0DlmvBA;EA0GM,cAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;A1D2/uBN;A0DxmvBA;EA+GQ,gBAAA;A1D4/uBR;A0Dz/uBI;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;A1D2/uBN;A0D9/uBI;EAKI,kBAAA;A1D4/uBR;A0DnnvBA;EA2HM,WAAA;A1D2/uBN;A0Dz/uBI;EACE,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;A1D2/uBN;A0DjgvBI;EAQI,mBAAA;A1D4/uBR;A0DpgvBI;EAWI,WAAA;A1D4/uBR;A0DvgvBI;;EAcI,kBAAA;A1D6/uBR;A0D3gvBI;;EAgBM,qBAAA;A1D+/uBV;A0D5ovBA;EAkJM,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;A1D6/uBN;A0D5/uBM;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1D8/uBR;A0D5/uBM;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1D8/uBR;A0DhqvBA;EAsKM,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;A1D6/uBN;A0DxqvBA;EA6KQ,cAAA;EACA,eAAA;EACA,cAAA;A1D8/uBR;A0D7qvBA;EAkLQ,cAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;A1D8/uBR;A0DprvBA;EAyLQ,cAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A1D8/uBR;A0DhsvBA;EAoMU,cAAA;EACA,YAAA;EACA,iBAAA;A1D+/uBV;A0DrsvBA;EA0MQ,yBAAA;A1D8/uBR;A0DxsvBA;EAiNI,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,SAAA;EACA,cAAA;A1D0/uBJ;A0DntvBA;EA2NM,cAAA;A1D2/uBN;A0DttvBA;EA+NI,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;A1D0/uBJ;A0DjuvBA;EAyOM,kBAAA;EACA,cAAA;A1D2/uBN;A0DruvBA;EA8OI,gBAAA;A1D0/uBJ;A0DxuvBA;EAgPM,eAAA;EACA,iBAAA;A1D2/uBN;A0D5uvBA;EAsPI,sBAAA;EACA,kBAAA;EACA,uBAAA;A1Dy/uBJ;A0DjvvBA;EA0PM,UAAA;EACA,eAAA;A1D0/uBN;A0DrvvBA;EA8PM,mBAAA;EACA,aAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;A1D0/uBN;A0Dz/uBM;EACE,gBAAA;A1D2/uBR;A0Dz/uBM;EACE,eAAA;A1D2/uBR;A0DlwvBA;EA0QQ,kBAAA;EACA,cAAA;EACA,eAAA;A1D2/uBR;A0DvwvBA;EA8QU,yBAAA;EACA,gBAAA;A1D4/uBV;A0D3wvBA;EAkRU,gBAAA;A1D4/uBV;A0D9wvBA;EAsRU,gBAAA;A1D2/uBV;A0DjxvBA;EAyRU,aAAA;EACA,YAAA;A1D2/uBV;A0Dz/uBQ;EACE,YAAA;EACA,kBAAA;A1D2/uBV;A0Dz/uBQ;EACE,gBAAA;A1D2/uBV;A0D5xvBA;EAsSM,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;A1Dy/uBN;A0DlyvBA;EA2SQ,iBAAA;EACA,eAAA;EACA,cAAA;A1D0/uBR;A2DtyvBA;EACE,oBAAA;EACA,kBAAA;A3DwyvBF;A2DvyvBE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,WAAA;A3DyyvBJ;A2DxyvBI;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,UAAA;EACA,mBAAA;A3D0yvBN;A2DvyvBI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,kEAAA;A3DyyvBN;A2DtyvBE;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;A3DwyvBJ;A2DryvBE;EACE,aAAA;EACA,iBAAA;EACA,mBAAA;A3DuyvBJ;A2DtyvBI;EACE,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;A3DwyvBN;A2DvyvBM;EACE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kDAAA;A3DyyvBR;A2DvyvBM;EACE,WAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kDAAA;A3DyyvBR;A2DtyvBI;EACE,cAAA;EACA,UAAA;EACA,YAAA;A3DwyvBN;A2D3yvBI;EAKI,kBAAA;EACA,mBAAA;A3DyyvBR;A2D/yvBI;EASI,gBAAA;A3DyyvBR;A2DvyvBM;EACE,YAAA;A3DyyvBR;A2DvyvBM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;A3DyyvBR;A2DvyvBM;EACE,aAAA;EACA,eAAA;EACA,WAAA;A3DyyvBR;A2D5yvBM;EAKI,cAAA;A3D0yvBV;A2DvyvBM;EACE,aAAA;EACA,cAAA;A3DyyvBR;A2D3yvBM;EAII,oBAAA;A3D0yvBV;A2D9yvBM;EAOI,cAAA;EACA,qBAAA;A3D0yvBV;A2DlzvBM;;EAWI,mBAAA;EACA,gBAAA;EACA,kBAAA;A3D2yvBV;A2DxzvBM;;EAeM,cAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;A3D6yvBZ;A2D/zvBM;EAsBI,cAAA;A3D4yvBV;A2Dl0vBM;EA0BM,aAAA;EACA,uBAAA;EACA,mBAAA;A3D2yvBZ;A2DvyvBM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;A3DyyvBR;A2D92vBI;EAwEI,oBAAA;EACA,iBAAA;A3DyyvBR;A2Dl3vBI;EA2EM,kBAAA;A3D0yvBV;A2DnyvBA;;EACI,cAAA;EACA,eAAA;EACA,gBAAA;A3DsyvBJ;A2DnyvBA;EACE,kBAAA;A3DqyvBF;A2DnyvBI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;A3DqyvBN;A4Dl9vBE;EACE,eAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;A5Do9vBJ;A4D19vBE;EAQI,kBAAA;A5Dq9vBN;A4D79vBE;EAWI,aAAA;EACA,aAAA;A5Dq9vBN;A4Dn9vBQ;EAAA;IACE,aAAA;E5Ds9vBR;AACF;A4Dt+vBE;EAmBM,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;A5Ds9vBR;A4D7+vBE;EA2BI,cAAA;EACA,QAAA;EACA,+BAAA;A5Dq9vBN;A4Dl/vBE;EAgCI,SAAA;A5Dq9vBN;A4Dr/vBE;EAmCI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;A5Dq9vBN;A4Dp9vBM;EACE,cAAA;EACA,gBAAA;EACA,iBAAA;A5Ds9vBR;A4DlgwBE;EA+CM,WAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;A5Ds9vBR;A4DxgwBE;EAsDI,gBAAA;A5Dq9vBN;A4Dh9vBA;EACE,cAAA;EACA,YAAA;A5Dk9vBF;A4Dp9vBA;EAII,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;A5Dm9vBJ;A4D39vBA;EAUM,cAAA;A5Do9vBN;A4Dj9vBE;EACE,YAAA;A5Dm9vBJ;A4Dj9vBE;EACE,gBAAA;A5Dm9vBJ;A4Dj9vBE;EACE,kBAAA;EACA,eAAA;A5Dm9vBJ;A4Dj9vBE;EACE,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,qCAAA;EACA,iDAAA;A5Dm9vBJ;A4Dj9vBE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;A5Dm9vBJ;A4D39vBE;EAUI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;A5Do9vBN;A4Dl+vBE;EAiBI,kBAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A5Do9vBN;A4Dh9vBA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;A5Dk9vBF;AACA;;;;;;CAMC;A6D5kwBD;;;;EAIC,sBAAA;A7D8kwBD;A6D5kwBA;;EAEC,kBAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;;;;EAIC,YAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,gBAAA;EACA,eAAA;EACA,kCAAA;A7D8kwBD;A6D5kwBA;EACC,kCAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;A7D8kwBD;A6D5kwBA;EACC,sBAAA;A7D8kwBD;A6D5kwBA;EACC,mCAAA;EAGA,4BAAA;A7D8kwBD;A6D5kwBA;EACC,wBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6DvkwBA;;EAEC,mBAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,SAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;;EAEC,gBAAA;A7D8kwBD;A6D5kwBA;;;;;EAKC,aAAA;A7D8kwBD;A6D5kwBA;EACC,2BAAA;EACA,cAAA;EACA,iBAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,UAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;A7D8kwBD;A6D5kwBA;;EAEC,YAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;A7D8kwBD;A6D5kwBA;;EAEC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,mCAAA;A7D8kwBD;A6D5kwBA;EACC,uCAAA;EACA,mCAAA;A7D8kwBD;A6D5kwBA;;EAEC,cAAA;A7D8kwBD;A6D5kwBA;;;;EAIC,mBAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;EACA,mCAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,2BAAA;A7D8kwBD;A6D5kwBA;;;;EAIC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,wBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;A7D8kwBD;A6D5kwBA;;EAEC,yBAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;;EAEC,qBAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,uCAAA;EACA,cAAA;EACA,mCAAA;A7D8kwBD;A6D5kwBA;EACC,kCAAA;EACA,qBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;A7D8kwBD;A6D5kwBA;;;EAGC,wCAAA;EACA,qBAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,wCAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,4BAAA;A7D8kwBD;A6D5kwBA;;EAEC,cAAA;A7D8kwBD;A6D5kwBA;;EAEC,wCAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,kCAAA;EACA,qBAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;A7D8kwBD;A6D5kwBA;EACC,kCAAA;EACA,oBAAA;A7D8kwBD;A6D5kwBA;EACC,iBAAA;EACA,gBAAA;EACA,yBAAA;EAGA,wDAAA;EACA,kBAAA;EACA,8CAAA;EACA,WAAA;EACA,2BAAA;EACA,UAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EACA,4BAAA;EACA,qBAAA;A7D8kwBD;A6D5kwBA;EACC,yCAAA;EACA,yBAAA;EAGA,2DAAA;EACA,uEAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,yCAAA;EACA,yBAAA;EAGA,2DAAA;EACA,uEAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,yCAAA;EACA,yBAAA;EAGA,qDAAA;EACA,uEAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,sBAAA;A7D8kwBD;A6D5kwBA;;EAEC,sBAAA;EACA,8EAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;A7D8kwBD;A6D5kwBA;EACC,iBAAA;A7D8kwBD;A6D5kwBA;;EAEC,eAAA;EACA,0BAAA;EACA,6BAAA;A7D8kwBD;A6D5kwBA;;EAEC,cAAA;EACA,yBAAA;EACA,4BAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,kCAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;EACA,+CAAA;EACA,+BAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;A7D8kwBD;A6D5kwBA;EACC,iBAAA;EACA,cAAA;EACA,YAAA;EACA,6CAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,SAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;A7D8kwBD;A6D5kwBA;EACC,sBAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,qCAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EAGA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,sBAAA;A7D8kwBD;A6D5kwBA;;EAEC,uBAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,aAAA;EACA,oCAAA;A7D8kwBD;A6D5kwBA;;EAEC,cAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,sBAAA;EACA,0EAAA;EACA,gBAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC;IACC,eAAA;IACA,qBAAA;IACA,sBAAA;IACA,gBAAA;IACA,kBAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;A7D8kwBD;A6D5kwBA;EACC,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,SAAA;EACA,SAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;A7D8kwBD;A6D5kwBA;EACC,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;A7D8kwBD;A6D5kwBA;;;;EAIC,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;EACA,wEAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;;EAEC,cAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;EACC;;IAEC,eAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,kBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,eAAA;EAEA,yCAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,uBAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;A7D8kwBD;A6D5kwBA;EACC,sBAAA;A7D8kwBD;A6D5kwBA;;;;EAIC,aAAA;EACA,kBAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;EACC,gBAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;;;;;;;;EAQC,cAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gDAAA;EAEA,wEAAA;A7D8kwBD;A6D5kwBA;;;;;;;;EAQC,qBAAA;EACA,UAAA;EACA,kFAAA;A7D8kwBD;A6D5kwBA;;;;;;;;EAQC,yBAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;;;;;;;;EAQC,WAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;EACA,yBAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,sBAAA;EACA,mBAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,oBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;A7D8kwBD;A6D5kwBA;EACC,SAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EACA,0BAAA;A7D8kwBD;A6D5kwBA;EACC,iBAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,0DAAA;A7D8kwBD;A6D5kwBA;EACC,gCAAA;A7D8kwBD;A6D5kwBA;EACC;IACC,aAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;A7D8kwBD;A6D5kwBA;EACC;;;;;;IAMC,wBAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,iBAAA;EACA,cAAA;EACA,wEAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EAEA,mCAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;A7D8kwBD;A6D5kwBA;;EAEC,mBAAA;A7D8kwBD;A6D5kwBA;;;;;;;;EAQC,kCAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,gBAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,iBAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;;EAEC,cAAA;EACA,kBAAA;A7D8kwBD;A6D5kwBA;EACC,iBAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,iBAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;;EAEC,sBAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;A7D8kwBD;A6D5kwBA;;EAEC,iBAAA;A7D8kwBD;A6D5kwBA;EACC,kCAAA;EACA,YAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;EACA,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EAEA,+BAAA;EACA,cAAA;EACA,qBAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;EACA,UAAA;A7D8kwBD;A6D5kwBA;;EAEC,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;A7D8kwBD;A6D5kwBA;;EAEC,qBAAA;A7D8kwBD;A6D5kwBA;;EAEC,UAAA;A7D8kwBD;A6D5kwBA;;EAEC,oDAAA;A7D8kwBD;A6D5kwBA;;EAEC,yBAAA;EACA,0BAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,yBAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC;IACC,aAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,oDAAA;A7D8kwBD;A6D5kwBA;EACC,uCAAA;EACA,0BAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EAGA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EAEA,yCAAA;EACA,gCAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,qBAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,yBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;;EAEC,YAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,gBAAA;EACA,aAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EAGA,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,gBAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;EAEA,kDAAA;EACA,uBAAA;EACA,kBAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;EACA,yBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;EAEA,6BAAA;EACA,yBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,gBAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EACA,WAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;A7D8kwBD;A6D5kwBA;EACC,uBAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;EACA,YAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;;EAEC,UAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC;IACC,WAAA;IACA,cAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,MAAA;EACA,YAAA;EACA,OAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,QAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EAEA,4BAAA;EACA,aAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;;EAEC,YAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;A7D8kwBD;A6DtkwBA;EACC;IAEC,wBAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,kEAAA;EACA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EAEA,oCAAA;A7D8kwBD;A6D5kwBA;;EAEC,qBAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EAEA,+BAAA;EACA,iBAAA;EACA,yBAAA;EACA,wBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,YAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,YAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC;IACC,YAAA;E7D8kwBA;AACF;A6D5kwBA;;EAEC,YAAA;A7D8kwBD;A6D5kwBA;EACC;;IAEC,YAAA;IACA,iBAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,sBAAA;A7D8kwBD;A6D5kwBA;EACC,4BAAA;EACA,WAAA;EACA,+CAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,gBAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EACA,WAAA;EACA,yBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;A7D8kwBD;A6D5kwBA;EACC,sBAAA;EAEA,gLAAA;EACA,0BAAA;EACA,kCAAA;EACA,YAAA;EACA,gBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,kBAAA;EACA,aAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;A7D8kwBD;A6D5kwBA;EACC,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EAGA,iBAAA;EACA,eAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;;EAEC,UAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,4BAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;A7D8kwBD;A6D5kwBA;;EAEC,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,UAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;;EAEC,sBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,kCAAA;EACA,UAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,8BAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,UAAA;EAEA,gCAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;EACA,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,UAAA;EACA,yBAAA;EACA,SAAA;EACA,wBAAA;EACA,eAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,gBAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;EACC,oBAAA;EACA,oBAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;EACC,gCAAA;EACA,iCAAA;A7D8kwBD;A6D5kwBA;;EAEC,sBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;EACA,8CAAA;EACA,sBAAA;EACA,gBAAA;EACA,2BAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EAEA,gBAAA;EACA,UAAA;EACA,MAAA;EACA,UAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,qBAAA;EACA,cAAA;EACA,yBAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,0BAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EAEA,6DAAA;A7D8kwBD;A6D5kwBA;EACC,uCAAA;EACA,YAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;EACA,+BAAA;EACA,UAAA;EACA,2BAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;EACC,wBAAA;EACA,WAAA;EACA,6BAAA;EACA,SAAA;EACA,wBAAA;A7D8kwBD;A6D5kwBA;;EAEC,WAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;A7D8kwBD;A6D5kwBA;;EAEC,WAAA;EACA,qBAAA;EACA,YAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;;EAEC,6BAAA;A7D8kwBD;A6D5kwBA;EACC,wBAAA;A7D8kwBD;A6D5kwBA;EACC,iBAAA;A7D8kwBD;A6D5kwBA;;;EAGC,6BAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EACA,aAAA;A7D8kwBD;A6D5kwBA;;EAEC,uCAAA;EACA,aAAA;A7D8kwBD;A6D5kwBA;EACC,wBAAA;A7D8kwBD;A6D5kwBA;EACC,QAAA;EACA,SAAA;EACA,mCAAA;EACA,kCAAA;EACA,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;;EAIC,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;EACA,iFAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,YAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;EACA,QAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,UAAA;EACA,WAAA;EAEA,+BAAA;A7D8kwBD;A6D5kwBA;EACC;IACC,aAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,2BAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,YAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;EACA,QAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,2BAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,YAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;EACA,QAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,OAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;EACA,wCAAA;EACA,oCAAA;A7D8kwBD;A6D5kwBA;EACC,gBAAA;EACA,eAAA;EACA,6BAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EACA,8CAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,qBAAA;EAEA,wBAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,UAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,QAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;EACA,sBAAA;EACA,2BAAA;A7D8kwBD;A6D5kwBA;EACC,2BAAA;A7D8kwBD;A6D5kwBA;EACC,wBAAA;EACA,4BAAA;A7D8kwBD;A6D5kwBA;;EAEC,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;;EAEC,yBAAA;A7D8kwBD;A6D5kwBA;;EAEC,eAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC;IACC,WAAA;IACA,eAAA;IACA,gBAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,sBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;EACA,kBAAA;A7D8kwBD;A6D5kwBA;;EAEC,SAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;A7D8kwBD;A6D5kwBA;;EAEC,iBAAA;A7D8kwBD;A6D5kwBA;;EAEC,yBAAA;EAGA,iBAAA;EACA,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;;EAEC,UAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;EACA,eAAA;EACA,kBAAA;A7D8kwBD;A6D5kwBA;EACC,wCAAA;EACA,qBAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;A7D8kwBD;A6D5kwBA;;;EAGC,wBAAA;EACA,qBAAA;EACA,cAAA;EACA,aAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;;;EAGC,qBAAA;EACA,iDAAA;A7D8kwBD;A6D5kwBA;EACC;;;IAGC,gBAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,aAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EAEA,mCAAA;EACA,gBAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,gBAAA;EACA,wCAAA;EACA,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EAEA,8DAAA;A7D8kwBD;A6D5kwBA;EACC,kEAAA;EACA,yBAAA;EACA,qBAAA;A7D8kwBD;A6D5kwBA;EACC,gBAAA;EACA,cAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,cAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;EACA,qBAAA;A7D8kwBD;A6D5kwBA;;EAEC,cAAA;EACA,0BAAA;EACA,UAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;A7D8kwBD;A6D5kwBA;EACC,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,yBAAA;EAGA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,qBAAA;EACA,YAAA;EACA,sBAAA;EACA,QAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,qBAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;A7D8kwBD;A6DjkwBA;EACC;IACC,YAAA;E7D8kwBA;E6D5kwBD;IACC,UAAA;E7D8kwBA;E6D5kwBD;IACC,YAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,mBAAA;EACA,WAAA;EAEA,oDAAA;EACA,2BAAA;A7D8kwBD;A6D5kwBA;;EAGC,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,iCAAA;EACA,mBAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;EACA,YAAA;EACA,kCAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,QAAA;EACA,kCAAA;A7D8kwBD;A6D5kwBA;EACC,iBAAA;EACA,kBAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EAEA,kCAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,oCAAA;EACA,aAAA;A7D8kwBD;A6D5kwBA;EACC;IACC,qBAAA;IACA,2BAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,iBAAA;A7D8kwBD;A6D5kwBA;;EAEC,WAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;A7D8kwBD;A6D5kwBA;;EAEC,UAAA;A7D8kwBD;A6D5kwBA;;EAEC,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;;;;EAIC,UAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;A7D8kwBD;A6D5kwBA;EACC,gBAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;EACA,MAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;A7D8kwBD;A6D5kwBA;;EAEC,sBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;A7D8kwBD;A6D5kwBA;;EAEC,qBAAA;EACA,sBAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,sBAAA;EACA,0BAAA;EACA,WAAA;EACA,wBAAA;A7D8kwBD;A6D5kwBA;EACC,QAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,UAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;EACC,wBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EAEA,mDAAA;EACA,UAAA;EACA,iCAAA;EACA,cAAA;EACA,gBAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,qCAAA;EACA,cAAA;EACA,wCAAA;A7D8kwBD;A6D5kwBA;EACC,oCAAA;EACA,cAAA;EACA,wCAAA;A7D8kwBD;A6D5kwBA;EACE,gBAAA;A7D8kwBF;A6D5kwBA;EACE,gBAAA;EACA,8BAAA;A7D8kwBF;A6DhlwBA;EAII,aAAA;A7D+kwBJ;A6D5kwBA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,0BAAA;A7D8kwBD;A6D5kwBA;EACC,sBAAA;A7D8kwBD;A6D5kwBA;;EAEC,YAAA;A7D8kwBD;A6D5kwBA;EACC,+BAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,+BAAA;A7D8kwBD;A6D5kwBA;EACC,+BAAA;A7D8kwBD;A6D5kwBA;EACC,mCAAA;EAGA,2BAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,0BAAA;EACA,oBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;A7D8kwBD;A6D5kwBA;EACC,gCAAA;EACA,6BAAA;A7D8kwBD;A6D5kwBA;EACC,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,4BAAA;EACA,kCAAA;EACA,sBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,wCAAA;EACA,qBAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,SAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;EACA,gBAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;EACA,qBAAA;EAEA,wBAAA;EACA,gBAAA;EACA,wCAAA;EACA,yBAAA;EACA,UAAA;A7D8kwBD;A6D5kwBA;EACC,SAAA;EACA,YAAA;EACA,yBAAA;A7D8kwBD;A6D5kwBA;EACC,wEAAA;EACA,cAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;EACA,WAAA;EACA,yBAAA;EAGA,iBAAA;EACA,kBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,WAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;EACA,aAAA;EACA,kBAAA;EACA,uCAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,oBAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,sBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EAEA,+BAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,qCAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;;EAEC,kBAAA;EACA,qBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,mBAAA;EACA,uCAAA;EACA,wCAAA;EACA,WAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,SAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,SAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,YAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC;IACC,WAAA;IACA,YAAA;E7D8kwBA;E6D5kwBD;IACC,WAAA;IACA,UAAA;IACA,iBAAA;E7D8kwBA;E6D5kwBD;IACC,YAAA;IACA,UAAA;IACA,iBAAA;E7D8kwBA;E6D5kwBD;IACC,YAAA;IACA,aAAA;IACA,iBAAA;E7D8kwBA;E6D5kwBD;IACC,WAAA;IACA,aAAA;IACA,iBAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,iBAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,SAAA;EACA,QAAA;EACA,yBAAA;EAGA,iBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,sDAAA;EACA,wCAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;;EAEC,gBAAA;A7D8kwBD;A6D5kwBA;;EAEC,wBAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;;;EAGC,wBAAA;EACA,UAAA;EACA,SAAA;A7D8kwBD;A6D5kwBA;EACC,SAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,aAAA;EACA,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EAEA,aAAA;EACA,gBAAA;A7D8kwBD;A6DzkwBA;EACC,mBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,cAAA;EACA,YAAA;EACA,QAAA;EACA,6BAAA;EACA,uBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EAGA,iBAAA;A7D8kwBD;A6D5kwBA;;EAEC,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EAGA,iBAAA;A7D8kwBD;A6D5kwBA;;EAEC,0BAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;EACA,yBAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,qBAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;EACC,gBAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,kCAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;;EAEC,WAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;A7D8kwBD;A6D5kwBA;;;EAGC,eAAA;EACA,kCAAA;EACA,WAAA;EACA,0BAAA;A7D8kwBD;A6D5kwBA;;EAEC,WAAA;A7D8kwBD;A6D5kwBA;;EAEC,sBAAA;A7D8kwBD;A6D5kwBA;EACC,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;A7D8kwBD;A6D5kwBA;EACC,YAAA;EACA,kBAAA;EACA,QAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,SAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;EACA,aAAA;EACA,eAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;A7D8kwBD;A6D5kwBA;;;EAGC,YAAA;EACA,qBAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,kBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,2BAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;A7D8kwBD;A6D5kwBA;EACC,qBAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,UAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EAGA,iCAAA;EAEA,YAAA;EACA,6BAAA;EACA,6BAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,0CAAA;A7D8kwBD;A6D5kwBA;EACC,yBAAA;EAEA,sBAAA;A7D8kwBD;A6D5kwBA;;EAEC,YAAA;A7D8kwBD;A6D5kwBA;;EAEC,WAAA;EAEA,wCAAA;A7D8kwBD;A6D5kwBA;;EAEC,kDAAA;A7D8kwBD;A6D5kwBA;;EAEC,cAAA;A7D8kwBD;A6D5kwBA;EACC;;IAEC,WAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,YAAA;EACA,aAAA;A7D8kwBD;A6D5kwBA;;EAEC,qBAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;EACC,SAAA;EACA,iBAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;EACC,UAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,qBAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,aAAA;EACA,cAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;A7D8kwBD;A6D5kwBA;;EAEC,yBAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;A7D8kwBD;A6D5kwBA;EACC,eAAA;EACA,UAAA;EACA,MAAA;EACA,UAAA;A7D8kwBD;A6D5kwBA;EACC,cAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;EACA,gBAAA;A7D8kwBD;A6D5kwBA;EACC;IACC,eAAA;E7D8kwBA;AACF;A6D5kwBA;EACC,eAAA;EACA,iBAAA;EACA,sBAAA;A7D8kwBD;A6D5kwBA;EACC,mBAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;EACA,qBAAA;EACA,WAAA;A7D8kwBD;A6D5kwBA;EACC,WAAA;EACA,yBAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;A7D8kwBD;A6D5kwBA;EACC,aAAA;EACA,cAAA;A7D8kwBD;A6D5kwBA;;EAEC,SAAA;A7D8kwBD;A6D3kwBA;EACE,UAAA;A7D6kwBF;A6D3kwBA;EACE,eAAA;A7D6kwBF;A6D9kwBA;EAGI,cAAA;EACA,iBAAA;EACA,aAAA;A7D8kwBJ;A6D3kwBI;EACE,kBAAA;A7D6kwBN;A6DtlwBA;EAaI,aAAA;A7D4kwBJ;A6DzkwBA;EACE,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;A7D2kwBF;A6DtlwBA;EAaI,SAAA;EACA,aAAA;EACA,YAAA;A7D4kwBJ;A6D3lwBA;EAkBI,UAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;A7D4kwBJ;A6D3kwBI;EACE,gBAAA;A7D6kwBN;A6D3kwBI;EACE,gBAAA;A7D6kwBN;A6D9kwBI;EAGI,iBAAA;A7D8kwBR;A6D1mwBA;EAiCI,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;A7D4kwBJ;A6D3kwBI;EACE,aAAA;A7D6kwBN;A6D3kwBI;EACE,aAAA;A7D6kwBN;A6D3kwBI;EACE,aAAA;A7D6kwBN;A6D7nwBA;EAmDM,aAAA;A7D6kwBN;A6DhowBA;EAsDM,cAAA;EACA,WAAA;EACA,YAAA;A7D6kwBN;A6D3kwBI;EACE;IACE,aAAA;E7D6kwBN;E6D3kwBI;IACE,aAAA;E7D6kwBN;E6D3kwBI;IACE,aAAA;E7D6kwBN;AACF;A6DhpwBA;EAuEI,sBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;A7D4kwBJ;A6DzkwBA;EACE,cAAA;A7D2kwBF;A6D5kwBA;EAGI,iBAAA;A7D4kwBJ;A6D/kwBA;EAMI,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;A7D4kwBJ;A6DtlwBA;EAaI,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;A7D4kwBJ;A6D/lwBA;EAsBI,eAAA;A7D4kwBJ;A6DlmwBA;EAyBI,mBAAA;EACA,gBAAA;A7D4kwBJ;A6DzkwBA;EACE,eAAA;A7D2kwBF;A6D5kwBA;EAGI,eAAA;A7D4kwBJ;A6DxkwBA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;A7D0kwBF;A6DvkwBA;EACE,cAAA;EACA,eAAA;A7DykwBF;A6DtkwBA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;A7DwkwBF;A6DrkwBA;EACE,WAAA;EACA,0BAAA;EACA,eAAA;A7DukwBF;A6DpkwBA;EACE,UAAA;EACA,SAAA;EACA,qBAAA;A7DskwBF;A6DnkwBA;EACE,uBAAA;EACA,kBAAA;A7DqkwBF;A6DlkwBA;EACE,eAAA;EACA,WAAA;A7DokwBF;A6DjkwBA;EACE,gBAAA;A7DmkwBF;A6DhkwBA;EACE,iBAAA;A7DkkwBF;A6D/jwBA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;A7DikwBF;A6D9jwBA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;A7DgkwBF;A6D7jwBA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;A7D+jwBF;A6D7jwBI;EAAA;IACE,2BAAA;I7DgkwBF,iBAAiB;I6D/jwBf,yBAAA;I7DikwBF,WAAW;IAEX,YAAY;IAEZ,QAAQ;I6DlkwBL,iBAAA;I7DokwBH,gBAAgB;EAClB;AACF;A6DrlwBA;EAmBI,cAAA;EACA,0BAAA;A7DqkwBJ;A6DpkwBI;EACE,cAAA;A7DskwBN;A6D5lwBA;EA0BI,0BAAA;A7DqkwBJ;A6D/lwBA;EA6BI,6BAAA;A7DqkwBJ;A6DjkwBA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,qBAAA;EACA,oBAAA;A7DmkwBF;A6DhkwBA;EACE,iBAAA;A7DkkwBF;A6D/jwBA;EACE,kBAAA;A7DikwBF;A6D9jwBA;EACE,0BAAA;A7DgkwBF;A6D7jwBA;EACE,6BAAA;A7D+jwBF;A6D5jwBA;EACE,uCAAA;A7D8jwBF;A6D3jwBA;EACE,yBAAA;EACA,oBAAA;EACA,+CAAA;EACA,cAAA;A7D6jwBF;A6D1jwBA;EACE,cAAA;EACA,qBAAA;A7D4jwBF;A6DzjwBA;EACE,cAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;EACA,gCAAA;EACA,cAAA;EACA,iBAAA;A7D2jwBF;A6DxjwBA;EACE,yBAAA;EACA,+CAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;E7D0jwBA,sBAAsB;E6DxjwBtB,gBAAA;EACA,kBAAA;A7D0jwBF;A6DvjwBA;EACE,0BAAA;EACA,kBAAA;EACA,sBAAA;EACA,OAAA;EACA,MAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;A7DyjwBF;A6DvjwBA;EACE,sCAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;A7DyjwBF;A6DtjwBA;EACE,gBAAA;A7DwjwBF;A6DrjwBA;EACE,WAAA;A7DujwBF;A6DpjwBA;EACE,WAAA;A7DsjwBF;A6DnjwBA;EACE,WAAA;A7DqjwBF;A6DljwBA;EACE,cAAA;A7DojwBF;A6DjjwBA;EACE,WAAA;A7DmjwBF;A6DhjwBA;EACE,WAAA;A7DkjwBF;A6D/iwBA;EACE,cAAA;A7DijwBF;A6D9iwBA;EACE,SAAA;EACA,kBAAA;EACA,kBAAA;A7DgjwBF;A6D7iwBA;EACE,gBAAA;A7D+iwBF;A6D5iwBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;A7D8iwBF;A6D3iwBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;A7D6iwBF;A6D1iwBA;EACE,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,wBAAA;EACA,aAAA;EACA,aAAA;A7D4iwBF;A6DziwBA;EACE,UAAA;EACA,SAAA;EACA,iBAAA;A7D2iwBF;A6DxiwBA;EACE,UAAA;EACA,SAAA;EACA,iBAAA;A7D0iwBF;A6DviwBA;EACE,yBAAA;A7DyiwBF;A6DtiwBA;EACE,qBAAA;A7DwiwBF;A6DriwBA;EACE,uBAAA;EACA,WAAA;A7DuiwBF;A6DpiwBA;EACE,gBAAA;A7DsiwBF;A6DniwBA;EACE,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;A7DqiwBF;A6DliwBA;EACE,UAAA;EACA,SAAA;A7DoiwBF;A6DjiwBA;EACE,UAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;A7DmiwBF;A6DhiwBA;EACE,0BAAA;A7DkiwBF;A6D/hwBA;EACE,SAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;A7DiiwBF;A6D9hwBA;EACE,0BAAA;A7DgiwBF;A6D7hwBA;EACE,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,cAAA;A7D+hwBF;A6D5hwBA;EACE,iBAAA;A7D8hwBF;A6D3hwBA;EACE,kBAAA;EACA,0CAAA;A7D6hwBF;A6D1hwBA;EACE,kBAAA;EACA,0CAAA;A7D4hwBF;A6DxhwBA;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;A7D0hwBF;A6DvhwBA;EACE,6BAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;A7DyhwBF;A6DthwBA;EACE,mBAAA;A7DwhwBF;A6DrhwBA;EACE,iBAAA;A7DuhwBF;A6DphwBA;EACE,wBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;A7DshwBF;A6DnhwBA;EACE,YAAA;A7DqhwBF;A6DlhwBA;EACE,0CAAA;A7DohwBF;A6DjhwBA;EACE,UAAA;A7DmhwBF;A6DhhwBA;EACE,sBAAA;A7DkhwBF;A6D/gwBA;EACE,UAAA;EACA,sBAAA;EACA,aAAA;A7DihwBF;A6D9gwBA;EACE,6BAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;A7DghwBF;A6D7gwBA;EACE,0BAAA;EACA,YAAA;A7D+gwBF;A6D5gwBA;EACE,aAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;A7D8gwBF;A6D3gwBA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;UAAA,iBAAA;A7D6gwBF;A6D1gwBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;A7D4gwBF;A6DzgwBA;EACE,6BAAA;EACA,wBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;A7D2gwBF;A6DxgwBA;EACE,yBAAA;A7D0gwBF;A6DvgwBA;EACE,kBAAA;A7DygwBF;A6DtgwBA;EACE,wBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;A7DwgwBF;A6DrgwBA;EACE,UAAA;EACA,cAAA;EACA,kBAAA;EACA,sHAAA;EAEA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;A7DsgwBF;A6DngwBA;EACE,mBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,cAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;A7DqgwBF;A6DlgwBA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;A7DogwBF;A6DjgwBA;EACE,eAAA;A7DmgwBF;A6DhgwBA;EACE,kBAAA;A7DkgwBF;A6D//vBA;EACE,sBAAA;A7DigwBF;A6D9/vBA;EACE,aAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;A7DggwBF;A6D7/vBA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,wBAAA;A7D+/vBF;A6D5/vBA;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,sBAAA;EACA,2CAAA;EACA,kBAAA;EACA,wBAAA;A7D8/vBF;A6D3/vBA;EACE,aAAA;EACA,wBAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;A7D6/vBF;A6D1/vBA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,oBAAA;A7D4/vBF;A6Dz/vBA;EACE,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,eAAA;A7D2/vBF;A6Dx/vBA;EACE,cAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;A7D0/vBF;A6Dv/vBA;EACE,0BAAA;A7Dy/vBF;A6Dt/vBA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;A7Dw/vBF;A6Dr/vBA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;A7Du/vBF;A6Dp/vBA;;EAEE,wBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;A7Ds/vBF;A6Dn/vBA;EACE,qBAAA;A7Dq/vBF;A6Dp/vBE;;EACE,aAAA;A7Du/vBJ;A6D1/vBA;EAMI,cAAA;A7Du/vBJ;A6Dn/vBA;EACE,kBAAA;A7Dq/vBF;A6Dt/vBA;EAGI,kBAAA;EACA,QAAA;EACA,SAAA;A7Ds/vBJ;A6D3/vBA;EAQI,YAAA;A7Ds/vBJ;A6Dr/vBI;EACE,gBAAA;A7Du/vBN;A6Dn/vBA;EACE,oBAAA;EACA,sBAAA;A7Dq/vBF;A6Dp/vBE;EACE,WAAA;A7Ds/vBJ;A6Dp/vBE;EACE,YAAA;A7Ds/vBJ;A6Dp/vBE;EACE,WAAA;A7Ds/vBJ;A8Dvw3BA;EACE,cAAA;A9Dyw3BF;A8Dxw3BE;EACE,mBAAA;A9D0w3BJ;A8Dxw3BE;EACE,6BAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;A9D0w3BJ;A8D/w3BE;EhE6PA,WAAA;EACA,YAAA;EACA,kBAAA;AEqh3BF;A8Dpx3BE;EAUI,aAAA;EACA,mBAAA;EACA,gBAAA;A9D6w3BN;A8D1w3BE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;A9D4w3BJ;A8D1w3BE;EAGM,eAAA;A9D0w3BR;A8Dxw3BM;EAEI,eAAA;A9Dyw3BV;A8Dpw3BE;EAGM,eAAA;A9Dow3BR;A8Dlw3BM;EAEI,eAAA;A9Dmw3BV;A8D9v3BE;EACE,aAAA;A9Dgw3BJ;A8D9v3BE;EACE,kBAAA;EACA,cAAA;A9Dgw3BJ;A8Dlw3BE;EAII,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;A9Diw3BN;A8D9v3BE;EACE,gCAAA;A9Dgw3BJ;A8D9v3BE;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,8BAAA;A9Dgw3BJ;A8Dpw3BE;EAMI,aAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;A9Diw3BN;A8D3w3BE;EAYM,WAAA;EACA,YAAA;A9Dkw3BR;A8D/w3BE;EAgBM,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;A9Dkw3BR;A8Dz13BA;EA6FM,iBAAA;A9D+v3BN;A8D513BA;EAiGI,aAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;A9D8v3BJ;A8Dn23BA;EAuGM,WAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;A9D+v3BN;A8Dz23BA;EA8GI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;A9D8v3BJ;A8D7v3BI;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;A9D+v3BN;A8D7v3BI;EACE,iBAAA;A9D+v3BN;A8D5v3BE;EACE,yBAAA;A9D8v3BJ;A8D1v3BA;EACE,MAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EAKA,mBAAA;A9Dwv3BF;A8D5v3BE;EAAA;IACE,gBAAA;IACA,YAAA;E9D+v3BF;AACF;A8Dvw3BA;;EAWI,kBAAA;EACA,aAAA;A9Dgw3BJ;A8D5w3BA;EAeI,aAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;A9Dgw3BJ;A8Dlx3BA;EAoBM,iBAAA;A9Diw3BN;A8Drx3BA;EAuBM,cAAA;EACA,cAAA;A9Diw3BN;A8Dzx3BA;EA0BQ,cAAA;A9Dkw3BR;A8Djw3BQ;EACE,cAAA;A9Dmw3BV;A8D/x3BA;EAiCM,cAAA;EACA,uBAAA;A9Diw3BN;A8Dny3BA;EAqCM,yBAAA;A9Diw3BN;A8Dty3BA;EAyCQ,SAAA;EACA,YAAA;A9Dgw3BR;A8D1y3BA;EA6CQ,gBAAA;A9Dgw3BR;A8D7y3BA;EAiDM,eAAA;EACA,kBAAA;A9D+v3BN;A8Djz3BA;EAsDI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;A9D8v3BJ;A8Dzz3BA;EA6DM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;A9D+v3BN;A8D3v3BA;EACE,aAAA;EACA,eAAA;EACA,WAAA;A9D6v3BF;A8D1v3BA;EAEI,kBAAA;A9D2v3BJ;A8Dvv3BA;EACE,eAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;EACA,2BAAA;EACA,yBAAA;A9Dyv3BF;A8Dxv3BE;EAAA;IACE,gBAAA;IACA,kBAAA;IACA,MAAA;IACA,cAAA;IACA,eAAA;IACA,aAAA;E9D2v3BF;AACF;A8D1v3BE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;A9D4v3BJ;A8D1v3BE;;EACE,aAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;A9D6v3BJ;A8D7x3BA;EAmCI,SAAA;A9D6v3BJ;A8D3v3BE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;A9D6v3BJ;A8D3v3BE;EAEI,mBAAA;A9D4v3BN;A8Dzv3BE;EACE,cAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;A9D2v3BJ;A8Dnw3BE;EAUI,iBAAA;A9D4v3BN;A8Dzv3BE;EACE,cAAA;A9D2v3BJ;A8Dzv3BE;EACE,cAAA;EACA,aAAA;EACA,iBAAA;A9D2v3BJ;A8Dzv3BE;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;A9D2v3BJ;A8Dzv3BE;EACE,cAAA;EACA,aAAA;EACA,YAAA;A9D2v3BJ;A8D9v3BE;EAKI,iBAAA;A9D4v3BN;A8Dzv3BE;EACE,cAAA;EACA,aAAA;EACA,YAAA;A9D2v3BJ;A8D9v3BE;EAKI,WAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;A9D4v3BN;A8Dzv3BE;EACE,aAAA;EACA,eAAA;EACA,cAAA;A9D2v3BJ;A8Dzv3BE;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;A9D2v3BJ;A8Dvv3BA;;EAEI,yBAAA;EACA,yBAAA;A9Dyv3BJ;A8Dxv3BI;;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;A9D2v3BN;A8Dzv3BI;;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;A9D4v3BN;A8D1v3BI;;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;A9D6v3BN;A8D3v3BI;;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;A9D8v3BN;A8Dzv3BA;EACE,cAAA;A9D2v3BF;A8D1v3BE;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;A9D4v3BJ;A8Dxv3BA;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;A9D0v3BF;A8Dlw3BA;EAUI,YAAA;EACA,WAAA;A9D2v3BJ;A8Dtw3BA;EAaM,eAAA;EACA,iBAAA;A9D4v3BN;A8D1w3BA;EAkBI,wBAAA;A9D2v3BJ;A+D5n4BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A/D8n4BF;A+D7n4BE;EACE,mBAAA;A/D+n4BJ;A+D7n4BE;EACE,mBAAA;A/D+n4BJ;A+D7n4BE;EACE,6BAAA;A/D+n4BJ;A+D7n4BE;EACE,aAAA;EACA,mBAAA;EACA,UAAA;A/D+n4BJ;A+D7n4BM;EACE,mBAAA;EACA,cAAA;A/D+n4BR;A+D7n4BM;EACE,mBAAA;EACA,cAAA;A/D+n4BR;A+D7n4BM;EACE,mBAAA;EACA,cAAA;A/D+n4BR;A+D7n4BM;EACE,mBAAA;EACA,cAAA;A/D+n4BR;A+D7n4BM;EACE,mBAAA;EACA,cAAA;A/D+n4BR;A+D7n4BM;EACE,mBAAA;EACA,cAAA;A/D+n4BR;A+D7n4BM;EACE,mBAAA;EACA,cAAA;A/D+n4BR;A+D7n4BM;EACE,mBAAA;EACA,cAAA;A/D+n4BR;A+D3n4BE;EACE,iBAAA;EACA,eAAA;A/D6n4BJ;A+D3n4BE;EAGM,eAAA;A/D2n4BR;A+Dzn4BM;EAEI,eAAA;A/D0n4BV;A+Drn4BE;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;A/Dun4BJ;A+Drn4BE;EACE,aAAA;EACA,YAAA;A/Dun4BJ;A+Dzn4BE;EAII,aAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;A/Dwn4BN;A+Dho4BE;EAUM,WAAA;EACA,YAAA;A/Dyn4BR;A+Dpo4BE;EAcM,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;A/Dyn4BR;A+Dtt4BA;EAkGI,aAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;A/Dun4BJ;A+D7t4BA;EAwGM,WAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;A/Dwn4BN;A+Dnu4BA;EA+GI,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;A/Dun4BJ;A+Dtn4BI;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;A/Dwn4BN;A+Dnn4BA;EACE,aAAA;EACA,eAAA;EACA,WAAA;A/Dqn4BF;A+Djn4BE;;;;EACE,UAAA;EACA,0CAAA;A/Dsn4BJ;A+Drn4BI;EAAA;;;;IACE,wCAAA;IACA,gCAAA;IACA,uBAAA;E/D2n4BJ;AACF;A+Dlo4BE;;;;EASI,kBAAA;A/D+n4BN;A+D1n4BA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;A/D4n4BF;A+Dzn4BA;EACE,eAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kDAAA;EACA,0BAAA;EACA,yBAAA;EAWA,cAAA;A/Din4BF;A+D3n4BE;EAAA;IACE,gBAAA;IACA,kBAAA;IACA,MAAA;IACA,cAAA;IACA,eAAA;IACA,aAAA;IACA,gDAAA;IACA,gCAAA;E/D8n4BF;AACF;A+Dpp4BA;EAyBI,uBAAA;A/D8n4BJ;A+Dvp4BA;EA4BQ,cAAA;A/D8n4BR;A+D1p4BA;EAgCM,kBAAA;A/D6n4BN;A+D7p4BA;EAoCI,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,SAAA;A/D4n4BJ;A+Drq4BA;EA2CM,gBAAA;A/D6n4BN;A+D1n4BE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;A/D4n4BJ;A+D1n4BE;;EACE,aAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;A/D6n4BJ;A+Dpr4BA;EA0DI,SAAA;A/D6n4BJ;A+D3n4BE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;A/D6n4BJ;A+D3n4BE;EAEI,mBAAA;A/D4n4BN;A+Dzn4BE;EACE,cAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;A/D2n4BJ;A+Dzn4BE;EACE,cAAA;A/D2n4BJ;A+Dzn4BE;EACE,cAAA;EACA,aAAA;EACA,iBAAA;A/D2n4BJ;A+Dzn4BE;EACE,iBAAA;EACA,eAAA;A/D2n4BJ;A+Dzn4BE;EACE,cAAA;EACA,aAAA;EACA,YAAA;A/D2n4BJ;A+D9n4BE;EAKI,iBAAA;A/D4n4BN;A+Dzn4BE;EACE,cAAA;EACA,aAAA;EACA,YAAA;A/D2n4BJ;A+D9n4BE;EAKI,WAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;A/D4n4BN;A+Dzn4BE;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;A/D2n4BJ;A+Dxn4BA;EACE,cAAA;A/D0n4BF;A+Dzn4BE;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;A/D2n4BJ;A+Dvn4BA;EACE,MAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;EACA,aAAA;EAKA,mBAAA;A/Dqn4BF;A+Dzn4BE;EAAA;IACE,gBAAA;IACA,YAAA;E/D4n4BF;AACF;A+Dro4BA;;EAYI,kBAAA;EACA,aAAA;A/D6n4BJ;A+D1o4BA;EAgBI,aAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;A/D6n4BJ;A+Dhp4BA;EAqBM,iBAAA;A/D8n4BN;A+Dnp4BA;EAwBM,cAAA;EACA,cAAA;A/D8n4BN;A+Dvp4BA;EA2BQ,cAAA;A/D+n4BR;A+D9n4BQ;EACE,cAAA;A/Dgo4BV;A+D7p4BA;EAkCM,cAAA;EACA,uBAAA;A/D8n4BN;A+Djq4BA;EAsCM,yBAAA;A/D8n4BN;A+Dpq4BA;EA0CQ,SAAA;EACA,YAAA;A/D6n4BR;A+Dxq4BA;EA8CQ,gBAAA;A/D6n4BR;A+D3q4BA;EAkDM,eAAA;EACA,kBAAA;A/D4n4BN;A+D/q4BA;EAuDI,mBAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;A/D2n4BJ;A+Drr4BA;EA6DI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;A/D2n4BJ;A+D7r4BA;EAoEM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;A/D4n4BN;A+Dvn4BA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;A/Dyn4BF;A+Dxn4BE;EACE,UAAA;A/D0n4BJ;A+Djo4BA;EAUI,kBAAA;EACA,mBAAA;A/D0n4BJ;A+Dxn4BE;EACE,iBAAA;EACA,UAAA;A/D0n4BJ;A+D5n4BE;EAII,mBAAA;EACA,cAAA;A/D2n4BN;A+Dho4BE;EAQI,iBAAA;EACA,cAAA;A/D2n4BN;A+Djp4BA;EA0BI,eAAA;EACA,kBAAA;EACA,mBAAA;A/D0n4BJ;A+Dtp4BA;EA+BI,cAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;A/D0n4BJ;A+D5p4BA;EAqCI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;A/D0n4BJ;A+Dnq4BA;EA4CI,aAAA;EACA,mBAAA;EAQA,mBAAA;EjEzJF,WAAA;EACA,YAAA;EACA,kBAAA;AE6w4BF;A+D3q4BA;EA+CM,UAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,uBAAA;A/D+n4BN;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;EACA,gBAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;EACA,gBAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;EACA,gBAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;EACA,gBAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;EACA,gBAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;EACA,gBAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;EACA,gBAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;EACA,gBAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;EACA,gBAAA;A/D4n4BR;A+Dzn4BI;EACE,mBAAA;A/D2n4BN;A+D5n4BI;EAGI,cAAA;A/D4n4BR;A+Dvy4BA;EAgLI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;A/D0n4BJ;A+Dtn4BA;EACE,aAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;A/Dwn4BF;A+D5n4BA;EAMI,cAAA;A/Dyn4BJ;A+Dxn4BI;EAAA;IACE,cAAA;E/D2n4BJ;AACF;A+Dvn4BA;EACE,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;A/Dyn4BF;A+Dtn4BA;EACE,gBAAA;A/Dwn4BF;A+Drn4BA;EAEI,eAAA;A/Dsn4BJ;A+Dxn4BA;EAKI,aAAA;EACA,sBAAA;EACA,cAAA;A/Dsn4BJ;A+Dnn4BA;EACE,aAAA;EjEnUA,WAAA;EACA,YAAA;EACA,kBAAA;EiEoUA,mBAAA;EACA,uBAAA;A/Dsn4BF;A+Drn4BE;EACE,mBAAA;A/Dun4BJ;A+Dxn4BE;EAGI,eAAA;A/Dwn4BN;A+Drn4BE;EACE,mBAAA;A/Dun4BJ;A+Dxn4BE;EAGI,eAAA;A/Dwn4BN;A+Drn4BE;EACE,mBAAA;A/Dun4BJ;A+Dxn4BE;EAGI,eAAA;A/Dwn4BN;A+Drn4BE;EACE,mBAAA;A/Dun4BJ;A+Dxn4BE;EAGI,eAAA;A/Dwn4BN;A+Drn4BE;EACE,mBAAA;A/Dun4BJ;A+Dxn4BE;EAGI,eAAA;A/Dwn4BN;A+Dzp4BA;EAqCI,WAAA;EACA,YAAA;EACA,iBAAA;A/Dun4BJ;A+Dpn4BA;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;A/Dsn4BF;A+Dpn4BA;EACE,cAAA;A/Dsn4BF;A+Dvn4BA;EAGI,cAAA;A/Dun4BJ;A+D1n4BA;EAMI,cAAA;EACA,kBAAA;A/Dun4BJ;A+Dnn4BA;EACE,eAAA;A/Dqn4BF;A+Dln4BA;EACE,aAAA;EACA,cAAA;A/Don4BF;A+Djn4BA;EAEI,mBAAA;A/Dkn4BJ;A+D9m4BA;EACE,gBAAA;A/Dgn4BF;A+Djn4BA;EAGI,mBAAA;EACA,yBAAA;A/Din4BJ;A+D7m4BA;EAEI,cAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;A/D8m4BJ;A+D7m4BI;EACE,aAAA;A/D+m4BN;A+D1m4BA;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;A/D4m4BF;A+Djn4BA;EAOI,UAAA;A/D6m4BJ;A+D5m4BI;EACE,UAAA;A/D8m4BN;A+D5m4BI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,+DAAA;A/D8m4BN;A+Dho4BA;EAuBI,kBAAA;EACA,aAAA;EACA,aAAA;EACA,UAAA;A/D4m4BJ;A+Dto4BA;EA4BM,SAAA;EACA,gBAAA;A/D6m4BN;A+D3m4BI;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EjEpcJ,UAAA;EACA,WAAA;EACA,kBAAA;AEkj5BF;A+D9m4BM;EACE,mBAAA;EACA,cAAA;A/Dgn4BR;A+D9m4BM;EACE,mBAAA;EACA,cAAA;A/Dgn4BR;A+D9m4BM;EACE,mBAAA;EACA,cAAA;A/Dgn4BR;A+D9m4BM;EACE,mBAAA;EACA,cAAA;A/Dgn4BR;A+D9m4BM;EACE,mBAAA;EACA,cAAA;A/Dgn4BR;A+D9m4BM;EACE,mBAAA;EACA,cAAA;A/Dgn4BR;A+D9m4BM;EACE,mBAAA;EACA,cAAA;A/Dgn4BR;A+D9m4BM;EACE,mBAAA;EACA,cAAA;A/Dgn4BR;AgEp15BA;EACE,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,aAAA;AhEs15BF;AgEr15BE;EACE,mBAAA;AhEu15BJ;AgEr15BE;EACE,kBAAA;EACA,qBAAA;AhEu15BJ;AgEr15BE;EACE,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gCAAA;EACA,mBAAA;AhEu15BJ;AgEr15BE;EACE,gBAAA;EACA,YAAA;AhEu15BJ;AgEp15BI;EACE,kDAAA;AhEs15BN;AgEr15BM;EACE,WAAA;EACA,yDAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;AhEu15BR;AgEr15BM;EACE,WAAA;EACA,yDAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;AhEu15BR;AgEp15BI;EACE,kDAAA;AhEs15BN;AgEr15BM;EACE,WAAA;EACA,yDAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,2BAAA;AhEu15BR;AgEr15BM;EACE,WAAA;EACA,yDAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,2BAAA;AhEu15BR;AgEp15BI;EACE,kDAAA;AhEs15BN;AgEr15BM;EACE,WAAA;EACA,yDAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;AhEu15BR;AgEr15BM;EACE,WAAA;EACA,yDAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;AhEu15BR;AgEj15BA;EACE,aAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;AhEm15BF;AgEv15BA;EAMI,YAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EAIA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBAAA;EACA,2BAAA;AhEi15BJ;AgEz15BI;EAAA;IACE,eAAA;EhE415BJ;AACF;AgEx25BA;EAoBM,WAAA;EACA,iBAAA;AhEu15BN;AgE525BA;EAyBI,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;AhEs15BJ;AgEl35BA;EA+BI,cAAA;EACA,yBAAA;EACA,cAAA;AhEs15BJ;AgEv35BA;EAoCI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AhEs15BJ;AgE735BA;EA0CI,cAAA;EACA,eAAA;EACA,cAAA;AhEs15BJ;AgEl45BA;EA+CI,cAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AhEs15BJ;AgEz45BA;EAsDI,aAAA;EACA,gCAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AhEs15BJ;AgEh55BA;EA4DM,aAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,aAAA;AhEu15BN;AgEx55BA;EAmEQ,aAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AhEw15BR;AgEn65BA;EA8EQ,aAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AhEw15BR;AiEjh6BA;EACE,eAAA;AjEmh6BF;AiEph6BA;EAGI,UAAA;EACA,SAAA;EACA,gBAAA;AjEoh6BJ;AiEhh6BE;EACE,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,mBAAA;AjEkh6BJ;AiE/g6BE;EACE,qBAAA;EACA,oBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AjEih6BJ;AiEth6BE;EAQI,uBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,iDAAA;AjEgh6BN;AiE3g6BI;EACE,UAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;AjE6g6BN;AiEjh6BI;EAOI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;AjE6g6BR;AiE3g6BQ;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AjE6g6BV;AiEpi6BI;EjEsi6BF,8DAA8D;EiE1g6BtD,UAAA;EACA,SAAA;AjE4g6BV;AiEvg6BI;EACE,YAAA;AjEyg6BN;AiE7i6BE;EAwCI,gBAAA;EACA,6BAAA;AjEwg6BN;AiEng6BA;EACE,uBAAA;EAEA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,sBAAA;AjEog6BF;AiEhh6BA;EAcI,UAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gCAAA;AjEqg6BJ;AiEng6BE;EAEI,eAAA;EACA,UAAA;EACA,mBAAA;AjEog6BN;AiE//5BA;EACE,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AjEig6BF;AiE9/5BA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AjEgg6BF;AiE7/5BA;EACE,oBAAA;AjE+/5BF;AiE5/5BA;;;;EAII,iBAAA;EACA,yBAAA;AjE8/5BJ;AiE1/5BA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AjE4/5BF;AiE3/5BE;EACE,yBAAA;AjE6/5BJ;AiEz/5BA;EACE,iBAAA;EACA,aAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;AjE2/5BF;AkExp6BA;EACE,YAAA;EACA,WAAA;EACA,WAAA;AlE0p6BF;AkExp6BA;EACE,aAAA;EACA,QAAA;AlE0p6BF;AkEvp6BA;EACE,YAAA;EACA,0BAAA;EACA,YAAA;AlEyp6BF;AkExp6BE;EAAA;IACE,YAAA;IACA,aAAA;ElE2p6BF;AACF;AkEzp6BA;EACE,eAAA;EACA,UAAA;EACA,4BAAA;EACA,SAAA;EACA,uBAAA;EACA,gDAAA;EACA,aAAA;EACA,kBAAA;AlE2p6BF;AkE1p6BE;EAAA;IACE,WAAA;IACA,eAAA;ElE6p6BF;AACF;AkEzq6BA;EAcI,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,6BAAA;AlE8p6BJ;AkE/q6BA;EAmBM,eAAA;AlE+p6BN","sourcesContent":["// main: ../framework.less\n/* Global styles */\n@charset \"UTF-8\";\n@import (css) url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;1,400;1,500;1,600&display=swap');\n\nhtml {\n  position: relative;\n  min-height: 100vh;\n  font-size: 12px;\n  line-height: 26px;\n}\nbody {\n  font-size: 12px;\n  min-height: 100%;\n  color: @text;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  margin: 0;\n  padding: 0;\n  font-family: @font-family;\n}\n\nul {\n  padding: 15px 0 0 15px;\n}\nli {\n  line-height: 1.5em;\n  margin-top: 5px;\n}\na, a:link {\n  text-decoration: none;\n  color: @text;\n}\na:active, a:focus, a:hover {\n  color: #000;\n}\na:focus, a:active,\nbutton::-moz-focus-inner,\nbutton:focus,\ninput[type=\"reset\"]::-moz-focus-inner,\ninput[type=\"button\"]::-moz-focus-inner,\ninput[type=\"submit\"]::-moz-focus-inner,\nselect::-moz-focus-inner,\ninput[type=\"file\"] > input[type=\"button\"]::-moz-focus-inner {\n  border: 0;\n  outline : 0;\n}\nform {\n  display: inline;\n}\ninput[type=\"submit\"], button {\n  box-sizing: border-box;\n}\n/* Reset IOS input box styling */\ninput {\n  -webkit-appearance: none;\n  border-radius: 0;\n}\ninput[type=\"checkbox\"]{\n  -webkit-appearance: checkbox;\n}\ninput[type=\"radio\"]{\n  -webkit-appearance: radio;\n}\n/* Reset webkit yellow background on autofill */\ninput:-webkit-autofill::first-line,\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:autofill,\ninput:autofill:hover,\ninput:autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\ntextarea:autofill,\ntextarea:autofill:hover,\ntextarea:autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus,\nselect:autofill,\nselect:autofill:hover,\nselect:autofill:focus {\n    -webkit-background-clip: text !important;\n    appearance: none;\n    box-shadow: 0 0 0px 1000px #fff inset !important;\n    -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;\n    -webkit-text-fill-color: #676a6c !important;\n    color: #222;\n    background-color: #fff !important;\n    background-image: none !important;\n    filter: none !important;\n    font-size: 14px !important;\n    font-family: @font-family !important;\n}\n\ninput:-internal-autofill-selected {\n  -webkit-background-clip: text !important;\n  appearance: none;\n  box-shadow: 0 0 0px 1000px #fff inset !important;\n  -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;\n  -webkit-text-fill-color: #676a6c !important;\n  color: #222;\n  background-color: #fff !important;\n  background-image: none !important;\n  filter: none !important;\n  font-size: 14px !important;\n  font-family: @font-family !important;\n}\n\ninput:-internal-autofill-previewed {\n  -webkit-background-clip: text !important;\n  appearance: none;\n  box-shadow: 0 0 0px 1000px #fff inset !important;\n  -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;\n  -webkit-text-fill-color: #676a6c !important;\n  color: #222;\n  background-color: #fff !important;\n  background-image: none !important;\n  filter: none !important;\n  font-size: 14px !important;\n  font-family: @font-family !important;\n}\n\ninput:-internal-autofill-selected {\n  font-family: 'Poppins', sans-serif;\n  -webkit-background-clip: text !important;\n  appearance: none;\n  box-shadow: 0 0 0px 1000px #fff inset !important;\n  -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;\n  -webkit-text-fill-color: #676a6c !important;\n  color: #222 !important;\n  background-color: #fff !important;\n  background-image: none !important;\n  filter: none !important;\n  font-size: 14px !important;\n}\n\ninput[type='number'] {\n    -moz-appearance:textfield;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n}\n\n/* Remove Webkit glow */\ntextarea, input { outline: 0 !important; }\n/* Remove webkit focus glow */\n:focus {\n  outline-color: transparent;\n  outline-style: none;\n  outline: 0;\n}\ntextarea {\n  width: 100%;\n  min-height: 250px;\n  border: 1px solid #edf3f7;\n  padding: 5px;\n  color: #444;\n}\ninput[type=\"text\"].error, input[type=\"password\"].error {\n  border-bottom: 1px solid @brand-primary;\n}\nselect {\n  margin: 0 0 10px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border-radius: 0;\n  box-sizing: border-box;\n  display: inline-block;\n  width: auto;\n  background: none;\n}\n/* Explicitly specify font-weight for all headings */\nh1,h2,h3,h4,h5,h6 {\n  font-weight: 600;\n  color: @primary_colour;\n}\nh1 {\n  font-size: 20px;\n  line-height: 1.2em;\n  font-weight: 300;\n}\nh2 {\n  font-size: 18px;\n  margin: 0;\n  font-weight: 600;\n}\nh3 {\n  font-size: 16px;\n  line-height: 30px;\n  margin: 10px 0;\n  font-weight: 600;\n}\nh4 {\n  font-size: 14px;\n  font-weight: 600;\n}\nh5 {\n  font-size: 12px;\n  line-height: 1em;\n  font-weight: 700;\n}\nh6 {\n  font-size: 10px;\n  line-height: 1em;\n}\ninput:focus::-webkit-input-placeholder { color:transparent; }\ninput:focus:-moz-placeholder { color:transparent; } /* FF 4-18 */\ninput:focus::-moz-placeholder { color:transparent; } /* FF 19+ */\ninput:focus:-ms-input-placeholder { color:transparent; } /* IE 10+ */\n::-webkit-input-placeholder {\n  color: #efefef;\n}\n:-moz-placeholder {\n  color: #efefef;\n}\n::-moz-placeholder {\n  color: #efefef;\n}\n:-ms-input-placeholder {\n  color: #efefef;\n}\nstrong {\n  color: #333;\n  font-weight: 700;\n}\n\n.heavy {\n  font-weight: 700;\n}\n\n.capitalize {\n  text-transform: capitalize;\n}\n\nsvg {\n  fill: #222;\n}\n\n// .btn svg {\n//   height: 18px;\n//   vertical-align: middle;\n//   transition: all 0.3s ease 0s;\n// }\n\n.hidden-sm {\n  display: none;\n  @media screen and (min-width: @screen-sm) {\n    display: block;\n  }\n}\n\n// Circle Mixin\n.circle(@width) {\n  width: @width;\n  height: @width;\n  border-radius: 50%;\n}","// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Setting @viewport causes scrollbars to overlap content in IE11 and Edge, so\n//    we force a non-overlapping, non-auto-hiding scrollbar to counteract.\n// 6. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n\tbox-sizing: border-box; // 1\n}\n\nhtml {\n\tfont-family: sans-serif; // 2\n\tline-height: 1.15; // 3\n\t-webkit-text-size-adjust: 100%; // 4\n\t-ms-text-size-adjust: 100%; // 4\n\t-ms-overflow-style: scrollbar; // 5\n\t// LESS PORT: Sass version uses `rgba($black, 0)` here but it ends up compiling to `transparent`.\n\t-webkit-tap-highlight-color: transparent; // 6\n}\n\n// IE10+ doesn't honor `<meta name=\"viewport\">` in some cases.\n// LESS PORT: Less has no `@at-root` equivalent, so omitting that here.\n@-ms-viewport {\n\twidth: device-width;\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n\tdisplay: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use the\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n\tmargin: 0; // 1\n\tfont-family: @font-family-base;\n\tfont-size: @font-size-base;\n\tfont-weight: @font-weight-base;\n\tline-height: @line-height-base;\n\tcolor: @body-color;\n\ttext-align: left; // 3\n\tbackground-color: @body-bg; // 2\n}\n\n// Suppress the focus outline on elements that cannot be accessed via keyboard.\n// This prevents an unwanted focus outline from appearing around elements that\n// might still respond to pointer events.\n//\n// Credit: https://github.com/suitcss/base\n[tabindex=\"-1\"]:focus {\n\toutline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n\tbox-sizing: content-box; // 1\n\theight: 0; // 1\n\toverflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\nh1, h2, h3, h4, h5, h6 {\n\tmargin-top: 0;\n\tmargin-bottom: @headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n\tmargin-top: 0;\n\tmargin-bottom: @paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Remove the bottom border in Firefox 39-.\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Duplicate behavior to the data-* attribute for our tooltip plugin\n\nabbr[title],\nabbr[data-original-title] { // 4\n\ttext-decoration: underline; // 2\n\ttext-decoration: underline dotted; // 2\n\tcursor: help; // 3\n\tborder-bottom: 0; // 1\n}\n\naddress {\n\tmargin-bottom: 1rem;\n\tfont-style: normal;\n\tline-height: inherit;\n}\n\nol,\nul,\ndl {\n\tmargin-top: 0;\n\tmargin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n\tmargin-bottom: 0;\n}\n\ndt {\n\tfont-weight: @dt-font-weight;\n}\n\ndd {\n\tmargin-bottom: 0.5rem;\n\tmargin-left: 0; // Undo browser default\n}\n\nblockquote {\n\tmargin: 0 0 1rem;\n}\n\ndfn {\n\tfont-style: italic; // Add the correct font style in Android 4.3-\n}\n\nb,\nstrong {\n\tfont-weight: bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n\tfont-size: 80%; // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n\tposition: relative;\n\tfont-size: 75%;\n\tline-height: 0;\n\tvertical-align: baseline;\n}\n\nsub { bottom: -0.25em; }\nsup { top: -0.5em; }\n\n\n//\n// Links\n//\n\na {\n\tcolor: @link-color;\n\ttext-decoration: @link-decoration;\n\tbackground-color: transparent; // Remove the gray background on active links in IE 10.\n\t-webkit-text-decoration-skip: objects; // Remove gaps in links underline in iOS 8+ and Safari 8+.\n\n\t#hover({\n\t\tcolor: @link-hover-color;\n\t\ttext-decoration: @link-hover-decoration;\n\t});\n}\n\n// And undo these styles for placeholder links/named anchors (without href)\n// which have not been made explicitly keyboard-focusable (without tabindex).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([tabindex]) {\n\tcolor: inherit;\n\ttext-decoration: none;\n\n\t#hover-focus({\n\t\tcolor: inherit;\n\t\ttext-decoration: none;\n\t});\n\n\t&:focus {\n\t\toutline: 0;\n\t}\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n\tfont-family: @font-family-monospace; // Correct the inheritance and scaling of font size in all browsers.\n\tfont-size: 1em; // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n\t// Remove browser default top margin\n\tmargin-top: 0;\n\t// Reset browser default of `1em` to use `rem`s\n\tmargin-bottom: 1rem;\n\t// Don't allow content to break outside\n\toverflow: auto;\n\t// We have @viewport set which causes scrollbars to overlap content in IE11 and Edge, so\n\t// we force a non-overlapping, non-auto-hiding scrollbar to counteract.\n\t-ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n\t// Apply a consistent margin strategy (matches our type styles).\n\tmargin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n\tvertical-align: middle;\n\tborder-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg:not(:root) {\n\toverflow: hidden; // Hide the overflow in IE\n}\n\n\n//\n// Tables\n//\n\ntable {\n\tborder-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n\tpadding-top: @table-cell-padding;\n\tpadding-bottom: @table-cell-padding;\n\tcolor: @table-caption-color;\n\ttext-align: left;\n\tcaption-side: bottom;\n}\n\nth {\n\t// Matches default `<td>` alignment by inheriting from the `<body>`, or the\n\t// closest parent with a set `text-align`.\n\ttext-align: inherit;\n}\n\n\n//\n// Forms\n//\n\nlabel {\n\t// Allow labels to use `margin` for spacing.\n\tdisplay: inline-block;\n\tmargin-bottom: @label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n\tborder-radius: 0;\n}\n\n// Work around a Firefox/IE bug where the transparent `button` background\n// results in a loss of the default `button` focus styles.\n//\n// Credit: https://github.com/suitcss/base/\nbutton:focus {\n\toutline: 1px dotted;\n\toutline: 5px auto -webkit-focus-ring-color;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n\tmargin: 0; // Remove the margin in Firefox and Safari\n\tfont-family: inherit;\n\tfont-size: inherit;\n\tline-height: inherit;\n}\n\nbutton,\ninput {\n\toverflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n\ttext-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\nhtml [type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n\t-webkit-appearance: button; // 2\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n\tpadding: 0;\n\tborder-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n\tbox-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n\tpadding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n\t// Remove the default appearance of temporal inputs to avoid a Mobile Safari\n\t// bug where setting a custom line-height prevents text from being vertically\n\t// centered within the input.\n\t// See https://bugs.webkit.org/show_bug.cgi?id=139848\n\t// and https://github.com/twbs/bootstrap/issues/11266\n\t-webkit-appearance: listbox;\n}\n\ntextarea {\n\toverflow: auto; // Remove the default vertical scrollbar in IE.\n\t// Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\tresize: vertical;\n}\n\nfieldset {\n\t// Browsers set a default `min-width: min-content;` on fieldsets,\n\t// unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n\t// So we reset that to ensure fieldsets behave more like a standard block element.\n\t// See https://github.com/twbs/bootstrap/issues/12359\n\t// and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n\tmin-width: 0;\n\t// Reset the default outline behavior of fieldsets so they don't affect page layout.\n\tpadding: 0;\n\tmargin: 0;\n\tborder: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n\tdisplay: block;\n\twidth: 100%;\n\tmax-width: 100%; // 1\n\tpadding: 0;\n\tmargin-bottom: 0.5rem;\n\tfont-size: 1.5rem;\n\tline-height: inherit;\n\tcolor: inherit; // 2\n\twhite-space: normal; // 1\n}\n\nprogress {\n\tvertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n\theight: auto;\n}\n\n[type=\"search\"] {\n\t// This overrides the extra rounded corners on search inputs in iOS so that our\n\t// `.form-control` class can properly style them. Note that this cannot simply\n\t// be added to `.form-control` as it's not specific enough. For details, see\n\t// https://github.com/twbs/bootstrap/issues/11586.\n\toutline-offset: -2px; // 2. Correct the outline style in Safari.\n\t-webkit-appearance: none;\n}\n\n//\n// Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n\t-webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n\tfont: inherit; // 2\n\t-webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n\tdisplay: inline-block;\n}\n\nsummary {\n\tdisplay: list-item; // Add the correct display in all browsers\n\tcursor: pointer;\n}\n\ntemplate {\n\tdisplay: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n\tdisplay: none !important;\n}\n","@charset \"UTF-8\";\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,500;0,600;1,400;1,500;1,600&display=swap');\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -ms-overflow-style: scrollbar;\n  -webkit-tap-highlight-color: transparent;\n}\n@-ms-viewport {\n  width: device-width;\n}\narticle,\naside,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmain,\nnav,\nsection {\n  display: block;\n}\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #212529;\n  text-align: left;\n  background-color: #ffffff;\n}\n[tabindex=\"-1\"]:focus {\n  outline: 0 !important;\n}\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0;\n}\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\ndt {\n  font-weight: 700;\n}\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\nblockquote {\n  margin: 0 0 1rem;\n}\ndfn {\n  font-style: italic;\n}\nb,\nstrong {\n  font-weight: bolder;\n}\nsmall {\n  font-size: 80%;\n}\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\na {\n  color: #007bff;\n  text-decoration: none;\n  background-color: transparent;\n  -webkit-text-decoration-skip: objects;\n}\na:hover {\n  color: #0056b3;\n  text-decoration: underline;\n}\na:not([href]):not([tabindex]) {\n  color: inherit;\n  text-decoration: none;\n}\na:not([href]):not([tabindex]):hover,\na:not([href]):not([tabindex]):focus {\n  color: inherit;\n  text-decoration: none;\n}\na:not([href]):not([tabindex]):focus {\n  outline: 0;\n}\npre,\ncode,\nkbd,\nsamp {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 1em;\n}\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  -ms-overflow-style: scrollbar;\n}\nfigure {\n  margin: 0 0 1rem;\n}\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\nsvg:not(:root) {\n  overflow: hidden;\n}\ntable {\n  border-collapse: collapse;\n}\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #6c757d;\n  text-align: left;\n  caption-side: bottom;\n}\nth {\n  text-align: inherit;\n}\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\nbutton {\n  border-radius: 0;\n}\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\nbutton,\ninput {\n  overflow: visible;\n}\nbutton,\nselect {\n  text-transform: none;\n}\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  -webkit-appearance: listbox;\n}\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal;\n}\nprogress {\n  vertical-align: baseline;\n}\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n[type=\"search\"] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\noutput {\n  display: inline-block;\n}\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\ntemplate {\n  display: none;\n}\n[hidden] {\n  display: none !important;\n}\n.align-baseline {\n  vertical-align: baseline !important;\n}\n.align-top {\n  vertical-align: top !important;\n}\n.align-middle {\n  vertical-align: middle !important;\n}\n.align-bottom {\n  vertical-align: bottom !important;\n}\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n.align-text-top {\n  vertical-align: text-top !important;\n}\n.bg-primary {\n  background-color: #007bff !important;\n}\na.bg-primary:hover,\nbutton.bg-primary:hover,\na.bg-primary:focus,\nbutton.bg-primary:focus {\n  background-color: #0062cc !important;\n}\n.bg-secondary {\n  background-color: #6c757d !important;\n}\na.bg-secondary:hover,\nbutton.bg-secondary:hover,\na.bg-secondary:focus,\nbutton.bg-secondary:focus {\n  background-color: #545b62 !important;\n}\n.bg-success {\n  background-color: #73C677 !important;\n}\na.bg-success:hover,\nbutton.bg-success:hover,\na.bg-success:focus,\nbutton.bg-success:focus {\n  background-color: #4fb754 !important;\n}\n.bg-info {\n  background-color: #60D3EC !important;\n}\na.bg-info:hover,\nbutton.bg-info:hover,\na.bg-info:focus,\nbutton.bg-info:focus {\n  background-color: #32c6e7 !important;\n}\n.bg-warning {\n  background-color: #FFA564 !important;\n}\na.bg-warning:hover,\nbutton.bg-warning:hover,\na.bg-warning:focus,\nbutton.bg-warning:focus {\n  background-color: #ff8731 !important;\n}\n.bg-danger {\n  background-color: #dc3545 !important;\n}\na.bg-danger:hover,\nbutton.bg-danger:hover,\na.bg-danger:focus,\nbutton.bg-danger:focus {\n  background-color: #bd2130 !important;\n}\n.bg-light {\n  background-color: #f8f9fa !important;\n}\na.bg-light:hover,\nbutton.bg-light:hover,\na.bg-light:focus,\nbutton.bg-light:focus {\n  background-color: #dae0e5 !important;\n}\n.bg-dark {\n  background-color: #343a40 !important;\n}\na.bg-dark:hover,\nbutton.bg-dark:hover,\na.bg-dark:focus,\nbutton.bg-dark:focus {\n  background-color: #1d2124 !important;\n}\n.bg-white {\n  background-color: #ffffff !important;\n}\n.bg-transparent {\n  background-color: transparent !important;\n}\n.border {\n  border: 1px solid #dee2e6 !important;\n}\n.border-top {\n  border-top: 1px solid #dee2e6 !important;\n}\n.border-right {\n  border-right: 1px solid #dee2e6 !important;\n}\n.border-bottom {\n  border-bottom: 1px solid #dee2e6 !important;\n}\n.border-left {\n  border-left: 1px solid #dee2e6 !important;\n}\n.border-0 {\n  border: 0 !important;\n}\n.border-top-0 {\n  border-top: 0 !important;\n}\n.border-right-0 {\n  border-right: 0 !important;\n}\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n.border-left-0 {\n  border-left: 0 !important;\n}\n.border-primary {\n  border-color: #007bff !important;\n}\n.border-secondary {\n  border-color: #6c757d !important;\n}\n.border-success {\n  border-color: #73C677 !important;\n}\n.border-info {\n  border-color: #60D3EC !important;\n}\n.border-warning {\n  border-color: #FFA564 !important;\n}\n.border-danger {\n  border-color: #dc3545 !important;\n}\n.border-light {\n  border-color: #f8f9fa !important;\n}\n.border-dark {\n  border-color: #343a40 !important;\n}\n.border-white {\n  border-color: #ffffff !important;\n}\n.rounded {\n  border-radius: 3px !important;\n}\n.rounded-top {\n  border-top-left-radius: 3px !important;\n  border-top-right-radius: 3px !important;\n}\n.rounded-right {\n  border-top-right-radius: 3px !important;\n  border-bottom-right-radius: 3px !important;\n}\n.rounded-bottom {\n  border-bottom-right-radius: 3px !important;\n  border-bottom-left-radius: 3px !important;\n}\n.rounded-left {\n  border-top-left-radius: 3px !important;\n  border-bottom-left-radius: 3px !important;\n}\n.rounded-circle {\n  border-radius: 50% !important;\n}\n.rounded-0 {\n  border-radius: 0 !important;\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n.d-none {\n  display: none !important;\n}\n.d-inline {\n  display: inline !important;\n}\n.d-inline-block {\n  display: inline-block !important;\n}\n.d-block {\n  display: block !important;\n}\n.d-table {\n  display: table !important;\n}\n.d-table-row {\n  display: table-row !important;\n}\n.d-table-cell {\n  display: table-cell !important;\n}\n.d-flex {\n  display: flex !important;\n}\n.d-inline-flex {\n  display: inline-flex !important;\n}\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n}\n@media print {\n  .d-print-none {\n    display: none !important;\n  }\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n}\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n.embed-responsive::before {\n  display: block;\n  content: \"\";\n}\n.embed-responsive .embed-responsive-item,\n.embed-responsive iframe,\n.embed-responsive embed,\n.embed-responsive object,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n.embed-responsive-21by9::before {\n  padding-top: 42.85714286%;\n}\n.embed-responsive-16by9::before {\n  padding-top: 56.25%;\n}\n.embed-responsive-4by3::before {\n  padding-top: 75%;\n}\n.embed-responsive-1by1::before {\n  padding-top: 100%;\n}\n.flex-row {\n  flex-direction: row !important;\n}\n.flex-column {\n  flex-direction: column !important;\n}\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n.justify-content-center {\n  justify-content: center !important;\n}\n.justify-content-between {\n  justify-content: space-between !important;\n}\n.justify-content-around {\n  justify-content: space-around !important;\n}\n.align-items-start {\n  align-items: flex-start !important;\n}\n.align-items-end {\n  align-items: flex-end !important;\n}\n.align-items-center {\n  align-items: center !important;\n}\n.align-items-baseline {\n  align-items: baseline !important;\n}\n.align-items-stretch {\n  align-items: stretch !important;\n}\n.align-content-start {\n  align-content: flex-start !important;\n}\n.align-content-end {\n  align-content: flex-end !important;\n}\n.align-content-center {\n  align-content: center !important;\n}\n.align-content-between {\n  align-content: space-between !important;\n}\n.align-content-around {\n  align-content: space-around !important;\n}\n.align-content-stretch {\n  align-content: stretch !important;\n}\n.align-self-auto {\n  align-self: auto !important;\n}\n.align-self-start {\n  align-self: flex-start !important;\n}\n.align-self-end {\n  align-self: flex-end !important;\n}\n.align-self-center {\n  align-self: center !important;\n}\n.align-self-baseline {\n  align-self: baseline !important;\n}\n.align-self-stretch {\n  align-self: stretch !important;\n}\n@media (min-width: 576px) {\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 768px) {\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    align-items: center !important;\n  }\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    align-content: center !important;\n  }\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    align-self: center !important;\n  }\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 992px) {\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n}\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n}\n.float-left {\n  float: left !important;\n}\n.float-right {\n  float: right !important;\n}\n.float-none {\n  float: none !important;\n}\n@media (min-width: 576px) {\n  .float-sm-left {\n    float: left !important;\n  }\n  .float-sm-right {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-left {\n    float: left !important;\n  }\n  .float-md-right {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-left {\n    float: left !important;\n  }\n  .float-lg-right {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-left {\n    float: left !important;\n  }\n  .float-xl-right {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n}\n.position-static {\n  position: static !important;\n}\n.position-relative {\n  position: relative !important;\n}\n.position-absolute {\n  position: absolute !important;\n}\n.position-fixed {\n  position: fixed !important;\n}\n.position-sticky {\n  position: sticky !important;\n}\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n@supports (position: sticky) {\n  .sticky-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n.sr-only-focusable:active,\n.sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n.shadow-sm {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n.shadow {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n.shadow-lg {\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;\n}\n.shadow-none {\n  box-shadow: none !important;\n}\n.w-25 {\n  width: 25% !important;\n}\n.w-50 {\n  width: 50% !important;\n}\n.w-75 {\n  width: 75% !important;\n}\n.w-100 {\n  width: 100% !important;\n}\n.w-auto {\n  width: auto !important;\n}\n.h-25 {\n  height: 25% !important;\n}\n.h-50 {\n  height: 50% !important;\n}\n.h-75 {\n  height: 75% !important;\n}\n.h-100 {\n  height: 100% !important;\n}\n.h-auto {\n  height: auto !important;\n}\n.mw-100 {\n  max-width: 100% !important;\n}\n.mh-100 {\n  max-height: 100% !important;\n}\n.m-0 {\n  margin: 0 !important;\n}\n.mt-0,\n.my-0 {\n  margin-top: 0 !important;\n}\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important;\n}\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important;\n}\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important;\n}\n.m-1 {\n  margin: 0.25rem !important;\n}\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important;\n}\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important;\n}\n.mb-1,\n.my-1 {\n  margin-bottom: 0.25rem !important;\n}\n.ml-1,\n.mx-1 {\n  margin-left: 0.25rem !important;\n}\n.m-2 {\n  margin: 0.5rem !important;\n}\n.mt-2,\n.my-2 {\n  margin-top: 0.5rem !important;\n}\n.mr-2,\n.mx-2 {\n  margin-right: 0.5rem !important;\n}\n.mb-2,\n.my-2 {\n  margin-bottom: 0.5rem !important;\n}\n.ml-2,\n.mx-2 {\n  margin-left: 0.5rem !important;\n}\n.m-3 {\n  margin: 1rem !important;\n}\n.mt-3,\n.my-3 {\n  margin-top: 1rem !important;\n}\n.mr-3,\n.mx-3 {\n  margin-right: 1rem !important;\n}\n.mb-3,\n.my-3 {\n  margin-bottom: 1rem !important;\n}\n.ml-3,\n.mx-3 {\n  margin-left: 1rem !important;\n}\n.m-4 {\n  margin: 1.5rem !important;\n}\n.mt-4,\n.my-4 {\n  margin-top: 1.5rem !important;\n}\n.mr-4,\n.mx-4 {\n  margin-right: 1.5rem !important;\n}\n.mb-4,\n.my-4 {\n  margin-bottom: 1.5rem !important;\n}\n.ml-4,\n.mx-4 {\n  margin-left: 1.5rem !important;\n}\n.m-5 {\n  margin: 3rem !important;\n}\n.mt-5,\n.my-5 {\n  margin-top: 3rem !important;\n}\n.mr-5,\n.mx-5 {\n  margin-right: 3rem !important;\n}\n.mb-5,\n.my-5 {\n  margin-bottom: 3rem !important;\n}\n.ml-5,\n.mx-5 {\n  margin-left: 3rem !important;\n}\n.p-0 {\n  padding: 0 !important;\n}\n.pt-0,\n.py-0 {\n  padding-top: 0 !important;\n}\n.pr-0,\n.px-0 {\n  padding-right: 0 !important;\n}\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important;\n}\n.pl-0,\n.px-0 {\n  padding-left: 0 !important;\n}\n.p-1 {\n  padding: 0.25rem !important;\n}\n.pt-1,\n.py-1 {\n  padding-top: 0.25rem !important;\n}\n.pr-1,\n.px-1 {\n  padding-right: 0.25rem !important;\n}\n.pb-1,\n.py-1 {\n  padding-bottom: 0.25rem !important;\n}\n.pl-1,\n.px-1 {\n  padding-left: 0.25rem !important;\n}\n.p-2 {\n  padding: 0.5rem !important;\n}\n.pt-2,\n.py-2 {\n  padding-top: 0.5rem !important;\n}\n.pr-2,\n.px-2 {\n  padding-right: 0.5rem !important;\n}\n.pb-2,\n.py-2 {\n  padding-bottom: 0.5rem !important;\n}\n.pl-2,\n.px-2 {\n  padding-left: 0.5rem !important;\n}\n.p-3 {\n  padding: 1rem !important;\n}\n.pt-3,\n.py-3 {\n  padding-top: 1rem !important;\n}\n.pr-3,\n.px-3 {\n  padding-right: 1rem !important;\n}\n.pb-3,\n.py-3 {\n  padding-bottom: 1rem !important;\n}\n.pl-3,\n.px-3 {\n  padding-left: 1rem !important;\n}\n.p-4 {\n  padding: 1.5rem !important;\n}\n.pt-4,\n.py-4 {\n  padding-top: 1.5rem !important;\n}\n.pr-4,\n.px-4 {\n  padding-right: 1.5rem !important;\n}\n.pb-4,\n.py-4 {\n  padding-bottom: 1.5rem !important;\n}\n.pl-4,\n.px-4 {\n  padding-left: 1.5rem !important;\n}\n.p-5 {\n  padding: 3rem !important;\n}\n.pt-5,\n.py-5 {\n  padding-top: 3rem !important;\n}\n.pr-5,\n.px-5 {\n  padding-right: 3rem !important;\n}\n.pb-5,\n.py-5 {\n  padding-bottom: 3rem !important;\n}\n.pl-5,\n.px-5 {\n  padding-left: 3rem !important;\n}\n.m-auto {\n  margin: auto !important;\n}\n.mt-auto,\n.my-auto {\n  margin-top: auto !important;\n}\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important;\n}\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important;\n}\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important;\n}\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important;\n  }\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 3rem !important;\n  }\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 3rem !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 3rem !important;\n  }\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 3rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important;\n  }\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important;\n  }\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important;\n  }\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 3rem !important;\n  }\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 3rem !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important;\n  }\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important;\n  }\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 3rem !important;\n  }\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 3rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important;\n  }\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important;\n  }\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 3rem !important;\n  }\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 3rem !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 3rem !important;\n  }\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 3rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important;\n  }\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important;\n  }\n}\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important;\n  }\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 3rem !important;\n  }\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 3rem !important;\n  }\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 3rem !important;\n  }\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 3rem !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 3rem !important;\n  }\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 3rem !important;\n  }\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 3rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important;\n  }\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important;\n  }\n}\n.text-monospace {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n.text-justify {\n  text-align: justify !important;\n}\n.text-nowrap {\n  white-space: nowrap !important;\n}\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.text-left {\n  text-align: left !important;\n}\n.text-right {\n  text-align: right !important;\n}\n.text-center {\n  text-align: center !important;\n}\n@media (min-width: 576px) {\n  .text-sm-left {\n    text-align: left !important;\n  }\n  .text-sm-right {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 768px) {\n  .text-md-left {\n    text-align: left !important;\n  }\n  .text-md-right {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 992px) {\n  .text-lg-left {\n    text-align: left !important;\n  }\n  .text-lg-right {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n@media (min-width: 1200px) {\n  .text-xl-left {\n    text-align: left !important;\n  }\n  .text-xl-right {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n.font-weight-light {\n  font-weight: 300 !important;\n}\n.font-weight-normal {\n  font-weight: 400 !important;\n}\n.font-weight-bold {\n  font-weight: 700 !important;\n}\n.font-italic {\n  font-style: italic !important;\n}\n.text-white {\n  color: #ffffff !important;\n}\n.text-primary {\n  color: #007bff !important;\n}\na.text-primary:hover,\na.text-primary:focus {\n  color: #0062cc !important;\n}\n.text-secondary {\n  color: #6c757d !important;\n}\na.text-secondary:hover,\na.text-secondary:focus {\n  color: #545b62 !important;\n}\n.text-success {\n  color: #73C677 !important;\n}\na.text-success:hover,\na.text-success:focus {\n  color: #4fb754 !important;\n}\n.text-info {\n  color: #60D3EC !important;\n}\na.text-info:hover,\na.text-info:focus {\n  color: #32c6e7 !important;\n}\n.text-warning {\n  color: #FFA564 !important;\n}\na.text-warning:hover,\na.text-warning:focus {\n  color: #ff8731 !important;\n}\n.text-danger {\n  color: #dc3545 !important;\n}\na.text-danger:hover,\na.text-danger:focus {\n  color: #bd2130 !important;\n}\n.text-light {\n  color: #f8f9fa !important;\n}\na.text-light:hover,\na.text-light:focus {\n  color: #dae0e5 !important;\n}\n.text-dark {\n  color: #343a40 !important;\n}\na.text-dark:hover,\na.text-dark:focus {\n  color: #1d2124 !important;\n}\n.text-body {\n  color: #212529 !important;\n}\n.text-muted {\n  color: #6c757d !important;\n}\n.text-black-50 {\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n.text-white-50 {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n.visible {\n  visibility: visible !important;\n}\n.invisible {\n  visibility: hidden !important;\n}\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border: 1px solid #cfcdcd;\n  border-radius: 4px;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media screen and (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.form-control:focus {\n  color: #495057;\n  background-color: #ffffff;\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.form-control::placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.form-control:disabled,\n.form-control[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\nselect.form-control:not([size]):not([multiple]) {\n  height: calc(2.25rem + 2px);\n}\nselect.form-control:focus::-ms-value {\n  color: #495057;\n  background-color: #ffffff;\n}\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n.col-form-label {\n  padding-top: calc(0.375rem + 1px);\n  padding-bottom: calc(0.375rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.5;\n}\n.col-form-label-lg {\n  padding-top: calc(0.5rem + 1px);\n  padding-bottom: calc(0.5rem + 1px);\n  font-size: 1.25rem;\n  line-height: 1.5;\n}\n.col-form-label-sm {\n  padding-top: calc(0.25rem + 1px);\n  padding-bottom: calc(0.25rem + 1px);\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding-top: 0.375rem;\n  padding-bottom: 0.375rem;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: #212529;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext.form-control-sm,\n.form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n.form-control-sm {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 3px;\n}\nselect.form-control-sm:not([size]):not([multiple]) {\n  height: calc(1.8125rem + 2px);\n}\n.form-control-lg {\n  padding: 0.5rem 1rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 3px;\n}\nselect.form-control-lg:not([size]):not([multiple]) {\n  height: calc(2.875rem + 2px);\n}\n.form-group {\n  margin-bottom: 1rem;\n}\n.form-text {\n  display: block;\n  margin-top: 0.25rem;\n}\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n.form-row > .col,\n.form-row > [class*=\"col-\"] {\n  padding-right: 5px;\n  padding-left: 5px;\n}\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem;\n}\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem;\n}\n.form-check-input:disabled ~ .form-check-label {\n  color: #6c757d;\n}\n.form-check-label {\n  margin-bottom: 0;\n}\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem;\n}\n.form-check-inline .form-check-input {\n  position: static;\n  margin-top: 0;\n  margin-right: 0.3125rem;\n  margin-left: 0;\n}\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #73C677;\n}\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  line-height: 1;\n  color: #ffffff;\n  background-color: rgba(115, 198, 119, 0.8);\n  border-radius: 0.2rem;\n}\n.was-validated .form-control:valid,\n.was-validated .custom-select:valid,\n.form-control.is-valid,\n.custom-select.is-valid {\n  border-color: #73C677;\n}\n.was-validated .form-control:valid:focus,\n.was-validated .custom-select:valid:focus,\n.form-control.is-valid:focus,\n.custom-select.is-valid:focus {\n  border-color: #73C677;\n  box-shadow: 0 0 0 0.2rem rgba(115, 198, 119, 0.25);\n}\n.was-validated .form-control:valid ~ .valid-feedback,\n.was-validated .custom-select:valid ~ .valid-feedback,\n.form-control.is-valid ~ .valid-feedback,\n.custom-select.is-valid ~ .valid-feedback,\n.was-validated .form-control:valid ~ .valid-tooltip,\n.was-validated .custom-select:valid ~ .valid-tooltip,\n.form-control.is-valid ~ .valid-tooltip,\n.custom-select.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .form-control-file:valid ~ .valid-feedback,\n.form-control-file.is-valid ~ .valid-feedback,\n.was-validated .form-control-file:valid ~ .valid-tooltip,\n.form-control-file.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .form-check-input:valid ~ .form-check-label,\n.form-check-input.is-valid ~ .form-check-label {\n  color: #73C677;\n}\n.was-validated .form-check-input:valid ~ .valid-feedback,\n.form-check-input.is-valid ~ .valid-feedback,\n.was-validated .form-check-input:valid ~ .valid-tooltip,\n.form-check-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .custom-control-input:valid ~ .custom-control-label,\n.custom-control-input.is-valid ~ .custom-control-label {\n  color: #73C677;\n}\n.was-validated .custom-control-input:valid ~ .custom-control-label::before,\n.custom-control-input.is-valid ~ .custom-control-label::before {\n  background-color: #ceebcf;\n}\n.was-validated .custom-control-input:valid ~ .valid-feedback,\n.custom-control-input.is-valid ~ .valid-feedback,\n.was-validated .custom-control-input:valid ~ .valid-tooltip,\n.custom-control-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before,\n.custom-control-input.is-valid:checked ~ .custom-control-label::before {\n  background-color: #97d59a;\n}\n.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before,\n.custom-control-input.is-valid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.2rem rgba(115, 198, 119, 0.25);\n}\n.was-validated .custom-file-input:valid ~ .custom-file-label,\n.custom-file-input.is-valid ~ .custom-file-label {\n  border-color: #73C677;\n}\n.was-validated .custom-file-input:valid ~ .custom-file-label::before,\n.custom-file-input.is-valid ~ .custom-file-label::before {\n  border-color: inherit;\n}\n.was-validated .custom-file-input:valid ~ .valid-feedback,\n.custom-file-input.is-valid ~ .valid-feedback,\n.was-validated .custom-file-input:valid ~ .valid-tooltip,\n.custom-file-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label,\n.custom-file-input.is-valid:focus ~ .custom-file-label {\n  box-shadow: 0 0 0 0.2rem rgba(115, 198, 119, 0.25);\n}\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #dc3545;\n}\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.5rem;\n  margin-top: 0.1rem;\n  font-size: 0.875rem;\n  line-height: 1;\n  color: #ffffff;\n  background-color: rgba(220, 53, 69, 0.8);\n  border-radius: 0.2rem;\n}\n.was-validated .form-control:invalid,\n.was-validated .custom-select:invalid,\n.form-control.is-invalid,\n.custom-select.is-invalid {\n  border-color: #dc3545;\n}\n.was-validated .form-control:invalid:focus,\n.was-validated .custom-select:invalid:focus,\n.form-control.is-invalid:focus,\n.custom-select.is-invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n.was-validated .form-control:invalid ~ .invalid-feedback,\n.was-validated .custom-select:invalid ~ .invalid-feedback,\n.form-control.is-invalid ~ .invalid-feedback,\n.custom-select.is-invalid ~ .invalid-feedback,\n.was-validated .form-control:invalid ~ .invalid-tooltip,\n.was-validated .custom-select:invalid ~ .invalid-tooltip,\n.form-control.is-invalid ~ .invalid-tooltip,\n.custom-select.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .form-control-file:invalid ~ .invalid-feedback,\n.form-control-file.is-invalid ~ .invalid-feedback,\n.was-validated .form-control-file:invalid ~ .invalid-tooltip,\n.form-control-file.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .form-check-input:invalid ~ .form-check-label,\n.form-check-input.is-invalid ~ .form-check-label {\n  color: #dc3545;\n}\n.was-validated .form-check-input:invalid ~ .invalid-feedback,\n.form-check-input.is-invalid ~ .invalid-feedback,\n.was-validated .form-check-input:invalid ~ .invalid-tooltip,\n.form-check-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .custom-control-input:invalid ~ .custom-control-label,\n.custom-control-input.is-invalid ~ .custom-control-label {\n  color: #dc3545;\n}\n.was-validated .custom-control-input:invalid ~ .custom-control-label::before,\n.custom-control-input.is-invalid ~ .custom-control-label::before {\n  background-color: #efa2a9;\n}\n.was-validated .custom-control-input:invalid ~ .invalid-feedback,\n.custom-control-input.is-invalid ~ .invalid-feedback,\n.was-validated .custom-control-input:invalid ~ .invalid-tooltip,\n.custom-control-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before,\n.custom-control-input.is-invalid:checked ~ .custom-control-label::before {\n  background-color: #e4606d;\n}\n.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before,\n.custom-control-input.is-invalid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n.was-validated .custom-file-input:invalid ~ .custom-file-label,\n.custom-file-input.is-invalid ~ .custom-file-label {\n  border-color: #dc3545;\n}\n.was-validated .custom-file-input:invalid ~ .custom-file-label::before,\n.custom-file-input.is-invalid ~ .custom-file-label::before {\n  border-color: inherit;\n}\n.was-validated .custom-file-input:invalid ~ .invalid-feedback,\n.custom-file-input.is-invalid ~ .invalid-feedback,\n.was-validated .custom-file-input:invalid ~ .invalid-tooltip,\n.custom-file-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label,\n.custom-file-input.is-invalid:focus ~ .custom-file-label {\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n}\n.form-inline .form-check {\n  width: 100%;\n}\n@media (min-width: 576px) {\n  .form-inline label {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-group {\n    display: flex;\n    flex: 0 0 auto;\n    flex-flow: row wrap;\n    align-items: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .form-inline .form-control-plaintext {\n    display: inline-block;\n  }\n  .form-inline .input-group,\n  .form-inline .custom-select {\n    width: auto;\n  }\n  .form-inline .form-check {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: auto;\n    padding-left: 0;\n  }\n  .form-inline .form-check-input {\n    position: relative;\n    margin-top: 0;\n    margin-right: 0.25rem;\n    margin-left: 0;\n  }\n  .form-inline .custom-control {\n    align-items: center;\n    justify-content: center;\n  }\n  .form-inline .custom-control-label {\n    margin-bottom: 0;\n  }\n}\n.container {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n@media (min-width: 576px) {\n  .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container {\n    max-width: 1140px;\n  }\n}\n.container-fluid {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n.row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n.no-gutters > .col,\n.no-gutters > [class*=\"col-\"] {\n  padding-right: 0;\n  padding-left: 0;\n}\n.grid-column,\n.col-1,\n.col-2,\n.col-3,\n.col-4,\n.col-5,\n.col-6,\n.col-7,\n.col-8,\n.col-9,\n.col-10,\n.col-11,\n.col-12,\n.col,\n.col-auto,\n.col-sm-1,\n.col-sm-2,\n.col-sm-3,\n.col-sm-4,\n.col-sm-5,\n.col-sm-6,\n.col-sm-7,\n.col-sm-8,\n.col-sm-9,\n.col-sm-10,\n.col-sm-11,\n.col-sm-12,\n.col-sm,\n.col-sm-auto,\n.col-md-1,\n.col-md-2,\n.col-md-3,\n.col-md-4,\n.col-md-5,\n.col-md-6,\n.col-md-7,\n.col-md-8,\n.col-md-9,\n.col-md-10,\n.col-md-11,\n.col-md-12,\n.col-md,\n.col-md-auto,\n.col-lg-1,\n.col-lg-2,\n.col-lg-3,\n.col-lg-4,\n.col-lg-5,\n.col-lg-6,\n.col-lg-7,\n.col-lg-8,\n.col-lg-9,\n.col-lg-10,\n.col-lg-11,\n.col-lg-12,\n.col-lg,\n.col-lg-auto,\n.col-xl-1,\n.col-xl-2,\n.col-xl-3,\n.col-xl-4,\n.col-xl-5,\n.col-xl-6,\n.col-xl-7,\n.col-xl-8,\n.col-xl-9,\n.col-xl-10,\n.col-xl-11,\n.col-xl-12,\n.col-xl,\n.col-xl-auto {\n  position: relative;\n  width: 100%;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n.col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n}\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: none;\n}\n.col-1 {\n  flex: 0 0 8.33333333%;\n  max-width: 8.33333333%;\n}\n.col-2 {\n  flex: 0 0 16.66666667%;\n  max-width: 16.66666667%;\n}\n.col-3 {\n  flex: 0 0 25%;\n  max-width: 25%;\n}\n.col-4 {\n  flex: 0 0 33.33333333%;\n  max-width: 33.33333333%;\n}\n.col-5 {\n  flex: 0 0 41.66666667%;\n  max-width: 41.66666667%;\n}\n.col-6 {\n  flex: 0 0 50%;\n  max-width: 50%;\n}\n.col-7 {\n  flex: 0 0 58.33333333%;\n  max-width: 58.33333333%;\n}\n.col-8 {\n  flex: 0 0 66.66666667%;\n  max-width: 66.66666667%;\n}\n.col-9 {\n  flex: 0 0 75%;\n  max-width: 75%;\n}\n.col-10 {\n  flex: 0 0 83.33333333%;\n  max-width: 83.33333333%;\n}\n.col-11 {\n  flex: 0 0 91.66666667%;\n  max-width: 91.66666667%;\n}\n.col-12 {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n.order-first {\n  order: -1;\n}\n.order-last {\n  order: 13;\n}\n.order-0 {\n  order: 0;\n}\n.order-1 {\n  order: 1;\n}\n.order-2 {\n  order: 2;\n}\n.order-3 {\n  order: 3;\n}\n.order-4 {\n  order: 4;\n}\n.order-5 {\n  order: 5;\n}\n.order-6 {\n  order: 6;\n}\n.order-7 {\n  order: 7;\n}\n.order-8 {\n  order: 8;\n}\n.order-9 {\n  order: 9;\n}\n.order-10 {\n  order: 10;\n}\n.order-11 {\n  order: 11;\n}\n.order-12 {\n  order: 12;\n}\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n.offset-3 {\n  margin-left: 25%;\n}\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n.offset-6 {\n  margin-left: 50%;\n}\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n.offset-9 {\n  margin-left: 75%;\n}\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n@media (min-width: 576px) {\n  .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .col-sm-1 {\n    flex: 0 0 8.33333333%;\n    max-width: 8.33333333%;\n  }\n  .col-sm-2 {\n    flex: 0 0 16.66666667%;\n    max-width: 16.66666667%;\n  }\n  .col-sm-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-sm-4 {\n    flex: 0 0 33.33333333%;\n    max-width: 33.33333333%;\n  }\n  .col-sm-5 {\n    flex: 0 0 41.66666667%;\n    max-width: 41.66666667%;\n  }\n  .col-sm-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-sm-7 {\n    flex: 0 0 58.33333333%;\n    max-width: 58.33333333%;\n  }\n  .col-sm-8 {\n    flex: 0 0 66.66666667%;\n    max-width: 66.66666667%;\n  }\n  .col-sm-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-sm-10 {\n    flex: 0 0 83.33333333%;\n    max-width: 83.33333333%;\n  }\n  .col-sm-11 {\n    flex: 0 0 91.66666667%;\n    max-width: 91.66666667%;\n  }\n  .col-sm-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-sm-first {\n    order: -1;\n  }\n  .order-sm-last {\n    order: 13;\n  }\n  .order-sm-0 {\n    order: 0;\n  }\n  .order-sm-1 {\n    order: 1;\n  }\n  .order-sm-2 {\n    order: 2;\n  }\n  .order-sm-3 {\n    order: 3;\n  }\n  .order-sm-4 {\n    order: 4;\n  }\n  .order-sm-5 {\n    order: 5;\n  }\n  .order-sm-6 {\n    order: 6;\n  }\n  .order-sm-7 {\n    order: 7;\n  }\n  .order-sm-8 {\n    order: 8;\n  }\n  .order-sm-9 {\n    order: 9;\n  }\n  .order-sm-10 {\n    order: 10;\n  }\n  .order-sm-11 {\n    order: 11;\n  }\n  .order-sm-12 {\n    order: 12;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .col-md-1 {\n    flex: 0 0 8.33333333%;\n    max-width: 8.33333333%;\n  }\n  .col-md-2 {\n    flex: 0 0 16.66666667%;\n    max-width: 16.66666667%;\n  }\n  .col-md-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-md-4 {\n    flex: 0 0 33.33333333%;\n    max-width: 33.33333333%;\n  }\n  .col-md-5 {\n    flex: 0 0 41.66666667%;\n    max-width: 41.66666667%;\n  }\n  .col-md-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-md-7 {\n    flex: 0 0 58.33333333%;\n    max-width: 58.33333333%;\n  }\n  .col-md-8 {\n    flex: 0 0 66.66666667%;\n    max-width: 66.66666667%;\n  }\n  .col-md-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-md-10 {\n    flex: 0 0 83.33333333%;\n    max-width: 83.33333333%;\n  }\n  .col-md-11 {\n    flex: 0 0 91.66666667%;\n    max-width: 91.66666667%;\n  }\n  .col-md-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-md-first {\n    order: -1;\n  }\n  .order-md-last {\n    order: 13;\n  }\n  .order-md-0 {\n    order: 0;\n  }\n  .order-md-1 {\n    order: 1;\n  }\n  .order-md-2 {\n    order: 2;\n  }\n  .order-md-3 {\n    order: 3;\n  }\n  .order-md-4 {\n    order: 4;\n  }\n  .order-md-5 {\n    order: 5;\n  }\n  .order-md-6 {\n    order: 6;\n  }\n  .order-md-7 {\n    order: 7;\n  }\n  .order-md-8 {\n    order: 8;\n  }\n  .order-md-9 {\n    order: 9;\n  }\n  .order-md-10 {\n    order: 10;\n  }\n  .order-md-11 {\n    order: 11;\n  }\n  .order-md-12 {\n    order: 12;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .col-lg-1 {\n    flex: 0 0 8.33333333%;\n    max-width: 8.33333333%;\n  }\n  .col-lg-2 {\n    flex: 0 0 16.66666667%;\n    max-width: 16.66666667%;\n  }\n  .col-lg-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-lg-4 {\n    flex: 0 0 33.33333333%;\n    max-width: 33.33333333%;\n  }\n  .col-lg-5 {\n    flex: 0 0 41.66666667%;\n    max-width: 41.66666667%;\n  }\n  .col-lg-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-lg-7 {\n    flex: 0 0 58.33333333%;\n    max-width: 58.33333333%;\n  }\n  .col-lg-8 {\n    flex: 0 0 66.66666667%;\n    max-width: 66.66666667%;\n  }\n  .col-lg-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-lg-10 {\n    flex: 0 0 83.33333333%;\n    max-width: 83.33333333%;\n  }\n  .col-lg-11 {\n    flex: 0 0 91.66666667%;\n    max-width: 91.66666667%;\n  }\n  .col-lg-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-lg-first {\n    order: -1;\n  }\n  .order-lg-last {\n    order: 13;\n  }\n  .order-lg-0 {\n    order: 0;\n  }\n  .order-lg-1 {\n    order: 1;\n  }\n  .order-lg-2 {\n    order: 2;\n  }\n  .order-lg-3 {\n    order: 3;\n  }\n  .order-lg-4 {\n    order: 4;\n  }\n  .order-lg-5 {\n    order: 5;\n  }\n  .order-lg-6 {\n    order: 6;\n  }\n  .order-lg-7 {\n    order: 7;\n  }\n  .order-lg-8 {\n    order: 8;\n  }\n  .order-lg-9 {\n    order: 9;\n  }\n  .order-lg-10 {\n    order: 10;\n  }\n  .order-lg-11 {\n    order: 11;\n  }\n  .order-lg-12 {\n    order: 12;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .col-xl-1 {\n    flex: 0 0 8.33333333%;\n    max-width: 8.33333333%;\n  }\n  .col-xl-2 {\n    flex: 0 0 16.66666667%;\n    max-width: 16.66666667%;\n  }\n  .col-xl-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-xl-4 {\n    flex: 0 0 33.33333333%;\n    max-width: 33.33333333%;\n  }\n  .col-xl-5 {\n    flex: 0 0 41.66666667%;\n    max-width: 41.66666667%;\n  }\n  .col-xl-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-xl-7 {\n    flex: 0 0 58.33333333%;\n    max-width: 58.33333333%;\n  }\n  .col-xl-8 {\n    flex: 0 0 66.66666667%;\n    max-width: 66.66666667%;\n  }\n  .col-xl-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-xl-10 {\n    flex: 0 0 83.33333333%;\n    max-width: 83.33333333%;\n  }\n  .col-xl-11 {\n    flex: 0 0 91.66666667%;\n    max-width: 91.66666667%;\n  }\n  .col-xl-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-xl-first {\n    order: -1;\n  }\n  .order-xl-last {\n    order: 13;\n  }\n  .order-xl-0 {\n    order: 0;\n  }\n  .order-xl-1 {\n    order: 1;\n  }\n  .order-xl-2 {\n    order: 2;\n  }\n  .order-xl-3 {\n    order: 3;\n  }\n  .order-xl-4 {\n    order: 4;\n  }\n  .order-xl-5 {\n    order: 5;\n  }\n  .order-xl-6 {\n    order: 6;\n  }\n  .order-xl-7 {\n    order: 7;\n  }\n  .order-xl-8 {\n    order: 8;\n  }\n  .order-xl-9 {\n    order: 9;\n  }\n  .order-xl-10 {\n    order: 10;\n  }\n  .order-xl-11 {\n    order: 11;\n  }\n  .order-xl-12 {\n    order: 12;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n}\n/* Basics */\n/* Primary */\n/* Secondary */\n/* Tertiary */\n/* States */\n/* Text */\n/* Shadows */\n/* Greys */\n/* Global styles */\nhtml {\n  position: relative;\n  min-height: 100vh;\n  font-size: 12px;\n  line-height: 26px;\n}\nbody {\n  font-size: 12px;\n  min-height: 100%;\n  color: #78789A;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  margin: 0;\n  padding: 0;\n  font-family: 'Poppins', sans-serif;\n}\nul {\n  padding: 15px 0 0 15px;\n}\nli {\n  line-height: 1.5em;\n  margin-top: 5px;\n}\na,\na:link {\n  text-decoration: none;\n  color: #78789A;\n}\na:active,\na:focus,\na:hover {\n  color: #000;\n}\na:focus,\na:active,\nbutton::-moz-focus-inner,\nbutton:focus,\ninput[type=\"reset\"]::-moz-focus-inner,\ninput[type=\"button\"]::-moz-focus-inner,\ninput[type=\"submit\"]::-moz-focus-inner,\nselect::-moz-focus-inner,\ninput[type=\"file\"] > input[type=\"button\"]::-moz-focus-inner {\n  border: 0;\n  outline: 0;\n}\nform {\n  display: inline;\n}\ninput[type=\"submit\"],\nbutton {\n  box-sizing: border-box;\n}\n/* Reset IOS input box styling */\ninput {\n  -webkit-appearance: none;\n  border-radius: 0;\n}\ninput[type=\"checkbox\"] {\n  -webkit-appearance: checkbox;\n}\ninput[type=\"radio\"] {\n  -webkit-appearance: radio;\n}\n/* Reset webkit yellow background on autofill */\ninput:-webkit-autofill::first-line,\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:autofill,\ninput:autofill:hover,\ninput:autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\ntextarea:autofill,\ntextarea:autofill:hover,\ntextarea:autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus,\nselect:autofill,\nselect:autofill:hover,\nselect:autofill:focus {\n  -webkit-background-clip: text !important;\n  appearance: none;\n  box-shadow: 0 0 0px 1000px #fff inset !important;\n  -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;\n  -webkit-text-fill-color: #676a6c !important;\n  color: #222;\n  background-color: #fff !important;\n  background-image: none !important;\n  filter: none !important;\n  font-size: 14px !important;\n  font-family: 'Poppins', sans-serif !important;\n}\ninput:-internal-autofill-selected {\n  -webkit-background-clip: text !important;\n  appearance: none;\n  box-shadow: 0 0 0px 1000px #fff inset !important;\n  -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;\n  -webkit-text-fill-color: #676a6c !important;\n  color: #222;\n  background-color: #fff !important;\n  background-image: none !important;\n  filter: none !important;\n  font-size: 14px !important;\n  font-family: 'Poppins', sans-serif !important;\n}\ninput:-internal-autofill-previewed {\n  -webkit-background-clip: text !important;\n  appearance: none;\n  box-shadow: 0 0 0px 1000px #fff inset !important;\n  -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;\n  -webkit-text-fill-color: #676a6c !important;\n  color: #222;\n  background-color: #fff !important;\n  background-image: none !important;\n  filter: none !important;\n  font-size: 14px !important;\n  font-family: 'Poppins', sans-serif !important;\n}\ninput:-internal-autofill-selected {\n  font-family: 'Poppins', sans-serif;\n  -webkit-background-clip: text !important;\n  appearance: none;\n  box-shadow: 0 0 0px 1000px #fff inset !important;\n  -webkit-box-shadow: 0 0 0px 1000px #fff inset !important;\n  -webkit-text-fill-color: #676a6c !important;\n  color: #222 !important;\n  background-color: #fff !important;\n  background-image: none !important;\n  filter: none !important;\n  font-size: 14px !important;\n}\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n}\n/* Remove Webkit glow */\ntextarea,\ninput {\n  outline: 0 !important;\n}\n/* Remove webkit focus glow */\n:focus {\n  outline-color: transparent;\n  outline-style: none;\n  outline: 0;\n}\ntextarea {\n  width: 100%;\n  min-height: 250px;\n  border: 1px solid #edf3f7;\n  padding: 5px;\n  color: #444;\n}\ninput[type=\"text\"].error,\ninput[type=\"password\"].error {\n  border-bottom: 1px solid #FC495D;\n}\nselect {\n  margin: 0 0 10px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border-radius: 0;\n  box-sizing: border-box;\n  display: inline-block;\n  width: auto;\n  background: none;\n}\n/* Explicitly specify font-weight for all headings */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-weight: 600;\n  color: #10294D;\n}\nh1 {\n  font-size: 20px;\n  line-height: 1.2em;\n  font-weight: 300;\n}\nh2 {\n  font-size: 18px;\n  margin: 0;\n  font-weight: 600;\n}\nh3 {\n  font-size: 16px;\n  line-height: 30px;\n  margin: 10px 0;\n  font-weight: 600;\n}\nh4 {\n  font-size: 14px;\n  font-weight: 600;\n}\nh5 {\n  font-size: 12px;\n  line-height: 1em;\n  font-weight: 700;\n}\nh6 {\n  font-size: 10px;\n  line-height: 1em;\n}\ninput:focus::-webkit-input-placeholder {\n  color: transparent;\n}\ninput:focus:-moz-placeholder {\n  color: transparent;\n}\n/* FF 4-18 */\ninput:focus::-moz-placeholder {\n  color: transparent;\n}\n/* FF 19+ */\ninput:focus:-ms-input-placeholder {\n  color: transparent;\n}\n/* IE 10+ */\n::-webkit-input-placeholder {\n  color: #efefef;\n}\n:-moz-placeholder {\n  color: #efefef;\n}\n::-moz-placeholder {\n  color: #efefef;\n}\n:-ms-input-placeholder {\n  color: #efefef;\n}\nstrong {\n  color: #333;\n  font-weight: 700;\n}\n.heavy {\n  font-weight: 700;\n}\n.capitalize {\n  text-transform: capitalize;\n}\nsvg {\n  fill: #222;\n}\n.hidden-sm {\n  display: none;\n}\n@media screen and (min-width: 576px) {\n  .hidden-sm {\n    display: block;\n  }\n}\n/* Silo Header */\n.silo-header {\n  top: 0px;\n  grid-area: silo-header;\n  height: 60px;\n  z-index: 900;\n  background: #000000;\n  left: 0;\n  right: 0;\n  transition: transform 0.2s ease-in-out;\n}\n@media print {\n  .silo-header {\n    display: none;\n  }\n}\n.silo-header .awaiting {\n  position: fixed;\n  top: 0px;\n  height: 2px;\n  width: 100%;\n  background: #000000;\n}\n.silo-header .awaiting > div.awaitcount {\n  width: 0;\n  height: 2px;\n  background-color: #ffffff;\n}\n.silo-header .logo-lg {\n  display: flex;\n  font-family: \"Century Gothic\", CenturyGothic, AppleGothic, sans-serif;\n  white-space: nowrap;\n  color: #ffffff;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  line-height: 60px;\n  max-height: 60px;\n  max-width: 200px;\n  margin-left: 10px;\n  position: absolute;\n}\n.silo-header .logo-lg:before {\n  content: \" \";\n  font-family: \"italici\";\n}\n.silo-header .logo-lg a {\n  color: #ffffff;\n}\n.silo-header .logo-lg img {\n  display: inline-block;\n}\n.silo-header .logo-lg svg {\n  margin: 0 6px 0 2px;\n  height: 32px;\n  vertical-align: middle;\n}\n.silo-header > .navbar {\n  display: none;\n  margin-bottom: 0;\n  margin-right: 20px;\n  border: none;\n  min-height: 60px;\n  border-radius: 0;\n  max-height: 60px;\n  line-height: 58px;\n  float: right;\n}\n@media (min-width: 576px) {\n  .silo-header > .navbar {\n    display: block;\n  }\n}\n.layout-top-nav .silo-header > .navbar {\n  margin-left: 0;\n}\n.silo-header > .navbar .navbar-collapse {\n  display: inline-block !important;\n  vertical-align: middle;\n}\n.silo-header > .navbar .navbar-collapse ul {\n  margin: 0;\n  padding: 0;\n}\n.silo-header > .navbar .navbar-collapse ul li {\n  margin-left: 3px;\n  display: inline-block;\n  list-style: none;\n}\n.silo-header > .navbar .navbar-collapse ul li a {\n  display: inline-block;\n  color: rgba(255, 255, 255, 0.57);\n  padding: 0 15px;\n  text-transform: uppercase;\n  line-height: 34px;\n  border: 1px solid rgba(255, 255, 255, 0);\n}\n.silo-header > .navbar .navbar-collapse ul li a:hover {\n  background: none;\n  color: #ffffff;\n  border: 1px solid #ffffff;\n}\n.silo-header > .navbar .navbar-collapse ul li.active a {\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.57);\n}\n.silo-header > .navbar .navbar-collapse ul li.active a:hover {\n  background: none;\n  border: 1px solid #ffffff;\n}\na.btn,\nbutton.btn,\n.btn {\n  display: flex;\n  align-items: center;\n  padding: 6px 15px;\n  min-height: 36px;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  user-select: none;\n  border: 1px solid transparent;\n  transition: all 0.2s ease-in-out;\n  border-radius: 4px;\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  font-weight: 500;\n}\na.btn-small,\nbutton.btn-small,\n.btn-small {\n  padding: 0 8px;\n  min-height: 26px;\n}\na.btn svg,\nbutton.btn svg,\n.btn svg {\n  fill: none;\n  transition: all 0.2s ease-in-out;\n}\na.btn.input-group-addon,\nbutton.btn.input-group-addon,\n.btn.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n}\na.btn-primary,\nbutton.btn-primary,\n.btn-primary {\n  background: #10294D;\n  border-color: transparent;\n  color: #ffffff;\n}\na.btn-primary svg,\nbutton.btn-primary svg,\n.btn-primary svg {\n  stroke: #ffffff;\n  fill: none;\n}\na.btn-primary:not(.disabled).focus,\nbutton.btn-primary:not(.disabled).focus,\n.btn-primary:not(.disabled).focus,\na.btn-primary:not(.disabled):focus,\nbutton.btn-primary:not(.disabled):focus,\n.btn-primary:not(.disabled):focus,\na.btn-primary:not(.disabled):focus-visible,\nbutton.btn-primary:not(.disabled):focus-visible,\n.btn-primary:not(.disabled):focus-visible {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #071B38;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\na.btn-primary:not(.disabled).active,\nbutton.btn-primary:not(.disabled).active,\n.btn-primary:not(.disabled).active,\na.btn-primary:not(.disabled):active,\nbutton.btn-primary:not(.disabled):active,\n.btn-primary:not(.disabled):active {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #071B38;\n}\na.btn-primary:not(.disabled).active.focus,\nbutton.btn-primary:not(.disabled).active.focus,\n.btn-primary:not(.disabled).active.focus,\na.btn-primary:not(.disabled):active.focus,\nbutton.btn-primary:not(.disabled):active.focus,\n.btn-primary:not(.disabled):active.focus,\na.btn-primary:not(.disabled).active:focus,\nbutton.btn-primary:not(.disabled).active:focus,\n.btn-primary:not(.disabled).active:focus,\na.btn-primary:not(.disabled):active:focus,\nbutton.btn-primary:not(.disabled):active:focus,\n.btn-primary:not(.disabled):active:focus,\na.btn-primary:not(.disabled).active:focus-visible,\nbutton.btn-primary:not(.disabled).active:focus-visible,\n.btn-primary:not(.disabled).active:focus-visible,\na.btn-primary:not(.disabled):active:focus-visible,\nbutton.btn-primary:not(.disabled):active:focus-visible,\n.btn-primary:not(.disabled):active:focus-visible {\n  background: #071B38;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\na.btn-primary:not(.disabled).hover,\nbutton.btn-primary:not(.disabled).hover,\n.btn-primary:not(.disabled).hover,\na.btn-primary:not(.disabled):hover,\nbutton.btn-primary:not(.disabled):hover,\n.btn-primary:not(.disabled):hover {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #071B38;\n}\na.btn-primary:not(.disabled).hover.active,\nbutton.btn-primary:not(.disabled).hover.active,\n.btn-primary:not(.disabled).hover.active,\na.btn-primary:not(.disabled):hover.active,\nbutton.btn-primary:not(.disabled):hover.active,\n.btn-primary:not(.disabled):hover.active,\na.btn-primary:not(.disabled).hover:active,\nbutton.btn-primary:not(.disabled).hover:active,\n.btn-primary:not(.disabled).hover:active,\na.btn-primary:not(.disabled):hover:active,\nbutton.btn-primary:not(.disabled):hover:active,\n.btn-primary:not(.disabled):hover:active {\n  border-color: transparent;\n  background: #071B38;\n}\na.btn-primary:not(.disabled).hover.active.focus,\nbutton.btn-primary:not(.disabled).hover.active.focus,\n.btn-primary:not(.disabled).hover.active.focus,\na.btn-primary:not(.disabled):hover.active.focus,\nbutton.btn-primary:not(.disabled):hover.active.focus,\n.btn-primary:not(.disabled):hover.active.focus,\na.btn-primary:not(.disabled).hover:active.focus,\nbutton.btn-primary:not(.disabled).hover:active.focus,\n.btn-primary:not(.disabled).hover:active.focus,\na.btn-primary:not(.disabled):hover:active.focus,\nbutton.btn-primary:not(.disabled):hover:active.focus,\n.btn-primary:not(.disabled):hover:active.focus,\na.btn-primary:not(.disabled).hover.active:focus,\nbutton.btn-primary:not(.disabled).hover.active:focus,\n.btn-primary:not(.disabled).hover.active:focus,\na.btn-primary:not(.disabled):hover.active:focus,\nbutton.btn-primary:not(.disabled):hover.active:focus,\n.btn-primary:not(.disabled):hover.active:focus,\na.btn-primary:not(.disabled).hover:active:focus,\nbutton.btn-primary:not(.disabled).hover:active:focus,\n.btn-primary:not(.disabled).hover:active:focus,\na.btn-primary:not(.disabled):hover:active:focus,\nbutton.btn-primary:not(.disabled):hover:active:focus,\n.btn-primary:not(.disabled):hover:active:focus,\na.btn-primary:not(.disabled).hover.active:focus-visible,\nbutton.btn-primary:not(.disabled).hover.active:focus-visible,\n.btn-primary:not(.disabled).hover.active:focus-visible,\na.btn-primary:not(.disabled):hover.active:focus-visible,\nbutton.btn-primary:not(.disabled):hover.active:focus-visible,\n.btn-primary:not(.disabled):hover.active:focus-visible,\na.btn-primary:not(.disabled).hover:active:focus-visible,\nbutton.btn-primary:not(.disabled).hover:active:focus-visible,\n.btn-primary:not(.disabled).hover:active:focus-visible,\na.btn-primary:not(.disabled):hover:active:focus-visible,\nbutton.btn-primary:not(.disabled):hover:active:focus-visible,\n.btn-primary:not(.disabled):hover:active:focus-visible {\n  background: #071B38;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\na.btn-secondary,\nbutton.btn-secondary,\n.btn-secondary {\n  background: #FC495D;\n  border-color: transparent;\n  color: #ffffff;\n}\na.btn-secondary svg,\nbutton.btn-secondary svg,\n.btn-secondary svg {\n  display: block;\n  stroke: #ffffff;\n  fill: none;\n}\na.btn-secondary.focus,\nbutton.btn-secondary.focus,\n.btn-secondary.focus,\na.btn-secondary:focus,\nbutton.btn-secondary:focus,\n.btn-secondary:focus,\na.btn-secondary:focus-visible,\nbutton.btn-secondary:focus-visible,\n.btn-secondary:focus-visible {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #E62D42;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FED1D6;\n}\na.btn-secondary.active,\nbutton.btn-secondary.active,\n.btn-secondary.active,\na.btn-secondary:active,\nbutton.btn-secondary:active,\n.btn-secondary:active {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #E62D42;\n}\na.btn-secondary.active.focus,\nbutton.btn-secondary.active.focus,\n.btn-secondary.active.focus,\na.btn-secondary:active.focus,\nbutton.btn-secondary:active.focus,\n.btn-secondary:active.focus,\na.btn-secondary.active:focus,\nbutton.btn-secondary.active:focus,\n.btn-secondary.active:focus,\na.btn-secondary:active:focus,\nbutton.btn-secondary:active:focus,\n.btn-secondary:active:focus,\na.btn-secondary.active:focus-visible,\nbutton.btn-secondary.active:focus-visible,\n.btn-secondary.active:focus-visible,\na.btn-secondary:active:focus-visible,\nbutton.btn-secondary:active:focus-visible,\n.btn-secondary:active:focus-visible {\n  background: #E62D42;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FED1D6;\n}\na.btn-secondary.hover,\nbutton.btn-secondary.hover,\n.btn-secondary.hover,\na.btn-secondary:hover,\nbutton.btn-secondary:hover,\n.btn-secondary:hover {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #E62D42;\n}\na.btn-secondary.hover.active,\nbutton.btn-secondary.hover.active,\n.btn-secondary.hover.active,\na.btn-secondary:hover.active,\nbutton.btn-secondary:hover.active,\n.btn-secondary:hover.active,\na.btn-secondary.hover:active,\nbutton.btn-secondary.hover:active,\n.btn-secondary.hover:active,\na.btn-secondary:hover:active,\nbutton.btn-secondary:hover:active,\n.btn-secondary:hover:active {\n  border-color: transparent;\n  background: #E62D42;\n}\na.btn-secondary.hover.active.focus,\nbutton.btn-secondary.hover.active.focus,\n.btn-secondary.hover.active.focus,\na.btn-secondary:hover.active.focus,\nbutton.btn-secondary:hover.active.focus,\n.btn-secondary:hover.active.focus,\na.btn-secondary.hover:active.focus,\nbutton.btn-secondary.hover:active.focus,\n.btn-secondary.hover:active.focus,\na.btn-secondary:hover:active.focus,\nbutton.btn-secondary:hover:active.focus,\n.btn-secondary:hover:active.focus,\na.btn-secondary.hover.active:focus,\nbutton.btn-secondary.hover.active:focus,\n.btn-secondary.hover.active:focus,\na.btn-secondary:hover.active:focus,\nbutton.btn-secondary:hover.active:focus,\n.btn-secondary:hover.active:focus,\na.btn-secondary.hover:active:focus,\nbutton.btn-secondary.hover:active:focus,\n.btn-secondary.hover:active:focus,\na.btn-secondary:hover:active:focus,\nbutton.btn-secondary:hover:active:focus,\n.btn-secondary:hover:active:focus,\na.btn-secondary.hover.active:focus-visible,\nbutton.btn-secondary.hover.active:focus-visible,\n.btn-secondary.hover.active:focus-visible,\na.btn-secondary:hover.active:focus-visible,\nbutton.btn-secondary:hover.active:focus-visible,\n.btn-secondary:hover.active:focus-visible,\na.btn-secondary.hover:active:focus-visible,\nbutton.btn-secondary.hover:active:focus-visible,\n.btn-secondary.hover:active:focus-visible,\na.btn-secondary:hover:active:focus-visible,\nbutton.btn-secondary:hover:active:focus-visible,\n.btn-secondary:hover:active:focus-visible {\n  background: #E62D42;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FED1D6;\n}\na.btn-round,\nbutton.btn-round,\n.btn-round {\n  border-radius: 30px;\n}\na.btn-red,\nbutton.btn-red,\n.btn-red {\n  background: #FFEDEF;\n  color: #FC495D;\n}\na.btn-red svg,\nbutton.btn-red svg,\n.btn-red svg {\n  stroke: #FC495D;\n}\na.btn-red.focus,\nbutton.btn-red.focus,\n.btn-red.focus,\na.btn-red:focus,\nbutton.btn-red:focus,\n.btn-red:focus,\na.btn-red:focus-visible,\nbutton.btn-red:focus-visible,\n.btn-red:focus-visible {\n  color: #FC495D;\n  border: 1px solid transparent;\n  background: #FED1D6;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FFEDEF;\n}\na.btn-red.active,\nbutton.btn-red.active,\n.btn-red.active,\na.btn-red:active,\nbutton.btn-red:active,\n.btn-red:active {\n  color: #FC495D;\n  border: 1px solid transparent;\n  background: #FED1D6;\n}\na.btn-red.active.focus,\nbutton.btn-red.active.focus,\n.btn-red.active.focus,\na.btn-red:active.focus,\nbutton.btn-red:active.focus,\n.btn-red:active.focus,\na.btn-red.active:focus,\nbutton.btn-red.active:focus,\n.btn-red.active:focus,\na.btn-red:active:focus,\nbutton.btn-red:active:focus,\n.btn-red:active:focus,\na.btn-red.active:focus-visible,\nbutton.btn-red.active:focus-visible,\n.btn-red.active:focus-visible,\na.btn-red:active:focus-visible,\nbutton.btn-red:active:focus-visible,\n.btn-red:active:focus-visible {\n  background: #FED1D6;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FFEDEF;\n}\na.btn-red.hover,\nbutton.btn-red.hover,\n.btn-red.hover,\na.btn-red:hover,\nbutton.btn-red:hover,\n.btn-red:hover {\n  color: #FC495D;\n  border: 1px solid transparent;\n  background: #FED1D6;\n}\na.btn-red.hover.active,\nbutton.btn-red.hover.active,\n.btn-red.hover.active,\na.btn-red:hover.active,\nbutton.btn-red:hover.active,\n.btn-red:hover.active,\na.btn-red.hover:active,\nbutton.btn-red.hover:active,\n.btn-red.hover:active,\na.btn-red:hover:active,\nbutton.btn-red:hover:active,\n.btn-red:hover:active {\n  border-color: transparent;\n  background: #FED1D6;\n}\na.btn-red.hover.active.focus,\nbutton.btn-red.hover.active.focus,\n.btn-red.hover.active.focus,\na.btn-red:hover.active.focus,\nbutton.btn-red:hover.active.focus,\n.btn-red:hover.active.focus,\na.btn-red.hover:active.focus,\nbutton.btn-red.hover:active.focus,\n.btn-red.hover:active.focus,\na.btn-red:hover:active.focus,\nbutton.btn-red:hover:active.focus,\n.btn-red:hover:active.focus,\na.btn-red.hover.active:focus,\nbutton.btn-red.hover.active:focus,\n.btn-red.hover.active:focus,\na.btn-red:hover.active:focus,\nbutton.btn-red:hover.active:focus,\n.btn-red:hover.active:focus,\na.btn-red.hover:active:focus,\nbutton.btn-red.hover:active:focus,\n.btn-red.hover:active:focus,\na.btn-red:hover:active:focus,\nbutton.btn-red:hover:active:focus,\n.btn-red:hover:active:focus,\na.btn-red.hover.active:focus-visible,\nbutton.btn-red.hover.active:focus-visible,\n.btn-red.hover.active:focus-visible,\na.btn-red:hover.active:focus-visible,\nbutton.btn-red:hover.active:focus-visible,\n.btn-red:hover.active:focus-visible,\na.btn-red.hover:active:focus-visible,\nbutton.btn-red.hover:active:focus-visible,\n.btn-red.hover:active:focus-visible,\na.btn-red:hover:active:focus-visible,\nbutton.btn-red:hover:active:focus-visible,\n.btn-red:hover:active:focus-visible {\n  background: #FED1D6;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FFEDEF;\n}\na.btn-green,\nbutton.btn-green,\n.btn-green {\n  background: #F0F9F1;\n  color: #73C677;\n}\na.btn-green svg,\nbutton.btn-green svg,\n.btn-green svg {\n  stroke: #73C677;\n}\na.btn-green.focus,\nbutton.btn-green.focus,\n.btn-green.focus,\na.btn-green:focus,\nbutton.btn-green:focus,\n.btn-green:focus,\na.btn-green:focus-visible,\nbutton.btn-green:focus-visible,\n.btn-green:focus-visible {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #DCF1DE;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #F0F9F1;\n}\na.btn-green.active,\nbutton.btn-green.active,\n.btn-green.active,\na.btn-green:active,\nbutton.btn-green:active,\n.btn-green:active {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #DCF1DE;\n}\na.btn-green.active.focus,\nbutton.btn-green.active.focus,\n.btn-green.active.focus,\na.btn-green:active.focus,\nbutton.btn-green:active.focus,\n.btn-green:active.focus,\na.btn-green.active:focus,\nbutton.btn-green.active:focus,\n.btn-green.active:focus,\na.btn-green:active:focus,\nbutton.btn-green:active:focus,\n.btn-green:active:focus,\na.btn-green.active:focus-visible,\nbutton.btn-green.active:focus-visible,\n.btn-green.active:focus-visible,\na.btn-green:active:focus-visible,\nbutton.btn-green:active:focus-visible,\n.btn-green:active:focus-visible {\n  background: #DCF1DE;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #F0F9F1;\n}\na.btn-green.hover,\nbutton.btn-green.hover,\n.btn-green.hover,\na.btn-green:hover,\nbutton.btn-green:hover,\n.btn-green:hover {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #DCF1DE;\n}\na.btn-green.hover.active,\nbutton.btn-green.hover.active,\n.btn-green.hover.active,\na.btn-green:hover.active,\nbutton.btn-green:hover.active,\n.btn-green:hover.active,\na.btn-green.hover:active,\nbutton.btn-green.hover:active,\n.btn-green.hover:active,\na.btn-green:hover:active,\nbutton.btn-green:hover:active,\n.btn-green:hover:active {\n  border-color: transparent;\n  background: #DCF1DE;\n}\na.btn-green.hover.active.focus,\nbutton.btn-green.hover.active.focus,\n.btn-green.hover.active.focus,\na.btn-green:hover.active.focus,\nbutton.btn-green:hover.active.focus,\n.btn-green:hover.active.focus,\na.btn-green.hover:active.focus,\nbutton.btn-green.hover:active.focus,\n.btn-green.hover:active.focus,\na.btn-green:hover:active.focus,\nbutton.btn-green:hover:active.focus,\n.btn-green:hover:active.focus,\na.btn-green.hover.active:focus,\nbutton.btn-green.hover.active:focus,\n.btn-green.hover.active:focus,\na.btn-green:hover.active:focus,\nbutton.btn-green:hover.active:focus,\n.btn-green:hover.active:focus,\na.btn-green.hover:active:focus,\nbutton.btn-green.hover:active:focus,\n.btn-green.hover:active:focus,\na.btn-green:hover:active:focus,\nbutton.btn-green:hover:active:focus,\n.btn-green:hover:active:focus,\na.btn-green.hover.active:focus-visible,\nbutton.btn-green.hover.active:focus-visible,\n.btn-green.hover.active:focus-visible,\na.btn-green:hover.active:focus-visible,\nbutton.btn-green:hover.active:focus-visible,\n.btn-green:hover.active:focus-visible,\na.btn-green.hover:active:focus-visible,\nbutton.btn-green.hover:active:focus-visible,\n.btn-green.hover:active:focus-visible,\na.btn-green:hover:active:focus-visible,\nbutton.btn-green:hover:active:focus-visible,\n.btn-green:hover:active:focus-visible {\n  background: #DCF1DE;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #F0F9F1;\n}\na.btn-blue,\nbutton.btn-blue,\n.btn-blue {\n  background: #EFFBFD;\n  color: #34BFDE;\n}\na.btn-blue svg,\nbutton.btn-blue svg,\n.btn-blue svg {\n  stroke: #73C677;\n}\na.btn-blue.focus,\nbutton.btn-blue.focus,\n.btn-blue.focus,\na.btn-blue:focus,\nbutton.btn-blue:focus,\n.btn-blue:focus,\na.btn-blue:focus-visible,\nbutton.btn-blue:focus-visible,\n.btn-blue:focus-visible {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #D7F4FA;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #EFFBFD;\n}\na.btn-blue.active,\nbutton.btn-blue.active,\n.btn-blue.active,\na.btn-blue:active,\nbutton.btn-blue:active,\n.btn-blue:active {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #D7F4FA;\n}\na.btn-blue.active.focus,\nbutton.btn-blue.active.focus,\n.btn-blue.active.focus,\na.btn-blue:active.focus,\nbutton.btn-blue:active.focus,\n.btn-blue:active.focus,\na.btn-blue.active:focus,\nbutton.btn-blue.active:focus,\n.btn-blue.active:focus,\na.btn-blue:active:focus,\nbutton.btn-blue:active:focus,\n.btn-blue:active:focus,\na.btn-blue.active:focus-visible,\nbutton.btn-blue.active:focus-visible,\n.btn-blue.active:focus-visible,\na.btn-blue:active:focus-visible,\nbutton.btn-blue:active:focus-visible,\n.btn-blue:active:focus-visible {\n  background: #D7F4FA;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #EFFBFD;\n}\na.btn-blue.hover,\nbutton.btn-blue.hover,\n.btn-blue.hover,\na.btn-blue:hover,\nbutton.btn-blue:hover,\n.btn-blue:hover {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #D7F4FA;\n}\na.btn-blue.hover.active,\nbutton.btn-blue.hover.active,\n.btn-blue.hover.active,\na.btn-blue:hover.active,\nbutton.btn-blue:hover.active,\n.btn-blue:hover.active,\na.btn-blue.hover:active,\nbutton.btn-blue.hover:active,\n.btn-blue.hover:active,\na.btn-blue:hover:active,\nbutton.btn-blue:hover:active,\n.btn-blue:hover:active {\n  border-color: transparent;\n  background: #D7F4FA;\n}\na.btn-blue.hover.active.focus,\nbutton.btn-blue.hover.active.focus,\n.btn-blue.hover.active.focus,\na.btn-blue:hover.active.focus,\nbutton.btn-blue:hover.active.focus,\n.btn-blue:hover.active.focus,\na.btn-blue.hover:active.focus,\nbutton.btn-blue.hover:active.focus,\n.btn-blue.hover:active.focus,\na.btn-blue:hover:active.focus,\nbutton.btn-blue:hover:active.focus,\n.btn-blue:hover:active.focus,\na.btn-blue.hover.active:focus,\nbutton.btn-blue.hover.active:focus,\n.btn-blue.hover.active:focus,\na.btn-blue:hover.active:focus,\nbutton.btn-blue:hover.active:focus,\n.btn-blue:hover.active:focus,\na.btn-blue.hover:active:focus,\nbutton.btn-blue.hover:active:focus,\n.btn-blue.hover:active:focus,\na.btn-blue:hover:active:focus,\nbutton.btn-blue:hover:active:focus,\n.btn-blue:hover:active:focus,\na.btn-blue.hover.active:focus-visible,\nbutton.btn-blue.hover.active:focus-visible,\n.btn-blue.hover.active:focus-visible,\na.btn-blue:hover.active:focus-visible,\nbutton.btn-blue:hover.active:focus-visible,\n.btn-blue:hover.active:focus-visible,\na.btn-blue.hover:active:focus-visible,\nbutton.btn-blue.hover:active:focus-visible,\n.btn-blue.hover:active:focus-visible,\na.btn-blue:hover:active:focus-visible,\nbutton.btn-blue:hover:active:focus-visible,\n.btn-blue:hover:active:focus-visible {\n  background: #D7F4FA;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #EFFBFD;\n}\na.btn-none,\nbutton.btn-none,\n.btn-none {\n  background: transparent;\n  color: #70859E;\n}\na.btn-none svg,\nbutton.btn-none svg,\n.btn-none svg {\n  stroke: #10294D;\n}\na.btn-none.focus,\nbutton.btn-none.focus,\n.btn-none.focus,\na.btn-none:focus,\nbutton.btn-none:focus,\n.btn-none:focus,\na.btn-none:focus-visible,\nbutton.btn-none:focus-visible,\n.btn-none:focus-visible {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\na.btn-none.active,\nbutton.btn-none.active,\n.btn-none.active,\na.btn-none:active,\nbutton.btn-none:active,\n.btn-none:active {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\na.btn-none.active.focus,\nbutton.btn-none.active.focus,\n.btn-none.active.focus,\na.btn-none:active.focus,\nbutton.btn-none:active.focus,\n.btn-none:active.focus,\na.btn-none.active:focus,\nbutton.btn-none.active:focus,\n.btn-none.active:focus,\na.btn-none:active:focus,\nbutton.btn-none:active:focus,\n.btn-none:active:focus,\na.btn-none.active:focus-visible,\nbutton.btn-none.active:focus-visible,\n.btn-none.active:focus-visible,\na.btn-none:active:focus-visible,\nbutton.btn-none:active:focus-visible,\n.btn-none:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\na.btn-none.hover,\nbutton.btn-none.hover,\n.btn-none.hover,\na.btn-none:hover,\nbutton.btn-none:hover,\n.btn-none:hover {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\na.btn-none.hover.active,\nbutton.btn-none.hover.active,\n.btn-none.hover.active,\na.btn-none:hover.active,\nbutton.btn-none:hover.active,\n.btn-none:hover.active,\na.btn-none.hover:active,\nbutton.btn-none.hover:active,\n.btn-none.hover:active,\na.btn-none:hover:active,\nbutton.btn-none:hover:active,\n.btn-none:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\na.btn-none.hover.active.focus,\nbutton.btn-none.hover.active.focus,\n.btn-none.hover.active.focus,\na.btn-none:hover.active.focus,\nbutton.btn-none:hover.active.focus,\n.btn-none:hover.active.focus,\na.btn-none.hover:active.focus,\nbutton.btn-none.hover:active.focus,\n.btn-none.hover:active.focus,\na.btn-none:hover:active.focus,\nbutton.btn-none:hover:active.focus,\n.btn-none:hover:active.focus,\na.btn-none.hover.active:focus,\nbutton.btn-none.hover.active:focus,\n.btn-none.hover.active:focus,\na.btn-none:hover.active:focus,\nbutton.btn-none:hover.active:focus,\n.btn-none:hover.active:focus,\na.btn-none.hover:active:focus,\nbutton.btn-none.hover:active:focus,\n.btn-none.hover:active:focus,\na.btn-none:hover:active:focus,\nbutton.btn-none:hover:active:focus,\n.btn-none:hover:active:focus,\na.btn-none.hover.active:focus-visible,\nbutton.btn-none.hover.active:focus-visible,\n.btn-none.hover.active:focus-visible,\na.btn-none:hover.active:focus-visible,\nbutton.btn-none:hover.active:focus-visible,\n.btn-none:hover.active:focus-visible,\na.btn-none.hover:active:focus-visible,\nbutton.btn-none.hover:active:focus-visible,\n.btn-none.hover:active:focus-visible,\na.btn-none:hover:active:focus-visible,\nbutton.btn-none:hover:active:focus-visible,\n.btn-none:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\na.btn-none-red,\nbutton.btn-none-red,\n.btn-none-red {\n  background: transparent;\n  color: #70859E;\n}\na.btn-none-red svg,\nbutton.btn-none-red svg,\n.btn-none-red svg {\n  stroke: #FC495D;\n}\na.btn-none-red.focus,\nbutton.btn-none-red.focus,\n.btn-none-red.focus,\na.btn-none-red:focus,\nbutton.btn-none-red:focus,\n.btn-none-red:focus,\na.btn-none-red:focus-visible,\nbutton.btn-none-red:focus-visible,\n.btn-none-red:focus-visible {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\na.btn-none-red.active,\nbutton.btn-none-red.active,\n.btn-none-red.active,\na.btn-none-red:active,\nbutton.btn-none-red:active,\n.btn-none-red:active {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\na.btn-none-red.active.focus,\nbutton.btn-none-red.active.focus,\n.btn-none-red.active.focus,\na.btn-none-red:active.focus,\nbutton.btn-none-red:active.focus,\n.btn-none-red:active.focus,\na.btn-none-red.active:focus,\nbutton.btn-none-red.active:focus,\n.btn-none-red.active:focus,\na.btn-none-red:active:focus,\nbutton.btn-none-red:active:focus,\n.btn-none-red:active:focus,\na.btn-none-red.active:focus-visible,\nbutton.btn-none-red.active:focus-visible,\n.btn-none-red.active:focus-visible,\na.btn-none-red:active:focus-visible,\nbutton.btn-none-red:active:focus-visible,\n.btn-none-red:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\na.btn-none-red.hover,\nbutton.btn-none-red.hover,\n.btn-none-red.hover,\na.btn-none-red:hover,\nbutton.btn-none-red:hover,\n.btn-none-red:hover {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\na.btn-none-red.hover.active,\nbutton.btn-none-red.hover.active,\n.btn-none-red.hover.active,\na.btn-none-red:hover.active,\nbutton.btn-none-red:hover.active,\n.btn-none-red:hover.active,\na.btn-none-red.hover:active,\nbutton.btn-none-red.hover:active,\n.btn-none-red.hover:active,\na.btn-none-red:hover:active,\nbutton.btn-none-red:hover:active,\n.btn-none-red:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\na.btn-none-red.hover.active.focus,\nbutton.btn-none-red.hover.active.focus,\n.btn-none-red.hover.active.focus,\na.btn-none-red:hover.active.focus,\nbutton.btn-none-red:hover.active.focus,\n.btn-none-red:hover.active.focus,\na.btn-none-red.hover:active.focus,\nbutton.btn-none-red.hover:active.focus,\n.btn-none-red.hover:active.focus,\na.btn-none-red:hover:active.focus,\nbutton.btn-none-red:hover:active.focus,\n.btn-none-red:hover:active.focus,\na.btn-none-red.hover.active:focus,\nbutton.btn-none-red.hover.active:focus,\n.btn-none-red.hover.active:focus,\na.btn-none-red:hover.active:focus,\nbutton.btn-none-red:hover.active:focus,\n.btn-none-red:hover.active:focus,\na.btn-none-red.hover:active:focus,\nbutton.btn-none-red.hover:active:focus,\n.btn-none-red.hover:active:focus,\na.btn-none-red:hover:active:focus,\nbutton.btn-none-red:hover:active:focus,\n.btn-none-red:hover:active:focus,\na.btn-none-red.hover.active:focus-visible,\nbutton.btn-none-red.hover.active:focus-visible,\n.btn-none-red.hover.active:focus-visible,\na.btn-none-red:hover.active:focus-visible,\nbutton.btn-none-red:hover.active:focus-visible,\n.btn-none-red:hover.active:focus-visible,\na.btn-none-red.hover:active:focus-visible,\nbutton.btn-none-red.hover:active:focus-visible,\n.btn-none-red.hover:active:focus-visible,\na.btn-none-red:hover:active:focus-visible,\nbutton.btn-none-red:hover:active:focus-visible,\n.btn-none-red:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\na.btn-subtle,\nbutton.btn-subtle,\n.btn-subtle {\n  background: transparent;\n  border: 1px solid #E5EBF1;\n  color: #10294D;\n}\na.btn-subtle svg,\nbutton.btn-subtle svg,\n.btn-subtle svg {\n  stroke: #10294D;\n}\na.btn-subtle.focus,\nbutton.btn-subtle.focus,\n.btn-subtle.focus,\na.btn-subtle:focus,\nbutton.btn-subtle:focus,\n.btn-subtle:focus,\na.btn-subtle:focus-visible,\nbutton.btn-subtle:focus-visible,\n.btn-subtle:focus-visible {\n  color: #071B38;\n  border: 1px solid #CED7E2;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\na.btn-subtle.active,\nbutton.btn-subtle.active,\n.btn-subtle.active,\na.btn-subtle:active,\nbutton.btn-subtle:active,\n.btn-subtle:active {\n  color: #071B38;\n  border: 1px solid #CED7E2;\n  background: transparent;\n}\na.btn-subtle.active.focus,\nbutton.btn-subtle.active.focus,\n.btn-subtle.active.focus,\na.btn-subtle:active.focus,\nbutton.btn-subtle:active.focus,\n.btn-subtle:active.focus,\na.btn-subtle.active:focus,\nbutton.btn-subtle.active:focus,\n.btn-subtle.active:focus,\na.btn-subtle:active:focus,\nbutton.btn-subtle:active:focus,\n.btn-subtle:active:focus,\na.btn-subtle.active:focus-visible,\nbutton.btn-subtle.active:focus-visible,\n.btn-subtle.active:focus-visible,\na.btn-subtle:active:focus-visible,\nbutton.btn-subtle:active:focus-visible,\n.btn-subtle:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\na.btn-subtle.hover,\nbutton.btn-subtle.hover,\n.btn-subtle.hover,\na.btn-subtle:hover,\nbutton.btn-subtle:hover,\n.btn-subtle:hover {\n  color: #071B38;\n  border: 1px solid #CED7E2;\n  background: transparent;\n}\na.btn-subtle.hover.active,\nbutton.btn-subtle.hover.active,\n.btn-subtle.hover.active,\na.btn-subtle:hover.active,\nbutton.btn-subtle:hover.active,\n.btn-subtle:hover.active,\na.btn-subtle.hover:active,\nbutton.btn-subtle.hover:active,\n.btn-subtle.hover:active,\na.btn-subtle:hover:active,\nbutton.btn-subtle:hover:active,\n.btn-subtle:hover:active {\n  border-color: #CED7E2;\n  background: transparent;\n}\na.btn-subtle.hover.active.focus,\nbutton.btn-subtle.hover.active.focus,\n.btn-subtle.hover.active.focus,\na.btn-subtle:hover.active.focus,\nbutton.btn-subtle:hover.active.focus,\n.btn-subtle:hover.active.focus,\na.btn-subtle.hover:active.focus,\nbutton.btn-subtle.hover:active.focus,\n.btn-subtle.hover:active.focus,\na.btn-subtle:hover:active.focus,\nbutton.btn-subtle:hover:active.focus,\n.btn-subtle:hover:active.focus,\na.btn-subtle.hover.active:focus,\nbutton.btn-subtle.hover.active:focus,\n.btn-subtle.hover.active:focus,\na.btn-subtle:hover.active:focus,\nbutton.btn-subtle:hover.active:focus,\n.btn-subtle:hover.active:focus,\na.btn-subtle.hover:active:focus,\nbutton.btn-subtle.hover:active:focus,\n.btn-subtle.hover:active:focus,\na.btn-subtle:hover:active:focus,\nbutton.btn-subtle:hover:active:focus,\n.btn-subtle:hover:active:focus,\na.btn-subtle.hover.active:focus-visible,\nbutton.btn-subtle.hover.active:focus-visible,\n.btn-subtle.hover.active:focus-visible,\na.btn-subtle:hover.active:focus-visible,\nbutton.btn-subtle:hover.active:focus-visible,\n.btn-subtle:hover.active:focus-visible,\na.btn-subtle.hover:active:focus-visible,\nbutton.btn-subtle.hover:active:focus-visible,\n.btn-subtle.hover:active:focus-visible,\na.btn-subtle:hover:active:focus-visible,\nbutton.btn-subtle:hover:active:focus-visible,\n.btn-subtle:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\na.btn-text,\nbutton.btn-text,\n.btn-text {\n  background: transparent;\n  color: #10294D;\n}\na.btn-text svg,\nbutton.btn-text svg,\n.btn-text svg {\n  stroke: #CED7E2;\n}\na.btn-text.focus,\nbutton.btn-text.focus,\n.btn-text.focus,\na.btn-text:focus,\nbutton.btn-text:focus,\n.btn-text:focus,\na.btn-text:focus-visible,\nbutton.btn-text:focus-visible,\n.btn-text:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\na.btn-text.active,\nbutton.btn-text.active,\n.btn-text.active,\na.btn-text:active,\nbutton.btn-text:active,\n.btn-text:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\na.btn-text.active.focus,\nbutton.btn-text.active.focus,\n.btn-text.active.focus,\na.btn-text:active.focus,\nbutton.btn-text:active.focus,\n.btn-text:active.focus,\na.btn-text.active:focus,\nbutton.btn-text.active:focus,\n.btn-text.active:focus,\na.btn-text:active:focus,\nbutton.btn-text:active:focus,\n.btn-text:active:focus,\na.btn-text.active:focus-visible,\nbutton.btn-text.active:focus-visible,\n.btn-text.active:focus-visible,\na.btn-text:active:focus-visible,\nbutton.btn-text:active:focus-visible,\n.btn-text:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\na.btn-text.hover,\nbutton.btn-text.hover,\n.btn-text.hover,\na.btn-text:hover,\nbutton.btn-text:hover,\n.btn-text:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\na.btn-text.hover.active,\nbutton.btn-text.hover.active,\n.btn-text.hover.active,\na.btn-text:hover.active,\nbutton.btn-text:hover.active,\n.btn-text:hover.active,\na.btn-text.hover:active,\nbutton.btn-text.hover:active,\n.btn-text.hover:active,\na.btn-text:hover:active,\nbutton.btn-text:hover:active,\n.btn-text:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\na.btn-text.hover.active.focus,\nbutton.btn-text.hover.active.focus,\n.btn-text.hover.active.focus,\na.btn-text:hover.active.focus,\nbutton.btn-text:hover.active.focus,\n.btn-text:hover.active.focus,\na.btn-text.hover:active.focus,\nbutton.btn-text.hover:active.focus,\n.btn-text.hover:active.focus,\na.btn-text:hover:active.focus,\nbutton.btn-text:hover:active.focus,\n.btn-text:hover:active.focus,\na.btn-text.hover.active:focus,\nbutton.btn-text.hover.active:focus,\n.btn-text.hover.active:focus,\na.btn-text:hover.active:focus,\nbutton.btn-text:hover.active:focus,\n.btn-text:hover.active:focus,\na.btn-text.hover:active:focus,\nbutton.btn-text.hover:active:focus,\n.btn-text.hover:active:focus,\na.btn-text:hover:active:focus,\nbutton.btn-text:hover:active:focus,\n.btn-text:hover:active:focus,\na.btn-text.hover.active:focus-visible,\nbutton.btn-text.hover.active:focus-visible,\n.btn-text.hover.active:focus-visible,\na.btn-text:hover.active:focus-visible,\nbutton.btn-text:hover.active:focus-visible,\n.btn-text:hover.active:focus-visible,\na.btn-text.hover:active:focus-visible,\nbutton.btn-text.hover:active:focus-visible,\n.btn-text.hover:active:focus-visible,\na.btn-text:hover:active:focus-visible,\nbutton.btn-text:hover:active:focus-visible,\n.btn-text:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\na.btn-text-only,\nbutton.btn-text-only,\n.btn-text-only {\n  padding: 0;\n  background: transparent;\n  color: #10294D;\n}\na.btn-text-only svg,\nbutton.btn-text-only svg,\n.btn-text-only svg {\n  stroke: #CED7E2;\n}\na.btn-text-only.focus,\nbutton.btn-text-only.focus,\n.btn-text-only.focus,\na.btn-text-only:focus,\nbutton.btn-text-only:focus,\n.btn-text-only:focus,\na.btn-text-only:focus-visible,\nbutton.btn-text-only:focus-visible,\n.btn-text-only:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\na.btn-text-only.active,\nbutton.btn-text-only.active,\n.btn-text-only.active,\na.btn-text-only:active,\nbutton.btn-text-only:active,\n.btn-text-only:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\na.btn-text-only.active.focus,\nbutton.btn-text-only.active.focus,\n.btn-text-only.active.focus,\na.btn-text-only:active.focus,\nbutton.btn-text-only:active.focus,\n.btn-text-only:active.focus,\na.btn-text-only.active:focus,\nbutton.btn-text-only.active:focus,\n.btn-text-only.active:focus,\na.btn-text-only:active:focus,\nbutton.btn-text-only:active:focus,\n.btn-text-only:active:focus,\na.btn-text-only.active:focus-visible,\nbutton.btn-text-only.active:focus-visible,\n.btn-text-only.active:focus-visible,\na.btn-text-only:active:focus-visible,\nbutton.btn-text-only:active:focus-visible,\n.btn-text-only:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\na.btn-text-only.hover,\nbutton.btn-text-only.hover,\n.btn-text-only.hover,\na.btn-text-only:hover,\nbutton.btn-text-only:hover,\n.btn-text-only:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\na.btn-text-only.hover.active,\nbutton.btn-text-only.hover.active,\n.btn-text-only.hover.active,\na.btn-text-only:hover.active,\nbutton.btn-text-only:hover.active,\n.btn-text-only:hover.active,\na.btn-text-only.hover:active,\nbutton.btn-text-only.hover:active,\n.btn-text-only.hover:active,\na.btn-text-only:hover:active,\nbutton.btn-text-only:hover:active,\n.btn-text-only:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\na.btn-text-only.hover.active.focus,\nbutton.btn-text-only.hover.active.focus,\n.btn-text-only.hover.active.focus,\na.btn-text-only:hover.active.focus,\nbutton.btn-text-only:hover.active.focus,\n.btn-text-only:hover.active.focus,\na.btn-text-only.hover:active.focus,\nbutton.btn-text-only.hover:active.focus,\n.btn-text-only.hover:active.focus,\na.btn-text-only:hover:active.focus,\nbutton.btn-text-only:hover:active.focus,\n.btn-text-only:hover:active.focus,\na.btn-text-only.hover.active:focus,\nbutton.btn-text-only.hover.active:focus,\n.btn-text-only.hover.active:focus,\na.btn-text-only:hover.active:focus,\nbutton.btn-text-only:hover.active:focus,\n.btn-text-only:hover.active:focus,\na.btn-text-only.hover:active:focus,\nbutton.btn-text-only.hover:active:focus,\n.btn-text-only.hover:active:focus,\na.btn-text-only:hover:active:focus,\nbutton.btn-text-only:hover:active:focus,\n.btn-text-only:hover:active:focus,\na.btn-text-only.hover.active:focus-visible,\nbutton.btn-text-only.hover.active:focus-visible,\n.btn-text-only.hover.active:focus-visible,\na.btn-text-only:hover.active:focus-visible,\nbutton.btn-text-only:hover.active:focus-visible,\n.btn-text-only:hover.active:focus-visible,\na.btn-text-only.hover:active:focus-visible,\nbutton.btn-text-only.hover:active:focus-visible,\n.btn-text-only.hover:active:focus-visible,\na.btn-text-only:hover:active:focus-visible,\nbutton.btn-text-only:hover:active:focus-visible,\n.btn-text-only:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\na.btn-grey,\nbutton.btn-grey,\n.btn-grey {\n  background: #E5EBF1;\n  color: #10294D;\n}\na.btn-grey svg,\nbutton.btn-grey svg,\n.btn-grey svg {\n  stroke: #10294D;\n}\na.btn-grey.input-group-addon,\nbutton.btn-grey.input-group-addon,\n.btn-grey.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n  background: #E5EBF1;\n  color: #10294D;\n}\na.btn-grey.input-group-addon svg,\nbutton.btn-grey.input-group-addon svg,\n.btn-grey.input-group-addon svg {\n  stroke: #10294D;\n}\na.btn-grey.focus,\nbutton.btn-grey.focus,\n.btn-grey.focus,\na.btn-grey:focus,\nbutton.btn-grey:focus,\n.btn-grey:focus,\na.btn-grey:focus-visible,\nbutton.btn-grey:focus-visible,\n.btn-grey:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\na.btn-grey.active,\nbutton.btn-grey.active,\n.btn-grey.active,\na.btn-grey:active,\nbutton.btn-grey:active,\n.btn-grey:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\na.btn-grey.active.focus,\nbutton.btn-grey.active.focus,\n.btn-grey.active.focus,\na.btn-grey:active.focus,\nbutton.btn-grey:active.focus,\n.btn-grey:active.focus,\na.btn-grey.active:focus,\nbutton.btn-grey.active:focus,\n.btn-grey.active:focus,\na.btn-grey:active:focus,\nbutton.btn-grey:active:focus,\n.btn-grey:active:focus,\na.btn-grey.active:focus-visible,\nbutton.btn-grey.active:focus-visible,\n.btn-grey.active:focus-visible,\na.btn-grey:active:focus-visible,\nbutton.btn-grey:active:focus-visible,\n.btn-grey:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\na.btn-grey.hover,\nbutton.btn-grey.hover,\n.btn-grey.hover,\na.btn-grey:hover,\nbutton.btn-grey:hover,\n.btn-grey:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\na.btn-grey.hover.active,\nbutton.btn-grey.hover.active,\n.btn-grey.hover.active,\na.btn-grey:hover.active,\nbutton.btn-grey:hover.active,\n.btn-grey:hover.active,\na.btn-grey.hover:active,\nbutton.btn-grey.hover:active,\n.btn-grey.hover:active,\na.btn-grey:hover:active,\nbutton.btn-grey:hover:active,\n.btn-grey:hover:active {\n  border-color: transparent;\n  background: #CED7E2;\n}\na.btn-grey.hover.active.focus,\nbutton.btn-grey.hover.active.focus,\n.btn-grey.hover.active.focus,\na.btn-grey:hover.active.focus,\nbutton.btn-grey:hover.active.focus,\n.btn-grey:hover.active.focus,\na.btn-grey.hover:active.focus,\nbutton.btn-grey.hover:active.focus,\n.btn-grey.hover:active.focus,\na.btn-grey:hover:active.focus,\nbutton.btn-grey:hover:active.focus,\n.btn-grey:hover:active.focus,\na.btn-grey.hover.active:focus,\nbutton.btn-grey.hover.active:focus,\n.btn-grey.hover.active:focus,\na.btn-grey:hover.active:focus,\nbutton.btn-grey:hover.active:focus,\n.btn-grey:hover.active:focus,\na.btn-grey.hover:active:focus,\nbutton.btn-grey.hover:active:focus,\n.btn-grey.hover:active:focus,\na.btn-grey:hover:active:focus,\nbutton.btn-grey:hover:active:focus,\n.btn-grey:hover:active:focus,\na.btn-grey.hover.active:focus-visible,\nbutton.btn-grey.hover.active:focus-visible,\n.btn-grey.hover.active:focus-visible,\na.btn-grey:hover.active:focus-visible,\nbutton.btn-grey:hover.active:focus-visible,\n.btn-grey:hover.active:focus-visible,\na.btn-grey.hover:active:focus-visible,\nbutton.btn-grey.hover:active:focus-visible,\n.btn-grey.hover:active:focus-visible,\na.btn-grey:hover:active:focus-visible,\nbutton.btn-grey:hover:active:focus-visible,\n.btn-grey:hover:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\na.btn-grey-50,\nbutton.btn-grey-50,\n.btn-grey-50 {\n  background: #F3F5F8;\n  color: #10294D;\n}\na.btn-grey-50 svg,\nbutton.btn-grey-50 svg,\n.btn-grey-50 svg {\n  stroke: #10294D;\n}\na.btn-grey-50.input-group-addon,\nbutton.btn-grey-50.input-group-addon,\n.btn-grey-50.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n  background: #F3F5F8;\n  color: #10294D;\n}\na.btn-grey-50.input-group-addon svg,\nbutton.btn-grey-50.input-group-addon svg,\n.btn-grey-50.input-group-addon svg {\n  stroke: #10294D;\n}\na.btn-grey-50.focus,\nbutton.btn-grey-50.focus,\n.btn-grey-50.focus,\na.btn-grey-50:focus,\nbutton.btn-grey-50:focus,\n.btn-grey-50:focus,\na.btn-grey-50:focus-visible,\nbutton.btn-grey-50:focus-visible,\n.btn-grey-50:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\na.btn-grey-50.active,\nbutton.btn-grey-50.active,\n.btn-grey-50.active,\na.btn-grey-50:active,\nbutton.btn-grey-50:active,\n.btn-grey-50:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\na.btn-grey-50.active.focus,\nbutton.btn-grey-50.active.focus,\n.btn-grey-50.active.focus,\na.btn-grey-50:active.focus,\nbutton.btn-grey-50:active.focus,\n.btn-grey-50:active.focus,\na.btn-grey-50.active:focus,\nbutton.btn-grey-50.active:focus,\n.btn-grey-50.active:focus,\na.btn-grey-50:active:focus,\nbutton.btn-grey-50:active:focus,\n.btn-grey-50:active:focus,\na.btn-grey-50.active:focus-visible,\nbutton.btn-grey-50.active:focus-visible,\n.btn-grey-50.active:focus-visible,\na.btn-grey-50:active:focus-visible,\nbutton.btn-grey-50:active:focus-visible,\n.btn-grey-50:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\na.btn-grey-50.hover,\nbutton.btn-grey-50.hover,\n.btn-grey-50.hover,\na.btn-grey-50:hover,\nbutton.btn-grey-50:hover,\n.btn-grey-50:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\na.btn-grey-50.hover.active,\nbutton.btn-grey-50.hover.active,\n.btn-grey-50.hover.active,\na.btn-grey-50:hover.active,\nbutton.btn-grey-50:hover.active,\n.btn-grey-50:hover.active,\na.btn-grey-50.hover:active,\nbutton.btn-grey-50.hover:active,\n.btn-grey-50.hover:active,\na.btn-grey-50:hover:active,\nbutton.btn-grey-50:hover:active,\n.btn-grey-50:hover:active {\n  border-color: transparent;\n  background: #E5EBF1;\n}\na.btn-grey-50.hover.active.focus,\nbutton.btn-grey-50.hover.active.focus,\n.btn-grey-50.hover.active.focus,\na.btn-grey-50:hover.active.focus,\nbutton.btn-grey-50:hover.active.focus,\n.btn-grey-50:hover.active.focus,\na.btn-grey-50.hover:active.focus,\nbutton.btn-grey-50.hover:active.focus,\n.btn-grey-50.hover:active.focus,\na.btn-grey-50:hover:active.focus,\nbutton.btn-grey-50:hover:active.focus,\n.btn-grey-50:hover:active.focus,\na.btn-grey-50.hover.active:focus,\nbutton.btn-grey-50.hover.active:focus,\n.btn-grey-50.hover.active:focus,\na.btn-grey-50:hover.active:focus,\nbutton.btn-grey-50:hover.active:focus,\n.btn-grey-50:hover.active:focus,\na.btn-grey-50.hover:active:focus,\nbutton.btn-grey-50.hover:active:focus,\n.btn-grey-50.hover:active:focus,\na.btn-grey-50:hover:active:focus,\nbutton.btn-grey-50:hover:active:focus,\n.btn-grey-50:hover:active:focus,\na.btn-grey-50.hover.active:focus-visible,\nbutton.btn-grey-50.hover.active:focus-visible,\n.btn-grey-50.hover.active:focus-visible,\na.btn-grey-50:hover.active:focus-visible,\nbutton.btn-grey-50:hover.active:focus-visible,\n.btn-grey-50:hover.active:focus-visible,\na.btn-grey-50.hover:active:focus-visible,\nbutton.btn-grey-50.hover:active:focus-visible,\n.btn-grey-50.hover:active:focus-visible,\na.btn-grey-50:hover:active:focus-visible,\nbutton.btn-grey-50:hover:active:focus-visible,\n.btn-grey-50:hover:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\na.btn-white,\nbutton.btn-white,\n.btn-white {\n  background: #ffffff;\n  color: #10294D;\n}\na.btn-white svg,\nbutton.btn-white svg,\n.btn-white svg {\n  stroke: #CED7E2;\n}\na.btn-white.input-group-addon,\nbutton.btn-white.input-group-addon,\n.btn-white.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n  background: #E5EBF1;\n  color: #10294D;\n}\na.btn-white.input-group-addon svg,\nbutton.btn-white.input-group-addon svg,\n.btn-white.input-group-addon svg {\n  stroke: #CED7E2;\n}\na.btn-white.focus,\nbutton.btn-white.focus,\n.btn-white.focus,\na.btn-white:focus,\nbutton.btn-white:focus,\n.btn-white:focus,\na.btn-white:focus-visible,\nbutton.btn-white:focus-visible,\n.btn-white:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\na.btn-white.active,\nbutton.btn-white.active,\n.btn-white.active,\na.btn-white:active,\nbutton.btn-white:active,\n.btn-white:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\na.btn-white.active.focus,\nbutton.btn-white.active.focus,\n.btn-white.active.focus,\na.btn-white:active.focus,\nbutton.btn-white:active.focus,\n.btn-white:active.focus,\na.btn-white.active:focus,\nbutton.btn-white.active:focus,\n.btn-white.active:focus,\na.btn-white:active:focus,\nbutton.btn-white:active:focus,\n.btn-white:active:focus,\na.btn-white.active:focus-visible,\nbutton.btn-white.active:focus-visible,\n.btn-white.active:focus-visible,\na.btn-white:active:focus-visible,\nbutton.btn-white:active:focus-visible,\n.btn-white:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\na.btn-white.hover,\nbutton.btn-white.hover,\n.btn-white.hover,\na.btn-white:hover,\nbutton.btn-white:hover,\n.btn-white:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\na.btn-white.hover.active,\nbutton.btn-white.hover.active,\n.btn-white.hover.active,\na.btn-white:hover.active,\nbutton.btn-white:hover.active,\n.btn-white:hover.active,\na.btn-white.hover:active,\nbutton.btn-white.hover:active,\n.btn-white.hover:active,\na.btn-white:hover:active,\nbutton.btn-white:hover:active,\n.btn-white:hover:active {\n  border-color: transparent;\n  background: #CED7E2;\n}\na.btn-white.hover.active.focus,\nbutton.btn-white.hover.active.focus,\n.btn-white.hover.active.focus,\na.btn-white:hover.active.focus,\nbutton.btn-white:hover.active.focus,\n.btn-white:hover.active.focus,\na.btn-white.hover:active.focus,\nbutton.btn-white.hover:active.focus,\n.btn-white.hover:active.focus,\na.btn-white:hover:active.focus,\nbutton.btn-white:hover:active.focus,\n.btn-white:hover:active.focus,\na.btn-white.hover.active:focus,\nbutton.btn-white.hover.active:focus,\n.btn-white.hover.active:focus,\na.btn-white:hover.active:focus,\nbutton.btn-white:hover.active:focus,\n.btn-white:hover.active:focus,\na.btn-white.hover:active:focus,\nbutton.btn-white.hover:active:focus,\n.btn-white.hover:active:focus,\na.btn-white:hover:active:focus,\nbutton.btn-white:hover:active:focus,\n.btn-white:hover:active:focus,\na.btn-white.hover.active:focus-visible,\nbutton.btn-white.hover.active:focus-visible,\n.btn-white.hover.active:focus-visible,\na.btn-white:hover.active:focus-visible,\nbutton.btn-white:hover.active:focus-visible,\n.btn-white:hover.active:focus-visible,\na.btn-white.hover:active:focus-visible,\nbutton.btn-white.hover:active:focus-visible,\n.btn-white.hover:active:focus-visible,\na.btn-white:hover:active:focus-visible,\nbutton.btn-white:hover:active:focus-visible,\n.btn-white:hover:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\na.btn-white:hover svg,\nbutton.btn-white:hover svg,\n.btn-white:hover svg,\na.btn-white.active svg,\nbutton.btn-white.active svg,\n.btn-white.active svg,\na.btn-white:active svg,\nbutton.btn-white:active svg,\n.btn-white:active svg {\n  stroke: #10294D;\n}\na.btn.disabled,\nbutton.btn.disabled,\n.btn.disabled,\na.btn[disabled],\nbutton.btn[disabled],\n.btn[disabled] {\n  background: #E5EBF1;\n  border: 1px solid transparent;\n  cursor: not-allowed;\n  color: #CED7E2;\n}\na.btn.disabled svg,\nbutton.btn.disabled svg,\n.btn.disabled svg,\na.btn[disabled] svg,\nbutton.btn[disabled] svg,\n.btn[disabled] svg {\n  display: block;\n  stroke: #CED7E2;\n}\na.btn.disabled.focus,\nbutton.btn.disabled.focus,\n.btn.disabled.focus,\na.btn[disabled].focus,\nbutton.btn[disabled].focus,\n.btn[disabled].focus,\na.btn.disabled:focus,\nbutton.btn.disabled:focus,\n.btn.disabled:focus,\na.btn[disabled]:focus,\nbutton.btn[disabled]:focus,\n.btn[disabled]:focus,\na.btn.disabled:focus-visible,\nbutton.btn.disabled:focus-visible,\n.btn.disabled:focus-visible,\na.btn[disabled]:focus-visible,\nbutton.btn[disabled]:focus-visible,\n.btn[disabled]:focus-visible {\n  color: #CED7E2;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\na.btn.disabled.active,\nbutton.btn.disabled.active,\n.btn.disabled.active,\na.btn[disabled].active,\nbutton.btn[disabled].active,\n.btn[disabled].active,\na.btn.disabled:active,\nbutton.btn.disabled:active,\n.btn.disabled:active,\na.btn[disabled]:active,\nbutton.btn[disabled]:active,\n.btn[disabled]:active {\n  color: #CED7E2;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\na.btn.disabled.active.focus,\nbutton.btn.disabled.active.focus,\n.btn.disabled.active.focus,\na.btn[disabled].active.focus,\nbutton.btn[disabled].active.focus,\n.btn[disabled].active.focus,\na.btn.disabled:active.focus,\nbutton.btn.disabled:active.focus,\n.btn.disabled:active.focus,\na.btn[disabled]:active.focus,\nbutton.btn[disabled]:active.focus,\n.btn[disabled]:active.focus,\na.btn.disabled.active:focus,\nbutton.btn.disabled.active:focus,\n.btn.disabled.active:focus,\na.btn[disabled].active:focus,\nbutton.btn[disabled].active:focus,\n.btn[disabled].active:focus,\na.btn.disabled:active:focus,\nbutton.btn.disabled:active:focus,\n.btn.disabled:active:focus,\na.btn[disabled]:active:focus,\nbutton.btn[disabled]:active:focus,\n.btn[disabled]:active:focus,\na.btn.disabled.active:focus-visible,\nbutton.btn.disabled.active:focus-visible,\n.btn.disabled.active:focus-visible,\na.btn[disabled].active:focus-visible,\nbutton.btn[disabled].active:focus-visible,\n.btn[disabled].active:focus-visible,\na.btn.disabled:active:focus-visible,\nbutton.btn.disabled:active:focus-visible,\n.btn.disabled:active:focus-visible,\na.btn[disabled]:active:focus-visible,\nbutton.btn[disabled]:active:focus-visible,\n.btn[disabled]:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\na.btn.disabled.hover,\nbutton.btn.disabled.hover,\n.btn.disabled.hover,\na.btn[disabled].hover,\nbutton.btn[disabled].hover,\n.btn[disabled].hover,\na.btn.disabled:hover,\nbutton.btn.disabled:hover,\n.btn.disabled:hover,\na.btn[disabled]:hover,\nbutton.btn[disabled]:hover,\n.btn[disabled]:hover {\n  color: #CED7E2;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\na.btn.disabled.hover.active,\nbutton.btn.disabled.hover.active,\n.btn.disabled.hover.active,\na.btn[disabled].hover.active,\nbutton.btn[disabled].hover.active,\n.btn[disabled].hover.active,\na.btn.disabled:hover.active,\nbutton.btn.disabled:hover.active,\n.btn.disabled:hover.active,\na.btn[disabled]:hover.active,\nbutton.btn[disabled]:hover.active,\n.btn[disabled]:hover.active,\na.btn.disabled.hover:active,\nbutton.btn.disabled.hover:active,\n.btn.disabled.hover:active,\na.btn[disabled].hover:active,\nbutton.btn[disabled].hover:active,\n.btn[disabled].hover:active,\na.btn.disabled:hover:active,\nbutton.btn.disabled:hover:active,\n.btn.disabled:hover:active,\na.btn[disabled]:hover:active,\nbutton.btn[disabled]:hover:active,\n.btn[disabled]:hover:active {\n  border-color: transparent;\n  background: #E5EBF1;\n}\na.btn.disabled.hover.active.focus,\nbutton.btn.disabled.hover.active.focus,\n.btn.disabled.hover.active.focus,\na.btn[disabled].hover.active.focus,\nbutton.btn[disabled].hover.active.focus,\n.btn[disabled].hover.active.focus,\na.btn.disabled:hover.active.focus,\nbutton.btn.disabled:hover.active.focus,\n.btn.disabled:hover.active.focus,\na.btn[disabled]:hover.active.focus,\nbutton.btn[disabled]:hover.active.focus,\n.btn[disabled]:hover.active.focus,\na.btn.disabled.hover:active.focus,\nbutton.btn.disabled.hover:active.focus,\n.btn.disabled.hover:active.focus,\na.btn[disabled].hover:active.focus,\nbutton.btn[disabled].hover:active.focus,\n.btn[disabled].hover:active.focus,\na.btn.disabled:hover:active.focus,\nbutton.btn.disabled:hover:active.focus,\n.btn.disabled:hover:active.focus,\na.btn[disabled]:hover:active.focus,\nbutton.btn[disabled]:hover:active.focus,\n.btn[disabled]:hover:active.focus,\na.btn.disabled.hover.active:focus,\nbutton.btn.disabled.hover.active:focus,\n.btn.disabled.hover.active:focus,\na.btn[disabled].hover.active:focus,\nbutton.btn[disabled].hover.active:focus,\n.btn[disabled].hover.active:focus,\na.btn.disabled:hover.active:focus,\nbutton.btn.disabled:hover.active:focus,\n.btn.disabled:hover.active:focus,\na.btn[disabled]:hover.active:focus,\nbutton.btn[disabled]:hover.active:focus,\n.btn[disabled]:hover.active:focus,\na.btn.disabled.hover:active:focus,\nbutton.btn.disabled.hover:active:focus,\n.btn.disabled.hover:active:focus,\na.btn[disabled].hover:active:focus,\nbutton.btn[disabled].hover:active:focus,\n.btn[disabled].hover:active:focus,\na.btn.disabled:hover:active:focus,\nbutton.btn.disabled:hover:active:focus,\n.btn.disabled:hover:active:focus,\na.btn[disabled]:hover:active:focus,\nbutton.btn[disabled]:hover:active:focus,\n.btn[disabled]:hover:active:focus,\na.btn.disabled.hover.active:focus-visible,\nbutton.btn.disabled.hover.active:focus-visible,\n.btn.disabled.hover.active:focus-visible,\na.btn[disabled].hover.active:focus-visible,\nbutton.btn[disabled].hover.active:focus-visible,\n.btn[disabled].hover.active:focus-visible,\na.btn.disabled:hover.active:focus-visible,\nbutton.btn.disabled:hover.active:focus-visible,\n.btn.disabled:hover.active:focus-visible,\na.btn[disabled]:hover.active:focus-visible,\nbutton.btn[disabled]:hover.active:focus-visible,\n.btn[disabled]:hover.active:focus-visible,\na.btn.disabled.hover:active:focus-visible,\nbutton.btn.disabled.hover:active:focus-visible,\n.btn.disabled.hover:active:focus-visible,\na.btn[disabled].hover:active:focus-visible,\nbutton.btn[disabled].hover:active:focus-visible,\n.btn[disabled].hover:active:focus-visible,\na.btn.disabled:hover:active:focus-visible,\nbutton.btn.disabled:hover:active:focus-visible,\n.btn.disabled:hover:active:focus-visible,\na.btn[disabled]:hover:active:focus-visible,\nbutton.btn[disabled]:hover:active:focus-visible,\n.btn[disabled]:hover:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\na.btn-icon-16 .icon,\nbutton.btn-icon-16 .icon,\n.btn-icon-16 .icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n}\na.btn-icon-16 .icon svg,\nbutton.btn-icon-16 .icon svg,\n.btn-icon-16 .icon svg {\n  width: 16px;\n  height: 16px;\n  stroke-width: 2.4;\n}\na.btn-icon-24 .icon,\nbutton.btn-icon-24 .icon,\n.btn-icon-24 .icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n}\na.btn-icon-24 .icon svg,\nbutton.btn-icon-24 .icon svg,\n.btn-icon-24 .icon svg {\n  width: 24px;\n  height: 24px;\n  stroke-width: 1.4;\n}\na.btn-icon-right,\nbutton.btn-icon-right,\n.btn-icon-right {\n  padding-right: 10px;\n}\na.btn-icon-right .icon,\nbutton.btn-icon-right .icon,\n.btn-icon-right .icon {\n  order: 1;\n  margin-left: 5px;\n}\na.btn-icon-right .icon svg,\nbutton.btn-icon-right .icon svg,\n.btn-icon-right .icon svg {\n  fill: none;\n}\na.btn-icon-left,\nbutton.btn-icon-left,\n.btn-icon-left {\n  padding-left: 10px;\n}\na.btn-icon-left .icon,\nbutton.btn-icon-left .icon,\n.btn-icon-left .icon {\n  order: 0;\n  margin-right: 5px;\n}\na.btn-icon-left .icon svg,\nbutton.btn-icon-left .icon svg,\n.btn-icon-left .icon svg {\n  fill: none;\n}\na.btn-icon-righta.btn-icon-left .icon,\na.btn-icon-rightbutton.btn-icon-left .icon,\na.btn-icon-right.btn-icon-left .icon,\nbutton.btn-icon-righta.btn-icon-left .icon,\nbutton.btn-icon-rightbutton.btn-icon-left .icon,\nbutton.btn-icon-right.btn-icon-left .icon,\n.btn-icon-righta.btn-icon-left .icon,\n.btn-icon-rightbutton.btn-icon-left .icon,\n.btn-icon-right.btn-icon-left .icon {\n  margin: 0;\n}\na.btn-icon-only,\nbutton.btn-icon-only,\n.btn-icon-only {\n  padding: 0;\n}\na.btn-icon-only.btn-icon-24,\nbutton.btn-icon-only.btn-icon-24,\n.btn-icon-only.btn-icon-24 {\n  min-height: 26px;\n  max-height: 26px;\n  max-width: 26px;\n}\na.btn-icon-only.btn-icon-24 .icon,\nbutton.btn-icon-only.btn-icon-24 .icon,\n.btn-icon-only.btn-icon-24 .icon {\n  max-height: 24px;\n  max-width: 24px;\n}\na.btn-icon-only.btn-icon-16,\nbutton.btn-icon-only.btn-icon-16,\n.btn-icon-only.btn-icon-16 {\n  min-height: 18px;\n  max-height: 18px;\n  max-width: 18px;\n}\na.btn-icon-only.btn-icon-16 .icon,\nbutton.btn-icon-only.btn-icon-16 .icon,\n.btn-icon-only.btn-icon-16 .icon {\n  max-height: 16px;\n  max-width: 16px;\n}\na.btn-icon-only.input-group-addon,\nbutton.btn-icon-only.input-group-addon,\n.btn-icon-only.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n}\na.btn-icon-success .icon svg,\nbutton.btn-icon-success .icon svg,\n.btn-icon-success .icon svg {\n  fill: none;\n  stroke: #73C677;\n}\na.btn-glyph .icon svg,\nbutton.btn-glyph .icon svg,\n.btn-glyph .icon svg {\n  stroke: none;\n}\na.btn.highlight,\nbutton.btn.highlight,\n.btn.highlight {\n  --color4: #60D3EC;\n}\na.btn.has-submenu,\nbutton.btn.has-submenu,\n.btn.has-submenu {\n  padding: 0;\n}\na.btn-red-text,\nbutton.btn-red-text,\n.btn-red-text {\n  color: #FC495D;\n  padding-left: 1px;\n}\n.track-vertical {\n  width: 6px;\n  top: 2px;\n  right: 2px;\n  bottom: 2px;\n}\n.track-horizontal {\n  height: 6px;\n  right: 8px;\n  left: 2px;\n  bottom: 2px;\n}\n.thumb-vertical {\n  background: #92A7C0;\n  border-radius: 3px;\n}\n.thumb-horizontal {\n  background: #92A7C0;\n  border-radius: 3px;\n}\n.user-photo {\n  position: relative;\n}\n.avatar-sm {\n  flex: 0 0 auto;\n}\n.avatar-sm > .thumbimg {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n.avatar-md {\n  flex: 0 0 auto;\n}\n.avatar-md > .thumbimg {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n}\n.avatar-lg {\n  flex: 0 0 auto;\n}\n.avatar-lg > .thumbimg {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n}\n.avatar > .thumbimg {\n  overflow: hidden;\n}\n.avatar > .thumbimg img {\n  aspect-ratio: 1 / 1;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.avatar > .initials {\n  stroke: none;\n}\n.avatar > .initials svg {\n  stroke: none;\n}\n.avatar > .initials svg circle {\n  fill: #FFF6F7;\n}\n.avatar > .initials svg text {\n  stroke: none;\n  fill: #FC495D;\n}\n.avatar svg {\n  width: 100%;\n  height: 100%;\n  stroke: #CED7E2;\n}\niframe {\n  border: 0 none;\n}\n.wrapper {\n  max-width: 100vw;\n  position: relative;\n  display: grid;\n  grid-gap: 0;\n  grid-template-rows: auto 1fr;\n  height: 100vh;\n  grid-template-areas: \"header\" \"content\";\n}\n@media (min-width: 800px) {\n  .wrapper {\n    grid-template-areas: \"header header\" \"nav content\";\n  }\n}\n.wrapper.login {\n  grid-template-columns: 1fr;\n  grid-template-rows: auto;\n  grid-template-areas: \"content\";\n}\n.wrapper.login .content:not(.form-group) {\n  width: 100%;\n  height: 100vh;\n  background: none;\n}\n.wrapper.modaled {\n  opacity: 0.5;\n}\n.main .showmenu .context-sidebar {\n  border-left: 1px solid #efefef;\n  width: 280px;\n  z-index: 900;\n}\n.main .showmenu .menubtn {\n  background-color: #fff;\n}\n.main .showmenu .menubtn > div,\n.main .showmenu .menubtn > div:before,\n.main .showmenu .menubtn > div:after {\n  background-color: #FC495D;\n}\n/* Loader */\n.loader {\n  margin: 0 auto;\n  position: relative;\n  z-index: 9999;\n}\n.loader svg {\n  width: 40px;\n  height: 40px;\n}\n.loader svg image {\n  width: 100%;\n  height: 100%;\n}\n.loader.inline {\n  z-index: auto;\n  display: inline-flex;\n  justify-content: center;\n  align-content: center;\n}\n.loader.inline svg {\n  width: 14px;\n  height: 14px;\n}\n.loader.inline.large svg {\n  width: 40px;\n  height: 40px;\n  margin: 20px;\n}\n/* Errors */\n.viewerror {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  min-height: calc(100vh - 68px);\n}\n.viewerror.view.container-fluid {\n  grid-area: view;\n  height: 100vh;\n}\n.viewerror svg {\n  height: 100px;\n  fill: #CED7E2;\n}\n.viewerror .err {\n  max-width: 280px;\n}\n@-webkit-keyframes load8 {\n  0% {\n    -webkit-transform: rotateZ(0deg);\n    transform: rotateZ(0deg);\n  }\n  100% {\n    -webkit-transform: rotateZ(360deg);\n    transform: rotateZ(360deg);\n  }\n}\n@keyframes load8 {\n  0% {\n    -webkit-transform: rotateZ(0deg);\n    transform: rotateZ(0deg);\n  }\n  100% {\n    -webkit-transform: rotateZ(360deg);\n    transform: rotateZ(360deg);\n  }\n}\n.isloading {\n  display: flex;\n  position: fixed;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n}\n.login .isloading {\n  top: 0 !important;\n  left: 0 !important;\n}\n.isloading.inline {\n  display: inline-block;\n  width: auto;\n  position: relative;\n  top: 10px;\n  left: 10px;\n  height: 30px;\n}\n.isloading.block {\n  margin: 0 auto;\n  width: auto;\n  height: 100%;\n  width: 100%;\n  z-index: 950;\n  background: rgba(255, 255, 255, 0.5);\n}\n@media (min-width: 799px) {\n  .isloading.block {\n    top: 68px;\n    left: 64px;\n  }\n  .isloading.block .loader {\n    margin-top: -68px;\n    margin-left: calc(50% - 54px);\n  }\n}\n.isloading.solid {\n  background: #ffffff;\n}\nbutton.disabled,\n.btn.disabled,\n.navitem.disabled {\n  cursor: not-allowed;\n}\n.flex-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n.card .cardbody .flex-container.ccontent {\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  flex: 1 1 100%;\n}\n.flex-container.gap-20 {\n  gap: 20px 20px;\n}\n.flex-container.gap-40 {\n  gap: 40px;\n}\n.text-left .checkcontainer {\n  align-items: flex-start;\n}\n.text-right .checkcontainer {\n  align-items: flex-end;\n}\n.text-center .checkcontainer {\n  align-items: middle;\n}\n.grid-container {\n  display: grid;\n  gap: 16px 16px;\n}\n@media screen and (min-width: 799px) {\n  .grid-container {\n    grid-template-columns: repeat(4, 1fr [col-start]);\n  }\n}\n.card .cardbody .grid-container.ccontent {\n  padding: 0;\n}\n.grid-container .card .cardbody {\n  margin-bottom: auto;\n}\n@media screen and (min-width: 799px) {\n  .grid-container.grid-3 {\n    grid-template-columns: repeat(3, 1fr [col-start]);\n  }\n}\n@media screen and (min-width: 799px) {\n  .grid-container.grid-2 {\n    grid-template-columns: repeat(2, 1fr [col-start]);\n  }\n}\n@media screen and (min-width: 799px) {\n  .grid-container.grid-1 {\n    grid-template-columns: repeat(1, 1fr [col-start]);\n  }\n}\n.grid-container .grid-row-2 {\n  grid-row: span 2;\n}\n.grid-container .grid-row-3 {\n  grid-row: span 3;\n}\n.grid-container .card {\n  margin: 0;\n}\n.grid-container .no-grow {\n  margin-bottom: auto;\n}\n.grid-container .grid-col-5 {\n  grid-column: span 5;\n}\n.grid-container .grid-col-4 {\n  grid-column: span 4;\n}\n.grid-container .grid-col-3 {\n  grid-column: span 4;\n  align-content: flex-start;\n}\n.grid-5 .grid-container .grid-col-3 {\n  grid-column: span 5;\n}\n@media screen and (min-width: 799px) {\n  .grid-container .grid-col-3 {\n    grid-column: span 3;\n  }\n}\n.grid-container .grid-col-2 {\n  grid-column: span 4;\n  align-content: flex-start;\n}\n.grid-5 .grid-container .grid-col-2 {\n  grid-column: span 5;\n}\n@media screen and (min-width: 799px) {\n  .grid-container .grid-col-2 {\n    grid-column: span 2;\n  }\n}\n.grid-container .grid-col-1 {\n  grid-column: span 4;\n  align-content: flex-start;\n}\n.grid-5 .grid-container .grid-col-1 {\n  grid-column: span 5;\n}\n@media screen and (min-width: 799px) {\n  .grid-container .grid-col-1 {\n    grid-column: span 1;\n  }\n}\n@media screen and (min-width: 799px) {\n  .grid-container.grid-5 {\n    grid-template-columns: repeat(5, 1fr [col-start]);\n  }\n}\n.grid-container.grid-5 .grid-col-3 {\n  grid-column: span 5;\n  align-content: flex-start;\n}\n@media screen and (min-width: 799px) {\n  .grid-container.grid-5 .grid-col-3 {\n    grid-column: span 3;\n  }\n}\n.grid-container.grid-5 .grid-col-2 {\n  grid-column: span 5;\n  align-content: flex-start;\n}\n@media screen and (min-width: 799px) {\n  .grid-container.grid-5 .grid-col-2 {\n    grid-column: span 2;\n  }\n}\n.grid-container.grid-5 .grid-col-1 {\n  grid-column: span 5;\n  align-content: flex-start;\n}\n@media screen and (min-width: 799px) {\n  .grid-container.grid-5 .grid-col-1 {\n    grid-column: span 1;\n  }\n}\n.grid-container .grid-listing-details {\n  order: -1;\n}\n@media screen and (min-width: 799px) {\n  .grid-container .grid-listing-details {\n    order: unset;\n  }\n}\n.grid-container > [class^=\"grid-col-\"],\n.grid-container > [class*=\"grid-col-\"] {\n  display: grid;\n  min-width: 0;\n}\n@media screen and (max-width: 799px) {\n  .grid-container > [class^=\"grid-col-\"],\n  .grid-container > [class*=\"grid-col-\"] {\n    grid-column: span 5;\n  }\n}\n.grid-container > [class^=\"grid-col-\"] > *,\n.grid-container > [class*=\"grid-col-\"] > * {\n  min-width: 0;\n}\n.monaco-editor {\n  min-height: 100px;\n  resize: vertical;\n  overflow: auto;\n}\n.monaco-editor .monaco-editor-tabs {\n  margin-top: -6px;\n  margin-left: -15px;\n  display: flex;\n  height: 35px;\n}\n.monaco-editor .monaco-editor-tabs .monaco-editor-tab {\n  background: rgba(227, 228, 226, 0.16);\n  color: #fff;\n  border-right: 1px solid #1e1f1c;\n  background-color: #34352f;\n  padding-left: 12px;\n  width: 120px;\n  min-width: fit-content;\n  min-width: -moz-fit-content;\n  flex-shrink: 0;\n  font-family: Menlo, Monaco, \"Courier New\", monospace;\n  font-weight: normal;\n  font-size: 12px;\n  font-feature-settings: \"liga\" 0, \"calt\" 0;\n  line-height: 18px;\n  letter-spacing: 0px;\n  line-height: 35px;\n}\n.monaco-editor .monaco-editor-tabs .monaco-editor-tab.active {\n  background: rgba(227, 228, 226, 0.16);\n  color: var(--vscode-textPreformat-foreground);\n}\n.version-list {\n  display: grid;\n  gap: 20px;\n  padding: 0;\n  margin: 0 0 0 -20px;\n  grid-template-areas: \"jump-menu\" \"details\";\n}\n@media screen and (min-width: 799px) {\n  .version-list {\n    grid-template-areas: \"jump-menu details\";\n    grid-template-columns: 370px auto;\n    grid-template-rows: auto;\n  }\n}\n.version-list .stepper {\n  grid-area: details;\n}\n.version-list .versions {\n  grid-area: details;\n}\n.version-list .versions .tablemeta {\n  padding-top: 0;\n  flex: 0 0 100%;\n}\n.version-list .versions .version-buttons {\n  display: flex;\n  gap: 15px 6px;\n}\n.reviewComment {\n  margin: 8px;\n  margin-top: 0;\n  padding: 8px;\n  border-top: 1px solid var(--vscode-textSeparator-foreground);\n  border-bottom: 1px solid var(--vscode-textSeparator-foreground);\n}\n.reviewComment > div {\n  border-radius: 6px !important;\n  border: 1px solid var(--vscode-textSeparator-foreground);\n}\n.reviewComment > div .reviewComment-meta {\n  border-radius: 6px !important;\n  padding-right: 8px !important;\n  padding-left: 8px !important;\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n}\n.reviewComment > div .reviewComment-text {\n  padding-right: 8px !important;\n  padding-left: 8px !important;\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n}\n.headerwrap {\n  grid-area: header;\n  position: sticky;\n  top: 0px;\n  z-index: 950;\n}\n@media (max-width: 799px) {\n  .headerwrap.down {\n    top: -60px;\n  }\n}\n/* Main Header */\n.main-header {\n  left: 0;\n  right: 0;\n  top: 68px;\n  background: #10294D;\n  color: #ffffff;\n  display: flex;\n  flex-wrap: wrap;\n  font-weight: 400;\n  /* User */\n  /* User */\n  /* Menu */\n}\n.main-header svg {\n  vertical-align: middle;\n  transition: all 0.3s ease 0s;\n}\n@media print {\n  .main-header {\n    display: none;\n  }\n}\n@media (min-width: 799px) {\n  .main-header {\n    background: #ffffff;\n    color: #10294D;\n    flex-wrap: nowrap;\n  }\n}\n.main-header .navbtn {\n  left: 0;\n  top: 0;\n  max-width: 64px;\n  flex: 0 0 64px;\n  height: 68px;\n  background-color: inherit;\n  background-image: none;\n  line-height: 1;\n  display: inline-block;\n  text-align: center;\n  cursor: pointer;\n  background: #10294D;\n  position: relative;\n  color: #ffffff;\n  z-index: 1;\n}\n.main-header .navbtn:before {\n  content: \"\";\n  width: 64px;\n  position: absolute;\n  height: 68px;\n  top: 0;\n  left: 0;\n  background: #10294D;\n  z-index: -1;\n}\n.main-header .navbtn > div {\n  display: inline-block;\n  line-height: 68px;\n  height: 100%;\n}\n.main-header .navbtn > div svg {\n  width: 24px;\n  height: 24px;\n  fill: none;\n  stroke: #ffffff;\n  stroke-width: 1.4;\n  position: absolute;\n  top: 50%;\n  margin-top: -12px;\n  left: 50%;\n  margin-left: -12px;\n  transition: all 0.2s ease-in-out;\n}\n.main-header .navbtn > div svg.close {\n  opacity: 0;\n  transform: scale(0);\n}\n.main-header .navbtn > div svg.open {\n  opacity: 1;\n  transform: scale(1);\n}\n.main-header .navbtn + div:nth-child(2) {\n  margin-left: auto;\n}\n.main-header .navbtn .icon-bar {\n  width: 22px;\n  height: 3px;\n  display: block;\n  border-radius: 6px;\n  background: #ffffff;\n  margin-bottom: 4px;\n}\n.main-header .navbtn .icon-bar:last-of-type {\n  margin-bottom: 0;\n}\n.main-header .breadcrumbs {\n  order: 4;\n  background: #ffffff;\n  color: #92A7C0;\n  flex: 0 0 100%;\n  padding: 11.5px 20px;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  justify-content: flex-start;\n}\n@media (min-width: 799px) {\n  .main-header .breadcrumbs {\n    order: 0;\n    flex: 1 1 auto;\n  }\n}\n.main-header .breadcrumbs .crumb {\n  text-transform: capitalize;\n  color: #92A7C0;\n}\n.main-header .breadcrumbs .crumb span.title {\n  text-transform: none;\n}\n.main-header .breadcrumbs .crumb a.lower {\n  text-transform: lowercase;\n}\n.main-header .breadcrumbs .crumb span:last-of-type {\n  color: #10294D;\n  font-weight: 600;\n}\n.main-header .breadcrumbs .crumb span,\n.main-header .breadcrumbs .crumb a {\n  color: #92A7C0;\n}\n.main-header .breadcrumbs .crumb span:before,\n.main-header .breadcrumbs .crumb a:before {\n  display: inline-block;\n  width: 20px;\n  height: 16px;\n  vertical-align: top;\n  content: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0iaXNvbGF0aW9uOmlzb2xhdGUiIHZpZXdCb3g9IjAgMCAxNiAxNiIgd2lkdGg9IjE2cHQiIGhlaWdodD0iMTZwdCI+PHBhdGggZD0iIE0gNS41NzYgMy41NzYgQyA1LjgxIDMuMzQxIDYuMTkgMy4zNDEgNi40MjQgMy41NzYgTCAxMC40MjQgNy41NzYgQyAxMC42NTkgNy44MSAxMC42NTkgOC4xOSAxMC40MjQgOC40MjQgTCA2LjQyNCAxMi40MjQgQyA2LjE5IDEyLjY1OSA1LjgxIDEyLjY1OSA1LjU3NiAxMi40MjQgQyA1LjM0MSAxMi4xOSA1LjM0MSAxMS44MSA1LjU3NiAxMS41NzYgTCA5LjE1MSA4IEwgNS41NzYgNC40MjQgQyA1LjM0MSA0LjE5IDUuMzQxIDMuODEgNS41NzYgMy41NzYgWiAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZmlsbD0icmdiKDIwNiwyMTUsMjI2KSIvPjwvc3ZnPg==\");\n}\n.main-header ~ .wrapper {\n  margin-top: 68px;\n}\n.main-header .userhead {\n  display: flex;\n  cursor: pointer;\n  margin-right: 10px;\n  order: 2;\n}\n.main-header .userhead .user-toggle {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: flex-start;\n}\n.main-header .userhead .user-toggle .user-details {\n  margin-right: 10px;\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: column;\n  text-align: right;\n}\n.main-header .userhead .user-toggle .user-name {\n  flex: 0 0 auto;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n.main-header .userhead .user-toggle .site-name {\n  flex: 0 0 auto;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n}\n.main-header .globaladd {\n  display: flex;\n  cursor: pointer;\n  margin-right: 10px;\n  align-items: center;\n  order: 3;\n}\n.main-header .globaladd .thumbimg {\n  background: #FC495D;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.main-header .globaladd svg {\n  width: 24px;\n  stroke: #ffffff;\n  stroke-width: 2.4;\n}\n.main-header .menubtn {\n  margin-left: auto;\n  width: 50px;\n  height: 68px;\n  line-height: 68px;\n  cursor: pointer;\n  text-align: center;\n  position: relative;\n  transition: all 0.2s ease 0s;\n}\n.main-header .menubtn > div {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  transform: translate(0, 0);\n  display: inline-block;\n  vertical-align: middle;\n  line-height: 0;\n}\n.main-header .menubtn > div:before {\n  content: \"\";\n  display: inline-block;\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  transform: translate(0, -9px);\n}\n.main-header .menubtn > div:after {\n  content: \"\";\n  display: inline-block;\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  transform: translate(0, 4px);\n}\n/* Notifications */\n.alertshead,\n.chatshead {\n  cursor: pointer;\n  max-width: 50px;\n  display: none;\n  flex: 0 0 50px;\n  height: 68px;\n  line-height: 68px;\n  margin-left: auto;\n  order: 1;\n  justify-content: center;\n  align-items: center;\n}\n@media screen and (min-width: 799px) {\n  .alertshead,\n  .chatshead {\n    display: flex;\n  }\n}\n.alertshead .btn,\n.chatshead .btn {\n  padding: 0;\n  position: relative;\n}\n.alertshead .btn .icon svg,\n.chatshead .btn .icon svg {\n  fill: none;\n  stroke: #10294D;\n}\n.alertshead .badge,\n.chatshead .badge {\n  position: absolute;\n  font-size: 10px;\n  min-width: 14px;\n  display: block;\n  line-height: 1;\n  bottom: 50%;\n  left: 50%;\n  text-align: center;\n  border-radius: 50%;\n}\n.alertshead + .userhead,\n.chatshead + .userhead {\n  margin-left: 20px;\n}\n.user-menu {\n  background: #FFFFFF;\n  border: 1px solid #CFCDCD;\n  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);\n  z-index: 100;\n  flex-direction: column;\n  padding: 0 0 20px 0;\n  overflow: auto;\n}\n@media screen and (min-width: 799px) {\n  .user-menu {\n    padding-top: 20px;\n  }\n}\n.user-menu .selectinput.default_home_page {\n  margin: 0 20px;\n}\n.user-menu .action {\n  display: flex;\n  position: relative;\n  cursor: pointer;\n  padding: 0.75rem 20px;\n  flex-wrap: nowrap;\n  align-content: center;\n  align-items: center;\n}\n.user-menu .action svg {\n  fill: none;\n  stroke: #10294D;\n  stroke-width: 1.4;\n}\n.user-menu .action .icon {\n  margin-right: 10px;\n}\n.user-menu .action:hover {\n  background: #F3F5F8;\n}\n.user-menu .action.menu-close {\n  width: 36px;\n  height: 36px;\n  max-width: 36px;\n  padding: 0;\n  justify-content: center;\n  align-items: center;\n  background: #E5EBF1;\n  border-radius: 18px;\n  margin-left: auto;\n}\n.user-menu .action.menu-close svg {\n  fill: none;\n  stroke: #10294D;\n  stroke-width: 1.4;\n}\n.user-menu .action.alerts-head svg {\n  fill: none;\n  stroke: #10294D;\n  stroke-width: 1.4;\n}\n.user-menu .menu-icons {\n  display: flex;\n  padding: 20px;\n  gap: 0 10px;\n}\n.user-menu .menu-icons .btn {\n  flex: 0 0 auto;\n  width: 45px;\n  height: 45px;\n  max-width: 45px;\n  padding: 0;\n}\n.user-menu .menu-icons .btn:hover {\n  background: none;\n}\n.user-menu .menu-icons .btn .icon {\n  margin-right: 0;\n}\n@media screen and (min-width: 799px) {\n  .user-menu .menu-icons {\n    display: none;\n  }\n}\n.user-menu .label {\n  display: flex;\n  flex: 0 0 auto;\n  display: inline-block;\n  white-space: nowrap;\n}\n.user-menu .navicon {\n  flex: 0 0 auto;\n  margin-right: 5px;\n}\n.user-menu-cover {\n  margin: 20px;\n}\n@media screen and (min-width: 799px) {\n  .user-menu-cover {\n    position: absolute;\n    left: auto;\n    min-width: 280px;\n    right: 0;\n  }\n}\n.user-menu-cover-wrapper {\n  position: fixed;\n  top: 68px;\n  left: 0;\n  right: 0;\n}\n.user-menu-cover-backdrop {\n  position: fixed;\n  top: 68px;\n  left: 0;\n  height: calc(100vh - 68px);\n  right: 0;\n  z-index: -1;\n  background: #F3F5F8;\n}\n@media screen and (min-width: 799px) {\n  .user-menu-cover-backdrop {\n    background: none;\n  }\n}\n/* Notifications */\n.alerts-head .badge {\n  position: absolute;\n  font-size: 10px;\n  min-width: 14px;\n  display: block;\n  line-height: 1;\n  bottom: 50%;\n  left: 50%;\n  text-align: center;\n  border-radius: 50%;\n}\n.badge {\n  font-size: 10px;\n  padding: 5px 8px;\n  position: absolute;\n  background: #FC495D;\n  color: #ffffff;\n}\n.ws-status {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #F3F5F8;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n.ws-status.connected {\n  background: #73C677;\n}\n.ws-status.disconnected {\n  background: #FF6464;\n}\n.menu-group {\n  margin: 10px 0;\n}\n.menu-group > .label {\n  padding: 0 20px;\n  text-transform: uppercase;\n  color: #92A7C0;\n}\n@media screen and (min-width: 799px) {\n  .menu-group:first-of-type {\n    margin: 0 0;\n  }\n}\n.pddash {\n  height: calc(100vh -  60px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n}\n.pddash svg {\n  height: 200px;\n  fill: #efefef;\n}\n.pddash h4 {\n  font-size: 1.4rem;\n  color: #ccc;\n}\n.dashcontent .dashmessagecontainer .msgactions {\n  text-align: right;\n}\n.dashcontent .dashmessagecontainer .dashmessage {\n  display: flex;\n  margin: 15px 0;\n  align-items: top;\n  max-height: 200px;\n}\n.dashcontent .dashmessagecontainer .dashmessage .msgall {\n  overflow-y: scroll;\n  max-height: 200px;\n}\n.dashcontent .dashmessagecontainer .dashmessage .msgall .msghead {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n.dashcontent .dashmessagecontainer .dashmessage .msgall .msghead .msgauthor {\n  font-weight: 600;\n  color: #333;\n}\n.dashcontent .dashmessagecontainer .dashmessage .msgall .msg {\n  padding: 15px;\n  border: 1px solid #efefef;\n  border-radius: 3px;\n}\n.dashcontent .dashmessagecontainer .dashmessage .msgreply {\n  margin-top: 10px;\n}\n.dashcontent .dashmessagecontainer .dashmessage .msgreply > div {\n  text-align: right;\n}\n.dashcontent .dashmessagecontainer .dashmessage .msgcomments {\n  display: flex;\n  flex-direction: row-reverse;\n}\n.dashcontent .dashmessagecontainer .dashmessage .msgcomments .msgcomment {\n  display: inline-block;\n  background-color: #efefef;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  padding: 10px 5px;\n  margin: 15px 0;\n  align-items: top;\n  max-height: 200px;\n  text-align: right;\n}\n.dashcontent .dashmessagecontainer .dashmessage .msgcomments .msgcomment .commentagent {\n  display: block;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 5px;\n}\n.dashcontent .dashmessagecontainer .dashmessage .msgcomments .msgcomment .comment {\n  overflow-y: scroll;\n  max-height: 200px;\n}\n.dashcontent .listingquality > div {\n  margin-bottom: 10px;\n  padding: 10px;\n}\n.dashcontent .listingtype {\n  font-size: 1.1rem;\n  font-weight: 600;\n  text-align: right;\n  margin: 20px 0;\n}\n.dashcontent .listingtype .radiocontainer {\n  display: inline-block;\n  min-width: 120px;\n  text-align: left;\n}\n.dashcontent .dashstats {\n  text-align: center;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.dashcontent .dashstats .bigstat {\n  border-radius: 4px;\n  display: inline-block;\n  padding: 15px 0;\n  font-size: 24px;\n  background-color: #FC495D;\n  color: #fff;\n  margin: 0 0 20px 0;\n  min-width: 100%;\n}\n.dashcontent .dashstats .bigstat span {\n  font-size: 1rem;\n  display: block;\n}\n.dashcontent .dashstats .bigstat h1 {\n  color: #fff;\n}\n.dashcontent .dashstats .bigstat.nobg {\n  background-color: transparent;\n  color: #979797;\n}\n.dashcontent .nodata {\n  text-align: center;\n}\n.dashcontent .nodata svg {\n  height: 120px;\n  fill: #eeeeee;\n}\n.dashcontent .nodata h5 {\n  color: #aaa;\n  font-weight: 600;\n}\n.dashcontent .simpletablecontainer,\n.dashcontent .timeonmarket,\n.dashcontent .listingquality {\n  display: flex;\n  flex-direction: column;\n}\n.dashcontent .simpletablecontainer .selectinput,\n.dashcontent .timeonmarket .selectinput,\n.dashcontent .listingquality .selectinput {\n  max-width: 200px;\n  min-width: 200px;\n  align-self: flex-end;\n}\n.dashcontent table.simpletable {\n  width: 100%;\n}\n.dashcontent table.simpletable tr {\n  border-bottom: 1px solid #efefef;\n}\n.dashcontent table.simpletable td,\n.dashcontent table.simpletable th {\n  padding: 5px 2px;\n  text-align: right;\n}\n.dashcontent table.simpletable th:first-of-type,\n.dashcontent table.simpletable td:first-of-type {\n  text-align: left;\n}\n.dashcontent .leads-analysis .pie {\n  text-align: center;\n}\n.tourmask {\n  height: 100%;\n  width: 100%;\n}\n.tour {\n  background-color: #ffffff;\n}\n.tour svg {\n  height: 10px;\n}\n.tour .touritem h3 {\n  font-weight: 500;\n}\n.tour .touritem h3 span {\n  font-weight: 600;\n}\n.percentage-change {\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n  font-size: 14px;\n}\n.percentage-change.success {\n  --color4: #73C677;\n  color: #73C677;\n}\n.percentage-change.failed {\n  --color4: #FF6464;\n  color: #FF6464;\n}\n.percentage-change svg {\n  width: 16px;\n}\n.flex-quality {\n  gap: 20px;\n}\n.quality-block {\n  background: #F3F5F8;\n  padding: 20px;\n  border-radius: 4px;\n  display: flex;\n  flex: 1 1 calc(25% - 20px);\n  min-width: 280px;\n  gap: 0 20px;\n}\n.flex-3 .quality-block {\n  flex: 1 1 calc(33% - 20px);\n}\n.quality-block .quality-graph {\n  flex: 0 0 100px;\n  height: 100px;\n}\n.quality-block .quality-content {\n  display: flex;\n  flex-direction: column;\n}\n.quality-block .quality-content h3 {\n  margin: 0;\n}\n.quality-block .quality-content strong {\n  color: #92A7C0;\n  font-weight: 600;\n}\n.quality-block .quality-content h2 {\n  font-size: 30px;\n  font-weight: 400;\n}\n.quality-block .quality-content .btn {\n  margin-right: auto;\n}\n.customized-legend {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  height: 100%;\n  padding-bottom: 20px;\n}\n@media screen and (min-width: 799px) {\n  .customized-legend {\n    width: 240px;\n  }\n}\n.customized-legend .legend-total {\n  flex: 1 1 100%;\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: auto;\n}\n.customized-legend .legend-total .legend-count {\n  font-size: 36px;\n  flex: 1 1 100%;\n  padding: 0;\n}\n.customized-legend .legend-item {\n  flex: 1 1 50%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0 10px;\n  height: 44px;\n}\n.customized-legend .legend-label {\n  text-transform: uppercase;\n  font-size: 11px;\n  color: #70859E;\n}\n.customized-legend .legend-count {\n  flex: 1 1 100%;\n  padding-left: 20px;\n  font-size: 18px;\n  color: #10294D;\n}\n.customized-legend-vertical {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  min-width: 240px;\n  height: 100%;\n  padding-top: 20px;\n  padding-left: 20px;\n  align-items: center;\n  justify-content: center;\n}\n@media screen and (min-width: 799px) {\n  .customized-legend-vertical {\n    padding-top: 0;\n  }\n}\n.customized-legend-vertical .legend-item {\n  display: flex;\n  flex-wrap: wrap;\n  min-width: 100%;\n  align-items: center;\n  height: 36px;\n  box-shadow: 0px 1px 0px #E5EBF1;\n}\n.customized-legend-vertical .legend-label {\n  font-size: 14px;\n  padding-left: 10px;\n  color: #70859E;\n}\n.customized-legend-vertical .legend-count {\n  margin-left: auto;\n  font-size: 16px;\n  color: #10294D;\n}\n.expiring-listings-widget .datatablewrap-inner {\n  max-height: 515px;\n}\n.latest-leads-widget tbody .tablecell {\n  min-height: 40px;\n}\n.latest-leads-widget .datatablewrap-inner {\n  max-height: 515px;\n}\n#listing-value-widget {\n  min-height: 330px;\n}\n.syndication-widget .scrollview {\n  max-height: 244px;\n}\n.syndication-widget .flex-2 {\n  gap: 20px 20px;\n  flex-wrap: wrap;\n  align-items: flex-start !important;\n}\n.syndication-widget .flex-2 > div {\n  flex: 1 1 100%;\n}\n@media screen and (min-width: 799px) {\n  .syndication-widget .flex-2 > div {\n    flex: 1 1 calc(50% - 10px);\n    max-width: calc(50% - 10px);\n  }\n}\n.syndication-summary {\n  flex: 1 1 auto;\n  min-width: 240px;\n}\n.syndication-summary .listbody {\n  max-height: 515px;\n}\n.syndication-summary .syndication-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 20px 20px;\n  margin-bottom: 20px;\n  justify-content: center;\n}\n.syndication-summary .syndication-meta .syndication-logo {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  min-width: 100px;\n  overflow: hidden;\n  border: 1px solid #E5EBF1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.syndication-summary .syndication-meta .syndication-logo img {\n  width: 100px;\n}\n.syndication-summary .syndication-meta .syndication-counts {\n  display: flex;\n  flex: 1 1;\n  gap: 0 10px;\n  justify-content: flex-end;\n}\n@media screen and (min-width: 799px) {\n  .syndication-summary .syndication-meta .syndication-counts {\n    flex: 0 0;\n    margin-left: auto;\n  }\n}\n.syndication-summary .syndication-meta .syndication-counts .syndication-count {\n  flex: 1 1 auto;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 0;\n}\n.syndication-summary .syndication-meta .syndication-counts .syndication-count button {\n  min-width: 90px;\n  height: 63px;\n  background: #F3F5F8;\n  border-radius: 8px;\n  border: none;\n  outline: none;\n  color: inherit;\n  cursor: pointer;\n}\n.syndication-summary .syndication-meta .syndication-counts .syndication-count button.active {\n  outline: 2px solid #B2C2D4;\n  cursor: default;\n}\n.syndication-summary .syndication-meta .syndication-counts .syndication-count strong {\n  color: #5A6F89;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.syndication-summary .syndication-meta .syndication-counts .syndication-count button > div {\n  font-size: 20px;\n  flex: 1 1 100%;\n  height: 22px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0;\n  color: inherit;\n}\n.syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-success {\n  color: #73C677;\n}\n.syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-failures {\n  color: #FF6464;\n}\n.syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-pending {\n  color: #FFA564;\n}\n.syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-withdrawn {\n  color: #455870;\n}\n.syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-res {\n  color: #455870;\n}\n.syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-com {\n  color: #455870;\n}\n.uae-list-actions {\n  display: flex;\n  padding: 20px 0;\n  gap: 16px;\n}\n.uae-syndication-summary {\n  min-width: 240px;\n}\n.uae-syndication-summary .syndication-meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 20px 20px;\n  margin-bottom: 20px;\n  justify-content: center;\n}\n.uae-syndication-summary .syndication-meta .syndication-logo {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  min-width: 100px;\n  overflow: hidden;\n  border: 1px solid #E5EBF1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 40px;\n}\n.uae-syndication-summary .syndication-meta .syndication-logo img {\n  width: 100px;\n}\n.uae-syndication-summary .syndication-meta .syndication-counts {\n  display: flex;\n  flex: 1 1;\n  gap: 0 10px;\n  justify-content: flex-end;\n}\n@media screen and (min-width: 799px) {\n  .uae-syndication-summary .syndication-meta .syndication-counts {\n    flex: 0 0;\n    margin-left: auto;\n  }\n}\n.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count {\n  flex: 1 1 auto;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  gap: 0;\n}\n.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count button {\n  min-width: 90px;\n  height: 63px;\n  background: #F3F5F8;\n  border-radius: 8px;\n  border: none;\n  outline: none;\n  color: inherit;\n  cursor: pointer;\n}\n.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count button.active {\n  outline: 2px solid #B2C2D4;\n  cursor: default;\n}\n.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count strong {\n  color: #5A6F89;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count button > div {\n  font-size: 20px;\n  flex: 1 1 100%;\n  height: 22px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0;\n  color: inherit;\n}\n.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-success {\n  color: #73C677;\n}\n.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-failures {\n  color: #FF6464;\n}\n.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-pending {\n  color: #FFA564;\n}\n.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-withdrawn {\n  color: #455870;\n}\n.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-res {\n  color: #455870;\n}\n.uae-syndication-summary .syndication-meta .syndication-counts .syndication-count.syndication-com {\n  color: #455870;\n}\n.notification {\n  padding: 20px 0;\n  box-shadow: 0px 1px 0px #E5EBF1;\n}\n.notification .notification-body {\n  font-size: 12px;\n}\n.notification .notification-body * {\n  font-size: 12px;\n}\n.notification .notification-actions {\n  padding: 20px 0 0;\n}\n.notes-widget .notes-summary {\n  box-shadow: 0px 1px 0px #E5EBF1;\n}\n.notes-widget .notes-summary .agents {\n  display: flex;\n  align-items: center;\n}\n.notes-widget .notes-summary .agents > div {\n  margin-right: 10px;\n}\n.empty.flex-container {\n  justify-content: center;\n}\n.flex-lifetime-sales {\n  flex-direction: column;\n}\n.flex-lifetime-sales > div:nth-child(1) {\n  min-width: 0;\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n.flex-lifetime-sales > div:nth-child(1) > div {\n  flex: 1 1 25%;\n}\n.flex-lifetime-sales > div:nth-child(2) {\n  margin-top: 30px;\n  min-width: 0;\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n.flex-lifetime-sales .strong {\n  color: #70859E;\n}\n.flex-lifetime-sales h1,\n.flex-lifetime-sales h3 {\n  color: #10294D;\n  font-weight: 500;\n  margin: 0;\n}\n.main-sidebar {\n  background: #10294D;\n  position: absolute;\n  display: flex;\n  flex-wrap: wrap;\n  left: 0;\n  top: 68px;\n  min-height: calc(100vh -  68px);\n  z-index: 951;\n  width: 100%;\n  transform: translate3d(-100%, 0, 0);\n}\n.main-sidebar svg {\n  transition: all 0.3s ease 0s;\n}\n.main-sidebar ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  flex: 1 1 100%;\n  max-width: 100%;\n}\n.main-sidebar .scrollview {\n  display: flex;\n  flex-wrap: wrap;\n}\n.main-sidebar .pd-logo {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-top: auto;\n  padding: 20px 0;\n  gap: 10px 0;\n  transition: none;\n  flex: 1 1 100%;\n  max-width: 100%;\n  min-width: 300px;\n}\n.main-sidebar .pd-logo svg {\n  --color1: #ffffff;\n  --color2: #ffffff;\n  width: 215px;\n  height: 32px;\n  flex: 1 1 100%;\n}\n.main-sidebar .pd-logo div {\n  flex: 1 1 100%;\n  display: flex;\n  justify-content: center;\n  color: #92A7C0;\n}\n.main-sidebar .menu-item > .inner-item {\n  min-height: 50px;\n  font-size: 16px;\n}\n.main-sidebar .menu-item {\n  margin: 0;\n  line-height: 1.2;\n  cursor: pointer;\n}\n.main-sidebar .menu-item .inner-item {\n  max-width: 100%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  color: #8894A6;\n}\n.main-sidebar .menu-item .inner-item .menu-icon-wrapper {\n  display: flex;\n  padding: 0 10px;\n  width: 64px;\n  height: 44px;\n  align-items: center;\n  justify-content: center;\n}\n.main-sidebar .menu-item .inner-item .menu-icon-wrapper .menu-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s ease-in-out;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n}\n.main-sidebar .menu-item .inner-item .menu-icon-wrapper svg {\n  flex: 0 0 24px;\n  fill: none;\n  stroke: #ffffff;\n  stroke-width: 1.4;\n  min-width: 24px;\n  height: 24px;\n}\n.main-sidebar .menu-item .inner-item .menu-item-content {\n  white-space: nowrap;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  line-height: inherit;\n  align-content: center;\n  transition: color 0.2s ease-in-out;\n}\n.main-sidebar .menu-item .inner-item .menu-arrow-wrapper {\n  display: flex;\n  width: 44px;\n  height: 44px;\n  align-items: center;\n  justify-content: center;\n  margin-left: auto;\n  transition: transform 0.2s ease-in-out;\n}\n.main-sidebar .menu-item .inner-item .menu-arrow-wrapper svg {\n  display: block;\n  flex: 0 0 24px;\n  fill: none;\n  stroke: #ffffff;\n  stroke-width: 1.4;\n  min-width: 24px;\n  height: 24px;\n}\n.main-sidebar .menu-item:hover > .inner-item .menu-item-content {\n  color: #ffffff;\n}\n.main-sidebar .menu-item:hover .menu-icon {\n  background: #4B5E79;\n}\n.main-sidebar .menu-item.active > .inner-item .menu-item-content {\n  color: #ffffff;\n}\n.main-sidebar .menu-item.active .menu-icon {\n  background: #FC495D;\n}\n.main-sidebar .menu-item.sub-menu.open .menu-arrow-wrapper {\n  transform: rotate(90deg);\n}\n.main-sidebar .list-item {\n  overflow: hidden;\n  padding-left: 64px;\n}\n.main-sidebar .list-item > ul > .menu-item > .inner-item {\n  min-height: 34px;\n  font-size: 14px;\n}\n.main-sidebar .popper-element {\n  max-height: none;\n  padding-left: 0;\n  height: auto !important;\n  position: fixed;\n  visibility: hidden;\n  min-width: 220px;\n  max-width: 270px;\n  background-color: transparent;\n  max-height: 100%;\n  padding-left: 3px;\n}\n.main-sidebar .popper-element .popper-inner {\n  background: #10294D;\n  border-radius: 4px;\n  padding: 7px 0;\n}\n.main-sidebar .popper-element .popper-inner .menu-item {\n  padding: 0 15px;\n}\n.main-sidebar .popper-element .popper-inner .menu-item > .inner-item {\n  font-size: 14px;\n  min-height: 36px;\n}\n.main .full .main-sidebar {\n  transform: translate3d(0, 0, 0);\n}\n.main .full .main-header .navbtn:before {\n  width: 100vw;\n}\n.main .full .main-header .navbtn svg.close {\n  opacity: 1;\n  transform: scale(1);\n}\n.main .full .main-header .navbtn svg.open {\n  opacity: 0;\n  transform: scale(0);\n}\n@media (min-width: 799px) {\n  .main-sidebar {\n    width: 300px;\n    top: auto;\n    height: calc(100vh -  68px);\n    grid-area: nav;\n    transform: translate3d(0, 0, 0);\n  }\n  .main-sidebar .menu-item:hover .popper-element {\n    transition: visibility, transform 0.3s;\n    visibility: visible;\n  }\n  .open .list-item:not(.popper-element) {\n    max-height: 0;\n  }\n  .main .mini {\n    grid-template-columns: 64px 1fr;\n  }\n  .main .mini .main-sidebar {\n    width: 64px;\n  }\n  .main .mini .main-sidebar .nav .navitem span {\n    opacity: 0;\n    line-height: 1px;\n    height: 0px;\n    font-size: 1px;\n  }\n  .main .mini .main-sidebar .pd-logo {\n    display: none;\n  }\n  .main .full {\n    grid-template-columns: 64px 1fr;\n  }\n  .main .full .open .list-item {\n    max-height: none;\n  }\n  .main .full .main-header .navbtn:before {\n    width: 300px;\n  }\n}\n.sidebar-right {\n  background: #ffffff;\n  width: 0;\n  position: absolute;\n  top: 112px;\n  bottom: 0;\n  z-index: 900;\n  right: 0;\n  grid-area: actions;\n  border-left: 1px solid #CFCDCD;\n  overflow: hidden;\n}\n@media screen and (min-width: 799px) {\n  .sidebar-right {\n    top: 134px;\n  }\n}\n.sidebar-right:after {\n  content: \"\";\n  position: absolute;\n  pointer-events: none;\n  right: 100%;\n  width: 0;\n  top: 0;\n  bottom: 0;\n}\n.sidebar-right .sidebar-view {\n  width: 280px;\n}\n.sidebar-right-enter {\n  width: 0;\n}\n.sidebar-right-enter-done {\n  width: 281px;\n}\n.sidebar-right-enter-done:after {\n  width: 60px;\n}\n.sidebar-right-enter-active {\n  width: 280px;\n}\n.sidebar-right-enter-active:after {\n  width: 60px;\n}\n/* Modal */\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1100;\n  background-color: rgba(51, 51, 51, 0.65);\n  display: block;\n}\n.modal-backdrop.nobackground {\n  opacity: 1;\n}\n.modal-wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 948;\n  height: 100%;\n  width: 100%;\n}\n.modal-wrapper .modal {\n  position: relative;\n  z-index: 1200;\n  top: 50%;\n  transform: translateY(-50%);\n  margin: 0 auto;\n  min-width: 300px;\n  max-width: 40%;\n  max-height: 60vh;\n  overflow-y: auto;\n  text-align: center;\n  border-radius: 2px;\n  font-size: 1.2rem;\n  font-weight: 300;\n}\n@media (max-width: 991px) {\n  .modal-wrapper .modal {\n    max-width: 70%;\n  }\n}\n@media (max-width: 799px) {\n  .modal-wrapper .modal {\n    max-width: 90%;\n  }\n}\n.modal-wrapper .modal .card {\n  border: 1px solid #efefef;\n  box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.1);\n  margin-bottom: 0;\n}\n.modal-wrapper .modal .card .cardfoot {\n  border: 0;\n}\n.modal-wrapper .modal .card .cardfoot > .ccontent {\n  display: flex;\n  justify-content: center;\n}\n.modal-wrapper .modal .card .cardfoot .modal-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 10px 5px;\n}\n.modal-wrapper .modal button.close {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n}\n.modal-wrapper .modal button.actionbtn {\n  margin: 20px 0;\n}\n.modal-wrapper h2 {\n  margin: 0 0 20px 0;\n  font-size: 18px;\n  font-weight: normal;\n}\n.modal-wrapper code {\n  background: #eeeeee;\n  font-weight: normal;\n  padding: 3px 6px;\n  font-size: 1rem;\n}\n.snippet-modal {\n  position: absolute;\n  left: 30%;\n  top: 10%;\n  max-height: 270px;\n  width: 280px;\n  overflow: auto;\n  display: none;\n  z-index: 10;\n  border-radius: 8px;\n  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);\n  border: 1px solid #E5EBF1;\n}\n.snippet-modal.showing {\n  display: block;\n}\n.snippet-modal .snippet-container {\n  margin: auto;\n}\n.snippet-modal .snippet-container .card {\n  font-weight: 500;\n  overflow-y: auto;\n  overflow-x: hidden;\n  border-radius: 0;\n  margin-bottom: 0;\n}\n.snippet-modal .snippet-container .card .cardhead {\n  padding: 5px;\n  border-bottom: 1px solid #B2C2D4;\n}\n.snippet-modal .snippet-container .card .cardhead input {\n  padding-left: 5px;\n}\n.snippet-modal .snippet-container .card .cardhead input::-webkit-input-placeholder {\n  /* WebKit browsers */\n  font-size: 12px;\n  font-weight: 600;\n}\n.snippet-modal .snippet-container .card .cardhead input:-moz-placeholder {\n  /* Mozilla Firefox 4 to 18 */\n  font-size: 12px;\n  font-weight: 600;\n}\n.snippet-modal .snippet-container .card .cardhead input::-moz-placeholder {\n  /* Mozilla Firefox 19+ */\n  font-size: 12px;\n  font-weight: 600;\n}\n.snippet-modal .snippet-container .card .cardhead input:-ms-input-placeholder {\n  /* Internet Explorer 10+ */\n  font-size: 12px;\n  font-weight: 600;\n}\n.snippet-modal .snippet-container .card .cardhead .ccontent > div {\n  display: flex;\n}\n.snippet-modal .snippet-container .card .cardhead .ccontent > div input {\n  width: 230px;\n}\n.snippet-modal .snippet-container .card .cardbody {\n  overflow: auto;\n}\n.snippet-modal .snippet-container .card .cardbody .ccontent {\n  padding: 0;\n}\n.snippet-modal .snippet-container .card .cardbody .ccontent .snippet-option {\n  padding: 10px 0px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 5px 10px 5px;\n  line-height: 30px;\n  color: #233142;\n}\n.snippet-modal .snippet-container .card .cardbody .ccontent .snippet-option:hover {\n  cursor: pointer;\n  background-color: #F3F5F8;\n}\n.snippet-modal .snippet-container .card .cardbody .ccontent .snippet-option.selected {\n  background-color: #E5EBF1;\n}\n.context-sidebar {\n  background: #ffffff;\n  position: absolute;\n  top: 136px;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n  transition: all 0.2s ease-in-out;\n  width: 0;\n  min-height: calc(100vh -  68px*2 + 50px);\n}\n.context-sidebar svg {\n  height: 18px;\n}\n.context-menu-cover .nav {\n  min-width: 145px;\n  background: #ffffff;\n  position: absolute;\n  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);\n  border-radius: 4px;\n  z-index: 100;\n  overflow: visible;\n}\n.context-menu-cover .nav > .action {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  position: relative;\n  overflow: visible;\n  height: auto;\n  border-radius: 0;\n}\n.context-menu-cover .nav > .action:first-child {\n  border-radius: 4px 4px 0 0;\n}\n.context-menu-cover .nav > .action:last-child {\n  border-radius: 0 0 4px 4px;\n}\n.context-menu-cover .nav > .action:last-child > .btn,\n.context-menu-cover .nav > .action:last-child.has-submenu > .btn {\n  border-radius: 0 0 4px 4px;\n}\n.context-menu-cover .nav > .action .label {\n  height: auto;\n  line-height: 1.5;\n}\n.context-menu-cover .nav > .action .navicon {\n  margin-right: 10px;\n}\n.context-menu-cover .nav > .action.has-submenu {\n  display: flex;\n  align-content: center;\n  align-items: center;\n}\n.context-menu-cover .nav > .action.has-submenu .navitem {\n  display: flex;\n  border-radius: 0;\n  flex: 1 1 100%;\n  align-content: center;\n  align-items: center;\n  padding-right: 6px;\n}\n.context-menu-cover .nav > .action.has-submenu .navicon.submenu-icon {\n  margin-left: auto;\n  flex: 0 0 auto;\n  margin-right: 0;\n  transform: rotate(-90deg);\n}\n.context-menu-cover .nav > .action.has-submenu .navicon.submenu-icon svg {\n  stroke: #10294D;\n  stroke-width: 1.4;\n  min-width: 24px;\n  height: 24px;\n}\n.context-menu-cover .nav > .action.has-submenu .action-submenu {\n  display: none;\n  position: absolute;\n  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);\n  top: 0;\n  left: 100%;\n  overflow: hidden;\n  padding-left: 5px;\n}\n.context-menu-cover .nav > .action.has-submenu .action-submenu .action-submenu-inner {\n  min-width: 145px;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);\n  border-radius: 4px;\n  overflow: hidden;\n}\n.context-menu-cover .nav > .action.has-submenu .action-submenu .action-sub-item {\n  text-align: left;\n  cursor: pointer;\n  white-space: nowrap;\n  padding: 0.75rem 0.8em;\n  background: #fff;\n  border: 0 none;\n  transition: background-color 0.2s ease-in-out;\n}\n.context-menu-cover .nav > .action.has-submenu .action-submenu .action-sub-item:hover {\n  background: #CED7E2;\n}\n.context-menu-cover-wrapper {\n  overflow: visible;\n  position: absolute;\n}\n.context-menu-cover-backdrop {\n  overflow: visible;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n  transform: translateZ(0);\n  background-color: rgba(0, 0, 0, 0);\n}\n.content:not(.form-group) {\n  grid-area: content;\n  display: grid;\n  grid-template-areas: \"actions\" \"view\";\n  grid-template-rows: 67px 1fr;\n  position: relative;\n  background: #F3F5F8;\n  transition: left 0.2s ease-in-out, margin-right 0.2s ease-in-out;\n  left: 0;\n  right: 0;\n  will-change: left margin-right;\n  min-height: 0;\n}\n@media screen and (min-width: 799px) {\n  .content:not(.form-group) {\n    grid-template-columns: 1fr;\n  }\n}\n.content:not(.form-group).canvassing {\n  grid-template-rows: 127px auto;\n}\n.view:not(.action) {\n  grid-area: view;\n  min-height: 0;\n  min-width: 0;\n  padding: 0;\n}\n.view:not(.action) .viewcontent {\n  display: grid;\n  grid-template-rows: 1fr auto;\n  grid-template-columns: 1fr;\n  grid-template-areas: \"content\";\n  padding: 10px;\n  grid-area: content;\n  height: 100%;\n  width: 100%;\n  overflow: auto;\n}\n@media screen and (min-width: 281px) {\n  .view:not(.action) .viewcontent {\n    padding: 20px;\n  }\n}\n.view:not(.action) .viewcontent > div {\n  grid-area: content;\n  min-width: 0;\n}\n.view:not(.action) .viewcontent > div.horizontal-tabs-container,\n.view:not(.action) .viewcontent > div:not(.brochure-generator) .horizontal-tabs-container {\n  margin: -20px -20px -20px -20px;\n}\n.integrations .viewcontent {\n  padding: 15px 0;\n}\n.integrations .viewcontent .integrations-group .ccontent {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.integrations .viewcontent .integrations-group .ccontent > div {\n  flex: 1 1 auto;\n}\n.integrations .viewcontent .integrations-group .ccontent .editgroup {\n  align-items: center;\n  justify-content: flex-end;\n}\n.integrations .viewcontent .integrations-group .ccontent .editgroup .input-group {\n  flex: 0 1 auto;\n  padding-left: 10px;\n}\n.integrations .viewcontent .integrations-group .ccontent .editgroup .input-group .forminput {\n  justify-content: flex-end;\n}\n.integrations .viewcontent .integrations-group .lightstone-logo {\n  width: 146px;\n  height: 49px;\n  flex: 0 0 146px;\n  color: #071B38;\n  background-image: url(\"../../images/lightstone-dark.svg\");\n  background-size: contain;\n  background-position: center center;\n  background-repeat: no-repeat;\n  margin: 0 0 20px 0;\n}\n.integrations .viewcontent .integrations-group .flow-logo {\n  width: 146px;\n  height: 49px;\n  flex: 0 0 146px;\n  color: #071B38;\n  background-image: url(\"../../images/flow.svg\");\n  background-size: contain;\n  background-position: center center;\n  background-repeat: no-repeat;\n  margin: 0 0 20px 0;\n}\n.integrations .viewcontent .integrations-group .reos-logo {\n  width: 146px;\n  height: 49px;\n  flex: 0 0 146px;\n  color: #071B38;\n  background-image: url(\"../../images/reos.svg\");\n  background-size: contain;\n  background-position: center center;\n  background-repeat: no-repeat;\n  margin: 0 0 20px 0;\n}\n.content.main-dashboard .actionswrap .action-list {\n  justify-content: flex-start;\n}\n.rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  -moz-appearance: button;\n  appearance: button;\n  cursor: pointer;\n}\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n.rbc-calendar {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n.rbc-calendar * {\n  -webkit-box-sizing: inherit;\n  box-sizing: inherit;\n}\n.rbc-calendar *:before {\n  -webkit-box-sizing: inherit;\n  box-sizing: inherit;\n}\n.rbc-calendar *:after {\n  -webkit-box-sizing: inherit;\n  box-sizing: inherit;\n}\n.rbc-m-b-negative-3 {\n  margin-bottom: -3px;\n}\n.rbc-h-full {\n  height: 100%;\n}\n.rbc-abs-full {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.rbc-row-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  overflow: hidden;\n  right: 1px;\n}\n.rbc-ellipsis {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rbc-show-more {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 4;\n  font-weight: bold;\n  height: auto;\n  line-height: normal;\n  color: #3174ad;\n}\n.rbc-show-more:hover {\n  color: #265985;\n}\n.rbc-show-more:focus {\n  color: #265985;\n}\n.rbc-row-segment {\n  padding: 0 1px 1px 1px;\n}\n.rbc-row-segment .rbc-event-content {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rbc-event-label {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rbc-rtl {\n  direction: rtl;\n}\n.rbc-rtl .rbc-header + .rbc-header {\n  border-left-width: 0;\n  border-right: 1px solid #E5EBF1;\n}\n.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {\n  border-radius: 4px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {\n  border-radius: 4px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-rtl .rbc-btn-group button + button {\n  margin-left: 0;\n  margin-right: -1px;\n}\n.rbc-rtl .rbc-day-bg + .rbc-day-bg {\n  border-left-width: 0;\n  border-right: 1px solid #E5EBF1;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left-width: 0;\n  border-right: 1px solid #E5EBF1;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  text-align: right;\n}\n.rbc-rtl .rbc-time-header.rbc-overflowing {\n  border-right-width: 0;\n}\n.rbc-rtl .rbc-time-header-content {\n  border-left-width: 0;\n}\n.rbc-rtl .rbc-time-content > * + * > * {\n  border-left-width: 0;\n  border-right: 1px solid #E5EBF1;\n}\n.rbc-off-range {\n  color: #999999;\n}\n.rbc-off-range-bg {\n  background: #e6e6e6;\n}\n.rbc-header {\n  overflow: hidden;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: center;\n  min-height: 45px;\n  display: inline-flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n}\n.rbc-header > a {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-header > a:active {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-header > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-button-link {\n  color: #10294D;\n  font-weight: 600;\n  background: none;\n  margin: 0;\n  padding: 0;\n  border: none;\n  cursor: pointer;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n.rbc-row-content {\n  position: relative;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n  z-index: 4;\n}\n.rbc-row-content-scrollable {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  height: 100%;\n}\n.rbc-row-content-scrollable .rbc-row-content-scroll-container {\n  height: 100%;\n  overflow-y: scroll;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n.rbc-row-content-scrollable .rbc-row-content-scroll-container::-webkit-scrollbar {\n  display: none;\n}\n.rbc-today {\n  background-color: #FAFBFD;\n}\n.rbc-toolbar {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: 10px;\n}\n.rbc-toolbar .rbc-toolbar-label {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  padding: 0 10px;\n  text-align: center;\n  font-weight: 600;\n  color: #10294D;\n}\n.rbc-btn-group {\n  display: inline-block;\n  white-space: nowrap;\n}\n.rbc-btn-group > button:first-child:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:last-child:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-btn-group > button:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.rbc-btn-group button + button {\n  margin-left: -1px;\n}\n.rbc-btn-group + .rbc-btn-group {\n  margin-left: 10px;\n}\n.rbc-btn-group + button {\n  margin-left: 10px;\n}\n.rbc-event {\n  border: none;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  margin: 0;\n  padding: 2px 5px;\n  background-color: #EBF5FF;\n  border-radius: 5px;\n  color: #3699FE;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  font-size: 11px;\n}\n.rbc-day-slot {\n  position: relative;\n}\n.rbc-day-slot .rbc-background-event {\n  border: none;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  margin: 0;\n  padding: 2px 5px;\n  background-color: #3174ad;\n  border-radius: 5px;\n  color: #fff;\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  border: 1px solid #265985;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  max-height: 100%;\n  min-height: 20px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-flow: column wrap;\n  flex-flow: column wrap;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  overflow: hidden;\n  position: absolute;\n  opacity: 0.75;\n}\n.rbc-day-slot .rbc-background-event:focus {\n  outline: 5px auto #3b99fc;\n}\n.rbc-day-slot .rbc-slot-selecting .rbc-background-event {\n  cursor: inherit;\n  pointer-events: none;\n}\n.rbc-day-slot .rbc-selected.rbc-background-event {\n  background-color: #265985;\n}\n.rbc-day-slot .rbc-events-container {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  margin-right: 10px;\n  top: 0;\n}\n.rbc-day-slot .rbc-events-container .tc-tooltip {\n  margin-left: 10px;\n  margin-top: 5px;\n  min-width: 100%;\n  max-width: none;\n  width: 130%;\n  border: 0 none;\n  background: #ffffff;\n  box-shadow: 0px 16px 32px #DCDEDF;\n  padding: 12px 15px;\n}\n.rbc-day-slot .rbc-events-container .tc-tooltip .tc-tooltip-title {\n  background: none;\n  border: 0 none;\n}\n.rbc-day-slot .rbc-events-container .tc-tooltip .tc-tooltip-title .btn {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n.rbc-day-slot .rbc-events-container .tc-tooltip .tc-tooltip-content {\n  background: none;\n  border: 0 none;\n}\n.rbc-day-slot .rbc-events-container .tc-tooltip .tc-tooltip-content .btn {\n  display: inline-flex;\n  margin-top: 8px;\n}\n.rbc-day-slot .rbc-events-container.rbc-rtl {\n  left: 10px;\n  right: 0;\n}\n.rbc-day-slot .rbc-event {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  max-height: 100%;\n  min-height: 20px;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-flow: column wrap;\n  flex-flow: column wrap;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  overflow: hidden;\n  position: absolute;\n}\n.rbc-day-slot .rbc-event-label {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n  flex: none;\n  padding-right: 5px;\n  width: auto;\n}\n.rbc-day-slot .rbc-event-content {\n  width: 100%;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 0px;\n  flex: 1 1 0;\n  word-wrap: break-word;\n  line-height: 1;\n  height: 100%;\n  min-height: 1em;\n}\n.rbc-day-slot .rbc-time-slot {\n  border-top: 1px solid #f7f7f7;\n}\n.rbc-slot-selecting {\n  cursor: move;\n}\n.rbc-slot-selecting .rbc-event {\n  cursor: inherit;\n  pointer-events: none;\n}\n.rbc-slot-selecting .rbc-day-slot .rbc-background-event {\n  cursor: inherit;\n  pointer-events: none;\n}\n.rbc-event.rbc-selected {\n  background-color: #CDE4FE;\n}\n.rbc-event-overlaps {\n  -webkit-box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n.rbc-selected-cell {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.rbc-month-view {\n  position: relative;\n  border: 1px solid #E5EBF1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  width: 100%;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n  height: 100%;\n}\n.rbc-month-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n.rbc-month-row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  -ms-flex-preferred-size: 0px;\n  flex-basis: 0px;\n  overflow: hidden;\n  height: 100%;\n}\n.rbc-month-row + .rbc-month-row {\n  border-top: 1px solid #E5EBF1;\n}\n.rbc-date-cell {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 0px;\n  flex: 1 1 0;\n  min-width: 0;\n  padding-right: 5px;\n  text-align: right;\n}\n.rbc-date-cell > a {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-date-cell > a:active {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-date-cell > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-date-cell.rbc-now {\n  font-weight: bold;\n}\n.rbc-day-bg {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n}\n.rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid #E5EBF1;\n}\n.rbc-overlay {\n  position: absolute;\n  z-index: 5;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  padding: 10px;\n}\n.rbc-overlay > * + * {\n  margin-top: 1px;\n}\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px;\n  padding: 2px 10px;\n}\n.rbc-agenda-view {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  overflow: auto;\n}\n.rbc-agenda-view table.rbc-agenda-table {\n  width: 100%;\n  border: 1px solid #E5EBF1;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n  padding: 5px 10px;\n  vertical-align: top;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left: 1px solid #E5EBF1;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {\n  border-top: 1px solid #E5EBF1;\n}\n.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {\n  padding-left: 15px;\n  padding-right: 15px;\n  text-transform: lowercase;\n}\n.rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  padding: 3px 5px;\n  text-align: left;\n  border-bottom: 1px solid #E5EBF1;\n}\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n  white-space: nowrap;\n}\n.rbc-agenda-time-cell .rbc-continues-after:after {\n  content: \" »\";\n}\n.rbc-agenda-time-cell .rbc-continues-prior:before {\n  content: \"« \";\n}\n.rbc-agenda-date-cell {\n  white-space: nowrap;\n}\n.rbc-agenda-event-cell {\n  width: 100%;\n}\n.rbc-time-column {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  min-height: 100%;\n}\n.rbc-time-column .rbc-timeslot-group {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.rbc-timeslot-group {\n  border-bottom: 1px solid #E5EBF1;\n  min-height: 40px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-flow: column nowrap;\n  flex-flow: column nowrap;\n}\n.rbc-time-gutter {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n  flex: none;\n}\n.rbc-header-gutter {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n  flex: none;\n}\n.rbc-label {\n  padding: 0 5px;\n}\n.rbc-time-view-resources .rbc-time-gutter {\n  position: sticky;\n  left: 0;\n  background-color: white;\n  border-right: 1px solid #E5EBF1;\n  z-index: 10;\n  margin-right: -1px;\n}\n.rbc-time-view-resources .rbc-time-header-gutter {\n  position: sticky;\n  left: 0;\n  background-color: white;\n  border-right: 1px solid #E5EBF1;\n  z-index: 10;\n  margin-right: -1px;\n}\n.rbc-time-view-resources .rbc-time-header {\n  overflow: hidden;\n}\n.rbc-time-view-resources .rbc-time-header-content {\n  min-width: auto;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  -ms-flex-preferred-size: 0px;\n  flex-basis: 0px;\n}\n.rbc-time-view-resources .rbc-time-header-cell-single-day {\n  display: none;\n}\n.rbc-time-view-resources .rbc-day-slot {\n  min-width: 140px;\n}\n.rbc-time-view-resources .rbc-header {\n  width: 140px;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 0px;\n  flex: 1 1 0;\n  -ms-flex-preferred-size: 0 px;\n  flex-basis: 0 px;\n}\n.rbc-time-view-resources .rbc-day-bg {\n  width: 140px;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 1 0px;\n  flex: 1 1 0;\n  -ms-flex-preferred-size: 0 px;\n  flex-basis: 0 px;\n}\n.rbc-time-header-content {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-width: 0;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n.rbc-time-header-content + .rbc-time-header-content {\n  margin-left: -1px;\n}\n.rbc-time-header-content > .rbc-row.rbc-row-resource {\n  border-bottom: 1px solid #E5EBF1;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n.rbc-time-slot {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 11px;\n  color: #10294D;\n  font-weight: 600;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n}\n.rbc-time-slot.rbc-now {\n  font-weight: bold;\n}\n.rbc-day-header {\n  text-align: center;\n}\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  width: 100%;\n  padding: 3px;\n}\n.rbc-time-view {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  width: 100%;\n  min-height: 0;\n}\n.rbc-time-view .rbc-time-gutter {\n  white-space: nowrap;\n  text-align: right;\n}\n.rbc-time-view .rbc-allday-cell {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: none;\n}\n.rbc-time-view .rbc-allday-cell + .rbc-allday-cell {\n  border-left: 1px solid #E5EBF1;\n}\n.rbc-time-view .rbc-allday-events {\n  position: relative;\n  z-index: 4;\n}\n.rbc-time-view .rbc-row {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  min-height: 20px;\n}\n.rbc-time-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n.rbc-time-header > .rbc-row:first-child {\n  border-bottom: 1px solid #E5EBF1;\n}\n.rbc-time-header > .rbc-row.rbc-row-resource {\n  border-bottom: 1px solid #E5EBF1;\n}\n.rbc-time-header-cell-single-day {\n  display: none;\n}\n.rbc-time-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  width: 100%;\n  overflow-y: auto;\n  position: relative;\n  border: 1px solid #E5EBF1;\n}\n.rbc-time-content > .rbc-time-gutter {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n  flex: none;\n}\n.rbc-time-content > * + * > * {\n  border-left: 1px solid #E5EBF1;\n}\n.rbc-time-content > .rbc-day-slot {\n  width: 100%;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 3;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background-color: #FC495D;\n  pointer-events: none;\n}\n.rbc-resource-grouping.rbc-time-header-content {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n.rbc-resource-grouping .rbc-row .rbc-header {\n  width: 141px;\n}\n@media (max-width: 767px) {\n  .rbc-toolbar {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n}\n.rbc-week-toolbar {\n  display: inline-flex;\n  align-items: center;\n  font-size: 16px;\n}\n.wide-sidebar {\n  width: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 949;\n  background: #ffffff;\n  position: absolute;\n  top: 114px;\n  max-height: calc(100vh - 114px);\n  display: flex;\n}\n@media (min-width: 799px) {\n  .wide-sidebar {\n    top: 67px;\n    max-height: calc(100vh - 67px);\n  }\n}\n.wide-sidebar:after {\n  content: \"\";\n  position: absolute;\n  pointer-events: none;\n  right: 100%;\n  width: 0;\n  top: 0;\n  bottom: 0;\n  background: linear-gradient(270deg, rgba(31, 41, 51, 0.15) 0%, rgba(31, 41, 51, 0) 100%);\n}\n.wide-sidebar .sidebar-view {\n  width: 100vw;\n}\n.wide-sidebar-enter {\n  width: 0;\n}\n.wide-sidebar-enter-done {\n  width: 100vw;\n}\n.wide-sidebar-enter-done:after {\n  width: 60px;\n}\n.wide-sidebar-enter-active {\n  width: 100vw;\n}\n.wide-sidebar-enter-active:after {\n  width: 60px;\n}\n@media (min-width: 799px) {\n  .wide-sidebar .sidebar-view {\n    width: 844px;\n  }\n  .wide-sidebar-enter {\n    width: 0;\n  }\n  .wide-sidebar-enter-done {\n    width: 844px;\n  }\n  .wide-sidebar-enter-done:after {\n    width: 60px;\n  }\n  .wide-sidebar-enter-active {\n    width: 844px;\n  }\n  .wide-sidebar-enter-active:after {\n    width: 60px;\n  }\n}\n.wide-sidebar .wide-sidebar-container {\n  list-style: none;\n  margin: 0;\n  padding: 0 0;\n  position: sticky;\n  top: 0;\n  width: 100%;\n  grid-template-rows: 50px auto;\n  justify-content: space-between;\n  overflow: hidden;\n}\n@media (min-width: 799px) {\n  .wide-sidebar .wide-sidebar-container {\n    width: 844px;\n  }\n}\n.wide-sidebar .wide-sidebar-content {\n  position: relative;\n  background: #ffffff;\n  padding: 20px 20px 120px;\n  min-width: 280px;\n}\n@media (min-width: 799px) {\n  .wide-sidebar .wide-sidebar-content {\n    width: 844px;\n    padding: 20px 40px 120px;\n  }\n}\n.wide-sidebar .wide-sidebar-content .editgroup {\n  margin-top: 27px;\n}\n.wide-sidebar .wide-sidebar-content .editgroup .btmatches {\n  width: 100%;\n}\n.wide-sidebar .wide-sidebar-heading {\n  position: sticky;\n  background: #F3F5F8;\n  top: 0;\n  z-index: 10;\n  min-height: 84px;\n  display: flex;\n  align-items: center;\n  padding: 0 20px;\n}\n@media (min-width: 799px) {\n  .wide-sidebar .wide-sidebar-heading {\n    padding: 0 40px;\n  }\n}\n.wide-sidebar .wide-sidebar-heading .btn-wide-sidebar-close {\n  margin-left: auto;\n  margin-right: -20px;\n}\n.wide-sidebar .wide-sidebar-heading h4 {\n  margin: 0;\n}\n.wide-sidebar .wide-sidebar-footer {\n  padding: 15px 0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 20px 20px;\n}\n.wide-sidebar .wide-sidebar-footer button {\n  min-height: 36px;\n}\n.model-selector-sidebar.wide-sidebar .datatablewrap {\n  min-width: 100%;\n}\n.model-selector-sidebar.wide-sidebar .search-buttons {\n  display: flex;\n  justify-content: end;\n  gap: 10px;\n  width: 100%;\n}\n.model-selector-sidebar.wide-sidebar .editgroup + .search-buttons {\n  margin-top: 20px;\n}\n.model-selector-sidebar.wide-sidebar .editgroup:has(.listbody) {\n  gap: 0;\n}\n.model-selector-sidebar.wide-sidebar .term {\n  margin-bottom: 15px;\n}\n.model-selector-sidebar.wide-sidebar .recipients-search .term {\n  margin-bottom: 0px;\n}\n.deeds-lookup-sidebar tbody td:last-of-type svg:hover {\n  cursor: pointer;\n}\n.deeds-lookup-sidebar .keyword-search {\n  box-shadow: 0px 1px 0 #F3F5F8;\n  padding-bottom: 20px;\n}\n.datatable.locationselector {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n.datatable.locationselector .datatable-headers {\n  display: grid;\n  padding: 0 10px;\n  margin-bottom: 10px;\n}\n.datatable.locationselector .datatable-headers[data-columns=\"3\"] {\n  grid-template-columns: 160px 0.7fr 0.3fr;\n}\n.datatable.locationselector .datatable-headers[data-columns=\"4\"] {\n  grid-template-columns: 160px 112px 234px 0.3fr;\n}\n.datatable.locationselector .datatable-headers[data-columns=\"5\"] {\n  grid-template-columns: 170px 170px 170px 210px auto 0.3fr;\n}\n.datatable.locationselector .datatable-headers[data-columns=\"7\"] {\n  grid-template-columns: 140px 140px 120px 120px 120px 80px auto 0.3fr;\n}\n.datatable.locationselector .datatable-headers[data-columns=\"8\"] {\n  grid-template-columns: 140px 140px 80px 80px 80px 80px 100px auto 0.3fr;\n}\n.datatable.locationselector .datatable-headers > div {\n  display: inline-flex;\n  align-items: center;\n  min-height: 34px;\n  text-transform: uppercase;\n  font-size: 10px;\n  font-weight: 700;\n  color: #455870;\n}\n.datatable.locationselector .datatable-headers > div.centered {\n  justify-content: center;\n}\n.datatable.locationselector .datatable-body {\n  gap: 10px 0;\n  display: flex;\n  flex-direction: column;\n}\n.datatable.locationselector .datatable-body .datatable-row {\n  display: grid;\n  font-size: 12px;\n  color: #5A6F89;\n  border: 1px solid #E5EBF1;\n  border-radius: 8px;\n  box-shadow: 0px 2px 4px rgba(195, 201, 210, 0.31);\n  padding: 0 10px;\n}\n.datatable.locationselector .datatable-body .datatable-row:hover {\n  background: #F3F5F8;\n}\n.datatable.locationselector .datatable-body .datatable-row > div {\n  display: inline-flex;\n  align-items: center;\n  min-height: 44px;\n  font-size: 12px;\n  color: #5A6F89;\n}\n.datatable.locationselector .datatable-body .datatable-row > div .btn {\n  padding-left: 0;\n  padding-right: 0;\n}\n.datatable.locationselector .datatable-body .datatable-row > div.centered {\n  justify-content: center;\n}\n.datatable.locationselector .datatable-body .datatable-row > div.right {\n  justify-content: right;\n}\n.datatable.locationselector .datatable-body .datatable-row svg {\n  fill: none;\n  stroke: #5A6F89;\n  stroke-width: 2.4;\n}\n.datatable.locationselector .datatable-body[data-columns=\"3\"] .datatable-row {\n  grid-template-columns: 160px auto 24px;\n}\n.datatable.locationselector .datatable-body[data-columns=\"3\"] .datatable-row.datatable-row-empty {\n  grid-template-columns: auto;\n}\n.datatable.locationselector .datatable-body[data-columns=\"4\"] .datatable-row {\n  grid-template-columns: 160px 112px auto 24px;\n}\n.datatable.locationselector .datatable-body[data-columns=\"4\"] .datatable-row.datatable-row-empty {\n  grid-template-columns: auto;\n}\n.datatable.locationselector .datatable-body[data-columns=\"5\"] .datatable-row {\n  grid-template-columns: 170px 170px 170px 210px auto 0.3fr;\n}\n.datatable.locationselector .datatable-body[data-columns=\"5\"] .datatable-row.datatable-row-empty {\n  grid-template-columns: auto;\n}\n.datatable.locationselector .datatable-body[data-columns=\"7\"] .datatable-row {\n  grid-template-columns: 140px 140px 120px 120px 120px 80px auto 0.3fr;\n}\n.datatable.locationselector .datatable-body[data-columns=\"7\"] .datatable-row.datatable-row-empty {\n  grid-template-columns: auto;\n}\n.datatable.locationselector .datatable-body[data-columns=\"8\"] .datatable-row {\n  grid-template-columns: 140px 140px 80px 80px 80px 80px 100px auto 0.3fr;\n}\n.datatable.locationselector .datatable-body[data-columns=\"8\"] .datatable-row.datatable-row-empty {\n  grid-template-columns: auto;\n}\n.datatable.locationselector .tablecell {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding-right: 10px;\n}\n.datatable.locationselector .tablecell img {\n  max-width: 90px;\n}\n.datatable.locationselector .tablecell svg {\n  height: 13px;\n}\n.datatable.locationselector .tablecell svg.success {\n  fill: #DFB0F4;\n}\n.datatable.locationselector .tablecell svg.pending {\n  fill: #ff7400;\n}\n.datatable.locationselector .tablecell svg.unknown,\n.datatable.locationselector .tablecell svg.failed {\n  fill: #EB4A36;\n}\n.datatable.locationselector .tablecell.ellipses {\n  min-width: 167px;\n}\n.datatable.contactselector {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n.datatable.contactselector .datatable-headers {\n  display: grid;\n  padding: 0 10px;\n  margin-bottom: 10px;\n}\n.datatable.contactselector .datatable-headers[data-columns=\"3\"] {\n  grid-template-columns: 100px 0.7fr 0.3fr;\n}\n.datatable.contactselector .datatable-headers[data-columns=\"5\"] {\n  grid-template-columns: 140px 112px 234px 234px 0.3fr;\n}\n.datatable.contactselector .datatable-headers[data-columns=\"6\"] {\n  grid-template-columns: 100px 140px 140px 112px 230px 0.3fr;\n}\n.datatable.contactselector .datatable-headers > div {\n  display: inline-flex;\n  align-items: center;\n  min-height: 34px;\n  text-transform: uppercase;\n  font-size: 10px;\n  font-weight: 700;\n  color: #455870;\n}\n.datatable.contactselector .datatable-body {\n  gap: 10px 0;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n}\n.datatable.contactselector .datatable-body .datatable-row {\n  display: grid;\n  font-size: 12px;\n  color: #5A6F89;\n  border: 1px solid #E5EBF1;\n  border-radius: 8px;\n  box-shadow: 0px 2px 4px rgba(195, 201, 210, 0.31);\n  padding: 0 10px;\n}\n.datatable.contactselector .datatable-body .datatable-row:hover {\n  background: #F3F5F8;\n}\n.datatable.contactselector .datatable-body .datatable-row > div {\n  display: inline-flex;\n  align-items: center;\n  min-height: 44px;\n  font-size: 12px;\n  color: #5A6F89;\n}\n.datatable.contactselector .datatable-body .datatable-row > div .btn {\n  padding-left: 0;\n  padding-right: 0;\n}\n.datatable.contactselector .datatable-body .datatable-row svg {\n  fill: none;\n  stroke: #5A6F89;\n  stroke-width: 2.4;\n}\n.datatable.contactselector .datatable-body[data-columns=\"3\"] .datatable-row {\n  grid-template-columns: 100px auto 24px;\n}\n.datatable.contactselector .datatable-body[data-columns=\"3\"] .datatable-row.datatable-row-empty {\n  grid-template-columns: auto;\n}\n.datatable.contactselector .datatable-body[data-columns=\"5\"] .datatable-row {\n  grid-template-columns: 140px 112px 234px 234px 0.3fr;\n}\n.datatable.contactselector .datatable-body[data-columns=\"5\"] .datatable-row.datatable-row-empty {\n  grid-template-columns: auto;\n}\n.datatable.contactselector .datatable-body[data-columns=\"6\"] .datatable-row {\n  grid-template-columns: 100px 140px 140px 112px 230px 0.3fr;\n}\n.datatable.contactselector .datatable-body[data-columns=\"6\"] .datatable-row.datatable-row-empty {\n  grid-template-columns: auto;\n}\n.datatable.contactselector .tablecell {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding-right: 10px;\n}\n.datatable.contactselector .tablecell img {\n  max-width: 90px;\n}\n.datatable.contactselector .tablecell svg {\n  height: 13px;\n}\n.datatable.contactselector .tablecell svg.success {\n  fill: #DFB0F4;\n}\n.datatable.contactselector .tablecell svg.pending {\n  fill: #ff7400;\n}\n.datatable.contactselector .tablecell svg.unknown,\n.datatable.contactselector .tablecell svg.failed {\n  fill: #EB4A36;\n}\n.datatable.contactselector .tablecell.ellipses {\n  min-width: 167px;\n}\n.credit-report {\n  display: flex;\n  flex-direction: column;\n  gap: 20px 20px;\n}\n.credit-report .report-tags {\n  display: flex;\n}\n.credit-report .report-tags .tag-label {\n  padding: 5px 8px;\n  background: #FC495D;\n  color: #ffffff;\n  font-size: 11px;\n  flex: 0 0;\n  border-radius: 50px;\n}\n.credit-report .report-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px 20px;\n}\n.credit-report .report-information {\n  display: flex;\n  flex-direction: column;\n  gap: 10px 20px;\n}\n.credit-report .report-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 20px;\n  background: #FAFBFD;\n  padding: 20px;\n}\n.credit-report .report-summary > div {\n  flex: 0 1 48%;\n}\n/* Tables */\n.datatablewrap-inner {\n  max-width: 100%;\n  overflow: auto;\n}\n.datatable {\n  width: 100%;\n  border-spacing: 0;\n  border-collapse: separate;\n  font-size: 12px;\n  margin-bottom: 1px;\n}\n.datatable .checkcontainer {\n  min-height: 0;\n  height: auto;\n}\n.datatable thead tr:first-child td:first-child,\n.datatable thead tr:first-child th:first-child {\n  overflow: hidden;\n}\n.datatable thead tr:first-child td:last-child,\n.datatable thead tr:first-child th:last-child {\n  overflow: hidden;\n}\n.datatable thead th {\n  vertical-align: bottom;\n  padding: 0;\n}\n.datatable tfoot tr:first-child td:first-child,\n.datatable tfoot tr:first-child th:first-child {\n  border-bottom-left-radius: 4px;\n  overflow: hidden;\n}\n.datatable tfoot tr:first-child td:last-child,\n.datatable tfoot tr:first-child th:last-child {\n  border-bottom-right-radius: 4px;\n  overflow: hidden;\n}\n.datatable tfoot th {\n  vertical-align: top;\n  padding: 0;\n}\n.datatable label.tooltip {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translate(-50%, 0);\n  padding: 10px 15px;\n  background-color: #fff;\n  font-weight: 400;\n  border-radius: 3px;\n  text-align: center;\n  border: 1px solid #efefef;\n  box-shadow: 4px 4px 3px -2px rgba(0, 0, 0, 0.3);\n}\n.datatable svg {\n  vertical-align: middle;\n}\n.datatable thead:not(:has(th[rowspan=\"2\"])),\n.datatable tfoot:not(:has(th[rowspan=\"2\"])) {\n  background: #F3F5F8;\n}\n.datatable thead td,\n.datatable tfoot td,\n.datatable thead th,\n.datatable tfoot th {\n  position: relative;\n  overflow: visible;\n  white-space: nowrap;\n  font-size: 10px;\n  font-weight: 600;\n  color: #5A6F89;\n  padding: 0;\n}\n.datatable thead td .heading-wrapper,\n.datatable tfoot td .heading-wrapper,\n.datatable thead th .heading-wrapper,\n.datatable tfoot th .heading-wrapper {\n  display: flex;\n  align-items: center;\n  padding: 5px 8px;\n  background: #F3F5F8;\n  min-height: 40px;\n}\n.datatable thead td .heading-wrapper .heading,\n.datatable tfoot td .heading-wrapper .heading,\n.datatable thead th .heading-wrapper .heading,\n.datatable tfoot th .heading-wrapper .heading {\n  flex: 0 0 auto;\n}\n.datatable thead td .heading-wrapper .heading + svg,\n.datatable tfoot td .heading-wrapper .heading + svg,\n.datatable thead th .heading-wrapper .heading + svg,\n.datatable tfoot th .heading-wrapper .heading + svg {\n  flex: 0 0 16px;\n  min-width: 16px;\n  fill: #CED7E2;\n  --color1: #CED7E2;\n}\n.datatable thead td.text-right .heading-wrapper,\n.datatable tfoot td.text-right .heading-wrapper,\n.datatable thead th.text-right .heading-wrapper,\n.datatable tfoot th.text-right .heading-wrapper {\n  justify-content: flex-end;\n}\n.datatable thead td.text-center .heading-wrapper,\n.datatable tfoot td.text-center .heading-wrapper,\n.datatable thead th.text-center .heading-wrapper,\n.datatable tfoot th.text-center .heading-wrapper {\n  justify-content: center;\n}\n.datatable thead td.column-check,\n.datatable tfoot td.column-check,\n.datatable thead th.column-check,\n.datatable tfoot th.column-check {\n  width: 25px;\n}\n.datatable thead td.orderable .heading,\n.datatable tfoot td.orderable .heading,\n.datatable thead th.orderable .heading,\n.datatable tfoot th.orderable .heading {\n  cursor: pointer;\n  text-transform: uppercase;\n}\n.datatable thead td.orderable .heading + svg,\n.datatable tfoot td.orderable .heading + svg,\n.datatable thead th.orderable .heading + svg,\n.datatable tfoot th.orderable .heading + svg {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  fill: #CED7E2;\n  --color1: #CED7E2;\n  --color4: #CED7E2;\n}\n.datatable thead td:hover label.tooltip,\n.datatable tfoot td:hover label.tooltip,\n.datatable thead th:hover label.tooltip,\n.datatable tfoot th:hover label.tooltip {\n  display: block;\n}\n.datatable thead td .checkmark,\n.datatable tfoot td .checkmark,\n.datatable thead th .checkmark,\n.datatable tfoot th .checkmark {\n  background-color: #fff;\n}\n.datatable thead .grouper {\n  z-index: 0;\n  min-height: 20px;\n  text-transform: uppercase;\n  padding: 0 8px;\n}\n.datatable thead .grouper:before {\n  content: \"\";\n  background: #E5EBF1;\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 1px;\n  right: 1px;\n  bottom: 0;\n}\n.datatable tfoot .grouper {\n  z-index: 0;\n  min-height: 20px;\n  text-transform: uppercase;\n  padding: 0 8px;\n}\n.datatable tfoot .grouper:before {\n  content: \"\";\n  background: #E5EBF1;\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  left: 1px;\n  right: 1px;\n  bottom: 0;\n}\n.datatable tbody tr td {\n  box-shadow: 0px 1px 0px #E5EBF1;\n}\n.datatable tbody tr td .cell-wrapper {\n  max-width: 100%;\n  display: block;\n}\n.datatable tbody tr td .icon.viewicon svg {\n  fill: none;\n  stroke: #10294D;\n}\n.datatable tbody tr .checkmark {\n  background-color: #fff;\n}\n.datatable tbody tr .checkcontainer {\n  min-height: auto;\n  height: auto;\n  margin: 0 auto;\n}\n.datatable tbody tr .column-cell_number,\n.datatable tbody tr .column-metacontactcell_number {\n  max-width: 200px;\n}\n.datatable tbody tr .column-cell_number svg,\n.datatable tbody tr .column-metacontactcell_number svg {\n  stroke: #10294D;\n  stroke-width: 1.4;\n}\n.datatable tbody tr:hover:not(.selected) td {\n  background-color: rgba(229, 235, 241, 0.5);\n}\n.datatable tbody tr.selected td {\n  background-color: rgba(54, 153, 254, 0.11);\n}\n.datatable tbody tr .thumbimg {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  overflow: hidden;\n  background-color: #F3F5F8;\n  background-position: center center;\n  background-size: cover;\n  transition: all 0.3s ease 0s;\n  vertical-align: middle;\n}\n.datatable tbody tr .thumbimg svg {\n  width: 40px;\n  height: 40px;\n  fill: none;\n}\n.datatable tbody tr .thumbimg svg text {\n  fill: #10294D;\n}\n.datatable tr.expanded td {\n  vertical-align: top;\n}\n.datatable tr.expanded td .tablecell {\n  white-space: normal;\n}\n.datatable td,\n.datatable th {\n  display: table-cell;\n  line-height: 1.8rem;\n  overflow: hidden;\n  vertical-align: middle;\n  max-width: 170px;\n  font-size: 1rem;\n}\n.datatable td.column-check,\n.datatable th.column-check {\n  width: 25px;\n  text-align: center;\n}\n.datatable td.column-score,\n.datatable th.column-score {\n  text-align: center;\n}\n.datatable td.column-score svg,\n.datatable th.column-score svg {\n  display: inline-block;\n}\n.datatable td.column-feed_status svg,\n.datatable th.column-feed_status svg,\n.datatable td[class^=\"feed_status\"] svg,\n.datatable th[class^=\"feed_status\"] svg,\n.datatable td[class*=\"feed_status\"] svg,\n.datatable th[class*=\"feed_status\"] svg {\n  fill: none;\n}\n.datatable td.column-actions,\n.datatable th.column-actions {\n  vertical-align: middle;\n  text-align: right;\n  max-width: none;\n}\n.datatable td.column-actions > div,\n.datatable th.column-actions > div {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  padding: 0 4px;\n  gap: 5px 5px;\n}\n.datatable td.column-actions > div > *:first-child,\n.datatable th.column-actions > div > *:first-child {\n  margin-left: auto;\n}\n.datatable td .tablecell,\n.datatable th .tablecell {\n  display: block;\n  max-width: 100%;\n  padding: 8px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.datatable td .tablecell img,\n.datatable th .tablecell img {\n  max-width: 90px;\n}\n.datatable td .tablecell svg,\n.datatable th .tablecell svg {\n  height: 20px;\n  padding-left: 0px;\n}\n.datatable td .tablecell svg.success,\n.datatable th .tablecell svg.success {\n  stroke: #73C677;\n  fill: none;\n}\n.datatable td .tablecell svg.pending,\n.datatable th .tablecell svg.pending {\n  stroke: #FFA564;\n  fill: none;\n}\n.datatable td .tablecell svg.withdrawn,\n.datatable th .tablecell svg.withdrawn {\n  stroke: #455870;\n  fill: none;\n}\n.datatable td .tablecell svg.unknown,\n.datatable th .tablecell svg.unknown,\n.datatable td .tablecell svg.failed,\n.datatable th .tablecell svg.failed {\n  stroke: #FF6464;\n  fill: none;\n}\n.datatable td .tablecell.ellipses,\n.datatable th .tablecell.ellipses {\n  min-width: 167px;\n}\n.datatable.imagestbl td:nth-of-type(2) {\n  width: 100px;\n}\n.datatable.imagestbl td:nth-of-type(8) {\n  text-align: center;\n}\n.datatable.imagestbl td .tablecell svg {\n  height: 40px;\n  fill: #ccc;\n}\n.datatable.portal-log-table .column-view-on-portal {\n  width: 5%;\n}\n.datatable.portal-log-table td .tablecell {\n  padding-left: 0;\n  padding-right: 0;\n}\n.datatable.portal-log-table tbody tr:hover:not(.selected) td {\n  background: none;\n}\n.datatable.commission-slip-table tbody tr:hover:not(.selected) td {\n  background: none;\n}\n.datatable.commission-slip-table tr[class*=\"-branch\"] .forminput:has(input:disabled) {\n  border: 0 none;\n}\n.datatable.commission-slip-table td,\n.datatable.commission-slip-table th {\n  position: relative;\n  overflow: visible;\n  white-space: nowrap;\n  padding: 0;\n}\n.datatable.commission-slip-table td .heading-wrapper,\n.datatable.commission-slip-table th .heading-wrapper {\n  display: flex;\n  align-items: center;\n  padding: 5px;\n  background: #F3F5F8;\n  min-height: 40px;\n}\n.datatable.commission-slip-table td .heading-wrapper .heading,\n.datatable.commission-slip-table th .heading-wrapper .heading {\n  flex: 0 0 auto;\n}\n.datatable.commission-slip-table td .heading-wrapper .heading + svg,\n.datatable.commission-slip-table th .heading-wrapper .heading + svg {\n  flex: 0 0 16px;\n  min-width: 16px;\n  fill: #CED7E2;\n  --color1: #CED7E2;\n}\n.datatable.commission-slip-table td.text-right .tablecell,\n.datatable.commission-slip-table th.text-right .tablecell,\n.datatable.commission-slip-table td.text-right .heading-wrapper,\n.datatable.commission-slip-table th.text-right .heading-wrapper {\n  justify-content: flex-end;\n}\n.datatable.commission-slip-table td.field .tablecell,\n.datatable.commission-slip-table th.field .tablecell {\n  overflow: visible;\n}\n.datatable.commission-slip-table td.field .form-group,\n.datatable.commission-slip-table th.field .form-group {\n  min-width: 100px;\n}\n.datatable.commission-slip-table td.field .form-group.selectinput,\n.datatable.commission-slip-table th.field .form-group.selectinput {\n  min-width: 150px;\n}\n.datatable.commission-slip-table td.field .form-group.asyncselectinput,\n.datatable.commission-slip-table th.field .form-group.asyncselectinput {\n  min-width: 150px;\n}\n.datatable.commission-slip-table td.field .form-group[class*=\".nett_amount\"],\n.datatable.commission-slip-table th.field .form-group[class*=\".nett_amount\"],\n.datatable.commission-slip-table td.field .form-group[class*=\".gross_amount\"],\n.datatable.commission-slip-table th.field .form-group[class*=\".gross_amount\"] {\n  min-width: 150px;\n  max-width: 150px;\n}\n.datatable.commission-slip-table td.field .form-group[class*=\".percentage\"],\n.datatable.commission-slip-table th.field .form-group[class*=\".percentage\"],\n.datatable.commission-slip-table td.field .form-group[class*=\".share_percentage\"],\n.datatable.commission-slip-table th.field .form-group[class*=\".share_percentage\"] {\n  min-width: 70px;\n  max-width: 70px;\n}\n.datatable.commission-slip-table td.field .form-group[class*=\".deduct_franchise_fee\"],\n.datatable.commission-slip-table th.field .form-group[class*=\".deduct_franchise_fee\"] {\n  min-width: 180px;\n}\n.datatable.commission-slip-table td.field .form-group[class*=\".deduct_franchise_fee\"] .forminput .checkcontainer + label,\n.datatable.commission-slip-table th.field .form-group[class*=\".deduct_franchise_fee\"] .forminput .checkcontainer + label {\n  min-width: 0;\n  margin-left: 0;\n}\n.datatable.commission-slip-table td .indicator,\n.datatable.commission-slip-table th .indicator {\n  width: 16px;\n  height: 16px;\n  border-radius: 16px;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n}\n.datatable.commission-slip-table td .indicator svg,\n.datatable.commission-slip-table th .indicator svg {\n  width: 16px;\n  height: 16px;\n  stroke: #ffffff;\n  fill: none;\n}\n.datatable.commission-slip-table td.text-center .heading-wrapper,\n.datatable.commission-slip-table th.text-center .heading-wrapper {\n  justify-content: center;\n}\n.datatable.commission-slip-table td {\n  color: #10294D;\n  font-size: 12px;\n}\n.datatable.commission-slip-table th {\n  color: #5A6F89;\n  font-size: 10px;\n  text-transform: uppercase;\n}\n.datatable.commission-slip-table .primary-bg td,\n.datatable.commission-slip-table .primary-bg th {\n  background: #10294D;\n  color: #ffffff;\n}\n.datatable.commission-slip-table .primary-bg td .heading-wrapper,\n.datatable.commission-slip-table .primary-bg th .heading-wrapper {\n  background: none;\n}\n.datatable.commission-slip-table .primary-bg.success td:not([colspan]),\n.datatable.commission-slip-table .primary-bg.success th:not([colspan]) {\n  color: #73C677;\n}\n.datatable.commission-slip-table .primary-bg.success td:not([colspan]) .indicator,\n.datatable.commission-slip-table .primary-bg.success th:not([colspan]) .indicator {\n  background: #73C677;\n}\n.datatable.commission-slip-table .primary-bg.fail td:not([colspan]),\n.datatable.commission-slip-table .primary-bg.fail th:not([colspan]) {\n  color: #FF6464;\n}\n.datatable.commission-slip-table .primary-bg.fail td:not([colspan]) .indicator,\n.datatable.commission-slip-table .primary-bg.fail th:not([colspan]) .indicator {\n  background: #FF6464;\n}\n.datatable.commission-slip-table .react-select__control {\n  min-height: 30px;\n}\n.datatable.commission-slip-table .react-select__control .react-select__single-value {\n  font-size: 12px;\n  font-weight: normal;\n}\n.datatable.commission-slip-table .checkmark {\n  background-color: reset;\n}\n.datatable.commission-slip-table td .tablecell {\n  padding: 5px;\n}\n.datatable .tablemeta select {\n  width: 45px;\n  padding: 10px 0 0;\n  text-indent: 10px;\n}\n.profile-form-footer {\n  margin-top: 10px;\n  margin-bottom: 25px;\n}\n.profile-form-footer .btn {\n  margin-top: 10px;\n  margin-right: 10px;\n  flex: 0 0 auto !important;\n}\n.profile-form-footer .btn:last-of-type {\n  margin-right: 0;\n}\n.details-section .details-section-buttons {\n  padding-right: 15px;\n}\n.details-section .details-section-buttons .btn {\n  margin-top: 5px;\n  margin-right: 5px;\n}\n.details-section .details-section-buttons .btn:last-of-type {\n  margin-right: 0;\n}\n.details-section .details-section-buttons + form {\n  margin-top: 20px;\n  display: block;\n}\n.list-actions {\n  display: flex;\n  padding: 20px 0;\n}\n.listbody {\n  overflow-y: visible;\n  overflow-x: auto;\n}\n.listbody thead th,\n.listbody tfoot th,\n.listbody thead td,\n.listbody tfoot td {\n  vertical-align: center;\n  text-transform: uppercase;\n  color: #5A6F89;\n}\n.listbody thead th.column-rating,\n.listbody tfoot th.column-rating,\n.listbody thead td.column-rating,\n.listbody tfoot td.column-rating {\n  width: 0;\n}\n.listbody thead th.column-rating svg,\n.listbody tfoot th.column-rating svg,\n.listbody thead td.column-rating svg,\n.listbody tfoot td.column-rating svg {\n  height: 23px;\n  fill: #ffffff;\n}\n.btmatches .listbody thead th,\n.btmatches .listbody tfoot th,\n.btmatches .listbody thead td,\n.btmatches .listbody tfoot td {\n  background: #F3F5F8;\n  padding: 0 5px;\n}\n.listbody thead th.column-check,\n.listbody tfoot th.column-check,\n.listbody thead td.column-check,\n.listbody tfoot td.column-check {\n  width: 46px;\n  min-width: 46px;\n  max-width: 46px;\n}\n.listbody thead th.column-view-on-portal,\n.listbody tfoot th.column-view-on-portal,\n.listbody thead td.column-view-on-portal,\n.listbody tfoot td.column-view-on-portal {\n  width: 120px;\n}\n.listbody thead th.column-feedstatus,\n.listbody tfoot th.column-feedstatus,\n.listbody thead td.column-feedstatus,\n.listbody tfoot td.column-feedstatus {\n  width: 0;\n}\n.listbody thead th.column-reason,\n.listbody tfoot th.column-reason,\n.listbody thead td.column-reason,\n.listbody tfoot td.column-reason {\n  width: 50%;\n}\n.listbody thead th.column-stage.stage-expanded,\n.listbody tfoot th.column-stage.stage-expanded,\n.listbody thead td.column-stage.stage-expanded,\n.listbody tfoot td.column-stage.stage-expanded {\n  min-width: 510px;\n  width: 30%;\n  max-width: none;\n}\n.listbody tbody tr {\n  box-shadow: 0px 1px 0px #E5EBF1;\n}\n.listbody tbody td .table-cell {\n  padding: 0 5px;\n}\n.listbody tbody td svg {\n  height: 13px;\n}\n.listbody tbody td.column-rating svg {\n  height: 23px;\n}\n.listbody tbody td .check-match {\n  height: 9px;\n  stroke: #22cf6d;\n  margin-right: 8px;\n}\n.listbody tbody td.column-view-on-portal {\n  text-align: right;\n}\n.listbody tbody td.column-feedstatus {\n  width: 0;\n}\n.listbody tbody td.column-feedstatus svg {\n  height: 24px;\n  fill: none;\n  stroke: #FFA564;\n  stroke-width: 1.4;\n}\n.listbody tbody td.column-feedstatus svg.success {\n  stroke: #73C677;\n}\n.listbody tbody td.column-feedstatus svg.failes {\n  stroke: #FF6464;\n}\n.listbody tbody tr:last-child td:first-child,\n.listbody tbody tr:last-child th:first-child {\n  overflow: hidden;\n}\n.listbody tbody tr:last-child td:last-child,\n.listbody tbody tr:last-child th:last-child {\n  overflow: hidden;\n}\n.listbody + form {\n  display: block;\n  margin-top: 20px;\n}\n.datatable.tfoot {\n  table-layout: fixed;\n}\n.datatable a:hover {\n  text-decoration: underline;\n}\n/* Table Metas */\n.tablemeta {\n  justify-content: space-between;\n  align-items: center;\n  font-size: 1.1rem;\n  margin: 0;\n  padding: 10px 0 0;\n  display: flex;\n  flex-wrap: wrap;\n  color: #333333;\n  gap: 10px 10px;\n  /* Search */\n}\n.tablemeta p {\n  font-size: inherit;\n  vertical-align: middle;\n  margin: 0;\n}\n.tablemeta select {\n  margin: 0;\n}\n.tablemeta .inlineselectinput {\n  flex: 1 1 100%;\n  margin-bottom: 0;\n}\n@media screen and (min-width: 799px) {\n  .tablemeta .inlineselectinput {\n    flex: 0 0 auto;\n  }\n}\n.tablemeta .inlineselectinput .forminput .input-group-addon {\n  padding-right: 0;\n  color: #10294D;\n  font-weight: 600;\n}\n.tablemeta .inlineselectinput .react-select .react-select__single-value {\n  color: #10294D;\n  font-weight: 500;\n}\n.tablemeta input[type=\"text\"] {\n  width: auto;\n  display: inline-block;\n  min-width: 300px;\n}\n.tablemeta form .btn {\n  display: inline-block;\n  margin: 0 0 0 20px;\n}\n@media (max-width: 799px) {\n  .tablemeta > div {\n    text-align: left;\n    margin-bottom: 10px;\n  }\n}\n@media (max-width: 799px) {\n  .tablemeta > div:last-of-type {\n    text-align: center;\n  }\n}\n.tablemeta .selected-records {\n  font-weight: 600;\n}\n.page-tools {\n  display: flex;\n  flex-wrap: nowrap;\n  flex: 1 1 0%;\n  gap: 10px 10px;\n  justify-content: flex-end;\n  color: #333333;\n  font-size: 12px;\n}\n.page-tools .pagejump .form-group .page-jump {\n  width: auto;\n  max-width: 60px;\n}\n.page-buttons {\n  display: flex;\n  flex: 0 0 auto;\n  gap: 10px 5px;\n  justify-content: flex-end;\n  color: #92A7C0;\n  font-size: 12px;\n  margin-left: auto;\n}\n@media screen and (min-width: 799px) {\n  .page-buttons {\n    margin-left: 0;\n  }\n}\n.record-count {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  flex-wrap: nowrap;\n}\n.pagejump {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: nowrap;\n}\n.pagejump form,\n.pagejump > div {\n  flex: 0 0 auto;\n  white-space: nowrap;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0 10px;\n}\n@media screen and (min-width: 799px) {\n  .pagejump form,\n  .pagejump > div {\n    flex: 1 1 auto;\n  }\n}\n.pagejump form > *,\n.pagejump > div > * {\n  vertical-align: middle;\n}\n.pagejump .form-group {\n  flex: 1 1 auto;\n}\n.pagejump .form-group .page-jump {\n  display: inline-block;\n  height: 36px;\n  width: 36px;\n  text-align: center;\n  padding: 6px;\n  color: #333333;\n  font-weight: 500;\n}\n.pagejump .btn-primary {\n  height: 36px;\n  line-height: 1.6;\n  vertical-align: middle;\n  margin: 0 0 0 5px;\n}\na.btn.btn-none.btn-gray,\nbutton.btn.btn-none.btn-gray,\nhtml [type=\"button\"].btn.btn-none.btn-gray {\n  color: #333333;\n}\na.btn.btn-none.btn-gray svg,\nbutton.btn.btn-none.btn-gray svg,\nhtml [type=\"button\"].btn.btn-none.btn-gray svg {\n  fill: #333333;\n}\n/* Steppers / paginations */\n.pagestep {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  border-radius: 4px;\n  justify-content: flex-end;\n  gap: 0 5px;\n}\n.pagestep .stepposition {\n  padding-right: 10px;\n}\n.pagestep .btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 36px;\n  padding: 0;\n  min-width: 36px;\n}\n.inline-select input[type=\"text\"] {\n  width: auto;\n  min-width: auto;\n}\n.inline__control.inline__control {\n  min-height: 32px;\n}\n.description input[type=\"text\"] {\n  min-width: 25px;\n}\n.status input[type=\"text\"] {\n  min-width: 50px;\n}\n.tablesearch {\n  position: relative;\n  transition: all 0.2s ease-in-out;\n  z-index: 1;\n  box-shadow: 0px 1px 0px #E5EBF1;\n  padding-bottom: 1px;\n}\n.tablesearch-simple {\n  display: none;\n}\n.tablesearch-advanced {\n  display: none;\n}\n.tablesearch .open {\n  display: block;\n}\n.tablesearch .search-buttons {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 8px 20px;\n  flex: 1 1 auto;\n}\n.tablesearch .search-buttons .btn {\n  width: 100%;\n  justify-content: center;\n}\n@media screen and (min-width: 799px) {\n  .tablesearch .search-buttons .btn {\n    justify-content: initial;\n    width: auto;\n  }\n}\n.tablesearch .adv-count {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  color: #10294D;\n  text-align: right;\n  width: 100%;\n  min-width: 280px;\n  justify-content: flex-start;\n}\n@media screen and (min-width: 799px) {\n  .tablesearch .adv-count {\n    width: auto;\n    justify-content: flex-end;\n    min-width: 0;\n  }\n}\n.search-fields {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 20px 15px;\n  margin-bottom: 10px;\n}\n.input-group .tags-form,\n.input-group .snippets-form {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 20px 15px;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n}\n.input-group .tags-form .field,\n.input-group .snippets-form .field {\n  flex: 0 0 100%;\n}\n.tbltags .column-label {\n  min-width: 280px;\n}\n.reset-group {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 0 10px;\n  flex: 0 0 auto;\n}\n.activity-search {\n  align-items: flex-start;\n  flex-wrap: wrap;\n}\n.activity-search .flex-container {\n  gap: 15px 20px;\n  justify-content: flex-start;\n  margin-bottom: 15px;\n}\n.activity-search .reset-group {\n  white-space: nowrap;\n}\n.activity-search .input-group {\n  flex: 1 1 0;\n  margin: 0;\n}\n.activity-search .form-group.dateinput .forminput {\n  border: 0 none;\n  flex-wrap: wrap;\n}\n.activity-search .form-group.dateinput .forminput:hover {\n  border: 0 none;\n}\n.activity-search .form-group.dateinput .forminput:focus {\n  box-shadow: none;\n}\n.activity-search .form-group.dateinput .forminput .input-group-addon {\n  width: auto;\n  flex: 1 1 100%;\n  max-width: none;\n}\n.activity-search .field {\n  padding: 0;\n}\n@media screen and (min-width: 799px) {\n  .activity-search .field {\n    flex: 0 0 200px;\n  }\n  .activity-search .field:first-child {\n    flex: 0 0 280px;\n  }\n}\n.activity-search .field .form-group {\n  margin-bottom: auto;\n}\n@media screen and (min-width: 799px) {\n  .activity-search .field .form-group.dateinput {\n    max-width: 200px;\n  }\n  .activity-search .field .form-group.search {\n    max-width: 280px;\n  }\n}\n.activity-search .field .form-group .flatpickr-inputwrap input {\n  min-height: 34px;\n}\n/* Table Manager */\n.table-manager {\n  display: flex;\n  flex: 0 0 36px;\n}\n.table-manager > .btn {\n  display: flex;\n  flex: 0 0 36px;\n  padding: 6px;\n  justify-content: center;\n}\n.drag-handle {\n  display: inline-block;\n  width: 24px;\n  min-width: 24px;\n  max-width: 24px;\n  height: 18px;\n  vertical-align: middle;\n  line-height: 14px;\n  margin-right: 10px;\n  padding: 0;\n  cursor: row-resize;\n  user-select: none;\n}\n.meta-status {\n  padding-left: 10px;\n}\n.meta-status .input-group-addon {\n  padding-right: 0;\n  color: #10294D;\n  font-weight: 600;\n  font-size: 1.1rem;\n}\n.table-manager-sidebar .track-horizontal {\n  right: 2px;\n  left: 8px;\n}\n.table-manager-sidebar .track-vertical {\n  left: 2px;\n  right: auto;\n}\n.table-manager-sidebar .table-manager-container {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  position: sticky;\n  grid-template-rows: 50px auto;\n  justify-content: space-between;\n  overflow: hidden;\n}\n.table-manager-sidebar .table-manager-content {\n  position: relative;\n  height: calc(100vh -  68px);\n  width: 280px;\n}\n.table-manager-sidebar .table-manager-pane {\n  position: relative;\n  width: 280px;\n}\n.table-manager-sidebar .table-manager-heading {\n  display: flex;\n  position: sticky;\n  background: #F3F5F8;\n  height: 64px;\n  align-items: center;\n  justify-content: space-between;\n  top: 0;\n  z-index: 10;\n}\n.table-manager-sidebar h3 {\n  padding-left: 20px;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.table-manager-sidebar .btn-table-manager-update {\n  outline: 0 !important;\n  box-shadow: none !important;\n  border: 1px solid #ccc;\n  height: 36px;\n  top: 0;\n  margin: 10px 0;\n}\n.table-manager-sidebar .btn-table-manager-update svg {\n  margin: 0;\n  height: 14px;\n}\n.table-manager-sidebar .table-column-list {\n  width: 280px;\n  padding: 20px 10px;\n}\n.table-manager-sidebar .table-column-list *::selection {\n  background: transparent;\n}\n.table-manager-sidebar .table-column-dropper {\n  overflow: hidden;\n  transition: all 0.2s ease-in-out;\n  font-weight: 500;\n  font-size: 12px;\n  touch-action: none;\n}\n.table-manager-sidebar .table-column-dropper > * {\n  touch-action: none;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable {\n  padding: 0 0 0 13px;\n  display: flex;\n  align-items: center;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable > .btn svg {\n  stroke: #10294D;\n  transition: all 0.2s ease-in-out;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable:hover {\n  background: #E5EBF1;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable:hover > span {\n  color: #10294D;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable[style^=\"left\"],\n.table-manager-sidebar .table-column-dropper .table-column-draggable[style*=\"left\"] {\n  background: #E5EBF1;\n  transition: none;\n  box-shadow: 0px 2px 4px #C5CFDC;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable .column-remover {\n  margin-left: auto;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable .column-remover svg {\n  stroke: #B2C2D4;\n  transition: all 0.2s ease-in-out;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable .column-remover:hover svg {\n  stroke: #10294D;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable.protected {\n  color: #ccc;\n  pointer-events: none;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable {\n  flex-wrap: wrap;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable > .column-remover svg {\n  transform: rotate(90deg);\n  stroke: #10294D;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable.open > .column-remover svg {\n  transform: rotate(0deg);\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable:hover .table-column-draggable {\n  background: #F3F5F8;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable:hover .table-column-draggable:hover {\n  background: #E5EBF1;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable .table-column-draggable {\n  padding-left: 33px;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable .table-column-draggable[style^=\"left\"],\n.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable .table-column-draggable[style*=\"left\"] {\n  background: #E5EBF1;\n  box-shadow: 0px 2px 4px #C5CFDC;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable.has-droppable .table-column-dropper {\n  margin-left: -13px;\n  flex: 0 0 calc(100% + 13px);\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable span {\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  color: #70859E;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable strong {\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1 1 200px;\n}\n.table-manager-sidebar .table-column-dropper .table-column-draggable button {\n  flex: 0 0 30px;\n}\n.table-manager-sidebar .column-remover {\n  padding: 0;\n  cursor: pointer;\n}\n.table-manager-sidebar .table-manager-actions {\n  padding: 0 10px 10px;\n}\n.table-manager-sidebar .table-manager-actions .form-group {\n  margin: 0;\n  width: 100%;\n}\n.table-manager-sidebar .table-manager-actions .btn-reset {\n  margin-bottom: 1rem;\n}\n.table-manager-sidebar .table-manager-field-form {\n  display: block;\n  margin-bottom: 10px;\n}\n.table-manager-sidebar .table-manager-field-form .selectinput .react-select {\n  width: 212px;\n}\n.table-manager-sidebar .btn-primary.btn-primary svg {\n  margin-right: 0 !important;\n}\n.table-manager-sidebar .msg.error {\n  flex: 1 1 100%;\n  color: #FFB1B1;\n  font-size: 1rem;\n  font-weight: 600;\n  text-align: left;\n}\n.preference-list {\n  width: 280px;\n  margin-top: -10px;\n  padding: 0 10px 30px 20px;\n}\n.preference-list .preference-item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  min-height: 36px;\n}\n.preference-list .preference-item .column-remover {\n  margin-left: auto;\n}\n.preference-list .preference-item .column-remover svg {\n  stroke: #B2C2D4;\n  transition: all 0.2s ease-in-out;\n}\n.preference-list .preference-item .column-remover:hover svg {\n  stroke: #10294D;\n}\n.preference-list .preference-item .form-group {\n  margin: 0;\n  flex: 1 1 100%;\n  display: flex;\n  align-items: center;\n  align-content: center;\n}\n.filtered_notice {\n  width: 100%;\n  border-bottom: 1px solid #cccccc;\n  line-height: 2em;\n  background-color: #efefef;\n  text-align: center;\n  padding: 10px 5px;\n}\na.has-link,\n.has-link {\n  color: inherit;\n  text-decoration: underline;\n}\na.has-link .listing-popup,\n.has-link .listing-popup,\na.has-link .contact-popup,\n.has-link .contact-popup {\n  text-decoration: inherit;\n  display: inline;\n}\na.has-link:hover,\n.has-link:hover {\n  color: #10294D;\n}\na.has-link.secondary,\n.has-link.secondary {\n  color: #FC495D;\n  text-decoration: none;\n}\na.has-link.secondary:hover,\n.has-link.secondary:hover {\n  text-decoration: underline;\n}\n.column-stage a {\n  text-decoration: none;\n}\n.lead-stage {\n  display: flex;\n  align-items: center;\n  padding: 6px 15px;\n  min-height: 36px;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  user-select: none;\n  border: 1px solid transparent;\n  transition: all 0.2s ease-in-out;\n  border-radius: 4px;\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  font-weight: 500;\n  border-radius: 30px;\n  min-height: 0;\n  padding: 3px 15px;\n  text-decoration: none;\n  display: inline-block;\n}\n.lead-stage-small {\n  padding: 0 8px;\n  min-height: 26px;\n}\n.lead-stage svg {\n  fill: none;\n  transition: all 0.2s ease-in-out;\n}\n.lead-stage.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n}\n.lead-stage-primary {\n  background: #10294D;\n  border-color: transparent;\n  color: #ffffff;\n}\n.lead-stage-primary svg {\n  stroke: #ffffff;\n  fill: none;\n}\n.lead-stage-primary:not(.disabled).focus,\n.lead-stage-primary:not(.disabled):focus,\n.lead-stage-primary:not(.disabled):focus-visible {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #071B38;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.lead-stage-primary:not(.disabled).active,\n.lead-stage-primary:not(.disabled):active {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #071B38;\n}\n.lead-stage-primary:not(.disabled).active.focus,\n.lead-stage-primary:not(.disabled):active.focus,\n.lead-stage-primary:not(.disabled).active:focus,\n.lead-stage-primary:not(.disabled):active:focus,\n.lead-stage-primary:not(.disabled).active:focus-visible,\n.lead-stage-primary:not(.disabled):active:focus-visible {\n  background: #071B38;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.lead-stage-primary:not(.disabled).hover,\n.lead-stage-primary:not(.disabled):hover {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #071B38;\n}\n.lead-stage-primary:not(.disabled).hover.active,\n.lead-stage-primary:not(.disabled):hover.active,\n.lead-stage-primary:not(.disabled).hover:active,\n.lead-stage-primary:not(.disabled):hover:active {\n  border-color: transparent;\n  background: #071B38;\n}\n.lead-stage-primary:not(.disabled).hover.active.focus,\n.lead-stage-primary:not(.disabled):hover.active.focus,\n.lead-stage-primary:not(.disabled).hover:active.focus,\n.lead-stage-primary:not(.disabled):hover:active.focus,\n.lead-stage-primary:not(.disabled).hover.active:focus,\n.lead-stage-primary:not(.disabled):hover.active:focus,\n.lead-stage-primary:not(.disabled).hover:active:focus,\n.lead-stage-primary:not(.disabled):hover:active:focus,\n.lead-stage-primary:not(.disabled).hover.active:focus-visible,\n.lead-stage-primary:not(.disabled):hover.active:focus-visible,\n.lead-stage-primary:not(.disabled).hover:active:focus-visible,\n.lead-stage-primary:not(.disabled):hover:active:focus-visible {\n  background: #071B38;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.lead-stage-secondary {\n  background: #FC495D;\n  border-color: transparent;\n  color: #ffffff;\n}\n.lead-stage-secondary svg {\n  display: block;\n  stroke: #ffffff;\n  fill: none;\n}\n.lead-stage-secondary.focus,\n.lead-stage-secondary:focus,\n.lead-stage-secondary:focus-visible {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #E62D42;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FED1D6;\n}\n.lead-stage-secondary.active,\n.lead-stage-secondary:active {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #E62D42;\n}\n.lead-stage-secondary.active.focus,\n.lead-stage-secondary:active.focus,\n.lead-stage-secondary.active:focus,\n.lead-stage-secondary:active:focus,\n.lead-stage-secondary.active:focus-visible,\n.lead-stage-secondary:active:focus-visible {\n  background: #E62D42;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FED1D6;\n}\n.lead-stage-secondary.hover,\n.lead-stage-secondary:hover {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #E62D42;\n}\n.lead-stage-secondary.hover.active,\n.lead-stage-secondary:hover.active,\n.lead-stage-secondary.hover:active,\n.lead-stage-secondary:hover:active {\n  border-color: transparent;\n  background: #E62D42;\n}\n.lead-stage-secondary.hover.active.focus,\n.lead-stage-secondary:hover.active.focus,\n.lead-stage-secondary.hover:active.focus,\n.lead-stage-secondary:hover:active.focus,\n.lead-stage-secondary.hover.active:focus,\n.lead-stage-secondary:hover.active:focus,\n.lead-stage-secondary.hover:active:focus,\n.lead-stage-secondary:hover:active:focus,\n.lead-stage-secondary.hover.active:focus-visible,\n.lead-stage-secondary:hover.active:focus-visible,\n.lead-stage-secondary.hover:active:focus-visible,\n.lead-stage-secondary:hover:active:focus-visible {\n  background: #E62D42;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FED1D6;\n}\n.lead-stage-round {\n  border-radius: 30px;\n}\n.lead-stage-red {\n  background: #FFEDEF;\n  color: #FC495D;\n}\n.lead-stage-red svg {\n  stroke: #FC495D;\n}\n.lead-stage-red.focus,\n.lead-stage-red:focus,\n.lead-stage-red:focus-visible {\n  color: #FC495D;\n  border: 1px solid transparent;\n  background: #FED1D6;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FFEDEF;\n}\n.lead-stage-red.active,\n.lead-stage-red:active {\n  color: #FC495D;\n  border: 1px solid transparent;\n  background: #FED1D6;\n}\n.lead-stage-red.active.focus,\n.lead-stage-red:active.focus,\n.lead-stage-red.active:focus,\n.lead-stage-red:active:focus,\n.lead-stage-red.active:focus-visible,\n.lead-stage-red:active:focus-visible {\n  background: #FED1D6;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FFEDEF;\n}\n.lead-stage-red.hover,\n.lead-stage-red:hover {\n  color: #FC495D;\n  border: 1px solid transparent;\n  background: #FED1D6;\n}\n.lead-stage-red.hover.active,\n.lead-stage-red:hover.active,\n.lead-stage-red.hover:active,\n.lead-stage-red:hover:active {\n  border-color: transparent;\n  background: #FED1D6;\n}\n.lead-stage-red.hover.active.focus,\n.lead-stage-red:hover.active.focus,\n.lead-stage-red.hover:active.focus,\n.lead-stage-red:hover:active.focus,\n.lead-stage-red.hover.active:focus,\n.lead-stage-red:hover.active:focus,\n.lead-stage-red.hover:active:focus,\n.lead-stage-red:hover:active:focus,\n.lead-stage-red.hover.active:focus-visible,\n.lead-stage-red:hover.active:focus-visible,\n.lead-stage-red.hover:active:focus-visible,\n.lead-stage-red:hover:active:focus-visible {\n  background: #FED1D6;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FFEDEF;\n}\n.lead-stage-green {\n  background: #F0F9F1;\n  color: #73C677;\n}\n.lead-stage-green svg {\n  stroke: #73C677;\n}\n.lead-stage-green.focus,\n.lead-stage-green:focus,\n.lead-stage-green:focus-visible {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #DCF1DE;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #F0F9F1;\n}\n.lead-stage-green.active,\n.lead-stage-green:active {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #DCF1DE;\n}\n.lead-stage-green.active.focus,\n.lead-stage-green:active.focus,\n.lead-stage-green.active:focus,\n.lead-stage-green:active:focus,\n.lead-stage-green.active:focus-visible,\n.lead-stage-green:active:focus-visible {\n  background: #DCF1DE;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #F0F9F1;\n}\n.lead-stage-green.hover,\n.lead-stage-green:hover {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #DCF1DE;\n}\n.lead-stage-green.hover.active,\n.lead-stage-green:hover.active,\n.lead-stage-green.hover:active,\n.lead-stage-green:hover:active {\n  border-color: transparent;\n  background: #DCF1DE;\n}\n.lead-stage-green.hover.active.focus,\n.lead-stage-green:hover.active.focus,\n.lead-stage-green.hover:active.focus,\n.lead-stage-green:hover:active.focus,\n.lead-stage-green.hover.active:focus,\n.lead-stage-green:hover.active:focus,\n.lead-stage-green.hover:active:focus,\n.lead-stage-green:hover:active:focus,\n.lead-stage-green.hover.active:focus-visible,\n.lead-stage-green:hover.active:focus-visible,\n.lead-stage-green.hover:active:focus-visible,\n.lead-stage-green:hover:active:focus-visible {\n  background: #DCF1DE;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #F0F9F1;\n}\n.lead-stage-blue {\n  background: #EFFBFD;\n  color: #34BFDE;\n}\n.lead-stage-blue svg {\n  stroke: #73C677;\n}\n.lead-stage-blue.focus,\n.lead-stage-blue:focus,\n.lead-stage-blue:focus-visible {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #D7F4FA;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #EFFBFD;\n}\n.lead-stage-blue.active,\n.lead-stage-blue:active {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #D7F4FA;\n}\n.lead-stage-blue.active.focus,\n.lead-stage-blue:active.focus,\n.lead-stage-blue.active:focus,\n.lead-stage-blue:active:focus,\n.lead-stage-blue.active:focus-visible,\n.lead-stage-blue:active:focus-visible {\n  background: #D7F4FA;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #EFFBFD;\n}\n.lead-stage-blue.hover,\n.lead-stage-blue:hover {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #D7F4FA;\n}\n.lead-stage-blue.hover.active,\n.lead-stage-blue:hover.active,\n.lead-stage-blue.hover:active,\n.lead-stage-blue:hover:active {\n  border-color: transparent;\n  background: #D7F4FA;\n}\n.lead-stage-blue.hover.active.focus,\n.lead-stage-blue:hover.active.focus,\n.lead-stage-blue.hover:active.focus,\n.lead-stage-blue:hover:active.focus,\n.lead-stage-blue.hover.active:focus,\n.lead-stage-blue:hover.active:focus,\n.lead-stage-blue.hover:active:focus,\n.lead-stage-blue:hover:active:focus,\n.lead-stage-blue.hover.active:focus-visible,\n.lead-stage-blue:hover.active:focus-visible,\n.lead-stage-blue.hover:active:focus-visible,\n.lead-stage-blue:hover:active:focus-visible {\n  background: #D7F4FA;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #EFFBFD;\n}\n.lead-stage-none {\n  background: transparent;\n  color: #70859E;\n}\n.lead-stage-none svg {\n  stroke: #10294D;\n}\n.lead-stage-none.focus,\n.lead-stage-none:focus,\n.lead-stage-none:focus-visible {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.lead-stage-none.active,\n.lead-stage-none:active {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.lead-stage-none.active.focus,\n.lead-stage-none:active.focus,\n.lead-stage-none.active:focus,\n.lead-stage-none:active:focus,\n.lead-stage-none.active:focus-visible,\n.lead-stage-none:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.lead-stage-none.hover,\n.lead-stage-none:hover {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.lead-stage-none.hover.active,\n.lead-stage-none:hover.active,\n.lead-stage-none.hover:active,\n.lead-stage-none:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\n.lead-stage-none.hover.active.focus,\n.lead-stage-none:hover.active.focus,\n.lead-stage-none.hover:active.focus,\n.lead-stage-none:hover:active.focus,\n.lead-stage-none.hover.active:focus,\n.lead-stage-none:hover.active:focus,\n.lead-stage-none.hover:active:focus,\n.lead-stage-none:hover:active:focus,\n.lead-stage-none.hover.active:focus-visible,\n.lead-stage-none:hover.active:focus-visible,\n.lead-stage-none.hover:active:focus-visible,\n.lead-stage-none:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.lead-stage-none-red {\n  background: transparent;\n  color: #70859E;\n}\n.lead-stage-none-red svg {\n  stroke: #FC495D;\n}\n.lead-stage-none-red.focus,\n.lead-stage-none-red:focus,\n.lead-stage-none-red:focus-visible {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.lead-stage-none-red.active,\n.lead-stage-none-red:active {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.lead-stage-none-red.active.focus,\n.lead-stage-none-red:active.focus,\n.lead-stage-none-red.active:focus,\n.lead-stage-none-red:active:focus,\n.lead-stage-none-red.active:focus-visible,\n.lead-stage-none-red:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.lead-stage-none-red.hover,\n.lead-stage-none-red:hover {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.lead-stage-none-red.hover.active,\n.lead-stage-none-red:hover.active,\n.lead-stage-none-red.hover:active,\n.lead-stage-none-red:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\n.lead-stage-none-red.hover.active.focus,\n.lead-stage-none-red:hover.active.focus,\n.lead-stage-none-red.hover:active.focus,\n.lead-stage-none-red:hover:active.focus,\n.lead-stage-none-red.hover.active:focus,\n.lead-stage-none-red:hover.active:focus,\n.lead-stage-none-red.hover:active:focus,\n.lead-stage-none-red:hover:active:focus,\n.lead-stage-none-red.hover.active:focus-visible,\n.lead-stage-none-red:hover.active:focus-visible,\n.lead-stage-none-red.hover:active:focus-visible,\n.lead-stage-none-red:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.lead-stage-subtle {\n  background: transparent;\n  border: 1px solid #E5EBF1;\n  color: #10294D;\n}\n.lead-stage-subtle svg {\n  stroke: #10294D;\n}\n.lead-stage-subtle.focus,\n.lead-stage-subtle:focus,\n.lead-stage-subtle:focus-visible {\n  color: #071B38;\n  border: 1px solid #CED7E2;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.lead-stage-subtle.active,\n.lead-stage-subtle:active {\n  color: #071B38;\n  border: 1px solid #CED7E2;\n  background: transparent;\n}\n.lead-stage-subtle.active.focus,\n.lead-stage-subtle:active.focus,\n.lead-stage-subtle.active:focus,\n.lead-stage-subtle:active:focus,\n.lead-stage-subtle.active:focus-visible,\n.lead-stage-subtle:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.lead-stage-subtle.hover,\n.lead-stage-subtle:hover {\n  color: #071B38;\n  border: 1px solid #CED7E2;\n  background: transparent;\n}\n.lead-stage-subtle.hover.active,\n.lead-stage-subtle:hover.active,\n.lead-stage-subtle.hover:active,\n.lead-stage-subtle:hover:active {\n  border-color: #CED7E2;\n  background: transparent;\n}\n.lead-stage-subtle.hover.active.focus,\n.lead-stage-subtle:hover.active.focus,\n.lead-stage-subtle.hover:active.focus,\n.lead-stage-subtle:hover:active.focus,\n.lead-stage-subtle.hover.active:focus,\n.lead-stage-subtle:hover.active:focus,\n.lead-stage-subtle.hover:active:focus,\n.lead-stage-subtle:hover:active:focus,\n.lead-stage-subtle.hover.active:focus-visible,\n.lead-stage-subtle:hover.active:focus-visible,\n.lead-stage-subtle.hover:active:focus-visible,\n.lead-stage-subtle:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.lead-stage-text {\n  background: transparent;\n  color: #10294D;\n}\n.lead-stage-text svg {\n  stroke: #CED7E2;\n}\n.lead-stage-text.focus,\n.lead-stage-text:focus,\n.lead-stage-text:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.lead-stage-text.active,\n.lead-stage-text:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.lead-stage-text.active.focus,\n.lead-stage-text:active.focus,\n.lead-stage-text.active:focus,\n.lead-stage-text:active:focus,\n.lead-stage-text.active:focus-visible,\n.lead-stage-text:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.lead-stage-text.hover,\n.lead-stage-text:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.lead-stage-text.hover.active,\n.lead-stage-text:hover.active,\n.lead-stage-text.hover:active,\n.lead-stage-text:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\n.lead-stage-text.hover.active.focus,\n.lead-stage-text:hover.active.focus,\n.lead-stage-text.hover:active.focus,\n.lead-stage-text:hover:active.focus,\n.lead-stage-text.hover.active:focus,\n.lead-stage-text:hover.active:focus,\n.lead-stage-text.hover:active:focus,\n.lead-stage-text:hover:active:focus,\n.lead-stage-text.hover.active:focus-visible,\n.lead-stage-text:hover.active:focus-visible,\n.lead-stage-text.hover:active:focus-visible,\n.lead-stage-text:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.lead-stage-text-only {\n  padding: 0;\n  background: transparent;\n  color: #10294D;\n}\n.lead-stage-text-only svg {\n  stroke: #CED7E2;\n}\n.lead-stage-text-only.focus,\n.lead-stage-text-only:focus,\n.lead-stage-text-only:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.lead-stage-text-only.active,\n.lead-stage-text-only:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.lead-stage-text-only.active.focus,\n.lead-stage-text-only:active.focus,\n.lead-stage-text-only.active:focus,\n.lead-stage-text-only:active:focus,\n.lead-stage-text-only.active:focus-visible,\n.lead-stage-text-only:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.lead-stage-text-only.hover,\n.lead-stage-text-only:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.lead-stage-text-only.hover.active,\n.lead-stage-text-only:hover.active,\n.lead-stage-text-only.hover:active,\n.lead-stage-text-only:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\n.lead-stage-text-only.hover.active.focus,\n.lead-stage-text-only:hover.active.focus,\n.lead-stage-text-only.hover:active.focus,\n.lead-stage-text-only:hover:active.focus,\n.lead-stage-text-only.hover.active:focus,\n.lead-stage-text-only:hover.active:focus,\n.lead-stage-text-only.hover:active:focus,\n.lead-stage-text-only:hover:active:focus,\n.lead-stage-text-only.hover.active:focus-visible,\n.lead-stage-text-only:hover.active:focus-visible,\n.lead-stage-text-only.hover:active:focus-visible,\n.lead-stage-text-only:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.lead-stage-grey {\n  background: #E5EBF1;\n  color: #10294D;\n}\n.lead-stage-grey svg {\n  stroke: #10294D;\n}\n.lead-stage-grey.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n  background: #E5EBF1;\n  color: #10294D;\n}\n.lead-stage-grey.input-group-addon svg {\n  stroke: #10294D;\n}\n.lead-stage-grey.focus,\n.lead-stage-grey:focus,\n.lead-stage-grey:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.lead-stage-grey.active,\n.lead-stage-grey:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\n.lead-stage-grey.active.focus,\n.lead-stage-grey:active.focus,\n.lead-stage-grey.active:focus,\n.lead-stage-grey:active:focus,\n.lead-stage-grey.active:focus-visible,\n.lead-stage-grey:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.lead-stage-grey.hover,\n.lead-stage-grey:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\n.lead-stage-grey.hover.active,\n.lead-stage-grey:hover.active,\n.lead-stage-grey.hover:active,\n.lead-stage-grey:hover:active {\n  border-color: transparent;\n  background: #CED7E2;\n}\n.lead-stage-grey.hover.active.focus,\n.lead-stage-grey:hover.active.focus,\n.lead-stage-grey.hover:active.focus,\n.lead-stage-grey:hover:active.focus,\n.lead-stage-grey.hover.active:focus,\n.lead-stage-grey:hover.active:focus,\n.lead-stage-grey.hover:active:focus,\n.lead-stage-grey:hover:active:focus,\n.lead-stage-grey.hover.active:focus-visible,\n.lead-stage-grey:hover.active:focus-visible,\n.lead-stage-grey.hover:active:focus-visible,\n.lead-stage-grey:hover:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.lead-stage-grey-50 {\n  background: #F3F5F8;\n  color: #10294D;\n}\n.lead-stage-grey-50 svg {\n  stroke: #10294D;\n}\n.lead-stage-grey-50.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n  background: #F3F5F8;\n  color: #10294D;\n}\n.lead-stage-grey-50.input-group-addon svg {\n  stroke: #10294D;\n}\n.lead-stage-grey-50.focus,\n.lead-stage-grey-50:focus,\n.lead-stage-grey-50:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.lead-stage-grey-50.active,\n.lead-stage-grey-50:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\n.lead-stage-grey-50.active.focus,\n.lead-stage-grey-50:active.focus,\n.lead-stage-grey-50.active:focus,\n.lead-stage-grey-50:active:focus,\n.lead-stage-grey-50.active:focus-visible,\n.lead-stage-grey-50:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.lead-stage-grey-50.hover,\n.lead-stage-grey-50:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\n.lead-stage-grey-50.hover.active,\n.lead-stage-grey-50:hover.active,\n.lead-stage-grey-50.hover:active,\n.lead-stage-grey-50:hover:active {\n  border-color: transparent;\n  background: #E5EBF1;\n}\n.lead-stage-grey-50.hover.active.focus,\n.lead-stage-grey-50:hover.active.focus,\n.lead-stage-grey-50.hover:active.focus,\n.lead-stage-grey-50:hover:active.focus,\n.lead-stage-grey-50.hover.active:focus,\n.lead-stage-grey-50:hover.active:focus,\n.lead-stage-grey-50.hover:active:focus,\n.lead-stage-grey-50:hover:active:focus,\n.lead-stage-grey-50.hover.active:focus-visible,\n.lead-stage-grey-50:hover.active:focus-visible,\n.lead-stage-grey-50.hover:active:focus-visible,\n.lead-stage-grey-50:hover:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.lead-stage-white {\n  background: #ffffff;\n  color: #10294D;\n}\n.lead-stage-white svg {\n  stroke: #CED7E2;\n}\n.lead-stage-white.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n  background: #E5EBF1;\n  color: #10294D;\n}\n.lead-stage-white.input-group-addon svg {\n  stroke: #CED7E2;\n}\n.lead-stage-white.focus,\n.lead-stage-white:focus,\n.lead-stage-white:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.lead-stage-white.active,\n.lead-stage-white:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\n.lead-stage-white.active.focus,\n.lead-stage-white:active.focus,\n.lead-stage-white.active:focus,\n.lead-stage-white:active:focus,\n.lead-stage-white.active:focus-visible,\n.lead-stage-white:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.lead-stage-white.hover,\n.lead-stage-white:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\n.lead-stage-white.hover.active,\n.lead-stage-white:hover.active,\n.lead-stage-white.hover:active,\n.lead-stage-white:hover:active {\n  border-color: transparent;\n  background: #CED7E2;\n}\n.lead-stage-white.hover.active.focus,\n.lead-stage-white:hover.active.focus,\n.lead-stage-white.hover:active.focus,\n.lead-stage-white:hover:active.focus,\n.lead-stage-white.hover.active:focus,\n.lead-stage-white:hover.active:focus,\n.lead-stage-white.hover:active:focus,\n.lead-stage-white:hover:active:focus,\n.lead-stage-white.hover.active:focus-visible,\n.lead-stage-white:hover.active:focus-visible,\n.lead-stage-white.hover:active:focus-visible,\n.lead-stage-white:hover:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.lead-stage-white:hover svg,\n.lead-stage-white.active svg,\n.lead-stage-white:active svg {\n  stroke: #10294D;\n}\n.lead-stage.disabled,\n.lead-stage[disabled] {\n  background: #E5EBF1;\n  border: 1px solid transparent;\n  cursor: not-allowed;\n  color: #CED7E2;\n}\n.lead-stage.disabled svg,\n.lead-stage[disabled] svg {\n  display: block;\n  stroke: #CED7E2;\n}\n.lead-stage.disabled.focus,\n.lead-stage[disabled].focus,\n.lead-stage.disabled:focus,\n.lead-stage[disabled]:focus,\n.lead-stage.disabled:focus-visible,\n.lead-stage[disabled]:focus-visible {\n  color: #CED7E2;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.lead-stage.disabled.active,\n.lead-stage[disabled].active,\n.lead-stage.disabled:active,\n.lead-stage[disabled]:active {\n  color: #CED7E2;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\n.lead-stage.disabled.active.focus,\n.lead-stage[disabled].active.focus,\n.lead-stage.disabled:active.focus,\n.lead-stage[disabled]:active.focus,\n.lead-stage.disabled.active:focus,\n.lead-stage[disabled].active:focus,\n.lead-stage.disabled:active:focus,\n.lead-stage[disabled]:active:focus,\n.lead-stage.disabled.active:focus-visible,\n.lead-stage[disabled].active:focus-visible,\n.lead-stage.disabled:active:focus-visible,\n.lead-stage[disabled]:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.lead-stage.disabled.hover,\n.lead-stage[disabled].hover,\n.lead-stage.disabled:hover,\n.lead-stage[disabled]:hover {\n  color: #CED7E2;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\n.lead-stage.disabled.hover.active,\n.lead-stage[disabled].hover.active,\n.lead-stage.disabled:hover.active,\n.lead-stage[disabled]:hover.active,\n.lead-stage.disabled.hover:active,\n.lead-stage[disabled].hover:active,\n.lead-stage.disabled:hover:active,\n.lead-stage[disabled]:hover:active {\n  border-color: transparent;\n  background: #E5EBF1;\n}\n.lead-stage.disabled.hover.active.focus,\n.lead-stage[disabled].hover.active.focus,\n.lead-stage.disabled:hover.active.focus,\n.lead-stage[disabled]:hover.active.focus,\n.lead-stage.disabled.hover:active.focus,\n.lead-stage[disabled].hover:active.focus,\n.lead-stage.disabled:hover:active.focus,\n.lead-stage[disabled]:hover:active.focus,\n.lead-stage.disabled.hover.active:focus,\n.lead-stage[disabled].hover.active:focus,\n.lead-stage.disabled:hover.active:focus,\n.lead-stage[disabled]:hover.active:focus,\n.lead-stage.disabled.hover:active:focus,\n.lead-stage[disabled].hover:active:focus,\n.lead-stage.disabled:hover:active:focus,\n.lead-stage[disabled]:hover:active:focus,\n.lead-stage.disabled.hover.active:focus-visible,\n.lead-stage[disabled].hover.active:focus-visible,\n.lead-stage.disabled:hover.active:focus-visible,\n.lead-stage[disabled]:hover.active:focus-visible,\n.lead-stage.disabled.hover:active:focus-visible,\n.lead-stage[disabled].hover:active:focus-visible,\n.lead-stage.disabled:hover:active:focus-visible,\n.lead-stage[disabled]:hover:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.lead-stage-icon-16 .icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n}\n.lead-stage-icon-16 .icon svg {\n  width: 16px;\n  height: 16px;\n  stroke-width: 2.4;\n}\n.lead-stage-icon-24 .icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n}\n.lead-stage-icon-24 .icon svg {\n  width: 24px;\n  height: 24px;\n  stroke-width: 1.4;\n}\n.lead-stage-icon-right {\n  padding-right: 10px;\n}\n.lead-stage-icon-right .icon {\n  order: 1;\n  margin-left: 5px;\n}\n.lead-stage-icon-right .icon svg {\n  fill: none;\n}\n.lead-stage-icon-left {\n  padding-left: 10px;\n}\n.lead-stage-icon-left .icon {\n  order: 0;\n  margin-right: 5px;\n}\n.lead-stage-icon-left .icon svg {\n  fill: none;\n}\n.lead-stage-icon-right.lead-stage-icon-left .icon {\n  margin: 0;\n}\n.lead-stage-icon-only {\n  padding: 0;\n}\n.lead-stage-icon-only.btn-icon-24 {\n  min-height: 26px;\n  max-height: 26px;\n  max-width: 26px;\n}\n.lead-stage-icon-only.btn-icon-24 .icon {\n  max-height: 24px;\n  max-width: 24px;\n}\n.lead-stage-icon-only.btn-icon-16 {\n  min-height: 18px;\n  max-height: 18px;\n  max-width: 18px;\n}\n.lead-stage-icon-only.btn-icon-16 .icon {\n  max-height: 16px;\n  max-width: 16px;\n}\n.lead-stage-icon-only.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n}\n.lead-stage-icon-success .icon svg {\n  fill: none;\n  stroke: #73C677;\n}\n.lead-stage-glyph .icon svg {\n  stroke: none;\n}\n.lead-stage.highlight {\n  --color4: #60D3EC;\n}\n.lead-stage.has-submenu {\n  padding: 0;\n}\n.lead-stage-red-text {\n  color: #FC495D;\n  padding-left: 1px;\n}\n.lead-stage.New {\n  background: #FC495D;\n  color: #ffffff;\n}\n.lead-stage.Contacted {\n  background: #73C677;\n  color: #ffffff;\n}\n.lead-stage.Viewing {\n  background: #3699FE;\n  color: #ffffff;\n}\n.lead-stage.Offer {\n  background: #BF60EC;\n  color: #ffffff;\n}\n.lead-stage.Sold {\n  background: #FFA564;\n  color: #ffffff;\n}\n.lead-stage.Rented {\n  background: #FFA564;\n  color: #ffffff;\n}\n.lead-stage.Rental-Application {\n  background: #BF60EC;\n  color: #ffffff;\n}\n.lead-stage.Archived {\n  background: #10294D;\n  color: #ffffff;\n}\n.email-stage {\n  color: #ffffff;\n  border-radius: 30px;\n  min-height: 0;\n  padding: 3px 15px;\n  text-decoration: none;\n  display: inline-block;\n}\n.email-stage.delivered {\n  background: #73C677;\n}\n.email-stage.open {\n  background: #0CA6C8;\n}\n.email-stage.click {\n  background: #10294D;\n}\n.email-stage.bounce {\n  background: #FC495D;\n}\n.email-stage.unsubscribe {\n  background: #70859E;\n}\n.email-stage.spamreport {\n  background: #459948;\n}\n.email-stage.dropped {\n  background: #006DDC;\n}\n.deal-stage {\n  color: #ffffff;\n  border-radius: 30px;\n  min-height: 0;\n  padding: 3px 15px;\n  text-decoration: none;\n  display: inline-block;\n}\n.deal-stage.offer-made {\n  background: #60D3EC;\n}\n.deal-stage.sale-agreement {\n  background: #0CA6C8;\n}\n.deal-stage.buyer-signed {\n  background: #3699FE;\n}\n.deal-stage.seller-signed {\n  background: #006DDC;\n}\n.deal-stage.instruction-sent {\n  background: #BF60EC;\n}\n.deal-stage.deposit-received {\n  background: #B339EC;\n}\n.deal-stage.conditions-met {\n  background: #B339EC;\n}\n.deal-stage.lodged {\n  background: #73C677;\n}\n.deal-stage.closed {\n  background: #E62D42;\n}\n.deal-stage.cancelled {\n  background: #10294D;\n}\n.application-stage {\n  display: flex;\n  align-items: center;\n  padding: 6px 15px;\n  min-height: 36px;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  user-select: none;\n  border: 1px solid transparent;\n  transition: all 0.2s ease-in-out;\n  border-radius: 4px;\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  font-weight: 500;\n  border-radius: 30px;\n  min-height: 0;\n  padding: 3px 15px;\n  text-decoration: none;\n  display: inline-block;\n}\n.application-stage-small {\n  padding: 0 8px;\n  min-height: 26px;\n}\n.application-stage svg {\n  fill: none;\n  transition: all 0.2s ease-in-out;\n}\n.application-stage.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n}\n.application-stage-primary {\n  background: #10294D;\n  border-color: transparent;\n  color: #ffffff;\n}\n.application-stage-primary svg {\n  stroke: #ffffff;\n  fill: none;\n}\n.application-stage-primary:not(.disabled).focus,\n.application-stage-primary:not(.disabled):focus,\n.application-stage-primary:not(.disabled):focus-visible {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #071B38;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.application-stage-primary:not(.disabled).active,\n.application-stage-primary:not(.disabled):active {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #071B38;\n}\n.application-stage-primary:not(.disabled).active.focus,\n.application-stage-primary:not(.disabled):active.focus,\n.application-stage-primary:not(.disabled).active:focus,\n.application-stage-primary:not(.disabled):active:focus,\n.application-stage-primary:not(.disabled).active:focus-visible,\n.application-stage-primary:not(.disabled):active:focus-visible {\n  background: #071B38;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.application-stage-primary:not(.disabled).hover,\n.application-stage-primary:not(.disabled):hover {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #071B38;\n}\n.application-stage-primary:not(.disabled).hover.active,\n.application-stage-primary:not(.disabled):hover.active,\n.application-stage-primary:not(.disabled).hover:active,\n.application-stage-primary:not(.disabled):hover:active {\n  border-color: transparent;\n  background: #071B38;\n}\n.application-stage-primary:not(.disabled).hover.active.focus,\n.application-stage-primary:not(.disabled):hover.active.focus,\n.application-stage-primary:not(.disabled).hover:active.focus,\n.application-stage-primary:not(.disabled):hover:active.focus,\n.application-stage-primary:not(.disabled).hover.active:focus,\n.application-stage-primary:not(.disabled):hover.active:focus,\n.application-stage-primary:not(.disabled).hover:active:focus,\n.application-stage-primary:not(.disabled):hover:active:focus,\n.application-stage-primary:not(.disabled).hover.active:focus-visible,\n.application-stage-primary:not(.disabled):hover.active:focus-visible,\n.application-stage-primary:not(.disabled).hover:active:focus-visible,\n.application-stage-primary:not(.disabled):hover:active:focus-visible {\n  background: #071B38;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.application-stage-secondary {\n  background: #FC495D;\n  border-color: transparent;\n  color: #ffffff;\n}\n.application-stage-secondary svg {\n  display: block;\n  stroke: #ffffff;\n  fill: none;\n}\n.application-stage-secondary.focus,\n.application-stage-secondary:focus,\n.application-stage-secondary:focus-visible {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #E62D42;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FED1D6;\n}\n.application-stage-secondary.active,\n.application-stage-secondary:active {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #E62D42;\n}\n.application-stage-secondary.active.focus,\n.application-stage-secondary:active.focus,\n.application-stage-secondary.active:focus,\n.application-stage-secondary:active:focus,\n.application-stage-secondary.active:focus-visible,\n.application-stage-secondary:active:focus-visible {\n  background: #E62D42;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FED1D6;\n}\n.application-stage-secondary.hover,\n.application-stage-secondary:hover {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #E62D42;\n}\n.application-stage-secondary.hover.active,\n.application-stage-secondary:hover.active,\n.application-stage-secondary.hover:active,\n.application-stage-secondary:hover:active {\n  border-color: transparent;\n  background: #E62D42;\n}\n.application-stage-secondary.hover.active.focus,\n.application-stage-secondary:hover.active.focus,\n.application-stage-secondary.hover:active.focus,\n.application-stage-secondary:hover:active.focus,\n.application-stage-secondary.hover.active:focus,\n.application-stage-secondary:hover.active:focus,\n.application-stage-secondary.hover:active:focus,\n.application-stage-secondary:hover:active:focus,\n.application-stage-secondary.hover.active:focus-visible,\n.application-stage-secondary:hover.active:focus-visible,\n.application-stage-secondary.hover:active:focus-visible,\n.application-stage-secondary:hover:active:focus-visible {\n  background: #E62D42;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FED1D6;\n}\n.application-stage-round {\n  border-radius: 30px;\n}\n.application-stage-red {\n  background: #FFEDEF;\n  color: #FC495D;\n}\n.application-stage-red svg {\n  stroke: #FC495D;\n}\n.application-stage-red.focus,\n.application-stage-red:focus,\n.application-stage-red:focus-visible {\n  color: #FC495D;\n  border: 1px solid transparent;\n  background: #FED1D6;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FFEDEF;\n}\n.application-stage-red.active,\n.application-stage-red:active {\n  color: #FC495D;\n  border: 1px solid transparent;\n  background: #FED1D6;\n}\n.application-stage-red.active.focus,\n.application-stage-red:active.focus,\n.application-stage-red.active:focus,\n.application-stage-red:active:focus,\n.application-stage-red.active:focus-visible,\n.application-stage-red:active:focus-visible {\n  background: #FED1D6;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FFEDEF;\n}\n.application-stage-red.hover,\n.application-stage-red:hover {\n  color: #FC495D;\n  border: 1px solid transparent;\n  background: #FED1D6;\n}\n.application-stage-red.hover.active,\n.application-stage-red:hover.active,\n.application-stage-red.hover:active,\n.application-stage-red:hover:active {\n  border-color: transparent;\n  background: #FED1D6;\n}\n.application-stage-red.hover.active.focus,\n.application-stage-red:hover.active.focus,\n.application-stage-red.hover:active.focus,\n.application-stage-red:hover:active.focus,\n.application-stage-red.hover.active:focus,\n.application-stage-red:hover.active:focus,\n.application-stage-red.hover:active:focus,\n.application-stage-red:hover:active:focus,\n.application-stage-red.hover.active:focus-visible,\n.application-stage-red:hover.active:focus-visible,\n.application-stage-red.hover:active:focus-visible,\n.application-stage-red:hover:active:focus-visible {\n  background: #FED1D6;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FFEDEF;\n}\n.application-stage-green {\n  background: #F0F9F1;\n  color: #73C677;\n}\n.application-stage-green svg {\n  stroke: #73C677;\n}\n.application-stage-green.focus,\n.application-stage-green:focus,\n.application-stage-green:focus-visible {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #DCF1DE;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #F0F9F1;\n}\n.application-stage-green.active,\n.application-stage-green:active {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #DCF1DE;\n}\n.application-stage-green.active.focus,\n.application-stage-green:active.focus,\n.application-stage-green.active:focus,\n.application-stage-green:active:focus,\n.application-stage-green.active:focus-visible,\n.application-stage-green:active:focus-visible {\n  background: #DCF1DE;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #F0F9F1;\n}\n.application-stage-green.hover,\n.application-stage-green:hover {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #DCF1DE;\n}\n.application-stage-green.hover.active,\n.application-stage-green:hover.active,\n.application-stage-green.hover:active,\n.application-stage-green:hover:active {\n  border-color: transparent;\n  background: #DCF1DE;\n}\n.application-stage-green.hover.active.focus,\n.application-stage-green:hover.active.focus,\n.application-stage-green.hover:active.focus,\n.application-stage-green:hover:active.focus,\n.application-stage-green.hover.active:focus,\n.application-stage-green:hover.active:focus,\n.application-stage-green.hover:active:focus,\n.application-stage-green:hover:active:focus,\n.application-stage-green.hover.active:focus-visible,\n.application-stage-green:hover.active:focus-visible,\n.application-stage-green.hover:active:focus-visible,\n.application-stage-green:hover:active:focus-visible {\n  background: #DCF1DE;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #F0F9F1;\n}\n.application-stage-blue {\n  background: #EFFBFD;\n  color: #34BFDE;\n}\n.application-stage-blue svg {\n  stroke: #73C677;\n}\n.application-stage-blue.focus,\n.application-stage-blue:focus,\n.application-stage-blue:focus-visible {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #D7F4FA;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #EFFBFD;\n}\n.application-stage-blue.active,\n.application-stage-blue:active {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #D7F4FA;\n}\n.application-stage-blue.active.focus,\n.application-stage-blue:active.focus,\n.application-stage-blue.active:focus,\n.application-stage-blue:active:focus,\n.application-stage-blue.active:focus-visible,\n.application-stage-blue:active:focus-visible {\n  background: #D7F4FA;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #EFFBFD;\n}\n.application-stage-blue.hover,\n.application-stage-blue:hover {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #D7F4FA;\n}\n.application-stage-blue.hover.active,\n.application-stage-blue:hover.active,\n.application-stage-blue.hover:active,\n.application-stage-blue:hover:active {\n  border-color: transparent;\n  background: #D7F4FA;\n}\n.application-stage-blue.hover.active.focus,\n.application-stage-blue:hover.active.focus,\n.application-stage-blue.hover:active.focus,\n.application-stage-blue:hover:active.focus,\n.application-stage-blue.hover.active:focus,\n.application-stage-blue:hover.active:focus,\n.application-stage-blue.hover:active:focus,\n.application-stage-blue:hover:active:focus,\n.application-stage-blue.hover.active:focus-visible,\n.application-stage-blue:hover.active:focus-visible,\n.application-stage-blue.hover:active:focus-visible,\n.application-stage-blue:hover:active:focus-visible {\n  background: #D7F4FA;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #EFFBFD;\n}\n.application-stage-none {\n  background: transparent;\n  color: #70859E;\n}\n.application-stage-none svg {\n  stroke: #10294D;\n}\n.application-stage-none.focus,\n.application-stage-none:focus,\n.application-stage-none:focus-visible {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.application-stage-none.active,\n.application-stage-none:active {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.application-stage-none.active.focus,\n.application-stage-none:active.focus,\n.application-stage-none.active:focus,\n.application-stage-none:active:focus,\n.application-stage-none.active:focus-visible,\n.application-stage-none:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.application-stage-none.hover,\n.application-stage-none:hover {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.application-stage-none.hover.active,\n.application-stage-none:hover.active,\n.application-stage-none.hover:active,\n.application-stage-none:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\n.application-stage-none.hover.active.focus,\n.application-stage-none:hover.active.focus,\n.application-stage-none.hover:active.focus,\n.application-stage-none:hover:active.focus,\n.application-stage-none.hover.active:focus,\n.application-stage-none:hover.active:focus,\n.application-stage-none.hover:active:focus,\n.application-stage-none:hover:active:focus,\n.application-stage-none.hover.active:focus-visible,\n.application-stage-none:hover.active:focus-visible,\n.application-stage-none.hover:active:focus-visible,\n.application-stage-none:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.application-stage-none-red {\n  background: transparent;\n  color: #70859E;\n}\n.application-stage-none-red svg {\n  stroke: #FC495D;\n}\n.application-stage-none-red.focus,\n.application-stage-none-red:focus,\n.application-stage-none-red:focus-visible {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.application-stage-none-red.active,\n.application-stage-none-red:active {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.application-stage-none-red.active.focus,\n.application-stage-none-red:active.focus,\n.application-stage-none-red.active:focus,\n.application-stage-none-red:active:focus,\n.application-stage-none-red.active:focus-visible,\n.application-stage-none-red:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.application-stage-none-red.hover,\n.application-stage-none-red:hover {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.application-stage-none-red.hover.active,\n.application-stage-none-red:hover.active,\n.application-stage-none-red.hover:active,\n.application-stage-none-red:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\n.application-stage-none-red.hover.active.focus,\n.application-stage-none-red:hover.active.focus,\n.application-stage-none-red.hover:active.focus,\n.application-stage-none-red:hover:active.focus,\n.application-stage-none-red.hover.active:focus,\n.application-stage-none-red:hover.active:focus,\n.application-stage-none-red.hover:active:focus,\n.application-stage-none-red:hover:active:focus,\n.application-stage-none-red.hover.active:focus-visible,\n.application-stage-none-red:hover.active:focus-visible,\n.application-stage-none-red.hover:active:focus-visible,\n.application-stage-none-red:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.application-stage-subtle {\n  background: transparent;\n  border: 1px solid #E5EBF1;\n  color: #10294D;\n}\n.application-stage-subtle svg {\n  stroke: #10294D;\n}\n.application-stage-subtle.focus,\n.application-stage-subtle:focus,\n.application-stage-subtle:focus-visible {\n  color: #071B38;\n  border: 1px solid #CED7E2;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.application-stage-subtle.active,\n.application-stage-subtle:active {\n  color: #071B38;\n  border: 1px solid #CED7E2;\n  background: transparent;\n}\n.application-stage-subtle.active.focus,\n.application-stage-subtle:active.focus,\n.application-stage-subtle.active:focus,\n.application-stage-subtle:active:focus,\n.application-stage-subtle.active:focus-visible,\n.application-stage-subtle:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.application-stage-subtle.hover,\n.application-stage-subtle:hover {\n  color: #071B38;\n  border: 1px solid #CED7E2;\n  background: transparent;\n}\n.application-stage-subtle.hover.active,\n.application-stage-subtle:hover.active,\n.application-stage-subtle.hover:active,\n.application-stage-subtle:hover:active {\n  border-color: #CED7E2;\n  background: transparent;\n}\n.application-stage-subtle.hover.active.focus,\n.application-stage-subtle:hover.active.focus,\n.application-stage-subtle.hover:active.focus,\n.application-stage-subtle:hover:active.focus,\n.application-stage-subtle.hover.active:focus,\n.application-stage-subtle:hover.active:focus,\n.application-stage-subtle.hover:active:focus,\n.application-stage-subtle:hover:active:focus,\n.application-stage-subtle.hover.active:focus-visible,\n.application-stage-subtle:hover.active:focus-visible,\n.application-stage-subtle.hover:active:focus-visible,\n.application-stage-subtle:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.application-stage-text {\n  background: transparent;\n  color: #10294D;\n}\n.application-stage-text svg {\n  stroke: #CED7E2;\n}\n.application-stage-text.focus,\n.application-stage-text:focus,\n.application-stage-text:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.application-stage-text.active,\n.application-stage-text:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.application-stage-text.active.focus,\n.application-stage-text:active.focus,\n.application-stage-text.active:focus,\n.application-stage-text:active:focus,\n.application-stage-text.active:focus-visible,\n.application-stage-text:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.application-stage-text.hover,\n.application-stage-text:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.application-stage-text.hover.active,\n.application-stage-text:hover.active,\n.application-stage-text.hover:active,\n.application-stage-text:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\n.application-stage-text.hover.active.focus,\n.application-stage-text:hover.active.focus,\n.application-stage-text.hover:active.focus,\n.application-stage-text:hover:active.focus,\n.application-stage-text.hover.active:focus,\n.application-stage-text:hover.active:focus,\n.application-stage-text.hover:active:focus,\n.application-stage-text:hover:active:focus,\n.application-stage-text.hover.active:focus-visible,\n.application-stage-text:hover.active:focus-visible,\n.application-stage-text.hover:active:focus-visible,\n.application-stage-text:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.application-stage-text-only {\n  padding: 0;\n  background: transparent;\n  color: #10294D;\n}\n.application-stage-text-only svg {\n  stroke: #CED7E2;\n}\n.application-stage-text-only.focus,\n.application-stage-text-only:focus,\n.application-stage-text-only:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.application-stage-text-only.active,\n.application-stage-text-only:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.application-stage-text-only.active.focus,\n.application-stage-text-only:active.focus,\n.application-stage-text-only.active:focus,\n.application-stage-text-only:active:focus,\n.application-stage-text-only.active:focus-visible,\n.application-stage-text-only:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.application-stage-text-only.hover,\n.application-stage-text-only:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.application-stage-text-only.hover.active,\n.application-stage-text-only:hover.active,\n.application-stage-text-only.hover:active,\n.application-stage-text-only:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\n.application-stage-text-only.hover.active.focus,\n.application-stage-text-only:hover.active.focus,\n.application-stage-text-only.hover:active.focus,\n.application-stage-text-only:hover:active.focus,\n.application-stage-text-only.hover.active:focus,\n.application-stage-text-only:hover.active:focus,\n.application-stage-text-only.hover:active:focus,\n.application-stage-text-only:hover:active:focus,\n.application-stage-text-only.hover.active:focus-visible,\n.application-stage-text-only:hover.active:focus-visible,\n.application-stage-text-only.hover:active:focus-visible,\n.application-stage-text-only:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.application-stage-grey {\n  background: #E5EBF1;\n  color: #10294D;\n}\n.application-stage-grey svg {\n  stroke: #10294D;\n}\n.application-stage-grey.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n  background: #E5EBF1;\n  color: #10294D;\n}\n.application-stage-grey.input-group-addon svg {\n  stroke: #10294D;\n}\n.application-stage-grey.focus,\n.application-stage-grey:focus,\n.application-stage-grey:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.application-stage-grey.active,\n.application-stage-grey:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\n.application-stage-grey.active.focus,\n.application-stage-grey:active.focus,\n.application-stage-grey.active:focus,\n.application-stage-grey:active:focus,\n.application-stage-grey.active:focus-visible,\n.application-stage-grey:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.application-stage-grey.hover,\n.application-stage-grey:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\n.application-stage-grey.hover.active,\n.application-stage-grey:hover.active,\n.application-stage-grey.hover:active,\n.application-stage-grey:hover:active {\n  border-color: transparent;\n  background: #CED7E2;\n}\n.application-stage-grey.hover.active.focus,\n.application-stage-grey:hover.active.focus,\n.application-stage-grey.hover:active.focus,\n.application-stage-grey:hover:active.focus,\n.application-stage-grey.hover.active:focus,\n.application-stage-grey:hover.active:focus,\n.application-stage-grey.hover:active:focus,\n.application-stage-grey:hover:active:focus,\n.application-stage-grey.hover.active:focus-visible,\n.application-stage-grey:hover.active:focus-visible,\n.application-stage-grey.hover:active:focus-visible,\n.application-stage-grey:hover:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.application-stage-grey-50 {\n  background: #F3F5F8;\n  color: #10294D;\n}\n.application-stage-grey-50 svg {\n  stroke: #10294D;\n}\n.application-stage-grey-50.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n  background: #F3F5F8;\n  color: #10294D;\n}\n.application-stage-grey-50.input-group-addon svg {\n  stroke: #10294D;\n}\n.application-stage-grey-50.focus,\n.application-stage-grey-50:focus,\n.application-stage-grey-50:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.application-stage-grey-50.active,\n.application-stage-grey-50:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\n.application-stage-grey-50.active.focus,\n.application-stage-grey-50:active.focus,\n.application-stage-grey-50.active:focus,\n.application-stage-grey-50:active:focus,\n.application-stage-grey-50.active:focus-visible,\n.application-stage-grey-50:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.application-stage-grey-50.hover,\n.application-stage-grey-50:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\n.application-stage-grey-50.hover.active,\n.application-stage-grey-50:hover.active,\n.application-stage-grey-50.hover:active,\n.application-stage-grey-50:hover:active {\n  border-color: transparent;\n  background: #E5EBF1;\n}\n.application-stage-grey-50.hover.active.focus,\n.application-stage-grey-50:hover.active.focus,\n.application-stage-grey-50.hover:active.focus,\n.application-stage-grey-50:hover:active.focus,\n.application-stage-grey-50.hover.active:focus,\n.application-stage-grey-50:hover.active:focus,\n.application-stage-grey-50.hover:active:focus,\n.application-stage-grey-50:hover:active:focus,\n.application-stage-grey-50.hover.active:focus-visible,\n.application-stage-grey-50:hover.active:focus-visible,\n.application-stage-grey-50.hover:active:focus-visible,\n.application-stage-grey-50:hover:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.application-stage-white {\n  background: #ffffff;\n  color: #10294D;\n}\n.application-stage-white svg {\n  stroke: #CED7E2;\n}\n.application-stage-white.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n  background: #E5EBF1;\n  color: #10294D;\n}\n.application-stage-white.input-group-addon svg {\n  stroke: #CED7E2;\n}\n.application-stage-white.focus,\n.application-stage-white:focus,\n.application-stage-white:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.application-stage-white.active,\n.application-stage-white:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\n.application-stage-white.active.focus,\n.application-stage-white:active.focus,\n.application-stage-white.active:focus,\n.application-stage-white:active:focus,\n.application-stage-white.active:focus-visible,\n.application-stage-white:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.application-stage-white.hover,\n.application-stage-white:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\n.application-stage-white.hover.active,\n.application-stage-white:hover.active,\n.application-stage-white.hover:active,\n.application-stage-white:hover:active {\n  border-color: transparent;\n  background: #CED7E2;\n}\n.application-stage-white.hover.active.focus,\n.application-stage-white:hover.active.focus,\n.application-stage-white.hover:active.focus,\n.application-stage-white:hover:active.focus,\n.application-stage-white.hover.active:focus,\n.application-stage-white:hover.active:focus,\n.application-stage-white.hover:active:focus,\n.application-stage-white:hover:active:focus,\n.application-stage-white.hover.active:focus-visible,\n.application-stage-white:hover.active:focus-visible,\n.application-stage-white.hover:active:focus-visible,\n.application-stage-white:hover:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.application-stage-white:hover svg,\n.application-stage-white.active svg,\n.application-stage-white:active svg {\n  stroke: #10294D;\n}\n.application-stage.disabled,\n.application-stage[disabled] {\n  background: #E5EBF1;\n  border: 1px solid transparent;\n  cursor: not-allowed;\n  color: #CED7E2;\n}\n.application-stage.disabled svg,\n.application-stage[disabled] svg {\n  display: block;\n  stroke: #CED7E2;\n}\n.application-stage.disabled.focus,\n.application-stage[disabled].focus,\n.application-stage.disabled:focus,\n.application-stage[disabled]:focus,\n.application-stage.disabled:focus-visible,\n.application-stage[disabled]:focus-visible {\n  color: #CED7E2;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.application-stage.disabled.active,\n.application-stage[disabled].active,\n.application-stage.disabled:active,\n.application-stage[disabled]:active {\n  color: #CED7E2;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\n.application-stage.disabled.active.focus,\n.application-stage[disabled].active.focus,\n.application-stage.disabled:active.focus,\n.application-stage[disabled]:active.focus,\n.application-stage.disabled.active:focus,\n.application-stage[disabled].active:focus,\n.application-stage.disabled:active:focus,\n.application-stage[disabled]:active:focus,\n.application-stage.disabled.active:focus-visible,\n.application-stage[disabled].active:focus-visible,\n.application-stage.disabled:active:focus-visible,\n.application-stage[disabled]:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.application-stage.disabled.hover,\n.application-stage[disabled].hover,\n.application-stage.disabled:hover,\n.application-stage[disabled]:hover {\n  color: #CED7E2;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\n.application-stage.disabled.hover.active,\n.application-stage[disabled].hover.active,\n.application-stage.disabled:hover.active,\n.application-stage[disabled]:hover.active,\n.application-stage.disabled.hover:active,\n.application-stage[disabled].hover:active,\n.application-stage.disabled:hover:active,\n.application-stage[disabled]:hover:active {\n  border-color: transparent;\n  background: #E5EBF1;\n}\n.application-stage.disabled.hover.active.focus,\n.application-stage[disabled].hover.active.focus,\n.application-stage.disabled:hover.active.focus,\n.application-stage[disabled]:hover.active.focus,\n.application-stage.disabled.hover:active.focus,\n.application-stage[disabled].hover:active.focus,\n.application-stage.disabled:hover:active.focus,\n.application-stage[disabled]:hover:active.focus,\n.application-stage.disabled.hover.active:focus,\n.application-stage[disabled].hover.active:focus,\n.application-stage.disabled:hover.active:focus,\n.application-stage[disabled]:hover.active:focus,\n.application-stage.disabled.hover:active:focus,\n.application-stage[disabled].hover:active:focus,\n.application-stage.disabled:hover:active:focus,\n.application-stage[disabled]:hover:active:focus,\n.application-stage.disabled.hover.active:focus-visible,\n.application-stage[disabled].hover.active:focus-visible,\n.application-stage.disabled:hover.active:focus-visible,\n.application-stage[disabled]:hover.active:focus-visible,\n.application-stage.disabled.hover:active:focus-visible,\n.application-stage[disabled].hover:active:focus-visible,\n.application-stage.disabled:hover:active:focus-visible,\n.application-stage[disabled]:hover:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.application-stage-icon-16 .icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n}\n.application-stage-icon-16 .icon svg {\n  width: 16px;\n  height: 16px;\n  stroke-width: 2.4;\n}\n.application-stage-icon-24 .icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n}\n.application-stage-icon-24 .icon svg {\n  width: 24px;\n  height: 24px;\n  stroke-width: 1.4;\n}\n.application-stage-icon-right {\n  padding-right: 10px;\n}\n.application-stage-icon-right .icon {\n  order: 1;\n  margin-left: 5px;\n}\n.application-stage-icon-right .icon svg {\n  fill: none;\n}\n.application-stage-icon-left {\n  padding-left: 10px;\n}\n.application-stage-icon-left .icon {\n  order: 0;\n  margin-right: 5px;\n}\n.application-stage-icon-left .icon svg {\n  fill: none;\n}\n.application-stage-icon-right.application-stage-icon-left .icon {\n  margin: 0;\n}\n.application-stage-icon-only {\n  padding: 0;\n}\n.application-stage-icon-only.btn-icon-24 {\n  min-height: 26px;\n  max-height: 26px;\n  max-width: 26px;\n}\n.application-stage-icon-only.btn-icon-24 .icon {\n  max-height: 24px;\n  max-width: 24px;\n}\n.application-stage-icon-only.btn-icon-16 {\n  min-height: 18px;\n  max-height: 18px;\n  max-width: 18px;\n}\n.application-stage-icon-only.btn-icon-16 .icon {\n  max-height: 16px;\n  max-width: 16px;\n}\n.application-stage-icon-only.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n}\n.application-stage-icon-success .icon svg {\n  fill: none;\n  stroke: #73C677;\n}\n.application-stage-glyph .icon svg {\n  stroke: none;\n}\n.application-stage.highlight {\n  --color4: #60D3EC;\n}\n.application-stage.has-submenu {\n  padding: 0;\n}\n.application-stage-red-text {\n  color: #FC495D;\n  padding-left: 1px;\n}\n.application-stage.Sent {\n  background: #3699FE;\n  color: #ffffff;\n}\n.application-stage.Submitted {\n  background: #BF60EC;\n  color: #ffffff;\n}\n.application-stage.Expired {\n  background: #FFA564;\n  color: #ffffff;\n}\n.application-stage.Accepted {\n  background: #73C677;\n  color: #ffffff;\n}\n.application-stage.Declined {\n  background: #FC495D;\n  color: #ffffff;\n}\n@media print {\n  body {\n    height: auto;\n    width: auto;\n    overflow: visible;\n    flex-wrap: nowrap !important;\n  }\n  .viewhead {\n    display: none;\n  }\n  .print-page .viewhead {\n    display: none;\n  }\n  .print-page .print-card-no-display {\n    visibility: hidden !important;\n  }\n  .print-page .mini {\n    grid-template-columns: 20px 1fr;\n  }\n  .print-page .view .heavy {\n    flex: 0 0 1%;\n  }\n  .print-page .meta-detail {\n    display: flex !important;\n    flex-wrap: wrap;\n    line-height: 1.5rem;\n    grid-gap: 0 16px;\n    gap: 0 16px;\n  }\n  .print-page .col-lg-6 {\n    flex: 1;\n  }\n  .print-page .meta-detail .col {\n    padding: 5px 6px !important;\n  }\n  .print-page .view .heavy + div {\n    display: flex;\n    flex: 1;\n    padding: 5px 6px;\n    min-width: auto;\n    overflow-wrap: break-word;\n  }\n  .print-page .model-details {\n    background-color: #ffffff;\n    padding: 0px 0 0 0 !important;\n  }\n  .print-page .card {\n    break-inside: avoid;\n    position: relative;\n    border-radius: 0 !important;\n    box-shadow: none;\n    margin-bottom: 0px !important;\n    width: 100%;\n    border: none;\n    border-bottom: 1px solid #CED7E2;\n  }\n  .print-page .card:last-of-type {\n    border-bottom: 1px solid transparent;\n  }\n  .print-page .wrapper {\n    display: block !important;\n    height: auto !important;\n    grid-template-rows: 20px auto;\n    background-color: #ffffff !important;\n  }\n  .print-page .wrapper .content:not(.form-group) {\n    display: block !important;\n    background-color: #ffffff;\n    grid-template-rows: 20px auto !important;\n  }\n  .print-page .wrapper .content:not(.form-group) .scrollview {\n    position: relative !important;\n    display: block !important;\n    overflow: visible !important;\n  }\n  .image-gallery .image-gallery-thumb {\n    flex: 0 0 calc(100% / 4 - 20px);\n    min-width: 0;\n  }\n  .productfruits--container {\n    display: none;\n  }\n  .model-details .card .cardbody > .ccontent {\n    page-break-before: avoid;\n  }\n}\n.print-page .viewcontent {\n  padding: 0;\n}\n.print-page .viewhead {\n  display: none;\n}\n.print-page .mini {\n  grid-template-columns: 20px 1fr;\n}\n.print-page .print-card-no-display {\n  color: #ffffff !important;\n  border: none !important;\n}\n.print-page .checkmark {\n  border: none !important;\n  background: transparent !important;\n}\n.print-page .model-details {\n  background-color: #ffffff;\n  padding: 0px 0 0 0 !important;\n}\n.print-page .meta-detail .col {\n  padding: 5px 6px !important;\n}\n.print-page .meta-detail .col iframe {\n  border: 0;\n}\n.print-page .viewhead {\n  display: none;\n}\n.print-page .mini {\n  grid-template-columns: 20px 1fr;\n}\n.print-page .view .heavy {\n  flex: 0 0 1%;\n}\n.print-page .meta-detail {\n  display: flex !important;\n  flex-wrap: wrap;\n  line-height: 1.5rem;\n  grid-gap: 0 16px;\n  gap: 0 16px;\n}\n.print-page .col-lg-6 {\n  flex: 1;\n}\n.print-page .meta-detail .col a {\n  flex: 1;\n}\n.print-page .view .heavy + div {\n  display: flex;\n  flex: 1;\n  padding: 5px 6px;\n  min-width: auto;\n  overflow-wrap: anywhere;\n}\n.print-page .view .heavy + div {\n  display: flex;\n  flex: 1;\n  padding: 5px 6px;\n  min-width: auto;\n  overflow-wrap: break-word;\n}\n.print-page .card {\n  break-inside: avoid;\n  position: relative;\n  border-radius: 0 !important;\n  box-shadow: none;\n  margin-bottom: 0px !important;\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid #CED7E2;\n}\n.print-page .card .section-underline {\n  width: 100%;\n}\n.print-page .card:last-of-type {\n  border-bottom: 1px solid transparent;\n}\n.print-page .wrapper {\n  grid-template-columns: auto;\n  grid-template-rows: auto;\n  background-color: #ffffff !important;\n  grid-template-areas: \"header\" \"content\";\n}\n.print-page .wrapper .content:not(.form-group) {\n  grid-template-columns: auto;\n  grid-template-rows: auto;\n  grid-template-areas: \"view\";\n  background-color: #ffffff !important;\n  height: 100vh;\n}\n.print-page .image-gallery {\n  justify-content: space-between;\n  grid-template-columns: repeat(3, 1fr);\n}\n.print-page .image-gallery img {\n  page-break-before: auto;\n  page-break-after: auto;\n  page-break-inside: avoid;\n}\n.print-page .image-gallery .image-gallery-thumb-img-size {\n  display: none;\n}\n.print-page .image-gallery .image-gallery-thumb-meta {\n  display: none;\n}\n.print-page .address-date {\n  flex: 0 0 100%;\n  text-align: center;\n}\n@media screen and (min-width: 799px) {\n  .print-page .header-section {\n    height: 90px;\n    justify-content: space-between;\n  }\n  .print-page .address-date {\n    flex: 1 1 auto;\n    text-align: right;\n  }\n}\n.print-page .header-section {\n  flex-wrap: wrap;\n  height: auto;\n  justify-content: center;\n  gap: 20px 20px;\n}\n.header-section {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  height: 90px;\n  box-sizing: border-box;\n}\n.header-section .logo img {\n  object-fit: contain;\n  height: 50px;\n}\n.header-section .address-date .address {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 27px;\n}\n.header-section .address-date .datetime {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 21px;\n}\n.tags-search .input-group.keyword-search {\n  flex: 0 0 100%;\n}\n@media screen and (min-width: 799px) {\n  .tags-search .input-group.keyword-search {\n    flex: 0 0 200px;\n  }\n}\n.tags-search .input-group.keyword-search + .btn {\n  flex: 0 0 100%;\n  justify-content: center;\n}\n@media screen and (min-width: 799px) {\n  .tags-search .input-group.keyword-search + .btn {\n    flex: 0 0 0;\n  }\n}\n.tags-search .search-buttons {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 10px 10px;\n}\n.tags-search .search-buttons .btn {\n  flex: 0 0 100%;\n  justify-content: center;\n}\n@media screen and (min-width: 799px) {\n  .tags-search .search-buttons .btn {\n    flex: 0 0 0;\n  }\n}\n.tagsbody {\n  max-width: calc(100vw - 82px);\n}\n.modelchoice {\n  grid-template-rows: min-content;\n}\n.modelchoice .choice {\n  display: flex;\n  justify-content: center;\n  max-height: 350px;\n}\n.modelchoice .choice .ccontent {\n  height: 100%;\n}\n.modelchoice .choice .ccontent .preview {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.modelchoice .choice .ccontent .preview:hover {\n  cursor: pointer;\n}\n.modelchoice .choice .ccontent .preview img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n.modelchoice h2 {\n  margin-top: 20px;\n}\n.modelchoice .img-placeholder {\n  height: 250px;\n}\n.group-detail .details {\n  padding: 15px;\n}\n.view.details,\n.view.model {\n  grid-area: view;\n}\n.view.details .viewcontent,\n.view.model .viewcontent {\n  width: 100%;\n  height: 100%;\n}\n.view.details.brochures .flex-container,\n.view.model.brochures .flex-container {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n.view.details.brochures .form-group.checkinput .checkcontainer,\n.view.model.brochures .form-group.checkinput .checkcontainer {\n  min-height: 24px;\n  margin-top: -5px;\n  margin-bottom: -5px;\n}\n.html-preview .viewcontent .horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav {\n  max-width: calc(100vw - 40px);\n}\n.html-preview .viewcontent .horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-content {\n  padding-left: 0;\n  padding-right: 0;\n}\n.html-preview .viewcontent .html-preview-form {\n  background: none;\n  grid-area: form;\n}\n.html-preview .viewcontent .html-preview-form form {\n  display: block;\n}\n.html-preview .viewcontent .tab-content {\n  padding: 0;\n}\n.html-preview .viewcontent .preview-pane {\n  padding-top: 20px;\n  grid-area: pane;\n}\n.html-preview .viewcontent .recipients-count {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  margin: 20px;\n}\n.html-preview .viewcontent .recipients-count > div {\n  line-height: 36px;\n  margin-right: 10px;\n}\n.col-md-4 .horizontal-tabs-container {\n  margin-top: -20px;\n}\n.permission-list {\n  padding: 0;\n  margin: 0;\n}\n.permission-list li {\n  list-style: none;\n  border-bottom: 1px solid #cccccc;\n  line-height: 3em;\n  margin: 0;\n  padding-left: 15px;\n}\n.permission-list li svg {\n  margin-right: 10px;\n  height: 18px;\n}\n.permission-list li span {\n  display: inline-block;\n  line-height: 18px;\n  vertical-align: middle;\n}\n.permission-list li:last-of-type {\n  border-bottom: none;\n}\n.model-details {\n  padding: 20px;\n  min-width: 0;\n  min-height: 0;\n  overflow: auto;\n  position: relative;\n}\n@media screen and (min-width: 799px) {\n  .model-details {\n    padding-left: 0;\n    padding-top: 0;\n  }\n}\n.model-details .card .cardbody > .ccontent {\n  display: flex;\n  flex-wrap: wrap;\n  padding-top: 5px;\n  gap: 7px 0;\n}\n.model-details #portal-feeds .ccontent > .meta-group > .meta-group {\n  border-bottom: 4px solid #E5EBF1;\n}\n.model-details #portal-feeds .ccontent > .meta-group > .meta-group:last-of-type {\n  border-bottom: none;\n}\n.model-details .array-group {\n  margin-bottom: 20px;\n  padding-bottom: 8px;\n}\n.financial-structure.ccontent {\n  display: flex;\n  flex-wrap: wrap;\n  padding-top: 5px;\n  gap: 7px 0;\n}\n.meta-group {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 0 0 100%;\n  gap: 7px 20px;\n}\n.meta-group .col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n}\n.meta-group .col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: none;\n}\n.meta-group .col-1 {\n  flex: 0 1 calc(8.33333333%);\n  flex: 0 1 calc(8.33333333% - 18.33333333px);\n  max-width: 8.33333333%;\n}\n.meta-group .col-2 {\n  flex: 0 1 calc(16.66666667%);\n  flex: 0 1 calc(16.66666667% - 16.66666667px);\n  max-width: 16.66666667%;\n}\n.meta-group .col-3 {\n  flex: 0 1 calc(25%);\n  flex: 0 1 calc(25% - 15px);\n  max-width: 25%;\n}\n.meta-group .col-4 {\n  flex: 0 1 calc(33.33333333%);\n  flex: 0 1 calc(33.33333333% - 13.33333333px);\n  max-width: 33.33333333%;\n}\n.meta-group .col-5 {\n  flex: 0 1 calc(41.66666667%);\n  flex: 0 1 calc(41.66666667% - 16.66666667px);\n  max-width: 41.66666667%;\n}\n.meta-group .col-6 {\n  flex: 0 1 calc(50%);\n  flex: 0 1 calc(50% - 10px);\n  max-width: 50%;\n}\n.meta-group .col-7 {\n  flex: 0 1 calc(58.33333333%);\n  flex: 0 1 calc(58.33333333% - 11.66666667px);\n  max-width: 58.33333333%;\n}\n.meta-group .col-8 {\n  flex: 0 1 calc(66.66666667%);\n  flex: 0 1 calc(66.66666667% - 13.33333333px);\n  max-width: 66.66666667%;\n}\n.meta-group .col-9 {\n  flex: 0 1 calc(75%);\n  flex: 0 1 calc(75% - 15px);\n  max-width: 75%;\n}\n.meta-group .col-10 {\n  flex: 0 1 calc(83.33333333%);\n  flex: 0 1 calc(83.33333333% - 16.66666667px);\n  max-width: 83.33333333%;\n}\n.meta-group .col-11 {\n  flex: 0 1 calc(91.66666667%);\n  flex: 0 1 calc(91.66666667% - 18.33333333px);\n  max-width: 91.66666667%;\n}\n.meta-group .col-12 {\n  flex: 0 1 calc(100%);\n  max-width: 100%;\n}\n.meta-group .order-first {\n  order: -1;\n}\n.meta-group .order-last {\n  order: 13;\n}\n.meta-group .order-0 {\n  order: 0;\n}\n.meta-group .order-1 {\n  order: 1;\n}\n.meta-group .order-2 {\n  order: 2;\n}\n.meta-group .order-3 {\n  order: 3;\n}\n.meta-group .order-4 {\n  order: 4;\n}\n.meta-group .order-5 {\n  order: 5;\n}\n.meta-group .order-6 {\n  order: 6;\n}\n.meta-group .order-7 {\n  order: 7;\n}\n.meta-group .order-8 {\n  order: 8;\n}\n.meta-group .order-9 {\n  order: 9;\n}\n.meta-group .order-10 {\n  order: 10;\n}\n.meta-group .order-11 {\n  order: 11;\n}\n.meta-group .order-12 {\n  order: 12;\n}\n.meta-group .offset-1 {\n  margin-left: 8.33333333%;\n}\n.meta-group .offset-2 {\n  margin-left: 16.66666667%;\n}\n.meta-group .offset-3 {\n  margin-left: 25%;\n}\n.meta-group .offset-4 {\n  margin-left: 33.33333333%;\n}\n.meta-group .offset-5 {\n  margin-left: 41.66666667%;\n}\n.meta-group .offset-6 {\n  margin-left: 50%;\n}\n.meta-group .offset-7 {\n  margin-left: 58.33333333%;\n}\n.meta-group .offset-8 {\n  margin-left: 66.66666667%;\n}\n.meta-group .offset-9 {\n  margin-left: 75%;\n}\n.meta-group .offset-10 {\n  margin-left: 83.33333333%;\n}\n.meta-group .offset-11 {\n  margin-left: 91.66666667%;\n}\n@media (min-width: 576px) {\n  .meta-group .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .meta-group .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .meta-group .col-sm-1 {\n    flex: 0 1 calc(8.33333333%);\n    flex: 0 1 calc(8.33333333% - 18.33333333px);\n    max-width: 8.33333333%;\n  }\n  .meta-group .col-sm-2 {\n    flex: 0 1 calc(16.66666667%);\n    flex: 0 1 calc(16.66666667% - 16.66666667px);\n    max-width: 16.66666667%;\n  }\n  .meta-group .col-sm-3 {\n    flex: 0 1 calc(25%);\n    flex: 0 1 calc(25% - 15px);\n    max-width: 25%;\n  }\n  .meta-group .col-sm-4 {\n    flex: 0 1 calc(33.33333333%);\n    flex: 0 1 calc(33.33333333% - 13.33333333px);\n    max-width: 33.33333333%;\n  }\n  .meta-group .col-sm-5 {\n    flex: 0 1 calc(41.66666667%);\n    flex: 0 1 calc(41.66666667% - 16.66666667px);\n    max-width: 41.66666667%;\n  }\n  .meta-group .col-sm-6 {\n    flex: 0 1 calc(50%);\n    flex: 0 1 calc(50% - 10px);\n    max-width: 50%;\n  }\n  .meta-group .col-sm-7 {\n    flex: 0 1 calc(58.33333333%);\n    flex: 0 1 calc(58.33333333% - 11.66666667px);\n    max-width: 58.33333333%;\n  }\n  .meta-group .col-sm-8 {\n    flex: 0 1 calc(66.66666667%);\n    flex: 0 1 calc(66.66666667% - 13.33333333px);\n    max-width: 66.66666667%;\n  }\n  .meta-group .col-sm-9 {\n    flex: 0 1 calc(75%);\n    flex: 0 1 calc(75% - 15px);\n    max-width: 75%;\n  }\n  .meta-group .col-sm-10 {\n    flex: 0 1 calc(83.33333333%);\n    flex: 0 1 calc(83.33333333% - 16.66666667px);\n    max-width: 83.33333333%;\n  }\n  .meta-group .col-sm-11 {\n    flex: 0 1 calc(91.66666667%);\n    flex: 0 1 calc(91.66666667% - 18.33333333px);\n    max-width: 91.66666667%;\n  }\n  .meta-group .col-sm-12 {\n    flex: 0 1 calc(100%);\n    max-width: 100%;\n  }\n  .meta-group .order-sm-first {\n    order: -1;\n  }\n  .meta-group .order-sm-last {\n    order: 13;\n  }\n  .meta-group .order-sm-0 {\n    order: 0;\n  }\n  .meta-group .order-sm-1 {\n    order: 1;\n  }\n  .meta-group .order-sm-2 {\n    order: 2;\n  }\n  .meta-group .order-sm-3 {\n    order: 3;\n  }\n  .meta-group .order-sm-4 {\n    order: 4;\n  }\n  .meta-group .order-sm-5 {\n    order: 5;\n  }\n  .meta-group .order-sm-6 {\n    order: 6;\n  }\n  .meta-group .order-sm-7 {\n    order: 7;\n  }\n  .meta-group .order-sm-8 {\n    order: 8;\n  }\n  .meta-group .order-sm-9 {\n    order: 9;\n  }\n  .meta-group .order-sm-10 {\n    order: 10;\n  }\n  .meta-group .order-sm-11 {\n    order: 11;\n  }\n  .meta-group .order-sm-12 {\n    order: 12;\n  }\n  .meta-group .offset-sm-0 {\n    margin-left: 0;\n  }\n  .meta-group .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .meta-group .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .meta-group .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .meta-group .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .meta-group .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .meta-group .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .meta-group .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .meta-group .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .meta-group .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .meta-group .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .meta-group .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n}\n@media (min-width: 768px) {\n  .meta-group .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .meta-group .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .meta-group .col-md-1 {\n    flex: 0 1 calc(8.33333333%);\n    flex: 0 1 calc(8.33333333% - 18.33333333px);\n    max-width: 8.33333333%;\n  }\n  .meta-group .col-md-2 {\n    flex: 0 1 calc(16.66666667%);\n    flex: 0 1 calc(16.66666667% - 16.66666667px);\n    max-width: 16.66666667%;\n  }\n  .meta-group .col-md-3 {\n    flex: 0 1 calc(25%);\n    flex: 0 1 calc(25% - 15px);\n    max-width: 25%;\n  }\n  .meta-group .col-md-4 {\n    flex: 0 1 calc(33.33333333%);\n    flex: 0 1 calc(33.33333333% - 13.33333333px);\n    max-width: 33.33333333%;\n  }\n  .meta-group .col-md-5 {\n    flex: 0 1 calc(41.66666667%);\n    flex: 0 1 calc(41.66666667% - 16.66666667px);\n    max-width: 41.66666667%;\n  }\n  .meta-group .col-md-6 {\n    flex: 0 1 calc(50%);\n    flex: 0 1 calc(50% - 10px);\n    max-width: 50%;\n  }\n  .meta-group .col-md-7 {\n    flex: 0 1 calc(58.33333333%);\n    flex: 0 1 calc(58.33333333% - 11.66666667px);\n    max-width: 58.33333333%;\n  }\n  .meta-group .col-md-8 {\n    flex: 0 1 calc(66.66666667%);\n    flex: 0 1 calc(66.66666667% - 13.33333333px);\n    max-width: 66.66666667%;\n  }\n  .meta-group .col-md-9 {\n    flex: 0 1 calc(75%);\n    flex: 0 1 calc(75% - 15px);\n    max-width: 75%;\n  }\n  .meta-group .col-md-10 {\n    flex: 0 1 calc(83.33333333%);\n    flex: 0 1 calc(83.33333333% - 16.66666667px);\n    max-width: 83.33333333%;\n  }\n  .meta-group .col-md-11 {\n    flex: 0 1 calc(91.66666667%);\n    flex: 0 1 calc(91.66666667% - 18.33333333px);\n    max-width: 91.66666667%;\n  }\n  .meta-group .col-md-12 {\n    flex: 0 1 calc(100%);\n    max-width: 100%;\n  }\n  .meta-group .order-md-first {\n    order: -1;\n  }\n  .meta-group .order-md-last {\n    order: 13;\n  }\n  .meta-group .order-md-0 {\n    order: 0;\n  }\n  .meta-group .order-md-1 {\n    order: 1;\n  }\n  .meta-group .order-md-2 {\n    order: 2;\n  }\n  .meta-group .order-md-3 {\n    order: 3;\n  }\n  .meta-group .order-md-4 {\n    order: 4;\n  }\n  .meta-group .order-md-5 {\n    order: 5;\n  }\n  .meta-group .order-md-6 {\n    order: 6;\n  }\n  .meta-group .order-md-7 {\n    order: 7;\n  }\n  .meta-group .order-md-8 {\n    order: 8;\n  }\n  .meta-group .order-md-9 {\n    order: 9;\n  }\n  .meta-group .order-md-10 {\n    order: 10;\n  }\n  .meta-group .order-md-11 {\n    order: 11;\n  }\n  .meta-group .order-md-12 {\n    order: 12;\n  }\n  .meta-group .offset-md-0 {\n    margin-left: 0;\n  }\n  .meta-group .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .meta-group .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .meta-group .offset-md-3 {\n    margin-left: 25%;\n  }\n  .meta-group .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .meta-group .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .meta-group .offset-md-6 {\n    margin-left: 50%;\n  }\n  .meta-group .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .meta-group .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .meta-group .offset-md-9 {\n    margin-left: 75%;\n  }\n  .meta-group .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .meta-group .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n}\n@media (min-width: 992px) {\n  .meta-group .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .meta-group .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .meta-group .col-lg-1 {\n    flex: 0 1 calc(8.33333333%);\n    flex: 0 1 calc(8.33333333% - 18.33333333px);\n    max-width: 8.33333333%;\n  }\n  .meta-group .col-lg-2 {\n    flex: 0 1 calc(16.66666667%);\n    flex: 0 1 calc(16.66666667% - 16.66666667px);\n    max-width: 16.66666667%;\n  }\n  .meta-group .col-lg-3 {\n    flex: 0 1 calc(25%);\n    flex: 0 1 calc(25% - 15px);\n    max-width: 25%;\n  }\n  .meta-group .col-lg-4 {\n    flex: 0 1 calc(33.33333333%);\n    flex: 0 1 calc(33.33333333% - 13.33333333px);\n    max-width: 33.33333333%;\n  }\n  .meta-group .col-lg-5 {\n    flex: 0 1 calc(41.66666667%);\n    flex: 0 1 calc(41.66666667% - 16.66666667px);\n    max-width: 41.66666667%;\n  }\n  .meta-group .col-lg-6 {\n    flex: 0 1 calc(50%);\n    flex: 0 1 calc(50% - 10px);\n    max-width: 50%;\n  }\n  .meta-group .col-lg-7 {\n    flex: 0 1 calc(58.33333333%);\n    flex: 0 1 calc(58.33333333% - 11.66666667px);\n    max-width: 58.33333333%;\n  }\n  .meta-group .col-lg-8 {\n    flex: 0 1 calc(66.66666667%);\n    flex: 0 1 calc(66.66666667% - 13.33333333px);\n    max-width: 66.66666667%;\n  }\n  .meta-group .col-lg-9 {\n    flex: 0 1 calc(75%);\n    flex: 0 1 calc(75% - 15px);\n    max-width: 75%;\n  }\n  .meta-group .col-lg-10 {\n    flex: 0 1 calc(83.33333333%);\n    flex: 0 1 calc(83.33333333% - 16.66666667px);\n    max-width: 83.33333333%;\n  }\n  .meta-group .col-lg-11 {\n    flex: 0 1 calc(91.66666667%);\n    flex: 0 1 calc(91.66666667% - 18.33333333px);\n    max-width: 91.66666667%;\n  }\n  .meta-group .col-lg-12 {\n    flex: 0 1 calc(100%);\n    max-width: 100%;\n  }\n  .meta-group .order-lg-first {\n    order: -1;\n  }\n  .meta-group .order-lg-last {\n    order: 13;\n  }\n  .meta-group .order-lg-0 {\n    order: 0;\n  }\n  .meta-group .order-lg-1 {\n    order: 1;\n  }\n  .meta-group .order-lg-2 {\n    order: 2;\n  }\n  .meta-group .order-lg-3 {\n    order: 3;\n  }\n  .meta-group .order-lg-4 {\n    order: 4;\n  }\n  .meta-group .order-lg-5 {\n    order: 5;\n  }\n  .meta-group .order-lg-6 {\n    order: 6;\n  }\n  .meta-group .order-lg-7 {\n    order: 7;\n  }\n  .meta-group .order-lg-8 {\n    order: 8;\n  }\n  .meta-group .order-lg-9 {\n    order: 9;\n  }\n  .meta-group .order-lg-10 {\n    order: 10;\n  }\n  .meta-group .order-lg-11 {\n    order: 11;\n  }\n  .meta-group .order-lg-12 {\n    order: 12;\n  }\n  .meta-group .offset-lg-0 {\n    margin-left: 0;\n  }\n  .meta-group .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .meta-group .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .meta-group .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .meta-group .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .meta-group .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .meta-group .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .meta-group .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .meta-group .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .meta-group .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .meta-group .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .meta-group .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n}\n@media (min-width: 1200px) {\n  .meta-group .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .meta-group .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .meta-group .col-xl-1 {\n    flex: 0 1 calc(8.33333333%);\n    flex: 0 1 calc(8.33333333% - 18.33333333px);\n    max-width: 8.33333333%;\n  }\n  .meta-group .col-xl-2 {\n    flex: 0 1 calc(16.66666667%);\n    flex: 0 1 calc(16.66666667% - 16.66666667px);\n    max-width: 16.66666667%;\n  }\n  .meta-group .col-xl-3 {\n    flex: 0 1 calc(25%);\n    flex: 0 1 calc(25% - 15px);\n    max-width: 25%;\n  }\n  .meta-group .col-xl-4 {\n    flex: 0 1 calc(33.33333333%);\n    flex: 0 1 calc(33.33333333% - 13.33333333px);\n    max-width: 33.33333333%;\n  }\n  .meta-group .col-xl-5 {\n    flex: 0 1 calc(41.66666667%);\n    flex: 0 1 calc(41.66666667% - 16.66666667px);\n    max-width: 41.66666667%;\n  }\n  .meta-group .col-xl-6 {\n    flex: 0 1 calc(50%);\n    flex: 0 1 calc(50% - 10px);\n    max-width: 50%;\n  }\n  .meta-group .col-xl-7 {\n    flex: 0 1 calc(58.33333333%);\n    flex: 0 1 calc(58.33333333% - 11.66666667px);\n    max-width: 58.33333333%;\n  }\n  .meta-group .col-xl-8 {\n    flex: 0 1 calc(66.66666667%);\n    flex: 0 1 calc(66.66666667% - 13.33333333px);\n    max-width: 66.66666667%;\n  }\n  .meta-group .col-xl-9 {\n    flex: 0 1 calc(75%);\n    flex: 0 1 calc(75% - 15px);\n    max-width: 75%;\n  }\n  .meta-group .col-xl-10 {\n    flex: 0 1 calc(83.33333333%);\n    flex: 0 1 calc(83.33333333% - 16.66666667px);\n    max-width: 83.33333333%;\n  }\n  .meta-group .col-xl-11 {\n    flex: 0 1 calc(91.66666667%);\n    flex: 0 1 calc(91.66666667% - 18.33333333px);\n    max-width: 91.66666667%;\n  }\n  .meta-group .col-xl-12 {\n    flex: 0 1 calc(100%);\n    max-width: 100%;\n  }\n  .meta-group .order-xl-first {\n    order: -1;\n  }\n  .meta-group .order-xl-last {\n    order: 13;\n  }\n  .meta-group .order-xl-0 {\n    order: 0;\n  }\n  .meta-group .order-xl-1 {\n    order: 1;\n  }\n  .meta-group .order-xl-2 {\n    order: 2;\n  }\n  .meta-group .order-xl-3 {\n    order: 3;\n  }\n  .meta-group .order-xl-4 {\n    order: 4;\n  }\n  .meta-group .order-xl-5 {\n    order: 5;\n  }\n  .meta-group .order-xl-6 {\n    order: 6;\n  }\n  .meta-group .order-xl-7 {\n    order: 7;\n  }\n  .meta-group .order-xl-8 {\n    order: 8;\n  }\n  .meta-group .order-xl-9 {\n    order: 9;\n  }\n  .meta-group .order-xl-10 {\n    order: 10;\n  }\n  .meta-group .order-xl-11 {\n    order: 11;\n  }\n  .meta-group .order-xl-12 {\n    order: 12;\n  }\n  .meta-group .offset-xl-0 {\n    margin-left: 0;\n  }\n  .meta-group .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .meta-group .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .meta-group .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .meta-group .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .meta-group .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .meta-group .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .meta-group .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .meta-group .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .meta-group .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .meta-group .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .meta-group .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n}\n.meta-group [class^=\"col-\"],\n.meta-group [class*=\"col-\"] {\n  padding: 0;\n}\n.meta-group .meta-detail:not([class^=\"col-\"]):not([class*=\"col-\"]) {\n  display: inherit;\n  flex-wrap: wrap;\n  gap: 16px 20px;\n}\n.meta-group .meta-detail:not([class^=\"col-\"]):not([class*=\"col-\"]) .tip {\n  flex: 0 0 100%;\n}\n.meta-group .bordered {\n  margin-top: 23px;\n  border-top: 4px solid #E5EBF1;\n  padding-top: 27px;\n  flex: 0 0 calc(100% + 30px);\n}\n.meta-detail {\n  display: flex;\n  flex-wrap: wrap;\n  line-height: 1.5rem;\n  gap: 0 16px;\n}\n.meta-detail div.domstring {\n  /* Ensure that the formatting is not lost on the Description text. */\n  white-space: pre-wrap;\n}\n.meta-detail div.domstring.position-left {\n  float: left;\n}\n.meta-detail div.domstring.position-right {\n  float: right;\n}\n.meta-detail div.domstring.position-full {\n  width: 100%;\n}\n.meta-detail div.domstring .inline-image {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n}\n.meta-detail div.domstring .inline-image figcaption {\n  padding: 10px;\n  width: 100%;\n  text-align: center;\n}\n.meta-detail ul {\n  padding-top: 0;\n}\n.meta-detail svg {\n  margin: 0;\n  height: 18px;\n  vertical-align: middle;\n  transition: all 0.3s ease 0s;\n}\n.meta-detail label {\n  margin-bottom: 0;\n}\n.meta-detail .btn {\n  line-height: 1.5rem;\n  vertical-align: top;\n  margin-right: 20px;\n}\n.meta-detail .col.cell_number {\n  display: flex;\n  flex-wrap: wrap;\n}\n.meta-detail .col.cell_number > div {\n  flex: 0 0 100%;\n  display: flex;\n}\n.meta-detail .col {\n  flex-wrap: wrap;\n  align-self: flex-start;\n}\n.meta-detail .col a {\n  flex: 0 0 auto;\n}\n.meta-detail .col:has(.tags-selected) {\n  gap: 6px 6px;\n}\n.meta-detail.extras .col {\n  align-items: center;\n  display: flex;\n  flex: 1 1;\n  flex-wrap: wrap;\n  min-width: 240px;\n  padding: 0;\n  gap: 6px 6px;\n  -webkit-overflow-scrolling: touch;\n  position: relative;\n  overflow: hidden;\n  box-sizing: border-box;\n  border: none;\n}\n@media screen and (max-width: 799px) {\n  .meta-detail.extras .col {\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n}\n.meta-detail.extras .extras-legend {\n  margin-left: 3px;\n}\n.meta-detail.extras .extras-selected {\n  background: #ffffff;\n  border-radius: 2px;\n  border: 1px solid #E5EBF1;\n  padding: 3px;\n}\n.meta-detail.extras .extras-selected .extras-label {\n  padding-left: 3px;\n}\n@media screen and (max-width: 799px) {\n  .meta-detail.extras .extras-selected {\n    flex: 0 0 100%;\n  }\n}\n.meta-detail .tags-selected {\n  display: flex;\n  align-items: center;\n  background: #ffffff;\n  border-radius: 2px;\n  border: 1px solid #E5EBF1;\n  padding: 3px;\n  line-height: 1;\n  font-size: 11px;\n}\n.meta-detail .tags-selected .tag-tags {\n  margin-left: 3px;\n  padding: 2px 5px;\n  border-radius: 2px;\n  background: #FC495D;\n  color: #ffffff;\n  font-size: 11px;\n}\n@media screen and (max-width: 799px) {\n  .meta-detail .tags-selected {\n    flex: 0 0 100%;\n  }\n}\n.meta-detail .col.tags {\n  padding-top: 2.5px;\n  padding-bottom: 0;\n  padding-right: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 6px;\n}\n.view .heavy {\n  text-transform: uppercase;\n  display: flex;\n  word-wrap: anywhere;\n  background: #F3F5F8;\n  padding: 5px 6px;\n  flex: 0 0 100%;\n  min-width: 190px;\n  font-size: 10px;\n  margin-bottom: auto;\n}\n@media screen and (min-width: 799px) {\n  .view .heavy {\n    flex: 0 0 1%;\n  }\n}\n.view .heavy + div {\n  display: flex;\n  padding: 5px 6px;\n  min-width: 200px;\n  overflow-wrap: anywhere;\n}\n.view .heavy + div.agent {\n  margin-right: 0;\n}\n.view .dashboard-meta {\n  flex: 1 1 100%;\n}\n.view .dashboard-meta .heavy {\n  background: none;\n  padding: 0;\n  font-size: 14px;\n  color: #10294D;\n  font-weight: 600;\n  text-transform: none;\n  min-width: 120px;\n}\n.view .dashboard-meta .heavy + div {\n  display: inline;\n  padding: 0;\n  flex: 1 1;\n  font-size: 14px;\n  min-width: 0;\n}\n.view .dashboard-meta.subtle-meta .heavy {\n  font-weight: 400;\n  color: #70859E;\n}\n.view .dashboard-meta.subtle-meta .heavy + div {\n  display: none;\n}\n.input-group .contact-details {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 10px;\n  flex: 1 1;\n}\n.input-group .contact-details.col-auto {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px 0;\n  flex: 1 1;\n}\n.input-group .contact-details .input-group {\n  gap: 6px 0;\n}\n.input-group .contact-details:not(.no-wrap) .meta-detail .heavy {\n  flex: 1 1 100%;\n  margin-bottom: 0;\n}\n.input-group .address-details {\n  display: flex;\n  justify-content: flex-end;\n  gap: 6px 20px;\n  flex: 1 1;\n}\n.listing-contacts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px 10px;\n}\n.social-icons {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  gap: 10px;\n  flex: 0 1;\n  min-width: 108px;\n}\n@media screen and (min-width: 799px) {\n  .social-icons {\n    justify-content: flex-end;\n  }\n}\n.card .cardbody > .ccontent.dashboard-sharing {\n  padding-top: 0;\n}\n.dashboard-sharing .social-icons {\n  justify-content: space-between;\n}\n.dashboard-sharing .social-icons .social-icon svg {\n  width: 40px;\n}\n.dashboard-sharing .portals {\n  margin-top: 20px;\n}\n.dashboard-listing-buttons {\n  margin-top: 20px;\n  display: flex;\n  gap: 10px 10px;\n  flex-wrap: wrap;\n}\n.flagged-matches .datatable tbody tr:hover:not(.selected) td {\n  background: none;\n}\n.flagged-matches .datatable td:first-of-type .tablecell {\n  padding-left: 0;\n}\n.flagged-matches .datatable td.column-actions > div {\n  padding-right: 0;\n}\n.flagged-matches a.btn-icon-16,\n.flagged-matches button.btn-icon-16,\n.flagged-matches .btn-icon-16 {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  min-width: 32px;\n  min-height: 32px;\n  max-width: 32px;\n  justify-content: center;\n}\n.flagged-matches .has-link {\n  text-decoration: none;\n}\n.latest-notes-list-inner {\n  display: flex;\n  gap: 10px 10px;\n  flex-direction: column;\n}\n.latest-notes-note {\n  display: flex;\n  gap: 10px 10px;\n}\n.latest-notes-note .agent {\n  padding-top: 16px;\n  margin: 0;\n}\n.latest-notes-note .avatar-md > .thumbimg {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n.latest-notes-note .latest-notes-summary {\n  flex: 1 1 auto;\n  background: #F3F5F8;\n  padding: 20px;\n  border-radius: 4px;\n}\n.latest-notes-note .noteauthor {\n  color: #10294D;\n  font-weight: 600;\n}\n.latest-notes-note .notes-summary-date {\n  font-size: 11px;\n  font-weight: 400;\n  color: #B2C2D4;\n  text-align: right;\n}\n.latest-notes-note .notes-summary-body {\n  margin-top: 10px;\n  margin-bottom: 0;\n  color: #5A6F89;\n}\n.branch-tel-number {\n  margin-top: 16px;\n  font-size: 30px;\n  font-weight: 400;\n  line-height: 30px;\n  color: #10294D;\n  flex: 1 1 100%;\n}\n.single-stat svg {\n  width: 70px;\n  height: auto;\n  margin: 0 0 0.5rem;\n  fill: #979797;\n}\n.single-stat h1 {\n  color: #FC495D;\n}\n.big-number {\n  font-size: 30px;\n  line-height: 1;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  flex: 1 1 100%;\n  max-height: 50px;\n  color: #10294D;\n}\n.big-number a {\n  text-decoration: none;\n}\n@media (max-width: 799px) {\n  .big-number {\n    font-size: 24px;\n  }\n}\n.agent-details .branchstats .details-section-heading {\n  padding: 0;\n}\n.listing-details .singlemeta img {\n  margin: 10px 20px 20px 0;\n  border: 4px solid #efefef;\n  border-radius: 3px;\n  width: 30%;\n}\n.listing-details .singlemeta img.headline {\n  margin: 0;\n  display: block;\n}\n.listing-details .singlemeta img:first-of-type {\n  width: 100%;\n}\n.listing-details .singlemeta img:nth-of-type(4) {\n  margin-right: 0;\n}\n.listing-details .singlemeta h2 {\n  margin: 30px 0 ;\n}\n.listing-details .singlemeta .description {\n  white-space: pre-line;\n  font-weight: 400;\n}\n.listing-details .singlemeta .agency-details .branch {\n  margin-bottom: 20px;\n}\n.listing-details .singlemeta .meta-detail span {\n  font-weight: 400;\n}\n.listing-details .singlemeta .meta-detail span:first-of-type {\n  text-align: right;\n  font-weight: 600;\n  display: block;\n}\nspan.tag {\n  background-color: #efefef;\n  color: #333333;\n  padding: 1px 8px;\n  border-radius: 3px;\n  font-size: 11px;\n  line-height: 1.5rem;\n  display: inline-block;\n}\nspan.tag + span.tag {\n  margin: 0 3px;\n}\nspan.tag.rounded {\n  border-radius: 60px !important;\n}\n.tagged .col {\n  gap: 3px 3px;\n}\n.tagged span.tag + span.tag {\n  margin: 0;\n}\n@-webkit-keyframes AnimatedLoadingGradient {\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n}\n@-moz-keyframes AnimatedLoadingGradient {\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n}\n@keyframes AnimatedLoadingGradient {\n  0% {\n    background-position: 50% 0%;\n  }\n  50% {\n    background-position: 50% 100%;\n  }\n  100% {\n    background-position: 50% 0%;\n  }\n}\n.mixed-gallery {\n  margin-bottom: 0;\n  margin-left: -15px;\n  margin-right: -15px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.mixed-gallery h2 {\n  text-transform: capitalize;\n}\n.mixed-gallery > div {\n  display: flex;\n  flex: 1 1 280px;\n  height: 210px;\n  max-width: 280px;\n  min-width: 280px;\n  align-items: center;\n  align-content: center;\n  overflow: hidden;\n  margin: 15px;\n  position: relative;\n  justify-content: center;\n}\n.mixed-gallery > div a {\n  position: relative;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  max-width: 280px;\n  width: 100%;\n  overflow: hidden;\n  height: 100%;\n  background: linear-gradient(140deg, #ffffff, #dddddd);\n  background-size: 400% 400%;\n  -webkit-animation: AnimatedLoadingGradient 2s ease infinite;\n  -moz-animation: AnimatedLoadingGradient 2s ease infinite;\n  animation: AnimatedLoadingGradient 2s ease infinite;\n}\n.mixed-gallery > div .img {\n  width: 100%;\n}\n.mixed-gallery > div svg {\n  height: 64px;\n}\n@media screen and (max-width: 798px) {\n  .mixed-gallery > div {\n    height: auto;\n    max-width: 100%;\n  }\n  .mixed-gallery > div a {\n    max-width: 100%;\n    height: auto;\n  }\n  .mixed-gallery > div a img {\n    width: 100%;\n    height: auto;\n  }\n}\n.mixed-gallery-caption {\n  position: absolute;\n  justify-content: center;\n  align-content: center;\n  background: rgba(0, 0, 0, 0.7);\n  color: #ffffff;\n  padding: 8px 12px;\n  display: flex;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  max-width: 280px;\n}\n.mixed-gallery img {\n  height: 210px;\n}\n.details-section {\n  margin-bottom: 20px;\n  padding: 20px;\n}\n.details-section .modelname {\n  display: inline-block;\n  margin-right: 20px;\n  line-height: 3rem;\n  vertical-align: middle;\n}\n.details-section .mediatype {\n  margin-bottom: 40px;\n}\n.details-section-heading {\n  font-weight: normal;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  margin: 0;\n}\n.no-border .details-section-heading,\n.details-section-heading.no-border {\n  border-top: 0;\n  padding-top: 0;\n}\n.details-section-heading-inline {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 0 0 100%;\n}\n.details-section-buttons {\n  display: flex;\n  flex: 0 1 450px;\n  flex-wrap: wrap;\n  gap: 6px 6px;\n  margin-left: 10px;\n  margin-left: auto;\n}\n.details-section-buttons.min-flex {\n  flex: 0 1 100%;\n  margin-left: 0;\n  margin-right: 0;\n}\n.details-section-buttons.min-flex > div {\n  flex: 1 1 100%;\n  margin: 0;\n}\n@media (min-width: 799px) {\n  .details-section-buttons {\n    flex: 1 1 auto;\n    justify-content: flex-end;\n    min-width: fit-content;\n  }\n  .details-section-buttons.min-flex {\n    padding-top: 0;\n    flex: 1 1 auto;\n  }\n  .details-section-buttons.min-flex > div {\n    flex: 0 1 auto;\n  }\n}\n.details-section-buttons .btn {\n  line-height: 1.5rem;\n  vertical-align: top;\n  display: flex;\n  flex: 0 0 auto;\n  cursor: pointer;\n  justify-content: center;\n  align-self: center;\n}\n.details-section-buttons .btn:last-of-type {\n  margin-right: 0;\n}\n.details-section-buttons .btn > svg {\n  height: 13px;\n  margin: 0 0.5em 0 0;\n}\n.details-section-buttons + form {\n  margin-top: 20px;\n  display: block;\n}\n.details-section:first-of-type .details-section-heading {\n  padding-top: 0;\n  border-top: none;\n}\n.details-section .para {\n  padding-bottom: 15px;\n  font-size: 1.1rem;\n  font-weight: 400;\n}\n.details-section.contact,\n.details-section .social {\n  margin: 30px 0;\n}\n.details-section .textformat,\n.details-section .summary-branch_profile,\n.details-section .summary-description {\n  white-space: pre-line;\n  font-weight: 400;\n}\n.space-evenly {\n  justify-content: space-between;\n}\n.social-icon {\n  display: flex;\n  max-width: 48px;\n  max-height: 48px;\n}\n.social-icon svg {\n  width: 48px;\n  height: 48px;\n}\n.image-gallery {\n  margin-bottom: 40px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(275px, max-content));\n  justify-content: space-around;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n.image-gallery-thumb {\n  position: relative;\n  background: #F3F5F8;\n  padding: 15px;\n  gap: 8px;\n}\n.image-gallery-thumb .checkcontainer {\n  min-height: 24px;\n}\n.image-gallery h2 {\n  text-transform: capitalize;\n}\n.image-gallery > div {\n  display: flex;\n  flex: 1 1 280px;\n  max-width: 280px;\n  min-width: 280px;\n  align-items: center;\n  align-content: center;\n  overflow: hidden;\n  position: relative;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.image-gallery > div a {\n  position: relative;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  max-width: 280px;\n  overflow: hidden;\n  max-height: 210px;\n  background: linear-gradient(140deg, #ffffff, #dddddd);\n  background-size: 400% 400%;\n  -webkit-animation: AnimatedLoadingGradient 2s ease infinite;\n  -moz-animation: AnimatedLoadingGradient 2s ease infinite;\n  animation: AnimatedLoadingGradient 2s ease infinite;\n}\n.image-gallery > div img {\n  max-height: 100%;\n  max-width: 100%;\n  background: linear-gradient(140deg, #ffffff, #dddddd);\n  background-size: 400% 400%;\n  -webkit-animation: AnimatedLoadingGradient 2s ease infinite;\n  -moz-animation: AnimatedLoadingGradient 2s ease infinite;\n  animation: AnimatedLoadingGradient 2s ease infinite;\n}\n.image-gallery .image-gallery-thumb-meta {\n  flex: 0 0 100%;\n  gap: 10px;\n  align-items: flex-start;\n  align-content: flex-start;\n  display: flex;\n}\n.image-gallery-caption {\n  color: #92A7C0;\n}\n.documents-gallery {\n  width: 100%;\n  margin-bottom: 15px;\n}\n.documents-gallery thead th {\n  color: #333333;\n  white-space: nowrap;\n  padding: 10px;\n}\n.documents-gallery thead th:first-of-type {\n  padding-left: 0;\n}\n.documents-gallery .file-item {\n  flex: 0 1 100%;\n  min-height: 44px;\n  align-items: center;\n}\n.documents-gallery .file-item td {\n  border-top: 1px solid #d6d6d6;\n}\n.documents-gallery .file-name {\n  padding: 10px 12px 10px 0;\n  width: 100%;\n  vertical-align: middle;\n}\n.documents-gallery .file-name .btn {\n  border: 0;\n  padding: 0;\n}\n.documents-gallery .file-name > div {\n  display: flex;\n  align-items: center;\n}\n.documents-gallery .file-name > div span {\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: calc(100% - 44px);\n}\n.documents-gallery .file-size {\n  padding: 0 10px;\n  white-space: nowrap;\n  display: none;\n}\n@media (min-width: 799px) {\n  .documents-gallery .file-size {\n    display: table-cell;\n  }\n}\n.documents-gallery .file-type {\n  flex: 0 0 30px;\n  padding: 0 10px;\n  text-align: center;\n  display: none;\n}\n@media (min-width: 799px) {\n  .documents-gallery .file-type {\n    display: table-cell;\n  }\n}\n.documents-gallery .file-type svg {\n  height: 24px;\n}\n.toolbox div.toolgroup {\n  display: flex;\n  flex-wrap: wrap;\n  padding: 20px;\n}\n.toolbox h4 {\n  flex: 1 0 100%;\n}\n.toolbox div.toolcontainer {\n  margin-right: 20px;\n  margin-bottom: 10px;\n  vertical-align: top;\n  width: 100px;\n  text-align: left;\n  color: #979797;\n}\n.toolbox div.toolcontainer .tool {\n  border-radius: 4px;\n  border: 1px solid #cfcdcd;\n  background: none;\n  display: block;\n  width: 100px;\n  height: 100px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n.toolbox div.toolcontainer .tool svg {\n  height: 48px;\n  fill: #10294D;\n  fill-rule: evenodd;\n}\n.toolbox div.toolcontainer a {\n  text-decoration: none;\n}\n.toolbox div.toolcontainer a.tool:hover svg,\n.toolbox div.toolcontainer .has-link:hover svg {\n  fill: #444444;\n}\n.toolbox div.toolcontainer .has-link {\n  color: #FC495D;\n  cursor: pointer;\n}\n.toolbox div.toolcontainer span.toolcount {\n  font-size: 1.5rem;\n  color: #444444;\n  display: block;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n.toolbox div.toolcontainer span.toolcount + svg {\n  height: 34px;\n}\n.toolbox div.toolcontainer span.toollabel {\n  display: inline-block;\n  max-width: 100%;\n  margin: 10px 0;\n  font-size: 1.1rem;\n}\n.card .publish-portals.cardbody > .ccontent {\n  padding-top: 0;\n}\n.publish-portals > .row {\n  flex: 0 0 calc(100% + 30px);\n}\n.publish-portals .column-feed_status {\n  width: 60px;\n}\n.publish-portals .column-modified {\n  width: 130px;\n}\n.publish-portals h2 {\n  padding-bottom: 10px;\n}\n.publish .portals table.datatable tbody tr:hover td,\n.syndication .portals table.datatable tbody tr:hover td {\n  background-color: #fff;\n}\n.publish .portals .portal,\n.syndication .portals .portal {\n  text-align: center;\n  border: 1px solid #E5EBF1;\n  border-radius: 3px;\n  display: inline-block;\n  width: 200px;\n  height: 100px;\n  align-items: center;\n  flex: 0 0 200px;\n}\n.publish .portals .portal img,\n.syndication .portals .portal img {\n  height: 100%;\n}\n.publish .portals .portal.portaloff img,\n.syndication .portals .portal.portaloff img {\n  -webkit-filter: grayscale(100%);\n  filter: grayscale(100%);\n}\n.publish .portals .portal label,\n.syndication .portals .portal label {\n  display: block;\n  min-width: auto;\n}\n.publish .portals .portal-log-meta,\n.syndication .portals .portal-log-meta {\n  display: block;\n  padding: 15px 0;\n}\n.publish .portals .portal-log-meta > div,\n.syndication .portals .portal-log-meta > div {\n  display: inline-block;\n  vertical-align: bottom;\n}\n.publish .portals .portal-log-meta .btn-primary.btn-primary,\n.syndication .portals .portal-log-meta .btn-primary.btn-primary {\n  display: inline-block !important;\n}\n.publish .portals .portal-log-meta button svg,\n.syndication .portals .portal-log-meta button svg {\n  height: 11px;\n  margin-top: -2px;\n  margin-right: 8px !important;\n}\n.publish .portal-col,\n.syndication .portal-col {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 0 0 1%;\n  gap: 15px;\n}\n.publish .portal-col.spacer,\n.syndication .portal-col.spacer {\n  margin-bottom: 0;\n}\n.publish .portal-col .row,\n.syndication .portal-col .row {\n  flex-wrap: auto;\n}\n.publish .portal-col .portal-fields,\n.syndication .portal-col .portal-fields {\n  flex: 1 1 100%;\n  min-height: 48px;\n}\n.publish .portal-col .meta-detail,\n.syndication .portal-col .meta-detail {\n  flex: 1 1 100%;\n  display: flex;\n  align-items: center;\n  margin-bottom: auto;\n  gap: 0;\n}\n.publish .portal-col .meta-detail svg,\n.syndication .portal-col .meta-detail svg {\n  height: 24px;\n  stroke: #10294D;\n  stroke-width: 1.4;\n}\n.publish .portal-col .meta-detail .portal-field-value,\n.syndication .portal-col .meta-detail .portal-field-value {\n  flex: 0 0 20px;\n}\n.publish .portal-col .meta-detail .portal-field-label,\n.syndication .portal-col .meta-detail .portal-field-label {\n  flex: 1 1 auto;\n}\n.flex-full {\n  flex-basis: 100% !important;\n}\n.syndication .portals > div {\n  justify-content: center;\n  align-items: top;\n}\n.portal-settings .cardbody .form-group {\n  display: flex;\n  align-items: center;\n}\n.portal-settings .cardbody .form-group .portallogo .portal {\n  text-align: center;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  padding: 10px 5px;\n  display: inline-block;\n  min-width: 250px;\n  max-width: 250px;\n  min-height: 250px;\n  margin: 15px 15px 15px 15px;\n  max-height: 250px;\n  align-items: center;\n}\n.portal-settings .cardbody .form-group .portallogo .portal.portaloff img {\n  -webkit-filter: grayscale(100%);\n  filter: grayscale(100%);\n}\n.portal-settings .cardbody .form-group .portallogo .portal img {\n  width: 220px;\n}\n.portal-settings .cardbody .form-group .portallogo button.btn {\n  display: block;\n  margin: 0 auto;\n}\n.portal-settings .cardbody table.datatable tr:hover td {\n  background-color: #fff;\n}\n.portal-settings .cardbody table.datatable td {\n  width: 25%;\n  border: none;\n  overflow: visible;\n}\n.portal-settings .cardbody table.datatable td .tablecell {\n  overflow: visible;\n}\n.portal-settings .cardbody table.datatable td:last-of-type {\n  text-align: center;\n}\n.card .cardbody .bar-graph.ccontent {\n  padding: 40px 20px 0;\n}\n@media screen and (min-width: 799px) {\n  .card .cardbody .bar-graph.ccontent {\n    padding: 0 20px;\n  }\n}\n.bar-graph .recharts-default-legend .recharts-legend-item {\n  margin: 0;\n  padding-bottom: 14px;\n}\n.stacked-legend-percentage {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n  color: #70859E;\n}\n.recharts-default-tooltip {\n  margin: 0px;\n  padding: 10px;\n  background-color: #ffffff;\n  border: 0 none !important;\n  border-radius: 8px;\n  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);\n  white-space: nowrap;\n}\n.piechart-columns {\n  margin-top: -30px;\n}\n.piechart-columns .piechart-column {\n  margin-top: 30px;\n}\n.piechart-columns .piechart-column .pie-chart {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n}\n.piechart-columns .piechart-column .pie-chart .stacked-legend {\n  max-width: calc(100% - 250px);\n  min-width: 250px;\n  flex-direction: column;\n}\n.piechart-columns .piechart-column .pie-chart .stacked-legend li {\n  min-width: 100%;\n}\n@media screen and (min-width: 799px) {\n  .piechart-columns .piechart-column .pie-chart .stacked-legend li {\n    min-width: 0;\n  }\n}\n.stacked-legend ul {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px 20px;\n}\n.stacked-legend ul .recharts-legend-item {\n  list-style: none;\n  margin: 0;\n}\n.matches-listing {\n  overflow: hidden;\n}\n.tablecell .indicator {\n  height: 16px;\n  width: 16px;\n  stroke-width: 2.4;\n  stroke: #73C677;\n  fill: none;\n  margin-right: 5px;\n}\n.tablecell .whatsapp-tel-link .whatsapp-link {\n  color: inherit;\n  text-decoration: underline;\n}\n.tablecell .whatsapp-tel-link .whatsapp-link svg {\n  stroke: #78789A;\n  stroke-width: 2.4;\n}\n.tablecell .whatsapp-tel-link .whatsapp-link .listing-popup,\n.tablecell .whatsapp-tel-link .whatsapp-link .contact-popup {\n  text-decoration: inherit;\n  display: inline;\n}\n.tablecell .whatsapp-tel-link .whatsapp-link:hover {\n  color: #10294D;\n}\n.tablecell .whatsapp-tel-link .whatsapp-link.secondary {\n  color: #FC495D;\n  text-decoration: none;\n}\n.tablecell .whatsapp-tel-link .whatsapp-link.secondary:hover {\n  text-decoration: underline;\n}\n.matches-listing-details {\n  display: flex;\n  gap: 16px 16px;\n}\n.matches-listing-details .matches-listing-image {\n  flex: 1 1 100;\n  height: 144px;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-size: cover;\n}\n@media screen and (min-width: 799px) {\n  .matches-listing-details .matches-listing-image {\n    flex: 0 0 208px;\n  }\n}\n.matches-listing-details .matches-listing-meta {\n  flex: 1 1 100;\n  height: 144px;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-wrap: wrap;\n  background: #F3F5F8;\n  padding: 15px;\n}\n@media screen and (min-width: 799px) {\n  .matches-listing-details .matches-listing-meta {\n    flex: 0 0 334px;\n  }\n}\n.matches-listing-details .matches-listing-meta .matches-listing-type {\n  margin-left: auto;\n  flex: 0 0 auto;\n  color: #CED7E2;\n}\n.matches-listing-details .matches-listing-meta .matches-listing-price {\n  margin-left: auto;\n  flex: 0 0 100%;\n  font-size: 24px;\n  font-weight: 500;\n  color: #10294D;\n}\n.matches-listing-details .matches-listing-meta .matches-listing-address {\n  margin-left: auto;\n  flex: 0 0 100%;\n  font-size: 16px;\n  color: #10294D;\n}\n.matches-listing-details .matches-listing-map {\n  flex: 1 1 100;\n  height: 144px;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  align-items: center;\n}\n@media screen and (min-width: 799px) {\n  .matches-listing-details .matches-listing-map {\n    flex: 1 1 auto;\n  }\n}\n.matches-listing-details .matches-listing-map img {\n  object-fit: cover;\n  min-width: 100%;\n}\n.dashboard-listing-details {\n  display: flex;\n  flex: 1 1 100%;\n  width: 100%;\n  height: 100%;\n  min-height: 350px;\n  background-size: cover;\n  justify-content: center;\n  align-items: center;\n  border-radius: 8px;\n  overflow: hidden;\n}\n.dashboard-listing-details > img {\n  width: 100%;\n  height: 350px;\n  object-fit: cover;\n}\n@media screen and (min-width: 799px) {\n  .dashboard-listing-details > img {\n    height: 469px;\n  }\n}\n.dashboard-listing-details:before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 64.06%, #000000 100%);\n  border-radius: 8px;\n}\n.dashboard-listing-details .dashboard-listing-buttons {\n  position: absolute;\n  display: flex;\n  top: 20px;\n  right: 20px;\n  gap: 10px 10px;\n}\n.dashboard-listing-details .dashboard-listing-buttons .btn {\n  color: #10294D;\n  font-weight: 600;\n}\n.dashboard-listing-details .dashboard-listing-meta {\n  flex: 1 1 100;\n  border-radius: 8px;\n  overflow: hidden;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-wrap: wrap;\n  padding: 15px;\n  gap: 10px 0;\n  color: #ffffff;\n}\n@media screen and (min-width: 799px) {\n  .dashboard-listing-details .dashboard-listing-meta {\n    flex: 0 0 334px;\n  }\n}\n.dashboard-listing-details .dashboard-listing-meta .dashboard-listing-type {\n  margin-left: auto;\n  flex: 0 0 auto;\n  color: #ffffff;\n}\n.dashboard-listing-details .dashboard-listing-meta .dashboard-listing-price {\n  margin-left: auto;\n  flex: 0 0 100%;\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n}\n.dashboard-listing-details .dashboard-listing-meta .dashboard-listing-address {\n  margin-left: auto;\n  flex: 0 0 100%;\n  font-size: 14px;\n  line-height: 21px;\n  color: #ffffff;\n}\n.listing-contacts-item {\n  display: flex;\n  min-height: 48px;\n  height: auto;\n  gap: 15px 15px;\n}\n.listing-contacts-item .listing-contacts-details {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n}\n.listing-contacts-item .listing-contacts-name {\n  font-size: 14px;\n  line-height: 1.5;\n  flex: 1 1 100%;\n  margin: 0;\n}\n.listing-contacts-item .listing-contacts-name a {\n  text-decoration: none;\n}\n.listing-contacts-item .listing-contacts-meta {\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n  gap: 0 10px;\n}\n.listing-contacts-item .listing-contacts-meta svg {\n  width: 24px;\n  stroke: #CED7E2;\n  stroke-width: 1.4;\n}\n.listing-contacts-item .listing-contacts-meta a {\n  text-decoration: none;\n}\n.listing-brochure-mini {\n  width: calc(100% - 40px);\n  max-width: 203px;\n  max-height: 260px;\n  box-shadow: 4px 4px 0 0 #E5EBF1;\n  position: relative;\n}\n.listing-brochure-mini .listing-brochure-mini-container {\n  width: 100%;\n  padding-bottom: 141.42%;\n}\n.listing-brochure-mini .listing-brochure-mini-image {\n  height: 60%;\n  width: 100%;\n  max-width: 203px;\n  position: absolute;\n  object-fit: cover;\n}\n.listing-brochure-mini .listing-brochure-mini-image img {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n}\n.listing-brochure-mini .listing-brochure-mini-logo {\n  position: absolute;\n  bottom: 15px;\n  left: 15px;\n  max-width: 50%;\n  object-fit: cover;\n}\n.listing-brochure-mini .listing-brochure-mini-logo img {\n  width: 100%;\n}\n.listing-brochure-mini + h3 {\n  display: flex;\n  flex: 0 0 100%;\n  justify-content: center;\n}\n.marker-dot {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: rgba(252, 73, 93, 0.7);\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  box-shadow: 0 0 0 25px rgba(252, 73, 93, 0.2);\n}\n.btmatches .table-header {\n  padding: 10px 0 20px;\n}\n.btmatches .btm-summary {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n.btmatches .btm-summary .btm-legend {\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  text-align: center;\n  color: #333;\n  max-width: 100%;\n  flex-wrap: wrap;\n}\n.btmatches .btm-summary .btm-legend .heavy {\n  text-align: right;\n  min-width: 0;\n}\n.btmatches .btm-summary .btm-legend div {\n  padding: 0 10px;\n  white-space: nowrap;\n}\n.btmatches .btm-summary .btm-legend div div {\n  display: inline-block;\n}\n.btmatches .btm-summary .btm-legend svg {\n  height: 35px;\n  display: block;\n}\n@media screen and (max-width: 798px) {\n  .btmatches .btm-summary {\n    justify-content: start;\n  }\n  .btmatches .btm-summary .btm-legend > div:first-of-type {\n    padding: 0;\n  }\n  .btmatches .btm-summary .btm-legend > div:nth-child(2) > div:first-of-type {\n    padding-left: 0;\n  }\n  .btmatches .btm-summary .btm-legend > div:first-of-type,\n  .btmatches .btm-summary .btm-legend > div:nth-child(2) {\n    padding-left: 0;\n  }\n  .btmatches .btm-summary .btm-legend .heavy {\n    min-width: 190px;\n    text-align: left;\n  }\n}\n.btmatches .listbody {\n  position: relative;\n}\n.btmatches .datatable thead td,\n.btmatches .datatable thead th {\n  padding: 12px 8px;\n}\n.btmatches .datatable thead td.column-rating,\n.btmatches .datatable thead th.column-rating {\n  padding: 8px;\n}\n.btmatches .datatable .loader.inline {\n  position: relative;\n  visibility: hidden;\n}\n.btmatches .loader.inline {\n  position: absolute;\n  bottom: 5px;\n  margin: 10px auto;\n  border-width: 4px;\n  width: 40px;\n  height: 40px;\n  left: 50%;\n  margin-left: -20px;\n  z-index: auto;\n}\n.listing-leads .datatable td:last-of-type {\n  text-align: center;\n}\n.listing-leads .datatable td button {\n  background-color: transparent;\n}\n.listing-leads .datatable td button:hover {\n  cursor: pointer;\n}\nsvg.btmstar {\n  width: 24px;\n}\ntbody svg.btmstar {\n  width: 16px;\n}\nsvg.btmstar.smaller {\n  width: 12px;\n}\nsvg.btmstar.hot {\n  --color4: #CF0000;\n}\nsvg.btmstar.warm {\n  --color4: #F7CA34;\n}\nsvg.btmstar.cold {\n  --color4: #0073B7;\n}\n.contact-compliance .datatable td:first-of-type,\n.contact-compliance .datatable th:first-of-type {\n  width: auto;\n}\n.contact-compliance .btn-primary {\n  margin-bottom: 2rem;\n}\n.model-details .stepper .card .cardbody > .ccontent {\n  padding-top: 20px;\n}\n.stepper .pagestep {\n  flex: 1 1;\n}\n.stepper .card {\n  margin-bottom: 0;\n}\n.model-details .stepper .card {\n  margin-bottom: 20px;\n}\n.google-map {\n  margin-top: 15px;\n  margin-bottom: 30px;\n  width: 100%;\n  height: calc(75vw - 110px);\n  max-height: 400px;\n  position: relative;\n}\n.google-map svg path {\n  fill: #FC495D;\n}\n.notes-form {\n  padding-bottom: 20px;\n}\n.notes-form textarea.form-control {\n  min-height: 150px;\n}\n.notes-form .loader + .btn {\n  margin-left: 10px;\n}\n.notes-form svg {\n  height: 16px;\n}\n.notes-form .btn-primary.btn-primary {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n.notes-form .btn-primary.btn-primary svg {\n  height: 18px;\n}\n.notes-form .note-original {\n  padding: 0 15px;\n  font-size: 1.1rem;\n}\n.notes-form .note-original p {\n  font-size: inherit;\n}\n.profile-listing-model .inline-select {\n  margin: 0;\n}\n.profile-listing-model .form-group .forminput .input-group-addon {\n  padding-left: 15px;\n}\n.referrals .meta-detail .referral-contact {\n  display: flex;\n}\n.referrals .meta-detail .referral-contact .referral-contact-icon {\n  display: flex;\n  align-items: center;\n  margin-right: 5px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #FF6464;\n}\n.referrals .meta-detail .referral-contact .referral-contact-icon.match {\n  background: #73C677;\n}\n.referrals .meta-detail .referral-contact .referral-contact-icon svg {\n  fill: none;\n  stroke: #ffffff;\n  stroke-width: 2.4;\n  width: 16px;\n  height: 16px !important;\n}\n.contacts {\n  flex: 1 1 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n}\n.contacts .col {\n  flex: 0 0 1%;\n}\n.contacts .col.associated_agents {\n  flex: 1 1 1%;\n}\n.contacts .col .meta-detail {\n  flex-wrap: nowrap;\n}\n.contacts .col .meta-detail .heavy {\n  flex: 1 1 160px;\n  min-width: 160px;\n  white-space: nowrap;\n}\n@media (max-width: 799px) {\n  .agents {\n    display: flex;\n  }\n  .contacts .col .meta-detail {\n    flex-wrap: wrap;\n  }\n}\n.meta-detail .microsite.has-link {\n  display: inline-block;\n  padding-left: 10px;\n}\n.meta-label {\n  font-weight: bold;\n  color: #333333;\n  max-width: 85px;\n}\na.meta-label {\n  color: #333333;\n}\n.listing-contacts {\n  display: flex;\n  flex-wrap: wrap;\n}\n.listing-contacts .row {\n  min-width: calc(100% + 30px);\n}\n.listing-contacts .listing-contacts-details {\n  flex: 1 1 auto;\n}\n.listing-contacts .listing-contacts-details .listing-contacts-meta .row {\n  margin-top: 15px;\n}\n.listing-contacts .avatar {\n  margin-right: 20px;\n  width: 100px;\n  height: 100px;\n}\n.listing-contacts .avatar .thumbimg {\n  width: 100px;\n  height: 100px;\n  background-size: cover;\n}\n.listing-contacts .avatar .thumbimg svg {\n  width: 100px;\n  height: 100px;\n}\n.section-underline {\n  margin: 15px 0 0;\n  line-height: 1;\n}\n.row + .section-underline {\n  margin-top: 0;\n}\n.section-underline:after {\n  content: \"\";\n  display: inline-block;\n  position: relative;\n  width: 100%;\n  vertical-align: bottom;\n  height: 1px;\n  background: #cccccc;\n}\n.contact-cards {\n  display: grid;\n  gap: 16px 16px;\n}\n@media screen and (min-width: 799px) {\n  .contact-cards {\n    grid-template-columns: repeat(auto-fit, 320px);\n  }\n}\n.tc-tooltip-content .contact-cards {\n  padding: 12px;\n  font-size: 12px;\n}\n.contact-cards .card {\n  margin-bottom: 0;\n  max-width: 400px;\n}\n.contact-cards .listing-contacts-card {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px 0;\n}\n.contact-cards .listing-contacts-card a,\n.contact-cards .listing-contacts-card button {\n  text-decoration: none;\n}\n.contact-cards .listing-contacts-card .avatar {\n  width: 96px;\n  height: 96px;\n  order: -1;\n}\n.contact-cards .listing-contacts-card .avatar .thumbimg {\n  width: 96px;\n  height: 96px;\n  border-radius: 50%;\n}\n.contact-cards .listing-contacts-card .listing-contacts-details {\n  display: flex;\n  flex: 0 0 100%;\n  flex-wrap: wrap;\n}\n.contact-cards .listing-contacts-card .listing-contacts-label {\n  color: #CED7E2;\n  text-transform: uppercase;\n  flex: 0 0 100%;\n}\n.contact-cards .listing-contacts-card .listing-contacts-name {\n  margin-top: 0;\n  flex: 0 0 100%;\n}\n.contact-cards .listing-contacts-card .listing-contacts-status {\n  display: flex;\n  align-items: center;\n  gap: 0 5px;\n  padding: 0 8px;\n  height: 21px;\n  border-radius: 12px;\n  background: #FFEEEF;\n  color: #FF6464;\n  font-size: 14px;\n  flex: 0 0 auto;\n}\n.contact-cards .listing-contacts-card .listing-contacts-status:before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #FF6464;\n  display: block;\n}\n.contact-cards .listing-contacts-card .listing-contacts-status.active {\n  background: #F0F9F1;\n  color: #73C677;\n}\n.contact-cards .listing-contacts-card .listing-contacts-status.active:before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #73C677;\n  display: block;\n}\n.contact-cards .listing-contacts-card .listing-contacts-meta {\n  margin-top: 15px;\n  flex: 0 0 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px 0;\n}\n.contact-cards .listing-contacts-card .listing-contacts-meta div {\n  flex: 0 0 100%;\n  display: flex;\n  gap: 0 15px;\n  align-items: center;\n}\n.contact-cards .listing-contacts-card .listing-contacts-meta svg {\n  width: 24px;\n  stroke: #10294D;\n  stroke-width: 1.4;\n}\n@media screen and (min-width: 799px) {\n  .contact-cards .listing-contacts-card {\n    flex-wrap: nowrap;\n  }\n  .contact-cards .listing-contacts-card .listing-contacts-details {\n    flex: 1 1 100%;\n  }\n  .contact-cards .listing-contacts-card .avatar {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    margin-left: auto;\n    order: 1;\n  }\n}\n.input-group.publish-group {\n  gap: 7px 20px;\n}\n.input-group.publish-group .heavy {\n  min-width: 220px;\n}\n.player-container {\n  width: 100%;\n  max-width: 480px;\n  padding: 15px 0;\n}\n.player-wrapper {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  padding-top: 56.25%;\n}\n.react-player {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.notes-search {\n  display: flex;\n  padding: 0 20px;\n}\n.notes-stream {\n  padding: 20px;\n}\n.notes-stream .notes-stream-content {\n  margin-left: -15px;\n  margin-right: -15px;\n}\n.notes-stream .notes-stream-event {\n  border-top: 5px solid #cccccc;\n  padding: 30px 15px;\n}\n.notes-stream .notes-stream-event-card-header {\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n}\n.notes-stream .notes-stream-event-card-header strong {\n  color: #000000;\n  margin-right: 5px;\n}\n.notes-stream .notes-stream-event-card-header .btn {\n  margin-left: auto;\n}\n.notes-stream .notes-stream-event-card-body {\n  font-size: 1.1rem;\n}\n.notes-stream .notes-stream-event-card-body p {\n  font-size: inherit;\n}\n.notes-stream .notes-stream-event-card .note-actions {\n  margin-top: 20px;\n  display: flex;\n  justify-content: flex-end;\n}\n.notes-stream .notes-stream-event-card .note-actions .agents {\n  margin-right: auto;\n  display: flex;\n}\n.notes-stream .notes-stream-event-card .note-actions .thumb.small {\n  width: 40px;\n  height: 40px;\n}\n.notes-stream .notes-stream-event-card .note-actions .thumb.small .thumbimg {\n  width: 40px;\n  height: 40px;\n}\n.notes-stream .notes-stream-event-card .note-comments .notes-stream-event {\n  margin-top: 15px;\n  border: 1px solid #cccccc;\n  border-radius: 4px;\n  padding: 15px;\n}\n.user-resume {\n  margin-top: 20px;\n}\n.activity {\n  display: grid;\n  grid-template-areas: \"search\" \"timeline\";\n  grid-template-columns: 1fr;\n  grid-template-rows: min-content min-content;\n  min-height: 0;\n  min-width: 0;\n}\n@media screen and (min-width: 799px) {\n  .activity {\n    grid-template-areas: \"timeline search\";\n    grid-template-columns: 1fr 355px;\n    grid-template-rows: 1fr;\n  }\n}\n.activity > .form {\n  min-height: 0;\n  min-width: 0;\n  flex-wrap: wrap;\n  grid-area: search;\n  display: grid;\n  padding: 20px;\n}\n@media screen and (min-width: 799px) {\n  .activity > .form {\n    padding: 0;\n    padding-right: 20px;\n  }\n}\n.activity > .form > div {\n  min-width: 0;\n}\n.activity > .form .editgroup > .input-group {\n  flex: 1 1 100%;\n  background: #ffffff;\n  padding: 10px;\n  border-radius: 8px;\n}\n.activity > .form .activity-search .field:first-child {\n  flex: 1 1;\n}\n.activity > .form .activity-search .field:first-child .form-group.search {\n  max-width: none;\n}\n.activity > .form .activity-search .field:first-child .form-group.dateinput {\n  max-width: none;\n}\n.activity > .form .activity-search .field:first-child .form-group.dateinput .forminput {\n  padding-bottom: 2px;\n}\n.activity > .form .activity-search .field:first-child .form-group.dateinput .flatpickr-calendar {\n  box-shadow: none;\n  border: 0 none;\n}\n.activity > .form .activity-search .field:first-child .form-group.dateinput .flatpickr-innerContainer {\n  border: 0 none;\n}\n.activity > .form .activity-search .field:first-child .form-group.dateinput .flatpickr-months {\n  padding-bottom: 5px;\n}\n.activity > .form .activity-search #keyword-search-btn {\n  margin-left: 10px;\n  padding: 0 9px;\n}\n.activity > .form .activity-search #field-search {\n  flex-wrap: nowrap;\n}\n.activity > .form .activity-search #field-search .forminput {\n  flex: 1 1 100%;\n}\n.activity > .form .activity-search .flatpickr-wrapper > .flatpickr-calendar.inline {\n  margin: 0 auto;\n}\n.activity > div {\n  grid-area: timeline;\n  min-height: 0;\n  min-width: 0;\n  overflow: auto;\n}\n.activity .list-actions {\n  padding-left: 50px;\n}\n.activity .thumb.small,\n.activity .thumb.small .thumbimg {\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n}\n.viewing-feedback-graph .customized-legend {\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: auto;\n  min-width: 150px;\n  gap: 8px;\n}\n.viewing-feedback-graph .customized-legend .legend-count {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 46px;\n  line-height: 1;\n}\n.viewing-feedback-graph .customized-legend .legend-total {\n  flex: 0 0;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 0;\n}\n.marketing-email-pie-graph .legend-label {\n  font-weight: 500;\n}\n.marketing-email-pie-graph .legend-count {\n  font-weight: 600;\n  color: #222222;\n}\n.viewing-feedback-card div {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 10px 10px;\n}\n.viewing-feedback-card span {\n  font-size: 34px;\n  color: #10294D;\n}\n.viewing-feedback-card svg {\n  width: 56px;\n  stroke: #10294D;\n  fill: none;\n}\n.column-metaviewingfeedback {\n  width: 50%;\n}\n.column-metaviewingviewing_date {\n  width: 100px;\n}\n.col.stage .lead-stage {\n  background: none;\n  padding: 0;\n  color: inherit;\n  text-decoration: inherit;\n}\n.grid-container.grid-5 .grid-col-1.flex-stats {\n  align-content: center;\n}\n.grid-container.grid-5 .grid-col-1.flex-stats .flex-container {\n  gap: 20px 20px;\n  justify-content: center;\n  align-items: center;\n}\n.grid-container.grid-5 .grid-col-1.flex-stats .stat-count {\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: center;\n  font-size: 42px;\n  color: #10294D;\n}\n.grid-container.grid-5 .grid-col-1.flex-stats .stat-heading {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-content: center;\n  align-items: center;\n  text-align: center;\n  font-size: 16px;\n  color: #70859E;\n}\n.image-gallery-thumb-img-size {\n  position: absolute;\n  background: #ffffff;\n  color: rgba(0, 0, 0, 0.7);\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 12px;\n  padding: 8px 12px;\n  display: flex;\n  border-radius: 18px;\n  right: 0;\n  top: 0px;\n  margin: 19px;\n  z-index: 1;\n}\n#social-Whatsapp path {\n  fill: rgba(0, 0, 0, 0.7);\n}\n.whatsapp-tel-link {\n  display: flex;\n  align-items: center;\n  gap: 0px 5px;\n}\na.whatsapp-link,\nbutton.whatsapp-link {\n  display: flex;\n  align-items: center;\n  background: none;\n  border: 0 none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n}\n.whatsapp-link .has-link {\n  display: flex;\n  align-items: center;\n  background: none;\n  border: 0 none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n}\n.whatsapp-link svg {\n  width: 16px;\n  fill: none;\n  stroke: #78789A;\n  stroke-width: 2.4;\n}\n.referral-response-outcome {\n  width: 100%;\n}\n.referral-response-outcome .radiogroup .radioinput {\n  margin-top: 10px;\n}\n.flow-placeholder {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px 10px;\n}\n.flow-placeholder-text {\n  flex: 0 0 100%;\n  text-align: center;\n  font-size: 14px;\n  line-height: 21px;\n}\n.flow-placeholder-text span {\n  color: #10294D;\n}\n.flow-placeholder .btn {\n  font-size: 14px;\n}\n.social-performance-filters .filter-overlay-ga .form-group.checkinput .forminput .checkcontainer + label {\n  min-width: auto;\n  margin-right: 12px;\n}\n.social-performance-widget .flex-container {\n  gap: 10px;\n}\n.social-performance-widget .customized-legend {\n  width: 100%;\n  gap: 10px 30px;\n  font-size: 11px;\n  padding-bottom: 0;\n}\n.social-performance-widget .customized-legend .legend-item {\n  flex: 0 0 auto;\n  height: auto;\n  cursor: pointer;\n}\n.social-performance-widget .customized-legend .powered-by {\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  margin-left: auto;\n}\n.social-performance-widget .customized-legend .powered-by svg {\n  display: inline;\n  width: 46px;\n  flex: 0 0 46px;\n  margin-left: 10px;\n}\n.deal-columns .grid-container {\n  border-bottom: 1px solid #E5EBF1;\n}\n.deal-columns .deal-columns--label {\n  color: #92A7C0;\n  align-self: center;\n  padding: 3px 0;\n}\n.deal-columns .deal-columns--label strong {\n  color: #10294D;\n}\n.deal-columns .deal-columns--value {\n  align-self: center;\n  padding: 3px 0;\n  justify-self: flex-end;\n  text-align: right;\n}\n.deal-columns .deal-columns--value.large {\n  color: #10294D;\n  font-size: 18px;\n  font-weight: 600;\n}\n.commission-block {\n  padding: 20px;\n  background: #F3F5F8;\n}\n.commission-block > div {\n  display: flex;\n  justify-content: space-between;\n}\n.commission-save {\n  display: flex;\n  justify-content: flex-end;\n}\n.report-group {\n  display: flex;\n  flex-direction: column;\n  margin-top: 16px;\n}\n.report-group .report-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  color: #10294D;\n  background: #F3F5F8;\n  padding: 10px 16px;\n  font-size: 16px;\n  line-height: 24px;\n}\n.report-group .report-heading span {\n  color: #92A7C0;\n  font-size: 12px;\n}\n.report-group .report-list {\n  margin: 0;\n}\n.report-group .report-list dd,\n.report-group .report-list dt {\n  margin: 0;\n  padding: 6px 15px;\n  color: #455870;\n  font-size: 12px;\n  font-weight: 500;\n}\n.report-group .report-list dt {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.report-group .report-list dd {\n  background: #FAFBFD;\n}\n.tab-availability .card {\n  margin-bottom: 0;\n}\n.alerts-sidebar {\n  background: #ffffff;\n  display: flex;\n}\n.alerts-sidebar .alerts-heading {\n  display: flex;\n  position: sticky;\n  background: #F3F5F8;\n  height: 64px;\n  align-items: center;\n  justify-content: space-between;\n  top: 0;\n  z-index: 10;\n  padding-left: 20px;\n}\n.alerts-sidebar .alerts-container {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  position: sticky;\n  top: 68px;\n  transition: width 0.2s ease-in-out;\n  width: 280px;\n  grid-template-rows: 50px auto;\n  max-height: calc(100vh -  68px);\n  justify-content: space-between;\n  overflow: hidden;\n}\n.alerts-sidebar .alerts-container .alert-action {\n  display: flex;\n  margin-top: 20px;\n  justify-content: space-between;\n  align-items: baseline;\n}\n.alerts-sidebar .alerts-container .alert-content {\n  overflow: visible;\n  overflow-x: visible;\n  overflow-y: auto;\n  position: relative;\n  right: -17px;\n  left: 0;\n  height: calc(100vh - 200px);\n  width: 297px;\n}\n.alerts-sidebar .alerts-container .alert-item {\n  text-align: left;\n  border-bottom: 1px solid #ccc;\n  padding: 10px 20px;\n  margin-right: 17px;\n}\n.alerts-sidebar .alerts-container .alert-item .alert-detail {\n  color: #979797;\n  font-size: 1rem;\n}\n.alerts-sidebar .alerts-container .alert-item .alert-detail.domain {\n  text-transform: capitalize;\n}\n.alerts-sidebar .alerts-container .alert-item.noalerts {\n  text-align: center;\n}\n.alerts-sidebar .alerts-container.noalerts h3 {\n  border-bottom: 2px solid #efefef;\n}\n.alerts-sidebar .alerts-container p {\n  font-size: 1rem;\n}\n.alerts-sidebar .alerts-container svg {\n  height: 100px;\n  fill: none;\n  stroke: #E5EBF1;\n}\n.alerts-sidebar .alerts-container .close-window {\n  text-align: right;\n  margin-right: 10px;\n}\n.alerts-sidebar .alerts-container .close-window button.btn.btn-alert-close-x {\n  background-color: transparent;\n  display: inline-block;\n}\n.alerts-sidebar .alerts-container .close-window svg {\n  height: 20px;\n  stroke: #CED7E2;\n}\n.notifier {\n  position: fixed;\n  z-index: 1000;\n  top: 85px;\n  right: 15px;\n  width: 300px;\n  display: flex;\n  flex-direction: column-reverse;\n}\n.notifier .notice-content {\n  position: relative;\n  transition: left 0.5s, opacity 0.6s, opacity 0.5s, opacity 0.6s;\n  left: 300px;\n  opacity: 0;\n  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);\n  background-color: #fff;\n  padding: 20px;\n  margin-bottom: 10px;\n  min-height: 40px;\n  color: #B2C2D4;\n}\n.notifier .notice-content.active {\n  left: 0;\n  opacity: 1;\n}\n.notifier .notice-content.success {\n  border-left: 4px solid #73C677;\n}\n.notifier .notice-content.error {\n  border-left: 4px solid #FF6464;\n}\n.notifier .notice-content.info {\n  border-left: 4px solid #60D3EC;\n}\n.notifier .notice-buttons {\n  display: flex;\n  gap: 10px 10px;\n}\n/* Cards */\n.card {\n  position: relative;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  width: 100%;\n  border: 1px solid rgba(195, 201, 210, 0.31);\n}\n.card.active {\n  border: 1px solid #92A7C0;\n}\n.card.maxcard {\n  overflow-y: hidden;\n}\n.card.no-shadow {\n  box-shadow: none;\n}\n.card.stats-card-grey {\n  background: #F3F5F8;\n  height: 100%;\n}\n.card.stats-card-grey h3 {\n  font-size: 24px;\n  margin-top: 0;\n}\n.card.stats-card-grey .ccontent svg {\n  position: absolute;\n  top: 6px;\n  right: 6px;\n  width: 24px;\n  stroke: #10294D;\n  stroke-width: 1.4;\n}\n.card.stats-card-grey .ccontent div {\n  font-size: 14px;\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n}\n.card.stats-card-grey .ccontent div span {\n  color: #70859E;\n}\n.card.stats-card-grey .ccontent div .view-text {\n  color: #B2C2D4;\n}\n.card-legend {\n  display: flex;\n  align-items: center;\n  gap: 0 5px;\n}\n.card-legend legend {\n  font-size: 1rem;\n  vertical-align: middle;\n  width: auto;\n  display: flex;\n  align-items: center;\n  margin: 0;\n}\n.card-legend legend:before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  display: block;\n  border-radius: 3px;\n  margin-right: 10px;\n}\n.card-legend legend.required:before {\n  background: #FFB1B1;\n}\n.card-legend legend.quality:before {\n  background: #DFB0F4;\n}\n.card-meta {\n  display: flex;\n  justify-content: space-between;\n  margin: -20px;\n  margin-bottom: 20px;\n  background: #ffffff;\n  padding: 20px;\n}\n.card-meta .card-toggles {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n}\n.card-meta .cardtoggle-required {\n  text-align: right;\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 5px 0;\n  padding-bottom: 20px;\n}\n.card-meta .cardtoggle-required .btn {\n  flex: 1 1 100%;\n  justify-content: center;\n  background: #ffffff;\n  border: 1px solid #E5EBF1;\n  color: #10294D;\n}\n.card-meta .cardtoggle-required .btn svg {\n  stroke: #10294D;\n}\n.card-meta .cardtoggle-required .btn.focus,\n.card-meta .cardtoggle-required .btn:focus,\n.card-meta .cardtoggle-required .btn:focus-visible {\n  color: #071B38;\n  border: 1px solid #CED7E2;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.card-meta .cardtoggle-required .btn.active,\n.card-meta .cardtoggle-required .btn:active {\n  color: #071B38;\n  border: 1px solid #CED7E2;\n  background: transparent;\n}\n.card-meta .cardtoggle-required .btn.active.focus,\n.card-meta .cardtoggle-required .btn:active.focus,\n.card-meta .cardtoggle-required .btn.active:focus,\n.card-meta .cardtoggle-required .btn:active:focus,\n.card-meta .cardtoggle-required .btn.active:focus-visible,\n.card-meta .cardtoggle-required .btn:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.card-meta .cardtoggle-required .btn.hover,\n.card-meta .cardtoggle-required .btn:hover {\n  color: #071B38;\n  border: 1px solid #CED7E2;\n  background: transparent;\n}\n.card-meta .cardtoggle-required .btn.hover.active,\n.card-meta .cardtoggle-required .btn:hover.active,\n.card-meta .cardtoggle-required .btn.hover:active,\n.card-meta .cardtoggle-required .btn:hover:active {\n  border-color: #CED7E2;\n  background: transparent;\n}\n.card-meta .cardtoggle-required .btn.hover.active.focus,\n.card-meta .cardtoggle-required .btn:hover.active.focus,\n.card-meta .cardtoggle-required .btn.hover:active.focus,\n.card-meta .cardtoggle-required .btn:hover:active.focus,\n.card-meta .cardtoggle-required .btn.hover.active:focus,\n.card-meta .cardtoggle-required .btn:hover.active:focus,\n.card-meta .cardtoggle-required .btn.hover:active:focus,\n.card-meta .cardtoggle-required .btn:hover:active:focus,\n.card-meta .cardtoggle-required .btn.hover.active:focus-visible,\n.card-meta .cardtoggle-required .btn:hover.active:focus-visible,\n.card-meta .cardtoggle-required .btn.hover:active:focus-visible,\n.card-meta .cardtoggle-required .btn:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n@media screen and (max-width: 799px) {\n  .card-meta {\n    flex-wrap: wrap;\n  }\n  .card-meta .card-toggles {\n    flex: 1 1 100%;\n    flex-wrap: wrap;\n  }\n  .card-meta .card-toggles .pagestep {\n    margin-top: 1.25rem;\n    margin-left: 8px;\n    margin-right: 0;\n    flex: 1 1 100%;\n  }\n  .card-meta .card-toggles .pagestep .firstpage {\n    margin-left: auto;\n  }\n  .card-meta .cardtoggle-required {\n    margin-top: 1.25rem;\n    text-align: left;\n  }\n}\n.card.hidden {\n  display: none;\n}\n.card .requiredonly .notrequired {\n  display: none;\n}\n.card .cardhead {\n  padding: 10px 20px;\n  display: flex;\n  align-items: center;\n}\n.card .cardhead h3 {\n  margin: 0;\n  line-height: 36px;\n}\n.card .cardhead .ccontent {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.card .cardhead .cardtoggle {\n  background: none;\n  border: none;\n  outline: none;\n  flex: 0 0 18px;\n  text-align: center;\n  cursor: pointer;\n}\n.card .cardhead .cardtoggle svg {\n  width: 12px;\n  fill: #ccc;\n  display: inline-block;\n  vertical-align: middle;\n}\n.card .cardhead .profile-matches {\n  display: flex;\n  gap: 8px 12px;\n  position: absolute;\n  right: 0px;\n  margin-right: 28px;\n}\n@media screen and (max-width: 799px) {\n  .card .cardhead .profile-matches {\n    display: flex;\n    gap: 8px 12px;\n    position: absolute;\n    top: 44px;\n  }\n}\n.card .cardhead .profile-matches > div {\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n}\n.card .cardhead .profile-matches > div span {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 21px;\n}\n.card .cardhead .profile-matches > div svg {\n  height: 16px;\n  width: 24px;\n}\n.card .cardhead .matches-header {\n  margin: 0px;\n}\n@media screen and (max-width: 799px) {\n  .card .cardhead .matches-header {\n    margin: 0px 0 16px 0;\n  }\n}\n.card .cardbody {\n  overflow: hidden;\n  max-height: none;\n  transition: max-height 0.2s ease-in-out;\n}\n.card .cardbody .horizontal-tabs-container {\n  margin-top: -15px;\n}\n.card .cardbody > .ccontent {\n  padding: 20px;\n}\n.card .cardbody > .ccontent.stats-card h1 a {\n  color: #ffffff;\n}\n.card .cardbody > .ccontent.stats-card .flex-container {\n  align-items: center;\n}\n.card .cardbody > .ccontent.stats-card-mini {\n  padding: 13px 20px;\n}\n.card .cardbody > .ccontent.no-top-padding {\n  padding-top: 0 !important;\n}\n.card .cardbody > .ccontent.no-padding {\n  padding: 0 !important;\n}\n.dash .card .cardbody > div {\n  text-align: center;\n  max-width: 145px;\n}\n.card#communication-preferences .listbody {\n  flex: 0 0 100%;\n}\n.card.open .cardbody {\n  overflow: visible;\n  height: auto;\n  margin: 0;\n}\n.card.closed .cardbody {\n  height: 0;\n  margin: 0;\n}\n.card .ccontent.nopadding {\n  padding: 0;\n}\n.card .cardfoot {\n  padding: 20px 15px;\n}\n.card .details {\n  font-size: 1.1rem;\n}\n.card .details span {\n  display: inline-block;\n  margin-right: 10px;\n}\n.card .stats > div {\n  margin: 20px 0;\n}\n.card .contacts td:first-of-type {\n  font-weight: 700;\n  text-align: right;\n  padding-right: 10px;\n}\n.card.tab-container {\n  border: 1px solid #cccccc;\n  border-radius: 3px;\n}\n.card.tab-container .ccontent {\n  padding-left: 0;\n  padding-right: 0;\n}\n.withbg {\n  background: #ffffff;\n}\n.grey_25 {\n  background: #FAFBFD;\n}\n.primary-bg {\n  background: #10294D;\n  color: #ffffff;\n}\n.primary-bg * {\n  color: inherit;\n}\n.primary-bg h1 {\n  font-size: 40px;\n  margin: 0;\n}\n.primary-bg h3 {\n  margin: 0;\n}\n.primary-bg span {\n  color: #70859E;\n}\n.primary-bg strong {\n  font-size: 14px;\n  color: #B2C2D4;\n  font-weight: 600;\n}\n.primary-bg .whatsapp-link svg {\n  stroke: #ffffff;\n  stroke-width: 2.4 !important;\n}\n.primary-bg .has-link:hover {\n  color: #ffffff;\n  text-decoration: none;\n}\n.primary-bg .heavy.heavy {\n  color: #ffffff;\n  font-weight: 600;\n}\n.primary-bg .flex-container {\n  align-items: center;\n  justify-content: flex-start;\n}\n.primary-bg .flex-container.justify-center {\n  justify-content: center;\n}\n.justify-center {\n  justify-content: center;\n}\n.justify-between {\n  justify-content: space-between !important;\n}\n.agent-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex: 1 1 100%;\n  gap: 30px 0;\n  padding: 40px 16px;\n}\n@media screen and (min-width: 799px) {\n  .agent-card {\n    flex: 1 1 240px;\n    max-width: 240px;\n  }\n}\n.agent-card h3 {\n  font-weight: 600;\n  text-align: center;\n  margin: 0 0 10px;\n}\n.agent-card h4 {\n  font-weight: 500;\n}\n.agent-card .avatar-lg > .thumbimg {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n}\n.agent-card .single-user {\n  margin: 0;\n  justify-content: center;\n}\n.agent-card .agent-details {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n.agent-card .agent-details > * {\n  flex: 1 1 100%;\n  text-align: center;\n}\n.agent-card .agent-details h1 {\n  font-size: 30px;\n  margin-top: 20px;\n}\n.agent-card .agent-links {\n  flex-wrap: wrap;\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n.cardtoggle-jump {\n  height: 37px;\n  flex: 0 0 100%;\n}\n.cardtoggle-jump .btn {\n  left: 0;\n  right: 0;\n  padding: 6px 20px;\n  background: #CED7E2;\n  border-radius: 0;\n  transition: none;\n  font-weight: 500;\n  width: 100%;\n  z-index: 99;\n}\n.cardtoggle-jump.sticky .btn {\n  position: fixed;\n  margin: 0;\n  left: 0;\n  right: 0;\n  top: 178px;\n}\n.stats-filters {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n}\n.stats-filters .form-group:not(.checkinput) {\n  flex: 0 0 auto;\n}\n.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) {\n  flex: 1 1;\n  border-color: transparent;\n}\n.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only):hover,\n.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only):focus,\n.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only):active,\n.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only):focus-within {\n  border-color: transparent;\n  box-shadow: none;\n}\n.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) .react-select__control--is-focused {\n  border-color: transparent;\n}\n.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) .react-select__value-container {\n  padding: 0;\n}\n.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) .react-select__control {\n  min-height: 21px;\n}\n.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) .react-select__control:hover {\n  cursor: pointer;\n}\n.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) .react-select__input-container {\n  color: transparent;\n}\n.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) .react-select__dropdown-indicator {\n  padding: 0;\n}\n.stats-filters .form-group:not(.checkinput) .forminput:not(.input-only) .react-select__indicators {\n  flex: 0 0;\n}\n@media screen and (max-width: 799px) {\n  .stats-filters {\n    display: block;\n  }\n}\n.primary-bg .react-select .react-select__dropdown-indicator svg {\n  stroke: #92A7C0;\n}\n.whatsapp-gray-div {\n  width: 14px;\n  height: 15px;\n}\n.force-update + .card {\n  margin-top: 20px;\n}\n.hotcoldcard {\n  font-size: 16px;\n  padding-right: 41px;\n  display: flex;\n  font-weight: 900;\n  height: 22px;\n  margin-bottom: 0px;\n}\n.hotcoldvalue {\n  padding-right: 41px;\n  padding-left: 6px;\n}\n.hotcoldvalueend {\n  padding-left: 6px;\n}\n.banner {\n  display: flex;\n  flex-direction: column;\n  border-radius: 8px;\n  padding: 20px;\n  gap: 16px;\n  background: #ffffff;\n}\n.banner .banner-heading {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  flex: none;\n  align-self: stretch;\n  flex-grow: 0;\n}\n.banner .banner-heading .btn-banner-close {\n  padding: 0;\n  min-height: unset;\n}\n.banner .banner-heading h3 {\n  margin: 0;\n  display: flex;\n  align-items: center;\n  flex: none;\n  flex-grow: 1;\n}\n.banner.quality {\n  background: #EFD7F9;\n}\n.banner.success {\n  background: #DCF1DE;\n}\n.banner.info {\n  background: #D7F4FA;\n}\n.banner.error {\n  background: #FFB1B1;\n}\n.tab-content {\n  display: grid;\n  grid-area: tab-content;\n  padding: 20px;\n  padding-top: 0;\n  gap: 20px;\n  min-width: 0;\n  min-height: 0;\n  grid-template-rows: auto minmax(min-content, max-content);\n  align-content: flex-start;\n}\n.tab-content > .portals {\n  max-width: calc(100vw - 40px);\n}\n.tab-content.tab-details,\n.tab-content.tab-notes {\n  padding: 0;\n  gap: 0;\n  grid-template-areas: \"jump-menu\" \"details\";\n  grid-template-rows: auto 1fr;\n  min-height: 0;\n}\n@media screen and (min-width: 799px) {\n  .tab-content.tab-details,\n  .tab-content.tab-notes {\n    grid-template-areas: \"jump-menu details\";\n    grid-template-columns: 260px 1fr;\n    grid-template-rows: 1fr;\n    gap: 20px 20px;\n  }\n}\n@media screen and (min-width: 799px) {\n  .tab-content.tab-notes {\n    grid-template-areas: \"jump-menu details\";\n    grid-template-columns: 370px 1fr;\n    grid-template-rows: 1fr;\n  }\n}\n.tab-content.tab-activity {\n  padding: 0;\n}\n.tab-content.tab-design {\n  gap: 0;\n}\n.tab-content.tab-stage {\n  gap: 0;\n}\n.tab-content .stepper:empty {\n  height: 0;\n}\n.tab-content .stepper + div {\n  min-width: 0;\n}\n.horizontal-tabs-container {\n  display: grid;\n  grid-template-areas: \"tabs\" \"tab-content\";\n  grid-template-rows: auto 1fr;\n  padding-left: 0;\n  min-height: 0;\n  flex: 1 0 100%;\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper {\n  grid-area: tabs;\n  min-width: 0;\n  display: flex;\n}\n@media screen and (min-width: 799px) {\n  .horizontal-tabs-container .horizontal-tabs-wrapper {\n    max-width: calc(100vw - 64px);\n  }\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper .for-scroll {\n  display: none;\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-content {\n  display: flex;\n  gap: 0 5px;\n  flex: 1 1 auto;\n  padding: 14px 40px 15px 10px;\n}\n@media screen and (min-width: 799px) {\n  .horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-content {\n    padding: 14px 20px;\n  }\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav {\n  display: flex;\n  flex: 1 1 100%;\n  max-width: 100vw;\n}\n@media screen and (min-width: 799px) {\n  .horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav {\n    max-width: calc(100vw - 64px);\n  }\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .horizontal-tabs-content:after {\n  content: \"\";\n  flex: 0 0 10px;\n  width: 20px;\n  order: 9999999;\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-left {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  background: #F3F5F8;\n  left: 0;\n  height: 66px;\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-left button {\n  margin: 0 10px 0 20px;\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-left svg {\n  height: 100%;\n  width: 24px;\n  fill: none;\n  stroke: #10294D;\n  stroke-width: 1.4;\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-left:before {\n  content: \"\";\n  z-index: 1;\n  background: linear-gradient(to right, #f3f5f8, rgba(243, 245, 248, 0) 100%);\n  position: absolute;\n  left: 100%;\n  width: 10px;\n  bottom: 0;\n  top: 0;\n  pointer-events: none;\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-right {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  background: #F3F5F8;\n  right: 0;\n  height: 66px;\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-right button {\n  margin: 0 20px 0 10px;\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-right svg {\n  height: 100%;\n  width: 24px;\n  fill: none;\n  stroke: #10294D;\n  stroke-width: 1.4;\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .scroll-right:after {\n  content: \"\";\n  z-index: 1;\n  background: linear-gradient(to right, rgba(243, 245, 248, 0), #f3f5f8 100%);\n  position: absolute;\n  right: 100%;\n  width: 10px;\n  bottom: 0;\n  top: 0;\n  pointer-events: none;\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .nav:before {\n  content: \"\";\n  flex: 0 0 15px;\n  background: none;\n  order: 0;\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav.has-scroll .nav:after {\n  content: \"\";\n  flex: 0 0 15px;\n  background: none;\n  order: 9999999;\n}\n.horizontal-tabs-container .horizontal-tabs-wrapper .btn.btn-none.active {\n  background: #10294D;\n  color: #ffffff;\n}\n/* Action Buttons */\n.viewhead {\n  position: sticky;\n  top: 0;\n  max-width: 100vw;\n  background: #ffffff;\n  border-top: 1px solid rgba(195, 201, 210, 0.31);\n  border-bottom: 1px solid rgba(195, 201, 210, 0.31);\n  grid-area: actions;\n  z-index: 100;\n}\n@media screen and (min-width: 799px) {\n  .viewhead {\n    max-width: calc(100vw - 64px);\n  }\n}\n.viewhead + div {\n  grid-area: view;\n}\n.viewhead .track-vertical {\n  display: none;\n}\n.viewhead .track-horizontal {\n  right: 2px;\n}\n.viewhead .scrollview {\n  display: flex;\n}\n.canvashead {\n  position: sticky;\n  top: 0;\n  max-width: 100vw;\n  background: #10294D;\n  grid-area: actions;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: space-between;\n  padding: 0 32px;\n}\n@media screen and (min-width: 799px) {\n  .canvashead {\n    max-width: calc(100vw);\n  }\n}\n.canvashead .track-vertical {\n  display: none;\n}\n.canvashead .track-horizontal {\n  right: 2px;\n}\n.canvashead .scrollview {\n  display: flex;\n}\n.canvashead .pd-logo {\n  width: 208px;\n  height: 54px;\n  flex: 0 0 208px;\n  margin-left: 10px;\n  color: #071B38;\n  background-image: url(\"../../images/pd-logo-white.svg\");\n  background-size: cover;\n}\n.canvashead .lightstone-logo {\n  width: 146px;\n  height: 49px;\n  flex: 0 0 146px;\n  color: #071B38;\n  background-image: url(\"../../images/lightstone.svg\");\n  background-size: contain;\n  background-position: center center;\n  background-repeat: no-repeat;\n}\n.canvashead .pd-callnow {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  text-align: right;\n  color: #ffffff;\n}\n.canvashead .pd-callnow a {\n  color: #ffffff;\n  text-decoration: underline;\n}\n.canvashead .pd-callnow a:hover {\n  color: #ffffff;\n  text-decoration: underline;\n}\n.canvas-footer {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: space-between;\n  padding: 0 20px 20px;\n}\n.canvas-footer .pd-logo {\n  width: 208px;\n  height: 54px;\n  flex: 0 0 208px;\n  color: #071B38;\n  background-image: url(\"../../images/pd-logo.svg\");\n  background-size: cover;\n}\n.canvas-footer .pd-callnow {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  text-align: right;\n}\n.action-bar {\n  display: flex;\n}\n.action-bar > div {\n  flex: 1 1 auto;\n  max-width: 100%;\n}\n.action-bar > .pagestep {\n  flex: 0 0 auto;\n  margin-right: 0;\n}\n.sticky-outer-wrapper.active .sticky-inner-wrapper {\n  z-index: 100;\n  right: 0;\n  left: 64px;\n  width: auto !important;\n}\n.sticky-outer-wrapper.active .sticky-inner-wrapper .actionswrap {\n  background: #ffffff;\n  margin: 0;\n}\n.actionswrap {\n  z-index: 100;\n  display: grid;\n  grid-template-columns: 0 1fr 0;\n  gap: 20px;\n  grid-template-areas: \"left scroll right\";\n  flex: 1 1 auto;\n}\n.actionswrap > div:not(.scroll-left):not(.scroll-right) {\n  grid-area: scroll;\n}\n.actionswrap.has-scroll {\n  gap: 0;\n  touch-action: pan-x;\n  grid-template-columns: 60px 1fr 60px;\n}\n.actionswrap.has-scroll * {\n  touch-action: pan-x;\n}\n.actionswrap.has-scroll .action-list {\n  padding-right: 0;\n}\n.actionswrap.has-scroll .scroll-left {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  background: #ffffff;\n  position: relative;\n  height: 66px;\n  grid-area: left;\n}\n.actionswrap.has-scroll .scroll-left button {\n  margin: 0 10px 0 20px;\n}\n.actionswrap.has-scroll .scroll-left svg {\n  height: 100%;\n  width: 24px;\n  fill: none;\n  stroke: #10294D;\n  stroke-width: 1.4;\n}\n.actionswrap.has-scroll .scroll-left:before {\n  content: \"\";\n  z-index: 1;\n  background: linear-gradient(to right, #ffffff 20%, rgba(255, 255, 255, 0) 100%);\n  position: absolute;\n  left: 100%;\n  width: 10px;\n  bottom: 0;\n  top: 0;\n  pointer-events: none;\n}\n.actionswrap.has-scroll .scroll-right {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  background: #ffffff;\n  position: relative;\n  height: 66px;\n  grid-area: right;\n}\n.actionswrap.has-scroll .scroll-right button {\n  margin: 0 20px 0 10px;\n}\n.actionswrap.has-scroll .scroll-right svg {\n  height: 100%;\n  width: 24px;\n  fill: none;\n  stroke: #10294D;\n  stroke-width: 1.4;\n}\n.actionswrap.has-scroll .scroll-right:after {\n  content: \"\";\n  z-index: 1;\n  background: linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff 100%);\n  position: absolute;\n  right: 100%;\n  width: 10px;\n  bottom: 0;\n  top: 0;\n  pointer-events: none;\n}\n.actionswrap.has-scroll .nav:before {\n  content: \"\";\n  flex: 0 0 15px;\n  background: none;\n  order: 0;\n}\n.actionswrap.has-scroll .nav:after {\n  content: \"\";\n  flex: 0 0 15px;\n  background: none;\n  order: 9999999;\n}\n.actionswrap.sticky {\n  background: #ffffff;\n  margin: 0;\n  position: fixed;\n  right: 0;\n  top: 60px;\n}\n.actionswrap .action-list {\n  grid-template: scroll;\n  display: flex;\n  justify-content: flex-start;\n  white-space: nowrap;\n  padding: 0 40px 0 10px;\n  top: 0;\n  gap: 0 5px;\n  flex: 1 1 auto;\n}\n.actionswrap .action-list:after {\n  content: \"\";\n  flex: 0 0 5px;\n  width: 10px;\n  order: 9999999;\n}\n@media screen and (min-width: 799px) {\n  .actionswrap .action-list {\n    justify-content: flex-end;\n    padding: 0 0;\n  }\n  .actionswrap .action-list:after {\n    flex: 0 0 0;\n  }\n}\n.actionswrap .action-list .navitem {\n  margin-top: 14px;\n  margin-bottom: 15px;\n}\n.actionswrap .action-list .add {\n  margin-right: auto;\n}\n.actionswrap .action-list .list {\n  order: 0;\n  margin-right: auto;\n}\n@media screen and (min-width: 799px) {\n  .viewhead:not(.details) .actionswrap .action-list .list {\n    margin-right: 0;\n  }\n}\n.actionswrap .action-list .save {\n  order: 999;\n}\n.actionswrap .action-list .cancel {\n  order: 1000;\n}\n.actionswrap .action-list .card-legend {\n  order: 1;\n  margin-right: auto;\n}\n.actionswrap .action-list .cardtoggle-required {\n  display: flex;\n  align-items: center;\n  gap: 0 5px;\n  order: 2;\n}\n.actionswrap .action-list .submenu-icon {\n  margin-left: 5px;\n  margin-right: 0;\n}\n.actionswrap .action-list .submenu-icon svg {\n  stroke: #10294D;\n  stroke-width: 1.4;\n  min-width: 24px;\n  height: 24px;\n}\n.actionswrap .action-list > .has-submenu {\n  display: flex;\n  flex: 0 0 auto;\n  padding: 0;\n}\n.actionswrap .action-list > .has-submenu .btn {\n  padding-right: 10px;\n}\n@media (min-width: 799px) {\n  .actionswrap .action-list > .has-submenu {\n    flex-wrap: nowrap;\n  }\n}\n@media (min-width: 799px) {\n  .full .actionswrap {\n    left: 300px;\n  }\n}\n@media (max-width: 799px) {\n  .full .actionswrap {\n    left: 0;\n  }\n  .mini .actionswrap {\n    left: 0;\n  }\n  .actionswrap.down {\n    transform: translate3d(0, 0, 0);\n    transition: all 0.2s ease-in-out;\n    top: 0;\n  }\n  .actionswrap.up {\n    transform: translate3d(0, 0, 0);\n    transition: all 0.2s ease-in-out;\n    top: 60px;\n  }\n}\n.context-sidebar .action-submenu {\n  border-top: 0;\n  width: 100%;\n  display: flex;\n}\n.context-sidebar .action-submenu strong {\n  display: block;\n  padding: 0 0 0 0.8em;\n  line-height: 2em;\n}\n.context-sidebar .action-submenu .action-sub-item {\n  display: block;\n  padding: 0 0.8em;\n  cursor: pointer;\n  background: none;\n  border: 0 none;\n}\n.context-sidebar .nav > .navitem.disabled {\n  color: #ccc;\n}\n.context-sidebar .nav > .navitem.disabled svg {\n  fill: #ccc;\n}\n.action-submenu-cover-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n}\n.action-submenu-cover-wrapper .action-submenu-cover {\n  margin-top: 10px;\n  z-index: 101;\n  transition: top 0.2s ease-in-out;\n}\n.action-submenu-cover-wrapper .action-submenu-cover-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n  transform: translateZ(0);\n  background-color: rgba(0, 0, 0, 0);\n}\n.action-submenu-cover-wrapper .action-submenu {\n  background: #ffffff;\n  margin-top: 3px;\n  border: 1px solid #CED7E2;\n  border-radius: 4px;\n}\n.action-submenu-cover-wrapper .action-submenu strong {\n  display: block;\n  padding: 0.75rem 0.8em;\n}\n.action-submenu-cover-wrapper .action-submenu .action-sub-item {\n  display: block;\n  padding: 0.75rem 0.8em;\n  cursor: pointer;\n  background: #fff;\n  border: 0 none;\n  width: 100%;\n  text-align: left;\n  text-decoration: none;\n  color: #78789A;\n}\n.action-submenu-cover-wrapper .action-submenu .action-sub-item:hover {\n  background-color: #F3F5F8;\n}\ninput:invalid {\n  border: none;\n  box-shadow: none !important;\n}\n.editgroup {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 1 1 auto;\n  gap: 27px 0;\n}\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 0.75rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  color: #495057;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border: 1px solid #cfcdcd;\n  border-radius: 4px;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  flex: 1 1 auto;\n  font-size: 14px;\n  line-height: 21px;\n  min-height: 34px;\n  padding: 6px 15px;\n  border: none;\n  outline: none;\n  color: #70859E;\n  background: transparent;\n}\n@media screen and (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n.form-control:focus {\n  color: #495057;\n  background-color: #ffffff;\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n.form-control::placeholder {\n  color: #6c757d;\n  opacity: 1;\n}\n.form-control:disabled,\n.form-control[readonly] {\n  background-color: #e9ecef;\n  opacity: 1;\n}\n.was-validated .form-control:valid,\n.form-control.is-valid {\n  border-color: #73C677;\n}\n.was-validated .form-control:valid:focus,\n.form-control.is-valid:focus {\n  border-color: #73C677;\n  box-shadow: 0 0 0 0.2rem rgba(115, 198, 119, 0.25);\n}\n.was-validated .form-control:valid ~ .valid-feedback,\n.form-control.is-valid ~ .valid-feedback,\n.was-validated .form-control:valid ~ .valid-tooltip,\n.form-control.is-valid ~ .valid-tooltip {\n  display: block;\n}\n.was-validated .form-control:invalid,\n.form-control.is-invalid {\n  border-color: #dc3545;\n}\n.was-validated .form-control:invalid:focus,\n.form-control.is-invalid:focus {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);\n}\n.was-validated .form-control:invalid ~ .invalid-feedback,\n.form-control.is-invalid ~ .invalid-feedback,\n.was-validated .form-control:invalid ~ .invalid-tooltip,\n.form-control.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n.form-control::placeholder {\n  color: #B2C2D4;\n  font-size: 14px;\n  line-height: 21px;\n  opacity: 1;\n}\n.form-control:disabled,\n.form-control[readonly] {\n  background-color: transparent;\n  color: #92A7C0;\n  opacity: 1;\n}\n.form-control:hover {\n  border: none;\n}\n.form-control:focus,\n.form-control:focus-within {\n  color: #70859E;\n  border: none;\n  box-shadow: none;\n}\ntextarea.form-control {\n  line-height: 18px;\n  min-height: 112px;\n  color: #444;\n  background: none;\n}\ntextarea.form-control:focus {\n  background: none;\n}\n.form-control.domstring {\n  white-space: pre-wrap;\n}\n.form-control + .tip:not(:first-of-type) {\n  margin-top: 10px;\n}\n.form-control + .tip:not(:first-of-type) + .tip {\n  margin-bottom: 0;\n}\n.form-control.google-map {\n  padding: 0;\n  margin: 0;\n  min-height: 420px;\n  margin-bottom: 104px;\n}\n.form-control.google-map .map-search,\n.form-control.google-map .map-buttons {\n  font-family: 'Poppins', sans-serif;\n  font-size: 12px;\n}\n.form-control.google-map .map-search {\n  box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;\n  margin: 10px;\n  background: #ffffff;\n  max-width: 300px;\n  width: calc(100vw - 100px);\n  border-radius: 2px;\n}\n.form-control.google-map .map-search .react-select__menu {\n  font-size: 10px;\n}\n.form-control.google-map .map-buttons {\n  margin: 10px 0;\n  display: flex;\n  gap: 10px 10px;\n}\n.form-control.sortable-text {\n  margin-bottom: 5px;\n}\n.form-control.sortable-text input {\n  border: 0;\n  height: 100%;\n}\n.fieldarray-label {\n  margin-bottom: 10px;\n}\n.fieldarray,\n.sortabletextinput,\n.fieldlist {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 27px 20px;\n}\n.fieldarray:not(.fieldlist) fieldset,\n.sortabletextinput:not(.fieldlist) fieldset,\n.fieldlist:not(.fieldlist) fieldset {\n  flex: 0 0 100%;\n}\n.fieldarray:not(.fieldlist) fieldset + fieldset,\n.sortabletextinput:not(.fieldlist) fieldset + fieldset,\n.fieldlist:not(.fieldlist) fieldset + fieldset {\n  padding-top: 27px;\n}\n.fieldarray:not(.fieldlist) fieldset > .input-group,\n.sortabletextinput:not(.fieldlist) fieldset > .input-group,\n.fieldlist:not(.fieldlist) fieldset > .input-group {\n  flex: 1 1 100%;\n}\n.fieldarray .arrayaction,\n.sortabletextinput .arrayaction,\n.fieldlist .arrayaction {\n  display: flex;\n  gap: 27px 20px;\n}\n.fieldarray#field-portals fieldset + fieldset,\n.sortabletextinput#field-portals fieldset + fieldset,\n.fieldlist#field-portals fieldset + fieldset {\n  box-shadow: 0px -5px 0px #E5EBF1;\n}\n.fieldarray.fieldarray > .input-group > .input-group > .input-group,\n.sortabletextinput.fieldarray > .input-group > .input-group > .input-group,\n.fieldlist.fieldarray > .input-group > .input-group > .input-group {\n  flex: 1 1 100%;\n}\n.fieldarray.fieldarray .btn-drag,\n.sortabletextinput.fieldarray .btn-drag,\n.fieldlist.fieldarray .btn-drag {\n  flex: 0 0 0;\n  max-height: 34px;\n  border: 0 !important;\n  outline: 0 !important;\n  box-shadow: none !important;\n  cursor: row-resize;\n}\n.fieldarray.fieldarray .btn-drag ~ .input-group,\n.sortabletextinput.fieldarray .btn-drag ~ .input-group,\n.fieldlist.fieldarray .btn-drag ~ .input-group {\n  flex: 1 1 calc(100% - 40px);\n}\n.fieldarray.fieldarray .dz-handle,\n.sortabletextinput.fieldarray .dz-handle,\n.fieldlist.fieldarray .dz-handle {\n  max-width: 12px;\n  margin: 0;\n}\n.listings-lookup .listings-items {\n  margin-bottom: 20px;\n}\n.listings-lookup .listing-lookup-listing-item {\n  width: 100%;\n  display: flex;\n  line-height: 20px;\n  padding-bottom: 10px;\n}\n.listings-lookup .listing-lookup-listing-item .listing-item-price {\n  font-weight: 800;\n  color: #000;\n  min-width: 80px;\n}\n.listings-lookup .listing-lookup-listing-item .listing-item-price p {\n  color: #92A7C0;\n  text-transform: uppercase;\n  margin: 0px;\n}\n.listings-lookup .listing-lookup-listing-item .listing-item-remove {\n  padding-left: 5px;\n}\n.form-group {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-bottom: 0;\n  position: relative;\n  flex: 0 0 100%;\n}\n@media screen and (min-width: 799px) {\n  .form-group {\n    flex: 1 1 auto;\n  }\n  .form-group.country-code-phone .input-group {\n    flex-wrap: nowrap;\n  }\n}\n.form-group.urltemplate .selectinput {\n  margin-top: 10px;\n}\n.form-group.notesinput {\n  margin-top: 10px;\n}\n.form-group.rtl textarea {\n  text-align: right;\n}\n.form-group.translatabletextareainput .input-group + .input-group {\n  margin-top: 20px;\n}\n.form-group.translatabletextareainput .input-group + .arrayaction {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 0 0 100%;\n}\n.form-group.translatabletextareainput .input-group + .arrayaction .input-group {\n  display: flex;\n  flex-wrap: wrap;\n}\n.form-group.translatabletextareainput .input-group + .arrayaction .input-group .arrayaction-button {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px 20px;\n}\n.disabled .form-group {\n  cursor: not-allowed;\n}\n.disabled .form-group .form-control {\n  color: #92A7C0;\n}\n.disabled .form-group .input-label {\n  color: #B2C2D4;\n}\n.form-group:not(.checkinput) .forminput {\n  display: flex;\n}\n.form-group:not(.checkinput) .forminput:not(.input-only) {\n  flex: 0 0 100%;\n  border-radius: 4px;\n  border: 1px solid #E5EBF1;\n}\n.form-group:not(.checkinput) .forminput:not(.input-only):hover {\n  border: 1px solid #CED7E2;\n}\n.form-group:not(.checkinput) .forminput:not(.input-only):focus,\n.form-group:not(.checkinput) .forminput:not(.input-only):focus-within {\n  box-shadow: 0px 0px 0px 3px #E4E7EB;\n}\n.form-group:not(.checkinput) .forminput::placeholder {\n  color: #B2C2D4;\n  opacity: 1;\n}\n.required:not(:has(.required)) .form-group:not(.not-required):not(.checkinput) .forminput:before {\n  content: \"\";\n  min-width: 6px;\n  margin: 3px 0 3px 3px;\n  border-radius: 2px 0 0 2px;\n  background: #FFB1B1;\n}\n.required:not(:has(.required)) .form-group:not(.not-required):not(.checkinput) .forminput .form-control,\n.required:not(:has(.required)) .form-group:not(.not-required):not(.checkinput) .forminput .react-select .react-select__control {\n  padding-left: 6px;\n}\n.quality .form-group:not(.not-required):not(.checkinput) .forminput:before {\n  content: \"\";\n  min-width: 6px;\n  margin: 3px 0 3px 3px;\n  border-radius: 2px 0 0 2px;\n  background: #DFB0F4;\n}\n.quality .form-group:not(.not-required):not(.checkinput) .forminput .form-control,\n.quality .form-group:not(.not-required):not(.checkinput) .forminput .react-select .react-select__control {\n  padding-left: 6px;\n}\n.form-group.code-input .formlabel {\n  position: relative;\n  top: unset;\n  left: unset;\n  margin-left: 10px;\n}\n.form-group.checkinput {\n  flex-wrap: nowrap;\n}\n.form-group.checkinput .formlabel {\n  font-size: unset;\n  line-height: unset;\n  font-weight: unset;\n  position: unset;\n  padding: unset;\n  display: unset;\n  height: unset;\n  min-height: unset;\n  background: unset;\n  color: unset;\n  top: unset;\n  left: unset;\n  margin: 0;\n  margin-left: 10px;\n  color: #10294D;\n}\n.search-fields .form-group.checkinput {\n  min-width: 0;\n}\n.form-group.checkinput .forminput {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n}\n.form-group.checkinput .forminput .checkcontainer {\n  flex: 0 0 auto;\n}\n.form-group.checkinput .forminput .checkcontainer + label {\n  max-width: calc(100vw - 182px);\n  white-space: normal;\n  flex: 1;\n  text-align: left;\n}\n@media screen and (min-width: 799px) {\n  .form-group.checkinput .forminput .checkcontainer + label {\n    min-width: 220px;\n  }\n  .search-fields .form-group.checkinput .forminput .checkcontainer + label {\n    min-width: 0;\n  }\n}\n.form-group.checkinput .forminput .input-group-addon.btn {\n  padding: 6px 15px;\n  border-radius: 4px;\n}\n.form-group.previewinput {\n  flex-wrap: wrap;\n  flex: 0 0 150px;\n  max-width: 150px;\n}\n@media screen and (min-width: 799px) {\n  .form-group.previewinput {\n    justify-content: center;\n  }\n}\n.form-group.previewinput .single-user {\n  max-width: 150px;\n  max-height: 150px;\n}\n.form-group.previewinput .thumb {\n  background: none;\n}\n.form-group.previewinput .thumb .thumbimg {\n  display: flex;\n  align-items: center;\n  border: 1px dashed #CED7E2;\n  justify-content: center;\n  background: none;\n}\n.form-group.previewinput .thumb .thumbimg svg {\n  vertical-align: middle;\n  width: 68px;\n  height: 68px;\n  fill: none;\n  stroke: #CED7E2;\n  stroke-width: 0.6;\n}\n.form-group.previewinput .thumb .thumbimg[style] {\n  border: none;\n}\n.form-group.previewinput .thumb .thumbimg[style] svg {\n  display: none;\n}\n.form-group.previewinput .thumb:hover {\n  box-shadow: none;\n}\n.form-group.previewinput .thumb:hover .thumbimg {\n  transform: scale(1) translateZ(1000px);\n}\n.form-group.previewinput label {\n  display: flex;\n  justify-content: center;\n  margin-top: 10px;\n  stroke: #92A7C0;\n  flex: 0 0 100%;\n}\n.form-group.uom .forminput:after {\n  justify-content: center;\n  min-width: 36px;\n  display: flex;\n  align-items: center;\n  width: auto;\n  padding: 0;\n  flex: 0 0 auto;\n  padding-right: 13px;\n  font-weight: 600;\n  color: #10294D;\n}\n.form-group.uom .forminput:after.btn {\n  justify-content: center;\n}\n.form-group.uom .forminput:after .btn-none:focus {\n  outline: none;\n}\n.form-group.uom .forminput:after:not(.btn-icon-16) svg {\n  width: 24px;\n  height: 24px;\n  stroke-width: 1.4;\n}\n.form-group.uom.seconds .forminput:after {\n  content: \"sec\";\n}\n.form-group.uom.metres .forminput:after {\n  content: \"m\";\n}\n.form-group.uom.squaremetres .forminput:after {\n  content: \"m\\00B2\";\n}\n.form-group.uom.squarefeet .forminput:after {\n  content: \"ft\\00B2\";\n}\n.form-group.uom.acres .forminput:after {\n  content: \"ac\";\n}\n.form-group.uom.hectares .forminput:after {\n  content: \"ha\";\n}\n.form-group.uom.percentage .forminput:after {\n  content: \"%\";\n}\n.form-group.uom.per.squaremetres .forminput:after {\n  content: \"per m\\00B2\";\n}\n.form-group.uom.per.squarefeet .forminput:after {\n  content: \"per ft\\00B2\";\n}\n.form-group.uom.loadingcapacity .forminput:after {\n  content: \"tn/m\\00B2\";\n}\n.form-group.uom input.form-control {\n  padding-right: 40px;\n}\n.form-group.recipient-lookup {\n  display: flex;\n  justify-content: space-between;\n}\n.form-group.contact-lookup.bulk {\n  display: flex;\n  justify-content: space-between;\n}\n.form-group.contact-lookup .recipients {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  line-height: 16px;\n  padding: 20px 0px 0px;\n}\n.form-group.contact-lookup .recipients > div {\n  display: flex;\n  align-items: center;\n}\n.form-group.contact-lookup .recipients > div svg {\n  fill: none;\n  stroke: #233142;\n  width: 16px;\n  height: 16px !important;\n}\n.form-group.contact-lookup .form-contact-card {\n  border: 1px solid #E5EBF1;\n  border-radius: 4px;\n  padding: 15px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px 0;\n}\n.form-group.contact-lookup .form-contact-card .contact-card-details {\n  flex: 0 0 100%;\n  display: grid;\n  grid-template-columns: 1fr 2fr;\n  gap: 0 10px;\n}\n.form-group.contact-lookup .form-contact-card .meta-detail .heavy {\n  min-width: 45%;\n}\n.form-group.contact-lookup .form-contact-card .meta-detail .heavy + div {\n  min-width: 45%;\n  max-width: calc(100vw - 110px);\n  flex: 1 1 45%;\n  white-space: nowrap;\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.form-group.contact-lookup .form-contact-card .arrayaction {\n  display: flex;\n  margin-top: 15px;\n}\n.form-group.contact-lookup .form-contact-card-empty .arrayaction {\n  display: flex;\n  margin-top: auto;\n}\n.form-group.contact-lookup .arrayaction {\n  flex: 1 1 100%;\n  gap: 10px 20px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.form-group.on_show .forminput {\n  flex-wrap: wrap;\n}\n.form-group.on_show .onshowhistory {\n  flex: 1 1 100%;\n}\n.form-group.on_show_events {\n  gap: 27px 20px;\n}\n.form-group.on_show_events .arrayaction {\n  display: flex;\n  flex: 1 1 100%;\n  gap: 10px 20px;\n  flex-wrap: wrap;\n}\n.form-group.on_show_events fieldset {\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px 5px 0px #E5EBF1;\n  padding-bottom: 20px;\n}\n.form-group.size_breakdowns {\n  gap: 27px 20px;\n}\n.form-group.size_breakdowns .arrayaction {\n  display: flex;\n  flex: 1 1 100%;\n  gap: 10px 20px;\n  flex-wrap: wrap;\n}\n.form-group.size_breakdowns fieldset {\n  display: flex;\n  flex-wrap: wrap;\n}\n.form-group.size_breakdowns fieldset > .btn {\n  flex: 0 0;\n  max-height: none;\n  min-width: 24px;\n  justify-content: center;\n}\n.form-group.size_breakdowns fieldset > .input-group {\n  flex: 1 1;\n}\n.form-group.size_breakdowns fieldset .section-heading {\n  display: flex;\n  align-items: center;\n}\n.form-group.size_breakdowns fieldset .section-heading h4 {\n  margin: 0;\n}\n.form-group.size_breakdowns .breakdown-totals {\n  display: flex;\n}\n.form-group.size_breakdowns .breakdown-totals > .btn {\n  flex: 0 0;\n  max-height: none;\n  min-width: 24px;\n  justify-content: center;\n}\n.form-group.size_breakdowns .breakdown-totals > .input-group {\n  flex: 1 1;\n  gap: 0px 20px;\n}\n.form-group.size_breakdowns .breakdown-totals .breakdown-total {\n  color: #B2C2D4;\n  padding: 6px 15px;\n}\n.form-group.size_breakdowns .arrayaction > .btn {\n  max-height: none;\n  min-width: 24px;\n  justify-content: center;\n}\n.form-group.size_breakdowns .arrayaction > .input-group {\n  flex: 1 1;\n}\n@media screen and (min-width: 799px) {\n  .form-group.size_breakdowns .arrayaction .arrayaction-button {\n    margin-left: -44px;\n    margin-right: 44px;\n  }\n}\n.form-group .input-label {\n  font-size: 11px;\n  line-height: 16.5px;\n  font-weight: 600;\n  position: absolute;\n  padding: 0 5px;\n  display: block;\n  height: auto;\n  min-height: auto;\n  background: #ffffff;\n  color: #455870;\n  top: -8px;\n  left: 10px;\n  margin: auto;\n  white-space: nowrap;\n  max-width: calc(100% - 10px);\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.form-group .error {\n  font-size: 11px;\n  line-height: 16.5px;\n  font-weight: 600;\n  position: absolute;\n  padding: 0 5px;\n  display: block;\n  height: auto;\n  min-height: auto;\n  background: #ffffff;\n  top: -8px;\n  right: 10px;\n  margin: auto;\n  color: #FF6464;\n}\n.form-group.textnotes .error,\n.form-group.selectnotes .error {\n  right: 80px;\n}\n.form-group .form-control-info {\n  flex: 1 1 100%;\n  display: block;\n  padding: 4px 15px;\n  color: #B2C2D4;\n  font-size: 9px;\n}\n.form-group .forminput {\n  flex: 1 1 auto;\n}\n.form-group .forminput .input-group-addon {\n  min-width: 36px;\n  display: flex;\n  align-items: center;\n  width: auto;\n  padding: 0;\n  flex: 0 0 auto;\n}\n.form-group .forminput .input-group-addon.btn {\n  justify-content: center;\n}\n.form-group .forminput .input-group-addon .btn-none:focus {\n  outline: none;\n}\n.form-group .forminput .input-group-addon:not(.btn-icon-16) svg {\n  width: 24px;\n  height: 24px;\n  stroke-width: 1.4;\n}\n.form-group .forminput .input-group-suffix {\n  border-right: 0;\n  padding-right: 0;\n  border-radius: 4px 0 0 4px;\n}\n.form-group .forminput .input-group-suffix ~ .input-group-addon {\n  min-width: 36px;\n  border-left: 1px solid transparent;\n  border-radius: 0;\n  font-weight: 600;\n}\n.form-group .forminput .input-group-suffix ~ .input-group-addon.btn {\n  justify-content: center;\n}\n.form-group .forminput .input-group-suffix ~ .input-group-addon.btn.btn-grey {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n.form-group .forminput .input-group-suffix ~ .input-group-addon svg {\n  stroke: #10294D;\n}\n.form-group .forminput .input-group-prefix {\n  border-left: 0;\n  padding-left: 0;\n  border-radius: 0 4px 4px 0;\n}\n.form-group .forminput .input-group-prefix:not(.input-group-suffix) {\n  order: 1;\n}\n.form-group .forminput .input-group-prefix + .input-group-addon {\n  border-left: 0;\n  order: 0;\n  font-weight: 600;\n  border-radius: 0;\n  padding: 0;\n}\n.form-group .forminput .input-group-prefix + .input-group-addon svg {\n  stroke: #10294D;\n}\n.form-group #country_code {\n  min-width: 145px;\n}\n.form-group.has-copy-link {\n  margin-top: 30px;\n}\n.form-group.has-copy-link .btn {\n  order: 0;\n  flex: 0 0 0%;\n  width: 0;\n  overflow: visible;\n  position: relative;\n  margin-bottom: auto;\n  margin-top: -50px;\n  left: 0;\n  padding: 0;\n  text-decoration: underline;\n}\n.form-group.has-copy-link .btn:hover,\n.form-group.has-copy-link .btn:focus,\n.form-group.has-copy-link .btn:active {\n  box-shadow: none;\n}\n.form-group.has-copy-link label {\n  order: 1;\n}\n.required .form-group.has-copy-link .btn {\n  left: -10px;\n}\n.form-group.bordered {\n  border-top: 4px solid #E5EBF1;\n  padding-top: 27px;\n  flex: 0 0 calc(100% + 30px);\n}\n.ratio-group .col-lg-2 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.section-heading.bordered {\n  border-top: 4px solid #E5EBF1;\n  flex: 0 0 calc(100% + 30px);\n}\n.section-heading.bordered .section-heading-content {\n  padding-top: 27px;\n}\n.sortabletextinput:not(.checkinput) .arrayaction {\n  margin-top: -10px;\n  align-self: flex-end;\n  margin-left: auto;\n}\n.sortabletextinput:not(.checkinput) .arrayaction .btn {\n  border-top-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.sortabletextinput:not(.checkinput) .sortable-text-list {\n  flex: 0 0 100%;\n}\n.sortabletextinput:not(.checkinput) .sortable-text-list .forminput {\n  flex-wrap: wrap;\n  flex: 0 0 100%;\n  gap: 5px 0;\n  padding-top: 10px;\n}\n.sortabletextinput:not(.checkinput) .sortable-text-list .sortable-text {\n  width: 100%;\n  flex: 1 1 100%;\n  margin: 0 5px;\n  border: 1px solid #E5EBF1;\n  display: flex;\n  align-items: center;\n}\n.sortabletextinput:not(.checkinput) .sortable-text-list .sortable-text[style^=\"left\"],\n.sortabletextinput:not(.checkinput) .sortable-text-list .sortable-text[style*=\"left\"] {\n  background: #E5EBF1;\n  transition: none;\n  box-shadow: 0px 2px 4px #C5CFDC;\n}\n.sortabletextinput:not(.checkinput) .sortable-text-list .sortable-text input {\n  width: 100%;\n  background: none;\n}\n.sortabletextinput:not(.checkinput) .sortable-text-list .sortable-text .btn {\n  padding: 0;\n  min-height: 0;\n}\n.sortabletextinput:not(.checkinput) .sortable-text-list .sortable-text:last-of-type {\n  margin-bottom: 5px;\n}\n.input-group-addon {\n  min-width: 36px;\n  display: flex;\n  align-items: center;\n  width: auto;\n  padding: 0;\n  flex: 0 0 auto;\n}\n.input-group-addon.btn {\n  justify-content: center;\n}\n.input-group-addon .btn-none:focus {\n  outline: none;\n}\n.input-group-addon:not(.btn-icon-16) svg {\n  width: 24px;\n  height: 24px;\n  stroke-width: 1.4;\n}\n.input-group-suffix {\n  border-right: 0;\n  padding-right: 0;\n  border-radius: 4px 0 0 4px;\n}\n.input-group-suffix ~ .input-group-addon {\n  min-width: 36px;\n  border-left: 1px solid transparent;\n  border-radius: 0;\n  font-weight: 600;\n}\n.input-group-suffix ~ .input-group-addon.btn {\n  justify-content: center;\n}\n.input-group-suffix ~ .input-group-addon.btn.btn-grey {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n.input-group-suffix ~ .input-group-addon svg {\n  stroke: #10294D;\n}\n.input-group-prefix {\n  border-left: 0;\n  padding-left: 0;\n  border-radius: 0 4px 4px 0;\n}\n.input-group-prefix:not(.input-group-suffix) {\n  order: 1;\n}\n.input-group-prefix + .input-group-addon {\n  border-left: 0;\n  order: 0;\n  font-weight: 600;\n  border-radius: 0;\n  padding: 0;\n}\n.input-group-prefix + .input-group-addon svg {\n  stroke: #10294D;\n}\n#profile-picture .editgroup,\n#signature-picture .editgroup {\n  justify-content: center;\n}\n@media screen and (min-width: 799px) {\n  #profile-picture .editgroup .input-group,\n  #signature-picture .editgroup .input-group {\n    flex: 0 0 auto;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n  }\n  #profile-picture .editgroup .input-group .field,\n  #signature-picture .editgroup .input-group .field {\n    max-width: none;\n    flex: 1 1 auto;\n  }\n}\n.input-group {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 0 0 100%;\n  gap: 27px 20px;\n}\n.input-group > * {\n  flex: 1 1 100%;\n}\n@media screen and (min-width: 799px) {\n  .input-group > * {\n    flex: auto;\n  }\n}\n.input-group .col {\n  flex-basis: 0;\n  flex-grow: 1;\n  max-width: 100%;\n}\n.input-group .col-auto {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: none;\n}\n.input-group .col-1 {\n  flex: 0 1 calc(8.33333333%);\n  flex: 0 1 calc(8.33333333% - 18.33333333px);\n  max-width: 8.33333333%;\n}\n.input-group .col-2 {\n  flex: 0 1 calc(16.66666667%);\n  flex: 0 1 calc(16.66666667% - 16.66666667px);\n  max-width: 16.66666667%;\n}\n.input-group .col-3 {\n  flex: 0 1 calc(25%);\n  flex: 0 1 calc(25% - 15px);\n  max-width: 25%;\n}\n.input-group .col-4 {\n  flex: 0 1 calc(33.33333333%);\n  flex: 0 1 calc(33.33333333% - 13.33333333px);\n  max-width: 33.33333333%;\n}\n.input-group .col-5 {\n  flex: 0 1 calc(41.66666667%);\n  flex: 0 1 calc(41.66666667% - 16.66666667px);\n  max-width: 41.66666667%;\n}\n.input-group .col-6 {\n  flex: 0 1 calc(50%);\n  flex: 0 1 calc(50% - 10px);\n  max-width: 50%;\n}\n.input-group .col-7 {\n  flex: 0 1 calc(58.33333333%);\n  flex: 0 1 calc(58.33333333% - 11.66666667px);\n  max-width: 58.33333333%;\n}\n.input-group .col-8 {\n  flex: 0 1 calc(66.66666667%);\n  flex: 0 1 calc(66.66666667% - 13.33333333px);\n  max-width: 66.66666667%;\n}\n.input-group .col-9 {\n  flex: 0 1 calc(75%);\n  flex: 0 1 calc(75% - 15px);\n  max-width: 75%;\n}\n.input-group .col-10 {\n  flex: 0 1 calc(83.33333333%);\n  flex: 0 1 calc(83.33333333% - 16.66666667px);\n  max-width: 83.33333333%;\n}\n.input-group .col-11 {\n  flex: 0 1 calc(91.66666667%);\n  flex: 0 1 calc(91.66666667% - 18.33333333px);\n  max-width: 91.66666667%;\n}\n.input-group .col-12 {\n  flex: 0 1 calc(100%);\n  max-width: 100%;\n}\n.input-group .order-first {\n  order: -1;\n}\n.input-group .order-last {\n  order: 13;\n}\n.input-group .order-0 {\n  order: 0;\n}\n.input-group .order-1 {\n  order: 1;\n}\n.input-group .order-2 {\n  order: 2;\n}\n.input-group .order-3 {\n  order: 3;\n}\n.input-group .order-4 {\n  order: 4;\n}\n.input-group .order-5 {\n  order: 5;\n}\n.input-group .order-6 {\n  order: 6;\n}\n.input-group .order-7 {\n  order: 7;\n}\n.input-group .order-8 {\n  order: 8;\n}\n.input-group .order-9 {\n  order: 9;\n}\n.input-group .order-10 {\n  order: 10;\n}\n.input-group .order-11 {\n  order: 11;\n}\n.input-group .order-12 {\n  order: 12;\n}\n.input-group .offset-1 {\n  margin-left: 8.33333333%;\n}\n.input-group .offset-2 {\n  margin-left: 16.66666667%;\n}\n.input-group .offset-3 {\n  margin-left: 25%;\n}\n.input-group .offset-4 {\n  margin-left: 33.33333333%;\n}\n.input-group .offset-5 {\n  margin-left: 41.66666667%;\n}\n.input-group .offset-6 {\n  margin-left: 50%;\n}\n.input-group .offset-7 {\n  margin-left: 58.33333333%;\n}\n.input-group .offset-8 {\n  margin-left: 66.66666667%;\n}\n.input-group .offset-9 {\n  margin-left: 75%;\n}\n.input-group .offset-10 {\n  margin-left: 83.33333333%;\n}\n.input-group .offset-11 {\n  margin-left: 91.66666667%;\n}\n@media (min-width: 576px) {\n  .input-group .col-sm {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .input-group .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .input-group .col-sm-1 {\n    flex: 0 1 calc(8.33333333%);\n    flex: 0 1 calc(8.33333333% - 18.33333333px);\n    max-width: 8.33333333%;\n  }\n  .input-group .col-sm-2 {\n    flex: 0 1 calc(16.66666667%);\n    flex: 0 1 calc(16.66666667% - 16.66666667px);\n    max-width: 16.66666667%;\n  }\n  .input-group .col-sm-3 {\n    flex: 0 1 calc(25%);\n    flex: 0 1 calc(25% - 15px);\n    max-width: 25%;\n  }\n  .input-group .col-sm-4 {\n    flex: 0 1 calc(33.33333333%);\n    flex: 0 1 calc(33.33333333% - 13.33333333px);\n    max-width: 33.33333333%;\n  }\n  .input-group .col-sm-5 {\n    flex: 0 1 calc(41.66666667%);\n    flex: 0 1 calc(41.66666667% - 16.66666667px);\n    max-width: 41.66666667%;\n  }\n  .input-group .col-sm-6 {\n    flex: 0 1 calc(50%);\n    flex: 0 1 calc(50% - 10px);\n    max-width: 50%;\n  }\n  .input-group .col-sm-7 {\n    flex: 0 1 calc(58.33333333%);\n    flex: 0 1 calc(58.33333333% - 11.66666667px);\n    max-width: 58.33333333%;\n  }\n  .input-group .col-sm-8 {\n    flex: 0 1 calc(66.66666667%);\n    flex: 0 1 calc(66.66666667% - 13.33333333px);\n    max-width: 66.66666667%;\n  }\n  .input-group .col-sm-9 {\n    flex: 0 1 calc(75%);\n    flex: 0 1 calc(75% - 15px);\n    max-width: 75%;\n  }\n  .input-group .col-sm-10 {\n    flex: 0 1 calc(83.33333333%);\n    flex: 0 1 calc(83.33333333% - 16.66666667px);\n    max-width: 83.33333333%;\n  }\n  .input-group .col-sm-11 {\n    flex: 0 1 calc(91.66666667%);\n    flex: 0 1 calc(91.66666667% - 18.33333333px);\n    max-width: 91.66666667%;\n  }\n  .input-group .col-sm-12 {\n    flex: 0 1 calc(100%);\n    max-width: 100%;\n  }\n  .input-group .order-sm-first {\n    order: -1;\n  }\n  .input-group .order-sm-last {\n    order: 13;\n  }\n  .input-group .order-sm-0 {\n    order: 0;\n  }\n  .input-group .order-sm-1 {\n    order: 1;\n  }\n  .input-group .order-sm-2 {\n    order: 2;\n  }\n  .input-group .order-sm-3 {\n    order: 3;\n  }\n  .input-group .order-sm-4 {\n    order: 4;\n  }\n  .input-group .order-sm-5 {\n    order: 5;\n  }\n  .input-group .order-sm-6 {\n    order: 6;\n  }\n  .input-group .order-sm-7 {\n    order: 7;\n  }\n  .input-group .order-sm-8 {\n    order: 8;\n  }\n  .input-group .order-sm-9 {\n    order: 9;\n  }\n  .input-group .order-sm-10 {\n    order: 10;\n  }\n  .input-group .order-sm-11 {\n    order: 11;\n  }\n  .input-group .order-sm-12 {\n    order: 12;\n  }\n  .input-group .offset-sm-0 {\n    margin-left: 0;\n  }\n  .input-group .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n  .input-group .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n  .input-group .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .input-group .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n  .input-group .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n  .input-group .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .input-group .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n  .input-group .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n  .input-group .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .input-group .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n  .input-group .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n}\n@media (min-width: 768px) {\n  .input-group .col-md {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .input-group .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .input-group .col-md-1 {\n    flex: 0 1 calc(8.33333333%);\n    flex: 0 1 calc(8.33333333% - 18.33333333px);\n    max-width: 8.33333333%;\n  }\n  .input-group .col-md-2 {\n    flex: 0 1 calc(16.66666667%);\n    flex: 0 1 calc(16.66666667% - 16.66666667px);\n    max-width: 16.66666667%;\n  }\n  .input-group .col-md-3 {\n    flex: 0 1 calc(25%);\n    flex: 0 1 calc(25% - 15px);\n    max-width: 25%;\n  }\n  .input-group .col-md-4 {\n    flex: 0 1 calc(33.33333333%);\n    flex: 0 1 calc(33.33333333% - 13.33333333px);\n    max-width: 33.33333333%;\n  }\n  .input-group .col-md-5 {\n    flex: 0 1 calc(41.66666667%);\n    flex: 0 1 calc(41.66666667% - 16.66666667px);\n    max-width: 41.66666667%;\n  }\n  .input-group .col-md-6 {\n    flex: 0 1 calc(50%);\n    flex: 0 1 calc(50% - 10px);\n    max-width: 50%;\n  }\n  .input-group .col-md-7 {\n    flex: 0 1 calc(58.33333333%);\n    flex: 0 1 calc(58.33333333% - 11.66666667px);\n    max-width: 58.33333333%;\n  }\n  .input-group .col-md-8 {\n    flex: 0 1 calc(66.66666667%);\n    flex: 0 1 calc(66.66666667% - 13.33333333px);\n    max-width: 66.66666667%;\n  }\n  .input-group .col-md-9 {\n    flex: 0 1 calc(75%);\n    flex: 0 1 calc(75% - 15px);\n    max-width: 75%;\n  }\n  .input-group .col-md-10 {\n    flex: 0 1 calc(83.33333333%);\n    flex: 0 1 calc(83.33333333% - 16.66666667px);\n    max-width: 83.33333333%;\n  }\n  .input-group .col-md-11 {\n    flex: 0 1 calc(91.66666667%);\n    flex: 0 1 calc(91.66666667% - 18.33333333px);\n    max-width: 91.66666667%;\n  }\n  .input-group .col-md-12 {\n    flex: 0 1 calc(100%);\n    max-width: 100%;\n  }\n  .input-group .order-md-first {\n    order: -1;\n  }\n  .input-group .order-md-last {\n    order: 13;\n  }\n  .input-group .order-md-0 {\n    order: 0;\n  }\n  .input-group .order-md-1 {\n    order: 1;\n  }\n  .input-group .order-md-2 {\n    order: 2;\n  }\n  .input-group .order-md-3 {\n    order: 3;\n  }\n  .input-group .order-md-4 {\n    order: 4;\n  }\n  .input-group .order-md-5 {\n    order: 5;\n  }\n  .input-group .order-md-6 {\n    order: 6;\n  }\n  .input-group .order-md-7 {\n    order: 7;\n  }\n  .input-group .order-md-8 {\n    order: 8;\n  }\n  .input-group .order-md-9 {\n    order: 9;\n  }\n  .input-group .order-md-10 {\n    order: 10;\n  }\n  .input-group .order-md-11 {\n    order: 11;\n  }\n  .input-group .order-md-12 {\n    order: 12;\n  }\n  .input-group .offset-md-0 {\n    margin-left: 0;\n  }\n  .input-group .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n  .input-group .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n  .input-group .offset-md-3 {\n    margin-left: 25%;\n  }\n  .input-group .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n  .input-group .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n  .input-group .offset-md-6 {\n    margin-left: 50%;\n  }\n  .input-group .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n  .input-group .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n  .input-group .offset-md-9 {\n    margin-left: 75%;\n  }\n  .input-group .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n  .input-group .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n}\n@media (min-width: 992px) {\n  .input-group .col-lg {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .input-group .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .input-group .col-lg-1 {\n    flex: 0 1 calc(8.33333333%);\n    flex: 0 1 calc(8.33333333% - 18.33333333px);\n    max-width: 8.33333333%;\n  }\n  .input-group .col-lg-2 {\n    flex: 0 1 calc(16.66666667%);\n    flex: 0 1 calc(16.66666667% - 16.66666667px);\n    max-width: 16.66666667%;\n  }\n  .input-group .col-lg-3 {\n    flex: 0 1 calc(25%);\n    flex: 0 1 calc(25% - 15px);\n    max-width: 25%;\n  }\n  .input-group .col-lg-4 {\n    flex: 0 1 calc(33.33333333%);\n    flex: 0 1 calc(33.33333333% - 13.33333333px);\n    max-width: 33.33333333%;\n  }\n  .input-group .col-lg-5 {\n    flex: 0 1 calc(41.66666667%);\n    flex: 0 1 calc(41.66666667% - 16.66666667px);\n    max-width: 41.66666667%;\n  }\n  .input-group .col-lg-6 {\n    flex: 0 1 calc(50%);\n    flex: 0 1 calc(50% - 10px);\n    max-width: 50%;\n  }\n  .input-group .col-lg-7 {\n    flex: 0 1 calc(58.33333333%);\n    flex: 0 1 calc(58.33333333% - 11.66666667px);\n    max-width: 58.33333333%;\n  }\n  .input-group .col-lg-8 {\n    flex: 0 1 calc(66.66666667%);\n    flex: 0 1 calc(66.66666667% - 13.33333333px);\n    max-width: 66.66666667%;\n  }\n  .input-group .col-lg-9 {\n    flex: 0 1 calc(75%);\n    flex: 0 1 calc(75% - 15px);\n    max-width: 75%;\n  }\n  .input-group .col-lg-10 {\n    flex: 0 1 calc(83.33333333%);\n    flex: 0 1 calc(83.33333333% - 16.66666667px);\n    max-width: 83.33333333%;\n  }\n  .input-group .col-lg-11 {\n    flex: 0 1 calc(91.66666667%);\n    flex: 0 1 calc(91.66666667% - 18.33333333px);\n    max-width: 91.66666667%;\n  }\n  .input-group .col-lg-12 {\n    flex: 0 1 calc(100%);\n    max-width: 100%;\n  }\n  .input-group .order-lg-first {\n    order: -1;\n  }\n  .input-group .order-lg-last {\n    order: 13;\n  }\n  .input-group .order-lg-0 {\n    order: 0;\n  }\n  .input-group .order-lg-1 {\n    order: 1;\n  }\n  .input-group .order-lg-2 {\n    order: 2;\n  }\n  .input-group .order-lg-3 {\n    order: 3;\n  }\n  .input-group .order-lg-4 {\n    order: 4;\n  }\n  .input-group .order-lg-5 {\n    order: 5;\n  }\n  .input-group .order-lg-6 {\n    order: 6;\n  }\n  .input-group .order-lg-7 {\n    order: 7;\n  }\n  .input-group .order-lg-8 {\n    order: 8;\n  }\n  .input-group .order-lg-9 {\n    order: 9;\n  }\n  .input-group .order-lg-10 {\n    order: 10;\n  }\n  .input-group .order-lg-11 {\n    order: 11;\n  }\n  .input-group .order-lg-12 {\n    order: 12;\n  }\n  .input-group .offset-lg-0 {\n    margin-left: 0;\n  }\n  .input-group .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n  .input-group .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n  .input-group .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .input-group .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n  .input-group .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n  .input-group .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .input-group .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n  .input-group .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n  .input-group .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .input-group .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n  .input-group .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n}\n@media (min-width: 1200px) {\n  .input-group .col-xl {\n    flex-basis: 0;\n    flex-grow: 1;\n    max-width: 100%;\n  }\n  .input-group .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n    max-width: none;\n  }\n  .input-group .col-xl-1 {\n    flex: 0 1 calc(8.33333333%);\n    flex: 0 1 calc(8.33333333% - 18.33333333px);\n    max-width: 8.33333333%;\n  }\n  .input-group .col-xl-2 {\n    flex: 0 1 calc(16.66666667%);\n    flex: 0 1 calc(16.66666667% - 16.66666667px);\n    max-width: 16.66666667%;\n  }\n  .input-group .col-xl-3 {\n    flex: 0 1 calc(25%);\n    flex: 0 1 calc(25% - 15px);\n    max-width: 25%;\n  }\n  .input-group .col-xl-4 {\n    flex: 0 1 calc(33.33333333%);\n    flex: 0 1 calc(33.33333333% - 13.33333333px);\n    max-width: 33.33333333%;\n  }\n  .input-group .col-xl-5 {\n    flex: 0 1 calc(41.66666667%);\n    flex: 0 1 calc(41.66666667% - 16.66666667px);\n    max-width: 41.66666667%;\n  }\n  .input-group .col-xl-6 {\n    flex: 0 1 calc(50%);\n    flex: 0 1 calc(50% - 10px);\n    max-width: 50%;\n  }\n  .input-group .col-xl-7 {\n    flex: 0 1 calc(58.33333333%);\n    flex: 0 1 calc(58.33333333% - 11.66666667px);\n    max-width: 58.33333333%;\n  }\n  .input-group .col-xl-8 {\n    flex: 0 1 calc(66.66666667%);\n    flex: 0 1 calc(66.66666667% - 13.33333333px);\n    max-width: 66.66666667%;\n  }\n  .input-group .col-xl-9 {\n    flex: 0 1 calc(75%);\n    flex: 0 1 calc(75% - 15px);\n    max-width: 75%;\n  }\n  .input-group .col-xl-10 {\n    flex: 0 1 calc(83.33333333%);\n    flex: 0 1 calc(83.33333333% - 16.66666667px);\n    max-width: 83.33333333%;\n  }\n  .input-group .col-xl-11 {\n    flex: 0 1 calc(91.66666667%);\n    flex: 0 1 calc(91.66666667% - 18.33333333px);\n    max-width: 91.66666667%;\n  }\n  .input-group .col-xl-12 {\n    flex: 0 1 calc(100%);\n    max-width: 100%;\n  }\n  .input-group .order-xl-first {\n    order: -1;\n  }\n  .input-group .order-xl-last {\n    order: 13;\n  }\n  .input-group .order-xl-0 {\n    order: 0;\n  }\n  .input-group .order-xl-1 {\n    order: 1;\n  }\n  .input-group .order-xl-2 {\n    order: 2;\n  }\n  .input-group .order-xl-3 {\n    order: 3;\n  }\n  .input-group .order-xl-4 {\n    order: 4;\n  }\n  .input-group .order-xl-5 {\n    order: 5;\n  }\n  .input-group .order-xl-6 {\n    order: 6;\n  }\n  .input-group .order-xl-7 {\n    order: 7;\n  }\n  .input-group .order-xl-8 {\n    order: 8;\n  }\n  .input-group .order-xl-9 {\n    order: 9;\n  }\n  .input-group .order-xl-10 {\n    order: 10;\n  }\n  .input-group .order-xl-11 {\n    order: 11;\n  }\n  .input-group .order-xl-12 {\n    order: 12;\n  }\n  .input-group .offset-xl-0 {\n    margin-left: 0;\n  }\n  .input-group .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n  .input-group .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n  .input-group .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .input-group .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n  .input-group .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n  .input-group .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .input-group .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n  .input-group .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n  .input-group .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .input-group .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n  .input-group .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n}\n.input-group [class^=\"col-\"],\n.input-group [class*=\"col-\"] {\n  padding: 0;\n}\n.input-group .field:not([class^=\"col-\"]):not([class*=\"col-\"]):not(td) {\n  display: inherit;\n  flex-wrap: wrap;\n  flex: 1 1 auto;\n  gap: 16px 20px;\n}\n.input-group .field:not([class^=\"col-\"]):not([class*=\"col-\"]):not(td) .tip:not(:first-of-type) {\n  flex: 0 0 100%;\n  margin-top: 10px;\n  margin-bottom: 0;\n}\n.input-group td.field {\n  padding: 0;\n}\n.input-group td.field .form-control {\n  min-height: 30px;\n  padding: 6px 8px;\n  font-size: 12px;\n  line-height: 1.125;\n}\n.input-group td.field .form-group .forminput .input-group-addon {\n  min-width: 30px;\n  min-height: 30px;\n}\n.input-group .field .tip:not(:first-of-type) {\n  margin-top: 10px;\n}\n.input-group .field .tip:not(:first-of-type) + .tip {\n  margin-bottom: 0;\n}\n.input-group .field .tip:first-of-type {\n  margin-bottom: 10px;\n}\n.input-group .field.disabled .forminput {\n  color: #5A6F89;\n  opacity: 1;\n}\n.input-group .field .clevercompose-field {\n  margin-top: 10px;\n}\n.input-group .submit-button {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 10px;\n}\n.input-group.keyword-search {\n  gap: 0 10px;\n}\n@media screen and (min-width: 799px) {\n  .input-group.keyword-search {\n    flex: 1 1 auto;\n  }\n  .input-group.keyword-search > div {\n    flex: 0 0 auto;\n  }\n  .input-group.keyword-search .form-group.term {\n    flex: 0 0 300px;\n    width: 205px;\n    max-width: 205px;\n  }\n}\n@media screen and (min-width: 799px) {\n  .input-group.advanced-search {\n    flex: 0 1 auto;\n  }\n}\n/* Create a custom radio */\n.radiocontainer {\n  display: flex;\n  position: relative;\n  margin: 0;\n  gap: 8px 8px;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  min-height: 25px;\n  line-height: 25px;\n  font-size: 14px;\n}\n.radiocontainer input {\n  position: absolute;\n  z-index: 10;\n  opacity: 0;\n  cursor: pointer;\n  left: 0;\n  height: 24px;\n  width: 24px;\n}\n.radiocontainer .radio {\n  flex: 0 0 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 24px;\n  width: 24px;\n  background-color: #fff;\n  box-shadow: inset 0 0 0 1px #E5EBF1;\n  border-radius: 50%;\n  order: -1;\n}\n.radiocontainer .radio:after {\n  content: \"\";\n  display: none;\n}\n.radiocontainer:hover input ~ .radio {\n  box-shadow: inset 0 0 0 1px #CED7E2;\n}\n.radiocontainer input:checked ~ .radio:after {\n  display: block;\n  background-color: #10294D;\n}\n.radiocontainer .radio:after {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: white;\n}\n.onshowhistory {\n  flex-basis: 100%;\n}\n.onshowhistory table.on_show_history {\n  margin-top: 10px;\n  min-width: 280px;\n}\n/* The switch - the box around the slider */\n.switch {\n  position: relative;\n  display: flex;\n  min-width: 60px;\n}\n.switch input {\n  position: absolute;\n  opacity: 0;\n  width: 1px;\n  height: 1px;\n}\n/* The slider */\n.slider {\n  cursor: pointer;\n  display: flex;\n  width: 60px;\n  height: 34px;\n  background-color: #CED7E2;\n  padding: 4px;\n  align-items: center;\n}\n.slider .onoff {\n  height: 26px;\n  width: 26px;\n  background-color: white;\n  border-radius: 50%;\n}\n.slider.round {\n  border-radius: 34px;\n}\ninput:checked + .slider {\n  background-color: #10294D;\n}\ninput:checked + .slider span.onoff {\n  left: 14px;\n}\ninput:focus + .slider {\n  box-shadow: 0px 0px 0px 3px #E4E7EB;\n}\ninput:checked + .slider .onoff {\n  transform: translateX(26px);\n}\ninput:disabled + .slider {\n  background-color: #E5EBF1;\n  cursor: not-allowed;\n}\ninput:disabled + .slider .onoff {\n  transform: translateX(14px);\n}\n.checkgroup {\n  font-size: 1.1rem;\n  display: flex;\n  align-items: center;\n}\n.checkgroup label:nth-of-type(2) {\n  margin-left: 10px;\n}\n.checkcontainer {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  max-width: 100%;\n  min-height: 36px;\n  width: 36px;\n  height: 36px;\n  align-items: center;\n  cursor: pointer;\n  margin: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  justify-content: center;\n  /* Hide the browser's default checkbox */\n  /* On mouse-over, add a grey background color */\n  /* Show the checkmark when checked */\n  /* Style the checkmark/indicator */\n}\n.checkcontainer.input-group-suffix {\n  flex: 1 1 auto;\n}\n.checkcontainer input {\n  position: absolute;\n  left: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n.checkcontainer.readonly span {\n  pointer-events: none;\n  cursor: not-allowed;\n  background-color: #E5EBF1;\n}\n.checkcontainer:focus .checkmark,\n.checkcontainer:focus-within .checkmark {\n  box-shadow: 0px 0px 0px 3px #E4E7EB;\n}\n.checkcontainer input:disabled ~ .checkmark,\n.checkcontainer input:checked:disabled ~ .checkmark {\n  background-color: #E5EBF1;\n}\n.checkcontainer:hover input:disabled ~ .checkmark {\n  cursor: not-allowed;\n}\n.checkcontainer input:checked ~ .checkmark {\n  background: #10294D;\n  border-color: transparent;\n}\n.checkcontainer .checkmark svg {\n  stroke: #ffffff;\n  fill: none;\n  width: 22px;\n  height: 22px;\n  stroke-width: 2.4;\n}\n.checkmark {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  height: 24px;\n  width: 24px;\n  border-radius: 4px;\n  border: 1px solid #E5EBF1;\n  background: #ffffff;\n}\n.checkmark:hover {\n  border: 1px solid #CED7E2;\n}\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n.selected .checkcontainer .checkmark {\n  border: 1px solid #fff;\n}\n.selected .checkcontainer .checkmark:after {\n  content: \"\";\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  margin-top: -7px;\n  height: 11px;\n}\n.asynccheckgroup-filter-buttons {\n  margin-bottom: 15px;\n}\n.dz-thumb-caption.linked_plan .react-select__single-value {\n  color: #cccccc;\n}\n.react-select {\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  font-size: 14px;\n}\n.react-select__control {\n  align-items: center;\n  background-color: transparent;\n  border-radius: 3px;\n  border-style: solid;\n  box-shadow: none;\n  cursor: default;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  min-height: 34px;\n  outline: 0 !important;\n  position: relative;\n  box-sizing: border-box;\n  border: none;\n  padding-left: 14px;\n}\n.react-select__control--is-focused {\n  border-color: #E5EBF1;\n}\n.react-select__control--is-focused + .react-select__menu {\n  border-color: #E5EBF1;\n}\n.react-select .react-select__dropdown-indicator {\n  border: 0 !important;\n}\n.react-select .react-select__dropdown-indicator svg {\n  fill: none;\n  stroke: #10294D;\n  stroke-width: 1.4;\n  width: 24px;\n  height: 24px;\n}\n.react-select.top .react-select__control--menu-is-open {\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n  border-top: 0 none;\n}\n.react-select.top .react-select__control--menu-is-open .react-select__dropdown-indicator {\n  border-right: 1px solid #58ACE4;\n}\n.react-select__value-container {\n  align-items: center;\n  display: inline-grid;\n  flex: 1 1 0%;\n  padding: 0;\n  gap: 2px 4px;\n  font-size: inherit;\n  line-height: 1;\n  -webkit-overflow-scrolling: touch;\n  position: relative;\n  overflow: hidden;\n  box-sizing: border-box;\n  border: none;\n}\n.react-select__value-container [class^=\"-Input\"],\n.react-select__value-container [class*=\"-Input\"] {\n  margin: 0;\n  padding: 0;\n}\n.react-select__value-container--has-value {\n  display: flex;\n}\n.react-select__value-container--is-multi {\n  padding: 6px 0 2px 0;\n  flex-wrap: wrap;\n  padding: 6px 0;\n}\n.inline-select .react-select .react-select__value-container {\n  gap: 0 0;\n}\n.react-select [class^=\"-A11yText\"],\n.react-select [class*=\"-A11yText\"] {\n  z-index: 9999;\n  border: 0;\n  clip: rect(1px, 1px, 1px, 1px);\n  height: 1px;\n  width: 1px;\n  position: absolute;\n  overflow: hidden;\n  padding: 0;\n  white-space: nowrap;\n}\n.react-select__menu {\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateZ(10px);\n  min-width: 200px;\n  background-color: hsl(0, 0%, 100%);\n  border-radius: 4px;\n  box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);\n  margin-bottom: 8px;\n  margin-top: 8px;\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n  box-sizing: border-box;\n}\n.asynccheckgroup .react-select__menu {\n  top: 0;\n  position: relative;\n  border: 0;\n  box-shadow: none;\n  margin: 0;\n  margin-top: 10px;\n  padding-top: 0;\n  background: none;\n  z-index: 0;\n}\n.react-select__single-value {\n  color: #5A6F89;\n  font-size: 14px;\n  line-height: 21px;\n  top: unset;\n  margin: 0 1px;\n  transform: none;\n  align-self: center;\n  position: relative;\n  grid-area: 1 / 1 / 2 / 3;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.react-select__single-value--is-disabled {\n  color: #B2C2D4;\n}\n.react-select__multi-value {\n  background: #E5EBF1;\n  border: 1px solid #E5EBF1;\n  display: flex;\n  margin: 0;\n  border-radius: 2px;\n  padding: 2px 3px 2px 6px;\n}\n.react-select__multi-value__label {\n  color: #455870;\n  display: flex;\n  align-items: center;\n  font-size: 11px;\n  font-weight: 500;\n}\n.dependentselectinput .react-select__multi-value__label {\n  padding: 2px 6px;\n}\n.react-select__multi-value__remove {\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  flex: 0 0 1%;\n  align-items: center;\n  background: none;\n}\n.react-select__multi-value__remove svg {\n  width: 16px;\n  fill: none;\n  stroke: #92A7C0;\n  stroke-width: 2.4;\n}\n.react-select__multi-value__remove:hover {\n  background: none;\n}\n.react-select__multi-value__remove:hover svg {\n  fill: none;\n  stroke: #455870;\n}\n.react-select__placeholder {\n  color: #B2C2D4;\n  opacity: 1;\n  margin-left: 2px;\n  margin-right: 2px;\n  box-sizing: border-box;\n  grid-area: 1 / 1 / 2 / 2;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.react-select__placeholder + div {\n  margin: 0;\n  padding-bottom: 0;\n  padding-top: 0;\n  visibility: visible;\n  box-sizing: border-box;\n}\n.react-select__indicators {\n  align-items: center;\n  align-self: stretch;\n  display: flex;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  padding: 0;\n  transition: color 150ms ease 0s;\n}\n.react-select__indicator {\n  display: flex;\n  cursor: pointer;\n  padding: 0 7px;\n  transition: color 150ms;\n  box-sizing: border-box;\n}\n.react-select__indicator.react-select__clear-indicator {\n  padding: 0;\n}\n.react-select__indicator.react-select__clear-indicator svg {\n  width: 16px;\n  fill: none;\n  stroke: #10294D;\n  stroke-width: 2.4;\n}\n.react-select__input-container {\n  visibility: visible;\n  flex: 1 1 auto;\n  display: inline-grid;\n  grid-area: 1 / 1 / 2 / 3;\n  grid-template-columns: 0px min-content;\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n.react-select__input-container:after {\n  content: attr(data-value) \" \";\n  visibility: hidden;\n  white-space: pre;\n  grid-area: 1/2;\n  font: inherit;\n  min-width: 2px;\n  border: 0;\n  margin: 0;\n  outline: 0;\n  padding: 0;\n}\n.react-select__input {\n  color: inherit;\n  background: 0px center;\n  opacity: 1;\n  width: 100%;\n  grid-area: 1 / 2;\n  font: inherit;\n  min-width: 2px;\n  border: 0px none;\n  margin: 0px;\n  outline: 0px;\n  padding: 0px;\n}\n.react-select__menu {\n  border-radius: 4px;\n  box-shadow: 1px 1px 4px -2px rgba(0, 0, 0, 0.2);\n  border: 1px solid #E5EBF1;\n  overflow: hidden;\n}\n.react-select.top .react-select__menu {\n  border-top: 1px solid #58ACE4;\n  top: auto;\n  bottom: 100%;\n  box-shadow: 0px -3px 5px -1px rgba(0, 0, 0, 0.2);\n  margin-top: 0;\n  border-top: 0 none;\n  z-index: 950;\n}\n.react-select__menu-list {\n  max-height: 300px;\n  overflow-y: auto;\n  padding-bottom: 4px;\n  padding-top: 4px;\n  position: relative;\n  -webkit-overflow-scrolling: touch;\n  box-sizing: border-box;\n}\n.react-select__option {\n  background-color: none;\n  color: #455870;\n  cursor: default;\n  display: block;\n  font-size: inherit;\n  padding: 7.5px 15px;\n  width: 100%;\n  user-select: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  box-sizing: border-box;\n}\n.react-select__option--is-focused,\n.react-select__option:hover {\n  background-color: #F3F5F8;\n}\n.asynccheckgroup .react-select__option--is-focused,\n.asynccheckgroup .react-select__option:hover {\n  background-color: inherit;\n}\n.react-select__option--is-selected {\n  background-color: #E5EBF1;\n  color: #455870;\n}\n.asynccheckgroup .react-select__option--is-selected {\n  background: none;\n  color: #455870;\n}\n.react-select__option--is-disabled {\n  background-color: #F3F5F8;\n  color: #B2C2D4;\n}\n.asynccheckgroup .react-select__option--is-disabled {\n  background: none;\n  color: #455870;\n}\n.react-select__option .customopt {\n  display: flex;\n  flex-wrap: wrap;\n}\n.react-select__option .customopt img {\n  flex: 0 0 50px;\n  height: 50px;\n  width: 50px;\n  display: inline-block;\n  border-radius: 100px;\n  margin-right: 10px;\n  border: none;\n  background-color: #efefef;\n}\n.react-select__option .customopt > div {\n  flex: 1 1 auto;\n  vertical-align: middle;\n  line-height: 21px;\n}\n.react-select__option .customopt > div.select-tags {\n  flex: 0 0 auto;\n}\n.react-select__option .customopt > div.select-tags .select-tag {\n  background: #FC495D;\n  color: #ffffff;\n  font-size: 11px;\n  padding: 4px 6px;\n  border-radius: 2px;\n  text-transform: uppercase;\n}\n.react-select__option .customopt > div.select-tags .select-tag.Active {\n  background: #73C677;\n}\n.react-select__option .customopt > div.select-tags .select-tag.Inactive {\n  background: #FF6464;\n}\n.react-select__option .customopt span.sub {\n  display: block;\n  font-size: 11px;\n  line-height: 16.5px;\n  color: #92A7C0;\n}\n.asynccheckgroup .react-select__option .customopt {\n  box-shadow: 0px 1px 0px #E5EBF1;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n.asynccheckgroup .react-select__option .customopt:last-of-type {\n  box-shadow: none;\n}\n.asynccheckgroup .react-select__option .customopt .checkcontainer {\n  min-height: 24px;\n}\n.asynccheckgroup .react-select__option .customopt .domstring {\n  margin-left: 15px;\n}\n.react-select__menu-notice--no-options {\n  background-color: none;\n  color: #455870;\n  cursor: default;\n  display: block;\n  font-size: inherit;\n  padding: 7.5px 15px;\n  width: 100%;\n  user-select: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  box-sizing: border-box;\n}\n.react-select__menu-notice--loading {\n  background-color: none;\n  color: #455870;\n  cursor: default;\n  display: block;\n  font-size: inherit;\n  padding: 7.5px 15px;\n  width: 100%;\n  user-select: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  box-sizing: border-box;\n}\n.react-select__group-heading {\n  background-color: #F3F5F8;\n  color: #92A7C0;\n  text-align: center;\n  margin: 1px 15px;\n  cursor: default;\n  display: block;\n  font-size: 11px;\n  padding: 3px 6px;\n  font-weight: 600;\n  user-select: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  box-sizing: border-box;\n  text-transform: none;\n}\n.react-select__group-heading .customopt {\n  padding-left: 12px;\n}\n.react-select__group-heading .customopt img {\n  height: 50px;\n  width: 50px;\n  display: inline-block;\n  border-radius: 100px;\n  margin-right: 10px;\n  border: none;\n  background-color: #efefef;\n}\n.react-select__group-heading .customopt > div {\n  display: inline-block;\n  vertical-align: middle;\n}\n.react-select__group-heading .customopt span.sub {\n  display: block;\n  font-size: 1rem;\n  color: #aaa;\n}\n.react-select__indicator-separator {\n  display: none;\n}\n.dz-handle {\n  display: inline-block;\n  width: 10px;\n  height: 5px;\n  vertical-align: middle;\n  margin-right: 10px;\n  border-top: 1px solid #979797;\n  cursor: row-resize;\n  border-bottom: 1px solid #979797;\n}\n.mg-collative-img-size {\n  flex: 1 1 100%;\n  width: 100%;\n  font-weight: 400;\n  font-style: normal;\n  display: flex;\n  align-items: center;\n}\n.dz-buttons-above {\n  display: flex;\n  padding: 0;\n  left: 600px;\n  gap: 10px 0px;\n}\n.dz-container-above {\n  margin-top: 15px;\n  display: flex;\n  flex: 1 1 100%;\n  align-items: center;\n  align-content: center;\n  justify-content: space-between;\n}\n.dz-container-above button {\n  margin-right: 3px;\n}\n.dz-actions label.checkcontainer span.checkmark {\n  width: 34px;\n  height: 35px;\n}\n.dz-actions label.checkcontainer span.checkmark svg {\n  width: 31px;\n  height: 31px;\n}\n.dropzoneinput {\n  display: flex;\n  margin-bottom: 5px;\n}\n.dropzoneinput .filehead {\n  width: 0;\n  height: 1.1rem;\n  background-color: #FC495D;\n  border-radius: 4px;\n  font-size: 1.1rem;\n  padding: 0;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  z-index: 3;\n  white-space: nowrap;\n  transition: background-color 2.5s ease, width 0.5s ease;\n}\n.dropzoneinput .dropzone {\n  display: flex;\n  flex: 1 1 100%;\n}\n.dropzoneinput .dropzone.mini-dropzone {\n  order: 2;\n  position: relative;\n}\n.dropzoneinput .dropzone.mini-dropzone .btn {\n  padding: 6px 15px;\n}\n.dropzoneinput .dropzone.mini-dropzone .btn input {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.dropzoneinput .dropzone.mini-dropzone .btn svg {\n  height: 24px;\n}\n.dropzoneinput .dropzone.mini-dropzone .dz-dropper {\n  min-height: 0;\n  height: auto;\n  width: auto;\n  border: none;\n  justify-content: flex-start;\n}\n.dropzoneinput .dropzone.mini-dropzone .dz-dropper.dz-dropper--isActive {\n  flex: 1 1 100%;\n}\n.dropzoneinput .dropzone .dz-dropper {\n  width: 100%;\n  border: 1px dashed #E5EBF1;\n  min-height: 250px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.dropzoneinput .dropzone .dz-message {\n  text-align: center;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 20px 0;\n}\n.dropzoneinput .dropzone .dz-message > p {\n  flex: 0 0 100%;\n}\n.dropzoneinput .dropzone .dz-message svg {\n  height: 36px;\n}\n.dropzoneinput .dropzone .dz-message .dz-icons {\n  flex: 0 0 100%;\n}\n.dropzoneinput .dropzone .btn {\n  padding: 8px 12px;\n}\n.dropzoneinput .dropzone p {\n  color: #92A7C0;\n  font-size: 1.1rem;\n  font-weight: normal;\n  text-align: center;\n  margin: 0;\n  display: none;\n}\n@media screen and (min-width: 799px) {\n  .dropzoneinput .dropzone p {\n    display: block;\n  }\n}\n.dropzoneinput .dz-list {\n  display: flex;\n  flex-wrap: wrap;\n  min-width: calc(100% + 30px);\n  justify-content: flex-start;\n  align-items: flex-start;\n  justify-content: space-around;\n  margin-left: -15px;\n  margin-right: -15px;\n}\n.dropzoneinput .dz-list * {\n  touch-action: none;\n}\n.dropzoneinput .dz-list.mini-items {\n  display: flex;\n  gap: 10px;\n  order: 1;\n  margin-left: 0;\n  margin-right: 0;\n  min-width: 0;\n}\n.dropzoneinput .dz-list.mini-items .formlabel {\n  flex: 0 0 100%;\n}\n.dropzoneinput .dz-list.mini-items .dz-item {\n  height: 72px;\n  min-width: 72px;\n  flex: 0 0 auto;\n  margin: 0 0 45px;\n}\n.dropzoneinput .dz-list.mini-items .dz-item .dz-actions {\n  display: flex;\n  flex: 0 0 72px;\n  max-height: 30px;\n  justify-content: center;\n}\n.dropzoneinput .dz-list.mini-items .dz-item button.btn.btn-none {\n  margin: 0 3px;\n}\n.dropzoneinput .dz-list.mini-items .dz-item button.btn.btn-none svg {\n  fill: #333333;\n}\n.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb {\n  height: 72px;\n  max-height: 72px;\n}\n.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb:hover {\n  cursor: default;\n}\n.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb:hover[style] {\n  cursor: move;\n}\n.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb .dz-thumb-img {\n  height: 72px;\n}\n.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb .dz-thumb-img img {\n  height: auto;\n  max-height: 100%;\n  max-width: 100%;\n}\n.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb .dz-thumb-img.icon {\n  width: 100%;\n  border: 1px solid #cfcdcd;\n  border-radius: 3px;\n  background: #ffffff;\n}\n.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb .dz-thumb-img.icon svg {\n  width: 54px;\n  height: 54px;\n}\n.dropzoneinput .dz-list.mini-items .dz-item .dz-thumb-caption {\n  position: relative;\n  align-self: flex-end;\n  padding: 4px 6px;\n  font-size: 0.8rem;\n  white-space: nowrap;\n}\n.dropzoneinput.dropzone-single .dz-list {\n  justify-content: center;\n}\n.dropzoneinput .table-wrapper {\n  width: 100%;\n  max-width: calc(100vw - 80px);\n  overflow: auto;\n}\n.dropzoneinput .dz-file-list {\n  width: 100%;\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n.dropzoneinput .dz-file-list thead th {\n  color: #333333;\n  white-space: nowrap;\n  padding: 10px;\n}\n.dropzoneinput .dz-file-item {\n  flex: 0 1 100%;\n  min-height: 44px;\n  align-items: center;\n  border-top: 1px solid #d6d6d6;\n}\n.dropzoneinput tr.dz-file-item {\n  box-shadow: 0px 1px 0px #E5EBF1;\n}\n.dropzoneinput .dz-file-handle {\n  padding: 10px 0;\n  vertical-align: middle;\n  table-layout: fixed;\n}\n.dropzoneinput .dz-file-handle .dz-handle {\n  margin-top: -5px;\n}\n.dropzoneinput .dz-edit-file-name {\n  display: none;\n  min-height: 0;\n  padding: 0;\n}\n.dropzoneinput:hover .dz-edit-file-name {\n  display: inline-block;\n}\n.dropzoneinput:hover .dz-edit-file-name svg {\n  stroke-width: 2.4;\n  stroke: #92A7C0;\n}\n.dropzoneinput .dz-file-name {\n  padding: 10px 12px;\n  width: 100%;\n  vertical-align: middle;\n}\n.dropzoneinput .dz-file-name > div {\n  display: flex;\n  align-items: center;\n}\n.dropzoneinput .dz-file-name > div .btn {\n  margin-left: 10px;\n}\n.dropzoneinput .dz-file-size {\n  padding: 0 10px;\n  white-space: nowrap;\n}\n.dropzoneinput .dz-file-type {\n  flex: 0 0 30px;\n  padding: 0 10px;\n  text-align: center;\n}\n.dropzoneinput .dz-file-type svg {\n  height: 24px;\n}\n.dropzoneinput td.dz-file-actions,\n.dropzoneinput th.dz-file-actions {\n  white-space: nowrap;\n}\n.dropzoneinput td.dz-file-actions .btn-none,\n.dropzoneinput th.dz-file-actions .btn-none {\n  border: 0;\n  display: inline-flex;\n  padding: 7.5px;\n}\n.dropzoneinput .dz-item {\n  display: flex;\n  flex-direction: column;\n  flex: 0 0 100%;\n  max-width: calc(100vw - 82px);\n  margin: 15px;\n}\n@media screen and (min-width: 799px) {\n  .dropzoneinput .dz-item {\n    flex: 0 0 320px;\n    max-width: 320px;\n  }\n}\n.dropzoneinput .dz-item .loader.inline {\n  justify-self: center;\n  align-self: center;\n  z-index: auto;\n  border-width: 3px;\n  width: 30px;\n  height: 30px;\n}\n.dropzoneinput .dz-item .dz-thumb-caption {\n  position: absolute;\n  justify-content: center;\n  align-content: center;\n  background: rgba(0, 0, 0, 0.7);\n  color: #ffffff;\n  padding: 8px 12px;\n  display: flex;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.dropzoneinput .dz-item .dz-thumb-img-size {\n  position: absolute;\n  justify-content: center;\n  align-content: center;\n  background: #ffffff;\n  color: rgba(0, 0, 0, 0.7);\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 12px;\n  padding: 8px 12px;\n  display: flex;\n  border-radius: 18px;\n  right: 0;\n  margin: 7px;\n}\n.dropzoneinput .dz-item .dz-thumb {\n  flex: 1 1 100%;\n  height: 240px;\n  max-height: 240px;\n  display: flex;\n  position: relative;\n  justify-content: center;\n  align-items: center;\n  box-shadow: inset 0 0 480px -240px #92A7C0;\n}\n.dropzoneinput .dz-item .dz-thumb *::selection {\n  background: transparent;\n}\n.dropzoneinput .dz-item .dz-thumb:hover {\n  cursor: move;\n}\n.dropzoneinput .dz-item .dz-thumb.updating .dz-thumb-img img {\n  display: none;\n}\n.dropzoneinput .dz-item .dz-thumb .dz-thumb-img {\n  height: 240px;\n  flex: 1 1 100%;\n  padding: 0;\n  position: relative;\n  border-radius: 0;\n  margin: 0;\n  overflow: hidden;\n  border: 0;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n.dropzoneinput .dz-item .dz-thumb .dz-thumb-img img {\n  height: 240px;\n  width: 320px;\n  object-fit: cover;\n  flex: 1 1 100%;\n}\n.dropzoneinput .dz-item .dz-thumb .dz-thumb-img:after {\n  position: absolute;\n  content: \"\";\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n}\n.dropzoneinput .dz-item .dz-actions {\n  padding-top: 5px;\n  flex: 0 0 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 5px 5px;\n}\n@media screen and (min-width: 799px) {\n  .dropzoneinput .dz-item .dz-actions {\n    flex-wrap: nowrap;\n  }\n}\n.dropzoneinput .dz-item .dz-actions .rotate,\n.dropzoneinput .dz-item .dz-actions .delete {\n  padding-left: 0;\n  padding-right: 0;\n  min-width: 36px;\n  width: 36px;\n  height: 36px;\n  justify-content: center;\n}\n.dropzoneinput .dz-item .dz-actions .rotate svg,\n.dropzoneinput .dz-item .dz-actions .delete svg {\n  width: 16px;\n  height: 16px;\n  stroke: #10294D;\n  stroke-width: 2.4;\n}\n.dropzoneinput .dz-item .dz-actions .btn:not(.rotate):not(.delete) {\n  padding: 7.5px 15px;\n}\n.dropzoneinput .dz-item .dz-actions .dz-thumb-caption {\n  position: relative;\n  flex-wrap: wrap;\n  flex: 0 0 100%;\n  background: none;\n  padding: 0;\n  margin-top: -41px;\n  gap: 5px 5px;\n}\n.dropzoneinput .dz-item .dz-actions .dz-thumb-caption > div {\n  flex: 0 0 100%;\n  background: rgba(0, 0, 0, 0.7);\n  box-shadow: none !important;\n  border: 0 none !important;\n}\n.dropzoneinput .dz-item .dz-actions .dz-thumb-caption > div .flatpickr-wrapper {\n  display: flex;\n}\n.dropzoneinput .dz-item .dz-actions .dz-thumb-caption > div .flatpickr-wrapper svg {\n  stroke: #ffffff;\n}\n.dropzoneinput .dz-item .dz-actions .dz-thumb-caption > div input {\n  background: none;\n  text-align: center;\n  border: none;\n  color: #ffffff;\n  min-height: 36px;\n  width: 100%;\n  padding: 0;\n}\n.dropzoneinput .dz-item .dz-actions .dz-thumb-caption > div .btn:not(.rotate):not(.delete) {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.dropzoneinput .dz-thumb-img-dims {\n  margin: 10px 0;\n  display: block;\n  text-align: center;\n}\n.cardbody .form-group.uploadinput {\n  align-items: start;\n}\n.serviced-location-lookup .forminput {\n  padding: 10px;\n}\n.serviced-location-lookup .forminput .btn {\n  padding: 10px;\n}\n.uploadinput .img-container {\n  width: 200px;\n}\n.uploadinput .img-container img {\n  width: 100%;\n  border: none;\n  display: block;\n  border-radius: 4px;\n}\n.uploadinput .img-container .img-placeholder {\n  height: 300px;\n  width: 200px;\n  border-radius: 4px;\n  background-color: #F3F5F8;\n  display: flex;\n  align-items: center;\n}\n.uploadinput .img-container .img-placeholder .inline {\n  margin: 0 auto;\n}\n.uploadwrap {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n}\n.uploadwrap .imagecropbtn {\n  margin-top: 10px;\n}\n.uploadwrap .imagecropbtn input:hover {\n  cursor: pointer;\n}\n.uploadwrap .inlineload {\n  position: relative;\n  min-height: 3.4rem;\n  line-height: 3.4rem;\n  vertical-align: middle;\n}\n.uploadwrap .inlineload a {\n  display: inline-block;\n  padding-left: 10px;\n  position: absolute;\n  z-index: 4;\n}\n.uploadwrap .inlineloaded {\n  width: 0%;\n}\n.ReactCrop__image {\n  max-height: none;\n}\n.recordselector-heading {\n  margin-top: 27px;\n}\ninput[type=\"file\"] {\n  position: absolute;\n  left: 0;\n  top: 9px;\n  opacity: 0;\n  height: 3rem;\n  width: 100px;\n}\ninput[type=\"file\"]:hover {\n  cursor: pointer;\n}\n@keyframes fpFadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n.flatpickr-calendar {\n  background: transparent;\n  opacity: 0;\n  display: none;\n  text-align: center;\n  visibility: hidden;\n  padding: 0;\n  -webkit-animation: none;\n  animation: none;\n  direction: ltr;\n  border: 0;\n  font-size: 14px;\n  line-height: 24px;\n  border-radius: 5px;\n  position: absolute;\n  width: 307.875px;\n  box-sizing: border-box;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  background: #fff;\n  -webkit-box-shadow: 1px 0 0 #e6e6e6, -1px 0 0 #e6e6e6, 0 1px 0 #e6e6e6, 0 -1px 0 #e6e6e6, 0 3px 13px rgba(0, 0, 0, 0.08);\n  box-shadow: 1px 0 0 #e6e6e6, -1px 0 0 #e6e6e6, 0 1px 0 #e6e6e6, 0 -1px 0 #e6e6e6, 0 3px 13px rgba(0, 0, 0, 0.08);\n}\n.flatpickr-calendar .hasWeeks .dayContainer {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n  border-left: 0;\n}\n.flatpickr-calendar .hasTime .dayContainer {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.flatpickr-calendar:before {\n  position: absolute;\n  display: block;\n  pointer-events: none;\n  border: solid transparent;\n  content: \"\";\n  height: 0;\n  width: 0;\n  left: 22px;\n  border-width: 5px;\n  margin: 0 -5px;\n}\n.flatpickr-calendar:after {\n  position: absolute;\n  display: block;\n  pointer-events: none;\n  border: solid transparent;\n  content: \"\";\n  height: 0;\n  width: 0;\n  left: 22px;\n  border-width: 4px;\n  margin: 0 -4px;\n}\n.flatpickr-calendar:focus {\n  outline: 0;\n}\n.flatpickr-calendar.open {\n  opacity: 1;\n  max-height: 640px;\n  visibility: visible;\n  display: inline-block;\n  z-index: 99999;\n}\n.flatpickr-calendar.inline {\n  opacity: 1;\n  max-height: 640px;\n  visibility: visible;\n  display: block;\n  position: relative;\n  top: 2px;\n}\n.flatpickr-calendar.animate.open {\n  -webkit-animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\n  animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n.flatpickr-calendar.static {\n  position: absolute;\n  top: calc(100% + 2px);\n}\n.flatpickr-calendar.static.open {\n  z-index: 999;\n  display: block;\n}\n.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n + 1) .flatpickr-day.inRange:nth-child(7n + 7) {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n + 2) .flatpickr-day.inRange:nth-child(7n + 1) {\n  -webkit-box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n  box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n}\n.flatpickr-calendar.showTimeInput.hasTime .flatpickr-time {\n  height: 40px;\n  border-top: 1px solid #e6e6e6;\n}\n.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {\n  height: auto;\n}\n.flatpickr-calendar.rightMost:before {\n  left: auto;\n  right: 22px;\n}\n.flatpickr-calendar.rightMost:after {\n  left: auto;\n  right: 22px;\n}\n.flatpickr-calendar.arrowTop:before {\n  bottom: 100%;\n  border: 0 none;\n}\n.flatpickr-calendar.arrowTop:after {\n  bottom: 100%;\n  border: 0 none;\n}\n.flatpickr-calendar.arrowBottom:before {\n  top: 100%;\n  border: 0 none;\n}\n.flatpickr-calendar.arrowBottom:after {\n  top: 100%;\n  border: 0 none;\n}\n.flatpickr-wrapper {\n  position: unset;\n  display: inline-block;\n  flex: 1 1;\n}\n.dateinput {\n  text-decoration: none;\n}\n.dateinput .form-control.hidden {\n  width: 1px;\n  height: 1px;\n  margin: 0;\n  padding: 0;\n  position: absolute;\n  pointer-events: none;\n  opacity: 0;\n}\n.dateinput .input-group-addon.btn {\n  margin-left: 0;\n}\n.dateinput .flatpickr-inputwrap {\n  display: flex;\n  flex: 1 1 100%;\n  flex-wrap: nowrap;\n  border: 1px solid #cfcdcd;\n  border-radius: 3px;\n}\n.dateinput .flatpickr-inputwrap input {\n  flex: 1 1 100%;\n  border: 0;\n}\n.dateinput .flatpickr-inputwrap button svg {\n  height: 20px;\n  fill: #cccccc;\n}\n.dateinput .flatpickr-inputwrap button:hover svg {\n  fill: hsl(0, 0%, 60%);\n}\n.flatpickr-months {\n  display: flex;\n}\n.flatpickr-months .flatpickr-month {\n  background: #ffffff;\n  color: #70859E;\n  fill: #70859E;\n  height: 28px;\n  line-height: 1;\n  text-align: center;\n  position: relative;\n  user-select: none;\n  flex: 1;\n}\n.flatpickr-months .flatpickr-month .flatpickr-current-month select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  text-overflow: '';\n}\n.flatpickr-months .flatpickr-month .flatpickr-current-month select::-ms-expand {\n  display: none;\n}\n.flatpickr-months .flatpickr-prev-month,\n.flatpickr-months .flatpickr-next-month {\n  text-decoration: none;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  line-height: 16px;\n  height: 28px;\n  padding: 10px;\n  z-index: 3;\n  color: #70859E;\n  fill: #70859E;\n}\n.flatpickr-months .flatpickr-prev-month i,\n.flatpickr-months .flatpickr-next-month i {\n  position: relative;\n}\n.flatpickr-months .flatpickr-prev-month:hover,\n.flatpickr-months .flatpickr-next-month:hover {\n  color: #ffffff;\n}\n.flatpickr-months .flatpickr-prev-month:hover svg,\n.flatpickr-months .flatpickr-next-month:hover svg {\n  fill: #ffffff;\n}\n.flatpickr-months .flatpickr-prev-month svg,\n.flatpickr-months .flatpickr-next-month svg {\n  width: 14px;\n  height: 14px;\n}\n.flatpickr-months .flatpickr-prev-month svg path,\n.flatpickr-months .flatpickr-next-month svg path {\n  -webkit-transition: fill 0.1s;\n  transition: fill 0.1s;\n  fill: #70859E;\n}\n.flatpickr-months .flatpickr-prev-month.disabled {\n  display: none;\n}\n.flatpickr-months .flatpickr-next-month.disabled {\n  display: none;\n}\n.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month {\n  left: 0;\n}\n.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {\n  left: 0;\n}\n.flatpickr-months .flatpickr-prev-month.flatpickr-next-month {\n  right: 0;\n}\n.flatpickr-months .flatpickr-next-month.flatpickr-next-month {\n  right: 0;\n}\n.numInputWrapper {\n  position: relative;\n  height: auto;\n}\n.numInputWrapper input {\n  display: inline-block;\n  width: 100%;\n}\n.numInputWrapper input::-ms-clear {\n  display: none;\n}\n.numInputWrapper span {\n  display: inline-block;\n  position: absolute;\n  right: 0;\n  width: 14px;\n  padding: 0 4px 0 2px;\n  height: 50%;\n  line-height: 50%;\n  opacity: 0;\n  cursor: pointer;\n  border: 1px solid rgba(57, 57, 57, 0.15);\n  box-sizing: border-box;\n}\n.numInputWrapper span:hover {\n  background: rgba(0, 0, 0, 0.1);\n}\n.numInputWrapper span:active {\n  background: rgba(0, 0, 0, 0.2);\n}\n.numInputWrapper span:after {\n  display: block;\n  content: \"\";\n  position: absolute;\n}\n.numInputWrapper span svg {\n  width: inherit;\n  height: auto;\n}\n.numInputWrapper span svg path {\n  fill: rgba(0, 0, 0, 0.5);\n}\n.numInputWrapper span.arrowUp {\n  top: 0;\n  border-bottom: 0;\n}\n.numInputWrapper span.arrowUp:after {\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-bottom: 4px solid rgba(57, 57, 57, 0.6);\n  top: 26%;\n}\n.numInputWrapper span.arrowDown {\n  top: 50%;\n}\n.numInputWrapper span.arrowDown:after {\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid rgba(57, 57, 57, 0.6);\n  top: 40%;\n}\n.numInputWrapper:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n.numInputWrapper:hover span {\n  opacity: 1;\n}\n.flatpickr-current-month {\n  font-size: 135%;\n  line-height: inherit;\n  color: inherit;\n  position: absolute;\n  width: 75%;\n  left: 12.5%;\n  padding: 6.16px 0 0 0;\n  line-height: 1;\n  height: 28px;\n  display: inline-block;\n  text-align: center;\n  transform: translate3d(0, 0, 0);\n}\n.flatpickr-current-month span.cur-month {\n  font-family: inherit;\n  font-weight: bold;\n  color: inherit;\n  display: inline-block;\n  margin-left: 0.5ch;\n  padding: 0;\n}\n.flatpickr-current-month span.cur-month:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n.flatpickr-current-month .numInputWrapper {\n  width: 6ch;\n  width: 7ch\\0;\n  display: inline-block;\n}\n.flatpickr-current-month .numInputWrapper span.arrowUp:after {\n  border-bottom-color: rgba(0, 0, 0, 0.9);\n}\n.flatpickr-current-month .numInputWrapper span.arrowDown:after {\n  border-top-color: rgba(0, 0, 0, 0.9);\n}\n.flatpickr-current-month input.cur-year {\n  background: transparent;\n  box-sizing: border-box;\n  color: inherit;\n  cursor: text;\n  padding: 0 0 0 0.5ch;\n  margin: 0;\n  display: inline-block;\n  font-size: inherit;\n  font-family: inherit;\n  line-height: inherit;\n  height: auto;\n  border: 0;\n  border-radius: 0;\n  vertical-align: initial;\n}\n.flatpickr-current-month input.cur-year:focus {\n  outline: 0;\n}\n.flatpickr-current-month input.cur-year[disabled] {\n  font-size: 100%;\n  color: rgba(0, 0, 0, 0.5);\n  background: transparent;\n  pointer-events: none;\n}\n.flatpickr-current-month input.cur-year[disabled]:hover {\n  font-size: 100%;\n  color: rgba(0, 0, 0, 0.5);\n  background: transparent;\n  pointer-events: none;\n}\n.flatpickr-weekdays {\n  background: #ffffff;\n  text-align: center;\n  overflow: hidden;\n  width: 100%;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 28px;\n}\n.flatpickr-weekdays .flatpickr-weekdaycontainer {\n  display: flex;\n  flex: 1;\n}\nspan.flatpickr-weekday {\n  cursor: default;\n  font-size: 11px;\n  background: transparent;\n  color: #B2C2D4;\n  line-height: 1;\n  margin: 0;\n  text-align: center;\n  display: block;\n  flex: 1;\n  font-weight: bolder;\n}\n.dayContainer {\n  padding: 1px 0 0 0;\n  padding: 0;\n  outline: 0;\n  text-align: left;\n  width: 307.875px;\n  min-width: 307.875px;\n  max-width: 307.875px;\n  box-sizing: border-box;\n  display: inline-block;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  transform: translate3d(0, 0, 0);\n  opacity: 1;\n}\n.dayContainer .dayContainer {\n  -webkit-box-shadow: -1px 0 0 #e6e6e6;\n  box-shadow: -1px 0 0 #e6e6e6;\n}\n.flatpickr-weeks {\n  padding: 1px 0 0 0;\n}\n.flatpickr-days {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-start;\n  width: 307.875px;\n  border: 0;\n}\n.flatpickr-days:focus {\n  outline: 0;\n}\n.flatpickr-day {\n  background: none;\n  border-radius: 0;\n  border: 0 none;\n  font-size: 12px;\n  box-sizing: border-box;\n  color: #5A6F89;\n  cursor: pointer;\n  width: 14.2857143%;\n  flex-basis: 14.2857143%;\n  max-width: 39px;\n  height: 39px;\n  line-height: 39px;\n  margin: 0;\n  display: flex;\n  position: relative;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n.flatpickr-day:hover {\n  cursor: pointer;\n  outline: 0;\n  font-weight: bold;\n  background: #ffffff;\n}\n.flatpickr-day:focus {\n  cursor: pointer;\n  outline: 0;\n  background: #ffffff;\n}\n.flatpickr-day.inRange {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n  border-radius: 0;\n  -webkit-box-shadow: -5px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n  box-shadow: -5px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n}\n.flatpickr-day.prevMonthDay.inRange {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n.flatpickr-day.nextMonthDay.inRange {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n.flatpickr-day.today.inRange {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n.flatpickr-day.prevMonthDay.today.inRange {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n.flatpickr-day.nextMonthDay.today.inRange {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n.flatpickr-day.prevMonthDay {\n  color: rgba(57, 57, 57, 0.3);\n  background: transparent;\n  border-color: transparent;\n  cursor: default;\n}\n.flatpickr-day.prevMonthDay:hover {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n.flatpickr-day.prevMonthDay:focus {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n.flatpickr-day.nextMonthDay {\n  color: rgba(57, 57, 57, 0.3);\n  background: transparent;\n  border-color: transparent;\n  cursor: default;\n}\n.flatpickr-day.nextMonthDay:hover {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n.flatpickr-day.nextMonthDay:focus {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n.flatpickr-day.today {\n  color: #3699FE;\n}\n.flatpickr-day.today:hover {\n  background: #ffffff;\n  color: #3699FE;\n}\n.flatpickr-day.today:focus {\n  background: #ffffff;\n  color: #3699FE;\n}\n.flatpickr-day.selected {\n  background: #F3F5F8;\n  box-shadow: none;\n  color: #10294D;\n  font-weight: bold;\n  border-radius: 50%;\n}\n.flatpickr-day.selected:focus {\n  color: #10294D;\n  background: #ffffff;\n  box-shadow: none;\n}\n.flatpickr-day.selected:hover {\n  color: #10294D;\n  background: #ffffff;\n  box-shadow: none;\n}\n.flatpickr-day.startRange {\n  background: #FC495D;\n  box-shadow: none;\n  color: #fff;\n  border-color: #FC495D;\n}\n.flatpickr-day.startRange:focus {\n  background: #FC495D;\n  box-shadow: none;\n  color: #fff;\n  border-color: #FC495D;\n}\n.flatpickr-day.startRange:hover {\n  background: #FC495D;\n  box-shadow: none;\n  color: #fff;\n  border-color: #FC495D;\n}\n.flatpickr-day.endRange {\n  background: #FC495D;\n  box-shadow: none;\n  color: #fff;\n  border-color: #FC495D;\n}\n.flatpickr-day.endRange:focus {\n  background: #FC495D;\n  box-shadow: none;\n  color: #fff;\n  border-color: #FC495D;\n}\n.flatpickr-day.endRange:hover {\n  background: #FC495D;\n  box-shadow: none;\n  color: #fff;\n  border-color: #FC495D;\n}\n.flatpickr-day.selected.inRange {\n  background: #FC495D;\n  box-shadow: none;\n  color: #fff;\n  border-color: #FC495D;\n}\n.flatpickr-day.startRange.inRange {\n  background: #FC495D;\n  box-shadow: none;\n  color: #fff;\n  border-color: #FC495D;\n}\n.flatpickr-day.endRange.inRange {\n  background: #FC495D;\n  box-shadow: none;\n  color: #fff;\n  border-color: #FC495D;\n}\n.flatpickr-day.selected.prevMonthDay,\n.flatpickr-day.selected.nextMonthDay {\n  background: #ffffff;\n  box-shadow: none;\n  color: #10294D;\n  border: 0 none;\n}\n.flatpickr-day.selected.prevMonthDay:hover,\n.flatpickr-day.selected.nextMonthDay:hover {\n  color: #10294D;\n}\n.flatpickr-day.startRange.prevMonthDay {\n  background: #FC495D;\n  box-shadow: none;\n  color: #fff;\n  border-color: #FC495D;\n}\n.flatpickr-day.endRange.prevMonthDay {\n  background: #FC495D;\n  box-shadow: none;\n  color: #fff;\n  border-color: #FC495D;\n}\n.flatpickr-day.startRange.nextMonthDay {\n  background: #FC495D;\n  box-shadow: none;\n  color: #fff;\n  border-color: #FC495D;\n}\n.flatpickr-day.endRange.nextMonthDay {\n  background: #FC495D;\n  box-shadow: none;\n  color: #fff;\n  border-color: #FC495D;\n}\n.flatpickr-day.selected.startRange {\n  border-radius: 50px 0 0 50px;\n}\n.flatpickr-day.selected.startRange .endRange:not(:nth-child(7n + 1)) {\n  box-shadow: -10px 0 0 #FC495D;\n}\n.flatpickr-day.startRange.startRange {\n  border-radius: 50px 0 0 50px;\n}\n.flatpickr-day.startRange.startRange .endRange:not(:nth-child(7n + 1)) {\n  box-shadow: -10px 0 0 #FC495D;\n}\n.flatpickr-day.endRange.startRange {\n  border-radius: 50px 0 0 50px;\n}\n.flatpickr-day.endRange.startRange .endRange:not(:nth-child(7n + 1)) {\n  box-shadow: -10px 0 0 #FC495D;\n}\n.flatpickr-day.selected.endRange {\n  border-radius: 0 50px 50px 0;\n}\n.flatpickr-day.startRange.endRange {\n  border-radius: 0 50px 50px 0;\n}\n.flatpickr-day.endRange.endRange {\n  border-radius: 0 50px 50px 0;\n}\n.flatpickr-day.selected.startRange.endRange {\n  border-radius: 50px;\n}\n.flatpickr-day.startRange.startRange.endRange {\n  border-radius: 50px;\n}\n.flatpickr-day.endRange.startRange.endRange {\n  border-radius: 50px;\n}\n.flatpickr-day.disabled,\n.flatpickr-day.flatpickr-disabled,\n.flatpickr-day.notAllowed,\n.flatpickr-day.prevMonthDay,\n.flatpickr-day.nextMonthDay {\n  color: #B2C2D4;\n  background: transparent;\n  border-color: transparent;\n}\n.flatpickr-day.disabled:hover,\n.flatpickr-day.flatpickr-disabled:hover,\n.flatpickr-day.notAllowed:hover,\n.flatpickr-day.prevMonthDay:hover,\n.flatpickr-day.nextMonthDay:hover {\n  background: transparent;\n  border-color: transparent;\n  color: #B2C2D4;\n}\n.flatpickr-day.disabled,\n.flatpickr-day.flatpickr-disabled,\n.flatpickr-day.notAllowed,\n.flatpickr-day.prevMonthDay.flatpickr-disabled,\n.flatpickr-day.nextMonthDay.flatpickr-disabled {\n  color: #CED7E2;\n  cursor: not-allowed;\n}\n.flatpickr-day.disabled:hover,\n.flatpickr-day.flatpickr-disabled:hover,\n.flatpickr-day.notAllowed:hover,\n.flatpickr-day.prevMonthDay.flatpickr-disabled:hover,\n.flatpickr-day.nextMonthDay.flatpickr-disabled:hover {\n  cursor: not-allowed;\n  font-weight: 400;\n  color: #CED7E2;\n}\n.flatpickr-day.week.selected {\n  border-radius: 0;\n  -webkit-box-shadow: -5px 0 0 #FC495D, 5px 0 0 #FC495D;\n  box-shadow: -5px 0 0 #FC495D, 5px 0 0 #FC495D;\n}\n.flatpickr-day.hidden {\n  visibility: hidden;\n}\n.rangeMode .flatpickr-day {\n  margin-top: 1px;\n}\n.flatpickr-weekwrapper {\n  display: inline-block;\n}\n.flatpickr-weekwrapper .flatpickr-weeks {\n  padding: 0 12px;\n  -webkit-box-shadow: 1px 0 0 #e6e6e6;\n  box-shadow: 1px 0 0 #e6e6e6;\n}\n.flatpickr-weekwrapper .flatpickr-weekday {\n  float: none;\n  width: 100%;\n  line-height: 28px;\n}\n.flatpickr-weekwrapper span.flatpickr-day {\n  display: block;\n  width: 100%;\n  max-width: none;\n  color: rgba(57, 57, 57, 0.3);\n  background: transparent;\n  cursor: default;\n  border: none;\n}\n.flatpickr-weekwrapper span.flatpickr-day:hover {\n  display: block;\n  width: 100%;\n  max-width: none;\n  color: rgba(57, 57, 57, 0.3);\n  background: transparent;\n  cursor: default;\n  border: none;\n}\n.flatpickr-innerContainer {\n  display: block;\n  display: flex;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n.flatpickr-rContainer {\n  display: inline-block;\n  padding: 0;\n  box-sizing: border-box;\n}\n.flatpickr-time {\n  text-align: center;\n  outline: 0;\n  display: block;\n  height: 0;\n  line-height: 40px;\n  max-height: 40px;\n  box-sizing: border-box;\n  overflow: hidden;\n  display: flex;\n}\n.flatpickr-time:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.flatpickr-time .numInputWrapper {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  width: 40%;\n  height: 40px;\n  float: left;\n}\n.flatpickr-time .numInputWrapper span.arrowUp:after {\n  border-bottom-color: #393939;\n}\n.flatpickr-time .numInputWrapper span.arrowDown:after {\n  border-top-color: #393939;\n}\n.flatpickr-time input {\n  background: transparent;\n  box-shadow: none;\n  border: 0;\n  border-radius: 0;\n  text-align: center;\n  margin: 0;\n  padding: 0;\n  height: inherit;\n  line-height: inherit;\n  color: #393939;\n  font-size: 14px;\n  position: relative;\n  box-sizing: border-box;\n}\n.flatpickr-time input:focus {\n  outline: 0;\n  border: 0;\n  background: #f3f3f3;\n}\n.flatpickr-time input:hover {\n  background: #f3f3f3;\n}\n.flatpickr-time input.flatpickr-hour {\n  font-weight: bold;\n}\n.flatpickr-time input.flatpickr-minute {\n  font-weight: 400;\n}\n.flatpickr-time input.flatpickr-second {\n  font-weight: 400;\n}\n.flatpickr-time .flatpickr-time-separator {\n  height: inherit;\n  display: inline-block;\n  line-height: inherit;\n  color: #393939;\n  font-weight: bold;\n  width: 2%;\n  user-select: none;\n  align-self: center;\n}\n.flatpickr-time .flatpickr-am-pm {\n  height: inherit;\n  display: inline-block;\n  line-height: inherit;\n  color: #393939;\n  font-weight: bold;\n  width: 2%;\n  user-select: none;\n  align-self: center;\n  outline: 0;\n  width: 18%;\n  cursor: pointer;\n  text-align: center;\n  font-weight: 400;\n}\n.flatpickr-time .flatpickr-am-pm:hover {\n  background: #f3f3f3;\n}\n.flatpickr-time .flatpickr-am-pm:focus {\n  background: #f3f3f3;\n}\n.flatpickr-time.hasSeconds .numInputWrapper {\n  width: 26%;\n}\n.flatpickr-time.time24hr .numInputWrapper {\n  width: 49%;\n}\n.flatpickr-input[readonly] {\n  cursor: pointer;\n  background-color: #ffffff;\n}\n.flatpickr-calendar .flatpickr-monthDropdown-months,\n.flatpickr-calendar .flatpickr-current-month input.cur-year {\n  background: none;\n  font-size: 1.2rem;\n  font-weight: 600;\n  -webkit-appearance: textfield;\n}\n.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {\n  background: #ffffff;\n  padding: 0;\n}\n.flatpickr-calendar span.flatpickr-weekday {\n  font-weight: 600;\n}\n.flatpickr-calendar .flatpickr-day {\n  line-height: 36px;\n  height: 40px;\n  max-width: 40px;\n}\n.tip {\n  min-height: 36px;\n  flex: 1 1 100%;\n  display: flex;\n  align-items: center;\n  color: #70859E;\n  vertical-align: center;\n  border-radius: 4px;\n  background: #EFFBFD;\n}\n.tip .tip-content {\n  padding: 6px 10px;\n}\n.tip.hot {\n  background: #FFEEEF;\n  color: #FF6464;\n}\n.tip.alert {\n  background: #FEF6EF;\n  color: #70859E;\n}\n.tip.fix-width {\n  min-width: 100%;\n}\n.tip.tip-input {\n  margin: 0 !important;\n}\n.tip .tipheading {\n  font-weight: 600;\n  padding-right: 10px;\n  white-space: nowrap;\n}\n.tip.multi,\n.input-group .field .tip.multi {\n  margin-top: -10px;\n}\n.tip.multi .tipheading.multi,\n.input-group .field .tip.multi .tipheading.multi {\n  flex: 0 0 100%;\n}\n.tip.multi .tiptext.multi,\n.input-group .field .tip.multi .tiptext.multi {\n  flex: 0 0 100%;\n}\n.colorpicker .color-swatch {\n  width: 36px;\n  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n}\n.colorpicker .formlabel {\n  left: 37px;\n}\n.colorpicker .input-group-addon {\n  border-radius: 4px 0 0 4px;\n}\n.colorpicker .input-group-addon ~ input.input-group-prefix {\n  padding-left: 8px;\n}\n.colorpicker .forminput {\n  position: relative;\n  flex: 1 1 auto !important;\n}\n.colorpicker .forminput input {\n  padding-left: 8px !important;\n}\n.colorpicker .picker_wrapper {\n  background: #ffffff;\n}\n.colorpicker .picker_editor {\n  flex: 1 1 auto;\n  border-radius: 4px 0 0 4px;\n  border: 1px solid #cfcdcd;\n  overflow: hidden;\n  margin-right: 0;\n  border-right: 0;\n}\n.colorpicker .picker_editor input {\n  border: none;\n  box-shadow: none;\n}\n.colorpicker .picker_alpha {\n  width: 100%;\n}\n.colorpicker .picker_sample {\n  flex: 0 0 36px;\n  margin-left: 0;\n  margin-right: 0;\n  box-shadow: none;\n  border: 1px solid #cfcdcd;\n}\n.colorpicker .picker_done {\n  margin-left: 0;\n}\n.colorpicker .picker_done button {\n  display: flex;\n  align-items: center;\n  padding: 6px 15px;\n  min-height: 36px;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  user-select: none;\n  border: 1px solid transparent;\n  transition: all 0.2s ease-in-out;\n  border-radius: 4px;\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  font-weight: 500;\n  box-shadow: none;\n  background: #F3F5F8;\n  color: #10294D;\n  border-radius: 0 4px 4px 0;\n}\n.colorpicker .picker_done button-small {\n  padding: 0 8px;\n  min-height: 26px;\n}\n.colorpicker .picker_done button svg {\n  fill: none;\n  transition: all 0.2s ease-in-out;\n}\n.colorpicker .picker_done button.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n}\n.colorpicker .picker_done button-primary {\n  background: #10294D;\n  border-color: transparent;\n  color: #ffffff;\n}\n.colorpicker .picker_done button-primary svg {\n  stroke: #ffffff;\n  fill: none;\n}\n.colorpicker .picker_done button-primary:not(.disabled).focus,\n.colorpicker .picker_done button-primary:not(.disabled):focus,\n.colorpicker .picker_done button-primary:not(.disabled):focus-visible {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #071B38;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.colorpicker .picker_done button-primary:not(.disabled).active,\n.colorpicker .picker_done button-primary:not(.disabled):active {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #071B38;\n}\n.colorpicker .picker_done button-primary:not(.disabled).active.focus,\n.colorpicker .picker_done button-primary:not(.disabled):active.focus,\n.colorpicker .picker_done button-primary:not(.disabled).active:focus,\n.colorpicker .picker_done button-primary:not(.disabled):active:focus,\n.colorpicker .picker_done button-primary:not(.disabled).active:focus-visible,\n.colorpicker .picker_done button-primary:not(.disabled):active:focus-visible {\n  background: #071B38;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.colorpicker .picker_done button-primary:not(.disabled).hover,\n.colorpicker .picker_done button-primary:not(.disabled):hover {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #071B38;\n}\n.colorpicker .picker_done button-primary:not(.disabled).hover.active,\n.colorpicker .picker_done button-primary:not(.disabled):hover.active,\n.colorpicker .picker_done button-primary:not(.disabled).hover:active,\n.colorpicker .picker_done button-primary:not(.disabled):hover:active {\n  border-color: transparent;\n  background: #071B38;\n}\n.colorpicker .picker_done button-primary:not(.disabled).hover.active.focus,\n.colorpicker .picker_done button-primary:not(.disabled):hover.active.focus,\n.colorpicker .picker_done button-primary:not(.disabled).hover:active.focus,\n.colorpicker .picker_done button-primary:not(.disabled):hover:active.focus,\n.colorpicker .picker_done button-primary:not(.disabled).hover.active:focus,\n.colorpicker .picker_done button-primary:not(.disabled):hover.active:focus,\n.colorpicker .picker_done button-primary:not(.disabled).hover:active:focus,\n.colorpicker .picker_done button-primary:not(.disabled):hover:active:focus,\n.colorpicker .picker_done button-primary:not(.disabled).hover.active:focus-visible,\n.colorpicker .picker_done button-primary:not(.disabled):hover.active:focus-visible,\n.colorpicker .picker_done button-primary:not(.disabled).hover:active:focus-visible,\n.colorpicker .picker_done button-primary:not(.disabled):hover:active:focus-visible {\n  background: #071B38;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.colorpicker .picker_done button-secondary {\n  background: #FC495D;\n  border-color: transparent;\n  color: #ffffff;\n}\n.colorpicker .picker_done button-secondary svg {\n  display: block;\n  stroke: #ffffff;\n  fill: none;\n}\n.colorpicker .picker_done button-secondary.focus,\n.colorpicker .picker_done button-secondary:focus,\n.colorpicker .picker_done button-secondary:focus-visible {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #E62D42;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FED1D6;\n}\n.colorpicker .picker_done button-secondary.active,\n.colorpicker .picker_done button-secondary:active {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #E62D42;\n}\n.colorpicker .picker_done button-secondary.active.focus,\n.colorpicker .picker_done button-secondary:active.focus,\n.colorpicker .picker_done button-secondary.active:focus,\n.colorpicker .picker_done button-secondary:active:focus,\n.colorpicker .picker_done button-secondary.active:focus-visible,\n.colorpicker .picker_done button-secondary:active:focus-visible {\n  background: #E62D42;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FED1D6;\n}\n.colorpicker .picker_done button-secondary.hover,\n.colorpicker .picker_done button-secondary:hover {\n  color: #ffffff;\n  border: 1px solid transparent;\n  background: #E62D42;\n}\n.colorpicker .picker_done button-secondary.hover.active,\n.colorpicker .picker_done button-secondary:hover.active,\n.colorpicker .picker_done button-secondary.hover:active,\n.colorpicker .picker_done button-secondary:hover:active {\n  border-color: transparent;\n  background: #E62D42;\n}\n.colorpicker .picker_done button-secondary.hover.active.focus,\n.colorpicker .picker_done button-secondary:hover.active.focus,\n.colorpicker .picker_done button-secondary.hover:active.focus,\n.colorpicker .picker_done button-secondary:hover:active.focus,\n.colorpicker .picker_done button-secondary.hover.active:focus,\n.colorpicker .picker_done button-secondary:hover.active:focus,\n.colorpicker .picker_done button-secondary.hover:active:focus,\n.colorpicker .picker_done button-secondary:hover:active:focus,\n.colorpicker .picker_done button-secondary.hover.active:focus-visible,\n.colorpicker .picker_done button-secondary:hover.active:focus-visible,\n.colorpicker .picker_done button-secondary.hover:active:focus-visible,\n.colorpicker .picker_done button-secondary:hover:active:focus-visible {\n  background: #E62D42;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FED1D6;\n}\n.colorpicker .picker_done button-round {\n  border-radius: 30px;\n}\n.colorpicker .picker_done button-red {\n  background: #FFEDEF;\n  color: #FC495D;\n}\n.colorpicker .picker_done button-red svg {\n  stroke: #FC495D;\n}\n.colorpicker .picker_done button-red.focus,\n.colorpicker .picker_done button-red:focus,\n.colorpicker .picker_done button-red:focus-visible {\n  color: #FC495D;\n  border: 1px solid transparent;\n  background: #FED1D6;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FFEDEF;\n}\n.colorpicker .picker_done button-red.active,\n.colorpicker .picker_done button-red:active {\n  color: #FC495D;\n  border: 1px solid transparent;\n  background: #FED1D6;\n}\n.colorpicker .picker_done button-red.active.focus,\n.colorpicker .picker_done button-red:active.focus,\n.colorpicker .picker_done button-red.active:focus,\n.colorpicker .picker_done button-red:active:focus,\n.colorpicker .picker_done button-red.active:focus-visible,\n.colorpicker .picker_done button-red:active:focus-visible {\n  background: #FED1D6;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FFEDEF;\n}\n.colorpicker .picker_done button-red.hover,\n.colorpicker .picker_done button-red:hover {\n  color: #FC495D;\n  border: 1px solid transparent;\n  background: #FED1D6;\n}\n.colorpicker .picker_done button-red.hover.active,\n.colorpicker .picker_done button-red:hover.active,\n.colorpicker .picker_done button-red.hover:active,\n.colorpicker .picker_done button-red:hover:active {\n  border-color: transparent;\n  background: #FED1D6;\n}\n.colorpicker .picker_done button-red.hover.active.focus,\n.colorpicker .picker_done button-red:hover.active.focus,\n.colorpicker .picker_done button-red.hover:active.focus,\n.colorpicker .picker_done button-red:hover:active.focus,\n.colorpicker .picker_done button-red.hover.active:focus,\n.colorpicker .picker_done button-red:hover.active:focus,\n.colorpicker .picker_done button-red.hover:active:focus,\n.colorpicker .picker_done button-red:hover:active:focus,\n.colorpicker .picker_done button-red.hover.active:focus-visible,\n.colorpicker .picker_done button-red:hover.active:focus-visible,\n.colorpicker .picker_done button-red.hover:active:focus-visible,\n.colorpicker .picker_done button-red:hover:active:focus-visible {\n  background: #FED1D6;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #FFEDEF;\n}\n.colorpicker .picker_done button-green {\n  background: #F0F9F1;\n  color: #73C677;\n}\n.colorpicker .picker_done button-green svg {\n  stroke: #73C677;\n}\n.colorpicker .picker_done button-green.focus,\n.colorpicker .picker_done button-green:focus,\n.colorpicker .picker_done button-green:focus-visible {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #DCF1DE;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #F0F9F1;\n}\n.colorpicker .picker_done button-green.active,\n.colorpicker .picker_done button-green:active {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #DCF1DE;\n}\n.colorpicker .picker_done button-green.active.focus,\n.colorpicker .picker_done button-green:active.focus,\n.colorpicker .picker_done button-green.active:focus,\n.colorpicker .picker_done button-green:active:focus,\n.colorpicker .picker_done button-green.active:focus-visible,\n.colorpicker .picker_done button-green:active:focus-visible {\n  background: #DCF1DE;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #F0F9F1;\n}\n.colorpicker .picker_done button-green.hover,\n.colorpicker .picker_done button-green:hover {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #DCF1DE;\n}\n.colorpicker .picker_done button-green.hover.active,\n.colorpicker .picker_done button-green:hover.active,\n.colorpicker .picker_done button-green.hover:active,\n.colorpicker .picker_done button-green:hover:active {\n  border-color: transparent;\n  background: #DCF1DE;\n}\n.colorpicker .picker_done button-green.hover.active.focus,\n.colorpicker .picker_done button-green:hover.active.focus,\n.colorpicker .picker_done button-green.hover:active.focus,\n.colorpicker .picker_done button-green:hover:active.focus,\n.colorpicker .picker_done button-green.hover.active:focus,\n.colorpicker .picker_done button-green:hover.active:focus,\n.colorpicker .picker_done button-green.hover:active:focus,\n.colorpicker .picker_done button-green:hover:active:focus,\n.colorpicker .picker_done button-green.hover.active:focus-visible,\n.colorpicker .picker_done button-green:hover.active:focus-visible,\n.colorpicker .picker_done button-green.hover:active:focus-visible,\n.colorpicker .picker_done button-green:hover:active:focus-visible {\n  background: #DCF1DE;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #F0F9F1;\n}\n.colorpicker .picker_done button-blue {\n  background: #EFFBFD;\n  color: #34BFDE;\n}\n.colorpicker .picker_done button-blue svg {\n  stroke: #73C677;\n}\n.colorpicker .picker_done button-blue.focus,\n.colorpicker .picker_done button-blue:focus,\n.colorpicker .picker_done button-blue:focus-visible {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #D7F4FA;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #EFFBFD;\n}\n.colorpicker .picker_done button-blue.active,\n.colorpicker .picker_done button-blue:active {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #D7F4FA;\n}\n.colorpicker .picker_done button-blue.active.focus,\n.colorpicker .picker_done button-blue:active.focus,\n.colorpicker .picker_done button-blue.active:focus,\n.colorpicker .picker_done button-blue:active:focus,\n.colorpicker .picker_done button-blue.active:focus-visible,\n.colorpicker .picker_done button-blue:active:focus-visible {\n  background: #D7F4FA;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #EFFBFD;\n}\n.colorpicker .picker_done button-blue.hover,\n.colorpicker .picker_done button-blue:hover {\n  color: #73C677;\n  border: 1px solid transparent;\n  background: #D7F4FA;\n}\n.colorpicker .picker_done button-blue.hover.active,\n.colorpicker .picker_done button-blue:hover.active,\n.colorpicker .picker_done button-blue.hover:active,\n.colorpicker .picker_done button-blue:hover:active {\n  border-color: transparent;\n  background: #D7F4FA;\n}\n.colorpicker .picker_done button-blue.hover.active.focus,\n.colorpicker .picker_done button-blue:hover.active.focus,\n.colorpicker .picker_done button-blue.hover:active.focus,\n.colorpicker .picker_done button-blue:hover:active.focus,\n.colorpicker .picker_done button-blue.hover.active:focus,\n.colorpicker .picker_done button-blue:hover.active:focus,\n.colorpicker .picker_done button-blue.hover:active:focus,\n.colorpicker .picker_done button-blue:hover:active:focus,\n.colorpicker .picker_done button-blue.hover.active:focus-visible,\n.colorpicker .picker_done button-blue:hover.active:focus-visible,\n.colorpicker .picker_done button-blue.hover:active:focus-visible,\n.colorpicker .picker_done button-blue:hover:active:focus-visible {\n  background: #D7F4FA;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #EFFBFD;\n}\n.colorpicker .picker_done button-none {\n  background: transparent;\n  color: #70859E;\n}\n.colorpicker .picker_done button-none svg {\n  stroke: #10294D;\n}\n.colorpicker .picker_done button-none.focus,\n.colorpicker .picker_done button-none:focus,\n.colorpicker .picker_done button-none:focus-visible {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.colorpicker .picker_done button-none.active,\n.colorpicker .picker_done button-none:active {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.colorpicker .picker_done button-none.active.focus,\n.colorpicker .picker_done button-none:active.focus,\n.colorpicker .picker_done button-none.active:focus,\n.colorpicker .picker_done button-none:active:focus,\n.colorpicker .picker_done button-none.active:focus-visible,\n.colorpicker .picker_done button-none:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.colorpicker .picker_done button-none.hover,\n.colorpicker .picker_done button-none:hover {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.colorpicker .picker_done button-none.hover.active,\n.colorpicker .picker_done button-none:hover.active,\n.colorpicker .picker_done button-none.hover:active,\n.colorpicker .picker_done button-none:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\n.colorpicker .picker_done button-none.hover.active.focus,\n.colorpicker .picker_done button-none:hover.active.focus,\n.colorpicker .picker_done button-none.hover:active.focus,\n.colorpicker .picker_done button-none:hover:active.focus,\n.colorpicker .picker_done button-none.hover.active:focus,\n.colorpicker .picker_done button-none:hover.active:focus,\n.colorpicker .picker_done button-none.hover:active:focus,\n.colorpicker .picker_done button-none:hover:active:focus,\n.colorpicker .picker_done button-none.hover.active:focus-visible,\n.colorpicker .picker_done button-none:hover.active:focus-visible,\n.colorpicker .picker_done button-none.hover:active:focus-visible,\n.colorpicker .picker_done button-none:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.colorpicker .picker_done button-none-red {\n  background: transparent;\n  color: #70859E;\n}\n.colorpicker .picker_done button-none-red svg {\n  stroke: #FC495D;\n}\n.colorpicker .picker_done button-none-red.focus,\n.colorpicker .picker_done button-none-red:focus,\n.colorpicker .picker_done button-none-red:focus-visible {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.colorpicker .picker_done button-none-red.active,\n.colorpicker .picker_done button-none-red:active {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.colorpicker .picker_done button-none-red.active.focus,\n.colorpicker .picker_done button-none-red:active.focus,\n.colorpicker .picker_done button-none-red.active:focus,\n.colorpicker .picker_done button-none-red:active:focus,\n.colorpicker .picker_done button-none-red.active:focus-visible,\n.colorpicker .picker_done button-none-red:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.colorpicker .picker_done button-none-red.hover,\n.colorpicker .picker_done button-none-red:hover {\n  color: #071B38;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.colorpicker .picker_done button-none-red.hover.active,\n.colorpicker .picker_done button-none-red:hover.active,\n.colorpicker .picker_done button-none-red.hover:active,\n.colorpicker .picker_done button-none-red:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\n.colorpicker .picker_done button-none-red.hover.active.focus,\n.colorpicker .picker_done button-none-red:hover.active.focus,\n.colorpicker .picker_done button-none-red.hover:active.focus,\n.colorpicker .picker_done button-none-red:hover:active.focus,\n.colorpicker .picker_done button-none-red.hover.active:focus,\n.colorpicker .picker_done button-none-red:hover.active:focus,\n.colorpicker .picker_done button-none-red.hover:active:focus,\n.colorpicker .picker_done button-none-red:hover:active:focus,\n.colorpicker .picker_done button-none-red.hover.active:focus-visible,\n.colorpicker .picker_done button-none-red:hover.active:focus-visible,\n.colorpicker .picker_done button-none-red.hover:active:focus-visible,\n.colorpicker .picker_done button-none-red:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.colorpicker .picker_done button-subtle {\n  background: transparent;\n  border: 1px solid #E5EBF1;\n  color: #10294D;\n}\n.colorpicker .picker_done button-subtle svg {\n  stroke: #10294D;\n}\n.colorpicker .picker_done button-subtle.focus,\n.colorpicker .picker_done button-subtle:focus,\n.colorpicker .picker_done button-subtle:focus-visible {\n  color: #071B38;\n  border: 1px solid #CED7E2;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.colorpicker .picker_done button-subtle.active,\n.colorpicker .picker_done button-subtle:active {\n  color: #071B38;\n  border: 1px solid #CED7E2;\n  background: transparent;\n}\n.colorpicker .picker_done button-subtle.active.focus,\n.colorpicker .picker_done button-subtle:active.focus,\n.colorpicker .picker_done button-subtle.active:focus,\n.colorpicker .picker_done button-subtle:active:focus,\n.colorpicker .picker_done button-subtle.active:focus-visible,\n.colorpicker .picker_done button-subtle:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.colorpicker .picker_done button-subtle.hover,\n.colorpicker .picker_done button-subtle:hover {\n  color: #071B38;\n  border: 1px solid #CED7E2;\n  background: transparent;\n}\n.colorpicker .picker_done button-subtle.hover.active,\n.colorpicker .picker_done button-subtle:hover.active,\n.colorpicker .picker_done button-subtle.hover:active,\n.colorpicker .picker_done button-subtle:hover:active {\n  border-color: #CED7E2;\n  background: transparent;\n}\n.colorpicker .picker_done button-subtle.hover.active.focus,\n.colorpicker .picker_done button-subtle:hover.active.focus,\n.colorpicker .picker_done button-subtle.hover:active.focus,\n.colorpicker .picker_done button-subtle:hover:active.focus,\n.colorpicker .picker_done button-subtle.hover.active:focus,\n.colorpicker .picker_done button-subtle:hover.active:focus,\n.colorpicker .picker_done button-subtle.hover:active:focus,\n.colorpicker .picker_done button-subtle:hover:active:focus,\n.colorpicker .picker_done button-subtle.hover.active:focus-visible,\n.colorpicker .picker_done button-subtle:hover.active:focus-visible,\n.colorpicker .picker_done button-subtle.hover:active:focus-visible,\n.colorpicker .picker_done button-subtle:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #E6EAED;\n}\n.colorpicker .picker_done button-text {\n  background: transparent;\n  color: #10294D;\n}\n.colorpicker .picker_done button-text svg {\n  stroke: #CED7E2;\n}\n.colorpicker .picker_done button-text.focus,\n.colorpicker .picker_done button-text:focus,\n.colorpicker .picker_done button-text:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.colorpicker .picker_done button-text.active,\n.colorpicker .picker_done button-text:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.colorpicker .picker_done button-text.active.focus,\n.colorpicker .picker_done button-text:active.focus,\n.colorpicker .picker_done button-text.active:focus,\n.colorpicker .picker_done button-text:active:focus,\n.colorpicker .picker_done button-text.active:focus-visible,\n.colorpicker .picker_done button-text:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.colorpicker .picker_done button-text.hover,\n.colorpicker .picker_done button-text:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.colorpicker .picker_done button-text.hover.active,\n.colorpicker .picker_done button-text:hover.active,\n.colorpicker .picker_done button-text.hover:active,\n.colorpicker .picker_done button-text:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\n.colorpicker .picker_done button-text.hover.active.focus,\n.colorpicker .picker_done button-text:hover.active.focus,\n.colorpicker .picker_done button-text.hover:active.focus,\n.colorpicker .picker_done button-text:hover:active.focus,\n.colorpicker .picker_done button-text.hover.active:focus,\n.colorpicker .picker_done button-text:hover.active:focus,\n.colorpicker .picker_done button-text.hover:active:focus,\n.colorpicker .picker_done button-text:hover:active:focus,\n.colorpicker .picker_done button-text.hover.active:focus-visible,\n.colorpicker .picker_done button-text:hover.active:focus-visible,\n.colorpicker .picker_done button-text.hover:active:focus-visible,\n.colorpicker .picker_done button-text:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.colorpicker .picker_done button-text-only {\n  padding: 0;\n  background: transparent;\n  color: #10294D;\n}\n.colorpicker .picker_done button-text-only svg {\n  stroke: #CED7E2;\n}\n.colorpicker .picker_done button-text-only.focus,\n.colorpicker .picker_done button-text-only:focus,\n.colorpicker .picker_done button-text-only:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.colorpicker .picker_done button-text-only.active,\n.colorpicker .picker_done button-text-only:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.colorpicker .picker_done button-text-only.active.focus,\n.colorpicker .picker_done button-text-only:active.focus,\n.colorpicker .picker_done button-text-only.active:focus,\n.colorpicker .picker_done button-text-only:active:focus,\n.colorpicker .picker_done button-text-only.active:focus-visible,\n.colorpicker .picker_done button-text-only:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.colorpicker .picker_done button-text-only.hover,\n.colorpicker .picker_done button-text-only:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: transparent;\n}\n.colorpicker .picker_done button-text-only.hover.active,\n.colorpicker .picker_done button-text-only:hover.active,\n.colorpicker .picker_done button-text-only.hover:active,\n.colorpicker .picker_done button-text-only:hover:active {\n  border-color: transparent;\n  background: transparent;\n}\n.colorpicker .picker_done button-text-only.hover.active.focus,\n.colorpicker .picker_done button-text-only:hover.active.focus,\n.colorpicker .picker_done button-text-only.hover:active.focus,\n.colorpicker .picker_done button-text-only:hover:active.focus,\n.colorpicker .picker_done button-text-only.hover.active:focus,\n.colorpicker .picker_done button-text-only:hover.active:focus,\n.colorpicker .picker_done button-text-only.hover:active:focus,\n.colorpicker .picker_done button-text-only:hover:active:focus,\n.colorpicker .picker_done button-text-only.hover.active:focus-visible,\n.colorpicker .picker_done button-text-only:hover.active:focus-visible,\n.colorpicker .picker_done button-text-only.hover:active:focus-visible,\n.colorpicker .picker_done button-text-only:hover:active:focus-visible {\n  background: transparent;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.colorpicker .picker_done button-grey {\n  background: #E5EBF1;\n  color: #10294D;\n}\n.colorpicker .picker_done button-grey svg {\n  stroke: #10294D;\n}\n.colorpicker .picker_done button-grey.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n  background: #E5EBF1;\n  color: #10294D;\n}\n.colorpicker .picker_done button-grey.input-group-addon svg {\n  stroke: #10294D;\n}\n.colorpicker .picker_done button-grey.focus,\n.colorpicker .picker_done button-grey:focus,\n.colorpicker .picker_done button-grey:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.colorpicker .picker_done button-grey.active,\n.colorpicker .picker_done button-grey:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\n.colorpicker .picker_done button-grey.active.focus,\n.colorpicker .picker_done button-grey:active.focus,\n.colorpicker .picker_done button-grey.active:focus,\n.colorpicker .picker_done button-grey:active:focus,\n.colorpicker .picker_done button-grey.active:focus-visible,\n.colorpicker .picker_done button-grey:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.colorpicker .picker_done button-grey.hover,\n.colorpicker .picker_done button-grey:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\n.colorpicker .picker_done button-grey.hover.active,\n.colorpicker .picker_done button-grey:hover.active,\n.colorpicker .picker_done button-grey.hover:active,\n.colorpicker .picker_done button-grey:hover:active {\n  border-color: transparent;\n  background: #CED7E2;\n}\n.colorpicker .picker_done button-grey.hover.active.focus,\n.colorpicker .picker_done button-grey:hover.active.focus,\n.colorpicker .picker_done button-grey.hover:active.focus,\n.colorpicker .picker_done button-grey:hover:active.focus,\n.colorpicker .picker_done button-grey.hover.active:focus,\n.colorpicker .picker_done button-grey:hover.active:focus,\n.colorpicker .picker_done button-grey.hover:active:focus,\n.colorpicker .picker_done button-grey:hover:active:focus,\n.colorpicker .picker_done button-grey.hover.active:focus-visible,\n.colorpicker .picker_done button-grey:hover.active:focus-visible,\n.colorpicker .picker_done button-grey.hover:active:focus-visible,\n.colorpicker .picker_done button-grey:hover:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.colorpicker .picker_done button-grey-50 {\n  background: #F3F5F8;\n  color: #10294D;\n}\n.colorpicker .picker_done button-grey-50 svg {\n  stroke: #10294D;\n}\n.colorpicker .picker_done button-grey-50.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n  background: #F3F5F8;\n  color: #10294D;\n}\n.colorpicker .picker_done button-grey-50.input-group-addon svg {\n  stroke: #10294D;\n}\n.colorpicker .picker_done button-grey-50.focus,\n.colorpicker .picker_done button-grey-50:focus,\n.colorpicker .picker_done button-grey-50:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.colorpicker .picker_done button-grey-50.active,\n.colorpicker .picker_done button-grey-50:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\n.colorpicker .picker_done button-grey-50.active.focus,\n.colorpicker .picker_done button-grey-50:active.focus,\n.colorpicker .picker_done button-grey-50.active:focus,\n.colorpicker .picker_done button-grey-50:active:focus,\n.colorpicker .picker_done button-grey-50.active:focus-visible,\n.colorpicker .picker_done button-grey-50:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.colorpicker .picker_done button-grey-50.hover,\n.colorpicker .picker_done button-grey-50:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\n.colorpicker .picker_done button-grey-50.hover.active,\n.colorpicker .picker_done button-grey-50:hover.active,\n.colorpicker .picker_done button-grey-50.hover:active,\n.colorpicker .picker_done button-grey-50:hover:active {\n  border-color: transparent;\n  background: #E5EBF1;\n}\n.colorpicker .picker_done button-grey-50.hover.active.focus,\n.colorpicker .picker_done button-grey-50:hover.active.focus,\n.colorpicker .picker_done button-grey-50.hover:active.focus,\n.colorpicker .picker_done button-grey-50:hover:active.focus,\n.colorpicker .picker_done button-grey-50.hover.active:focus,\n.colorpicker .picker_done button-grey-50:hover.active:focus,\n.colorpicker .picker_done button-grey-50.hover:active:focus,\n.colorpicker .picker_done button-grey-50:hover:active:focus,\n.colorpicker .picker_done button-grey-50.hover.active:focus-visible,\n.colorpicker .picker_done button-grey-50:hover.active:focus-visible,\n.colorpicker .picker_done button-grey-50.hover:active:focus-visible,\n.colorpicker .picker_done button-grey-50:hover:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.colorpicker .picker_done button-white {\n  background: #ffffff;\n  color: #10294D;\n}\n.colorpicker .picker_done button-white svg {\n  stroke: #CED7E2;\n}\n.colorpicker .picker_done button-white.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n  background: #E5EBF1;\n  color: #10294D;\n}\n.colorpicker .picker_done button-white.input-group-addon svg {\n  stroke: #CED7E2;\n}\n.colorpicker .picker_done button-white.focus,\n.colorpicker .picker_done button-white:focus,\n.colorpicker .picker_done button-white:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.colorpicker .picker_done button-white.active,\n.colorpicker .picker_done button-white:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\n.colorpicker .picker_done button-white.active.focus,\n.colorpicker .picker_done button-white:active.focus,\n.colorpicker .picker_done button-white.active:focus,\n.colorpicker .picker_done button-white:active:focus,\n.colorpicker .picker_done button-white.active:focus-visible,\n.colorpicker .picker_done button-white:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.colorpicker .picker_done button-white.hover,\n.colorpicker .picker_done button-white:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #CED7E2;\n}\n.colorpicker .picker_done button-white.hover.active,\n.colorpicker .picker_done button-white:hover.active,\n.colorpicker .picker_done button-white.hover:active,\n.colorpicker .picker_done button-white:hover:active {\n  border-color: transparent;\n  background: #CED7E2;\n}\n.colorpicker .picker_done button-white.hover.active.focus,\n.colorpicker .picker_done button-white:hover.active.focus,\n.colorpicker .picker_done button-white.hover:active.focus,\n.colorpicker .picker_done button-white:hover:active.focus,\n.colorpicker .picker_done button-white.hover.active:focus,\n.colorpicker .picker_done button-white:hover.active:focus,\n.colorpicker .picker_done button-white.hover:active:focus,\n.colorpicker .picker_done button-white:hover:active:focus,\n.colorpicker .picker_done button-white.hover.active:focus-visible,\n.colorpicker .picker_done button-white:hover.active:focus-visible,\n.colorpicker .picker_done button-white.hover:active:focus-visible,\n.colorpicker .picker_done button-white:hover:active:focus-visible {\n  background: #CED7E2;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.colorpicker .picker_done button-white:hover svg,\n.colorpicker .picker_done button-white.active svg,\n.colorpicker .picker_done button-white:active svg {\n  stroke: #10294D;\n}\n.colorpicker .picker_done button.disabled,\n.colorpicker .picker_done button[disabled] {\n  background: #E5EBF1;\n  border: 1px solid transparent;\n  cursor: not-allowed;\n  color: #CED7E2;\n}\n.colorpicker .picker_done button.disabled svg,\n.colorpicker .picker_done button[disabled] svg {\n  display: block;\n  stroke: #CED7E2;\n}\n.colorpicker .picker_done button.disabled.focus,\n.colorpicker .picker_done button[disabled].focus,\n.colorpicker .picker_done button.disabled:focus,\n.colorpicker .picker_done button[disabled]:focus,\n.colorpicker .picker_done button.disabled:focus-visible,\n.colorpicker .picker_done button[disabled]:focus-visible {\n  color: #CED7E2;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.colorpicker .picker_done button.disabled.active,\n.colorpicker .picker_done button[disabled].active,\n.colorpicker .picker_done button.disabled:active,\n.colorpicker .picker_done button[disabled]:active {\n  color: #CED7E2;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\n.colorpicker .picker_done button.disabled.active.focus,\n.colorpicker .picker_done button[disabled].active.focus,\n.colorpicker .picker_done button.disabled:active.focus,\n.colorpicker .picker_done button[disabled]:active.focus,\n.colorpicker .picker_done button.disabled.active:focus,\n.colorpicker .picker_done button[disabled].active:focus,\n.colorpicker .picker_done button.disabled:active:focus,\n.colorpicker .picker_done button[disabled]:active:focus,\n.colorpicker .picker_done button.disabled.active:focus-visible,\n.colorpicker .picker_done button[disabled].active:focus-visible,\n.colorpicker .picker_done button.disabled:active:focus-visible,\n.colorpicker .picker_done button[disabled]:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.colorpicker .picker_done button.disabled.hover,\n.colorpicker .picker_done button[disabled].hover,\n.colorpicker .picker_done button.disabled:hover,\n.colorpicker .picker_done button[disabled]:hover {\n  color: #CED7E2;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\n.colorpicker .picker_done button.disabled.hover.active,\n.colorpicker .picker_done button[disabled].hover.active,\n.colorpicker .picker_done button.disabled:hover.active,\n.colorpicker .picker_done button[disabled]:hover.active,\n.colorpicker .picker_done button.disabled.hover:active,\n.colorpicker .picker_done button[disabled].hover:active,\n.colorpicker .picker_done button.disabled:hover:active,\n.colorpicker .picker_done button[disabled]:hover:active {\n  border-color: transparent;\n  background: #E5EBF1;\n}\n.colorpicker .picker_done button.disabled.hover.active.focus,\n.colorpicker .picker_done button[disabled].hover.active.focus,\n.colorpicker .picker_done button.disabled:hover.active.focus,\n.colorpicker .picker_done button[disabled]:hover.active.focus,\n.colorpicker .picker_done button.disabled.hover:active.focus,\n.colorpicker .picker_done button[disabled].hover:active.focus,\n.colorpicker .picker_done button.disabled:hover:active.focus,\n.colorpicker .picker_done button[disabled]:hover:active.focus,\n.colorpicker .picker_done button.disabled.hover.active:focus,\n.colorpicker .picker_done button[disabled].hover.active:focus,\n.colorpicker .picker_done button.disabled:hover.active:focus,\n.colorpicker .picker_done button[disabled]:hover.active:focus,\n.colorpicker .picker_done button.disabled.hover:active:focus,\n.colorpicker .picker_done button[disabled].hover:active:focus,\n.colorpicker .picker_done button.disabled:hover:active:focus,\n.colorpicker .picker_done button[disabled]:hover:active:focus,\n.colorpicker .picker_done button.disabled.hover.active:focus-visible,\n.colorpicker .picker_done button[disabled].hover.active:focus-visible,\n.colorpicker .picker_done button.disabled:hover.active:focus-visible,\n.colorpicker .picker_done button[disabled]:hover.active:focus-visible,\n.colorpicker .picker_done button.disabled.hover:active:focus-visible,\n.colorpicker .picker_done button[disabled].hover:active:focus-visible,\n.colorpicker .picker_done button.disabled:hover:active:focus-visible,\n.colorpicker .picker_done button[disabled]:hover:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px transparent;\n}\n.colorpicker .picker_done button-icon-16 .icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n}\n.colorpicker .picker_done button-icon-16 .icon svg {\n  width: 16px;\n  height: 16px;\n  stroke-width: 2.4;\n}\n.colorpicker .picker_done button-icon-24 .icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n}\n.colorpicker .picker_done button-icon-24 .icon svg {\n  width: 24px;\n  height: 24px;\n  stroke-width: 1.4;\n}\n.colorpicker .picker_done button-icon-right {\n  padding-right: 10px;\n}\n.colorpicker .picker_done button-icon-right .icon {\n  order: 1;\n  margin-left: 5px;\n}\n.colorpicker .picker_done button-icon-right .icon svg {\n  fill: none;\n}\n.colorpicker .picker_done button-icon-left {\n  padding-left: 10px;\n}\n.colorpicker .picker_done button-icon-left .icon {\n  order: 0;\n  margin-right: 5px;\n}\n.colorpicker .picker_done button-icon-left .icon svg {\n  fill: none;\n}\n.colorpicker .picker_done button-icon-right.colorpicker .picker_done button-icon-left .icon {\n  margin: 0;\n}\n.colorpicker .picker_done button-icon-only {\n  padding: 0;\n}\n.colorpicker .picker_done button-icon-only.btn-icon-24 {\n  min-height: 26px;\n  max-height: 26px;\n  max-width: 26px;\n}\n.colorpicker .picker_done button-icon-only.btn-icon-24 .icon {\n  max-height: 24px;\n  max-width: 24px;\n}\n.colorpicker .picker_done button-icon-only.btn-icon-16 {\n  min-height: 18px;\n  max-height: 18px;\n  max-width: 18px;\n}\n.colorpicker .picker_done button-icon-only.btn-icon-16 .icon {\n  max-height: 16px;\n  max-width: 16px;\n}\n.colorpicker .picker_done button-icon-only.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n}\n.colorpicker .picker_done button-icon-success .icon svg {\n  fill: none;\n  stroke: #73C677;\n}\n.colorpicker .picker_done button-glyph .icon svg {\n  stroke: none;\n}\n.colorpicker .picker_done button.highlight {\n  --color4: #60D3EC;\n}\n.colorpicker .picker_done button.has-submenu {\n  padding: 0;\n}\n.colorpicker .picker_done button-red-text {\n  color: #FC495D;\n  padding-left: 1px;\n}\n.colorpicker .picker_done button svg {\n  stroke: #10294D;\n}\n.colorpicker .picker_done button.input-group-addon {\n  min-height: 34px;\n  max-height: none;\n  background: #F3F5F8;\n  color: #10294D;\n}\n.colorpicker .picker_done button.input-group-addon svg {\n  stroke: #10294D;\n}\n.colorpicker .picker_done button.focus,\n.colorpicker .picker_done button:focus,\n.colorpicker .picker_done button:focus-visible {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.colorpicker .picker_done button.active,\n.colorpicker .picker_done button:active {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\n.colorpicker .picker_done button.active.focus,\n.colorpicker .picker_done button:active.focus,\n.colorpicker .picker_done button.active:focus,\n.colorpicker .picker_done button:active:focus,\n.colorpicker .picker_done button.active:focus-visible,\n.colorpicker .picker_done button:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.colorpicker .picker_done button.hover,\n.colorpicker .picker_done button:hover {\n  color: #10294D;\n  border: 1px solid transparent;\n  background: #E5EBF1;\n}\n.colorpicker .picker_done button.hover.active,\n.colorpicker .picker_done button:hover.active,\n.colorpicker .picker_done button.hover:active,\n.colorpicker .picker_done button:hover:active {\n  border-color: transparent;\n  background: #E5EBF1;\n}\n.colorpicker .picker_done button.hover.active.focus,\n.colorpicker .picker_done button:hover.active.focus,\n.colorpicker .picker_done button.hover:active.focus,\n.colorpicker .picker_done button:hover:active.focus,\n.colorpicker .picker_done button.hover.active:focus,\n.colorpicker .picker_done button:hover.active:focus,\n.colorpicker .picker_done button.hover:active:focus,\n.colorpicker .picker_done button:hover:active:focus,\n.colorpicker .picker_done button.hover.active:focus-visible,\n.colorpicker .picker_done button:hover.active:focus-visible,\n.colorpicker .picker_done button.hover:active:focus-visible,\n.colorpicker .picker_done button:hover:active:focus-visible {\n  background: #E5EBF1;\n  outline: none;\n  box-shadow: 0px 0px 0px 3px #C3C9D2;\n}\n.extras-opt,\n.extras-selected,\n.extras-legend {\n  display: flex;\n  justify-content: space-between;\n}\n.extras-opt .extras-tags,\n.extras-selected .extras-tags,\n.extras-legend .extras-tags {\n  display: flex;\n  gap: 0 5px;\n}\n.extras-opt .extras-tag,\n.extras-selected .extras-tag,\n.extras-legend .extras-tag {\n  font-size: 11px;\n  display: block;\n  border-radius: 2px;\n  padding: 2px 5px;\n  color: #5A6F89;\n}\n.extras-opt .extras-tag.group-tag,\n.extras-selected .extras-tag.group-tag,\n.extras-legend .extras-tag.group-tag {\n  background: #E5EBF1;\n}\n.extras-opt .extras-tag.P24,\n.extras-selected .extras-tag.P24,\n.extras-legend .extras-tag.P24 {\n  background: rgba(88, 172, 228, 0.3);\n}\n.extras-opt .extras-tag.PP,\n.extras-selected .extras-tag.PP,\n.extras-legend .extras-tag.PP {\n  background: rgba(83, 216, 106, 0.3);\n}\n.extras-opt .extras-tag.DBZ,\n.extras-selected .extras-tag.DBZ,\n.extras-legend .extras-tag.DBZ {\n  background: #ffe98a;\n}\n.extras-opt .extras-tag.BYT,\n.extras-selected .extras-tag.BYT,\n.extras-legend .extras-tag.BYT {\n  background: rgba(40, 177, 109, 0.5);\n}\n.extras-opt .extras-tag.PF,\n.extras-selected .extras-tag.PF,\n.extras-legend .extras-tag.PF {\n  background: #fda79d;\n}\n.extras-selected {\n  align-content: center;\n  line-height: 1;\n  font-size: 11px;\n}\n.extras-selected .extras-label {\n  display: flex;\n  align-items: center;\n}\n.extras-selected .extras-tags {\n  margin-left: 3px;\n}\n.extras-legend {\n  color: #000;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  min-width: 240px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.col .extras-legend {\n  flex: 1 1 100%;\n  justify-content: flex-start;\n}\n.extras-legend > div {\n  display: flex;\n  align-content: center;\n  align-items: center;\n  margin-right: 5px;\n  margin-bottom: 10px;\n}\n.extras-legend > div .extras-tag {\n  margin-left: 0;\n  margin-right: 5px;\n}\n.model-form.view:not(.action) {\n  display: grid;\n  grid-area: view;\n  grid-template-areas: \"jump-menu\" \"form\";\n  grid-template-rows: 37px auto;\n  padding: 0;\n}\n@media screen and (min-width: 799px) {\n  .model-form.view:not(.action) {\n    grid-template-areas: \"jump-menu form\";\n    grid-template-columns: 260px auto;\n    grid-template-rows: auto;\n  }\n}\n.model-form.view:not(.action) .viewcontent {\n  grid-area: form;\n  position: relative;\n  overflow: auto;\n}\n.jumplist {\n  grid-area: jump-menu;\n  background: #E5EBF1;\n  top: 0;\n  width: 100vw;\n  height: 37px;\n  max-height: 37px;\n  overflow: hidden;\n  z-index: 101;\n  margin-bottom: 60px;\n}\n@media screen and (min-width: 799px) {\n  .jumplist {\n    top: 0;\n    position: sticky;\n    overflow: auto;\n    height: auto;\n    width: 260px;\n    max-height: none;\n    margin-bottom: 0;\n  }\n}\n.jumplist + div {\n  grid-area: details;\n}\n.jumplist.show {\n  position: absolute;\n  top: 66px;\n  height: auto;\n  max-height: none;\n}\n@media screen and (min-width: 799px) {\n  .jumplist.show {\n    position: relative;\n    top: 0;\n  }\n}\n.jumplist-inner {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n}\n.jumplist-inner a {\n  background: #E5EBF1;\n  height: 37px;\n  flex: 0 0 100%;\n  display: flex;\n  align-items: center;\n  padding: 8px 20px;\n  color: #92A7C0;\n  font-weight: 500;\n}\n.jumplist-inner a.active {\n  background: #CED7E2;\n  color: #10294D;\n}\n.jumplist-inner a:hover {\n  background: #CED7E2;\n  color: #10294D;\n}\n.vehicle-manager .search-fields {\n  justify-content: unset;\n}\n.vehicle-manager .search-buttons {\n  flex-wrap: nowrap;\n  display: flex;\n  gap: inherit;\n  align-self: start;\n}\n.template-manager .search-buttons {\n  flex: 0 0 100%;\n}\n.previewcontainer {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding-bottom: 20px;\n}\n@media (min-width: 799px) {\n  .previewcontainer {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n}\n.previewcontainer .isloading {\n  position: absolute;\n  z-index: 999;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n.previewcontainer-nav {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  padding: 0 20px;\n}\n@media (min-width: 799px) {\n  .previewcontainer-nav {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n.previewcontainer-nav .btn-highlight {\n  text-align: center;\n}\n.previewcontainer-nav .nav-group {\n  display: flex;\n  gap: 10px 5px;\n}\n@media (max-width: 799px) {\n  .previewcontainer-nav .nav-group:nth-of-type(2) {\n    display: none;\n  }\n}\n.previewcontainer-nav .nav-group .btn-icon-only {\n  min-width: 38px;\n  max-width: 38px;\n  min-height: 38px;\n  max-height: 38px;\n  justify-content: center;\n}\n.previewcontainer-nav .seperator {\n  margin: 0 10px;\n  width: 0;\n  border-right: 1px solid #cfcdcd;\n}\n.previewcontainer-nav .form-group {\n  margin: 0;\n}\n.previewcontainer-nav .page {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  white-space: nowrap;\n  justify-content: center;\n  margin-right: 15px;\n}\n.previewcontainer-nav .page .forminput {\n  flex: 1 1;\n  margin-left: 3px;\n  margin-right: 3px;\n}\n.previewcontainer-nav .page .page-jump {\n  width: 36px;\n  min-width: 36px;\n  max-width: 36px;\n  text-align: center;\n}\n.previewcontainer-nav .zoom {\n  min-width: 150px;\n}\n.previewcontainer-content {\n  margin-top: 20px;\n  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);\n  overflow: auto;\n}\n.previewcontainer-content iframe {\n  width: 100%;\n  border: none;\n  overflow: visible;\n}\n.check-header {\n  display: flex;\n  flex: 1 1;\n  color: #455870;\n  font-weight: 500;\n  justify-content: space-between;\n}\n.check-body {\n  font-size: 12px;\n  color: #455870;\n}\n.asset-selector {\n  width: 100%;\n  max-width: 100%;\n  position: relative;\n  overflow: hidden;\n  height: 56px;\n  max-height: 56px;\n}\n.asset-selector.selected {\n  height: 230px;\n  max-height: 230px;\n  display: flex;\n  justify-content: center;\n}\n.asset-selector .asset-selector-btn-container {\n  position: absolute;\n  width: 100%;\n  margin: 10px -5px;\n  display: flex;\n  flex-direction: row-reverse;\n}\n.asset-selector .asset-selector-btn-container .asset-selector-btn:first-of-type {\n  margin-left: 5px;\n}\n.asset-selector .asset-selector-btn-container .asset-selector-btn .btn-icon-only {\n  min-height: 36px;\n  max-height: 36px;\n  max-width: 36px;\n  padding: 6px 15px;\n  justify-content: center;\n}\n.asset-selector .asset-item {\n  margin-top: 5px;\n}\n.gallery-selector {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: min-content;\n  width: 100%;\n  max-width: 100%;\n  position: relative;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  gap: 10px 10px;\n  height: 300px;\n  max-height: 300px;\n}\n.gallery-selector * {\n  touch-action: none;\n}\n.gallery-selector .gallery-item {\n  height: min-content;\n  border-radius: 4px;\n  position: relative;\n  padding: 10px;\n}\n.gallery-selector .gallery-item.active {\n  background: #CED7E2;\n}\n.gallery-selector .gallery-item .checkcontainer {\n  justify-content: flex-start;\n  align-items: flex-start;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  min-height: 24px;\n}\n.gallery-selector .gallery-item img {\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  max-height: 100%;\n  max-width: 100%;\n  user-select: none;\n  pointer-events: none;\n}\n.gallery-selector .gallery-item.disabled .checkcontainer {\n  display: none;\n}\n.gallery-selector .gallery-item.required .checkcontainer span {\n  background: #FFB1B1;\n}\n.customopt .domstring {\n  display: flex;\n  gap: 14px 14px;\n  align-items: center;\n}\n.customopt .check-image {\n  min-width: 150px;\n  max-width: 150px;\n  height: 150px;\n}\n.customopt .check-image img {\n  background: #ffffff;\n  border-radius: 0;\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n}\n.customopt .check-listing .listing-property-type {\n  color: #B2C2D4;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.customopt .check-listing .listing-address {\n  color: #5A6F89;\n  font-size: 13px;\n  line-height: 21px;\n}\n.customopt .check-listing .listing-meta {\n  display: flex;\n  gap: 14px 14px;\n  padding: 14px 0;\n}\n.customopt .check-listing .listing-meta svg {\n  fill: none;\n  stroke: #10294D;\n  stroke-width: 2.4;\n  width: 16px;\n}\n.customopt .check-listing .icon-value {\n  display: flex;\n  align-items: center;\n  color: #5A6F89;\n  gap: 2px 2px;\n}\n.customopt .check-listing .listing-price {\n  font-size: 15px;\n  font-weight: 600;\n  color: #10294D;\n}\n.brochures .forminput,\n.brochures .input-group {\n  max-width: 100%;\n}\n.brochures .forminput [class^=\"col-\"],\n.brochures .input-group [class^=\"col-\"],\n.brochures .forminput [class*=\"col-\"],\n.brochures .input-group [class*=\"col-\"] {\n  min-width: 180px;\n}\n#field-to {\n  margin-top: 1rem;\n}\n.versions-summary {\n  padding: 20px;\n  display: block;\n}\n.versions-summary:hover {\n  background: #EBF5FF;\n}\n.versions-summary-top {\n  display: flex;\n  align-items: center;\n  gap: 0 6px;\n}\n.versions-summary-top .avatar-md {\n  max-width: 24px;\n}\n.versions-summary-top .avatar-md > .thumbimg {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n.versions-summary-top .agents {\n  display: flex;\n  align-items: center;\n  gap: 0 6px;\n}\n.versions-summary-date {\n  margin-left: auto;\n}\n.versions-summary-pin .btn svg {\n  stroke: #CED7E2;\n}\n.versions-summary-pin .btn.pinned svg {\n  stroke: #10294D;\n}\n.versions-summary-tag-name .tag {\n  background-color: #ffffff;\n  border: 1px solid #CED7E2;\n}\n.versions-summary-body {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  margin: 20px 0 0;\n  display: flex;\n  justify-content: space-between;\n  gap: 6px 6px;\n}\n.versions-summary-body .versions-summary-content {\n  overflow: hidden;\n}\n.versions-summary-bottom {\n  display: flex;\n  gap: 6px 6px;\n}\n.versions-summary-bottom .versions-summary-comments {\n  display: flex;\n  align-items: center;\n  gap: 0 6px;\n  color: #10294D;\n  font-weight: 600;\n}\n.versions-summary-bottom .versions-summary-comments .icon {\n  width: 16px;\n  height: 16px;\n}\n.versions-summary-bottom .versions-summary-comments svg {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: #CED7E2;\n  stroke-width: 2.4;\n}\n.versions-summary .versions-summary-attachments {\n  display: flex;\n  align-items: center;\n  gap: 0 6px;\n  color: #10294D;\n  font-weight: 600;\n}\n.versions-summary .versions-summary-attachments svg {\n  width: 16px;\n  fill: none;\n  stroke: #CED7E2;\n  stroke-width: 2.4;\n}\n.versions-summary .versions-summary-tag {\n  border-radius: 30px;\n  padding: 5px 8px;\n  font-size: 10px;\n  background: #B2C2D4;\n  color: #ffffff;\n}\n.versions-summary .versions-summary-tag-related {\n  border-radius: 30px;\n  padding: 5px 8px;\n  font-size: 10px;\n  background: #CED7E2;\n  color: #ffffff;\n}\n.check-input-group {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 0 0 100%;\n  border: 1px solid #E5EBF1;\n  padding: 9px 15px 8px;\n  border-radius: 4px;\n}\n.check-input-group fieldset {\n  display: flex;\n  flex: 0 0 100%;\n  justify-content: flex-start;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0 15px;\n}\n.check-input-group fieldset .checkcontainer {\n  display: flex;\n  flex: 1 1 auto;\n  align-items: flex-start;\n  flex-wrap: nowrap;\n  min-width: fit-content;\n}\n.check-input-group fieldset .checkcontainer .formlabel {\n  font-weight: normal;\n}\n.match-filters-header .cardhead {\n  padding-top: 20px;\n  padding-bottom: 20px;\n}\n.match-filters-header .cardbody {\n  display: none;\n}\n@media screen and (min-width: 799px) {\n  .match-filters-header .match-filters {\n    min-width: 910px;\n  }\n}\n.match-filters {\n  display: flex;\n  gap: 20px 20px;\n  align-items: flex-end;\n  justify-content: space-between;\n  min-height: 60px;\n  margin: 10px;\n}\n@media screen and (max-width: 1200px) {\n  .match-filters {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n.match-filters h3 {\n  line-height: auto;\n  margin: 0;\n}\n.match-filters .filters-container {\n  flex-grow: 1;\n  display: flex;\n  justify-content: flex-end;\n  flex-direction: column;\n}\n@media screen and (min-width: 799px) {\n  .match-filters .filters-container {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n}\n.match-filters .filters-container > div {\n  padding-right: 15px;\n}\n.match-filters .form-group {\n  flex: 0 0 auto;\n}\n.match-filters .form-group .checkinput .forminput,\n.match-filters .form-group .checkgroup {\n  border: 0 !important;\n  padding: 10px 0;\n  font-size: 1.1rem;\n}\n.match-filters .form-group .checkinput .forminput:focus,\n.match-filters .form-group .checkgroup:focus,\n.match-filters .form-group .checkinput .forminput:focus-within,\n.match-filters .form-group .checkgroup:focus-within {\n  box-shadow: none;\n}\n.match-filters .form-group .checkinput .forminput .checkcontainer + label,\n.match-filters .form-group .checkgroup .checkcontainer + label {\n  min-width: 0;\n}\n.match-filters .check-input-group {\n  border: 0;\n  padding: 0;\n}\n.match-filters .check-input-group .checkcontainer {\n  display: contents;\n}\n.match-filters .check-input-group > .input-label {\n  display: none;\n}\n.match-filters .score {\n  width: 100%;\n  max-width: 360px;\n  /* Adjust the maximum width as needed */\n  min-width: 0;\n}\n.vacancy-list {\n  flex: 0 0 100%;\n}\n.vacancy-list .vacancy-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 20px 20px;\n}\n.vacancy-list .vacancy-wrapper + .vacancy-wrapper {\n  margin-top: 20px;\n}\n.vacancy-list .vacancy-wrapper .vacancy-image {\n  flex: 0 0 186px;\n  width: 186px;\n  height: 150px;\n}\n.vacancy-list .vacancy-wrapper .vacancy-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.vacancy-list .vacancy-wrapper .vacancy-data {\n  display: flex;\n  flex: 1 1 auto;\n  min-width: 280px;\n}\n.vacancy-list .vacancy-wrapper .vacancy-data h5 {\n  margin-bottom: 0;\n}\n.vacancy-list .vacancy-wrapper .vacancy-data svg {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: #10294D;\n  margin-right: 5px;\n}\n.vacancy-list .vacancy-wrapper .vacancy-data span {\n  display: inline-flex;\n  align-items: center;\n  align-content: center;\n  white-space: nowrap;\n  text-align: right;\n}\n.vacancy-list .vacancy-wrapper .vacancy-meta {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 1 1 auto;\n}\n.vacancy-list .vacancy-wrapper .vacancy-meta > * {\n  flex: 0 0 100%;\n}\n.vacancy-list .vacancy-wrapper .vacancy-meta > * + * {\n  margin: 10px 0 0 0;\n}\n.vacancy-list .vacancy-wrapper .vacancy-price {\n  flex: 0 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  white-space: nowrap;\n  text-align: right;\n}\n.vacancy-list .vacancy-wrapper .vacancy-price .btn {\n  margin-top: auto;\n}\n.bulkedit .container-fluid {\n  padding-top: 20px;\n}\n.vacancy-agent-detail {\n  flex: 0 0;\n  display: inline-block;\n  flex-wrap: wrap;\n}\n.company-user-detail {\n  display: flex;\n  flex-wrap: nowrap;\n}\n.company-user-detail > div {\n  display: flex;\n  flex-wrap: wrap;\n}\n.vacancy-agent-email {\n  padding-left: 19px;\n}\n.vacancy-show-contact-detail {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  cursor: pointer;\n}\n.vacancy-show-contact-detail .btn:hover {\n  background-color: #ffffff;\n}\n.vacancy-hide-contact-detail {\n  display: none;\n}\n.vacancy-hide-agent-contact-detail {\n  display: none;\n}\n.vacancy-show-agent-contact-detail {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  color: #fc495d;\n  background: #ffffff;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 21px;\n  padding-left: 1px;\n  border: none;\n  font-family: 'Poppins', sans-serif;\n}\n.brochure-generator {\n  grid-template-areas: \"form\" \"pane\";\n  grid-template-rows: 1fr;\n  grid-template-columns: 1fr;\n  min-width: 0;\n  min-height: 0;\n  gap: 20px;\n  margin: -20px;\n  position: relative;\n}\n@media screen and (min-width: 799px) {\n  .brochure-generator {\n    display: grid;\n    grid-template-areas: \"form pane\";\n    grid-template-columns: 400px 1fr;\n  }\n}\n.brochure-generator .brochure-form {\n  min-height: 0;\n  overflow: auto;\n  padding: 20px;\n  grid-area: form;\n}\n.brochure-generator .brochure-preview {\n  grid-area: pane;\n  min-height: 0;\n  overflow: auto;\n  padding: 20px;\n}\n@media screen and (min-width: 799px) {\n  .brochure-generator .brochure-preview {\n    padding: 20px 20px 0 0;\n  }\n}\n.area-groups-search .field {\n  padding: 0;\n}\n#field-modules {\n  padding-left: 0;\n  padding-right: 0;\n}\n#field-modules .checkgroup {\n  flex: 1 1 100%;\n}\n#field-modules .checkinput {\n  padding: 9px 20px 8px;\n}\n#field-modules .checkinput .input-label {\n  top: unset;\n  left: unset;\n  position: unset;\n  background: none;\n  flex: 1 1 0;\n}\n#field-modules .checkinput.checked {\n  background: #EBF5FF;\n}\n#field-modules .checkcontainer {\n  flex: 0 0 24px;\n}\n#field-modules .credit-check-option {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 9px 20px 8px;\n}\n#field-modules .credit-check-option > div {\n  display: flex;\n  flex-direction: column;\n}\n#field-modules .credit-check-option strong {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  /* Primary/100 */\n  color: #10294D;\n}\n#field-modules .credit-check-option span {\n  white-space: normal;\n  /* Frame 1601 */\n  font-size: 12px;\n  line-height: 18px;\n  font-weight: normal;\n  color: #455870;\n}\n.templates-search {\n  display: flex;\n}\n.templates-search > div {\n  display: flex;\n  flex: 1 1 100%;\n}\n.templates-search > div .search-fields {\n  margin-bottom: 10px;\n  flex: 1 1 100%;\n}\n.templates-search > div .search-fields > .field {\n  margin-right: auto;\n}\n.report-table-criteria {\n  display: grid;\n  grid-template-columns: auto fit-content(100px);\n  align-items: center;\n}\n.report-table-criteria .report-table-criteria-list {\n  display: inline-flex;\n}\n.report-table-criteria .report-table-criteria-buttons {\n  min-width: 0;\n}\n.thumb {\n  display: inline-block;\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  overflow: hidden;\n  background-color: #efefef;\n  transition: all 0.3s ease 0s;\n}\n.thumb.small,\n.thumb.small .thumbimg {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n}\n.thumb .thumbimg {\n  display: inline-block;\n  width: 150px;\n  height: 150px;\n  border-radius: 50%;\n  background-color: #f5f5f5;\n  background-position: center center;\n  background-size: cover;\n  transition: all 0.3s ease 0s;\n  transform: scale(1) translateZ(1000px);\n}\n.thumb .thumbimg svg {\n  width: 100%;\n  height: 100%;\n}\n.thumb:hover {\n  box-shadow: -1px 1px 3px 0px rgba(0, 0, 0, 0.2), 1px -1px 3px 0px rgba(0, 0, 0, 0.2);\n}\n.thumb:hover .thumbimg {\n  transform: scale(1.15) translateZ(1000px);\n}\n.agent {\n  display: flex;\n  text-align: left;\n  margin-right: 20px;\n}\n.single-user.agent .thumb {\n  display: block;\n}\n.branchagents,\n.teammembers {\n  display: flex;\n}\n.branchagents > .row,\n.teammembers > .row {\n  flex-grow: 1;\n}\n.branchagents > .row > .col,\n.teammembers > .row > .col {\n  flex-grow: 0;\n}\n.branchagents h3,\n.teammembers h3 {\n  box-sizing: border-box;\n  padding: 0 15px;\n  margin-top: 30px;\n  line-height: 22px;\n  min-height: 2em;\n}\n.branchagents .agents,\n.teammembers .agents {\n  display: flex;\n}\n.branchagents .agent,\n.teammembers .agent {\n  padding: 0 15px;\n  margin-top: 15px;\n  justify-content: center;\n}\n@media (max-width: 799px) {\n  .branchagents > .row .col,\n  .teammembers > .row .col {\n    flex-grow: 1;\n  }\n}\n@media (min-width: 799px) {\n  .branchagents h3,\n  .teammembers h3 {\n    margin-top: 0;\n  }\n  .branchagents .agent,\n  .teammembers .agent {\n    margin: 0;\n  }\n}\n.branchstats {\n  margin: 30px 0;\n}\n.branchstats .row {\n  justify-content: flex-start;\n}\n.branchstats .singlestat {\n  text-align: left;\n  flex: 0 1 200px;\n  max-width: none;\n}\n@media (max-width: 799px) {\n  .branchstats .singlestat {\n    flex: 0 1 300px;\n    text-align: center;\n  }\n}\n.branchstats .singlestat:last-of-type {\n  margin-right: auto;\n}\n.branchstats .singlestat h1 {\n  color: #FC495D;\n  margin: 15px 0 0;\n  line-height: 1;\n}\n.branchstats .singlestat h4 {\n  font-size: 1.5rem;\n  margin: 0;\n}\n.branchstats .singlestat p {\n  font-size: 1.1rem;\n  margin: 0;\n}\n.branchstats .singlestat svg {\n  width: 80px;\n  height: auto;\n  fill: #979797;\n}\n.branchmap {\n  max-height: 280px;\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n.branchmap img {\n  width: 100%;\n}\n.pie-graph {\n  margin-top: 60px;\n  padding: 0 15px;\n  font-size: 1rem;\n  flex: 1 1 360px;\n  display: flex;\n  flex-wrap: wrap;\n}\n@media screen and (min-width: 799px) {\n  .pie-graph {\n    margin-top: 30px;\n    max-width: 360px;\n  }\n}\n.pie-graph svg {\n  margin: 0;\n}\n@media screen and (min-width: 799px) {\n  .pie-graph svg {\n    padding: 0 15px 0 0;\n  }\n}\n.pie-graph h4 {\n  flex: 0 0 100%;\n}\n.pie-graph-wrapper {\n  flex: 1 1 100%;\n  display: flex;\n  flex-wrap: wrap;\n}\n@media screen and (min-width: 799px) {\n  .pie-graph-wrapper {\n    margin-top: 0;\n    flex-wrap: nowrap;\n  }\n}\n.pie-graph-legend {\n  margin-top: 16px;\n  padding: 0;\n}\n.pie-graph-legend li {\n  list-style: none;\n  white-space: nowrap;\n}\n.pie-graph-legend li .pie-graph-legend-color {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  vertical-align: middle;\n  margin-right: 3px;\n}\n.pie-graph-legend li span {\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 10px;\n}\n.login .content {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-wrap: nowrap;\n  overflow: auto;\n}\n.login .overlay {\n  display: none;\n  background-image: url(\"../../images/bg.webp\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center center;\n  width: 100%;\n  min-height: 100%;\n}\n.webp .login .overlay {\n  background-image: url(\"../../images/bg.webp\");\n}\n.no-webp .login .overlay {\n  background-image: url(\"../../images/bg.jpg\");\n}\n.login .overlay:after {\n  content: \"\";\n  position: absolute;\n  top: 30%;\n  right: 5%;\n  background-image: url(\"../../images/dots.svg\");\n  background-repeat: no-repeat;\n  width: 180px;\n  height: 180px;\n}\n@media (min-width: 799px) {\n  .login .overlay {\n    display: block;\n    width: 100%;\n    min-height: 100%;\n    z-index: -1;\n  }\n}\n.login .pd-logo {\n  width: 208px;\n  height: 54px;\n  flex: 0 0 208px;\n  background-image: url(\"../../images/pd-logo.svg\");\n}\n.login .content-wrapper {\n  flex: 1 1 40%;\n  position: relative;\n  min-width: 320px;\n  min-height: 100%;\n  display: grid;\n  grid-template-rows: auto 92px;\n  align-items: center;\n  flex-wrap: wrap;\n  background: #ffffff;\n}\n.login .login-box,\n.login .welcome,\n.login .agentselector {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  flex: 1 1 100%;\n}\n.login .login-box,\n.login .agentselector {\n  overflow: hidden;\n  margin: 0 0;\n  padding-top: 30px;\n  padding-bottom: 30px;\n}\n.login .login-box .scrollview:after,\n.login .agentselector .scrollview:after {\n  content: \"\";\n  height: 30px;\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #ffffff 95%);\n  position: sticky;\n  display: block;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.login .welcome h2,\n.login .welcome h1 {\n  color: #ffffff;\n  background-color: #FC495D;\n  font-weight: 500;\n  padding: 10px 15px;\n  display: inline-block;\n  margin-top: 10px;\n}\n.login .form-group {\n  position: relative;\n  margin-bottom: 24px;\n}\n.login .forgot {\n  margin-top: 1px;\n  margin-left: auto;\n  font-size: 12px;\n  color: #78789A;\n}\n.login .forgot.float-right {\n  margin-left: 0;\n}\n.login .login-box {\n  text-align: center;\n  background: #ffffff;\n  height: 650px;\n}\n.login .login-box h3 {\n  color: #10294D;\n  flex: 1 1 100%;\n  font-weight: 500;\n  padding: 20px 0 0;\n}\n.login .login-box h3 span {\n  font-weight: 600;\n}\n.login .login-box-buttons {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.login .login-box-buttons a {\n  margin-right: auto;\n}\n.login .login-box form {\n  width: 100%;\n}\n.login .login-box-body {\n  background: #ffffff;\n  padding: 20px 10%;\n  border-top: 0;\n  max-width: 100%;\n  width: 100%;\n  min-height: 95px;\n}\n.login .login-box-body p:first-of-type {\n  margin-bottom: 30px;\n}\n.login .login-box-body .form-control-feedback {\n  color: #777;\n}\n.login .login-box-body .box-header,\n.login .login-box-body .box-header span {\n  text-align: center;\n}\n.login .login-box-body .box-header h3,\n.login .login-box-body .box-header span h3 {\n  display: inline-block;\n}\n.login .login-box .message {\n  background-color: #fff;\n  font-size: 1.1rem;\n  width: 100%;\n  color: #fff;\n  margin-top: 30px;\n  padding: 10px;\n}\n.login .login-box .message.error {\n  background-color: #FF6464;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.login .login-box .message.success {\n  background-color: #73C677;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.login .login-box .social-logins {\n  text-align: center;\n  padding-top: 0;\n  padding-bottom: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 30px;\n}\n.login .login-box .social-logins span {\n  color: #70859E;\n  font-size: 14px;\n  flex: 0 0 100%;\n}\n.login .login-box .social-logins > div {\n  flex: 0 0 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 15px;\n}\n.login .login-box .social-logins a {\n  flex: 1 1 auto;\n  height: 44px;\n  border: 1px solid #E5EBF1;\n  border-radius: 4px;\n  color: #10294D;\n  font-weight: 600;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.login .login-box .social-logins a svg {\n  flex: 0 0 20px;\n  height: 20px;\n  margin-right: 8px;\n}\n.login .login-box .social-logins a:hover {\n  background-color: #eeeeee;\n}\n.login .footer {\n  min-height: 50px;\n  background: none;\n  display: flex;\n  flex-wrap: wrap;\n  align-content: center;\n  justify-content: center;\n  padding: 0.75rem 15px;\n  margin: 0;\n  color: #92A7C0;\n}\n.login .footer a {\n  color: #92A7C0;\n}\n.login .login-box-footer {\n  background: #fff;\n  margin: auto 0 0;\n  justify-content: center;\n  flex-wrap: wrap;\n  padding: 0 20px 20px 20px;\n  display: flex;\n  bottom: 50px;\n  left: 0;\n  right: 0;\n}\n.login .login-box-footer > a {\n  text-align: center;\n  color: #FC495D;\n}\n.login .help-text {\n  margin-bottom: 0;\n}\n.login .help-text .fa-question-circle {\n  font-size: 38px;\n  margin-right: 5px;\n}\n.login .agentselector {\n  background-color: #fff;\n  text-align: center;\n  justify-content: center;\n}\n.login .agentselector h3 {\n  margin: 0 ;\n  padding: 10px 0;\n}\n.login .agentselector .agent-option {\n  align-items: center;\n  display: flex;\n  box-shadow: 0px 1px 0px #E5EBF1;\n  max-width: 100%;\n  overflow: hidden;\n}\n.login .agentselector .agent-option:first-of-type {\n  border-top: none;\n}\n.login .agentselector .agent-option:hover {\n  cursor: pointer;\n}\n.login .agentselector .agent-option > div {\n  padding: 10px 20px;\n  color: #B2C2D4;\n  font-size: 11px;\n}\n.login .agentselector .agent-option > div .site-name {\n  text-transform: uppercase;\n  font-weight: 600;\n}\n.login .agentselector .agent-option > div .site-domain {\n  font-weight: 500;\n}\n.login .agentselector .agent-option > div .site-email {\n  font-weight: 500;\n}\n.login .agentselector .agent-option > div svg {\n  fill: #FC495D;\n  stroke: none;\n}\n.login .agentselector .agent-option > div:first-of-type {\n  padding: 0px;\n  padding-left: 20px;\n}\n.login .agentselector .agent-option > div:last-of-type {\n  text-align: left;\n}\n.login .agentselector .notfound {\n  align-items: center;\n  flex-direction: column;\n  font-size: 1.2rem;\n  padding: 20px 0;\n}\n.login .agentselector .notfound h4 {\n  font-size: 1.3rem;\n  padding: 10px 0;\n  display: block;\n}\n.timeline {\n  padding-bottom: 60px;\n  position: relative;\n}\n.timeline-bar {\n  text-align: center;\n  position: absolute;\n  width: 50px;\n  top: 0;\n  bottom: 5px;\n}\n.timeline-bar:before {\n  content: \"\";\n  height: 100%;\n  display: inline-block;\n  width: 3px;\n  background: #E5EBF1;\n}\n.timeline-bar:after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 50px;\n  background-image: linear-gradient(to bottom, transparent, #F3F5F8);\n}\n.timeline-heading {\n  padding-left: 50px;\n  padding-right: 15px;\n  padding-top: 20px;\n  margin-top: 0;\n  margin-bottom: 30px;\n  margin-left: 0;\n  min-width: 0;\n}\n.timeline-event {\n  display: flex;\n  flex-wrap: nowrap;\n  padding-right: 20px;\n}\n.timeline-event-day {\n  text-align: center;\n  position: relative;\n  padding: 0;\n  z-index: 1;\n  margin-top: 14px;\n  min-width: 50px;\n  flex: 0 0 50px;\n  color: #FC495D;\n}\n.timeline-event-day:before {\n  content: \"\";\n  background: #fff;\n  width: 14px;\n  height: 14px;\n  position: absolute;\n  left: 50%;\n  top: 0;\n  margin-left: -7px;\n  margin-top: -12px;\n  border-radius: 50%;\n  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);\n}\n.timeline-event-day:after {\n  content: \"\";\n  background: #FC495D;\n  width: 8px;\n  height: 8px;\n  position: absolute;\n  left: 50%;\n  top: 0;\n  margin-left: -4px;\n  margin-top: -9px;\n  border-radius: 50%;\n  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);\n}\n.timeline-event-card {\n  flex: 1 1 auto;\n  padding: 0;\n  min-width: 0;\n}\n.timeline-event-card .cardhead {\n  margin-left: -15px;\n  margin-right: -15px;\n}\n.timeline-event-card .card {\n  overflow: hidden;\n}\n.timeline-event-card-right {\n  min-width: 0;\n}\n.timeline-event-card-header {\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: #B2C2D4;\n  padding: 0 0 10px 0;\n}\n.timeline-event-card-changes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px 0;\n}\n.timeline-event-card-changes > div {\n  flex: 0 0 100%;\n}\n.timeline-event-card-body {\n  display: flex;\n  color: #92A7C0;\n}\n.timeline-event-card-body h4 {\n  padding: 5px 0 5px 0;\n}\n.timeline-event-card-body h5 {\n  color: #979797;\n  padding: 0px 0 20px 0;\n}\n.timeline-event-card-body code,\n.timeline-event-card-body pre {\n  background: #F3F5F8;\n  padding: 2px 5px;\n  line-height: 1.2em;\n}\n.timeline-event-card-body code ul,\n.timeline-event-card-body pre ul {\n  padding-top: 0;\n  margin: 0;\n  margin-bottom: 5px;\n  background: #F3F5F8;\n}\n.timeline-event-card-body strong {\n  color: #10294D;\n}\n.timeline-event-card-body .agent .thumbimg {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.timeline-event-card-footer {\n  display: flex;\n  align-items: center;\n  font-size: 11px;\n  color: #979797;\n  padding: 0;\n  font-weight: 600;\n  padding-top: 20px;\n}\n.timeline-event-card .notebody {\n  padding-bottom: 15px;\n  font-size: 1.2rem;\n}\n.timeline-event-card .notebody > p {\n  font-size: inherit;\n}\n.noteauthor,\n.noteauthor a {\n  color: #B2C2D4;\n  font-size: 11px;\n  font-weight: 600;\n}\n.wide-sidebar-pane .activity {\n  padding-left: 15px;\n}\n.wide-sidebar-pane .activity .timeline-bar:after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 60px;\n}\n.pdfcontainer-nav {\n  flex-wrap: wrap;\n  display: flex;\n  justify-content: space-between;\n  margin-left: -15px;\n  margin-right: -15px;\n  padding: 0 15px;\n}\n.pdfcontainer-nav .btn-highlight {\n  text-align: center;\n}\n.pdfcontainer-nav .nav-group {\n  display: flex;\n  gap: 10px 5px;\n}\n@media (max-width: 799px) {\n  .pdfcontainer-nav .nav-group:nth-of-type(2) {\n    display: none;\n  }\n}\n.pdfcontainer-nav .nav-group .btn-icon-only {\n  min-width: 38px;\n  max-width: 38px;\n  min-height: 38px;\n  max-height: 38px;\n  justify-content: center;\n}\n.pdfcontainer-nav .seperator {\n  margin: 0 10px;\n  width: 0;\n  border-right: 1px solid #cfcdcd;\n}\n.pdfcontainer-nav .form-group {\n  margin: 0;\n}\n.pdfcontainer-nav .page {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  white-space: nowrap;\n  justify-content: center;\n  margin-right: 15px;\n}\n.pdfcontainer-nav .page.form-group .forminput {\n  flex: 1 1 auto;\n  margin-left: 3px;\n  margin-right: 3px;\n}\n.pdfcontainer-nav .page .page-jump {\n  width: 36px;\n  min-width: 36px;\n  max-width: 36px;\n  text-align: center;\n}\n.pdfcontainer-nav .zoom {\n  min-width: 150px;\n}\n.react-pdf {\n  overflow: auto;\n  cursor: grab;\n}\n.react-pdf .text-center {\n  display: flex;\n  min-height: 68px;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.react-pdf .text-center .message {\n  flex: 0 0 100%;\n}\n.react-pdf__Highlighting {\n  cursor: auto;\n}\n.react-pdf__Scrolling {\n  cursor: grabbing;\n}\n.react-pdf__Document {\n  text-align: center;\n  padding: 20px 0;\n}\n.react-pdf__Page {\n  margin: 20px;\n  display: inline-block;\n  text-align: initial;\n  border: 1px solid rgba(0, 0, 0, 0.14);\n  box-shadow: 8px 8px 16px -2px rgba(0, 0, 0, 0.14);\n}\n.react-pdf__Page__annotations {\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n  opacity: 0.2;\n  line-height: 1;\n}\n.react-pdf__Page__annotations > section {\n  color: transparent;\n  position: absolute;\n  white-space: pre;\n  cursor: text;\n  transform-origin: 0% 0%;\n}\n.react-pdf__Page__annotations > .linkAnnotation > a {\n  position: absolute;\n  font-size: 1em;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.no-pdf {\n  background: #F3F5F8;\n  border-radius: 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 0;\n}\n/*!\n jodit - Jodit is awesome and usefully wysiwyg editor with filebrowser\n Author: Chupurnov <chupurnov@gmail.com> (https://xdsoft.net/)\n Version: v3.2.44\n Url: https://xdsoft.net/jodit/\n License(s): GPL-2.0-or-later\n*/\n.jodit,\n.jodit *,\n.jodit_container,\n.jodit_container * {\n  box-sizing: border-box;\n}\n.jodit .jodit_workplace,\n.jodit_container .jodit_workplace {\n  position: relative;\n  overflow: auto;\n}\n.jodit .jodit_workplace .jodit_wysiwyg,\n.jodit .jodit_workplace .jodit_wysiwyg_iframe,\n.jodit_container .jodit_workplace .jodit_wysiwyg,\n.jodit_container .jodit_workplace .jodit_wysiwyg_iframe {\n  height: 100%;\n  width: 100%;\n}\n.jodit_container:not(.jodit_inline) {\n  background: #fff;\n  font-size: 14px;\n  font-family: Helvetica, sans-serif;\n}\n.jodit_container:not(.jodit_inline).jodit_disabled {\n  background: hsla(0, 0%, 88%, 0.99);\n}\n.jodit_container:not(.jodit_inline).jodit_disabled .jodit_workplace {\n  opacity: 0.4;\n}\n.jodit_container:not(.jodit_inline) .jodit_workplace {\n  border: 1px solid #ccc;\n}\n.jodit_disabled {\n  -webkit-user-select: none!important;\n  -moz-user-select: none!important;\n  -ms-user-select: none!important;\n  user-select: none !important;\n}\n.jodit_hidden {\n  display: none !important;\n}\n.jodit_wysiwyg {\n  outline: 0;\n}\n.jodit_wysiwyg::-moz-selection,\n.jodit_wysiwyg ::-moz-selection {\n  background: #b5d6fd;\n  color: #000;\n}\n.jodit_wysiwyg::selection,\n.jodit_wysiwyg ::selection {\n  background: #b5d6fd;\n  color: #000;\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg {\n  margin: 0;\n  padding: 10px;\n  outline: 0;\n  overflow-x: auto;\n  position: relative;\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg img {\n  position: relative;\n  max-width: 100%;\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg p,\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg pre {\n  margin: 0 0 10px;\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg h1,\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg h2,\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg h3,\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg h4,\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg h5 {\n  margin-top: 0;\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg blockquote {\n  border-left: 2px solid #222;\n  margin-left: 0;\n  padding-left: 5px;\n  color: #222;\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg jodit-media {\n  position: relative;\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg jodit-media * {\n  position: relative;\n  z-index: 0;\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg jodit-media:before {\n  z-index: 1;\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.jodit_clearfix:after,\n.jodit_clearfix:before {\n  content: \" \";\n  display: table;\n}\n.jodit_clearfix:after {\n  clear: both;\n}\n.jodit_dark_theme.jodit_container,\n.jodit_dark_theme.jodit_container.jodit_disabled {\n  background-color: #575757;\n}\n.jodit_dark_theme .jodit_workplace {\n  border-color: rgba(87, 87, 87, 0.8);\n}\n.jodit_dark_theme .jodit_statusbar {\n  background-color: rgba(95, 92, 92, 0.8);\n  border-color: rgba(87, 87, 87, 0.8);\n}\n.jodit_dark_theme .jodit_statusbar,\n.jodit_dark_theme .jodit_statusbar .jodit_statusbar_item span {\n  color: #d1cccc;\n}\n.jodit_dark_theme .jodit_toolbar_popup,\n.jodit_dark_theme .jodit_toolbar_popup-inline,\n.jodit_dark_theme .jodit_toolbar_popup-inline:before,\n.jodit_dark_theme .jodit_toolbar_popup:before {\n  background: #575757;\n}\n.jodit_dark_theme .jodit_toolbar {\n  background: #5f5c5c;\n  border-color: rgba(87, 87, 87, 0.8);\n}\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn > a {\n  color: #d1cccc;\n}\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn > a:hover {\n  background-color: #575757;\n}\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn.jodit_toolbar_btn-break {\n  border-top-color: #686767;\n}\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn.jodit_toolbar_btn-separator {\n  border-right-color: #686767;\n}\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn.active,\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn.jodit_active,\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn:active,\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn:hover {\n  background-color: #575757;\n}\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn.jodit_with_dropdownlist .jodit_with_dropdownlist-trigger {\n  border-top-color: silver;\n}\n.jodit_dark_theme .jodit_icon {\n  fill: silver;\n}\n.jodit_dark_theme .jodit_wysiwyg,\n.jodit_dark_theme .jodit_wysiwyg_iframe {\n  background-color: #575757;\n  color: #d1cccc;\n}\n.jodit_dark_theme .jodit_wysiwyg [data-jodit-selected-cell],\n.jodit_dark_theme .jodit_wysiwyg_iframe [data-jodit-selected-cell] {\n  border-color: #152f5f;\n}\n.jodit_dark_theme .jodit_dropdownlist {\n  background: #5f5c5c;\n}\n.jodit_dark_theme .jodit_tabs .jodit_tabs_buttons > a {\n  background-color: #686767;\n  color: #d1cccc;\n}\n.jodit_dark_theme .jodit_tabs .jodit_tabs_buttons > a:hover {\n  background-color: hsla(0, 0%, 41%, 0.8);\n  color: #d1cccc;\n  border-color: hsla(0, 0%, 41%, 0.9);\n}\n.jodit_dark_theme .jodit_tabs .jodit_tabs_buttons > a.active {\n  background: rgba(81, 81, 81, 0.41);\n  border-color: #686767;\n}\n.jodit_dark_theme .jodit_tabs .jodit_tabs_buttons > a svg {\n  fill: silver;\n}\n.jodit_dark_theme .jodit_form input[type=text],\n.jodit_dark_theme .jodit_form input[type=url],\n.jodit_dark_theme .jodit_form textarea {\n  background-color: rgba(81, 81, 81, 0.41);\n  border-color: #686767;\n  color: #d1cccc;\n}\n.jodit_dark_theme .jodit_form button {\n  background-color: hsla(0, 0%, 41%, 0.75);\n  color: #d1cccc;\n}\n.jodit_dark_theme .jodit_placeholder {\n  color: hsla(0, 5%, 81%, 0.8);\n}\n.jodit_dark_theme .jodit_draganddrop_file_box,\n.jodit_dark_theme .jodit_uploadfile_button {\n  color: #d1cccc;\n}\n.jodit_dark_theme .jodit_draganddrop_file_box:hover,\n.jodit_dark_theme .jodit_uploadfile_button:hover {\n  background-color: hsla(0, 0%, 41%, 0.75);\n}\n.jodit_dark_theme .jodit-add-new-line:before {\n  border-top-color: #686767;\n}\n.jodit_dark_theme .jodit-add-new-line span {\n  background: hsla(0, 0%, 41%, 0.75);\n  border-color: #686767;\n}\n.jodit_dark_theme .jodit-add-new-line span svg {\n  fill: #d1cccc;\n}\n.jodit_dark_theme .jodit_resizer > i {\n  background: hsla(0, 0%, 41%, 0.75);\n  border-color: silver;\n}\n.jodit_btn {\n  border: 1px solid;\n  border-radius: 0;\n  background-color: #f5f5f5;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(#fff), to(#e6e6e6));\n  background-image: -webkit-linear-gradient(top, #fff, #e6e6e6);\n  background-image: linear-gradient(180deg, #fff, #e6e6e6);\n  border-color: #ccc;\n  text-shadow: 0 1px 1px hsla(0, 0%, 100%, 0.75);\n  color: #333;\n  background-repeat: repeat-x;\n  outline: 0;\n  display: inline-block;\n  padding: 6px 12px;\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.42857143;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.jodit_btn:hover {\n  background-color: #e6e6e6;\n  background-position: 0 -15px;\n  text-decoration: none;\n}\n.jodit_btn.jodit_btn_success {\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n  background-color: #5bb75b;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(#62c462), to(#51a351));\n  background-image: -webkit-linear-gradient(top, #62c462, #51a351);\n  background-image: linear-gradient(180deg, #62c462, #51a351);\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n  color: #fff;\n}\n.jodit_btn.jodit_btn_success svg {\n  fill: #fff;\n}\n.jodit_btn.jodit_btn_success:hover {\n  background-color: #51a351;\n}\n.jodit_btn.jodit_btn_danger {\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n  background-color: #da4f49;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(#ee5f5b), to(#bd362f));\n  background-image: -webkit-linear-gradient(top, #ee5f5b, #bd362f);\n  background-image: linear-gradient(180deg, #ee5f5b, #bd362f);\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n  color: #fff;\n}\n.jodit_btn.jodit_btn_danger svg {\n  fill: #fff;\n}\n.jodit_btn.jodit_btn_danger:hover {\n  background-color: #bd362f;\n}\n.jodit_btn.jodit_btn_inverse {\n  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n  background-color: #363636;\n  background-image: -webkit-gradient(linear, left top, left bottom, from(#444), to(#222));\n  background-image: -webkit-linear-gradient(top, #444, #222);\n  background-image: linear-gradient(180deg, #444, #222);\n  border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n  color: #fff;\n}\n.jodit_btn.jodit_btn_inverse svg {\n  fill: #fff;\n}\n.jodit_btn.jodit_btn_inverse:hover {\n  background-color: #222;\n}\n.jodit_btn.active,\n.jodit_btn:active {\n  background-image: none;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.15), 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n.jodit_btn_group {\n  font-size: 0;\n  vertical-align: middle;\n}\n.jodit_btn_group input {\n  display: none;\n}\n.jodit_btn_group button {\n  float: left;\n}\n.jodit_btn_group button + button {\n  margin-left: -1px;\n}\n.jodit_btn_group button:first-child,\n.jodit_btn_group input:first-child + button {\n  border-right: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.jodit_btn_group button:last-child,\n.jodit_btn_group input:last-child + button {\n  border-left: 0;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.jodit_btn_group:after {\n  content: \"\";\n  clear: both;\n  float: none;\n  display: table;\n}\n.jodit_context_menu {\n  font-family: Helvetica, sans-serif;\n  display: none;\n  background: #fff;\n  position: absolute;\n  min-width: 150px;\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.24);\n  z-index: 15;\n}\n.jodit_context_menu a {\n  display: block;\n  border-bottom: 1px solid hsla(0, 0%, 80%, 0.24);\n  text-decoration: none!important;\n  color: #727272;\n}\n.jodit_context_menu a svg {\n  float: left;\n  display: block;\n  width: 18px;\n  height: 28px;\n  margin: 0 4.5px;\n  fill: #727272;\n}\n.jodit_context_menu a span {\n  margin-left: 27px;\n  display: block;\n  padding: 5px;\n  border-left: 1px solid hsla(0, 0%, 80%, 0.24);\n  line-height: 18px;\n}\n.jodit_context_menu a:hover {\n  background-color: #e3e3e3;\n  color: #000;\n}\n.jodit_context_menu a:hover .jodit_icon {\n  fill: #000;\n}\n.jodit_context_menu a:last-child {\n  border: 0;\n}\n.jodit_context_menu-show {\n  display: block;\n}\n.jodit_dialog_box {\n  box-sizing: border-box;\n  display: none;\n  width: 0;\n  height: 0;\n  border: 0;\n  position: absolute;\n  will-change: left, top, width, height;\n}\n.jodit_dialog_box.jodit_dialog_box-moved {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.jodit_dialog_box * {\n  box-sizing: border-box;\n}\n.jodit_dialog_box .jodit_elfinder,\n.jodit_dialog_box .jodit_elfinder * {\n  box-sizing: content-box;\n  box-sizing: initial;\n}\n.jodit_dialog_box .jodit_dialog_overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 13;\n  text-align: center;\n  white-space: nowrap;\n  overflow: auto;\n  display: none;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n.jodit_dialog_box.active,\n.jodit_dialog_box.jodit_modal .jodit_dialog_overlay {\n  display: block;\n}\n.jodit_dialog_box .jodit_dialog {\n  z-index: 14;\n  display: inline-block;\n  vertical-align: middle;\n  white-space: normal;\n  text-align: left;\n  position: fixed;\n  left: 0;\n  top: 0;\n  background-color: #fff;\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);\n  min-width: 200px;\n  min-height: 100px;\n}\n@media (max-width: 480px) {\n  .jodit_dialog_box .jodit_dialog {\n    max-width: 100%;\n    width: 100%!important;\n    height: 100%!important;\n    top: 0!important;\n    left: 0 !important;\n  }\n}\n.jodit_dialog_box .jodit_dialog .jodit_promt {\n  max-width: 300px;\n  min-width: 200px;\n  padding: 10px;\n  word-break: break-all;\n}\n.jodit_dialog_box .jodit_dialog .jodit_promt label {\n  margin-bottom: 5px;\n  display: block;\n}\n.jodit_dialog_box .jodit_dialog .jodit_promt input[type=text] {\n  display: block;\n  border: 1px solid #ccc;\n  background: #fff;\n  width: 100%;\n  height: 28px;\n  line-height: 16px;\n  padding: 3px 6px;\n  outline: none;\n}\n.jodit_dialog_box .jodit_dialog .jodit_alert {\n  max-width: 300px;\n  min-width: 200px;\n  padding: 10px;\n  word-break: break-all;\n}\n.jodit_dialog_box .jodit_dialog .jodit_button {\n  padding: 0;\n  margin: 0;\n  border: 0;\n  display: inline-block;\n  vertical-align: top;\n  width: 32px;\n  height: 48px;\n  line-height: 48px;\n  text-align: center;\n  cursor: pointer;\n  text-decoration: none;\n}\n.jodit_dialog_box .jodit_dialog .jodit_button:not(.disabled):hover {\n  background-color: #ecebe9;\n}\n.jodit_dialog_box .jodit_dialog .jodit_button.disabled {\n  opacity: 0.7;\n}\n.jodit_dialog_box .jodit_dialog .jodit_input {\n  border: 1px solid #ccc;\n  padding: 5px;\n  background-color: #fff;\n  outline: 0;\n  width: 120px;\n  margin-left: 10px;\n  font: 13px Arial;\n  height: 28px;\n  vertical-align: middle;\n}\n.jodit_dialog_box .jodit_dialog select.jodit_input {\n  width: 75px;\n}\n.jodit_dialog_box .jodit_dialog .jodit_button .jodit_icon,\n.jodit_dialog_box .jodit_dialog .jodit_button svg,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_icon,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header svg {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header {\n  display: flex;\n  justify-content: space-between;\n  text-align: left;\n  color: #222;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.16), 0 1px 2px rgba(0, 0, 0, 0.23);\n  cursor: move;\n  height: 48px;\n  overflow: hidden;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-title,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-toolbar {\n  flex-shrink: 3;\n  font-size: 18px;\n  margin: 0;\n  font-weight: 400;\n  line-height: 48px;\n  vertical-align: top;\n  padding: 0 10px;\n}\n@media (max-width: 480px) {\n  .jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-title,\n  .jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-toolbar {\n    padding-left: 0;\n  }\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header button {\n  margin-right: 10px;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-button {\n  color: #222;\n  font-size: 28px;\n  -webkit-transition: background-color 0.2s ease 0s;\n  transition: background-color 0.2s ease 0s;\n  flex-basis: 48px;\n  height: 48px;\n  line-height: 48px;\n  text-decoration: none;\n  text-align: center;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-button:hover {\n  background-color: #ecebe9;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar {\n  background: transparent;\n  display: block;\n  height: 100%;\n  border: 0;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar > li.jodit_toolbar_btn {\n  vertical-align: middle;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar > li.jodit_toolbar_btn input[type=number],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar > li.jodit_toolbar_btn input[type=text],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar > li.jodit_toolbar_btn input[type=url],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar > li.jodit_toolbar_btn select {\n  margin: 0 5px;\n  padding-left: 10px;\n  width: auto;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content {\n  height: calc(100% - 48px);\n  overflow: auto;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group {\n  margin-bottom: 10px;\n  padding: 0 10px;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group:first-child {\n  margin-top: 10px;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group label {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: 700;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input.select,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=number],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=text],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=url],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select.select,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=number],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=text],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=url] {\n  display: block;\n  height: 34px;\n  padding: 6px 4px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #555;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 0;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);\n  -webkit-transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input.select:focus,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=number]:focus,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=text]:focus,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=url]:focus,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select.select:focus,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=number]:focus,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=text]:focus,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=url]:focus {\n  border-color: #66afe9;\n  outline: 0;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input.select[disabled],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=number][disabled],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=text][disabled],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=url][disabled],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select.select[disabled],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=number][disabled],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=text][disabled],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=url][disabled] {\n  background-color: #f0f0f0;\n  color: #ccc;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input.select:not([class*=col-]),\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=number]:not([class*=col-]),\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=text]:not([class*=col-]),\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=url]:not([class*=col-]),\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select.select:not([class*=col-]),\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=number]:not([class*=col-]),\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=text]:not([class*=col-]),\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=url]:not([class*=col-]) {\n  width: 100%;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group {\n  display: table;\n  border-collapse: separate;\n  width: 100%;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group > * {\n  vertical-align: middle;\n  display: table-cell;\n  height: 34px;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group > input {\n  float: left;\n  margin: 0 !important;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group > input:not([class*=col-]) {\n  width: 100%;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group-buttons {\n  width: 1%;\n  font-size: 0;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group-buttons > a {\n  text-align: center;\n  display: inline-block;\n  border: 1px solid #ccc;\n  margin-left: -1px;\n  position: relative;\n  height: 34px;\n  line-height: 34px;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_footer {\n  padding: 0 10px;\n  padding-top: 10px;\n  text-align: center;\n  height: 48px;\n  display: none;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button {\n  width: auto;\n  margin-bottom: 10px;\n  height: 32px;\n  line-height: 100%;\n  padding: 0 15px;\n  background-color: #ccc;\n  border: 1px solid #ccc;\n  color: #000;\n  font-size: 0;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button:before {\n  content: \"\";\n  display: inline-block;\n  vertical-align: middle;\n  height: 100%;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button svg {\n  display: inline-block;\n  width: 24px;\n  height: 24px;\n  vertical-align: middle;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button span {\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 14px;\n  margin-left: 5px;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button:focus {\n  border: 1px solid #8bade4;\n  outline: 1px solid #82b2e8;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button:nth-child(n+2) {\n  margin-left: 10px;\n}\n.jodit_dialog_box .jodit_dialog.with_footer .jodit_dialog_content {\n  height: calc(100% - 96px);\n}\n.jodit_dialog_box .jodit_dialog.with_footer .jodit_dialog_footer {\n  display: block;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_resizer {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  cursor: se-resize;\n  width: 7px;\n  height: 7px;\n  display: inline-block;\n  background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADFJREFUeNpilJGRYcACIoB4ORMuCSCOZMIlga4TRQJZJ4YETCdWCSBmZMIlATIOIMAAEyAPt4RnNx0AAAAASUVORK5CYII=\");\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_resizer:hover {\n  border-color: rgba(0, 0, 0, 0.6);\n}\n@media (max-width: 480px) {\n  .jodit_dialog_box .jodit_dialog .jodit_dialog_resizer {\n    display: none;\n  }\n}\n.jodit_dialog_box.jodit_fullsize .jodit_dialog {\n  top: 0!important;\n  bottom: 0!important;\n  left: 0!important;\n  right: 0!important;\n  width: 100%!important;\n  height: 100% !important;\n}\n.jodit_dialog_box.jodit_fullsize .jodit_dialog .jodit_dialog_resizer {\n  display: none;\n}\n@media (max-width: 768px) {\n  .jodit_dialog_header .jodit_input,\n  .jodit_dialog_header .jodit_toolbar_btn-filter,\n  .jodit_dialog_header .jodit_toolbar_btn-separator,\n  .jodit_dialog_header .jodit_toolbar_btn-sort,\n  .jodit_dialog_header_fullsize,\n  .jodit_dialog_header_title {\n    display: none !important;\n  }\n}\n.jodit_toolbar_list > .jodit_toolbar {\n  max-height: 400px;\n  overflow: auto;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);\n  padding: 0;\n  margin: auto;\n  text-align: left;\n  box-sizing: border-box;\n  -webkit-transition: max-height 0.2s ease 0s;\n  transition: max-height 0.2s ease 0s;\n  margin-top: 0!important;\n  list-style-type: none;\n  font-size: 16px;\n  z-index: 8;\n  position: absolute;\n  left: 0;\n  top: 100%;\n}\n.jodit_toolbar_list > .jodit_toolbar,\n.jodit_toolbar_list > .jodit_toolbar .jodit_toolbar {\n  background: #f9f9f9;\n}\n.jodit_toolbar_list > .jodit_toolbar blockquote,\n.jodit_toolbar_list > .jodit_toolbar h1,\n.jodit_toolbar_list > .jodit_toolbar h2,\n.jodit_toolbar_list > .jodit_toolbar h3,\n.jodit_toolbar_list > .jodit_toolbar h4,\n.jodit_toolbar_list > .jodit_toolbar h5,\n.jodit_toolbar_list > .jodit_toolbar p,\n.jodit_toolbar_list > .jodit_toolbar pre {\n  font-family: Helvetica, sans-serif;\n  margin: 0;\n  padding: 0;\n  font-weight: 400;\n}\n.jodit_toolbar_list > .jodit_toolbar h5 {\n  font-size: 0.8em;\n  line-height: 1.4;\n}\n.jodit_toolbar_list > .jodit_toolbar h3 {\n  font-size: 1.31em;\n  line-height: 1.4;\n}\n.jodit_toolbar_list > .jodit_toolbar h4,\n.jodit_toolbar_list > .jodit_toolbar p {\n  font-size: 1em;\n  line-height: 1.5em;\n}\n.jodit_toolbar_list > .jodit_toolbar h2 {\n  font-size: 1.74em;\n  line-height: 1.4;\n}\n.jodit_toolbar_list > .jodit_toolbar h1 {\n  font-size: 2.17em;\n  line-height: 1.4;\n}\n.jodit_toolbar_list > .jodit_toolbar blockquote,\n.jodit_toolbar_list > .jodit_toolbar pre {\n  font-family: monospace;\n}\n.jodit_toolbar_list > .jodit_toolbar li.jodit_toolbar_btn {\n  display: block;\n  cursor: pointer;\n  white-space: nowrap;\n  color: inherit;\n  text-decoration: none;\n  width: 100%;\n  height: auto;\n  box-sizing: border-box;\n  text-align: left;\n}\n.jodit_toolbar_list > .jodit_toolbar li.jodit_toolbar_btn > a {\n  background-image: none;\n  padding: 7px 24px;\n  cursor: pointer;\n  line-height: 100%;\n  width: auto;\n  height: auto;\n  display: block;\n}\n.jodit_toolbar_list > .jodit_toolbar li.jodit_toolbar_btn > a > span {\n  display: inline-block;\n}\n.jodit_toolbar_list > .jodit_toolbar li.jodit_toolbar_btn > a:hover {\n  background-color: #f3f0f0;\n}\n.jodit_toolbar_list > .jodit_toolbar li.jodit_toolbar_btn > a:after {\n  display: none;\n}\n.jodit_toolbar[dir=rtl] .jodit_toolbar_list > .jodit_toolbar,\n.jodit_toolbar[dir=rtl] .jodit_toolbar_list > .jodit_toolbar li.jodit_toolbar_btn {\n  text-align: right;\n}\n.jodit_filebrowser {\n  font-family: Helvetica, sans-serif;\n  font-size: 0;\n  height: 100%;\n}\n.jodit_filebrowser .jodit_filebrowser_loader {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n.jodit_filebrowser .jodit_filebrowser_loader i {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  margin-top: -64px;\n  margin-left: -64px;\n}\n.jodit_filebrowser .jodit_filebrowser_status {\n  position: absolute;\n  font-size: 10px;\n  padding: 2px 3px;\n  border-top: 1px solid hsla(0, 0%, 50%, 0.4);\n  left: 31%;\n  right: 0;\n  bottom: 0;\n  background-color: #4a4a4a;\n  visibility: hidden;\n  opacity: 0;\n  -webkit-transition: opacity 0.3s linear;\n  transition: opacity 0.3s linear;\n  color: #b38888;\n  word-break: break-all;\n}\n.jodit_filebrowser .jodit_filebrowser_status.success {\n  color: #c5c5c5;\n}\n.jodit_filebrowser .jodit_filebrowser_status.active {\n  visibility: visible;\n  opacity: 1;\n}\n.jodit_filebrowser .jodit_filebrowser_files,\n.jodit_filebrowser .jodit_filebrowser_tree {\n  display: none;\n  vertical-align: top;\n  height: 100%;\n  position: relative;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active,\n.jodit_filebrowser .jodit_filebrowser_tree.active {\n  display: inline-block;\n}\n.jodit_filebrowser .jodit_filebrowser_files::-webkit-scrollbar,\n.jodit_filebrowser .jodit_filebrowser_tree::-webkit-scrollbar {\n  width: 5px;\n}\n.jodit_filebrowser .jodit_filebrowser_files::-webkit-scrollbar-track,\n.jodit_filebrowser .jodit_filebrowser_tree::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n.jodit_filebrowser .jodit_filebrowser_files::-webkit-scrollbar-thumb,\n.jodit_filebrowser .jodit_filebrowser_tree::-webkit-scrollbar-thumb {\n  background-color: #a9a9a9;\n  outline: 1px solid #708090;\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active {\n  width: 31%;\n  background-color: #3f3f3f;\n  overflow-y: auto;\n}\n@media (max-width: 480px) {\n  .jodit_filebrowser .jodit_filebrowser_tree.active {\n    display: none;\n  }\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active::-webkit-scrollbar {\n  width: 5px;\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active::-webkit-scrollbar-thumb {\n  background-color: hsla(0, 0%, 50%, 0.5);\n  outline: 1px solid #708090;\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active .jodit_filebrowser_source_title {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  display: block;\n  padding: 10px;\n  color: #969696;\n  border-bottom: 1px solid #484848;\n  line-height: 17px;\n  min-height: 38px;\n  position: relative;\n  word-break: break-all;\n  background: #5a5a5a;\n  font-size: 16px;\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a {\n  display: block;\n  padding: 10px 20px;\n  text-decoration: none;\n  color: #b1b1b1;\n  font-weight: 600;\n  -webkit-transition: background-color 0.2s ease 0s;\n  transition: background-color 0.2s ease 0s;\n  border-bottom: 1px solid #474747;\n  line-height: 17px;\n  min-height: 38px;\n  position: relative;\n  word-break: break-all;\n  font-size: 16px;\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a i.remove {\n  height: 16px;\n  width: 16px;\n  line-height: 17px;\n  font-size: 16px;\n  position: absolute;\n  right: 5px;\n  top: 11px;\n  opacity: 0;\n  padding-left: 3px;\n  display: inline-block;\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a i.remove:hover {\n  background: #696969;\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a:hover {\n  color: #222;\n  background-color: #ecebe9;\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a:hover i.remove {\n  opacity: 0.6;\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a.jodit_button {\n  cursor: pointer;\n  background: #696969;\n  text-align: center;\n  width: auto;\n  height: 38px;\n  color: #333;\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a.jodit_button svg {\n  vertical-align: top;\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a.jodit_button:not(.disabled):hover {\n  background-color: #ecebe9;\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a.jodit_button.disabled,\n.jodit_filebrowser .jodit_filebrowser_tree.active a.jodit_button:hover i {\n  opacity: 0.7;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active {\n  width: 100%;\n  overflow-y: auto;\n  padding: 10px;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active .jodit_filebrowser_source_title {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  margin: -10px -10px 0;\n  display: block;\n  padding: 10px;\n  line-height: 17px;\n  min-height: 38px;\n  position: relative;\n  word-break: break-all;\n  background: #5a5a5a;\n  font-size: 16px;\n  color: #969696;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a + .jodit_filebrowser_source_title {\n  margin-top: 10px;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a {\n  vertical-align: top;\n  display: inline-block;\n  width: 150px;\n  height: 150px;\n  line-height: 150px;\n  text-align: center;\n  border: 1px solid #ccc;\n  margin: 5px 5px 10px;\n  font-size: 0;\n  overflow: hidden;\n  -webkit-transition: border 0.1s linear, bottom 0.1s linear;\n  transition: border 0.1s linear, bottom 0.1s linear;\n  box-sizing: content-box;\n  position: relative;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a img {\n  max-width: 100%;\n  vertical-align: middle;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a:hover {\n  border-color: #433b5c;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a.active {\n  border-color: #1e88e5;\n  background-color: #b5b5b5;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a .jodit_filebrowser_files_item-info {\n  position: absolute;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  white-space: normal;\n  opacity: 0.85;\n  overflow: visible;\n  padding: 0.3em 0.6em;\n  -webkit-transition: opacity 0.4s ease;\n  transition: opacity 0.4s ease;\n  background-color: #e9e9e9;\n  color: #333;\n  text-shadow: #eee 0 1px 0;\n  font-size: 14px;\n  line-height: 16px;\n  text-align: left;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a .jodit_filebrowser_files_item-info > span {\n  display: block;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  font-size: 0.75em;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a .jodit_filebrowser_files_item-info > span.jodit_filebrowser_files_item-info-filename {\n  font-weight: 700;\n  font-size: 0.9em;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a.active .jodit_filebrowser_files_item-info {\n  background-color: #b5b5b5;\n  color: #fff;\n  text-shadow: none;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a:hover .jodit_filebrowser_files_item-info {\n  bottom: -100px;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list {\n  scroll-behavior: smooth;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a {\n  display: block;\n  width: 100%;\n  height: 26px;\n  line-height: 26px;\n  margin: 0;\n  border-width: 0 0 1px;\n  text-align: left;\n  white-space: nowrap;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a img {\n  min-width: 16px;\n  max-width: 16px;\n  vertical-align: middle;\n  display: inline-block;\n  margin-left: 4px;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a .jodit_filebrowser_files_item-info {\n  padding: 0;\n  position: static;\n  display: inline-block;\n  width: calc(100% - 20px);\n  margin-left: 4px;\n  background-color: transparent;\n  height: 100%;\n  line-height: inherit;\n  vertical-align: middle;\n  font-size: 0;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a .jodit_filebrowser_files_item-info > span {\n  display: inline-block;\n  height: 100%;\n  font-size: 12px;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a .jodit_filebrowser_files_item-info > span.jodit_filebrowser_files_item-info-filename {\n  width: 50%;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a .jodit_filebrowser_files_item-info > span.jodit_filebrowser_files_item-info-filechanged,\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a .jodit_filebrowser_files_item-info > span.jodit_filebrowser_files_item-info-filesize {\n  width: 25%;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a:hover {\n  background-color: #433b5c;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a:hover .jodit_filebrowser_files_item-info {\n  color: #fff;\n  text-shadow: none;\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a:before {\n  height: 100%;\n  content: \"\";\n  vertical-align: middle;\n  display: inline-block;\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active + .jodit_filebrowser_files.active {\n  width: 69%;\n}\n@media (max-width: 480px) {\n  .jodit_filebrowser .jodit_filebrowser_tree.active + .jodit_filebrowser_files.active {\n    width: auto;\n    display: block;\n  }\n}\n.jodit_filebrowser_preview {\n  text-align: center;\n  min-width: 300px;\n  max-width: 900px;\n  max-height: 700px;\n  min-height: 700px;\n  position: relative;\n}\n.jodit_filebrowser_preview .jodit_filebrowser_preview_navigation {\n  position: absolute;\n  top: 0;\n  height: 100%;\n  left: 0;\n}\n.jodit_filebrowser_preview .jodit_filebrowser_preview_navigation-next {\n  left: auto;\n  right: 0;\n}\n.jodit_filebrowser_preview .jodit_filebrowser_preview_navigation svg {\n  width: 45px;\n  height: 45px;\n  position: relative;\n  top: 50%;\n  margin-top: -22px;\n  -webkit-transition: fill 0.3s linear;\n  transition: fill 0.3s linear;\n  fill: #9e9ba7;\n}\n.jodit_filebrowser_preview .jodit_filebrowser_preview_navigation:hover svg {\n  fill: #000;\n}\n.jodit_filebrowser_preview img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.jodit_draghover {\n  background-color: #ecebe9;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-title .jodit_upload_button {\n  position: relative;\n  width: 220px;\n  border: 0;\n  padding: 25px 0;\n  margin: 10px 0;\n  overflow: hidden;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-title .jodit_upload_button input {\n  cursor: pointer;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  margin: 0 -10px 0 0;\n  padding: 0;\n  opacity: 0;\n  font-size: 400px;\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-title.jodit_filebrowser_title_box {\n  padding-left: 10px;\n}\n.jodit_grid {\n  width: 100%;\n}\n.jodit_grid [class*=jodit_col-] {\n  display: block;\n  float: left;\n}\n.jodit_grid .jodit_col-lg-5-5 {\n  width: 100%;\n}\n.jodit_grid .jodit_col-lg-4-5 {\n  width: 80%;\n}\n.jodit_grid .jodit_col-lg-3-5 {\n  width: 60%;\n}\n.jodit_grid .jodit_col-lg-2-5 {\n  width: 40%;\n}\n.jodit_grid .jodit_col-lg-1-5 {\n  width: 20%;\n}\n.jodit_grid .jodit_col-lg-4-4 {\n  width: 100%;\n}\n.jodit_grid .jodit_col-lg-3-4 {\n  width: 75%;\n}\n.jodit_grid .jodit_col-lg-2-4 {\n  width: 50%;\n}\n.jodit_grid .jodit_col-lg-1-4 {\n  width: 25%;\n}\n.jodit_grid:after,\n.jodit_grid:before {\n  content: \" \";\n  display: table;\n}\n.jodit_grid:after {\n  clear: both;\n}\n@-webkit-keyframes a {\n  to {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n@keyframes a {\n  to {\n    -webkit-transform: rotate(1turn);\n    transform: rotate(1turn);\n  }\n}\n.jodit_icon-loader {\n  background: url(\"data:image/png;base64,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\") no-repeat 50%;\n  background-size: 100% 100%;\n  width: 128px;\n  height: 128px;\n  will-change: transform;\n  -webkit-animation: a 2s ease-out 0s infinite;\n  animation: a 2s ease-out 0s infinite;\n}\n.jodit_icon,\n.jodit_icon-loader {\n  display: inline-block;\n  vertical-align: middle;\n}\n.jodit_icon {\n  font-style: normal;\n  width: 14px;\n  height: 14px;\n  font-size: 8px;\n  fill: #222;\n  -webkit-transform-origin: 0 0!important;\n  transform-origin: 0 0!important;\n  overflow: visible;\n  background: 50% no-repeat;\n  background-size: contain;\n}\nsvg.jodit_icon {\n  height: auto;\n}\n.jodit_text_icon {\n  font-size: 14px;\n}\n.jodit_toolbar_size-small .jodit_icon {\n  min-width: 12px;\n  height: 12px;\n  line-height: 12px;\n}\n.jodit_toolbar_size-large .jodit_icon {\n  min-width: 16px;\n  height: 16px;\n  line-height: 16px;\n}\n.jodit_image_editor {\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n  overflow: hidden;\n}\n@media (max-width: 768px) {\n  .jodit_image_editor {\n    height: auto;\n  }\n}\n.jodit_image_editor > div,\n.jodit_image_editor > div > div {\n  height: 100%;\n}\n@media (max-width: 768px) {\n  .jodit_image_editor > div,\n  .jodit_image_editor > div > div {\n    height: auto;\n    min-height: 200px;\n  }\n}\n.jodit_image_editor * {\n  box-sizing: border-box;\n}\n.jodit_image_editor .jodit_image_editor_slider-title {\n  text-shadow: #f3f3f3 0 1px 0;\n  color: #333;\n  border-bottom: 1px solid hsla(0, 0%, 62%, 0.31);\n  background-color: #f9f9f9;\n  padding: 0.8em 1em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  font-weight: 700;\n  line-height: 1em;\n}\n.jodit_image_editor .jodit_image_editor_slider-title svg {\n  margin-right: 10px;\n  width: 16px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.jodit_image_editor .jodit_image_editor_slider-content {\n  display: none;\n}\n.jodit_image_editor .jodit_image_editor_slider.active .jodit_image_editor_slider-title {\n  background-color: #5d5d5d;\n  color: #fff;\n  text-shadow: #000 0 1px 0;\n}\n.jodit_image_editor .jodit_image_editor_slider.active .jodit_image_editor_slider-title svg {\n  fill: #fff;\n}\n.jodit_image_editor .jodit_image_editor_slider.active .jodit_image_editor_slider-content {\n  display: block;\n}\n.jodit_image_editor_area {\n  background-color: #eee;\n  background-image: -webkit-linear-gradient(45deg, #ccc 25%, transparent 0, transparent 75%, #ccc 0, #ccc), -webkit-linear-gradient(45deg, #ccc 25%, transparent 0, transparent 75%, #ccc 0, #ccc);\n  background-image: linear-gradient(45deg, #ccc 25%, transparent 0, transparent 75%, #ccc 0, #ccc), linear-gradient(45deg, #ccc 25%, transparent 0, transparent 75%, #ccc 0, #ccc);\n  background-size: 30px 30px;\n  background-position: 0 0,15px 15px;\n  height: 100%;\n  overflow: hidden;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  position: relative;\n  display: none;\n}\n.jodit_image_editor_area.active {\n  display: block;\n}\n.jodit_image_editor_area .jodit_image_editor_box {\n  overflow: hidden;\n  position: relative;\n  z-index: 1;\n  pointer-events: none;\n  height: 100%;\n}\n.jodit_image_editor_area .jodit_image_editor_box img {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  max-width: 100%;\n  max-height: 100%;\n}\n.jodit_image_editor_area .jodit_image_editor_croper,\n.jodit_image_editor_area .jodit_image_editor_resizer {\n  z-index: 2;\n  width: 100px;\n  height: 100px;\n  position: absolute;\n  box-shadow: 0 0 11px #000;\n  border: 1px solid #fff;\n  background-repeat: no-repeat;\n  top: 10px;\n  left: 20px;\n  pointer-events: none;\n}\n.jodit_image_editor_area .jodit_image_editor_croper i.jodit_bottomright,\n.jodit_image_editor_area .jodit_image_editor_resizer i.jodit_bottomright {\n  position: absolute;\n  display: inline-block;\n  border: 1px solid #383838;\n  z-index: 4;\n  background-color: #8c7878;\n  cursor: se-resize;\n  border-radius: 10px;\n  height: 20px;\n  width: 20px;\n  right: -10px;\n  bottom: -10px;\n  box-shadow: 0 0 11px #000;\n  pointer-events: all;\n}\n.jodit_image_editor_area .jodit_image_editor_croper i.jodit_bottomright:active,\n.jodit_image_editor_area .jodit_image_editor_resizer i.jodit_bottomright:active {\n  border: 1px solid #ff0;\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop {\n  height: 100%;\n  background: #eee;\n  text-align: center;\n  line-height: 100%;\n  position: relative;\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop:before {\n  content: \"\";\n  line-height: 100%;\n  vertical-align: middle;\n  height: 100%;\n  display: inline-block;\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box {\n  height: 100%;\n  overflow: visible;\n  display: inline-block;\n  vertical-align: middle;\n  pointer-events: all;\n  font-size: 0;\n  text-align: left;\n  line-height: 100%;\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box img {\n  max-width: 100%;\n  max-height: 100%;\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box:before {\n  content: \"\";\n  line-height: 100%;\n  vertical-align: middle;\n  height: 100%;\n  display: inline-block;\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto;\n  background: hsla(0, 0%, 100%, 0.3);\n  z-index: 1;\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box .jodit_image_editor_croper {\n  pointer-events: all;\n  cursor: move;\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box .jodit_image_editor_croper i.jodit_sizes {\n  font-size: 12px;\n  white-space: pre;\n  position: absolute;\n  bottom: -30px;\n  left: 100%;\n  text-align: center;\n  color: #fff;\n  text-shadow: none;\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 0.4em;\n  padding: 9px 6px;\n  display: block;\n}\n.jodit_properties svg {\n  font-style: normal;\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  line-height: 14px;\n  font-size: 8px;\n  overflow: hidden;\n  vertical-align: middle;\n  fill: #222;\n  -webkit-transform-origin: 0 0!important;\n  transform-origin: 0 0 !important;\n}\n.jodit_properties #tabsbox {\n  padding: 10px;\n}\n.jodit_properties #tabsbox .jodit_form_group {\n  padding: 0;\n}\n.jodit_properties .jodit_properties_view_box {\n  padding: 10px;\n}\n.jodit_properties .jodit_properties_view_box .jodit_properties_image_view {\n  height: 150px;\n  text-align: center;\n  line-height: 1;\n  vertical-align: middle;\n  padding: 0;\n  background-color: #f6f6f6;\n  margin: 0;\n  vertical-align: baseline;\n  font-size: 100%;\n  margin-bottom: 10px;\n}\n.jodit_properties .jodit_properties_view_box .jodit_properties_image_view:before {\n  content: \"\";\n  display: inline-block;\n  vertical-align: middle;\n  height: 100%;\n}\n.jodit_properties .jodit_properties_view_box .jodit_properties_image_view img {\n  max-width: 100%;\n  max-height: 100%;\n  vertical-align: middle;\n}\n.jodit_properties .jodit_properties_view_box .jodit_properties_image_sizes.jodit_form_group {\n  padding: 0!important;\n  margin: 0 !important;\n}\n.jodit_properties .jodit_properties_view_box .jodit_properties_image_sizes.jodit_form_group a {\n  display: inline-block;\n  cursor: pointer;\n}\n.jodit_properties .jodit_properties_view_box .jodit_properties_image_sizes.jodit_form_group input[type=number] {\n  display: inline-block !important;\n  width: calc(50% - 8px) !important;\n}\n.jodit_toolbar,\n.jodit_toolbar * {\n  box-sizing: border-box;\n}\n.jodit_toolbar {\n  position: relative;\n  left: 0;\n  top: 0;\n  margin: 0!important;\n  padding: 0!important;\n  list-style: none!important;\n  font-size: 0;\n  background: #f9f9f9;\n  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.14);\n  border: 1px solid #ccc;\n  border-bottom: 0;\n  min-height: 16px !important;\n}\n.jodit_toolbar + .jodit_toolbar_dummy {\n  display: none;\n}\n.jodit_toolbar.jodit_fly {\n  position: absolute;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  background: #fff;\n}\n.jodit_toolbar.jodit_sticky {\n  position: fixed;\n  position: -webkit-sticky;\n  position: sticky;\n  z-index: 3;\n  top: 0;\n  left: auto;\n}\n.jodit_toolbar.jodit_sticky + .jodit_toolbar_dummy {\n  display: block;\n}\n.jodit_toolbar .jodit_toolbar_btn > a {\n  color: #000;\n  text-decoration: none;\n  display: block;\n  background: no-repeat 50%;\n}\n.jodit_toolbar > li.jodit_toolbar_btn {\n  display: inline-block;\n  vertical-align: top;\n  margin: 0!important;\n  padding: 0;\n  list-style: none!important;\n  outline: none;\n  position: relative;\n  text-align: center;\n  cursor: pointer;\n  -webkit-transition: background-color 0.2s linear, opacity 0.1s linear;\n  transition: background-color 0.2s linear, opacity 0.1s linear;\n}\n.jodit_toolbar > li.jodit_toolbar_btn.jodit_disabled {\n  background-color: transparent!important;\n  opacity: 0.3;\n  cursor: default;\n}\n.jodit_toolbar > li.jodit_toolbar_btn.jodit_disabled a {\n  cursor: default;\n}\n.jodit_toolbar > li.jodit_toolbar_btn.jodit_toolbar_btn-separator {\n  border-left: 0;\n  border-right: 1px solid #e6e6e6;\n  padding: 0;\n  margin: 2px 3px 0!important;\n  cursor: default;\n}\n.jodit_toolbar > li.jodit_toolbar_btn.jodit_toolbar_btn-break {\n  display: block!important;\n  width: auto;\n  border-top: 1px solid #e6e6e6;\n  height: 0;\n  margin: 0 3px !important;\n}\n.jodit_toolbar > li.jodit_toolbar_btn .jodit_toolbar_btn > a,\n.jodit_toolbar > li.jodit_toolbar_btn > a {\n  width: 100%;\n  height: 100%;\n  display: inline-block;\n  outline: none;\n  text-decoration: none;\n}\n.jodit_toolbar > li.jodit_toolbar_btn .jodit_toolbar_btn > a:after,\n.jodit_toolbar > li.jodit_toolbar_btn > a:after {\n  content: \"\";\n  display: inline-block;\n  height: 100%;\n  vertical-align: middle;\n}\n.jodit_toolbar > li.jodit_toolbar_btn .jodit_toolbar_btn > a:active + .jodit_tooltip,\n.jodit_toolbar > li.jodit_toolbar_btn > a:active + .jodit_tooltip {\n  visibility: hidden !important;\n}\n.jodit_toolbar > li.jodit_toolbar_btn.jodit_disabled .jodit_tooltip {\n  display: none !important;\n}\n.jodit_toolbar > li.jodit_toolbar_btn > a {\n  line-height: 100%;\n}\n.jodit_toolbar > li.jodit_toolbar_btn.jodit_dropdown_open .jodit_tooltip,\n.jodit_toolbar > li.jodit_toolbar_btn .jodit_popap_open,\n.jodit_toolbar > li.jodit_toolbar_btn.jodit_popup_open .jodit_tooltip {\n  visibility: hidden !important;\n}\n.jodit_toolbar > li.jodit_toolbar_btn:not(.jodit_toolbar-input):hover {\n  background-color: #dde4ef;\n  outline: none;\n}\n.jodit_toolbar > li.jodit_toolbar_btn.jodit_active,\n.jodit_toolbar > li.jodit_toolbar_btn:not(.jodit_toolbar-input):active {\n  background-color: hsla(0, 0%, 87%, 0.4);\n  outline: none;\n}\n.jodit_toolbar > li.jodit_toolbar_btn.jodit-btn-hidden {\n  display: none !important;\n}\n.jodit_toolbar > li.jodit_toolbar_btn.jodit_with_dropdownlist .jodit_with_dropdownlist-trigger {\n  width: 0;\n  height: 0;\n  border-right: 3px solid transparent;\n  border-left: 3px solid transparent;\n  border-top: 3px solid #4c4c4c;\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 3px;\n}\n.jodit_toolbar > li.jodit_toolbar_btn.jodit_toolbar-input input,\n.jodit_toolbar > li.jodit_toolbar_btn.jodit_toolbar-input select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  height: 100%;\n  border-radius: 0;\n  outline: none;\n  line-height: 100%;\n}\n.jodit_toolbar > li.jodit_toolbar_btn.jodit_toolbar-input select {\n  padding-right: 20px;\n  background: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+) no-repeat 98% 50% !important;\n}\n.jodit_toolbar > li {\n  min-width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n.jodit_toolbar > li.jodit_toolbar_btn-separator {\n  height: 28px;\n  width: 0;\n  min-width: 0;\n}\n.jodit_tooltip {\n  position: absolute;\n  background: #727171;\n  color: #fff;\n  font-size: 12px;\n  line-height: 15px;\n  padding: 4px 5px;\n  font-family: Arial, sans-serif;\n  z-index: 9;\n  width: 90px;\n  -webkit-transition: opacity 0.3s linear;\n  transition: opacity 0.3s linear;\n}\n@media (max-width: 768px) {\n  .jodit_tooltip {\n    display: none;\n  }\n}\n.jodit_toolbar_size-small .jodit_toolbar {\n  min-height: 12px !important;\n}\n.jodit_toolbar_size-small .jodit_toolbar > li {\n  min-width: 24px;\n  height: 24px;\n  line-height: 24px;\n}\n.jodit_toolbar_size-small .jodit_toolbar > li.jodit_toolbar_btn-separator {\n  height: 20px;\n  width: 0;\n  min-width: 0;\n}\n.jodit_toolbar_size-large .jodit_toolbar {\n  min-height: 18px !important;\n}\n.jodit_toolbar_size-large .jodit_toolbar > li {\n  min-width: 36px;\n  height: 36px;\n  line-height: 36px;\n}\n.jodit_toolbar_size-large .jodit_toolbar > li.jodit_toolbar_btn-separator {\n  height: 32px;\n  width: 0;\n  min-width: 0;\n}\n.jodit_toolbar_popup {\n  position: absolute;\n  z-index: 7;\n  top: 100%;\n  margin-top: 10px;\n  padding-top: 0;\n  left: 0;\n  font-size: 14px;\n  line-height: 14px!important;\n  background: #fff;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  border: 1px solid rgba(0, 0, 0, 0.2);\n}\n.jodit_toolbar_popup .jodit_toolbar {\n  box-shadow: none;\n  border-width: 0;\n  background-color: transparent;\n}\n.jodit_toolbar_popup .jodit_toolbar .jodit_toolbar {\n  background-color: #f9f9f9;\n  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.14);\n  border: 1px solid #ccc;\n}\n.jodit_toolbar_popup > * {\n  margin: 10px;\n}\n.jodit_toolbar_popup .jodit_popup_triangle {\n  padding: 0;\n  margin: 0;\n  width: 8px;\n  height: 8px;\n  position: absolute;\n  top: -5px;\n  left: 9px;\n  display: inline-block;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-width: 1px 0 0 1px;\n  z-index: 5;\n}\n.jodit_toolbar_popup.jodit_right {\n  left: auto;\n  right: 0;\n}\n.jodit_toolbar_popup.jodit_right:before {\n  left: auto;\n  right: 14px;\n}\n.jodit_toolbar .jodit_toolbar_btn > svg {\n  max-width: 50%;\n  vertical-align: middle;\n  font-smoothing: antialiased;\n}\n.jodit_container > .jodit_toolbar > li:first-child {\n  margin-left: 2px !important;\n}\n.jodit_container[dir=rtl] > .jodit_toolbar > li:first-child {\n  margin-left: 0!important;\n  margin-right: 2px !important;\n}\n.jodit_draganddrop_file_box,\n.jodit_uploadfile_button {\n  position: relative;\n  width: 220px;\n  border: 1px dashed #ccc;\n  padding: 25px 0;\n  margin: 10px 0;\n  text-align: center;\n  overflow: hidden;\n}\n.jodit_draganddrop_file_box:hover,\n.jodit_uploadfile_button:hover {\n  background-color: #ecebe9;\n}\n.jodit_draganddrop_file_box input,\n.jodit_uploadfile_button input {\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  margin: 0;\n  padding: 0;\n  opacity: 0;\n  font-size: 400px;\n}\n@media (max-width: 768px) {\n  .jodit_draganddrop_file_box {\n    width: auto;\n    max-width: 100%;\n    min-width: 120px;\n  }\n}\n.jodit_statusbar {\n  border: 1px solid #ccc;\n  border-top: 0;\n  font-size: 0;\n  background-color: #f9f9f9;\n  padding: 0 5px;\n}\n.jodit_statusbar .jodit_statusbar_item {\n  font-size: 11px;\n  float: left;\n  line-height: 1.57142857em;\n  margin: 0 10px 0 0;\n  padding: 0;\n  vertical-align: middle;\n}\n.jodit_statusbar .jodit_statusbar_item.jodit_statusbar_item-right {\n  float: right;\n  margin: 0 0 0 10px;\n}\n.jodit_statusbar .jodit_statusbar_item li,\n.jodit_statusbar .jodit_statusbar_item ul {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: inline-block;\n  vertical-align: top;\n  position: relative;\n}\n.jodit_statusbar .jodit_statusbar_item li li,\n.jodit_statusbar .jodit_statusbar_item ul li {\n  margin-right: 5px;\n}\n.jodit_statusbar .jodit_statusbar_item a,\n.jodit_statusbar .jodit_statusbar_item span {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  display: inline-block;\n  vertical-align: baseline;\n  text-align: left;\n  white-space: nowrap;\n  padding: 2px 3px;\n  line-height: 10px;\n  outline: 0;\n  border: 0;\n  color: #222;\n}\n.jodit_statusbar .jodit_statusbar_item a span,\n.jodit_statusbar .jodit_statusbar_item span span {\n  padding: 0;\n}\n.jodit_statusbar .jodit_statusbar_item svg {\n  width: 11px;\n  height: 11px;\n  display: inline-block;\n  vertical-align: top;\n}\n.jodit_statusbar .jodit_statusbar_item a {\n  text-decoration: none;\n  cursor: default;\n  border-radius: 3px;\n}\n.jodit_statusbar .jodit_statusbar_item a:hover {\n  background-color: hsla(0, 0%, 88%, 0.99);\n  text-decoration: none;\n  color: #222;\n}\n.jodit_statusbar:after {\n  content: \" \";\n  display: block;\n  visibility: hidden;\n  font-size: 0;\n  height: 0;\n  float: none;\n  clear: both;\n}\n.jodit_disabled .jodit_statusbar {\n  opacity: 0.4;\n}\n.jodit_form {\n  color: #000;\n}\n.jodit_form input[type=text],\n.jodit_form input[type=url],\n.jodit_form textarea {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  display: block;\n  outline: none;\n  border: 1px solid #b5b5b5;\n  height: 28px;\n  line-height: 28px;\n  padding: 0 5px;\n  min-width: 220px;\n  margin-top: 10px;\n}\n.jodit_form input[type=text].jodit_error,\n.jodit_form input[type=url].jodit_error,\n.jodit_form textarea.jodit_error {\n  border-color: #f7d1d1;\n  box-shadow: inset 0 0 3px 0 hsla(0, 0%, 74%, 0.3);\n}\n@media (max-width: 768px) {\n  .jodit_form input[type=text],\n  .jodit_form input[type=url],\n  .jodit_form textarea {\n    min-width: 150px;\n  }\n}\n.jodit_form textarea {\n  height: 128px;\n}\n.jodit_form button {\n  height: 36px;\n  line-height: 1;\n  color: #000;\n  padding: 10px;\n  cursor: pointer;\n  text-decoration: none;\n  border: none;\n  background: #d6d6d6;\n  font-size: 16px;\n  outline: none;\n  -webkit-transition: background 0.2s ease 0s;\n  transition: background 0.2s ease 0s;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.jodit_form button:hover {\n  background-color: #ecebe9;\n  color: #000;\n}\n.jodit_form button:active {\n  background: #ecebe9;\n  color: #000;\n}\n.jodit_form input[type=checkbox] {\n  display: inline-block;\n  z-index: 2;\n  border: 0 none;\n  cursor: pointer;\n  height: 16px;\n  margin: 0;\n  padding: 0;\n  width: 16px;\n  position: relative;\n  outline: none;\n  top: 3px;\n}\n.jodit_form input[type=checkbox]:after {\n  content: \"\";\n  background: #fff;\n  border: 1px solid hsla(0, 0%, 88%, 0.99);\n  border-radius: 2px;\n  background-clip: padding-box;\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  position: relative;\n  z-index: 1;\n  box-sizing: border-box;\n  -webkit-transition: background 0.2s ease 0s, border-color 0.2s ease 0s;\n  transition: background 0.2s ease 0s, border-color 0.2s ease 0s;\n}\n.jodit_form input[type=checkbox]:checked:after {\n  background: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Cpath d='M27 4L12 19l-7-7-5 5 12 12L32 9z' fill='%23FFF'/%3E%3C/svg%3E\") no-repeat 50%;\n  background-color: #b5b5b5;\n  border-color: #b5b5b5;\n}\n.jodit_form label {\n  margin-top: 10px;\n  display: block;\n  text-align: left;\n}\n.jodit_form form:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.jodit_about {\n  padding: 20px;\n}\n.jodit_about a {\n  color: #459ce7;\n  text-decoration: none;\n}\n.jodit_about a:focus,\n.jodit_about a:hover {\n  color: #23527c;\n  text-decoration: underline;\n  outline: 0;\n}\n.jodit_about div {\n  margin-bottom: 5px;\n}\n.jodit_colorpicker {\n  min-width: 180px;\n  text-align: left;\n  margin: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.jodit_colorpicker .jodit_colorpicker_group {\n  margin-bottom: 5px;\n  white-space: normal;\n}\n.jodit_colorpicker a {\n  width: 18px;\n  height: 18px;\n  line-height: 16px;\n  display: inline-block;\n  text-decoration: none;\n  vertical-align: middle;\n  text-align: center;\n}\n.jodit_colorpicker a:before {\n  content: \"\";\n  display: inline-block;\n  height: 100%;\n  vertical-align: middle;\n  width: 0;\n}\n.jodit_colorpicker a svg {\n  display: inline-block;\n  vertical-align: middle;\n  font-smoothing: antialiased;\n  max-width: 14px;\n}\n.jodit_colorpicker a:hover {\n  border-color: #000;\n}\n.jodit_colorpicker a:active {\n  background: #d6d6d6;\n  color: #b5b5b5;\n}\n.jodit_colorpicker .jodit_text_icon {\n  width: auto;\n  text-decoration: none;\n  color: #000;\n}\n.jodit_colorpicker span {\n  float: right;\n}\n.jodit_colorpicker span em {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  margin-right: 4px;\n}\n.jodit_colorpicker span input {\n  width: 18px;\n  height: 18px;\n  padding: 0;\n  border: none;\n  -webkit-appearance: none;\n}\n.jodit_colorpicker span input[type=color]::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n.jodit_colorpicker span input input[type=color]::-webkit-color-swatch {\n  border: none;\n}\n@-webkit-keyframes b {\n  30% {\n    opacity: 0.6;\n  }\n  60% {\n    opacity: 0;\n  }\n  to {\n    opacity: 0.6;\n  }\n}\n@keyframes b {\n  30% {\n    opacity: 0.6;\n  }\n  60% {\n    opacity: 0;\n  }\n  to {\n    opacity: 0.6;\n  }\n}\n.jodit_progress_bar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 2px;\n  z-index: 16;\n  border-radius: 1px;\n  display: none;\n}\n.jodit_progress_bar div {\n  position: relative;\n  background: #b91f1f;\n  height: 2px;\n  -webkit-transition: width 0.5s ease-out, opacity 0.5s linear;\n  transition: width 0.5s ease-out, opacity 0.5s linear;\n  will-change: width, opacity;\n}\n.jodit_progress_bar div:after,\n.jodit_progress_bar div:before {\n  -webkit-animation: b 2s ease-out 0s infinite;\n  animation: b 2s ease-out 0s infinite;\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  top: 0;\n  height: 2px;\n  box-shadow: 1px 0 6px 1px #b91f1f;\n  border-radius: 100%;\n  opacity: 0.6;\n}\n.jodit_progress_bar div:before {\n  width: 180px;\n  right: -80px;\n  clip: rect(-6px, 90px, 14px, -6px);\n}\n.jodit_progress_bar div:after {\n  width: 20px;\n  right: 0;\n  clip: rect(-6px, 22px, 14px, 10px);\n}\n.jodit_tabs .jodit_tabs_buttons {\n  line-height: 18px;\n  margin-bottom: 5px;\n  margin-top: 4px;\n}\n.jodit_tabs .jodit_tabs_buttons > a {\n  display: inline-block;\n  text-decoration: none;\n  font-size: 11px;\n  font-weight: 700;\n  text-align: center;\n  white-space: nowrap;\n  height: 29px;\n  line-height: 27px;\n  position: relative;\n  vertical-align: middle;\n  -webkit-transition: background 0.1s linear;\n  transition: background 0.1s linear;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  box-shadow: none;\n  background-color: #f5f5f5;\n  color: #737373;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  outline: none;\n}\n@media (max-width: 768px) {\n  .jodit_tabs .jodit_tabs_buttons > a {\n    width: 100%!important;\n    border-radius: 0 !important;\n  }\n}\n.jodit_tabs .jodit_tabs_buttons > a + a {\n  margin-left: -1px;\n}\n.jodit_tabs .jodit_tabs_buttons > a i,\n.jodit_tabs .jodit_tabs_buttons > a svg {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n  vertical-align: sub;\n  margin-right: 5px;\n  fill: #737373;\n}\n.jodit_tabs .jodit_tabs_buttons > a:hover {\n  border: 1px solid #c6c6c6;\n  color: #111;\n  box-shadow: none;\n  background-color: #f8f8f8;\n  outline: none;\n}\n.jodit_tabs .jodit_tabs_buttons > a:hover i,\n.jodit_tabs .jodit_tabs_buttons > a:hover svg {\n  fill: #111;\n}\n.jodit_tabs .jodit_tabs_buttons > a.active,\n.jodit_tabs .jodit_tabs_buttons > a:active {\n  outline: none;\n  background: #fff;\n  border: 1px solid #ccc;\n  color: #333;\n}\n.jodit_tabs .jodit_tabs_buttons > a.active i,\n.jodit_tabs .jodit_tabs_buttons > a.active svg,\n.jodit_tabs .jodit_tabs_buttons > a:active i,\n.jodit_tabs .jodit_tabs_buttons > a:active svg {\n  fill: #333;\n}\n.jodit_tabs .jodit_tabs_wrapper .jodit_tab {\n  display: none;\n}\n.jodit_tabs .jodit_tabs_wrapper .jodit_tab.active {\n  display: block;\n}\n.jodit_tabs .jodit_tabs_wrapper .jodit_tab .jodit_tab_empty {\n  min-width: 220px;\n  min-height: 100px;\n}\n.jodit-add-new-line {\n  z-index: 1;\n  position: absolute;\n  height: 20px;\n  line-height: 100%;\n  vertical-align: middle;\n  font-size: 0;\n  top: 0;\n  outline: none;\n  margin-top: -10px;\n  display: none;\n}\n.jodit-add-new-line,\n.jodit-add-new-line * {\n  box-sizing: border-box;\n}\n.jodit-add-new-line:before {\n  height: 100%;\n}\n.jodit-add-new-line:after,\n.jodit-add-new-line:before {\n  display: inline-block;\n  vertical-align: middle;\n  content: \"\";\n}\n.jodit-add-new-line:after {\n  box-sizing: border-box;\n  border-top: 1px solid #ccc;\n  height: 1px;\n  width: calc(100% - 30px);\n}\n.jodit-add-new-line span {\n  right: 0;\n  position: absolute;\n  display: inline-block;\n  width: 30px;\n  height: 20px;\n  background: hsla(40, 7%, 92%, 0.3);\n  vertical-align: top;\n  border: 1px solid #ccc;\n  padding: 0 5px;\n  cursor: pointer;\n}\n.jodit-add-new-line span:hover {\n  background: #ecebe9;\n}\n.jodit-add-new-line svg {\n  width: 16px;\n  fill: #ccc;\n  vertical-align: top;\n}\n.jodit_source_mode .jodit-add-new-line {\n  display: none !important;\n}\n.jodit_error_box_for_messages {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 0;\n  height: 0;\n  overflow: visible;\n  z-index: 3;\n}\n.jodit_error_box_for_messages > * {\n  position: absolute;\n  right: 5px;\n  bottom: 0;\n  display: block;\n  -webkit-transition: opacity 0.1s linear, bottom 0.3s linear;\n  transition: opacity 0.1s linear, bottom 0.3s linear;\n  opacity: 0;\n  background: rgba(255, 0, 0, 0.29);\n  color: #e02b2b;\n  padding: 2px 7px;\n  border: 1px solid hsla(0, 65%, 67%, 0.44);\n  font-size: 14px;\n  white-space: pre;\n}\n.jodit_error_box_for_messages > .active {\n  opacity: 1;\n}\n.jodit_error_box_for_messages > .info {\n  background: rgba(204, 229, 247, 0.71);\n  color: #776565;\n  border: 1px solid hsla(0, 0%, 60%, 0.44);\n}\n.jodit_error_box_for_messages > .success {\n  background: rgba(77, 236, 112, 0.29);\n  color: #5d5a5a;\n  border: 1px solid hsla(0, 0%, 58%, 0.44);\n}\n.card.jodit_fullsize_box {\n  position: static;\n}\n.viewcontent.jodit_fullsize_box {\n  position: sticky;\n  min-height: calc(100vh + 30px);\n}\n.viewcontent.jodit_fullsize_box > *:not(.jodit_fullsize_box) {\n  display: none;\n}\n.jodit_fullsize {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 11;\n  max-width: 100% !important;\n}\n.jodit_fullsize .toolbar {\n  width: 100% !important;\n}\n.jodit_fullsize .jodit_area,\n.jodit_fullsize .jodit_editor {\n  height: 100%;\n}\n.jodit_fullsize .jodit_workflow {\n  height: calc(100% - 16px * 1.5);\n  overflow: auto;\n}\n.jodit_fullsize.jodit_toolbar_size-small .jodit_workflow {\n  height: calc(100% - 12px * 1.5);\n}\n.jodit_fullsize.jodit_toolbar_size-large .jodit_workflow {\n  height: calc(100% - 18px * 1.5);\n}\n.jodit_placeholder {\n  -webkit-user-select: none!important;\n  -moz-user-select: none!important;\n  -ms-user-select: none!important;\n  user-select: none!important;\n  top: 0;\n  left: 0;\n  display: block;\n  position: absolute;\n  padding: 10px;\n  color: rgba(0, 0, 0, 0.35);\n  pointer-events: none;\n}\n.jodit_toolbar_popup-inline-target {\n  position: absolute;\n  width: 0;\n  height: 0;\n}\n.jodit_toolbar_popup-inline-target.jodit_toolbar_popup-inline-target-hidden {\n  display: none;\n}\n.jodit_toolbar_popup-inline {\n  display: inline-block !important;\n  position: relative !important;\n}\n.jodit_toolbar_popup-inline > div {\n  color: hsla(0, 0%, 88%, 0.99);\n  background: #fff;\n  box-shadow: none;\n  background-clip: padding-box;\n  font-family: Helvetica, sans-serif;\n  box-sizing: border-box;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  z-index: 12!important;\n  text-align: left;\n  border: 1px solid hsla(0, 0%, 88%, 0.99);\n  display: inline-block;\n  vertical-align: top;\n}\n.jodit_toolbar_popup-inline .jodit_toolbar {\n  z-index: 6;\n  border: 0;\n  white-space: normal;\n}\n.jodit_toolbar_popup-inline > div > .jodit_toolbar {\n  white-space: nowrap;\n  box-shadow: none;\n  vertical-align: top;\n}\n.jodit_toolbar_popup-inline > .jodit_popup_triangle {\n  padding: 0;\n  margin: 0;\n  width: 8px;\n  height: 8px;\n  position: absolute;\n  top: -4px;\n  margin-left: -4px;\n  display: inline-block;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  background: #fff;\n  border: 1px solid hsla(0, 0%, 88%, 0.99);\n  border-width: 1px 0 0 1px;\n  z-index: 5;\n}\n.jodit_toolbar_popup-inline.jodit_toolbar_popup-inline-top > .jodit_popup_triangle {\n  top: auto;\n  bottom: -4px;\n  border-width: 0 1px 1px 0;\n}\n.jodit_toolbar_popup-inline .buttons {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n  padding: 0 2px;\n  white-space: nowrap;\n  line-height: 0;\n  border-bottom: 0;\n}\n[data-jodit_iframe_wrapper] {\n  display: block;\n  clear: both;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  position: relative;\n}\n[data-jodit_iframe_wrapper]:after {\n  position: absolute;\n  content: \"\";\n  z-index: 1;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  cursor: pointer;\n  display: block;\n  background: transparent;\n}\n.jodit_resizer {\n  width: 100px;\n  height: 100px;\n  position: absolute;\n  border: 1px solid rgba(3, 14, 82, 0.92);\n  top: 0;\n  left: 0;\n  display: none;\n  pointer-events: none;\n  font-size: 0;\n}\n.jodit_resizer * {\n  box-sizing: border-box;\n}\n.jodit_resizer > span {\n  opacity: 0;\n  -webkit-transition: opacity 0.2s linear;\n  transition: opacity 0.2s linear;\n  left: 50%;\n  top: 50%;\n  height: 24px;\n  line-height: 24px;\n  font-size: 12px;\n  width: 70px;\n  margin-left: -35px;\n  margin-top: -12px;\n  text-align: center;\n  overflow: visible;\n  color: #fff;\n  background-color: rgba(0, 0, 0, 0.35);\n  max-width: 100%;\n}\n.jodit_resizer > i,\n.jodit_resizer > span {\n  position: absolute;\n  display: inline-block;\n}\n.jodit_resizer > i {\n  z-index: 4;\n  pointer-events: all;\n  border: 1px solid rgba(3, 14, 82, 0.92);\n  background-color: hsla(0, 0%, 88%, 0.99);\n  width: 10px;\n  height: 10px;\n}\n.jodit_resizer > i:hover {\n  background-color: #f8f8f8;\n}\n.jodit_resizer > i:first-child {\n  left: -5px;\n  top: -5px;\n  cursor: nw-resize;\n}\n.jodit_resizer > i:nth-child(2) {\n  right: -5px;\n  top: -5px;\n  cursor: ne-resize;\n}\n.jodit_resizer > i:nth-child(3) {\n  right: -5px;\n  bottom: -5px;\n  cursor: se-resize;\n}\n.jodit_resizer > i:nth-child(4) {\n  left: -5px;\n  bottom: -5px;\n  cursor: sw-resize;\n}\n@media (max-width: 768px) {\n  .jodit_resizer > i {\n    width: 20px;\n    height: 20px;\n  }\n  .jodit_resizer > i:first-child {\n    left: -10px;\n    top: -10px;\n    cursor: nw-resize;\n  }\n  .jodit_resizer > i:nth-child(2) {\n    right: -10px;\n    top: -10px;\n    cursor: ne-resize;\n  }\n  .jodit_resizer > i:nth-child(3) {\n    right: -10px;\n    bottom: -10px;\n    cursor: se-resize;\n  }\n  .jodit_resizer > i:nth-child(4) {\n    left: -10px;\n    bottom: -10px;\n    cursor: sw-resize;\n  }\n}\n.jodit_container {\n  min-height: 100px;\n}\n.jodit_container .jodit_workplace {\n  display: flex;\n  height: auto;\n  min-height: 50px;\n  overflow: hidden;\n}\n.jodit_editor_resize {\n  position: relative;\n}\n.jodit_editor_resize a {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 0;\n  height: 0;\n  overflow: hidden;\n  border-width: 7px 7px 0 0;\n  border-color: transparent #ccc transparent transparent;\n  border-style: dashed solid dashed dashed;\n  cursor: se-resize;\n}\n.jodit_source {\n  display: none;\n  position: relative;\n  background-color: #f8f8f8;\n  font-size: 0;\n  flex: 1 1;\n  overflow: auto;\n}\n.jodit_source,\n.jodit_source .jodit_source_mirror-fake {\n  min-height: 100%;\n}\n.jodit_container.jodit_source_mode .jodit_wysiwyg,\n.jodit_container.jodit_source_mode .jodit_wysiwyg_iframe {\n  display: none !important;\n}\n.jodit_container.jodit_source_mode .jodit_source {\n  display: block !important;\n}\n.jodit_container.jodit_split_mode .jodit_source,\n.jodit_container.jodit_split_mode .jodit_wysiwyg,\n.jodit_container.jodit_split_mode .jodit_wysiwyg_iframe {\n  display: block!important;\n  width: 50%;\n  flex: 1 1;\n}\n.jodit_source_mirror {\n  border: 0;\n  width: 100%;\n  background: #3f3f3f;\n  margin: 0;\n  height: 100%;\n  box-shadow: none;\n  resize: none;\n  box-sizing: border-box;\n  color: #f0f0f0;\n  outline: none;\n  font-family: Menlo, Monaco, monospace, sans-serif;\n  font-size: 13px;\n  line-height: 1.3em;\n  z-index: 2;\n  padding: 10px;\n  overflow: auto;\n  white-space: pre-wrap;\n  -moz-tab-size: 2em;\n  tab-size: 2em;\n  min-height: 100%;\n}\n.jodit_source_mirror::-moz-selection {\n  background: #bdbdbd;\n}\n.jodit_source_mirror::selection {\n  background: #bdbdbd;\n}\n.jodit_table_resizer {\n  cursor: col-resize;\n  position: absolute;\n  z-index: 3;\n  padding-left: 5px;\n  padding-right: 5px;\n  margin-left: -5px;\n}\n.jodit_table_resizer:after {\n  content: \"\";\n  display: block;\n  height: 100%;\n  width: 0;\n  border: 1px solid transparent;\n  border-width: 0 1px 0 0;\n}\n.jodit_table_resizer-moved {\n  z-index: 2;\n}\n.jodit_table_resizer-moved:after {\n  border-color: #1e88e5;\n}\n.jodit_wysiwyg table {\n  width: 100%;\n  border: none;\n  border-collapse: collapse;\n  table-layout: fixed;\n  empty-cells: show;\n  max-width: 100%;\n}\n.jodit_wysiwyg table tr {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.jodit_wysiwyg table tr td,\n.jodit_wysiwyg table tr th {\n  border: 1px solid #ddd;\n  text-align: left;\n  vertical-align: middle;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n.jodit_wysiwyg table tr td[data-jodit-selected-cell],\n.jodit_wysiwyg table tr th[data-jodit-selected-cell] {\n  border: 1px double #1e88e5;\n}\n.jodit_form_inserter .jodit_form-table-creator-box {\n  font-size: 0;\n}\n.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-container {\n  display: inline-block;\n  vertical-align: top;\n  padding: 0;\n  margin: 0;\n  min-width: 180px;\n  font-size: 0;\n}\n.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-container > div {\n  width: 18px;\n  height: 18px;\n  box-sizing: border-box;\n  display: inline-block;\n  position: relative;\n  vertical-align: top;\n}\n.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-container > div:after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border: 1px solid #ccc;\n}\n.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-container > div.hovered:after {\n  background: #7a450f;\n  border: 1px solid #b5b5b5;\n}\n.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-options {\n  font-size: 14px;\n  display: inline-block;\n  vertical-align: top;\n}\n.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-options label {\n  text-align: left;\n  padding-top: 0;\n}\n.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-options label input {\n  margin-right: 10px;\n}\n.jodit_form_inserter label {\n  text-align: center;\n  font-size: 14px;\n  padding: 8px;\n  display: block;\n  margin: 0;\n}\n.jodit_text_icons .jodit_icon {\n  width: auto;\n  font-size: 14px;\n}\n.jodit_text_icons .jodit_icon:first-letter {\n  text-transform: uppercase;\n}\n.jodit_text_icons .jodit_tabs .jodit_tabs_buttons > a {\n  font-family: Helvetica, sans-serif;\n  width: auto;\n}\n.jodit_text_icons .jodit_tabs .jodit_tabs_buttons > a i,\n.jodit_text_icons .jodit_toolbar > li {\n  width: auto;\n}\n.jodit_text_icons .jodit_toolbar > li > a {\n  text-decoration: none;\n}\n.jodit_text_icons.jodit_dialog_box .jodit_dialog .jodit_button,\n.jodit_text_icons.jodit_dialog_box .jodit_dialog .jodit_dialog_header a,\n.jodit_text_icons .jodit_toolbar > li > a {\n  padding: 0 12px;\n  font-family: Helvetica, sans-serif;\n  width: auto;\n  color: rgba(0, 0, 0, 0.75);\n}\n.jodit_text_icons.jodit_dialog_box .jodit_dialog .jodit_button .jodit_icon,\n.jodit_text_icons.jodit_dialog_box .jodit_dialog .jodit_dialog_header a .jodit_icon {\n  width: auto;\n}\n.jodit_widget,\n.jodit_widget * {\n  box-sizing: border-box;\n}\n.jodit_search {\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 0;\n  height: 0;\n}\n.jodit_search.jodit_search-active {\n  visibility: visible;\n}\n.jodit_search .jodit_search_box {\n  width: 320px;\n  position: absolute;\n  right: 0;\n  background-color: #f9f9f9;\n  border: 1px solid #ccc;\n  border-width: 0 0 1px 1px;\n  padding: 5px;\n}\n.jodit_search .jodit_search_box input {\n  margin: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  background-color: transparent;\n  outline: none;\n  padding: 0 10px;\n}\n.jodit_search .jodit_search_box input.jodit_search-replace {\n  display: none;\n}\n.jodit_search .jodit_search_box .jodit_search_buttons,\n.jodit_search .jodit_search_box .jodit_search_counts,\n.jodit_search .jodit_search_box .jodit_search_inputs {\n  height: 30px;\n  display: inline-block;\n  vertical-align: top;\n}\n.jodit_search .jodit_search_box .jodit_search_inputs {\n  width: 60%;\n  padding-right: 5px;\n}\n.jodit_search .jodit_search_box .jodit_search_counts {\n  width: 15%;\n  line-height: 100%;\n  text-align: center;\n  color: #ccc;\n  border-left: 1px solid #ccc;\n}\n.jodit_search .jodit_search_box .jodit_search_counts:before {\n  content: \"\";\n  display: inline-block;\n  vertical-align: middle;\n  height: 100%;\n}\n.jodit_search .jodit_search_box .jodit_search_counts span {\n  display: inline-block;\n  vertical-align: middle;\n}\n.jodit_search .jodit_search_box .jodit_search_buttons {\n  padding-left: 0;\n  width: 25%;\n}\n.jodit_search .jodit_search_box .jodit_search_buttons button {\n  outline: 0;\n  width: 32%;\n  padding: 1px 5px;\n  margin-right: 1%;\n  -webkit-transition: -webkit-transform 0.1s linear;\n  transition: -webkit-transform 0.1s linear;\n  transition: transform 0.1s linear;\n  transition: transform 0.1s linear, -webkit-transform 0.1s linear;\n  height: 100%;\n  border: 1px solid transparent;\n  background-color: transparent;\n}\n.jodit_search .jodit_search_box .jodit_search_buttons button.jodit_search_buttons-replace {\n  width: 100%;\n  border: 1px solid #ccc;\n  margin-top: 2px;\n  display: none;\n}\n.jodit_search .jodit_search_box .jodit_search_buttons button:hover {\n  background-color: #ecebe9;\n}\n.jodit_search .jodit_search_box .jodit_search_buttons button:focus {\n  border: 1px solid rgba(181, 214, 253, 0.5);\n}\n.jodit_search .jodit_search_box .jodit_search_buttons button:active {\n  border: 1px solid #b5d6fd;\n  -webkit-transform: scale(0.95);\n  transform: scale(0.95);\n}\n.jodit_search.jodit_search-and-replace .jodit_search_counts,\n.jodit_search.jodit_search-and-replace .jodit_search_inputs {\n  height: 60px;\n}\n.jodit_search.jodit_search-and-replace .jodit_search_counts input,\n.jodit_search.jodit_search-and-replace .jodit_search_inputs input {\n  height: 50%;\n  -webkit-transition: background-color 0.1s linear;\n  transition: background-color 0.1s linear;\n}\n.jodit_search.jodit_search-and-replace .jodit_search_counts input:focus,\n.jodit_search.jodit_search-and-replace .jodit_search_inputs input:focus {\n  box-shadow: inset 0 0 3px 0 hsla(0, 0%, 80%, 0.58);\n}\n.jodit_search.jodit_search-and-replace .jodit_search_buttons button.jodit_search_buttons-replace,\n.jodit_search.jodit_search-and-replace .jodit_search_inputs input.jodit_search-replace {\n  display: block;\n}\n@media (max-width: 320px) {\n  .jodit_search,\n  .jodit_search .jodit_search_box {\n    width: 100%;\n  }\n}\n.jodit_symbols {\n  width: 460px;\n  padding: 10px;\n}\n.jodit_symbols .jodit_symbols-container_preview,\n.jodit_symbols .jodit_symbols-container_table {\n  display: inline-block;\n  vertical-align: top;\n}\n.jodit_symbols .jodit_symbols-container_table {\n  width: 88%;\n}\n.jodit_symbols .jodit_symbols-container_preview {\n  width: 12%;\n}\n.jodit_symbols .jodit_symbols-container_preview .jodit_symbols-preview {\n  font-size: 34px;\n  text-align: center;\n  padding: 20px 0;\n  border: 1px solid #ccc;\n}\n.jodit_symbols table {\n  border: 0;\n  border-spacing: 0;\n  table-layout: fixed;\n}\n.jodit_symbols table td {\n  padding: 0;\n}\n.jodit_symbols table td a {\n  font-size: 16px;\n  text-decoration: none;\n  color: #000;\n  display: inline-block;\n  box-sizing: border-box;\n  width: 21.6px;\n  height: 21.6px;\n  border: 1px solid transparent;\n  text-align: center;\n  line-height: 21.6px;\n  vertical-align: top;\n}\n.jodit_symbols table td a:focus,\n.jodit_symbols table td a:hover {\n  border: 1px solid #1e88e5;\n}\n.jodit_sticky-dummy_toolbar {\n  display: none;\n}\n.jodit_sticky > .jodit_toolbar {\n  position: fixed;\n  z-index: 3;\n  top: 0;\n  left: auto;\n}\n.jodit_sticky .jodit_sticky-dummy_toolbar {\n  display: block;\n}\n.jodit_paste_storage {\n  padding: 10px;\n  max-width: 600px;\n}\n@media (max-width: 768px) {\n  .jodit_paste_storage {\n    max-width: 100%;\n  }\n}\n.jodit_paste_storage > div {\n  max-width: 100%;\n  max-height: 300px;\n  border: 1px solid #ccc;\n}\n.jodit_paste_storage > div:first-child {\n  margin-bottom: 10px;\n}\n.jodit_paste_storage > div:first-child a {\n  outline: none;\n  box-sizing: border-box;\n  display: block;\n  max-width: 100%;\n  white-space: pre;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  padding: 5px;\n  margin: 0;\n  border: 1px solid transparent;\n  text-decoration: none;\n  color: #000;\n}\n.jodit_paste_storage > div:first-child a.jodit_active {\n  color: #fff;\n  background-color: #575757;\n}\n.jodit_paste_storage > div:first-child a:focus {\n  outline: none;\n}\n.jodit_paste_storage > div:last-child {\n  padding: 10px;\n  overflow: auto;\n}\n.jodit_paste_storage > div:last-child li,\n.jodit_paste_storage > div:last-child ul {\n  margin: 0;\n}\n.form-group .form-control.rdw-editor-wrapper {\n  padding: 0;\n}\n.form-control.forminput.slate-wrapper {\n  flex-wrap: wrap;\n}\n.form-control.forminput.slate-wrapper .slate-editor {\n  flex: 0 0 100%;\n  min-height: 112px;\n  padding: 15px;\n}\n.required .form-control.forminput.slate-wrapper:before {\n  position: absolute;\n}\n.form-control.forminput.slate-wrapper .DraftEditor-editorContainer {\n  z-index: auto;\n}\n.slate-toolbar {\n  position: relative;\n  border: 0;\n  border-bottom: 2px solid #eeeeee;\n  display: flex;\n  flex: 1 1 100%;\n  flex-wrap: wrap;\n  gap: 0 7.5px;\n  padding: 15px 0;\n  margin: 0 15px;\n  border-radius: 0;\n  align-items: center;\n}\n.slate-toolbar > div {\n  margin: 0;\n  display: flex;\n  gap: 0 7.5px;\n}\n.slate-toolbar .btn {\n  padding: 0;\n  width: 24px;\n  min-height: 24px;\n  justify-content: center;\n}\n.slate-toolbar .btn:hover {\n  box-shadow: none;\n}\n.slate-toolbar .btn.rdw-option-active {\n  box-shadow: none;\n}\n.slate-toolbar .btn.rdw-option-active svg {\n  stroke-width: 2.4;\n}\n.slate-toolbar .slate-button {\n  flex: 0 0 auto;\n  width: 24px;\n  height: 24px;\n  box-sizing: border-box;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  margin: 0 5px;\n}\n.slate-toolbar .slate-button.code {\n  display: none;\n}\n.slate-toolbar .slate-button.blockquote {\n  display: none;\n}\n.slate-toolbar .slate-button.u {\n  display: none;\n}\n.slate-toolbar .slate-button span {\n  display: flex;\n}\n.slate-toolbar .slate-button svg {\n  display: block;\n  width: 20px;\n  height: 20px;\n}\n@media (min-width: 799px) {\n  .slate-toolbar .slate-button.code {\n    display: flex;\n  }\n  .slate-toolbar .slate-button.blockquote {\n    display: flex;\n  }\n  .slate-toolbar .slate-button.u {\n    display: flex;\n  }\n}\n.slate-toolbar .slate-source {\n  box-sizing: border-box;\n  padding: 2px;\n  height: 28px;\n  align-self: middle;\n  margin-left: auto;\n}\n[data-slate-editor] {\n  flex: 0 0 100%;\n}\n[data-slate-editor] > p {\n  font-size: 1.1rem;\n}\n[data-slate-editor] blockquote {\n  border-left: 5px solid #ccc;\n  font-style: italic;\n  margin: 1.5em 10px;\n  padding: 0.5em 10px;\n  quotes: \"\\201C\" \"\\201D\" \"\\2018\" \"\\2019\";\n}\n[data-slate-editor] blockquote:before {\n  color: #ccc;\n  font-style: normal;\n  content: open-quote;\n  font-size: 4em;\n  line-height: 0.1em;\n  margin-right: 0.25em;\n  vertical-align: -0.4em;\n}\n[data-slate-editor] blockquote p {\n  display: inline;\n}\n[data-slate-editor] code {\n  background: #f9f9f9;\n  padding: 5px 8px;\n}\n[data-slate-editor] {\n  padding: 0 10px;\n}\n[data-slate-editor] * + * {\n  margin-top: 1em;\n}\n.slate-editor-frame {\n  width: 100%;\n  height: 480px;\n  border: 1px solid #f9f9f9;\n}\n.form-group.editor {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n.other h2 {\n  font-size: 18px;\n  color: #444;\n  margin-bottom: 7px;\n}\n.other a {\n  color: #777;\n  text-decoration: underline;\n  font-size: 14px;\n}\n.other ul {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n.App {\n  font-family: sans-serif;\n  text-align: center;\n}\nh1 {\n  font-size: 24px;\n  color: #333;\n}\n.ltr {\n  text-align: left;\n}\n.rtl {\n  text-align: right;\n}\n.editor-container {\n  background: none;\n  font-weight: 400;\n  text-align: left;\n  flex-wrap: wrap;\n}\n.editor-inner {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n}\n.editor-input {\n  flex: 0 0 100%;\n  min-height: 150px;\n  max-width: 100%;\n  resize: none;\n  position: relative;\n  tab-size: 1;\n  outline: 0;\n  padding: 15px 10px;\n}\n@media screen and (max-width: 799px) {\n  .editor-input * {\n    -webkit-touch-callout: none;\n    /* Safari Touch */\n    -webkit-user-select: none;\n    /* Webkit */\n    -moz-user-select: none;\n    /* Firefox */\n    -ms-user-select: none;\n    /* Edge*/\n    user-select: none;\n    /* Future-proof*/\n  }\n}\n.editor-input a {\n  color: inherit;\n  text-decoration: underline;\n}\n.editor-input a:hover {\n  color: #10294D;\n}\n.editor-input .underline {\n  text-decoration: underline;\n}\n.editor-input .line-through {\n  text-decoration: line-through;\n}\n.editor-placeholder {\n  color: #B2C2D4;\n  overflow: hidden;\n  position: absolute;\n  text-overflow: ellipsis;\n  top: 15px;\n  left: 10px;\n  font-size: 15px;\n  user-select: none;\n  display: inline-block;\n  pointer-events: none;\n}\n.editor-text-bold {\n  font-weight: bold;\n}\n.editor-text-italic {\n  font-style: italic;\n}\n.editor-text-underline {\n  text-decoration: underline;\n}\n.editor-text-strikethrough {\n  text-decoration: line-through;\n}\n.editor-text-underlineStrikethrough {\n  text-decoration: underline line-through;\n}\n.editor-text-code {\n  background-color: #f0f2f5;\n  padding: 1px 0.25rem;\n  font-family: Menlo, Consolas, Monaco, monospace;\n  font-size: 94%;\n}\n.editor-link {\n  color: #216fdb;\n  text-decoration: none;\n}\n.tree-view-output {\n  display: block;\n  background: #222;\n  color: #fff;\n  padding: 5px;\n  font-size: 12px;\n  white-space: pre-wrap;\n  margin: 1px auto 10px auto;\n  max-height: 250px;\n  position: relative;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  overflow: auto;\n  line-height: 14px;\n}\n.editor-code {\n  background-color: #f0f2f5;\n  font-family: Menlo, Consolas, Monaco, monospace;\n  display: block;\n  padding: 8px 8px 8px 52px;\n  line-height: 1.53;\n  font-size: 13px;\n  margin: 0;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  tab-size: 2;\n  /* white-space: pre; */\n  overflow-x: auto;\n  position: relative;\n}\n.editor-code:before {\n  content: attr(data-gutter);\n  position: absolute;\n  background-color: #eee;\n  left: 0;\n  top: 0;\n  border-right: 1px solid #ccc;\n  padding: 8px;\n  color: #777;\n  white-space: pre-wrap;\n  text-align: right;\n  min-width: 25px;\n}\n.editor-code:after {\n  content: attr(data-highlight-language);\n  top: 0;\n  right: 3px;\n  padding: 3px;\n  font-size: 10px;\n  text-transform: uppercase;\n  position: absolute;\n  color: rgba(0, 0, 0, 0.5);\n}\n.editor-tokenComment {\n  color: slategray;\n}\n.editor-tokenPunctuation {\n  color: #999;\n}\n.editor-tokenProperty {\n  color: #905;\n}\n.editor-tokenSelector {\n  color: #690;\n}\n.editor-tokenOperator {\n  color: #9a6e3a;\n}\n.editor-tokenAttr {\n  color: #07a;\n}\n.editor-tokenVariable {\n  color: #e90;\n}\n.editor-tokenFunction {\n  color: #dd4a68;\n}\n.editor-paragraph {\n  margin: 0;\n  margin-bottom: 8px;\n  position: relative;\n}\n.editor-paragraph:last-child {\n  margin-bottom: 0;\n}\n.editor-heading-h1 {\n  font-size: 24px;\n  color: #050505;\n  font-weight: 400;\n  margin: 0;\n  margin-bottom: 12px;\n  padding: 0;\n}\n.editor-heading-h2 {\n  font-size: 15px;\n  color: #65676b;\n  font-weight: 700;\n  margin: 0;\n  margin-top: 10px;\n  padding: 0;\n  text-transform: uppercase;\n}\nblockquote {\n  background: #f2f2f2;\n  border-left-color: #ced0d4;\n  border-left-width: 4px;\n  border-left-style: solid;\n  padding: 16px;\n  margin: 1em 0;\n}\n.editor-list-ol {\n  padding: 0;\n  margin: 0;\n  margin-left: 16px;\n}\n.editor-list-ul {\n  padding: 0;\n  margin: 0;\n  margin-left: 16px;\n}\n.editor-listitem {\n  margin: 8px 32px 8px 32px;\n}\n.editor-nested-listitem {\n  list-style-type: none;\n}\npre::-webkit-scrollbar {\n  background: transparent;\n  width: 10px;\n}\npre::-webkit-scrollbar-thumb {\n  background: #999;\n}\n.debug-timetravel-panel {\n  overflow: hidden;\n  padding: 0 0 10px 0;\n  margin: auto;\n  display: flex;\n}\n.debug-timetravel-panel-slider {\n  padding: 0;\n  flex: 8;\n}\n.debug-timetravel-panel-button {\n  padding: 0;\n  border: 0;\n  background: none;\n  flex: 1;\n  color: #fff;\n  font-size: 12px;\n}\n.debug-timetravel-panel-button:hover {\n  text-decoration: underline;\n}\n.debug-timetravel-button {\n  border: 0;\n  padding: 0;\n  font-size: 12px;\n  top: 10px;\n  right: 15px;\n  position: absolute;\n  background: none;\n  color: #fff;\n}\n.debug-timetravel-button:hover {\n  text-decoration: underline;\n}\n.emoji {\n  color: transparent;\n  background-size: 16px 16px;\n  background-position: center;\n  background-repeat: no-repeat;\n  vertical-align: middle;\n  margin: 0 -1px;\n}\n.emoji-inner {\n  padding: 0 0.15em;\n}\n.emoji-inner::selection {\n  color: transparent;\n  background-color: rgba(150, 150, 150, 0.4);\n}\n.emoji-inner::moz-selection {\n  color: transparent;\n  background-color: rgba(150, 150, 150, 0.4);\n}\n.toolbar {\n  display: flex;\n  flex: 0 0 100%;\n  margin-bottom: 1px;\n  flex-wrap: wrap;\n  padding-bottom: 4px;\n  vertical-align: middle;\n  border-bottom: 2px solid #eeeeee;\n}\n.toolbar button.toolbar-item {\n  border: 1px solid transparent;\n  display: flex;\n  background: none;\n  padding: 8px;\n  cursor: pointer;\n  vertical-align: middle;\n}\n.toolbar button.toolbar-item:disabled {\n  cursor: not-allowed;\n}\n.toolbar button.toolbar-item.spaced {\n  margin-right: 2px;\n}\n.toolbar button.toolbar-item i.format {\n  background-size: contain;\n  display: inline-block;\n  height: 18px;\n  width: 18px;\n  margin-top: 2px;\n  vertical-align: -0.25em;\n  display: flex;\n  opacity: 0.6;\n}\n.toolbar button.toolbar-item:disabled i.format {\n  opacity: 0.2;\n}\n.toolbar button.toolbar-item.active {\n  background-color: rgba(223, 232, 250, 0.3);\n}\n.toolbar button.toolbar-item.active i {\n  opacity: 1;\n}\n.toolbar .toolbar-item:hover:not([disabled]) {\n  background-color: #eee;\n}\n.toolbar .divider {\n  width: 1px;\n  background-color: #eee;\n  margin: 0 4px;\n}\n.toolbar select.toolbar-item {\n  border: 1px solid transparent;\n  display: flex;\n  background: none;\n  border-radius: 10px;\n  padding: 8px;\n  vertical-align: middle;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 70px;\n  font-size: 14px;\n  color: #777;\n  text-overflow: ellipsis;\n}\n.toolbar select.code-language {\n  text-transform: capitalize;\n  width: 130px;\n}\n.toolbar .toolbar-item .text {\n  display: flex;\n  line-height: 20px;\n  width: 200px;\n  vertical-align: middle;\n  font-size: 14px;\n  color: #777;\n  text-overflow: ellipsis;\n  width: 70px;\n  overflow: hidden;\n  height: 20px;\n  text-align: left;\n}\n.toolbar i.chevron-down {\n  margin-top: 3px;\n  width: 16px;\n  height: 16px;\n  display: flex;\n  user-select: none;\n}\n.toolbar i.chevron-down.inside {\n  width: 16px;\n  height: 16px;\n  display: flex;\n  margin-left: -25px;\n  margin-top: 11px;\n  margin-right: 10px;\n  pointer-events: none;\n}\ni.chevron-down {\n  background-color: transparent;\n  background-size: contain;\n  display: inline-block;\n  height: 8px;\n  width: 8px;\n}\n#block-controls button:hover {\n  background-color: #efefef;\n}\n#block-controls button:focus-visible {\n  border-color: blue;\n}\n#block-controls span.block-type {\n  background-size: contain;\n  display: block;\n  width: 18px;\n  height: 18px;\n  margin: 2px;\n}\n.dropdown {\n  z-index: 5;\n  display: block;\n  position: absolute;\n  box-shadow: 0 12px 28px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(255, 255, 255, 0.5);\n  border-radius: 8px;\n  min-width: 100px;\n  min-height: 40px;\n  background-color: #fff;\n}\n.dropdown .item {\n  margin: 0 8px 0 8px;\n  padding: 8px;\n  color: #050505;\n  cursor: pointer;\n  line-height: 16px;\n  font-size: 15px;\n  display: flex;\n  align-content: center;\n  flex-direction: row;\n  flex-shrink: 0;\n  justify-content: space-between;\n  background-color: #fff;\n  border-radius: 8px;\n  border: 0;\n  min-width: 268px;\n}\n.dropdown .item .active {\n  display: flex;\n  width: 20px;\n  height: 20px;\n  background-size: contain;\n}\n.dropdown .item:first-child {\n  margin-top: 8px;\n}\n.dropdown .item:last-child {\n  margin-bottom: 8px;\n}\n.dropdown .item:hover {\n  background-color: #eee;\n}\n.dropdown .item .text {\n  display: flex;\n  line-height: 20px;\n  flex-grow: 1;\n  width: 200px;\n}\n.dropdown .item .icon {\n  display: flex;\n  width: 20px;\n  height: 20px;\n  user-select: none;\n  margin-right: 12px;\n  line-height: 16px;\n  background-size: contain;\n}\n.link-editor {\n  position: absolute;\n  z-index: 1000;\n  top: -10000px;\n  left: -10000px;\n  margin-top: -6px;\n  max-width: 300px;\n  width: 100%;\n  opacity: 0;\n  background-color: #fff;\n  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  transition: opacity 0.5s;\n}\n.link-editor .link-input {\n  display: flex;\n  width: calc(100% - 24px);\n  box-sizing: border-box;\n  margin: 8px 12px;\n  padding: 8px 0 8px 12px;\n  border-radius: 15px;\n  background-color: #eee;\n  font-size: 15px;\n  color: #050505;\n  border: 0;\n  outline: 0;\n  position: relative;\n  font-family: inherit;\n}\n.link-editor .link-target {\n  display: flex;\n  gap: 5px 5px;\n  width: 100%;\n  margin: 8px 12px;\n  padding: 8px 0 8px 0;\n}\n.link-editor div.link-edit {\n  background-size: 16px;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 35px;\n  vertical-align: -0.25em;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  cursor: pointer;\n}\n.link-editor .link-input a {\n  color: #216fdb;\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1 1 100%;\n}\n.link-editor .link-input a:hover {\n  text-decoration: underline;\n}\n.link-editor .button {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  padding: 6px;\n  border-radius: 8px;\n  cursor: pointer;\n  margin: 0 2px;\n}\n.link-editor .button.hovered {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  background-color: #eee;\n}\n.link-editor .button i,\n.actions i {\n  background-size: contain;\n  display: inline-block;\n  height: 20px;\n  width: 20px;\n  vertical-align: -0.25em;\n}\n.nestedListItem {\n  list-style-type: none;\n}\n.nestedListItem:before,\n.nestedListItem:after {\n  display: none;\n}\n.nestedListItem > ul {\n  padding-top: 0;\n}\n.lexical-inline-image {\n  position: relative;\n}\n.lexical-inline-image button {\n  position: absolute;\n  top: 5px;\n  left: 5px;\n}\n.lexical-inline-image img.focused.draggable {\n  cursor: grab;\n}\n.lexical-inline-image img.focused.draggable:active {\n  cursor: grabbing;\n}\nfigure.inline-image {\n  display: inline-flex;\n  flex-direction: column;\n}\nfigure.inline-image.position-left {\n  float: left;\n}\nfigure.inline-image.position-right {\n  float: right;\n}\nfigure.inline-image.position-full {\n  width: 100%;\n}\n.notes-summary {\n  display: block;\n}\n.notes-summary:hover {\n  background: #EBF5FF;\n}\n.notes-summary-top {\n  border-top: 1px solid #F3F5F8;\n  padding: 20px 20px 0 20px;\n  display: flex;\n  align-items: center;\n  gap: 0 6px;\n}\n.notes-summary-top .avatar-md > .thumbimg {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n.notes-summary-top .agents {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n}\n.notes-summary-date {\n  margin-left: auto;\n  font-size: 11px;\n  font-weight: 400;\n  color: #B2C2D4;\n  text-align: right;\n}\n.notes-summary-pin .btn svg {\n  stroke: #CED7E2;\n}\n.notes-summary-pin .btn.pinned svg {\n  stroke: #10294D;\n}\n.notes-summary-private .btn svg {\n  stroke: #CED7E2;\n}\n.notes-summary-private .btn.private svg {\n  stroke: #10294D;\n}\n.notes-summary-tag-name {\n  display: flex;\n}\n.notes-summary-body {\n  padding: 20px 20px;\n  display: block;\n}\n.notes-summary-body div {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.notes-summary:last-of-type .notes-summary-bottom {\n  border-bottom: 1px solid #F3F5F8;\n}\n.notes-summary-bottom {\n  display: flex;\n  gap: 6px 6px;\n  padding: 0 20px 20px 20px;\n  justify-content: space-between;\n}\n.notes-summary-bottom .notes-summary-comments {\n  display: flex;\n  align-items: center;\n  gap: 0 6px;\n  color: #10294D;\n  font-weight: 600;\n}\n.notes-summary-bottom .notes-summary-comments .icon {\n  width: 16px;\n  height: 16px;\n}\n.notes-summary-bottom .notes-summary-comments svg {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: #CED7E2;\n  stroke-width: 2.4;\n}\n.notes-summary .notes-summary-creator .agent {\n  margin-right: 5px;\n}\n.notes-summary .notes-summary-attachments {\n  display: flex;\n  align-items: center;\n  gap: 0 6px;\n  color: #10294D;\n  font-weight: 600;\n}\n.notes-summary .notes-summary-attachments svg {\n  width: 16px;\n  fill: none;\n  stroke: #CED7E2;\n  stroke-width: 2.4;\n}\n.notes-summary .notes-summary-tag {\n  border-radius: 30px;\n  padding: 5px 8px;\n  font-size: 10px;\n  background: #B2C2D4;\n  color: #ffffff;\n}\n.notes-summary .notes-summary-tag-related {\n  border-radius: 30px;\n  padding: 5px 8px;\n  font-size: 10px;\n  background: #CED7E2;\n  color: #ffffff;\n}\n.notes-summary .notes-summary-tag-name {\n  margin-left: auto;\n}\n.notes-summary.active {\n  border: 2px solid #E5EBF1;\n}\n.notes-index {\n  top: 0;\n  position: relative;\n  grid-area: jump-menu;\n  width: 100%;\n  background: #ffffff;\n}\n@media screen and (min-width: 799px) {\n  .notes-index {\n    position: sticky;\n    width: 370px;\n  }\n}\n.notes-index form,\n.notes-index > div:nth-child(1) {\n  padding: 10px 20px;\n  display: flex;\n}\n.notes-index .keyword-search {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 0 0 100%;\n  gap: 10px 10px;\n}\n.notes-index .keyword-search .btn-red {\n  margin-left: auto;\n}\n.notes-index .keyword-search > .form-group {\n  flex: 0 0 100%;\n  gap: 10px 10px;\n}\n.notes-index .keyword-search > .form-group .form-group {\n  flex: 1 1 auto;\n}\n.notes-index .keyword-search > .form-group .form-group.dateinput {\n  flex: 0 0 auto;\n}\n.notes-index .keyword-search .advanced-toggle {\n  flex: 1 1 auto;\n  justify-content: center;\n}\n.notes-index .keyword-search .button-only {\n  flex: 0 0 auto !important;\n}\n.notes-index .keyword-search .input-only .flatpickr-wrapper {\n  flex: 0 0 0;\n  max-width: 0;\n}\n.notes-index .keyword-search .input-only .input-group-addon {\n  min-height: 36px;\n}\n.notes-index .keyword-search .inline-select .input-group-addon {\n  font-size: 14px;\n  padding-left: 15px;\n}\n.notes-index .no-notes {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  min-height: 100%;\n  padding-bottom: 56px;\n}\n.notes-index .no-notes .no-notes-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1 1 100%;\n}\n.notes-view-notes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px 0;\n}\n.tab-notes .stepper {\n  grid-area: details;\n}\n.notes-view {\n  position: fixed;\n  top: 112px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow-x: auto;\n  z-index: 1000;\n  padding-top: 15px;\n  padding-left: 15px;\n  padding-right: 15px;\n  grid-area: details;\n  grid-template-areas: \"interactions\";\n  grid-template-columns: auto;\n  background-color: #F3F5F8;\n}\n@media screen and (min-width: 799px) {\n  .notes-view {\n    z-index: initial;\n    position: relative;\n    top: 0;\n    padding-top: 0;\n    padding-left: 0;\n    display: grid;\n  }\n}\n.notes-view.no-notes {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.notes-view-note,\n.notes-view-comment {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 0 20px;\n  flex: 0 0 100%;\n}\n.notes-view .agent {\n  margin: 0;\n}\n.notes-view-author {\n  font-size: 11px;\n  color: #5A6F89;\n  font-weight: 600;\n}\n.notes-view-comment .notes-view-body {\n  background: #EBF5FF;\n}\n.notes-view-body {\n  flex: 1 1 100%;\n  display: flex;\n  flex-wrap: wrap;\n  background: #FAFBFD;\n  padding: 20px;\n  gap: 10px 0;\n  border-radius: 8px;\n  position: relative;\n}\n.notes-view-body .notes-summary-tag-name {\n  margin-right: 5px;\n}\n.notes-view-content {\n  flex: 0 0 100%;\n}\n.notes-view-top {\n  flex: 0 0 100%;\n  display: flex;\n  flex-wrap: nowrap;\n}\n.notes-view-date {\n  margin-left: auto;\n  font-size: 11px;\n  font-weight: 400;\n  color: #92A7C0;\n  text-align: right;\n}\n.notes-view-bottom {\n  flex: 0 0 100%;\n  display: flex;\n  gap: 6px 6px;\n}\n.notes-view-bottom .btn {\n  min-height: 1.5em;\n}\n.notes-view-attachments {\n  flex: 0 0 100%;\n  display: flex;\n  gap: 6px 6px;\n}\n.notes-view-attachments svg {\n  width: 16px;\n  fill: none;\n  stroke: #10294D;\n  stroke-width: 2.4;\n}\n.notes-view-relations-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 10px;\n}\n.notes-view-relation {\n  border: 1px solid #CED7E2;\n  border-radius: 2px;\n  font-weight: 500;\n  font-size: 12px;\n  padding: 2px 5px;\n  color: #455870;\n}\n.notes-view .tag,\n.notes-summary .tag {\n  background-color: #ffffff;\n  border: 1px solid #CED7E2;\n}\n.notes-view .tag.Scheduled,\n.notes-summary .tag.Scheduled {\n  background-color: #FFF6EF;\n  color: #FFA564;\n  border: none;\n  display: list-item;\n  list-style-position: inside;\n  white-space: nowrap;\n}\n.notes-view .tag.Complete,\n.notes-summary .tag.Complete {\n  background-color: #F0F9F1;\n  color: #73C677;\n  border: none;\n  display: list-item;\n  list-style-position: inside;\n  white-space: nowrap;\n}\n.notes-view .tag.Proceed,\n.notes-summary .tag.Proceed {\n  background-color: #EFFBFD;\n  color: #60D3EC;\n  border: none;\n  display: list-item;\n  list-style-position: inside;\n  white-space: nowrap;\n}\n.notes-view .tag.Cancelled,\n.notes-summary .tag.Cancelled {\n  background-color: #FFEEEF;\n  color: #FF6464;\n  border: none;\n  display: list-item;\n  list-style-position: inside;\n  white-space: nowrap;\n}\n.notes-view-form {\n  flex: 0 0 100%;\n}\n.notes-view-form-footer {\n  margin-top: 15px;\n  display: flex;\n  justify-content: flex-end;\n}\n.notes-view-private-footer {\n  background-color: #10294D;\n  position: absolute;\n  right: 0px;\n  bottom: 0px;\n  color: #ffffff;\n  border-radius: 0px 0px 5px 0px;\n  display: flex;\n  align-items: center;\n}\n.notes-view-private-footer .icon {\n  height: 16px;\n  width: 16px;\n}\n.notes-view-private-footer .icon svg {\n  stroke: #ffffff;\n  stroke-width: 2.4;\n}\n.notes-view-private-footer .list {\n  padding: 0px 3px 0px 3px;\n}\n.leads-summary {\n  padding: 20px;\n  background: #FAFBFD;\n  border-radius: 8px;\n}\n.leads-summary.new-lead {\n  background: #EBF5FF;\n}\n.leads-summary:hover {\n  background: #EBF5FF;\n}\n.leads-summary.active {\n  box-shadow: 0 0 0 2px #E5EBF1;\n}\n.leads-summary-top {\n  display: flex;\n  align-items: center;\n  gap: 0 6px;\n}\n.leads-summary-top .tag.New {\n  background: #FC495D;\n  color: #ffffff;\n}\n.leads-summary-top .tag.Contacted {\n  background: #73C677;\n  color: #ffffff;\n}\n.leads-summary-top .tag.Viewing {\n  background: #3699FE;\n  color: #ffffff;\n}\n.leads-summary-top .tag.Rental-Application {\n  background: #BF60EC;\n  color: #ffffff;\n}\n.leads-summary-top .tag.Offer {\n  background: #BF60EC;\n  color: #ffffff;\n}\n.leads-summary-top .tag.Sold {\n  background: #FFA564;\n  color: #ffffff;\n}\n.leads-summary-top .tag.Rented {\n  background: #FFA564;\n  color: #ffffff;\n}\n.leads-summary-top .tag.Archived {\n  background: #10294D;\n  color: #ffffff;\n}\n.leads-summary-date {\n  margin-left: auto;\n  font-size: 11px;\n}\n.leads-summary-pin .btn svg {\n  stroke: #CED7E2;\n}\n.leads-summary-pin .btn.pinned svg {\n  stroke: #10294D;\n}\n.leads-summary-body {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  margin: 20px 0 0;\n}\n.leads-summary-bottom {\n  display: flex;\n  gap: 6px 6px;\n}\n.leads-summary-bottom .leads-summary-comments {\n  display: flex;\n  align-items: center;\n  gap: 0 6px;\n  color: #10294D;\n  font-weight: 600;\n}\n.leads-summary-bottom .leads-summary-comments .icon {\n  width: 16px;\n  height: 16px;\n}\n.leads-summary-bottom .leads-summary-comments svg {\n  width: 16px;\n  height: 16px;\n  fill: none;\n  stroke: #CED7E2;\n  stroke-width: 2.4;\n}\n.leads-summary .leads-summary-attachments {\n  display: flex;\n  align-items: center;\n  gap: 0 6px;\n  color: #10294D;\n  font-weight: 600;\n}\n.leads-summary .leads-summary-attachments svg {\n  width: 16px;\n  fill: none;\n  stroke: #CED7E2;\n  stroke-width: 2.4;\n}\n.leads-summary .leads-summary-tag {\n  border-radius: 30px;\n  padding: 5px 8px;\n  font-size: 10px;\n  background: #B2C2D4;\n  color: #ffffff;\n}\n.leads-summary .leads-summary-tag-related {\n  border-radius: 30px;\n  padding: 5px 8px;\n  font-size: 10px;\n  background: #CED7E2;\n  color: #ffffff;\n}\n.leads-view-leads {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px 0;\n}\n.residential .tab-leads,\n.commercial .tab-leads,\n.projects .tab-leads,\n.holiday .tab-leads {\n  padding: 0;\n  grid-template-areas: \"jump-menu\" \"details\";\n}\n@media screen and (min-width: 799px) {\n  .residential .tab-leads,\n  .commercial .tab-leads,\n  .projects .tab-leads,\n  .holiday .tab-leads {\n    grid-template-areas: \"jump-menu details\";\n    grid-template-columns: 370px 1fr;\n    grid-template-rows: 1fr;\n  }\n}\n.residential .tab-leads .stepper,\n.commercial .tab-leads .stepper,\n.projects .tab-leads .stepper,\n.holiday .tab-leads .stepper {\n  grid-area: details;\n}\n.latest-leads-widget.leads-index {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px 8px;\n}\n.leads-view {\n  position: fixed;\n  top: 112px;\n  bottom: 0;\n  overflow-x: auto;\n  z-index: 1000;\n  padding-top: 15px;\n  padding-left: 15px;\n  padding-right: 15px;\n  grid-area: details;\n  grid-template-areas: \"lead-details\" \"interactions\";\n  grid-template-columns: 1fr;\n  background-color: #F3F5F8;\n  gap: 20px 20px;\n}\n@media screen and (min-width: 799px) {\n  .leads-view {\n    z-index: initial;\n    position: relative;\n    top: 0;\n    padding-top: 0;\n    padding-left: 0;\n    display: grid;\n    grid-template-areas: \"interactions lead-details\";\n    grid-template-columns: 1fr 260px;\n  }\n}\n.leads-view .lead-details {\n  grid-area: lead-details;\n}\n.leads-view .lead-details .primary-bg h3 {\n  color: #ffffff;\n}\n.leads-view .lead-details .btn-grey {\n  margin-right: auto;\n}\n.leads-view .lead-interactions {\n  grid-area: interactions;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  gap: 20px;\n}\n.leads-view .lead-interactions .card {\n  margin-bottom: 0;\n}\n.leads-view.no-leads {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.leads-view-note,\n.leads-view-comment {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 0 20px;\n  flex: 0 0 100%;\n}\n.leads-view .agent {\n  margin: 0;\n}\n.leads-view-author {\n  font-size: 11px;\n  color: #5A6F89;\n  font-weight: 600;\n}\n.leads-view-comment .leads-view-body {\n  background: #EBF5FF;\n}\n.leads-view-body {\n  flex: 1 1 100%;\n  display: flex;\n  flex-wrap: wrap;\n  background: #FAFBFD;\n  padding: 20px;\n  gap: 10px 0;\n  border-radius: 8px;\n}\n.leads-view-content {\n  flex: 0 0 100%;\n}\n.leads-view-top {\n  flex: 0 0 100%;\n  display: flex;\n  flex-wrap: nowrap;\n}\n.leads-view-date {\n  margin-left: auto;\n  font-size: 11px;\n}\n.leads-view-bottom {\n  flex: 0 0 100%;\n  display: flex;\n  gap: 6px 6px;\n}\n.leads-view-bottom .btn {\n  min-height: 1.5em;\n}\n.leads-view-attachments {\n  flex: 0 0 100%;\n  display: flex;\n  gap: 6px 6px;\n}\n.leads-view-attachments svg {\n  width: 16px;\n  fill: none;\n  stroke: #10294D;\n  stroke-width: 2.4;\n}\n.leads-view-relation {\n  border-radius: 2px;\n  border: 1px solid #CED7E2;\n  font-weight: 500;\n  font-size: 12px;\n  padding: 2px 5px;\n}\n.leads-view-form {\n  flex: 0 0 100%;\n}\n.leads-view-form-footer {\n  margin-top: 15px;\n  display: flex;\n  justify-content: flex-end;\n}\n.leads-index {\n  top: 0;\n  position: relative;\n  grid-area: jump-menu;\n  min-width: 0;\n  min-height: 0;\n  background: #ffffff;\n}\n@media screen and (min-width: 799px) {\n  .leads-index {\n    position: sticky;\n    width: 370px;\n  }\n}\n.leads-index form,\n.leads-index > div:nth-child(1) {\n  padding: 10px 15px;\n  display: flex;\n}\n.leads-index .keyword-search {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 0 0 100%;\n  gap: 10px 10px;\n}\n.leads-index .keyword-search .btn-red {\n  margin-left: auto;\n}\n.leads-index .keyword-search > .form-group {\n  flex: 0 0 100%;\n  gap: 10px 10px;\n}\n.leads-index .keyword-search > .form-group .form-group {\n  flex: 1 1 auto;\n}\n.leads-index .keyword-search > .form-group .form-group.dateinput {\n  flex: 0 0 auto;\n}\n.leads-index .keyword-search .advanced-toggle {\n  flex: 1 1 auto;\n  justify-content: center;\n}\n.leads-index .keyword-search .button-only {\n  flex: 0 0 auto !important;\n}\n.leads-index .keyword-search .input-only .flatpickr-wrapper {\n  flex: 0 0 0;\n  max-width: 0;\n}\n.leads-index .keyword-search .input-only .input-group-addon {\n  min-height: 36px;\n}\n.leads-index .keyword-search .inline-select .input-group-addon {\n  font-size: 14px;\n  padding-left: 15px;\n}\n.leads-index .leads-index-list-inner {\n  padding: 2px 15px 0;\n  display: flex;\n  gap: 15px 0;\n  flex-direction: column;\n}\n.leads-index .no-leads {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  min-height: 100%;\n  padding-bottom: 56px;\n}\n.leads-index .no-leads .no-leads-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1 1 100%;\n}\n.lead-progress {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 0 10px;\n  padding: 15px 20px;\n}\n.tablecell .lead-progress {\n  padding: 0;\n}\n.lead-progress .lead-progress-label {\n  text-align: center;\n  white-space: nowrap;\n}\n.flex-heading + .lead-progress {\n  margin-left: auto;\n  padding: 0;\n}\n.flex-heading + .lead-progress .lead-progress-item {\n  flex-direction: row;\n  gap: 10px 10px;\n}\n.flex-heading + .lead-progress .lead-progress-label {\n  font-weight: bold;\n  color: #10294D;\n}\n.lead-progress .lead-progress-label {\n  margin-top: 5px;\n  text-align: center;\n  white-space: nowrap;\n}\n.lead-progress .lead-progress-meta {\n  font-size: 9px;\n  color: #5A6F89;\n  text-align: center;\n  white-space: nowrap;\n}\n.lead-progress .lead-progress-divider {\n  height: 1px;\n  margin: 32px 0 0;\n  background: #E5EBF1;\n  align-self: flex-start;\n  flex: 1 1 auto;\n}\n.lead-progress .lead-progress-icon {\n  display: flex;\n  align-items: center;\n  background: #E5EBF1;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n}\n.lead-progress .lead-progress-icon svg {\n  fill: none;\n  stroke: #ffffff;\n  stroke-width: 2.4;\n  width: 16px;\n  height: 16px !important;\n}\n.lead-progress .lead-progress-icon.New {\n  background: #FC495D;\n}\n.lead-progress .lead-progress-icon.New + .lead-progress-label {\n  color: #10294D;\n}\n.lead-progress .lead-progress-icon.Contacted {\n  background: #73C677;\n}\n.lead-progress .lead-progress-icon.Contacted + .lead-progress-label {\n  color: #10294D;\n}\n.lead-progress .lead-progress-icon.Lease-Application {\n  background: #BF60EC;\n}\n.lead-progress .lead-progress-icon.Lease-Application + .lead-progress-label {\n  color: #10294D;\n}\n.lead-progress .lead-progress-icon.Viewing {\n  background: #3699FE;\n}\n.lead-progress .lead-progress-icon.Viewing + .lead-progress-label {\n  color: #10294D;\n}\n.lead-progress .lead-progress-icon.Offer {\n  background: #BF60EC;\n}\n.lead-progress .lead-progress-icon.Offer + .lead-progress-label {\n  color: #10294D;\n}\n.lead-progress .lead-progress-icon.Sold {\n  background: #FFA564;\n}\n.lead-progress .lead-progress-icon.Sold + .lead-progress-label {\n  color: #10294D;\n}\n.lead-progress .lead-progress-icon.Rented {\n  background: #FFA564;\n}\n.lead-progress .lead-progress-icon.Rented + .lead-progress-label {\n  color: #10294D;\n}\n.lead-progress .lead-progress-icon.Archived {\n  background: #10294D;\n}\n.lead-progress .lead-progress-icon.Archived + .lead-progress-label {\n  color: #10294D;\n}\n.lead-progress .lead-progress-icon.offer-made {\n  background: #60D3EC;\n}\n.lead-progress .lead-progress-icon.offer-made + .lead-progress-label {\n  color: #10294D;\n  font-weight: 500;\n}\n.lead-progress .lead-progress-icon.sale-agreement {\n  background: #0CA6C8;\n}\n.lead-progress .lead-progress-icon.sale-agreement + .lead-progress-label {\n  color: #10294D;\n  font-weight: 500;\n}\n.lead-progress .lead-progress-icon.buyer-signed {\n  background: #3699FE;\n}\n.lead-progress .lead-progress-icon.buyer-signed + .lead-progress-label {\n  color: #10294D;\n  font-weight: 500;\n}\n.lead-progress .lead-progress-icon.seller-signed {\n  background: #006DDC;\n}\n.lead-progress .lead-progress-icon.seller-signed + .lead-progress-label {\n  color: #10294D;\n  font-weight: 500;\n}\n.lead-progress .lead-progress-icon.instruction-sent {\n  background: #BF60EC;\n}\n.lead-progress .lead-progress-icon.instruction-sent + .lead-progress-label {\n  color: #10294D;\n  font-weight: 500;\n}\n.lead-progress .lead-progress-icon.deposit-received {\n  background: #B339EC;\n}\n.lead-progress .lead-progress-icon.deposit-received + .lead-progress-label {\n  color: #10294D;\n  font-weight: 500;\n}\n.lead-progress .lead-progress-icon.conditions-met {\n  background: #B339EC;\n}\n.lead-progress .lead-progress-icon.conditions-met + .lead-progress-label {\n  color: #10294D;\n  font-weight: 500;\n}\n.lead-progress .lead-progress-icon.lodged {\n  background: #73C677;\n}\n.lead-progress .lead-progress-icon.lodged + .lead-progress-label {\n  color: #10294D;\n  font-weight: 500;\n}\n.lead-progress .lead-progress-icon.closed {\n  background: #E62D42;\n}\n.lead-progress .lead-progress-icon.closed + .lead-progress-label {\n  color: #10294D;\n  font-weight: 500;\n}\n.lead-progress .lead-progress-icon.cancelled {\n  background: #10294D;\n}\n.lead-progress .lead-progress-icon.cancelled + .lead-progress-label {\n  color: #10294D;\n}\n.lead-progress .lead-progress-item {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex: 0 0;\n  line-height: 21px;\n}\n.interaction-selection {\n  display: flex;\n  gap: 15px 6px;\n  flex-wrap: wrap;\n  margin-bottom: 25px;\n}\n.interaction-selection .btn {\n  flex: 0 0 100%;\n}\n@media screen and (min-width: 799px) {\n  .interaction-selection .btn {\n    flex: 0 0 auto;\n  }\n}\n.back-to-leads {\n  position: fixed;\n  padding: 4px 0 !important;\n  background: #ffffff;\n  top: 68px;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n}\n.interaction-buttons {\n  margin-top: 25px;\n}\n.lead-interaction-details strong {\n  font-size: 12px;\n}\n.lead-interaction-details .cardbody .ccontent {\n  display: flex;\n  flex-direction: column;\n  gap: 10px 10px;\n}\n.lead-interaction-item-icon {\n  display: flex;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  align-items: center;\n  justify-content: center;\n}\n.lead-interaction-item-icon.Contacted {\n  background: #DCF1DE;\n}\n.lead-interaction-item-icon.Contacted svg {\n  stroke: #73C677;\n}\n.lead-interaction-item-icon.Viewing {\n  background: #D7F4FA;\n}\n.lead-interaction-item-icon.Viewing svg {\n  stroke: #60D3EC;\n}\n.lead-interaction-item-icon.Rental-Application {\n  background: #EFD7F9;\n}\n.lead-interaction-item-icon.Rental-Application svg {\n  stroke: #BF60EC;\n}\n.lead-interaction-item-icon.Offer {\n  background: #EFD7F9;\n}\n.lead-interaction-item-icon.Offer svg {\n  stroke: #BF60EC;\n}\n.lead-interaction-item-icon.Archived {\n  background: #C3C9D2;\n}\n.lead-interaction-item-icon.Archived svg {\n  stroke: #10294D;\n}\n.lead-interaction-item-icon svg {\n  width: 24px;\n  height: 24px;\n  stroke-width: 1.4;\n}\n.lead-interaction-item-header {\n  font-size: 11px;\n  flex: 1 1 auto;\n  gap: 12px 12px;\n  display: flex;\n  align-items: center;\n}\n.lead-interaction-item-top {\n  flex: 1 1 auto;\n}\n.lead-interaction-item-top > * {\n  flex: 1 1 100%;\n}\n.lead-interaction-item-top strong {\n  color: #10294D;\n  margin-right: auto;\n}\n.lead-interaction-item-date {\n  font-size: 11px;\n}\n.interaction-buttons {\n  display: flex;\n  gap: 20px 20px;\n}\n.interaction-form .form-group .input-label {\n  background: #FAFBFD;\n}\n.lead-interaction-tags {\n  margin-top: 12px;\n}\n.lead-interaction-tags .lead-interaction-tag {\n  background: #ffffff;\n  border: 1px solid #CED7E2;\n}\n.lead-interaction-item-body label {\n  display: block;\n  color: #92A7C0;\n  text-transform: uppercase;\n  font-size: 11px;\n  margin-top: 12px;\n}\n.lead-interaction-item-body label:nth-child(1) {\n  margin-top: 0;\n}\n.lead-log-timeline {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  gap: 13px 13px;\n  padding-bottom: 0;\n}\n.lead-log-timeline .lead-log-timeline-bar {\n  width: 7px;\n}\n.lead-log-timeline .lead-log-timeline-bar:before {\n  width: 1px;\n}\n.lead-log-timeline .lead-log-timeline-bar:after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 20px;\n  background-image: linear-gradient(to bottom, transparent, #FFF);\n}\n.lead-log-timeline .lead-log-item {\n  position: relative;\n  display: flex;\n  gap: 2px 12px;\n  z-index: 1;\n}\n.lead-log-timeline .lead-log-item h5 {\n  margin: 0;\n  font-weight: 600;\n}\n.lead-log-timeline .lead-log-item-icon {\n  display: flex;\n  align-items: center;\n  margin: 2px 0;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n}\n.lead-log-timeline .lead-log-item-icon.New {\n  background: #FC495D;\n  color: #ffffff;\n}\n.lead-log-timeline .lead-log-item-icon.Contacted {\n  background: #73C677;\n  color: #ffffff;\n}\n.lead-log-timeline .lead-log-item-icon.Viewing {\n  background: #3699FE;\n  color: #ffffff;\n}\n.lead-log-timeline .lead-log-item-icon.Rental-Application {\n  background: #BF60EC;\n  color: #ffffff;\n}\n.lead-log-timeline .lead-log-item-icon.Offer {\n  background: #BF60EC;\n  color: #ffffff;\n}\n.lead-log-timeline .lead-log-item-icon.Sold {\n  background: #FFA564;\n  color: #ffffff;\n}\n.lead-log-timeline .lead-log-item-icon.Rented {\n  background: #FFA564;\n  color: #ffffff;\n}\n.lead-log-timeline .lead-log-item-icon.Archived {\n  background: #10294D;\n  color: #ffffff;\n}\n.tc-tooltip {\n  pointer-events: none;\n  font-size: 0.9rem;\n  background: #FAFBFD;\n  border-radius: 3px;\n  border: 1px solid #CED7E2;\n  max-width: 50%;\n  z-index: 1000;\n}\n.tc-tooltip.tc-tooltip-clickable {\n  pointer-events: all;\n}\n.tc-tooltip-wrapper {\n  position: relative;\n  display: inline-block;\n}\n.tc-tooltip-title {\n  margin: 0;\n  padding: 6px 8px;\n  font-size: 1rem;\n  line-height: 1;\n  border-bottom: 1px solid #CED7E2;\n  background: #f4f4f4;\n}\n.tc-tooltip-content {\n  text-align: left;\n  padding: 8px;\n}\n.tc-tooltip-arrow-bottom {\n  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);\n}\n.tc-tooltip-arrow-bottom:after {\n  content: \"\";\n  border-color: #FAFBFD transparent transparent transparent;\n  border-width: 10px;\n  border-style: solid;\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.tc-tooltip-arrow-bottom:before {\n  content: \"\";\n  border-color: #CED7E2 transparent transparent transparent;\n  border-width: 11px;\n  border-style: solid;\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.tc-tooltip-arrow-bottom-left {\n  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);\n}\n.tc-tooltip-arrow-bottom-left:after {\n  content: \"\";\n  border-color: #FAFBFD transparent transparent transparent;\n  border-width: 10px;\n  border-style: solid;\n  position: absolute;\n  top: 100%;\n  left: 80px;\n  transform: translateX(-50%);\n}\n.tc-tooltip-arrow-bottom-left:before {\n  content: \"\";\n  border-color: #CED7E2 transparent transparent transparent;\n  border-width: 11px;\n  border-style: solid;\n  position: absolute;\n  top: 100%;\n  left: 80px;\n  transform: translateX(-50%);\n}\n.tc-tooltip-arrow-top {\n  box-shadow: 0px 9px 17px rgba(195, 201, 210, 0.31);\n}\n.tc-tooltip-arrow-top:after {\n  content: \"\";\n  border-color: transparent transparent #FAFBFD transparent;\n  border-width: 10px;\n  border-style: solid;\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.tc-tooltip-arrow-top:before {\n  content: \"\";\n  border-color: transparent transparent #CED7E2 transparent;\n  border-width: 11px;\n  border-style: solid;\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.popup-wrapper {\n  display: flex;\n  align-content: flex-start;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.popup-wrapper .popup-image {\n  width: 160px;\n  position: relative;\n  flex: 0 0 100%;\n  min-height: 160px;\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  overflow: hidden;\n  background-size: cover;\n  background-position: center;\n}\n@media screen and (min-width: 799px) {\n  .popup-wrapper .popup-image {\n    flex: 0 0 160px;\n  }\n}\n.popup-wrapper .popup-image img {\n  width: 100%;\n  object-fit: cover;\n}\n.popup-wrapper .popup-data {\n  flex: 1 1 auto;\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 380px;\n}\n.popup-wrapper h5 {\n  flex: 1 1 100%;\n  text-transform: uppercase;\n  color: #10294D;\n}\n.popup-wrapper .popup-price {\n  flex: 1 1 100%;\n  font-size: 1.25rem;\n  font-weight: bold;\n  color: #5A6F89;\n}\n.popup-wrapper .popup-address {\n  flex: 1 1 100%;\n  margin-top: 2px;\n  color: #5A6F89;\n}\n.popup-wrapper .popup-divider {\n  flex: 1 1 100%;\n  height: 1px;\n  background: #CED7E2;\n  margin-top: 8px;\n  margin-bottom: 8px;\n}\n.popup-wrapper .popup-featured {\n  display: grid;\n  grid-template-columns: auto auto;\n  flex: 0 0 100%;\n  gap: 4px 10px;\n  flex-wrap: wrap;\n}\n.popup-wrapper .popup-featured > .meta-detail {\n  display: flex;\n  margin: 0;\n  flex-wrap: nowrap;\n  align-items: center;\n  align-content: center;\n  gap: 4px 10px;\n}\n.popup-wrapper .popup-featured > .meta-detail .heavy {\n  display: flex;\n  min-width: 90px;\n  margin: auto;\n  font-size: 10px;\n  text-transform: uppercase;\n  white-space: nowrap;\n  background: #F3F5F8;\n  flex: 0 0 1%;\n  padding: 3px 6px;\n}\n.popup-wrapper .popup-featured > .meta-detail .col {\n  display: flex;\n  padding: 0;\n  max-width: 90px;\n  margin: auto;\n  flex: 0 1 auto;\n  align-items: center;\n}\n.tree-wrapper {\n  padding: 0 10px;\n}\n.tree-wrapper ul {\n  padding: 0;\n  margin: 0;\n  min-height: 36px;\n}\n.tree-item--wrapper {\n  list-style: none;\n  box-sizing: border-box;\n  padding-left: var(--spacing);\n  margin-bottom: -1px;\n}\n.tree-item--clone {\n  display: inline-block;\n  pointer-events: none;\n  padding: 0;\n  padding-left: 10px;\n  padding-top: 5px;\n}\n.tree-item--clone .tree-item--item {\n  --vertical-padding: 5px;\n  padding-right: 24px;\n  border-radius: 4px;\n  box-shadow: 0px 15px 15px 0 rgba(34, 33, 81, 0.1);\n}\n.tree-item--ghost.tree-item--indicator {\n  opacity: 1;\n  position: relative;\n  z-index: 1;\n  margin-bottom: -1px;\n}\n.tree-item--ghost.tree-item--indicator .tree-item--item {\n  position: relative;\n  padding: 0;\n  height: 8px;\n  border-color: #2389ff;\n  background-color: #56a1f8;\n}\n.tree-item--ghost.tree-item--indicator .tree-item--item:before {\n  position: absolute;\n  left: -8px;\n  top: -4px;\n  display: block;\n  content: '';\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  border: 1px solid #2389ff;\n  background-color: #ffffff;\n}\n.tree-item--ghost.tree-item--indicator .tree-item--item > * {\n  /* Items are hidden using height and opacity to retain focus */\n  opacity: 0;\n  height: 0;\n}\n.tree-item--ghost:not(.tree-item--indicator) {\n  opacity: 0.5;\n}\n.tree-item--ghost .tree-item--item > * {\n  box-shadow: none;\n  background-color: transparent;\n}\n.tree-item--item {\n  --vertical-padding: 8px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: var(--vertical-padding) 13px;\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid #cfcdcd;\n  border-color: #E5EBF1;\n  color: #222;\n  box-sizing: border-box;\n}\n.tree-item--item svg {\n  fill: none;\n  stroke: #92A7C0;\n  stroke-width: 2.4;\n  width: 16px;\n  transition: transform 250ms ease;\n}\n.tree-item--item:hover .tree-item--item--remove {\n  cursor: pointer;\n  opacity: 1;\n  pointer-events: all;\n}\n.tree-item--item--text {\n  flex-grow: 1;\n  padding-left: 0.5rem;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.tree-item--item--count {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #2389ff;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #fff;\n}\n.tree-item--item--disable-interaction {\n  pointer-events: none;\n}\n.tree-item--item--disable-selection .tree-item--item--text,\n.tree-item--clone .tree-item--item--text,\n.tree-item--item--disable-selection .tree-item--item--count,\n.tree-item--clone .tree-item--item--count {\n  user-select: none;\n  -webkit-user-select: none;\n}\n.tree-item--item--collapse {\n  margin-right: 10px;\n  display: flex;\n  align-items: center;\n}\n.tree-item--item--collapse.tree-item--item--collapsed svg {\n  transform: rotate(-90deg);\n}\n.tree-item--item--remove {\n  margin-left: auto;\n  display: flex;\n  opacity: 0;\n  pointer-events: none;\n  align-items: center;\n}\n#fc_frame.fc-widget-small {\n  bottom: 50px;\n  right: 10px;\n  z-index: 10;\n}\n#fc_frame.freshchat_frame.fc-open {\n  z-index: 1000;\n  right: 0;\n}\n#hubspot-conversations-inline-iframe {\n  width: 100vw;\n  height: calc(100vh - 68px);\n  border: none;\n}\n@media screen and (min-width: 799px) {\n  #hubspot-conversations-inline-iframe {\n    width: 300px;\n    height: 500px;\n  }\n}\n#hubspot-chat-holder {\n  position: fixed;\n  right: 50%;\n  transform: translate(50%, 0);\n  top: 68px;\n  background-color: white;\n  box-shadow: 0px 0px 59px 0px rgba(0, 0, 0, 0.25);\n  z-index: 1000;\n  visibility: hidden;\n}\n@media screen and (min-width: 799px) {\n  #hubspot-chat-holder {\n    right: 15px;\n    transform: none;\n  }\n}\n#hubspot-chat-holder > .btn {\n  position: absolute;\n  top: calc(68px / 2);\n  right: 0;\n  transform: translate(0, -50%);\n}\n#hubspot-chat-holder > .btn svg {\n  stroke: #ffffff;\n}\n","// Hover mixin and `@enable-hover-media-query` are deprecated.\n//\n// Origally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n#hover(@content) {\n\t&:hover { @content(); }\n}\n\n#hover-focus(@content) {\n\t&:hover,\n\t&:focus {\n\t\t@content();\n\t}\n}\n\n#plain-hover-focus(@content) {\n\t&,\n\t&:hover,\n\t&:focus {\n\t\t@content();\n\t}\n}\n\n#hover-focus-active(@content) {\n\t&:hover,\n\t&:focus,\n\t&:active {\n\t\t@content();\n\t}\n}\n",".align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// Contextual backgrounds\n\n#bg-variant(@parent, @color) {\n\t@{parent} {\n\t\tbackground-color: @color !important;\n\t}\n\ta@{parent},\n\tbutton@{parent} {\n\t\t#hover-focus({\n\t\t\tbackground-color: darken(@color, 10%) !important;\n\t\t});\n\t}\n}\n\n#bg-gradient-variant(@parent, @color) {\n\t@{parent} {\n\t\tbackground: @color linear-gradient(180deg, mix(@body-bg, @color, 15%), @color) repeat-x !important;\n\t}\n}\n","//@each $color, $value in $theme-colors {\n//  @include bg-variant('.bg-#{$color}', $value);\n//}\n#each-theme-color-bg(@i: 1) when (@i =< length(@theme-colors)) {\n\t@item: extract(@theme-colors, @i);\n\t@color: extract(@item, 1);\n\t@value: extract(@item, 2);\n\n\t#bg-variant(~\".bg-@{color}\", @value);\n\n\t#each-theme-color-bg((@i + 1));\n} #each-theme-color-bg();\n\n//@if $enable-gradients {\n//  @each $color, $value in $theme-colors {\n//    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value);\n//  }\n//}\n#each-theme-color-bg-gradient(@i: 1) when (@i =< length(@theme-colors)) and (@enable-gradients) {\n\t@item: extract(@theme-colors, @i);\n\t@color: extract(@item, 1);\n\t@value: extract(@item, 2);\n\n\t#bg-gradient-variant(~\".bg-gradient-@{color}\", @value);\n\n\t#each-theme-color-bg-gradient((@i + 1));\n} #each-theme-color-bg-gradient();\n\n\n.bg-white {\n\tbackground-color: @white !important;\n}\n\n.bg-transparent {\n\tbackground-color: transparent !important;\n}\n","//\n// Border\n//\n\n.border         { border: @border-width solid @border-color !important; }\n.border-top     { border-top: @border-width solid @border-color !important; }\n.border-right   { border-right: @border-width solid @border-color !important; }\n.border-bottom  { border-bottom: @border-width solid @border-color !important; }\n.border-left    { border-left: @border-width solid @border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n//@each $color, $value in $theme-colors {\n//  .border-#{$color} {\n//    border-color: $value !important;\n//  }\n//}\n#each-theme-color-border(@i: 1) when (@i =< length(@theme-colors)) {\n\t@item: extract(@theme-colors, @i);\n\t@color: extract(@item, 1);\n\t@value: extract(@item, 2);\n\n\t.border-@{color} {\n\t\tborder-color: @value !important;\n\t}\n\n\t#each-theme-color-border((@i + 1));\n} #each-theme-color-border();\n\n.border-white {\n\tborder-color: @white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded {\n\tborder-radius: @border-radius !important;\n}\n.rounded-top {\n\tborder-top-left-radius: @border-radius !important;\n\tborder-top-right-radius: @border-radius !important;\n}\n.rounded-right {\n\tborder-top-right-radius: @border-radius !important;\n\tborder-bottom-right-radius: @border-radius !important;\n}\n.rounded-bottom {\n\tborder-bottom-right-radius: @border-radius !important;\n\tborder-bottom-left-radius: @border-radius !important;\n}\n.rounded-left {\n\tborder-top-left-radius: @border-radius !important;\n\tborder-bottom-left-radius: @border-radius !important;\n}\n\n.rounded-circle {\n\tborder-radius: 50% !important;\n}\n\n.rounded-0 {\n\tborder-radius: 0 !important;\n}\n","#clearfix() {\n\t&::after {\n\t\tdisplay: block;\n\t\tclear: both;\n\t\tcontent: \"\";\n\t}\n}\n","//\n// Utilities for common `display` values\n//\n\n//@each $breakpoint in map-keys($grid-breakpoints) {\n//  @include media-breakpoint-up($breakpoint) {\n//    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n//\n//    .d#{$infix}-none         { display: none !important; }\n//    .d#{$infix}-inline       { display: inline !important; }\n//    .d#{$infix}-inline-block { display: inline-block !important; }\n//    .d#{$infix}-block        { display: block !important; }\n//    .d#{$infix}-table        { display: table !important; }\n//    .d#{$infix}-table-cell   { display: table-cell !important; }\n//    .d#{$infix}-flex         { display: flex !important; }\n//    .d#{$infix}-inline-flex  { display: inline-flex !important; }\n//  }\n//}\n#each-breakpoint-display(@i: 1) when (@i =< length(@grid-breakpoints)) {\n\t@breakpoint: extract(extract(@grid-breakpoints, @i), 1);\n\n\t#media-breakpoint-up(@breakpoint, {\n\t\t@infix: breakpoint-infix(@breakpoint, @grid-breakpoints);\n\n\t\t.d@{infix}-none         { display: none !important; }\n\t\t.d@{infix}-inline       { display: inline !important; }\n\t\t.d@{infix}-inline-block { display: inline-block !important; }\n\t\t.d@{infix}-block        { display: block !important; }\n\t\t.d@{infix}-table        { display: table !important; }\n\t\t.d@{infix}-table-row    { display: table-row !important; }\n\t\t.d@{infix}-table-cell   { display: table-cell !important; }\n\t\t.d@{infix}-flex         { display: flex !important; }\n\t\t.d@{infix}-inline-flex  { display: inline-flex !important; }\n\t});\n\n\t#each-breakpoint-display((@i + 1));\n} #each-breakpoint-display();\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n\t.d-print-none         { display: none !important; }\n\t.d-print-inline       { display: inline !important; }\n\t.d-print-inline-block { display: inline-block !important; }\n\t.d-print-block        { display: block !important; }\n\t.d-print-table        { display: table !important; }\n\t.d-print-table-row    { display: table-row !important; }\n\t.d-print-table-cell   { display: table-cell !important; }\n\t.d-print-flex         { display: flex !important; }\n\t.d-print-inline-flex  { display: inline-flex !important; }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `@grid-breakpoints` global variable is used as the `@breakpoints` argument by default.\n\n@plugin \"../plugins/breakpoints\";\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, @breakpoint-names: (xs sm md lg xl))\n//    md\n//@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n//  $n: index($breakpoint-names, $name);\n//  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n//}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n//@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n//  $min: map-get($breakpoints, $name);\n//  @return if($min != 0, $min, null);\n//}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n//@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n//  $next: breakpoint-next($name, $breakpoints);\n//  @return if($next, breakpoint-min($next, $breakpoints) - 0.01px, null);\n//}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash infront.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n//@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n//  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n//}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n//@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n//  $min: breakpoint-min($name, $breakpoints);\n//  @if $min {\n//    @media (min-width: $min) {\n//      @content;\n//    }\n//  } @else {\n//    @content;\n//  }\n//}\n#media-breakpoint-up(@name, @content, @breakpoints: @grid-breakpoints) {\n\t@min: breakpoint-min(@name, @breakpoints);\n\n\t& when not (@min = ~\"\") {\n\t\t@media (min-width: @min) {\n\t\t\t@content();\n\t\t}\n\t}\n\t& when (@min = ~\"\") {\n\t\t@content();\n\t}\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n//@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n//  $max: breakpoint-max($name, $breakpoints);\n//  @if $max {\n//    @media (max-width: $max) {\n//      @content;\n//    }\n//  } @else {\n//    @content;\n//  }\n//}\n#media-breakpoint-down(@name, @content, @breakpoints: @grid-breakpoints) {\n\t@max: breakpoint-max(@name, @breakpoints);\n\n\t& when not (@max = ~\"\") {\n\t\t@media (max-width: @max) {\n\t\t\t@content();\n\t\t}\n\t}\n\t& when (@max = ~\"\") {\n\t\t@content();\n\t}\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n//@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n//  $min: breakpoint-min($lower, $breakpoints);\n//  $max: breakpoint-max($upper, $breakpoints);\n//\n//  @if $min != null and $max != null {\n//    @media (min-width: $min) and (max-width: $max) {\n//      @content;\n//    }\n//  } @else if $max == null {\n//    @include media-breakpoint-up($lower) {\n//      @content;\n//    }\n//  } @else if $min == null {\n//    @include media-breakpoint-down($upper) {\n//      @content;\n//    }\n//  }\n//}\n#media-breakpoint-between(@lower, @upper, @content, @breakpoints: @grid-breakpoints) {\n\t@min: breakpoint-min(@lower, @breakpoints);\n\t@max: breakpoint-max(@upper, @breakpoints);\n\n\t& when not (@min = ~\"\") and not (@max = ~\"\") {\n\t\t@media (min-width: @min) and (max-width: @max) {\n\t\t\t@content();\n\t\t}\n\t}\n\t& when not (@min = ~\"\") and     (@max = ~\"\") {\n\t\t#media-breakpoint-up(@lower, @content, @breakpoints);\n\t}\n\t& when     (@min = ~\"\") and not (@max = ~\"\") {\n\t\t#media-breakpoint-down(@upper, @content, @breakpoints);\n\t}\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n//@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n//  $min: breakpoint-min($name, $breakpoints);\n//  $max: breakpoint-max($name, $breakpoints);\n//\n//  @if $min != null and $max != null {\n//    @media (min-width: $min) and (max-width: $max) {\n//      @content;\n//    }\n//  } @else if $max == null {\n//    @include media-breakpoint-up($name) {\n//      @content;\n//    }\n//  } @else if $min == null {\n//    @include media-breakpoint-down($name) {\n//      @content;\n//    }\n//  }\n//}\n#media-breakpoint-only(@name, @content, @breakpoints: @grid-breakpoints) {\n\t@min: breakpoint-min(@name, @breakpoints);\n\t@max: breakpoint-max(@name, @breakpoints);\n\n\t& when not (@min = ~\"\") and not (@max = ~\"\") {\n\t\t@media (min-width: @min) and (max-width: @max) {\n\t\t\t@content();\n\t\t}\n\t}\n\t& when not (@min = ~\"\") and     (@max = ~\"\") {\n\t\t#media-breakpoint-up(@name, @content, @breakpoints);\n\t}\n\t& when     (@min = ~\"\") and not (@max = ~\"\") {\n\t\t#media-breakpoint-down(@name, @content, @breakpoints);\n\t}\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n\tposition: relative;\n\tdisplay: block;\n\twidth: 100%;\n\tpadding: 0;\n\toverflow: hidden;\n\n\t&::before {\n\t\tdisplay: block;\n\t\tcontent: \"\";\n\t}\n\n\t.embed-responsive-item,\n\tiframe,\n\tembed,\n\tobject,\n\tvideo {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tborder: 0;\n\t}\n}\n\n.embed-responsive-21by9 {\n\t&::before {\n\t\tpadding-top: percentage((9 / 21));\n\t}\n}\n\n.embed-responsive-16by9 {\n\t&::before {\n\t\tpadding-top: percentage((9 / 16));\n\t}\n}\n\n.embed-responsive-4by3 {\n\t&::before {\n\t\tpadding-top: percentage((3 / 4));\n\t}\n}\n\n.embed-responsive-1by1 {\n\t&::before {\n\t\tpadding-top: percentage((1 / 1));\n\t}\n}\n","// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n//@each $breakpoint in map-keys($grid-breakpoints) {\n//  @include media-breakpoint-up($breakpoint) {\n//    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n//\n//    .flex#{$infix}-row            { flex-direction: row !important; }\n//    .flex#{$infix}-column         { flex-direction: column !important; }\n//    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n//    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n//\n//    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n//    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n//    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n//    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n//    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n//    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n//    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n//    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n//\n//    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n//    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n//    .justify-content#{$infix}-center  { justify-content: center !important; }\n//    .justify-content#{$infix}-between { justify-content: space-between !important; }\n//    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n//\n//    .align-items#{$infix}-start    { align-items: flex-start !important; }\n//    .align-items#{$infix}-end      { align-items: flex-end !important; }\n//    .align-items#{$infix}-center   { align-items: center !important; }\n//    .align-items#{$infix}-baseline { align-items: baseline !important; }\n//    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n//\n//    .align-content#{$infix}-start   { align-content: flex-start !important; }\n//    .align-content#{$infix}-end     { align-content: flex-end !important; }\n//    .align-content#{$infix}-center  { align-content: center !important; }\n//    .align-content#{$infix}-between { align-content: space-between !important; }\n//    .align-content#{$infix}-around  { align-content: space-around !important; }\n//    .align-content#{$infix}-stretch { align-content: stretch !important; }\n//\n//    .align-self#{$infix}-auto     { align-self: auto !important; }\n//    .align-self#{$infix}-start    { align-self: flex-start !important; }\n//    .align-self#{$infix}-end      { align-self: flex-end !important; }\n//    .align-self#{$infix}-center   { align-self: center !important; }\n//    .align-self#{$infix}-baseline { align-self: baseline !important; }\n//    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n//  }\n//}\n#each-breakpoint-flex(@i: 1) when (@i =< length(@grid-breakpoints)) {\n\t@breakpoint: extract(extract(@grid-breakpoints, @i), 1);\n\n\t#media-breakpoint-up(@breakpoint, {\n\t\t@infix: breakpoint-infix(@breakpoint, @grid-breakpoints);\n\n\t\t.flex@{infix}-row            { flex-direction: row !important; }\n\t\t.flex@{infix}-column         { flex-direction: column !important; }\n\t\t.flex@{infix}-row-reverse    { flex-direction: row-reverse !important; }\n\t\t.flex@{infix}-column-reverse { flex-direction: column-reverse !important; }\n\n\t\t.flex@{infix}-wrap         { flex-wrap: wrap !important; }\n\t\t.flex@{infix}-nowrap       { flex-wrap: nowrap !important; }\n\t\t.flex@{infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n\t\t.flex@{infix}-fill         { flex: 1 1 auto !important; }\n\t\t.flex@{infix}-grow-0       { flex-grow: 0 !important; }\n\t\t.flex@{infix}-grow-1       { flex-grow: 1 !important; }\n\t\t.flex@{infix}-shrink-0     { flex-shrink: 0 !important; }\n\t\t.flex@{infix}-shrink-1     { flex-shrink: 1 !important; }\n\n\t\t.justify-content@{infix}-start   { justify-content: flex-start !important; }\n\t\t.justify-content@{infix}-end     { justify-content: flex-end !important; }\n\t\t.justify-content@{infix}-center  { justify-content: center !important; }\n\t\t.justify-content@{infix}-between { justify-content: space-between !important; }\n\t\t.justify-content@{infix}-around  { justify-content: space-around !important; }\n\n\t\t.align-items@{infix}-start    { align-items: flex-start !important; }\n\t\t.align-items@{infix}-end      { align-items: flex-end !important; }\n\t\t.align-items@{infix}-center   { align-items: center !important; }\n\t\t.align-items@{infix}-baseline { align-items: baseline !important; }\n\t\t.align-items@{infix}-stretch  { align-items: stretch !important; }\n\n\t\t.align-content@{infix}-start   { align-content: flex-start !important; }\n\t\t.align-content@{infix}-end     { align-content: flex-end !important; }\n\t\t.align-content@{infix}-center  { align-content: center !important; }\n\t\t.align-content@{infix}-between { align-content: space-between !important; }\n\t\t.align-content@{infix}-around  { align-content: space-around !important; }\n\t\t.align-content@{infix}-stretch { align-content: stretch !important; }\n\n\t\t.align-self@{infix}-auto     { align-self: auto !important; }\n\t\t.align-self@{infix}-start    { align-self: flex-start !important; }\n\t\t.align-self@{infix}-end      { align-self: flex-end !important; }\n\t\t.align-self@{infix}-center   { align-self: center !important; }\n\t\t.align-self@{infix}-baseline { align-self: baseline !important; }\n\t\t.align-self@{infix}-stretch  { align-self: stretch !important; }\n\t});\n\n\t#each-breakpoint-flex((@i + 1));\n} #each-breakpoint-flex();\n","//@each $breakpoint in map-keys($grid-breakpoints) {\n//  @include media-breakpoint-up($breakpoint) {\n//    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n//\n//    .float#{$infix}-left  { @include float-left; }\n//    .float#{$infix}-right { @include float-right; }\n//    .float#{$infix}-none  { @include float-none; }\n//  }\n//}\n#each-breakpoint-float(@i: 1) when (@i =< length(@grid-breakpoints)) {\n\t@breakpoint: extract(extract(@grid-breakpoints, @i), 1);\n\n\t#media-breakpoint-up(@breakpoint, {\n\t\t@infix: breakpoint-infix(@breakpoint, @grid-breakpoints);\n\n\t\t.float@{infix}-left  { #float-left(); }\n\t\t.float@{infix}-right { #float-right(); }\n\t\t.float@{infix}-none  { #float-none(); }\n\t});\n\n\t#each-breakpoint-float((@i + 1));\n} #each-breakpoint-float();\n","#float-left() {\n\tfloat: left !important;\n}\n#float-right() {\n\tfloat: right !important;\n}\n#float-none() {\n\tfloat: none !important;\n}\n","// Common values\n\n// Less list not in variables since it's not intended for customization.\n@positions: static, relative, absolute, fixed, sticky;\n\n//@each $position in $positions {\n//  .position-#{$position} { position: $position !important; }\n//}\n#each-position(@i: 1) when (@i =< length(@positions)) {\n\t@position: extract(@positions, @i);\n\n\t.position-@{position} { position: @position !important; }\n\n\t#each-position((@i + 1));\n} #each-position();\n\n// Shorthand\n\n.fixed-top {\n\tposition: fixed;\n\ttop: 0;\n\tright: 0;\n\tleft: 0;\n\tz-index: @zindex-fixed;\n}\n\n.fixed-bottom {\n\tposition: fixed;\n\tright: 0;\n\tbottom: 0;\n\tleft: 0;\n\tz-index: @zindex-fixed;\n}\n\n.sticky-top {\n\t@supports (position: sticky) {\n\t\tposition: sticky;\n\t\ttop: 0;\n\t\tz-index: @zindex-sticky;\n\t}\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n\t#sr-only();\n}\n\n.sr-only-focusable {\n\t#sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://a11yproject.com/posts/how-to-hide-content\n// See: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/\n\n#sr-only() {\n\tposition: absolute;\n\twidth: 1px;\n\theight: 1px;\n\tpadding: 0;\n\toverflow: hidden;\n\tclip: rect(0, 0, 0, 0);\n\twhite-space: nowrap;\n\tborder: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n#sr-only-focusable() {\n\t&:active,\n\t&:focus {\n\t\tposition: static;\n\t\twidth: auto;\n\t\theight: auto;\n\t\toverflow: visible;\n\t\tclip: auto;\n\t\twhite-space: normal;\n\t}\n}\n",".shadow-sm { box-shadow: @box-shadow-sm !important; }\n.shadow { box-shadow: @box-shadow !important; }\n.shadow-lg { box-shadow: @box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// Width and height\n\n//@each $prop, $abbrev in (width: w, height: h) {\n//  @each $size, $length in $sizes {\n//    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n//  }\n//}\n@sizing-properties: width w, height h;\n\n#each-sizing-property(@i: 1) when (@i =< length(@sizing-properties)) {\n\t@sizing-property: extract(@sizing-properties, @i);\n\t@prop: extract(@sizing-property, 1);\n\t@abbrev: extract(@sizing-property, 2);\n\n\t#each-size(@ii: 1) when (@ii =< length(@sizes)) {\n\t\t@item: extract(@sizes, @ii);\n\t\t@size: extract(@item, 1);\n\t\t@length: extract(@item, 2);\n\n\t\t.@{abbrev}-@{size} { @{prop}: @length !important; }\n\n\t\t#each-size((@ii + 1));\n\t} #each-size();\n\n\t#each-sizing-property((@i + 1));\n} #each-sizing-property();\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n","// Margin and Padding\n\n//@each $breakpoint in map-keys($grid-breakpoints) {\n//  @include media-breakpoint-up($breakpoint) {\n//    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n//\n//    @each $prop, $abbrev in (margin: m, padding: p) {\n//      @each $size, $length in $spacers {\n//\n//        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n//        .#{$abbrev}t#{$infix}-#{$size},\n//        .#{$abbrev}y#{$infix}-#{$size} {\n//          #{$prop}-top: $length !important;\n//        }\n//        .#{$abbrev}r#{$infix}-#{$size},\n//        .#{$abbrev}x#{$infix}-#{$size} {\n//          #{$prop}-right: $length !important;\n//        }\n//        .#{$abbrev}b#{$infix}-#{$size},\n//        .#{$abbrev}y#{$infix}-#{$size} {\n//          #{$prop}-bottom: $length !important;\n//        }\n//        .#{$abbrev}l#{$infix}-#{$size},\n//        .#{$abbrev}x#{$infix}-#{$size} {\n//          #{$prop}-left: $length !important;\n//        }\n//      }\n//    }\n//\n//    // Some special margin utils\n//    .m#{$infix}-auto { margin: auto !important; }\n//    .mt#{$infix}-auto,\n//    .my#{$infix}-auto {\n//      margin-top: auto !important;\n//    }\n//    .mr#{$infix}-auto,\n//    .mx#{$infix}-auto {\n//      margin-right: auto !important;\n//    }\n//    .mb#{$infix}-auto,\n//    .my#{$infix}-auto {\n//      margin-bottom: auto !important;\n//    }\n//    .ml#{$infix}-auto,\n//    .mx#{$infix}-auto {\n//      margin-left: auto !important;\n//    }\n//  }\n//}\n#each-breakpoint-spacing(@i: 1) when (@i =< length(@grid-breakpoints)) {\n\t@breakpoint: extract(extract(@grid-breakpoints, @i), 1);\n\n\t#media-breakpoint-up(@breakpoint, {\n\t\t@infix: breakpoint-infix(@breakpoint, @grid-breakpoints);\n\n\t\t@spacing-properties: margin m, padding p;\n\n\t\t#each-spacing-property(@ii: 1) when (@ii =< length(@spacing-properties)) {\n\t\t\t@spacing-property: extract(@spacing-properties, @ii);\n\t\t\t@prop: extract(@spacing-property, 1);\n\t\t\t@abbrev: extract(@spacing-property, 2);\n\n\t\t\t#each-spacer(@iii: 1) when (@iii =< length(@spacers)) {\n\t\t\t\t@item: extract(@spacers, @iii);\n\t\t\t\t@size: extract(@item, 1);\n\t\t\t\t@length: extract(@item, 2);\n\n\t\t\t\t.@{abbrev}@{infix}-@{size} { @{prop}: @length !important; }\n\t\t\t\t.@{abbrev}t@{infix}-@{size},\n\t\t\t\t.@{abbrev}y@{infix}-@{size} {\n\t\t\t\t\t@{prop}-top: @length !important;\n\t\t\t\t}\n\t\t\t\t.@{abbrev}r@{infix}-@{size},\n\t\t\t\t.@{abbrev}x@{infix}-@{size} {\n\t\t\t\t\t@{prop}-right: @length !important;\n\t\t\t\t}\n\t\t\t\t.@{abbrev}b@{infix}-@{size},\n\t\t\t\t.@{abbrev}y@{infix}-@{size} {\n\t\t\t\t\t@{prop}-bottom: @length !important;\n\t\t\t\t}\n\t\t\t\t.@{abbrev}l@{infix}-@{size},\n\t\t\t\t.@{abbrev}x@{infix}-@{size} {\n\t\t\t\t\t@{prop}-left: @length !important;\n\t\t\t\t}\n\n\t\t\t\t#each-spacer((@iii + 1));\n\t\t\t} #each-spacer();\n\n\t\t\t#each-spacing-property((@ii + 1));\n\t\t} #each-spacing-property();\n\n\t\t// Some special margin utils\n\t\t.m@{infix}-auto { margin: auto !important; }\n\t\t.mt@{infix}-auto,\n\t\t.my@{infix}-auto {\n\t\t\tmargin-top: auto !important;\n\t\t}\n\t\t.mr@{infix}-auto,\n\t\t.mx@{infix}-auto {\n\t\t\tmargin-right: auto !important;\n\t\t}\n\t\t.mb@{infix}-auto,\n\t\t.my@{infix}-auto {\n\t\t\tmargin-bottom: auto !important;\n\t\t}\n\t\t.ml@{infix}-auto,\n\t\t.mx@{infix}-auto {\n\t\t\tmargin-left: auto !important;\n\t\t}\n\t});\n\n\t#each-breakpoint-spacing((@i + 1));\n} #each-breakpoint-spacing();\n","//\n// Text\n//\n\n.text-monospace { font-family: @font-family-monospace; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { #text-truncate(); }\n\n// Responsive alignment\n\n//@each $breakpoint in map-keys($grid-breakpoints) {\n//  @include media-breakpoint-up($breakpoint) {\n//    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n//\n//    .text#{$infix}-left   { text-align: left !important; }\n//    .text#{$infix}-right  { text-align: right !important; }\n//    .text#{$infix}-center { text-align: center !important; }\n//  }\n//}\n#each-breakpoint-text(@i: 1) when (@i =< length(@grid-breakpoints)) {\n\t@breakpoint: extract(extract(@grid-breakpoints, @i), 1);\n\n\t#media-breakpoint-up(@breakpoint, {\n\t\t@infix: breakpoint-infix(@breakpoint, @grid-breakpoints);\n\n\t\t.text@{infix}-left   { text-align: left !important; }\n\t\t.text@{infix}-right  { text-align: right !important; }\n\t\t.text@{infix}-center { text-align: center !important; }\n\t});\n\n\t#each-breakpoint-text((@i + 1));\n} #each-breakpoint-text();\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light  { font-weight: @font-weight-light !important; }\n.font-weight-normal { font-weight: @font-weight-normal !important; }\n.font-weight-bold   { font-weight: @font-weight-bold !important; }\n.font-italic        { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: @white !important; }\n\n//@each $color, $value in $theme-colors {\n//  @include text-emphasis-variant('.text-#{$color}', $value);\n//}\n#each-theme-color-text(@i: 1) when (@i =< length(@theme-colors)) {\n\t@item: extract(@theme-colors, @i);\n\t@color: extract(@item, 1);\n\t@value: extract(@item, 2);\n\n\t#text-emphasis-variant(~\".text-@{color}\", @value);\n\n\t#each-theme-color-text((@i + 1));\n} #each-theme-color-text();\n\n.text-body { color: @body-color !important; }\n.text-muted { color: @text-muted !important; }\n\n.text-black-50 { color: fade(@black, 50%) !important; }\n.text-white-50 { color: fade(@white, 50%) !important; }\n\n// Misc\n\n.text-hide {\n\t#text-hide(@ignore-warning: true);\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n#text-truncate() {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n","// Typography\n\n#text-emphasis-variant(@parent, @color) {\n\t@{parent} {\n\t\tcolor: @color !important;\n\t}\n\ta@{parent} {\n\t\t#hover-focus({\n\t\t\tcolor: darken(@color, 10%) !important;\n\t\t});\n\t}\n}\n","// CSS image replacement\n#text-hide(@ignore-warning) {\n\tfont: ~\"0/0 a\";\n\tcolor: transparent;\n\ttext-shadow: none;\n\tbackground-color: transparent;\n\tborder: 0;\n\n\t& when not (@ignore-warning) {\n\t\t// @warn \"The `text-hide()` mixin has been deprecated as of v4.1.0. It will be removed entirely in v5.\";\n\t}\n}\n","//\n// Visibility utilities\n//\n\n.visible {\n\t#invisible(visible);\n}\n\n.invisible {\n\t#invisible(hidden);\n}\n","// Visibility\n\n#invisible(@visibility) {\n\tvisibility: @visibility !important;\n}\n","//\n// Textual form controls\n//\n\n.form-control {\n\tdisplay: block;\n\twidth: 100%;\n\tpadding: @input-padding-y @input-padding-x;\n\tfont-size: @font-size-base;\n\tline-height: @input-line-height;\n\tcolor: @input-color;\n\tbackground-color: @input-bg;\n\tbackground-clip: padding-box;\n\tborder: @input-border-width solid @input-border-color;\n\n\t// Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n\t& when (@enable-rounded) {\n\t\t// Manually use the if/else instead of the mixin to account for iOS override\n\t\tborder-radius: @input-border-radius;\n\t}\n\t& when not (@enable-rounded) {\n\t\t// Otherwise undo the iOS default\n\t\tborder-radius: 0;\n\t}\n\n\t#box-shadow(@input-box-shadow);\n\t#transition(@input-transition);\n\n\t// Unstyle the caret on `<select>`s in IE10+.\n\t&::-ms-expand {\n\t\tbackground-color: transparent;\n\t\tborder: 0;\n\t}\n\n\t// Customize the `:focus` state to imitate native WebKit styles.\n\t#form-control-focus();\n\n\t// Placeholder\n\t&::placeholder {\n\t\tcolor: @input-placeholder-color;\n\t\t// Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n\t\topacity: 1;\n\t}\n\n\t// Disabled and read-only inputs\n\t//\n\t// HTML5 says that controls under a fieldset > legend:first-child won't be\n\t// disabled if the fieldset is disabled. Due to implementation difficulty, we\n\t// don't honor that edge case; we style them as disabled anyway.\n\t&:disabled,\n\t&[readonly] {\n\t\tbackground-color: @input-disabled-bg;\n\t\t// iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n\t\topacity: 1;\n\t}\n}\n\nselect.form-control {\n\t&:not([size]):not([multiple]) {\n\t\theight: @input-height;\n\t}\n\n\t&:focus::-ms-value {\n\t\t// Suppress the nested default white text on blue background highlight given to\n\t\t// the selected option text when the (still closed) <select> receives focus\n\t\t// in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n\t\t// match the appearance of the native widget.\n\t\t// See https://github.com/twbs/bootstrap/issues/19398.\n\t\tcolor: @input-color;\n\t\tbackground-color: @input-bg;\n\t}\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n\tdisplay: block;\n\twidth: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n\tpadding-top: ~\"calc(@{input-padding-y} + @{input-border-width})\";\n\tpadding-bottom: ~\"calc(@{input-padding-y} + @{input-border-width})\";\n\tmargin-bottom: 0; // Override the `<label>/<legend>` default\n\tfont-size: inherit; // Override the `<legend>` default\n\tline-height: @input-line-height;\n}\n\n.col-form-label-lg {\n\tpadding-top: ~\"calc(@{input-padding-y-lg} + @{input-border-width})\";\n\tpadding-bottom: ~\"calc(@{input-padding-y-lg} + @{input-border-width})\";\n\tfont-size: @font-size-lg;\n\tline-height: @input-line-height-lg;\n}\n\n.col-form-label-sm {\n\tpadding-top: ~\"calc(@{input-padding-y-sm} + @{input-border-width})\";\n\tpadding-bottom: ~\"calc(@{input-padding-y-sm} + @{input-border-width})\";\n\tfont-size: @font-size-sm;\n\tline-height: @input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n\tdisplay: block;\n\twidth: 100%;\n\tpadding-top: @input-padding-y;\n\tpadding-bottom: @input-padding-y;\n\tmargin-bottom: 0; // match inputs if this class comes on inputs with default margins\n\tline-height: @input-line-height;\n\tcolor: @input-plaintext-color;\n\tbackground-color: transparent;\n\tborder: solid transparent;\n\tborder-width: @input-border-width 0;\n\n\t&.form-control-sm,\n\t&.form-control-lg {\n\t\tpadding-right: 0;\n\t\tpadding-left: 0;\n\t}\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// The `.form-group-* form-control` variations are sadly duplicated to avoid the\n// issue documented in https://github.com/twbs/bootstrap/issues/15074.\n\n.form-control-sm {\n\tpadding: @input-padding-y-sm @input-padding-x-sm;\n\tfont-size: @font-size-sm;\n\tline-height: @input-line-height-sm;\n\t#border-radius(@input-border-radius-sm);\n}\n\nselect.form-control-sm {\n\t&:not([size]):not([multiple]) {\n\t\theight: @input-height-sm;\n\t}\n}\n\n.form-control-lg {\n\tpadding: @input-padding-y-lg @input-padding-x-lg;\n\tfont-size: @font-size-lg;\n\tline-height: @input-line-height-lg;\n\t#border-radius(@input-border-radius-lg);\n}\n\nselect.form-control-lg {\n\t&:not([size]):not([multiple]) {\n\t\theight: @input-height-lg;\n\t}\n}\n\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n\tmargin-bottom: @form-group-margin-bottom;\n}\n\n.form-text {\n\tdisplay: block;\n\tmargin-top: @form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmargin-right: -5px;\n\tmargin-left: -5px;\n\n\t> .col,\n\t> [class*=\"col-\"] {\n\t\tpadding-right: 5px;\n\t\tpadding-left: 5px;\n\t}\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n\tposition: relative;\n\tdisplay: block;\n\tpadding-left: @form-check-input-gutter;\n}\n\n.form-check-input {\n\tposition: absolute;\n\tmargin-top: @form-check-input-margin-y;\n\tmargin-left: -@form-check-input-gutter;\n\n\t&:disabled ~ .form-check-label {\n\t\tcolor: @text-muted;\n\t}\n}\n\n.form-check-label {\n\tmargin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tpadding-left: 0; // Override base .form-check\n\tmargin-right: @form-check-inline-margin-x;\n\n\t// Undo .form-check-input defaults and add some `margin-right`.\n\t.form-check-input {\n\t\tposition: static;\n\t\tmargin-top: 0;\n\t\tmargin-right: @form-check-inline-input-margin-x;\n\t\tmargin-left: 0;\n\t}\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n#form-validation-state(valid, @form-feedback-valid-color);\n#form-validation-state(invalid, @form-feedback-invalid-color);\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n\tdisplay: flex;\n\tflex-flow: row wrap;\n\talign-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n\t// Because we use flex, the initial sizing of checkboxes is collapsed and\n\t// doesn't occupy the full-width (which is what we want for xs grid tier),\n\t// so we force that here.\n\t.form-check {\n\t\twidth: 100%;\n\t}\n\n\t// Kick in the inline\n\t#media-breakpoint-up(sm, {\n\t\tlabel {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t\t// Inline-block all the things for \"inline\"\n\t\t.form-group {\n\t\t\tdisplay: flex;\n\t\t\tflex: 0 0 auto;\n\t\t\tflex-flow: row wrap;\n\t\t\talign-items: center;\n\t\t\tmargin-bottom: 0;\n\t\t}\n\n\t\t// Allow folks to *not* use `.form-group`\n\t\t.form-control {\n\t\t\tdisplay: inline-block;\n\t\t\twidth: auto; // Prevent labels from stacking above inputs in `.form-group`\n\t\t\tvertical-align: middle;\n\t\t}\n\n\t\t// Make static controls behave like regular ones\n\t\t.form-control-plaintext {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t.input-group,\n\t\t.custom-select {\n\t\t\twidth: auto;\n\t\t}\n\n\t\t// Remove default margin on radios/checkboxes that were used for stacking, and\n\t\t// then undo the floating of radios and checkboxes to match.\n\t\t.form-check {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\twidth: auto;\n\t\t\tpadding-left: 0;\n\t\t}\n\t\t.form-check-input {\n\t\t\tposition: relative;\n\t\t\tmargin-top: 0;\n\t\t\tmargin-right: @form-check-input-margin-x;\n\t\t\tmargin-left: 0;\n\t\t}\n\n\t\t.custom-control {\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t}\n\t\t.custom-control-label {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t});\n}\n","//@mixin transition($transition...) {\n//  @if $enable-transitions {\n//    @if length($transition) == 0 {\n//      transition: $transition-base;\n//    } @else {\n//      transition: $transition;\n//    }\n//  }\n//}\n#transition(@transition...) when (@enable-transitions) {\n\t& when (length(@transition) = 0) {\n\t\ttransition: @transition-base;\n\t}\n\t// LESS PORT: In order to output the transitions correctly we have to iterate over the list and\n\t// use Less’s merge feature. Without this, transitions will be output space-separated instead of\n\t// comma-separated. Also, since a single transition can be misinterpreted as multiple transitions\n\t// (since it will have a length > 1) we have to include a check for the length of the first item\n\t// in the list. If the length is greater than 1, then we have a list of separate transitions. If\n\t// the the length is 1, then we’re looking at the first value of a single transition, so we\n\t// output `@transition` as-is.\n\t& when (length(@transition) > 0) and (length(extract(@transition, 1)) = 1) {\n\t\ttransition: @transition;\n\t}\n\t& when (length(@transition) > 0) and (length(extract(@transition, 1)) > 1) {\n\t\t#each-transition(@i: 1) when (@i =< length(@transition)) {\n\t\t\ttransition+: extract(@transition, @i);\n\n\t\t\t#each-transition((@i + 1));\n\t\t} #each-transition();\n\t}\n\n\t@media screen and (prefers-reduced-motion: reduce) {\n\t\ttransition: none;\n\t}\n}\n","// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `@input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n#form-control-focus() {\n\t&:focus {\n\t\tcolor: @input-focus-color;\n\t\tbackground-color: @input-focus-bg;\n\t\tborder-color: @input-focus-border-color;\n\t\toutline: 0;\n\t\t// Avoid using mixin so we can pass custom focus shadow properly\n\t\t& when (@enable-shadows) {\n\t\t\tbox-shadow: @input-box-shadow, @input-focus-box-shadow;\n\t\t}\n\t\t& when not (@enable-shadows) {\n\t\t\tbox-shadow: @input-focus-box-shadow;\n\t\t}\n\t}\n}\n\n\n#form-validation-state(@state, @color) {\n\t.@{state}-feedback {\n\t\tdisplay: none;\n\t\twidth: 100%;\n\t\tmargin-top: @form-feedback-margin-top;\n\t\tfont-size: @form-feedback-font-size;\n\t\tcolor: @color;\n\t}\n\n\t.@{state}-tooltip {\n\t\tposition: absolute;\n\t\ttop: 100%;\n\t\tz-index: 5;\n\t\tdisplay: none;\n\t\tmax-width: 100%; // Contain to parent when possible\n\t\tpadding: 0.5rem;\n\t\tmargin-top: 0.1rem;\n\t\tfont-size: 0.875rem;\n\t\tline-height: 1;\n\t\tcolor: @white;\n\t\tbackground-color: fade(@color, 80%);\n\t\tborder-radius: 0.2rem;\n\t}\n\n\t.form-control,\n\t.custom-select {\n\t\t.was-validated &:@{state},\n\t\t&.is-@{state} {\n\t\t\tborder-color: @color;\n\n\t\t\t&:focus {\n\t\t\t\tborder-color: @color;\n\t\t\t\tbox-shadow: 0 0 0 @input-focus-width fade(@color, 25%);\n\t\t\t}\n\n\t\t\t~ .@{state}-feedback,\n\t\t\t~ .@{state}-tooltip {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\n\t.form-control-file {\n\t\t.was-validated &:@{state},\n\t\t&.is-@{state} {\n\t\t\t~ .@{state}-feedback,\n\t\t\t~ .@{state}-tooltip {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\n\t.form-check-input {\n\t\t.was-validated &:@{state},\n\t\t&.is-@{state} {\n\t\t\t~ .form-check-label {\n\t\t\t\tcolor: @color;\n\t\t\t}\n\n\t\t\t~ .@{state}-feedback,\n\t\t\t~ .@{state}-tooltip {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\n\t.custom-control-input {\n\t\t.was-validated &:@{state},\n\t\t&.is-@{state} {\n\t\t\t~ .custom-control-label {\n\t\t\t\tcolor: @color;\n\n\t\t\t\t&::before {\n\t\t\t\t\tbackground-color: lighten(@color, 25%);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t~ .@{state}-feedback,\n\t\t\t~ .@{state}-tooltip {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\n\t\t\t&:checked {\n\t\t\t\t~ .custom-control-label::before {\n\t\t\t\t\t#gradient-bg(lighten(@color, 10%));\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&:focus {\n\t\t\t\t~ .custom-control-label::before {\n\t\t\t\t\tbox-shadow: 0 0 0 1px @body-bg, 0 0 0 @input-focus-width fade(@color, 25%);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// custom file\n\t.custom-file-input {\n\t\t.was-validated &:@{state},\n\t\t&.is-@{state} {\n\t\t\t~ .custom-file-label {\n\t\t\t\tborder-color: @color;\n\n\t\t\t\t&::before { border-color: inherit; }\n\t\t\t}\n\n\t\t\t~ .@{state}-feedback,\n\t\t\t~ .@{state}-tooltip {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\n\t\t\t&:focus {\n\t\t\t\t~ .custom-file-label {\n\t\t\t\t\tbox-shadow: 0 0 0 @input-focus-width fade(@color, 25%);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n","// Single side border-radius\n\n#border-radius(@radius: @border-radius) when (@enable-rounded) {\n\tborder-radius: @radius;\n}\n\n#border-top-radius(@radius) when (@enable-rounded) {\n\tborder-top-left-radius: @radius;\n\tborder-top-right-radius: @radius;\n}\n\n#border-right-radius(@radius) when (@enable-rounded) {\n\tborder-top-right-radius: @radius;\n\tborder-bottom-right-radius: @radius;\n}\n\n#border-bottom-radius(@radius) when (@enable-rounded) {\n\tborder-bottom-right-radius: @radius;\n\tborder-bottom-left-radius: @radius;\n}\n\n#border-left-radius(@radius) when (@enable-rounded) {\n\tborder-top-left-radius: @radius;\n\tborder-bottom-left-radius: @radius;\n}\n","// Gradients\n\n#gradient-bg(@color) {\n\t& when (@enable-gradients) {\n\t\tbackground: @color linear-gradient(180deg, mix(@body-bg, @color, 15%), @color) repeat-x;\n\t}\n\t& when not (@enable-gradients) {\n\t\tbackground-color: @color;\n\t}\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n#gradient-x(@start-color: @gray-700, @end-color: @gray-800, @start-percent: 0%, @end-percent: 100%) {\n\tbackground-image: linear-gradient(to right, @start-color @start-percent, @end-color @end-percent);\n\tbackground-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n#gradient-y(@start-color: @gray-700, @end-color: @gray-800, @start-percent: 0%, @end-percent: 100%) {\n\tbackground-image: linear-gradient(to bottom, @start-color @start-percent, @end-color @end-percent);\n\tbackground-repeat: repeat-x;\n}\n\n#gradient-directional(@start-color: @gray-700, @end-color: @gray-800, @deg: 45deg) {\n\tbackground-image: linear-gradient(@deg, @start-color, @end-color);\n\tbackground-repeat: repeat-x;\n}\n#gradient-x-three-colors(@start-color: @blue, @mid-color: @purple, @color-stop: 50%, @end-color: @red) {\n\tbackground-image: linear-gradient(to right, @start-color, @mid-color @color-stop, @end-color);\n\tbackground-repeat: no-repeat;\n}\n#gradient-y-three-colors(@start-color: @blue, @mid-color: @purple, @color-stop: 50%, @end-color: @red) {\n\tbackground-image: linear-gradient(@start-color, @mid-color @color-stop, @end-color);\n\tbackground-repeat: no-repeat;\n}\n#gradient-radial(@inner-color: @gray-700, @outer-color: @gray-800) {\n\tbackground-image: radial-gradient(circle, @inner-color, @outer-color);\n\tbackground-repeat: no-repeat;\n}\n#gradient-striped(@color: fade(@white, 15%), @angle: 45deg) {\n\tbackground-image: linear-gradient(@angle, @color 25%, transparent 25%, transparent 50%, @color 50%, @color 75%, transparent 75%, transparent);\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n.container when (@enable-grid-classes) {\n\t#make-container();\n\t#make-container-max-widths();\n}\n\n// Fluid container\n//\n// Utilizes the mixin meant for fixed width containers, but with 100% width for\n// fluid, full width layouts.\n\n.container-fluid when (@enable-grid-classes) {\n\t#make-container();\n}\n\n// Row\n//\n// Rows contain and clear the floats of your columns.\n\n.row when (@enable-grid-classes) {\n\t#make-row();\n}\n\n// Remove the negative margin from default .row, then the horizontal padding\n// from all immediate children columns (to prevent runaway style inheritance).\n.no-gutters when (@enable-grid-classes) {\n\tmargin-right: 0;\n\tmargin-left: 0;\n\n\t> .col,\n\t> [class*=\"col-\"] {\n\t\tpadding-right: 0;\n\t\tpadding-left: 0;\n\t}\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n#output-columns() when (@enable-grid-classes) {\n\t#make-grid-columns();\n} #output-columns();\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n#make-container() {\n\twidth: 100%;\n\tpadding-right: (@grid-gutter-width / 2);\n\tpadding-left: (@grid-gutter-width / 2);\n\tmargin-right: auto;\n\tmargin-left: auto;\n}\n\n\n// For each breakpoint, define the maximum width of the container in a media query\n//@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n//  @each $breakpoint, $container-max-width in $max-widths {\n//    @include media-breakpoint-up($breakpoint, $breakpoints) {\n//      max-width: $container-max-width;\n//    }\n//  }\n//}\n#make-container-max-widths(@max-widths: @container-max-widths, @breakpoints: @grid-breakpoints) {\n\t#each-max-width(@i: 1) when (@i <= length(@max-widths)) {\n\t\t@item: extract(@max-widths, @i);\n\t\t@breakpoint: extract(@item, 1);\n\t\t@container-max-width: extract(@item, 2);\n\n\t\t#media-breakpoint-up(@breakpoint, {\n\t\t\tmax-width: @container-max-width;\n\t\t}, @breakpoints);\n\n\t\t#each-max-width((@i + 1));\n\t} #each-max-width();\n}\n\n#make-row() {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmargin-right: (@grid-gutter-width / -2);\n\tmargin-left: (@grid-gutter-width / -2);\n}\n\n#make-col-ready() {\n\tposition: relative;\n\t// Prevent columns from becoming too narrow when at smaller grid tiers by\n\t// always setting `width: 100%;`. This works because we use `flex` values\n\t// later on to override this initial width.\n\twidth: 100%;\n\tmin-height: 1px; // Prevent collapsing\n\tpadding-right: (@grid-gutter-width / 2);\n\tpadding-left: (@grid-gutter-width / 2);\n}\n\n#make-col(@size, @columns: @grid-columns) {\n\tflex: 0 0 percentage((@size / @columns));\n\t// Add a `max-width` to ensure content within each column does not blow out\n\t// the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n\t// do not appear to require this.\n\tmax-width: percentage((@size / @columns));\n}\n\n#make-col-offset(@size, @columns: @grid-columns) {\n\t@num: (@size / @columns);\n\n\t& when (@num = 0) {\n\t\tmargin-left: 0;\n\t}\n\t& when not (@num = 0) {\n\t\tmargin-left: percentage(@num);\n\t}\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `@grid-columns`.\n\n//@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n//  // Common properties for all breakpoints\n//  %grid-column {\n//    position: relative;\n//    width: 100%;\n//    min-height: 1px; // Prevent columns from collapsing when empty\n//    padding-right: ($gutter / 2);\n//    padding-left: ($gutter / 2);\n//  }\n//\n//  @each $breakpoint in map-keys($breakpoints) {\n//    $infix: breakpoint-infix($breakpoint, $breakpoints);\n//\n//    // Allow columns to stretch full width below their breakpoints\n//    @for $i from 1 through $columns {\n//      .col#{$infix}-#{$i} {\n//        @extend %grid-column;\n//      }\n//    }\n//    .col#{$infix},\n//    .col#{$infix}-auto {\n//      @extend %grid-column;\n//    }\n//\n//    @include media-breakpoint-up($breakpoint, $breakpoints) {\n//      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n//      .col#{$infix} {\n//        flex-basis: 0;\n//        flex-grow: 1;\n//        max-width: 100%;\n//      }\n//      .col#{$infix}-auto {\n//        flex: 0 0 auto;\n//        width: auto;\n//        max-width: none; // Reset earlier grid tiers\n//      }\n//\n//      @for $i from 1 through $columns {\n//        .col#{$infix}-#{$i} {\n//          @include make-col($i, $columns);\n//        }\n//      }\n//\n//      .order#{$infix}-first { order: -1; }\n//\n//      .order#{$infix}-last { order: $columns + 1; }\n//\n//      @for $i from 0 through $columns {\n//        .order#{$infix}-#{$i} { order: $i; }\n//      }\n//\n//      // `$columns - 1` because offsetting by the width of an entire row isn't possible\n//      @for $i from 0 through ($columns - 1) {\n//        @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n//          .offset#{$infix}-#{$i} {\n//            @include make-col-offset($i, $columns);\n//          }\n//        }\n//      }\n//    }\n//  }\n//}\n#make-grid-columns(@columns: @grid-columns, @gutter: @grid-gutter-width, @breakpoints: @grid-breakpoints) {\n\t// Common properties for all breakpoints\n\t// LESS PORT: Unfortunately we have to use an actual selector here in order to be able to\n\t// `:extend()` it later. This means that the selector is output in the compiled CSS, creating a\n\t// small disparity between the Less and Sass versions.\n\t.grid-column {\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\tmin-height: 1px; // Prevent columns from collapsing when empty\n\t\tpadding-right: (@gutter / 2);\n\t\tpadding-left: (@gutter / 2);\n\t};\n\n\t#each-breakpoint-column(@i: 1) when (@i <= length(@breakpoints)) {\n\t\t@breakpoint: extract(extract(@breakpoints, @i), 1);\n\t\t@infix: breakpoint-infix(@breakpoint, @breakpoints);\n\n\t\t// Allow columns to stretch full width below their breakpoints\n\t\t#each-column(@ii: 1) when (@ii <= @columns) {\n\t\t\t.col@{infix}-@{ii} {\n\t\t\t\t&:extend(.grid-column);\n\t\t\t}\n\n\t\t\t#each-column((@ii + 1));\n\t\t} #each-column();\n\t\t.col@{infix},\n\t\t.col@{infix}-auto {\n\t\t\t&:extend(.grid-column);\n\t\t}\n\n\t\t#media-breakpoint-up(@breakpoint, {\n\t\t\t// Provide basic `.col-{bp}` classes for equal-width flexbox columns\n\t\t\t.col@{infix} {\n\t\t\t\tflex-basis: 0;\n\t\t\t\tflex-grow: 1;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t\t.col@{infix}-auto {\n\t\t\t\tflex: 0 0 auto;\n\t\t\t\twidth: auto;\n\t\t\t\tmax-width: none; // Reset earlier grid tiers\n\t\t\t}\n\n\t\t\t#each-column-col(@iii: 1) when (@iii <= @columns) {\n\t\t\t\t.col@{infix}-@{iii} {\n\t\t\t\t\t#make-col(@iii, @columns);\n\t\t\t\t}\n\n\t\t\t\t#each-column-col((@iii + 1));\n\t\t\t} #each-column-col();\n\n\t\t\t.order@{infix}-first { order: -1; }\n\n\t\t\t.order@{infix}-last { order: (@columns + 1); }\n\n\t\t\t#each-column-order(@iii: 0) when (@iii <= @columns) {\n\t\t\t\t.order@{infix}-@{iii} { order: @iii; }\n\n\t\t\t\t#each-column-order((@iii + 1));\n\t\t\t} #each-column-order();\n\n\t\t\t// `@iii < @columns` because offsetting by the width of an entire row isn't possible\n\t\t\t#each-column-offset(@iii: 0) when (@iii < @columns) {\n\t\t\t\t& when not (@iii = 0),\n\t\t\t\t(@iii = 0) and not (@infix = ~\"\") {\n\t\t\t\t\t.offset@{infix}-@{iii} {\n\t\t\t\t\t\t#make-col-offset(@iii, @columns);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t#each-column-offset((@iii + 1));\n\t\t\t} #each-column-offset();\n\t\t});\n\n\t\t#each-breakpoint-column((@i + 1));\n\t} #each-breakpoint-column();\n}\n","// main: ../framework.less\n\n/* Silo Header */\n.silo-header {\n  top: 0px;\n  grid-area: silo-header;\n  height: @silo-height;\n  z-index: 900;\n  background: #000000;\n  left: 0;\n  right: 0;\n  transition: transform @transition-speed @transition-fn;\n  @media print{\n    display: none;\n  }\n  .awaiting {\n    position: fixed;\n    top: 0px;\n    height: 2px;\n    width: 100%;\n    background: #000000;\n    > div.awaitcount {\n      width: 0;\n      height: 2px;\n      background-color: #ffffff;\n    }\n  }\n  .logo-lg{\n    display: flex;\n    font-family: \"Century Gothic\", CenturyGothic, AppleGothic, sans-serif;\n    white-space: nowrap;\n    color: #ffffff;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n    line-height:  60px;\n    max-height: 60px;\n    max-width: 200px;\n    margin-left: 10px;\n    position: absolute;\n    &:before{\n      content: \" \";\n      font-family: \"italici\";\n    }\n    a{\n      color: #ffffff;\n    }\n    img{\n      display: inline-block;\n    }\n    svg{\n      margin: 0 6px 0 2px;\n      height: 32px;\n      vertical-align: middle;\n    }\n  }\n  //Navbar\n  > .navbar {\n    display: none;\n    margin-bottom: 0;\n    margin-right: 20px;\n    border: none;\n    min-height: 60px;\n    border-radius: 0;\n    max-height: 60px;\n    line-height: 60px - 2;\n    float: right;\n    @media (min-width: @screen-sm){\n      display: block;\n    }\n    .layout-top-nav & {\n      margin-left: 0;\n    }\n    .navbar-collapse{\n      display: inline-block !important;\n      vertical-align: middle;\n      ul{\n        margin: 0;\n        padding: 0;\n        li{\n          margin-left: 3px;\n          display: inline-block;\n          list-style: none;\n          a{\n            display: inline-block;\n            color: fade(#ffffff, 57%);\n            padding: 0 15px;\n            text-transform: uppercase;\n            line-height: 34px;\n            border: 1px solid fade(#ffffff, 0%);\n            &:hover{\n              background: none;\n              color: #ffffff;\n              border: 1px solid fade(#ffffff, 100%);\n            }\n          }\n          &.active{\n            a{\n              color: #ffffff;\n              border: 1px solid fade(#ffffff, 57%);\n              &:hover{\n                background: none;\n                border: 1px solid fade(#ffffff, 100%);\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","// main: ../framework.less\n\n.pseudo_btn(@text, @background, @outline, @border: transparent) {\n\n  &.focus,\n  &:focus,\n  &:focus-visible {\n    color: @text;\n    border: 1px solid @border;\n    background: @background;\n    outline: none;\n    box-shadow: 0px 0px 0px 3px @outline;\n  }\n\n  &.active,\n  &:active {\n    color: @text;\n    border: 1px solid @border;\n    background: @background;\n\n    &.focus,\n    &:focus,\n    &:focus-visible {\n      background: @background;\n      outline: none;\n      box-shadow: 0px 0px 0px 3px @outline;\n    }\n  }\n\n  &.hover,\n  &:hover {\n    color: @text;\n    border: 1px solid @border;\n    background: @background;\n\n    &.active,\n    &:active {\n      border-color: @border;\n      background: @background;\n\n      &.focus,\n      &:focus,\n      &:focus-visible {\n        background: @background;\n        outline: none;\n        box-shadow: 0px 0px 0px 3px @outline;\n      }\n    }\n  }\n}\n\na.btn,\nbutton.btn,\n.btn {\n  display: flex;\n  align-items: center;\n  padding: 6px 15px;\n  min-height: 36px;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  user-select: none;\n  border: 1px solid transparent;\n  transition: all @transition-speed @transition-fn;\n  border-radius: 4px;\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  font-weight: 500;\n\n  &-small {\n    padding: 0 8px;\n    min-height: 26px;\n  }\n\n  svg {\n    fill: none;\n    transition: all @transition-speed @transition-fn;\n  }\n\n  &.input-group-addon {\n    min-height: 34px;\n    max-height: none;\n  }\n\n  &-primary {\n    background: @primary_colour;\n    border-color: transparent;\n    color: #ffffff;\n\n    svg {\n      stroke: #ffffff;\n      fill: none;\n    }\n\n    &:not(.disabled) {\n      .pseudo_btn(#ffffff, @primary_colour_120, @primary_colour_25);\n    }\n  }\n\n  &-secondary {\n    background: @secondary_colour;\n    border-color: transparent;\n    color: #ffffff;\n\n    svg {\n      display: block;\n      stroke: #ffffff;\n      fill: none;\n    }\n\n    .pseudo_btn(#ffffff, @secondary_colour_120, @secondary_colour_25);\n  }\n\n  &-round {\n    border-radius: 30px;\n  }\n\n  &-red {\n    background: @secondary_colour_10;\n    color: @secondary_colour;\n\n    svg {\n      stroke: @secondary_colour;\n    }\n\n    .pseudo_btn(@secondary_colour, @secondary_colour_25, @secondary_colour_10);\n  }\n\n  &-green {\n    background: @success_10;\n    color: @success;\n\n    svg {\n      stroke: @success;\n    }\n\n    .pseudo_btn(@success, @success_25, @success_10);\n  }\n\n  &-blue {\n    background: @info_10;\n    color: @info_50;\n\n    svg {\n      stroke: @success;\n    }\n\n    .pseudo_btn(@success, @info_25, @info_10);\n  }\n\n  &-none {\n    background: transparent;\n    color: @grey_500;\n\n    svg {\n      stroke: @primary_colour;\n    }\n\n    .pseudo_btn(@primary_colour_120, transparent, @primary_colour_10);\n\n    &-red {\n      background: transparent;\n      color: @grey_500;\n\n      svg {\n        stroke: @secondary_colour;\n      }\n\n      .pseudo_btn(@primary_colour_120, transparent, @primary_colour_10);\n    }\n  }\n\n  &-subtle {\n    background: transparent;\n    border: 1px solid @grey;\n    color: @primary_colour;\n\n    svg {\n      stroke: @primary_colour;\n    }\n\n    .pseudo_btn(@primary_colour_120, transparent, @primary_colour_10, @grey_200);\n  }\n\n  &-text {\n    background: transparent;\n    color: @primary_colour;\n\n    svg {\n      stroke: @grey_200;\n    }\n\n    .pseudo_btn(@primary_colour, transparent, transparent);\n  }\n\n  &-text-only {\n    padding: 0;\n    background: transparent;\n    color: @primary_colour;\n\n    svg {\n      stroke: @grey_200;\n    }\n\n    .pseudo_btn(@primary_colour, transparent, transparent);\n  }\n\n  &-grey {\n    background: @grey;\n    color: @primary_colour;\n\n    svg {\n      stroke: @primary_colour;\n    }\n\n    &.input-group-addon {\n      min-height: 34px;\n      max-height: none;\n      background: @grey;\n      color: @primary_colour;\n\n      svg {\n        stroke: @primary_colour;\n      }\n    }\n\n    .pseudo_btn(@primary_colour, @grey_200, @primary_colour_25);\n  }\n\n  &-grey-50 {\n    background: @grey_50;\n    color: @primary_colour;\n\n    svg {\n      stroke: @primary_colour;\n    }\n\n    &.input-group-addon {\n      min-height: 34px;\n      max-height: none;\n      background: @grey_50;\n      color: @primary_colour;\n\n      svg {\n        stroke: @primary_colour;\n      }\n    }\n\n    .pseudo_btn(@primary_colour, @grey, @primary_colour_25);\n  }\n\n  &-white {\n    background: @white;\n    color: @primary_colour;\n\n    svg {\n      stroke: @grey_200;\n    }\n\n    &.input-group-addon {\n      min-height: 34px;\n      max-height: none;\n      background: @grey;\n      color: @primary_colour;\n\n      svg {\n        stroke: @grey_200;\n      }\n    }\n\n    .pseudo_btn(@primary_colour, @grey_200, @primary_colour_25);\n\n    &:hover,\n    &.active,\n    &:active {\n      svg {\n        stroke: @primary_colour;\n      }\n    }\n  }\n\n  &.disabled,\n  &[disabled] {\n    background: @grey;\n    border: 1px solid transparent;\n    cursor: not-allowed;\n    color: @grey_200;\n\n    svg {\n      display: block;\n      stroke: @grey_200;\n    }\n\n    .pseudo_btn(@grey_200, @grey, transparent);\n  }\n\n  &-icon-16 {\n    .icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 16px;\n\n      svg {\n        width: 16px;\n        height: 16px;\n        stroke-width: @svg-16-stroke-width;\n      }\n    }\n  }\n\n  &-icon-24 {\n    .icon {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: 24px;\n\n      svg {\n        width: 24px;\n        height: 24px;\n        stroke-width: @svg-24-stroke-width;\n      }\n    }\n  }\n\n  &-icon-right {\n    padding-right: 10px;\n\n    .icon {\n      svg {\n        fill: none;\n      }\n\n      order: 1;\n      margin-left: 5px;\n    }\n  }\n\n  &-icon-left {\n    padding-left: 10px;\n\n    .icon {\n      svg {\n        fill: none;\n      }\n\n      order: 0;\n      margin-right: 5px;\n    }\n  }\n\n  &-icon-right&-icon-left {\n    .icon {\n      margin: 0;\n    }\n  }\n\n  &-icon-only {\n    padding: 0;\n\n    &.btn-icon-24 {\n      min-height: 26px;\n      max-height: 26px;\n      max-width: 26px;\n\n      .icon {\n        max-height: 24px;\n        max-width: 24px;\n      }\n    }\n\n    &.btn-icon-16 {\n      .icon {\n        max-height: 16px;\n        max-width: 16px;\n      }\n\n      min-height: 18px;\n      max-height: 18px;\n      max-width: 18px;\n    }\n\n    &.input-group-addon {\n      min-height: 34px;\n      max-height: none;\n    }\n  }\n\n  &-icon-success {\n    .icon {\n      svg {\n        fill: none;\n        stroke: @success;\n      }\n    }\n  }\n\n  &-glyph {\n    .icon {\n      svg {\n        stroke: none;\n      }\n    }\n  }\n\n  &.highlight {\n    --color4: @info;\n  }\n\n  &.has-submenu {\n    padding: 0;\n  }\n\n  &-red-text {\n    color: @secondary_colour;\n    padding-left: 1px;\n  }\n}","// main: ../framework.less\n\n.track-vertical {\n  width: 6px;\n  top: 2px;\n  right: 2px;\n  bottom: 2px;\n}\n.track-horizontal {\n  height: 6px;\n  right: 8px;\n  left: 2px;\n  bottom: 2px;\n}\n.thumb-vertical {\n  background: @grey_400;\n  border-radius: 3px;\n}\n.thumb-horizontal {\n  background: @grey_400;\n  border-radius: 3px;\n}","// main: ../framework.less\n\n.user-photo {\n  position: relative;\n}\n\n.avatar {\n  &-sm{\n    flex: 0 0 auto;\n    > .thumbimg {\n      .circle(@avatar-sm);\n    }\n  }\n  &-md{\n    flex: 0 0 auto;\n    > .thumbimg {\n      .circle(@avatar-md);\n    }\n  }\n  &-lg{\n    flex: 0 0 auto;\n    > .thumbimg {\n      .circle(@avatar-lg);\n    }\n  }\n  > .thumbimg {\n    overflow: hidden;\n    img {\n      aspect-ratio: 1 / 1;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n  > .initials {\n    stroke: none;\n    svg {\n      stroke: none;\n      circle {\n        fill: @secondary_colour_5;\n      }\n      text {\n        stroke: none;\n        fill: @secondary_colour;\n      }\n    }\n  }\n  svg {\n    width: 100%;\n    height: 100%;\n    stroke: @grey_200;\n  }\n}","// out: ../../css/ui/framework.css, sourceMap: true, relativePaths: true\n\n@import \"./bootstrap/less/_functions\";\n@import \"./bootstrap/less/_variables\";\n@import \"./bootstrap/less/_mixins\";\n\n@import \"./bootstrap/less/_reboot\";\n@import \"./bootstrap/less/_utilities\";\n@import \"./bootstrap/less/_forms\";\n// @import \"./bootstrap/less/_buttons\"≈;\n@import \"./bootstrap/less/_grid\";\n\n@import \"./variables\";\n@import \"./common/global\";\n@import \"./common/silo-header\";\n@import \"./common/buttons\";\n@import \"./common/scrollbars\";\n@import \"./common/avatar\";\n\niframe {\n  border: 0 none;\n}\n\n\n.wrapper {\n  max-width: 100vw;\n  position: relative;\n  display: grid;\n  grid-gap: 0;\n  grid-template-rows: auto 1fr;\n  height: 100vh;\n  grid-template-areas:\n    \"header\"\n    \"content\";\n  @media (min-width: @screen-md){\n    grid-template-areas:\n      \"header header\"\n      \"nav content\";\n  }\n  &.login{\n    grid-template-columns: 1fr;\n    grid-template-rows: auto;\n    grid-template-areas:\n      \"content\";\n    .content:not(.form-group) {\n      width: 100%;\n      height: 100vh;\n      background: none;\n    }\n  }\n  &.modaled {\n    opacity: 0.5;\n  }\n}\n\n.dot(@ypos) {\n  display: inline-block;\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  @dots: contrast(@brand-logo-bg, #ffffff, #000000, 55%);\n  background-color: @dots;\n  transform: translate(0, @ypos);\n}\n\n.main .showmenu{\n  .context-sidebar{\n    border-left: 1px solid #efefef;\n    width: @sidebar-width;\n    z-index: 900;\n  }\n  .menubtn {\n    background-color: #fff;\n  }\n  .menubtn > div, .menubtn > div:before, .menubtn > div:after {\n    background-color: @brand-primary;\n  }\n}\n\n/* Loader */\n.loader {\n  margin: 0 auto;\n  position: relative;\n  z-index: 9999;\n  svg {\n    width: 40px;\n    height: 40px;\n    image {\n      width: 100%;\n      height: 100%;\n    }\n  }\n  &.inline {\n    z-index: auto;\n    display: inline-flex;\n    justify-content: center;\n    align-content: center;\n    svg {\n      width: 14px;\n      height: 14px;\n    }\n    &.large svg {\n      width: 40px;\n      height: 40px;\n      margin: 20px;\n    }\n  }\n}\n\n/* Errors */\n\n.viewerror {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  min-height: calc(~\"100vh - 68px\");\n  &.view.container-fluid {\n    grid-area: view;\n    height: 100vh;\n  }\n  svg {\n    height: 100px;\n    fill: @grey_200;\n  }\n  .err {\n    max-width: 280px;\n  }\n}\n\n@-webkit-keyframes load8 {\n  0% {\n    -webkit-transform: rotateZ(0deg);\n    transform: rotateZ(0deg);\n  }\n  100% {\n    -webkit-transform: rotateZ(360deg);\n    transform: rotateZ(360deg);\n  }\n}\n\n@keyframes load8 {\n  0% {\n    -webkit-transform: rotateZ(0deg);\n    transform: rotateZ(0deg);\n  }\n  100% {\n    -webkit-transform: rotateZ(360deg);\n    transform: rotateZ(360deg);\n  }\n}\n.isloading {\n  display: flex;\n  position: fixed;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n}\n.login .isloading {\n  top: 0 !important;\n  left: 0 !important;\n}\n.isloading.inline {\n  display: inline-block;\n  width: auto;\n  position: relative;\n  top: 10px;\n  left: 10px;\n  height: 30px;\n}\n.isloading.block {\n  margin: 0 auto;\n  width: auto;\n  height: 100%;\n  width: 100%;\n  z-index: 950;\n  background: rgba(255, 255, 255, 0.5);\n  @media (min-width: @screen-header-collapse) {\n    top: 68px;\n    left: 64px;\n    .loader {\n      margin-top: -68px;\n      margin-left: calc(50% - 54px);\n      // transform: translateZ(0);\n    }\n  }\n}\n.isloading.solid {\n  background: rgba(255, 255, 255, 1);\n}\n\nbutton.disabled, .btn.disabled, .navitem.disabled {\n  cursor: not-allowed;\n}\n\n\n// .btn-primary.btn-primary {\n//   background-color: @brand-primary;\n//   border-color: @brand-primary;\n//   color: contrast(@brand-primary, #212121, #ffffff, 55%);\n//   outline: 0 none !important;\n//   line-height: 1.5;\n//   display: flex !important;\n//   align-items: center;\n//   justify-content: center;\n//   &:hover{\n//     background-color: lighten(@brand-primary, 5%);\n//     border-color: @brand-primary;\n//     color: contrast(@brand-primary, #212121, #ffffff, 55%);\n//   }\n//   &:not(:disabled):not(.disabled):active,\n//   &:not(:disabled):not(.disabled).active,\n//   .show > &.dropdown-toggle {\n//     background-color: @brand-primary;\n//     border-color: @brand-primary;\n//     color: contrast(@brand-primary, #212121, #ffffff, 55%);\n//   }\n//   &:focus{\n//     box-shadow: none !important;\n//   }\n//   &.disabled, &:disabled {\n//     background-color: #d6d6d6 !important;\n//     border-color: #d6d6d6 !important;\n//   }\n//   svg {\n//     fill: contrast(@brand-primary, #212121, #ffffff, 55%);\n//     display: inline-block;\n//     margin-right: 0.3em !important;\n//     vertical-align: middle;\n//     line-height: 1em;\n//     height: 13px;\n//   }\n// }\n\n.flex-container {\n  display: flex;\n  flex-wrap: wrap;\n  .card .cardbody &.ccontent {\n    padding: 0;\n    display: flex;\n    flex-wrap: wrap;\n    flex: 1 1 100%;\n  }\n  &.gap-20 {\n    gap: 20px 20px;\n  }\n  &.gap-40 {\n    gap: 40px;\n  }\n}\n\n\n.text-left {\n  .checkcontainer {\n    align-items: flex-start;\n  }\n}\n.text-right {\n  .checkcontainer {\n    align-items: flex-end;\n  }\n}\n.text-center {\n  .checkcontainer {\n    align-items: middle;\n  }\n}\n\n@import \"./common/grid\";\n@import \"./common/header\";\n@import \"./common/dash\";\n@import \"./common/nav\";\n@import \"./common/sidebar\";\n@import \"./common/footer\";\n@import \"./common/modal\";\n@import \"./common/contextmenu\";\n@import \"./common/content\";\n@import \"./common/calendar\";\n@import \"./common/widesidebar\";\n@import \"./common/modellist\";\n@import \"./common/modeldetails\";\n@import \"./common/notifications\";\n@import \"./common/card\";\n@import \"./common/banners\";\n@import \"./common/tabs\";\n@import \"./common/actions\";\n@import \"./common/forms\";\n@import \"./common/users\";\n@import \"./common/branch\";\n@import \"./common/login\";\n@import \"./common/timeline\";\n@import \"./common/pdf\";\n@import \"./common/editor\";\n@import \"./common/notes\";\n@import \"./common/leads\";\n@import \"./common/tooltips\";\n@import \"./common/tree\";\n@import \"./common/freshchat\";\n\n","// main: ../framework.less\n\n.grid-container {\n  display: grid;\n  @media screen and (min-width: @screen-header-collapse) {\n    grid-template-columns: repeat(4, 1fr [col-start]);\n  }\n  .card .cardbody &.ccontent {\n    padding: 0;\n  }\n  .card .cardbody {\n    margin-bottom: auto;\n  }\n  gap: 16px 16px;\n  &.grid-3 {\n    @media screen and (min-width: @screen-header-collapse) {\n      grid-template-columns: repeat(3, 1fr [col-start]);\n    }\n  }\n  &.grid-2 {\n    @media screen and (min-width: @screen-header-collapse) {\n      grid-template-columns: repeat(2, 1fr [col-start]);\n    }\n  }\n  &.grid-1 {\n    @media screen and (min-width: @screen-header-collapse) {\n      grid-template-columns: repeat(1, 1fr [col-start]);\n    }\n  }\n  .grid-row-2 {\n    grid-row: span 2;\n  }\n  .grid-row-3 {\n    grid-row: span 3;\n  }\n  .card {\n    margin: 0;\n  }\n  .no-grow {\n    margin-bottom: auto;\n  }\n  .grid-col-5 {\n    grid-column: span 5;\n  }\n  .grid-col-4 {\n    grid-column: span 4;\n  }\n  .grid-col-3 {\n    grid-column: span 4;\n    .grid-5 & {\n      grid-column: span 5;\n    }\n    align-content: flex-start;\n    @media screen and (min-width: @screen-header-collapse) {\n      grid-column: span 3;\n    }\n  }\n  .grid-col-2 {\n    grid-column: span 4;\n    .grid-5 & {\n      grid-column: span 5;\n    }\n    align-content: flex-start;\n    @media screen and (min-width: @screen-header-collapse) {\n      grid-column: span 2;\n    }\n  }\n  .grid-col-1 {\n    grid-column: span 4;\n    .grid-5 & {\n      grid-column: span 5;\n    }\n    align-content: flex-start;\n    @media screen and (min-width: @screen-header-collapse) {\n      grid-column: span 1;\n    }\n  }\n  &.grid-5 {\n    @media screen and (min-width: @screen-header-collapse) {\n      grid-template-columns: repeat(5, 1fr [col-start]);\n    }\n    .grid-col-3 {\n      grid-column: span 5;\n      align-content: flex-start;\n      @media screen and (min-width: @screen-header-collapse) {\n        grid-column: span 3;\n      }\n    }\n    .grid-col-2 {\n      grid-column: span 5;\n      align-content: flex-start;\n      @media screen and (min-width: @screen-header-collapse) {\n        grid-column: span 2;\n      }\n    }\n    .grid-col-1 {\n      grid-column: span 5;\n      align-content: flex-start;\n      @media screen and (min-width: @screen-header-collapse) {\n        grid-column: span 1;\n      }\n    }\n  }\n  .grid-listing-details {\n    order: -1;\n    @media screen and (min-width: @screen-header-collapse) {\n      order: unset;\n    }\n  }\n  > [class^=\"grid-col-\"], > [class*=\"grid-col-\"] {\n    display: grid;\n    min-width: 0;\n    @media screen and (max-width: @screen-header-collapse) {\n      grid-column: span 5;\n    }\n    > * {\n      min-width: 0;\n    }\n  }\n}\n\n.monaco-editor {\n  min-height: 100px;\n  resize: vertical;\n  overflow: auto;\n  .monaco-editor-tabs {\n    margin-top: -6px;\n    margin-left: -15px;\n    display: flex;\n    height: 35px;\n    .monaco-editor-tab {\n      background: rgba(227, 228, 226, 0.16);\n      color: #fff;\n      &.active {\n        background: rgba(227, 228, 226, 0.16);\n        color: var(--vscode-textPreformat-foreground);\n      }\n      border-right: 1px solid rgb(30, 31, 28);\n      background-color: rgb(52, 53, 47);\n      padding-left: 12px;\n      width: 120px;\n      min-width: fit-content;\n      min-width: -moz-fit-content;\n      flex-shrink: 0;\n      font-family: Menlo, Monaco, \"Courier New\", monospace;\n      font-weight: normal;\n      font-size: 12px;\n      font-feature-settings: \"liga\" 0, \"calt\" 0;\n      line-height: 18px;\n      letter-spacing: 0px;\n      line-height: 35px;\n    }\n  }\n}\n\n.version-list {\n  display: grid;\n  gap: 20px;\n  padding: 0;\n  margin: 0 0 0 -20px;\n  grid-template-areas: \"jump-menu\" \"details\";\n  @media screen and (min-width: @screen-header-collapse) {\n    grid-template-areas: \"jump-menu details\";\n    grid-template-columns: 370px auto;\n    grid-template-rows: auto;\n  }\n  .stepper {\n    grid-area: details;\n  }\n  .versions {\n    grid-area: details;\n    .tablemeta {\n      padding-top: 0;\n      flex: 0 0 100%;\n    }\n    .version-buttons {\n      display: flex;\n      gap: 15px 6px;\n    }\n  }\n}\n\n.reviewComment {\n  margin: 8px;\n  margin-top: 0;\n  padding: 8px;\n  border-top: 1px solid var(--vscode-textSeparator-foreground);\n  border-bottom: 1px solid var(--vscode-textSeparator-foreground);\n  > div {\n    border-radius: 6px !important;\n    border: 1px solid var(--vscode-textSeparator-foreground);\n    .reviewComment-meta {\n      border-radius: 6px !important;\n      padding-right: 8px !important;\n      padding-left: 8px !important;\n      padding-top: 4px !important;\n      padding-bottom: 4px !important;\n    }\n    .reviewComment-text {\n      padding-right: 8px !important;\n      padding-left: 8px !important;\n      padding-top: 4px !important;\n      padding-bottom: 4px !important;\n    }\n  }\n}","// main: ../framework.less\n\n\n.headerwrap {\n  grid-area: header;\n  position: sticky;\n  top: 0px;\n  z-index: 950;\n  @media (max-width: @screen-header-collapse) {\n    &.down {\n      top: -60px;\n    }\n  }\n}\n\n\n/* Main Header */\n.main-header {\n  left: 0;\n  right: 0;\n  top: @navbar-height;\n  background: @primary_colour;\n  color: #ffffff;\n  display: flex;\n  flex-wrap: wrap;\n  font-weight: 400;\n  svg {\n    vertical-align: middle;\n    transition: all 0.3s ease 0s;\n  }\n  @media print{\n    display: none;\n  }\n  @media (min-width: @screen-header-collapse) {\n    background: @white;\n    color: @primary_colour;\n    flex-wrap: nowrap;\n  }\n  //Navbar toggle button\n  .navbtn {\n    left: 0;\n    top: 0;\n    max-width: 64px;\n    flex: 0 0 64px;\n    height: @navbar-height;\n    background-color: inherit;\n    background-image: none;\n    line-height: 1;\n    display: inline-block;\n    text-align: center;\n    cursor: pointer;\n    background: @primary_colour;\n    position: relative;\n    color: #ffffff;\n    z-index: 1;\n    &:before {\n      content:\"\";\n      width: 64px;\n      position: absolute;\n      height: @navbar-height;\n      top: 0;\n      left: 0;\n      background: @primary_colour;\n      z-index: -1;\n    }\n    > div {\n      display: inline-block;\n      line-height: @navbar-height;\n      height: 100%;\n      svg {\n        width: 24px;\n        height: 24px;\n        fill: none;\n        stroke: @white;\n        stroke-width: @svg-24-stroke-width;\n        position: absolute;\n        top: 50%;\n        margin-top: -12px;\n        left: 50%;\n        margin-left: -12px;\n        transition: all @transition-speed @transition-fn;\n        &.close {\n          opacity: 0;\n          transform: scale(0)\n        }\n        &.open {\n          opacity: 1;\n          transform: scale(1)\n        }\n      }\n    }\n    + div:nth-child(2) {\n      margin-left: auto\n    }\n    .icon-bar{\n      width: 22px;\n      height: 3px;\n      display: block;\n      border-radius: 6px;\n      background: contrast(@brand-logo-bg, #ffffff, #000000, 55%);\n      margin-bottom: 4px;\n      &:last-of-type{\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  .breadcrumbs {\n    order: 4;\n    background: @white;\n    color: @grey_400;\n    flex: 0 0 100%;\n    padding: 11.5px 20px;\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    justify-content: flex-start;\n    @media (min-width: @screen-header-collapse) {\n      order: 0;\n      flex: 1 1 auto;\n    }\n    .crumb {\n      text-transform: capitalize;\n      color: @grey_400;\n      span.title {\n        text-transform: none;\n      }\n      a.lower {\n        text-transform: lowercase;\n      }\n      span:last-of-type {\n        color: @primary_colour;\n        font-weight: 600;\n      }\n      span, a {\n        color: @grey_400;\n        &:before {\n          display: inline-block;\n          width: 20px;\n          height: 16px;\n          vertical-align: top;\n          content: url(\"data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBzdHlsZT0iaXNvbGF0aW9uOmlzb2xhdGUiIHZpZXdCb3g9IjAgMCAxNiAxNiIgd2lkdGg9IjE2cHQiIGhlaWdodD0iMTZwdCI+PHBhdGggZD0iIE0gNS41NzYgMy41NzYgQyA1LjgxIDMuMzQxIDYuMTkgMy4zNDEgNi40MjQgMy41NzYgTCAxMC40MjQgNy41NzYgQyAxMC42NTkgNy44MSAxMC42NTkgOC4xOSAxMC40MjQgOC40MjQgTCA2LjQyNCAxMi40MjQgQyA2LjE5IDEyLjY1OSA1LjgxIDEyLjY1OSA1LjU3NiAxMi40MjQgQyA1LjM0MSAxMi4xOSA1LjM0MSAxMS44MSA1LjU3NiAxMS41NzYgTCA5LjE1MSA4IEwgNS41NzYgNC40MjQgQyA1LjM0MSA0LjE5IDUuMzQxIDMuODEgNS41NzYgMy41NzYgWiAiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZmlsbD0icmdiKDIwNiwyMTUsMjI2KSIvPjwvc3ZnPg==\");\n        }\n      }\n\n    }\n  }\n\n  ~ .wrapper{\n    margin-top: @navbar-height;\n  }\n\n\n  /* User */\n  .userhead {\n    display: flex;\n    cursor: pointer;\n    margin-right: 10px;\n    order: 2;\n    .user-toggle {\n      display: flex;\n      flex-wrap: nowrap;\n      align-items: center;\n      justify-content: flex-start;\n      .user-details {\n        margin-right: 10px;\n        display: flex;\n        justify-content: flex-end;\n        flex-direction: column;\n        text-align: right;\n      }\n      .user-name {\n        flex: 0 0 auto;\n        font-weight: 400;\n        font-size: 16px;\n        line-height: 24px;\n      }\n      .site-name {\n        flex: 0 0 auto;\n        font-weight: 600;\n        font-size: 12px;\n        line-height: 18px;\n      }\n    }\n  }\n\n  /* User */\n  .globaladd {\n    display: flex;\n    cursor: pointer;\n    margin-right: 10px;\n    align-items: center;\n    order: 3;\n    .thumbimg {\n      background: @secondary_colour;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n    svg {\n      width: 24px;\n      stroke: #ffffff;\n      stroke-width: 2.4;\n    }\n  }\n\n  /* Menu */\n  .menubtn {\n    margin-left: auto;\n    width: 50px;\n    height: @navbar-height;\n    line-height: @navbar-height;\n    cursor: pointer;\n    text-align: center;\n    position: relative;\n    transition: all 0.2s ease 0s;\n    > div {\n      .dot(0);\n      display: inline-block;\n      vertical-align: middle;\n      line-height: 0;\n      &:before{\n        content:\"\";\n        .dot(-9px);\n      }\n      &:after{\n        content:\"\";\n        .dot(4px);\n      }\n    }\n  }\n}\n\n/* Notifications */\n.alertshead, .chatshead {\n  cursor: pointer;\n  max-width: 50px;\n  display: none;\n  flex: 0 0 50px;\n  height: @navbar-height;\n  line-height:  @navbar-height;\n  margin-left: auto;\n  order: 1;\n  justify-content: center;\n  align-items: center;\n  @media screen and (min-width: @screen-header-collapse) {\n    display: flex;\n  }\n  .btn {\n    padding: 0;\n    position: relative;\n    .icon {\n      svg {\n        fill: none;\n        stroke: @primary_colour;\n      }\n    }\n  }\n  .badge {\n    position: absolute;\n    font-size: 10px;\n    min-width: 14px;\n    display: block;\n    line-height: 1;\n    bottom: 50%;\n    left: 50%;\n    text-align: center;\n    border-radius: 50%;\n  }\n  + .userhead {\n    margin-left: 20px;\n  }\n}\n.user-menu {\n  background: #FFFFFF;\n  border: 1px solid #CFCDCD;\n  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);\n  z-index: 100;\n  flex-direction: column;\n  padding: 0 0 20px 0;\n  @media screen and (min-width: @screen-header-collapse) {\n    padding-top: 20px;\n  }\n  overflow: auto;\n  .selectinput.default_home_page {\n    margin: 0 20px;\n  }\n  .action {\n    display: flex;\n    position: relative;\n    cursor: pointer;\n    padding: 0.75rem 20px;\n    flex-wrap: nowrap;\n    align-content: center;\n    align-items: center;\n    svg {\n      fill: none;\n      stroke: @primary_colour;\n      stroke-width: @svg-24-stroke-width;\n    }\n    .icon {\n      margin-right: 10px;\n    }\n    &:hover {\n      background: @grey_50;\n    }\n    &.menu-close {\n      width: 36px;\n      height: 36px;\n      max-width: 36px;\n      padding: 0;\n      justify-content: center;\n      align-items: center;\n      background: @grey;\n      border-radius: 18px;\n      margin-left: auto;\n      svg {\n        fill: none;\n        stroke: @primary_colour;\n        stroke-width: @svg-24-stroke-width;\n      }\n    }\n    &.alerts-head {\n      svg {\n        fill: none;\n        stroke: @primary_colour;\n        stroke-width: @svg-24-stroke-width;\n      }\n    }\n  }\n  .menu-icons {\n    display: flex;\n    padding: 20px;\n    gap: 0 10px;\n    .btn {\n      flex: 0 0 auto;\n      width: 45px;\n      height: 45px;\n      max-width: 45px;\n      padding: 0;\n      &:hover {\n        background: none;\n      }\n      .icon {\n        margin-right: 0;\n      }\n    }\n    @media screen and (min-width: @screen-header-collapse) {\n      display: none;\n    }\n  }\n  .label {\n    display: flex;\n    flex: 0 0 auto;\n    display: inline-block;\n    white-space: nowrap;\n  }\n  .navicon {\n    flex: 0 0 auto;\n    margin-right: 5px;\n  }\n  &-cover {\n    margin: 20px;\n    @media screen and (min-width: @screen-header-collapse) {\n      position: absolute;\n      left: auto;\n      min-width: 280px;\n      right: 0;\n    }\n  }\n  &-cover-wrapper{\n    position: fixed;\n    top: @navbar-height;\n    left: 0;\n    right: 0;\n  }\n  &-cover-backdrop {\n    position: fixed;\n    top: @navbar-height;\n    left: 0;\n    height: calc(100vh - @navbar-height);\n    right: 0;\n    z-index: -1;\n    background: @grey_50;\n    @media screen and (min-width: @screen-header-collapse) {\n      background: none;\n    }\n  }\n}\n\n/* Notifications */\n.alerts-head {\n  .badge {\n    position: absolute;\n    font-size: 10px;\n    min-width: 14px;\n    display: block;\n    line-height: 1;\n    bottom: 50%;\n    left: 50%;\n    text-align: center;\n    border-radius: 50%;\n  }\n}\n.badge {\n  font-size: 10px;\n  padding: 5px 8px;\n  position: absolute;\n  background: @secondary_colour;\n  color: @white;\n}\n\n.ws-status {\n  width: 10px;\n  height: 10px;\n  .circle(10px);\n  background: @grey_50;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  &.connected {\n    background: @success;\n  }\n  &.disconnected {\n    background: @error;\n  }\n}\n\n.menu-group {\n  margin: 10px 0;\n  > .label {\n    padding: 0 20px;\n    text-transform: uppercase;\n    color: @grey_400;\n  }\n  @media screen and (min-width: @screen-header-collapse) {\n    &:first-of-type {\n      margin: 0 0;\n    }\n  }\n}","// main: ../framework.less\n\n.pddash {\n  height: calc(~\"100vh - \"@silo-height);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  svg {\n    height: 200px;\n    fill: #efefef;\n  }\n  h4 {\n    font-size: 1.4rem;\n    color: #ccc;\n  }\n}\n.dashcontent {\n  .dashmessagecontainer {\n    .msgactions {\n      text-align: right;\n    }\n    .dashmessage {\n      display: flex;\n      margin: 15px 0;\n      align-items: top;\n      max-height: 200px;\n      .msgall {\n        overflow-y: scroll;\n        max-height: 200px;\n        .msghead {\n          display: flex;\n          justify-content: space-between;\n          margin-bottom: 10px;\n          .msgauthor {\n            font-weight: 600;\n            color: #333;\n          }\n        }\n        .msg {\n          padding: 15px;\n          border: 1px solid #efefef;\n          border-radius: @border-radius;\n        }\n      }\n      .msgreply {\n        margin-top: 10px;\n        > div {\n          text-align: right;\n        }\n      }\n      .msgcomments {\n        display: flex;\n        flex-direction: row-reverse;\n        .msgcomment {\n          display: inline-block;\n          background-color: #efefef;\n          border: 1px solid #ccc;\n          border-radius: 3px;\n          padding: 10px 5px;\n          margin: 15px 0;\n          align-items: top;\n          max-height: 200px;\n          text-align: right;\n          .commentagent {\n            display: block;\n            font-weight: 600;\n            color: #333;\n            margin: 0 0 5px;\n          }\n          .comment {\n            overflow-y: scroll;\n            max-height: 200px;\n          }\n        }\n      }\n    }\n  }\n  .listingquality > div {\n    margin-bottom: 10px;\n    padding: 10px;\n  }\n  .listingtype {\n    font-size: 1.1rem;\n    font-weight: 600;\n    text-align: right;\n    margin: 20px 0;\n    .radiocontainer {\n      display: inline-block;\n      min-width: 120px;\n      text-align: left;\n    }\n  }\n  .dashstats {\n    text-align: center;\n    margin-top: 10px;\n    margin-bottom: 10px;\n\n    .bigstat {\n      border-radius: 4px;\n      display: inline-block;\n      padding: 15px 0;\n      font-size: 24px;\n      background-color: @brand-primary;\n      color: #fff;\n      margin: 0 0 20px 0;\n      min-width: 100%;\n      span {\n        font-size: 1rem;\n        display: block;\n      }\n      h1 {\n        color: #fff;\n      }\n      &.nobg {\n        background-color: transparent;\n        color: @content-text;\n      }\n    }\n  }\n  .nodata {\n    text-align: center;\n    svg {\n      height: 120px;\n      fill: @gray-lighter;\n    }\n    h5 {\n      color: #aaa;\n      font-weight: 600;\n    }\n  }\n  .simpletablecontainer, .timeonmarket, .listingquality {\n    display: flex;\n    flex-direction: column;\n    .selectinput {\n      max-width: 200px;\n      min-width: 200px;\n      align-self: flex-end;\n    }\n  }\n  table.simpletable {\n    width: 100%;\n    tr {\n      border-bottom: 1px solid #efefef;\n    }\n    td, th {\n      padding: 5px 2px;\n      text-align: right;\n    }\n    th:first-of-type, td:first-of-type {\n      text-align: left;\n    }\n  }\n  .leads-analysis .pie {\n    text-align: center;\n  }\n}\n\n.tourmask {\n  height: 100%;\n  width: 100%;\n}\n.tour {\n  background-color: #ffffff;\n  svg {\n    height: 10px;\n  }\n  .touritem {\n    h3 {\n      font-weight: 500;\n    }\n    h3 span {\n      font-weight: 600;\n    }\n  }\n}\n\n.percentage-change {\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n  font-size: 14px;\n  &.success {\n    --color4: @success;\n    color: @success;\n  }\n  &.failed {\n    --color4: @error;\n    color: @error;\n  }\n  svg {\n    width: 16px;\n  }\n}\n\n.flex-quality {\n  gap: 20px;\n}\n\n.quality-block {\n  background: @grey_50;\n  padding: 20px;\n  border-radius: @input-border-radius;\n  display: flex;\n  flex: 1 1 calc(25% - 20px);\n  .flex-3 & {\n    flex: 1 1 calc(33% - 20px);\n  }\n  min-width: 280px;\n  gap: 0 20px;\n  .quality-graph {\n    flex: 0 0 100px;\n    height: 100px;\n  }\n  .quality-content {\n    display: flex;\n    flex-direction: column;\n    h3 {\n      margin: 0;\n    }\n    strong {\n      color: @grey_400;\n      font-weight: 600;\n    }\n    h2 {\n      font-size: 30px;\n      font-weight: 400;\n    }\n    .btn {\n      margin-right: auto;\n    }\n  }\n}\n.quality-graph-icon {\n  // transform: translate(50%, 50%);\n  .quality-graph-transformer{\n    // transform: translate(-50%, -50%);\n  }\n}\n\n.customized-legend {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  @media screen and (min-width: @screen-header-collapse) {\n    width: 240px;\n  }\n  height: 100%;\n  padding-bottom: 20px;\n  .legend-total {\n    flex: 1 1 100%;\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: auto;\n    .legend-count {\n      font-size: 36px;\n      flex: 1 1 100%;\n      padding: 0;\n    }\n  }\n  .legend-item {\n    flex: 1 1 50%;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 0 10px;\n    height: 44px;\n  }\n  .legend-label {\n    text-transform: uppercase;\n    font-size: 11px;\n    color: @grey_500;\n  }\n  .legend-count {\n    flex: 1 1 100%;\n    padding-left: 20px;\n    font-size: 18px;\n    color: @primary_colour;\n  }\n}\n\n.customized-legend-vertical {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  min-width: 240px;\n  height: 100%;\n  padding-top:20px;\n  @media screen and (min-width: @screen-header-collapse) {\n    padding-top: 0;\n  }\n  padding-left: 20px;\n  align-items: center;\n  justify-content: center;\n  .legend-item {\n    display: flex;\n    flex-wrap: wrap;\n    min-width: 100%;\n    align-items: center;\n    height: 36px;\n    box-shadow: 0px 1px 0px #E5EBF1;\n  }\n  .legend-label {\n    font-size: 14px;\n    padding-left: 10px;\n    color: @grey_500;\n  }\n  .legend-count {\n    margin-left: auto;\n    font-size: 16px;\n    color: @primary_colour;\n  }\n}\n\n.expiring-listings-widget {\n  .datatablewrap-inner {\n    max-height: 515px;\n  }\n}\n\n.latest-leads-widget {\n  tbody .tablecell {\n    min-height: 40px;\n  }\n  .datatablewrap-inner {\n    max-height: 515px;\n  }\n}\n\n#listing-value-widget {\n  min-height: 330px;\n}\n\n.syndication-widget {\n  .scrollview {\n    max-height: 244px;\n  }\n  .flex-2 {\n    gap: 20px 20px;\n    flex-wrap: wrap;\n    align-items: flex-start !important;\n    > div {\n      flex: 1 1 100%;\n      @media screen and (min-width: @screen-header-collapse) {\n        flex: 1 1 calc(50% - 10px);\n        max-width: calc(50% - 10px);\n      }\n    }\n  }\n}\n\n.syndication-summary {\n  flex: 1 1 auto;\n  min-width: 240px;\n  .listbody {\n    max-height: 515px;\n  }\n  .syndication-meta {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 20px 20px;\n    margin-bottom: 20px;\n    justify-content: center;\n    .syndication-logo {\n      .circle(100px);\n      min-width: 100px;\n      overflow: hidden;\n      border: 1px solid @grey;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      img {\n        width: 100px;\n      }\n    }\n    .syndication-counts {\n      display: flex;\n      flex: 1 1;\n      gap: 0 10px;\n      justify-content: flex-end;\n      @media screen and (min-width: @screen-header-collapse) {\n        flex: 0 0;\n        margin-left: auto;\n      }\n      .syndication-count {\n        flex: 1 1 auto;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        align-items: center;\n        gap: 0;\n        button {\n          min-width: 90px;\n          height: 63px;\n          background: @grey_50;\n          border-radius: 8px;\n          border: none;\n          outline: none;\n          color: inherit;\n          cursor: pointer;\n          &.active {\n            outline: 2px solid @grey_300;\n            cursor: default;\n          }\n        }\n        strong {\n          color: @grey_600;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n        button > div {\n          font-size: 20px;\n          flex: 1 1 100%;\n          height: 22px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          margin: 0;\n          color: inherit;\n        }\n        &.syndication-success {\n          color: @success;\n        }\n        &.syndication-failures {\n          color: @error;\n        }\n        &.syndication-pending {\n          color: @warning;\n        }\n        &.syndication-withdrawn {\n          color: @grey_700;\n        }\n        &.syndication-res {\n          color: @grey_700;\n        }\n        &.syndication-com {\n          color: @grey_700;\n        }\n      }\n    }\n  }\n}\n\n.uae-list-actions{\n  display: flex;\n  padding: 20px 0;\n  gap: 16px;\n}\n\n.uae-syndication-summary {\n  min-width: 240px;\n  .syndication-meta {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 20px 20px;\n    margin-bottom: 20px;\n    justify-content: center;\n    .syndication-logo {\n      .circle(100px);\n      min-width: 100px;\n      overflow: hidden;\n      border: 1px solid @grey;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-right: 40px;\n      img {\n        width: 100px;\n      }\n    }\n    .syndication-counts {\n      display: flex;\n      flex: 1 1;\n      gap: 0 10px;\n      justify-content: flex-end;\n      @media screen and (min-width: @screen-header-collapse) {\n        flex: 0 0;\n        margin-left: auto;\n      }\n      .syndication-count {\n        flex: 1 1 auto;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        align-items: center;\n        gap: 0;\n        button {\n          min-width: 90px;\n          height: 63px;\n          background: @grey_50;\n          border-radius: 8px;\n          border: none;\n          outline: none;\n          color: inherit;\n          cursor: pointer;\n          &.active {\n            outline: 2px solid @grey_300;\n            cursor: default;\n          }\n        }\n        strong {\n          color: @grey_600;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n        button > div {\n          font-size: 20px;\n          flex: 1 1 100%;\n          height: 22px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          margin: 0;\n          color: inherit;\n        }\n        &.syndication-success {\n          color: @success;\n        }\n        &.syndication-failures {\n          color: @error;\n        }\n        &.syndication-pending {\n          color: @warning;\n        }\n        &.syndication-withdrawn {\n          color: @grey_700;\n        }\n        &.syndication-res {\n          color: @grey_700;\n        }\n        &.syndication-com {\n          color: @grey_700;\n        }\n      }\n    }\n  }\n}\n\n.notification {\n  padding: 20px 0;\n  box-shadow: 0px 1px 0px #E5EBF1;\n  .notification-body {\n    font-size: 12px;\n    * {\n      font-size: 12px;\n    }\n  }\n  .notification-actions {\n    padding: 20px 0 0;\n  }\n}\n\n.notes-widget {\n  .notes-summary {\n    box-shadow: 0px 1px 0px #E5EBF1;\n    .agents {\n      display: flex;\n      align-items: center;\n      > div {\n        margin-right: 10px;\n      }\n    }\n  }\n}\n\n.empty.flex-container {\n  justify-content: center;\n}\n\n.flex-lifetime-sales {\n  flex-direction: column;\n  > div:nth-child(1) {\n    min-width: 0;\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    > div {\n      flex: 1 1 25%;\n    }\n  }\n  > div:nth-child(2) {\n    margin-top: 30px;\n    min-width: 0;\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    flex-wrap: wrap;\n    gap: 20px;\n  }\n  .strong {\n    color: @grey_500;\n  }\n  h1, h3 {\n    color: @primary_colour;\n    font-weight: 500;\n    margin: 0;\n  }\n}","// main: ../framework.less\n\n.main-sidebar {\n  background: @primary_colour;\n  position: absolute;\n  display: flex;\n  flex-wrap: wrap;\n  left: 0;\n  top: @navbar-height;\n  min-height: calc(~\"100vh - \"@navbar-height);\n  z-index: 951;\n  width: 100%;\n  transform: translate3d(-100%, 0, 0);\n  svg {\n    transition: all 0.3s ease 0s;\n  }\n  ul {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n    flex: 1 1 100%;\n    max-width: 100%;\n  }\n  .scrollview {\n    display: flex;\n    flex-wrap: wrap;\n  }\n  .pd-logo {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    margin-top: auto;\n    padding: 20px 0;\n    gap: 10px 0;\n    transition: none;\n    flex: 1 1 100%;\n    max-width: 100%;\n    min-width: @sidebar-width-md;\n    svg {\n      --color1: #ffffff;\n      --color2: #ffffff;\n      width: 215px;\n      height: 32px;\n      flex: 1 1 100%;\n    }\n    div {\n      flex: 1 1 100%;\n      display: flex;\n      justify-content: center;\n      color: @grey_400;\n    }\n  }\n  .menu-item > .inner-item {\n    min-height: 50px;\n    font-size: 16px;\n  }\n  .menu-item {\n    margin: 0;\n    line-height: 1.2;\n    cursor: pointer;\n    .inner-item {\n      max-width: 100%;\n      overflow: hidden;\n      display: flex;\n      align-items: center;\n      color: @primary_colour_50;\n      .menu-icon-wrapper {\n        display: flex;\n        padding: 0 10px;\n        width: 64px;\n        height: 44px;\n        align-items: center;\n        justify-content: center;\n        .menu-icon {\n          display: flex;\n          width: 44px;\n          height: 44px;\n          align-items: center;\n          justify-content: center;\n          transition: background @transition-speed @transition-fn;\n          .circle(44px);\n        }\n        svg {\n          flex: 0 0 24px;\n          fill: none;\n          stroke: @white;\n          stroke-width: @svg-24-stroke-width;\n          min-width: 24px;\n          height: 24px;\n        }\n      }\n      .menu-item-content {\n        white-space: nowrap;\n        display: flex;\n        overflow: hidden;\n        align-items: center;\n        line-height: inherit;\n        align-content: center;\n        transition: color @transition-speed @transition-fn;\n      }\n      .menu-arrow-wrapper {\n        display: flex;\n        width: 44px;\n        height: 44px;\n        align-items: center;\n        justify-content: center;\n        margin-left: auto;\n        transition: transform @transition-speed @transition-fn;\n        svg {\n          display: block;\n          flex: 0 0 24px;\n          fill: none;\n          stroke: @white;\n          stroke-width: @svg-24-stroke-width;\n          min-width: 24px;\n          height: 24px;\n        }\n      }\n    }\n    &:hover {\n      > .inner-item .menu-item-content {\n        color: @white;\n      }\n      .menu-icon {\n        background: @primary_colour_75;\n      }\n    }\n    &.active {\n      > .inner-item .menu-item-content {\n        color: @white;\n      }\n      .menu-icon {\n        background: @secondary_colour;\n      }\n    }\n    &.sub-menu{\n      &.open {\n        .menu-arrow-wrapper {\n          transform: rotate(90deg);\n        }\n      }\n    }\n  }\n  .list-item {\n    overflow: hidden;\n    padding-left: 64px;\n    > ul > .menu-item > .inner-item {\n      min-height: 34px;\n      font-size: 14px;\n    }\n  }\n  .popper-element {\n    .popper-inner {\n      background: @primary_colour;\n      border-radius: @input-border-radius;\n      padding: 7px 0;\n      .menu-item {\n        padding: 0 15px;\n        > .inner-item {\n          font-size: 14px;\n          min-height: 36px;\n        }\n      }\n    }\n    max-height: none;\n    padding-left: 0;\n    height: auto !important;\n    position: fixed;\n    visibility: hidden;\n    min-width: 220px;\n    max-width: 270px;\n    background-color: transparent;\n    max-height: 100%;\n    padding-left: 3px;\n  }\n}\n\n.main {\n  .full{\n    .main-sidebar{\n      transform: translate3d(0, 0, 0);\n    }\n    .main-header {\n      .navbtn {\n        &:before {\n          width: 100vw;\n        }\n        svg.close {\n          opacity: 1;\n          transform: scale(1)\n        }\n        svg.open {\n          opacity: 0;\n          transform: scale(0)\n        }\n      }\n    }\n  }\n}\n\n@media (min-width: @screen-header-collapse){\n  .main-sidebar{\n    width: @sidebar-width-md;\n    top: auto;\n    height: calc(~\"100vh - \"@navbar-height);\n    grid-area: nav;\n    transform: translate3d(0, 0, 0);\n    .menu-item:hover .popper-element {\n      transition: visibility,transform .3s;\n      visibility: visible;\n    }\n  }\n  .open .list-item:not(.popper-element) {\n    max-height: 0;\n  }\n  .main .mini{\n    grid-template-columns: 64px 1fr;\n    .main-sidebar{\n      width: 64px;\n      .nav .navitem span {\n        opacity: 0;\n        line-height: 1px;\n        height: 0px;\n        font-size: 1px;\n      }\n      .pd-logo {\n        display: none;\n      }\n    }\n  }\n  .main .full{\n    grid-template-columns: 64px 1fr;\n    .open .list-item {\n      max-height: none;\n    }\n    .main-header .navbtn {\n      &:before {\n        width: @sidebar-width-md;\n      }\n    }\n  }\n}","// main: ../framework.less\n\n.sidebar-right {\n  background: @white;\n  width: 0;\n  position: absolute;\n  top: 112px;\n  @media screen and (min-width: @screen-header-collapse) {\n    top: @navbar-height + 66px;\n  }\n  bottom: 0;\n  z-index: 900;\n  right: 0;\n  grid-area: actions;\n  border-left: 1px solid @frame-borders;\n  overflow: hidden;\n  &:after {\n    content: \"\";\n    position: absolute;\n    pointer-events: none;\n    right: 100%;\n    width: 0;\n    top: 0;\n    bottom: 0;\n  }\n  .sidebar-view {\n    width: @sidebar-width;\n  }\n\n  &-enter {\n    width: 0;\n  }\n  &-enter-done {\n    width: @sidebar-width + 1;\n    &:after {\n      width: 60px;\n    }\n  }\n  &-enter-active {\n    width: @sidebar-width;\n    &:after {\n      width: 60px;\n    }\n  }\n}\n","// main: ../framework.less\n/* Modal */\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1100;\n  background-color: rgba(51, 51, 51, 0.65);\n  display: block;\n}\n\n.modal-backdrop.nobackground {\n  opacity: 1;\n}\n\n.modal-wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 948;\n  height: 100%;\n  width: 100%;\n\n  .modal {\n    position: relative;\n    z-index: 1200;\n    top: 50%;\n    transform: translateY(-50%);\n    margin: 0 auto;\n    min-width: 300px;\n    max-width: 40%;\n    max-height: 60vh;\n    overflow-y: auto;\n    text-align: center;\n    border-radius: 2px;\n    font-size: 1.2rem;\n    font-weight: 300;\n\n    @media (max-width: @screen-lg-max) {\n      max-width: 70%;\n    }\n\n    @media (max-width: @screen-sm-max) {\n      max-width: 90%;\n    }\n\n    .card {\n      border: 1px solid #efefef;\n      box-shadow: 0px 0px 8px 2px rgba(0, 0, 0, 0.1);\n      margin-bottom: 0;\n\n      .cardfoot {\n        border: 0;\n\n        >.ccontent {\n          display: flex;\n          justify-content: center;\n        }\n\n        .modal-buttons {\n          display: flex;\n          justify-content: center;\n          gap: 10px 5px;\n        }\n      }\n    }\n\n    button {\n      &.close {\n        position: absolute;\n        top: 5px;\n        right: 5px;\n      }\n\n      &.actionbtn {\n        margin: 20px 0;\n      }\n    }\n  }\n\n  h2 {\n    margin: 0 0 20px 0;\n    font-size: 18px;\n    font-weight: normal;\n  }\n\n  code {\n    background: @gray-lighter;\n    font-weight: normal;\n    padding: 3px 6px;\n    font-size: 1rem;\n  }\n}\n\n.snippet-modal {\n  position: absolute;\n  left: 30%;\n  top: 10%;\n  max-height: 270px;\n  width: 280px;\n  overflow: auto;\n  display: none;\n  z-index: 10;\n  border-radius: @card-radius;\n  box-shadow: @card-shadow;\n  border: 1px solid @grey;\n\n  &.showing {\n    display: block;\n  }\n\n  .snippet-container {\n    margin: auto;\n\n    .card {\n      border-radius: 0;\n      font-weight: 500;\n      overflow-y: auto;\n      overflow-x: hidden;\n      border-radius: 0;\n      margin-bottom: 0;\n\n      .cardhead {\n        padding: 5px;\n        border-bottom: 1px solid @grey_300;\n\n        input {\n          padding-left: 5px;\n        }\n\n        input::-webkit-input-placeholder {\n          /* WebKit browsers */\n          font-size: 12px;\n          font-weight: 600;\n        }\n\n        input:-moz-placeholder {\n          /* Mozilla Firefox 4 to 18 */\n          font-size: 12px;\n          font-weight: 600;\n        }\n\n        input::-moz-placeholder {\n          /* Mozilla Firefox 19+ */\n          font-size: 12px;\n          font-weight: 600;\n        }\n\n        input:-ms-input-placeholder {\n          /* Internet Explorer 10+ */\n          font-size: 12px;\n          font-weight: 600;\n        }\n\n        .ccontent>div {\n          display: flex;\n\n          input {\n            width: 230px;\n          }\n        }\n      }\n\n      .cardbody {\n        overflow: auto;\n\n        .ccontent {\n          padding: 0;\n\n          .snippet-option {\n            padding: 10px 0px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            padding: 5px 10px 5px;\n            line-height: 30px;\n            color: @grey_900;\n\n            &:hover {\n              cursor: pointer;\n              background-color: @grey_50;\n            }\n\n            &.selected {\n              background-color: @grey;\n            }\n          }\n        }\n      }\n    }\n  }\n\n}","// main: ../framework.less\n.context-sidebar{\n  background: @white;\n  position: absolute;\n  top: @navbar-height * 2;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n  transition: all @transition-speed @transition-fn;\n  width: 0;\n  min-height: calc(~\"100vh - \"(@navbar-height*2 + @footer-height));\n  svg {\n    height: 18px;\n  }\n  // .has-submenu.navitem{\n  //   display: grid;\n  //   grid-template-columns: 1fr 45px;\n  //   > .navitem {\n  //     .nav > .navitem();\n  //     border: 0;\n  //   }\n  // }\n}\n\n.context-menu-cover{\n  .nav {\n    min-width: 145px;\n    overflow: visible;\n    background: #ffffff;\n    position: absolute;\n    box-shadow: @card-shadow;\n    border-radius: 4px;\n    z-index: 100;\n    overflow: visible;\n    > .action {\n      display: flex;\n      align-content: center;\n      align-items: center;\n      position: relative;\n      overflow: visible;\n      height: auto;\n      border-radius: 0;\n      &:first-child {\n        border-radius: @input-border-radius @input-border-radius 0 0;\n      }\n      &:last-child {\n        border-radius: 0 0 @input-border-radius @input-border-radius;\n        & > .btn, &.has-submenu > .btn {\n          border-radius: 0 0 @input-border-radius @input-border-radius;\n        }\n      }\n      .label {\n        height: auto;\n        line-height: 1.5;\n      }\n      .navicon {\n        margin-right: 10px;\n      }\n      &.has-submenu {\n        display: flex;\n        align-content: center;\n        align-items: center;\n        .navitem {\n          display: flex;\n          border-radius: 0;\n          flex: 1 1 100%;\n          align-content: center;\n          align-items: center;\n          padding-right: 6px;\n        }\n        .navicon.submenu-icon {\n          margin-left: auto;\n          flex: 0 0 auto;\n          margin-right: 0;\n          transform: rotate(-90deg);\n          svg {\n            stroke: @primary_colour;\n            stroke-width: @svg-24-stroke-width;\n            min-width: 24px;\n            height: 24px;\n          }\n        }\n        .action-submenu {\n          display: none;\n          position: absolute;\n          box-shadow: @card-shadow;\n          top: 0;\n          left: 100%;\n          overflow: hidden;\n          padding-left: 5px;\n          .action-submenu-inner {\n            min-width: 145px;\n            display: flex;\n            flex-direction: column;\n            background: @white;\n            box-shadow: @card-shadow;\n            border-radius: @input-border-radius;\n            overflow: hidden;\n          }\n          .action-sub-item {\n            text-align: left;\n            cursor: pointer;\n            white-space: nowrap;\n            padding: 0.75rem 0.8em;\n            background: #fff;\n            border: 0 none;\n            transition: background-color @transition-speed @transition-fn;\n            &:hover {\n              background: @grey_200;\n            }\n          }\n        }\n      }\n    }\n  }\n  &-wrapper {\n    overflow: visible;\n    position: absolute;\n  }\n  &-backdrop {\n    overflow: visible;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 10;\n    transform: translateZ(0);\n    background-color: rgba(0, 0, 0, 0);\n  }\n}","// main: ../framework.less\n\n.content:not(.form-group) {\n  grid-area: content;\n  display: grid;\n  grid-template-areas:\n    \"actions\"\n    \"view\";\n  grid-template-rows: 67px 1fr;\n  @media screen and (min-width: @screen-header-collapse) {\n    grid-template-columns: 1fr;\n  }\n  position: relative;\n  background: @grey_50;\n  transition: left @transition-speed @transition-fn, margin-right @transition-speed @transition-fn;\n  left: 0;\n  right: 0;\n  will-change: left margin-right;\n  min-height: 0;\n  &.canvassing {\n    grid-template-rows: 127px auto;\n  }\n}\n.view:not(.action) {\n  grid-area: view;\n  min-height: 0;\n  min-width: 0;\n  padding: 0;\n  .viewcontent {\n    display: grid;\n    grid-template-rows: 1fr auto;\n    grid-template-columns: 1fr;\n    grid-template-areas: \"content\";\n    padding: 10px;\n    @media screen and (min-width: 281px) {\n      padding: 20px;\n    }\n    grid-area: content;\n    height: 100%;\n    width: 100%;\n    overflow: auto;\n    > div {\n      grid-area: content;\n      min-width: 0;\n      &.horizontal-tabs-container, &:not(.brochure-generator) .horizontal-tabs-container {\n        margin: -20px -20px -20px -20px\n      }\n    }\n  }\n}\n\n.integrations {\n  .viewcontent {\n    padding: 15px 0;\n    .integrations-group {\n      .ccontent {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        > div {\n          flex: 1 1 auto;\n        }\n        .editgroup {\n          align-items: center;\n          justify-content: flex-end;\n          .input-group {\n            flex: 0 1 auto;\n            padding-left: 10px;\n            .forminput {\n              justify-content: flex-end;\n            }\n          }\n        }\n      }\n      .lightstone-logo {\n        width: 146px;\n        height: 49px;\n        flex: 0 0 146px;\n        color: #071B38;\n        background-image: url(\"../../images/lightstone-dark.svg\");\n        background-size: contain;\n        background-position: center center;\n        background-repeat: no-repeat;\n        margin: 0 0 20px 0;\n      }\n      .flow-logo {\n        width: 146px;\n        height: 49px;\n        flex: 0 0 146px;\n        color: #071B38;\n        background-image: url(\"../../images/flow.svg\");\n        background-size: contain;\n        background-position: center center;\n        background-repeat: no-repeat;\n        margin: 0 0 20px 0;\n      }\n      .reos-logo {\n        width: 146px;\n        height: 49px;\n        flex: 0 0 146px;\n        color: #071B38;\n        background-image: url(\"../../images/reos.svg\");\n        background-size: contain;\n        background-position: center center;\n        background-repeat: no-repeat;\n        margin: 0 0 20px 0;\n      }\n    }\n  }\n}\n\n.content.main-dashboard {\n  .actionswrap .action-list {\n    justify-content: flex-start;\n  }\n}","// main: ../framework.less\n\n@color_1: inherit;\n@color_2: #999999;\n@color_3: #373a3c;\n@color_4: #fff;\n@color_5: #3174ad;\n@color_6: #265985;\n@color_7: white;\n@background_color_1: #eaf6ff;\n@background_color_2: #e6e6e6;\n@background_color_3: #d4d4d4;\n@background_color_4: #3174ad;\n@background_color_5: #265985;\n@background_color_6: rgba(0, 0, 0, 0.1);\n@background_color_7: rgba(255, 255, 255, 0.3);\n@background_color_8: #fff;\n@background_color_9: white;\n@background_color_10: rgba(0, 0, 0, 0.5);\n@background_color_11: #74ad31;\n@border_color_1: #adadad;\n@border_color_2: #8c8c8c;\n\n.rbc-btn {\n\tcolor: @color_1;\n\tfont: inherit;\n\tmargin: 0;\n}\nbutton.rbc-btn {\n\toverflow: visible;\n\ttext-transform: none;\n\t-webkit-appearance: button;\n\t-moz-appearance: button;\n\tappearance: button;\n\tcursor: pointer;\n}\nbutton[disabled].rbc-btn {\n\tcursor: not-allowed;\n}\nbutton.rbc-input {\n\t&::-moz-focus-inner {\n\t\tborder: 0;\n\t\tpadding: 0;\n\t}\n}\n.rbc-calendar {\n\t-webkit-box-sizing: border-box;\n\tbox-sizing: border-box;\n\theight: 100%;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-webkit-box-align: stretch;\n\t-ms-flex-align: stretch;\n\talign-items: stretch;\n\t* {\n\t\t-webkit-box-sizing: inherit;\n\t\tbox-sizing: inherit;\n\t\t&:before {\n\t\t\t-webkit-box-sizing: inherit;\n\t\t\tbox-sizing: inherit;\n\t\t}\n\t\t&:after {\n\t\t\t-webkit-box-sizing: inherit;\n\t\t\tbox-sizing: inherit;\n\t\t}\n\t}\n}\n.rbc-m-b-negative-3 {\n\tmargin-bottom: -3px;\n}\n.rbc-h-full {\n\theight: 100%;\n}\n.rbc-abs-full {\n\toverflow: hidden;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n}\n.rbc-row-bg {\n\toverflow: hidden;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: row;\n\tflex-direction: row;\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1 0 0px;\n\tflex: 1 0 0;\n\toverflow: hidden;\n\tright: 1px;\n}\n.rbc-ellipsis {\n\tdisplay: block;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n.rbc-show-more {\n\tdisplay: block;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\tbackground-color: @background_color_7;\n\tz-index: 4;\n\tfont-weight: bold;\n\theight: auto;\n\tline-height: normal;\n\tcolor: @color_5;\n\t&:hover {\n\t\tcolor: @color_6;\n\t}\n\t&:focus {\n\t\tcolor: @color_6;\n\t}\n}\n.rbc-row-segment {\n\t.rbc-event-content {\n\t\tdisplay: block;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\twhite-space: nowrap;\n\t}\n\tpadding: 0 1px 1px 1px;\n}\n.rbc-event-label {\n\tdisplay: block;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n.rbc-rtl {\n\tdirection: rtl;\n\t.rbc-header {\n\t\t&+.rbc-header {\n\t\t\tborder-left-width: 0;\n\t\t\tborder-right: 1px solid @grey;\n\t\t}\n\t}\n\t.rbc-btn-group {\n\t\t>button {\n\t\t\t&:first-child {\n\t\t\t\t&:not(:last-child) {\n\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\t&:not(:first-child) {\n\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\tborder-top-right-radius: 0;\n\t\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tbutton {\n\t\t\t&+button {\n\t\t\t\tmargin-left: 0;\n\t\t\t\tmargin-right: -1px;\n\t\t\t}\n\t\t}\n\t}\n\t.rbc-day-bg {\n\t\t&+.rbc-day-bg {\n\t\t\tborder-left-width: 0;\n\t\t\tborder-right: 1px solid @grey;\n\t\t}\n\t}\n\t.rbc-agenda-view {\n\t\ttable.rbc-agenda-table {\n\t\t\ttbody {\n\t\t\t\t>tr {\n\t\t\t\t\t>td {\n\t\t\t\t\t\t&+td {\n\t\t\t\t\t\t\tborder-left-width: 0;\n\t\t\t\t\t\t\tborder-right: 1px solid @grey;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\tthead {\n\t\t\t\t>tr {\n\t\t\t\t\t>th {\n\t\t\t\t\t\ttext-align: right;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.rbc-time-header.rbc-overflowing {\n\t\tborder-right-width: 0;\n\t}\n\t.rbc-time-header-content {\n\t\tborder-left-width: 0;\n\t}\n\t.rbc-time-content {\n\t\t>* {\n\t\t\t&+* {\n\t\t\t\t>* {\n\t\t\t\t\tborder-left-width: 0;\n\t\t\t\t\tborder-right: 1px solid @grey;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.rbc-off-range {\n\tcolor: @color_2;\n}\n.rbc-off-range-bg {\n\tbackground: #e6e6e6;\n}\n.rbc-header {\n\toverflow: hidden;\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1 0 0%;\n\tflex: 1 0 0%;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\tpadding: 0 3px;\n\ttext-align: center;\n\tmin-height: 45px;\n    display: inline-flex;\n    justify-content: center;\n    align-content: center;\n    align-items: center;\n\t>a {\n\t\tcolor: @color_1;\n\t\ttext-decoration: none;\n\t\t&:active {\n\t\t\tcolor: @color_1;\n\t\t\ttext-decoration: none;\n\t\t}\n\t\t&:visited {\n\t\t\tcolor: @color_1;\n\t\t\ttext-decoration: none;\n\t\t}\n\t}\n}\n.rbc-button-link {\n    color: @primary_colour;\n    font-weight: 600;\n\tbackground: none;\n\tmargin: 0;\n\tpadding: 0;\n\tborder: none;\n\tcursor: pointer;\n\t-webkit-user-select: text;\n\t-moz-user-select: text;\n\t-ms-user-select: text;\n\tuser-select: text;\n}\n.rbc-row-content {\n\tposition: relative;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\t-webkit-user-select: none;\n\tz-index: 4;\n}\n.rbc-row-content-scrollable {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\theight: 100%;\n\t.rbc-row-content-scroll-container {\n\t\theight: 100%;\n\t\toverflow-y: scroll;\n\t\t-ms-overflow-style: none;\n\t\tscrollbar-width: none;\n\t\t-ms-overflow-style: none;\n\t\tscrollbar-width: none;\n\t\t&::-webkit-scrollbar {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n.rbc-today {\n\tbackground-color: @grey_25;\n}\n.rbc-toolbar {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-ms-flex-wrap: wrap;\n\tflex-wrap: wrap;\n\t-webkit-box-pack: center;\n\t-ms-flex-pack: center;\n\tjustify-content: center;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tmargin-bottom: 10px;\n\t.rbc-toolbar-label {\n\t\t-webkit-box-flex: 1;\n\t\t-ms-flex-positive: 1;\n\t\tflex-grow: 1;\n\t\tpadding: 0 10px;\n\t\ttext-align: center;\n        font-weight: 600;\n        color: @primary_colour;\n\t}\n}\n.rbc-btn-group {\n\tdisplay: inline-block;\n\twhite-space: nowrap;\n\t>button {\n\t\t&:first-child {\n\t\t\t&:not(:last-child) {\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\t\t&:last-child {\n\t\t\t&:not(:first-child) {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t}\n\t\t}\n\t\t&:not(:first-child) {\n\t\t\t&:not(:last-child) {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\tbutton {\n\t\t&+button {\n\t\t\tmargin-left: -1px;\n\t\t}\n\t}\n\t&+.rbc-btn-group {\n\t\tmargin-left: 10px;\n\t}\n\t&+button {\n\t\tmargin-left: 10px;\n\t}\n}\n.rbc-event {\n\tborder: none;\n\t-webkit-box-sizing: border-box;\n\tbox-sizing: border-box;\n\t-webkit-box-shadow: none;\n\tbox-shadow: none;\n\tmargin: 0;\n\tpadding: 2px 5px;\n\tbackground-color: @tertiary_colour_10;\n\tborder-radius: 5px;\n\tcolor: @tertiary_colour;\n\tcursor: pointer;\n\twidth: 100%;\n\ttext-align: left;\n    font-size: 11px;\n}\n.rbc-day-slot {\n\t.rbc-background-event {\n\t\tborder: none;\n\t\t-webkit-box-sizing: border-box;\n\t\tbox-sizing: border-box;\n\t\t-webkit-box-shadow: none;\n\t\tbox-shadow: none;\n\t\tmargin: 0;\n\t\tpadding: 2px 5px;\n\t\tbackground-color: @background_color_4;\n\t\tborder-radius: 5px;\n\t\tcolor: @color_4;\n\t\tcursor: pointer;\n\t\twidth: 100%;\n\t\ttext-align: left;\n\t\tborder: 1px solid #265985;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tmax-height: 100%;\n\t\tmin-height: 20px;\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-ms-flex-flow: column wrap;\n\t\tflex-flow: column wrap;\n\t\t-webkit-box-align: start;\n\t\t-ms-flex-align: start;\n\t\talign-items: flex-start;\n\t\toverflow: hidden;\n\t\tposition: absolute;\n\t\topacity: 0.75;\n\t\t&:focus {\n\t\t\toutline: 5px auto #3b99fc;\n\t\t}\n\t}\n\t.rbc-slot-selecting {\n\t\t.rbc-background-event {\n\t\t\tcursor: inherit;\n\t\t\tpointer-events: none;\n\t\t}\n\t}\n\t.rbc-selected.rbc-background-event {\n\t\tbackground-color: @background_color_5;\n\t}\n\tposition: relative;\n\t.rbc-events-container {\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\tright: 0;\n\t\tmargin-right: 10px;\n\t\ttop: 0;\n\t\t.tc-tooltip {\n\t\t\tmargin-left: 10px;\n\t\t\tmargin-top: 5px;\n\t\t\tmin-width: 100%;\n\t\t\tmax-width: none;\n\t\t\twidth: 130%;\n\t\t\tborder: 0 none;\n\t\t\tbackground: @white;\n\t\t\tbox-shadow: @elevation_16;\n\t\t\tpadding: 12px 15px;\n\t\t\t.tc-tooltip-title {\n\t\t\t\tbackground: none;\n\t\t\t\tborder: 0 none;\n\t\t\t\t.btn {\n\t\t\t\t\tposition: absolute;\n          top: 0;\n          right: 0;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.tc-tooltip-content {\n\t\t\t\tbackground: none;\n\t\t\t\tborder: 0 none;\n\t\t\t\t.btn {\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\tmargin-top: 8px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.rbc-events-container.rbc-rtl {\n\t\tleft: 10px;\n\t\tright: 0;\n\t}\n\t.rbc-event {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\tmax-height: 100%;\n\t\tmin-height: 20px;\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-ms-flex-flow: column wrap;\n\t\tflex-flow: column wrap;\n\t\t-webkit-box-align: start;\n\t\t-ms-flex-align: start;\n\t\talign-items: flex-start;\n\t\toverflow: hidden;\n\t\tposition: absolute;\n\t}\n\t.rbc-event-label {\n\t\t-webkit-box-flex: 0;\n\t\t-ms-flex: none;\n\t\tflex: none;\n\t\tpadding-right: 5px;\n\t\twidth: auto;\n\t}\n\t.rbc-event-content {\n\t\twidth: 100%;\n\t\t-webkit-box-flex: 1;\n\t\t-ms-flex: 1 1 0px;\n\t\tflex: 1 1 0;\n\t\tword-wrap: break-word;\n\t\tline-height: 1;\n\t\theight: 100%;\n\t\tmin-height: 1em;\n\t}\n\t.rbc-time-slot {\n\t\tborder-top: 1px solid #f7f7f7;\n\t}\n}\n.rbc-slot-selecting {\n\t.rbc-event {\n\t\tcursor: inherit;\n\t\tpointer-events: none;\n\t}\n\t.rbc-day-slot {\n\t\t.rbc-background-event {\n\t\t\tcursor: inherit;\n\t\t\tpointer-events: none;\n\t\t}\n\t}\n\tcursor: move;\n}\n.rbc-event.rbc-selected {\n\tbackground-color: @tertiary_colour_25;\n}\n.rbc-event-overlaps {\n\t-webkit-box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n\tbox-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n.rbc-event-continues-prior {\n\tborder-top-left-radius: 0;\n\tborder-bottom-left-radius: 0;\n}\n.rbc-event-continues-after {\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n.rbc-event-continues-earlier {\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n}\n.rbc-event-continues-later {\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n.rbc-row {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: row;\n\tflex-direction: row;\n}\n.rbc-selected-cell {\n\tbackground-color: @background_color_6;\n}\n.rbc-month-view {\n\tposition: relative;\n\tborder: 1px solid @grey;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1 0 0px;\n\tflex: 1 0 0;\n\twidth: 100%;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\t-webkit-user-select: none;\n\theight: 100%;\n}\n.rbc-month-header {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: row;\n\tflex-direction: row;\n}\n.rbc-month-row {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tposition: relative;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1 0 0px;\n\tflex: 1 0 0;\n\t-ms-flex-preferred-size: 0px;\n\tflex-basis: 0px;\n\toverflow: hidden;\n\theight: 100%;\n\t&+.rbc-month-row {\n\t\tborder-top: 1px solid @grey;\n\t}\n}\n.rbc-date-cell {\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1 1 0px;\n\tflex: 1 1 0;\n\tmin-width: 0;\n\tpadding-right: 5px;\n\ttext-align: right;\n\t>a {\n\t\tcolor: @color_1;\n\t\ttext-decoration: none;\n\t\t&:active {\n\t\t\tcolor: @color_1;\n\t\t\ttext-decoration: none;\n\t\t}\n\t\t&:visited {\n\t\t\tcolor: @color_1;\n\t\t\ttext-decoration: none;\n\t\t}\n\t}\n}\n.rbc-date-cell.rbc-now {\n\tfont-weight: bold;\n}\n.rbc-day-bg {\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1 0 0%;\n\tflex: 1 0 0%;\n\t&+.rbc-day-bg {\n\t\tborder-left: 1px solid @grey;\n\t}\n}\n.rbc-overlay {\n\tposition: absolute;\n\tz-index: 5;\n\tborder: 1px solid #e5e5e5;\n\tbackground-color: @background_color_8;\n\t-webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n\tbox-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n\tpadding: 10px;\n\t>* {\n\t\t&+* {\n\t\t\tmargin-top: 1px;\n\t\t}\n\t}\n}\n.rbc-overlay-header {\n\tborder-bottom: 1px solid #e5e5e5;\n\tmargin: -10px -10px 5px -10px;\n\tpadding: 2px 10px;\n}\n.rbc-agenda-view {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1 0 0px;\n\tflex: 1 0 0;\n\toverflow: auto;\n\ttable.rbc-agenda-table {\n\t\twidth: 100%;\n\t\tborder: 1px solid @grey;\n\t\tborder-spacing: 0;\n\t\tborder-collapse: collapse;\n\t\ttbody {\n\t\t\t>tr {\n\t\t\t\t>td {\n\t\t\t\t\tpadding: 5px 10px;\n\t\t\t\t\tvertical-align: top;\n\t\t\t\t\t&+td {\n\t\t\t\t\t\tborder-left: 1px solid @grey;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t&+tr {\n\t\t\t\t\tborder-top: 1px solid @grey;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.rbc-agenda-time-cell {\n\t\t\tpadding-left: 15px;\n\t\t\tpadding-right: 15px;\n\t\t\ttext-transform: lowercase;\n\t\t}\n\t\tthead {\n\t\t\t>tr {\n\t\t\t\t>th {\n\t\t\t\t\tpadding: 3px 5px;\n\t\t\t\t\ttext-align: left;\n\t\t\t\t\tborder-bottom: 1px solid @grey;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.rbc-agenda-time-cell {\n\ttext-transform: lowercase;\n\twhite-space: nowrap;\n\t.rbc-continues-after {\n\t\t&:after {\n\t\t\tcontent: \" »\";\n\t\t}\n\t}\n\t.rbc-continues-prior {\n\t\t&:before {\n\t\t\tcontent: \"« \";\n\t\t}\n\t}\n}\n.rbc-agenda-date-cell {\n\twhite-space: nowrap;\n}\n.rbc-agenda-event-cell {\n\twidth: 100%;\n}\n.rbc-time-column {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\tmin-height: 100%;\n\t.rbc-timeslot-group {\n\t\t-webkit-box-flex: 1;\n\t\t-ms-flex: 1;\n\t\tflex: 1;\n\t}\n}\n.rbc-timeslot-group {\n\tborder-bottom: 1px solid @grey;\n\tmin-height: 40px;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-flow: column nowrap;\n\tflex-flow: column nowrap;\n}\n.rbc-time-gutter {\n\t-webkit-box-flex: 0;\n\t-ms-flex: none;\n\tflex: none;\n}\n.rbc-header-gutter {\n\t-webkit-box-flex: 0;\n\t-ms-flex: none;\n\tflex: none;\n}\n.rbc-label {\n\tpadding: 0 5px;\n}\n.rbc-time-view-resources {\n\t.rbc-time-gutter {\n\t\tposition: sticky;\n\t\tleft: 0;\n\t\tbackground-color: @background_color_9;\n\t\tborder-right: 1px solid @grey;\n\t\tz-index: 10;\n\t\tmargin-right: -1px;\n\t}\n\t.rbc-time-header-gutter {\n\t\tposition: sticky;\n\t\tleft: 0;\n\t\tbackground-color: @background_color_9;\n\t\tborder-right: 1px solid @grey;\n\t\tz-index: 10;\n\t\tmargin-right: -1px;\n\t}\n\t.rbc-time-header {\n\t\toverflow: hidden;\n\t}\n\t.rbc-time-header-content {\n\t\tmin-width: auto;\n\t\t-webkit-box-flex: 1;\n\t\t-ms-flex: 1 0 0px;\n\t\tflex: 1 0 0;\n\t\t-ms-flex-preferred-size: 0px;\n\t\tflex-basis: 0px;\n\t}\n\t.rbc-time-header-cell-single-day {\n\t\tdisplay: none;\n\t}\n\t.rbc-day-slot {\n\t\tmin-width: 140px;\n\t}\n\t.rbc-header {\n\t\twidth: 140px;\n\t\t-webkit-box-flex: 1;\n\t\t-ms-flex: 1 1 0px;\n\t\tflex: 1 1 0;\n\t\t-ms-flex-preferred-size: 0 px;\n\t\tflex-basis: 0 px;\n\t}\n\t.rbc-day-bg {\n\t\twidth: 140px;\n\t\t-webkit-box-flex: 1;\n\t\t-ms-flex: 1 1 0px;\n\t\tflex: 1 1 0;\n\t\t-ms-flex-preferred-size: 0 px;\n\t\tflex-basis: 0 px;\n\t}\n}\n.rbc-time-header-content {\n\t&+.rbc-time-header-content {\n\t\tmargin-left: -1px;\n\t}\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\tmin-width: 0;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t>.rbc-row.rbc-row-resource {\n\t\tborder-bottom: 1px solid @grey;\n\t\t-ms-flex-negative: 0;\n\t\tflex-shrink: 0;\n\t}\n}\n.rbc-time-slot {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    font-size: 11px;\n    color: @primary_colour;\n    font-weight: 600;\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1 0 0px;\n\tflex: 1 0 0;\n}\n.rbc-time-slot.rbc-now {\n\tfont-weight: bold;\n}\n.rbc-day-header {\n\ttext-align: center;\n}\n.rbc-slot-selection {\n\tz-index: 10;\n\tposition: absolute;\n\tbackground-color: @background_color_10;\n\tcolor: @color_7;\n\twidth: 100%;\n\tpadding: 3px;\n}\n.rbc-time-view {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1;\n\tflex: 1;\n\twidth: 100%;\n\tmin-height: 0;\n\t.rbc-time-gutter {\n\t\twhite-space: nowrap;\n\t\ttext-align: right;\n\t}\n\t.rbc-allday-cell {\n\t\t-webkit-box-sizing: content-box;\n\t\tbox-sizing: content-box;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tposition: relative;\n        display: none;\n\t\t&+.rbc-allday-cell {\n\t\t\tborder-left: 1px solid @grey;\n\t\t}\n\t}\n\t.rbc-allday-events {\n\t\tposition: relative;\n\t\tz-index: 4;\n\t}\n\t.rbc-row {\n\t\t-webkit-box-sizing: border-box;\n\t\tbox-sizing: border-box;\n\t\tmin-height: 20px;\n\t}\n}\n.rbc-time-header {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-flex: 0;\n\t-ms-flex: 0 0 auto;\n\tflex: 0 0 auto;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: row;\n\tflex-direction: row;\n\t>.rbc-row {\n\t\t&:first-child {\n\t\t\tborder-bottom: 1px solid @grey;\n\t\t}\n\t}\n\t>.rbc-row.rbc-row-resource {\n\t\tborder-bottom: 1px solid @grey;\n\t}\n}\n.rbc-time-header-cell-single-day {\n\tdisplay: none;\n}\n.rbc-time-content {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-flex: 1;\n\t-ms-flex: 1 0 0%;\n\tflex: 1 0 0%;\n\t-webkit-box-align: start;\n\t-ms-flex-align: start;\n\talign-items: flex-start;\n\twidth: 100%;\n\toverflow-y: auto;\n\tposition: relative;\n    border: 1px solid @grey;\n\t>.rbc-time-gutter {\n\t\t-webkit-box-flex: 0;\n\t\t-ms-flex: none;\n\t\tflex: none;\n\t}\n\t>* {\n\t\t&+* {\n\t\t\t>* {\n\t\t\t\tborder-left: 1px solid @grey;\n\t\t\t}\n\t\t}\n\t}\n\t>.rbc-day-slot {\n\t\twidth: 100%;\n\t\t-moz-user-select: none;\n\t\t-ms-user-select: none;\n\t\tuser-select: none;\n\t\t-webkit-user-select: none;\n\t}\n}\n.rbc-current-time-indicator {\n\tposition: absolute;\n\tz-index: 3;\n\tleft: 0;\n\tright: 0;\n\theight: 3px;\n\tbackground-color: @secondary_colour;\n\tpointer-events: none;\n}\n.rbc-resource-grouping.rbc-time-header-content {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: vertical;\n\t-webkit-box-direction: normal;\n\t-ms-flex-direction: column;\n\tflex-direction: column;\n}\n.rbc-resource-grouping {\n\t.rbc-row {\n\t\t.rbc-header {\n\t\t\twidth: 141px;\n\t\t}\n\t}\n}\n@media (max-width: 767px) {\n\t.rbc-toolbar {\n\t\t-webkit-box-orient: vertical;\n\t\t-webkit-box-direction: normal;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column;\n\t}\n}\n\n.rbc-week-toolbar {\n    display: inline-flex;\n    align-items: center;\n    font-size: 16px;\n}","// main: ../framework.less\n\n@wide-sidebar-width: 844px;\n\n.wide-sidebar {\n  width: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 949;\n  background: #ffffff;\n  position: absolute;\n  top: 114px;\n  max-height: calc(~\"100vh - 114px\");\n  display: flex;\n\n  @media (min-width: @screen-header-collapse) {\n    top: 67px;\n    max-height: calc(~\"100vh - 67px\");\n  }\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    pointer-events: none;\n    right: 100%;\n    width: 0;\n    top: 0;\n    bottom: 0;\n    background: linear-gradient(270deg, rgba(31, 41, 51, 0.15) 0%, rgba(31, 41, 51, 0) 100%);\n  }\n\n  .sidebar-view {\n    width: 100vw;\n  }\n\n  &-enter {\n    width: 0;\n  }\n\n  &-enter-done {\n    width: 100vw;\n\n    &:after {\n      width: 60px;\n    }\n  }\n\n  &-enter-active {\n    width: 100vw;\n\n    &:after {\n      width: 60px;\n    }\n  }\n\n  @media (min-width: @screen-header-collapse) {\n    .sidebar-view {\n      width: @wide-sidebar-width;\n    }\n\n    &-enter {\n      width: 0;\n    }\n\n    &-enter-done {\n      width: @wide-sidebar-width;\n\n      &:after {\n        width: 60px;\n      }\n    }\n\n    &-enter-active {\n      width: @wide-sidebar-width;\n\n      &:after {\n        width: 60px;\n      }\n    }\n  }\n\n  .wide-sidebar-container {\n    list-style: none;\n    margin: 0;\n    padding: 0 0;\n    position: sticky;\n    top: 0;\n    width: 100%;\n    grid-template-rows: 50px auto;\n    justify-content: space-between;\n    overflow: hidden;\n\n    @media (min-width: @screen-header-collapse) {\n      width: @wide-sidebar-width;\n    }\n  }\n\n  .wide-sidebar-content {\n    position: relative;\n    background: @white;\n    padding: 20px 20px 120px;\n    min-width: 280px;\n\n    @media (min-width: @screen-header-collapse) {\n      width: @wide-sidebar-width;\n      padding: 20px 40px 120px;\n    }\n\n    .editgroup {\n      margin-top: 27px;\n\n      .btmatches {\n        width: 100%;\n      }\n    }\n  }\n\n  .wide-sidebar-heading {\n    position: sticky;\n    background: @grey_50;\n    top: 0;\n    z-index: 10;\n    min-height: 84px;\n    display: flex;\n    align-items: center;\n    padding: 0 20px;\n\n    @media (min-width: @screen-header-collapse) {\n      padding: 0 40px;\n    }\n\n    .btn-wide-sidebar-close {\n      margin-left: auto;\n      margin-right: -20px;\n    }\n\n    h4 {\n      margin: 0;\n    }\n  }\n\n  .wide-sidebar-footer {\n    padding: 15px 0;\n    display: flex;\n    justify-content: flex-end;\n    gap: 20px 20px;\n\n    button {\n      min-height: 36px;\n    }\n  }\n}\n\n// Recipient / asset selector\n.model-selector-sidebar.wide-sidebar {\n\n  .datatablewrap {\n    min-width: 100%;\n  }\n\n  .search-buttons {\n    display: flex;\n    justify-content: end;\n    gap: 10px;\n    width: 100%;\n  }\n\n  .editgroup+.search-buttons {\n    margin-top: 20px;\n  }\n\n  .editgroup:has(.listbody) {\n    gap: 0;\n  }\n\n  .term {\n    margin-bottom: 15px;\n  }\n\n  .recipients-search .term {\n    margin-bottom: 0px;\n  }\n}\n\n// Deeds lookup\n.deeds-lookup-sidebar {\n  tbody td:last-of-type svg:hover {\n    cursor: pointer;\n  }\n\n  .keyword-search {\n    box-shadow: 0px 1px 0 @grey_50;\n    padding-bottom: 20px;\n  }\n}\n\n.datatable.locationselector {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n\n  .datatable-headers {\n    display: grid;\n    padding: 0 10px;\n    margin-bottom: 10px;\n\n    &[data-columns=\"3\"] {\n      grid-template-columns: 160px 0.7fr 0.3fr;\n    }\n\n    &[data-columns=\"4\"] {\n      grid-template-columns: 160px 112px 234px 0.3fr;\n    }\n\n    &[data-columns=\"5\"] {\n      grid-template-columns: 170px 170px 170px 210px auto 0.3fr;\n    }\n\n    &[data-columns=\"7\"] {\n      grid-template-columns: 140px 140px 120px 120px 120px 80px auto 0.3fr;\n    }\n\n    &[data-columns=\"8\"] {\n      grid-template-columns: 140px 140px 80px 80px 80px 80px 100px auto 0.3fr;\n    }\n\n    >div {\n      display: inline-flex;\n      align-items: center;\n      min-height: 34px;\n      text-transform: uppercase;\n      font-size: 10px;\n      font-weight: 700;\n      color: @grey_700;\n\n      &.centered {\n        justify-content: center;\n      }\n    }\n  }\n\n  .datatable-body {\n    gap: 10px 0;\n    display: flex;\n    flex-direction: column;\n\n    .datatable-row {\n      display: grid;\n      font-size: 12px;\n      color: @grey_600;\n      border: 1px solid @grey;\n      border-radius: @card-radius;\n      box-shadow: 0px 2px 4px rgba(195, 201, 210, 0.31);\n      padding: 0 10px;\n\n      &:hover {\n        background: @grey_50;\n      }\n\n      >div {\n        display: inline-flex;\n        align-items: center;\n        min-height: 44px;\n        font-size: 12px;\n        color: @grey_600;\n\n        .btn {\n          padding-left: 0;\n          padding-right: 0;\n        }\n\n        &.centered {\n          justify-content: center;\n        }\n\n        &.right {\n          justify-content: right;\n        }\n      }\n\n      svg {\n        fill: none;\n        stroke: @grey_600;\n        stroke-width: @svg-16-stroke-width;\n      }\n    }\n\n    &[data-columns=\"3\"] .datatable-row {\n      grid-template-columns: 160px auto 24px;\n\n      &.datatable-row-empty {\n        grid-template-columns: auto;\n      }\n    }\n\n    &[data-columns=\"4\"] .datatable-row {\n      grid-template-columns: 160px 112px auto 24px;\n\n      &.datatable-row-empty {\n        grid-template-columns: auto;\n      }\n    }\n\n    &[data-columns=\"5\"] .datatable-row {\n      grid-template-columns: 170px 170px 170px 210px auto 0.3fr;\n\n      &.datatable-row-empty {\n        grid-template-columns: auto;\n      }\n    }\n\n    &[data-columns=\"7\"] .datatable-row {\n      grid-template-columns: 140px 140px 120px 120px 120px 80px auto 0.3fr;\n\n      &.datatable-row-empty {\n        grid-template-columns: auto;\n      }\n    }\n\n    &[data-columns=\"8\"] .datatable-row {\n      grid-template-columns: 140px 140px 80px 80px 80px 80px 100px auto 0.3fr;\n\n      &.datatable-row-empty {\n        grid-template-columns: auto;\n      }\n    }\n  }\n\n  .tablecell {\n    display: block;\n    max-width: 100%;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    padding-right: 10px;\n\n    img {\n      max-width: 90px;\n    }\n\n    svg {\n      height: 13px;\n\n      &.success {\n        fill: @quality-border;\n      }\n\n      &.pending {\n        fill: #ff7400;\n      }\n\n      &.unknown,\n      &.failed {\n        fill: @tip-hot-border;\n      }\n    }\n\n    &.ellipses {\n      min-width: 167px;\n    }\n  }\n}\n\n.datatable.contactselector {\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n\n  .datatable-headers {\n    display: grid;\n    padding: 0 10px;\n    margin-bottom: 10px;\n\n    &[data-columns=\"3\"] {\n      grid-template-columns: 100px 0.7fr 0.3fr;\n    }\n\n    &[data-columns=\"5\"] {\n      grid-template-columns: 140px 112px 234px 234px 0.3fr;\n    }\n\n    &[data-columns=\"6\"] {\n      grid-template-columns: 100px 140px 140px 112px 230px 0.3fr;\n    }\n\n    >div {\n      display: inline-flex;\n      align-items: center;\n      min-height: 34px;\n      text-transform: uppercase;\n      font-size: 10px;\n      font-weight: 700;\n      color: @grey_700;\n    }\n  }\n\n  .datatable-body {\n    gap: 10px 0;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n\n    .datatable-row {\n      display: grid;\n      font-size: 12px;\n      color: @grey_600;\n      border: 1px solid @grey;\n      border-radius: @card-radius;\n      box-shadow: 0px 2px 4px rgba(195, 201, 210, 0.31);\n      padding: 0 10px;\n\n      &:hover {\n        background: @grey_50;\n      }\n\n      >div {\n        display: inline-flex;\n        align-items: center;\n        min-height: 44px;\n        font-size: 12px;\n        color: @grey_600;\n\n        .btn {\n          padding-left: 0;\n          padding-right: 0;\n        }\n      }\n\n      svg {\n        fill: none;\n        stroke: @grey_600;\n        stroke-width: @svg-16-stroke-width;\n      }\n    }\n\n    &[data-columns=\"3\"] .datatable-row {\n      grid-template-columns: 100px auto 24px;\n\n      &.datatable-row-empty {\n        grid-template-columns: auto;\n      }\n    }\n\n    &[data-columns=\"5\"] .datatable-row {\n      grid-template-columns: 140px 112px 234px 234px 0.3fr;\n\n      &.datatable-row-empty {\n        grid-template-columns: auto;\n      }\n    }\n\n    &[data-columns=\"6\"] .datatable-row {\n      grid-template-columns: 100px 140px 140px 112px 230px 0.3fr;\n\n      &.datatable-row-empty {\n        grid-template-columns: auto;\n      }\n    }\n  }\n\n  .tablecell {\n    display: block;\n    max-width: 100%;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    padding-right: 10px;\n\n    img {\n      max-width: 90px;\n    }\n\n    svg {\n      height: 13px;\n\n      &.success {\n        fill: @quality-border;\n      }\n\n      &.pending {\n        fill: #ff7400;\n      }\n\n      &.unknown,\n      &.failed {\n        fill: @tip-hot-border;\n      }\n    }\n\n    &.ellipses {\n      min-width: 167px;\n    }\n  }\n}\n\n.credit-report {\n  display: flex;\n  flex-direction: column;\n  gap: 20px 20px;\n\n  .report-tags {\n    display: flex;\n\n    .tag-label {\n      padding: 5px 8px;\n      background: @secondary_colour;\n      color: #ffffff;\n      font-size: 11px;\n      flex: 0 0;\n      border-radius: 50px;\n    }\n  }\n\n  .report-buttons {\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px 20px;\n  }\n\n  .report-information {\n    display: flex;\n    flex-direction: column;\n    gap: 10px 20px;\n  }\n\n  .report-summary {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px 20px;\n    background: @grey_25;\n    padding: 20px;\n\n    >div {\n      flex: 0 1 48%;\n    }\n  }\n}","// main: ../framework.less\n/* Tables */\n.datatablewrap-inner {\n  max-width: 100%;\n  overflow: auto;\n}\n\n.datatable {\n  width: 100%;\n  border-spacing: 0;\n  border-collapse: separate;\n  font-size: 12px;\n  margin-bottom: 1px;\n\n  .checkcontainer {\n    min-height: 0;\n    height: auto;\n  }\n\n  thead {\n    tr:first-child {\n\n      td:first-child,\n      th:first-child {\n        overflow: hidden;\n      }\n    }\n\n    tr:first-child {\n\n      td:last-child,\n      th:last-child {\n        overflow: hidden;\n      }\n    }\n\n    th {\n      vertical-align: bottom;\n      padding: 0;\n    }\n  }\n\n  tfoot {\n    tr:first-child {\n\n      td:first-child,\n      th:first-child {\n        border-bottom-left-radius: 4px;\n        overflow: hidden;\n      }\n    }\n\n    tr:first-child {\n\n      td:last-child,\n      th:last-child {\n        border-bottom-right-radius: 4px;\n        overflow: hidden;\n      }\n    }\n\n    th {\n      vertical-align: top;\n      padding: 0;\n    }\n  }\n\n  label.tooltip {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translate(-50%, 0);\n    padding: 10px 15px;\n    background-color: #fff;\n    font-weight: 400;\n    border-radius: 3px;\n    text-align: center;\n    border: 1px solid #efefef;\n    box-shadow: 4px 4px 3px -2px fade(#000, 30%);\n  }\n\n  svg {\n    vertical-align: middle;\n  }\n\n  thead,\n  tfoot {\n    &:not(:has(th[rowspan=\"2\"])) {\n      background: @grey_50;\n    }\n\n    td,\n    th {\n      position: relative;\n      overflow: visible;\n      white-space: nowrap;\n      font-size: 10px;\n      font-weight: 600;\n      color: @grey_600;\n      padding: 0;\n\n      .heading-wrapper {\n        display: flex;\n        align-items: center;\n        padding: 5px 8px;\n        background: @grey_50;\n        min-height: 40px;\n\n        .heading {\n          flex: 0 0 auto;\n\n          +svg {\n            flex: 0 0 16px;\n            min-width: 16px;\n            fill: @grey_200;\n            --color1: @grey_200;\n          }\n        }\n      }\n\n      &.text-right .heading-wrapper {\n        justify-content: flex-end;\n      }\n\n      &.text-center .heading-wrapper {\n        justify-content: center;\n      }\n\n      &.column-check {\n        width: 25px;\n      }\n\n      &.orderable {\n        .heading {\n          cursor: pointer;\n          text-transform: uppercase;\n\n          &+svg {\n            width: 16px;\n            height: 16px;\n            margin: 0;\n            fill: @grey_200;\n            --color1: @grey_200;\n            --color4: @grey_200;\n          }\n        }\n      }\n\n      &:hover {\n        label.tooltip {\n          display: block;\n        }\n      }\n\n      .checkmark {\n        background-color: #fff;\n      }\n    }\n  }\n\n  thead .grouper {\n    z-index: 0;\n    min-height: 20px;\n    text-transform: uppercase;\n    padding: 0 8px;\n\n    &:before {\n      content: \"\";\n      background: @grey;\n      position: absolute;\n      z-index: -1;\n      top: 0;\n      left: 1px;\n      right: 1px;\n      bottom: 0;\n    }\n  }\n\n  tfoot .grouper {\n    z-index: 0;\n    min-height: 20px;\n    text-transform: uppercase;\n    padding: 0 8px;\n\n    &:before {\n      content: \"\";\n      background: @grey;\n      position: absolute;\n      z-index: -1;\n      top: 0;\n      left: 1px;\n      right: 1px;\n      bottom: 0;\n    }\n  }\n\n  tbody {\n    tr {\n      td {\n        .cell-wrapper {\n          max-width: 100%;\n          display: block;\n        }\n\n        box-shadow: 0px 1px 0px #E5EBF1;\n\n        .icon.viewicon {\n          svg {\n            fill: none;\n            stroke: @primary_colour;\n          }\n        }\n      }\n\n      .checkmark {\n        background-color: #fff;\n      }\n\n      .checkcontainer {\n        min-height: auto;\n        height: auto;\n        margin: 0 auto;\n      }\n\n      .column-cell_number,\n      .column-metacontactcell_number {\n        max-width: 200px;\n\n        svg {\n          stroke: @primary_colour;\n          stroke-width: @svg-24-stroke-width;\n        }\n      }\n\n      &:hover:not(.selected) {\n        td {\n          background-color: fade(@grey, 50%);\n        }\n      }\n\n      &.selected {\n        td {\n          background-color: fade(@tertiary_colour, 11%);\n        }\n      }\n\n      .thumbimg {\n        display: inline-block;\n        .circle(40px);\n        overflow: hidden;\n        background-color: @grey_50;\n        background-position: center center;\n        background-size: cover;\n        transition: all 0.3s ease 0s;\n        vertical-align: middle;\n\n        svg {\n          width: 40px;\n          height: 40px;\n          fill: none;\n\n          text {\n            fill: @primary_colour;\n          }\n        }\n      }\n    }\n  }\n\n  tr.expanded {\n    td {\n      vertical-align: top;\n\n      .tablecell {\n        white-space: normal;\n      }\n    }\n  }\n\n  td,\n  th {\n    display: table-cell;\n    line-height: 1.8rem;\n    overflow: hidden;\n    vertical-align: middle;\n    max-width: 170px;\n    font-size: 1rem;\n\n    &.column-check {\n      width: 25px;\n      text-align: center;\n    }\n\n    &.column-score {\n      text-align: center;\n\n      svg {\n        display: inline-block;\n      }\n    }\n\n    &.column-feed_status,\n    &[class^=\"feed_status\"],\n    &[class*=\"feed_status\"] {\n      svg {\n        fill: none;\n      }\n    }\n\n    &.column-actions {\n      vertical-align: middle;\n      text-align: right;\n      max-width: none;\n\n      >div {\n        display: flex;\n        flex-wrap: nowrap;\n        align-items: center;\n        padding: 0 4px;\n        gap: 5px 5px;\n\n        >*:first-child {\n          margin-left: auto;\n        }\n      }\n    }\n\n    .tablecell {\n      display: block;\n      max-width: 100%;\n      padding: 8px;\n      overflow: hidden;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n\n      img {\n        max-width: 90px;\n      }\n\n      svg {\n        height: 20px;\n        padding-left: 0px;\n\n        &.success {\n          stroke: @success;\n          fill: none;\n        }\n\n        &.pending {\n          stroke: @warning;\n          fill: none;\n        }\n\n        &.withdrawn {\n          stroke: @grey_700;\n          fill: none;\n        }\n\n        &.unknown,\n        &.failed {\n          stroke: @error;\n          fill: none;\n        }\n      }\n\n      &.ellipses {\n        min-width: 167px;\n      }\n    }\n  }\n\n  &.imagestbl {\n    td:nth-of-type(2) {\n      width: 100px;\n    }\n\n    td:nth-of-type(8) {\n      text-align: center;\n    }\n\n    td .tablecell svg {\n      height: 40px;\n      fill: #ccc;\n    }\n  }\n\n  &.portal-log-table {\n    .column-view-on-portal {\n      width: 5%;\n    }\n\n    td {\n      .tablecell {\n        padding-left: 0;\n        padding-right: 0;\n      }\n    }\n\n    tbody tr:hover:not(.selected) td {\n      background: none;\n    }\n  }\n\n  &.commission-slip-table {\n    tbody tr:hover:not(.selected) td {\n      background: none;\n    }\n\n    tr[class*=\"-branch\"] {\n      .forminput:has(input:disabled) {\n        border: 0 none;\n      }\n    }\n\n    td,\n    th {\n      position: relative;\n      overflow: visible;\n      white-space: nowrap;\n      padding: 0;\n\n      .heading-wrapper {\n        display: flex;\n        align-items: center;\n        padding: 5px;\n        background: @grey_50;\n        min-height: 40px;\n\n        .heading {\n          flex: 0 0 auto;\n\n          +svg {\n            flex: 0 0 16px;\n            min-width: 16px;\n            fill: @grey_200;\n            --color1: @grey_200;\n          }\n        }\n      }\n\n      &.text-right {\n\n        .tablecell,\n        .heading-wrapper {\n          justify-content: flex-end;\n        }\n      }\n\n      &.field {\n        .tablecell {\n          overflow: visible;\n        }\n\n        .form-group {\n          min-width: 100px;\n        }\n\n        .form-group.selectinput {\n          min-width: 150px;\n        }\n\n        .form-group.asyncselectinput {\n          min-width: 150px;\n        }\n\n        .form-group[class*=\".nett_amount\"],\n        .form-group[class*=\".gross_amount\"] {\n          min-width: 150px;\n          max-width: 150px;\n        }\n\n        .form-group[class*=\".percentage\"],\n        .form-group[class*=\".share_percentage\"] {\n          min-width: 70px;\n          max-width: 70px;\n        }\n\n        .form-group[class*=\".deduct_franchise_fee\"] {\n          min-width: 180px;\n\n          .forminput .checkcontainer+label {\n            min-width: 0;\n            margin-left: 0;\n          }\n        }\n      }\n\n      .indicator {\n        width: 16px;\n        height: 16px;\n        border-radius: 16px;\n        display: flex;\n        justify-content: center;\n        align-content: center;\n\n        svg {\n          width: 16px;\n          height: 16px;\n          stroke: #ffffff;\n          fill: none;\n        }\n      }\n\n      &.text-center .heading-wrapper {\n        justify-content: center;\n      }\n    }\n\n    td {\n      color: @primary_colour;\n      font-size: 12px;\n    }\n\n    th {\n      color: @grey_600;\n      font-size: 10px;\n      text-transform: uppercase;\n    }\n\n    .primary-bg {\n\n      td,\n      th {\n        background: @primary_colour;\n        color: #ffffff;\n\n        .heading-wrapper {\n          background: none;\n        }\n      }\n\n      &.success {\n\n        td:not([colspan]),\n        th:not([colspan]) {\n          color: @success;\n\n          .indicator {\n            background: @success;\n          }\n        }\n      }\n\n      &.fail {\n\n        td:not([colspan]),\n        th:not([colspan]) {\n          color: @error;\n\n          .indicator {\n            background: @error;\n          }\n        }\n      }\n    }\n\n    .react-select__control {\n      min-height: 30px;\n\n      .react-select__single-value {\n        font-size: 12px;\n        font-weight: normal;\n      }\n    }\n\n    .checkmark {\n      background-color: reset;\n    }\n\n    td {\n      .tablecell {\n        padding: 5px;\n      }\n    }\n  }\n}\n\n.datatable .tablemeta select {\n  width: 45px;\n  padding: 10px 0 0;\n  text-indent: 10px;\n}\n\n.profile-form-footer {\n  margin-top: 10px;\n  margin-bottom: 25px;\n\n  .btn {\n    margin-top: 10px;\n    margin-right: 10px;\n    flex: 0 0 auto !important;\n\n    &:last-of-type {\n      margin-right: 0;\n    }\n  }\n}\n\n.details-section {\n  .details-section-buttons {\n    padding-right: 15px;\n\n    .btn {\n      margin-top: 5px;\n      margin-right: 5px;\n\n      &:last-of-type {\n        margin-right: 0;\n      }\n    }\n\n    +form {\n      margin-top: 20px;\n      display: block;\n    }\n  }\n}\n\n.list-actions {\n  display: flex;\n  padding: 20px 0;\n}\n\n.listbody {\n  overflow-y: visible;\n  overflow-x: auto;\n\n  thead,\n  tfoot {\n\n    th,\n    td {\n      vertical-align: center;\n      text-transform: uppercase;\n      color: @grey_600;\n\n      &.column-rating {\n        width: 0;\n\n        svg {\n          height: 23px;\n          fill: #ffffff;\n        }\n      }\n\n      .btmatches & {\n        background: @grey_50;\n        padding: 0 5px;\n      }\n\n      &.column-check {\n        width: 46px;\n        min-width: 46px;\n        max-width: 46px;\n      }\n\n      &.column-view-on-portal {\n        width: 120px;\n      }\n\n      &.column-feedstatus {\n        width: 0;\n      }\n\n      &.column-reason {\n        width: 50%;\n      }\n\n      &.column-stage.stage-expanded {\n        min-width: 510px;\n        width: 30%;\n        max-width: none;\n      }\n    }\n  }\n\n  tbody {\n    tr {\n      box-shadow: 0px 1px 0px #E5EBF1;\n    }\n\n    td {\n      .table-cell {\n        padding: 0 5px;\n      }\n\n      svg {\n        height: 13px;\n      }\n\n      &.column-rating {\n        svg {\n          height: 23px;\n        }\n      }\n\n      .check-match {\n        height: 9px;\n        stroke: #22cf6d;\n        margin-right: 8px;\n      }\n\n      &.column-view-on-portal {\n        text-align: right;\n      }\n\n      &.column-feedstatus {\n        width: 0;\n\n        svg {\n          height: 24px;\n          fill: none;\n          stroke: @warning;\n          stroke-width: @svg-24-stroke-width;\n\n          &.success {\n            stroke: @success;\n          }\n\n          &.failes {\n            stroke: @error;\n          }\n        }\n      }\n    }\n\n    tr:last-child {\n\n      td:first-child,\n      th:first-child {\n        overflow: hidden;\n      }\n    }\n\n    tr:last-child {\n\n      td:last-child,\n      th:last-child {\n        overflow: hidden;\n      }\n    }\n  }\n\n  &+form {\n    display: block;\n    margin-top: 20px;\n  }\n}\n\n.datatable.tfoot {\n  table-layout: fixed;\n}\n\n.datatable a:hover {\n  text-decoration: underline;\n}\n\n/* Table Metas */\n.tablemeta {\n  justify-content: space-between;\n  align-items: center;\n  font-size: 1.1rem;\n  margin: 0;\n  padding: 10px 0 0;\n  display: flex;\n  flex-wrap: wrap;\n  color: @content-text-alt;\n  gap: 10px 10px;\n\n  p {\n    font-size: inherit;\n    vertical-align: middle;\n    margin: 0;\n  }\n\n  select {\n    margin: 0;\n  }\n\n  .inlineselectinput {\n    flex: 1 1 100%;\n    margin-bottom: 0;\n\n    @media screen and (min-width: @screen-header-collapse) {\n      flex: 0 0 auto;\n    }\n\n    .forminput .input-group-addon {\n      padding-right: 0;\n      color: @primary_colour;\n      font-weight: 600;\n    }\n\n    .react-select .react-select__single-value {\n      color: @primary_colour;\n      font-weight: 500;\n    }\n  }\n\n  // .description {\n  //   flex: 0 0 auto;\n  //   display: flex;\n  //   align-items: center;\n  // }\n  // .status__in {\n  //   .react-select {\n  //     display: flex;\n  //     .react-select__control {\n  //       flex: 0 0 auto;\n  //     }\n  //   }\n  // }\n  // > div {\n  //   margin-bottom: 10px;\n  //   &:last-of-type {\n  //     flex: 1 1 100%;\n  //     display: flex;\n  //     justify-content: flex-end;\n  //   }\n  // }\n  // @media (min-width: @screen-header-collapse) {\n  //   display: flex;\n  //   > div {\n  //     width: auto;\n  //     text-align: inherit;\n  //     margin-bottom: 0;\n  //     &:last-of-type {\n  //       flex: 0 0 auto;\n  //       justify-content: flex-end;\n  //       width: auto;\n  //     }\n  //   }\n  // }\n  // @media (min-width: @screen-header-collapse) and (max-width: 1080px) {\n  //   flex-wrap: wrap;\n  //   > div {\n  //     margin-bottom: 10px;\n  //     &:last-of-type {\n  //       justify-content: flex-end;\n  //       width: 100%;\n  //     }\n  //   }\n  // }\n  /* Search */\n  input[type=\"text\"] {\n    width: auto;\n    display: inline-block;\n    min-width: 300px;\n  }\n\n  form .btn {\n    display: inline-block;\n    margin: 0 0 0 20px;\n  }\n\n  >div {\n    @media (max-width: @screen-sm-max) {\n      text-align: left;\n      margin-bottom: 10px;\n    }\n  }\n\n  >div:last-of-type {\n    @media (max-width: @screen-sm-max) {\n      text-align: center;\n    }\n  }\n\n  .selected-records {\n    font-weight: 600;\n  }\n}\n\n.page-tools {\n  display: flex;\n  flex-wrap: nowrap;\n  flex: 1 1 0%;\n  gap: 10px 10px;\n  justify-content: flex-end;\n  color: @content-text-alt;\n  font-size: 12px;\n\n  .pagejump .form-group .page-jump {\n    width: auto;\n    max-width: 60px;\n  }\n}\n\n.page-buttons {\n  display: flex;\n  flex: 0 0 auto;\n  gap: 10px 5px;\n  justify-content: flex-end;\n  color: @grey_400;\n  font-size: 12px;\n  margin-left: auto;\n\n  @media screen and (min-width: @screen-header-collapse) {\n    margin-left: 0;\n  }\n}\n\n.record-count {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  flex-wrap: nowrap;\n}\n\n.pagejump {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: nowrap;\n\n  form,\n  >div {\n    flex: 0 0 auto;\n\n    @media screen and (min-width: @screen-header-collapse) {\n      flex: 1 1 auto;\n    }\n\n    white-space: nowrap;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 0 10px;\n\n    >* {\n      vertical-align: middle;\n    }\n  }\n\n  .form-group {\n    flex: 1 1 auto;\n\n    .page-jump {\n      display: inline-block;\n      height: 36px;\n      width: 36px;\n      text-align: center;\n      padding: 6px;\n      color: @content-text-alt;\n      font-weight: 500;\n    }\n  }\n\n  .btn-primary {\n    height: 36px;\n    line-height: 1.6;\n    vertical-align: middle;\n    margin: 0 0 0 5px;\n  }\n}\n\na,\nbutton,\nhtml [type=\"button\"] {\n  &.btn.btn-none.btn-gray {\n    color: @gray-dark;\n\n    svg {\n      fill: @gray-dark;\n    }\n  }\n}\n\n/* Steppers / paginations */\n.pagestep {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  border-radius: 4px;\n  justify-content: flex-end;\n  gap: 0 5px;\n\n  .stepposition {\n    padding-right: 10px;\n  }\n\n  .btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex: 0 0 36px;\n    padding: 0;\n    min-width: 36px;\n  }\n}\n\n.inline-select {\n  input[type=\"text\"] {\n    width: auto;\n    min-width: auto;\n  }\n}\n\n.inline__control.inline__control {\n  min-height: 32px;\n}\n\n.description {\n  input[type=\"text\"] {\n    min-width: 25px;\n  }\n}\n\n.status {\n  input[type=\"text\"] {\n    min-width: 50px;\n  }\n}\n\n.tablesearch {\n  position: relative;\n  transition: all @transition-speed @transition-fn;\n  z-index: 1;\n  box-shadow: 0px 1px 0px #E5EBF1;\n  padding-bottom: 1px;\n\n  &-simple {\n    display: none;\n  }\n\n  &-advanced {\n    display: none;\n  }\n\n  .open {\n    display: block;\n  }\n\n  .search-buttons {\n    display: flex;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n    gap: 8px 20px;\n    flex: 1 1 auto;\n\n    .btn {\n      width: 100%;\n      justify-content: center;\n\n      @media screen and (min-width: @screen-header-collapse) {\n        justify-content: initial;\n        width: auto;\n      }\n    }\n  }\n\n  .adv-count {\n    display: flex;\n    align-items: center;\n    font-weight: 600;\n    color: @primary_colour;\n    text-align: right;\n    width: 100%;\n    min-width: 280px;\n    justify-content: flex-start;\n\n    @media screen and (min-width: @screen-header-collapse) {\n      width: auto;\n      justify-content: flex-end;\n      min-width: 0;\n    }\n  }\n}\n\n.search-fields {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 20px 15px;\n  margin-bottom: 10px;\n}\n\n.input-group {\n\n  .tags-form,\n  .snippets-form {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 20px 15px;\n    padding-bottom: 10px;\n    margin-bottom: 10px;\n\n    .field {\n      flex: 0 0 100%;\n    }\n  }\n}\n\n.tbltags {\n  .column-label {\n    min-width: 280px;\n  }\n}\n\n.reset-group {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 0 10px;\n  flex: 0 0 auto;\n}\n\n.activity-search {\n  align-items: flex-start;\n  flex-wrap: wrap;\n\n  .flex-container {\n    gap: 15px 20px;\n    justify-content: flex-start;\n    margin-bottom: 15px;\n  }\n\n  .reset-group {\n    white-space: nowrap;\n  }\n\n  .input-group {\n    flex: 1 1 0;\n    margin: 0;\n  }\n\n  .form-group.dateinput .forminput {\n    border: 0 none;\n    flex-wrap: wrap;\n\n    &:hover {\n      border: 0 none;\n    }\n\n    &:focus {\n      box-shadow: none;\n    }\n\n    .input-group-addon {\n      width: auto;\n      flex: 1 1 100%;\n      max-width: none;\n    }\n  }\n\n  .field {\n    padding: 0;\n\n    @media screen and (min-width: @screen-header-collapse) {\n      flex: 0 0 200px;\n\n      &:first-child {\n        flex: 0 0 280px;\n      }\n    }\n\n    .form-group {\n      margin-bottom: auto;\n\n      @media screen and (min-width: @screen-header-collapse) {\n        &.dateinput {\n          max-width: 200px;\n        }\n\n        &.search {\n          max-width: 280px;\n        }\n      }\n\n      .flatpickr-inputwrap {\n        input {\n          min-height: 34px;\n        }\n      }\n    }\n  }\n}\n\n/* Table Manager */\n\n.table-manager {\n  display: flex;\n  flex: 0 0 36px;\n\n  >.btn {\n    display: flex;\n    flex: 0 0 36px;\n    padding: 6px;\n    justify-content: center;\n  }\n}\n\n.drag-handle {\n  display: inline-block;\n  width: 24px;\n  min-width: 24px;\n  max-width: 24px;\n  height: 18px;\n  vertical-align: middle;\n  line-height: 14px;\n  margin-right: 10px;\n  padding: 0;\n  cursor: row-resize;\n  user-select: none;\n}\n\n.meta-status {\n  padding-left: 10px;\n\n  .input-group-addon {\n    padding-right: 0;\n    color: @primary_colour;\n    font-weight: 600;\n    font-size: 1.1rem;\n  }\n}\n\n.table-manager-sidebar {\n  .track-horizontal {\n    right: 2px;\n    left: 8px;\n  }\n\n  .track-vertical {\n    left: 2px;\n    right: auto;\n  }\n\n  .table-manager-container {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    position: sticky;\n    grid-template-rows: 50px auto;\n    justify-content: space-between;\n    overflow: hidden;\n  }\n\n  .table-manager-content {\n    position: relative;\n    height: calc(~\"100vh - \"@navbar-height);\n    width: @sidebar-width;\n  }\n\n  .table-manager-pane {\n    position: relative;\n    width: @sidebar-width;\n  }\n\n  .table-manager-heading {\n    display: flex;\n    position: sticky;\n    background: @grey_50;\n    height: 64px;\n    align-items: center;\n    justify-content: space-between;\n    top: 0;\n    z-index: 10;\n  }\n\n  h3 {\n    padding-left: 20px;\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n\n  .btn-table-manager-update {\n    outline: 0 !important;\n    box-shadow: none !important;\n    border: 1px solid #ccc;\n    height: 36px;\n    top: 0;\n    margin: 10px 0;\n\n    svg {\n      margin: 0;\n      height: 14px;\n    }\n  }\n\n  .table-column-list {\n    width: @sidebar-width;\n    padding: 20px 10px;\n\n    *::selection {\n      background: transparent;\n    }\n  }\n\n  .table-column-dropper {\n    overflow: hidden;\n    transition: all @transition-speed @transition-fn;\n    font-weight: 500;\n    font-size: 12px;\n    touch-action: none;\n\n    >* {\n      touch-action: none;\n    }\n\n    .table-column-draggable {\n      padding: 0 0 0 13px;\n      display: flex;\n      align-items: center;\n\n      >.btn svg {\n        stroke: @primary_colour;\n        transition: all @transition-speed @transition-fn;\n      }\n\n      &:hover {\n        background: @grey;\n\n        >span {\n          color: @primary_colour;\n        }\n      }\n\n      &[style^=\"left\"],\n      &[style*=\"left\"] {\n        background: @grey;\n        transition: none;\n        box-shadow: 0px 2px 4px #C5CFDC;\n      }\n\n      .column-remover {\n        margin-left: auto;\n\n        svg {\n          stroke: @grey_300;\n          transition: all @transition-speed @transition-fn;\n        }\n\n        &:hover {\n          svg {\n            stroke: @primary_colour;\n          }\n        }\n      }\n\n      &.protected {\n        color: @disabled-text;\n        pointer-events: none;\n      }\n\n      &.has-droppable {\n        flex-wrap: wrap;\n\n        >.column-remover svg {\n          transform: rotate(90deg);\n          stroke: @primary_colour;\n        }\n\n        &.open {\n          >.column-remover svg {\n            transform: rotate(0deg);\n          }\n        }\n\n        &:hover {\n          .table-column-draggable {\n            background: @grey_50;\n\n            &:hover {\n              background: @grey;\n              ;\n            }\n          }\n        }\n\n        .table-column-draggable {\n          padding-left: 33px;\n\n          &[style^=\"left\"],\n          &[style*=\"left\"] {\n            background: @grey;\n            box-shadow: 0px 2px 4px #C5CFDC;\n          }\n        }\n\n        .table-column-dropper {\n          margin-left: -13px;\n          flex: 0 0 calc(100% + 13px);\n        }\n      }\n\n      span {\n        align-items: center;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        max-width: 100%;\n        color: @grey_500;\n      }\n\n      strong {\n        width: 100%;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        flex: 1 1 200px;\n      }\n\n      button {\n        flex: 0 0 30px;\n      }\n    }\n  }\n\n  .column-remover {\n    padding: 0;\n    cursor: pointer;\n  }\n\n  .table-manager-actions {\n    padding: 0 10px 10px;\n\n    .form-group {\n      margin: 0;\n      width: 100%;\n    }\n\n    .btn-reset {\n      margin-bottom: 1rem;\n    }\n  }\n\n  .table-manager-field-form {\n    display: block;\n    margin-bottom: 10px;\n\n    .selectinput .react-select {\n      width: 212px;\n    }\n  }\n\n  .btn-primary.btn-primary {\n    svg {\n      margin-right: 0 !important;\n    }\n  }\n\n  .msg.error {\n    flex: 1 1 100%;\n    color: @required-border;\n    font-size: 1rem;\n    font-weight: 600;\n    text-align: left;\n  }\n}\n\n.preference-list {\n  width: @sidebar-width;\n  margin-top: -10px;\n  padding: 0 10px 30px 20px;\n\n  .preference-item {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    align-content: center;\n    min-height: 36px;\n\n    .column-remover {\n      margin-left: auto;\n\n      svg {\n        stroke: @grey_300;\n        transition: all @transition-speed @transition-fn;\n      }\n\n      &:hover {\n        svg {\n          stroke: @primary_colour;\n        }\n      }\n    }\n\n    .form-group {\n      margin: 0;\n      flex: 1 1 100%;\n      display: flex;\n      align-items: center;\n      align-content: center;\n    }\n  }\n}\n\n.filtered_notice {\n  width: 100%;\n  border-bottom: 1px solid #cccccc;\n  line-height: 2em;\n  background-color: #efefef;\n  text-align: center;\n  padding: 10px 5px;\n}\n\n// .main .showmanager {\n//   @media (min-width: @screen-header-collapse) {\n//     .table-manager-sidebar {\n//       &:after {\n//         content: \"\";\n//         position: absolute;\n//         pointer-events: none;\n//         right: 100%;\n//         width: 60px;\n//         top: 0;\n//         bottom: 0;\n//         background: linear-gradient(270deg, rgba(31, 41, 51, 0.15) 0%, rgba(31, 41, 51, 0) 100%);\n//       }\n//       width: @sidebar-width;\n//       .table-manager-container {\n//         width: @sidebar-width;\n//       }\n//     }\n//   }\n// }\n\na.has-link,\n.has-link {\n  color: inherit;\n  text-decoration: underline;\n\n  .listing-popup,\n  .contact-popup {\n    text-decoration: inherit;\n    display: inline;\n  }\n\n  &:hover {\n    color: @primary_colour;\n  }\n\n  &.secondary {\n    color: @secondary_colour;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n\n.column-stage {\n  a {\n    text-decoration: none;\n  }\n}\n\n.lead-stage {\n  .btn();\n  border-radius: 30px;\n  min-height: 0;\n  padding: 3px 15px;\n  text-decoration: none;\n  display: inline-block;\n\n  &.New {\n    background: @secondary_colour;\n    color: #ffffff;\n  }\n\n  &.Contacted {\n    background: @success;\n    color: #ffffff;\n  }\n\n  &.Viewing {\n    background: @tertiary_colour;\n    color: #ffffff;\n  }\n\n  &.Offer {\n    background: @quality;\n    color: #ffffff;\n  }\n\n  &.Sold {\n    background: @warning;\n    color: #ffffff;\n  }\n\n  &.Rented {\n    background: @warning;\n    color: #ffffff;\n  }\n\n  &.Rental-Application {\n    background: @quality;\n    color: #ffffff;\n  }\n\n  &.Archived {\n    background: @primary_colour;\n    color: #ffffff;\n  }\n}\n\n.email-stage {\n  color: #ffffff;\n  border-radius: 30px;\n  min-height: 0;\n  padding: 3px 15px;\n  text-decoration: none;\n  display: inline-block;\n\n  &.delivered {\n    background: #73C677;\n  }\n\n  &.open {\n    background: #0CA6C8;\n  }\n\n  &.click {\n    background: #10294D;\n  }\n\n  &.bounce {\n    background: #FC495D;\n  }\n\n  &.unsubscribe {\n    background: #70859E;\n  }\n\n  &.spamreport {\n    background: #459948;\n  }\n\n  &.dropped {\n    background: #006DDC;\n  }\n}\n\n.deal-stage {\n  color: #ffffff;\n  border-radius: 30px;\n  min-height: 0;\n  padding: 3px 15px;\n  text-decoration: none;\n  display: inline-block;\n\n  &.offer-made {\n    background: @info;\n  }\n\n  &.sale-agreement {\n    background: @info_130;\n  }\n\n  &.buyer-signed {\n    background: @tertiary_colour;\n  }\n\n  &.seller-signed {\n    background: @tertiary_colour_130;\n  }\n\n  &.instruction-sent {\n    background: @quality;\n  }\n\n  &.deposit-received {\n    background: @quality_120;\n  }\n\n  &.conditions-met {\n    background: @quality_120;\n  }\n\n  &.lodged {\n    background: @success;\n  }\n\n  &.closed {\n    background: @secondary_colour_120\n  }\n\n  &.cancelled {\n    background: @primary_colour;\n  }\n}\n\n.application-stage {\n  .btn();\n  border-radius: 30px;\n  min-height: 0;\n  padding: 3px 15px;\n  text-decoration: none;\n  display: inline-block;\n\n  &.Sent {\n    background: @tertiary_colour;\n    color: #ffffff;\n  }\n\n  &.Submitted {\n    background: @quality;\n    color: #ffffff;\n  }\n\n  &.Expired {\n    background: @warning;\n    color: #ffffff;\n  }\n\n  &.Accepted {\n    background: @success;\n    color: #ffffff;\n  }\n\n  &.Declined {\n    background: @secondary_colour;\n    color: #ffffff;\n  }\n}\n\n@media print {\n  body {\n    height: auto;\n    width: auto;\n    overflow: visible;\n    flex-wrap: nowrap !important;\n  }\n\n  .viewhead {\n    display: none;\n  }\n\n  .print-page {\n    .viewhead {\n      display: none;\n    }\n\n    .print-card-no-display {\n      visibility: hidden !important;\n    }\n\n    .mini {\n      grid-template-columns: 20px 1fr;\n    }\n\n    .view .heavy {\n      flex: 0 0 1%;\n    }\n\n    .meta-detail {\n      display: flex !important;\n      flex-wrap: wrap;\n      line-height: 1.5rem;\n      grid-gap: 0 16px;\n      gap: 0 16px;\n    }\n\n    .col-lg-6 {\n      flex: 1;\n    }\n\n    .meta-detail .col {\n      padding: 5px 6px !important;\n    }\n\n    .view .heavy+div {\n      display: flex;\n      flex: 1;\n      padding: 5px 6px;\n      min-width: auto;\n      overflow-wrap: break-word;\n    }\n\n    .model-details {\n      background-color: @white;\n      padding: 0px 0 0 0 !important;\n    }\n\n    .card {\n      break-inside: avoid;\n      position: relative;\n      border-radius: 0 !important;\n      box-shadow: none;\n      margin-bottom: 0px !important;\n      width: 100%;\n      border: none;\n      border-bottom: 1px solid @grey_200;\n\n      &:last-of-type {\n        border-bottom: 1px solid transparent;\n      }\n    }\n\n    .wrapper {\n      display: block !important;\n      height: auto !important;\n      grid-template-rows: 20px auto;\n      background-color: @white !important;\n\n      .content:not(.form-group) {\n        display: block !important;\n        background-color: @white;\n        grid-template-rows: 20px auto !important;\n\n        .scrollview {\n          position: relative !important;\n          display: block !important;\n          overflow: visible !important;\n        }\n      }\n    }\n  }\n\n  .image-gallery {\n    .image-gallery-thumb {\n      flex: 0 0 calc(100% / 4 - 20px);\n      min-width: 0;\n    }\n  }\n\n  .productfruits--container {\n    display: none\n  }\n\n  .model-details .card .cardbody>.ccontent {\n    page-break-before: avoid;\n  }\n}\n\n.print-page {\n  .viewcontent {\n    padding: 0;\n  }\n\n  .viewhead {\n    display: none;\n  }\n\n  .mini {\n    grid-template-columns: 20px 1fr;\n  }\n\n  .print-card-no-display {\n    color: @white !important;\n    border: none !important;\n  }\n\n  .checkmark {\n    border: none !important;\n    background: transparent !important;\n  }\n\n  .model-details {\n    background-color: @white;\n    padding: 0px 0 0 0 !important;\n  }\n\n  .meta-detail .col {\n    padding: 5px 6px !important;\n\n    iframe {\n      border: 0;\n    }\n  }\n\n  .viewhead {\n    display: none;\n  }\n\n  .mini {\n    grid-template-columns: 20px 1fr;\n  }\n\n  .view .heavy {\n    flex: 0 0 1%;\n  }\n\n  .meta-detail {\n    display: flex !important;\n    flex-wrap: wrap;\n    line-height: 1.5rem;\n    grid-gap: 0 16px;\n    gap: 0 16px;\n  }\n\n  .col-lg-6 {\n    flex: 1;\n  }\n\n  .meta-detail .col a {\n    flex: 1;\n  }\n\n  .view .heavy+div {\n    display: flex;\n    flex: 1;\n    padding: 5px 6px;\n    min-width: auto;\n    overflow-wrap: anywhere;\n  }\n\n  .view .heavy+div {\n    display: flex;\n    flex: 1;\n    padding: 5px 6px;\n    min-width: auto;\n    overflow-wrap: break-word;\n  }\n\n  .card {\n    break-inside: avoid;\n    position: relative;\n    border-radius: 0 !important;\n    box-shadow: none;\n    margin-bottom: 0px !important;\n    width: 100%;\n    border: none;\n    border-bottom: 1px solid @grey_200;\n\n    .section-underline {\n      width: 100%;\n    }\n\n    &:last-of-type {\n      border-bottom: 1px solid transparent;\n    }\n  }\n\n  .wrapper {\n    grid-template-columns: auto;\n    grid-template-rows: auto;\n    background-color: @white !important;\n    grid-template-areas:\n      \"header\"\n      \"content\";\n\n    .content:not(.form-group) {\n      grid-template-columns: auto;\n      grid-template-rows: auto;\n      grid-template-areas:\n        \"view\";\n      background-color: @white !important;\n      height: 100vh;\n    }\n  }\n\n  .image-gallery {\n    justify-content: space-between;\n    grid-template-columns: repeat(3, 1fr);\n\n    img {\n      page-break-before: auto;\n      page-break-after: auto;\n      page-break-inside: avoid;\n    }\n\n    .image-gallery-thumb-img-size {\n      display: none;\n    }\n\n    .image-gallery-thumb-meta {\n      display: none;\n    }\n  }\n\n  .address-date {\n    flex: 0 0 100%;\n    text-align: center;\n  }\n\n  @media screen and (min-width: @screen-header-collapse) {\n    .header-section {\n      height: 90px;\n      justify-content: space-between;\n    }\n\n    .address-date {\n      flex: 1 1 auto;\n      text-align: right;\n    }\n  }\n\n  .header-section {\n    flex-wrap: wrap;\n    height: auto;\n    justify-content: center;\n    gap: 20px 20px;\n  }\n\n}\n\n.header-section {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  height: 90px;\n  box-sizing: border-box;\n\n  .logo {\n    img {\n      object-fit: contain;\n      height: 50px;\n    }\n  }\n\n  .address-date {\n    .address {\n      font-size: 18px;\n      font-weight: 500;\n      line-height: 27px;\n    }\n\n    .datetime {\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 21px;\n    }\n  }\n}\n\n.tags-search {\n  .input-group.keyword-search {\n    flex: 0 0 100%;\n\n    @media screen and (min-width: @screen-header-collapse) {\n      flex: 0 0 200px;\n    }\n\n    +.btn {\n      flex: 0 0 100%;\n      justify-content: center;\n\n      @media screen and (min-width: @screen-header-collapse) {\n        flex: 0 0 0;\n      }\n    }\n  }\n\n  .search-buttons {\n    display: flex;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n    gap: 10px 10px;\n\n    .btn {\n      flex: 0 0 100%;\n      justify-content: center;\n\n      @media screen and (min-width: @screen-header-collapse) {\n        flex: 0 0 0;\n      }\n    }\n  }\n}\n\n.tagsbody {\n  max-width: calc(100vw - 82px);\n}\n\n.modelchoice {\n  grid-template-rows: min-content;\n\n  .choice {\n    display: flex;\n    justify-content: center;\n    max-height: 350px;\n\n    .ccontent {\n      height: 100%;\n\n      .preview {\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        flex-direction: column;\n\n        &:hover {\n          cursor: pointer;\n        }\n\n        img {\n          width: 100%;\n          height: 100%;\n          object-fit: contain;\n        }\n      }\n    }\n  }\n\n  h2 {\n    margin-top: 20px;\n  }\n\n  .img-placeholder {\n    height: 250px;\n  }\n}","// main: ../framework.less\n\n.group-detail {\n  .details {\n    padding: 15px;\n  }\n}\n\n.view.details, .view.model {\n  grid-area: view;\n  .viewcontent {\n    width: 100%;\n    height: 100%;\n  }\n  &.brochures {\n    .flex-container {\n      padding-top: 20px;\n      padding-bottom: 20px;\n    }\n    .form-group.checkinput .checkcontainer {\n      min-height: 24px;\n      margin-top: -5px;\n      margin-bottom: -5px;\n    }\n  }\n}\n\n.html-preview {\n  .viewcontent {\n    .horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-nav {\n      max-width: calc(100vw - 40px);\n    }\n    .horizontal-tabs-container .horizontal-tabs-wrapper .horizontal-tabs-content {\n      padding-left: 0;\n      padding-right: 0;\n    }\n    .html-preview-form{\n      background: none;\n      grid-area: form;\n      form {\n        display: block;\n      }\n    }\n    .tab-content {\n      padding: 0;\n    }\n    .preview-pane {\n      padding-top: 20px;\n      grid-area: pane;\n    }\n    .recipients-count {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n      margin: 20px;\n      & > div {\n        line-height: 36px;\n        margin-right: 10px;\n      }\n    }\n  }\n}\n\n.col-md-4 .horizontal-tabs-container {\n  margin-top: -20px;\n}\n\n.permission-list{\n  padding: 0;\n  margin: 0;\n  li {\n    list-style: none;\n    border-bottom: 1px solid @gray-light;\n    line-height: 3em;\n    margin: 0;\n    padding-left: 15px;\n    svg {\n      margin-right: 10px;\n      height: 18px;\n    }\n    span {\n      display: inline-block;\n      line-height: 18px;\n      vertical-align: middle;\n    }\n  }\n  li:last-of-type {\n    border-bottom: none;\n  }\n}\n\n.model-details {\n  padding: 20px;\n  min-width: 0;\n  min-height: 0;\n  overflow: auto;\n  position: relative;\n  @media screen and (min-width: @screen-header-collapse) {\n    padding-left: 0;\n    padding-top:  0;\n  }\n  .card .cardbody > .ccontent {\n    display: flex;\n    flex-wrap: wrap;\n    padding-top: 5px;\n    gap: 7px 0;\n  }\n  #portal-feeds {\n    .ccontent > .meta-group > .meta-group {\n      border-bottom: 4px solid @grey;\n    }\n    .ccontent > .meta-group > .meta-group:last-of-type {\n      border-bottom: none;\n    }\n  }\n  .array-group {\n    margin-bottom: 20px;\n    padding-bottom: 8px;\n  }\n}\n\n.financial-structure.ccontent {\n  display: flex;\n  flex-wrap: wrap;\n  padding-top: 5px;\n  gap: 7px 0;\n}\n\n.meta-group {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 0 0 100%;\n  gap: 7px 20px;\n  #make-form-grid-columns(@columns: 12, @gutter: 20px, @grid-breakpoints);\n  [class^=\"col-\"], [class*=\"col-\"] {\n    padding: 0;\n  }\n  .meta-detail:not([class^=\"col-\"]):not([class*=\"col-\"]) {\n    display: inherit;\n    flex-wrap: wrap;\n    gap: 16px 20px;\n    .tip {\n      flex: 0 0 100%;\n    }\n  }\n  .bordered {\n    margin-top: 23px;\n    border-top: 4px solid @grey;\n    padding-top: 27px;\n    flex: 0 0 calc(~\"100% + 30px\");\n  }\n}\n\n.meta-detail {\n\n  div.domstring {\n    /* Ensure that the formatting is not lost on the Description text. */\n    white-space: pre-wrap;\n    &.position-left {\n      float: left\n    }\n    &.position-right {\n      float: right\n    }\n    &.position-full {\n      width: 100%;\n    }\n    .inline-image {\n      display: inline-flex;\n      justify-content: center;\n      align-items: center;\n      figcaption {\n        padding: 10px;\n        width: 100%;\n        text-align: center;\n      }\n    }\n  }\n\n  display: flex;\n  flex-wrap: wrap;\n  line-height: 1.5rem;\n  gap: 0 16px;\n  ul {\n    padding-top: 0;\n  }\n  svg {\n    margin: 0;\n    height: 18px;\n    vertical-align: middle;\n    transition: all 0.3s ease 0s;\n  }\n  label {\n    margin-bottom: 0;\n  }\n  .btn {\n    line-height: 1.5rem;\n    vertical-align: top;\n    margin-right: 20px;\n  }\n  .col.cell_number {\n    display: flex;\n    flex-wrap: wrap;\n    > div {\n      flex: 0 0 100%;\n      display: flex;\n    }\n  }\n  .col {\n    flex-wrap: wrap;\n    align-self: flex-start;\n    a {\n      flex: 0 0 auto;\n    }\n    &:has(.tags-selected) {\n      gap: 6px 6px;\n    }\n  }\n  &.extras {\n    .col {\n      align-items: center;\n      display: flex;\n      flex: 1 1;\n      flex-wrap: wrap;\n      min-width: 240px;\n      padding: 0;\n      gap: 6px 6px;\n      -webkit-overflow-scrolling: touch;\n      position: relative;\n      overflow: hidden;\n      box-sizing: border-box;\n      border: none;\n      @media screen and (max-width: @screen-header-collapse) {\n        flex-direction: row;\n        align-items: flex-start;\n        justify-content: flex-start;\n      }\n    }\n    .extras-legend {\n      margin-left: 3px;\n    }\n    .extras-selected {\n      background: #ffffff;\n      border-radius: 2px;\n      border: 1px solid @grey;\n      padding: 3px;\n      .extras-label {\n        padding-left: 3px;\n      }\n      @media screen and (max-width: @screen-header-collapse) {\n        flex: 0 0 100%;\n      }\n    }\n  }\n  .tags-selected {\n    display: flex;\n    align-items: center;\n    background: #ffffff;\n    border-radius: 2px;\n    border: 1px solid @grey;\n    padding: 3px;\n    line-height: 1;\n    font-size: 11px;\n    .tag-tags {\n      margin-left: 3px;\n      padding: 2px 5px;\n      border-radius: 2px;\n      background: @secondary_colour;\n      color: #ffffff;\n      font-size: 11px;\n    }\n    @media screen and (max-width: @screen-header-collapse) {\n      flex: 0 0 100%;\n    }\n  }\n  .col.tags {\n    padding-top: 2.5px;\n    padding-bottom: 0;\n    padding-right: 0;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px 6px;\n  }\n}\n\n.view {\n  .heavy {\n    text-transform: uppercase;\n    display: flex;\n    word-wrap: anywhere;\n    background: @grey_50;\n    padding: 5px 6px;\n    flex: 0 0 100%;\n    @media screen and (min-width: @screen-header-collapse) {\n      flex: 0 0 1%;\n    }\n    min-width: 190px;\n    font-size: 10px;\n    margin-bottom: auto;\n    + div {\n      display: flex;\n      padding: 5px 6px;\n      min-width: 200px;\n      overflow-wrap: anywhere;\n      &.agent {\n        margin-right: 0;\n      }\n    }\n  }\n  .dashboard-meta{\n    flex: 1 1 100%;\n    .heavy {\n      background: none;\n      padding: 0;\n      font-size: 14px;\n      color: @primary_colour;\n      font-weight: 600;\n      text-transform: none;\n      min-width: 120px;\n      + div {\n        display: inline;\n        padding: 0;\n        flex: 1 1;\n        font-size: 14px;\n        min-width: 0;\n      }\n    }\n    &.subtle-meta {\n      .heavy {\n        font-weight: 400;\n        color: @grey_500;\n        + div {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n.input-group {\n  .contact-details {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px 10px;\n    flex: 1 1;\n    &.col-auto {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 3px 0;\n      flex: 1 1;\n    }\n    .input-group {\n      gap: 6px 0;\n    }\n    &:not(.no-wrap) {\n      .meta-detail {\n        .heavy {\n          flex: 1 1 100%;\n          margin-bottom: 0;\n        }\n      }\n    }\n  }\n  .address-details {\n    display: flex;\n    justify-content: flex-end;\n    gap: 6px 20px;\n    flex: 1 1;\n  }\n}\n\n.listing-contacts-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px 10px;\n}\n\n.social-icons {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  @media screen and (min-width: @screen-header-collapse) {\n    justify-content: flex-end;\n  }\n  gap: 10px;\n  flex: 0 1;\n  min-width: 108px;\n}\n\n.dashboard-sharing {\n  .card .cardbody > .ccontent& {\n    padding-top: 0;\n  }\n  .social-icons {\n    justify-content: space-between;\n    .social-icon svg {\n      width: 40px;\n    }\n  }\n  .portals {\n    margin-top: 20px;\n  }\n}\n\n.dashboard-listing-buttons {\n  margin-top: 20px;\n  display: flex;\n  gap: 10px 10px;\n  flex-wrap: wrap;\n}\n\n.flagged-matches {\n  .datatable tbody tr:hover:not(.selected) td {\n    background: none;\n  }\n  .datatable td {\n    &:first-of-type {\n      .tablecell {\n        padding-left: 0;\n      }\n    }\n    &.column-actions > div {\n      padding-right: 0;\n    }\n  }\n  a.btn-icon-16, button.btn-icon-16, .btn-icon-16 {\n    .circle(32px);\n    min-width: 32px;\n    min-height: 32px;\n    max-width: 32px;\n    justify-content: center;\n  }\n  .has-link {\n    text-decoration: none;\n  }\n}\n\n.latest-notes-list-inner {\n  display: flex;\n  gap: 10px 10px;\n  flex-direction: column;\n}\n\n.latest-notes-note {\n  display: flex;\n  gap: 10px 10px;\n  .agent {\n    padding-top: 16px;\n    margin: 0;\n  }\n  .avatar-md > .thumbimg {\n    .circle(24px);\n  }\n  .latest-notes-summary {\n    flex: 1 1 auto;\n    background: @grey_50;\n    padding: 20px;\n    border-radius: @input-border-radius;\n  }\n  .noteauthor {\n    color: @primary_colour;\n    font-weight: 600;\n  }\n  .notes-summary-date {\n    font-size: 11px;\n    font-weight: 400;\n    color: @grey_300;\n    text-align: right;\n  }\n  .notes-summary-body {\n    margin-top: 10px;\n    margin-bottom: 0;\n    color: @grey_600;\n  }\n}\n\n.branch-tel-number {\n  margin-top: 16px;\n  font-size: 30px;\n  font-weight: 400;\n  line-height: 30px;\n  color: @primary_colour;\n  flex: 1 1 100%;\n}\n\n.single-stat{\n  svg {\n    width: 70px;\n    height: auto;\n    margin: 0 0 .5rem;\n    fill: @gray;\n  }\n  h1 {\n    color: @brand-primary;\n  }\n}\n\n.big-number{\n  font-size: 30px;\n  line-height: 1;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  flex: 1 1 100%;\n  max-height: 50px;\n  color: @primary_colour;\n  a {\n    text-decoration: none;\n  }\n}\n\n@media (max-width: @screen-header-collapse) {\n  .big-number{\n    font-size: 24px;\n  }\n}\n\n.agent-details .branchstats .details-section-heading {\n  padding: 0;\n}\n\n.listing-details {\n  .singlemeta {\n    img {\n      margin: 10px 20px 20px 0;\n      border: 4px solid #efefef;\n      border-radius: 3px;\n      width: 30%;\n      &.headline {\n        margin: 0;\n        display: block;\n      }\n    }\n    img:first-of-type {\n      width: 100%\n    }\n    img:nth-of-type(4) {\n      margin-right: 0;\n    }\n    h2 {\n      margin: 30px 0 ;\n    }\n    .description {\n      white-space: pre-line;\n      font-weight: 400;\n    }\n    .agency-details {\n      .branch {\n        margin-bottom: 20px;\n      }\n    }\n    .meta-detail span {\n      font-weight: 400;\n    }\n    .meta-detail span:first-of-type {\n      text-align: right;\n      font-weight: 600;\n      display: block;\n    }\n  }\n}\nspan.tag {\n  background-color: #efefef;\n  color: @gray-dark;\n  padding: 1px 8px;\n  border-radius: 3px;\n  font-size: 11px;\n  line-height: 1.5rem;\n  display: inline-block;\n  & + span.tag {\n    margin: 0 3px;\n  }\n  &.rounded {\n    border-radius: 60px !important;\n  }\n}\n\n.tagged {\n  .col {\n    gap: 3px 3px;\n  }\n  span.tag + span.tag {\n    margin: 0;\n  }\n}\n\n\n\n@-webkit-keyframes AnimatedLoadingGradient {\n    0%{background-position:50% 0%}\n    50%{background-position:50% 100%}\n    100%{background-position:50% 0%}\n}\n@-moz-keyframes AnimatedLoadingGradient {\n    0%{background-position:50% 0%}\n    50%{background-position:50% 100%}\n    100%{background-position:50% 0%}\n}\n@keyframes AnimatedLoadingGradient {\n    0%{background-position:50% 0%}\n    50%{background-position:50% 100%}\n    100%{background-position:50% 0%}\n}\n\n.mixed-gallery {\n  margin-bottom: 0;\n  margin-left: -15px;\n  margin-right: -15px;\n  display: flex;\n  flex-wrap: wrap;\n  h2 {\n    text-transform: capitalize\n  }\n  > div {\n    display: flex;\n    flex: 1 1 280px;\n    height: 210px;\n    max-width: 280px;\n    min-width: 280px;\n    align-items: center;\n    align-content: center;\n    overflow: hidden;\n    margin: 15px;\n    position: relative;\n    justify-content: center;\n    a {\n      position: relative;\n      display: flex;\n      align-items: center;\n      align-content: center;\n      justify-content: center;\n      max-width: 280px;\n      width: 100%;\n      overflow: hidden;\n      height: 100%;\n      background: linear-gradient(140deg, #ffffff, #dddddd);\n      background-size: 400% 400%;\n      -webkit-animation: AnimatedLoadingGradient 2s ease infinite;\n      -moz-animation: AnimatedLoadingGradient 2s ease infinite;\n      animation: AnimatedLoadingGradient 2s ease infinite;\n    }\n    .img {\n      width: 100%;\n    }\n    svg {\n      height: 64px;\n    }\n    @media screen and (max-width: @screen-header-collapse - 1) {\n      height: auto;\n      max-width: 100%;\n      a {\n        max-width: 100%;\n        height: auto;\n        img {\n          width: 100%;\n          height: auto;\n        }\n      }\n    }\n  }\n  &-caption {\n    position: absolute;\n    justify-content: center;\n    align-content: center;\n    background: fade(#000000, 70%);\n    color: #ffffff;\n    padding: 8px 12px;\n    display: flex;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    max-width: 280px;\n  }\n  img {\n    height: 210px;\n  }\n}\n.details-section{\n  margin-bottom: 20px;\n  padding: 20px;\n  .modelname {\n    display: inline-block;\n    margin-right: 20px;\n    line-height: 3rem;\n    vertical-align: middle;\n  }\n  .mediatype {\n    margin-bottom: 40px;\n  }\n  &-heading{\n    font-weight: normal;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    margin: 0;\n    .no-border &, &.no-border {\n      border-top: 0;\n      padding-top: 0;\n    }\n    &-inline {\n      display: flex;\n      flex-wrap: wrap;\n      flex: 0 0 100%;\n    }\n  }\n  &-buttons {\n    display: flex;\n    flex: 0 1 450px;\n    flex-wrap: wrap;\n    gap: 6px 6px;\n    margin-left: 10px;\n    &.min-flex {\n      flex: 0 1 100%;\n      margin-left: 0;\n      margin-right: 0;\n      > div {\n        flex: 1 1 100%;\n        margin: 0;\n      }\n    }\n    @media(min-width: @screen-header-collapse) {\n      flex: 1 1 auto;\n      justify-content: flex-end;\n      min-width: fit-content;\n      &.min-flex {\n        padding-top: 0;\n        flex: 1 1 auto;\n        > div {\n          flex: 0 1 auto;\n        }\n      }\n    }\n    margin-left: auto;\n    .btn {\n      line-height: 1.5rem;\n      vertical-align: top;\n      display: flex;\n      flex: 0 0 auto;\n      cursor: pointer;\n      justify-content: center;\n      align-self: center;\n      &:last-of-type {\n        margin-right: 0;\n      }\n      > svg {\n        height: 13px;\n        margin: 0 0.5em 0 0;\n      }\n    }\n    + form {\n      margin-top: 20px;\n      display: block;\n    }\n  }\n  &:first-of-type &-heading {\n    padding-top: 0;\n    border-top: none;\n  }\n  .para {\n    padding-bottom: 15px;\n    font-size: 1.1rem;\n    font-weight: 400;\n  }\n  &.contact, .social {\n    margin: 30px 0;\n  }\n\n  .textformat, .summary-branch_profile, .summary-description {\n    white-space: pre-line;\n    font-weight: 400;\n  }\n}\n\n.space-evenly {\n  justify-content: space-between;\n}\n\n\n.social-icon {\n  display: flex;\n  max-width: 48px;\n  max-height: 48px;\n  svg {\n    width: 48px;\n    height: 48px;\n  }\n}\n\n.image-gallery {\n  margin-bottom: 40px;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(275px, max-content));\n  justify-content: space-around;\n  gap: 15px;\n  flex-wrap: wrap;\n  &-thumb {\n    position: relative;\n    background: @grey_50;\n    padding: 15px;\n    gap: 8px;\n    .checkcontainer {\n      min-height: 24px;\n    }\n  }\n  h2 {\n    text-transform: capitalize\n  }\n  > div {\n    display: flex;\n    flex: 1 1 280px;\n    max-width: 280px;\n    min-width: 280px;\n    align-items: center;\n    align-content: center;\n    overflow: hidden;\n    position: relative;\n    justify-content: center;\n    flex-wrap: wrap;\n    a {\n      position: relative;\n      display: flex;\n      align-items: center;\n      align-content: center;\n      justify-content: center;\n      max-width: 280px;\n      overflow: hidden;\n      max-height: 210px;\n      background: linear-gradient(140deg, #ffffff, #dddddd);\n      background-size: 400% 400%;\n      -webkit-animation: AnimatedLoadingGradient 2s ease infinite;\n      -moz-animation: AnimatedLoadingGradient 2s ease infinite;\n      animation: AnimatedLoadingGradient 2s ease infinite;\n    }\n    img {\n      max-height: 100%;\n      max-width: 100%;\n      background: linear-gradient(140deg, #ffffff, #dddddd);\n      background-size: 400% 400%;\n      -webkit-animation: AnimatedLoadingGradient 2s ease infinite;\n      -moz-animation: AnimatedLoadingGradient 2s ease infinite;\n      animation: AnimatedLoadingGradient 2s ease infinite;\n    }\n  }\n  .image-gallery-thumb-meta {\n    flex: 0 0 100%;\n    gap: 10px;\n    align-items: flex-start;\n    align-content: flex-start;\n    display: flex;\n  }\n  &-caption {\n    color: @grey_400;\n  }\n}\n.documents-gallery {\n  width: 100%;\n  margin-bottom: 15px;\n  thead {\n    th {\n      color: #333333;\n      white-space: nowrap;\n      padding: 10px;\n      &:first-of-type {\n        padding-left: 0;\n      }\n    }\n  }\n  .file-item {\n    flex: 0 1 100%;\n    min-height: 44px;\n    align-items: center;\n    td {\n      border-top: 1px solid #d6d6d6;\n    }\n  }\n  .file-name {\n    padding: 10px 12px 10px 0;\n    width: 100%;\n    vertical-align: middle;\n    .btn {\n      border: 0;\n      padding: 0;\n    }\n    > div {\n      display: flex;\n      align-items: center;\n      span {\n        display: inline-block;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        max-width: calc(~'100% - 44px');\n      }\n    }\n  }\n  .file-size {\n    padding: 0 10px;\n    white-space: nowrap;\n    display: none;\n    @media(min-width: @screen-header-collapse) {\n      display: table-cell;\n    }\n  }\n  .file-type {\n    flex: 0 0 30px;\n    padding: 0 10px;\n    text-align: center;\n    display: none;\n    @media(min-width: @screen-header-collapse) {\n      display: table-cell;\n    }\n    svg {\n      height: 24px;\n    }\n  }\n}\n.toolbox {\n  div.toolgroup {\n    display: flex;\n    flex-wrap: wrap;\n    padding: 20px;\n  }\n  h4 {\n    flex: 1 0 100%;\n  }\n  div.toolcontainer {\n    margin-right: 20px;\n    margin-bottom: 10px;\n    vertical-align: top;\n    width: 100px;\n    text-align: left;\n    color: @gray;\n    .tool {\n      border-radius: 4px;\n      border: @input-border;\n      background: none;\n      display: block;\n      width: 100px;\n      height: 100px;\n      text-align: center;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: column;\n      svg {\n        height: 48px;\n        fill: @primary_colour;\n        fill-rule: evenodd;\n      }\n    }\n    a {\n      text-decoration: none;\n    }\n    a.tool:hover svg, .has-link:hover svg {\n      fill: @brand-secondary;\n    }\n    .has-link {\n      color: @brand-primary;\n      cursor: pointer;\n    }\n    span.toolcount {\n      font-size: 1.5rem;\n      color: @brand-secondary;\n      display: block;\n      font-weight: bold;\n      margin-bottom: 5px;\n      & + svg {\n        height: 34px;\n      }\n    }\n    span.toollabel {\n      display: inline-block;\n      max-width: 100%;\n      margin: 10px 0;\n      font-size: 1.1rem;\n    }\n  }\n\n}\n.publish-portals {\n  .card &.cardbody > .ccontent {\n    padding-top: 0;\n  }\n  & > .row {\n    flex: 0 0 calc(~\"100% + 30px\");\n  }\n  .column-feed_status {\n    width: 60px;\n  }\n  .column-modified {\n    width: 130px;\n  }\n  h2 {\n    padding-bottom: 10px;\n  }\n}\n.publish, .syndication {\n  .portals {\n    table.datatable {\n      tbody tr:hover td {\n        background-color: #fff;\n      }\n    }\n    .portal {\n      text-align: center;\n      border: 1px solid @grey;\n      border-radius: 3px;\n      display: inline-block;\n      width: 200px;\n      height: 100px;\n      align-items: center;\n      flex: 0 0 200px;\n      img {\n        height: 100%;\n      }\n      &.portaloff {\n        img {\n          -webkit-filter: grayscale(100%);\n          filter: grayscale(100%);\n        }\n      }\n      label {\n        display: block;\n        min-width: auto;\n      }\n    }\n    .portal-log-meta {\n      display: block;\n      padding: 15px 0;\n      & > div {\n        display: inline-block;\n        vertical-align: bottom;\n      }\n      .btn-primary.btn-primary {\n        display: inline-block !important;\n      }\n      button {\n        svg {\n          height: 11px;\n          margin-top: -2px;\n          margin-right: 8px !important;\n        }\n      }\n    }\n  }\n  .portal-col {\n    display: flex;\n    flex-wrap: wrap;\n    flex: 0 0 1%;\n    gap: 15px;\n    &.spacer {\n      margin-bottom: 0;\n    }\n    .row {\n      flex-wrap: auto;\n    }\n    .portal-fields {\n      flex: 1 1 100%;\n      min-height: 48px;\n    }\n    .meta-detail {\n      flex: 1 1 100%;\n      display: flex;\n      align-items: center;\n      margin-bottom: auto;\n      gap: 0;\n      svg {\n        height: 24px;\n        stroke: @primary_colour;\n        stroke-width: @svg-24-stroke-width;\n      }\n      .portal-field-value {\n        flex: 0 0 20px;\n      }\n      .portal-field-label {\n        flex: 1 1 auto;\n      }\n    }\n  }\n}\n\n.flex-full {\n  flex-basis: 100% !important;\n}\n\n.syndication .portals > div {\n  justify-content: center;\n  align-items: top;\n}\n\n.portal-settings {\n  .cardbody {\n    .form-group {\n      display: flex;\n      align-items: center;\n      .portallogo {\n        .portal {\n          text-align: center;\n          border: 1px solid #ccc;\n          border-radius: 3px;\n          padding: 10px 5px;\n          display: inline-block;\n          min-width: 250px;\n          max-width: 250px;\n          min-height: 250px;\n          margin: 15px 15px 15px 15px;\n          max-height: 250px;\n          align-items: center;\n          &.portaloff {\n            img {\n              -webkit-filter: grayscale(100%);\n              filter: grayscale(100%);\n            }\n          }\n          img {\n            width: 220px;\n          }\n        }\n        button.btn {\n          display: block;\n          margin: 0 auto;\n        }\n      }\n    }\n    table.datatable {\n      tr:hover td {\n        background-color: #fff;\n      }\n      td {\n        width: 25%;\n        border: none;\n        overflow: visible;\n        .tablecell {\n          overflow: visible;\n        }\n      }\n      td:last-of-type {\n        text-align: center;\n      }\n    }\n\n  }\n}\n\n.by-key(@array, @key, @fallback...) {\n    .-(length(@array));\n    .-(@i) when (@i > 0) {.-((@i - 1))}\n    .-(@i) when (@key = extract(extract(@array, @i), 1)) {\n        @by-key: extract(extract(@array, @i), 2);\n    }\n\n    .--() {@by-key: @fallback} .--;\n}\n\n.bar-graph {\n  .card .cardbody &.ccontent {\n    padding: 40px 20px 0;\n    @media screen and (min-width: @screen-header-collapse) {\n      padding: 0 20px;\n    }\n  }\n  .recharts-default-legend {\n    .recharts-legend-item {\n      margin: 0;\n      padding-bottom: 14px;\n    }\n  }\n}\n.stacked-legend-percentage {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n  color: @grey_500;\n}\n\n.recharts-default-tooltip {\n  margin: 0px;\n  padding: 10px;\n  background-color: rgb(255, 255, 255);\n  border: 0 none !important;\n  border-radius: @card-radius;\n  box-shadow: @card-shadow;\n  white-space: nowrap;\n}\n.piechart-columns {\n  margin-top: -30px;\n  .piechart-column {\n    margin-top: 30px;\n    .pie-chart {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      .stacked-legend {\n        max-width: calc(100% - 250px);\n        min-width: 250px;\n        flex-direction: column;\n        li {\n          min-width: 100%;\n          @media screen and (min-width: @screen-header-collapse) {\n            min-width: 0;\n          }\n        }\n      }\n    }\n  }\n}\n.stacked-legend {\n  ul {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px 20px;\n    .recharts-legend-item {\n      list-style: none;\n      margin: 0;\n    }\n  }\n}\n.matches-listing {\n  overflow: hidden;\n}\n.tablecell {\n  .indicator {\n    height: 16px;\n    width: 16px;\n    stroke-width: @svg-16-stroke-width;\n    stroke: @success;\n    fill: none;\n    margin-right: 5px;\n  }\n  .whatsapp-tel-link {\n    .whatsapp-link {\n      svg {\n        stroke: @text;\n        stroke-width: @svg-16-stroke-width;\n      }\n      .has-link()\n    }\n  }\n}\n.matches-listing-details {\n  display: flex;\n  gap: 16px 16px;\n  .matches-listing-image {\n    flex: 1 1 100;\n    height: 144px;\n    border-radius: @card-radius;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-size: cover;\n    @media screen and (min-width: @screen-header-collapse) {\n      flex: 0 0 208px;\n    }\n  }\n  .matches-listing-meta {\n    flex: 1 1 100;\n    height: 144px;\n    border-radius: @card-radius;\n    overflow: hidden;\n    display: flex;\n    flex-wrap: wrap;\n    background: @grey_50;\n    padding: 15px;\n    @media screen and (min-width: @screen-header-collapse) {\n      flex: 0 0 334px;\n    }\n    .matches-listing-type {\n      margin-left: auto;\n      flex: 0 0 auto;\n      color: @grey_200;\n    }\n    .matches-listing-price {\n      margin-left: auto;\n      flex: 0 0 100%;\n      font-size: 24px;\n      font-weight: 500;\n      color: @primary_colour;\n    }\n    .matches-listing-address {\n      margin-left: auto;\n      flex: 0 0 100%;\n      font-size: 16px;\n      color: @primary_colour;\n    }\n  }\n  .matches-listing-map {\n    flex: 1 1 100;\n    height: 144px;\n    border-radius: @card-radius;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    position: relative;\n    align-items: center;\n    @media screen and (min-width: @screen-header-collapse) {\n      flex: 1 1 auto;\n    }\n    img {\n      object-fit: cover;\n      min-width: 100%\n    }\n  }\n}\n\n\n.dashboard-listing-details {\n  display: flex;\n  width: 100%;\n  flex: 1 1 100%;\n  width: 100%;\n  height: 100%;\n  min-height: 350px;\n  background-size: cover;\n  border-radius: @card-radius;\n  justify-content: center;\n  align-items: center;\n  border-radius: @card-radius;\n  overflow: hidden;\n  > img {\n    width: 100%;\n    height: 350px;\n    @media screen and (min-width: @screen-header-collapse) {\n      height: 469px;\n    }\n    object-fit: cover;\n  }\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 64.06%, #000000 100%);\n    border-radius: @card-radius;\n  }\n  .dashboard-listing-buttons {\n    position: absolute;\n    display: flex;\n    top: 20px;\n    right: 20px;\n    gap: 10px 10px;\n    .btn {\n      color: @primary_colour;\n      font-weight: 600;\n    }\n  }\n  .dashboard-listing-meta {\n    flex: 1 1 100;\n    border-radius: @card-radius;\n    overflow: hidden;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    flex-wrap: wrap;\n    padding: 15px;\n    gap: 10px 0;\n    color: #ffffff;\n    @media screen and (min-width: @screen-header-collapse) {\n      flex: 0 0 334px;\n    }\n    .dashboard-listing-type {\n      margin-left: auto;\n      flex: 0 0 auto;\n      color: #ffffff;\n    }\n    .dashboard-listing-price {\n      margin-left: auto;\n      flex: 0 0 100%;\n      font-size: 18px;\n      font-weight: 600;\n      color: #ffffff;\n    }\n    .dashboard-listing-address {\n      margin-left: auto;\n      flex: 0 0 100%;\n      font-size: 14px;\n      line-height: 21px;\n      color: #ffffff;\n    }\n  }\n}\n\n.listing-contacts-item {\n  display: flex;\n  min-height: 48px;\n  height: auto;\n  gap: 15px 15px;\n  .listing-contacts-details {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n  }\n  .listing-contacts-name {\n    font-size: 14px;\n    line-height: 1.5;\n    flex: 1 1 100%;\n    margin: 0;\n    a {\n      text-decoration: none;\n    }\n  }\n  .listing-contacts-meta {\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n    gap: 0 10px;\n    svg {\n      width: 24px;\n      stroke: @grey_200;\n      stroke-width: @svg-24-stroke-width;\n    }\n    a {\n      text-decoration: none;\n    }\n  }\n}\n\n.listing-brochure-mini {\n  width: calc(100% - 40px);\n  max-width: 203px;\n  max-height: 260px;\n  box-shadow: 4px 4px 0 0 @grey;\n  position: relative;\n  .listing-brochure-mini-container {\n    width: 100%;\n    padding-bottom: 141.42%;\n  }\n  .listing-brochure-mini-image {\n    height: 60%;\n    width: 100%;\n    max-width: 203px;\n    position: absolute;\n    object-fit: cover;\n    img {\n      height: 100%;\n      width: 100%;\n      object-fit: cover;\n    }\n  }\n  .listing-brochure-mini-logo {\n    position: absolute;\n    bottom: 15px;\n    left: 15px;\n    max-width: 50%;\n    object-fit: cover;\n    img {\n      width: 100%;\n    }\n  }\n  & + h3 {\n    display: flex;\n    flex: 0 0 100%;\n    justify-content: center;\n  }\n}\n\n.marker-dot {\n  .circle(18px);\n  background: fade(@secondary_colour, 70%);\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  box-shadow: 0 0 0 25px fade(@secondary_colour, 20%);\n}\n\n.btmatches {\n  .table-header {\n    padding: 10px 0 20px;\n  }\n  .btm-summary {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    .btm-legend {\n      font-weight: 600;\n      display: flex;\n      align-items: center;\n      justify-content: left;\n      text-align: center;\n      color: #333;\n      max-width: 100%;\n      flex-wrap: wrap;\n      .heavy {\n        text-align: right;\n        min-width: 0;\n      }\n      div {\n        padding: 0 10px;\n        white-space: nowrap;\n        div {\n          display: inline-block;\n        }\n      }\n      svg {\n        height: 35px;\n        display: block;\n      }\n    }\n    @media screen and (max-width: @screen-header-collapse - 1px) {\n      justify-content: start;\n      .btm-legend {\n        > div:first-of-type {\n          padding: 0;\n        }\n        > div:nth-child(2) {\n          > div:first-of-type {\n            padding-left: 0;\n          }\n        }\n        > div:first-of-type, > div:nth-child(2) {\n          padding-left: 0;\n        }\n        .heavy {\n          min-width: 190px;\n          text-align: left;\n        }\n      }\n    }\n  }\n  .listbody {\n    position: relative;\n  }\n  .datatable {\n    thead {\n      td, th {\n        padding: 12px 8px;\n        &.column-rating {\n          padding: 8px;\n        }\n      }\n    }\n    .loader.inline { // hack to get loader to fill space\n      position: relative;\n      visibility: hidden;\n    }\n  }\n  .loader.inline { // position loader in container, not table\n    position: absolute;\n    bottom: 5px;\n    margin: 10px auto;\n    border-width: 4px;\n    width: 40px;\n    height: 40px;\n    left: 50%;\n    margin-left: -20px;\n    z-index: auto;\n  }\n}\n\n.listing-leads {\n  .datatable td {\n    &:last-of-type {\n      text-align: center;\n    }\n    button {\n      background-color: transparent;\n      &:hover {\n        cursor: pointer;\n      }\n    }\n  }\n}\n\nsvg.btmstar {\n  width: 24px;\n  tbody & {\n    width: 16px;\n  }\n  &.smaller {\n    width: 12px;\n  }\n  &.hot {\n    --color4: #CF0000;\n  }\n  &.warm {\n    --color4: #F7CA34;\n  }\n  &.cold {\n    --color4: #0073B7;\n  }\n}\n\n.contact-compliance {\n  .datatable {\n    td, th {\n      &:first-of-type {\n        width: auto;\n      }\n    }\n  }\n  .btn-primary {\n    margin-bottom: 2rem;\n  }\n}\n\n.model-details .stepper .card .cardbody > .ccontent {\n  padding-top: 20px;\n}\n\n.stepper {\n  .pagestep {\n    flex: 1 1;\n  }\n  .card {\n    margin-bottom: 0;\n  }\n  .model-details & .card {\n    margin-bottom: 20px;\n  }\n}\n\n.google-map {\n  margin-top: 15px;\n  margin-bottom: 30px;\n  width: 100%;\n  height: calc(~\"75vw - 110px\");\n  max-height: 400px;\n  position: relative;\n  svg {\n    path {\n      fill: @brand-primary\n    }\n  }\n}\n\n.notes-form{\n  padding-bottom: 20px;\n  textarea.form-control {\n    min-height: 150px;\n  }\n  .loader + .btn {\n    margin-left: 10px;\n  }\n  svg {\n    height: 16px;\n  }\n  .btn-primary.btn-primary {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1.1rem;\n    svg {\n      height: 18px;\n    }\n  }\n  .note-original{\n    padding: 0 15px;\n    font-size: 1.1rem;\n    p {\n      font-size: inherit;\n    }\n  }\n}\n\n.profile-listing-model {\n  .inline-select {\n    margin: 0;\n  }\n  .form-group .forminput .input-group-addon {\n    padding-left: 15px;\n  }\n}\n\n.referrals .meta-detail .referral-contact {\n  display: flex;\n  .referral-contact-icon {\n    display: flex;\n    align-items: center;\n    margin-right: 5px;\n    width: 16px;\n    height: 16px;\n    .circle(16px);\n    background: @error;\n    &.match {\n        background: @success;\n    }\n    svg {\n      fill: none;\n      stroke: #ffffff;\n      stroke-width: @svg-16-stroke-width;\n      width: 16px;\n      height: 16px !important;\n    }\n  }\n}\n\n.contacts {\n  flex: 1 1 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  .col {\n    flex: 0 0 1%;\n    &.associated_agents {\n      flex: 1 1 1%;\n    }\n    .meta-detail {\n      flex-wrap: nowrap;\n      .heavy {\n        flex: 1 1 160px;\n        min-width: 160px;\n        white-space: nowrap;\n      }\n    }\n  }\n}\n@media (max-width: @screen-header-collapse) {\n  .agents {\n    display: flex;\n  }\n  .contacts {\n    .col {\n      .meta-detail {\n        flex-wrap: wrap;\n      }\n    }\n  }\n}\n\n.meta-detail .microsite.has-link {\n  display: inline-block;\n  padding-left: 10px;\n}\n\n.meta-label {\n  font-weight: bold;\n  color: @gray-dark;\n  max-width: 85px;\n  a& {\n    color: @gray-dark;\n  }\n}\n\n.listing-contacts {\n  display: flex;\n  flex-wrap: wrap;\n  .row {\n    min-width: calc(100% + 30px);\n  }\n  .listing-contacts-details {\n    flex: 1 1 auto;\n    .listing-contacts-meta .row {\n      margin-top: 15px;\n    }\n  }\n  .avatar {\n    margin-right: 20px;\n    width: 100px;\n    height: 100px;\n    .thumbimg {\n      width: 100px;\n      height: 100px;\n      background-size: cover;\n      svg {\n        width: 100px;\n        height: 100px;\n      }\n    }\n  }\n}\n\n.section-underline {\n  margin: 15px 0 0;\n  line-height: 1;\n  .row + & {\n    margin-top: 0;\n  }\n  &:after {\n    content:\"\";\n    display: inline-block;\n    position: relative;\n    width: 100%;\n    vertical-align: bottom;\n    height: 1px;\n    background: @gray-light;\n  }\n}\n\n.contact-cards {\n  display: grid;\n  @media screen and (min-width: @screen-header-collapse) {\n    grid-template-columns: repeat(auto-fit, 320px);\n  }\n  gap: 16px 16px;\n  .tc-tooltip-content & {\n    padding: 12px;\n    font-size: 12px;\n  }\n  .card {\n    margin-bottom: 0;\n    max-width: 400px;\n  }\n  .listing-contacts-card {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px 0;\n    a, button {\n      text-decoration: none;\n    }\n    .avatar {\n      width: 96px;\n      height: 96px;\n      order: -1;\n      .thumbimg {\n        .circle(96px);\n      }\n    }\n    .listing-contacts-details {\n      display: flex;\n      flex: 0 0 100%;\n      flex-wrap: wrap;\n    }\n    .listing-contacts-label {\n      color: @grey_200;\n      text-transform: uppercase;\n      flex: 0 0 100%;\n    }\n    .listing-contacts-name {\n      margin-top: 0;\n      flex: 0 0 100%;\n    }\n    .listing-contacts-status {\n      display: flex;\n      align-items: center;\n      gap: 0 5px;\n      padding: 0 8px;\n      height: 21px;\n      border-radius: 12px;\n      background: @error_10;\n      color: @error;\n      font-size: 14px;\n      &:before {\n        content: \"\";\n        .circle(6px);\n        background: @error;\n        display: block;\n      }\n      &.active {\n        background: @success_10;\n        color: @success;\n        &:before {\n          content: \"\";\n          .circle(6px);\n          background: @success;\n          display: block;\n        }\n      }\n      flex: 0 0 auto;\n\n    }\n    .listing-contacts-meta {\n      margin-top: 15px;\n      flex: 0 0 100%;\n      display: flex;\n      flex-wrap: wrap;\n      gap: 7px 0;\n      div {\n        flex: 0 0 100%;\n        display: flex;\n        align-items: center;\n        gap: 0 15px;\n        align-items: center;\n      }\n      svg {\n        width: 24px;\n        stroke: @primary_colour;\n        stroke-width: @svg-24-stroke-width;\n      }\n    }\n    @media screen and (min-width: @screen-header-collapse) {\n      flex-wrap: nowrap;\n      .listing-contacts-details {\n        flex: 1 1 100%;\n      }\n      .avatar {\n        position: absolute;\n        top: 20px;\n        right: 20px;\n        margin-left: auto;\n        order: 1\n      }\n    }\n  }\n}\n\n.input-group.publish-group {\n  gap: 7px 20px;\n  .heavy {\n    min-width: 220px\n  }\n}\n\n.player-container {\n  width: 100%;\n  max-width: 480px;\n  padding: 15px 0;\n}\n.player-wrapper {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  padding-top: 56.25%;\n}\n\n.react-player {\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.notes-search {\n  display: flex;\n  padding: 0 20px;\n}\n.notes-stream {\n  padding: 20px;\n  .notes-stream-content {\n    margin-left: -15px;\n    margin-right: -15px;\n  }\n  .notes-stream-event {\n    border-top: 5px solid #cccccc;\n    padding: 30px 15px;\n  }\n  .notes-stream-event-card  {\n    &-header {\n      font-size: 1rem;\n      display: flex;\n      align-items: center;\n      strong{\n        color: #000000;\n        margin-right: 5px;\n      }\n      .btn {\n        margin-left: auto;\n      }\n    }\n    &-body {\n      font-size: 1.1rem;\n      p {\n        font-size: inherit;\n      }\n    }\n    .note-actions {\n      margin-top: 20px;\n      display: flex;\n      justify-content: flex-end;\n      .agents {\n        margin-right: auto;\n        display: flex;\n      }\n      .thumb.small {\n        width: 40px;\n        height: 40px;\n        .thumbimg {\n          width: 40px;\n          height: 40px;\n        }\n      }\n    }\n    .note-comments {\n      .notes-stream-event {\n        margin-top: 15px;\n        border: 1px solid #cccccc;\n        border-radius: 4px;\n        padding: 15px;\n      }\n    }\n  }\n}\n.user-resume {\n  margin-top: 20px;\n}\n\n.activity {\n  display: grid;\n  grid-template-areas: \"search\" \"timeline\";\n  grid-template-columns: 1fr;\n  grid-template-rows: min-content min-content;\n  min-height: 0;\n  min-width: 0;\n  @media screen and (min-width: @screen-header-collapse) {\n    grid-template-areas: \"timeline search\";\n    grid-template-columns: 1fr 355px;\n    grid-template-rows: 1fr;\n  }\n  > .form {\n    min-height: 0;\n    min-width: 0;\n    flex-wrap: wrap;\n    grid-area: search;\n    display: grid;\n    padding: 20px;\n    @media screen and (min-width: @screen-header-collapse) {\n      padding: 0;\n      padding-right: 20px;\n    }\n    > div {\n      min-width: 0;\n    }\n    .editgroup {\n      > .input-group {\n        flex: 1 1 100%;\n        background: #ffffff;\n        padding: 10px;\n        border-radius: @card-radius;\n      }\n    }\n    .activity-search {\n      .field:first-child {\n        flex: 1 1;\n        .form-group.search {\n          max-width: none;\n        }\n        .form-group.dateinput {\n          max-width: none;\n          .forminput {\n            padding-bottom: 2px;\n          }\n          .flatpickr-calendar {\n            box-shadow: none;\n            border: 0 none;\n          }\n          .flatpickr-innerContainer {\n            border: 0 none;\n          }\n          .flatpickr-months {\n            padding-bottom: 5px;\n          }\n        }\n      }\n      #keyword-search-btn {\n        margin-left: 10px;\n        padding: 0 9px;\n      }\n      #field-search {\n        flex-wrap: nowrap;\n        .forminput {\n          flex: 1 1 100%;\n        }\n      }\n      .flatpickr-wrapper > .flatpickr-calendar.inline {\n        margin: 0 auto;\n      }\n    }\n  }\n  > div {\n    grid-area: timeline;\n    min-height: 0;\n    min-width: 0;\n    overflow: auto;\n  }\n  .list-actions {\n    padding-left: 50px\n  }\n  .thumb.small, .thumb.small .thumbimg {\n    .circle(32px);\n    width: 32px;\n    height: 32px;\n  }\n}\n\n.viewing-feedback-graph {\n  .customized-legend {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: auto;\n    min-width: 150px;\n    gap: 8px;\n    .legend-count {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-size: 46px;\n      line-height: 1;\n    }\n    .legend-total {\n      flex: 0 0;\n      justify-content: center;\n      align-items: center;\n      margin-bottom: 0;\n    }\n  }\n}\n\n.marketing-email-pie-graph {\n  .legend-label {\n    font-weight: 500;\n  }\n  .legend-count {\n    font-weight: 600;\n    color: #222222;\n  }\n}\n\n.viewing-feedback-card {\n  div {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    gap: 10px 10px;\n  }\n  span {\n    font-size: 34px;\n    color: @primary_colour;\n  }\n  svg {\n    width: 56px;\n    stroke: @primary_colour;\n    fill: none;\n  }\n}\n\n.column-metaviewingfeedback {\n  width: 50%;\n}\n\n.column-metaviewingviewing_date{\n  width: 100px;\n}\n\n.col.stage {\n  .lead-stage {\n    background: none;\n    padding: 0;\n    color: inherit;\n    text-decoration: inherit;\n  }\n}\n\n.grid-container.grid-5 .grid-col-1.flex-stats {\n  align-content: center;\n  .flex-container {\n    gap: 20px 20px;\n    justify-content: center;\n    align-items: center;\n  }\n  .stat-count {\n    display: flex;\n    flex-wrap: nowrap;\n    justify-content: center;\n    align-items: center;\n    font-size: 42px;\n    color: @primary_colour;\n  }\n  .stat-heading {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    align-content: center;\n    align-items: center;\n    text-align: center;\n    font-size: 16px;\n    color: @grey_500;\n  }\n}\n\n.image-gallery-thumb-img-size {\n  position: absolute;\n  background: #ffffff;\n  color: rgba(0, 0, 0, 0.7);\n  font-family: 'Poppins';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 12px;\n  padding: 8px 12px;\n  display: flex;\n  border-radius: 18px;\n  right: 0;\n  top: 0px;\n  margin: 19px;\n  z-index: 1;\n}\n#social-Whatsapp path {\n  fill: rgba(0, 0, 0, 0.7)\n}\n\n.whatsapp-tel-link {\n  display: flex;\n  align-items: center;\n  gap: 0px 5px;\n}\n\n.whatsapp-link {\n  a&, button& {\n    display: flex;\n    align-items: center;\n    background: none;\n    border: 0 none;\n    padding: 0;\n    margin: 0;\n    cursor: pointer;\n  }\n  .has-link {\n    display: flex;\n    align-items: center;\n    background: none;\n    border: 0 none;\n    padding: 0;\n    margin: 0;\n    cursor: pointer;\n  }\n  svg {\n    width: 16px;\n    fill: none;\n    stroke: @text;\n    stroke-width: @svg-16-stroke-width;\n  }\n}\n\n.referral-response-outcome {\n  width: 100%;\n  .radiogroup .radioinput {\n    margin-top: 10px;\n  }\n}\n\n.flow-placeholder {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px 10px;\n  &-text {\n    flex: 0 0 100%;\n    text-align: center;\n    font-size: 14px;\n    line-height: 21px;\n    span {\n      color: @primary_colour;\n    }\n  }\n  .btn {\n    font-size: 14px;\n  }\n}\n\n.social-performance-filters {\n  .filter-overlay-ga {\n    .form-group.checkinput .forminput .checkcontainer + label {\n      min-width: auto;\n      margin-right: 12px;\n    }\n  }\n}\n\n.social-performance-widget {\n  .flex-container {\n    gap: 10px;\n  }\n  .customized-legend {\n    width: 100%;\n    gap: 10px 30px;\n    font-size: 11px;\n    padding-bottom: 0;\n    .legend-item {\n      flex: 0 0 auto;\n      height: auto;\n      cursor: pointer;\n    }\n    .powered-by {\n      white-space: nowrap;\n      display: flex;\n      align-items: center;\n      align-content: center;\n      margin-left: auto;\n      svg {\n        display: inline;\n        width: 46px;\n        flex: 0 0 46px;\n        margin-left: 10px;\n      }\n    }\n  }\n}\n\n.deal-columns {\n  .grid-container {\n    border-bottom: 1px solid @grey;\n  }\n  .deal-columns--label {\n    color: @grey_400;\n    align-self: center;\n    padding: 3px 0;\n    strong {\n      color: @primary_colour;\n    }\n  }\n  .deal-columns--value {\n    align-self: center;\n    padding: 3px 0;\n    justify-self: flex-end;\n    text-align: right;\n    &.large {\n      color: @primary_colour;\n      font-size: 18px;\n      font-weight: 600;\n    }\n  }\n}\n\n.commission-block {\n  padding: 20px;\n  background: @grey_50;\n  > div {\n    display: flex;\n    justify-content: space-between;\n  }\n}\n\n.commission-save {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.report-group {\n  display: flex;\n  flex-direction: column;\n  margin-top: 16px;\n  .report-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    color: @primary_colour;\n    background: @grey_50;\n    padding: 10px 16px;\n    font-size: 16px;\n    line-height: 24px;\n    span {\n      color: @grey_400;\n      font-size: 12px;\n    }\n  }\n  .report-list {\n    margin: 0;\n    dd, dt {\n      margin: 0;\n      padding: 6px 15px;\n      color: @grey_700;\n      font-size: 12px;\n      font-weight: 500;\n    }\n    dt {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n    }\n    dd {\n      background: @grey_25;\n    }\n  }\n}\n\n.tab-availability {\n  .card {\n    margin-bottom: 0;\n  }\n}","// main: ../framework.less\n\n#make-form-grid-columns(@columns: @grid-columns, @gutter: @grid-gutter-width, @breakpoints: @grid-breakpoints) {\n  // Common properties for all breakpoints\n  // LESS PORT: Unfortunately we have to use an actual selector here in order to be able to\n  // `:extend()` it later. This means that the selector is output in the compiled CSS, creating a\n  // small disparity between the Less and Sass versions.\n\n  #each-breakpoint-column(@i: 1) when (@i <=length(@breakpoints)) {\n    @breakpoint: extract(extract(@breakpoints, @i), 1);\n    @infix: breakpoint-infix(@breakpoint, @breakpoints);\n\n    // Allow columns to stretch full width below their breakpoints\n    #each-column(@ii: 1) when (@ii <=@columns) {\n      .col@{infix}-@{ii} {\n        &:extend(.form-grid-column);\n      }\n\n      #each-column((@ii + 1));\n    }\n\n    #each-column();\n\n    .col@{infix},\n    .col@{infix}-auto {\n      &:extend(.form-grid-column);\n    }\n\n    #media-breakpoint-up(@breakpoint, {\n\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col@{infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      .col@{infix}-auto {\n        flex: 0 0 auto;\n        width: auto;\n        max-width: none; // Reset earlier grid tiers\n      }\n\n      #each-column-col(@iii: 1) when (@iii <=@columns) {\n        .col@{infix}-@{iii} {\n          #make-col-form(@iii, @columns);\n        }\n\n        #each-column-col((@iii + 1));\n      }\n\n      #each-column-col();\n\n      .order@{infix}-first {\n        order: -1;\n      }\n\n      .order@{infix}-last {\n        order: (@columns + 1);\n      }\n\n      #each-column-order(@iii: 0) when (@iii <=@columns) {\n        .order@{infix}-@{iii} {\n          order: @iii;\n        }\n\n        #each-column-order((@iii + 1));\n      }\n\n      #each-column-order();\n\n      // `@iii < @columns` because offsetting by the width of an entire row isn't possible\n      #each-column-offset(@iii: 0) when (@iii < @columns) {\n\n        & when not (@iii =0),\n        (@iii =0) and not (@infix =~\"\") {\n          .offset@{infix}-@{iii} {\n            #make-col-offset(@iii, @columns);\n          }\n        }\n\n        #each-column-offset((@iii + 1));\n      }\n\n      #each-column-offset();\n    });\n\n  #each-breakpoint-column((@i + 1));\n}\n\n#each-breakpoint-column();\n}\n\n#make-col-form(@size, @columns: @grid-columns) {\n  @remainder: @columns - @size * @size;\n  @fract: ceil((@columns / @size));\n  @multiplier: (@fract - 1);\n  @margin: (20px * (@size / @columns) * @multiplier);\n  flex: 0 1 calc(percentage((@size / @columns)));\n\n  & when not (@size =12) {\n    flex: 0 1 calc(percentage((@size / @columns)) - min(@margin));\n  }\n\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage((@size / @columns));\n}\n\n// remove browser styles\ninput:invalid {\n  border: none;\n  box-shadow: none !important;\n}\n\n.editgroup {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 1 1 auto;\n  gap: 27px 0;\n}\n\n\n.form-control {\n  .form-control();\n  flex: 1 1 auto;\n  font-size: 14px;\n  line-height: 21px;\n  min-height: 34px;\n  padding: 6px 15px;\n  border: none;\n  outline: none;\n  color: @grey_500;\n  background: transparent;\n\n  &::placeholder {\n    color: @grey_300;\n    font-size: 14px;\n    line-height: 21px;\n    opacity: 1;\n  }\n\n  &:disabled,\n  &[readonly] {\n    background-color: transparent;\n    color: @grey_400;\n    opacity: 1;\n  }\n\n  &:hover {\n    border: none;\n  }\n\n  &:focus,\n  &:focus-within {\n    color: @grey_500;\n    border: none;\n    box-shadow: none;\n  }\n\n  textarea& {\n    line-height: 18px;\n    min-height: 14px * 8;\n    color: #444;\n    background: none;\n\n    &:focus {\n      background: none;\n    }\n  }\n\n  &.domstring {\n    white-space: pre-wrap;\n  }\n\n  &+.tip:not(:first-of-type) {\n    margin-top: 10px;\n\n    &+.tip {\n      margin-bottom: 0;\n    }\n  }\n\n  &.google-map {\n    padding: 0;\n    margin: 0;\n    min-height: 420px;\n    margin-bottom: 104px;\n\n    .map-search,\n    .map-buttons {\n      font-family: @font-family;\n      font-size: 12px;\n    }\n\n    .map-search {\n      box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;\n      margin: 10px;\n      background: @white;\n      max-width: 300px;\n      width: calc(100vw - 100px);\n      border-radius: 2px;\n\n      .react-select__menu {\n        font-size: 10px;\n      }\n    }\n\n    .map-buttons {\n      margin: 10px 0;\n      display: flex;\n      gap: 10px 10px;\n    }\n  }\n\n  &.sortable-text {\n    margin-bottom: 5px;\n\n    input {\n      border: 0;\n      height: 100%;\n    }\n  }\n}\n\n.fieldarray-label {\n  margin-bottom: 10px;\n}\n\n.fieldarray,\n.sortabletextinput,\n.fieldlist {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 27px 20px;\n\n  &:not(.fieldlist) fieldset {\n    flex: 0 0 100%;\n\n    +fieldset {\n      padding-top: 27px;\n    }\n\n    >.input-group {\n      flex: 1 1 100%;\n    }\n  }\n\n  .arrayaction {\n    display: flex;\n    gap: 27px 20px;\n  }\n\n  &#field-portals {\n    fieldset+fieldset {\n      box-shadow: 0px -5px 0px #E5EBF1;\n    }\n  }\n\n  &.fieldarray {\n    >.input-group>.input-group>.input-group {\n      flex: 1 1 100%;\n    }\n\n    .btn-drag {\n      flex: 0 0 0;\n      max-height: 34px;\n      border: 0 !important;\n      outline: 0 !important;\n      box-shadow: none !important;\n      cursor: row-resize;\n\n      ~.input-group {\n        flex: 1 1 calc(100% - 40px);\n      }\n    }\n\n    .dz-handle {\n      max-width: 12px;\n      margin: 0;\n    }\n  }\n}\n\n.listings-lookup {\n  .listings-items {\n    margin-bottom: 20px;\n  }\n\n  .listing-lookup-listing-item {\n    width: 100%;\n    display: flex;\n    line-height: 20px;\n    padding-bottom: 10px;\n\n    .listing-item-price {\n      font-weight: 800;\n      color: #000;\n      min-width: 80px;\n\n      p {\n        color: @grey_400;\n        text-transform: uppercase;\n        margin: 0px;\n      }\n    }\n\n    .listing-item-remove {\n      padding-left: 5px;\n    }\n  }\n}\n\n.form-group {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-bottom: 0;\n  position: relative;\n  flex: 0 0 100%;\n\n  @media screen and (min-width: @screen-header-collapse) {\n    flex: 1 1 auto;\n\n    &.country-code-phone {\n      .input-group {\n        flex-wrap: nowrap;\n      }\n    }\n  }\n\n  &.urltemplate .selectinput {\n    margin-top: 10px;\n  }\n\n  &.notesinput {\n    margin-top: 10px;\n  }\n\n  &.rtl textarea {\n    text-align: right;\n  }\n\n  &.translatabletextareainput {\n    .input-group {\n      &+.input-group {\n        margin-top: 20px;\n      }\n\n      +.arrayaction {\n        display: flex;\n        flex-wrap: wrap;\n        flex: 0 0 100%;\n\n        .input-group {\n          display: flex;\n          flex-wrap: wrap;\n\n          .arrayaction-button {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 20px 20px;\n          }\n        }\n      }\n    }\n  }\n\n  .disabled & {\n    cursor: not-allowed;\n\n    .form-control {\n      color: @grey_400;\n    }\n\n    .input-label {\n      color: @grey_300;\n    }\n  }\n\n  &:not(.checkinput) .forminput {\n    display: flex;\n\n    &:not(.input-only) {\n      flex: 0 0 100%;\n      border-radius: @input-border-radius;\n      border: @input-border-default;\n\n      &:hover {\n        border: @input-border-hover;\n      }\n\n      &:focus,\n      &:focus-within {\n        box-shadow: @input-focus-shadow;\n      }\n    }\n\n    &::placeholder {\n      color: @grey_300;\n      opacity: 1;\n    }\n  }\n\n  .required:not(:has(.required)) &:not(.not-required):not(.checkinput) .forminput {\n    &:before {\n      content: \"\";\n      min-width: 6px;\n      margin: 3px 0 3px 3px;\n      border-radius: 2px 0 0 2px;\n      background: @required-border;\n    }\n\n    .form-control,\n    .react-select .react-select__control {\n      padding-left: 6px;\n    }\n  }\n\n  .quality &:not(.not-required):not(.checkinput) .forminput {\n    &:before {\n      content: \"\";\n      min-width: 6px;\n      margin: 3px 0 3px 3px;\n      border-radius: 2px 0 0 2px;\n      background: @quality-border;\n    }\n\n    .form-control,\n    .react-select .react-select__control {\n      padding-left: 6px;\n    }\n  }\n\n  &.code-input {\n    .formlabel {\n      position: relative;\n      top: unset;\n      left: unset;\n      margin-left: 10px;\n    }\n  }\n\n  &.checkinput {\n    flex-wrap: nowrap;\n\n    .formlabel {\n      font-size: unset;\n      line-height: unset;\n      font-weight: unset;\n      position: unset;\n      padding: unset;\n      display: unset;\n      height: unset;\n      min-height: unset;\n      background: unset;\n      color: unset;\n      top: unset;\n      left: unset;\n      margin: 0;\n      margin-left: 10px;\n      color: @primary_colour;\n    }\n\n    .search-fields & {\n      min-width: 0;\n    }\n\n    .forminput {\n      display: flex;\n      flex-wrap: nowrap;\n      align-items: center;\n\n      .checkcontainer {\n        flex: 0 0 auto;\n\n        +label {\n          max-width: calc(100vw - 182px);\n          white-space: normal;\n          flex: 1;\n          text-align: left;\n\n          @media screen and (min-width: @screen-header-collapse) {\n            min-width: 220px;\n\n            .search-fields & {\n              min-width: 0;\n            }\n          }\n        }\n      }\n\n      .input-group-addon {\n        &.btn {\n          padding: 6px 15px;\n          border-radius: @input-border-radius;\n        }\n      }\n    }\n  }\n\n  &.previewinput {\n    flex-wrap: wrap;\n    flex: 0 0 150px;\n    max-width: 150px;\n\n    @media screen and (min-width: @screen-header-collapse) {\n      justify-content: center;\n    }\n\n    .single-user {\n      max-width: 150px;\n      max-height: 150px;\n    }\n\n    .thumb {\n      background: none;\n\n      .thumbimg {\n        display: flex;\n        align-items: center;\n        border: 1px dashed @grey_200;\n        justify-content: center;\n        background: none;\n\n        svg {\n          vertical-align: middle;\n          width: 68px;\n          height: 68px;\n          fill: none;\n          stroke: @grey_200;\n          stroke-width: 0.6;\n        }\n\n        &[style] {\n          border: none;\n\n          svg {\n            display: none;\n          }\n        }\n      }\n\n      &:hover {\n        box-shadow: none;\n\n        .thumbimg {\n          transform: scale(1) translateZ(1000px);\n        }\n      }\n    }\n\n    label {\n      display: flex;\n      justify-content: center;\n      margin-top: 10px;\n      stroke: @grey_400;\n      flex: 0 0 100%;\n    }\n  }\n\n  &.uom {\n    & .forminput:after {\n      justify-content: center;\n      .input-group-addon();\n      padding-right: 13px;\n      font-weight: 600;\n      color: @primary_colour;\n    }\n\n    &.seconds .forminput:after {\n      content: \"sec\";\n    }\n\n    &.metres .forminput:after {\n      content: \"m\";\n    }\n\n    &.squaremetres .forminput:after {\n      content: \"m\\00B2\";\n    }\n\n    &.squarefeet .forminput:after {\n      content: \"ft\\00B2\";\n    }\n\n    &.acres .forminput:after {\n      content: \"ac\";\n    }\n\n    &.hectares .forminput:after {\n      content: \"ha\";\n    }\n\n    &.percentage .forminput:after {\n      content: \"%\";\n    }\n\n    &.per {\n      &.squaremetres .forminput:after {\n        content: \"per m\\00B2\";\n      }\n\n      &.squarefeet .forminput:after {\n        content: \"per ft\\00B2\";\n      }\n    }\n\n    &.loadingcapacity .forminput:after {\n      content: \"tn/m\\00B2\";\n    }\n\n    input.form-control {\n      padding-right: 40px;\n    }\n  }\n\n  &.recipient-lookup {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  &.contact-lookup {\n    &.bulk {\n      display: flex;\n      justify-content: space-between;\n    }\n\n    .recipients {\n      display: flex;\n      justify-content: flex-end;\n      width: 100%;\n      line-height: 16px;\n\n      >div {\n        display: flex;\n        align-items: center;\n\n        svg {\n          fill: none;\n          stroke: @grey_900;\n          width: 16px;\n          height: 16px !important;\n        }\n      }\n\n      padding: 20px 0px 0px;\n    }\n\n    .form-contact-card {\n      border: @input-border-default;\n      border-radius: @input-border-radius;\n      padding: 15px;\n      display: flex;\n      flex-wrap: wrap;\n      gap: 2px 0;\n\n      .contact-card-details {\n        flex: 0 0 100%;\n        display: grid;\n        grid-template-columns: 1fr 2fr;\n        gap: 0 10px;\n      }\n\n      .meta-detail {\n        .heavy {\n          min-width: 45%;\n\n          +div {\n            min-width: 45%;\n            max-width: calc(100vw - 110px);\n            flex: 1 1 45%;\n            white-space: nowrap;\n            display: block;\n            overflow: hidden;\n            text-overflow: ellipsis;\n          }\n        }\n      }\n\n      .arrayaction {\n        display: flex;\n        margin-top: 15px;\n      }\n\n      &-empty {\n        .arrayaction {\n          display: flex;\n          margin-top: auto;\n        }\n      }\n    }\n\n    .arrayaction {\n      flex: 1 1 100%;\n      gap: 10px 20px;\n      display: flex;\n      flex-wrap: wrap;\n    }\n  }\n\n  &.on_show {\n    .forminput {\n      flex-wrap: wrap;\n    }\n\n    .onshowhistory {\n      flex: 1 1 100%;\n    }\n  }\n\n  &.on_show_events {\n    gap: 27px 20px;\n\n    .arrayaction {\n      display: flex;\n      flex: 1 1 100%;\n      gap: 10px 20px;\n      flex-wrap: wrap;\n    }\n\n    fieldset {\n      display: flex;\n      flex-direction: column;\n      box-shadow: 0px 5px 0px #E5EBF1;\n      padding-bottom: 20px;\n    }\n  }\n\n  &.size_breakdowns {\n    gap: 27px 20px;\n\n    .arrayaction {\n      display: flex;\n      flex: 1 1 100%;\n      gap: 10px 20px;\n      flex-wrap: wrap;\n    }\n\n    fieldset {\n      display: flex;\n      flex-wrap: wrap;\n\n      >.btn {\n        flex: 0 0;\n        max-height: none;\n        min-width: 24px;\n        justify-content: center;\n      }\n\n      >.input-group {\n        flex: 1 1;\n      }\n\n      .section-heading {\n        display: flex;\n        align-items: center;\n\n        h4 {\n          margin: 0;\n        }\n      }\n    }\n\n    .breakdown-totals {\n      display: flex;\n\n      >.btn {\n        flex: 0 0;\n        max-height: none;\n        min-width: 24px;\n        justify-content: center;\n      }\n\n      >.input-group {\n        flex: 1 1;\n        gap: 0px 20px;\n      }\n\n      .breakdown-total {\n        color: @grey_300;\n        padding: 6px 15px;\n      }\n    }\n\n    .arrayaction {\n      >.btn {\n        max-height: none;\n        min-width: 24px;\n        justify-content: center;\n      }\n\n      >.input-group {\n        flex: 1 1;\n      }\n\n      @media screen and (min-width: @screen-header-collapse) {\n        .arrayaction-button {\n          margin-left: -44px;\n          margin-right: 44px;\n        }\n      }\n    }\n  }\n\n  .input-label {\n    font-size: 11px;\n    line-height: 16.5px;\n    font-weight: 600;\n    position: absolute;\n    padding: 0 5px;\n    display: block;\n    height: auto;\n    min-height: auto;\n    background: @white;\n    color: @grey_700;\n    top: -8px;\n    left: 10px;\n    margin: auto;\n    white-space: nowrap;\n    max-width: calc(100% - 10px);\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .error {\n    font-size: 11px;\n    line-height: 16.5px;\n    font-weight: 600;\n    position: absolute;\n    padding: 0 5px;\n    display: block;\n    height: auto;\n    min-height: auto;\n    background: @white;\n    top: -8px;\n    right: 10px;\n    margin: auto;\n    color: @error;\n  }\n\n  &.textnotes .error,\n  &.selectnotes .error {\n    right: 80px;\n  }\n\n  .form-control-info {\n    flex: 1 1 100%;\n    display: block;\n    padding: 4px 15px;\n    color: @grey_300;\n    font-size: 9px;\n  }\n\n  .forminput {\n    flex: 1 1 auto;\n\n    .input-group-addon {\n      .input-group-addon();\n    }\n\n    .input-group-suffix {\n      .input-group-suffix();\n    }\n\n    .input-group-prefix {\n      .input-group-prefix();\n    }\n  }\n\n  #country_code {\n    min-width: 145px;\n  }\n\n  &.has-copy-link {\n    margin-top: 30px;\n\n    .btn {\n      order: 0;\n      flex: 0 0 0%;\n      width: 0;\n      overflow: visible;\n      position: relative;\n      margin-bottom: auto;\n      margin-top: -50px;\n      left: 0;\n      padding: 0;\n      text-decoration: underline;\n\n      &:hover,\n      &:focus,\n      &:active {\n        box-shadow: none;\n      }\n    }\n\n    label {\n      order: 1;\n    }\n\n    .required & {\n      .btn {\n        left: -10px;\n      }\n    }\n  }\n\n  &.bordered {\n    border-top: 4px solid @grey;\n    padding-top: 27px;\n    flex: 0 0 calc(~\"100% + 30px\");\n  }\n}\n\n.ratio-group {\n  .col-lg-2 {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.section-heading {\n  &.bordered {\n    border-top: 4px solid @grey;\n    flex: 0 0 calc(~\"100% + 30px\");\n\n    .section-heading-content {\n      padding-top: 27px;\n    }\n  }\n}\n\n.sortabletextinput:not(.checkinput) {\n  .arrayaction {\n    margin-top: -10px;\n    align-self: flex-end;\n    margin-left: auto;\n\n    .btn {\n      border-top-left-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n  }\n\n  .sortable-text-list {\n    flex: 0 0 100%;\n\n    .forminput {\n      flex-wrap: wrap;\n      flex: 0 0 100%;\n      gap: 5px 0;\n      padding-top: 10px;\n    }\n\n    .sortable-text {\n      width: 100%;\n      flex: 1 1 100%;\n      margin: 0 5px;\n      border: @input-border-default;\n      display: flex;\n      align-items: center;\n\n      &[style^=\"left\"],\n      &[style*=\"left\"] {\n        background: @grey;\n        transition: none;\n        box-shadow: 0px 2px 4px #C5CFDC;\n      }\n\n      input {\n        width: 100%;\n        background: none;\n      }\n\n      .btn {\n        padding: 0;\n        min-height: 0;\n      }\n\n      &:last-of-type {\n        margin-bottom: 5px;\n      }\n    }\n  }\n}\n\n.input-group-addon {\n  min-width: 36px;\n  display: flex;\n  align-items: center;\n  width: auto;\n  padding: 0;\n  flex: 0 0 auto;\n\n  &.btn {\n    justify-content: center;\n  }\n\n  .btn-none {\n    &:focus {\n      outline: none;\n    }\n  }\n\n  &:not(.btn-icon-16) {\n    svg {\n      width: 24px;\n      height: 24px;\n      stroke-width: @svg-24-stroke-width;\n    }\n  }\n}\n\n.input-group-suffix {\n  border-right: 0;\n  padding-right: 0;\n  border-radius: @input-border-radius 0 0 @input-border-radius;\n\n  &~.input-group-addon {\n    min-width: 36px;\n    border-left: 1px solid transparent;\n    border-radius: 0;\n    font-weight: 600;\n\n    &.btn {\n      justify-content: center;\n\n      &.btn-grey {\n        padding-left: 15px;\n        padding-right: 15px;\n      }\n    }\n\n    svg {\n      stroke: @primary_colour;\n    }\n  }\n}\n\n.input-group-prefix {\n  border-left: 0;\n  padding-left: 0;\n  border-radius: 0 @input-border-radius @input-border-radius 0;\n\n  &:not(.input-group-suffix) {\n    order: 1;\n  }\n\n  &+.input-group-addon {\n    border-left: 0;\n    order: 0;\n    font-weight: 600;\n    border-radius: 0;\n    padding: 0;\n\n    svg {\n      stroke: @primary_colour;\n    }\n  }\n}\n\n#profile-picture, #signature-picture {\n  .editgroup {\n    justify-content: center;\n\n    .input-group {\n      @media screen and (min-width: @screen-header-collapse) {\n        flex: 0 0 auto;\n        flex-wrap: nowrap;\n        justify-content: space-between;\n\n        .field {\n          max-width: none;\n          flex: 1 1 auto;\n        }\n      }\n    }\n  }\n}\n\n.input-group {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 0 0 100%;\n  gap: 27px 20px;\n\n  >* {\n    flex: 1 1 100%;\n\n    @media screen and (min-width: @screen-header-collapse) {\n      flex: auto;\n    }\n  }\n\n  #make-form-grid-columns(@columns: 12, @gutter: 20px, @grid-breakpoints);\n\n  [class^=\"col-\"],\n  [class*=\"col-\"] {\n    padding: 0;\n  }\n\n  .field:not([class^=\"col-\"]):not([class*=\"col-\"]):not(td) {\n    display: inherit;\n    flex-wrap: wrap;\n    flex: 1 1 auto;\n    gap: 16px 20px;\n\n    .tip:not(:first-of-type) {\n      flex: 0 0 100%;\n      margin-top: 10px;\n      margin-bottom: 0;\n    }\n  }\n\n  td.field {\n    padding: 0;\n\n    .form-control {\n      min-height: 30px;\n      padding: 6px 8px;\n      font-size: 12px;\n      line-height: 1.125;\n    }\n\n    .form-group .forminput .input-group-addon {\n      min-width: 30px;\n      min-height: 30px;\n    }\n  }\n\n  .field {\n    .tip:not(:first-of-type) {\n      margin-top: 10px;\n\n      &+.tip {\n        margin-bottom: 0;\n      }\n    }\n\n    .tip:first-of-type {\n      margin-bottom: 10px;\n    }\n\n    &.disabled .forminput {\n      color: @grey_600;\n      opacity: 1;\n    }\n\n    .clevercompose-field {\n      margin-top: 10px;\n    }\n  }\n\n  .submit-button {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px 10px;\n  }\n\n  &.keyword-search {\n    gap: 0 10px;\n\n    @media screen and (min-width: @screen-header-collapse) {\n      flex: 1 1 auto;\n\n      >div {\n        flex: 0 0 auto;\n      }\n\n      .form-group.term {\n        flex: 0 0 300px;\n        width: 205px;\n        max-width: 205px;\n      }\n    }\n  }\n\n  &.advanced-search {\n    @media screen and (min-width: @screen-header-collapse) {\n      flex: 0 1 auto;\n    }\n  }\n\n}\n\n// .field:last-child {\n//   // Hack for select inputs before the map-element falling behind map inputs\n//   [for=\"location\"] + .forminput {\n//     position: relative;\n//     z-index: 2;\n//   }\n// }\n\n// .form-control {\n//   .form-control();\n//   font-size: 1.1rem;\n//   color: #222;\n//   flex: 1 1 100%;\n//   min-height: 36px;\n//   border: @input-border;\n//   &::placeholder {\n//     color: @grey_300;\n//     opacity: 1 !important;\n//   }\n//   &:focus {\n//     box-shadow: none;\n//     border-color: @input-border-color-focus;\n//     .submitting {\n//       border-color: @input-border-color;\n//     }\n//   }\n//   &:invalid {\n//     border: @input-border;\n//   }\n// }\n\n/* Create a custom radio */\n.radiocontainer {\n  display: flex;\n  position: relative;\n  margin: 0;\n  gap: 8px 8px;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  min-height: 25px;\n  line-height: 25px;\n  font-size: 14px;\n\n  input {\n    position: absolute;\n    z-index: 10;\n    opacity: 0;\n    cursor: pointer;\n    left: 0;\n    height: 24px;\n    width: 24px;\n  }\n\n  .radio {\n    flex: 0 0 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 24px;\n    width: 24px;\n    background-color: #fff;\n    box-shadow: inset 0 0 0 1px @grey;\n    border-radius: 50%;\n    order: -1;\n\n    &:after {\n      content: \"\";\n      display: none;\n    }\n  }\n\n  &:hover input~.radio {\n    box-shadow: inset 0 0 0 1px @grey_200;\n  }\n\n  input:checked~.radio:after {\n    display: block;\n    background-color: @primary_colour;\n  }\n\n  .radio:after {\n    width: 12px;\n    height: 12px;\n    border-radius: 50%;\n    background: white;\n  }\n}\n\n// .checkinput {\n//   vertical-align: middle;\n//   > label {\n//     margin: 0;\n//   }\n\n//   .cardbody &.form-group + .tip {\n//     flex-wrap: wrap;\n//     padding-left: 20px;\n//     flex: 1 1 100%;\n//     .tiptext {\n//       white-space: nowrap;\n//       padding-left: 0;\n//     }\n//   }\n//   @media screen and (min-width: @screen-header-collapse) {\n//     .cardbody &.form-group .form-input {\n//       flex-wrap: nowrap;\n//     }\n//     .cardbody &.form-group + .tip {\n//       flex-wrap: nowrap;\n//       padding-left: 6px;\n//       flex: 1 1 auto;\n//       .tiptext {\n//         white-space: nowrap;\n//         padding-left: 10px;\n//       }\n//     }\n//   }\n// }\n\n.onshowhistory {\n  flex-basis: 100%;\n\n  table.on_show_history {\n    margin-top: 10px;\n    min-width: 280px;\n  }\n}\n\n\n/* The switch - the box around the slider */\n.switch {\n  position: relative;\n  display: flex;\n  min-width: 60px;\n\n  input {\n    position: absolute;\n    opacity: 0;\n    width: 1px;\n    height: 1px;\n  }\n}\n\n/* The slider */\n.slider {\n  cursor: pointer;\n  display: flex;\n  width: 60px;\n  height: 34px;\n  background-color: @grey_200;\n  padding: 4px;\n  align-items: center;\n\n  .onoff {\n    height: 26px;\n    width: 26px;\n    background-color: white;\n    border-radius: 50%;\n  }\n\n  &.round {\n    border-radius: 34px;\n  }\n}\n\ninput:checked+.slider {\n  background-color: @primary_colour;\n\n  span.onoff {\n    left: 14px;\n  }\n}\n\ninput:focus+.slider {\n  box-shadow: @input-focus-shadow;\n}\n\ninput:checked+.slider .onoff {\n  transform: translateX(26px);\n}\n\ninput:disabled+.slider {\n  background-color: @grey;\n  cursor: not-allowed;\n\n  .onoff {\n    transform: translateX(14px);\n  }\n}\n\n// /* Create a custom checkbox */\n\n.checkgroup {\n  font-size: 1.1rem;\n  display: flex;\n  align-items: center;\n\n  label:nth-of-type(2) {\n    margin-left: 10px;\n  }\n}\n\n.checkcontainer {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  max-width: 100%;\n  min-height: 36px;\n  width: 36px;\n  height: 36px;\n  align-items: center;\n  cursor: pointer;\n  margin: 0;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  justify-content: center;\n\n  &.input-group-suffix {\n    flex: 1 1 auto;\n  }\n\n  /* Hide the browser's default checkbox */\n  input {\n    position: absolute;\n    left: 0;\n    opacity: 0;\n    cursor: pointer;\n  }\n\n  &.readonly span {\n    pointer-events: none;\n    cursor: not-allowed;\n    background-color: @grey;\n  }\n\n  &:focus,\n  &:focus-within {\n    .checkmark {\n      box-shadow: @input-focus-shadow;\n    }\n  }\n\n  /* On mouse-over, add a grey background color */\n  input:disabled~.checkmark,\n  input:checked:disabled~.checkmark {\n    background-color: @grey;\n  }\n\n  &:hover input:disabled~.checkmark {\n    cursor: not-allowed;\n  }\n\n  /* Show the checkmark when checked */\n  input:checked~.checkmark {\n    background: @primary_colour;\n    border-color: transparent;\n  }\n\n  /* Style the checkmark/indicator */\n  .checkmark svg {\n    stroke: @white;\n    fill: none;\n    width: 22px;\n    height: 22px;\n    stroke-width: @svg-16-stroke-width;\n  }\n}\n\n.checkmark {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  height: 24px;\n  width: 24px;\n  border-radius: @input-border-radius;\n  border: @input-border-default;\n  background: #ffffff;\n}\n\n.checkmark:hover {\n  border: @input-border-hover;\n}\n\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n.selected .checkcontainer .checkmark {\n  border: 1px solid #fff;\n}\n\n\n.selected .checkcontainer .checkmark:after {\n  content: \"\";\n  border: solid #fff;\n  border-width: 0 2px 2px 0;\n  margin-top: -7px;\n  height: 11px;\n}\n\n.asynccheckgroup-filter-buttons {\n  margin-bottom: 15px;\n}\n\n\n.dz-thumb-caption.linked_plan .react-select__single-value {\n  color: @gray-light;\n}\n\n// Simple Select\n.react-select {\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  font-size: 14px;\n\n  &__control {\n    align-items: center;\n    background-color: transparent;\n    border-radius: 3px;\n    border-style: solid;\n    box-shadow: none;\n    cursor: default;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    min-height: 34px;\n    outline: 0 !important;\n    position: relative;\n    box-sizing: border-box;\n    border: none;\n    padding-left: 14px;\n\n    &--is-focused {\n      border-color: @grey; // some focus-styling here\n\n      &+.react-select__menu {\n        border-color: @grey;\n      }\n    }\n  }\n\n  & .react-select__dropdown-indicator {\n    border: 0 !important;\n\n    svg {\n      fill: none;\n      stroke: @primary_colour;\n      stroke-width: @svg-24-stroke-width;\n      width: 24px;\n      height: 24px;\n    }\n\n    ;\n  }\n\n  &.top &__control--menu-is-open {\n    border-top-left-radius: @border-radius;\n    border-top-right-radius: @border-radius;\n    border-top: 0 none;\n\n    & .react-select__dropdown-indicator {\n      border-right: 1px solid @input-border-color-focus;\n    }\n  }\n\n  &__value-container {\n    align-items: center;\n    display: inline-grid;\n    flex: 1 1 0%;\n    padding: 0;\n    gap: 2px 4px;\n    font-size: inherit;\n    line-height: 1;\n    -webkit-overflow-scrolling: touch;\n    position: relative;\n    overflow: hidden;\n    box-sizing: border-box;\n    border: none;\n\n    [class^=\"-Input\"],\n    [class*=\"-Input\"] {\n      margin: 0;\n      padding: 0;\n    }\n\n    &--has-value {\n      display: flex;\n    }\n\n    &--is-multi {\n      padding: 6px 0 2px 0;\n      flex-wrap: wrap;\n      padding: 6px 0;\n    }\n  }\n\n  .inline-select & &__value-container {\n    gap: 0 0;\n  }\n\n  [class^=\"-A11yText\"],\n  [class*=\"-A11yText\"] {\n    z-index: 9999;\n    border: 0;\n    clip: rect(1px, 1px, 1px, 1px);\n    height: 1px;\n    width: 1px;\n    position: absolute;\n    overflow: hidden;\n    padding: 0;\n    white-space: nowrap;\n  }\n\n  &__menu {\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%) translateZ(10px);\n    min-width: 200px;\n    background-color: hsl(0, 0%, 100%);\n    border-radius: 4px;\n    box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1);\n    margin-bottom: 8px;\n    margin-top: 8px;\n    position: absolute;\n    width: 100%;\n    z-index: 1;\n    box-sizing: border-box;\n\n    .asynccheckgroup & {\n      top: 0;\n      position: relative;\n      border: 0;\n      box-shadow: none;\n      margin: 0;\n      margin-top: 10px;\n      padding-top: 0;\n      background: none;\n      z-index: 0;\n    }\n  }\n\n  &__single-value {\n    color: @grey_600;\n    font-size: 14px;\n    line-height: 21px;\n    top: unset;\n    margin: 0 1px;\n    transform: none;\n    align-self: center;\n    position: relative;\n    grid-area: 1 / 1 / 2 / 3;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    &--is-disabled {\n      color: @grey_300;\n    }\n  }\n\n  &__multi-value {\n    background: @grey;\n    border: 1px solid @grey;\n    display: flex;\n    margin: 0;\n    border-radius: 2px;\n    padding: 2px 3px 2px 6px;\n  }\n\n  &__multi-value__label {\n    color: @grey_700;\n    display: flex;\n    align-items: center;\n    font-size: 11px;\n    font-weight: 500;\n\n    .dependentselectinput & {\n      padding: 2px 6px;\n    }\n  }\n\n  &__multi-value__remove {\n    cursor: pointer;\n    padding: 0;\n    display: flex;\n    flex: 0 0 1%;\n    align-items: center;\n    background: none;\n\n    svg {\n      width: 16px;\n      fill: none;\n      stroke: @grey_400;\n      stroke-width: @svg-16-stroke-width;\n    }\n  }\n\n  &__multi-value__remove:hover {\n    background: none;\n\n    svg {\n      fill: none;\n      stroke: @grey_700;\n    }\n  }\n\n  &__placeholder {\n    color: @grey_300;\n    opacity: 1;\n    margin-left: 2px;\n    margin-right: 2px;\n    box-sizing: border-box;\n    grid-area: 1 / 1 / 2 / 2;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n\n    &+div {\n      margin: 0;\n      padding-bottom: 0;\n      padding-top: 0;\n      visibility: visible;\n      box-sizing: border-box;\n    }\n  }\n\n  &__indicators {\n    align-items: center;\n    align-self: stretch;\n    display: flex;\n    flex-shrink: 0;\n    box-sizing: border-box;\n    padding: 0;\n    transition: color 150ms ease 0s;\n  }\n\n  &__indicator {\n    display: flex;\n    cursor: pointer;\n    padding: 0 7px;\n    transition: color 150ms;\n    box-sizing: border-box;\n\n    &.react-select__clear-indicator {\n      padding: 0;\n\n      svg {\n        width: 16px;\n        fill: none;\n        stroke: @primary_colour;\n        stroke-width: @svg-16-stroke-width;\n      }\n    }\n  }\n\n  &__input-container {\n    visibility: visible;\n    flex: 1 1 auto;\n    display: inline-grid;\n    grid-area: 1 / 1 / 2 / 3;\n    grid-template-columns: 0px min-content;\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n\n    &:after {\n      content: attr(data-value) \" \";\n      visibility: hidden;\n      white-space: pre;\n      grid-area: 1/2;\n      font: inherit;\n      min-width: 2px;\n      border: 0;\n      margin: 0;\n      outline: 0;\n      padding: 0;\n    }\n  }\n\n  &__input {\n    color: inherit;\n    background: 0px center;\n    opacity: 1;\n    width: 100%;\n    grid-area: 1 / 2;\n    font: inherit;\n    min-width: 2px;\n    border: 0px none;\n    margin: 0px;\n    outline: 0px;\n    padding: 0px;\n  }\n\n  &__menu {\n    border-radius: @input-border-radius;\n    box-shadow: 1px 1px 4px -2px rgba(0, 0, 0, 0.2);\n    border: 1px solid @grey;\n    overflow: hidden;\n  }\n\n  &.top &__menu {\n    border-top: 1px solid @input-border-color-focus;\n    top: auto;\n    bottom: 100%;\n    box-shadow: 0px -3px 5px -1px rgba(0, 0, 0, 0.2);\n    margin-top: 0;\n    border-top: 0 none;\n    z-index: 950;\n  }\n\n  // .required &__menu {\n  //   border-left: 3px solid @required-border;\n  // }\n  &__menu-list {\n    max-height: 300px;\n    overflow-y: auto;\n    padding-bottom: 4px;\n    padding-top: 4px;\n    position: relative;\n    -webkit-overflow-scrolling: touch;\n    box-sizing: border-box;\n  }\n\n  // .required &__menu-list {\n  //   border-left: 1px solid @required-border;\n  // }\n  &__option {\n    background-color: none;\n    color: @grey_700;\n    cursor: default;\n    display: block;\n    font-size: inherit;\n    padding: 7.5px 15px;\n    width: 100%;\n    user-select: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    box-sizing: border-box;\n\n    &--is-focused,\n    &:hover {\n      background-color: @grey_50;\n    }\n\n    .asynccheckgroup & {\n\n      &--is-focused,\n      &:hover {\n        background-color: inherit;\n      }\n    }\n\n    &--is-selected {\n      background-color: @grey;\n      color: @grey_700;\n\n      .asynccheckgroup & {\n        background: none;\n        color: @grey_700;\n      }\n    }\n\n    &--is-disabled {\n      background-color: @grey_50;\n      color: @grey_300;\n\n      .asynccheckgroup & {\n        background: none;\n        color: @grey_700;\n      }\n    }\n\n    .customopt {\n      display: flex;\n      flex-wrap: wrap;\n\n      img {\n        flex: 0 0 50px;\n        height: 50px;\n        width: 50px;\n        display: inline-block;\n        border-radius: 100px;\n        margin-right: 10px;\n        border: none;\n        background-color: #efefef;\n      }\n\n      >div {\n        flex: 1 1 auto;\n        vertical-align: middle;\n        line-height: 21px;\n\n        &.select-tags {\n          flex: 0 0 auto;\n\n          .select-tag {\n            background: @secondary_colour;\n            color: @white;\n            font-size: 11px;\n            padding: 4px 6px;\n            border-radius: 2px;\n            text-transform: uppercase;\n\n            &.Active {\n              background: @success;\n            }\n\n            &.Inactive {\n              background: @error;\n            }\n          }\n        }\n      }\n\n      span.sub {\n        display: block;\n        font-size: 11px;\n        line-height: 16.5px;\n        color: @grey_400;\n      }\n\n      .asynccheckgroup & {\n        box-shadow: 0px 1px 0px #E5EBF1;\n        padding-top: 8px;\n        padding-bottom: 8px;\n\n        &:last-of-type {\n          box-shadow: none;\n        }\n\n        .checkcontainer {\n          min-height: 24px;\n        }\n\n        .domstring {\n          margin-left: 15px;\n        }\n      }\n    }\n  }\n\n  &__menu-notice--no-options {\n    background-color: none;\n    color: @grey_700;\n    cursor: default;\n    display: block;\n    font-size: inherit;\n    padding: 7.5px 15px;\n    width: 100%;\n    user-select: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    box-sizing: border-box;\n  }\n\n  &__menu-notice--loading {\n    background-color: none;\n    color: @grey_700;\n    cursor: default;\n    display: block;\n    font-size: inherit;\n    padding: 7.5px 15px;\n    width: 100%;\n    user-select: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    box-sizing: border-box;\n  }\n\n  &__group-heading {\n    background-color: @grey_50;\n    color: @grey_400;\n    text-align: center;\n    margin: 1px 15px;\n    cursor: default;\n    display: block;\n    font-size: 11px;\n    padding: 3px 6px;\n    font-weight: 600;\n    user-select: none;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    box-sizing: border-box;\n    text-transform: none;\n\n    .customopt {\n      padding-left: 12px;\n\n      img {\n        height: 50px;\n        width: 50px;\n        display: inline-block;\n        border-radius: 100px;\n        margin-right: 10px;\n        border: none;\n        background-color: #efefef;\n      }\n\n      >div {\n        display: inline-block;\n        vertical-align: middle;\n      }\n\n      span.sub {\n        display: block;\n        font-size: 1rem;\n        color: #aaa;\n      }\n    }\n  }\n\n  &__indicator-separator {\n    display: none;\n  }\n}\n\n// /* Dropzone and uploads */\n.dz-handle {\n  display: inline-block;\n  width: 10px;\n  height: 5px;\n  vertical-align: middle;\n  margin-right: 10px;\n  border-top: 1px solid @gray;\n  cursor: row-resize;\n  border-bottom: 1px solid @gray;\n}\n\n.mg-collative-img-size {\n  flex: 1 1 100%;\n  width: 100%;\n  font-weight: 400;\n  font-style: normal;\n  display: flex;\n  align-items: center;\n}\n\n.dz-buttons-above {\n  display: flex;\n  padding: 0;\n  left: 600px;\n  gap: 10px 0px;\n}\n\n\n.dz-container-above {\n  margin-top: 15px;\n  display: flex;\n  flex: 1 1 100%;\n  align-items: center;\n  align-content: center;\n  justify-content: space-between;\n\n  button {\n    margin-right: 3px;\n  }\n}\n\n.dz-actions {\n  label.checkcontainer {\n    span.checkmark {\n      width: 34px;\n      height: 35px;\n\n      svg {\n        width: 31px;\n        height: 31px;\n      }\n    }\n  }\n}\n\n.dropzoneinput {\n  display: flex;\n  margin-bottom: 5px;\n\n  .filehead {\n    width: 0;\n    height: 1.1rem;\n    background-color: @secondary_colour;\n    border-radius: @input-border-radius;\n    font-size: 1.1rem;\n    padding: 0;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    z-index: 3;\n    white-space: nowrap;\n    transition: background-color 2.5s ease, width 0.5s ease;\n  }\n\n  .dropzone {\n    display: flex;\n    flex: 1 1 100%;\n\n    &.mini-dropzone {\n      order: 2;\n      position: relative;\n\n      .btn {\n        padding: 6px 15px;\n\n        input {\n          position: absolute;\n          width: 100%;\n          height: 100%;\n          top: 0;\n          left: 0;\n        }\n\n        svg {\n          height: 24px;\n        }\n      }\n\n      .dz-dropper {\n        min-height: 0;\n        height: auto;\n        width: auto;\n        border: none;\n        justify-content: flex-start;\n\n        &.dz-dropper--isActive {\n          flex: 1 1 100%;\n        }\n      }\n    }\n\n    .dz-dropper {\n      width: 100%;\n      border: 1px dashed @grey;\n      min-height: 250px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .dz-message {\n      text-align: center;\n      display: flex;\n      align-items: center;\n      align-content: center;\n      justify-content: center;\n      flex-wrap: wrap;\n      gap: 20px 0;\n\n      >p {\n        flex: 0 0 100%;\n      }\n\n      svg {\n        height: 36px;\n      }\n\n      .dz-icons {\n        flex: 0 0 100%;\n      }\n    }\n\n    .btn {\n      padding: 8px 12px;\n    }\n\n    p {\n      color: @grey_400;\n      font-size: 1.1rem;\n      font-weight: normal;\n      text-align: center;\n      margin: 0;\n      display: none;\n\n      @media screen and (min-width: @screen-header-collapse) {\n        display: block;\n      }\n    }\n  }\n\n  .dz-list {\n    display: flex;\n    flex-wrap: wrap;\n    min-width: calc(~\"100% + 30px\");\n    justify-content: flex-start;\n    align-items: flex-start;\n    justify-content: space-around;\n    margin-left: -15px;\n    margin-right: -15px;\n\n    * {\n      touch-action: none;\n    }\n\n    &.mini-items {\n      display: flex;\n      gap: 10px;\n      order: 1;\n      margin-left: 0;\n      margin-right: 0;\n      min-width: 0;\n\n      .formlabel {\n        flex: 0 0 100%;\n      }\n\n      .dz-item {\n        height: 72px;\n        min-width: 72px;\n        flex: 0 0 auto;\n        margin: 0 0 45px;\n\n        .dz-actions {\n          display: flex;\n          flex: 0 0 72px;\n          max-height: 30px;\n          justify-content: center;\n        }\n\n        button.btn.btn-none {\n          margin: 0 3px;\n\n          svg {\n            fill: @gray-dark;\n          }\n        }\n\n        .dz-thumb {\n          height: 72px;\n          max-height: 72px;\n\n          &:hover {\n            cursor: default;\n\n            &[style] {\n              cursor: move;\n            }\n          }\n\n          .dz-thumb-img {\n            height: 72px;\n\n            img {\n              height: auto;\n              max-height: 100%;\n              max-width: 100%;\n            }\n\n            &.icon {\n              width: 100%;\n              border: @input-border;\n              border-radius: @border-radius;\n              background: #ffffff;\n\n              svg {\n                width: 54px;\n                height: 54px;\n              }\n            }\n          }\n        }\n\n        .dz-thumb-caption {\n          position: relative;\n          align-self: flex-end;\n          padding: 4px 6px;\n          font-size: 0.8rem;\n          white-space: nowrap;\n        }\n      }\n    }\n  }\n\n  &.dropzone-single .dz-list {\n    justify-content: center;\n  }\n\n  .table-wrapper {\n    width: 100%;\n    max-width: calc(100vw - 80px);\n    overflow: auto;\n\n  }\n\n  .dz-file-list {\n    width: 100%;\n    margin-top: 15px;\n    margin-bottom: 15px;\n\n    thead {\n      th {\n        color: #333333;\n        white-space: nowrap;\n        padding: 10px;\n      }\n    }\n  }\n\n  .dz-file-item {\n    flex: 0 1 100%;\n    min-height: 44px;\n    align-items: center;\n    border-top: 1px solid #d6d6d6;\n  }\n\n  tr.dz-file-item {\n    box-shadow: 0px 1px 0px #E5EBF1;\n  }\n\n  .dz-file-handle {\n    padding: 10px 0;\n    vertical-align: middle;\n    table-layout: fixed;\n\n    .dz-handle {\n      margin-top: -5px;\n    }\n  }\n\n  .dz-edit-file-name {\n    display: none;\n    min-height: 0;\n    padding: 0;\n  }\n\n  &:hover {\n    .dz-edit-file-name {\n      display: inline-block;\n\n      svg {\n        stroke-width: 2.4;\n        stroke: @grey_400;\n      }\n    }\n  }\n\n  .dz-file-name {\n    padding: 10px 12px;\n    width: 100%;\n    vertical-align: middle;\n\n    >div {\n      display: flex;\n      align-items: center;\n\n      .btn {\n        margin-left: 10px;\n      }\n    }\n  }\n\n  .dz-file-size {\n    padding: 0 10px;\n    white-space: nowrap;\n  }\n\n  .dz-file-type {\n    flex: 0 0 30px;\n    padding: 0 10px;\n    text-align: center;\n\n    svg {\n      height: 24px;\n    }\n  }\n\n  td.dz-file-actions,\n  th.dz-file-actions {\n    white-space: nowrap;\n\n    .btn-none {\n      border: 0;\n      display: inline-flex;\n      padding: 7.5px;\n    }\n  }\n\n  .dz-item {\n    display: flex;\n    flex-direction: column;\n    flex: 0 0 100%;\n    max-width: calc(100vw - 82px);\n    margin: 15px;\n\n    @media screen and (min-width: @screen-header-collapse) {\n      flex: 0 0 320px;\n      max-width: 320px;\n    }\n\n    .loader.inline {\n      // position: absolute;\n      justify-self: center;\n      align-self: center;\n      z-index: auto;\n      // top: 50%;\n      // left: 50%;\n      border-width: 3px;\n      width: 30px;\n      height: 30px;\n      // margin-left: -15px;\n      // margin-top: -15px;\n    }\n\n    .dz-thumb-caption {\n      position: absolute;\n      justify-content: center;\n      align-content: center;\n      background: fade(#000000, 70%);\n      color: #ffffff;\n      padding: 8px 12px;\n      display: flex;\n      bottom: 0;\n      left: 0;\n      right: 0;\n    }\n\n    .dz-thumb-img-size {\n      position: absolute;\n      justify-content: center;\n      align-content: center;\n      background: #ffffff;\n      color: fade(#000000, 70%);\n      font-family: 'Poppins';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 12px;\n      padding: 8px 12px;\n      display: flex;\n      border-radius: 18px;\n      right: 0;\n      margin: 7px;\n    }\n\n    .dz-thumb {\n      flex: 1 1 100%;\n      height: 240px;\n      max-height: 240px;\n      display: flex;\n      position: relative;\n      justify-content: center;\n      align-items: center;\n      box-shadow: inset 0 0 480px -240px @grey_400;\n\n      *::selection {\n        background: transparent;\n      }\n\n      &:hover {\n        cursor: move;\n      }\n\n      &.updating .dz-thumb-img img {\n        display: none;\n      }\n\n      .dz-thumb-img {\n        height: 240px;\n        flex: 1 1 100%;\n        padding: 0;\n        position: relative;\n        border-radius: 0;\n        margin: 0;\n        overflow: hidden;\n        border: 0;\n        display: flex;\n        justify-content: center;\n        align-items: flex-start;\n\n        img {\n          height: 240px;\n          width: 320px;\n          object-fit: cover;\n          flex: 1 1 100%;\n        }\n\n        &:after {\n          position: absolute;\n          content: \"\";\n          top: 0;\n          bottom: 0;\n          right: 0;\n          left: 0;\n        }\n      }\n    }\n\n    .dz-actions {\n      padding-top: 5px;\n      flex: 0 0 100%;\n      display: flex;\n      flex-wrap: wrap;\n\n      @media screen and (min-width: @screen-header-collapse) {\n        flex-wrap: nowrap;\n      }\n\n      justify-content: center;\n      gap: 5px 5px;\n\n      .rotate,\n      .delete {\n        padding-left: 0;\n        padding-right: 0;\n        min-width: 36px;\n        width: 36px;\n        height: 36px;\n        justify-content: center;\n\n        svg {\n          width: 16px;\n          height: 16px;\n          stroke: @primary_colour;\n          stroke-width: @svg-16-stroke-width;\n        }\n      }\n\n      .btn:not(.rotate):not(.delete) {\n        padding: 7.5px 15px;\n      }\n\n      .dz-thumb-caption {\n        position: relative;\n        flex-wrap: wrap;\n        flex: 0 0 100%;\n        background: none;\n        padding: 0;\n        margin-top: -41px;\n        gap: 5px 5px;\n\n        >div {\n          flex: 0 0 100%;\n          background: rgba(0, 0, 0, 0.7);\n          box-shadow: none !important;\n          border: 0 none !important;\n\n          .flatpickr-wrapper {\n            display: flex;\n\n            svg {\n              stroke: #ffffff;\n            }\n          }\n\n          input {\n            background: none;\n            text-align: center;\n            border: none;\n            color: #ffffff;\n            min-height: 36px;\n            width: 100%;\n            padding: 0;\n          }\n\n          .btn:not(.rotate):not(.delete) {\n            padding-top: 0;\n            padding-bottom: 0;\n          }\n        }\n      }\n    }\n  }\n\n  .dz-thumb-img-dims {\n    margin: 10px 0;\n    display: block;\n    text-align: center;\n  }\n}\n\n.cardbody .form-group.uploadinput {\n  align-items: start;\n}\n\n.serviced-location-lookup .forminput {\n  padding: 10px;\n\n  .btn {\n    padding: 10px;\n  }\n}\n\n.uploadinput {\n  .img-container {\n    width: 200px;\n\n    img {\n      width: 100%;\n      border: none;\n      display: block;\n      border-radius: @input-border-radius;\n    }\n\n    .img-placeholder {\n      height: 300px;\n      width: 200px;\n      border-radius: @input-border-radius;\n      background-color: @grey_50;\n      display: flex;\n      align-items: center;\n\n      .inline {\n        margin: 0 auto;\n      }\n    }\n  }\n}\n\n.uploadwrap {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n\n  .imagecropbtn {\n    margin-top: 10px;\n\n    input:hover {\n      cursor: pointer;\n    }\n  }\n\n  .inlineload {\n    position: relative;\n    min-height: 3.4rem;\n    line-height: 3.4rem;\n    vertical-align: middle;\n\n    a {\n      display: inline-block;\n      padding-left: 10px;\n      position: absolute;\n      z-index: 4;\n    }\n  }\n\n  .inlineloaded {\n    width: 0%;\n  }\n}\n\n.ReactCrop__image {\n  max-height: none;\n}\n\n.recordselector-heading {\n  margin-top: 27px;\n}\n\n// button,\n// html [type=\"button\"],\n// a {\n//   border: none;\n//   -webkit-appearance: none;\n//   &.btn {\n//     display: inline;\n//     :hover {\n//       cursor: pointer;\n//     }\n//     &.btn-secondary {\n//       color: #444;\n//       background-color: #efefef;\n//       border: 1px solid #ccc;\n//     }\n//     &.btn-border {\n//       color: @brand-primary;\n//       border: 1px solid @brand-primary;\n//     }\n//     &.btn-none {\n//       color: @brand-primary;\n//       background: transparent;\n//       box-shadow: none;\n//       border: 0;\n//       &.link {\n//         margin: 0;\n//         padding: 0 10px 0 10px;\n//       }\n//       svg {\n//         fill: @brand-primary;\n//       }\n//       &.btn-add {\n//         svg {\n//           height: 12px;\n//           margin: 0 5px;\n//         }\n//       }\n//       &.rotate {\n//         padding-left: 0;\n//         padding-right: 0;\n//       }\n//     }\n//   }\n// }\ninput[type=\"file\"] {\n  position: absolute;\n  left: 0;\n  top: 9px;\n  opacity: 0;\n  height: 3rem;\n  width: 100px;\n}\n\ninput[type=\"file\"]:hover {\n  cursor: pointer;\n}\n\n\n// FLATPCIKR Date Picker\n@keyframes fpFadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n.flatpickr-calendar {\n  background: transparent;\n  opacity: 0;\n  display: none;\n  text-align: center;\n  visibility: hidden;\n  padding: 0;\n  -webkit-animation: none;\n  animation: none;\n  direction: ltr;\n  border: 0;\n  font-size: 14px;\n  line-height: 24px;\n  border-radius: 5px;\n  position: absolute;\n  width: 307.875px;\n  box-sizing: border-box;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  background: #fff;\n  -webkit-box-shadow: 1px 0 0 #e6e6e6, -1px 0 0 #e6e6e6, 0 1px 0 #e6e6e6,\n    0 -1px 0 #e6e6e6, 0 3px 13px rgba(0, 0, 0, 0.08);\n  box-shadow: 1px 0 0 #e6e6e6, -1px 0 0 #e6e6e6, 0 1px 0 #e6e6e6,\n    0 -1px 0 #e6e6e6, 0 3px 13px rgba(0, 0, 0, 0.08);\n\n  .hasWeeks {\n    .dayContainer {\n      border-bottom: 0;\n      border-bottom-right-radius: 0;\n      border-bottom-left-radius: 0;\n      border-left: 0;\n    }\n  }\n\n  .hasTime {\n    .dayContainer {\n      border-bottom: 0;\n      border-bottom-right-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n  }\n\n  &:before {\n    position: absolute;\n    display: block;\n    pointer-events: none;\n    border: solid transparent;\n    content: \"\";\n    height: 0;\n    width: 0;\n    left: 22px;\n    border-width: 5px;\n    margin: 0 -5px;\n  }\n\n  &:after {\n    position: absolute;\n    display: block;\n    pointer-events: none;\n    border: solid transparent;\n    content: \"\";\n    height: 0;\n    width: 0;\n    left: 22px;\n    border-width: 4px;\n    margin: 0 -4px;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n}\n\n.flatpickr-calendar.open {\n  opacity: 1;\n  max-height: 640px;\n  visibility: visible;\n  display: inline-block;\n  z-index: 99999;\n}\n\n.flatpickr-calendar.inline {\n  opacity: 1;\n  max-height: 640px;\n  visibility: visible;\n  display: block;\n  position: relative;\n  top: 2px;\n}\n\n.flatpickr-calendar.animate.open {\n  -webkit-animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\n  animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.flatpickr-calendar.static {\n  position: absolute;\n  top: calc(100% + 2px);\n}\n\n.flatpickr-calendar.static.open {\n  z-index: 999;\n  display: block;\n}\n\n.flatpickr-calendar.multiMonth {\n  .flatpickr-days {\n    .dayContainer {\n      &:nth-child(n + 1) {\n        .flatpickr-day.inRange {\n          &:nth-child(7n + 7) {\n            -webkit-box-shadow: none !important;\n            box-shadow: none !important;\n          }\n        }\n      }\n\n      &:nth-child(n + 2) {\n        .flatpickr-day.inRange {\n          &:nth-child(7n + 1) {\n            -webkit-box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n            box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n          }\n        }\n      }\n    }\n  }\n}\n\n.flatpickr-calendar.showTimeInput.hasTime {\n  .flatpickr-time {\n    height: 40px;\n    border-top: 1px solid #e6e6e6;\n  }\n}\n\n.flatpickr-calendar.noCalendar.hasTime {\n  .flatpickr-time {\n    height: auto;\n  }\n}\n\n.flatpickr-calendar.rightMost {\n  &:before {\n    left: auto;\n    right: 22px;\n  }\n\n  &:after {\n    left: auto;\n    right: 22px;\n  }\n}\n\n.flatpickr-calendar.arrowTop {\n  &:before {\n    bottom: 100%;\n    border: 0 none;\n  }\n\n  &:after {\n    bottom: 100%;\n    border: 0 none;\n  }\n}\n\n.flatpickr-calendar.arrowBottom {\n  &:before {\n    top: 100%;\n    border: 0 none;\n  }\n\n  &:after {\n    top: 100%;\n    border: 0 none;\n  }\n}\n\n.flatpickr-wrapper {\n  position: unset;\n  display: inline-block;\n  flex: 1 1;\n}\n\n.dateinput {\n  text-decoration: none;\n\n  .form-control.hidden {\n    width: 1px;\n    height: 1px;\n    opacity: 0;\n    margin: 0;\n    padding: 0;\n    position: absolute;\n    pointer-events: none;\n    opacity: 0;\n  }\n\n  .input-group-addon.btn {\n    margin-left: 0;\n  }\n\n  .flatpickr-inputwrap {\n    display: flex;\n    flex: 1 1 100%;\n    flex-wrap: nowrap;\n    border: @input-border;\n    border-radius: 3px;\n\n    input {\n      flex: 1 1 100%;\n      border: 0;\n    }\n\n    button {\n      svg {\n        height: 20px;\n        fill: #cccccc;\n      }\n\n      &:hover {\n        svg {\n          fill: hsl(0, 0%, 60%);\n        }\n      }\n    }\n  }\n}\n\n.flatpickr-months {\n  display: flex;\n\n  .flatpickr-month {\n    background: @white;\n    color: @grey_500;\n    fill: @grey_500;\n    height: 28px;\n    line-height: 1;\n    text-align: center;\n    position: relative;\n    user-select: none;\n    flex: 1;\n\n    .flatpickr-current-month select {\n      -webkit-appearance: none;\n      -moz-appearance: none;\n      // text-indent: 1px;\n      text-overflow: '';\n    }\n\n    // Above hides the ugly dropdown arrow in FF / Chrome\n    .flatpickr-current-month select::-ms-expand {\n      display: none;\n    }\n\n    // Above hides the ugly dropdown arrow in IE\n  }\n\n  .flatpickr-prev-month,\n  .flatpickr-next-month {\n    text-decoration: none;\n    cursor: pointer;\n    position: absolute;\n    top: 0;\n    line-height: 16px;\n    height: 28px;\n    padding: 10px;\n    z-index: 3;\n    color: @grey_500;\n    fill: @grey_500;\n\n    i {\n      position: relative;\n    }\n\n    &:hover {\n      color: #ffffff;\n\n      svg {\n        fill: #ffffff;\n      }\n    }\n\n    svg {\n      width: 14px;\n      height: 14px;\n\n      path {\n        -webkit-transition: fill 0.1s;\n        transition: fill 0.1s;\n        fill: @grey_500;\n      }\n    }\n  }\n\n  .flatpickr-prev-month.disabled {\n    display: none;\n  }\n\n  .flatpickr-next-month.disabled {\n    display: none;\n  }\n\n  .flatpickr-prev-month.flatpickr-prev-month {\n    left: 0;\n  }\n\n  .flatpickr-next-month.flatpickr-prev-month {\n    left: 0;\n  }\n\n  .flatpickr-prev-month.flatpickr-next-month {\n    right: 0;\n  }\n\n  .flatpickr-next-month.flatpickr-next-month {\n    right: 0;\n  }\n}\n\n.numInputWrapper {\n  position: relative;\n  height: auto;\n\n  input {\n    display: inline-block;\n    width: 100%;\n\n    &::-ms-clear {\n      display: none;\n    }\n  }\n\n  span {\n    display: inline-block;\n    position: absolute;\n    right: 0;\n    width: 14px;\n    padding: 0 4px 0 2px;\n    height: 50%;\n    line-height: 50%;\n    opacity: 0;\n    cursor: pointer;\n    border: 1px solid rgba(57, 57, 57, 0.15);\n    box-sizing: border-box;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.1);\n    }\n\n    &:active {\n      background: rgba(0, 0, 0, 0.2);\n    }\n\n    &:after {\n      display: block;\n      content: \"\";\n      position: absolute;\n    }\n\n    svg {\n      width: inherit;\n      height: auto;\n\n      path {\n        fill: rgba(0, 0, 0, 0.5);\n      }\n    }\n  }\n\n  span.arrowUp {\n    top: 0;\n    border-bottom: 0;\n\n    &:after {\n      border-left: 4px solid transparent;\n      border-right: 4px solid transparent;\n      border-bottom: 4px solid rgba(57, 57, 57, 0.6);\n      top: 26%;\n    }\n  }\n\n  span.arrowDown {\n    top: 50%;\n\n    &:after {\n      border-left: 4px solid transparent;\n      border-right: 4px solid transparent;\n      border-top: 4px solid rgba(57, 57, 57, 0.6);\n      top: 40%;\n    }\n  }\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.05);\n\n    span {\n      opacity: 1;\n    }\n  }\n}\n\n.flatpickr-current-month {\n  font-size: 135%;\n  line-height: inherit;\n  color: inherit;\n  position: absolute;\n  width: 75%;\n  left: 12.5%;\n  padding: 6.16px 0 0 0;\n  line-height: 1;\n  height: 28px;\n  display: inline-block;\n  text-align: center;\n  transform: translate3d(0, 0, 0);\n\n  span.cur-month {\n    font-family: inherit;\n    font-weight: bold;\n    color: inherit;\n    display: inline-block;\n    margin-left: 0.5ch;\n    padding: 0;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.05);\n    }\n  }\n\n  .numInputWrapper {\n    width: 6ch;\n    width: 7ch\\0;\n    display: inline-block;\n\n    span.arrowUp {\n      &:after {\n        border-bottom-color: rgba(0, 0, 0, 0.9);\n      }\n    }\n\n    span.arrowDown {\n      &:after {\n        border-top-color: rgba(0, 0, 0, 0.9);\n      }\n    }\n  }\n\n  input.cur-year {\n    background: transparent;\n    box-sizing: border-box;\n    color: inherit;\n    cursor: text;\n    padding: 0 0 0 0.5ch;\n    margin: 0;\n    display: inline-block;\n    font-size: inherit;\n    font-family: inherit;\n    line-height: inherit;\n    height: auto;\n    border: 0;\n    border-radius: 0;\n    vertical-align: initial;\n\n    &:focus {\n      outline: 0;\n    }\n  }\n\n  input.cur-year[disabled] {\n    font-size: 100%;\n    color: rgba(0, 0, 0, 0.5);\n    background: transparent;\n    pointer-events: none;\n\n    &:hover {\n      font-size: 100%;\n      color: rgba(0, 0, 0, 0.5);\n      background: transparent;\n      pointer-events: none;\n    }\n  }\n}\n\n.flatpickr-weekdays {\n  background: @white;\n  text-align: center;\n  overflow: hidden;\n  width: 100%;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 28px;\n\n  .flatpickr-weekdaycontainer {\n    display: flex;\n    flex: 1;\n  }\n}\n\nspan.flatpickr-weekday {\n  cursor: default;\n  font-size: 11px;\n  background: transparent;\n  color: @grey_300;\n  line-height: 1;\n  margin: 0;\n  text-align: center;\n  display: block;\n  flex: 1;\n  font-weight: bolder;\n}\n\n.dayContainer {\n  padding: 1px 0 0 0;\n  padding: 0;\n  outline: 0;\n  text-align: left;\n  width: 307.875px;\n  min-width: 307.875px;\n  max-width: 307.875px;\n  box-sizing: border-box;\n  display: inline-block;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  transform: translate3d(0, 0, 0);\n  opacity: 1;\n\n  &+ {\n    .dayContainer {\n      -webkit-box-shadow: -1px 0 0 #e6e6e6;\n      box-shadow: -1px 0 0 #e6e6e6;\n    }\n  }\n}\n\n.flatpickr-weeks {\n  padding: 1px 0 0 0;\n}\n\n.flatpickr-days {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-start;\n  width: 307.875px;\n  border: 0;\n\n  &:focus {\n    outline: 0;\n  }\n}\n\n.flatpickr-day {\n  background: none;\n  border-radius: 0;\n  border: 0 none;\n  font-size: 12px;\n  box-sizing: border-box;\n  color: @grey_600;\n  cursor: pointer;\n  width: 14.2857143%;\n  flex-basis: 14.2857143%;\n  max-width: 39px;\n  height: 39px;\n  line-height: 39px;\n  margin: 0;\n  display: flex;\n  position: relative;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n\n  &:hover {\n    cursor: pointer;\n    outline: 0;\n    font-weight: bold;\n    background: @white;\n  }\n\n  &:focus {\n    cursor: pointer;\n    outline: 0;\n    background: @white;\n  }\n}\n\n.flatpickr-day.inRange {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n  border-radius: 0;\n  -webkit-box-shadow: -5px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n  box-shadow: -5px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n}\n\n.flatpickr-day.prevMonthDay.inRange {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n\n.flatpickr-day.nextMonthDay.inRange {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n\n.flatpickr-day.today.inRange {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n\n.flatpickr-day.prevMonthDay.today.inRange {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n\n.flatpickr-day.nextMonthDay.today.inRange {\n  cursor: pointer;\n  outline: 0;\n  background: #e6e6e6;\n  border-color: #e6e6e6;\n}\n\n.flatpickr-day.prevMonthDay {\n  &:hover {\n    cursor: pointer;\n    outline: 0;\n    background: #e6e6e6;\n    border-color: #e6e6e6;\n  }\n\n  &:focus {\n    cursor: pointer;\n    outline: 0;\n    background: #e6e6e6;\n    border-color: #e6e6e6;\n  }\n\n  color: rgba(57, 57, 57, 0.3);\n  background: transparent;\n  border-color: transparent;\n  cursor: default;\n}\n\n.flatpickr-day.nextMonthDay {\n  &:hover {\n    cursor: pointer;\n    outline: 0;\n    background: #e6e6e6;\n    border-color: #e6e6e6;\n  }\n\n  &:focus {\n    cursor: pointer;\n    outline: 0;\n    background: #e6e6e6;\n    border-color: #e6e6e6;\n  }\n\n  color: rgba(57, 57, 57, 0.3);\n  background: transparent;\n  border-color: transparent;\n  cursor: default;\n}\n\n.flatpickr-day.today {\n  color: @tertiary_colour;\n\n  &:hover {\n    background: @white;\n    color: @tertiary_colour;\n  }\n\n  &:focus {\n    background: @white;\n    color: @tertiary_colour;\n  }\n}\n\n.flatpickr-day.selected {\n  background: @grey_50;\n  box-shadow: none;\n  color: @primary_colour;\n  font-weight: bold;\n  border-radius: 50%;\n\n  &:focus {\n    color: @primary_colour;\n    background: @white;\n    box-shadow: none;\n  }\n\n  &:hover {\n    color: @primary_colour;\n    background: @white;\n    box-shadow: none;\n  }\n}\n\n.flatpickr-day.startRange {\n  background: @brand-primary;\n  box-shadow: none;\n  color: #fff;\n  border-color: @brand-primary;\n\n  &:focus {\n    background: @brand-primary;\n    box-shadow: none;\n    color: #fff;\n    border-color: @brand-primary;\n  }\n\n  &:hover {\n    background: @brand-primary;\n    box-shadow: none;\n    color: #fff;\n    border-color: @brand-primary;\n  }\n}\n\n.flatpickr-day.endRange {\n  background: @brand-primary;\n  box-shadow: none;\n  color: #fff;\n  border-color: @brand-primary;\n\n  &:focus {\n    background: @brand-primary;\n    box-shadow: none;\n    color: #fff;\n    border-color: @brand-primary;\n  }\n\n  &:hover {\n    background: @brand-primary;\n    box-shadow: none;\n    color: #fff;\n    border-color: @brand-primary;\n  }\n}\n\n.flatpickr-day.selected.inRange {\n  background: @brand-primary;\n  box-shadow: none;\n  color: #fff;\n  border-color: @brand-primary;\n}\n\n.flatpickr-day.startRange.inRange {\n  background: @brand-primary;\n  box-shadow: none;\n  color: #fff;\n  border-color: @brand-primary;\n}\n\n.flatpickr-day.endRange.inRange {\n  background: @brand-primary;\n  box-shadow: none;\n  color: #fff;\n  border-color: @brand-primary;\n}\n\n.flatpickr-day.selected.prevMonthDay,\n.flatpickr-day.selected.nextMonthDay {\n  background: @white;\n  box-shadow: none;\n  color: @primary_colour;\n  border: 0 none;\n\n  &:hover {\n    color: @primary_colour;\n  }\n}\n\n.flatpickr-day.startRange.prevMonthDay {\n  background: @brand-primary;\n  box-shadow: none;\n  color: #fff;\n  border-color: @brand-primary;\n}\n\n.flatpickr-day.endRange.prevMonthDay {\n  background: @brand-primary;\n  box-shadow: none;\n  color: #fff;\n  border-color: @brand-primary;\n}\n\n.flatpickr-day.startRange.nextMonthDay {\n  background: @brand-primary;\n  box-shadow: none;\n  color: #fff;\n  border-color: @brand-primary;\n}\n\n.flatpickr-day.endRange.nextMonthDay {\n  background: @brand-primary;\n  box-shadow: none;\n  color: #fff;\n  border-color: @brand-primary;\n}\n\n.flatpickr-day.selected.startRange {\n  border-radius: 50px 0 0 50px;\n\n  &+ {\n    .endRange {\n      &:not(:nth-child(7n + 1)) {\n        box-shadow: -10px 0 0 @brand-primary;\n      }\n    }\n  }\n}\n\n.flatpickr-day.startRange.startRange {\n  border-radius: 50px 0 0 50px;\n\n  &+ {\n    .endRange {\n      &:not(:nth-child(7n + 1)) {\n        box-shadow: -10px 0 0 @brand-primary;\n      }\n    }\n  }\n}\n\n.flatpickr-day.endRange.startRange {\n  border-radius: 50px 0 0 50px;\n\n  &+ {\n    .endRange {\n      &:not(:nth-child(7n + 1)) {\n        box-shadow: -10px 0 0 @brand-primary;\n      }\n    }\n  }\n}\n\n.flatpickr-day.selected.endRange {\n  border-radius: 0 50px 50px 0;\n}\n\n.flatpickr-day.startRange.endRange {\n  border-radius: 0 50px 50px 0;\n}\n\n.flatpickr-day.endRange.endRange {\n  border-radius: 0 50px 50px 0;\n}\n\n.flatpickr-day.selected.startRange.endRange {\n  border-radius: 50px;\n}\n\n.flatpickr-day.startRange.startRange.endRange {\n  border-radius: 50px;\n}\n\n.flatpickr-day.endRange.startRange.endRange {\n  border-radius: 50px;\n}\n\n.flatpickr-day.disabled,\n.flatpickr-day.flatpickr-disabled,\n.flatpickr-day.notAllowed,\n.flatpickr-day.prevMonthDay,\n.flatpickr-day.nextMonthDay {\n  color: @grey_300;\n  background: transparent;\n  border-color: transparent;\n\n  &:hover {\n    background: transparent;\n    border-color: transparent;\n    color: @grey_300;\n  }\n}\n\n.flatpickr-day.disabled,\n.flatpickr-day.flatpickr-disabled,\n.flatpickr-day.notAllowed,\n.flatpickr-day.prevMonthDay.flatpickr-disabled,\n.flatpickr-day.nextMonthDay.flatpickr-disabled {\n  color: @grey_200;\n  cursor: not-allowed;\n\n  &:hover {\n    cursor: not-allowed;\n    font-weight: 400;\n    color: @grey_200;\n  }\n}\n\n.flatpickr-day.week.selected {\n  border-radius: 0;\n  -webkit-box-shadow: -5px 0 0 @brand-primary, 5px 0 0 @brand-primary;\n  box-shadow: -5px 0 0 @brand-primary, 5px 0 0 @brand-primary;\n}\n\n.flatpickr-day.hidden {\n  visibility: hidden;\n}\n\n.rangeMode {\n  .flatpickr-day {\n    margin-top: 1px;\n  }\n}\n\n.flatpickr-weekwrapper {\n  display: inline-block;\n\n  .flatpickr-weeks {\n    padding: 0 12px;\n    -webkit-box-shadow: 1px 0 0 #e6e6e6;\n    box-shadow: 1px 0 0 #e6e6e6;\n  }\n\n  .flatpickr-weekday {\n    float: none;\n    width: 100%;\n    line-height: 28px;\n  }\n\n  span.flatpickr-day {\n    display: block;\n    width: 100%;\n    max-width: none;\n    color: rgba(57, 57, 57, 0.3);\n    background: transparent;\n    cursor: default;\n    border: none;\n\n    &:hover {\n      display: block;\n      width: 100%;\n      max-width: none;\n      color: rgba(57, 57, 57, 0.3);\n      background: transparent;\n      cursor: default;\n      border: none;\n    }\n  }\n}\n\n.flatpickr-innerContainer {\n  display: block;\n  display: flex;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.flatpickr-rContainer {\n  display: inline-block;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.flatpickr-time {\n  text-align: center;\n  outline: 0;\n  display: block;\n  height: 0;\n  line-height: 40px;\n  max-height: 40px;\n  box-sizing: border-box;\n  overflow: hidden;\n  display: flex;\n\n  &:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n\n  .numInputWrapper {\n    -webkit-box-flex: 1;\n    -webkit-flex: 1;\n    -ms-flex: 1;\n    flex: 1;\n    width: 40%;\n    height: 40px;\n    float: left;\n\n    span.arrowUp {\n      &:after {\n        border-bottom-color: #393939;\n      }\n    }\n\n    span.arrowDown {\n      &:after {\n        border-top-color: #393939;\n      }\n    }\n  }\n\n  input {\n    background: transparent;\n    box-shadow: none;\n    border: 0;\n    border-radius: 0;\n    text-align: center;\n    margin: 0;\n    padding: 0;\n    height: inherit;\n    line-height: inherit;\n    color: #393939;\n    font-size: 14px;\n    position: relative;\n    box-sizing: border-box;\n\n    &:focus {\n      outline: 0;\n      border: 0;\n      background: #f3f3f3;\n    }\n\n    &:hover {\n      background: #f3f3f3;\n    }\n  }\n\n  input.flatpickr-hour {\n    font-weight: bold;\n  }\n\n  input.flatpickr-minute {\n    font-weight: 400;\n  }\n\n  input.flatpickr-second {\n    font-weight: 400;\n  }\n\n  .flatpickr-time-separator {\n    height: inherit;\n    display: inline-block;\n    line-height: inherit;\n    color: #393939;\n    font-weight: bold;\n    width: 2%;\n    user-select: none;\n    align-self: center;\n  }\n\n  .flatpickr-am-pm {\n    height: inherit;\n    display: inline-block;\n    line-height: inherit;\n    color: #393939;\n    font-weight: bold;\n    width: 2%;\n    user-select: none;\n    align-self: center;\n    outline: 0;\n    width: 18%;\n    cursor: pointer;\n    text-align: center;\n    font-weight: 400;\n\n    &:hover {\n      background: #f3f3f3;\n    }\n\n    &:focus {\n      background: #f3f3f3;\n    }\n  }\n}\n\n.flatpickr-time.hasSeconds {\n  .numInputWrapper {\n    width: 26%;\n  }\n}\n\n.flatpickr-time.time24hr {\n  .numInputWrapper {\n    width: 49%;\n  }\n}\n\n.flatpickr-input[readonly] {\n  cursor: pointer;\n  background-color: #ffffff;\n}\n\n.flatpickr-calendar .flatpickr-monthDropdown-months,\n.flatpickr-calendar .flatpickr-current-month input.cur-year {\n  background: none;\n  font-size: 1.2rem;\n  font-weight: 600;\n  -webkit-appearance: textfield;\n}\n\n.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {\n  background: @white;\n  padding: 0;\n}\n\n.flatpickr-calendar span.flatpickr-weekday {\n  font-weight: 600;\n}\n\n.flatpickr-calendar .flatpickr-day {\n  line-height: 36px;\n  height: 40px;\n  max-width: 40px;\n}\n\n// .jodit_form {\n//   display: block;\n//   input::placeholder {\n//     color: #979797;\n//     font-size: 1.1rem;\n//   }\n//   .jodit_link_insert_button {\n//     .btn();\n//     // .btn-primary.btn-primary();\n//     height: auto;\n//   }\n// }\n\n.tip {\n  min-height: 36px;\n  flex: 1 1 100%;\n  display: flex;\n  align-items: center;\n  color: @grey_500;\n  vertical-align: center;\n  border-radius: 4px;\n  background: @info_10;\n\n  .tip-content {\n    padding: 6px 10px;\n  }\n\n  &.hot {\n    background: @error_10;\n    color: @error;\n  }\n\n  &.alert {\n    background: @alert;\n    color: @grey_500;\n  }\n\n  &.fix-width {\n    min-width: 100%;\n  }\n\n  &.tip-input {\n    margin: 0 !important;\n  }\n\n  .tipheading {\n    font-weight: 600;\n    padding-right: 10px;\n    white-space: nowrap;\n  }\n}\n\n.tip {\n\n  &.multi,\n  .input-group .field &.multi {\n    margin-top: -10px;\n\n    .tipheading.multi {\n      flex: 0 0 100%;\n    }\n\n    .tiptext.multi {\n      flex: 0 0 100%;\n    }\n  }\n}\n\n.colorpicker {\n  .color-swatch {\n    width: 36px;\n    box-shadow: inset 0px 2px 4px rgba(0, 0, 0, .1);\n    cursor: pointer;\n  }\n\n  .formlabel {\n    left: 37px;\n  }\n\n  .input-group-addon {\n    border-radius: @input-border-radius 0 0 @input-border-radius;\n\n    ~input.input-group-prefix {\n      padding-left: 8px;\n    }\n  }\n\n  .forminput {\n    position: relative;\n    flex: 1 1 auto !important;\n\n    input {\n      padding-left: 8px !important;\n    }\n  }\n\n  .picker_wrapper {\n    background: #ffffff;\n  }\n\n  .picker_editor {\n    flex: 1 1 auto;\n    border-radius: @input-border-radius 0 0 @input-border-radius;\n    border: @input-border;\n    overflow: hidden;\n    margin-right: 0;\n    border-right: 0;\n\n    input {\n      border: none;\n      box-shadow: none;\n    }\n  }\n\n  .picker_alpha {\n    width: 100%;\n  }\n\n  .picker_sample {\n    flex: 0 0 36px;\n    margin-left: 0;\n    margin-right: 0;\n    box-shadow: none;\n    border: @input-border;\n  }\n\n  .picker_done {\n    margin-left: 0;\n\n    button {\n      .btn();\n      box-shadow: none;\n      background: @grey_50;\n      color: @primary_colour;\n\n      svg {\n        stroke: @primary_colour;\n      }\n\n      &.input-group-addon {\n        min-height: 34px;\n        max-height: none;\n        background: @grey_50;\n        color: @primary_colour;\n\n        svg {\n          stroke: @primary_colour;\n        }\n      }\n\n      .pseudo_btn(@primary_colour, @grey, @primary_colour_25);\n      border-radius: 0 @input-border-radius @input-border-radius 0;\n    }\n  }\n}\n\n.extras-opt,\n.extras-selected,\n.extras-legend {\n  display: flex;\n  justify-content: space-between;\n\n  .extras-tags {\n    display: flex;\n    gap: 0 5px;\n  }\n\n  .extras-tag {\n    font-size: 11px;\n    display: block;\n    border-radius: 2px;\n    padding: 2px 5px;\n    color: @grey_600;\n\n    &.group-tag {\n      background: @grey;\n    }\n\n    &.P24 {\n      background: rgba(88, 172, 228, 0.3);\n    }\n\n    &.PP {\n      background: rgba(83, 216, 106, 0.3);\n    }\n\n    &.DBZ {\n      background: #ffe98a;\n    }\n\n    &.BYT {\n      background: rgba(40, 177, 109, 0.5);\n    }\n\n    &.PF {\n      background: #fda79d;\n    }\n  }\n}\n\n.extras-selected {\n  align-content: center;\n  line-height: 1;\n  font-size: 11px;\n\n  .extras-label {\n    display: flex;\n    align-items: center;\n  }\n\n  .extras-tags {\n    margin-left: 3px;\n  }\n}\n\n.extras-legend {\n  color: #000;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  min-width: 240px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n\n  .col & {\n    flex: 1 1 100%;\n    justify-content: flex-start;\n  }\n\n  >div {\n    display: flex;\n    align-content: center;\n    align-items: center;\n    margin-right: 5px;\n    margin-bottom: 10px;\n\n    .extras-tag {\n      margin-left: 0;\n      margin-right: 5px;\n    }\n  }\n\n}\n\n// #field-on_show {\n//   label {\n//     min-height: auto;\n//   }\n//   .checkcontainer > div {\n//     align-self: flex-start;\n//     margin-top: 0;\n//   }\n// }\n\n// .challenge-text {\n//   margin-bottom: 1rem;\n// }\n\n.model-form.view:not(.action) {\n  display: grid;\n  grid-area: view;\n  grid-template-areas: \"jump-menu\" \"form\";\n  grid-template-rows: 37px auto;\n  padding: 0;\n\n  @media screen and (min-width: @screen-header-collapse) {\n    grid-template-areas: \"jump-menu form\";\n    grid-template-columns: 260px auto;\n    grid-template-rows: auto;\n  }\n\n  .viewcontent {\n    grid-area: form;\n    position: relative;\n    overflow: auto;\n  }\n}\n\n.jumplist {\n  grid-area: jump-menu;\n  background: @grey;\n  top: 0;\n  width: 100vw;\n  height: 37px;\n  max-height: 37px;\n  overflow: hidden;\n  z-index: 101;\n  margin-bottom: 60px;\n\n  @media screen and (min-width: @screen-header-collapse) {\n    top: 0;\n    position: sticky;\n    overflow: auto;\n    height: auto;\n    width: 260px;\n    max-height: none;\n    margin-bottom: 0;\n  }\n\n  +div {\n    grid-area: details;\n  }\n\n  &.show {\n    position: absolute;\n    top: 66px;\n    height: auto;\n\n    @media screen and (min-width: @screen-header-collapse) {\n      position: relative;\n      top: 0;\n    }\n\n    max-height: none;\n  }\n\n  &-inner {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n\n    a {\n      background: @grey;\n      height: 37px;\n      flex: 0 0 100%;\n      display: flex;\n      align-items: center;\n      padding: 8px 20px;\n      color: @grey_400;\n      font-weight: 500;\n\n      &.active {\n        background: @grey_200;\n        color: @primary_colour;\n      }\n\n      &:hover {\n        background: @grey_200;\n        color: @primary_colour;\n      }\n    }\n  }\n}\n\n.vehicle-manager {\n  .search-fields {\n    justify-content: unset;\n  }\n\n  .search-buttons {\n    flex-wrap: nowrap;\n    display: flex;\n    gap: inherit;\n    align-self: start;\n  }\n}\n\n.template-manager {\n  .search-buttons {\n    flex: 0 0 100%;\n  }\n}\n\n.previewcontainer {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  padding-bottom: 20px;\n\n  @media (min-width: @screen-header-collapse) {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  .isloading {\n    position: absolute;\n    z-index: 999;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  &-nav {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    padding: 0 20px;\n\n    @media (min-width: @screen-header-collapse) {\n      padding-left: 0;\n      padding-right: 0;\n    }\n\n    .btn-highlight {\n      text-align: center;\n    }\n\n    .nav-group {\n      display: flex;\n      gap: 10px 5px;\n\n      &:nth-of-type(2) {\n        @media (max-width: @screen-header-collapse) {\n          display: none;\n        }\n      }\n\n      .btn-icon-only {\n        min-width: 38px;\n        max-width: 38px;\n        min-height: 38px;\n        max-height: 38px;\n        justify-content: center;\n      }\n    }\n\n    .seperator {\n      margin: 0 10px;\n      width: 0;\n      border-right: @input-border;\n    }\n\n    .form-group {\n      margin: 0;\n    }\n\n    .page {\n      display: flex;\n      flex-wrap: nowrap;\n      align-items: center;\n      white-space: nowrap;\n      justify-content: center;\n      margin-right: 15px;\n\n      .forminput {\n        flex: 1 1;\n        margin-left: 3px;\n        margin-right: 3px;\n      }\n\n      .page-jump {\n        width: 36px;\n        min-width: 36px;\n        max-width: 36px;\n        text-align: center;\n      }\n    }\n\n    .zoom {\n      min-width: 150px;\n    }\n  }\n}\n\n.previewcontainer-content {\n  margin-top: 20px;\n  box-shadow: @card-shadow;\n  overflow: auto;\n\n  iframe {\n    width: 100%;\n    border: none;\n    overflow: visible;\n  }\n}\n\n.check-header {\n  display: flex;\n  flex: 1 1;\n  color: @grey_700;\n  font-weight: 500;\n  justify-content: space-between;\n}\n\n.check-body {\n  font-size: 12px;\n  color: @grey_700;\n}\n\n.asset-selector {\n  width: 100%;\n  max-width: 100%;\n  position: relative;\n  overflow: hidden;\n  height: 56px;\n  max-height: 56px;\n\n  &.selected {\n    height: 230px;\n    max-height: 230px;\n    display: flex;\n    justify-content: center;\n  }\n\n  .asset-selector-btn-container {\n    position: absolute;\n    width: 100%;\n    margin: 10px -5px;\n    display: flex;\n    flex-direction: row-reverse;\n\n    .asset-selector-btn:first-of-type {\n      margin-left: 5px;\n    }\n\n    .asset-selector-btn .btn-icon-only {\n      min-height: 36px;\n      max-height: 36px;\n      max-width: 36px;\n      padding: 6px 15px;\n      justify-content: center;\n    }\n  }\n\n  .asset-item {\n    margin-top: 5px;\n  }\n}\n\n.gallery-selector {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: min-content;\n  width: 100%;\n  max-width: 100%;\n  position: relative;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  gap: 10px 10px;\n  height: 300px;\n  max-height: 300px;\n\n  * {\n    touch-action: none;\n  }\n\n  .gallery-item {\n    height: min-content;\n    border-radius: @input-border-radius;\n    position: relative;\n    padding: 10px;\n\n    &.active {\n      background: @grey_200;\n    }\n\n    .checkcontainer {\n      justify-content: flex-start;\n      align-items: flex-start;\n      position: absolute;\n      bottom: 0;\n      right: 0;\n      min-height: 24px;\n    }\n\n    img {\n      width: 100%;\n      aspect-ratio: 4 / 3;\n      max-height: 100%;\n      max-width: 100%;\n      user-select: none;\n      pointer-events: none;\n    }\n\n    &.disabled {\n      .checkcontainer {\n        display: none;\n      }\n    }\n\n    &.required {\n      .checkcontainer span {\n        background: @required-border;\n      }\n    }\n  }\n}\n\n.customopt {\n  .domstring {\n    display: flex;\n    gap: 14px 14px;\n    align-items: center;\n\n  }\n\n  .check-image {\n    min-width: 150px;\n    max-width: 150px;\n    height: 150px;\n\n    img {\n      background: #ffffff;\n      border-radius: 0;\n      object-fit: cover;\n      width: 100%;\n      height: 100%;\n    }\n  }\n\n  .check-listing {\n    .listing-property-type {\n      color: @grey_300;\n      font-size: 11px;\n      font-weight: 600;\n      text-transform: uppercase;\n    }\n\n    .listing-address {\n      color: @grey_600;\n      font-size: 13px;\n      line-height: 21px;\n    }\n\n    .listing-meta {\n      display: flex;\n      gap: 14px 14px;\n      padding: 14px 0;\n\n      svg {\n        fill: none;\n        stroke: @primary_colour;\n        stroke-width: @svg-16-stroke-width;\n        width: 16px;\n      }\n    }\n\n    .icon-value {\n      display: flex;\n      align-items: center;\n      color: @grey_600;\n      gap: 2px 2px;\n    }\n\n    .listing-price {\n      font-size: 15px;\n      font-weight: 600;\n      color: @primary_colour;\n    }\n  }\n}\n\n\n.brochures {\n\n  .forminput,\n  .input-group {\n    max-width: 100%;\n\n    [class^=\"col-\"],\n    [class*=\"col-\"] {\n      min-width: 180px;\n    }\n  }\n}\n\n#field-to {\n  margin-top: 1rem;\n}\n\n\n.versions-summary {\n  padding: 20px;\n  display: block;\n\n  &:hover {\n    background: @tertiary_colour_10;\n  }\n\n  &-top {\n    display: flex;\n    align-items: center;\n    gap: 0 6px;\n\n    .avatar-md {\n      max-width: 24px;\n\n      >.thumbimg {\n        .circle(24px);\n      }\n    }\n\n    .agents {\n      display: flex;\n      align-items: center;\n      gap: 0 6px;\n    }\n  }\n\n  &-date {\n    margin-left: auto;\n  }\n\n  &-pin {\n    .btn {\n      svg {\n        stroke: @grey_200;\n      }\n\n      &.pinned {\n        svg {\n          stroke: @primary_colour;\n        }\n      }\n    }\n  }\n\n  &-tag-name {\n    .tag {\n      background-color: @white;\n      border: 1px solid @grey_200;\n    }\n  }\n\n  &-body {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    margin: 20px 0 0;\n    display: flex;\n    justify-content: space-between;\n    gap: 6px 6px;\n\n    .versions-summary-content {\n      overflow: hidden;\n    }\n  }\n\n  &-bottom {\n    display: flex;\n    gap: 6px 6px;\n\n    .versions-summary-comments {\n      display: flex;\n      align-items: center;\n      gap: 0 6px;\n      color: @primary_colour;\n      font-weight: 600;\n\n      .icon {\n        width: 16px;\n        height: 16px;\n      }\n\n      svg {\n        width: 16px;\n        height: 16px;\n        fill: none;\n        stroke: @grey_200;\n        stroke-width: @svg-16-stroke-width;\n      }\n    }\n  }\n\n  .versions-summary-attachments {\n    display: flex;\n    align-items: center;\n    gap: 0 6px;\n    color: @primary_colour;\n    font-weight: 600;\n\n    svg {\n      width: 16px;\n      fill: none;\n      stroke: @grey_200;\n      stroke-width: @svg-16-stroke-width;\n    }\n  }\n\n  .versions-summary-tag {\n    border-radius: 30px;\n    padding: 5px 8px;\n    font-size: 10px;\n    background: @grey_300;\n    color: @white;\n\n    &-related {\n      border-radius: 30px;\n      padding: 5px 8px;\n      font-size: 10px;\n      background: @grey_200;\n      color: @white;\n    }\n  }\n}\n\n.check-input-group {\n  display: flex;\n  flex-wrap: wrap;\n  flex: 0 0 100%;\n  border: @input-border-default;\n  padding: 9px 15px 8px;\n  border-radius: @input-border-radius;\n\n  fieldset {\n    display: flex;\n    flex: 0 0 100%;\n    justify-content: flex-start;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0 15px;\n\n    .checkcontainer {\n      display: flex;\n      flex: 1 1 auto;\n      align-items: flex-start;\n      flex-wrap: nowrap;\n      min-width: fit-content;\n\n      .formlabel {\n        font-weight: normal;\n      }\n    }\n  }\n}\n\n.match-filters-header {\n  .cardhead {\n    padding-top: 20px;\n    padding-bottom: 20px;\n  }\n\n  .cardbody {\n    display: none;\n  }\n\n  .match-filters {\n    @media screen and (min-width: @screen-header-collapse) {\n      min-width: 910px;\n    }\n  }\n}\n\n.match-filters {\n  display: flex;\n  gap: 20px 20px;\n  align-items: flex-end;\n  justify-content: space-between;\n  min-height: 60px;\n  margin: 10px;\n\n  @media screen and (max-width: 1200px) {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  h3 {\n    line-height: auto;\n    margin: 0;\n  }\n\n  .filters-container {\n    flex-grow: 1;\n    display: flex;\n    justify-content: flex-end;\n    flex-direction: column;\n\n    @media screen and (min-width: @screen-header-collapse) {\n      flex-direction: row;\n      flex-wrap: wrap;\n    }\n\n    >div {\n      padding-right: 15px;\n    }\n  }\n\n  .form-group {\n    flex: 0 0 auto;\n\n    .checkinput .forminput,\n    .checkgroup {\n      border: 0 !important;\n      padding: 10px 0;\n      font-size: 1.1rem;\n\n      &:focus,\n      &:focus-within {\n        box-shadow: none;\n      }\n\n      .checkcontainer+label {\n        min-width: 0;\n      }\n    }\n  }\n\n  .check-input-group {\n    border: 0;\n    padding: 0;\n\n    .checkcontainer {\n      display: contents;\n    }\n\n    >.input-label {\n      display: none;\n    }\n  }\n\n  .score {\n    width: 100%;\n    max-width: 360px;\n    /* Adjust the maximum width as needed */\n    min-width: 0;\n  }\n}\n\n.vacancy-list {\n  flex: 0 0 100%;\n\n  .vacancy-wrapper {\n    +.vacancy-wrapper {\n      margin-top: 20px;\n    }\n\n    display: flex;\n    align-items: center;\n    gap: 20px 20px;\n\n    .vacancy-image {\n      flex: 0 0 186px;\n      width: 186px;\n      height: 150px;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n      }\n    }\n\n    .vacancy-data {\n      display: flex;\n      flex: 1 1 auto;\n      min-width: 280px;\n\n      h5 {\n        margin-bottom: 0;\n      }\n\n      svg {\n        width: 16px;\n        height: 16px;\n        fill: none;\n        stroke: @primary_colour;\n        margin-right: 5px;\n      }\n\n      span {\n        display: inline-flex;\n        align-items: center;\n        align-content: center;\n        white-space: nowrap;\n        text-align: right;\n      }\n    }\n\n    .vacancy-meta {\n      display: flex;\n      flex-wrap: wrap;\n      flex: 1 1 auto;\n\n      >* {\n        flex: 0 0 100%;\n      }\n\n      >*+* {\n        margin: 10px 0 0 0;\n      }\n    }\n\n    .vacancy-price {\n      flex: 0 0;\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: flex-end;\n      white-space: nowrap;\n      text-align: right;\n\n      .btn {\n        margin-top: auto;\n      }\n    }\n  }\n}\n\n.bulkedit .container-fluid {\n  padding-top: 20px;\n}\n\n.vacancy-agent-detail {\n  flex: 0 0;\n  display: inline-block;\n  flex-wrap: wrap;\n}\n\n.company-user-detail {\n  >div {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  display: flex;\n  flex-wrap: nowrap;\n}\n\n.vacancy-agent-email {\n  padding-left: 19px;\n}\n\n.vacancy-show-contact-detail {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: wrap;\n  cursor: pointer;\n}\n\n.vacancy-show-contact-detail .btn:hover {\n  background-color: #ffffff;\n}\n\n.vacancy-hide-contact-detail {\n  display: none;\n}\n\n.vacancy-hide-agent-contact-detail {\n  display: none;\n}\n\n.vacancy-show-agent-contact-detail {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  color: #fc495d;\n  background: #ffffff;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 21px;\n  padding-left: 1px;\n  border: none;\n  font-family: 'Poppins', sans-serif;\n}\n\n.brochure-generator {\n  grid-template-areas: \"form\"\n    \"pane\";\n  grid-template-rows: 1fr;\n  grid-template-columns: 1fr;\n  min-width: 0;\n  min-height: 0;\n  gap: 20px;\n  margin: -20px;\n  position: relative;\n\n  @media screen and (min-width: @screen-header-collapse) {\n    display: grid;\n    grid-template-areas: \"form pane\";\n    grid-template-columns: 400px 1fr;\n  }\n\n  .brochure-form {\n    min-height: 0;\n    overflow: auto;\n    padding: 20px;\n    grid-area: form;\n  }\n\n  .brochure-preview {\n    grid-area: pane;\n    min-height: 0;\n    overflow: auto;\n    padding: 20px;\n\n    @media screen and (min-width: @screen-header-collapse) {\n      padding: 20px 20px 0 0;\n    }\n  }\n}\n\n.area-groups-search {\n  .field {\n    padding: 0;\n  }\n}\n\n#field-modules {\n  padding-left: 0;\n  padding-right: 0;\n\n  .checkgroup {\n    flex: 1 1 100%;\n  }\n\n  .checkinput {\n    .input-label {\n      top: unset;\n      left: unset;\n      position: unset;\n      background: none;\n      flex: 1 1 0;\n    }\n\n    padding: 9px 20px 8px;\n\n    &.checked {\n      background: @tertiary_colour_10;\n    }\n  }\n\n  .checkcontainer {\n    flex: 0 0 24px;\n  }\n\n  .credit-check-option {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    padding: 9px 20px 8px;\n\n    >div {\n      display: flex;\n      flex-direction: column;\n    }\n\n    strong {\n      font-weight: 600;\n      font-size: 16px;\n      line-height: 24px;\n      /* Primary/100 */\n      color: @primary_colour;\n    }\n\n    span {\n      white-space: normal;\n      /* Frame 1601 */\n      font-size: 12px;\n      line-height: 18px;\n      font-weight: normal;\n      color: @grey_700;\n    }\n  }\n}\n\n.templates-search {\n  display: flex;\n\n  >div {\n    display: flex;\n    flex: 1 1 100%;\n\n    .search-fields {\n      margin-bottom: 10px;\n      flex: 1 1 100%;\n\n      >.field {\n        margin-right: auto;\n      }\n    }\n  }\n}\n\n.report-table-criteria {\n  display: grid;\n  grid-template-columns: auto fit-content(100px);\n  align-items: center;\n\n  .report-table-criteria-list {\n    display: inline-flex;\n  }\n\n  .report-table-criteria-buttons {\n    min-width: 0;\n  }\n}","// main: ../framework.less\n\n.alerts-sidebar {\n  background: #ffffff;\n  display: flex;\n  .alerts-heading {\n    display: flex;\n    position: sticky;\n    background: @grey_50;\n    height: 64px;\n    align-items: center;\n    justify-content: space-between;\n    top: 0;\n    z-index: 10;\n    padding-left: 20px;\n  }\n  .alerts-container {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    position: sticky;\n    top: @navbar-height;\n    transition: width  @transition-speed @transition-fn;\n    width: @sidebar-width;\n    grid-template-rows: 50px auto;\n    max-height: calc(~\"100vh - \"@navbar-height);\n    justify-content: space-between;\n    overflow: hidden;\n    .alert-action {\n      display: flex;\n      margin-top: 20px;\n      justify-content: space-between;\n      align-items: baseline;\n    }\n    .alert-content {\n      overflow: visible;\n      overflow-x: visible;\n      overflow-y: auto;\n      position: relative;\n      right: -17px;\n      left: 0;\n      height: calc(~\"100vh - 200px\");\n      width: @sidebar-width + 17px;\n    }\n\n    .alert-item {\n      text-align: left;\n      border-bottom: 1px solid #ccc;\n      padding: 10px 20px;\n      margin-right: 17px;\n\n      .alert-detail {\n        color: @gray;\n        font-size: 1rem;\n        &.domain {\n          text-transform: capitalize;\n        }\n      }\n      &.noalerts {\n        text-align: center;\n      }\n    }\n    &.noalerts h3 {\n      border-bottom: 2px solid #efefef;\n    }\n    p {\n      font-size: 1rem;\n    }\n    svg {\n      height: 100px;\n      fill: none;\n      stroke: @grey;\n    }\n\n    .close-window {\n      text-align: right;\n      margin-right: 10px;\n      button.btn.btn-alert-close-x {\n        background-color: transparent;\n        display: inline-block;\n      }\n      svg{\n        height: 20px;\n        stroke: @grey_200;\n      }\n    }\n  }\n\n}\n\n.notifier {\n  position: fixed;\n  z-index: 1000;\n  top: 85px;\n  right: 15px;\n  width: 300px;\n  display: flex;\n  flex-direction: column-reverse;\n\n  .notice-content {\n    position: relative;\n    transition: left 0.5s, opacity 0.6s, opacity 0.5s, opacity 0.6s;\n    left: 300px;\n    opacity: 0;\n    box-shadow: @card-shadow;\n    background-color: #fff;\n    padding: 20px;\n    margin-bottom: 10px;\n    min-height: 40px;\n    color: @grey_300;\n    &.active {\n      left: 0;\n      opacity: 1;\n    }\n    &.success {\n      border-left: 4px solid @success;\n    }\n    &.error {\n      border-left: 4px solid @error;\n    }\n    &.info {\n      border-left: 4px solid @info;\n    }\n  }\n  .notice-buttons {\n    display: flex;\n    gap: 10px 10px;\n  }\n}\n\n\n","// main: ../framework.less\n\n/* Cards */\n.card {\n  position: relative;\n  border-radius: @card-radius;\n  margin-bottom: 20px;\n  width: 100%;\n  border: 1px solid rgba(195, 201, 210, 0.31);\n  // transition: border @transition-fn @transition-speed;\n  &.active {\n    border: 1px solid @grey_400;\n  }\n  &.maxcard {\n    overflow-y: hidden;\n  }\n  &.no-shadow {\n    box-shadow: none;\n  }\n  &.stats-card-grey {\n    background: @grey_50;\n    height: 100%;\n    h3 {\n      font-size: 24px;\n      margin-top: 0;\n    }\n    .ccontent {\n      svg {\n        position: absolute;\n        top: 6px;\n        right: 6px;\n        width: 24px;\n        stroke: @primary_colour;\n        stroke-width: @svg-24-stroke-width;\n      }\n      div {\n        font-size: 14px;\n        display: flex;\n        justify-content: space-between;\n        flex-wrap: wrap;\n        span {\n          color: @grey_500;\n        }\n        .view-text {\n          color: @grey_300;\n        }\n      }\n    }\n  }\n  &-legend {\n    display: flex;\n    align-items: center;\n    gap: 0 5px;\n    legend {\n      font-size: 1rem;\n      vertical-align: middle;\n      width: auto;\n      display: flex;\n      align-items: center;\n      margin: 0;\n      &:before {\n        content: \"\";\n        width: 6px;\n        height: 6px;\n        display: block;\n        border-radius: 3px;\n        margin-right: 10px;\n      }\n      &.required:before {\n        background: @required-border;\n      }\n      &.quality:before {\n        background: @quality-border;\n      }\n    }\n  }\n  &-meta {\n    display: flex;\n    justify-content: space-between;\n    margin: -20px;\n    margin-bottom: 20px;\n    background: @white;\n    padding: 20px;\n    .card-toggles {\n      margin-left: auto;\n      display: flex;\n      align-items: center;\n    }\n    .cardtoggle-required {\n      text-align: right;\n      width: 100%;\n      display: flex;\n      flex-wrap: wrap;\n      gap: 5px 0;\n      padding-bottom: 20px;\n      .btn {\n        flex: 1 1 100%;\n        justify-content: center;\n        background: #ffffff;\n        border: 1px solid @grey;\n        color: @primary_colour;\n        svg {\n          stroke: @primary_colour;\n        }\n        .pseudo_btn(@primary_colour_120, transparent, @primary_colour_10, @grey_200);\n      }\n    }\n    @media screen and (max-width: @screen-header-collapse) {\n      flex-wrap: wrap;\n      .card-toggles {\n        flex: 1 1 100%;\n        flex-wrap: wrap;\n        .pagestep {\n          margin-top: 1.25rem;\n          margin-left: 8px;\n          margin-right: 0;\n          flex: 1 1 100%;\n          .firstpage {\n            margin-left: auto;\n          }\n        }\n      }\n      .cardtoggle-required {\n        margin-top: 1.25rem;\n        text-align: left;\n      }\n    }\n  }\n  &.hidden {\n    display: none;\n  }\n  .requiredonly .notrequired {\n    display: none;\n  }\n\n  .cardhead {\n    padding: 10px 20px;\n    display: flex;\n    align-items: center;\n    h3 {\n      margin: 0;\n      line-height: 36px;\n    }\n    .ccontent {\n      flex: 1 1 auto;\n      display: flex;\n      align-items: center;\n      flex-wrap: wrap;\n    }\n    .cardtoggle{\n      background: none;\n      border: none;\n      outline: none;\n      flex: 0 0 18px;\n      text-align: center;\n      cursor: pointer;\n      svg {\n        width: 12px;\n        fill: #ccc;\n        display: inline-block;\n        vertical-align: middle;\n      }\n    }\n    .profile-matches {\n      display: flex;\n      gap: 8px 12px;\n      position: absolute;\n      right: 0px;\n      margin-right: 28px;\n      @media screen and (max-width: @screen-header-collapse) {\n        display: flex;\n        gap: 8px 12px;\n        position: absolute;\n        top: 44px;\n      }\n      > div {\n        display: flex;\n        align-items: center;\n        justify-content: space-evenly;\n        span {\n          font-weight: 500;\n          font-size: 14px;\n          line-height: 21px;\n        }\n        svg {\n          height: 16px;\n          width: 24px;\n        }\n      }\n    }\n    .matches-header {\n      margin: 0px;\n      @media screen and (max-width: @screen-header-collapse) {\n       margin: 0px 0 16px 0;\n      }\n    }\n  }\n\n  .cardbody {\n    overflow: hidden;\n    max-height: none;\n    transition: max-height @transition-speed @transition-fn;\n    .horizontal-tabs-container {\n      margin-top: -15px;\n    }\n    > .ccontent{\n      padding: 20px;\n      &.stats-card {\n        h1 a {\n          color: #ffffff;\n        }\n        .flex-container {\n          align-items: center;\n        }\n      }\n      &.stats-card-mini {\n        padding: 13px 20px;\n      }\n      &.no-top-padding {\n        padding-top: 0 !important;\n      }\n      &.no-padding {\n        padding: 0 !important;\n      }\n    }\n    .dash & > div {\n      text-align: center;\n      max-width: 145px;\n    }\n  }\n  &#communication-preferences {\n    .listbody {\n      flex: 0 0 100%;\n    }\n  }\n  &.open .cardbody {\n    overflow: visible;\n    height: auto;\n    margin: 0;\n  }\n  &.closed .cardbody {\n    height: 0;\n    margin: 0;\n  }\n  & .ccontent.nopadding {\n    padding: 0;\n  }\n  .cardfoot {\n    padding: 20px 15px;\n  }\n\n  .details {\n    font-size: 1.1rem;\n    span {\n      display: inline-block;\n      margin-right: 10px;\n    }\n  }\n\n  .stats {\n    > div {\n      margin: 20px 0;\n    }\n  }\n\n  .contacts {\n    td:first-of-type {\n      font-weight: 700;\n      text-align: right;\n      padding-right: 10px;\n    }\n  }\n  &.tab-container {\n    border: 1px solid @gray-light;\n    border-radius: 3px;\n    .ccontent {\n      padding-left: 0;\n      padding-right: 0;\n    }\n  }\n}\n.withbg{\n  background: #ffffff;\n}\n.grey_25 {\n  background: @grey_25;\n}\n.primary-bg {\n  background: @primary_colour;\n  color: #ffffff;\n  * {\n    color: inherit;\n  }\n  h1 {\n    font-size: 40px;\n    margin: 0;\n  }\n  h3 {\n    margin: 0;\n  }\n  span {\n    color: @grey_500;\n  }\n  strong {\n    font-size: 14px;\n    color: @grey_300;\n    font-weight: 600;\n  }\n  .whatsapp-link svg {\n    stroke: #ffffff;\n    stroke-width: @svg-16-stroke-width !important;\n  }\n  .has-link:hover {\n    color: #ffffff;\n    text-decoration: none;\n  }\n  .heavy.heavy {\n    color: @white;\n    font-weight: 600;\n  }\n  .flex-container {\n    align-items: center;\n    justify-content: flex-start;\n    &.justify-center {\n      justify-content: center;\n    }\n  }\n}\n.justify-center {\n  justify-content: center;\n}\n.justify-between {\n  justify-content: space-between !important;\n}\n\n.agent-card {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex: 1 1 100%;\n  gap: 30px 0;\n  @media screen and (min-width: @screen-header-collapse) {\n    flex: 1 1 240px;\n    max-width: 240px;\n  }\n  padding: 40px 16px;\n  h3 {\n    font-weight: 600;\n    text-align: center;\n    margin: 0 0 10px;\n  }\n  h4 {\n    font-weight: 500;\n  }\n  .avatar-lg > .thumbimg {\n    .circle(120px);\n  }\n  .single-user {\n    margin: 0;\n    justify-content: center;\n  }\n  .agent-details {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    > * {\n      flex: 1 1 100%;\n      text-align: center;\n    }\n    h1 {\n      font-size: 30px;\n      margin-top: 20px;\n    }\n  }\n\n  .agent-links {\n    flex-wrap: wrap;\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n  }\n}\n\n.cardtoggle-jump {\n  height: 37px;\n  flex: 0 0 100%;\n  .btn {\n    left: 0;\n    right: 0;\n    padding: 6px 20px;\n    background: @grey_200;\n    border-radius: 0;\n    transition: none;\n    font-weight: 500;\n    width: 100%;\n    z-index: 99;\n  }\n  &.sticky {\n    .btn {\n      position: fixed;\n      margin: 0;\n      left: 0;\n      right: 0;\n      top: 178px;\n    }\n  }\n}\n\n.stats-filters {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  .form-group:not(.checkinput) {\n    flex: 0 0 auto;\n    .forminput:not(.input-only) {\n      flex: 1 1;\n      border-color: transparent;\n      &:hover, &:focus, &:active, &:focus-within {\n        border-color: transparent;\n        box-shadow: none;\n      }\n      .react-select__control--is-focused {\n        border-color: transparent; // some focus-styling here\n      }\n      .react-select__value-container {\n        padding: 0;\n      }\n      .react-select__control {\n        min-height: 21px;\n        &:hover {\n          cursor: pointer;\n        }\n      }\n      .react-select__input-container {\n        color: transparent; // remove blinking cursor\n      }\n      .react-select__dropdown-indicator {\n        padding: 0;\n      }\n      .react-select__indicators {\n        flex: 0 0;\n      }\n    }\n  }\n\n   @media screen and (max-width: @screen-header-collapse) {\n     display: block;\n   }\n}\n\n.primary-bg {\n  .react-select .react-select__dropdown-indicator svg {\n    stroke: @grey_400;\n  }\n}\n.whatsapp-gray-div {\n  width: 14px;\n  height: 15px\n}\n.force-update + .card {\n  margin-top: 20px;\n}\n\n.hotcoldcard {\n  font-size: 16px;\n  padding-right: 41px;\n  display: flex;\n  font-weight: 900;\n  height:22px;\n  margin-bottom:0px;\n}\n\n.hotcoldvalue {\n  padding-right: 41px;\n  padding-left: 6px;\n}\n\n.hotcoldvalueend {\n  padding-left: 6px;\n}","// main: ../framework.less\n\n.banner {\n  display: flex;\n  flex-direction: column;\n  border-radius: @card-radius;\n  padding: 20px;\n  gap: 16px;\n  background: @white;\n  .banner-heading {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 16px;\n    flex: none;\n    align-self: stretch;\n    flex-grow: 0;\n    .btn-banner-close {\n      padding: 0;\n      min-height: unset;\n    }\n    h3 {\n      margin: 0;\n      display: flex;\n      align-items: center;\n      flex: none;\n      flex-grow: 1;\n    }\n  }\n  &.quality {\n    background: @quality_25;\n  }\n  &.success {\n    background: @success_25;\n  }\n  &.info {\n    background: @info_25;\n  }\n  &.error {\n    background: @error_50;\n  }\n}","// main: ../framework.less\n\n.tab-content {\n  display: grid;\n  grid-area: tab-content;\n  padding: 20px;\n  padding-top: 0;\n  gap: 20px;\n  min-width: 0;\n  min-height: 0;\n  grid-template-rows: auto minmax(min-content, max-content);\n  align-content: flex-start;\n  > .portals {\n    max-width: calc(100vw - 40px);\n  }\n  &.tab-details, &.tab-notes {\n    padding: 0;\n    gap: 0;\n    grid-template-areas: \"jump-menu\" \"details\";\n    grid-template-rows: auto 1fr;\n    min-height: 0;\n    @media screen and (min-width: @screen-header-collapse) {\n      grid-template-areas: \"jump-menu details\";\n      grid-template-columns: 260px 1fr;\n      grid-template-rows: 1fr;\n      gap: 20px 20px;\n    }\n  }\n  &.tab-notes {\n    @media screen and (min-width: @screen-header-collapse) {\n      grid-template-areas: \"jump-menu details\";\n      grid-template-columns: 370px 1fr;\n      grid-template-rows: 1fr;\n    }\n  }\n  &.tab-activity {\n    padding: 0;\n  }\n  &.tab-design {\n    gap: 0;\n  }\n  &.tab-stage {\n    gap: 0;\n  }\n  .stepper {\n    &:empty {\n      height: 0;\n    }\n    + div {\n      min-width: 0;\n    }\n  }\n}\n\n.horizontal-tabs-container {\n  display: grid;\n  grid-template-areas: \"tabs\" \"tab-content\";\n  grid-template-rows: auto 1fr;\n  padding-left: 0;\n  min-height: 0;\n  flex: 1 0 100%;\n  .horizontal-tabs-wrapper {\n    grid-area: tabs;\n    min-width: 0;\n    display: flex;\n    @media screen and (min-width: @screen-header-collapse) {\n      max-width: calc(100vw - 64px);\n    }\n    .for-scroll {\n      display: none;\n    }\n\n    .horizontal-tabs-content {\n      display: flex;\n      gap: 0 5px;\n      flex: 1 1 auto;\n      padding: 14px 40px 15px 10px;\n      @media screen and (min-width: @screen-header-collapse) {\n        padding: 14px 20px;\n      }\n    }\n    .horizontal-tabs-nav {\n      display: flex;\n      flex: 1 1 100%;\n      max-width: 100vw;\n      @media screen and (min-width: @screen-header-collapse) {\n        max-width: calc(100vw - 64px);\n      }\n      &.has-scroll {\n        .horizontal-tabs-content {\n          &:after {\n            content: \"\";\n            flex: 0 0 10px;\n            width: 20px;\n            order: 9999999\n          }\n        }\n        .scroll-left{\n          display: flex;\n          justify-content: flex-start;\n          align-items: center;\n          background: @grey_50;\n          left: 0;\n          height: 66px;\n          button {\n            margin: 0 10px 0 20px;\n          }\n          svg {\n            height: 100%;\n            width: 24px;\n            fill: none;\n            stroke: @primary_colour;\n            stroke-width: @svg-24-stroke-width;\n          }\n          &:before {\n            content: \"\";\n            z-index: 1;\n            background: linear-gradient(to right, fade(@grey_50, 100%), fade(@grey_50, 0) 100%);\n            position: absolute;\n            left: 100%;\n            width: 10px;\n            bottom: 0;\n            top: 0;\n            pointer-events: none;\n          }\n        }\n        .scroll-right{\n          display: flex;\n          justify-content: flex-end;\n          align-items: center;\n          background: @grey_50;\n          right: 0;\n          height: 66px;\n          button {\n            margin: 0 20px 0 10px;\n          }\n          svg {\n            height: 100%;\n            width: 24px;\n            fill: none;\n            stroke: @primary_colour;\n            stroke-width: @svg-24-stroke-width;\n          }\n          &:after {\n            content: \"\";\n            z-index: 1;\n            background: linear-gradient(to right, fade(@grey_50, 0), fade(@grey_50, 100%) 100%);\n            position: absolute;\n            right: 100%;\n            width: 10px;\n            bottom: 0;\n            top: 0;\n            pointer-events: none;\n          }\n        }\n        .nav:before {\n          content: \"\";\n          flex: 0 0 15px;\n          background: none;\n          order: 0\n        }\n        .nav:after {\n          content: \"\";\n          flex: 0 0 15px;\n          background: none;\n          order: 9999999\n        }\n      }\n    }\n    .btn.btn-none.active {\n      background: @primary_colour;\n      color: @white;\n    }\n  }\n}","// main: ../framework.less\n/* Action Buttons */\n.viewhead {\n  position: sticky;\n  top: 0;\n  max-width: 100vw;\n  @media screen and (min-width: @screen-header-collapse) {\n    max-width: calc(100vw - 64px);\n  }\n  background: @white;\n  border-top: 1px solid @shadow-color;\n  border-bottom: 1px solid @shadow-color;\n  grid-area: actions;\n  z-index: 100;\n  + div {\n    grid-area: view;\n  }\n  .track-vertical {\n    display: none;\n  }\n  .track-horizontal {\n    right: 2px;\n  }\n  .scrollview {\n    display: flex;\n  }\n}\n.canvashead {\n  position: sticky;\n  top: 0;\n  max-width: 100vw;\n  @media screen and (min-width: @screen-header-collapse) {\n    max-width: calc(100vw);\n  }\n  background: @primary_colour;\n  grid-area: actions;\n  z-index: 100;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: space-between;\n  padding: 0 32px;\n  .track-vertical {\n    display: none;\n  }\n  .track-horizontal {\n    right: 2px;\n  }\n  .scrollview {\n    display: flex;\n  }\n\n  .pd-logo {\n    width: 208px;\n    height: 54px;\n    flex: 0 0 208px;\n    margin-left: 10px;\n    color: #071B38;\n    background-image: url(\"../../images/pd-logo-white.svg\");\n    background-size: cover;\n  }\n  .lightstone-logo {\n    width: 146px;\n    height: 49px;\n    flex: 0 0 146px;\n    color: #071B38;\n    background-image: url(\"../../images/lightstone.svg\");\n    background-size: contain;\n    background-position: center center;\n    background-repeat: no-repeat;\n  }\n  .pd-callnow {\n    display: flex;\n    align-items: center;\n    align-content: center;\n    text-align: right;\n    color: #ffffff;\n    a {\n      color: #ffffff;\n      text-decoration: underline;\n      &:hover {\n        color: #ffffff;\n        text-decoration: underline;\n      }\n    }\n  }\n}\n.canvas-footer {\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: space-between;\n  padding: 0 20px 20px;\n  .pd-logo {\n    width: 208px;\n    height: 54px;\n    flex: 0 0 208px;\n    color: #071B38;\n    background-image: url(\"../../images/pd-logo.svg\");\n    background-size: cover;\n  }\n  .pd-callnow {\n    display: flex;\n    align-items: center;\n    align-content: center;\n    text-align: right;\n  }\n}\n.action-bar{\n  display: flex;\n  > div {\n    flex: 1 1 auto;\n    max-width: 100%;\n  }\n  > .pagestep{\n    flex: 0 0 auto;\n    margin-right: 0;\n  }\n  // @media screen and (max-width: @screen-header-collapse) {\n  //   flex-wrap: wrap;\n  //   .pagestep {\n  //     margin-top: 1.25rem;\n  //     margin-left: 8px;\n  //     margin-right: 0;\n  //     flex: 1 1 100%;\n  //     .firstpage {\n  //       margin-left: auto;\n  //     }\n  //   }\n  // }\n}\n.sticky-outer-wrapper {\n  &.active {\n    .sticky-inner-wrapper {\n      z-index: 100;\n      right: 0;\n      left: 64px;\n      width: auto !important;\n      .actionswrap {\n        background: @white;\n        margin: 0;\n      }\n    }\n  }\n}\n.actionswrap {\n  z-index: 100;\n  display: grid;\n  grid-template-columns: 0 1fr 0;\n  gap: 20px;\n  grid-template-areas: \"left scroll right\";\n  flex: 1 1 auto;\n  > div:not(.scroll-left):not(.scroll-right) {\n    grid-area: scroll;\n  }\n  &.has-scroll {\n    gap: 0;\n    touch-action: pan-x;\n    grid-template-columns: 60px 1fr 60px;\n    * {\n      touch-action: pan-x;\n    }\n    .action-list {\n      padding-right: 0;\n    }\n    .scroll-left{\n      display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      background: @white;\n      position: relative;\n      height: 66px;\n      grid-area: left;\n      button {\n        margin: 0 10px 0 20px;\n      }\n      svg {\n        height: 100%;\n        width: 24px;\n        fill: none;\n        stroke: @primary_colour;\n        stroke-width: @svg-24-stroke-width;\n      }\n      &:before {\n        content: \"\";\n        z-index: 1;\n        background: linear-gradient(to right, fade(@white, 100%) 20%, fade(@white, 0) 100%);\n        position: absolute;\n        left: 100%;\n        width: 10px;\n        bottom: 0;\n        top: 0;\n        pointer-events: none;\n      }\n    }\n    .scroll-right{\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n      background: @white;\n      position: relative;\n      height: 66px;\n      grid-area: right;\n      button {\n        margin: 0 20px 0 10px;\n      }\n      svg {\n        height: 100%;\n        width: 24px;\n        fill: none;\n        stroke: @primary_colour;\n        stroke-width: @svg-24-stroke-width;\n      }\n      &:after {\n        content: \"\";\n        z-index: 1;\n        background: linear-gradient(to right, fade(@white, 0), fade(@white, 100%) 100%);\n        position: absolute;\n        right: 100%;\n        width: 10px;\n        bottom: 0;\n        top: 0;\n        pointer-events: none;\n      }\n    }\n    .nav:before {\n      content: \"\";\n      flex: 0 0 15px;\n      background: none;\n      order: 0\n    }\n    .nav:after {\n      content: \"\";\n      flex: 0 0 15px;\n      background: none;\n      order: 9999999\n    }\n  }\n  &.sticky {\n    background: @white;\n    margin: 0;\n    position: fixed;\n    right: 0;\n    top: 60px;\n  }\n  .action-list {\n    grid-template: scroll;\n    display: flex;\n    justify-content: flex-start;\n    white-space: nowrap;\n    padding: 0 40px 0 10px;\n    top: 0;\n    gap: 0 5px;\n    flex: 1 1 auto;\n    &:after {\n      content: \"\";\n      flex: 0 0 5px;\n      width: 10px;\n      order: 9999999\n    }\n    @media screen and (min-width: @screen-header-collapse) {\n      justify-content: flex-end;\n      padding: 0 0;\n      &:after {\n        flex: 0 0 0;\n      }\n    }\n    .navitem {\n      margin-top: 14px;\n      margin-bottom: 15px;\n    }\n    .add {\n      margin-right: auto;\n    }\n    .list {\n      order: 0;\n      margin-right: auto;\n      @media screen and (min-width: @screen-header-collapse) {\n        .viewhead:not(.details) & {\n          margin-right: 0;\n        }\n      }\n    }\n    .save {\n      order: 999;\n    }\n    .cancel {\n      order: 1000;\n    }\n    .card-legend {\n      order: 1;\n      margin-right: auto;\n    }\n    .cardtoggle-required{\n      display: flex;\n      align-items: center;\n      gap: 0 5px;\n      order: 2;\n    }\n    .submenu-icon{\n      margin-left: 5px;\n      margin-right: 0;\n      svg {\n        stroke: @primary_colour;\n        stroke-width: @svg-24-stroke-width;\n        min-width: 24px;\n        height: 24px;\n      }\n    }\n    // .navicon{\n    //   svg{\n    //     margin: 0;\n    //     @media (min-width: @screen-header-collapse) {\n    //       margin: 0 0.5em 0 0;\n    //     }\n    //     display: inline-block;\n    //     vertical-align: middle;\n    //     line-height: 1em;\n    //     height: 13px;\n    //     fill: #444;\n    //   }\n    // }\n    > .has-submenu {\n      display: flex;\n      flex: 0 0 auto;\n      padding: 0;\n      .btn {\n        padding-right: 10px;\n      }\n      @media (min-width: @screen-header-collapse) {\n        flex-wrap: nowrap;\n      }\n      // > .navitem {\n      //   display: flex;\n      //   min-height: 36px;\n      //   flex-wrap: wrap;\n      //   min-width: 0;\n      //   cursor: pointer;\n      //   @media (min-width: @screen-header-collapse) {\n      //     flex-wrap: nowrap;\n      //   }\n      //   padding: 0.375rem 0.75rem;\n      //   justify-content: center;\n      //   align-items: center;\n      //   color: #333;\n      //   font-weight: inherit;\n      //   margin-right: 0;\n      //   border-radius: @border-radius 0 0 @border-radius;\n      //   transition: all 0.2s ease-in-out 0s;\n      //   .navicon{\n      //     display: inline-block;\n      //     vertical-align: middle;\n      //     text-align: center;\n      //     line-height: 1em;\n      //   }\n      //   .label{\n      //     line-height: inherit;\n      //     height: auto;\n      //     vertical-align: middle;\n      //   }\n      //   &:hover {\n      //     background-color: #efefef;\n      //   }\n      // }\n      //   flex: 1 1 auto;\n      //   display: flex;\n      //   align-items: center;\n      //   border-left: @default-button-border;\n      //   min-height: 36px;\n      //   @media (min-width: @screen-header-collapse) {\n      //     padding: 0.375rem 0.75rem;\n      //   }\n      //   padding: 0.375rem 0.25rem;\n      //   width: auto;\n      //   text-align: center;\n      //   color: #333;\n      //   border-radius: 0 @border-radius @border-radius 0;\n      //   svg {\n      //     fill: none;\n      //     stroke: @primary_colour;\n      //     // fill: #444;\n      //   }\n      //   &:hover {\n      //     background-color: inherit;\n      //     border-left: 1px solid inherit;\n      //     // svg {\n      //     //   fill: #FFF;\n      //     // }\n      //   }\n      }\n    }\n    // > .navitem {\n    //   display: flex;\n    //   flex: 0 0 auto;\n    //   flex-wrap: wrap;\n    //   cursor: pointer;\n    //   justify-content: center;\n    //   align-items: center;\n    //   background: #ffffff;\n    //   border: @default-button-border;\n    //   padding: 0.375rem 0.75rem;\n    //   vertical-align: middle;\n    //   line-height: 1.5;\n    //   color: #444;\n    //   margin-right: 5px;\n    //   min-height: 36px;\n    //   box-sizing: border-box;\n    //   border-radius: @border-radius;\n    //   transition: all 0.2s ease-in-out 0s;\n    //   &:hover {\n    //     background-color: #efefef;\n    //   }\n    //   @media (min-width: @screen-header-collapse) {\n    //     flex-wrap: nowrap;\n    //   }\n    //   & > * {\n    //     background: none;\n    //   }\n    //   &.save {\n    //     order: 0;\n    //     margin-left: auto;\n    //     // .btn-primary.btn-primary();\n    //     > .navitem .label {\n    //       color: contrast(@brand-primary, #444444, #ffffff);\n    //     }\n    //     .navicon svg path {\n    //       fill: contrast(@brand-primary, #444444, #ffffff);\n    //     }\n    //     &.disabled .navicon svg path {\n    //         fill: #fff;\n    //     }\n    //     @media (min-width: @screen-header-collapse) {\n    //       order: 999999;\n    //     }\n    //     .label {\n    //       color: #fff;\n    //     }\n    //   }\n    //   .navicon{\n    //     flex: 1 1 auto;\n    //     padding: 0;\n    //     min-width: 0;\n    //     @media (min-width: @screen-header-collapse) {\n    //       flex: 1 1 auto;\n    //     }\n    //     display: inline-block;\n    //     vertical-align: middle;\n    //     text-align: center;\n    //     line-height: 0.5em;\n    //   }\n    //   .label{\n    //     flex: 1 1 100%;\n    //     min-width: 0;\n    //     display: inline-block;\n    //     @media (min-width: @screen-header-collapse) {\n    //       flex: 1 1 auto;\n    //     }\n    //     line-height: inherit;\n    //     height: auto;\n    //     vertical-align: middle;\n    //     text-align: center;\n    //     color: #444;\n    //   }\n\n    // }\n    // > .navitem.disabled {\n    //   color: #ccc;\n    // }\n    // > .navitem.disabled .label {\n    //   color: #fff;\n    // }\n    // > .navitem.disabled svg {\n    //   fill: #ccc;\n    // }\n  @media (min-width: @screen-header-collapse) {\n    .full & {\n      left: @sidebar-width-md;\n    }\n  }\n  @media (max-width: @screen-header-collapse) {\n    .full & {\n      left: 0;\n    }\n    .mini & {\n      left: 0;\n    }\n    &.down {\n      transform: translate3d(0, 0, 0);\n      transition: all @transition-speed @transition-fn;\n      top: 0;\n    }\n    &.up {\n      transform: translate3d(0, 0, 0);\n      transition: all @transition-speed @transition-fn;\n      top: 60px;\n    }\n  }\n}\n\n.context-sidebar {\n  .action-submenu{\n    border-top: 0;\n    width: 100%;\n    display: flex;\n    strong {\n      display: block;\n      padding: 0 0 0 0.8em;\n      line-height: 2em;\n    }\n    .action-sub-item{\n      display: block;\n      padding: 0 0.8em;\n      cursor: pointer;\n      background: none;\n      border: 0 none;\n    }\n  }\n  .nav {\n    > .navitem.disabled {\n      color: #ccc;\n    }\n    > .navitem.disabled svg {\n      fill: #ccc;\n    }\n  }\n}\n\n.action-submenu-cover-wrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n  .action-submenu-cover {\n    margin-top: 10px;\n    z-index: 101;\n    transition: top @transition-speed @transition-fn;\n  }\n  .action-submenu-cover-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 10;\n    transform: translateZ(0);\n    background-color: rgba(0,0,0,0);\n  }\n  .action-submenu {\n    background: #ffffff;\n    margin-top: 3px;\n    border: 1px solid @grey_200;\n    border-radius: @input-border-radius;\n    strong {\n      display: block;\n      padding: 0.75rem 0.8em;\n    }\n    .action-sub-item{\n      display: block;\n      padding: 0.75rem 0.8em;\n      cursor: pointer;\n      background: #fff;\n      border: 0 none;\n      width: 100%;\n      text-align: left;\n      text-decoration: none;\n      color: @text;\n      &:hover {\n        background-color: @grey_50;\n      }\n    }\n  }\n}\n","// main: ../framework.less\n\n.thumb {\n  display: inline-block;\n  .circle(150px);\n  overflow: hidden;\n  background-color: #efefef;\n  transition: all 0.3s ease 0s;\n  &.small, &.small .thumbimg {\n    .circle(@agent-thumb-size-small);\n  }\n  .thumbimg {\n    display: inline-block;\n    .circle(@agent-thumb-size);\n    background-color: #f5f5f5;\n    background-position: center center;\n    background-size: cover;\n    transition: all 0.3s ease 0s;\n    transform: scale(1) translateZ(1000px);\n    svg {\n      width: 100%;\n      height: 100%;\n    }\n  }\n  &:hover {\n    box-shadow: -1px 1px 3px 0px rgba(0,0,0,0.2), 1px -1px 3px 0px rgba(0,0,0,0.2);\n  }\n  &:hover .thumbimg {\n    transform: scale(1.15) translateZ(1000px);\n  }\n}\n.agent {\n  display: flex;\n  text-align: left;\n  margin-right: 20px;\n}\n.single-user.agent .thumb {\n  display: block;\n}\n\n","// main: ../framework.less\n.branchagents, .teammembers {\n  display: flex;\n  > .row {\n    flex-grow: 1;\n    > .col {\n      flex-grow: 0;\n    }\n  }\n  h3 {\n    box-sizing: border-box;\n    padding: 0 15px;\n    margin-top: 30px;\n    line-height: 22px;\n    min-height: 2em;\n  }\n  .agents {\n    display: flex;\n  }\n  .agent {\n    padding: 0 15px;\n    margin-top: 15px;\n    justify-content: center;\n  }\n  @media (max-width: @screen-header-collapse) {\n    > .row .col {\n      flex-grow: 1;\n    }\n  }\n  @media (min-width: @screen-header-collapse) {\n    h3 {\n      margin-top: 0;\n    }\n    .agent {\n      margin: 0;\n    }\n  }\n}\n\n.branchstats {\n  margin: 30px 0;\n  .row {\n    justify-content: flex-start;\n  }\n  .singlestat {\n    text-align: left;\n    flex: 0 1 200px;\n    max-width: none;\n    @media (max-width: @screen-header-collapse) {\n      flex: 0 1 300px;\n      text-align: center;\n    }\n    &:last-of-type {\n      margin-right: auto;\n    }\n    h1 {\n      color: @brand-primary;\n      margin: 15px 0 0;\n      line-height: 1;\n    }\n    h4 {\n      font-size: 1.5rem;\n      margin: 0;\n    }\n    p {\n      font-size: 1.1rem;\n      margin: 0;\n    }\n    svg {\n      width: 80px;\n      height: auto;\n      fill: @content-text;\n    }\n  }\n}\n\n.branchmap {\n  max-height: 280px;\n  width: 100%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  position: relative;\n  img {\n    width: 100%;\n  }\n}\n\n.pie-graph{\n  margin-top: 60px;\n  padding: 0 15px;\n  font-size: 1rem;\n  flex: 1 1 360px;\n  display: flex;\n  flex-wrap: wrap;\n  @media screen and (min-width: @screen-header-collapse) {\n    margin-top: 30px;\n    max-width: 360px;\n  }\n  svg {\n    margin: 0;\n    @media screen and (min-width: @screen-header-collapse) {\n      padding: 0 15px 0 0;\n    }\n  }\n  h4 {\n    flex: 0 0 100%;\n  }\n  &-wrapper{\n    flex: 1 1 100%;\n    display: flex;\n    flex-wrap: wrap;\n    @media screen and (min-width: @screen-header-collapse) {\n      margin-top: 0;\n      flex-wrap: nowrap;\n    }\n  }\n\n  &-legend{\n    margin-top: 16px;\n    padding: 0;\n    li{\n      list-style: none;\n      white-space: nowrap;\n      .pie-graph-legend-color{\n        display: inline-block;\n        width: 16px;\n        height: 16px;\n        vertical-align: middle;\n        margin-right: 3px;\n      }\n      span{\n        display: inline-block;\n        vertical-align: middle;\n        margin-right: 10px;\n      }\n    }\n  }\n}","// main: ../framework.less\n.login {\n  .content {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    flex-wrap: nowrap;\n    overflow: auto;\n  }\n  .overlay {\n    display: none;\n    background-image: url(\"../../images/bg.webp\");\n    .webp & { background-image: url(\"../../images/bg.webp\"); }\n    .no-webp & { background-image: url(\"../../images/bg.jpg\"); }\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center center;\n    width: 100%;\n    min-height: 100%;\n    &:after {\n      content: \"\";\n      position: absolute;\n      top: 30%;\n      right: 5%;\n      background-image: url(\"../../images/dots.svg\");\n      background-repeat: no-repeat;\n      width: 180px;\n      height: 180px;\n    }\n    @media (min-width: @screen-header-collapse) {\n      display: block;\n      width: 100%;\n      min-height: 100%;\n      z-index: -1;\n    }\n  }\n  .pd-logo {\n    width: 208px;\n    height: 54px;\n    flex: 0 0 208px;\n    background-image: url(\"../../images/pd-logo.svg\");\n  }\n  .content-wrapper {\n    flex: 1 1 40%;\n    position: relative;\n    min-width: 320px;\n    min-height: 100%;\n    display: grid;\n    grid-template-rows: auto 92px;\n    align-items: center;\n    flex-wrap: wrap;\n    background: @white;\n  }\n  .login-box, .welcome, .agentselector {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-content: center;\n    flex: 1 1 100%;\n  }\n  .login-box, .agentselector {\n    overflow: hidden;\n    margin: 0 0;\n    padding-top: 30px;\n    padding-bottom: 30px;\n    .scrollview {\n      &:after {\n        content: \"\";\n        height: 30px;\n        background-image: linear-gradient(to bottom, fade(@white, 0), fade(@white, 100%) 95%);\n        position: sticky;\n        display: block;\n        bottom: 0;\n        left: 0;\n        right: 0;\n      }\n    }\n  }\n  .welcome {\n    h2, h1 {\n      color: #ffffff;\n      background-color: #FC495D;\n      font-weight: 500;\n      padding: 10px 15px;\n      display: inline-block;\n      margin-top: 10px;\n    }\n  }\n  .form-group {\n    position: relative;\n    margin-bottom: 24px;\n  }\n  .forgot {\n    margin-top: 1px;\n    margin-left: auto;\n    font-size: 12px;\n    color: @text;\n    &.float-right {\n      margin-left: 0;\n    }\n  }\n  .login-box {\n    text-align: center;\n    background: #ffffff;\n    height: 650px;\n    h3 {\n      color: @primary_colour;\n      flex: 1 1 100%;\n      font-weight: 500;\n      padding: 20px 0 0;\n      span {\n        font-weight: 600;\n      }\n    }\n    &-buttons {\n      display: flex;\n      align-items: center;\n      justify-content: flex-end;\n      a {\n        margin-right: auto;\n      }\n    }\n    form {\n      width: 100%;\n    }\n    &-body {\n      background: #ffffff;\n      padding: 20px 10%;\n      border-top: 0;\n      max-width: 100%;\n      width: 100%;\n      min-height: 95px;\n      p:first-of-type {\n        margin-bottom: 30px;\n      }\n      .form-control-feedback {\n        color: #777;\n      }\n      .box-header, .box-header span {\n        text-align: center;\n        h3 {\n          display: inline-block;\n        }\n      }\n    }\n    .message {\n      background-color: #fff;\n      font-size: 1.1rem;\n      width: 100%;\n      color: #fff;\n      margin-top: 30px;\n      padding: 10px;\n      &.error {\n        background-color: @error;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n      &.success {\n        background-color: @success;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n    }\n    .social-logins {\n      text-align: center;\n      padding-top: 0;\n      padding-bottom: 0;\n      display: flex;\n      flex-wrap: wrap;\n      gap: 30px;\n      span {\n        color: @grey_500;\n        font-size: 14px;\n        flex: 0 0 100%;\n      }\n      > div {\n        flex: 0 0 100%;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        gap: 15px;\n      }\n      a {\n        flex: 1 1 auto;\n        height: 44px;\n        border: 1px solid #E5EBF1;\n        border-radius: @input-border-radius;\n        color: @primary_colour;\n        font-weight: 600;\n        font-size: 16px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        svg {\n          flex: 0 0 20px;\n          height: 20px;\n          margin-right: 8px;\n        }\n      }\n      a:hover {\n        background-color: @gray-lighter;\n      }\n    }\n  }\n\n\n  .footer {\n    min-height: @footer-height;\n    background: none;\n    display: flex;\n    flex-wrap: wrap;\n    align-content: center;\n    justify-content: center;\n    padding: 0.75rem 15px;\n    margin: 0;\n    color: @grey_400;\n    a {\n      color: @grey_400;\n    }\n  }\n  .login-box-footer {\n    background: #fff;\n    margin: auto 0 0;\n    justify-content: center;\n    flex-wrap: wrap;\n    padding: 0 20px 20px 20px;\n    display: flex;\n    bottom: 50px;\n    left: 0;\n    right: 0;\n    > a {\n      text-align: center;\n      color: @secondary_colour;\n    }\n  }\n  .help-text{\n    margin-bottom: 0;\n    .fa-question-circle{\n      font-size: 38px;\n      margin-right: 5px;\n    }\n  }\n\n  .agentselector {\n    background-color: #fff;\n    text-align: center;\n    justify-content: center;\n    h3 {\n      margin: 0 ;\n      padding: 10px 0;\n    }\n    .agent-option {\n      align-items: center;\n      display: flex;\n      box-shadow: 0px 1px 0px #E5EBF1;\n      max-width: 100%;\n      overflow: hidden;\n      &:first-of-type {\n        border-top: none;\n      }\n      &:hover {\n        cursor: pointer;\n      }\n      > div {\n        padding: 10px 20px;\n        color: @grey_300;\n        font-size: 11px;\n        .site-name {\n          text-transform: uppercase;\n          font-weight: 600;\n        }\n        .site-domain {\n          font-weight: 500;\n        }\n        // Add the settings for the added css site-mail:\n        .site-email {\n          font-weight: 500;\n        }\n        svg {\n          fill: @secondary_colour;\n          stroke: none;\n        }\n        &:first-of-type {\n          padding: 0px;\n          padding-left: 20px;\n        }\n        &:last-of-type {\n          text-align: left;\n        }\n      }\n    }\n    .notfound {\n      align-items: center;\n      flex-direction: column;\n      font-size: 1.2rem;\n      padding: 20px 0;\n      h4 {\n        font-size: 1.3rem;\n        padding: 10px 0;\n        display: block;\n      }\n    }\n  }\n}\n","// main: ../framework.less\n\n.timeline{\n  padding-bottom: 60px;\n  position: relative;\n  &-bar {\n    text-align: center;\n    position: absolute;\n    width: 50px;\n    top: 0;\n    bottom: 5px;\n    &:before {\n      content:\"\";\n      height: 100%;\n      display: inline-block;\n      width: 3px;\n      background: @grey;\n    }\n\n    &:after {\n      content:\"\";\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      height: 50px;\n      background-image: linear-gradient(to bottom, transparent, @grey_50);\n    }\n  }\n  &-heading {\n    padding-left: 50px;\n    padding-right: 15px;\n    padding-top: 20px;\n    margin-top: 0;\n    margin-bottom: 30px;\n    margin-left: 0;\n    min-width: 0;\n  }\n\n  &-event {\n    display: flex;\n    flex-wrap: nowrap;\n    padding-right: 20px;\n    &-day {\n      text-align: center;\n      position: relative;\n      padding: 0;\n      z-index: 1;\n      margin-top: 14px;\n      min-width: 50px;\n      flex: 0 0 50px;\n      color: @brand-primary;\n      &:before {\n        content:\"\";\n        background: #fff;\n        width: 14px;\n        height: 14px;\n        position: absolute;\n        left: 50%;\n        top: 0;\n        margin-left: -7px;\n        margin-top: -12px;\n        border-radius: 50%;\n        box-shadow: @card-shadow;\n      }\n      &:after {\n        content:\"\";\n        background: @secondary_colour;\n        width: 8px;\n        height: 8px;\n        position: absolute;\n        left: 50%;\n        top: 0;\n        margin-left: -4px;\n        margin-top: -9px;\n        border-radius: 50%;\n        box-shadow: @card-shadow;\n      }\n    }\n    &-card {\n      flex: 1 1 auto;\n      padding: 0;\n      min-width: 0;\n      .cardhead {\n        margin-left :-15px;\n        margin-right :-15px;\n      }\n      .card {\n        overflow: hidden;\n      }\n      &-right {\n        min-width: 0;\n      }\n      &-header {\n        display: flex;\n        align-items: center;\n        font-size: 12px;\n        font-weight: 600;\n        color: @grey_300;\n        padding: 0 0 10px 0;\n      }\n      &-changes {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 12px 0;\n        > div {\n          flex: 0 0 100%;\n        }\n      }\n      &-body {\n        display: flex;\n        color: @grey_400;\n        h4 {\n          padding: 5px 0 5px 0;\n        }\n        h5 {\n          color: @gray;\n          padding: 0px 0 20px 0;\n        }\n        code, pre {\n          background: @grey_50;\n          padding: 2px 5px;\n          line-height: 1.2em;\n          ul {\n            padding-top: 0;\n            margin: 0;\n            margin-bottom: 5px;\n            background: @grey_50;\n          }\n        }\n        strong {\n          color: @primary_colour;\n        }\n        .agent {\n          .thumbimg {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n          }\n        }\n      }\n      &-footer {\n        display: flex;\n        align-items: center;\n        font-size: 11px;\n        color: @gray;\n        padding: 0;\n        font-weight: 600;\n        padding-top: 20px;\n      }\n      .notebody {\n        padding-bottom: 15px;\n        font-size: 1.2rem;\n        > p {\n          font-size: inherit;\n        }\n      }\n    }\n  }\n}\n\n.noteauthor, .noteauthor a {\n    color: @grey_300;\n    font-size: 11px;\n    font-weight: 600;\n}\n\n.wide-sidebar-pane .activity {\n  padding-left: 15px;\n  .timeline-bar {\n    &:after {\n      content:\"\";\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      height: 60px;\n    }\n  }\n}","// main: ../framework.less\n\n.pdfcontainer {\n  &-nav {\n    flex-wrap: wrap;\n    display: flex;\n    justify-content: space-between;\n    margin-left: -15px;\n    margin-right: -15px;\n    padding: 0 15px;\n    .btn-highlight {\n      text-align: center;\n    }\n    .nav-group {\n      display: flex;\n      gap: 10px 5px;\n      &:nth-of-type(2) {\n        @media (max-width: @screen-header-collapse) {\n          display: none;\n        }\n      }\n      .btn-icon-only {\n        min-width: 38px;\n        max-width: 38px;\n        min-height: 38px;\n        max-height: 38px;\n        justify-content: center;\n      }\n    }\n    .seperator {\n      margin: 0 10px;\n      width: 0;\n      border-right: @input-border;\n    }\n    .form-group {\n      margin: 0;\n    }\n    .page {\n      display: flex;\n      flex-wrap: nowrap;\n      align-items: center;\n      white-space: nowrap;\n      justify-content: center;\n      margin-right: 15px;\n      &.form-group .forminput {\n        flex: 1 1 auto;\n        margin-left: 3px;\n        margin-right: 3px;\n      }\n      .page-jump {\n        width: 36px;\n        min-width: 36px;\n        max-width: 36px;\n        text-align: center;\n      }\n    }\n    .zoom {\n      min-width: 150px;\n    }\n  }\n}\n\n.react-pdf {\n  overflow: auto;\n  cursor: grab;\n  .text-center {\n    display: flex;\n    min-height: 68px;\n    justify-content: center;\n    align-items: center;\n    flex-wrap: wrap;\n    .message {\n      flex: 0 0 100%;\n    }\n  }\n  &__Highlighting {\n    cursor: auto;\n  }\n  &__Scrolling {\n    cursor: grabbing;\n  }\n  &__Document {\n    text-align: center;\n    padding: 20px 0;\n  }\n  &__Page {\n    margin: 20px;\n    display: inline-block;\n    text-align: initial;\n    border: 1px solid rgba(0,0,0,0.14);\n    box-shadow: 8px 8px 16px -2px rgba(0,0,0,0.14);\n  }\n  &__Page__annotations {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    overflow: hidden;\n    opacity: 0.2;\n    line-height: 1.0;\n    > section {\n      color: transparent;\n      position: absolute;\n      white-space: pre;\n      cursor: text;\n      transform-origin: 0% 0%;\n    }\n    > .linkAnnotation > a {\n      position: absolute;\n      font-size: 1em;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n    }\n  }\n}\n.no-pdf {\n  background: @grey_50;\n  border-radius: @input-border-radius;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 40px 0;\n}","// main: ../framework.less\n/*!\n jodit - Jodit is awesome and usefully wysiwyg editor with filebrowser\n Author: Chupurnov <chupurnov@gmail.com> (https://xdsoft.net/)\n Version: v3.2.44\n Url: https://xdsoft.net/jodit/\n License(s): GPL-2.0-or-later\n*/\n\n.jodit,\n.jodit *,\n.jodit_container,\n.jodit_container * {\n box-sizing:border-box\n}\n.jodit .jodit_workplace,\n.jodit_container .jodit_workplace {\n position:relative;\n overflow:auto\n}\n.jodit .jodit_workplace .jodit_wysiwyg,\n.jodit .jodit_workplace .jodit_wysiwyg_iframe,\n.jodit_container .jodit_workplace .jodit_wysiwyg,\n.jodit_container .jodit_workplace .jodit_wysiwyg_iframe {\n height:100%;\n width:100%\n}\n.jodit_container:not(.jodit_inline) {\n background:#fff;\n font-size:14px;\n font-family:Helvetica,sans-serif\n}\n.jodit_container:not(.jodit_inline).jodit_disabled {\n background:hsla(0,0%,88%,.99)\n}\n.jodit_container:not(.jodit_inline).jodit_disabled .jodit_workplace {\n opacity:.4\n}\n.jodit_container:not(.jodit_inline) .jodit_workplace {\n border:1px solid #ccc\n}\n.jodit_disabled {\n -webkit-user-select:none!important;\n -moz-user-select:none!important;\n -ms-user-select:none!important;\n user-select:none!important\n}\n.jodit_hidden {\n display:none!important\n}\n.jodit_wysiwyg {\n outline:0\n}\n.jodit_wysiwyg::-moz-selection,\n.jodit_wysiwyg ::-moz-selection {\n background:#b5d6fd;\n color:#000\n}\n.jodit_wysiwyg::selection,\n.jodit_wysiwyg ::selection {\n background:#b5d6fd;\n color:#000\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg {\n margin:0;\n padding:10px;\n outline:0;\n overflow-x:auto;\n position:relative\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg img {\n position:relative;\n max-width:100%\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg p,\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg pre {\n margin:0 0 10px\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg h1,\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg h2,\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg h3,\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg h4,\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg h5 {\n margin-top:0\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg blockquote {\n border-left:2px solid #222;\n margin-left:0;\n padding-left:5px;\n color:#222\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg jodit-media {\n position:relative\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg jodit-media * {\n position:relative;\n z-index:0\n}\n.jodit_container:not(.jodit_inline) .jodit_wysiwyg jodit-media:before {\n z-index:1;\n content:\"\";\n position:absolute;\n top:0;\n left:0;\n right:0;\n bottom:0\n}\n.jodit_clearfix:after,\n.jodit_clearfix:before {\n content:\" \";\n display:table\n}\n.jodit_clearfix:after {\n clear:both\n}\n.jodit_dark_theme.jodit_container,\n.jodit_dark_theme.jodit_container.jodit_disabled {\n background-color:#575757\n}\n.jodit_dark_theme .jodit_workplace {\n border-color:rgba(87,87,87,.8)\n}\n.jodit_dark_theme .jodit_statusbar {\n background-color:rgba(95,92,92,.8);\n border-color:rgba(87,87,87,.8)\n}\n.jodit_dark_theme .jodit_statusbar,\n.jodit_dark_theme .jodit_statusbar .jodit_statusbar_item span {\n color:#d1cccc\n}\n.jodit_dark_theme .jodit_toolbar_popup,\n.jodit_dark_theme .jodit_toolbar_popup-inline,\n.jodit_dark_theme .jodit_toolbar_popup-inline:before,\n.jodit_dark_theme .jodit_toolbar_popup:before {\n background:#575757\n}\n.jodit_dark_theme .jodit_toolbar {\n background:#5f5c5c;\n border-color:rgba(87,87,87,.8)\n}\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn>a {\n color:#d1cccc\n}\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn>a:hover {\n background-color:#575757\n}\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn.jodit_toolbar_btn-break {\n border-top-color:#686767\n}\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn.jodit_toolbar_btn-separator {\n border-right-color:#686767\n}\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn.active,\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn.jodit_active,\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn:active,\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn:hover {\n background-color:#575757\n}\n.jodit_dark_theme .jodit_toolbar li.jodit_toolbar_btn.jodit_with_dropdownlist .jodit_with_dropdownlist-trigger {\n border-top-color:silver\n}\n.jodit_dark_theme .jodit_icon {\n fill:silver\n}\n.jodit_dark_theme .jodit_wysiwyg,\n.jodit_dark_theme .jodit_wysiwyg_iframe {\n background-color:#575757;\n color:#d1cccc\n}\n.jodit_dark_theme .jodit_wysiwyg [data-jodit-selected-cell],\n.jodit_dark_theme .jodit_wysiwyg_iframe [data-jodit-selected-cell] {\n border-color:#152f5f\n}\n.jodit_dark_theme .jodit_dropdownlist {\n background:#5f5c5c\n}\n.jodit_dark_theme .jodit_tabs .jodit_tabs_buttons>a {\n background-color:#686767;\n color:#d1cccc\n}\n.jodit_dark_theme .jodit_tabs .jodit_tabs_buttons>a:hover {\n background-color:hsla(0,0%,41%,.8);\n color:#d1cccc;\n border-color:hsla(0,0%,41%,.9)\n}\n.jodit_dark_theme .jodit_tabs .jodit_tabs_buttons>a.active {\n background:rgba(81,81,81,.41);\n border-color:#686767\n}\n.jodit_dark_theme .jodit_tabs .jodit_tabs_buttons>a svg {\n fill:silver\n}\n.jodit_dark_theme .jodit_form input[type=text],\n.jodit_dark_theme .jodit_form input[type=url],\n.jodit_dark_theme .jodit_form textarea {\n background-color:rgba(81,81,81,.41);\n border-color:#686767;\n color:#d1cccc\n}\n.jodit_dark_theme .jodit_form button {\n background-color:hsla(0,0%,41%,.75);\n color:#d1cccc\n}\n.jodit_dark_theme .jodit_placeholder {\n color:hsla(0,5%,81%,.8)\n}\n.jodit_dark_theme .jodit_draganddrop_file_box,\n.jodit_dark_theme .jodit_uploadfile_button {\n color:#d1cccc\n}\n.jodit_dark_theme .jodit_draganddrop_file_box:hover,\n.jodit_dark_theme .jodit_uploadfile_button:hover {\n background-color:hsla(0,0%,41%,.75)\n}\n.jodit_dark_theme .jodit-add-new-line:before {\n border-top-color:#686767\n}\n.jodit_dark_theme .jodit-add-new-line span {\n background:hsla(0,0%,41%,.75);\n border-color:#686767\n}\n.jodit_dark_theme .jodit-add-new-line span svg {\n fill:#d1cccc\n}\n.jodit_dark_theme .jodit_resizer>i {\n background:hsla(0,0%,41%,.75);\n border-color:silver\n}\n.jodit_btn {\n border:1px solid;\n border-radius:0;\n background-color:#f5f5f5;\n background-image:-webkit-gradient(linear,left top, left bottom,from(#fff),to(#e6e6e6));\n background-image:-webkit-linear-gradient(top,#fff,#e6e6e6);\n background-image:linear-gradient(180deg,#fff,#e6e6e6);\n border-color:#ccc;\n text-shadow:0 1px 1px hsla(0,0%,100%,.75);\n color:#333;\n background-repeat:repeat-x;\n outline:0;\n display:inline-block;\n padding:6px 12px;\n margin-bottom:0;\n font-size:14px;\n font-weight:400;\n line-height:1.42857143;\n text-align:center;\n white-space:nowrap;\n vertical-align:middle;\n touch-action:manipulation;\n cursor:pointer;\n -webkit-user-select:none;\n -moz-user-select:none;\n -ms-user-select:none;\n user-select:none\n}\n.jodit_btn:hover {\n background-color:#e6e6e6;\n background-position:0 -15px;\n text-decoration:none\n}\n.jodit_btn.jodit_btn_success {\n text-shadow:0 -1px 0 rgba(0,0,0,.25);\n background-color:#5bb75b;\n background-image:-webkit-gradient(linear,left top, left bottom,from(#62c462),to(#51a351));\n background-image:-webkit-linear-gradient(top,#62c462,#51a351);\n background-image:linear-gradient(180deg,#62c462,#51a351);\n border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);\n color:#fff\n}\n.jodit_btn.jodit_btn_success svg {\n fill:#fff\n}\n.jodit_btn.jodit_btn_success:hover {\n background-color:#51a351\n}\n.jodit_btn.jodit_btn_danger {\n text-shadow:0 -1px 0 rgba(0,0,0,.25);\n background-color:#da4f49;\n background-image:-webkit-gradient(linear,left top, left bottom,from(#ee5f5b),to(#bd362f));\n background-image:-webkit-linear-gradient(top,#ee5f5b,#bd362f);\n background-image:linear-gradient(180deg,#ee5f5b,#bd362f);\n border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);\n color:#fff\n}\n.jodit_btn.jodit_btn_danger svg {\n fill:#fff\n}\n.jodit_btn.jodit_btn_danger:hover {\n background-color:#bd362f\n}\n.jodit_btn.jodit_btn_inverse {\n text-shadow:0 -1px 0 rgba(0,0,0,.25);\n background-color:#363636;\n background-image:-webkit-gradient(linear,left top, left bottom,from(#444),to(#222));\n background-image:-webkit-linear-gradient(top,#444,#222);\n background-image:linear-gradient(180deg,#444,#222);\n border-color:rgba(0,0,0,.1) rgba(0,0,0,.1) rgba(0,0,0,.25);\n color:#fff\n}\n.jodit_btn.jodit_btn_inverse svg {\n fill:#fff\n}\n.jodit_btn.jodit_btn_inverse:hover {\n background-color:#222\n}\n.jodit_btn.active,\n.jodit_btn:active {\n background-image:none;\n box-shadow:inset 0 2px 4px rgba(0,0,0,.15),0 1px 2px rgba(0,0,0,.05)\n}\n.jodit_btn_group {\n font-size:0;\n vertical-align:middle\n}\n.jodit_btn_group input {\n display:none\n}\n.jodit_btn_group button {\n float:left\n}\n.jodit_btn_group button+button {\n margin-left:-1px\n}\n.jodit_btn_group button:first-child,\n.jodit_btn_group input:first-child+button {\n border-right:0;\n border-top-right-radius:0;\n border-bottom-right-radius:0\n}\n.jodit_btn_group button:last-child,\n.jodit_btn_group input:last-child+button {\n border-left:0;\n border-top-left-radius:0;\n border-bottom-left-radius:0\n}\n.jodit_btn_group:after {\n content:\"\";\n clear:both;\n float:none;\n display:table\n}\n.jodit_context_menu {\n font-family:Helvetica,sans-serif;\n display:none;\n background:#fff;\n position:absolute;\n min-width:150px;\n box-shadow:0 0 5px 0 rgba(0,0,0,.24);\n z-index:15\n}\n.jodit_context_menu a {\n display:block;\n border-bottom:1px solid hsla(0,0%,80%,.24);\n text-decoration:none!important;\n color:#727272\n}\n.jodit_context_menu a svg {\n float:left;\n display:block;\n width:18px;\n height:28px;\n margin:0 4.5px;\n fill:#727272\n}\n.jodit_context_menu a span {\n margin-left:27px;\n display:block;\n padding:5px;\n border-left:1px solid hsla(0,0%,80%,.24);\n line-height:18px\n}\n.jodit_context_menu a:hover {\n background-color:#e3e3e3;\n color:#000\n}\n.jodit_context_menu a:hover .jodit_icon {\n fill:#000\n}\n.jodit_context_menu a:last-child {\n border:0\n}\n.jodit_context_menu-show {\n display:block\n}\n.jodit_dialog_box {\n box-sizing:border-box;\n display:none;\n width:0;\n height:0;\n border:0;\n position:absolute;\n will-change:left,top,width,height\n}\n.jodit_dialog_box.jodit_dialog_box-moved {\n -webkit-user-select:none;\n -moz-user-select:none;\n -ms-user-select:none;\n user-select:none\n}\n.jodit_dialog_box * {\n box-sizing:border-box\n}\n.jodit_dialog_box .jodit_elfinder,\n.jodit_dialog_box .jodit_elfinder * {\n box-sizing:content-box;\n box-sizing:initial\n}\n.jodit_dialog_box .jodit_dialog_overlay {\n position:fixed;\n top:0;\n left:0;\n width:100%;\n height:100%;\n z-index:13;\n text-align:center;\n white-space:nowrap;\n overflow:auto;\n display:none;\n background-color:rgba(0,0,0,.5)\n}\n.jodit_dialog_box.active,\n.jodit_dialog_box.jodit_modal .jodit_dialog_overlay {\n display:block\n}\n.jodit_dialog_box .jodit_dialog {\n z-index:14;\n display:inline-block;\n vertical-align:middle;\n white-space:normal;\n text-align:left;\n position:fixed;\n left:0;\n top:0;\n background-color:#fff;\n box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);\n min-width:200px;\n min-height:100px\n}\n@media (max-width:480px) {\n .jodit_dialog_box .jodit_dialog {\n  max-width:100%;\n  width:100%!important;\n  height:100%!important;\n  top:0!important;\n  left:0!important\n }\n}\n.jodit_dialog_box .jodit_dialog .jodit_promt {\n max-width:300px;\n min-width:200px;\n padding:10px;\n word-break:break-all\n}\n.jodit_dialog_box .jodit_dialog .jodit_promt label {\n margin-bottom:5px;\n display:block\n}\n.jodit_dialog_box .jodit_dialog .jodit_promt input[type=text] {\n display:block;\n border:1px solid #ccc;\n background:#fff;\n width:100%;\n height:28px;\n line-height:16px;\n padding:3px 6px;\n outline:none\n}\n.jodit_dialog_box .jodit_dialog .jodit_alert {\n max-width:300px;\n min-width:200px;\n padding:10px;\n word-break:break-all\n}\n.jodit_dialog_box .jodit_dialog .jodit_button {\n padding:0;\n margin:0;\n border:0;\n display:inline-block;\n vertical-align:top;\n width:32px;\n height:48px;\n line-height:48px;\n text-align:center;\n cursor:pointer;\n text-decoration:none\n}\n.jodit_dialog_box .jodit_dialog .jodit_button:not(.disabled):hover {\n background-color:#ecebe9\n}\n.jodit_dialog_box .jodit_dialog .jodit_button.disabled {\n opacity:.7\n}\n.jodit_dialog_box .jodit_dialog .jodit_input {\n border:1px solid #ccc;\n padding:5px;\n background-color:#fff;\n outline:0;\n width:120px;\n margin-left:10px;\n font:13px Arial;\n height:28px;\n vertical-align:middle\n}\n.jodit_dialog_box .jodit_dialog select.jodit_input {\n width:75px\n}\n.jodit_dialog_box .jodit_dialog .jodit_button .jodit_icon,\n.jodit_dialog_box .jodit_dialog .jodit_button svg,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_icon,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header svg {\n width:16px;\n height:16px;\n display:inline-block;\n vertical-align:middle\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header {\n display:flex;\n justify-content:space-between;\n text-align:left;\n color:#222;\n box-shadow:0 1px 3px rgba(0,0,0,.16),0 1px 2px rgba(0,0,0,.23);\n cursor:move;\n height:48px;\n overflow:hidden\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-title,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-toolbar {\n flex-shrink:3;\n font-size:18px;\n margin:0;\n font-weight:400;\n line-height:48px;\n vertical-align:top;\n padding:0 10px\n}\n@media (max-width:480px) {\n .jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-title,\n .jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-toolbar {\n  padding-left:0\n }\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header button {\n margin-right:10px\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-button {\n color:#222;\n font-size:28px;\n -webkit-transition:background-color .2s ease 0s;\n transition:background-color .2s ease 0s;\n flex-basis:48px;\n height:48px;\n line-height:48px;\n text-decoration:none;\n text-align:center\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-button:hover {\n background-color:#ecebe9\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar {\n background:transparent;\n display:block;\n height:100%;\n border:0\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar>li.jodit_toolbar_btn {\n vertical-align:middle\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar>li.jodit_toolbar_btn input[type=number],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar>li.jodit_toolbar_btn input[type=text],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar>li.jodit_toolbar_btn input[type=url],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_toolbar>li.jodit_toolbar_btn select {\n margin:0 5px;\n padding-left:10px;\n width:auto\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content {\n height:calc(100% - 48px);\n overflow:auto\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group {\n margin-bottom:10px;\n padding:0 10px\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group:first-child {\n margin-top:10px\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group label {\n display:inline-block;\n max-width:100%;\n margin-bottom:5px;\n font-weight:700\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input.select,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=number],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=text],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=url],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select.select,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=number],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=text],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=url] {\n display:block;\n height:34px;\n padding:6px 4px;\n font-size:14px;\n line-height:1.42857143;\n color:#555;\n background-color:#fff;\n background-image:none;\n border:1px solid #ccc;\n border-radius:0;\n box-shadow:inset 0 1px 1px rgba(0,0,0,.075);\n -webkit-transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input.select:focus,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=number]:focus,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=text]:focus,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=url]:focus,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select.select:focus,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=number]:focus,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=text]:focus,\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=url]:focus {\n border-color:#66afe9;\n outline:0;\n box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input.select[disabled],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=number][disabled],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=text][disabled],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=url][disabled],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select.select[disabled],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=number][disabled],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=text][disabled],\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=url][disabled] {\n background-color:#f0f0f0;\n color:#ccc\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input.select:not([class*=col-]),\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=number]:not([class*=col-]),\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=text]:not([class*=col-]),\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group input[type=url]:not([class*=col-]),\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select.select:not([class*=col-]),\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=number]:not([class*=col-]),\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=text]:not([class*=col-]),\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group select[type=url]:not([class*=col-]) {\n width:100%\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group {\n display:table;\n border-collapse:separate;\n width:100%\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group>* {\n vertical-align:middle;\n display:table-cell;\n height:34px\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group>input {\n float:left;\n margin:0!important\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group>input:not([class*=col-]) {\n width:100%\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group-buttons {\n width:1%;\n font-size:0;\n white-space:nowrap;\n vertical-align:middle\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_content .jodit_form_group .jodit_input_group-buttons>a {\n text-align:center;\n display:inline-block;\n border:1px solid #ccc;\n margin-left:-1px;\n position:relative;\n height:34px;\n line-height:34px\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_footer {\n padding:0 10px;\n padding-top:10px;\n text-align:center;\n height:48px;\n display:none\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button {\n width:auto;\n margin-bottom:10px;\n height:32px;\n line-height:100%;\n padding:0 15px;\n background-color:#ccc;\n border:1px solid #ccc;\n color:#000;\n font-size:0\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button:before {\n content:\"\";\n display:inline-block;\n vertical-align:middle;\n height:100%\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button svg {\n display:inline-block;\n width:24px;\n height:24px;\n vertical-align:middle\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button span {\n display:inline-block;\n vertical-align:middle;\n font-size:14px;\n margin-left:5px\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button:focus {\n border:1px solid #8bade4;\n outline:1px solid #82b2e8\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_footer .jodit_button:nth-child(n+2) {\n margin-left:10px\n}\n.jodit_dialog_box .jodit_dialog.with_footer .jodit_dialog_content {\n height:calc(100% - 96px)\n}\n.jodit_dialog_box .jodit_dialog.with_footer .jodit_dialog_footer {\n display:block\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_resizer {\n position:absolute;\n bottom:0;\n right:0;\n cursor:se-resize;\n width:7px;\n height:7px;\n display:inline-block;\n background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAYAAADEUlfTAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADFJREFUeNpilJGRYcACIoB4ORMuCSCOZMIlga4TRQJZJ4YETCdWCSBmZMIlATIOIMAAEyAPt4RnNx0AAAAASUVORK5CYII=\")\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_resizer:hover {\n border-color:rgba(0,0,0,.6)\n}\n@media (max-width:480px) {\n .jodit_dialog_box .jodit_dialog .jodit_dialog_resizer {\n  display:none\n }\n}\n.jodit_dialog_box.jodit_fullsize .jodit_dialog {\n top:0!important;\n bottom:0!important;\n left:0!important;\n right:0!important;\n width:100%!important;\n height:100%!important\n}\n.jodit_dialog_box.jodit_fullsize .jodit_dialog .jodit_dialog_resizer {\n display:none\n}\n@media (max-width:768px) {\n .jodit_dialog_header .jodit_input,\n .jodit_dialog_header .jodit_toolbar_btn-filter,\n .jodit_dialog_header .jodit_toolbar_btn-separator,\n .jodit_dialog_header .jodit_toolbar_btn-sort,\n .jodit_dialog_header_fullsize,\n .jodit_dialog_header_title {\n  display:none!important\n }\n}\n.jodit_toolbar_list>.jodit_toolbar {\n max-height:400px;\n overflow:auto;\n box-shadow:0 3px 6px rgba(0,0,0,.16),0 3px 6px rgba(0,0,0,.23);\n padding:0;\n margin:auto;\n text-align:left;\n box-sizing:border-box;\n -webkit-transition:max-height .2s ease 0s;\n transition:max-height .2s ease 0s;\n margin-top:0!important;\n list-style-type:none;\n font-size:16px;\n z-index:8;\n position:absolute;\n left:0;\n top:100%\n}\n.jodit_toolbar_list>.jodit_toolbar,\n.jodit_toolbar_list>.jodit_toolbar .jodit_toolbar {\n background:#f9f9f9\n}\n.jodit_toolbar_list>.jodit_toolbar blockquote,\n.jodit_toolbar_list>.jodit_toolbar h1,\n.jodit_toolbar_list>.jodit_toolbar h2,\n.jodit_toolbar_list>.jodit_toolbar h3,\n.jodit_toolbar_list>.jodit_toolbar h4,\n.jodit_toolbar_list>.jodit_toolbar h5,\n.jodit_toolbar_list>.jodit_toolbar p,\n.jodit_toolbar_list>.jodit_toolbar pre {\n font-family:Helvetica,sans-serif;\n margin:0;\n padding:0;\n font-weight:400\n}\n.jodit_toolbar_list>.jodit_toolbar h5 {\n font-size:.8em;\n line-height:1.4\n}\n.jodit_toolbar_list>.jodit_toolbar h3 {\n font-size:1.31em;\n line-height:1.4\n}\n.jodit_toolbar_list>.jodit_toolbar h4,\n.jodit_toolbar_list>.jodit_toolbar p {\n font-size:1em;\n line-height:1.5em\n}\n.jodit_toolbar_list>.jodit_toolbar h2 {\n font-size:1.74em;\n line-height:1.4\n}\n.jodit_toolbar_list>.jodit_toolbar h1 {\n font-size:2.17em;\n line-height:1.4\n}\n.jodit_toolbar_list>.jodit_toolbar blockquote,\n.jodit_toolbar_list>.jodit_toolbar pre {\n font-family:monospace\n}\n.jodit_toolbar_list>.jodit_toolbar li.jodit_toolbar_btn {\n display:block;\n cursor:pointer;\n white-space:nowrap;\n color:inherit;\n text-decoration:none;\n width:100%;\n height:auto;\n box-sizing:border-box;\n text-align:left\n}\n.jodit_toolbar_list>.jodit_toolbar li.jodit_toolbar_btn>a {\n background-image:none;\n padding:7px 24px;\n cursor:pointer;\n line-height:100%;\n width:auto;\n height:auto;\n display:block\n}\n.jodit_toolbar_list>.jodit_toolbar li.jodit_toolbar_btn>a>span {\n display:inline-block\n}\n.jodit_toolbar_list>.jodit_toolbar li.jodit_toolbar_btn>a:hover {\n background-color:#f3f0f0\n}\n.jodit_toolbar_list>.jodit_toolbar li.jodit_toolbar_btn>a:after {\n display:none\n}\n.jodit_toolbar[dir=rtl] .jodit_toolbar_list>.jodit_toolbar,\n.jodit_toolbar[dir=rtl] .jodit_toolbar_list>.jodit_toolbar li.jodit_toolbar_btn {\n text-align:right\n}\n.jodit_filebrowser {\n font-family:Helvetica,sans-serif;\n font-size:0;\n height:100%\n}\n.jodit_filebrowser .jodit_filebrowser_loader {\n height:100%;\n width:100%;\n position:absolute;\n top:0;\n left:0\n}\n.jodit_filebrowser .jodit_filebrowser_loader i {\n position:absolute;\n top:50%;\n left:50%;\n margin-top:-64px;\n margin-left:-64px\n}\n.jodit_filebrowser .jodit_filebrowser_status {\n position:absolute;\n font-size:10px;\n padding:2px 3px;\n border-top:1px solid hsla(0,0%,50%,.4);\n left:31%;\n right:0;\n bottom:0;\n background-color:#4a4a4a;\n visibility:hidden;\n opacity:0;\n -webkit-transition:opacity .3s linear;\n transition:opacity .3s linear;\n color:#b38888;\n word-break:break-all\n}\n.jodit_filebrowser .jodit_filebrowser_status.success {\n color:#c5c5c5\n}\n.jodit_filebrowser .jodit_filebrowser_status.active {\n visibility:visible;\n opacity:1\n}\n.jodit_filebrowser .jodit_filebrowser_files,\n.jodit_filebrowser .jodit_filebrowser_tree {\n display:none;\n vertical-align:top;\n height:100%;\n position:relative\n}\n.jodit_filebrowser .jodit_filebrowser_files.active,\n.jodit_filebrowser .jodit_filebrowser_tree.active {\n display:inline-block\n}\n.jodit_filebrowser .jodit_filebrowser_files::-webkit-scrollbar,\n.jodit_filebrowser .jodit_filebrowser_tree::-webkit-scrollbar {\n width:5px\n}\n.jodit_filebrowser .jodit_filebrowser_files::-webkit-scrollbar-track,\n.jodit_filebrowser .jodit_filebrowser_tree::-webkit-scrollbar-track {\n -webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3)\n}\n.jodit_filebrowser .jodit_filebrowser_files::-webkit-scrollbar-thumb,\n.jodit_filebrowser .jodit_filebrowser_tree::-webkit-scrollbar-thumb {\n background-color:#a9a9a9;\n outline:1px solid #708090\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active {\n width:31%;\n background-color:#3f3f3f;\n overflow-y:auto\n}\n@media (max-width:480px) {\n .jodit_filebrowser .jodit_filebrowser_tree.active {\n  display:none\n }\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active::-webkit-scrollbar {\n width:5px\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active::-webkit-scrollbar-track {\n -webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.3)\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active::-webkit-scrollbar-thumb {\n background-color:hsla(0,0%,50%,.5);\n outline:1px solid #708090\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active .jodit_filebrowser_source_title {\n -webkit-user-select:none;\n -moz-user-select:none;\n -ms-user-select:none;\n user-select:none;\n display:block;\n padding:10px;\n color:#969696;\n border-bottom:1px solid #484848;\n line-height:17px;\n min-height:38px;\n position:relative;\n word-break:break-all;\n background:#5a5a5a;\n font-size:16px\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a {\n display:block;\n padding:10px 20px;\n text-decoration:none;\n color:#b1b1b1;\n font-weight:600;\n -webkit-transition:background-color .2s ease 0s;\n transition:background-color .2s ease 0s;\n border-bottom:1px solid #474747;\n line-height:17px;\n min-height:38px;\n position:relative;\n word-break:break-all;\n font-size:16px\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a i.remove {\n height:16px;\n width:16px;\n line-height:17px;\n font-size:16px;\n position:absolute;\n right:5px;\n top:11px;\n opacity:0;\n padding-left:3px;\n display:inline-block\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a i.remove:hover {\n background:#696969\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a:hover {\n color:#222;\n background-color:#ecebe9\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a:hover i.remove {\n opacity:.6\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a.jodit_button {\n cursor:pointer;\n background:#696969;\n text-align:center;\n width:auto;\n height:38px;\n color:#333\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a.jodit_button svg {\n vertical-align:top\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a.jodit_button:not(.disabled):hover {\n background-color:#ecebe9\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active a.jodit_button.disabled,\n.jodit_filebrowser .jodit_filebrowser_tree.active a.jodit_button:hover i {\n opacity:.7\n}\n.jodit_filebrowser .jodit_filebrowser_files.active {\n width:100%;\n overflow-y:auto;\n padding:10px\n}\n.jodit_filebrowser .jodit_filebrowser_files.active .jodit_filebrowser_source_title {\n -webkit-user-select:none;\n -moz-user-select:none;\n -ms-user-select:none;\n user-select:none;\n margin:-10px -10px 0;\n display:block;\n padding:10px;\n line-height:17px;\n min-height:38px;\n position:relative;\n word-break:break-all;\n background:#5a5a5a;\n font-size:16px;\n color:#969696\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a+.jodit_filebrowser_source_title {\n margin-top:10px\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a {\n vertical-align:top;\n display:inline-block;\n width:150px;\n height:150px;\n line-height:150px;\n text-align:center;\n border:1px solid #ccc;\n margin:5px 5px 10px;\n font-size:0;\n overflow:hidden;\n -webkit-transition:border .1s linear,bottom .1s linear;\n transition:border .1s linear,bottom .1s linear;\n box-sizing:content-box;\n position:relative\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a img {\n max-width:100%;\n vertical-align:middle\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a:hover {\n border-color:#433b5c\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a.active {\n border-color:#1e88e5;\n background-color:#b5b5b5\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a .jodit_filebrowser_files_item-info {\n position:absolute;\n right:0;\n left:0;\n bottom:0;\n white-space:normal;\n opacity:.85;\n overflow:visible;\n padding:.3em .6em;\n -webkit-transition:opacity .4s ease;\n transition:opacity .4s ease;\n background-color:#e9e9e9;\n color:#333;\n text-shadow:#eee 0 1px 0;\n font-size:14px;\n line-height:16px;\n text-align:left\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a .jodit_filebrowser_files_item-info>span {\n display:block;\n text-overflow:ellipsis;\n white-space:nowrap;\n overflow:hidden;\n font-size:.75em\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a .jodit_filebrowser_files_item-info>span.jodit_filebrowser_files_item-info-filename {\n font-weight:700;\n font-size:.9em\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a.active .jodit_filebrowser_files_item-info {\n background-color:#b5b5b5;\n color:#fff;\n text-shadow:none\n}\n.jodit_filebrowser .jodit_filebrowser_files.active a:hover .jodit_filebrowser_files_item-info {\n bottom:-100px\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list {\n scroll-behavior:smooth\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a {\n display:block;\n width:100%;\n height:26px;\n line-height:26px;\n margin:0;\n border-width:0 0 1px;\n text-align:left;\n white-space:nowrap\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a img {\n min-width:16px;\n max-width:16px;\n vertical-align:middle;\n display:inline-block;\n margin-left:4px\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a .jodit_filebrowser_files_item-info {\n padding:0;\n position:static;\n display:inline-block;\n width:calc(100% - 20px);\n margin-left:4px;\n background-color:transparent;\n height:100%;\n line-height:inherit;\n vertical-align:middle;\n font-size:0\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a .jodit_filebrowser_files_item-info>span {\n display:inline-block;\n height:100%;\n font-size:12px\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a .jodit_filebrowser_files_item-info>span.jodit_filebrowser_files_item-info-filename {\n width:50%\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a .jodit_filebrowser_files_item-info>span.jodit_filebrowser_files_item-info-filechanged,\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a .jodit_filebrowser_files_item-info>span.jodit_filebrowser_files_item-info-filesize {\n width:25%\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a:hover {\n background-color:#433b5c\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a:hover .jodit_filebrowser_files_item-info {\n color:#fff;\n text-shadow:none\n}\n.jodit_filebrowser .jodit_filebrowser_files.active.jodit_filebrowser_files_view-list a:before {\n height:100%;\n content:\"\";\n vertical-align:middle;\n display:inline-block\n}\n.jodit_filebrowser .jodit_filebrowser_tree.active+.jodit_filebrowser_files.active {\n width:69%\n}\n@media (max-width:480px) {\n .jodit_filebrowser .jodit_filebrowser_tree.active+.jodit_filebrowser_files.active {\n  width:auto;\n  display:block\n }\n}\n.jodit_filebrowser_preview {\n text-align:center;\n min-width:300px;\n max-width:900px;\n max-height:700px;\n min-height:700px;\n position:relative\n}\n.jodit_filebrowser_preview .jodit_filebrowser_preview_navigation {\n position:absolute;\n top:0;\n height:100%;\n left:0\n}\n.jodit_filebrowser_preview .jodit_filebrowser_preview_navigation-next {\n left:auto;\n right:0\n}\n.jodit_filebrowser_preview .jodit_filebrowser_preview_navigation svg {\n width:45px;\n height:45px;\n position:relative;\n top:50%;\n margin-top:-22px;\n -webkit-transition:fill .3s linear;\n transition:fill .3s linear;\n fill:#9e9ba7\n}\n.jodit_filebrowser_preview .jodit_filebrowser_preview_navigation:hover svg {\n fill:#000\n}\n.jodit_filebrowser_preview img {\n max-width:100%;\n max-height:100%\n}\n.jodit_draghover {\n background-color:#ecebe9\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-title .jodit_upload_button {\n position:relative;\n width:220px;\n border:0;\n padding:25px 0;\n margin:10px 0;\n overflow:hidden\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-title .jodit_upload_button input {\n cursor:pointer;\n position:absolute;\n right:0;\n top:0;\n bottom:0;\n margin:0 -10px 0 0;\n padding:0;\n opacity:0;\n font-size:400px\n}\n.jodit_dialog_box .jodit_dialog .jodit_dialog_header .jodit_dialog_header-title.jodit_filebrowser_title_box {\n padding-left:10px\n}\n.jodit_grid {\n width:100%\n}\n.jodit_grid [class*=jodit_col-] {\n display:block;\n float:left\n}\n.jodit_grid .jodit_col-lg-5-5 {\n width:100%\n}\n.jodit_grid .jodit_col-lg-4-5 {\n width:80%\n}\n.jodit_grid .jodit_col-lg-3-5 {\n width:60%\n}\n.jodit_grid .jodit_col-lg-2-5 {\n width:40%\n}\n.jodit_grid .jodit_col-lg-1-5 {\n width:20%\n}\n.jodit_grid .jodit_col-lg-4-4 {\n width:100%\n}\n.jodit_grid .jodit_col-lg-3-4 {\n width:75%\n}\n.jodit_grid .jodit_col-lg-2-4 {\n width:50%\n}\n.jodit_grid .jodit_col-lg-1-4 {\n width:25%\n}\n.jodit_grid:after,\n.jodit_grid:before {\n content:\" \";\n display:table\n}\n.jodit_grid:after {\n clear:both\n}\n@-webkit-keyframes a {\n to {\n  -webkit-transform:rotate(1turn);\n  transform:rotate(1turn)\n }\n}\n@keyframes a {\n to {\n  -webkit-transform:rotate(1turn);\n  transform:rotate(1turn)\n }\n}\n.jodit_icon-loader {\n background:url(\"data:image/png;base64,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\") no-repeat 50%;\n background-size:100% 100%;\n width:128px;\n height:128px;\n will-change:transform;\n -webkit-animation:a 2s ease-out 0s infinite;\n animation:a 2s ease-out 0s infinite\n}\n.jodit_icon,\n.jodit_icon-loader {\n display:inline-block;\n vertical-align:middle\n}\n.jodit_icon {\n font-style:normal;\n width:14px;\n height:14px;\n font-size:8px;\n fill:#222;\n -webkit-transform-origin:0 0!important;\n transform-origin:0 0!important;\n overflow:visible;\n background:50% no-repeat;\n background-size:contain\n}\nsvg.jodit_icon {\n height:auto\n}\n.jodit_text_icon {\n font-size:14px\n}\n.jodit_toolbar_size-small .jodit_icon {\n min-width:12px;\n height:12px;\n line-height:12px\n}\n.jodit_toolbar_size-large .jodit_icon {\n min-width:16px;\n height:16px;\n line-height:16px\n}\n.jodit_image_editor {\n width:100%;\n height:100%;\n padding:10px;\n overflow:hidden\n}\n@media (max-width:768px) {\n .jodit_image_editor {\n  height:auto\n }\n}\n.jodit_image_editor>div,\n.jodit_image_editor>div>div {\n height:100%\n}\n@media (max-width:768px) {\n .jodit_image_editor>div,\n .jodit_image_editor>div>div {\n  height:auto;\n  min-height:200px\n }\n}\n.jodit_image_editor * {\n box-sizing:border-box\n}\n.jodit_image_editor .jodit_image_editor_slider-title {\n text-shadow:#f3f3f3 0 1px 0;\n color:#333;\n border-bottom:1px solid hsla(0,0%,62%,.31);\n background-color:#f9f9f9;\n padding:.8em 1em;\n text-overflow:ellipsis;\n white-space:nowrap;\n cursor:pointer;\n -webkit-user-select:none;\n -moz-user-select:none;\n -ms-user-select:none;\n user-select:none;\n font-weight:700;\n line-height:1em\n}\n.jodit_image_editor .jodit_image_editor_slider-title svg {\n margin-right:10px;\n width:16px;\n display:inline-block;\n vertical-align:middle\n}\n.jodit_image_editor .jodit_image_editor_slider-content {\n display:none\n}\n.jodit_image_editor .jodit_image_editor_slider.active .jodit_image_editor_slider-title {\n background-color:#5d5d5d;\n color:#fff;\n text-shadow:#000 0 1px 0\n}\n.jodit_image_editor .jodit_image_editor_slider.active .jodit_image_editor_slider-title svg {\n fill:#fff\n}\n.jodit_image_editor .jodit_image_editor_slider.active .jodit_image_editor_slider-content {\n display:block\n}\n.jodit_image_editor_area {\n background-color:#eee;\n background-image:-webkit-linear-gradient(45deg,#ccc 25%,transparent 0,transparent 75%,#ccc 0,#ccc),-webkit-linear-gradient(45deg,#ccc 25%,transparent 0,transparent 75%,#ccc 0,#ccc);\n background-image:linear-gradient(45deg,#ccc 25%,transparent 0,transparent 75%,#ccc 0,#ccc),linear-gradient(45deg,#ccc 25%,transparent 0,transparent 75%,#ccc 0,#ccc);\n background-size:30px 30px;\n background-position:0 0,15px 15px;\n height:100%;\n overflow:hidden;\n -webkit-user-select:none;\n -moz-user-select:none;\n -ms-user-select:none;\n user-select:none;\n position:relative;\n display:none\n}\n.jodit_image_editor_area.active {\n display:block\n}\n.jodit_image_editor_area .jodit_image_editor_box {\n overflow:hidden;\n position:relative;\n z-index:1;\n pointer-events:none;\n height:100%\n}\n.jodit_image_editor_area .jodit_image_editor_box img {\n -webkit-user-select:none;\n -moz-user-select:none;\n -ms-user-select:none;\n user-select:none;\n max-width:100%;\n max-height:100%\n}\n.jodit_image_editor_area .jodit_image_editor_croper,\n.jodit_image_editor_area .jodit_image_editor_resizer {\n z-index:2;\n width:100px;\n height:100px;\n position:absolute;\n box-shadow:0 0 11px #000;\n border:1px solid #fff;\n background-repeat:no-repeat;\n top:10px;\n left:20px;\n pointer-events:none\n}\n.jodit_image_editor_area .jodit_image_editor_croper i.jodit_bottomright,\n.jodit_image_editor_area .jodit_image_editor_resizer i.jodit_bottomright {\n position:absolute;\n display:inline-block;\n border:1px solid #383838;\n z-index:4;\n background-color:#8c7878;\n cursor:se-resize;\n border-radius:10px;\n height:20px;\n width:20px;\n right:-10px;\n bottom:-10px;\n box-shadow:0 0 11px #000;\n pointer-events:all\n}\n.jodit_image_editor_area .jodit_image_editor_croper i.jodit_bottomright:active,\n.jodit_image_editor_area .jodit_image_editor_resizer i.jodit_bottomright:active {\n border:1px solid #ff0\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop {\n height:100%;\n background:#eee;\n text-align:center;\n line-height:100%;\n position:relative\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop:before {\n content:\"\";\n line-height:100%;\n vertical-align:middle;\n height:100%;\n display:inline-block\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box {\n height:100%;\n overflow:visible;\n display:inline-block;\n vertical-align:middle;\n pointer-events:all;\n font-size:0;\n text-align:left;\n line-height:100%\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box img {\n max-width:100%;\n max-height:100%\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box:before {\n content:\"\";\n line-height:100%;\n vertical-align:middle;\n height:100%;\n display:inline-block\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box:after {\n content:\"\";\n position:absolute;\n top:0;\n left:0;\n bottom:0;\n right:0;\n margin:auto;\n background:hsla(0,0%,100%,.3);\n z-index:1\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box .jodit_image_editor_croper {\n pointer-events:all;\n cursor:move\n}\n.jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box .jodit_image_editor_croper i.jodit_sizes {\n font-size:12px;\n white-space:pre;\n position:absolute;\n bottom:-30px;\n left:100%;\n text-align:center;\n color:#fff;\n text-shadow:none;\n background:rgba(0,0,0,.2);\n border-radius:.4em;\n padding:9px 6px;\n display:block\n}\n.jodit_properties svg {\n font-style:normal;\n display:inline-block;\n width:14px;\n height:14px;\n line-height:14px;\n font-size:8px;\n overflow:hidden;\n vertical-align:middle;\n fill:#222;\n -webkit-transform-origin:0 0!important;\n transform-origin:0 0!important\n}\n.jodit_properties #tabsbox {\n padding:10px\n}\n.jodit_properties #tabsbox .jodit_form_group {\n padding:0\n}\n.jodit_properties .jodit_properties_view_box {\n padding:10px\n}\n.jodit_properties .jodit_properties_view_box .jodit_properties_image_view {\n height:150px;\n text-align:center;\n line-height:1;\n vertical-align:middle;\n padding:0;\n background-color:#f6f6f6;\n margin:0;\n vertical-align:baseline;\n font-size:100%;\n margin-bottom:10px\n}\n.jodit_properties .jodit_properties_view_box .jodit_properties_image_view:before {\n content:\"\";\n display:inline-block;\n vertical-align:middle;\n height:100%\n}\n.jodit_properties .jodit_properties_view_box .jodit_properties_image_view img {\n max-width:100%;\n max-height:100%;\n vertical-align:middle\n}\n.jodit_properties .jodit_properties_view_box .jodit_properties_image_sizes.jodit_form_group {\n padding:0!important;\n margin:0!important\n}\n.jodit_properties .jodit_properties_view_box .jodit_properties_image_sizes.jodit_form_group a {\n display:inline-block;\n cursor:pointer\n}\n.jodit_properties .jodit_properties_view_box .jodit_properties_image_sizes.jodit_form_group input[type=number] {\n display:inline-block!important;\n width:calc(50% - 8px)!important\n}\n.jodit_toolbar,\n.jodit_toolbar * {\n box-sizing:border-box\n}\n.jodit_toolbar {\n position:relative;\n left:0;\n top:0;\n margin:0!important;\n padding:0!important;\n list-style:none!important;\n font-size:0;\n background:#f9f9f9;\n box-shadow:0 4px 4px -2px rgba(0,0,0,.14);\n border:1px solid #ccc;\n border-bottom:0;\n min-height:16px!important\n}\n.jodit_toolbar+.jodit_toolbar_dummy {\n display:none\n}\n.jodit_toolbar.jodit_fly {\n position:absolute;\n left:0;\n right:0;\n z-index:10;\n background:#fff\n}\n.jodit_toolbar.jodit_sticky {\n position:fixed;\n position:-webkit-sticky;\n position:sticky;\n z-index:3;\n top:0;\n left:auto\n}\n.jodit_toolbar.jodit_sticky+.jodit_toolbar_dummy {\n display:block\n}\n.jodit_toolbar .jodit_toolbar_btn>a {\n color:#000;\n text-decoration:none;\n display:block;\n background:no-repeat 50%\n}\n.jodit_toolbar>li.jodit_toolbar_btn {\n display:inline-block;\n vertical-align:top;\n margin:0!important;\n padding:0;\n list-style:none!important;\n outline:none;\n position:relative;\n text-align:center;\n cursor:pointer;\n -webkit-transition:background-color .2s linear,opacity .1s linear;\n transition:background-color .2s linear,opacity .1s linear\n}\n.jodit_toolbar>li.jodit_toolbar_btn.jodit_disabled {\n background-color:transparent!important;\n opacity:.3;\n cursor:default\n}\n.jodit_toolbar>li.jodit_toolbar_btn.jodit_disabled a {\n cursor:default\n}\n.jodit_toolbar>li.jodit_toolbar_btn.jodit_toolbar_btn-separator {\n border-left:0;\n border-right:1px solid #e6e6e6;\n padding:0;\n margin:2px 3px 0!important;\n cursor:default\n}\n.jodit_toolbar>li.jodit_toolbar_btn.jodit_toolbar_btn-break {\n display:block!important;\n width:auto;\n border-top:1px solid #e6e6e6;\n height:0;\n margin:0 3px!important\n}\n.jodit_toolbar>li.jodit_toolbar_btn .jodit_toolbar_btn>a,\n.jodit_toolbar>li.jodit_toolbar_btn>a {\n width:100%;\n height:100%;\n display:inline-block;\n outline:none;\n text-decoration:none\n}\n.jodit_toolbar>li.jodit_toolbar_btn .jodit_toolbar_btn>a:after,\n.jodit_toolbar>li.jodit_toolbar_btn>a:after {\n content:\"\";\n display:inline-block;\n height:100%;\n vertical-align:middle\n}\n.jodit_toolbar>li.jodit_toolbar_btn .jodit_toolbar_btn>a:active+.jodit_tooltip,\n.jodit_toolbar>li.jodit_toolbar_btn>a:active+.jodit_tooltip {\n visibility:hidden!important\n}\n.jodit_toolbar>li.jodit_toolbar_btn.jodit_disabled .jodit_tooltip {\n display:none!important\n}\n.jodit_toolbar>li.jodit_toolbar_btn>a {\n line-height:100%\n}\n.jodit_toolbar>li.jodit_toolbar_btn.jodit_dropdown_open .jodit_tooltip,\n.jodit_toolbar>li.jodit_toolbar_btn .jodit_popap_open,\n.jodit_toolbar>li.jodit_toolbar_btn.jodit_popup_open .jodit_tooltip {\n visibility:hidden!important\n}\n.jodit_toolbar>li.jodit_toolbar_btn:not(.jodit_toolbar-input):hover {\n background-color:#dde4ef;\n outline:none\n}\n.jodit_toolbar>li.jodit_toolbar_btn.jodit_active,\n.jodit_toolbar>li.jodit_toolbar_btn:not(.jodit_toolbar-input):active {\n background-color:hsla(0,0%,87%,.4);\n outline:none\n}\n.jodit_toolbar>li.jodit_toolbar_btn.jodit-btn-hidden {\n display:none!important\n}\n.jodit_toolbar>li.jodit_toolbar_btn.jodit_with_dropdownlist .jodit_with_dropdownlist-trigger {\n width:0;\n height:0;\n border-right:3px solid transparent;\n border-left:3px solid transparent;\n border-top:3px solid #4c4c4c;\n display:inline-block;\n vertical-align:middle;\n margin-left:3px\n}\n.jodit_toolbar>li.jodit_toolbar_btn.jodit_toolbar-input input,\n.jodit_toolbar>li.jodit_toolbar_btn.jodit_toolbar-input select {\n -webkit-appearance:none;\n -moz-appearance:none;\n appearance:none;\n height:100%;\n border-radius:0;\n outline:none;\n line-height:100%\n}\n.jodit_toolbar>li.jodit_toolbar_btn.jodit_toolbar-input select {\n padding-right:20px;\n background:url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+) no-repeat 98% 50%!important\n}\n.jodit_toolbar>li {\n min-width:32px;\n height:32px;\n line-height:32px\n}\n.jodit_toolbar>li.jodit_toolbar_btn-separator {\n height:28px;\n width:0;\n min-width:0\n}\n.jodit_tooltip {\n position:absolute;\n background:#727171;\n color:#fff;\n font-size:12px;\n line-height:15px;\n padding:4px 5px;\n font-family:Arial,sans-serif;\n z-index:9;\n width:90px;\n -webkit-transition:opacity .3s linear;\n transition:opacity .3s linear\n}\n@media (max-width:768px) {\n .jodit_tooltip {\n  display:none\n }\n}\n.jodit_toolbar_size-small .jodit_toolbar {\n min-height:12px!important\n}\n.jodit_toolbar_size-small .jodit_toolbar>li {\n min-width:24px;\n height:24px;\n line-height:24px\n}\n.jodit_toolbar_size-small .jodit_toolbar>li.jodit_toolbar_btn-separator {\n height:20px;\n width:0;\n min-width:0\n}\n.jodit_toolbar_size-large .jodit_toolbar {\n min-height:18px!important\n}\n.jodit_toolbar_size-large .jodit_toolbar>li {\n min-width:36px;\n height:36px;\n line-height:36px\n}\n.jodit_toolbar_size-large .jodit_toolbar>li.jodit_toolbar_btn-separator {\n height:32px;\n width:0;\n min-width:0\n}\n.jodit_toolbar_popup {\n position:absolute;\n z-index:7;\n top:100%;\n margin-top:10px;\n padding-top:0;\n left:0;\n font-size:14px;\n line-height:14px!important;\n background:#fff;\n box-shadow:0 2px 4px rgba(0,0,0,.2);\n border:1px solid rgba(0,0,0,.2)\n}\n.jodit_toolbar_popup .jodit_toolbar {\n box-shadow:none;\n border-width:0;\n background-color:transparent\n}\n.jodit_toolbar_popup .jodit_toolbar .jodit_toolbar {\n background-color:#f9f9f9;\n box-shadow:0 4px 4px -2px rgba(0,0,0,.14);\n border:1px solid #ccc\n}\n.jodit_toolbar_popup>* {\n margin:10px\n}\n.jodit_toolbar_popup .jodit_popup_triangle {\n padding:0;\n margin:0;\n width:8px;\n height:8px;\n position:absolute;\n top:-5px;\n left:9px;\n display:inline-block;\n -webkit-transform:rotate(45deg);\n transform:rotate(45deg);\n background:#fff;\n border:1px solid rgba(0,0,0,.2);\n border-width:1px 0 0 1px;\n z-index:5\n}\n.jodit_toolbar_popup.jodit_right {\n left:auto;\n right:0\n}\n.jodit_toolbar_popup.jodit_right:before {\n left:auto;\n right:14px\n}\n.jodit_toolbar .jodit_toolbar_btn>svg {\n max-width:50%;\n vertical-align:middle;\n font-smoothing:antialiased\n}\n.jodit_container>.jodit_toolbar>li:first-child {\n margin-left:2px!important\n}\n.jodit_container[dir=rtl]>.jodit_toolbar>li:first-child {\n margin-left:0!important;\n margin-right:2px!important\n}\n.jodit_draganddrop_file_box,\n.jodit_uploadfile_button {\n position:relative;\n width:220px;\n border:1px dashed #ccc;\n padding:25px 0;\n margin:10px 0;\n text-align:center;\n overflow:hidden\n}\n.jodit_draganddrop_file_box:hover,\n.jodit_uploadfile_button:hover {\n background-color:#ecebe9\n}\n.jodit_draganddrop_file_box input,\n.jodit_uploadfile_button input {\n cursor:pointer;\n position:absolute;\n top:0;\n bottom:0;\n right:0;\n margin:0;\n padding:0;\n opacity:0;\n font-size:400px\n}\n@media (max-width:768px) {\n .jodit_draganddrop_file_box {\n  width:auto;\n  max-width:100%;\n  min-width:120px\n }\n}\n.jodit_statusbar {\n border:1px solid #ccc;\n border-top:0;\n font-size:0;\n background-color:#f9f9f9;\n padding:0 5px\n}\n.jodit_statusbar .jodit_statusbar_item {\n font-size:11px;\n float:left;\n line-height:1.57142857em;\n margin:0 10px 0 0;\n padding:0;\n vertical-align:middle\n}\n.jodit_statusbar .jodit_statusbar_item.jodit_statusbar_item-right {\n float:right;\n margin:0 0 0 10px\n}\n.jodit_statusbar .jodit_statusbar_item li,\n.jodit_statusbar .jodit_statusbar_item ul {\n margin:0;\n padding:0;\n list-style:none;\n display:inline-block;\n vertical-align:top;\n position:relative\n}\n.jodit_statusbar .jodit_statusbar_item li li,\n.jodit_statusbar .jodit_statusbar_item ul li {\n margin-right:5px\n}\n.jodit_statusbar .jodit_statusbar_item a,\n.jodit_statusbar .jodit_statusbar_item span {\n -webkit-user-select:none;\n -moz-user-select:none;\n -ms-user-select:none;\n user-select:none;\n display:inline-block;\n vertical-align:baseline;\n text-align:left;\n white-space:nowrap;\n padding:2px 3px;\n line-height:10px;\n outline:0;\n border:0;\n color:#222\n}\n.jodit_statusbar .jodit_statusbar_item a span,\n.jodit_statusbar .jodit_statusbar_item span span {\n padding:0\n}\n.jodit_statusbar .jodit_statusbar_item svg {\n width:11px;\n height:11px;\n display:inline-block;\n vertical-align:top\n}\n.jodit_statusbar .jodit_statusbar_item a {\n text-decoration:none;\n cursor:default;\n border-radius:3px\n}\n.jodit_statusbar .jodit_statusbar_item a:hover {\n background-color:hsla(0,0%,88%,.99);\n text-decoration:none;\n color:#222\n}\n.jodit_statusbar:after {\n content:\" \";\n display:block;\n visibility:hidden;\n font-size:0;\n height:0;\n float:none;\n clear:both\n}\n.jodit_disabled .jodit_statusbar {\n opacity:.4\n}\n.jodit_form {\n color:#000\n}\n.jodit_form input[type=text],\n.jodit_form input[type=url],\n.jodit_form textarea {\n -webkit-appearance:none;\n -moz-appearance:none;\n display:block;\n outline:none;\n border:1px solid #b5b5b5;\n height:28px;\n line-height:28px;\n padding:0 5px;\n min-width:220px;\n margin-top:10px\n}\n.jodit_form input[type=text].jodit_error,\n.jodit_form input[type=url].jodit_error,\n.jodit_form textarea.jodit_error {\n border-color:#f7d1d1;\n box-shadow:inset 0 0 3px 0 hsla(0,0%,74%,.3)\n}\n@media (max-width:768px) {\n .jodit_form input[type=text],\n .jodit_form input[type=url],\n .jodit_form textarea {\n  min-width:150px\n }\n}\n.jodit_form textarea {\n height:128px\n}\n.jodit_form button {\n height:36px;\n line-height:1;\n color:#000;\n padding:10px;\n cursor:pointer;\n text-decoration:none;\n border:none;\n background:#d6d6d6;\n font-size:16px;\n outline:none;\n -webkit-transition:background .2s ease 0s;\n transition:background .2s ease 0s;\n margin-top:10px;\n margin-bottom:10px\n}\n.jodit_form button:hover {\n background-color:#ecebe9;\n color:#000\n}\n.jodit_form button:active {\n background:#ecebe9;\n color:#000\n}\n.jodit_form input[type=checkbox] {\n display:inline-block;\n z-index:2;\n border:0 none;\n cursor:pointer;\n height:16px;\n margin:0;\n padding:0;\n width:16px;\n position:relative;\n outline:none;\n top:3px\n}\n.jodit_form input[type=checkbox]:after {\n content:\"\";\n background:#fff;\n border:1px solid hsla(0,0%,88%,.99);\n border-radius:2px;\n background-clip:padding-box;\n width:16px;\n height:16px;\n display:inline-block;\n position:relative;\n z-index:1;\n box-sizing:border-box;\n -webkit-transition:background .2s ease 0s,border-color .2s ease 0s;\n transition:background .2s ease 0s,border-color .2s ease 0s\n}\n.jodit_form input[type=checkbox]:checked:after {\n background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'%3E%3Cpath d='M27 4L12 19l-7-7-5 5 12 12L32 9z' fill='%23FFF'/%3E%3C/svg%3E\") no-repeat 50%;\n background-color:#b5b5b5;\n border-color:#b5b5b5\n}\n.jodit_form label {\n margin-top:10px;\n display:block;\n text-align:left\n}\n.jodit_form form:after {\n content:\"\";\n display:table;\n clear:both\n}\n.jodit_about {\n padding:20px\n}\n.jodit_about a {\n color:#459ce7;\n text-decoration:none\n}\n.jodit_about a:focus,\n.jodit_about a:hover {\n color:#23527c;\n text-decoration:underline;\n outline:0\n}\n.jodit_about div {\n margin-bottom:5px\n}\n.jodit_colorpicker {\n min-width:180px;\n text-align:left;\n margin:0;\n -webkit-user-select:none;\n -moz-user-select:none;\n -ms-user-select:none;\n user-select:none\n}\n.jodit_colorpicker .jodit_colorpicker_group {\n margin-bottom:5px;\n white-space:normal\n}\n.jodit_colorpicker a {\n width:18px;\n height:18px;\n line-height:16px;\n display:inline-block;\n text-decoration:none;\n vertical-align:middle;\n text-align:center\n}\n.jodit_colorpicker a:before {\n content:\"\";\n display:inline-block;\n height:100%;\n vertical-align:middle;\n width:0\n}\n.jodit_colorpicker a svg {\n display:inline-block;\n vertical-align:middle;\n font-smoothing:antialiased;\n max-width:14px\n}\n.jodit_colorpicker a:hover {\n border-color:#000\n}\n.jodit_colorpicker a:active {\n background:#d6d6d6;\n color:#b5b5b5\n}\n.jodit_colorpicker .jodit_text_icon {\n width:auto;\n text-decoration:none;\n color:#000\n}\n.jodit_colorpicker span {\n float:right\n}\n.jodit_colorpicker span em {\n width:16px;\n height:16px;\n display:inline-block;\n margin-right:4px\n}\n.jodit_colorpicker span input {\n width:18px;\n height:18px;\n padding:0;\n border:none;\n -webkit-appearance:none\n}\n.jodit_colorpicker span input[type=color]::-webkit-color-swatch-wrapper {\n padding:0\n}\n.jodit_colorpicker span input input[type=color]::-webkit-color-swatch {\n border:none\n}\n@-webkit-keyframes b {\n 30% {\n  opacity:.6\n }\n 60% {\n  opacity:0\n }\n to {\n  opacity:.6\n }\n}\n@keyframes b {\n 30% {\n  opacity:.6\n }\n 60% {\n  opacity:0\n }\n to {\n  opacity:.6\n }\n}\n.jodit_progress_bar {\n position:absolute;\n top:0;\n left:0;\n height:2px;\n z-index:16;\n border-radius:1px;\n display:none\n}\n.jodit_progress_bar div {\n position:relative;\n background:#b91f1f;\n height:2px;\n -webkit-transition:width .5s ease-out,opacity .5s linear;\n transition:width .5s ease-out,opacity .5s linear;\n will-change:width,opacity\n}\n.jodit_progress_bar div:after,\n.jodit_progress_bar div:before {\n -webkit-animation:b 2s ease-out 0s infinite;\n animation:b 2s ease-out 0s infinite;\n content:\"\";\n display:inline-block;\n position:absolute;\n top:0;\n height:2px;\n box-shadow:1px 0 6px 1px #b91f1f;\n border-radius:100%;\n opacity:.6\n}\n.jodit_progress_bar div:before {\n width:180px;\n right:-80px;\n clip:rect(-6px,90px,14px,-6px)\n}\n.jodit_progress_bar div:after {\n width:20px;\n right:0;\n clip:rect(-6px,22px,14px,10px)\n}\n.jodit_tabs .jodit_tabs_buttons {\n line-height:18px;\n margin-bottom:5px;\n margin-top:4px\n}\n.jodit_tabs .jodit_tabs_buttons>a {\n display:inline-block;\n text-decoration:none;\n font-size:11px;\n font-weight:700;\n text-align:center;\n white-space:nowrap;\n height:29px;\n line-height:27px;\n position:relative;\n vertical-align:middle;\n -webkit-transition:background .1s linear;\n transition:background .1s linear;\n text-overflow:ellipsis;\n overflow:hidden;\n box-shadow:none;\n background-color:#f5f5f5;\n color:#737373;\n border:1px solid rgba(0,0,0,.1);\n outline:none\n}\n@media (max-width:768px) {\n .jodit_tabs .jodit_tabs_buttons>a {\n  width:100%!important;\n  border-radius:0!important\n }\n}\n.jodit_tabs .jodit_tabs_buttons>a+a {\n margin-left:-1px\n}\n.jodit_tabs .jodit_tabs_buttons>a i,\n.jodit_tabs .jodit_tabs_buttons>a svg {\n width:16px;\n height:16px;\n display:inline-block;\n vertical-align:sub;\n margin-right:5px;\n fill:#737373\n}\n.jodit_tabs .jodit_tabs_buttons>a:hover {\n border:1px solid #c6c6c6;\n color:#111;\n box-shadow:none;\n background-color:#f8f8f8;\n outline:none\n}\n.jodit_tabs .jodit_tabs_buttons>a:hover i,\n.jodit_tabs .jodit_tabs_buttons>a:hover svg {\n fill:#111\n}\n.jodit_tabs .jodit_tabs_buttons>a.active,\n.jodit_tabs .jodit_tabs_buttons>a:active {\n outline:none;\n background:#fff;\n border:1px solid #ccc;\n color:#333\n}\n.jodit_tabs .jodit_tabs_buttons>a.active i,\n.jodit_tabs .jodit_tabs_buttons>a.active svg,\n.jodit_tabs .jodit_tabs_buttons>a:active i,\n.jodit_tabs .jodit_tabs_buttons>a:active svg {\n fill:#333\n}\n.jodit_tabs .jodit_tabs_wrapper .jodit_tab {\n display:none\n}\n.jodit_tabs .jodit_tabs_wrapper .jodit_tab.active {\n display:block\n}\n.jodit_tabs .jodit_tabs_wrapper .jodit_tab .jodit_tab_empty {\n min-width:220px;\n min-height:100px\n}\n.jodit-add-new-line {\n z-index:1;\n position:absolute;\n height:20px;\n line-height:100%;\n vertical-align:middle;\n font-size:0;\n top:0;\n outline:none;\n margin-top:-10px;\n display:none\n}\n.jodit-add-new-line,\n.jodit-add-new-line * {\n box-sizing:border-box\n}\n.jodit-add-new-line:before {\n height:100%\n}\n.jodit-add-new-line:after,\n.jodit-add-new-line:before {\n display:inline-block;\n vertical-align:middle;\n content:\"\"\n}\n.jodit-add-new-line:after {\n box-sizing:border-box;\n border-top:1px solid #ccc;\n height:1px;\n width:calc(100% - 30px)\n}\n.jodit-add-new-line span {\n right:0;\n position:absolute;\n display:inline-block;\n width:30px;\n height:20px;\n background:hsla(40,7%,92%,.3);\n vertical-align:top;\n border:1px solid #ccc;\n padding:0 5px;\n cursor:pointer\n}\n.jodit-add-new-line span:hover {\n background:#ecebe9\n}\n.jodit-add-new-line svg {\n width:16px;\n fill:#ccc;\n vertical-align:top\n}\n.jodit_source_mode .jodit-add-new-line {\n display:none!important\n}\n.jodit_error_box_for_messages {\n position:absolute;\n right:0;\n bottom:0;\n width:0;\n height:0;\n overflow:visible;\n z-index:3\n}\n.jodit_error_box_for_messages>* {\n position:absolute;\n right:5px;\n bottom:0;\n display:block;\n -webkit-transition:opacity .1s linear,bottom .3s linear;\n transition:opacity .1s linear,bottom .3s linear;\n opacity:0;\n background:rgba(255,0,0,.29);\n color:#e02b2b;\n padding:2px 7px;\n border:1px solid hsla(0,65%,67%,.44);\n font-size:14px;\n white-space:pre\n}\n.jodit_error_box_for_messages>.active {\n opacity:1\n}\n.jodit_error_box_for_messages>.info {\n background:rgba(204,229,247,.71);\n color:#776565;\n border:1px solid hsla(0,0%,60%,.44)\n}\n.jodit_error_box_for_messages>.success {\n background:rgba(77,236,112,.29);\n color:#5d5a5a;\n border:1px solid hsla(0,0%,58%,.44)\n}\n.card.jodit_fullsize_box {\n  position: static;\n}\n.viewcontent.jodit_fullsize_box {\n  position: sticky;\n  min-height: calc(~\"100vh + 30px\");\n  > *:not(.jodit_fullsize_box) {\n    display: none;\n  }\n}\n.jodit_fullsize {\n position:absolute;\n top:0;\n left:0;\n right:0;\n bottom:0;\n z-index:11;\n max-width: 100% !important\n}\n.jodit_fullsize .toolbar {\n width:100%!important\n}\n.jodit_fullsize .jodit_area,\n.jodit_fullsize .jodit_editor {\n height:100%\n}\n.jodit_fullsize .jodit_workflow {\n height:calc(100% - 16px * 1.5);\n overflow:auto\n}\n.jodit_fullsize.jodit_toolbar_size-small .jodit_workflow {\n height:calc(100% - 12px * 1.5)\n}\n.jodit_fullsize.jodit_toolbar_size-large .jodit_workflow {\n height:calc(100% - 18px * 1.5)\n}\n.jodit_placeholder {\n -webkit-user-select:none!important;\n -moz-user-select:none!important;\n -ms-user-select:none!important;\n user-select:none!important;\n top:0;\n left:0;\n display:block;\n position:absolute;\n padding:10px;\n color:rgba(0,0,0,.35);\n pointer-events:none\n}\n.jodit_toolbar_popup-inline-target {\n position:absolute;\n width:0;\n height:0\n}\n.jodit_toolbar_popup-inline-target.jodit_toolbar_popup-inline-target-hidden {\n display:none\n}\n.jodit_toolbar_popup-inline {\n display:inline-block!important;\n position:relative!important\n}\n.jodit_toolbar_popup-inline>div {\n color:hsla(0,0%,88%,.99);\n background:#fff;\n box-shadow:none;\n background-clip:padding-box;\n font-family:Helvetica,sans-serif;\n box-sizing:border-box;\n -webkit-user-select:none;\n -moz-user-select:none;\n -ms-user-select:none;\n user-select:none;\n z-index:12!important;\n text-align:left;\n border:1px solid hsla(0,0%,88%,.99);\n display:inline-block;\n vertical-align:top\n}\n.jodit_toolbar_popup-inline .jodit_toolbar {\n z-index:6;\n border:0;\n white-space:normal\n}\n.jodit_toolbar_popup-inline>div>.jodit_toolbar {\n white-space:nowrap;\n box-shadow:none;\n vertical-align:top\n}\n.jodit_toolbar_popup-inline>.jodit_popup_triangle {\n padding:0;\n margin:0;\n width:8px;\n height:8px;\n position:absolute;\n top:-4px;\n margin-left:-4px;\n display:inline-block;\n -webkit-transform:rotate(45deg);\n transform:rotate(45deg);\n background:#fff;\n border:1px solid hsla(0,0%,88%,.99);\n border-width:1px 0 0 1px;\n z-index:5\n}\n.jodit_toolbar_popup-inline.jodit_toolbar_popup-inline-top>.jodit_popup_triangle {\n top:auto;\n bottom:-4px;\n border-width:0 1px 1px 0\n}\n.jodit_toolbar_popup-inline .buttons {\n box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 2px rgba(0,0,0,.24);\n padding:0 2px;\n white-space:nowrap;\n line-height:0;\n border-bottom:0\n}\n[data-jodit_iframe_wrapper] {\n display:block;\n clear:both;\n -webkit-user-select:none;\n -moz-user-select:none;\n -ms-user-select:none;\n user-select:none;\n position:relative\n}\n[data-jodit_iframe_wrapper]:after {\n position:absolute;\n content:\"\";\n z-index:1;\n top:0;\n left:0;\n right:0;\n bottom:0;\n cursor:pointer;\n display:block;\n background:transparent\n}\n.jodit_resizer {\n width:100px;\n height:100px;\n position:absolute;\n border:1px solid rgba(3,14,82,.92);\n top:0;\n left:0;\n display:none;\n pointer-events:none;\n font-size:0\n}\n.jodit_resizer * {\n box-sizing:border-box\n}\n.jodit_resizer>span {\n opacity:0;\n -webkit-transition:opacity .2s linear;\n transition:opacity .2s linear;\n left:50%;\n top:50%;\n height:24px;\n line-height:24px;\n font-size:12px;\n width:70px;\n margin-left:-35px;\n margin-top:-12px;\n text-align:center;\n overflow:visible;\n color:#fff;\n background-color:rgba(0,0,0,.35);\n max-width:100%\n}\n.jodit_resizer>i,\n.jodit_resizer>span {\n position:absolute;\n display:inline-block\n}\n.jodit_resizer>i {\n z-index:4;\n pointer-events:all;\n border:1px solid rgba(3,14,82,.92);\n background-color:hsla(0,0%,88%,.99);\n width:10px;\n height:10px\n}\n.jodit_resizer>i:hover {\n background-color:#f8f8f8\n}\n.jodit_resizer>i:first-child {\n left:-5px;\n top:-5px;\n cursor:nw-resize\n}\n.jodit_resizer>i:nth-child(2) {\n right:-5px;\n top:-5px;\n cursor:ne-resize\n}\n.jodit_resizer>i:nth-child(3) {\n right:-5px;\n bottom:-5px;\n cursor:se-resize\n}\n.jodit_resizer>i:nth-child(4) {\n left:-5px;\n bottom:-5px;\n cursor:sw-resize\n}\n@media (max-width:768px) {\n .jodit_resizer>i {\n  width:20px;\n  height:20px\n }\n .jodit_resizer>i:first-child {\n  left:-10px;\n  top:-10px;\n  cursor:nw-resize\n }\n .jodit_resizer>i:nth-child(2) {\n  right:-10px;\n  top:-10px;\n  cursor:ne-resize\n }\n .jodit_resizer>i:nth-child(3) {\n  right:-10px;\n  bottom:-10px;\n  cursor:se-resize\n }\n .jodit_resizer>i:nth-child(4) {\n  left:-10px;\n  bottom:-10px;\n  cursor:sw-resize\n }\n}\n.jodit_container {\n min-height:100px\n}\n.jodit_container .jodit_workplace {\n display:flex;\n height:auto;\n min-height:50px;\n overflow:hidden\n}\n.jodit_editor_resize {\n position:relative\n}\n.jodit_editor_resize a {\n position:absolute;\n bottom:0;\n right:0;\n -webkit-user-select:none;\n -moz-user-select:none;\n -ms-user-select:none;\n user-select:none;\n width:0;\n height:0;\n overflow:hidden;\n border-width:7px 7px 0 0;\n border-color:transparent #ccc transparent transparent;\n border-style:dashed solid dashed dashed;\n cursor:se-resize\n}\n.jodit_source {\n display:none;\n position:relative;\n background-color:#f8f8f8;\n font-size:0;\n flex:1 1;\n overflow:auto\n}\n.jodit_source,\n.jodit_source .jodit_source_mirror-fake {\n min-height:100%\n}\n.jodit_container.jodit_source_mode .jodit_wysiwyg,\n.jodit_container.jodit_source_mode .jodit_wysiwyg_iframe {\n display:none!important\n}\n.jodit_container.jodit_source_mode .jodit_source {\n display:block!important\n}\n.jodit_container.jodit_split_mode .jodit_source,\n.jodit_container.jodit_split_mode .jodit_wysiwyg,\n.jodit_container.jodit_split_mode .jodit_wysiwyg_iframe {\n display:block!important;\n width:50%;\n flex:1 1\n}\n.jodit_source_mirror {\n border:0;\n width:100%;\n background:#3f3f3f;\n margin:0;\n height:100%;\n box-shadow:none;\n resize:none;\n box-sizing:border-box;\n color:#f0f0f0;\n outline:none;\n font-family:Menlo,Monaco,monospace,sans-serif;\n font-size:13px;\n line-height:1.3em;\n z-index:2;\n padding:10px;\n overflow:auto;\n white-space:pre-wrap;\n -moz-tab-size:2em;\n tab-size:2em;\n min-height:100%\n}\n.jodit_source_mirror::-moz-selection {\n background:#bdbdbd\n}\n.jodit_source_mirror::selection {\n background:#bdbdbd\n}\n.jodit_table_resizer {\n cursor:col-resize;\n position:absolute;\n z-index:3;\n padding-left:5px;\n padding-right:5px;\n margin-left:-5px\n}\n.jodit_table_resizer:after {\n content:\"\";\n display:block;\n height:100%;\n width:0;\n border:1px solid transparent;\n border-width:0 1px 0 0\n}\n.jodit_table_resizer-moved {\n z-index:2\n}\n.jodit_table_resizer-moved:after {\n border-color:#1e88e5\n}\n.jodit_wysiwyg table {\n width:100%;\n border:none;\n border-collapse:collapse;\n table-layout:fixed;\n empty-cells:show;\n max-width:100%\n}\n.jodit_wysiwyg table tr {\n -webkit-user-select:none;\n -moz-user-select:none;\n -ms-user-select:none;\n user-select:none\n}\n.jodit_wysiwyg table tr td,\n.jodit_wysiwyg table tr th {\n border:1px solid #ddd;\n text-align:left;\n vertical-align:middle;\n -webkit-user-select:text;\n -moz-user-select:text;\n -ms-user-select:text;\n user-select:text\n}\n.jodit_wysiwyg table tr td[data-jodit-selected-cell],\n.jodit_wysiwyg table tr th[data-jodit-selected-cell] {\n border:1px double #1e88e5\n}\n.jodit_form_inserter .jodit_form-table-creator-box {\n font-size:0\n}\n.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-container {\n display:inline-block;\n vertical-align:top;\n padding:0;\n margin:0;\n min-width:180px;\n font-size:0\n}\n.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-container>div {\n width:18px;\n height:18px;\n box-sizing:border-box;\n display:inline-block;\n position:relative;\n vertical-align:top\n}\n.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-container>div:after {\n content:\"\";\n position:absolute;\n top:0;\n left:0;\n display:inline-block;\n width:12px;\n height:12px;\n border:1px solid #ccc\n}\n.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-container>div.hovered:after {\n background:#7a450f;\n border:1px solid #b5b5b5\n}\n.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-options {\n font-size:14px;\n display:inline-block;\n vertical-align:top\n}\n.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-options label {\n text-align:left;\n padding-top:0\n}\n.jodit_form_inserter .jodit_form-table-creator-box .jodit_form-options label input {\n margin-right:10px\n}\n.jodit_form_inserter label {\n text-align:center;\n font-size:14px;\n padding:8px;\n display:block;\n margin:0\n}\n.jodit_text_icons .jodit_icon {\n width:auto;\n font-size:14px\n}\n.jodit_text_icons .jodit_icon:first-letter {\n text-transform:uppercase\n}\n.jodit_text_icons .jodit_tabs .jodit_tabs_buttons>a {\n font-family:Helvetica,sans-serif;\n width:auto\n}\n.jodit_text_icons .jodit_tabs .jodit_tabs_buttons>a i,\n.jodit_text_icons .jodit_toolbar>li {\n width:auto\n}\n.jodit_text_icons .jodit_toolbar>li>a {\n text-decoration:none\n}\n.jodit_text_icons.jodit_dialog_box .jodit_dialog .jodit_button,\n.jodit_text_icons.jodit_dialog_box .jodit_dialog .jodit_dialog_header a,\n.jodit_text_icons .jodit_toolbar>li>a {\n padding:0 12px;\n font-family:Helvetica,sans-serif;\n width:auto;\n color:rgba(0,0,0,.75)\n}\n.jodit_text_icons.jodit_dialog_box .jodit_dialog .jodit_button .jodit_icon,\n.jodit_text_icons.jodit_dialog_box .jodit_dialog .jodit_dialog_header a .jodit_icon {\n width:auto\n}\n.jodit_widget,\n.jodit_widget * {\n box-sizing:border-box\n}\n.jodit_search {\n visibility:hidden;\n position:absolute;\n top:0;\n right:0;\n width:0;\n height:0\n}\n.jodit_search.jodit_search-active {\n visibility:visible\n}\n.jodit_search .jodit_search_box {\n width:320px;\n position:absolute;\n right:0;\n background-color:#f9f9f9;\n border:1px solid #ccc;\n border-width:0 0 1px 1px;\n padding:5px\n}\n.jodit_search .jodit_search_box input {\n margin:0;\n width:100%;\n height:100%;\n border:0;\n background-color:transparent;\n outline:none;\n padding:0 10px\n}\n.jodit_search .jodit_search_box input.jodit_search-replace {\n display:none\n}\n.jodit_search .jodit_search_box .jodit_search_buttons,\n.jodit_search .jodit_search_box .jodit_search_counts,\n.jodit_search .jodit_search_box .jodit_search_inputs {\n height:30px;\n display:inline-block;\n vertical-align:top\n}\n.jodit_search .jodit_search_box .jodit_search_inputs {\n width:60%;\n padding-right:5px\n}\n.jodit_search .jodit_search_box .jodit_search_counts {\n width:15%;\n line-height:100%;\n text-align:center;\n color:#ccc;\n border-left:1px solid #ccc\n}\n.jodit_search .jodit_search_box .jodit_search_counts:before {\n content:\"\";\n display:inline-block;\n vertical-align:middle;\n height:100%\n}\n.jodit_search .jodit_search_box .jodit_search_counts span {\n display:inline-block;\n vertical-align:middle\n}\n.jodit_search .jodit_search_box .jodit_search_buttons {\n padding-left:0;\n width:25%\n}\n.jodit_search .jodit_search_box .jodit_search_buttons button {\n outline:0;\n width:32%;\n padding:1px 5px;\n margin-right:1%;\n -webkit-transition:-webkit-transform .1s linear;\n transition:-webkit-transform .1s linear;\n transition:transform .1s linear;\n transition:transform .1s linear, -webkit-transform .1s linear;\n height:100%;\n border:1px solid transparent;\n background-color:transparent\n}\n.jodit_search .jodit_search_box .jodit_search_buttons button.jodit_search_buttons-replace {\n width:100%;\n border:1px solid #ccc;\n margin-top:2px;\n display:none\n}\n.jodit_search .jodit_search_box .jodit_search_buttons button:hover {\n background-color:#ecebe9\n}\n.jodit_search .jodit_search_box .jodit_search_buttons button:focus {\n border:1px solid rgba(181,214,253,.5)\n}\n.jodit_search .jodit_search_box .jodit_search_buttons button:active {\n border:1px solid #b5d6fd;\n -webkit-transform:scale(.95);\n transform:scale(.95)\n}\n.jodit_search.jodit_search-and-replace .jodit_search_counts,\n.jodit_search.jodit_search-and-replace .jodit_search_inputs {\n height:60px\n}\n.jodit_search.jodit_search-and-replace .jodit_search_counts input,\n.jodit_search.jodit_search-and-replace .jodit_search_inputs input {\n height:50%;\n -webkit-transition:background-color .1s linear;\n transition:background-color .1s linear\n}\n.jodit_search.jodit_search-and-replace .jodit_search_counts input:focus,\n.jodit_search.jodit_search-and-replace .jodit_search_inputs input:focus {\n box-shadow:inset 0 0 3px 0 hsla(0,0%,80%,.58)\n}\n.jodit_search.jodit_search-and-replace .jodit_search_buttons button.jodit_search_buttons-replace,\n.jodit_search.jodit_search-and-replace .jodit_search_inputs input.jodit_search-replace {\n display:block\n}\n@media (max-width:320px) {\n .jodit_search,\n .jodit_search .jodit_search_box {\n  width:100%\n }\n}\n.jodit_symbols {\n width:460px;\n padding:10px\n}\n.jodit_symbols .jodit_symbols-container_preview,\n.jodit_symbols .jodit_symbols-container_table {\n display:inline-block;\n vertical-align:top\n}\n.jodit_symbols .jodit_symbols-container_table {\n width:88%\n}\n.jodit_symbols .jodit_symbols-container_preview {\n width:12%\n}\n.jodit_symbols .jodit_symbols-container_preview .jodit_symbols-preview {\n font-size:34px;\n text-align:center;\n padding:20px 0;\n border:1px solid #ccc\n}\n.jodit_symbols table {\n border:0;\n border-spacing:0;\n table-layout:fixed\n}\n.jodit_symbols table td {\n padding:0\n}\n.jodit_symbols table td a {\n font-size:16px;\n text-decoration:none;\n color:#000;\n display:inline-block;\n box-sizing:border-box;\n width:21.6px;\n height:21.6px;\n border:1px solid transparent;\n text-align:center;\n line-height:21.6px;\n vertical-align:top\n}\n.jodit_symbols table td a:focus,\n.jodit_symbols table td a:hover {\n border:1px solid #1e88e5\n}\n.jodit_sticky-dummy_toolbar {\n display:none\n}\n.jodit_sticky>.jodit_toolbar {\n position:fixed;\n z-index:3;\n top:0;\n left:auto\n}\n.jodit_sticky .jodit_sticky-dummy_toolbar {\n display:block\n}\n.jodit_paste_storage {\n padding:10px;\n max-width:600px\n}\n@media (max-width:768px) {\n .jodit_paste_storage {\n  max-width:100%\n }\n}\n.jodit_paste_storage>div {\n max-width:100%;\n max-height:300px;\n border:1px solid #ccc\n}\n.jodit_paste_storage>div:first-child {\n margin-bottom:10px\n}\n.jodit_paste_storage>div:first-child a {\n outline:none;\n box-sizing:border-box;\n display:block;\n max-width:100%;\n white-space:pre;\n overflow:hidden;\n text-overflow:ellipsis;\n padding:5px;\n margin:0;\n border:1px solid transparent;\n text-decoration:none;\n color:#000\n}\n.jodit_paste_storage>div:first-child a.jodit_active {\n color:#fff;\n background-color:#575757\n}\n.jodit_paste_storage>div:first-child a:focus {\n outline:none\n}\n.jodit_paste_storage>div:last-child {\n padding:10px;\n overflow:auto\n}\n.jodit_paste_storage>div:last-child li,\n.jodit_paste_storage>div:last-child ul {\n margin:0\n}\n\n.form-group .form-control.rdw-editor-wrapper {\n  padding: 0;\n}\n.form-control.forminput.slate-wrapper {\n  flex-wrap: wrap;\n  .slate-editor {\n    flex: 0 0 100%;\n    min-height: 14px * 8;\n    padding: 15px;\n  }\n  .required & {\n    &:before {\n      position: absolute;\n    }\n  }\n  .DraftEditor-editorContainer {\n    z-index: auto;\n  }\n}\n.slate-toolbar {\n  position: relative;\n  border: 0;\n  border-bottom: 2px solid rgb(238, 238, 238);\n  display: flex;\n  flex: 1 1 100%;\n  flex-wrap: wrap;\n  gap: 0 7.5px;\n  padding: 15px 0;\n  margin: 0 15px;\n  border-radius: 0;\n  align-items: center;\n  > div {\n    margin: 0;\n    display: flex;\n    gap: 0 7.5px;\n  }\n  .btn {\n    padding: 0;\n    width: 24px;\n    min-height: 24px;\n    justify-content: center;\n    &:hover {\n      box-shadow: none;\n    }\n    &.rdw-option-active {\n      box-shadow: none;\n      svg {\n        stroke-width: @svg-16-stroke-width;\n      }\n    }\n  }\n  .slate-button {\n    flex: 0 0 auto;\n    width: 24px;\n    height: 24px;\n    box-sizing: border-box;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    margin: 0 5px;\n    &.code {\n      display: none;\n    }\n    &.blockquote {\n      display: none;\n    }\n    &.u {\n      display: none;\n    }\n    span {\n      display: flex;\n    }\n    svg {\n      display: block;\n      width: 20px;\n      height: 20px;\n    }\n    @media (min-width: @screen-header-collapse) {\n      &.code {\n        display: flex;\n      }\n      &.blockquote {\n        display: flex;\n      }\n      &.u {\n        display: flex;\n      }\n    }\n  }\n  .slate-source {\n    box-sizing: border-box;\n    padding: 2px;\n    height: 28px;\n    align-self: middle;\n    margin-left: auto;\n  }\n}\n[data-slate-editor] {\n  flex: 0 0 100%;\n  > p {\n    font-size: 1.1rem;\n  }\n  blockquote {\n    border-left: 5px solid #ccc;\n    font-style: italic;\n    margin: 1.5em 10px;\n    padding: 0.5em 10px;\n    quotes: \"\\201C\"\"\\201D\"\"\\2018\"\"\\2019\";\n  }\n  blockquote:before {\n    color: #ccc;\n    font-style: normal;\n    content: open-quote;\n    font-size: 4em;\n    line-height: 0.1em;\n    margin-right: 0.25em;\n    vertical-align: -0.4em;\n  }\n  blockquote p {\n    display: inline;\n  }\n  code {\n    background: #f9f9f9;\n    padding: 5px 8px;\n  }\n}\n[data-slate-editor] > {\n  padding: 0 10px;\n  * + * {\n    margin-top: 1em;\n  }\n}\n\n.slate-editor-frame {\n  width: 100%;\n  height: 480px;\n  border: 1px solid #f9f9f9;\n}\n\n.form-group.editor {\n  flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.other h2 {\n  font-size: 18px;\n  color: #444;\n  margin-bottom: 7px;\n}\n\n.other a {\n  color: #777;\n  text-decoration: underline;\n  font-size: 14px;\n}\n\n.other ul {\n  padding: 0;\n  margin: 0;\n  list-style-type: none;\n}\n\n.App {\n  font-family: sans-serif;\n  text-align: center;\n}\n\nh1 {\n  font-size: 24px;\n  color: #333;\n}\n\n.ltr {\n  text-align: left;\n}\n\n.rtl {\n  text-align: right;\n}\n\n.editor-container {\n  background: none;\n  font-weight: 400;\n  text-align: left;\n  flex-wrap: wrap;\n}\n\n.editor-inner {\n  position: relative;\n  width: 100%;\n  max-width: 100%;\n}\n\n.editor-input {\n  flex: 0 0 100%;\n  min-height: 150px;\n  max-width: 100%;\n  resize: none;\n  position: relative;\n  tab-size: 1;\n  outline: 0;\n  padding: 15px 10px;\n  * {\n    @media screen and (max-width: @screen-header-collapse) {\n      -webkit-touch-callout: none; /* Safari Touch */\n      -webkit-user-select: none;   /* Webkit */\n      -moz-user-select: none;      /* Firefox */\n      -ms-user-select: none;       /* Edge*/\n       user-select: none;       /* Future-proof*/\n    }\n  }\n  a {\n    color: inherit;\n    text-decoration: underline;\n    &:hover {\n      color: @primary_colour;\n    }\n  }\n  .underline {\n    text-decoration: underline;\n  }\n  .line-through {\n    text-decoration: line-through;\n  }\n}\n\n.editor-placeholder {\n  color: @grey_300;\n  overflow: hidden;\n  position: absolute;\n  text-overflow: ellipsis;\n  top: 15px;\n  left: 10px;\n  font-size: 15px;\n  user-select: none;\n  display: inline-block;\n  pointer-events: none;\n}\n\n.editor-text-bold {\n  font-weight: bold;\n}\n\n.editor-text-italic {\n  font-style: italic;\n}\n\n.editor-text-underline {\n  text-decoration: underline;\n}\n\n.editor-text-strikethrough {\n  text-decoration: line-through;\n}\n\n.editor-text-underlineStrikethrough {\n  text-decoration: underline line-through;\n}\n\n.editor-text-code {\n  background-color: rgb(240, 242, 245);\n  padding: 1px 0.25rem;\n  font-family: Menlo, Consolas, Monaco, monospace;\n  font-size: 94%;\n}\n\n.editor-link {\n  color: rgb(33, 111, 219);\n  text-decoration: none;\n}\n\n.tree-view-output {\n  display: block;\n  background: #222;\n  color: #fff;\n  padding: 5px;\n  font-size: 12px;\n  white-space: pre-wrap;\n  margin: 1px auto 10px auto;\n  max-height: 250px;\n  position: relative;\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  overflow: auto;\n  line-height: 14px;\n}\n\n.editor-code {\n  background-color: rgb(240, 242, 245);\n  font-family: Menlo, Consolas, Monaco, monospace;\n  display: block;\n  padding: 8px 8px 8px 52px;\n  line-height: 1.53;\n  font-size: 13px;\n  margin: 0;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  tab-size: 2;\n  /* white-space: pre; */\n  overflow-x: auto;\n  position: relative;\n}\n\n.editor-code:before {\n  content: attr(data-gutter);\n  position: absolute;\n  background-color: #eee;\n  left: 0;\n  top: 0;\n  border-right: 1px solid #ccc;\n  padding: 8px;\n  color: #777;\n  white-space: pre-wrap;\n  text-align: right;\n  min-width: 25px;\n}\n.editor-code:after {\n  content: attr(data-highlight-language);\n  top: 0;\n  right: 3px;\n  padding: 3px;\n  font-size: 10px;\n  text-transform: uppercase;\n  position: absolute;\n  color: rgba(0, 0, 0, 0.5);\n}\n\n.editor-tokenComment {\n  color: slategray;\n}\n\n.editor-tokenPunctuation {\n  color: #999;\n}\n\n.editor-tokenProperty {\n  color: #905;\n}\n\n.editor-tokenSelector {\n  color: #690;\n}\n\n.editor-tokenOperator {\n  color: #9a6e3a;\n}\n\n.editor-tokenAttr {\n  color: #07a;\n}\n\n.editor-tokenVariable {\n  color: #e90;\n}\n\n.editor-tokenFunction {\n  color: #dd4a68;\n}\n\n.editor-paragraph {\n  margin: 0;\n  margin-bottom: 8px;\n  position: relative;\n}\n\n.editor-paragraph:last-child {\n  margin-bottom: 0;\n}\n\n.editor-heading-h1 {\n  font-size: 24px;\n  color: rgb(5, 5, 5);\n  font-weight: 400;\n  margin: 0;\n  margin-bottom: 12px;\n  padding: 0;\n}\n\n.editor-heading-h2 {\n  font-size: 15px;\n  color: rgb(101, 103, 107);\n  font-weight: 700;\n  margin: 0;\n  margin-top: 10px;\n  padding: 0;\n  text-transform: uppercase;\n}\n\nblockquote {\n  background: #f2f2f2;\n  border-left-color: rgb(206, 208, 212);\n  border-left-width: 4px;\n  border-left-style: solid;\n  padding: 16px;\n  margin: 1em 0;\n}\n\n.editor-list-ol {\n  padding: 0;\n  margin: 0;\n  margin-left: 16px;\n}\n\n.editor-list-ul {\n  padding: 0;\n  margin: 0;\n  margin-left: 16px;\n}\n\n.editor-listitem {\n  margin: 8px 32px 8px 32px;\n}\n\n.editor-nested-listitem {\n  list-style-type: none;\n}\n\npre::-webkit-scrollbar {\n  background: transparent;\n  width: 10px;\n}\n\npre::-webkit-scrollbar-thumb {\n  background: #999;\n}\n\n.debug-timetravel-panel {\n  overflow: hidden;\n  padding: 0 0 10px 0;\n  margin: auto;\n  display: flex;\n}\n\n.debug-timetravel-panel-slider {\n  padding: 0;\n  flex: 8;\n}\n\n.debug-timetravel-panel-button {\n  padding: 0;\n  border: 0;\n  background: none;\n  flex: 1;\n  color: #fff;\n  font-size: 12px;\n}\n\n.debug-timetravel-panel-button:hover {\n  text-decoration: underline;\n}\n\n.debug-timetravel-button {\n  border: 0;\n  padding: 0;\n  font-size: 12px;\n  top: 10px;\n  right: 15px;\n  position: absolute;\n  background: none;\n  color: #fff;\n}\n\n.debug-timetravel-button:hover {\n  text-decoration: underline;\n}\n\n.emoji {\n  color: transparent;\n  background-size: 16px 16px;\n  background-position: center;\n  background-repeat: no-repeat;\n  vertical-align: middle;\n  margin: 0 -1px;\n}\n\n.emoji-inner {\n  padding: 0 0.15em;\n}\n\n.emoji-inner::selection {\n  color: transparent;\n  background-color: rgba(150, 150, 150, 0.4);\n}\n\n.emoji-inner::moz-selection {\n  color: transparent;\n  background-color: rgba(150, 150, 150, 0.4);\n}\n\n\n.toolbar {\n  display: flex;\n  flex: 0 0 100%;\n  margin-bottom: 1px;\n  flex-wrap: wrap;\n  padding-bottom: 4px;\n  vertical-align: middle;\n  border-bottom: 2px solid rgb(238, 238, 238);\n}\n\n.toolbar button.toolbar-item {\n  border: 1px solid transparent;\n  display: flex;\n  background: none;\n  padding: 8px;\n  cursor: pointer;\n  vertical-align: middle;\n}\n\n.toolbar button.toolbar-item:disabled {\n  cursor: not-allowed;\n}\n\n.toolbar button.toolbar-item.spaced {\n  margin-right: 2px;\n}\n\n.toolbar button.toolbar-item i.format {\n  background-size: contain;\n  display: inline-block;\n  height: 18px;\n  width: 18px;\n  margin-top: 2px;\n  vertical-align: -0.25em;\n  display: flex;\n  opacity: 0.6;\n}\n\n.toolbar button.toolbar-item:disabled i.format {\n  opacity: 0.2;\n}\n\n.toolbar button.toolbar-item.active {\n  background-color: rgba(223, 232, 250, 0.3);\n}\n\n.toolbar button.toolbar-item.active i {\n  opacity: 1;\n}\n\n.toolbar .toolbar-item:hover:not([disabled]) {\n  background-color: #eee;\n}\n\n.toolbar .divider {\n  width: 1px;\n  background-color: #eee;\n  margin: 0 4px;\n}\n\n.toolbar select.toolbar-item {\n  border: 1px solid transparent;\n  display: flex;\n  background: none;\n  border-radius: 10px;\n  padding: 8px;\n  vertical-align: middle;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  width: 70px;\n  font-size: 14px;\n  color: #777;\n  text-overflow: ellipsis;\n}\n\n.toolbar select.code-language {\n  text-transform: capitalize;\n  width: 130px;\n}\n\n.toolbar .toolbar-item .text {\n  display: flex;\n  line-height: 20px;\n  width: 200px;\n  vertical-align: middle;\n  font-size: 14px;\n  color: #777;\n  text-overflow: ellipsis;\n  width: 70px;\n  overflow: hidden;\n  height: 20px;\n  text-align: left;\n}\n\n.toolbar i.chevron-down {\n  margin-top: 3px;\n  width: 16px;\n  height: 16px;\n  display: flex;\n  user-select: none;\n}\n\n.toolbar i.chevron-down.inside {\n  width: 16px;\n  height: 16px;\n  display: flex;\n  margin-left: -25px;\n  margin-top: 11px;\n  margin-right: 10px;\n  pointer-events: none;\n}\n\ni.chevron-down {\n  background-color: transparent;\n  background-size: contain;\n  display: inline-block;\n  height: 8px;\n  width: 8px;\n}\n\n#block-controls button:hover {\n  background-color: #efefef;\n}\n\n#block-controls button:focus-visible {\n  border-color: blue;\n}\n\n#block-controls span.block-type {\n  background-size: contain;\n  display: block;\n  width: 18px;\n  height: 18px;\n  margin: 2px;\n}\n\n.dropdown {\n  z-index: 5;\n  display: block;\n  position: absolute;\n  box-shadow: 0 12px 28px 0 rgba(0, 0, 0, 0.2), 0 2px 4px 0 rgba(0, 0, 0, 0.1),\n    inset 0 0 0 1px rgba(255, 255, 255, 0.5);\n  border-radius: 8px;\n  min-width: 100px;\n  min-height: 40px;\n  background-color: #fff;\n}\n\n.dropdown .item {\n  margin: 0 8px 0 8px;\n  padding: 8px;\n  color: #050505;\n  cursor: pointer;\n  line-height: 16px;\n  font-size: 15px;\n  display: flex;\n  align-content: center;\n  flex-direction: row;\n  flex-shrink: 0;\n  justify-content: space-between;\n  background-color: #fff;\n  border-radius: 8px;\n  border: 0;\n  min-width: 268px;\n}\n\n.dropdown .item .active {\n  display: flex;\n  width: 20px;\n  height: 20px;\n  background-size: contain;\n}\n\n.dropdown .item:first-child {\n  margin-top: 8px;\n}\n\n.dropdown .item:last-child {\n  margin-bottom: 8px;\n}\n\n.dropdown .item:hover {\n  background-color: #eee;\n}\n\n.dropdown .item .text {\n  display: flex;\n  line-height: 20px;\n  flex-grow: 1;\n  width: 200px;\n}\n\n.dropdown .item .icon {\n  display: flex;\n  width: 20px;\n  height: 20px;\n  user-select: none;\n  margin-right: 12px;\n  line-height: 16px;\n  background-size: contain;\n}\n\n.link-editor {\n  position: absolute;\n  z-index: 1000;\n  top: -10000px;\n  left: -10000px;\n  margin-top: -6px;\n  max-width: 300px;\n  width: 100%;\n  opacity: 0;\n  background-color: #fff;\n  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  transition: opacity 0.5s;\n}\n\n.link-editor .link-input {\n  display: flex;\n  width: calc(100% - 24px);\n  box-sizing: border-box;\n  margin: 8px 12px;\n  padding: 8px 0 8px 12px;\n  border-radius: 15px;\n  background-color: #eee;\n  font-size: 15px;\n  color: rgb(5, 5, 5);\n  border: 0;\n  outline: 0;\n  position: relative;\n  font-family: inherit;\n}\n\n.link-editor .link-target {\n  display: flex;\n  gap: 5px 5px;\n  width: 100%;\n  margin: 8px 12px;\n  padding: 8px 0 8px 0;\n}\n\n.link-editor div.link-edit {\n  background-size: 16px;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 35px;\n  vertical-align: -0.25em;\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  cursor: pointer;\n}\n\n.link-editor .link-input a {\n  color: rgb(33, 111, 219);\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1 1 100%;\n}\n\n.link-editor .link-input a:hover {\n  text-decoration: underline;\n}\n\n.link-editor .button {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  padding: 6px;\n  border-radius: 8px;\n  cursor: pointer;\n  margin: 0 2px;\n}\n\n.link-editor .button.hovered {\n  width: 20px;\n  height: 20px;\n  display: inline-block;\n  background-color: #eee;\n}\n\n.link-editor .button i,\n.actions i {\n  background-size: contain;\n  display: inline-block;\n  height: 20px;\n  width: 20px;\n  vertical-align: -0.25em;\n}\n\n.nestedListItem {\n  list-style-type: none;\n  &:before, &:after {\n    display: none;\n  }\n  > ul {\n    padding-top: 0;\n  }\n}\n\n.lexical-inline-image {\n  position: relative;\n  button {\n    position: absolute;\n    top: 5px;\n    left: 5px;\n  }\n  img.focused.draggable {\n    cursor: grab;\n    &:active {\n      cursor: grabbing;\n    }\n  }\n}\nfigure.inline-image {\n  display: inline-flex;\n  flex-direction: column;\n  &.position-left {\n    float: left\n  }\n  &.position-right {\n    float: right\n  }\n  &.position-full {\n    width: 100%;\n  }\n}","// main: ../framework.less\n.notes-summary {\n  display: block;\n  &:hover {\n    background: @tertiary_colour_10;\n  }\n  &-top {\n    border-top: 1px solid @grey_50;\n    padding: 20px 20px 0 20px;\n    display: flex;\n    align-items: center;\n    gap: 0 6px;\n    .avatar-md > .thumbimg {\n      .circle(24px);\n    }\n    .agents {\n      display: flex;\n      align-items: center;\n      overflow: hidden;\n    }\n  }\n  &-date {\n    margin-left: auto;\n    font-size: 11px;\n    font-weight: 400;\n    color: @grey_300;\n    text-align: right;\n  }\n  &-pin {\n    .btn {\n      svg {\n        stroke: @grey_200;\n      }\n      &.pinned {\n        svg {\n          stroke: @primary_colour;\n        }\n      }\n    }\n  }\n  &-private {\n    .btn {\n      svg {\n        stroke: @grey_200;\n      }\n      &.private {\n        svg {\n          stroke: @primary_colour;\n        }\n      }\n    }\n  }\n  &-tag-name{\n    display: flex;\n  }\n  &-body {\n    padding: 20px 20px;\n    display: block;\n    div {\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n    }\n  }\n  &:last-of-type &-bottom {\n    border-bottom: 1px solid @grey_50;\n  }\n  &-bottom {\n    display: flex;\n    gap: 6px 6px;\n    padding: 0 20px 20px 20px;\n    justify-content: space-between;\n    .notes-summary-comments {\n      display: flex;\n      align-items: center;\n      gap: 0 6px;\n      color: @primary_colour;\n      font-weight: 600;\n      .icon {\n        width: 16px;\n        height: 16px;\n      }\n      svg {\n        width: 16px;\n        height: 16px;\n        fill: none;\n        stroke: @grey_200;\n        stroke-width: @svg-16-stroke-width;\n      }\n    }\n  }\n  .notes-summary-creator {\n    .agent {\n      margin-right: 5px;\n    }\n  }\n  .notes-summary-attachments {\n    display: flex;\n    align-items: center;\n    gap: 0 6px;\n    color: @primary_colour;\n    font-weight: 600;\n    svg {\n      width: 16px;\n      fill: none;\n      stroke: @grey_200;\n      stroke-width: @svg-16-stroke-width;\n    }\n  }\n  .notes-summary-tag {\n    border-radius: 30px;\n    padding: 5px 8px;\n    font-size: 10px;\n    background: @grey_300;\n    color: @white;\n    &-related {\n      border-radius: 30px;\n      padding: 5px 8px;\n      font-size: 10px;\n      background: @grey_200;\n      color: @white;\n    }\n    &-name {\n      margin-left: auto;\n    }\n  }\n  &.active {\n    border: 2px solid @grey;\n  }\n}\n\n.notes-index {\n  top: 0;\n  position: relative;\n  grid-area: jump-menu;\n  width: 100%;\n  @media screen and (min-width: @screen-header-collapse) {\n    position: sticky;\n    width: 370px;\n  }\n  background: #ffffff;\n  form, > div:nth-child(1) {\n    padding: 10px 20px;\n    display: flex;\n  }\n  .keyword-search {\n    display: flex;\n    flex-wrap: wrap;\n    flex: 0 0 100%;\n    gap: 10px 10px;\n    .btn-red {\n      margin-left: auto;\n    }\n    > .form-group {\n      flex: 0 0 100%;\n      gap: 10px 10px;\n      .form-group {\n        flex: 1 1 auto;\n        &.dateinput {\n          flex: 0 0 auto;\n        }\n      }\n    }\n    .advanced-toggle {\n      flex: 1 1 auto;\n      justify-content: center;\n    }\n    .button-only {\n      flex: 0 0 auto !important;\n    }\n    .input-only {\n      .flatpickr-wrapper {\n        flex: 0 0 0;\n        max-width: 0;\n      }\n      .input-group-addon {\n        min-height: 36px;\n      }\n    }\n    .inline-select .input-group-addon {\n      font-size: 14px;\n      padding-left: 15px;\n    }\n  }\n  .no-notes {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    min-height: 100%;\n    padding-bottom: 56px;\n    .no-notes-wrapper {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex: 1 1 100%;\n    }\n  }\n}\n.notes-view-notes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px 0;\n}\n\n.tab-notes {\n  .stepper {\n    grid-area: details;\n  }\n}\n\n.notes-view {\n  position: fixed;\n  top: @navbar-height + 44px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow-x: auto;\n  z-index: 1000;\n  padding-top: 15px;\n  padding-left: 15px;\n  padding-right: 15px;\n  grid-area: details;\n  grid-template-areas: \"interactions\";\n  grid-template-columns: auto;\n  background-color: @grey_50;\n  @media screen and (min-width: @screen-header-collapse) {\n    z-index: initial;\n    position: relative;\n    top: 0;\n    padding-top: 0;\n    padding-left: 0;\n    display: grid;\n  }\n  &.no-notes {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  &-note, &-comment {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 0 20px;\n    flex: 0 0 100%;\n  }\n  .agent {\n    margin: 0;\n  }\n  &-author {\n    font-size: 11px;\n    color: @grey_600;\n    font-weight: 600;\n  }\n  &-comment {\n    .notes-view-body {\n      background: @tertiary_colour_10;\n    }\n  }\n  &-body {\n    flex: 1 1 100%;\n    display: flex;\n    flex-wrap: wrap;\n    background: @grey_25;\n    padding: 20px;\n    gap: 10px 0;\n    border-radius: @card-radius;\n    position: relative;\n    .notes-summary-tag-name {\n      margin-right: 5px;\n    }\n  }\n  &-content {\n    flex: 0 0 100%;\n  }\n  &-top {\n    flex: 0 0 100%;\n    display: flex;\n    flex-wrap: nowrap;\n  }\n  &-date {\n    margin-left: auto;\n    font-size: 11px;\n    font-weight: 400;\n    color: @grey_400;\n    text-align: right;\n  }\n  &-bottom {\n    flex: 0 0 100%;\n    display: flex;\n    gap: 6px 6px;\n    .btn {\n      min-height: 1.5em;\n    }\n  }\n  &-attachments {\n    flex: 0 0 100%;\n    display: flex;\n    gap: 6px 6px;\n    svg {\n      width: 16px;\n      fill: none;\n      stroke: @primary_colour;\n      stroke-width: @svg-16-stroke-width;\n    }\n  }\n  &-relations-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px 10px;\n  }\n  &-relation {\n    border: 1px solid @grey_200;\n    border-radius: 2px;\n    font-weight: 500;\n    font-size: 12px;\n    padding: 2px 5px;\n    color: @grey_700;\n  }\n  \n}\n.notes-view, .notes-summary {\n  .tag{\n    background-color: @white;\n    border: 1px solid @grey_200;\n    &.Scheduled {\n      background-color: @warning_10;\n      color: @warning;\n      border: none;\n      display: list-item;\n      list-style-position: inside;\n      white-space: nowrap;        \n    }\n    &.Complete {\n      background-color: @success_10;\n      color: @success;\n      border: none;\n      display: list-item;\n      list-style-position: inside;\n      white-space: nowrap;        \n    }\n    &.Proceed {\n      background-color: @info_10;\n      color: @info;\n      border: none;\n      display: list-item;\n      list-style-position: inside;\n      white-space: nowrap;\n    }\n    &.Cancelled {\n      background-color: @error_10;\n      color: @error;\n      border: none;\n      display: list-item;\n      list-style-position: inside;\n      white-space: nowrap;        \n    }\n  }\n}\n\n.notes-view-form {\n  flex: 0 0 100%;\n  &-footer {\n    margin-top: 15px;\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.notes-view-private-footer {\n  background-color: @primary_colour;\n  position: absolute;\n  right: 0px;\n  bottom: 0px;\n  color: @white;\n  border-radius: 0px 0px 5px 0px;\n  display: flex;\n  align-items: center;\n  .icon {\n    height: 16px;\n    width: 16px;\n    svg {\n      stroke: @white;\n      stroke-width: 2.4;\n    }\n  }\n  .list {\n    padding: 0px 3px 0px 3px;\n  }\n}","// main: ../framework.less\n\n.leads-summary {\n  padding: 20px;\n  background: @grey_25;\n  border-radius: 8px;\n  &.new-lead {\n    background: @tertiary_colour_10;\n  }\n  &:hover {\n    background: @tertiary_colour_10;\n  }\n  &.active {\n    box-shadow: 0 0 0 2px @grey;\n  }\n  &-top {\n    display: flex;\n    align-items: center;\n    gap: 0 6px;\n    .tag {\n      &.New {\n        background: @secondary_colour;\n        color: #ffffff;\n      }\n      &.Contacted {\n        background: @success;\n        color: #ffffff;\n      }\n      &.Viewing {\n        background: @tertiary_colour;\n        color: #ffffff;\n      }\n      &.Rental-Application {\n        background: @quality;\n        color: #ffffff;\n      }\n      &.Offer {\n        background: @quality;\n        color: #ffffff;\n      }\n      &.Sold {\n        background: @warning;\n        color: #ffffff;\n      }\n      &.Rented {\n        background: @warning;\n        color: #ffffff;\n      }\n      &.Archived {\n        background: @primary_colour;\n        color: #ffffff;\n      }\n    }\n  }\n  &-date {\n    margin-left: auto;\n    font-size: 11px;\n  }\n  &-pin {\n    .btn {\n      svg {\n        stroke: @grey_200;\n      }\n      &.pinned {\n        svg {\n          stroke: @primary_colour;\n        }\n      }\n    }\n  }\n  &-body {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    margin: 20px 0 0;\n  }\n  &-bottom {\n    display: flex;\n    gap: 6px 6px;\n    .leads-summary-comments {\n      display: flex;\n      align-items: center;\n      gap: 0 6px;\n      color: @primary_colour;\n      font-weight: 600;\n      .icon {\n        width: 16px;\n        height: 16px;\n      }\n      svg {\n        width: 16px;\n        height: 16px;\n        fill: none;\n        stroke: @grey_200;\n        stroke-width: @svg-16-stroke-width;\n      }\n    }\n  }\n  .leads-summary-attachments {\n    display: flex;\n    align-items: center;\n    gap: 0 6px;\n    color: @primary_colour;\n    font-weight: 600;\n    svg {\n      width: 16px;\n      fill: none;\n      stroke: @grey_200;\n      stroke-width: @svg-16-stroke-width;\n    }\n  }\n  .leads-summary-tag {\n    border-radius: 30px;\n    padding: 5px 8px;\n    font-size: 10px;\n    background: @grey_300;\n    color: @white;\n    &-related {\n      border-radius: 30px;\n      padding: 5px 8px;\n      font-size: 10px;\n      background: @grey_200;\n      color: @white;\n    }\n  }\n}\n\n.leads-view-leads {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px 0;\n}\n\n.tab-leads {\n  .residential &, .commercial &, .projects &, .holiday & {\n    padding: 0;\n    grid-template-areas: \"jump-menu\" \"details\";\n    @media screen and (min-width: @screen-header-collapse) {\n      grid-template-areas: \"jump-menu details\";\n      grid-template-columns: 370px 1fr;\n      grid-template-rows: 1fr;\n    }\n    .stepper {\n      grid-area: details;\n    }\n  }\n}\n\n.latest-leads-widget.leads-index {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px 8px;\n}\n\n.leads-view {\n  position: fixed;\n  top: @navbar-height + 44px;\n  bottom: 0;\n  overflow-x: auto;\n  z-index: 1000;\n  padding-top: 15px;\n  padding-left: 15px;\n  padding-right: 15px;\n  grid-area: details;\n  grid-template-areas: \"lead-details\" \"interactions\";\n  grid-template-columns: 1fr;\n  background-color: @grey_50;\n  @media screen and (min-width: @screen-header-collapse) {\n    z-index: initial;\n    position: relative;\n    top: 0;\n    padding-top: 0;\n    padding-left: 0;\n    display: grid;\n    grid-template-areas: \"interactions lead-details\";\n    grid-template-columns: 1fr 260px;\n  }\n  gap: 20px 20px;\n  .lead-details {\n    grid-area: lead-details;\n    .primary-bg {\n      h3 {\n        color: @white;\n      }\n    }\n    .btn-grey {\n      margin-right: auto;\n    }\n  }\n  .lead-interactions {\n    grid-area: interactions;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    min-height: 0;\n    gap: 20px;\n    .card {\n      margin-bottom: 0;\n    }\n  }\n  &.no-leads {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  &-note, &-comment {\n    display: flex;\n    flex-wrap: nowrap;\n    gap: 0 20px;\n    flex: 0 0 100%;\n  }\n  .agent {\n    margin: 0;\n  }\n  &-author {\n    font-size: 11px;\n    color: @grey_600;\n    font-weight: 600;\n  }\n  &-comment {\n    .leads-view-body {\n      background: @tertiary_colour_10;\n    }\n  }\n  &-body {\n    flex: 1 1 100%;\n    display: flex;\n    flex-wrap: wrap;\n    background: @grey_25;\n    padding: 20px;\n    gap: 10px 0;\n    border-radius: @card-radius;\n  }\n  &-content {\n    flex: 0 0 100%;\n  }\n  &-top {\n    flex: 0 0 100%;\n    display: flex;\n    flex-wrap: nowrap;\n  }\n  &-date {\n    margin-left: auto;\n    font-size: 11px;\n  }\n  &-bottom {\n    flex: 0 0 100%;\n    display: flex;\n    gap: 6px 6px;\n    .btn {\n      min-height: 1.5em;\n    }\n  }\n  &-attachments {\n    flex: 0 0 100%;\n    display: flex;\n    gap: 6px 6px;\n    svg {\n      width: 16px;\n      fill: none;\n      stroke: @primary_colour;\n      stroke-width: @svg-16-stroke-width;\n    }\n  }\n  &-relation {\n    border-radius: 2px;\n    border: 1px solid @grey_200;\n    font-weight: 500;\n    font-size: 12px;\n    padding: 2px 5px;\n  }\n}\n.leads-view-form {\n  flex: 0 0 100%;\n  &-footer {\n    margin-top: 15px;\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.leads-index {\n  top: 0;\n  position: relative;\n  grid-area: jump-menu;\n  min-width: 0;\n  min-height: 0;\n  @media screen and (min-width: @screen-header-collapse) {\n    position: sticky;\n    width: 370px;\n  }\n  background: #ffffff;\n  form, > div:nth-child(1) {\n    padding: 10px 15px;\n    display: flex;\n  }\n  .keyword-search {\n    display: flex;\n    flex-wrap: wrap;\n    flex: 0 0 100%;\n    gap: 10px 10px;\n    .btn-red {\n      margin-left: auto;\n    }\n    > .form-group {\n      flex: 0 0 100%;\n      gap: 10px 10px;\n      .form-group {\n        flex: 1 1 auto;\n        &.dateinput {\n          flex: 0 0 auto;\n        }\n      }\n    }\n    .advanced-toggle {\n      flex: 1 1 auto;\n      justify-content: center;\n    }\n    .button-only {\n      flex: 0 0 auto !important;\n    }\n    .input-only {\n      .flatpickr-wrapper {\n        flex: 0 0 0;\n        max-width: 0;\n      }\n      .input-group-addon {\n        min-height: 36px;\n      }\n    }\n    .inline-select .input-group-addon {\n      font-size: 14px;\n      padding-left: 15px;\n    }\n  }\n  .leads-index-list-inner {\n    padding: 2px 15px 0;\n    display: flex;\n    gap: 15px 0;\n    flex-direction: column;\n  }\n  .no-leads {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    min-height: 100%;\n    padding-bottom: 56px;\n    .no-leads-wrapper {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex: 1 1 100%;\n    }\n  }\n}\n\n.lead-progress {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 0 10px;\n  padding: 15px 20px;\n  .tablecell & {\n    padding: 0;\n  }\n  .lead-progress-label {\n    text-align: center;\n    white-space: nowrap;\n  }\n  .flex-heading + & {\n    margin-left: auto;\n    padding: 0;\n    .lead-progress-item {\n      flex-direction: row;\n      gap: 10px 10px;\n    }\n    .lead-progress-label {\n      font-weight: bold;\n      color: @primary_colour;\n    }\n  }\n  .lead-progress-label {\n    margin-top: 5px;\n    text-align: center;\n    white-space: nowrap;\n  }\n  .lead-progress-meta {\n    font-size: 9px;\n    color: @grey_600;\n    text-align: center;\n    white-space: nowrap;\n  }\n  .lead-progress-divider {\n    height: 1px;\n    margin: 32px 0 0;\n    background: @grey;\n    align-self: flex-start;\n    flex: 1 1 auto;\n  }\n  .lead-progress-icon {\n    display: flex;\n    align-items: center;\n    svg {\n      fill: none;\n      stroke: #ffffff;\n      stroke-width: @svg-16-stroke-width;\n      width: 16px;\n      height: 16px !important;\n    }\n    background: @grey;\n    width: 16px;\n    height: 16px;\n    .circle(16px);\n    &.New {\n      background: @secondary_colour;\n      + .lead-progress-label {\n        color: @primary_colour;\n      }\n    }\n    &.Contacted {\n      background: @success;\n      + .lead-progress-label {\n        color: @primary_colour;\n      }\n    }\n    &.Lease-Application {\n      background: @quality;\n      + .lead-progress-label {\n        color: @primary_colour;\n      }\n    }\n    &.Viewing {\n      background: @tertiary_colour;\n      + .lead-progress-label {\n        color: @primary_colour;\n      }\n    }\n    &.Offer {\n      background: @quality;\n      + .lead-progress-label {\n        color: @primary_colour;\n      }\n    }\n    &.Sold {\n      background: @warning;\n      + .lead-progress-label {\n        color: @primary_colour;\n      }\n    }\n    &.Rented {\n      background: @warning;\n      + .lead-progress-label {\n        color: @primary_colour;\n      }\n    }\n    &.Archived {\n      background: @primary_colour;\n      + .lead-progress-label {\n        color: @primary_colour;\n      }\n    }\n    &.offer-made {\n      background: @info;\n      + .lead-progress-label {\n        color: @primary_colour;\n        font-weight: 500;\n      }\n    }\n    &.sale-agreement {\n      background: @info_130;\n      + .lead-progress-label {\n        color: @primary_colour;\n        font-weight: 500;\n      }\n    }\n    &.buyer-signed {\n      background: @tertiary_colour;\n      + .lead-progress-label {\n        color: @primary_colour;\n        font-weight: 500;\n      }\n    }\n    &.seller-signed {\n      background: @tertiary_colour_130;\n      + .lead-progress-label {\n        color: @primary_colour;\n        font-weight: 500;\n      }\n    }\n    &.instruction-sent {\n      background: @quality;\n      + .lead-progress-label {\n        color: @primary_colour;\n        font-weight: 500;\n      }\n    }\n    &.deposit-received {\n      background: @quality_120;\n      + .lead-progress-label {\n        color: @primary_colour;\n        font-weight: 500;\n      }\n    }\n    &.conditions-met {\n      background: @quality_120;\n      + .lead-progress-label {\n        color: @primary_colour;\n        font-weight: 500;\n      }\n    }\n    &.lodged {\n      background: @success;\n      + .lead-progress-label {\n        color: @primary_colour;\n        font-weight: 500;\n      }\n    }\n    &.closed {\n      background: @secondary_colour_120;\n      + .lead-progress-label {\n        color: @primary_colour;\n        font-weight: 500;\n      }\n    }\n    &.cancelled {\n      background: @primary_colour;\n      + .lead-progress-label {\n        color: @primary_colour;\n      }\n    }\n  }\n  .lead-progress-item {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    flex: 0 0;\n    line-height: 21px;\n  }\n}\n\n.interaction-selection {\n  display: flex;\n  gap: 15px 6px;\n  flex-wrap: wrap;\n  margin-bottom: 25px;\n  .btn {\n    flex: 0 0 100%;\n    @media screen and (min-width: @screen-header-collapse) {\n      flex: 0 0 auto;\n    }\n  }\n}\n\n.back-to-leads {\n  position: fixed;\n  padding: 4px 0 !important;\n  background: #ffffff;\n  top: @navbar-height;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n}\n\n.interaction-buttons {\n  margin-top: 25px;\n}\n\n.lead-interaction-details {\n  strong {\n    font-size: 12px;\n  }\n  .cardbody .ccontent {\n    display: flex;\n    flex-direction: column;\n    gap: 10px 10px;\n  }\n}\n.lead-interaction-item-icon {\n  display: flex;\n  width: 44px;\n  .circle(44px);\n  align-items: center;\n  justify-content: center;\n  &.Contacted {\n    background: @success_25;\n    svg {\n      stroke: @success;\n    }\n  }\n  &.Viewing {\n    background: @info_25;\n    svg {\n      stroke: @info;\n    }\n  }\n  &.Rental-Application {\n    background: @quality_25;\n    svg {\n      stroke: @quality;\n    }\n  }\n  &.Offer {\n    background: @quality_25;\n    svg {\n      stroke: @quality;\n    }\n  }\n  &.Archived {\n    background: @primary_colour_25;\n    svg {\n      stroke: @primary_colour;\n    }\n  }\n  svg {\n    width: 24px;\n    height: 24px;\n    stroke-width: @svg-24-stroke-width;\n  }\n}\n.lead-interaction-item-header {\n  font-size: 11px;\n  flex: 1 1 auto;\n  gap: 12px 12px;\n  display: flex;\n  align-items: center;\n}\n.lead-interaction-item-top {\n  flex: 1 1 auto;\n  > * {\n    flex: 1 1 100%;\n  }\n  strong {\n    color: @primary_colour;\n    margin-right: auto;\n  }\n}\n\n.lead-interaction-item-date {\n  font-size: 11px;\n}\n\n.interaction-buttons {\n  display: flex;\n  gap: 20px 20px;\n}\n\n.interaction-form {\n  .form-group .input-label {\n    background: @grey_25;\n  }\n}\n\n.lead-interaction-tags {\n  margin-top: 12px;\n  .lead-interaction-tag {\n    background: @white;\n    border: 1px solid @grey_200;\n  }\n}\n\n.lead-interaction-item-body {\n  label {\n    display: block;\n    color: @grey_400;\n    text-transform: uppercase;\n    font-size: 11px;\n    margin-top: 12px;\n    &:nth-child(1) {\n      margin-top: 0;\n    }\n  }\n}\n\n.lead-log-timeline {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  gap: 13px 13px;\n  padding-bottom: 0;\n  .lead-log-timeline-bar {\n    width: 7px;\n    &:before {\n      width: 1px;\n    }\n    &:after {\n      content:\"\";\n      position: absolute;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      height: 20px;\n      background-image: linear-gradient(to bottom, transparent, #FFF);\n    }\n  }\n\n  .lead-log-item {\n    position: relative;\n    display: flex;\n    gap: 2px 12px;\n    z-index: 1;\n    h5 {\n      margin: 0;\n      font-weight: 600;\n    }\n    &-icon {\n      display: flex;\n      align-items: center;\n      margin: 2px 0;\n      .circle(7px);\n      &.New {\n        background: @secondary_colour;\n        color: #ffffff;\n      }\n      &.Contacted {\n        background: @success;\n        color: #ffffff;\n      }\n      &.Viewing {\n        background: @tertiary_colour;\n        color: #ffffff;\n      }\n      &.Rental-Application {\n        background: @quality;\n        color: #ffffff;\n      }\n      &.Offer {\n        background: @quality;\n        color: #ffffff;\n      }\n      &.Sold {\n        background: @warning;\n        color: #ffffff;\n      }\n      &.Rented {\n        background: @warning;\n        color: #ffffff;\n      }\n      &.Archived {\n        background: @primary_colour;\n        color: #ffffff;\n      }\n    }\n  }\n}","// main: ../framework.less\n\n\n.tc-tooltip {\n  pointer-events: none;\n  font-size: 0.9rem;\n  background: @grey_25;\n  border-radius: @border-radius;\n  border: 1px solid @grey_200;\n  max-width: 50%;\n  z-index: 1000;\n  &.tc-tooltip-clickable {\n    pointer-events: all;\n  }\n  &-wrapper {\n    position: relative;\n    display: inline-block;\n  }\n  &-title {\n    margin: 0;\n    padding: 6px 8px;\n    font-size: 1rem;\n    line-height: 1;\n    border-bottom: 1px solid @grey_200;\n    background: #f4f4f4;\n  }\n  &-content {\n    text-align: left;\n    padding: 8px;\n  }\n  &-arrow{\n    &-bottom{\n      box-shadow: @card-shadow;\n      &:after {\n        content:\"\";\n        border-color: @grey_25 transparent transparent transparent;\n        border-width: 10px;\n        border-style: solid;\n        position: absolute;\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n      }\n      &:before {\n        content:\"\";\n        border-color: @grey_200 transparent transparent transparent;\n        border-width: 11px;\n        border-style: solid;\n        position: absolute;\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n      }\n    }\n    &-bottom-left{\n      box-shadow: @card-shadow;\n      &:after {\n        content:\"\";\n        border-color: @grey_25 transparent transparent transparent;\n        border-width: 10px;\n        border-style: solid;\n        position: absolute;\n        top: 100%;\n        left: 80px;\n        transform: translateX(-50%);\n      }\n      &:before {\n        content:\"\";\n        border-color: @grey_200 transparent transparent transparent;\n        border-width: 11px;\n        border-style: solid;\n        position: absolute;\n        top: 100%;\n        left: 80px;\n        transform: translateX(-50%);\n      }\n    }\n    &-top{\n      box-shadow: @card-shadow;\n      &:after {\n        content:\"\";\n        border-color: transparent transparent @grey_25 transparent;\n        border-width: 10px;\n        border-style: solid;\n        position: absolute;\n        bottom: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n      }\n      &:before {\n        content:\"\";\n        border-color: transparent transparent @grey_200 transparent;\n        border-width: 11px;\n        border-style: solid;\n        position: absolute;\n        bottom: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n      }\n    }\n  }\n}\n\n.popup-wrapper {\n  display: flex;\n  align-content: flex-start;\n  flex-wrap: wrap;\n  gap: 10px;\n  .popup-image {\n    width: 160px;\n    position: relative;\n    flex: 0 0 100%;\n    min-height: 160px;\n    @media screen and (min-width: @screen-header-collapse) {\n      flex: 0 0 160px;\n    }\n    display: flex;\n    align-content: center;\n    justify-content: center;\n    overflow: hidden;\n    background-size: cover;\n    background-position: center;\n    img {\n      width: 100%;\n      object-fit: cover;\n    }\n  }\n  .popup-data {\n    flex: 1 1 auto;\n    display: flex;\n    flex-wrap: wrap;\n    max-width: 380px;\n  }\n  h5 {\n    flex: 1 1 100%;\n    text-transform: uppercase;\n    color: @primary_colour;\n  }\n  .popup-price {\n    flex: 1 1 100%;\n    font-size: 1.25rem;\n    font-weight: bold;\n    color: @grey_600;\n  }\n  .popup-address {\n    flex: 1 1 100%;\n    margin-top: 2px;\n    color: @grey_600;\n  }\n  .popup-divider {\n    flex: 1 1 100%;\n    height: 1px;\n    background: @grey_200;\n    margin-top: 8px;\n    margin-bottom: 8px;\n  }\n  .popup-featured {\n    display: grid;\n    grid-template-columns: auto auto;\n    flex: 0 0 100%;\n    gap: 4px 10px;\n    flex-wrap: wrap;\n    > .meta-detail {\n      display: flex;\n      margin: 0;\n      flex-wrap: nowrap;\n      align-items: center;\n      align-content: center;\n      gap: 4px 10px;\n      .heavy {\n        display: flex;\n        min-width: 90px;\n        margin: auto;\n        font-size: 10px;\n        text-transform: uppercase;\n        white-space: nowrap;\n        background: @grey_50;\n        flex: 0 0 1%;\n        padding: 3px 6px;\n      }\n      .col {\n        display: flex;\n        padding: 0;\n        max-width: 90px;\n        margin: auto;\n        flex: 0 1 auto;\n        align-items: center;\n      }\n    }\n  }\n}\n","// main: ../framework.less\n.tree-wrapper {\n  padding: 0 10px;\n  ul {\n    padding: 0;\n    margin: 0;\n    min-height: 36px;\n  }\n}\n.tree-item {\n  &--wrapper {\n    list-style: none;\n    box-sizing: border-box;\n    padding-left: var(--spacing);\n    margin-bottom: -1px;\n  }\n\n  &--clone {\n    display: inline-block;\n    pointer-events: none;\n    padding: 0;\n    padding-left: 10px;\n    padding-top: 5px;\n\n    .tree-item--item {\n      --vertical-padding: 5px;\n\n      padding-right: 24px;\n      border-radius: 4px;\n      box-shadow: 0px 15px 15px 0 rgba(34, 33, 81, 0.1);\n    }\n  }\n\n  &--ghost {\n    &.tree-item--indicator {\n      opacity: 1;\n      position: relative;\n      z-index: 1;\n      margin-bottom: -1px;\n\n      .tree-item--item {\n        position: relative;\n        padding: 0;\n        height: 8px;\n        border-color: #2389ff;\n        background-color: #56a1f8;\n\n        &:before {\n          position: absolute;\n          left: -8px;\n          top: -4px;\n          display: block;\n          content: '';\n          width: 12px;\n          height: 12px;\n          border-radius: 50%;\n          border: 1px solid #2389ff;\n          background-color: #ffffff;\n        }\n\n        > * {\n          /* Items are hidden using height and opacity to retain focus */\n          opacity: 0;\n          height: 0;\n        }\n      }\n    }\n\n    &:not(.tree-item--indicator) {\n      opacity: 0.5;\n    }\n\n    .tree-item--item > * {\n      box-shadow: none;\n      background-color: transparent;\n    }\n  }\n}\n\n.tree-item--item {\n  --vertical-padding: 8px;\n\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: var(--vertical-padding) 13px;\n  background-color: #fff;\n  border-radius: @input-border-radius;\n  border: @input-border;\n  border-color: @grey;\n  color: #222;\n  box-sizing: border-box;\n  svg {\n    fill: none;\n    stroke: @grey_400;\n    stroke-width: @svg-16-stroke-width;\n    width: 16px;\n    transition: transform 250ms ease;\n  }\n  &:hover {\n    .tree-item--item--remove {\n      cursor: pointer;\n      opacity: 1;\n      pointer-events: all;\n    }\n  }\n}\n\n.tree-item--item--text {\n  flex-grow: 1;\n  padding-left: 0.5rem;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.tree-item--item--count {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background-color: #2389ff;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #fff;\n}\n\n.tree-item--item--disable-interaction {\n  pointer-events: none;\n}\n\n.tree-item--item--disable-selection,\n.tree-item--clone {\n  .tree-item--item--text,\n  .tree-item--item--count {\n    user-select: none;\n    -webkit-user-select: none;\n  }\n}\n\n.tree-item--item--collapse {\n  margin-right: 10px;\n  display: flex;\n  align-items: center;\n  &.tree-item--item--collapsed svg {\n    transform: rotate(-90deg);\n  }\n}\n\n.tree-item--item--remove {\n  margin-left: auto;\n  display: flex;\n  opacity: 0;\n  pointer-events: none;\n  align-items: center;\n}","// main: ../framework.less\n\n#fc_frame.fc-widget-small {\n  bottom: 50px;\n  right: 10px;\n  z-index: 10;\n}\n#fc_frame.freshchat_frame.fc-open {\n  z-index: 1000;\n  right: 0;\n}\n\n#hubspot-conversations-inline-iframe {\n  width: 100vw;\n  height: calc(100vh - @navbar-height);\n  border:none;\n  @media screen and (min-width: @screen-header-collapse) {\n    width: 300px;\n    height: 500px;\n  }\n}\n#hubspot-chat-holder {\n  position: fixed;\n  right: 50%;\n  transform: translate(50%, 0);\n  top: @navbar-height;\n  background-color: white;\n  box-shadow: 0px 0px 59px 0px rgba(0, 0, 0, 0.25);\n  z-index: 1000;\n  visibility: hidden;\n  @media screen and (min-width: @screen-header-collapse) {\n    right: 15px;\n    transform: none;\n  }\n  > .btn {\n    position: absolute;\n    top: calc(@navbar-height / 2);\n    right: 0;\n    transform: translate(0, -50%);\n    svg {\n      stroke: #ffffff;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
